// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2710%27 height=%276%27 viewBox=%270 0 10 6%27 fill=%27none%27%3E%3Cpath d=%27M1 1l4 4 4-4%27 stroke=%27%2394a3b8%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2394a3b8%27 stroke-width=%272%27%3E%3Cpolyline points=%276 9 12 15 18 9%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════════════════════════════════
   AcyMart design tokens — the four-color brand system.

   The interface is restricted to exactly four brand colors. Every other
   value in this file is derived from them by transparency or by mixing
   them against each other; no unrelated grey, green, red, amber, violet or
   teal ramp exists any more. Product photography, seller-uploaded images
   and promotional banner artwork are exempt -- the restriction covers the
   application chrome, not the content inside it.

     Navy   #010D21  structure, text, dark canvas
     Orange #FF6700  primary commercial actions and promotions
     Blue   #3B82F6  secondary interaction, selection, information
     White  #FFFFFF  primary light surface, text on dark

   Because only four hues are available, colour can no longer carry meaning
   on its own -- "success" and "error" are not distinguishable by hue. Every
   status must therefore also carry an icon or a text label; see theme.js's
   STATUS_TONE for the shared vocabulary, and the .status-* rules below.

   The legacy token names (--bg-primary, --text-primary, --danger, --success
   and friends) are kept as aliases because several thousand call sites
   reference them. They now resolve to brand values, so re-pointing them
   here is what rolls the palette out across the whole app at once. Prefer
   the semantic --color-* names in new code.
   ════════════════════════════════════════════════════════════════════════ */

:root,
:root[data-theme="light"] {
  /* ── Brand foundation — the only raw brand hexes in the system ───────── */
  --color-brand-navy: #010D21;
  --color-brand-orange: #FF6700;
  --color-brand-blue: #3B82F6;
  --color-brand-white: #FFFFFF;

  /* ── Rating green — a narrow, deliberate exception ───────────────────────
     Green is NOT a fifth brand colour. It is approved for exactly one thing:
     product ratings (the pill over the image, and the filled stars under the
     product name). It must never be used for stock status, buttons, checkout
     discounts, success messages, navigation, or anything else -- those all
     stay on navy/orange/blue. Always reference the token; never paste
     #16A34A into a component. */
  --color-rating: #16A34A;
  /* Text sitting ON the green fill, and the same rule the orange and blue
     fills already follow: navy, never white. White on #16A34A is 3.30:1 and
     fails AA for text this size; navy is 5.90:1. The green itself is
     unchanged, so the filled stars (a graphic, judged at 3:1) are
     unaffected. */
  --color-rating-on-fill: var(--color-brand-navy);
  --color-rating-soft: rgba(22, 163, 74, 0.12);
  /* Unfilled stars in a partial rating: navy at 15%, not a grey. */
  --color-rating-empty: rgba(1, 13, 33, 0.15);
  /* Review counts and the "No reviews" placeholder. */
  --color-review-muted: rgba(1, 13, 33, 0.56);

  /* ── Confirm-dialog red/green — the second narrow exception ──────────────
     Like the rating green above, these are NOT new brand colours. They are
     approved for exactly one surface: the destructive-confirmation dialog
     (.confirm-dialog), where the choice is irreversible and the two options
     must be told apart instantly, under stress, without reading.

     Everything else in the admin chrome stays on navy/orange/blue: Edit,
     Hide, Save, Create, status pills, charts and toasts are all unchanged.
     Do not reach for these for a general "success" or "error" state, and
     never paste the hexes into a component.

     Contrast on white: #C0261B is 5.6:1, #15803D is 4.8:1, both AA for
     body text. The filled variants pair with white text (5.6:1 and 4.8:1
     respectively), and each button also carries an icon and a verb, so
     meaning never rests on hue alone. */
  --color-confirm-danger: #C0261B;
  --color-confirm-danger-hover: #A21D14;
  --color-confirm-danger-soft: rgba(192, 38, 27, 0.12);
  --color-confirm-safe: #15803D;
  --color-confirm-safe-hover: #116932;
  --color-confirm-safe-soft: rgba(21, 128, 61, 0.12);
  --color-confirm-on-fill: #FFFFFF;

  /* ── Order-confirmed green — the third narrow exception ─────────────────
     Requested for the packaged app's order-confirmation banner, and recorded
     here rather than pasted into a component so it follows the same rule as
     the two exceptions above: an exception is a named token or it is not
     approved.

     Worth being straight about the tension. The palette notes say success
     shares blue and that the rating green must never appear on a success
     message, and on the website that still holds -- .order-success-trust is
     unchanged there. This applies to one banner on one surface, the app's
     order-placed screen, where a green confirmation is the near-universal
     convention on a phone and the moment is the single most reassuring one
     in the flow.

     4.9:1 on white and lifted for the navy canvas, so both are AA for body
     text. The banner also carries a check icon and an explicit sentence, so
     nothing here depends on hue being understood. */
  --color-app-success: #15803D;
  --color-app-success-soft: rgba(21, 128, 61, 0.12);
  --color-app-success-border: rgba(21, 128, 61, 0.28);

  /* ── Surfaces ────────────────────────────────────────────────────────── */
  --color-page: var(--color-brand-white);
  --color-surface: var(--color-brand-white);
  --color-surface-subtle: rgba(1, 13, 33, 0.035);
  --color-surface-hover: rgba(1, 13, 33, 0.06);
  /* Opaque twin of --color-surface-subtle (navy 3.5% flattened onto white).
     Needed wherever a translucent fill would let another surface show
     through: sticky headers, dropdown panels, table header rows. */
  --color-surface-subtle-solid: #F6F7F8;
  /* Inverse surface: solid navy in light mode, used for badges and pills
     that need to read as "filled dark". In dark mode the page is already
     navy, so a solid navy fill would vanish -- it lifts to a translucent
     white instead. Pair with --color-text-on-inverse. */
  --color-surface-inverse: var(--color-brand-navy);
  --color-text-on-inverse: var(--color-brand-white);

  /* ── Text ────────────────────────────────────────────────────────────── */
  --color-text-primary: var(--color-brand-navy);
  --color-text-secondary: rgba(1, 13, 33, 0.68);
  --color-text-muted: rgba(1, 13, 33, 0.5);

  /* ── Borders ─────────────────────────────────────────────────────────── */
  --color-border: rgba(1, 13, 33, 0.12);
  --color-border-strong: rgba(1, 13, 33, 0.22);

  /* ── Primary (commercial) ────────────────────────────────────────────── */
  /* The FILL orange, mixed 25% toward navy (#C05108).
     
     Buttons carry a white label throughout the app, which pure #FF6700 cannot
     support: white on it is 2.92:1, well under the 4.5:1 AA needs for a
     button's ~15px text. Mixed a quarter of the way to navy it reaches
     4.75:1, and still reads unmistakably as the brand orange.
     
     --color-brand-orange stays exactly #FF6700 and is what the charts and the
     logo use; this is the role token for surfaces that carry text on top. */
  --color-primary: color-mix(in srgb, var(--color-brand-orange) 75%, var(--color-brand-navy));
  --color-primary-hover: color-mix(in srgb, var(--color-brand-orange) 66%, var(--color-brand-navy));
  --color-primary-soft: rgba(255, 103, 0, 0.1);
  --color-text-on-primary: var(--color-brand-white);

  /* ── Secondary (interaction / selection) ─────────────────────────────── */
  /* The FILL blue, mixed 15% toward navy (#3270D6) -- the same value
     --color-secondary-text already used, for the same reason one step along:
     white on pure #3B82F6 is 3.68:1 and fails AA, and at this depth it is
     4.75:1. Fills and their labels now agree with links instead of being a
     slightly different blue. --color-brand-blue stays pure for charts. */
  --color-secondary: color-mix(in srgb, var(--color-brand-blue) 85%, var(--color-brand-navy));
  --color-secondary-hover: color-mix(in srgb, var(--color-brand-blue) 74%, var(--color-brand-navy));
  --color-secondary-soft: rgba(59, 130, 246, 0.1);
  /* Brand blue as TEXT on a light surface is only 3.68:1 -- below AA for
     anything under 24px. This is the same blue mixed 15% toward navy
     (4.72:1), which is "controlled mixing of the official colours" rather
     than a new hue, and still reads unmistakably as the brand blue. Use it
     for links and small blue labels; use --color-secondary itself for fills,
     borders and icons, where the 3:1 non-text threshold applies and the pure
     blue passes. Dark mode overrides this back to pure blue, which is already
     high-contrast on the navy canvas. */
  --color-secondary-text: color-mix(in srgb, var(--color-brand-blue) 85%, var(--color-brand-navy));
  /* White on the fill blue above is 4.75:1 and clears AA. */
  --color-text-on-secondary: var(--color-brand-white);

  /* ── Foregrounds for permanently-navy surfaces ───────────────────────────
     The footer, the flash-sale bar and the admin sidebar are navy in BOTH
     themes, so their text can't use --text-* : those flip to navy in light
     mode and would disappear against the navy behind them. These three are
     defined only here and deliberately never overridden in the dark block,
     so they stay white-based whatever the theme is. */
  --color-on-navy: var(--color-brand-white);
  --color-on-navy-secondary: rgba(255, 255, 255, 0.72);
  --color-on-navy-muted: rgba(255, 255, 255, 0.55);

  --color-focus-ring: rgba(59, 130, 246, 0.25);
  --color-overlay: rgba(1, 13, 33, 0.64);

  --shadow-sm: 0 2px 8px rgba(1, 13, 33, 0.06);
  --shadow-md: 0 8px 24px rgba(1, 13, 33, 0.1);

  /* ── Chart series ramp ───────────────────────────────────────────────────
     Categorical scale for dashboards. Only the brand hues are available, so
     additional series are separated by opacity rather than by borrowing an
     unrelated colour. Step 3 rides --accent-secondary, which is navy in
     light mode and white in dark, so the "structural" series stays legible
     on either canvas. Charts must still carry labels/legends -- eight steps
     from three hues are not reliably distinguishable by colour alone.
     Referenced from JS via theme.js's CHART_SERIES; kept as CSS variables
     because recharts writes these into SVG fill/stroke attributes. */
  --chart-1: var(--color-brand-blue);
  --chart-2: var(--color-brand-orange);
  --chart-3: var(--accent-secondary);
  --chart-4: color-mix(in srgb, var(--color-brand-blue) 55%, transparent);
  --chart-5: color-mix(in srgb, var(--color-brand-orange) 55%, transparent);
  --chart-6: color-mix(in srgb, var(--accent-secondary) 45%, transparent);
  --chart-7: color-mix(in srgb, var(--color-brand-blue) 28%, transparent);
  --chart-8: color-mix(in srgb, var(--color-brand-orange) 28%, transparent);
  --chart-grid: var(--color-border);
  --chart-axis: var(--color-text-muted);

  /* ── Legacy aliases (resolve onto the tokens above) ──────────────────── */
  --bg-primary: var(--color-page);
  --bg-secondary: var(--color-surface);
  --bg-tertiary: var(--color-surface-subtle-solid);
  /* The admin overview cards -- .ops-kpi-card, .ops-gmv-card, .ops-rate-card
     and .ops-channel-panel -- all set \`background: var(--surface-card)\`, but
     that token was never declared anywhere. An undeclared custom property
     resolves to nothing, so every one of those cards has been rendering with
     no background at all, showing the page canvas through in both themes and
     leaving only their 1px border to suggest a card. Aliased onto the surface
     they were evidently written for. --bg-secondary is itself redefined per
     theme, so this single declaration is correct in light and dark. */
  --surface-card: var(--bg-secondary);
  --text-primary: var(--color-text-primary);
  --text-secondary: var(--color-text-secondary);
  --text-tertiary: rgba(1, 13, 33, 0.58);
  --text-muted: var(--color-text-muted);
  --border: var(--color-border);
  --border-strong: var(--color-border-strong);
  --accent: var(--color-secondary-text);
  --accent-hover: var(--color-secondary-hover);
  --brand-navy: var(--color-brand-navy);
  --brand-orange: var(--color-brand-orange);
  /* The navy foreground/tint accent. In dark mode navy has no foreground
     role (the canvas is navy), so this lifts to white there -- which makes
     every \`color-mix(--accent-secondary N%, transparent)\` tint resolve to
     the white-N% surface the dark spec asks for, automatically. Solid
     fills must use --color-surface-inverse instead, not this. */
  --accent-secondary: var(--color-brand-navy);
  --accent-secondary-hover: rgba(1, 13, 33, 0.78);
  /* Only four hues exist, so danger/warning share orange and success shares
     blue. Always pair these with an icon or label -- never colour alone. */
  --danger: var(--color-primary);
  --warning: var(--color-primary);
  --success: var(--color-secondary);
  --info: var(--color-secondary);
  --shadow-card: 0 2px 8px rgba(1, 13, 33, 0.09), 0 0 0 1px rgba(1, 13, 33, 0.05);
  --shadow-panel: 0 4px 24px rgba(1, 13, 33, 0.10), 0 1px 4px rgba(1, 13, 33, 0.06);

  /* Spacing scale */
  --space-1: 8px;
  --space-2: 16px;
  --space-3: 24px;
  --space-4: 32px;

  /* Radius scale */
  --radius-xs: 6px;
  --radius-sm: 12px;
  --radius-md: 14px;
  --radius-lg: 16px;
  --radius-xl: 20px;
  --radius-pill: 999px;
}

/* ── Mobile type scale: now lives in mobile/tokens.css ─────────────────────
   The 18px root that lifts this stylesheet's type for the phone used to be
   declared here as \`.is-native-app { font-size: 18px }\`, which meant only the
   packaged Capacitor shell ever got it.

   That was the wrong condition. The mobile design layer it feeds is applied
   to the shell AND to any viewport <= 768px (see mobile/mobileUI.js), and
   every size in that layer is stated in rem -- so a phone browser rendered
   the whole mobile design 12.5% smaller than the app did. One design, two
   sizes, and the browser's was the cramped one.

   The root now sits on html.m-app in mobile/tokens.css, alongside the scale
   it governs, so the app at 390px and the browser at 390px are the same app.
   The reasoning that was here -- why a root change rather than a thousand
   individual edits, and what 1.125x does to the ramp -- moved with it.
   Nothing is declared at this point in the file. */

:root[data-theme="dark"] {
  /* Dark mode is the same four colours re-weighted: navy becomes the canvas,
     white becomes the structural foreground, orange and blue keep their
     exact light-mode responsibilities so an action never changes meaning
     between themes. No second dark navy, and never pure black. */
  --color-page: var(--color-brand-navy);
  --color-surface: rgba(255, 255, 255, 0.05);
  --color-surface-subtle: rgba(255, 255, 255, 0.035);
  --color-surface-hover: rgba(255, 255, 255, 0.09);
  /* White 5% flattened onto #010D21, for the same "must be opaque" cases. */
  --color-surface-subtle-solid: #0E192C;
  --color-surface-inverse: rgba(255, 255, 255, 0.12);
  --color-text-on-inverse: var(--color-brand-white);

  --color-text-primary: var(--color-brand-white);
  --color-text-secondary: rgba(255, 255, 255, 0.7);
  --color-text-muted: rgba(255, 255, 255, 0.5);

  --color-border: rgba(255, 255, 255, 0.12);
  --color-border-strong: rgba(255, 255, 255, 0.22);
  --color-secondary-text: var(--color-brand-blue);
  /* The button fill on the navy canvas. Kept at the same depth as light mode
     rather than reverting to pure blue: buttons carry a white label in both
     themes, and pure #3B82F6 gives white only 3.68:1. */
  --accent: color-mix(in srgb, var(--color-brand-blue) 85%, var(--color-brand-navy));
  /* Rating green keeps the same hue on the navy canvas (5.1:1 against
     #010D21); only the neutrals it pairs with flip to white-based. */
  --color-rating-empty: rgba(255, 255, 255, 0.2);
  --color-review-muted: rgba(255, 255, 255, 0.62);

  /* Confirm-dialog red/green, lifted for the navy canvas. The light-mode
     values are tuned for white and drop to ~3:1 on navy, so both hues move
     up in lightness here: #F2564A reads 5.0:1 and #2FBF6A 7.1:1 against
     #010D21. The filled variants keep navy text rather than white, which is
     the same rule the orange and blue fills follow elsewhere. */
  --color-confirm-danger: #F2564A;
  --color-confirm-danger-hover: #FF6E63;
  --color-confirm-danger-soft: rgba(242, 86, 74, 0.18);
  --color-confirm-safe: #2FBF6A;
  --color-confirm-safe-hover: #45D07E;
  --color-confirm-safe-soft: rgba(47, 191, 106, 0.18);

  /* The light green drops to roughly 3:1 on the navy canvas, so the app's
     confirmation banner takes the same lift the confirm dialog does. */
  --color-app-success: #2FBF6A;
  --color-app-success-soft: rgba(47, 191, 106, 0.16);
  --color-app-success-border: rgba(47, 191, 106, 0.34);
  --color-confirm-on-fill: var(--color-brand-navy);

  --color-primary-soft: rgba(255, 103, 0, 0.16);
  --color-secondary-soft: rgba(59, 130, 246, 0.16);
  --color-focus-ring: rgba(59, 130, 246, 0.35);
  --color-overlay: rgba(1, 13, 33, 0.78);

  --shadow-sm: 0 2px 8px rgba(1, 13, 33, 0.3);
  --shadow-md: 0 8px 24px rgba(1, 13, 33, 0.4);

  /* ── Legacy aliases ──────────────────────────────────────────────────── */
  --bg-primary: var(--color-page);
  --bg-secondary: var(--color-surface-subtle-solid);
  --bg-tertiary: rgba(255, 255, 255, 0.09);
  --text-primary: var(--color-text-primary);
  --text-secondary: var(--color-text-secondary);
  --text-tertiary: rgba(255, 255, 255, 0.6);
  --text-muted: var(--color-text-muted);
  --border: var(--color-border);
  --border-strong: var(--color-border-strong);
  --brand-navy: var(--color-brand-navy);
  --accent-secondary: var(--color-brand-white);
  --accent-secondary-hover: rgba(255, 255, 255, 0.82);
  --shadow-card: 0 2px 8px rgba(1, 13, 33, 0.35);
  --shadow-panel: 0 4px 24px rgba(1, 13, 33, 0.4);
}

/* ── Animation system variables ───────────────────────────── */
:root {
  --ease-spring:   cubic-bezier(0.34, 1.56, 0.64, 1);
  --ease-out-expo: cubic-bezier(0.16, 1, 0.3, 1);
  --ease-in-out:   cubic-bezier(0.4, 0, 0.2, 1);
  --dur-fast:  110ms;
  --dur-base:  220ms;
  --dur-slow:  380ms;
}

/* Global dark-mode colour transition — targeted, not everything */
*, *::before, *::after {
  transition: background-color 240ms ease, color 160ms ease, border-color 200ms ease;
}

.app-shell {
  min-height: 100vh;
  background: var(--bg-primary);
  color: var(--text-primary);
  display: flex;
  flex-direction: column;
}

@media (max-width: 768px) {
  .app-shell-with-bottom-nav {
    padding-bottom: calc(56px + env(safe-area-inset-bottom, 0px));
  }

  /* The taller bar an installed app gets, packaged or PWA -- both are driven
     by thumb rather than cursor and both sit over the system gesture area. */
  .is-native-app .app-shell-with-bottom-nav,
  html.m-installed .app-shell-with-bottom-nav {
    padding-bottom: calc(60px + env(safe-area-inset-bottom, 0px));
  }
}

/* The padding that wraps the account and info pages (My Orders, Wishlist,
   Profile, Notifications, Dashboard, Dispute, the legal pages). This was
   seven copies of style={{ padding: '20px' }} inline on the wrapper div,
   which no stylesheet could reach -- the mobile layer needs to drop the
   horizontal half so those pages can sit on the same edge as everything
   else, and an inline style outranks it. Same 20px as before on desktop. */
.page-shell-pad {
  padding: 20px;
}

/* Topbar */
.topbar {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
  background: var(--bg-secondary);
  color: var(--text-primary);
  box-shadow: var(--shadow-sm);
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid var(--border);
}

.navbar-top {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: 12px 20px;
  background: var(--bg-secondary);
  flex-wrap: wrap;
}

.brand-button {
  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);
  border: none;
  border-radius: var(--radius-sm);
  padding: 10px 16px;
  cursor: pointer;
  transition: transform 200ms ease;
  flex-shrink: 0;
}

.brand-button:hover {
  transform: scale(1.05);
}

.brand {
  font-size: 1.4rem;
  font-weight: 800;
  margin: 0;
  letter-spacing: -0.5px;
  color: white;
}

.navbar-search {
  display: flex;
  flex: 1 1;
  min-width: 280px;
}

.search-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: 0.95rem;
  background: var(--bg-tertiary);
  color: var(--text-primary);
  transition: all 200ms ease;
}

.search-input:focus {
  outline: none;
  border-color: var(--accent);
  background: var(--bg-secondary);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.navbar-actions-top {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  flex-shrink: 0;
}

.btn-icon-text {
  background: none;
  border: none;
  color: var(--text-primary);
  cursor: pointer;
  font-weight: 500;
  font-size: 0.9rem;
  padding: 8px 12px;
  border-radius: var(--radius-xs);
  transition: all 120ms ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 4px;
}

.btn-icon-text:hover {
  background: var(--bg-tertiary);
  transform: translateY(-1px);
}

.cart-icon-btn {
  background: none;
  border: none;
  font-size: 1.6rem;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: var(--radius-xs);
  transition: all 120ms ease;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cart-icon-btn:hover {
  background: var(--bg-tertiary);
  transform: scale(1.1);
}

.cart-badge {
  position: absolute;
  top: 0;
  right: 0;
  background: var(--danger);
  color: var(--color-text-on-primary);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 700;
}

/* User Dropdown Menu */
.user-dropdown-container {
  position: relative;
  display: inline-block;
  padding-bottom: 8px;  /* bridges the gap so onMouseLeave doesn't fire mid-crossing */
}

.user-dropdown-toggle {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.user-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  min-width: 200px;
  box-shadow: 0 4px 12px rgba(1, 13, 33, 0.15);
  z-index: 1000;
  margin-top: 0;
  animation: slideDown 200ms ease-out;
}

/* Language Switcher */
.lang-switcher { position: relative; display: inline-block; }
.lang-switcher-btn {
  display: flex; align-items: center; gap: 6px;
  background: none; border: none; cursor: pointer;
  color: var(--text-secondary); font-size: 0.8rem; font-weight: 600;
  padding: 8px 6px;
}
.lang-switcher-btn:hover { color: var(--text-primary); }
.lang-switcher-current { white-space: nowrap; }
.lang-switcher-menu {
  position: absolute; top: 100%; right: 0;
  background: var(--bg-secondary); border: 1px solid var(--border);
  border-radius: var(--radius-sm); min-width: 150px;
  box-shadow: 0 4px 12px rgba(1, 13, 33, 0.15); z-index: 1000;
  animation: slideDown 200ms ease-out; overflow: hidden;
}
[dir="rtl"] .lang-switcher-menu { right: auto; left: 0; }
.lang-switcher-option {
  display: block; width: 100%; text-align: left;
  background: none; border: none; cursor: pointer;
  padding: 10px 14px; font-size: 0.85rem; color: var(--text-primary);
}
[dir="rtl"] .lang-switcher-option { text-align: right; }
.lang-switcher-option:hover { background: var(--bg-tertiary); }
.lang-switcher-option.active { color: var(--accent); font-weight: 700; }

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dropdown-item {
  position: relative;
  display: block;
  width: 100%;
  text-align: left;
  padding: 12px 16px;
  background: none;
  border: none;
  color: var(--text-primary);
  cursor: pointer;
  font-size: 0.95rem;
  transition: all 120ms ease;
  font-weight: 500;
}

.dropdown-item-badge {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: var(--accent);
  color: var(--color-text-on-secondary);
  font-size: 0.68rem;
  font-weight: 700;
  min-width: 18px;
  height: 18px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  box-sizing: border-box;
}

.dropdown-item:hover {
  background: var(--bg-tertiary);
  color: var(--accent);
}

.dropdown-item:first-child {
  border-radius: var(--radius-sm) var(--radius-sm) 0 0;
}

/* Nested under the item above it (e.g. Track Order under My Orders) --
   same left padding as regular items so the icon column stays aligned;
   the smaller/lighter type is what signals it's a sub-item. */
.dropdown-item-sub {
  padding: 9px 16px;
  font-size: 0.85rem;
  font-weight: 400;
  color: var(--text-secondary);
}

.dropdown-divider {
  height: 1px;
  border: none;
  background: var(--border);
  margin: 4px 0;
}

.logout-item {
  color: var(--danger);
}

.logout-item:hover {
  background: color-mix(in srgb, var(--danger) 10%, transparent);
}

.logout-item:last-child {
  border-radius: 0 0 var(--radius-sm) var(--radius-sm);
}

.navbar-categories-bottom {
  display: flex;
  gap: 0;
  padding: 0;
  background: var(--bg-secondary);
  border-top: 1px solid var(--border);
  overflow-x: auto;
  scroll-behavior: smooth;
}

.navbar-categories-bottom::-webkit-scrollbar {
  height: 4px;
}

.navbar-categories-bottom::-webkit-scrollbar-track {
  background: transparent;
}

.navbar-categories-bottom::-webkit-scrollbar-thumb {
  background: var(--border-strong);
  border-radius: var(--radius-xs);
}

.category-icon-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px 18px;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  color: var(--text-secondary);
  cursor: pointer;
  font-weight: 500;
  font-size: 0.85rem;
  white-space: nowrap;
  transition: all 200ms ease;
  flex-shrink: 0;
}

.category-icon-btn:hover {
  color: var(--accent);
  background: rgba(59, 130, 246, 0.05);
}

.category-icon-btn.active {
  color: var(--accent);
  border-bottom-color: var(--accent);
}

.category-icon {
  font-size: 1.4rem;
  display: block;
}

.category-label {
  display: block;
}

.topbar-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  flex: 0 0 auto;
}

.user-name {
  background: rgba(255, 255, 255, 0.1);
  padding: 6px 12px;
  border-radius: var(--radius-xl);
  font-weight: 600;
  font-size: 0.9rem;
}

.btn-text {
  background: none;
  border: none;
  color: var(--bg-tertiary);
  cursor: pointer;
  font-weight: 600;
  font-size: 0.95rem;
  padding: 6px 12px;
  border-radius: var(--radius-sm);
  transition: all 120ms ease;
  white-space: nowrap;
}

.btn-text:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-1px);
}

.btn-icon {
  background: none;
  border: none;
  font-size: 1.4rem;
  cursor: pointer;
  padding: 6px;
  border-radius: var(--radius-sm);
}

.btn-icon:hover {
  transform: scale(1.1);
}

.cart-pill {
  background: var(--accent);
  border: none;
  border-radius: var(--radius-pill);
  padding: 10px 16px;
  font-weight: 700;
  color: var(--color-text-on-secondary);
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 200ms ease;
  white-space: nowrap;
  flex-shrink: 0;
}

.cart-pill:hover {
  background: var(--accent-hover);
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
}

/* Hero Section */
.hero {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-3);
  padding: 42px 28px;
  background: linear-gradient(135deg, var(--accent) 0%, var(--color-secondary) 100%);
  color: white;
  flex-wrap: wrap;
}

.hero-copy {
  max-width: 760px;
}

.hero-copy h1 {
  margin: 0 0 16px;
  font-size: clamp(2.5rem, 4vw, 4rem);
  line-height: 1.05;
  font-weight: 800;
}

.hero-copy p {
  margin: 0;
  font-size: 1.05rem;
  color: var(--border);
}

.hero-state {
  display: grid;
  gap: 18px;
  width: min(100%, 360px);
}

.hero-state div {
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: var(--radius-xl);
  padding: 22px;
  animation: slideIn 600ms ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hero-state strong {
  display: block;
  font-size: 1.9rem;
  margin-bottom: 6px;
}

.hero-state span {
  color: var(--color-secondary-soft);
  font-size: 0.9rem;
}

/* Content Grid */
.content-grid {
  width: min(1280px, 100%);
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.7fr 0.95fr;
  gap: var(--space-3);
  padding: 24px 28px 40px;
}

.product-panel,
.cart-panel {
  background: var(--bg-secondary);
  border-radius: 28px;
  box-shadow: var(--shadow-panel);
  border: 1px solid var(--border);
  padding: var(--space-3);
}

.panel-header h2 {
  margin: 0 0 8px;
  font-size: 1.6rem;
  font-weight: 700;
}

.panel-header p {
  margin: 0;
  color: var(--text-secondary);
  font-size: 0.95rem;
}

/* Controls */
/* ── Legacy controls (kept for backward compat) ─────────── */
.controls { display: none; }
.search-box { flex: 1 1 320px; }
.search-box input {
  width: 100%;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 14px 16px;
  font-size: 1rem;
  outline: none;
  background: var(--bg-secondary);
  color: var(--text-primary);
}
.search-box input:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(59, 130, 246,0.1);
}

/* ── Filter bar ─────────────────────────────────────────── */
.filter-bar {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 20px 0 18px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 16px 20px;
  box-shadow: var(--shadow-sm);
}

/* Search row */
.filter-search-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.filter-search-icon {
  position: absolute;
  left: 14px;
  font-size: 1rem;
  pointer-events: none;
}
.filter-search-input {
  width: 100%;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 11px 40px 11px 42px;
  font-size: 0.95rem;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-family: inherit;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.filter-search-input:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(59, 130, 246,0.1);
}
.filter-search-clear {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-muted);
  font-size: 0.85rem;
  padding: 4px;
  line-height: 1;
}
.filter-search-clear:hover { color: var(--text-primary); }

/* Filter row */
.filter-row {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  flex-wrap: wrap;
  border-top: 1px solid var(--border);
  padding-top: 12px;
}
.filter-section {
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.filter-section-right {
  margin-left: auto;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}
.filter-label {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-muted);
}

/* Price range inputs */
.price-range-inputs {
  display: flex;
  align-items: center;
  gap: 6px;
}
.price-range-currency {
  font-size: 0.82rem;
  color: var(--text-muted);
  font-weight: 600;
}
.price-range-sep {
  font-size: 0.82rem;
  color: var(--text-muted);
}
.price-input {
  width: 80px;
  padding: 7px 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 0.85rem;
  font-family: inherit;
  outline: none;
}
.price-input:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 2px rgba(59, 130, 246,0.1);
}
.price-input::-webkit-inner-spin-button,
.price-input::-webkit-outer-spin-button { opacity: 0.5; }
.filter-clear-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-muted);
  font-size: 0.8rem;
  padding: 4px 6px;
  border-radius: var(--radius-xs);
  line-height: 1;
}
.filter-clear-btn:hover { background: var(--bg-tertiary); color: var(--text-primary); }

/* Rating filter buttons */
.rating-filter-row {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.rating-filter-btn {
  background: var(--bg-primary);
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  padding: 5px 12px;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.13s;
}
.rating-filter-btn:hover {
  border-color: var(--color-primary);
  color: var(--color-primary);
}
.rating-filter-btn.active {
  background: var(--color-primary-soft);
  border-color: var(--color-primary);
  color: var(--color-primary);
}
.dark .rating-filter-btn.active {
  background: #78350f44;
  color: var(--color-primary);
}

/* In-stock toggle */
.stock-toggle {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 0.82rem;
  color: var(--text-secondary);
  cursor: pointer;
  white-space: nowrap;
  font-weight: 500;
}
.stock-toggle input[type="checkbox"] {
  width: 15px;
  height: 15px;
  accent-color: var(--accent);
  cursor: pointer;
}

/* Active filters summary */
.active-filters {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  flex-wrap: wrap;
  border-top: 1px solid var(--border);
  padding-top: 10px;
}
.active-filters-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-muted);
  margin-right: 4px;
}
.active-filter-tag {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: var(--accent);
  color: var(--color-text-on-secondary);
  border-radius: var(--radius-xl);
  padding: 3px 10px 3px 12px;
  font-size: 0.75rem;
  font-weight: 600;
}
.active-filter-tag button {
  background: none;
  border: none;
  color: rgba(255,255,255,0.8);
  cursor: pointer;
  font-size: 0.75rem;
  padding: 0;
  line-height: 1;
}
.active-filter-tag button:hover { color: var(--color-brand-white); }
.active-filters-reset {
  background: none;
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  padding: 3px 12px;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-muted);
  cursor: pointer;
  margin-left: auto;
}
.active-filters-reset:hover {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

/* .shop-pagination / .shop-page-btn / .shop-page-info lived here. The shop
   grows the list as you reach the end of it at every width now, so there is no
   Prev/Next to style -- see the infinite-scroll sentinel in App.js. */

@media (max-width: 700px) {
  .filter-row { gap: 14px; }
  .filter-section-right { margin-left: 0; }
  .price-input { width: 68px; }
}

.category-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.chip {
  border: 1px solid var(--border);
  background: var(--bg-secondary);
  color: var(--text-secondary);
  border-radius: var(--radius-pill);
  padding: 10px 16px;
  cursor: pointer;
  transition: all 120ms ease;
  font-weight: 600;
  font-size: 0.9rem;
}

.chip:hover {
  background: var(--accent);
  color: var(--color-text-on-secondary);
  border-color: var(--accent);
  transform: translateY(-2px);
}

.chip.active {
  background: var(--accent);
  color: var(--color-text-on-secondary);
  border-color: var(--accent);
}

/* Product Grid */
.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  justify-items: center;
}

/* ── New Flipkart-style product card ───────────────────── */
.product-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  display: flex;
  flex-direction: column;
  cursor: pointer;
  width: 100%;
  max-width: 360px;
  position: relative;
  overflow: hidden;
  box-shadow: var(--shadow-card);
  transition: transform 300ms var(--ease-out-expo), box-shadow 300ms var(--ease-out-expo);
}

.product-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(1, 13, 33,0.14), 0 0 0 1px rgba(1, 13, 33,0.06);
}

[data-theme="dark"] .product-card:hover {
  box-shadow: 0 12px 32px rgba(1, 13, 33,0.45);
}

/* Image section */
.card-img-wrap {
  position: relative;
  background: var(--bg-tertiary);
  height: 210px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  overflow: hidden;
}

.card-img-wrap img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 300ms ease;
}

.product-card:hover .card-img-wrap img {
  transform: scale(1.05);
}

/* Wishlist heart */
.card-wishlist {
  position: absolute;
  top: 10px;
  right: 10px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 1.05rem;
  color: var(--text-tertiary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-sm);
  z-index: 2;
  transition: color 180ms, transform 180ms;
  line-height: 1;
}

.card-wishlist:hover { color: var(--danger); transform: scale(1.15); }

/* Low-stock ribbon */
.card-stock-ribbon {
  position: absolute;
  top: 10px;
  left: 0;
  background: var(--color-primary);
  color: var(--color-text-on-primary);
  font-size: 0.68rem;
  font-weight: 700;
  padding: 3px 10px 3px 8px;
  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
  z-index: 2;
  letter-spacing: 0.03em;
}

/* Out-of-stock overlay */
.card-oos-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255,255,255,0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
}

[data-theme="dark"] .card-oos-overlay { background: rgba(1, 13, 33,0.65); }

.card-oos-overlay span {
  background: var(--text-secondary);
  color: var(--color-brand-white);
  font-size: 0.78rem;
  font-weight: 700;
  padding: 5px 14px;
  border-radius: var(--radius-xs);
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

/* Card body — must be position:relative so the hover section anchors to it */
.card-body {
  padding: 10px 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1 1;
  position: relative;
}

.card-title {
  font-size: 0.88rem;
  font-weight: 400;
  color: var(--accent);
  line-height: 1.4;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 2.5em;
}

[data-theme="dark"] .card-title { color: var(--color-secondary-soft); }

/* Rating row */
.card-meta-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.card-rating-pill {
  background: var(--color-secondary);
  color: var(--color-text-on-secondary);
  font-size: 0.74rem;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: var(--radius-xs);
  white-space: nowrap;
  letter-spacing: 0.02em;
}

.card-review-cnt {
  font-size: 0.78rem;
  color: var(--text-tertiary);
}

.card-no-rating {
  font-size: 0.78rem;
  color: var(--text-tertiary);
  font-style: italic;
}

.card-assured {
  margin-left: auto;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--accent);
  display: flex;
  align-items: center;
  gap: 3px;
  white-space: nowrap;
}

[data-theme="dark"] .card-assured { color: var(--color-secondary-soft); }

/* Price row */
.card-price-row {
  display: flex;
  align-items: baseline;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 2px;
}

/* Tabular figures on money.
   The default proportional digits give every price a different width, so a
   grid of cards shows a ragged column of prices -- barely noticeable at
   "\$12.99" and very noticeable at "SSP 150,228", where the digits are most of
   the string. tabular-nums makes every digit the same advance width, so
   prices line up down a column and the eye can compare them. */
.card-price,
.card-mrp,
.cat-carousel-price,
.cat-carousel-price-sale,
.cat-carousel-price-was,
.detail-price,
.cs-item-price,
.cs-item-line-total,
.admin-preview-price,
.admin-price,
.admin-product-price-cell,
.dash-mini-price,
.fi-price {
  font-variant-numeric: tabular-nums;
}

.card-price {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
  /* The currency code is joined to the digits by a non-breaking space (see
     currency.js), so this only guards against a break inside the number
     itself in a very narrow card. */
  white-space: nowrap;
}

.card-mrp {
  font-size: 0.8rem;
  color: var(--text-tertiary);
  text-decoration: line-through;
}

.card-off {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--color-secondary);
}

/* ── Hover-reveal section ──────────────────────────────────
   Absolutely positioned so it slides up over the card bottom
   without changing the card's height or touching the grid layout.
   ─────────────────────────────────────────────────────────── */
.card-hover-section {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--bg-secondary);
  border-top: 1px solid var(--border);
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  transform: translateY(100%);
  transition: transform 260ms var(--ease-out-expo);
  z-index: 5;
  box-shadow: 0 -4px 12px rgba(1, 13, 33,0.06);
}

.product-card:hover .card-hover-section {
  transform: translateY(0);
}

.card-compare {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 0.82rem;
  color: var(--text-secondary);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.card-compare input[type="checkbox"] {
  width: 14px;
  height: 14px;
  accent-color: var(--accent);
  cursor: pointer;
  flex-shrink: 0;
}

/* Color swatches */
.card-swatches {
  display: flex;
  gap: 6px;
  align-items: center;
}

.color-swatch {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid var(--border);
  cursor: pointer;
  display: inline-block;
  transition: border-color 150ms, transform 150ms;
  box-shadow: 0 1px 3px rgba(1, 13, 33,0.18);
  flex-shrink: 0;
}

.color-swatch:hover {
  border-color: var(--accent);
  transform: scale(1.2);
}

/* Add to cart inside hover */
.card-cart-btn {
  width: 100%;
  padding: 8px 12px;
  font-size: 0.85rem;
  border-radius: var(--radius-xs);
}

/* legacy selectors kept for cart panel etc. */
.price {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary);
}

.product-buttons {
  display: flex;
  gap: var(--space-1);
  width: 100%;
  flex-wrap: wrap;
}

.btn {
  flex: 1 1;
  min-width: 60px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: var(--radius-lg);
  background: var(--accent);
  color: var(--color-text-on-secondary);
  padding: 10px 12px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.85rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: transform 120ms ease, background 120ms ease, box-shadow 120ms ease;
}

.btn:hover {
  transform: translateY(-2px);
  background: var(--accent-hover);
  box-shadow: 0 8px 16px rgba(59, 130, 246, 0.3);
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn.submit {
  width: 100%;
}

.btn-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  margin-right: 8px;
  border: 2px solid rgba(255,255,255,0.35);
  border-top-color: var(--color-brand-white);
  border-radius: 50%;
  animation: spin 700ms linear infinite;
  flex-shrink: 0;
}

.btn.danger {
  background: var(--danger);
}

.btn.danger:hover {
  background: var(--color-primary);
}

/* Cart Panel */
.user-menu {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border);
}

.user-menu .btn-text {
  color: var(--text-primary);
  background: var(--bg-tertiary);
  border-radius: var(--radius-sm);
  padding: 10px 14px;
  text-align: left;
}

.user-menu .btn-text:hover {
  background: var(--accent);
  color: var(--color-text-on-secondary);
}

.cart-items {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.cart-item {
  display: grid;
  grid-template-columns: 88px 1fr auto;
  gap: var(--space-2);
  align-items: center;
  padding: var(--space-2);
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  animation: slideIn 300ms ease-out;
}

.cart-item img {
  width: 88px;
  height: 88px;
  object-fit: cover;
  border-radius: var(--radius-xl);
}

.cart-item h3 {
  margin: 0 0 6px;
  font-size: 1rem;
  color: var(--text-primary);
}

.cart-item p {
  margin: 0 0 12px;
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.quantity-row {
  display: inline-flex;
  gap: var(--space-1);
  align-items: center;
}

.quantity-row button {
  width: 34px;
  height: 34px;
  border: 1px solid var(--border);
  background: var(--bg-secondary);
  border-radius: 50%;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 700;
  transition: all 120ms ease;
}

.quantity-row button:hover {
  background: var(--accent);
  color: var(--color-text-on-secondary);
  border-color: var(--accent);
}

.remove-button {
  border: none;
  background: transparent;
  color: var(--danger);
  font-weight: 700;
  cursor: pointer;
  font-size: 0.9rem;
  padding: 6px;
  border-radius: var(--radius-sm);
  transition: all 120ms ease;
}

.remove-button:hover {
  background: color-mix(in srgb, var(--danger) 10%, transparent);
}

.cart-summary {
  display: grid;
  gap: 12px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  padding: 18px;
  border-radius: var(--radius-xl);
  margin: 20px 0;
  box-shadow: var(--shadow-card);
}

.cart-summary div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cart-summary span {
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.cart-summary strong {
  font-size: 1.1rem;
  color: var(--text-primary);
}

/* Checkout Form */
.checkout-form {
  display: grid;
  gap: 14px;
}

.checkout-form h3 {
  margin: 0 0 12px;
  font-size: 1.2rem;
  color: var(--text-primary);
}

.checkout-form input,
.checkout-form textarea {
  width: 100%;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 14px 16px;
  font-size: 0.98rem;
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-family: inherit;
}

.checkout-form input:focus,
.checkout-form textarea:focus {
  border-color: var(--accent);
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.checkout-form textarea {
  resize: vertical;
  min-height: 80px;
}

/* Alerts */
.alert {
  border-radius: var(--radius-xl);
  padding: var(--space-2);
  margin-top: 16px;
  font-size: 0.95rem;
  border: 1px solid transparent;
  animation: slideIn 300ms ease-out;
}

.alert.danger {
  background: color-mix(in srgb, var(--danger) 10%, transparent);
  color: var(--danger);
  border-color: color-mix(in srgb, var(--danger) 30%, transparent);
}

.alert.info {
  background: rgba(59, 130, 246, 0.1);
  color: var(--accent);
  border-color: rgba(59, 130, 246, 0.3);
}

.alert.success {
  background: rgba(59, 130, 246, 0.1);
  color: var(--success);
  border-color: rgba(59, 130, 246, 0.3);
}

/* App boot loader — full-screen branded spinner shown while the app
   first initializes (auth check + minimum display time so it doesn't
   just flash by). Not used for in-app page navigation. */
.app-boot-loader {
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
  background: var(--bg-primary);
  z-index: 9999;
}

/* Soft ambient halo pulsing behind the whole mark, in lockstep with the
   arrow glow below -- adds depth around the icon as it brightens instead of
   the glowing arrow being the only thing moving. */
.acy-loader-halo {
  position: absolute;
  inset: -18%;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255,140,26,0.35) 0%, rgba(56,189,248,0.18) 55%, transparent 75%);
  filter: blur(10px);
  animation: acy-loader-halo-pulse 1.6s ease-in-out infinite;
}
@keyframes acy-loader-halo-pulse {
  0%, 100% { opacity: 0.35; transform: scale(0.88); }
  50%      { opacity: 0.85; transform: scale(1.08); }
}

/* Loader arrow glow — the whole traced arrow curve (see LOADER_TRAIL_PATH
   in Logo.js) breathes brighter and dimmer together, in lockstep with the
   ambient halo above, rather than a small dash travelling along it. The
   blurred glow layer's stroke-width pulses too so the light visibly swells
   around the arrow at its brightest instead of just fading in place. */
.acy-loader-arrow-glow {
  stroke-width: 16px;
  stroke-dasharray: 18 82;
  animation: acy-loader-arrow-travel 1.7s linear infinite;
}
.acy-loader-arrow-core {
  stroke-width: 5px;
  stroke-dasharray: 12 88;
  animation: acy-loader-arrow-travel 1.7s linear infinite;
}
@keyframes acy-loader-arrow-travel {
  0%   { stroke-dashoffset: 20; opacity: 0; }
  8%   { opacity: 1; }
  90%  { opacity: 1; }
  100% { stroke-dashoffset: -100; opacity: 0; }
}
@media (prefers-reduced-motion: reduce) {
  .acy-loader-arrow-glow, .acy-loader-arrow-core { animation: none; stroke-dasharray: none; opacity: 0.45; }
  .acy-loader-travel-spark { display: none; }
}

.abl-wordmark {
  font-size: 1.3rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--text-primary);
}

.abl-message {
  font-size: 0.88rem;
  color: var(--text-secondary);
  margin: -8px 0 0;
}

/* Loading & Empty States */
.loading,
.empty-state {
  padding: var(--space-4);
  text-align: center;
  border-radius: var(--radius-xl);
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  font-size: 1rem;
}

.loading::after {
  content: '';
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 8px;
  border: 3px solid rgba(59, 130, 246, 0.3);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ── Auth Gate (checkout + page-level) ─────────────────────────── */
.auth-gate-page {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: var(--bg-primary);
  min-height: calc(100vh - 70px);
}

.auth-gate-box {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 36px 40px 32px;
  width: 100%;
  max-width: 460px;
  box-shadow: 0 8px 32px rgba(1, 13, 33,0.10);
  text-align: center;
}

.auth-gate-icon-wrap {
  font-size: 2.4rem;
  margin-bottom: 14px;
  line-height: 1;
}

.auth-gate-box h2 {
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 8px;
}

.auth-gate-sub {
  font-size: 0.875rem;
  color: var(--text-secondary);
  margin: 0 0 24px;
  line-height: 1.55;
}

.auth-gate-tabs {
  display: flex;
  border-radius: var(--radius-sm);
  overflow: hidden;
  border: 1px solid var(--border);
  margin-bottom: 20px;
}

.auth-gate-tab {
  flex: 1 1;
  padding: 10px 14px;
  font-size: 0.875rem;
  font-weight: 500;
  background: var(--bg-primary);
  color: var(--text-secondary);
  border: none;
  cursor: pointer;
  transition: background 180ms, color 180ms;
}

.auth-gate-tab.active {
  background: var(--accent);
  color: var(--color-text-on-secondary);
}

/* --bg-tertiary, not --bg-card: there is no --bg-card token and never was, so
   this declaration was invalid and dropped, and the tab had no hover state at
   all. A var() naming something undefined fails silently -- the property is
   simply discarded -- which is why this survived: nothing logs, nothing looks
   obviously wrong, the hover just does nothing. --bg-tertiary is what the
   other 38 hover backgrounds in this file use. */
.auth-gate-tab:hover:not(.active) {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.auth-gate-switch {
  margin: 18px 0 0;
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.auth-gate-switch button {
  background: none;
  border: none;
  padding: 0;
  color: var(--accent);
  font-weight: 600;
  font-size: inherit;
  cursor: pointer;
}
.auth-gate-switch button:hover { text-decoration: underline; }

@media (max-width: 640px) {
  .auth-gate-page {
    padding: 20px 12px;
  }
  .auth-gate-box {
    padding: 28px 20px 24px;
    max-width: 100%;
    border-radius: var(--radius-md);
  }
}

/* Strip the card wrapper from embedded login/register forms */
.auth-gate-box .auth-page {
  min-height: 0;
  padding: 0;
  background: transparent;
}

.auth-gate-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 20px 0 4px;
  color: var(--text-secondary);
  font-size: 0.8rem;
}
.auth-gate-divider::before,
.auth-gate-divider::after {
  content: '';
  flex: 1 1;
  height: 1px;
  background: var(--border);
}

.auth-gate-guest-btn {
  width: 100%;
  padding: 11px;
  background: transparent;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  color: var(--text-primary);
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}
.auth-gate-guest-btn:hover {
  background: var(--bg-tertiary);
  border-color: var(--text-secondary);
}

.auth-gate-box .auth-container {
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 0;
  max-width: none;
  box-shadow: none;
}

.auth-gate-box .auth-container h1 {
  display: none;
}

/* Auth Pages */
.auth-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 80px);
  padding: 20px;
  background: var(--bg-primary);
}

.auth-container {
  box-sizing: border-box;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: 28px;
  padding: 40px;
  width: 100%;
  max-width: 420px;
  box-shadow: var(--shadow-panel);
}

.auth-container h1 {
  margin: 0 0 28px;
  font-size: 1.8rem;
  text-align: center;
  color: var(--text-primary);
}

.auth-form {
  display: grid;
  gap: var(--space-2);
}

.auth-form input {
  box-sizing: border-box;
  width: 100%;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 14px 16px;
  font-size: 1rem;
  background: var(--bg-secondary);
  color: var(--text-primary);
}

.auth-form input:focus {
  border-color: var(--accent);
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Show/hide eye toggle -- shared across every password field in the app
   (see PasswordInput.js). The wrapper is a plain block so it takes on
   whatever width/height the input inside it would have on its own; the
   toggle button just needs the input's own right padding bumped enough to
   clear the icon, regardless of which form's input styling is in play. */
.pw-input-wrap { position: relative; display: block; width: 100%; }
.pw-input-wrap input { width: 100%; box-sizing: border-box; padding-right: 42px; }
.pw-toggle-btn {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 6px;
  cursor: pointer;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: color 120ms ease, background 120ms ease;
}
.pw-toggle-btn:hover { color: var(--text-primary); background: var(--bg-tertiary); }

.auth-forgot-link {
  display: block;
  margin: -6px 0 0;
  background: none;
  border: none;
  color: var(--accent);
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  text-align: right;
  padding: 4px 2px;
  justify-self: end;
}

.auth-error {
  background: color-mix(in srgb, var(--danger) 10%, transparent);
  color: var(--danger);
  border: 1px solid color-mix(in srgb, var(--danger) 30%, transparent);
  border-radius: var(--radius-sm);
  padding: 12px 14px;
  font-size: 0.9rem;
  animation: fieldErrorIn var(--motion-normal, 210ms) var(--motion-ease-enter, ease-out);
}

@keyframes fieldErrorIn {
  from { opacity: 0; transform: translate3d(0, -4px, 0); }
  to   { opacity: 1; transform: translate3d(0, 0, 0); }
}

@media (prefers-reduced-motion: reduce) {
  .auth-error { animation: none; }
}

.otp-sub {
  margin: 0 0 20px;
  font-size: 0.9rem;
  color: var(--text-secondary);
  text-align: center;
  line-height: 1.5;
}

.otp-digit-row {
  display: flex;
  gap: clamp(5px, 2vw, 10px);
  justify-content: center;
  margin: 4px 0 16px;
  width: 100%;
}

.otp-digit-box {
  /* Fluid sizing (not a fixed 46px) so 6 boxes + their gaps always fit
     within the narrowest phone viewport instead of overflowing the card --
     scales down smoothly rather than needing a stack of breakpoints. The
     28px floor (with the modal padding trimmed below) still leaves margin
     to spare even inside the auth modal on a 320px-wide screen. */
  width: clamp(28px, 9vw, 46px);
  height: clamp(38px, 12vw, 56px);
  min-width: 0;
  text-align: center;
  font-size: clamp(1rem, 4.5vw, 1.5rem);
  font-weight: 700;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--bg-secondary);
  color: var(--text-primary);
  transition: border-color 0.15s, box-shadow 0.15s;
}

.otp-digit-box:focus {
  border-color: var(--accent);
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.otp-digit-box-err {
  border-color: var(--danger);
}

.otp-digit-box:disabled {
  opacity: 0.6;
}

.otp-verifying {
  text-align: center;
  font-size: 0.82rem;
  color: var(--text-tertiary);
  margin: -4px 0 12px;
}

.otp-expiry {
  text-align: center;
  font-size: 0.8rem;
  color: var(--text-tertiary);
  margin: 0 0 14px;
}

.otp-expired {
  color: var(--danger);
  font-weight: 600;
}

.otp-verify-btn {
  width: 100%;
}

.otp-info {
  background: color-mix(in srgb, var(--success) 10%, transparent);
  color: var(--success);
  border: 1px solid color-mix(in srgb, var(--success) 30%, transparent);
  border-radius: var(--radius-sm);
  padding: 12px 14px;
  font-size: 0.85rem;
}

.otp-resend-btn {
  display: block;
  width: 100%;
  margin-top: 14px;
  background: none;
  border: none;
  color: var(--accent);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  text-align: center;
  padding: 6px;
}
.otp-resend-btn:disabled { color: var(--text-tertiary); cursor: default; }

.otp-back-btn {
  display: block;
  width: 100%;
  margin-top: 4px;
  background: none;
  border: none;
  color: var(--text-tertiary);
  font-size: 0.82rem;
  cursor: pointer;
  text-align: center;
  padding: 6px;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(1, 13, 33, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 1000;
}

.modal-content {
  background: var(--bg-secondary);
  border-radius: 28px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 25px 50px rgba(1, 13, 33, 0.3);
}

.modal-close {
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  font-size: 1.8rem;
  cursor: pointer;
  color: var(--text-secondary);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transition: all 120ms ease;
  z-index: 10;
}

.modal-close:hover {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

/* LoginPage/RegisterPage are also used as standalone full-height pages
   elsewhere, so strip their page-level sizing when nested inside another
   container -- otherwise .auth-page's min-height balloons the host to
   near-viewport height.

   Two hosts nest them: the auth modal, and the delivery agent sign-in card
   (.dc-card). The delivery card was missing these overrides, which left an
   860px .auth-page inside a card holding a ~300px form -- a dead gap under the
   heading and a 1149px card that ran off a 900px viewport, so an agent had to
   scroll before they could reach the password field.

   They differ only in padding: the modal supplies none of its own, while
   .dc-card already pads 40px, so there the nested page must add nothing. */
.modal-content .auth-page,
.dc-card .auth-page {
  min-height: 0;
  background: transparent;
}

.modal-content .auth-page { padding: 24px 28px 32px; }
.dc-card .auth-page { padding: 0; }

@media (max-width: 480px) {
  .modal-overlay { padding: 10px; }
  .modal-content .auth-page { padding: 20px 14px 24px; }
}

.modal-content .auth-container,
.dc-card .auth-container {
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 0;
  max-width: none;
  box-shadow: none;
}

/* The card already carries its own "Delivery Agent Sign In" title in .dc-title,
   so LoginPage's own <h1> repeats it -- and puts a second <h1> on the page. */
.dc-card .auth-container > h1 { display: none; }

/* Product Detail Page */
.product-detail-page {
  animation: slideIn 300ms ease-out;
}

.back-button {
  background: none;
  border: none;
  color: var(--accent);
  cursor: pointer;
  font-weight: 600;
  font-size: 1rem;
  padding: 8px 12px;
  border-radius: var(--radius-sm);
  transition: all 120ms ease;
  margin-bottom: 20px;
}

.back-button:hover {
  background: var(--bg-tertiary);
  transform: translateX(-4px);
}

.product-detail-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  margin-bottom: 40px;
  animation: slideIn 300ms ease-out;
}

.detail-image {
  border-radius: var(--radius-xl);
  overflow: hidden;
  height: 400px;
}

.detail-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.detail-info {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detail-label {
  color: var(--accent);
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
}

.detail-info h1 {
  margin: 0;
  font-size: 2.2rem;
  color: var(--text-primary);
  line-height: 1.2;
}

.detail-rating {
  display: flex;
  align-items: center;
  gap: 12px;
}

.stars {
  font-size: 1.2rem;
  font-weight: 700;
}

.review-count {
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.detail-description {
  font-size: 1rem;
  line-height: 1.6;
  color: var(--text-secondary);
}

.detail-price {
  font-size: 2rem;
  font-weight: 800;
  color: var(--accent);
}

/* Reviews Section */
.reviews-section {
  margin-top: 40px;
  padding-top: 40px;
  border-top: 1px solid var(--border);
}

.reviews-section h2 {
  margin: 0 0 24px;
  font-size: 1.6rem;
  color: var(--text-primary);
}

.review-form {
  background: var(--bg-tertiary);
  border-radius: var(--radius-xl);
  padding: var(--space-3);
  margin-bottom: 24px;
  display: grid;
  gap: var(--space-2);
}

.form-group {
  display: grid;
  gap: var(--space-1);
}

.form-group label {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 0.9rem;
}

/* Muted "(optional)" / hint text inline in a field label. */
.field-optional {
  font-weight: 400;
  color: var(--text-muted);
  font-size: 0.8em;
}

.form-group select,
.form-group textarea {
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 12px 14px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 0.95rem;
  font-family: inherit;
}

.reviews-list {
  display: grid;
  gap: var(--space-2);
}

.review-card {
  background: var(--bg-tertiary);
  border-radius: var(--radius-lg);
  padding: 18px;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-card);
}

.review-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.review-header strong {
  color: var(--text-primary);
}

.review-rating {
  color: var(--color-primary);
}

.review-verified-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  color: var(--success);
  background: color-mix(in srgb, var(--success) 12%, transparent);
  border-radius: 999px;
  padding: 2px 8px;
}

.review-card p {
  margin: 0 0 12px;
  color: var(--text-secondary);
  line-height: 1.6;
}

.review-card small {
  color: var(--text-tertiary);
  font-size: 0.85rem;
}

/* Order History */
.order-history-page,
.wishlist-page {
  animation: slideIn 300ms ease-out;
}

.order-history-page h1,
.wishlist-page h1 {
  margin: 0 0 28px;
  font-size: 2rem;
  color: var(--text-primary);
}

.orders-list {
  display: grid;
  gap: 18px;
}

.order-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  padding: var(--space-3);
  box-shadow: var(--shadow-card);
  transition: all 200ms ease;
}

.order-card:hover {
  box-shadow: 0 8px 24px rgba(1, 13, 33, 0.13), 0 0 0 1px rgba(1, 13, 33,0.05);
  border-color: rgba(59, 130, 246,0.25);
}

[data-theme="dark"] .order-card:hover {
  box-shadow: 0 8px 24px rgba(1, 13, 33,0.4);
  border-color: rgba(59, 130, 246,0.2);
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 18px;
  gap: var(--space-2);
}

.order-header h3 {
  margin: 0;
  font-size: 1.1rem;
  color: var(--text-primary);
}

.order-header p {
  margin: 6px 0 0;
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.status,
.order-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: var(--radius-xl);
  font-weight: 600;
  font-size: 0.85rem;
  white-space: nowrap;
  text-transform: capitalize;
}

.status::before,
.order-status::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  flex-shrink: 0;
}

.status-received {
  background: color-mix(in srgb, var(--accent-secondary) 10%, transparent);
  color: var(--accent-secondary);
}

.status-processing {
  background: rgba(255, 103, 0, 0.1);
  color: var(--color-primary);
}

.status-shipped {
  background: rgba(59, 130, 246, 0.1);
  color: var(--color-secondary);
}

.status-out_for_delivery {
  background: rgba(59, 130, 246, 0.1);
  color: var(--color-secondary);
}

.status-delivered {
  background: color-mix(in srgb, var(--success) 10%, transparent);
  color: var(--success);
}

.status-cancelled {
  background: color-mix(in srgb, var(--danger) 10%, transparent);
  color: var(--danger);
}

.status-refunded {
  background: color-mix(in srgb, var(--accent-secondary) 10%, transparent);
  color: var(--accent-secondary);
}

.status-exchanged {
  background: color-mix(in srgb, var(--accent-secondary) 10%, transparent);
  color: var(--accent-secondary);
}

.order-items {
  background: var(--bg-tertiary);
  border-radius: var(--radius-lg);
  padding: var(--space-2);
  margin-bottom: 16px;
  display: grid;
  gap: 10px;
}

.order-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid var(--border);
  font-size: 0.95rem;
}

.order-item:last-child {
  border-bottom: none;
}

.order-footer {
  text-align: right;
  font-size: 1.1rem;
  color: var(--text-primary);
}

/* ══════════════════════════════════════════════════════════════
   ADMIN SHELL — sidebar + main layout
   ══════════════════════════════════════════════════════════════ */

.admin-shell {
  display: flex;
  height: 100vh;
  overflow: hidden;
  background: var(--bg-primary);
}

/* ── Sidebar ─────────────────────────────────────────────────── */
.admin-sidebar {
  width: 230px;
  flex-shrink: 0;
  /* Navy in both themes -- see .ann-bar for why this isn't --text-primary. */
  background: var(--color-brand-navy);
  border-right: none;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  transition: width var(--motion-normal, 210ms) ease;
}
.admin-sidebar::-webkit-scrollbar { display: none; }

.admin-sidebar-collapsed {
  width: 64px;
}

.admin-sidebar-collapsed .admin-nav-label,
.admin-sidebar-collapsed .admin-nav-spacer,
.admin-sidebar-collapsed .admin-nav-count,
.admin-sidebar-collapsed .admin-nav-badge {
  display: none;
}

.admin-sidebar-collapsed .admin-nav-item {
  justify-content: center;
  padding: 12px 0;
}

.admin-sidebar-collapsed .admin-nav-icon {
  width: 20px;
  font-size: 1.2rem;
}

.admin-sidebar-toggle {
  margin-left: auto;
  background: rgba(255,255,255,0.06);
  border: none;
  color: rgba(255,255,255,0.7);
  width: 26px; height: 26px;
  border-radius: 7px;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 150ms ease, color 150ms ease;
}
.admin-sidebar-toggle:hover { background: rgba(255,255,255,0.14); color: var(--color-brand-white); }
.admin-sidebar-collapsed .admin-sidebar-toggle { margin-left: 0; }

@media (prefers-reduced-motion: reduce) {
  .admin-sidebar { transition: none; }
}

[data-theme="dark"] .admin-sidebar { background: var(--color-brand-navy); }

.admin-sidebar-brand {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 16px 16px;
  border-bottom: 1px solid rgba(255,255,255,0.08);
}

.admin-sidebar-collapsed .admin-sidebar-brand {
  padding: 16px 8px;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}

.admin-sidebar-logo-icon {
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 40px;
  overflow: hidden;
  border-radius: 9px;
  background: var(--text-primary);
  box-shadow: none;
}

[data-theme="dark"] .admin-sidebar-logo-icon { background: var(--color-brand-navy); }

.admin-sidebar-logo-icon img {
  width: 38px !important;
  height: 38px !important;
  object-fit: contain;
}

.admin-sidebar-store {
  font-weight: 700;
  font-size: 1rem;
  /* Sits on the always-navy sidebar, so it can't use a surface token that
     resolves to a 9% white wash in dark mode. */
  color: var(--color-on-navy);
  margin: 0;
}

.admin-sidebar-role {
  max-width: none;
  font-size: 0.56rem;
  line-height: 1.3;
  color: rgba(255,255,255,0.45);
  margin: 0;
  text-transform: none;
  letter-spacing: 0.015em;
  white-space: nowrap;
}

.admin-sidebar:not(.admin-sidebar-collapsed) .admin-sidebar-toggle {
  position: absolute;
  top: 18px;
  right: 10px;
}

/* ── Nav ─────────────────────────────────────────────────────── */
.admin-nav {
  flex: 1 1;
  padding: 12px 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.admin-nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  border-radius: var(--radius-sm);
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(255,255,255,0.55);
  font-size: 0.95rem;
  font-weight: 600;
  text-align: left;
  transition: background 160ms ease, color 160ms ease;
}

.admin-nav-item:hover {
  background: rgba(255,255,255,0.08);
  color: rgba(255,255,255,0.9);
}

.admin-nav-item.active {
  background: rgba(255,255,255,0.14);
  color: var(--color-brand-white);
  font-weight: 700;
}

.admin-nav-item.active .admin-nav-count,
.admin-nav-item.active .admin-nav-badge {
  background: rgba(255,255,255,0.25);
  color: var(--color-brand-white);
}

.admin-nav-icon  { font-size: 1rem; flex-shrink: 0; width: 20px; text-align: center; }
.admin-nav-label {
  flex: 1 1 auto;
  min-width: 0;
  text-align: left;
  line-height: 1.25;
  white-space: normal;
  overflow-wrap: normal;
}
.admin-nav-spacer { flex: 0 0 auto; margin-left: auto; }

.admin-nav-item-long {
  min-height: 48px;
  align-items: flex-start;
  padding-top: 9px;
  padding-bottom: 9px;
}

.admin-nav-item-long .admin-nav-icon {
  margin-top: 2px;
}

.admin-nav-item-long .admin-nav-label {
  font-size: 0.9rem;
  line-height: 1.28;
}

.admin-nav-item-long .admin-nav-count,
.admin-nav-item-long .admin-nav-badge {
  flex-shrink: 0;
  margin-top: 0;
}

.admin-nav-count {
  font-size: 0.72rem;
  font-weight: 600;
  background: rgba(255,255,255,0.12);
  color: rgba(255,255,255,0.55);
  border-radius: var(--radius-xl);
  padding: 2px 7px;
  min-width: 22px;
  text-align: center;
}

.admin-nav-badge {
  font-size: 0.7rem;
  font-weight: 700;
  background: var(--color-primary);
  color: var(--color-text-on-primary);
  border-radius: var(--radius-xl);
  padding: 2px 7px;
  min-width: 20px;
  text-align: center;
  animation: badge-pop 0.4s var(--ease-spring, ease) both;
}

/* ── Sidebar footer ──────────────────────────────────────────── */
.admin-sidebar-footer {
  padding: 8px 8px 12px;
  border-top: 1px solid rgba(255,255,255,0.08);
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.admin-logout-item {
  color: var(--color-primary) !important;
}

.admin-logout-item:hover {
  background: rgba(255, 103, 0,0.15) !important;
  color: var(--color-primary-soft) !important;
}

/* ── Main area ───────────────────────────────────────────────── */
.admin-main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.admin-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-2);
  padding: 20px 28px 18px;
  border-bottom: 1px solid var(--border);
  background: var(--bg-secondary);
  flex-shrink: 0;
  flex-wrap: wrap;
  /* Prevent horizontal overflow during font metric shifts */
  overflow-x: hidden;
  width: 100%;
  box-sizing: border-box;
}

/* On the dark canvas the header bar takes the sidebar's navy. It shares
 * --bg-secondary with the cards, which is right in light mode -- both are
 * surfaces lifted off a grey page -- but on the dark canvas it put the strip
 * running along the top of every admin screen at exactly the card colour,
 * beside a sidebar that stays navy. Chrome and content read as the same
 * material.
 *
 * The cards keep --bg-secondary: they are content, and the difference is now
 * what separates them from the frame around them. The date picker, period
 * buttons and refresh button inside the bar keep it too, so they stop being
 * defined by their borders alone and lift off the navy as controls.
 *
 * The bottom hairline stays: the content behind the bar is navy as well, and
 * the rule is what marks where the frame ends. */
[data-theme="dark"] .admin-page-header { background: var(--color-brand-navy); }

.admin-breadcrumb {
  font-size: 0.78rem;
  color: var(--text-secondary);
  margin: 0 0 4px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.admin-page-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.admin-refresh-btn {
  width: 38px;
  height: 38px;
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
  background: var(--bg-secondary);
  color: var(--text-secondary);
  font-size: 1.1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-card);
  transition: background 160ms ease, color 160ms ease, transform 200ms var(--ease-spring, ease);
}

.admin-refresh-btn:hover { background: var(--accent); color: var(--color-text-on-secondary); }
.admin-refresh-btn.spinning { animation: spin 700ms linear infinite; }

@keyframes spin { to { transform: rotate(360deg); } }

/* ── Responsive adjustments for admin header ────────────────────── */
/* Prevent layout shift on narrow screens when elements wrap */
@media (max-width: 1024px) {
  .admin-header-actions {
    max-width: 100%;
  }
  
  .ov-date-range {
    min-width: auto;
    max-width: 180px;
    font-size: 0.75rem;
    padding: 6px 10px;
  }
  
  .ov-period-btns {
    max-width: none;
  }
  
  .ov-period-btn {
    padding: 6px 11px;
    min-width: 32px;
    font-size: 0.75rem;
  }
}

@media (max-width: 768px) {
  .admin-page-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  
  .admin-header-actions {
    order: 3;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 8px;
  }
}

.admin-content {
  flex: 1 1;
  overflow-y: auto;
  scrollbar-width: none;
  padding: 24px 28px 40px;

  /* Shared design tokens for the admin redesign rollout (Add Product,
     Commission & Tax, ...) -- declared once here so every admin page can
     opt into the same look via new component classes without redeclaring
     these. Values match the exact spec supplied for the Add Product page. */
  --pf-primary: var(--color-secondary);
  --pf-primary-dark: var(--color-secondary-hover);
  --pf-primary-soft: var(--color-secondary-soft);
  --pf-focus-ring: rgba(59, 130, 246, 0.16);
  --pf-field-bg: var(--bg-tertiary);
  --pf-heading: var(--text-primary);
  --pf-label: var(--text-secondary);
  --pf-text: var(--text-secondary);
  --pf-muted: var(--text-muted);
  --pf-divider: var(--border);
  --pf-danger: var(--color-primary);
  --pf-success: var(--color-secondary);
  --pf-info: var(--color-secondary);
  --pf-info-soft: var(--color-secondary-soft);
  --pf-positive: var(--color-secondary);
  --pf-positive-soft: var(--color-secondary-soft);
  --pf-card-radius: 16px;
  --pf-field-radius: 10px;
  --pf-field-height: 56px;
  --pf-card-shadow: 0 3px 10px rgba(16,24,40,0.07), 0 1px 2px rgba(16,24,40,0.04);
}
.admin-content::-webkit-scrollbar { display: none; }
:root[data-theme="dark"] .admin-content {
  --pf-primary: var(--color-secondary);
  --pf-primary-dark: var(--color-secondary);
  --pf-primary-soft: rgba(91,147,255,0.16);
  --pf-focus-ring: rgba(91,147,255,0.28);
  --pf-field-bg: var(--color-brand-navy);
  --pf-heading: var(--bg-tertiary);
  --pf-label: var(--border);
  --pf-text: var(--border-strong);
  --pf-muted: var(--text-muted);
  --pf-divider: var(--text-secondary);
  --pf-danger: var(--color-primary);
  --pf-success: var(--color-secondary);
  --pf-info: var(--color-secondary);
  --pf-info-soft: rgba(59, 130, 246,0.16);
  --pf-positive: var(--color-secondary);
  --pf-positive-soft: rgba(59, 130, 246, 0.16);
  --pf-card-shadow: 0 2px 10px rgba(1, 13, 33,0.35);
}

/* Shown on every tab when the logged-in admin hasn't enabled 2FA yet --
   requireAdmin.js blocks nearly every admin API call in that state, so
   without this the dashboard just silently shows zeros/empty everywhere
   with no explanation. */
.admin-2fa-banner {
  display: flex; align-items: center; gap: 14px;
  background: color-mix(in srgb, var(--color-primary) 12%, var(--bg-secondary));
  border: 1px solid color-mix(in srgb, var(--color-primary) 35%, var(--border));
  border-radius: 12px;
  padding: 14px 18px;
  margin-bottom: 20px;
  color: var(--text-primary);
}
.admin-2fa-banner-icon { color: var(--color-primary); flex-shrink: 0; }
.admin-2fa-banner-text { flex: 1 1; font-size: 0.88rem; line-height: 1.5; }
.admin-2fa-banner-text strong { display: block; margin-bottom: 2px; }
.admin-2fa-banner-btn {
  flex-shrink: 0; background: var(--color-primary); color: #1a1200; border: none;
  font-weight: 700; font-size: 0.82rem; padding: 9px 16px; border-radius: 8px;
  cursor: pointer; white-space: nowrap; transition: filter 0.15s;
}
.admin-2fa-banner-btn:hover { filter: brightness(1.08); }

/* ── Section utils ───────────────────────────────────────────── */
/* fill-mode deliberately NOT "both" -- fade-up's keyframes animate
   transform, and "both"/"forwards" would permanently persist the final
   \`transform: translateY(0)\` on this element even after the 260ms
   animation ends. Per the CSS spec, ANY non-none transform on an ancestor
   (even a visual no-op like translateY(0)) makes it a containing block for
   position:fixed descendants -- trapping every modal rendered inside an
   .admin-section (there are ~9 in AdminDashboard.js) inside this element's
   box instead of the real viewport, so its full-screen backdrop and
   centering never actually covered the screen. Dropping the fill-mode is
   visually identical (the element's un-animated resting state is already
   opacity:1/transform:none, matching fade-up's "to" keyframe) but lets
   \`transform\` genuinely resolve back to \`none\` once the animation ends. */
.admin-section {
  animation: fade-up 260ms var(--ease-out-expo, ease);
}

.admin-section-heading {
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 28px 0 14px;
  padding-top: 20px;
  border-top: 1px solid var(--border);
}

.admin-form-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 20px 22px;
  margin-bottom: 20px;
  box-shadow: var(--shadow-card);
}

/* ── Store Information (Settings tab) ──────────────────────────── */
.si-field-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px 16px;
}
.si-field { display: flex; flex-direction: column; gap: 5px; min-width: 0; }
.si-field-full { grid-column: 1 / -1; }
.si-label { font-size: 0.82rem; font-weight: 600; color: var(--text-secondary); }
.si-input {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 10px 12px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 0.9rem;
  font-family: inherit;
}
.si-input::placeholder { color: var(--text-muted); }
.si-input:focus { outline: none; border-color: var(--accent); }
@media (max-width: 640px) {
  .si-field-grid { grid-template-columns: 1fr; }
}

/* ── Add Product: live preview ─────────────────────────────────── */
.admin-product-form-layout {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 20px;
  align-items: start;
}

.admin-product-form-main {
  min-width: 0;
}

.admin-banner-form-layout {
  display: grid;
  grid-template-columns: 1fr 420px;
  gap: 20px;
  align-items: start;
}

.admin-banner-form-main {
  min-width: 0;
}

.admin-banner-preview-card .carousel-slide {
  width: 100%;
}

.admin-preview-card {
  background: var(--bg-primary);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 16px;
  position: sticky;
  top: 16px;
}

.admin-preview-label {
  font-size: 0.88rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 3px;
}

.admin-preview-sub {
  font-size: 0.74rem;
  color: var(--text-secondary);
  margin: 0 0 12px;
}

.admin-preview-img-wrap {
  position: relative;
  background: var(--bg-tertiary);
  border-radius: 10px;
  height: 180px;
  overflow: hidden;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.admin-preview-badge {
  position: absolute;
  top: 10px;
  left: 0;
  background: var(--color-secondary);
  color: var(--color-text-on-secondary);
  font-size: 0.68rem;
  font-weight: 800;
  padding: 4px 10px 4px 8px;
  border-radius: 0 8px 8px 0;
  z-index: 2;
  letter-spacing: 0.04em;
}

.admin-preview-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 8px;
}

.admin-preview-img-empty {
  font-size: 2.6rem;
  opacity: 0.35;
}

.admin-preview-info { display: flex; flex-direction: column; gap: 5px; }

.admin-preview-cat {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--accent);
  margin: 0;
}

.admin-preview-name {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  line-height: 1.3;
}

.admin-preview-price-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}

.admin-preview-price {
  font-size: 1.3rem;
  font-weight: 800;
  color: var(--text-primary);
}

.admin-preview-compare {
  font-size: 0.82rem;
  color: var(--text-tertiary);
  text-decoration: line-through;
}

.admin-preview-off {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--color-secondary);
  background: rgba(59, 130, 246,0.1);
  padding: 2px 7px;
  border-radius: 5px;
}

.admin-preview-stock { font-size: 0.78rem; font-weight: 700; margin: 4px 0 0; }
.admin-stock-in  { color: var(--color-secondary); }
.admin-stock-out { color: var(--color-primary); }

@media (max-width: 900px) {
  .admin-product-form-layout, .admin-banner-form-layout { grid-template-columns: 1fr; }
  .admin-preview-card { position: static; }
}

/* ── Add Product: image upload dropzone ──────────────────────────── */
.admin-dropzone {
  border: 2px dashed var(--border);
  border-radius: 12px;
  padding: 24px 20px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
  background: var(--bg-primary);
}
.admin-dropzone:hover { border-color: var(--accent); background: rgba(59, 130, 246,0.03); }
.admin-dropzone-over {
  border-color: var(--accent);
  background: rgba(59, 130, 246,0.06);
}
.admin-dropzone-icon { font-size: 1.8rem; display: block; margin-bottom: 6px; }
.admin-dropzone-text { font-size: 0.85rem; color: var(--text-secondary); margin: 0 0 4px; }
.admin-dropzone-link { color: var(--accent); font-weight: 600; text-decoration: underline; cursor: pointer; }
.admin-dropzone-hint { font-size: 0.74rem; color: var(--text-tertiary); margin: 0; }

.admin-images-label {
  font-size: 0.82rem;
  color: var(--text-secondary);
  margin: 4px 0 0;
}
.admin-images-label span { color: var(--text-tertiary); font-size: 0.76rem; }

.admin-image-grid {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 4px;
}

.admin-img-slot {
  position: relative;
  width: 96px;
  border-radius: 10px;
  border: 2px solid var(--border);
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.admin-img-slot-primary {
  border-color: var(--accent);
  box-shadow: 0 0 0 2px rgba(59, 130, 246,0.3);
}

.admin-img-thumb {
  width: 100%;
  height: 80px;
  object-fit: cover;
  display: block;
  border-radius: 8px 8px 0 0;
}

.admin-img-view-select {
  width: 100%;
  font-size: 0.6rem;
  border: none;
  border-top: 1px solid var(--border);
  background: var(--bg-secondary);
  color: var(--text-secondary);
  padding: 3px 4px;
  cursor: pointer;
  text-align: center;
  outline: none;
  flex-shrink: 0;
}
.admin-img-view-select:hover { background: var(--bg-tertiary); }

.admin-img-cover-badge {
  position: absolute;
  top: 4px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--accent);
  color: var(--color-text-on-secondary);
  font-size: 0.62rem;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 4px;
  white-space: nowrap;
  letter-spacing: 0.04em;
}

.admin-img-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgba(1, 13, 33,0.65);
  border: none;
  color: var(--color-brand-white);
  font-size: 0.65rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.15s;
}
.admin-img-slot:hover .admin-img-remove { opacity: 1; }

.admin-img-spinner {
  position: absolute;
  inset: 0;
  background: rgba(1, 13, 33,0.4);
  color: var(--color-brand-white);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  animation: spin 1s linear infinite;
}

.admin-img-error {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--color-primary);
  color: var(--color-text-on-primary);
  font-size: 0.75rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.admin-img-add {
  width: 96px;
  height: 96px;
  border-radius: 10px;
  border: 2px dashed var(--border);
  background: var(--bg-primary);
  cursor: pointer;
  font-size: 1.6rem;
  color: var(--text-tertiary);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.15s, color 0.15s;
  flex-shrink: 0;
}
.admin-img-add:hover { border-color: var(--accent); color: var(--accent); }

/* ── Add Product: feature highlights editor ──────────────────────── */
.admin-highlights-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.admin-highlight-row {
  display: grid;
  grid-template-columns: 170px 1fr 1fr 32px;
  gap: 8px;
  align-items: center;
}

.admin-highlight-icon-select {
  width: 100%;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 9px 10px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 0.85rem;
  font-family: inherit;
  cursor: pointer;
}

.admin-highlight-remove {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--bg-tertiary);
  border: none;
  color: var(--text-secondary);
  font-size: 0.75rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.admin-highlight-remove:hover { background: var(--color-primary); color: var(--color-text-on-primary); }

.admin-highlight-add {
  align-self: flex-start;
  font-size: 0.82rem !important;
  padding: 6px 12px !important;
}

@media (max-width: 700px) {
  .admin-highlight-row { grid-template-columns: 1fr; }
}

/* ── Add Product: specifications editor ──────────────────────────── */
.admin-spec-template-btn {
  align-self: flex-start;
  font-size: 0.82rem !important;
  padding: 6px 12px !important;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.admin-spec-row {
  display: grid;
  grid-template-columns: 150px 1fr 1fr 32px;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;
}

.admin-spec-row input[type="text"] {
  width: 100%;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 9px 10px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 0.85rem;
  font-family: inherit;
  box-sizing: border-box;
}

.admin-spec-group-input { font-weight: 600; }

@media (max-width: 700px) {
  .admin-spec-row { grid-template-columns: 1fr; }
}

.banner-feature-row {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;
}
.banner-feature-row input { flex: 1 1; }

/* ── Add Product: sectioned form (mirrors seller's Add Product) ──── */
.admin-pf-section {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 14px;
  box-shadow: var(--shadow-card);
}

.admin-pf-section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 2px;
}

.admin-pf-section-icon {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  flex-shrink: 0;
}

.admin-pf-section-sub {
  font-size: 0.8rem;
  color: var(--text-secondary);
  margin: -8px 0 4px;
}

.admin-pf-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.admin-pf-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-secondary);
}

.admin-pf-req { color: var(--color-primary); }

.admin-pf-input,
.admin-pf-textarea {
  width: 100%;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 10px 12px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 0.9rem;
  font-family: inherit;
  box-sizing: border-box;
}

/* \`min-height: 80px\` and \`resize\` used to live in the shared block above,
   which meant every single-line <input class="admin-pf-input"> rendered at
   textarea height with a resize affordance it can't even use. Nearly every
   admin form was already papering over it with its own min-height override
   (see .admin-banner-editor-compact, .admin-pf-card-v2,
   .admin-product-editor-compact) -- the forms that didn't, like the Add
   Delivery Agent modal, ended up with 80px-tall name and email boxes.

   Scoped by element rather than class so a <textarea> still gets the
   intended height whichever of the two classes it happens to carry. */
textarea.admin-pf-input,
.admin-pf-textarea {
  resize: vertical;
  min-height: 80px;
}

/* Native <option> popups don't inherit the <select>'s background in most
   browsers -- they fall back to the OS's own white listbox, which leaves
   dark-mode text (light-on-white) unreadable unless set explicitly here. */
.admin-pf-input option { background: var(--bg-primary); color: var(--text-primary); }

/* ── Add Delivery Agent modal ──────────────────────────────────────
   Replaces a form built entirely from inline styles. Beyond being hard to
   read, that version had no header treatment, no close button, and inherited
   the 80px textarea min-height above, so the name/email fields rendered as
   tall empty boxes. Kept theme-reactive (var(--bg-*)) rather than following
   .admin-modal-panel's fixed-dark identity, because this modal opens over
   the light Super Admin content area, not the dark sidebar. */
.dagent-overlay {
  position: fixed;
  inset: 0;
  background: rgba(1, 13, 33, 0.5);
  backdrop-filter: blur(2px);
  z-index: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.dagent-modal {
  background: var(--bg-primary);
  border: 1px solid var(--border);
  border-radius: 18px;
  width: 100%;
  max-width: 430px;
  box-shadow: 0 24px 64px rgba(1, 13, 33, 0.28);
  overflow: hidden;
}
.dagent-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 22px 16px;
  border-bottom: 1px solid var(--border);
}
.dagent-head-icon {
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  border-radius: 10px;
  background: rgba(59, 130, 246, 0.1);
  color: var(--accent);
  display: flex;
  align-items: center;
  justify-content: center;
}
.dagent-head-text { flex: 1 1; min-width: 0; }
.dagent-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.3;
}
.dagent-sub {
  margin: 2px 0 0;
  font-size: 0.78rem;
  color: var(--text-secondary);
}
.dagent-close {
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 140ms ease, color 140ms ease;
}
.dagent-close:hover:not(:disabled) { background: var(--bg-tertiary); color: var(--text-primary); }
.dagent-close:disabled { opacity: 0.45; cursor: not-allowed; }

.dagent-body {
  padding: 18px 22px 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.dagent-field { display: flex; flex-direction: column; gap: 6px; }
.dagent-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-secondary);
}
/* The leading icon sits in the wrapper rather than the input so it stays put
   while the input keeps full-width behaviour and its own focus ring. */
.dagent-input-wrap { position: relative; display: block; }
.dagent-input-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  /* --text-muted is the same grey as the placeholder, which left these
     1.5px-stroke glyphs barely legible against the field. --text-secondary
     separates the icon from the placeholder text beside it. */
  color: var(--text-secondary);
  display: flex;
  pointer-events: none;
  transition: color 140ms ease;
}
/* Sharpen the active field's icon along with its border. */
.dagent-input-wrap:focus-within .dagent-input-icon { color: var(--accent); }
.dagent-input-wrap input {
  width: 100%;
  box-sizing: border-box;
  height: 44px;
  min-height: 0;
  padding: 0 12px 0 38px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 0.9rem;
  font-family: inherit;
  transition: border-color 140ms ease, box-shadow 140ms ease;
}
.dagent-input-wrap input::placeholder { color: var(--text-muted); }
.dagent-input-wrap input:hover:not(:focus) { border-color: var(--text-muted); }
.dagent-input-wrap input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}
/* Password field: PasswordInput renders its own .pw-input-wrap around the
   input, so the icon padding and the eye button have to coexist. */
.dagent-input-wrap .pw-input-wrap input { padding-right: 42px; }

.dagent-error {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 0;
  padding: 9px 11px;
  border-radius: 9px;
  background: rgba(255, 103, 0, 0.08);
  border: 1px solid rgba(255, 103, 0, 0.25);
  color: var(--color-primary);
  font-size: 0.8rem;
  font-weight: 500;
}

.dagent-foot {
  display: flex;
  gap: 10px;
  padding: 0 22px 20px;
}
.dagent-btn {
  height: 42px;
  border-radius: 10px;
  font-size: 0.88rem;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 140ms ease, border-color 140ms ease, opacity 140ms ease;
}
.dagent-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.dagent-btn-cancel {
  flex: 0 0 auto;
  padding: 0 18px;
  border: 1px solid var(--border);
  background: transparent;
  color: var(--text-secondary);
}
.dagent-btn-cancel:hover:not(:disabled) { background: var(--bg-tertiary); color: var(--text-primary); }
/* The primary action takes the remaining width so the pair reads as one
   bar and the destructive-free default is the obvious target. */
.dagent-btn-submit {
  flex: 1 1;
  border: none;
  background: var(--accent);
  color: var(--color-text-on-secondary);
}
.dagent-btn-submit:hover:not(:disabled) { background: var(--accent-dark, var(--color-secondary-hover)); }

@media (max-width: 480px) {
  .dagent-foot { flex-direction: column-reverse; }
  .dagent-btn-cancel { flex: 1 1 auto; width: 100%; }
}

/* ── "Add Admin" modal ────────────────────────────────────────────
   Deliberately fixed-dark rather than theme-reactive (var(--bg-*)) --
   matches the existing .admin-sidebar, which is likewise a hardcoded
   var(--text-primary) regardless of the site's light/dark toggle. This is an
   admin-only surface with its own settled dark identity, not a
   customer-facing one that needs to flip with the theme switch. */
.admin-modal-panel {
  background: var(--color-brand-navy);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 20px;
  padding: 32px;
  width: 100%;
  /* Widened from 480px to fit the two-column field grid below. In one
     column the Add Admin form ran past the viewport, and because the whole
     panel was the scroll container the Cancel/Create buttons sat below the
     fold -- the modal opened with no visible way to submit it. */
  max-width: 620px;
  box-shadow: 0 24px 70px rgba(1, 13, 33,0.5);
  max-height: calc(100vh - 32px);
  /* Scroll the body instead of the panel so the header and footer stay put
     however long the form gets. */
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.admin-modal-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 28px;
}
.admin-modal-icon-badge {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: rgba(59,130,246,0.15);
  color: var(--color-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
}
.admin-modal-header-text { flex: 1 1; min-width: 0; }
.admin-modal-header-text h3 {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 800;
  color: var(--color-brand-white);
  letter-spacing: -0.01em;
}
.admin-modal-header-text p {
  margin: 6px 0 0;
  font-size: 0.9rem;
  color: var(--text-muted);
  line-height: 1.4;
}
.admin-modal-close {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid rgba(255,255,255,0.12);
  background: transparent;
  color: var(--border-strong);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 150ms, border-color 150ms;
}
.admin-modal-close:hover { background: rgba(255,255,255,0.06); border-color: rgba(255,255,255,0.22); }

.admin-modal-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* min-height:0 lets this shrink inside the flex panel so it -- not the
     panel -- is what scrolls. Without it a flex child refuses to go below
     its content height and the footer gets pushed off-screen again. */
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  /* Room for the focus ring, which would otherwise be clipped by the
     scroll container's edge. */
  padding: 3px;
  margin: -3px;
}
.admin-modal-field label {
  display: block;
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--border);
  margin-bottom: 8px;
}
.admin-modal-field input,
.admin-modal-field select {
  width: 100%;
  box-sizing: border-box;
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 12px;
  padding: 13px 15px;
  font-size: 0.95rem;
  font-family: inherit;
  color: var(--color-brand-white);
  transition: border-color 150ms, box-shadow 150ms;
}
/* \`width: 100%\` above was written for text fields, but it also caught the
   Granted Areas checkboxes -- stretching each one into a ~360px-wide box
   that shoved its label to the far right and wrapped it onto two lines. */
.admin-modal-field input[type="checkbox"] {
  width: auto;
  padding: 0;
}
.admin-modal-field input::placeholder { color: var(--text-secondary); }
.admin-modal-field input:focus,
.admin-modal-field select:focus {
  outline: none;
  border-color: var(--color-secondary);
  box-shadow: 0 0 0 3px rgba(59,130,246,0.25);
}
.admin-modal-field select option { background: var(--color-brand-navy); color: var(--color-brand-white); }

/* Two-column field grid. Collapses to one column on narrow viewports, where
   side-by-side fields would be too cramped to read. */
.admin-modal-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}
.admin-modal-field--full { grid-column: 1 / -1; }
@media (max-width: 560px) {
  .admin-modal-grid { grid-template-columns: 1fr; }
}

/* Leading icons. The icon lives in the wrapper rather than the field so the
   input keeps its own full-width sizing and focus ring. */
.admin-modal-input-wrap { position: relative; display: block; }
.admin-modal-input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
  display: flex;
  pointer-events: none;
  transition: color 150ms;
}
.admin-modal-input-wrap:focus-within .admin-modal-input-icon { color: var(--color-secondary); }
.admin-modal-input-wrap input { padding-left: 42px; }
/* PasswordInput nests its own wrapper and eye button inside this one. */
.admin-modal-input-wrap .pw-input-wrap input { padding-right: 44px !important; }

/* Sub-label under a field heading. Sits between the bold <label> and the
   control, so its top margin cancels the label's bottom margin. */
.admin-modal-hint {
  margin: -4px 0 10px;
  font-size: 0.82rem;
  color: var(--text-muted);
  line-height: 1.4;
}

/* Granted-areas picker, shared by the Add Admin and Edit Access modals so
   the same choice looks the same in both. The whole tile is the label, which
   gives a much larger hit target than a bare 13px checkbox. */
.admin-area-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}
@media (max-width: 560px) {
  .admin-area-grid { grid-template-columns: 1fr; }
}
/* Scoped under .admin-area-grid purely for specificity: a bare
   \`.admin-area-tile\` (0,1,0) loses to \`.admin-modal-field label\` (0,1,1),
   which would force display:block and drop each label onto its own line
   below the checkbox. Tiles only ever live inside the grid, so this costs
   nothing. */
.admin-area-grid .admin-area-tile {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 13px 14px;
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 12px;
  background: rgba(255,255,255,0.02);
  cursor: pointer;
  transition: border-color 150ms, background 150ms;
  /* Also overrides that rule's bold/blocky label treatment. */
  font-size: 0.88rem;
  font-weight: 500;
  color: var(--border-strong);
  margin-bottom: 0;
  line-height: 1.35;
}
.admin-area-grid .admin-area-tile:hover { border-color: rgba(255,255,255,0.24); background: rgba(255,255,255,0.04); }
.admin-area-grid .admin-area-tile--on {
  border-color: rgba(59,130,246,0.55);
  background: rgba(59,130,246,0.1);
  color: var(--color-brand-white);
}
/* Drawn rather than left native. accent-color only recolours the *checked*
   fill -- an unchecked native checkbox keeps its white UA background, which
   on this near-black panel read as four glaring white squares. appearance:
   none lets the unchecked state be a soft outline instead, and the tick is
   a rotated CSS border so there's no SVG to keep in sync with the state. */
.admin-area-tile input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  flex-shrink: 0;
  width: 17px;
  height: 17px;
  margin: 0;
  border: 1.5px solid rgba(255,255,255,0.28);
  border-radius: 5px;
  background: rgba(255,255,255,0.04);
  display: grid;
  place-content: center;
  cursor: pointer;
  transition: background 140ms, border-color 140ms;
}
.admin-area-tile input[type="checkbox"]:hover { border-color: rgba(255,255,255,0.45); }
.admin-area-tile input[type="checkbox"]:checked {
  background: var(--color-secondary-hover);
  border-color: var(--color-secondary-hover);
}
.admin-area-tile input[type="checkbox"]:checked::after {
  content: '';
  width: 9px;
  height: 5px;
  border-left: 2px solid var(--color-brand-white);
  border-bottom: 2px solid var(--color-brand-white);
  transform: rotate(-45deg) translate(1px, -2px);
}
.admin-area-grid .admin-area-tile:focus-within { border-color: var(--color-secondary); box-shadow: 0 0 0 3px rgba(59,130,246,0.25); }

.admin-modal-error {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(255, 103, 0,0.1);
  border: 1px solid rgba(255, 103, 0,0.3);
  color: var(--color-primary-soft);
  font-size: 0.85rem;
}

.admin-modal-footer {
  display: flex;
  gap: 12px;
  margin-top: 28px;
  padding-top: 24px;
  border-top: 1px solid rgba(255,255,255,0.08);
}
.admin-modal-btn-cancel {
  flex: 0 0 auto;
  min-width: 120px;
  padding: 14px 20px;
  border-radius: 12px;
  border: 1px solid rgba(255,255,255,0.14);
  background: transparent;
  color: var(--border);
  font-weight: 700;
  font-size: 0.95rem;
  cursor: pointer;
  transition: background 150ms;
}
.admin-modal-btn-cancel:hover { background: rgba(255,255,255,0.06); }
.admin-modal-btn-submit {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 20px;
  border-radius: 12px;
  border: none;
  background: var(--color-secondary-hover);
  color: var(--color-text-on-secondary);
  font-weight: 700;
  font-size: 0.95rem;
  cursor: pointer;
  transition: background 150ms;
}
.admin-modal-btn-submit:hover:not(:disabled) { background: var(--color-secondary-hover); }
.admin-modal-btn-submit:disabled,
.admin-modal-btn-cancel:disabled { opacity: 0.55; cursor: not-allowed; }

.admin-pf-char-count {
  font-size: 0.72rem;
  color: var(--text-tertiary);
  text-align: right;
  margin-top: 4px;
}

.admin-pf-row-3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; }
.admin-pf-row-2 { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; }

.admin-pf-price-wrap {
  display: flex;
  align-items: center;
  border: 1px solid var(--border);
  border-radius: 8px;
  overflow: hidden;
  background: var(--bg-primary);
  transition: border-color 0.15s;
}
.admin-pf-price-wrap:focus-within { border-color: var(--accent); }
.admin-pf-price-sym {
  padding: 0 8px;
  font-size: 0.85rem;
  color: var(--text-secondary);
  background: var(--bg-tertiary);
  border-right: 1px solid var(--border);
  height: 100%;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  line-height: 36px;
}
.admin-pf-price-sym-r {
  border-right: none;
  border-left: 1px solid var(--border);
}
.admin-pf-price-input {
  border: none !important;
  border-radius: 0 !important;
  background: transparent !important;
  flex: 1 1;
}

.admin-pf-qty-ctrl {
  display: flex;
  align-items: center;
  align-self: flex-start;
  border: 1px solid var(--border);
  border-radius: 8px;
  overflow: hidden;
  width: fit-content;
}
.admin-pf-qty-btn {
  width: 36px;
  height: 36px;
  border: none;
  background: var(--bg-tertiary);
  color: var(--text-primary);
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.admin-pf-qty-btn:hover { background: var(--border); }
.admin-pf-qty-input {
  width: 64px;
  border: none !important;
  border-radius: 0 !important;
  background: transparent !important;
  text-align: center;
}
.admin-pf-in-stock {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--color-secondary);
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
}

@media (max-width: 700px) {
  .admin-pf-row-3 { grid-template-columns: 1fr 1fr; }
}
@media (max-width: 480px) {
  .admin-pf-row-3, .admin-pf-row-2 { grid-template-columns: 1fr; }
}

.admin-table-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

/* ── Toast notifications ─────────────────────────────────────── */
.toast-stack {
  position: fixed;
  bottom: 24px;
  right: 24px;
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  z-index: 9999;
  pointer-events: none;
}

.toast {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 18px;
  border-radius: var(--radius-sm);
  font-size: 0.88rem;
  font-weight: 500;
  box-shadow: 0 4px 20px rgba(1, 13, 33,0.15);
  animation: slide-down 260ms var(--ease-out-expo, ease) both;
  max-width: 320px;
  pointer-events: auto;
}

.toast-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 700;
  flex-shrink: 0;
}

.toast-success { background: var(--color-secondary-soft); color: var(--color-secondary); border: 1px solid var(--color-secondary-soft); }
.toast-success .toast-icon { background: var(--color-secondary); color: var(--color-text-on-secondary); }
.toast-error   { background: var(--color-primary-soft); color: var(--color-primary); border: 1px solid var(--color-primary-soft); }
.toast-error   .toast-icon { background: var(--color-primary); color: var(--color-text-on-primary); }
.toast-info    { background: var(--color-secondary-soft); color: var(--color-secondary-hover); border: 1px solid var(--color-secondary-soft); }
.toast-info    .toast-icon { background: var(--accent); color: var(--color-text-on-secondary); }

[data-theme="dark"] .toast-success { background: var(--color-secondary-soft); color: var(--color-secondary); border-color: var(--color-secondary); }
[data-theme="dark"] .toast-error   { background: var(--color-primary-soft); color: var(--color-primary-soft); border-color: var(--color-primary); }
[data-theme="dark"] .toast-info    { background: #0f1d3d; color: var(--color-secondary-soft); border-color: var(--color-secondary-hover); }

/* ── Skeleton shimmer ────────────────────────────────────────── */
.skeleton {
  background: linear-gradient(90deg, var(--bg-tertiary) 25%, var(--border) 50%, var(--bg-tertiary) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s ease infinite;
}

@keyframes shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.skeleton-row {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 12px 0;
}

/* ── KPI header/footer/trend ─────────────────────────────────── */
.kpi-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.kpi-icon {
  width: 36px;
  height: 36px;
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  flex-shrink: 0;
}

.kpi-footer {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  margin-top: 2px;
}

.kpi-trend {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: var(--radius-xl);
}

.kpi-trend-up   { background: var(--color-secondary-soft); color: var(--color-secondary); }
.kpi-trend-down { background: var(--color-primary-soft); color: var(--color-primary); }

[data-theme="dark"] .kpi-trend-up   { background: var(--color-secondary-soft); color: var(--color-secondary); }
[data-theme="dark"] .kpi-trend-down { background: var(--color-primary-soft); color: var(--color-primary); }

/* ── Empty state ─────────────────────────────────────────────── */
.admin-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 24px;
  gap: var(--space-1);
}

.admin-empty-icon  { font-size: 2.5rem; opacity: 0.4; }
.admin-empty-title { font-size: 0.95rem; font-weight: 600; color: var(--text-secondary); margin: 0; }
.admin-empty-sub   { font-size: 0.82rem; color: var(--text-secondary); margin: 0; opacity: 0.7; }

/* ── Inline delete confirm ───────────────────────────────────── */
/* Superseded by .confirm-dialog (see the destructive-confirmation block at
   the end of this file). Kept only because .inline-confirm-label is still a
   convenient hook if a compact inline confirm is ever wanted again; no
   component references these today. */
.inline-confirm {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.inline-confirm-label {
  font-size: 0.78rem;
  color: var(--text-secondary);
}

/* ── Pagination ──────────────────────────────────────────────── */
.admin-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  padding: 20px 0 4px;
}

.admin-page-btn {
  padding: 8px 18px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 160ms ease, color 160ms ease;
}

.admin-page-btn:hover:not(:disabled) { background: var(--accent); color: var(--color-text-on-secondary); border-color: var(--accent); }
.admin-page-btn:disabled { opacity: 0.4; cursor: not-allowed; }

.admin-page-info {
  font-size: 0.85rem;
  color: var(--text-secondary);
}

/* ── Orders status summary row ───────────────────────────────── */
.orders-summary-row {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}

.orders-status-card {
  background: color-mix(in srgb, var(--scolor, var(--accent)) 9%, var(--bg-secondary));
  border: 1px solid var(--border);
  border-top: 4px solid var(--scolor, var(--accent));
  border-radius: var(--radius-md);
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-shadow: var(--shadow-card);
}

.osc-count {
  font-size: 1.85rem;
  font-weight: 800;
  line-height: 1;
}

.osc-label {
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: capitalize;
  color: var(--text-primary);
}

.osc-bar-bg {
  height: 6px;
  background: var(--bg-tertiary);
  border-radius: 999px;
  margin-top: 8px;
  overflow: hidden;
}

.osc-bar-fill {
  height: 100%;
  border-radius: 999px;
  transition: width 600ms var(--ease-out-expo, ease);
}

@media (max-width: 768px) {
  .orders-summary-row { grid-template-columns: repeat(3, 1fr); }
}

/* ── Orders table extra columns ──────────────────────────────── */
.admin-orders-header {
  grid-template-columns: 132px 1fr 70px 90px 72px 100px 130px !important;
}

.admin-order-row {
  display: grid !important;
  grid-template-columns: 132px 1fr 70px 90px 72px 100px 130px !important;
}

.order-items-count {
  font-size: 0.85rem;
  color: var(--text-secondary);
  align-self: center;
}

.order-date-cell {
  font-size: 0.82rem;
  color: var(--text-secondary);
  align-self: center;
}

/* ── Ghost button ────────────────────────────────────────────── */
.btn-ghost {
  background: transparent !important;
  border: 1px solid var(--border) !important;
  color: var(--text-primary) !important;
}

.btn-ghost:hover { background: var(--bg-tertiary) !important; }

/* ── Legacy .admin-dashboard removed — kept for backward compat. */
.admin-dashboard { animation: fade-up 260ms ease both; }

.admin-tabs {
  display: flex;
  gap: 12px;
  margin-bottom: 28px;
  border-bottom: 2px solid var(--border);
}

.tab {
  background: none;
  border: none;
  padding: 14px 18px;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  font-size: 1rem;
  border-bottom: 3px solid transparent;
  transition: all 120ms ease;
  margin-bottom: -2px;
}

.tab:hover  { color: var(--text-primary); }
.tab.active { color: var(--accent); border-bottom-color: var(--accent); }

.admin-section h2 {
  margin: 0 0 18px;
  font-size: 1.3rem;
  color: var(--text-primary);
  padding-top: 20px;
  border-top: 1px solid var(--border);
}

.product-form,
.product-form {
  background: var(--bg-tertiary);
  border-radius: var(--radius-lg);
  padding: 20px;
  display: grid;
  gap: 12px;
  margin-bottom: 24px;
}

.product-form input,
.product-form textarea {
  width: 100%;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 12px 14px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 0.95rem;
  font-family: inherit;
}

.products-table,
.orders-table {
  background: var(--bg-secondary);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  overflow: hidden;
  box-shadow: var(--shadow-card);
}

.product-row,
.order-row {
  display: grid;
  grid-template-columns: auto 1fr auto auto auto;
  gap: var(--space-2);
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border);
  font-size: 0.95rem;
}

.status-select {
  padding: 8px 12px;
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 150ms, box-shadow 150ms;
}

.status-select:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent) 18%, transparent);
}

.product-row:last-child,
.order-row:last-child {
  border-bottom: none;
}

.product-row span,
.order-row span {
  color: var(--text-primary);
}

/* ── Password Strength Meter ─────────────────────────── */
.strength-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 12px 14px;
  animation: strength-fade-in 180ms ease-out;
}

.strength-wrapper-closing {
  animation: strength-fade-out 220ms ease-in forwards;
}

@keyframes strength-fade-in {
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
}

@keyframes strength-fade-out {
  from { opacity: 1; transform: translateY(0); max-height: 160px; margin: 0; padding: 12px 14px; }
  to   { opacity: 0; transform: translateY(-6px); max-height: 0; margin: 0; padding: 0 14px; overflow: hidden; }
}

.strength-bar-track {
  height: 6px;
  border-radius: var(--radius-xs);
  background: var(--border);
  overflow: hidden;
}

.strength-bar-fill {
  height: 100%;
  border-radius: var(--radius-xs);
  transition: width 300ms ease, background 300ms ease;
}

.strength-weak   { background: var(--danger); }
.strength-fair   { background: var(--color-primary); }
.strength-strong { background: var(--success); }

.strength-label {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.strength-label-weak   { color: var(--danger); }
.strength-label-fair   { color: var(--color-primary); }
.strength-label-strong { color: var(--success); }

.strength-checks {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.strength-checks li {
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 6px;
}

.check-pass { color: var(--success); }
.check-fail { color: var(--text-secondary); }

/* ── Address Book ─────────────────────────────────────── */
.address-book {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.address-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 14px;
  margin-bottom: 4px;
}

.address-card {
  position: relative;
  background: var(--bg-secondary);
  border: 2px solid var(--border);
  border-radius: var(--radius-sm);
  padding: var(--space-2);
  font-size: 0.9rem;
  color: var(--text-secondary);
  transition: border-color 150ms, background 150ms;
  cursor: default;
  box-shadow: var(--shadow-card);
}

.address-card p {
  margin: 2px 0;
  line-height: 1.5;
}

.address-card.selected {
  border-color: var(--accent);
  background: rgba(59, 130, 246, 0.05);
  cursor: pointer;
}

.address-card.is-default {
  border-color: var(--accent);
}

[data-theme='dark'] .address-card.selected,
[data-theme='dark'] .address-card.is-default {
  background: rgba(59, 130, 246, 0.1);
}

.address-default-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: var(--accent);
  color: var(--color-text-on-secondary);
  padding: 2px 8px;
  border-radius: var(--radius-xl);
}

.address-card-name {
  font-weight: 600;
  color: var(--text-primary) !important;
  margin-bottom: 6px !important;
}

.address-card-actions {
  display: flex;
  gap: 12px;
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid var(--border);
}

.btn-link {
  background: none;
  border: none;
  padding: 0;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--accent);
  cursor: pointer;
  text-decoration: none;
}

.btn-link:hover { text-decoration: underline; }

.danger-link { color: var(--danger) !important; }

.address-form-inline {
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 20px;
  margin-top: 16px;
  box-shadow: var(--shadow-card);
}

.address-form-inline h3 {
  margin: 0 0 16px;
  font-size: 1rem;
  color: var(--text-primary);
}

/* ── Stock Badges ─────────────────────────────────────── */
.product-image-wrap {
  position: relative;
  overflow: hidden;
}

.product-image-wrap img {
  display: block;
  width: 100%;
}

.stock-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: var(--radius-xl);
  pointer-events: none;
}

.badge-in  { background: var(--color-secondary-soft); color: var(--color-secondary); }
.badge-low { background: var(--color-primary-soft); color: var(--color-primary); }
.badge-oos { background: var(--color-primary-soft); color: var(--color-primary); }

.product-card.out-of-stock {
  opacity: 0.72;
}

.detail-stock-badge {
  display: inline-block;
  font-size: 0.82rem;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: var(--radius-xl);
  margin-bottom: 12px;
}

/* Admin stock pill */
.admin-stock-pill {
  display: inline-block;
  font-size: 0.82rem;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: var(--radius-xl);
  text-align: center;
}

.stock-ok        { background: var(--color-secondary-soft); color: var(--color-secondary); }
.stock-low       { background: var(--color-primary-soft); color: var(--color-primary); }
.stock-oos       { background: var(--color-primary-soft); color: var(--color-primary); }
.stock-unlimited { background: var(--bg-primary); color: var(--text-secondary); border: 1px solid var(--border); }

/* ── Admin Dashboard Improvements ────────────────────── */
.admin-form-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.product-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.product-form-actions {
  display: flex;
  gap: 10px;
}

.admin-products-table,
.admin-orders-table {
  background: var(--bg-secondary);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  overflow: hidden;
  margin-bottom: 24px;
  box-shadow: var(--shadow-card);
}

.admin-table-header {
  display: grid;
  gap: 12px;
  padding: 12px 20px;
  background: var(--bg-tertiary);
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-secondary);
  border-bottom: 1px solid var(--border);
}

.admin-products-table .admin-table-header {
  grid-template-columns: 1fr 120px 100px 80px 290px;
}

/* Customers tab reuses .admin-products-table's row/border/hover styling but
   needs its own column layout (Customer/Orders/Spent/Cancelled/Refunded/Last
   Order/Actions instead of Product/Category/Price/Stock/Actions) -- scoped
   override, must come after the shared rule above to win on source order. */
.admin-customers-table .admin-table-header,
.admin-customers-table .admin-product-row {
  grid-template-columns: 1.4fr 90px 100px 110px 110px 100px 90px;
}

.admin-orders-table .admin-table-header {
  grid-template-columns: 132px 1fr 70px 90px 72px 100px 130px;
}

.admin-product-row {
  display: grid;
  grid-template-columns: 1fr 120px 100px 80px 290px;
  gap: 12px;
  align-items: center;
  padding: 14px 20px;
  border-bottom: 1px solid var(--border);
  transition: background 150ms;
}

.admin-product-row:last-child {
  border-bottom: none;
}

.admin-product-row:hover {
  background: var(--bg-tertiary);
}

.admin-product-row.editing {
  background: rgba(59, 130, 246, 0.06);
  border-left: 3px solid var(--accent);
}

.admin-product-name {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.admin-product-thumb {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  flex-shrink: 0;
}

.admin-product-title {
  display: block;
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.admin-product-desc {
  display: block;
  font-size: 0.78rem;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.admin-category-chip {
  display: inline-block;
  font-size: 0.78rem;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: var(--radius-xl);
  background: var(--bg-primary);
  border: 1px solid var(--border);
  color: var(--text-secondary);
  white-space: nowrap;
}

.admin-price {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 0.95rem;
}

.admin-row-actions {
  display: flex;
  gap: var(--space-1);
  align-items: center;
  flex-wrap: wrap;
}

.btn-admin-edit {
  padding: 6px 14px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--accent);
  background: transparent;
  color: var(--accent);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 150ms;
}

.btn-admin-edit:hover {
  background: var(--accent);
  color: var(--color-text-on-secondary);
}

/* ── Careers tab ─────────────────────────────────────────────────── */
.admin-careers-grid {
  display: grid;
  /* The left-side stats/table has a wide intrinsic size. A plain \`1fr\`
     therefore refuses to shrink and pushes the form past the viewport when
     the admin sidebar is open. Explicitly allow both tracks to shrink. */
  grid-template-columns: minmax(0, 1fr) minmax(320px, 380px);
  gap: 20px;
  align-items: start;
  width: 100%;
  min-width: 0;
}
.admin-careers-grid > * { min-width: 0; }
.admin-careers-grid .admin-pf-section { min-width: 0; }
.admin-careers-grid .admin-products-table { width: 100%; max-width: 100%; min-width: 0; overflow: hidden; }
.admin-careers-grid .admin-careers-stat-tile { min-width: 0; }
@media (max-width: 1100px) {
  .admin-careers-grid { grid-template-columns: 1fr; }
}
.admin-careers-form-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 20px;
}
.admin-careers-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}
@media (max-width: 900px) {
  .admin-careers-stats { grid-template-columns: repeat(2, 1fr); }
}
.admin-careers-stat-tile {
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 16px;
}
.admin-careers-stat-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}
.admin-careers-stat-value { font-size: 1.5rem; font-weight: 800; color: var(--text-primary); }
.admin-careers-stat-label { font-size: 0.82rem; color: var(--text-secondary); }
.admin-careers-stat-trend { font-size: 0.75rem; color: var(--text-muted); display: flex; align-items: center; gap: 3px; margin-top: 2px; }
.admin-careers-stat-trend.up { color: var(--color-secondary); }
.admin-careers-stat-trend.down { color: var(--color-primary); }

/* Lightweight rich-text editor (job description field) */
.admin-rte {
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  overflow: hidden;
  background: var(--bg-primary);
}
.admin-rte-toolbar {
  display: flex;
  gap: 2px;
  padding: 6px 8px;
  border-bottom: 1px solid var(--border);
  background: var(--bg-secondary);
}
.admin-rte-toolbar button {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  border-radius: var(--radius-sm);
  color: var(--text-secondary);
  cursor: pointer;
}
.admin-rte-toolbar button:hover { background: var(--bg-tertiary); color: var(--text-primary); }
.admin-rte-body {
  min-height: 120px;
  max-height: 280px;
  overflow-y: auto;
  padding: 10px 12px;
  font-size: 0.88rem;
  color: var(--text-primary);
  outline: none;
}
.admin-rte-body:empty::before {
  content: attr(data-placeholder);
  color: var(--text-muted);
}
.admin-rte-body ul, .admin-rte-body ol { padding-left: 20px; margin: 6px 0; }

.admin-search-input {
  flex: 1 1;
  min-width: 200px;
  padding: 10px 16px;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 0.9rem;
  font-family: inherit;
  transition: border-color 150ms, box-shadow 150ms;
}

.admin-search-input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent) 18%, transparent);
}

.admin-otp-input {
  width: 100%;
  padding: 4px 8px;
  font-size: 0.78rem;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-family: inherit;
}
.admin-otp-input:focus { outline: none; border-color: var(--accent); }

.admin-otp-btn {
  padding: 4px 10px;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  background: var(--bg-secondary);
  color: var(--text-primary);
  cursor: pointer;
  white-space: nowrap;
}
.admin-otp-btn:hover:not(:disabled) { background: var(--accent); color: var(--color-text-on-secondary); border-color: var(--accent); }
.admin-otp-btn:disabled { opacity: 0.4; cursor: not-allowed; }

.admin-result-count {
  font-size: 0.85rem;
  color: var(--text-secondary);
  margin-bottom: 10px;
}

.admin-order-row {
  display: grid;
  grid-template-columns: 132px 1fr 70px 90px 72px 100px 130px;
  gap: 12px;
  align-items: center;
  padding: 14px 20px;
  border-bottom: 1px solid var(--border);
}

.admin-order-row:last-child {
  border-bottom: none;
}

/* Wrapper so the expand panel is outside the grid row */
.admin-order-block {
  border-bottom: 1px solid var(--border);
}
.admin-order-block:last-child {
  border-bottom: none;
}
.admin-order-block .admin-order-row {
  border-bottom: none;
}

/* "X sellers ▼" toggle button */
.admin-seller-toggle {
  display: inline-block;
  margin-top: 3px;
  font-size: 0.7rem;
  background: rgba(59, 130, 246,0.1);
  color: var(--color-secondary);
  border: 1px solid rgba(59, 130, 246,0.25);
  border-radius: var(--radius-xs);
  padding: 1px 6px;
  cursor: pointer;
  white-space: nowrap;
}
.admin-seller-toggle:hover { background: rgba(59, 130, 246,0.2); }

/* "Seller managed" label replaces the Update dropdown */
.admin-seller-managed-label {
  font-size: 0.75rem;
  color: var(--color-secondary);
  font-style: italic;
}

/* Seller breakdown panel */
.admin-seller-breakdown {
  background: var(--bg-tertiary);
  border-top: 1px dashed var(--border);
  padding: 12px 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.admin-seller-suborder {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  box-shadow: var(--shadow-card);
}

.admin-suborder-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.admin-suborder-store {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.admin-suborder-store-name {
  font-weight: 600;
  font-size: 0.88rem;
}

.admin-suborder-seller-email {
  font-size: 0.75rem;
  color: var(--text-secondary);
}

.admin-suborder-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.admin-suborder-id {
  font-family: monospace;
  font-size: 0.72rem;
  color: var(--text-secondary);
}

.admin-suborder-items {
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-top: 1px solid var(--border);
  padding-top: 8px;
}

.admin-suborder-item-row {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  font-size: 0.82rem;
}
.admin-suborder-item-row span:first-child { flex: 1 1; }

.admin-suborder-earnings {
  display: flex;
  gap: var(--space-2);
  flex-wrap: wrap;
  font-size: 0.78rem;
  color: var(--text-secondary);
  border-top: 1px solid var(--border);
  padding-top: 8px;
}

.admin-suborder-timeline {
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-top: 1px solid var(--border);
  padding-top: 8px;
}

.admin-timeline-chip {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.75rem;
}

.admin-order-row:hover {
  background: var(--bg-tertiary);
}

.order-id-cell {
  font-family: monospace;
  font-size: 0.85rem;
  color: var(--text-secondary);
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: flex-start;
}
.order-id-top { display: flex; align-items: center; gap: 6px; }
.order-id-doc { display: inline-flex; color: var(--text-muted); flex-shrink: 0; }
.order-id-num { font-weight: 600; color: var(--text-primary); white-space: nowrap; }
.order-id-badges { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }
.order-risk-badge {
  display: inline-flex; align-items: center; gap: 2px;
  font-family: var(--font-sans); font-size: 0.62rem; font-weight: 700;
  padding: 1px 5px; border-radius: 4px; cursor: help; letter-spacing: 0.02em;
}

.order-customer-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.order-customer-cell span:first-child {
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--text-primary);
}

.order-customer-email {
  font-size: 0.78rem;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 768px) {
  .product-form-grid {
    grid-template-columns: 1fr;
  }

  .admin-products-table .admin-table-header,
  .admin-product-row {
    grid-template-columns: 1fr auto;
  }

  .admin-products-table .admin-table-header span:nth-child(2),
  .admin-products-table .admin-table-header span:nth-child(3),
  .admin-products-table .admin-table-header span:nth-child(4),
  .admin-product-row .admin-category-chip,
  .admin-product-row .admin-price,
  .admin-product-row .admin-stock-pill {
    display: none;
  }

  .admin-orders-table .admin-table-header,
  .admin-order-row {
    grid-template-columns: 1fr auto;
  }

  .admin-orders-table .admin-table-header span:nth-child(3),
  .admin-orders-table .admin-table-header span:nth-child(4),
  .admin-order-row .admin-price,
  .admin-order-row .status {
    display: none;
  }
}

/* Settings Pages */
.settings-container {
  max-width: 600px;
  margin: 0 auto;
}

.legal-page {
  max-width: 720px;
  margin: 0 auto;
  padding-bottom: var(--space-4);
}

/* Card/grid-based hub pages (e.g. Help Center) align to the same
   max-width + padding as the navbar instead of the narrower prose column
   used by legal/text pages. */
.legal-page.legal-page-wide {
  max-width: 1440px;
  padding: 0 24px var(--space-4);
}
@media (max-width: 640px) {
  .legal-page.legal-page-wide { padding: 0 12px var(--space-4); }
}

.legal-title {
  font-size: 1.9rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0 0 6px;
}

.legal-updated {
  font-size: 0.85rem;
  color: var(--text-muted);
  margin: 0 0 var(--space-3);
}

.legal-section {
  margin-bottom: var(--space-3);
}

.legal-section h2 {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 8px;
}

.legal-section p,
.legal-section li {
  font-size: 0.92rem;
  line-height: 1.65;
  color: var(--text-secondary);
}

.legal-section ul {
  margin: 0;
  padding-left: 20px;
}

.legal-section li {
  margin-bottom: 6px;
}

.legal-section a {
  color: var(--accent);
  font-weight: 600;
}

/* Privacy policy — its outer edge deliberately matches the 1440px subpage header. */
.privacy-page { max-width: 1440px; margin: 0 auto; padding: 4px 0 28px; }
.privacy-heading { display: flex; align-items: center; gap: 16px; margin: 0 0 22px; }
.privacy-heading-icon { width: 52px; height: 52px; border: 1px solid color-mix(in srgb, var(--color-secondary) 22%, var(--border)); border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; flex: 0 0 auto; color: var(--color-secondary); background: var(--color-secondary-soft); }
.privacy-heading h1 { margin: 0 0 3px; color: var(--text-primary); font-size: clamp(1.8rem, 3vw, 2.35rem); line-height: 1.05; letter-spacing: -0.035em; }
.privacy-heading p { margin: 0; color: var(--text-muted); font-size: 0.86rem; }
.privacy-layout { display: grid; grid-template-columns: minmax(0, 1fr) 330px; gap: 22px; align-items: start; }
.privacy-main { display: grid; gap: 12px; min-width: 0; }
.privacy-policy-card, .privacy-compact-card, .privacy-side-card { border: 1px solid var(--border); border-radius: 10px; background: var(--bg-secondary); box-shadow: var(--shadow-card); }
.privacy-policy-card { display: grid; grid-template-columns: 28px minmax(0, 1fr); gap: 14px; padding: 18px; scroll-margin-top: 20px; }
.privacy-number { width: 26px; height: 26px; border: 1px solid color-mix(in srgb, var(--color-secondary) 35%, var(--border)); border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; color: var(--color-secondary-text); background: var(--color-secondary-soft); font-size: 0.78rem; font-weight: 750; }
.privacy-policy-card h2, .privacy-compact-card h2, .privacy-side-card h2 { margin: 0; color: var(--text-primary); font-size: 1rem; font-weight: 750; }
.privacy-policy-card p, .privacy-compact-card p, .privacy-side-card p { margin: 7px 0 0; color: var(--text-secondary); font-size: 0.84rem; line-height: 1.55; }
.privacy-info-list { display: grid; gap: 10px; margin-top: 10px; }
.privacy-info-row { display: grid; grid-template-columns: 34px minmax(0, 1fr); gap: 10px; align-items: start; }
.privacy-info-row > span, .privacy-compact-card > div > span { width: 32px; height: 32px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; color: var(--color-secondary); background: var(--color-secondary-soft); }
.privacy-info-row p { margin: 4px 0 0; }
.privacy-info-row strong { color: var(--text-primary); }
.privacy-compact-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
.privacy-compact-card { padding: 16px; scroll-margin-top: 20px; }
.privacy-compact-card > div { display: flex; align-items: center; gap: 10px; }
.privacy-compact-card a { color: var(--color-secondary-text); font-weight: 700; }
.privacy-aside { position: sticky; top: 20px; display: grid; gap: 12px; }
.privacy-side-card { padding: 18px; }
.privacy-side-title { display: flex; align-items: center; gap: 10px; color: var(--color-primary); }
.privacy-side-card ol { list-style: none; display: grid; gap: 7px; margin: 16px 0 0; padding: 0; }
.privacy-side-card li a { display: flex; align-items: center; gap: 10px; color: var(--text-secondary); font-size: 0.8rem; text-decoration: none; }
.privacy-side-card li a:hover { color: var(--text-primary); }
.privacy-side-card li span { width: 22px; height: 22px; border: 1px solid color-mix(in srgb, var(--color-secondary) 35%, var(--border)); border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; flex: 0 0 auto; color: var(--color-secondary-text); background: var(--color-secondary-soft); font-size: 0.7rem; font-weight: 700; }
.privacy-email { display: inline-flex; align-items: center; justify-content: center; gap: 8px; max-width: 100%; margin-top: 14px; padding: 9px 14px; border: 1px solid var(--color-secondary); border-radius: 999px; color: var(--color-secondary-text); font-size: 0.78rem; font-weight: 700; text-decoration: none; }
.privacy-footer { display: flex; align-items: center; gap: 14px; margin-top: 18px; padding: 18px 4px 0; border-top: 1px solid var(--border); }
.privacy-footer > span { width: 42px; height: 42px; border-radius: 9px; display: inline-flex; align-items: center; justify-content: center; color: var(--color-secondary); background: var(--color-secondary-soft); }
.privacy-footer strong { color: var(--text-primary); font-size: 0.88rem; }
.privacy-footer p { margin: 3px 0 0; color: var(--text-secondary); font-size: 0.78rem; }
.policy-document-page .privacy-layout { grid-template-columns: minmax(0, 1fr) 330px; }
.policy-document-card { min-height: 92px; }
.policy-document-title { display: flex; align-items: center; gap: 9px; }
.policy-document-title > span { width: 30px; height: 30px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; flex: 0 0 auto; color: var(--color-secondary); background: var(--color-secondary-soft); }
.policy-document-copy > p { margin-top: 9px; }
.policy-document-copy ul { margin: 9px 0 0; padding-left: 20px; color: var(--text-secondary); font-size: 0.84rem; line-height: 1.55; }
.policy-document-copy li + li { margin-top: 5px; }
.policy-document-copy a { color: var(--color-secondary-text); font-weight: 700; }
/* .policy-document-page .privacy-layout (0,2,0) outranks a bare
   .privacy-layout (0,1,0) -- a media query adds no specificity -- so
   Terms & Conditions and Returns & Refunds, the two pages carrying that
   class, kept the 330px sidebar column below 900px. That squeezed
   .privacy-main to zero width and pushed .privacy-aside past the right
   edge. The collapse rule has to match that specificity to win. */
@media (max-width: 900px) { .privacy-layout,
  .policy-document-page .privacy-layout { grid-template-columns: 1fr; } .privacy-aside { position: static; grid-template-columns: repeat(2, minmax(0, 1fr)); } .privacy-aside .privacy-side-card:first-child { grid-row: span 2; } }
@media (max-width: 640px) { .privacy-page { padding: 0 0 76px; } .privacy-heading { margin-bottom: 18px; } .privacy-heading-icon { width: 46px; height: 46px; } .privacy-compact-grid, .privacy-aside { grid-template-columns: 1fr; } .privacy-aside .privacy-side-card:first-child { grid-row: auto; } .privacy-policy-card { gap: 10px; padding: 15px 13px; } .privacy-info-row { grid-template-columns: 30px minmax(0, 1fr); gap: 8px; } .privacy-info-row > span { width: 30px; height: 30px; } }

/* ── FAQ accordion (shared by FAQ, Seller FAQs, Help Center) ────────── */
.faq-accordion { display: flex; flex-direction: column; gap: 10px; }
.faq-item {
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--bg-secondary);
  overflow: hidden;
}
.faq-item.open { border-color: var(--accent); }
.faq-question {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  background: none;
  border: none;
  text-align: left;
  font-size: 0.92rem;
  font-weight: 700;
  color: var(--text-primary);
  cursor: pointer;
}
.faq-chevron { color: var(--text-muted); flex-shrink: 0; transition: transform 150ms ease; display: flex; }
.faq-item.open .faq-chevron { transform: rotate(180deg); color: var(--accent); }
.faq-answer {
  padding: 0 16px 16px;
  font-size: 0.88rem;
  line-height: 1.6;
  color: var(--text-secondary);
}

/* ── Careers ─────────────────────────────────────────────────────── */
.careers-page { max-width: 1440px; margin: 0 auto; padding: 0 24px var(--space-4); }
@media (max-width: 640px) { .careers-page { padding: 0 12px var(--space-4); } }

.careers-hero {
  text-align: center;
  background: linear-gradient(180deg, var(--text-primary), color-mix(in srgb, var(--text-primary) 82%, var(--color-brand-navy)));
  border-radius: var(--radius-lg, 16px);
  padding: 40px 24px 32px;
  margin-bottom: 28px;
  color: var(--bg-tertiary);
}
.careers-hero-icon {
  display: inline-flex; align-items: center; justify-content: center;
  width: 56px; height: 56px; border-radius: 50%;
  background: color-mix(in srgb, var(--accent-secondary) 18%, transparent); color: var(--color-secondary); margin-bottom: 14px;
}
.careers-hero-title { font-size: 1.9rem; font-weight: 800; margin: 0 0 10px; color: var(--bg-tertiary); }
.careers-hero-brand { color: var(--color-secondary); }
.careers-hero-sub { font-size: 0.95rem; color: var(--border-strong); max-width: 560px; margin: 0 auto 30px; line-height: 1.6; }
.careers-value-props { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; max-width: 720px; margin: 0 auto; }
@media (max-width: 640px) { .careers-value-props { grid-template-columns: 1fr; } }
.careers-value-prop { background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: var(--radius-md); padding: 18px 14px; }
.careers-value-icon { display: inline-flex; align-items: center; justify-content: center; width: 36px; height: 36px; border-radius: 10px; background: color-mix(in srgb, var(--accent-secondary) 16%, transparent); color: var(--color-secondary); margin-bottom: 10px; }
.careers-value-title { font-size: 0.92rem; font-weight: 700; color: var(--bg-tertiary); margin: 0 0 4px; }
.careers-value-text { font-size: 0.8rem; color: var(--text-muted); margin: 0; line-height: 1.5; }

.careers-body { width: 100%; }
.careers-search-row { display: flex; flex-wrap: wrap; gap: 12px; align-items: center; margin-bottom: 20px; }
.careers-search-box {
  display: flex; align-items: center; gap: 8px; flex: 1 1 220px; min-width: 200px;
  background: var(--bg-secondary); border: 1px solid var(--border); border-radius: var(--radius-md);
  padding: 10px 14px; color: var(--text-muted);
}
.careers-search-box input { flex: 1 1; border: none; background: none; outline: none; font-size: 0.88rem; color: var(--text-primary); }
.careers-filter-pills { display: flex; flex-wrap: wrap; gap: 8px; }
.careers-filter-pill {
  font-size: 0.8rem; font-weight: 600; color: var(--text-secondary); background: var(--bg-secondary);
  border: 1px solid var(--border); border-radius: 999px; padding: 8px 14px; cursor: pointer; white-space: nowrap;
}
.careers-filter-pill.active { background: var(--accent); border-color: var(--accent); color: var(--color-text-on-secondary); }
.careers-filter-pill:hover:not(.active) { border-color: var(--accent); color: var(--accent); }

.careers-cta-card {
  margin-top: 20px; text-align: center; background: var(--bg-secondary); border: 1px solid var(--border);
  border-radius: var(--radius-md); padding: 28px 20px;
}
.careers-cta-title { font-size: 1.05rem; font-weight: 700; color: var(--text-primary); margin: 0 0 4px; }
.careers-cta-text { font-size: 0.85rem; color: var(--text-secondary); margin: 0 0 16px; }
.careers-cta-btn {
  display: inline-flex; align-items: center; gap: 8px; font-weight: 700; font-size: 0.88rem;
  background: var(--accent); color: var(--color-text-on-secondary); border: none; border-radius: var(--radius-md);
  padding: 10px 20px; cursor: pointer;
}
.careers-cta-card .careers-apply-form { text-align: left; }

.careers-list { display: flex; flex-direction: column; gap: 12px; }
.careers-card { border: 1px solid var(--border); border-radius: var(--radius-md); background: var(--bg-secondary); overflow: hidden; padding: 18px; }
.careers-card-row { display: flex; align-items: center; gap: 18px; }
.careers-card-icon { flex-shrink: 0; width: 44px; height: 44px; border-radius: 12px; display: inline-flex; align-items: center; justify-content: center; }
.careers-card-main { flex: 1 1 240px; min-width: 0; }
.careers-card-summary { font-size: 0.85rem; color: var(--text-secondary); margin: 0; line-height: 1.5; }
.careers-card-title { font-size: 0.98rem; font-weight: 700; color: var(--text-primary); margin: 0 0 4px; }

.careers-card-meta-col {
  display: flex; flex-direction: column; gap: 6px; flex-shrink: 0;
  font-size: 0.82rem; color: var(--text-secondary); min-width: 150px;
}
.careers-card-meta-col span { display: inline-flex; align-items: center; gap: 6px; }

.careers-card-type-col { display: flex; flex-direction: column; align-items: flex-end; gap: 10px; flex-shrink: 0; }
.careers-type-dot { display: inline-flex; align-items: center; gap: 6px; font-size: 0.82rem; font-weight: 600; color: var(--text-secondary); }
.careers-type-dot span { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }
.careers-view-details {
  display: inline-flex; align-items: center; gap: 6px; background: none; cursor: pointer;
  font-size: 0.82rem; font-weight: 700; padding: 7px 14px; border-radius: 999px; border: 1px solid;
  white-space: nowrap;
}

@media (max-width: 760px) {
  .careers-card-row { flex-wrap: wrap; }
  .careers-card-meta-col { flex-direction: row; flex-wrap: wrap; gap: 12px; min-width: 0; }
  .careers-card-type-col { flex-direction: row; align-items: center; width: 100%; justify-content: space-between; }
}

.careers-card-body { padding-top: 14px; margin-top: 14px; border-top: 1px solid var(--border); font-size: 0.88rem; line-height: 1.6; color: var(--text-secondary); }
.careers-req-title { font-weight: 700; color: var(--text-primary); margin: 12px 0 6px; font-size: 0.85rem; }
.careers-card-body ul { margin: 0 0 14px; padding-left: 20px; }
.careers-card-body li { margin-bottom: 4px; }
.careers-apply-btn { display: inline-block; text-decoration: none; }
.careers-apply-form { display: flex; flex-direction: column; gap: 14px; margin-top: 10px; padding-top: 14px; border-top: 1px solid var(--border); }
.careers-apply-row { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
@media (max-width: 480px) { .careers-apply-row { grid-template-columns: 1fr; } }
.careers-apply-sent { text-align: center; padding: 20px 0 6px; }
.careers-apply-sent-icon { color: var(--success); display: inline-flex; margin-bottom: 8px; }
.careers-apply-sent-title { font-size: 1rem; font-weight: 700; color: var(--text-primary); margin: 0 0 4px; }
.careers-apply-sent-sub { font-size: 0.85rem; color: var(--text-secondary); margin: 0 0 14px; }
.careers-empty { text-align: center; padding: 30px 20px; color: var(--text-secondary); font-size: 0.9rem; background: var(--bg-secondary); border: 1px solid var(--border); border-radius: var(--radius-md); }
.careers-empty a { color: var(--accent); font-weight: 600; }
.careers-apply-section-title { font-size: 0.9rem; font-weight: 700; color: var(--text-primary); margin: 4px 0 -2px; display: flex; align-items: center; gap: 8px; }
.careers-apply-required-badge { font-size: 0.65rem; font-weight: 700; letter-spacing: 0.03em; text-transform: uppercase; color: var(--danger); background: color-mix(in srgb, var(--danger) 10%, transparent); border: 1px solid color-mix(in srgb, var(--danger) 30%, transparent); border-radius: 999px; padding: 2px 8px; }
.careers-apply-entry { display: flex; flex-direction: column; gap: 12px; padding: 12px; background: var(--bg-secondary); border: 1px solid var(--border); border-radius: var(--radius-md); }
.careers-apply-add { align-self: flex-start; display: inline-flex; align-items: center; gap: 6px; background: none; border: 1px dashed var(--border); color: var(--accent); font-size: 0.8rem; font-weight: 600; padding: 6px 12px; border-radius: var(--radius-md); cursor: pointer; }
.careers-apply-add:hover { background: var(--bg-secondary); }
.careers-apply-remove { align-self: flex-end; display: inline-flex; align-items: center; gap: 4px; background: none; border: none; color: var(--danger); font-size: 0.75rem; font-weight: 600; padding: 2px 4px; cursor: pointer; }
.careers-apply-file-btn { display: inline-flex; align-items: center; gap: 8px; width: fit-content; max-width: 100%; font-size: 0.85rem; color: var(--text-primary); background: var(--bg-secondary); border: 1px solid var(--border); border-radius: var(--radius-md); padding: 9px 14px; cursor: pointer; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.careers-apply-file-btn:hover { border-color: var(--accent); }
.careers-apply-declaration { display: flex; align-items: flex-start; gap: 10px; font-size: 0.85rem; color: var(--text-secondary); line-height: 1.4; cursor: pointer; }
.careers-apply-declaration input { margin-top: 3px; flex-shrink: 0; }

/* ── Contact Us ──────────────────────────────────────────────────── */
.contact-layout { display: grid; grid-template-columns: 220px 1fr; gap: 28px; align-items: start; }
@media (max-width: 640px) { .contact-layout { grid-template-columns: 1fr; } }
.contact-info-col { display: flex; flex-direction: column; gap: 18px; }
.contact-info-row { display: flex; align-items: flex-start; gap: 10px; }
.contact-info-icon {
  width: 32px; height: 32px; border-radius: 50%; background: color-mix(in srgb, var(--accent-secondary) 12%, transparent); color: var(--accent-secondary);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.contact-info-label { font-size: 0.75rem; color: var(--text-muted); margin: 0 0 2px; text-transform: uppercase; letter-spacing: 0.04em; }
.contact-info-value { font-size: 0.88rem; color: var(--text-primary); font-weight: 600; margin: 0; text-decoration: none; }
/* Only the anchor form is a control -- the same class is used on a plain <p>
   for values that are not links (an address, opening hours), and giving those
   a 24px floor would space the contact block out for nothing. */
a.contact-info-value {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
}
a.contact-info-value:hover { text-decoration: underline; }

.contact-form { display: flex; flex-direction: column; gap: 14px; }
.contact-form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
@media (max-width: 480px) { .contact-form-row { grid-template-columns: 1fr; } }
.contact-field { display: flex; flex-direction: column; gap: 5px; }
.contact-label { font-size: 0.8rem; font-weight: 600; color: var(--text-secondary); }
.contact-input {
  box-sizing: border-box; width: 100%; border: 1px solid var(--border); border-radius: var(--radius-md);
  padding: 10px 12px; font-size: 0.9rem; background: var(--bg-primary); color: var(--text-primary); font-family: inherit; resize: vertical;
}
/* These land at 38px on a phone, under the 44px comfortable-tap floor, and a
   contact form is where a mis-tap costs the most. Mobile only -- a mouse
   doesn't need the extra height. */
@media (max-width: 768px) {
  .contact-input { min-height: 44px; }
}
.contact-input:focus { border-color: var(--accent); outline: none; box-shadow: 0 0 0 3px rgba(59, 130, 246,0.1); }

.contact-sent { text-align: center; padding: 30px 20px; }
.contact-sent-icon { color: var(--success); display: inline-flex; margin-bottom: 10px; }
.contact-sent-title { font-size: 1.1rem; font-weight: 700; color: var(--text-primary); margin: 0 0 6px; }
.contact-sent-sub { font-size: 0.88rem; color: var(--text-secondary); margin: 0 0 18px; }

.settings-container h1 {
  font-size: 2rem;
  margin-bottom: 24px;
  color: var(--text-primary);
}

.settings-panel {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: var(--space-3);
  box-shadow: var(--shadow-card);
}

.settings-panel h2 {
  font-size: 1.3rem;
  margin-bottom: 18px;
  color: var(--text-primary);
}

.settings-panel h3 {
  font-size: 1.1rem;
  margin: 16px 0 12px;
  color: var(--text-primary);
}

.address-form {
  display: grid;
  gap: var(--space-2);
}

.address-form label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-weight: 500;
}

.address-form span {
  color: var(--text-primary);
  font-size: 0.95rem;
  font-weight: 600;
}

.address-form input {
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: 0.95rem;
  background: var(--bg-tertiary);
  color: var(--text-primary);
  transition: all 200ms ease;
}

.address-form input:focus {
  outline: none;
  border-color: var(--accent);
  background: var(--bg-secondary);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.setting-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  gap: 12px;
}

.setting-item span {
  color: var(--text-primary);
  font-weight: 500;
}

.setting-item input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: var(--accent);
}

.settings-panel hr {
  border: none;
  border-top: 1px solid var(--border);
  margin: 16px 0;
}

/* Cookie policy */
.cookie-page { max-width: 1440px; margin: 0 auto; padding: 4px 0 28px; }
.cookie-heading { margin-bottom: 24px; }
.cookie-heading h1 { margin: 0 0 8px; color: var(--text-primary); font-size: clamp(2rem, 3vw, 2.6rem); letter-spacing: -0.04em; }
.cookie-heading p { margin: 0 0 12px; color: var(--text-secondary); font-size: 0.9rem; }
.cookie-heading .cookie-updated { color: var(--text-muted); font-size: 0.82rem; }
.cookie-layout { display: grid; grid-template-columns: minmax(0, 1.9fr) minmax(340px, 1fr); gap: 30px; align-items: start; }
.cookie-sections, .cookie-card { background: var(--bg-secondary); border: 1px solid var(--border); border-radius: 14px; box-shadow: var(--shadow-card); }
.cookie-sections { padding: 10px 24px; }
.cookie-section { display: grid; grid-template-columns: 30px 52px minmax(0, 1fr); gap: 18px; align-items: center; min-height: 102px; border-bottom: 1px solid var(--border); }
.cookie-section:last-child { border-bottom: 0; }
.cookie-number { width: 26px; height: 26px; border-radius: 6px; display: inline-flex; align-items: center; justify-content: center; color: white; background: var(--color-secondary); font-size: 0.8rem; font-weight: 700; }
.cookie-icon, .cookie-choice-icon { width: 48px; height: 48px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; color: var(--color-secondary); background: color-mix(in srgb, var(--color-secondary) 10%, transparent); flex: 0 0 auto; }
.cookie-section h2 { margin: 0 0 4px; color: var(--text-primary); font-size: 0.98rem; }
.cookie-section p { margin: 0; color: var(--text-secondary); font-size: 0.82rem; line-height: 1.45; }
.cookie-side { display: grid; gap: 18px; }
.cookie-card { padding: 24px; }
.cookie-card h2 { margin: 0 0 20px; display: flex; align-items: center; gap: 12px; color: var(--text-primary); font-size: 1rem; }
.cookie-card h2 .cookie-icon { width: 42px; height: 42px; }
.cookie-card ul { list-style: none; padding: 0; margin: 0 0 20px; display: grid; gap: 18px; }
.cookie-card li { display: flex; align-items: flex-start; gap: 12px; color: var(--text-secondary); font-size: 0.8rem; line-height: 1.4; }
.cookie-card li svg { color: var(--success); flex: 0 0 auto; margin-top: 1px; }
.cookie-card > a { display: inline-flex; align-items: center; gap: 8px; color: var(--color-secondary); font-size: 0.8rem; text-decoration: none; }
.cookie-choices { padding-bottom: 12px; }
.cookie-choices > a, .cookie-choices > button { width: 100%; min-height: 66px; padding: 8px 0; border: 0; border-bottom: 1px solid var(--border); background: transparent; display: grid; grid-template-columns: 42px minmax(0, 1fr) auto; align-items: center; gap: 12px; text-align: left; color: var(--text-primary); cursor: pointer; text-decoration: none; }
.cookie-choices > :last-child { border-bottom: 0; }
.cookie-choice-icon { width: 40px; height: 40px; border-radius: 9px; }
.cookie-choices strong, .cookie-choices small { display: block; }
.cookie-choices strong { margin-bottom: 3px; font-size: 0.82rem; }
.cookie-choices small { color: var(--text-secondary); font-size: 0.74rem; }
.cookie-footer { display: flex; align-items: center; gap: 12px; min-height: 76px; margin-top: 28px; border-top: 1px solid var(--border); color: var(--text-secondary); font-size: 0.82rem; }
.cookie-footer i { width: 1px; height: 22px; margin: 0 12px; background: var(--border); }
.cookie-footer a { color: var(--color-secondary); text-decoration: none; }
@media (max-width: 900px) { .cookie-layout { grid-template-columns: 1fr; } }
@media (max-width: 600px) { .cookie-page { padding: 4px 0 76px; } .cookie-section { grid-template-columns: 26px 42px minmax(0, 1fr); gap: 10px; padding: 12px 0; } .cookie-icon { width: 40px; height: 40px; } .cookie-sections, .cookie-card { padding-left: 16px; padding-right: 16px; } .cookie-footer { flex-wrap: wrap; } }

/* Customer account settings */
.settings-page { padding: 38px 24px 0; }
.settings-page .settings-container { max-width: 1440px; margin: 0 auto; }
.settings-page-heading { margin-bottom: 30px; }
.settings-page-heading h1 { margin: 0 0 6px; font-size: clamp(2rem, 3vw, 2.55rem); line-height: 1.1; font-weight: 800; letter-spacing: -0.035em; color: var(--text-primary); }
.settings-page-heading p { margin: 0; font-size: 1rem; color: var(--text-secondary); }
.settings-grid { display: grid; grid-template-columns: minmax(0, 1.2fr) minmax(400px, 1fr); gap: 22px; align-items: stretch; }
.settings-page .settings-panel { padding: 28px; border-radius: 14px; background: var(--bg-secondary); }
.settings-section-head { display: flex; align-items: center; gap: 16px; }
.settings-section-icon { width: 48px; height: 48px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; flex: 0 0 auto; color: var(--color-secondary); background: color-mix(in srgb, var(--color-secondary) 11%, transparent); }
.settings-section-icon.strong { color: var(--color-brand-white); background: var(--color-secondary); }
.settings-section-head h2 { margin: 0 0 4px; font-size: 1.15rem; font-weight: 750; color: var(--text-primary); }
.settings-section-head p { margin: 0; font-size: 0.86rem; color: var(--text-secondary); }
.settings-options { margin-top: 24px; border-top: 1px solid var(--border); }
.settings-page .setting-item { position: relative; display: grid; grid-template-columns: 48px minmax(0, 1fr) 28px; align-items: center; gap: 16px; min-height: 94px; padding: 14px 0; border-bottom: 1px solid var(--border); cursor: pointer; }
.settings-page .setting-item:last-child { border-bottom: 0; }
.setting-icon { width: 48px; height: 48px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; color: var(--color-secondary); background: color-mix(in srgb, var(--color-secondary) 10%, transparent); }
.setting-copy { display: flex; flex-direction: column; gap: 5px; min-width: 0; }
.setting-copy strong { color: var(--text-primary); font-size: 0.95rem; font-weight: 700; }
.setting-copy small { color: var(--text-secondary); font-size: 0.82rem; line-height: 1.35; }
.settings-page .setting-item input { position: absolute; opacity: 0; pointer-events: none; }
.setting-check { width: 26px; height: 26px; border: 1px solid var(--border-strong, var(--border)); border-radius: 6px; display: inline-flex; align-items: center; justify-content: center; color: transparent; background: var(--bg-primary); }
.setting-item input:checked + .setting-check { color: white; border-color: var(--color-secondary); background: var(--color-secondary); }
.setting-item:focus-within .setting-check { box-shadow: 0 0 0 3px color-mix(in srgb, var(--color-secondary) 18%, transparent); }
.settings-side-column { display: grid; grid-template-rows: auto 1fr; gap: 18px; }
.settings-theme-toggle { display: grid; grid-template-columns: 1fr 1fr; margin-top: 24px; border: 1px solid var(--border); border-radius: 9px; overflow: hidden; }
.settings-theme-toggle button { min-height: 50px; border: 0; background: transparent; color: var(--text-primary); display: flex; align-items: center; justify-content: center; gap: 9px; font: inherit; font-size: 0.9rem; cursor: pointer; }
.settings-theme-toggle button.active { color: white; background: var(--color-secondary); }
.settings-theme-note { margin: 10px 0 0; color: var(--text-secondary); font-size: 0.8rem; }
.settings-privacy-note { display: flex; align-items: flex-start; gap: 12px; margin-top: 22px; padding: 16px; border: 1px solid color-mix(in srgb, var(--color-secondary) 22%, var(--border)); border-radius: 9px; color: var(--color-secondary); background: color-mix(in srgb, var(--color-secondary) 5%, transparent); font-size: 0.82rem; line-height: 1.45; }
.settings-privacy-note svg { flex: 0 0 auto; margin-top: 1px; }
.settings-privacy-actions { display: flex; gap: 14px; margin-top: 16px; flex-wrap: wrap; }
.settings-download-btn, .settings-delete-btn, .settings-delete-danger, .settings-delete-cancel { min-height: 44px; padding: 0 22px; border-radius: 8px; display: inline-flex; align-items: center; justify-content: center; gap: 9px; font: inherit; font-size: 0.84rem; font-weight: 650; cursor: pointer; }
.settings-download-btn { border: 1px solid var(--color-secondary); color: white; background: var(--color-secondary); }
.settings-delete-btn { border: 1px solid var(--border); color: var(--text-primary); background: var(--bg-secondary); }
.settings-delete-btn svg, .settings-delete-danger { color: var(--color-primary); }
.settings-delete-confirm { flex: 1 0 100%; display: grid; gap: 9px; padding-top: 4px; }
.settings-delete-confirm > p { margin: 0; color: var(--color-primary); font-size: 0.8rem; font-weight: 600; }
.settings-delete-confirm input { min-height: 42px; padding: 0 12px; border: 1px solid var(--border); border-radius: 8px; background: var(--bg-primary); color: var(--text-primary); }
.settings-delete-confirm > div { display: flex; gap: 8px; }
.settings-delete-danger { border: 1px solid var(--color-primary); background: var(--color-primary); color: white; }
.settings-delete-cancel { border: 1px solid var(--border); background: var(--bg-tertiary); color: var(--text-primary); }
.settings-delete-error { color: var(--color-primary); font-size: 0.78rem; margin: 0; }
.settings-privacy-footer { display: flex; align-items: center; gap: 12px; margin-top: 30px; min-height: 70px; border-top: 1px solid var(--border); color: var(--text-secondary); font-size: 0.82rem; }
.settings-privacy-footer i { width: 1px; height: 22px; margin: 0 10px; background: var(--border); }
.settings-privacy-footer a { color: var(--color-secondary); text-decoration: none; }
@media (max-width: 900px) { .settings-grid { grid-template-columns: 1fr; } }
@media (max-width: 600px) {
  .settings-page { padding: 24px 14px 82px; }
  .settings-page .settings-panel { padding: 20px; }
  .settings-page-heading { margin-bottom: 20px; }
  .settings-page-heading p { font-size: 0.9rem; }
  .settings-page .setting-item { grid-template-columns: 42px minmax(0, 1fr) 25px; gap: 11px; min-height: 84px; }
  .setting-icon, .settings-section-icon { width: 42px; height: 42px; }
  .settings-theme-toggle button { font-size: 0.82rem; }
  .settings-privacy-actions > button { flex: 1 1 100%; }
  .settings-privacy-footer { flex-wrap: wrap; gap: 8px; padding: 18px 0; }
}

/* ── Notifications page (NotificationsPage.js) ──────────────────────── */
.ntf-page { max-width: 900px; margin: 0 auto; }

.ntf-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; margin-bottom: 18px; flex-wrap: wrap; }
.ntf-title { margin: 0 0 4px; font-size: 1.4rem; font-weight: 800; color: var(--text-primary); }
.ntf-sub { margin: 0; font-size: 0.86rem; color: var(--text-secondary); }
.ntf-mark-all {
  display: flex; align-items: center; gap: 6px;
  background: none; border: 1px solid var(--accent); color: var(--accent);
  font-size: 0.82rem; font-weight: 700; cursor: pointer;
  padding: 8px 14px; border-radius: var(--radius-sm); white-space: nowrap;
  transition: background 150ms;
}
.ntf-mark-all:hover { background: rgba(59, 130, 246, 0.08); }

.ntf-tabs { display: flex; gap: 8px; overflow-x: auto; padding-bottom: 4px; margin-bottom: 14px; scrollbar-width: none; }
.ntf-tabs::-webkit-scrollbar { display: none; }
.ntf-tab {
  display: flex; align-items: center; gap: 6px; flex-shrink: 0;
  padding: 8px 14px; border-radius: 20px; border: 1px solid var(--border);
  background: var(--bg-secondary); color: var(--text-secondary);
  font-size: 0.84rem; font-weight: 600; cursor: pointer; transition: all 150ms;
}
.ntf-tab:hover { border-color: var(--accent); color: var(--text-primary); }
.ntf-tab.active { background: var(--accent); border-color: var(--accent); color: var(--color-text-on-secondary); }
.ntf-tab-count {
  background: rgba(1, 13, 33,0.08); border-radius: 10px; padding: 1px 7px; font-size: 0.72rem; font-weight: 700;
}
.ntf-tab.active .ntf-tab-count { background: rgba(255,255,255,0.25); }
[data-theme="dark"] .ntf-tab-count { background: rgba(255,255,255,0.1); }

.ntf-toolbar { display: flex; gap: 10px; margin-bottom: 16px; flex-wrap: wrap; }
.ntf-search-wrap { position: relative; flex: 1 1; min-width: 200px; }
.ntf-search-icon { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: var(--text-tertiary); pointer-events: none; }
.ntf-search-input {
  width: 100%; box-sizing: border-box; padding: 9px 12px 9px 34px; border-radius: var(--radius-sm);
  border: 1px solid var(--border); background: var(--bg-secondary); color: var(--text-primary); font-size: 0.86rem;
}
.ntf-search-input:focus { outline: none; border-color: var(--accent); }

.ntf-popover-wrap { position: relative; }
.ntf-filter-btn {
  display: flex; align-items: center; gap: 6px; height: 100%;
  padding: 9px 14px; border-radius: var(--radius-sm); border: 1px solid var(--border);
  background: var(--bg-secondary); color: var(--text-primary); font-size: 0.84rem; font-weight: 600; cursor: pointer; white-space: nowrap;
}
.ntf-filter-btn:hover { border-color: var(--accent); }
.ntf-popover {
  position: absolute; top: calc(100% + 6px); right: 0; z-index: 20;
  background: var(--bg-primary); border: 1px solid var(--border); border-radius: var(--radius-sm);
  box-shadow: 0 8px 24px rgba(1, 13, 33,0.15); padding: 14px; min-width: 220px;
  display: flex; flex-direction: column; gap: 10px;
}
.ntf-popover-date-label { display: flex; flex-direction: column; gap: 4px; font-size: 0.78rem; font-weight: 600; color: var(--text-secondary); }
.ntf-popover-date-label input {
  padding: 7px 8px; border-radius: 6px; border: 1px solid var(--border); background: var(--bg-secondary); color: var(--text-primary); font-size: 0.82rem;
}
.ntf-popover-clear { align-self: flex-start; background: none; border: none; color: var(--accent); font-size: 0.8rem; font-weight: 600; cursor: pointer; padding: 0; }

.ntf-list { display: flex; flex-direction: column; gap: 10px; }

.ntf-skeleton { height: 82px; border-radius: var(--radius-sm); }

.ntf-empty {
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 10px;
  padding: 60px 20px; color: var(--text-tertiary); text-align: center;
}
.ntf-empty p { margin: 0; font-size: 0.88rem; }

.ntf-card {
  position: relative;
  display: flex; align-items: flex-start; gap: 12px;
  background: var(--bg-secondary); border: 1px solid var(--border); border-radius: var(--radius-sm);
  padding: 14px; transition: border-color 150ms, box-shadow 150ms;
}
.ntf-card--unread { border-color: var(--accent); cursor: pointer; background: rgba(59, 130, 246, 0.04); }
.ntf-card:hover { box-shadow: 0 2px 10px rgba(1, 13, 33,0.08); }

.ntf-icon {
  flex-shrink: 0; width: 38px; height: 38px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
}

.ntf-body { flex: 1 1; min-width: 0; }
.ntf-body-top { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.ntf-item-title { margin: 0; font-size: 0.92rem; font-weight: 700; color: var(--text-primary); }
.ntf-badge {
  background: var(--bg-tertiary); color: var(--text-secondary); border-radius: 20px;
  padding: 2px 9px; font-size: 0.7rem; font-weight: 700;
}
.ntf-msg { margin: 4px 0 0; font-size: 0.84rem; color: var(--text-secondary); line-height: 1.4; }

.ntf-meta { flex-shrink: 0; display: flex; flex-direction: column; align-items: flex-end; gap: 3px; text-align: right; }
.ntf-relative { display: flex; align-items: center; gap: 4px; font-size: 0.76rem; color: var(--text-tertiary); white-space: nowrap; }
.ntf-absolute { font-size: 0.72rem; color: var(--text-tertiary); opacity: 0.75; white-space: nowrap; }

.ntf-dot { position: absolute; top: 14px; left: -6px; width: 8px; height: 8px; border-radius: 50%; background: var(--accent); }

.ntf-menu-wrap { position: relative; flex-shrink: 0; }
.ntf-menu-btn {
  background: none; border: none; color: var(--text-tertiary); cursor: pointer;
  padding: 4px; border-radius: 6px; display: flex; align-items: center; justify-content: center;
}
.ntf-menu-btn:hover { background: var(--bg-tertiary); color: var(--text-primary); }
.ntf-menu {
  position: absolute; top: calc(100% + 4px); right: 0; z-index: 20;
  background: var(--bg-primary); border: 1px solid var(--border); border-radius: var(--radius-sm);
  box-shadow: 0 8px 24px rgba(1, 13, 33,0.15); padding: 6px; min-width: 160px;
  display: flex; flex-direction: column; gap: 2px;
}
.ntf-menu button {
  display: flex; align-items: center; gap: 8px; background: none; border: none; text-align: left;
  padding: 8px 10px; border-radius: 6px; font-size: 0.82rem; color: var(--text-primary); cursor: pointer;
}
.ntf-menu button:hover { background: var(--bg-tertiary); }
.ntf-menu-danger { color: var(--danger) !important; }
.ntf-menu button:disabled { opacity: 0.5; cursor: not-allowed; }

.ntf-pagination { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-top: 18px; flex-wrap: wrap; }
.ntf-pagination-info { margin: 0; font-size: 0.8rem; color: var(--text-tertiary); }
.ntf-page-btns { display: flex; align-items: center; gap: 10px; }
.ntf-page-arrow {
  display: flex; align-items: center; justify-content: center; width: 32px; height: 32px;
  border-radius: 50%; border: 1px solid var(--border); background: var(--bg-secondary); color: var(--text-primary); cursor: pointer;
}
.ntf-page-arrow:disabled { opacity: 0.4; cursor: not-allowed; }
.ntf-page-current {
  min-width: 32px; height: 32px; display: flex; align-items: center; justify-content: center;
  border-radius: 50%; background: var(--accent); color: var(--color-text-on-secondary); font-weight: 700; font-size: 0.84rem;
}

@media (max-width: 640px) {
  .ntf-card { flex-wrap: wrap; }
  .ntf-meta { flex-direction: row; align-items: center; gap: 8px; margin-left: 50px; order: 3; width: 100%; text-align: left; }
}


/* Responsive */
@media (max-width: 980px) {
  .content-grid {
    grid-template-columns: 1fr;
  }

  .hero {
    text-align: center;
    justify-content: center;
  }

  .product-detail-container {
    grid-template-columns: 1fr;
    gap: var(--space-3);
  }

  .detail-image {
    height: 300px;
  }

  .cart-item {
    grid-template-columns: 88px 1fr;
  }

  .navbar-top {
    flex-wrap: wrap;
  }

  .navbar-search {
    min-width: 240px;
    flex: 1 1;
  }

  .navbar-categories-bottom {
    overflow-x: auto;
  }

  .category-icon-btn {
    padding: 10px 16px;
  }
}

@media (max-width: 640px) {
  .topbar,
  .hero,
  .content-grid,
  .product-panel,
  .cart-panel,
  .auth-container {
    padding-left: 12px;
    padding-right: 12px;
  }

  .navbar-top {
    flex-direction: column;
    gap: 10px;
    padding: 10px 12px;
  }

  .brand {
    font-size: 1.2rem;
  }

  .brand-button {
    padding: 8px 12px;
    flex: 0 0 auto;
  }

  .navbar-search {
    min-width: 100%;
    flex: 1 1;
  }

  .search-input {
    padding: 10px 12px;
    font-size: 0.9rem;
  }

  .navbar-actions-top {
    width: 100%;
    justify-content: space-around;
    gap: 4px;
  }

  .btn-icon-text {
    font-size: 0.75rem;
    padding: 6px 8px;
    flex: 1 1;
    text-align: center;
  }

  .cart-icon-btn {
    font-size: 1.4rem;
    padding: 6px 8px;
  }

  .category-icon-btn {
    padding: 8px 12px;
    font-size: 0.75rem;
  }

  .category-icon {
    font-size: 1.2rem;
  }

  .navbar-categories-bottom {
    overflow-x: auto;
  }

  .hero {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .hero-copy h1 {
    font-size: 1.6rem;
  }

  .product-grid {
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  }

  .product-card img {
    height: 140px;
  }

  .cart-item {
    grid-template-columns: 70px 1fr;
    gap: 12px;
  }

  .cart-item img {
    width: 70px;
    height: 70px;
  }

  .auth-container {
    padding: 28px 16px;
  }

  .auth-container h1 {
    font-size: 1.4rem;
    margin-bottom: 20px;
  }

  .product-detail-container {
    gap: 18px;
  }

  .detail-image {
    height: 240px;
  }

  .detail-info h1 {
    font-size: 1.6rem;
  }

  .detail-price {
    font-size: 1.6rem;
  }

  .admin-tabs {
    flex-direction: column;
  }

  .product-row,
  .order-row {
    grid-template-columns: 1fr;
    gap: var(--space-1);
  }
}

/* Checkout Multi-Step Styles */
.checkout-steps {
  display: flex;
  justify-content: space-between;
  gap: 0;
  width: min(1120px, calc(100% - 32px));
  max-width: 1120px;
  margin: 0 auto 40px;
  padding: 20px 40px;
  box-sizing: border-box;
}

.step {
  position: relative;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-1);
}

/* Each step draws the segment leading to the next one. Keeping the segments
   on the steps makes their centres stay aligned even when labels differ in
   width or the checkout becomes narrower. */
.step:not(:last-child)::after {
  content: '';
  position: absolute;
  z-index: 0;
  top: 23px;
  left: calc(50% + 24px);
  width: calc(100% - 48px);
  height: 2px;
  background: var(--border);
}

.step.completed:not(:last-child)::after {
  background: var(--accent);
}

.step-number {
  position: relative;
  z-index: 1;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--bg-tertiary);
  border: 2px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: var(--text-secondary);
  font-size: 1.1rem;
}

.step.active .step-number {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--color-text-on-secondary);
}

.step.completed .step-number {
  background: var(--success);
  border-color: var(--success);
  color: var(--color-text-on-secondary);
  font-size: 1.3rem;
}

.step-label {
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--text-secondary);
}

.step.active .step-label {
  color: var(--accent);
  font-weight: 600;
}

.checkout-step-pad {
  padding: 40px 20px;
}

/* Checkout Container */
.checkout-container {
  max-width: 800px;
  margin: 0 auto;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 30px;
  box-shadow: var(--shadow-panel);
}

/* Delivery-address checkout needs more horizontal room than the compact
   payment/summary steps. Keep this scoped so those steps retain their
   intentionally narrow reading width. */
.checkout-address-container {
  width: min(1120px, calc(100% - 32px));
  max-width: 1120px;
  box-sizing: border-box;
  padding: 34px 40px;
}

.checkout-address-container .address-section {
  margin-bottom: 0;
}

.checkout-address-container .ab-page {
  min-height: 0;
  padding: 10px 0 0;
  background: transparent;
}

.checkout-address-container .ab-cards-grid {
  max-width: none;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
  margin-bottom: 18px;
}

.checkout-address-container .ab-card {
  min-width: 0;
  min-height: 190px;
  padding: 26px 28px;
}

.checkout-address-container .ab-card-top {
  gap: 14px;
  margin-bottom: 18px;
}

.checkout-address-container .ab-card-info {
  gap: 10px;
  padding-bottom: 0;
}

.checkout-address-container .ab-info-row {
  gap: 12px;
  font-size: 0.9rem;
  line-height: 1.65;
  overflow-wrap: anywhere;
}

@media (max-width: 850px) {
  .checkout-address-container {
    width: min(680px, calc(100% - 24px));
    padding: 26px;
  }

  .checkout-address-container .ab-cards-grid {
    grid-template-columns: 1fr;
    gap: 18px;
  }
}

/* On mobile these two paddings stack with .ab-page's own mobile padding
   (used for the address-card picker embedded in checkout step 1), leaving
   the cards with a large, cramped-looking margin on both edges. Cut both
   back so the cards can actually use the screen width. */
@media (max-width: 600px) {
  .checkout-step-pad { padding: 20px 8px; }
  .checkout-container { padding: 12px; }
  .checkout-address-container { width: 100%; }
  .checkout-address-container .ab-card {
    min-height: 0;
    padding: 20px;
  }
}

.address-section {
  margin-bottom: 30px;
}

.address-section h2,
.address-form-section h2 {
  font-size: 1.2rem;
  margin-bottom: 20px;
  color: var(--text-primary);
}

.address-display {
  background: var(--bg-tertiary);
  padding: 20px;
  border-radius: var(--radius-sm);
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.address-info {
  flex: 1 1;
}

.address-info p {
  margin: 4px 0;
  color: var(--text-primary);
  font-size: 0.95rem;
}

.address-info p strong {
  font-weight: 600;
}

.btn-link {
  background: none;
  border: none;
  color: var(--accent);
  cursor: pointer;
  font-weight: 600;
  padding: 0;
  text-decoration: underline;
  font-size: 0.95rem;
}

.btn-link:hover {
  color: var(--accent-hover);
}

.address-form-section {
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: var(--text-primary);
  font-size: 0.95rem;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: 0.95rem;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-family: inherit;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: var(--space-2);
}

/* Order Summary */
.checkout-summary-pad {
  padding: 22px 30px 48px;
}

.checkout-summary-pad .checkout-steps {
  margin-bottom: 24px;
  padding-top: 8px;
  padding-bottom: 8px;
}

.order-summary-container {
  display: grid;
  grid-template-columns: minmax(0, 1.8fr) minmax(340px, 0.9fr);
  gap: 24px;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  align-items: start;
}

.summary-left {
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;
}

.summary-left .address-section,
.summary-left .order-items-section {
  background: var(--bg-secondary);
  padding: 24px;
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-card);
}

.summary-left .address-display {
  margin-bottom: 0;
  padding: 20px 22px;
  border: 1px solid var(--border);
}

.summary-left h3 {
  font-size: 1.1rem;
  margin-bottom: 15px;
  color: var(--text-primary);
}

.order-items {
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* ── Flipkart-style order item ──────────────────────────────── */
.fi-item {
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  margin-bottom: 12px;
  background: var(--bg-secondary);
  overflow: hidden;
  box-shadow: var(--shadow-card);
}

.fi-content-row {
  display: flex;
  gap: 20px;
  padding: 18px 20px 16px;
}

/* Left column: image + qty dropdown */
.fi-left {
  flex: 0 0 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.fi-img {
  width: 90px;
  height: 90px;
  object-fit: contain;
  border-radius: var(--radius-xs);
  background: var(--bg-primary);
  padding: 4px;
}

.fi-qty-wrap {
  display: flex;
  align-items: center;
  gap: 4px;
  border: 1px solid var(--border);
  border-radius: var(--radius-xs);
  padding: 4px 8px;
  background: var(--bg-primary);
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-primary);
  width: 100%;
  justify-content: center;
}

.fi-qty-label { color: var(--text-secondary); }

.fi-qty-select {
  border: none;
  background: transparent;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-primary);
  cursor: pointer;
  appearance: none;
  padding: 0;
}

.fi-qty-arrow {
  font-size: 0.6rem;
  color: var(--text-secondary);
  pointer-events: none;
}

/* Right column: product details */
.fi-right {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.fi-name {
  font-size: 0.92rem;
  font-weight: 500;
  color: var(--text-primary);
  line-height: 1.4;
  margin: 0;
}

.fi-size { font-size: 0.78rem; color: var(--text-secondary); margin: 2px 0 0; }

.fi-meta-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin: 2px 0;
}

.fi-rating-pill {
  background: var(--color-rating);
  color: var(--color-brand-white);
  font-size: 0.7rem;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: var(--radius-xs);
}

.fi-review-cnt {
  font-size: 0.72rem;
  color: var(--text-secondary);
}

.fi-assured {
  font-size: 0.72rem;
  color: var(--color-secondary);
  font-weight: 600;
}

.fi-price-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-1);
  row-gap: 2px;
  margin: 3px 0;
}

.fi-mrp {
  font-size: 0.8rem;
  color: var(--text-secondary);
  text-decoration: line-through;
}

.fi-price {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text-primary);
}

.fi-line-total {
  font-size: 0.75rem;
  color: var(--text-secondary);
  margin: 0;
}

.fi-delivery {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
}

.fi-express-badge {
  font-size: 0.68rem;
  font-weight: 800;
  color: var(--color-secondary);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.fi-delivery-text {
  font-size: 0.76rem;
  color: var(--text-secondary);
}

/* Action row */
.fi-actions {
  display: flex;
  align-items: stretch;
  border-top: 1px solid var(--border);
}

.fi-action-btn {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 10px 6px;
  font-size: 0.78rem;
  font-weight: 500;
  color: var(--text-secondary);
  background: none;
  border: none;
  cursor: pointer;
  transition: background 140ms, color 140ms;
  text-align: center;
}

/* Same undefined --bg-card as .auth-gate-tab above; same silent no-op hover. */
.fi-action-btn:hover {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.fi-action-remove { }
.fi-action-remove:hover { color: #c62828; }

.fi-action-buy { color: var(--color-secondary); }
.fi-action-buy:hover { background: rgba(40, 116, 240, 0.07); }

.fi-action-sep {
  width: 1px;
  background: var(--border);
  align-self: stretch;
}

/* Checkout delivery selector */
.checkout-del-opt {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  background: var(--bg-primary);
  transition: border-color 150ms;
  font-size: 0.84rem;
}
.checkout-del-opt > div {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}
.checkout-del-opt > div > span {
  margin-left: 0 !important;
  line-height: 1.35;
}
.checkout-del-opt input[type="radio"] { accent-color: var(--accent); cursor: pointer; }
.checkout-del-opt:hover { border-color: var(--accent) !important; }

/* Savings banner */
.fi-savings-banner {
  margin-top: 12px;
  padding: 10px 14px;
  background: #e8f5e9;
  color: #2e7d32;
  border-radius: var(--radius-xs);
  font-size: 0.82rem;
  font-weight: 600;
}

[data-theme="dark"] .fi-savings-banner {
  background: rgba(46, 125, 50, 0.18);
  color: #81c784;
}

/* Right sticky column — card + button scroll together */
.summary-right {
  position: sticky;
  top: 72px;
  align-self: start;
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* Price Details */
.price-details {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 24px;
  box-shadow: var(--shadow-card);
}

.price-details h3 {
  font-size: 1.2rem;
  margin-bottom: 20px;
  color: var(--text-primary);
}

.price-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
  font-size: 0.95rem;
  color: var(--text-secondary);
}

.price-row.total {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--border);
  font-weight: 600;
  font-size: 1.05rem;
  color: var(--text-primary);
}

/* The total is the row the shopper is actually deciding on, so it outweighs
   everything above it: navy (not an accent colour), heavier, and a step up in
   size. Accent colours are for actions; this is the number. */
.price-row.total span:last-child {
  color: var(--text-primary);
  font-weight: 800;
  font-size: 1.18rem;
  letter-spacing: -0.01em;
}

.free {
  color: var(--success);
  font-weight: 600;
}

.savings {
  color: var(--success);
  font-size: 0.85rem;
  margin-top: 12px;
  font-weight: 500;
}

.btn-place-order {
  width: 100%;
  margin-top: 20px;
  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);
  color: white;
  border: none;
  padding: 12px 20px;
  font-weight: 600;
  cursor: pointer;
  border-radius: var(--radius-sm);
  font-size: 1rem;
  transition: all 200ms ease;
}

.btn-place-order:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

/* Mobile Responsive */
@media (max-width: 980px) {
  .checkout-steps {
    gap: 0;
  }

  .order-summary-container {
    grid-template-columns: minmax(0, 1fr);
  }

  .summary-right {
    position: static;
  }

  .form-row {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 680px) {
  .checkout-summary-pad { padding: 18px 12px 36px; }
  .summary-left .address-section,
  .summary-left .order-items-section,
  .price-details { padding: 18px; }
  .summary-left .address-display { gap: 16px; flex-direction: column; }
  .fi-content-row { gap: 14px; padding: 14px; }
  .fi-left { flex-basis: 76px; }
  .fi-img { width: 76px; height: 76px; }
}

/* ── Order Timeline ───────────────────────────────────── */
.order-history-page h1 {
  margin-bottom: 24px;
  font-size: 1.8rem;
  color: var(--text-primary);
}

.orders-list { display: flex; flex-direction: column; gap: 14px; }

.order-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  overflow: hidden;
  transition: box-shadow 150ms;
  box-shadow: var(--shadow-card);
}

.order-card:hover { box-shadow: 0 2px 12px rgba(1, 13, 33,0.08); }

.order-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  background: none;
  border: none;
  width: 100%;
  cursor: pointer;
  text-align: left;
  gap: 12px;
}

.order-header-left h3 {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 3px;
}

.order-date {
  font-size: 0.82rem;
  color: var(--text-secondary);
  margin: 0;
}

.order-header-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.order-total-badge {
  font-weight: 700;
  font-size: 1rem;
  color: var(--text-primary);
}

.order-chevron {
  font-size: 0.7rem;
  color: var(--text-secondary);
}

.order-card-body {
  padding: 0 20px 20px;
  border-top: 1px solid var(--border);
}

/* Timeline */
.order-timeline {
  display: flex;
  align-items: flex-start;
  gap: 0;
  padding: 20px 0 16px;
  overflow-x: auto;
}

.timeline-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
  position: relative;
  gap: 6px;
}

.timeline-dot {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid var(--border);
  background: var(--bg-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-secondary);
  z-index: 1;
  position: relative;
  transition: all 200ms;
}

.timeline-step.done .timeline-dot {
  border-color: var(--accent);
  background: var(--accent);
  color: var(--color-text-on-secondary);
}

.timeline-step.current .timeline-dot {
  border-color: var(--accent);
  background: var(--accent);
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.18);
}

.timeline-icon { font-size: 1rem; }
.timeline-num  { font-size: 0.82rem; font-weight: 700; }

.timeline-line {
  position: absolute;
  top: 18px;
  left: calc(50% + 18px);
  width: calc(100% - 36px);
  height: 2px;
  background: var(--border);
}

.timeline-line.filled { background: var(--accent); }

.timeline-label {
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-align: center;
  white-space: nowrap;
}

.timeline-step.done .timeline-label { color: var(--accent); }

.timeline-cancelled {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  margin: 16px 0;
  padding: 8px 16px;
  background: var(--color-primary-soft);
  color: var(--color-primary);
  border-radius: var(--radius-sm);
  font-weight: 600;
  font-size: 0.9rem;
}

/* Order items inside card */
.order-items { margin-top: 4px; }
.order-items h4 { font-size: 0.85rem; font-weight: 600; color: var(--text-secondary); text-transform: uppercase; letter-spacing: 0.06em; margin: 0 0 8px; }

.order-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid var(--border);
  font-size: 0.9rem;
}

.order-item:last-child { border-bottom: none; }
.order-item-name  { flex: 1 1; color: var(--text-primary); }
.order-item-qty   { color: var(--text-secondary); font-size: 0.82rem; }
.order-item-price { font-weight: 600; color: var(--text-primary); }

.order-footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid var(--border);
  gap: var(--space-2);
  flex-wrap: wrap;
}

.order-address {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.order-address strong { color: var(--text-primary); margin-bottom: 2px; }

.order-total-row {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}

.order-total-row span { font-size: 0.82rem; color: var(--text-secondary); }
.order-total-row strong { font-size: 1.15rem; color: var(--text-primary); }

/* ── Product Card Ratings ─────────────────────────────── */
.card-rating {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 6px;
  font-size: 0.82rem;
}

.card-stars {
  color: var(--color-primary);
  letter-spacing: 1px;
  font-size: 0.85rem;
}

.card-rating-val {
  font-weight: 700;
  color: var(--text-primary);
}

.card-review-count {
  color: var(--text-secondary);
}

.detail-stars {
  color: var(--color-primary);
  font-size: 1.1rem;
  letter-spacing: 2px;
}

.card-rating-empty {
  color: var(--text-secondary);
  font-size: 0.78rem;
  font-style: italic;
}

/* ── Sort + Controls Row ──────────────────────────────── */
.controls-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.sort-select {
  padding: 8px 12px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 0.88rem;
  font-family: inherit;
  cursor: pointer;
  flex-shrink: 0;
}

.sort-select:focus {
  outline: none;
  border-color: var(--accent);
}

/* ── Admin Analytics ──────────────────────────────────── */
.analytics-section { display: flex; flex-direction: column; gap: var(--space-3); }

.kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--space-2);
}

.kpi-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  border-top: 3px solid var(--kpi-color, var(--accent));
  position: relative;
  overflow: hidden;
  box-shadow: var(--shadow-card);
  transition: transform 280ms var(--ease-out-expo, ease), box-shadow 280ms var(--ease-out-expo, ease);
}

.kpi-card::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, var(--kpi-color, var(--accent)) 0%, transparent 60%);
  opacity: 0.04;
  pointer-events: none;
}

.kpi-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(1, 13, 33,0.14);
}

[data-theme="dark"] .kpi-card:hover {
  box-shadow: 0 12px 32px rgba(1, 13, 33,0.4);
}

.kpi-label {
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-secondary);
}

.kpi-value {
  font-size: 1.65rem;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.1;
}

.kpi-sub {
  font-size: 0.78rem;
  color: var(--text-secondary);
}

.analytics-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-2);
}

.analytics-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 20px;
  box-shadow: var(--shadow-card);
}

.analytics-card.wide {
  grid-column: 1 / -1;
}

.analytics-card h3 {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 16px;
}

.chart-tooltip {
  background: var(--bg-primary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 10px 14px;
  font-size: 0.85rem;
  color: var(--text-primary);
}

.chart-tooltip-label {
  font-weight: 600;
  margin-bottom: 4px;
}

/* Top products list */
.top-products-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.top-product-item {
  display: grid;
  grid-template-columns: 28px 1fr auto auto;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: var(--bg-tertiary);
  border-radius: var(--radius-sm);
  font-size: 0.88rem;
}

.top-rank {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--text-secondary);
}

.top-name {
  font-weight: 500;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.top-units {
  font-size: 0.78rem;
  color: var(--text-secondary);
  white-space: nowrap;
}

.top-revenue {
  font-weight: 700;
  color: var(--accent);
  white-space: nowrap;
}

/* Recent orders list */
.recent-orders-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.recent-order-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  background: var(--bg-tertiary);
  border-radius: var(--radius-sm);
}

.recent-order-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.recent-order-id {
  font-size: 0.75rem;
  font-family: monospace;
  color: var(--text-secondary);
}

.recent-order-name {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--text-primary);
}

.recent-order-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.recent-order-total {
  font-weight: 700;
  font-size: 0.9rem;
  color: var(--text-primary);
}

@media (max-width: 900px) {
  .kpi-grid { grid-template-columns: 1fr 1fr; }
  .analytics-grid { grid-template-columns: 1fr; }
  .analytics-card.wide { grid-column: 1; }
}

@media (max-width: 500px) {
  .kpi-grid { grid-template-columns: 1fr; }
}

/* ── Profile Page ─────────────────────────────────────── */
.pf-page {
  max-width: 640px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.pf-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: var(--space-3);
  box-shadow: var(--shadow-card);
}

.pf-avatar-row {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.pf-avatar-wrap {
  position: relative;
  flex-shrink: 0;
}

.pf-avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--accent), var(--accent-secondary));
  color: var(--color-brand-white);
  font-size: 2rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pf-avatar-img {
  object-fit: cover;
}

.pf-avatar-spinner {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: rgba(1, 13, 33, 0.45);
  display: flex;
}

.pf-avatar-spinner::after {
  content: '';
  margin: auto;
  width: 22px;
  height: 22px;
  border: 3px solid rgba(255, 255, 255, 0.35);
  border-top-color: var(--color-brand-white);
  border-radius: 50%;
  animation: spin 800ms linear infinite;
}

.pf-avatar-edit {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  color: var(--accent);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-card);
  cursor: pointer;
  padding: 0;
}

.pf-avatar-edit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.pf-identity {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pf-name {
  font-size: 1.3rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0;
}

.pf-role-badge {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--accent-secondary);
  background: color-mix(in srgb, var(--accent-secondary) 12%, transparent);
  border-radius: var(--radius-pill);
  padding: 3px 12px;
  width: fit-content;
}

.pf-info-row {
  display: flex;
  align-items: center;
  margin-top: var(--space-3);
  padding-top: var(--space-3);
  border-top: 1px solid var(--border);
}

.pf-info-item {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.pf-info-divider {
  width: 1px;
  height: 32px;
  background: var(--border);
  margin: 0 var(--space-2);
}

.pf-info-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: color-mix(in srgb, var(--accent-secondary) 12%, transparent);
  color: var(--accent-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.pf-info-text { min-width: 0; }

.pf-info-label {
  font-size: 0.74rem;
  color: var(--text-muted);
}

.pf-info-value {
  font-size: 0.88rem;
  font-weight: 700;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pf-card-hdr {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: var(--space-3);
}

.pf-card-hdr-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-sm);
  background: color-mix(in srgb, var(--accent-secondary) 12%, transparent);
  color: var(--accent-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.pf-card-hdr h3 {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.pf-card-hdr p {
  font-size: 0.82rem;
  color: var(--text-secondary);
  margin: 2px 0 0;
}

.pf-form {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.pf-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pf-field-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-primary);
}

.pf-input-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 0 14px;
  background: var(--bg-primary);
}

.pf-input-wrap:focus-within {
  border-color: var(--accent);
}

.pf-input-icon {
  color: var(--text-muted);
  display: flex;
  flex-shrink: 0;
}

.pf-input-wrap input {
  flex: 1 1;
  min-width: 0;
  border: none;
  background: transparent;
  padding: 12px 0;
  font-size: 0.92rem;
  color: var(--text-primary);
}

.pf-input-wrap input:focus { outline: none; }

.pf-input-eye {
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  padding: 4px;
}

.pf-btn-primary,
.pf-btn-secondary {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 46px;
  border-radius: var(--radius-sm);
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  margin-top: 6px;
}

/* "Save changes" is a primary commercial action -> orange, navy label. */
.pf-btn-primary {
  border: none;
  background: var(--color-primary);
  color: var(--color-text-on-primary);
}

.pf-btn-primary:hover:not(:disabled) {
  background: var(--accent-secondary-hover);
}

.pf-btn-secondary {
  border: none;
  background: color-mix(in srgb, var(--accent-secondary) 12%, transparent);
  color: var(--accent-secondary);
}

.pf-btn-secondary:hover:not(:disabled) {
  background: color-mix(in srgb, var(--accent-secondary) 20%, transparent);
}

.pf-btn-primary:disabled,
.pf-btn-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 480px) {
  /* Side-by-side email + member-since truncates the email at narrow
     widths -- stack them so each value gets the full row width instead. */
  .pf-info-row {
    flex-direction: column;
    align-items: stretch;
    gap: var(--space-2);
  }
  .pf-info-divider { display: none; }
}

/* ── Cash on Delivery Payment Step ───────────────────── */
.cod-payment-section {
  max-width: 560px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.cod-payment-section h2 {
  font-size: 1.4rem;
  color: var(--text-primary);
  margin: 0;
}

.payment-method-card {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: 18px 20px;
  border: 2px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--bg-secondary);
  cursor: pointer;
  transition: border-color 200ms;
  box-shadow: var(--shadow-card);
}

.payment-method-card.selected {
  border-color: var(--accent);
  background: rgba(59, 130, 246, 0.05);
}

/* COD-only confirmation panel (no method to choose): not a clickable chooser,
   so drop the pointer affordance and read as a settled, confirmed state. */
.payment-method-cod-confirm {
  cursor: default;
  border-color: color-mix(in srgb, var(--success) 40%, transparent);
  background: color-mix(in srgb, var(--success) 6%, transparent);
}

/* .payment-method-icon and .payment-method-info are gone, here and in
   mobile/screens.css. Every payment card is now a marker, a .co-selected-title
   and (on the chosen one) a chip -- no glyph tile, no title-and-blurb column --
   so nothing rendered these any more.

   Deleted rather than left in place on purpose. Orphaned rules describing a
   structure that no longer exists are the same trap the mobile layer's
   three-column grid turned out to be: confident, specific, and about a card
   that had changed shape underneath them. */

/* .payment-method-check is gone: the chooser marked its chosen card with a
   standalone tick glyph, and that job now belongs to the filled marker and the
   Selected chip. Nothing else referenced it. */
.cod-order-recap,
.cod-address-recap {
  padding: 18px 20px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--bg-secondary);
  box-shadow: var(--shadow-card);
}

.cod-order-recap h3,
.cod-address-recap h3 {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 14px;
}

.zone-check-status {
  margin-top: 8px !important;
  font-weight: 600;
  font-size: 0.85rem !important;
}
.zone-check-status.zone-ok { color: var(--success); }
.zone-check-status.zone-warn { color: var(--danger); }

.cod-address-recap p {
  margin: 4px 0;
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.cod-address-recap p strong {
  color: var(--text-primary);
}

/* ── Order Success Page ──────────────────────────────────────── */
.order-success-wrap,
.order-success-wrap * {
  box-sizing: border-box;
}

.order-success-wrap {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-align: center;
}

.order-success-hero {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.order-success-icon {
  position: relative;
  z-index: 1;
  width: 84px;
  height: 84px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(34,255,122,0.18) 0%, rgba(34,255,122,0.05) 55%, transparent 100%);
  border: 3px solid #2dff85;
  color: var(--color-brand-white);
  font-size: 2.1rem;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow:
    0 0 10px 2px rgba(45,255,133,0.85),
    0 0 28px 8px rgba(45,255,133,0.5),
    0 0 56px 18px rgba(45,255,133,0.28),
    inset 0 0 18px rgba(45,255,133,0.35);
  animation: scale-in 0.35s ease-out;
}

[data-theme="light"] .order-success-icon {
  background: radial-gradient(circle, var(--success) 0%, color-mix(in srgb, var(--success) 78%, var(--color-brand-navy)) 100%);
  border-color: var(--success);
  box-shadow:
    0 0 10px 2px color-mix(in srgb, var(--success) 45%, transparent),
    0 0 28px 8px color-mix(in srgb, var(--success) 30%, transparent),
    0 0 56px 18px color-mix(in srgb, var(--success) 16%, transparent);
}

.order-success-confetti {
  position: absolute;
  inset: -40px;
  pointer-events: none;
}

.confetti-piece {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 9px;
  height: 9px;
  border-radius: 2.5px;
  opacity: 0;
  animation: confetti-burst 1.8s ease-out forwards;
  animation-delay: calc(var(--i) * 0.04s);
  transform: rotate(calc(var(--i) * 37deg));
}
.confetti-piece:nth-child(3n)   { width: 11px; height: 11px; }
.confetti-piece:nth-child(3n+1) { width: 7px; height: 7px; }
.confetti-0 { background: var(--color-primary); }
.confetti-1 { background: var(--color-secondary); }
.confetti-2 { background: var(--success); }
.confetti-3 { background: var(--danger); }
.confetti-4 { background: #a855f7; }
.confetti-5 { background: var(--color-secondary); }

@keyframes confetti-burst {
  0%   { opacity: 1; transform: rotate(calc(var(--i) * 37deg)) translate(0, 0) scale(0.6); }
  18%  { opacity: 1; transform: rotate(calc(var(--i) * 37deg)) translate(0, -58px) scale(1.1); }
  70%  { opacity: 1; transform: rotate(calc(var(--i) * 37deg)) translate(0, -58px) scale(1); }
  100% { opacity: 0; transform: rotate(calc(var(--i) * 37deg)) translate(0, -70px) scale(0.7); }
}

.order-success-title {
  font-size: 1.75rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0;
}

.order-success-sub {
  font-size: 1.02rem;
  color: var(--text-secondary);
  margin: 0 0 16px;
  max-width: 420px;
}

.order-success-trust {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: color-mix(in srgb, var(--success) 10%, transparent);
  border: 1px solid color-mix(in srgb, var(--success) 30%, transparent);
  color: var(--success);
  font-size: 0.94rem;
  font-weight: 600;
  border-radius: 999px;
  padding: 8px 18px;
  margin-bottom: 20px;
}

/* ── Order-placed screen, mobile treatment ────────────────────────────────
   The desktop version is a long report: a pill-shaped confirmation, four
   stat cards in a row, a "What's Next?" explainer and a recommendations
   grid. On a phone that becomes a lot of scrolling before the two facts that
   actually matter -- it worked, and here is the order number.

   Everything below hangs off html.m-app, so the packaged app and the phone
   browser get the same screen. The desktop site keeps its layout, which suits
   a wide viewport and is doing SEO work a phone does not need. */

/* The confirmation is a full-width band rather than a centred pill: on a
   narrow screen a pill either wraps awkwardly or shrinks the sentence, and a
   band reads as a status bar for the whole page. Square corners requested;
   they also let it sit flush against the content above and below. */
html.m-app .order-success-trust {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  justify-content: center;
  text-align: left;
  border-radius: 0;
  border-left: 0;
  border-right: 0;
  padding: 12px 16px;
  font-size: 0.82rem;
  background: var(--color-app-success-soft);
  border-color: var(--color-app-success-border);
  color: var(--color-app-success);
}

/* Two columns, not four. At four the labels ("PAYMENT METHOD", "EST
   DELIVERY") were wrapping inside 90px cards and the values underneath them
   broke mid-word. The secondary line in each card goes too -- the date range
   and "Pay on delivery" are detail the tracking page already carries. */
html.m-app .order-success-stats {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}
html.m-app .oss-card { padding: 10px; gap: 8px; }
html.m-app .oss-icon { width: 26px; height: 26px; border-radius: 7px; }
html.m-app .oss-label { font-size: 0.62rem; margin-bottom: 1px; }
html.m-app .oss-value { font-size: 0.78rem; line-height: 1.3; }
html.m-app .oss-sub-detail { display: none; }
html.m-app .oss-pill { font-size: 0.6rem; }
html.m-app .oss-fast-pill { display: none; }

/* Removed in the app: it explains what the tracker directly above it is
   already showing, and the three mini-items repeat the email/notification
   promises made at checkout. */
html.m-app .order-success-next { display: none; }

/* ── The order-placed page gets its edges back ────────────────────────────
   Everything on this screen was running 0 -> 390: the tracker, the stat
   cards and the items list all touched both bezels, so cards that are drawn
   with a border had that border sitting on the edge of the glass and read as
   clipped rather than as cards.

   Checkout is the surface that benefits from full-bleed -- it is a form, and
   width is what its rows need. This screen is a receipt: a stack of discrete
   cards, which need an edge to sit against to look like cards at all. */
html.m-app .order-success-wrap {
  padding-left: 14px;
  padding-right: 14px;
  box-sizing: border-box;
}

/* The confirmation band is the exception and stays edge to edge. It is a
   status bar for the whole screen rather than one of the cards, so it is
   pulled back out through the padding just added above. */
html.m-app .order-success-trust {
  width: calc(100% + 28px);
  margin-left: -14px;
  margin-right: -14px;
}

/* ── Progress tracker goes vertical on a phone ────────────────────────────
   Four steps laid out across 390px leaves about 60px each, so every label
   ("Order Received", "Payment Confirmed") is squeezed into a two-line stack
   under a 32px dot, and the timestamps below them have nowhere to go. The
   horizontal form is right on a wide canvas and wrong in the hand.

   Stacked, each step gets the full width: dot on the left, label and its
   timestamp beside it, and the connector running down between dots. This is
   the ordinary shape of a progress list on a phone, and it leaves room for
   the timestamp to be read rather than truncated.

   Done with grid rather than new markup. The step's three children -- dot,
   label, and either a timestamp or the "In Progress" pill -- are siblings
   with no wrapper around the text pair, so a flex row would put all three
   side by side. Named areas place the dot in a column of its own spanning
   both rows, and the text stacks beside it. */
html.m-app .order-success-tracker {
  flex-direction: column;
  align-items: stretch;
  padding: 16px 18px;
}

/* The dot column is a fixed 38px -- the width of the largest dot -- rather
   than sized to each step's own content.

   That difference is what made the column look ragged. The active step's dot
   is 38px while the rest are 32px, so an auto-sized column gave that one step
   a wider first track: its dot centre landed 3px right of the others and its
   label 6px right, leaving the connectors zig-zagging between them and the
   text edge stepping in and out. Pinning the track and centring the dot inside
   it puts every dot, every connector and every label on one axis, whatever
   size the dot happens to be. */
html.m-app .ost-step {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  grid-template-areas:
    "dot label"
    "dot sub";
  align-items: center;
  column-gap: 13px;
  text-align: left;
}

html.m-app .ost-dot {
  grid-area: dot;
  justify-self: center;
}
/* max-width: none is the load-bearing line here.

   The horizontal layout caps these at 80px below 820px and 60px below 600px,
   because there each label had to fit a narrow column. Stacked, that cap is
   exactly wrong: the label had a 301px track available and was still being
   held to 60px, wrapping "Order Received" onto two lines with 240px of empty
   column beside it -- which is what made the list look ragged.

   Specificity alone did not fix it. This selector already outranks the media
   query's, but width and max-width are different properties, so a wider width
   never contended with the cap; it had to be lifted by name. */
html.m-app .ost-label,
html.m-app .ost-sub {
  max-width: none;
  width: 100%;
  justify-self: stretch;
  white-space: normal;
}

html.m-app .ost-label {
  grid-area: label;
  margin: 0;
}
html.m-app .ost-sub { grid-area: sub; }
html.m-app .ost-pill-active { grid-area: sub; justify-self: start; margin-top: 3px; }

/* The connector is a sibling of the steps, not a child, so in a column it
   becomes a short vertical rule. 18px puts its 2px width centred on 19 --
   the middle of the 38px dot track above -- so it meets every dot dead centre
   regardless of that dot's own size. */
html.m-app .ost-line {
  flex: 0 0 auto;
  width: 2px;
  height: 20px;
  margin: 3px 0 3px 18px;
  background-image: repeating-linear-gradient(
    to bottom,
    var(--border) 0, var(--border) 5px, transparent 5px, transparent 10px
  );
}
html.m-app .ost-line-done { background-image: none; background-color: var(--success); }

/* Progress tracker */
.order-success-tracker {
  width: 100%;
  display: flex;
  align-items: flex-start;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-card);
  padding: 20px 16px;
  margin-bottom: 16px;
}

/* Each step is sized to its own content (dot + label), so dot and label
   share the same center automatically. Connecting lines are separate
   flex:1 siblings that absorb all the space between steps — this is what
   keeps the first dot flush-left, the last dot flush-right, and every gap
   in between equal, with no leftover slack on either edge. */
.ost-step {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.ost-dot {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--bg-tertiary);
  border: 2px solid var(--border);
  color: var(--text-tertiary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.95rem;
  flex-shrink: 0;
}
.ost-dot-done { background: var(--success); border-color: var(--success); color: var(--color-text-on-secondary); }
.ost-dot-active {
  width: 38px;
  height: 38px;
  background: var(--success);
  border-color: var(--success);
  color: var(--color-text-on-secondary);
  font-size: 1.1rem;
  animation: pulse-ring-active 1.6s ease-out infinite;
}

@keyframes pulse-ring-active {
  0%   { box-shadow: 0 0 0 0   color-mix(in srgb, var(--success) 45%, transparent); }
  70%  { box-shadow: 0 0 0 10px color-mix(in srgb, var(--success) 0%, transparent); }
  100% { box-shadow: 0 0 0 0   color-mix(in srgb, var(--success) 0%, transparent); }
}

.ost-line {
  flex: 1 1;
  height: 2px;
  margin-top: 15px;
  background-image: repeating-linear-gradient(to right, var(--border) 0, var(--border) 5px, transparent 5px, transparent 10px);
}
.ost-line-done { background-image: none; background-color: var(--success); }

.ost-label {
  font-size: 0.86rem;
  font-weight: 600;
  color: var(--text-secondary);
  margin: 8px 0 2px;
  white-space: nowrap;
}
.ost-label-done { color: var(--success); }
.ost-label-active { color: var(--text-primary); font-weight: 700; }

.ost-sub {
  font-size: 0.78rem;
  color: var(--text-tertiary);
  margin: 0;
  white-space: nowrap;
}

.ost-pill-active {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--success);
  background: color-mix(in srgb, var(--success) 12%, transparent);
  border-radius: 999px;
  padding: 2px 9px;
  margin-top: 1px;
  white-space: nowrap;
}

/* Below ~820px, steps no longer have room to sit at their natural width —
   let labels wrap instead of forcing the row wider than its container. */
@media (max-width: 820px) {
  .ost-label, .ost-sub { white-space: normal; max-width: 80px; }
}

@media (max-width: 600px) {
  .ost-label { font-size: 0.7rem; }
  .ost-sub { font-size: 0.66rem; }
  .ost-label, .ost-sub { max-width: 60px; }
}

/* Stat cards */
.order-success-stats {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-bottom: 16px;
}

.oss-card {
  text-align: left;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-card);
  padding: 12px;
  min-width: 0;
}

.oss-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.05rem;
  flex-shrink: 0;
}
.oss-icon-blue   { background: rgba(59,130,246,0.15); }
.oss-icon-positive  { background: color-mix(in srgb, var(--success) 15%, transparent); }
.oss-icon-orange { background: rgba(255, 103, 0,0.15); }
.oss-icon-info { background: color-mix(in srgb, var(--accent-secondary) 15%, transparent); }

.oss-body { flex: 1 1; min-width: 0; }

.oss-label {
  font-size: 0.76rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--text-tertiary);
  margin: 0 0 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.oss-value {
  font-size: 0.94rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  overflow-wrap: break-word;
}
.oss-pill {
  display: inline-block;
  background: color-mix(in srgb, var(--success) 15%, transparent);
  color: var(--success);
  font-size: 0.7rem;
  font-weight: 800;
  padding: 1px 6px;
  border-radius: 4px;
  margin-left: 4px;
}

.oss-copy-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.82rem;
  color: var(--text-tertiary);
  margin-left: 4px;
  padding: 0;
  vertical-align: middle;
}
.oss-copy-btn:hover { color: var(--accent); }

.oss-sub-detail {
  font-size: 0.82rem;
  color: var(--text-tertiary);
  margin: 3px 0 0;
}
.oss-sub-detail-orange { color: var(--color-primary); font-weight: 600; }

.oss-fast-pill {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--success);
  background: color-mix(in srgb, var(--success) 12%, transparent);
  border-radius: 999px;
  padding: 2px 9px;
  margin-top: 5px;
}

@media (max-width: 700px) {
  .order-success-stats { grid-template-columns: repeat(2, 1fr); }
}

.order-success-card,
.order-success-items,
.order-success-address,
.order-success-summary {
  width: 100%;
  text-align: left;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-card);
  padding: 18px 20px;
  margin-bottom: 16px;
}

.order-success-card hr,
.order-success-summary hr {
  border: none;
  border-top: 1px solid var(--border);
  margin: 10px 0;
}

.order-success-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.98rem;
  color: var(--text-secondary);
  padding: 5px 0;
}

.order-success-row strong { color: var(--text-primary); }
.order-success-free { color: var(--success) !important; }

.order-success-row.total {
  font-size: 1.18rem;
}
.order-success-row.total strong { color: var(--accent); }

.order-success-items h3,
.order-success-address h3,
.order-success-summary h3 {
  font-size: 1.08rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 12px;
}

.order-success-item-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid var(--border);
}
.order-success-item-row:last-child { border-bottom: none; }

.order-success-item-row img {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  object-fit: cover;
  background: var(--bg-tertiary);
  flex-shrink: 0;
}

.order-success-item-info { flex: 1 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }
.order-success-item-name {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.order-success-item-meta {
  font-size: 0.88rem;
  color: var(--text-tertiary);
  margin: 0;
}
.osi-seller { color: var(--accent); font-weight: 600; }
.osi-qty-pill {
  display: inline-block;
  align-self: flex-start;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-secondary);
  background: var(--bg-tertiary);
  border-radius: 20px;
  padding: 2px 10px;
}
.order-success-item-total {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
  flex-shrink: 0;
}

/* Delivering to / Summary two-column */
.order-success-cols {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
@media (max-width: 700px) {
  .order-success-cols { grid-template-columns: 1fr; }
}

.osa-body {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.osa-info { flex: 1 1; min-width: 0; }

.order-success-address p {
  margin: 4px 0;
  font-size: 0.98rem;
  color: var(--text-secondary);
}
.order-success-address p strong { color: var(--text-primary); }

.order-success-map {
  position: relative;
  width: 100px;
  height: 90px;
  flex-shrink: 0;
  border-radius: var(--radius-sm);
  background: repeating-linear-gradient(45deg, var(--bg-tertiary) 0 10px, var(--bg-primary) 10px 20px);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  opacity: 0.6;
  overflow: hidden;
}
.order-success-map-pin {
  position: absolute;
  font-size: 1.3rem;
  opacity: 1;
  filter: drop-shadow(0 2px 3px rgba(1, 13, 33,0.3));
}

@media (max-width: 480px) {
  .osa-body { flex-direction: column-reverse; }
  .order-success-map { width: 100%; }
}

/* What's next */
.order-success-next {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
  background: color-mix(in srgb, var(--accent-secondary) 10%, transparent);
  border: 1px solid color-mix(in srgb, var(--accent-secondary) 30%, transparent);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  padding: 16px 20px;
  margin-bottom: 20px;
  text-align: left;
}

.osn-icon {
  position: relative;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: var(--success);
  color: var(--color-text-on-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.32rem;
  flex-shrink: 0;
}

.osn-icon-badge {
  position: absolute;
  bottom: -3px;
  right: -3px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--accent);
  color: var(--color-text-on-secondary);
  font-size: 0.68rem;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--bg-secondary);
}

.osn-text { flex: 1 1; min-width: 180px; }
.osn-title { font-size: 1.02rem; font-weight: 700; color: var(--text-primary); margin: 0 0 2px; }
.osn-sub { font-size: 0.9rem; color: var(--text-secondary); margin: 0; }

.osn-mini-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.osn-mini {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-width: 64px;
  text-align: center;
}
.osn-mini-icon { font-size: 1.22rem; }
.osn-mini-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-secondary);
  white-space: nowrap;
}

.order-success-actions {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 28px;
}

@media (min-width: 600px) {
  .order-success-actions { flex-direction: row; }
  .order-success-actions .btn { flex: 1 1; }
}

/* You may also like */
.order-success-recs {
  width: 100%;
  text-align: left;
}
.osr-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.osr-head h3 { font-size: 1.12rem; font-weight: 700; color: var(--text-primary); margin: 0; }

/* minmax(0, 1fr), not 1fr. A 1fr track's automatic minimum is \`auto\`, which
   for a card containing an <img width:100%> resolves to the image's INTRINSIC
   width -- so the column refuses to shrink below the source image and the grid
   blows out of its container. On the order confirmation at 360px that made
   each card 221px wide in a 340px grid, running the second column 138px off
   the right of the screen. minmax(0, ...) lets the track shrink to the space
   actually available; min-width:0 on the card is the same fix one level down,
   for the flex/grid children inside it. */
.osr-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}
@media (max-width: 700px) {
  .osr-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

/* With equal columns each card is ~180px, where a 100px contained image left
   the product floating in empty space. Cover fills the tile, and the name is
   clamped so a long one wraps to two lines instead of setting the card's
   height by itself. */
html.m-app .osr-card img {
  height: 120px;
  object-fit: cover;
}

html.m-app .osr-name {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 2.6em;
}

.osr-card {
  min-width: 0;
  position: relative;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 10px;
  cursor: pointer;
  transition: box-shadow 0.15s, transform 0.15s;
  box-shadow: var(--shadow-card);
}
.osr-card:hover { box-shadow: var(--shadow-card); transform: translateY(-2px); }

.osr-heart {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  color: var(--text-secondary);
  cursor: pointer;
  z-index: 1;
}

.osr-card img {
  width: 100%;
  height: 100px;
  object-fit: contain;
  background: var(--bg-tertiary);
  border-radius: 6px;
  margin-bottom: 8px;
}

.osr-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.osr-price-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.osr-price { font-size: 0.95rem; font-weight: 700; color: var(--text-primary); }
/* The number is navy (green text on this surface is 3.30:1); the star keeps
   the rating green, which is a graphic and clears its 3:1 bar. */
.osr-rating { font-size: 0.8rem; color: var(--text-primary); font-weight: 600; }
.osr-rating svg { color: var(--color-rating); }

/* ── Coupon Section (Checkout Step 3) ────────────────────────── */
.order-notes-section {
  background: var(--bg-tertiary);
  border: 1px solid color-mix(in srgb, var(--accent-secondary) 25%, transparent);
  border-radius: var(--radius-sm);
  padding: 18px 20px;
  margin-top: 16px;
}
.order-notes-section h3 {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-secondary);
  margin: 0 0 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.order-notes-textarea {
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 0.9rem;
  font-family: inherit;
  resize: vertical;
  box-sizing: border-box;
  line-height: 1.5;
}
.order-notes-textarea:focus {
  outline: none;
  border-color: var(--accent-secondary);
}

.coupon-section {
  background: var(--bg-tertiary);
  border: 1px dashed var(--border);
  border-radius: var(--radius-sm);
  padding: 18px 20px;
  box-shadow: var(--shadow-card);
}

.coupon-section h3 {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-secondary);
  margin: 0 0 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.coupon-input-row {
  display: flex;
  gap: 10px;
}

.coupon-input {
  flex: 1 1;
  min-width: 0;
  padding: 10px 14px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: 0.95rem;
  font-family: 'Courier New', monospace;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  background: var(--bg-secondary);
  color: var(--text-primary);
  transition: border-color 200ms;
}

.coupon-input:focus {
  outline: none;
  border-color: var(--accent);
}

.coupon-apply-btn {
  flex: 0 0 auto;
  padding: 10px 20px;
  font-size: 0.9rem;
  white-space: nowrap;
}

.coupon-feedback {
  margin-top: 10px;
  padding: 10px 14px;
  border-radius: var(--radius-sm);
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: var(--space-1);
}

.coupon-success {
  background: rgba(59, 130, 246, 0.12);
  border: 1px solid rgba(59, 130, 246, 0.35);
  color: var(--success);
}

.coupon-error {
  background: color-mix(in srgb, var(--danger) 10%, transparent);
  border: 1px solid color-mix(in srgb, var(--danger) 30%, transparent);
  color: var(--danger);
}

.coupon-remove {
  margin-left: auto;
  background: none;
  border: none;
  cursor: pointer;
  color: inherit;
  opacity: 0.7;
  font-size: 1rem;
  padding: 0 4px;
  line-height: 1;
}

.rewards-redeem-section { margin-top: var(--space-2); }

.rewards-redeem-toggle {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-primary);
  cursor: pointer;
  text-transform: none;
  letter-spacing: normal;
}

.rewards-redeem-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}
.rewards-redeem-controls input[type="range"] {
  flex: 1 1;
  accent-color: var(--accent);
}
.rewards-redeem-value {
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--success);
  white-space: nowrap;
}

.rewards-redeem-hint {
  margin: 10px 0 0;
  font-size: 0.78rem;
  color: var(--text-tertiary);
}

.coupon-remove:hover {
  opacity: 1;
}

/* Deductions in the order summary (coupon discount, reward points, wallet
   credit) read in brand orange -- never green. Green in this app is reserved
   for product ratings and must not appear on a money row. */
.discount-row {
  color: var(--color-primary);
  font-weight: 600;
}

/* ── Coupons Admin Table ─────────────────────────────────────── */
.coupons-header {
  grid-template-columns: 140px 120px 100px 80px 100px 90px 160px !important;
}

.coupons-table {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-card);
}

.coupon-row {
  display: grid;
  grid-template-columns: 140px 120px 100px 80px 100px 90px 160px;
  gap: 12px;
  align-items: center;
  padding: 12px 20px;
  border-bottom: 1px solid var(--border);
  font-size: 0.88rem;
}

.coupon-row:last-child { border-bottom: none; }
.coupon-row:hover { background: var(--bg-tertiary); }

.coupon-code-badge {
  display: inline-block;
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-radius: var(--radius-xs);
  padding: 3px 8px;
  font-family: 'Courier New', monospace;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: var(--accent);
}

.coupon-active {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: var(--success);
  font-size: 0.82rem;
  font-weight: 600;
}

.coupon-inactive {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: var(--text-tertiary);
  font-size: 0.82rem;
}

/* ════════════════════════════════════════════════════════════════
   Coupons — redesigned submenu
   ════════════════════════════════════════════════════════════════ */
.cpn-section { display: flex; flex-direction: column; gap: 24px; }

.cpn-card {
  background: linear-gradient(155deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0) 42%), var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 24px;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.04), var(--shadow-card);
}

.cpn-card-head { display: flex; align-items: center; gap: 12px; margin-bottom: 22px; }
.cpn-card-icon {
  width: 38px; height: 38px; border-radius: 10px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  background: color-mix(in srgb, var(--color-secondary) 18%, transparent); color: var(--color-secondary);
}
.cpn-card-title { margin: 0; font-size: 1.15rem; font-weight: 700; color: var(--text-primary); }
.cpn-cancel-edit {
  margin-left: auto; display: inline-flex; align-items: center; gap: 5px;
  background: transparent; border: 1px solid var(--border); color: var(--text-secondary);
  border-radius: var(--radius-sm); padding: 6px 12px; font-size: 0.8rem; font-weight: 600; cursor: pointer;
}
.cpn-cancel-edit:hover { background: var(--bg-tertiary); color: var(--text-primary); }

/* form grid */
.cpn-form-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 18px 20px; }
@media (max-width: 900px) { .cpn-form-grid { grid-template-columns: 1fr; } }

.cpn-field { display: flex; flex-direction: column; gap: 8px; min-width: 0; }
.cpn-label { font-size: 0.85rem; font-weight: 600; color: var(--text-primary); }
.cpn-opt { color: var(--text-muted); font-weight: 500; font-size: 0.8rem; }

.cpn-input-wrap { position: relative; display: flex; align-items: center; }
.cpn-input-icon {
  position: absolute; left: 12px; display: flex; align-items: center; justify-content: center;
  color: var(--text-muted); font-weight: 700; pointer-events: none;
}
.cpn-input-icon-pct, .cpn-input-icon-hash { font-size: 0.95rem; }
.cpn-input {
  width: 100%; box-sizing: border-box;
  background: var(--bg-primary); border: 1px solid var(--border);
  border-radius: var(--radius-sm); color: var(--text-primary);
  padding: 11px 14px 11px 38px; font-size: 0.9rem; font-family: inherit;
  transition: border-color 150ms, box-shadow 150ms;
}
.cpn-input::placeholder { color: var(--text-muted); }
.cpn-input:focus { outline: none; border-color: var(--accent); box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent) 18%, transparent); }
.cpn-input:disabled { opacity: 0.5; cursor: not-allowed; }
.cpn-input-suffix {
  position: absolute; right: 1px; top: 1px; bottom: 1px; width: 40px;
  display: flex; align-items: center; justify-content: center;
  color: var(--text-secondary); font-weight: 700; font-size: 0.9rem;
  border-left: 1px solid var(--border); background: var(--bg-tertiary);
  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
}
.cpn-select {
  appearance: none; -webkit-appearance: none; cursor: pointer;
  padding-right: 34px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat; background-position: right 12px center;
}
.cpn-hint { margin: 0; font-size: 0.78rem; color: var(--text-muted); }

/* additional options box */
.cpn-options { margin-top: 22px; border: 1px solid var(--border); border-radius: var(--radius-md); padding: 18px 20px; background: color-mix(in srgb, var(--bg-primary) 55%, transparent); }
.cpn-options-head { display: flex; align-items: center; gap: 8px; font-size: 0.88rem; font-weight: 700; color: var(--text-primary); margin-bottom: 16px; }
.cpn-options-icon { display: inline-flex; color: var(--text-secondary); }
.cpn-options-row { display: flex; align-items: flex-start; gap: 32px; flex-wrap: wrap; }
.cpn-option-group { display: flex; flex-direction: column; gap: 8px; }
.cpn-option-label { font-size: 0.82rem; font-weight: 600; color: var(--text-secondary); }
.cpn-options-hint { margin: 4px 0 0; font-size: 0.78rem; color: var(--text-muted); max-width: 260px; }

/* Segmented toggle (Status, Usage Limit).
   \`display: flex\` + a shared min-width rather than \`inline-flex\`, because
   .cpn-option-group is a stretch-aligned flex column: an inline-flex segment
   inherited whatever width the widest sibling had. Under "Usage Limit" that
   sibling is the 260px hint, so the control stretched but its two buttons
   stayed content-sized, leaving dead space to the right of "Limited" while
   the "Status" pair beside it hugged its content. The two controls therefore
   rendered at different widths on the same row.
   The min-width pins both segments to one size, and \`flex: 1\` below splits
   each into equal halves, so either option reads as one half of a toggle
   whichever is active. */
.cpn-segment {
  display: flex;
  min-width: 240px;
  background: var(--bg-primary); border: 1px solid var(--border);
  border-radius: var(--radius-sm); padding: 3px; gap: 3px;
}
.cpn-segment button {
  flex: 1 1;
  border: none; background: transparent; color: var(--text-secondary);
  padding: 6px 16px; font-size: 0.82rem; font-weight: 600; border-radius: calc(var(--radius-sm) - 4px);
  cursor: pointer; transition: background 150ms, color 150ms; font-family: inherit;
  white-space: nowrap;
}
.cpn-segment button.active { background: color-mix(in srgb, var(--accent) 22%, transparent); color: var(--accent); }
:root[data-theme="light"] .cpn-segment button.active { background: var(--accent); color: var(--color-text-on-secondary); }

/* Below the min-width the segment would push the options card wider than the
   viewport, so let it collapse to the column instead. */
@media (max-width: 520px) {
  .cpn-segment { min-width: 0; width: 100%; }
}

.cpn-submit {
  margin-left: auto; align-self: center;
  display: inline-flex; align-items: center; gap: 8px;
  background: var(--accent); border: none; color: var(--color-text-on-secondary);
  border-radius: var(--radius-sm); padding: 12px 24px; font-size: 0.9rem; font-weight: 700; cursor: pointer;
  transition: background 150ms; font-family: inherit;
}
.cpn-submit:hover { background: var(--accent-hover); }

/* All coupons list tools */
.cpn-card-head-list { align-items: center; }
.cpn-card-head-left { display: flex; align-items: center; gap: 12px; }
.cpn-list-tools { margin-left: auto; display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.cpn-search { position: relative; display: flex; align-items: center; }
.cpn-search svg { position: absolute; left: 11px; color: var(--text-muted); pointer-events: none; }
.cpn-search input {
  background: var(--bg-primary); border: 1px solid var(--border); border-radius: var(--radius-sm);
  color: var(--text-primary); padding: 8px 12px 8px 32px; font-size: 0.85rem; width: 200px; font-family: inherit;
}
.cpn-search input::placeholder { color: var(--text-muted); }
.cpn-search input:focus { outline: none; border-color: var(--accent); }
.cpn-sort {
  appearance: none; -webkit-appearance: none; cursor: pointer;
  background: var(--bg-primary); border: 1px solid var(--border); border-radius: var(--radius-sm);
  color: var(--text-secondary); padding: 8px 30px 8px 12px; font-size: 0.82rem; font-weight: 600; font-family: inherit;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat; background-position: right 11px center;
}
.cpn-filter-btn {
  display: inline-flex; align-items: center; gap: 7px;
  background: var(--bg-primary); border: 1px solid var(--border); border-radius: var(--radius-sm);
  color: var(--text-secondary); padding: 8px 14px; font-size: 0.82rem; font-weight: 600; cursor: pointer; font-family: inherit;
}
.cpn-filter-btn:hover { background: var(--bg-tertiary); }
.cpn-filter-btn.active { border-color: var(--accent); color: var(--accent); }

/* table */
.cpn-table-wrap { border: 1px solid var(--border); border-radius: var(--radius-md); overflow: hidden; }
.cpn-table-header, .cpn-row {
  display: grid;
  grid-template-columns: 120px 110px 120px 100px 90px 120px 110px minmax(250px, 1fr);
  gap: 14px;
  align-items: center;
  padding: 13px 18px;
}
.cpn-table-header {
  background: var(--bg-tertiary);
  font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em;
  color: var(--text-muted); border-bottom: 1px solid var(--border);
}
.cpn-row { border-bottom: 1px solid var(--border); font-size: 0.88rem; transition: background 150ms; }
.cpn-row:last-child { border-bottom: none; }
.cpn-row:hover { background: color-mix(in srgb, var(--bg-tertiary) 55%, transparent); }
.cpn-row-editing { background: color-mix(in srgb, var(--accent) 8%, transparent); box-shadow: inset 3px 0 0 var(--accent); }

.cpn-code {
  display: inline-block; font-family: 'Courier New', monospace; font-weight: 700; letter-spacing: 0.05em;
  color: #a5b4fc; background: color-mix(in srgb, var(--color-secondary) 15%, transparent);
  border: 1px solid color-mix(in srgb, var(--color-secondary) 30%, transparent);
  border-radius: var(--radius-xs); padding: 4px 9px; font-size: 0.82rem;
}
.cpn-type { color: var(--text-secondary); }
.cpn-discount { font-weight: 700; color: var(--text-primary); }
.cpn-muted { color: var(--text-secondary); }
.cpn-status {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 4px 11px; border-radius: var(--radius-pill); font-size: 0.78rem; font-weight: 700;
}
.cpn-status-dot { width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0; }

.cpn-actions { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.cpn-act {
  display: inline-flex; align-items: center; gap: 5px;
  background: transparent; border: 1px solid var(--border); border-radius: var(--radius-sm);
  padding: 6px 12px; font-size: 0.8rem; font-weight: 600; cursor: pointer; font-family: inherit;
  color: var(--text-secondary); transition: background 150ms, border-color 150ms, color 150ms;
}
.cpn-act-edit { color: var(--color-secondary); border-color: color-mix(in srgb, var(--color-secondary) 40%, transparent); }
.cpn-act-edit:hover { background: color-mix(in srgb, var(--color-secondary) 14%, transparent); }
.cpn-act-toggle { color: var(--color-primary); border-color: color-mix(in srgb, var(--color-primary) 40%, transparent); }
.cpn-act-toggle:hover { background: color-mix(in srgb, var(--color-primary) 14%, transparent); }
.cpn-act-delete { color: var(--color-primary); border-color: color-mix(in srgb, var(--color-primary) 40%, transparent); }
.cpn-act-delete:hover { background: color-mix(in srgb, var(--color-primary) 14%, transparent); }

@media (max-width: 1100px) {
  .cpn-table-wrap { overflow-x: auto; }
  .cpn-table-header, .cpn-row { min-width: 920px; }
}

/* ── Related Products ─────────────────────────────────────────── */
.related-products {
  margin-top: 48px;
  padding-top: 32px;
  border-top: 1px solid var(--border);
}

.related-products h2 {
  font-size: 1.3rem;
  font-weight: 700;
  margin: 0 0 20px;
  color: var(--text-primary);
}

.related-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: var(--space-2);
}

.related-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  overflow: hidden;
  cursor: pointer;
  transition: transform 200ms ease, box-shadow 200ms ease;
  box-shadow: var(--shadow-card);
}

.related-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(1, 13, 33, 0.12);
}

.related-card img {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

.related-card-body {
  padding: 12px;
}

.related-card-body h4 {
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0 0 4px;
  color: var(--text-primary);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.related-card-body .related-price {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--accent);
  margin: 0 0 8px;
}

.related-card-body .btn {
  width: 100%;
  padding: 7px;
  font-size: 0.82rem;
}

/* ═══════════════════════════════════════════════════════════
   PRODUCT DETAIL — RICH PAGE
   ═══════════════════════════════════════════════════════════ */

/* 360° image wrap & trigger button */
.detail-image-wrap {
  position: relative;
  border-radius: var(--radius-lg);
  overflow: hidden;
  background: var(--bg-tertiary);
}

.detail-image-wrap img {
  width: 100%;
  display: block;
  border-radius: var(--radius-lg);
}

.view-360-btn {
  position: absolute;
  bottom: 14px;
  right: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(1, 13, 33, 0.7);
  color: var(--color-brand-white);
  border: 1.5px solid rgba(255,255,255,0.3);
  border-radius: var(--radius-xl);
  padding: 7px 14px;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  backdrop-filter: blur(6px);
  transition: background 200ms;
}

.view-360-btn:hover {
  background: rgba(59, 130, 246, 0.85);
}

.btn-360-icon {
  font-weight: 800;
  font-size: 0.9rem;
  letter-spacing: -0.5px;
}

/* Feature chips row (below product name) */
.feature-chips-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 10px 0;
}

.feature-chip {
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  padding: 4px 10px;
  font-size: 0.78rem;
  color: var(--text-secondary);
  white-space: nowrap;
}

.feature-chip strong {
  color: var(--text-primary);
  margin-left: 3px;
}

/* 3 Buy action buttons */
.buy-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
}

.buy-add-cart {
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border: 2px solid var(--accent);
}

.buy-add-cart:hover:not(:disabled) {
  background: var(--accent);
  color: var(--color-text-on-secondary);
}

.buy-now {
  background: var(--color-primary);
  color: var(--text-primary);
  border: none;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.buy-now:hover:not(:disabled) {
  background: var(--color-primary);
  color: var(--color-text-on-primary);
}

/* ── 360° Viewer Modal ──────────────────────────────────── */
.modal360-overlay {
  position: fixed;
  inset: 0;
  background: rgba(1, 13, 33, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
}

.modal360-box {
  background: var(--bg-secondary);
  border-radius: var(--radius-xl);
  padding: 28px;
  width: 100%;
  max-width: 500px;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}

.modal360-close {
  position: absolute;
  top: 14px;
  right: 18px;
  background: none;
  border: none;
  font-size: 1.6rem;
  cursor: pointer;
  color: var(--text-secondary);
  line-height: 1;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal360-title {
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0 0 4px;
}

.modal360-hint {
  font-size: 0.82rem;
  color: var(--text-tertiary);
  margin: 0 0 16px;
}

.modal360-stage {
  background: var(--bg-tertiary);
  border-radius: var(--radius-md);
  overflow: hidden;
  position: relative;
  cursor: grab;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal360-stage.dragging {
  cursor: grabbing;
}

.modal360-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  pointer-events: none;
  transition: transform 0.04s linear;
}

.modal360-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background: rgba(1, 13, 33,0.55);
  color: var(--color-brand-white);
  font-size: 0.78rem;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: var(--radius-sm);
  letter-spacing: 0.05em;
  backdrop-filter: blur(4px);
}

.modal360-track {
  position: relative;
  height: 4px;
  background: var(--border);
  border-radius: var(--radius-xs);
  margin: 12px 0 16px;
  overflow: visible;
}

.modal360-thumb {
  position: absolute;
  top: -5px;
  width: 14px;
  height: 14px;
  background: var(--accent);
  border-radius: 50%;
  transform: translateX(-50%);
  transition: left 0.04s linear;
  pointer-events: none;
}

.modal360-actions {
  display: flex;
  gap: 10px;
}

.modal360-actions .btn {
  flex: 1 1;
  padding: 9px;
  font-size: 0.88rem;
}

/* ── Product Highlights ─────────────────────────────────── */
.product-highlights {
  margin-top: 40px;
  padding: 28px 30px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-card);
}

.product-highlights h2 {
  font-size: 1.15rem;
  font-weight: 700;
  margin: 0 0 20px;
  color: var(--text-primary);
}

.highlights-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 12px;
}

.highlight-item {
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--bg-tertiary);
  border-radius: var(--radius-sm);
  padding: 12px 14px;
  border: 1px solid var(--border);
}

.highlight-icon {
  font-size: 1.4rem;
  width: 36px;
  height: 36px;
  background: var(--bg-secondary);
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.highlight-text {
  font-size: 0.88rem;
  font-weight: 500;
  color: var(--text-primary);
  line-height: 1.3;
}

/* ── Spec / Warranty / Manufacturer Tabs ────────────────── */
.product-tabs-section {
  margin-top: 32px;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  overflow: hidden;
  background: var(--bg-secondary);
  box-shadow: var(--shadow-card);
}

.product-tabs {
  display: flex;
  border-bottom: 1px solid var(--border);
  background: var(--bg-tertiary);
  overflow-x: auto;
}

.tab-btn {
  padding: 14px 24px;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  color: var(--text-secondary);
  white-space: nowrap;
  transition: color 200ms, border-color 200ms;
  margin-bottom: -1px;
}

.tab-btn:hover {
  color: var(--text-primary);
}

.tab-btn.active {
  color: var(--accent);
  border-bottom-color: var(--accent);
  background: var(--bg-secondary);
}

.tab-content {
  padding: 24px 28px;
}

/* Specs */
.specs-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: var(--space-3);
}

.spec-group-title {
  font-size: 0.88rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--accent);
  margin: 0 0 10px;
}

.spec-table {
  width: 100%;
  border-collapse: collapse;
}

.spec-table tr:not(:last-child) td {
  border-bottom: 1px solid var(--border);
}

.spec-key {
  padding: 8px 0;
  font-size: 0.85rem;
  color: var(--text-secondary);
  width: 45%;
  vertical-align: top;
}

.spec-val {
  padding: 8px 0 8px 12px;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--text-primary);
}

/* Warranty */
.warranty-box {
  display: flex;
  gap: 18px;
  align-items: flex-start;
}

.warranty-icon {
  font-size: 2.5rem;
  flex-shrink: 0;
  margin-top: 2px;
}

.warranty-box p {
  font-size: 0.92rem;
  line-height: 1.7;
  color: var(--text-secondary);
  margin: 0;
}

/* Manufacturer */
.manufacturer-box h4 {
  font-size: 1.05rem;
  font-weight: 700;
  margin: 0 0 16px;
  color: var(--text-primary);
}

.mfr-row {
  display: flex;
  gap: 14px;
  padding: 10px 0;
  border-bottom: 1px solid var(--border);
  font-size: 0.88rem;
}

.mfr-row:last-child {
  border-bottom: none;
}

.mfr-row span:first-child {
  width: 110px;
  flex-shrink: 0;
  color: var(--text-secondary);
  font-weight: 500;
}

.mfr-row span:last-child {
  color: var(--text-primary);
}

/* ── Feature Rating Bars ────────────────────────────────── */
.feature-rating-bars {
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 20px 22px;
  margin-bottom: 24px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 12px 24px;
  box-shadow: var(--shadow-card);
}

.fr-bar-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.fr-label {
  font-size: 0.82rem;
  color: var(--text-secondary);
  min-width: 110px;
  flex-shrink: 0;
}

.fr-track {
  flex: 1 1;
  height: 6px;
  background: var(--border);
  border-radius: var(--radius-xs);
  overflow: hidden;
}

.fr-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--accent), var(--success));
  border-radius: var(--radius-xs);
  transition: width 600ms ease;
}

.fr-value {
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--text-primary);
  min-width: 38px;
  text-align: right;
  white-space: nowrap;
}

/* ═══════════════════════════════════════════════════════════
   HERO CAROUSEL  — Flipkart-style multi-card layout
   ═══════════════════════════════════════════════════════════ */

.hero-carousel {
  background: var(--bg-tertiary);
  -webkit-user-select: none;
          user-select: none;
  padding: 8px 0 0;
}

/* Branded welcome hero shown when no admin banners are configured, so the
   homepage never opens on a bare category bar. Deep-blue brand gradient with
   white text -- reads the same in light and dark themes. */
.hero-fallback {
  margin: 8px 20px 0;
  border-radius: 16px;
  background: linear-gradient(120deg, var(--color-brand-navy) 0%, #1e63c4 55%, var(--color-secondary) 100%);
  color: var(--color-brand-white);
  overflow: hidden;
  position: relative;
}
.hero-fallback::after {
  content: '';
  position: absolute;
  top: -40%; right: -10%;
  width: 380px; height: 380px;
  background: radial-gradient(circle, rgba(255,255,255,0.14) 0%, rgba(255,255,255,0) 70%);
  pointer-events: none;
}
.hero-fallback-inner {
  max-width: 1440px;
  margin: 0 auto;
  padding: 48px 32px;
  position: relative;
  z-index: 1;
}
.hero-fallback-title {
  margin: 0;
  font-size: clamp(1.5rem, 4vw, 2.4rem);
  font-weight: 800;
  letter-spacing: -0.02em;
}
.hero-fallback-sub {
  margin: 10px 0 0;
  font-size: clamp(0.9rem, 2vw, 1.05rem);
  max-width: 520px;
  opacity: 0.92;
}
.hero-fallback-cta {
  margin-top: 22px;
  background: var(--color-brand-white);
  color: var(--color-brand-navy);
  border: none;
  border-radius: 10px;
  padding: 12px 28px;
  font-weight: 700;
  font-size: 0.95rem;
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s;
  box-shadow: 0 6px 18px rgba(1, 13, 33,0.18);
}
.hero-fallback-cta:hover { transform: translateY(-2px); box-shadow: 0 10px 24px rgba(1, 13, 33,0.24); }

@media (max-width: 520px) {
  .hero-fallback-inner { padding: 36px 22px; }
}

/* Compact, clearly defined Banner editor. */
.admin-banner-editor-compact .admin-form-card {
  padding: 14px 16px 16px;
  margin-bottom: 14px;
}

.admin-banner-editor-compact .admin-form-header {
  margin-bottom: 12px;
}

.admin-banner-editor-compact .admin-form-header h2 {
  font-size: 22px;
}

.admin-banner-editor-compact .admin-banner-form-layout {
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: 14px;
}

.admin-banner-editor-compact .admin-pf-section {
  padding: 14px 16px;
  gap: 11px;
  margin-bottom: 11px;
  border-radius: 12px;
}

.admin-banner-editor-compact .admin-pf-section-title {
  font-size: 16px;
}

.admin-banner-editor-compact .admin-pf-row-2 {
  gap: 10px;
}

.admin-banner-editor-compact .admin-pf-field {
  gap: 5px;
}

.admin-banner-editor-compact .admin-pf-label {
  font-size: 13px;
}

.admin-banner-editor-compact .admin-pf-input,
.admin-banner-editor-compact .admin-pf-textarea,
.admin-banner-editor-compact .banner-feature-row input,
.admin-banner-editor-compact .color-hex {
  min-height: 40px;
  border: 1.5px solid var(--accent);
  border-radius: 9px;
  padding: 7px 11px;
  background: var(--bg-primary);
  box-sizing: border-box;
}

.admin-banner-editor-compact .admin-pf-textarea {
  min-height: 62px;
  max-height: 100px;
  line-height: 1.4;
}

.admin-banner-editor-compact .admin-pf-input:hover,
.admin-banner-editor-compact .admin-pf-textarea:hover,
.admin-banner-editor-compact .banner-feature-row input:hover,
.admin-banner-editor-compact .color-hex:hover {
  border-color: var(--accent-hover, var(--accent));
}

.admin-banner-editor-compact .admin-pf-input:focus,
.admin-banner-editor-compact .admin-pf-textarea:focus,
.admin-banner-editor-compact .banner-feature-row input:focus,
.admin-banner-editor-compact .color-hex:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent) 16%, transparent);
}

.admin-banner-editor-compact .admin-preview-card {
  padding: 12px;
  border-radius: 12px;
}

.admin-banner-editor-compact .admin-highlight-add {
  align-self: flex-start;
  background: var(--accent);
  border-color: var(--accent);
  color: var(--color-text-on-secondary);
  padding: 8px 14px;
  border-radius: 8px;
  font-weight: 700;
}

.admin-banner-editor-compact .admin-highlight-add:hover {
  background: var(--accent-hover, var(--accent));
  border-color: var(--accent-hover, var(--accent));
  color: var(--color-brand-white);
}

.admin-banner-editor-compact .admin-banner-image-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.admin-banner-editor-compact .admin-banner-upload-divider,
.admin-banner-editor-compact .admin-banner-upload-hint {
  color: var(--text-muted);
  font-size: 12px;
}

.admin-banner-editor-compact .admin-banner-upload-btn,
.admin-banner-editor-compact .admin-banner-image-remove {
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border-radius: 8px;
  padding: 7px 12px;
  font: inherit;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.admin-banner-editor-compact .admin-banner-upload-btn {
  color: var(--color-text-on-secondary);
  background: var(--accent);
  border: 1px solid var(--accent);
}

.admin-banner-editor-compact .admin-banner-upload-btn:hover {
  background: var(--accent-hover, var(--accent));
}

.admin-banner-editor-compact .admin-banner-upload-btn.uploading {
  cursor: wait;
  opacity: 0.7;
}

.admin-banner-editor-compact .admin-banner-image-remove {
  color: var(--color-primary);
  background: transparent;
  border: 1px solid var(--color-primary);
}

.admin-banner-editor-compact .admin-banner-image-remove:hover {
  color: var(--color-text-on-primary);
  background: var(--color-primary);
}

.admin-banner-editor-compact .admin-banner-list-card {
  width: 100%;
  min-width: 0;
  margin-top: 14px;
  padding: 14px 16px 16px;
  background: var(--bg-secondary);
  border: 1.5px solid var(--accent);
  border-radius: 13px;
  box-shadow: var(--shadow-card);
  box-sizing: border-box;
}

.admin-banner-editor-compact .admin-banner-list-head {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 12px;
}

.admin-banner-editor-compact .admin-banner-list-head h2 {
  margin: 0;
  color: var(--text-primary);
  font-size: 17px;
  font-weight: 750;
}

.admin-banner-editor-compact .admin-banner-list-icon {
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--accent);
  background: color-mix(in srgb, var(--accent) 12%, transparent);
  border-radius: 9px;
}

.admin-banner-editor-compact .admin-banner-count {
  min-width: 25px;
  height: 25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--accent);
  background: color-mix(in srgb, var(--accent) 12%, transparent);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 750;
}

.admin-banner-editor-compact .banners-list {
  gap: 8px;
}

.admin-banner-editor-compact .banner-list-row {
  display: grid;
  grid-template-columns: 68px minmax(0, 1fr) auto minmax(214px, auto);
  gap: 12px;
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid color-mix(in srgb, var(--accent) 45%, var(--border));
  border-radius: 10px;
  background: var(--bg-primary);
}

.admin-banner-editor-compact .banner-list-row:hover {
  border-color: var(--accent);
  background: color-mix(in srgb, var(--accent) 3%, var(--bg-primary));
}

.admin-banner-editor-compact .banner-list-swatch {
  width: 68px;
  height: 46px;
}

.admin-banner-editor-compact .banner-list-info {
  min-width: 0;
}

.admin-banner-editor-compact .banner-list-title,
.admin-banner-editor-compact .banner-list-sub {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.admin-banner-editor-compact .banner-list-meta {
  margin-top: 2px;
  gap: 5px;
}

.admin-banner-editor-compact .admin-row-actions {
  justify-content: flex-end;
  flex-wrap: nowrap;
  gap: 6px;
}

.admin-banner-editor-compact .admin-banner-action {
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 6px 10px;
  border-radius: 8px;
  white-space: nowrap;
}

.admin-banner-editor-compact .admin-banner-delete,
.admin-banner-editor-compact .admin-banner-delete:hover,
.admin-banner-editor-compact .admin-banner-delete:focus-visible {
  border: 1px solid var(--color-primary);
  background: var(--color-primary);
  color: var(--color-text-on-primary);
}

.admin-banner-editor-compact .admin-banner-pagination {
  justify-content: space-between;
  gap: 12px;
  padding: 14px 0 0;
  border-top: 1px solid color-mix(in srgb, var(--accent) 25%, var(--border));
  margin-top: 12px;
}

.admin-banner-editor-compact .admin-banner-page-range {
  color: var(--text-secondary);
  font-size: 12px;
}

.admin-banner-editor-compact .admin-banner-page-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.admin-banner-editor-compact .admin-banner-pagination .admin-page-btn {
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 11px;
  border-color: var(--accent);
  color: var(--accent);
}

@media (max-width: 850px) {
  .admin-banner-editor-compact .banner-list-row {
    grid-template-columns: 68px minmax(0, 1fr) auto;
  }

  .admin-banner-editor-compact .admin-row-actions {
    grid-column: 1 / -1;
    justify-content: flex-end;
  }
}

@media (max-width: 560px) {
  .admin-banner-editor-compact .admin-banner-list-card {
    padding: 12px;
  }

  .admin-banner-editor-compact .banner-list-row {
    grid-template-columns: 56px minmax(0, 1fr);
    gap: 9px;
  }

  .admin-banner-editor-compact .banner-list-swatch {
    width: 56px;
    height: 44px;
  }

  .admin-banner-editor-compact .banner-list-row > .coupon-active,
  .admin-banner-editor-compact .banner-list-row > .coupon-inactive {
    grid-column: 2;
    justify-self: start;
  }

  .admin-banner-editor-compact .admin-row-actions {
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .admin-banner-editor-compact .admin-banner-pagination {
    align-items: stretch;
    flex-direction: column;
  }

  .admin-banner-editor-compact .admin-banner-page-controls {
    justify-content: space-between;
  }
}

/* Careers overview and positions: fully contained, responsive, no x-scroll. */
.admin-section.admin-pf-card-v2 .admin-careers-grid {
  grid-template-columns: minmax(0, 1fr) minmax(300px, 350px);
}

.admin-section.admin-pf-card-v2 .admin-careers-grid .admin-pf-section {
  border: 1.5px solid color-mix(in srgb, var(--pf-primary) 42%, var(--pf-divider));
  overflow: hidden;
}

.admin-section.admin-pf-card-v2 .admin-table-toolbar {
  min-width: 0;
  gap: 10px;
  flex-wrap: wrap;
}

.admin-section.admin-pf-card-v2 .ov-period-btns {
  border: 1.5px solid var(--pf-primary);
  background: var(--pf-field-bg);
}

.admin-section.admin-pf-card-v2 .admin-careers-stat-tile {
  border: 1.5px solid color-mix(in srgb, var(--pf-primary) 32%, var(--pf-divider));
  background: var(--pf-field-bg);
  min-height: 138px;
  justify-content: flex-start;
  transition: border-color 160ms ease, transform 160ms ease, box-shadow 160ms ease;
}

.admin-section.admin-pf-card-v2 .admin-careers-stat-tile:hover {
  border-color: var(--pf-primary);
  transform: translateY(-1px);
  box-shadow: 0 5px 14px color-mix(in srgb, var(--pf-primary) 10%, transparent);
}

.admin-section.admin-pf-card-v2 .admin-careers-stat-label {
  min-height: 2.4em;
  line-height: 1.2;
}

.admin-section.admin-pf-card-v2 .admin-careers-stat-trend {
  line-height: 1.25;
  white-space: normal;
}

.admin-careers-positions-table {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden !important;
  box-sizing: border-box;
}

.admin-careers-positions-table .admin-table-header,
.admin-careers-positions-table .admin-product-row {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  grid-template-columns:
    minmax(145px, 1.4fr)
    minmax(92px, 0.9fr)
    minmax(78px, 0.72fr)
    minmax(72px, 0.68fr)
    minmax(72px, 0.65fr)
    104px;
  gap: 7px;
  padding-left: 10px;
  padding-right: 10px;
}

.admin-careers-positions-table .admin-table-header {
  font-size: 10px;
  letter-spacing: 0.035em;
}

.admin-careers-positions-table .admin-product-row > * {
  min-width: 0;
}

.admin-careers-positions-table .admin-product-title,
.admin-careers-positions-table .admin-career-department-cell,
.admin-careers-positions-table .admin-career-location-cell {
  overflow-wrap: anywhere;
  line-height: 1.25;
}

.admin-careers-positions-table .admin-category-chip {
  display: inline-flex;
  max-width: 100%;
  box-sizing: border-box;
  white-space: normal;
  text-align: center;
  line-height: 1.15;
}

.admin-careers-positions-table .admin-career-applications-cell {
  min-width: 0;
}

.admin-careers-positions-table .admin-career-actions-cell {
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
}

.admin-careers-positions-table .admin-career-actions-cell .btn-admin-edit {
  width: 30px;
  height: 30px;
  padding: 0 !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 30px;
}

.admin-careers-positions-table .admin-career-actions-cell .btn-admin-edit:last-child {
  color: var(--color-brand-white) !important;
  background: var(--color-primary);
  border-color: var(--color-primary) !important;
}

@media (max-width: 1250px) {
  .admin-section.admin-pf-card-v2 .admin-careers-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .admin-section.admin-pf-card-v2 .admin-careers-grid > div:last-child {
    position: static !important;
  }
}

@media (max-width: 760px) {
  .admin-careers-positions-table {
    border: 0;
    background: transparent;
  }

  .admin-careers-positions-table .admin-table-header {
    display: none;
  }

  .admin-careers-positions-table .admin-product-row {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px 14px;
    margin-bottom: 9px;
    padding: 12px;
    border: 1.5px solid color-mix(in srgb, var(--pf-primary) 35%, var(--pf-divider));
    border-radius: 10px;
    background: var(--pf-field-bg);
  }

  .admin-careers-positions-table .admin-career-position-cell,
  .admin-careers-positions-table .admin-career-actions-cell {
    grid-column: 1 / -1;
  }

  .admin-careers-positions-table .admin-career-actions-cell {
    justify-content: flex-start;
    padding-top: 2px;
  }
}

@media (max-width: 520px) {
  .admin-section.admin-pf-card-v2 .admin-careers-stats {
    grid-template-columns: minmax(0, 1fr);
  }

  .admin-section.admin-pf-card-v2 .admin-careers-stat-tile {
    min-height: 0;
  }

  .admin-careers-positions-table .admin-product-row {
    grid-template-columns: minmax(0, 1fr);
  }

  .admin-careers-positions-table .admin-career-position-cell,
  .admin-careers-positions-table .admin-career-actions-cell {
    grid-column: 1;
  }
}

.admin-banner-editor-compact .admin-banner-preview-card .carousel-slide {
  height: 205px;
}

@media (max-width: 1120px) {
  .admin-banner-editor-compact .admin-banner-form-layout {
    grid-template-columns: minmax(0, 1fr) 310px;
  }
}

@media (max-width: 900px) {
  .admin-banner-editor-compact .admin-banner-form-layout {
    grid-template-columns: minmax(0, 1fr);
  }

  .admin-banner-editor-compact .admin-preview-card {
    position: static;
  }
}

/* Wrapper holds the track + absolute arrows */
.carousel-track-outer {
  position: relative;
}

/* Horizontally scrollable track — 2 cards visible */
.carousel-track {
  display: flex;
  gap: var(--space-1);
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  padding: 0 8px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.carousel-track::-webkit-scrollbar { display: none; }

.carousel-slide {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc((100% - 16px) / 3);
  scroll-snap-align: start;
  height: 230px;
  border-radius: var(--radius-md);
  cursor: pointer;
  overflow: hidden;
  position: relative;
  box-shadow: 0 3px 12px rgba(1, 13, 33,0.16);
  transition: box-shadow 200ms, transform 200ms;
}

.carousel-slide::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 78% 55%, var(--glow, var(--color-brand-white)) 0%, transparent 62%);
  opacity: 0.25;
  pointer-events: none;
  z-index: 0;
}

/* Glossy diagonal sheen across the artwork */
.carousel-slide::after {
  content: '';
  position: absolute;
  top: -60%;
  left: -25%;
  width: 55%;
  height: 220%;
  background: linear-gradient(115deg, rgba(255,255,255,0.22) 0%, rgba(255,255,255,0) 65%);
  transform: rotate(8deg);
  z-index: 2;
  pointer-events: none;
}

.carousel-slide:hover {
  box-shadow: 0 8px 26px rgba(1, 13, 33,0.22);
  transform: translateY(-2px);
}

/* Image fills the entire card; a gradient overlay keeps the text legible */
.slide-bg-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
  transition: transform 400ms ease;
}

.carousel-slide:hover .slide-bg-img {
  transform: scale(1.05);
}

.slide-overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  background: linear-gradient(90deg, rgba(1, 13, 33,0.8) 0%, rgba(1, 13, 33,0.52) 45%, rgba(1, 13, 33,0.14) 100%);
  pointer-events: none;
}

.slide-inner {
  display: flex;
  align-items: center;
  height: 230px;
  padding: 0;
  position: relative;
}

.slide-content {
  position: relative;
  z-index: 2;
  color: var(--color-brand-white);
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 68%;
  padding: 20px 22px 18px;
  min-width: 0;
  text-shadow: 0 1px 4px rgba(1, 13, 33,0.35);
}

.slide-features {
  list-style: none;
  margin: 4px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.slide-feature-item {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 0.82rem;
  font-weight: 500;
  opacity: 0.92;
  line-height: 1.3;
}

.slide-feature-icon {
  font-size: 0.78rem;
  flex-shrink: 0;
  color: var(--color-primary);
}

.slide-discount-badge {
  position: absolute;
  right: 14px;
  bottom: 14px;
  z-index: 2;
  /* A solid orange pill with a navy label, matching every other discount pill
     in the app. Orange text on a translucent navy scrim measured 1.5:1 over
     light banner artwork -- the scrim can't guarantee a background when the
     image underneath is unknown, so the pill supplies its own. */
  background: var(--color-primary);
  padding: 6px 14px;
  border-radius: var(--radius-xl);
  font-size: 0.8rem;
  font-weight: 800;
  color: var(--color-text-on-primary);
}

/* Promotional label -- orange fill, navy text. The per-banner badgeColor that
   used to drive this is no longer applied to any text or control (see
   BannerSlide.js); it only tints the ambient --glow behind the artwork now. */
.slide-badge {
  display: inline-block;
  padding: 4px 11px;
  border-radius: var(--radius-xl);
  font-size: 0.74rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: var(--color-primary);
  color: var(--color-text-on-primary);
  width: fit-content;
  margin-bottom: 3px;
}

.slide-brand {
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  opacity: 0.7;
  margin-bottom: 2px;
}

h2.slide-title {
  font-size: 1.55rem;
  font-weight: 800;
  line-height: 1.18;
  margin: 0;
  color: inherit;
}

.slide-subtitle {
  font-size: 0.94rem;
  font-weight: 600;
  margin: 0;
  color: var(--color-primary);
  opacity: 0.95;
  line-height: 1.3;
}

.slide-body {
  font-size: 0.85rem;
  line-height: 1.45;
  margin: 0;
  opacity: 0.78;
}

/* CTA pushed to bottom */
.slide-cta {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-top: auto;
  padding: 9px 18px;
  border-radius: var(--radius-xl);
  font-size: 0.86rem;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: transform 180ms, opacity 180ms;
  width: fit-content;
}

.slide-cta:hover {
  transform: translateY(-1px);
  opacity: 0.9;
}

/* Fixed white pill over banner artwork -- the label must be a fixed navy, not
   --text-primary, which flips to white in dark mode and made this button read
   as an empty white rectangle. */
.slide-cta-light { background: var(--color-brand-white); color: var(--color-brand-navy); }
.slide-cta-dark  { background: rgba(1, 13, 33,0.72); color: var(--color-brand-white); }

.slide-cta-arrow {
  font-size: 1.02rem;
  transition: transform 180ms;
}

.slide-cta:hover .slide-cta-arrow { transform: translateX(3px); }


/* Arrows — positioned over the track */
.carousel-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255,255,255,0.92);
  border: 1px solid var(--border-strong);
  color: #555;
  font-size: 1.8rem;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: box-shadow 150ms, background 150ms;
  z-index: 10;
  line-height: 1;
  padding-bottom: 2px;
  box-shadow: 0 2px 8px rgba(1, 13, 33,0.14);
}

.carousel-arrow:hover {
  background: var(--color-brand-white);
  box-shadow: 0 4px 16px rgba(1, 13, 33,0.22);
}

.carousel-arrow-left  { left: 4px; }
.carousel-arrow-right { right: 4px; }

/* Dots — below the track in normal flow */
/* 16px gap, not 6px: the dot itself stays 8px, but each one carries a 24px
   invisible hit area (see .carousel-dot::after) and two 24px targets can't
   sit closer than 24px apart without overlapping -- tapping "next" would
   land on the dot beside it. 8 + 16 = 24px centre to centre, exactly
   touching, which is the tightest they can legally pack. */
.carousel-dots {
  display: flex;
  justify-content: center;
  gap: 16px;
  padding: 8px 0 6px;
}

.carousel-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #c0c0c0;
  border: none;
  cursor: pointer;
  transition: background 220ms, width 220ms;
  padding: 0;
  position: relative;
}
/* An 8px button is a third of the 24px minimum tap target. Rather than
   inflate the dot -- these read as dots precisely because they're small --
   extend only the touchable area, centred on the dot and invisible. */
.carousel-dot::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 24px;
  height: 24px;
  transform: translate(-50%, -50%);
}

.carousel-dot.active {
  background: var(--color-secondary);
  width: 20px;
  border-radius: var(--radius-xs);
}

/* Tablet: 2 cards */
@media (max-width: 900px) {
  .carousel-slide {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc((100% - 8px) / 2);
    height: 210px;
  }

  .slide-inner { height: 210px; }
  .slide-content { max-width: 78%; }
}

/* Mobile: 1 card */
@media (max-width: 600px) {
  .carousel-slide {
    flex: 0 0 88%;
    height: 185px;
  }

  .slide-inner { height: 185px; }
  .slide-content { max-width: 88%; }

  .slide-title   { font-size: 1.15rem; }
  .slide-body    { display: none; }

  .carousel-arrow {
    width: 28px;
    height: 28px;
    font-size: 1.3rem;
  }
}

/* ═══════════════════════════════════════════════════════════
   ADMIN — BANNERS TAB
   ═══════════════════════════════════════════════════════════ */

.banner-form {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin-bottom: 32px;
}

.color-input-wrap {
  display: flex;
  align-items: center;
  gap: var(--space-1);
}

.color-input-wrap input[type="color"] {
  width: 40px;
  height: 38px;
  padding: 2px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-xs);
  cursor: pointer;
  flex-shrink: 0;
}

.color-hex {
  flex: 1 1;
  font-family: 'Courier New', monospace;
  font-size: 0.82rem;
}

/* Banners list */
.banners-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.banner-list-row {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 12px 16px;
  transition: opacity 200ms;
}

.banner-list-row.banner-inactive {
  opacity: 0.55;
}

.banner-list-swatch {
  width: 72px;
  height: 50px;
  border-radius: var(--radius-sm);
  flex-shrink: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-list-swatch img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-list-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.banner-list-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--text-primary);
}

.banner-list-sub {
  font-size: 0.8rem;
  color: var(--text-secondary);
}

.banner-list-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
}

.banner-badge-chip {
  font-size: 0.68rem;
  font-weight: 700;
  color: var(--color-brand-white);
  padding: 2px 7px;
  border-radius: var(--radius-sm);
  letter-spacing: 0.05em;
}

.banner-link-chip,
.banner-order-chip {
  font-size: 0.72rem;
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-radius: var(--radius-xs);
  padding: 2px 7px;
  color: var(--text-secondary);
}

.banner-list-status {
  flex-shrink: 0;
}

/* ══════════════════════════════════════════════════════════════
   ANIMATION SYSTEM
   ══════════════════════════════════════════════════════════════ */

/* ── Keyframe library ──────────────────────────────────────────*/
@keyframes fade-up {
  from { opacity: 0; transform: translateY(22px); }
  to   { opacity: 1; transform: translateY(0); }
}

@keyframes fade-in {
  from { opacity: 0; }
  to   { opacity: 1; }
}

@keyframes scale-in {
  from { opacity: 0; transform: scale(0.92) translateY(16px); }
  to   { opacity: 1; transform: scale(1)    translateY(0); }
}

@keyframes slide-down {
  from { opacity: 0; transform: translateY(-16px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* Opacity-only card entrance (avoids conflict with hover transform) */
@keyframes card-appear {
  from { opacity: 0; }
  to   { opacity: 1; }
}

@keyframes badge-pop {
  0%   { transform: scale(1); }
  35%  { transform: scale(1.55); }
  65%  { transform: scale(0.86); }
  100% { transform: scale(1); }
}

@keyframes pulse-ring {
  0%   { box-shadow: 0 0 0 0   rgba(59, 130, 246, 0.55); }
  70%  { box-shadow: 0 0 0 10px rgba(59, 130, 246, 0);   }
  100% { box-shadow: 0 0 0 0   rgba(59, 130, 246, 0);   }
}

/* ── Topbar ─────────────────────────────────────────────────── */
.topbar {
  transition: box-shadow 280ms var(--ease-in-out) !important;
}

.is-scrolled .topbar {
  box-shadow: 0 2px 20px rgba(1, 13, 33, 0.09);
}

[data-theme="dark"] .is-scrolled .topbar {
  box-shadow: 0 2px 20px rgba(1, 13, 33, 0.45);
}

/* ── Auth gate entrance ──────────────────────────────────────── */
.auth-gate-box {
  animation: scale-in 400ms var(--ease-spring) both;
}

/* ── Product card stagger (opacity-only — no transform conflict) */
.product-card { animation: card-appear 380ms ease both; }
.product-card:nth-child(1) { animation-delay:   0ms; }
.product-card:nth-child(2) { animation-delay:  55ms; }
.product-card:nth-child(3) { animation-delay: 110ms; }
.product-card:nth-child(4) { animation-delay: 165ms; }
.product-card:nth-child(5) { animation-delay: 220ms; }
.product-card:nth-child(6) { animation-delay: 275ms; }
.product-card:nth-child(7) { animation-delay: 330ms; }
.product-card:nth-child(8) { animation-delay: 385ms; }

/* ── Checkout containers ─────────────────────────────────────── */
.checkout-steps {
  animation: fade-up var(--dur-slow) var(--ease-out-expo) both;
}

.order-summary-container {
  animation: fade-up var(--dur-slow) var(--ease-out-expo) 70ms both;
}

.cod-payment-section {
  animation: fade-up var(--dur-slow) var(--ease-out-expo) 70ms both;
}

.price-details {
  animation: fade-up var(--dur-slow) var(--ease-out-expo) 120ms both;
  box-shadow: var(--shadow-card);
}

/* ── Order items stagger ─────────────────────────────────────── */
.fi-item { animation: fade-up 320ms var(--ease-out-expo) both; 
  box-shadow: var(--shadow-card);
}
.fi-item:nth-child(1) { animation-delay:  0ms; }
.fi-item:nth-child(2) { animation-delay: 70ms; }
.fi-item:nth-child(3) { animation-delay: 140ms; }

/* ── Alert / toast entrance ──────────────────────────────────── */
.alert {
  animation: slide-down 260ms var(--ease-out-expo) both;
}

/* ── Cart panel ──────────────────────────────────────────────── */
.cart-panel {
  animation: fade-up 380ms var(--ease-out-expo) 80ms both;
}

/* ── Cart badge pop ──────────────────────────────────────────── */
.cart-badge {
  transition: transform 300ms var(--ease-spring) !important;
}

/* ── Checkout step number: pulse on active ───────────────────── */
.step.active .step-number {
  animation: pulse-ring 2s ease-out infinite;
}

/* ── User dropdown slide-in ──────────────────────────────────── */
.user-dropdown {
  animation: scale-in 200ms var(--ease-out-expo) both;
  transform-origin: top right;
}

/* ── Button press (active state) ─────────────────────────────── */
.btn:not(:disabled):active,
.submit:not(:disabled):active,
.btn-place-order:not(:disabled):active,
.fi-action-btn:active,
.btn-icon-text:active,
.category-icon-btn:active {
  transform: scale(0.95) !important;
  transition-duration: 70ms !important;
}

/* ── Carousel arrows spring ──────────────────────────────────── */
.carousel-arrow {
  transition: background 180ms ease, box-shadow 220ms var(--ease-spring),
              transform 220ms var(--ease-spring) !important;
}

.carousel-arrow:hover {
  transform: translateY(-50%) scale(1.14) !important;
}

/* ── Carousel dot expand ─────────────────────────────────────── */
.carousel-dot {
  transition: background 220ms ease, width 300ms var(--ease-spring) !important;
}

/* ── Category pill scale ─────────────────────────────────────── */
.category-icon-btn {
  transition: background 180ms ease, color 180ms ease,
              transform 220ms var(--ease-spring) !important;
}

.category-icon-btn.active  { transform: scale(1.06); }
.category-icon-btn:hover:not(.active) { transform: scale(1.03); }

/* ── KPI admin cards ─────────────────────────────────────────── */
.kpi-card {
  transition: transform 280ms var(--ease-out-expo),
              box-shadow 280ms var(--ease-out-expo) !important;
}
.kpi-card:hover {
  transform: translateY(-4px) !important;
  box-shadow: 0 12px 32px rgba(1, 13, 33, 0.13) !important;
}

/* ── Form input focus spring ─────────────────────────────────── */
input:not([type="checkbox"]):not([type="radio"]):not([type="range"]),
select,
textarea {
  transition: border-color 180ms ease, box-shadow 220ms var(--ease-spring),
              transform 200ms var(--ease-spring) !important;
}

input:not([type="checkbox"]):not([type="radio"]):not([type="range"]):focus,
select:focus,
textarea:focus {
  transform: scale(1.008);
}

/* ── Wishlist heart pop on click ─────────────────────────────── */
.card-wishlist:active {
  animation: badge-pop 300ms var(--ease-spring) both !important;
}

/* ── Honour "prefer reduced motion" ─────────────────────────── */
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}

/* ═══════════════════════════════════════════════════════════════
   DATAFLOW-STYLE OVERVIEW TAB
   ═══════════════════════════════════════════════════════════════ */

/* ── Root container ──────────────────────────────────────────── */
.ov-root {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Shown when the period analytics fetch fails. Every secondary figure on the
   Overview falls back to 0 when that request doesn't land, so without a
   visible banner a failed load is indistinguishable from a genuinely quiet
   trading period. */
.ov-period-error {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(255, 103, 0, 0.08);
  border: 1px solid rgba(255, 103, 0, 0.28);
  color: var(--color-primary);
  font-size: 0.86rem;
  font-weight: 500;
}
.ov-period-error span { flex: 1 1; min-width: 0; }
.ov-period-error button {
  flex-shrink: 0;
  padding: 6px 14px;
  border-radius: 8px;
  border: 1px solid rgba(255, 103, 0, 0.4);
  background: transparent;
  color: inherit;
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
}
.ov-period-error button:hover:not(:disabled) { background: rgba(255, 103, 0, 0.12); }
.ov-period-error button:disabled { opacity: 0.55; cursor: not-allowed; }
:root[data-theme="dark"] .ov-period-error { color: var(--color-primary-soft); }

/* ── Generic overview card ───────────────────────────────────── */
.ov-card {
  background: linear-gradient(155deg, rgba(255,255,255,0.07) 0%, rgba(255,255,255,0) 42%), color-mix(in srgb, var(--bg-secondary) 82%, transparent);
  backdrop-filter: blur(20px) saturate(160%);
  -webkit-backdrop-filter: blur(20px) saturate(160%);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 20px 22px;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.05), var(--shadow-card);
}
.ov-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 12px;
}
.ov-card-header > div:first-child {
  flex: 1 1;
  min-width: 0;
}
.ov-card-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 4px;
}
.ov-card-sub {
  font-size: 0.78rem;
  color: var(--text-muted);
  margin: 0;
}

/* ── KPI Spark 2×2 grid ──────────────────────────────────────── */
.kpi-spark-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: var(--space-2);
}
@media (max-width: 1100px) { .kpi-spark-grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 640px)  { .kpi-spark-grid { grid-template-columns: 1fr; } }

.kpi-spark-card {
  background: linear-gradient(155deg, rgba(255,255,255,0.07) 0%, rgba(255,255,255,0) 42%), color-mix(in srgb, var(--bg-secondary) 82%, transparent);
  backdrop-filter: blur(20px) saturate(160%);
  -webkit-backdrop-filter: blur(20px) saturate(160%);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 18px 18px 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow: hidden;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.05), var(--shadow-card);
}

.ksc-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 8px;
}
.ksc-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
.ksc-icon {
  width: 36px;
  height: 36px;
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.92;
  flex-shrink: 0;
}
.ksc-icon-inner { font-size: 1rem; line-height: 1; }
.ksc-label {
  font-size: 0.78rem;
  color: var(--text-muted);
  margin: 0 0 3px;
  font-weight: 500;
}
.ksc-trend {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: var(--radius-xl);
}
.ksc-up   { background: var(--color-secondary-soft); color: var(--color-secondary); }
.ksc-down { background: var(--color-primary-soft); color: var(--color-primary); }
.ksc-trend-arrow { font-size: 0.85em; }
.ksc-period {
  font-size: 0.7rem;
  color: var(--text-muted);
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  padding: 2px 8px;
  border-radius: var(--radius-xl);
  white-space: nowrap;
}
.ksc-value {
  font-size: 1.55rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 4px 0 2px;
  line-height: 1.1;
}
.ksc-sub {
  font-size: 0.76rem;
  color: var(--text-muted);
  margin: 0 0 2px;
  font-weight: 500;
}
.ksc-chart { margin: 4px -4px 0; }

/* ── Traffic clarity notes ───────────────────────────────────── */
.traffic-note {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 16px;
  padding: 12px 16px;
  background: color-mix(in srgb, var(--accent) 8%, var(--bg-secondary));
  border: 1px solid color-mix(in srgb, var(--accent) 30%, var(--border));
  border-radius: var(--radius-md);
}
.traffic-note-icon { display: inline-flex; color: var(--accent); flex-shrink: 0; margin-top: 1px; }
.traffic-note-text { margin: 0; font-size: 0.83rem; color: var(--text-secondary); line-height: 1.5; }
.traffic-note-text strong { color: var(--text-primary); }

.traffic-unknown-info {
  display: inline-flex; align-items: center; color: var(--text-muted); cursor: help;
}
.traffic-unknown-info:hover, .traffic-unknown-info:focus { color: var(--accent); outline: none; }
.traffic-unknown-note {
  display: flex; align-items: flex-start; gap: 7px;
  margin: 14px 0 0; padding-top: 12px; border-top: 1px dashed var(--border);
  font-size: 0.78rem; color: var(--text-muted); line-height: 1.5;
}
.traffic-unknown-note svg { flex-shrink: 0; margin-top: 2px; }
.traffic-unknown-note strong { color: var(--text-secondary); }

/* ── Revenue chart card ──────────────────────────────────────── */
.ov-revenue-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 22px 24px 16px;
  box-shadow: var(--shadow-card);
}

/* stat row (Revenue | Orders) below header */
.rev-stat-row {
  display: flex;
  align-items: center;
  gap: 0;
  margin-bottom: 20px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  overflow: hidden;
}
.rev-stat-block {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  padding: 14px 20px;
}
.rev-stat-indicator {
  width: 4px;
  height: 36px;
  border-radius: var(--radius-xs);
  flex-shrink: 0;
}
.rev-stat-label {
  font-size: 0.73rem;
  color: var(--text-muted);
  margin: 0 0 3px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.rev-stat-value {
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  line-height: 1.1;
}
.rev-stat-divider {
  width: 1px;
  height: 52px;
  background: var(--border);
  flex-shrink: 0;
}

/* chart tooltip */
.rev-tooltip {
  background: var(--bg-primary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 10px 14px;
  box-shadow: 0 8px 24px rgba(1, 13, 33,0.18);
  min-width: 160px;
}
.rev-tooltip-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-muted);
  margin: 0 0 8px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.rev-tooltip-row {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  margin-bottom: 5px;
}
.rev-tooltip-row:last-child { margin-bottom: 0; }
.rev-tooltip-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.rev-tooltip-name {
  font-size: 0.8rem;
  color: var(--text-muted);
  flex: 1 1;
}
.rev-tooltip-val {
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--text-primary);
}

/* legacy legend classes kept for other usages */
.rev-legend {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  flex-wrap: wrap;
  margin-top: 2px;
}
.rev-leg-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}
.rev-leg-label {
  font-size: 0.78rem;
  color: var(--text-muted);
}
.rev-legend strong {
  font-size: 0.82rem;
  color: var(--text-primary);
}

/* ── Two-column row ──────────────────────────────────────────── */
.ov-two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
.ov-two-col-wide {
  grid-template-columns: 2fr 1fr;
}
@media (max-width: 900px) {
  .ov-two-col,
  .ov-two-col-wide { grid-template-columns: 1fr; }
}

/* ── Order Distribution legend ───────────────────────────────── */
.dist-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  justify-content: center;
  margin-top: 4px;
}
.dist-leg-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  color: var(--text-secondary);
  font-weight: 500;
}

/* ── Top Sale list ───────────────────────────────────────────── */
.top-sale-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.top-sale-item {
  display: flex;
  align-items: center;
  gap: 12px;
}
.top-sale-thumb {
  width: 48px;
  height: 48px;
  border-radius: var(--radius-sm);
  object-fit: cover;
  flex-shrink: 0;
  border: 1px solid var(--border);
}
.top-sale-info {
  flex: 1 1;
  min-width: 0;
}
.top-sale-name {
  font-size: 0.83rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.top-sale-price {
  font-size: 0.78rem;
  color: var(--text-muted);
  margin: 0;
}
.top-sale-units {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-muted);
  white-space: nowrap;
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  padding: 3px 9px;
  border-radius: var(--radius-xl);
}

/* ── Recent Orders table ─────────────────────────────────────── */
/* No overflow-x here: the v2 table below is table-layout:fixed and always sizes
   to its column, so a sideways scrollbar would only ever be a symptom of a
   column width bug rather than a legitimate escape hatch. */
.ro-table-wrap {
  margin: 0 -2px;
}
.ro-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.82rem;
}
.ro-table thead th {
  padding: 8px 10px;
  text-align: left;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid var(--border);
}
.ro-row td {
  padding: 10px 10px;
  vertical-align: middle;
  border-bottom: 1px solid var(--border);
  color: var(--text-primary);
}
.ro-row:last-child td { border-bottom: none; }
.ro-row:hover { background: var(--bg-tertiary); }
.ro-row-urgent { background: linear-gradient(90deg, rgba(255, 103, 0, 0.05) 0%, rgba(255, 103, 0, 0) 100%); }
.ro-row-urgent:hover { background: linear-gradient(90deg, rgba(255, 103, 0, 0.12) 0%, rgba(255, 103, 0, 0.02) 100%); }

.ro-product-cell {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 160px;
}
.ro-thumb {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-sm);
  object-fit: cover;
  flex-shrink: 0;
  border: 1px solid var(--border);
}
.ro-product-name {
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
}
.ro-customer { color: var(--text-secondary); white-space: nowrap; }
.ro-total    { font-weight: 600; white-space: nowrap; }
.ro-date     { color: var(--text-muted); white-space: nowrap; }

/* ── Recent Orders pagination ────────────────────────────────── */
.ro-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 2px 0;
  margin-top: 4px;
  border-top: 1px solid var(--border);
}
.ro-showing {
  font-size: 0.76rem;
  color: var(--text-muted);
}
.ro-pages {
  display: flex;
  align-items: center;
  gap: 4px;
}
.ro-page-btn {
  min-width: 30px;
  height: 30px;
  padding: 0 4px;
  border-radius: var(--radius-xs);
  border: 1px solid var(--border);
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 140ms ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ro-page-btn:hover:not(:disabled) {
  background: var(--accent);
  color: var(--color-text-on-secondary);
  border-color: var(--accent);
}
.ro-page-btn.active {
  background: var(--accent);
  color: var(--color-text-on-secondary);
  border-color: var(--accent);
  font-weight: 700;
}
.ro-page-btn:disabled { opacity: 0.35; cursor: default; }
.ro-arrow { font-size: 1.1rem; }

/* ── Category Revenue breakdown ──────────────────────────────── */
.cat-rev-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.cat-rev-item { }
.cat-rev-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
}
.cat-rev-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}
.cat-rev-name {
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--text-primary);
}
.cat-rev-pct {
  font-size: 0.78rem;
  color: var(--text-muted);
  font-weight: 500;
}
.cat-rev-val {
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--text-primary);
  min-width: 68px;
  text-align: right;
}
.cat-rev-bar-bg {
  height: 7px;
  background: var(--bg-tertiary);
  border-radius: var(--radius-pill);
  overflow: hidden;
}
.cat-rev-bar-fill {
  height: 100%;
  border-radius: var(--radius-pill);
  transition: width 600ms var(--ease-out-expo);
}

/* ── Chart tooltip (shared) ──────────────────────────────────── */
.chart-tooltip {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 8px 12px;
  font-size: 0.8rem;
  box-shadow: 0 4px 16px rgba(1, 13, 33,0.1);
}
.chart-tooltip-label {
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 4px;
}
.chart-tooltip p { margin: 2px 0; }

/* ═══════════════════════════════════════════════════════════════
   OVERVIEW REDESIGN v2
   ═══════════════════════════════════════════════════════════════ */

/* ── Page header extras ──────────────────────────────────────── */
.admin-page-subtitle {
  font-size: 0.82rem;
  color: var(--text-muted);
  margin: 3px 0 0;
}
/* ── Live status + sound, in the admin header ─────────────────────────────
   Two small controls that belong together: whether the dashboard is still
   hearing orders, and whether it will make a noise when one arrives. Grouped
   so they wrap as a pair rather than splitting across two rows of the header.
   flex-shrink:0 because the header is an overflow-x:auto row -- without it
   these are the first things squeezed to nothing on a narrow screen. */
.admin-live-controls {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.admin-live-pill,
.admin-sound-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 38px;           /* matches .admin-refresh-btn, so the row has one baseline */
  padding: 0 12px;
  border-radius: var(--radius-xl);
  border: 1px solid var(--border);
  background: var(--bg-secondary);
  color: var(--text-secondary);
  font-size: 0.76rem;
  font-weight: 700;
  white-space: nowrap;
}

/* The state dot. Blue when the push socket is up, hollow when it is not --
   and never the only thing saying which: the pill carries the words "Live" or
   "Polling" beside it, because four hues cannot also encode status. */
.admin-live-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 1.5px solid var(--text-muted);
  background: transparent;
}

.admin-live-pill.is-live {
  border-color: color-mix(in srgb, var(--color-secondary) 40%, transparent);
  color: var(--color-secondary-text);
}

.admin-live-pill.is-live .admin-live-dot {
  border-color: var(--color-secondary);
  background: var(--color-secondary);
  animation: admin-live-ping 2.4s ease-out infinite;
}

@keyframes admin-live-ping {
  0%   { box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.5); }
  70%  { box-shadow: 0 0 0 7px rgba(59, 130, 246, 0); }
  100% { box-shadow: 0 0 0 0 rgba(59, 130, 246, 0); }
}

.admin-sound-toggle {
  cursor: pointer;
  transition: border-color 150ms, color 150ms, background 150ms;
}

.admin-sound-toggle:hover {
  border-color: var(--color-secondary);
  color: var(--color-secondary-text);
}

.admin-sound-toggle.is-on {
  border-color: color-mix(in srgb, var(--color-secondary) 40%, transparent);
  color: var(--color-secondary-text);
}

.admin-sound-toggle:focus-visible {
  outline: 2px solid var(--color-secondary);
  outline-offset: 2px;
}

/* The label goes before the icon does. At phone width the header is already
   a scrolling row of controls, and "Sound on" spelled out costs more than the
   speaker glyph earns -- but the glyph alone still says mute-or-not, and the
   title attribute still carries the words. */
@media (max-width: 720px) {
  .admin-sound-toggle-label { display: none; }
  .admin-live-pill,
  .admin-sound-toggle { padding: 0 10px; }
}

@media (prefers-reduced-motion: reduce) {
  .admin-live-pill.is-live .admin-live-dot { animation: none; }
}

.admin-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  /* Constrain width to prevent expansion beyond available space */
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
}
.admin-header-actions,
.ov-date-range,
.ov-period-btns {
  /* Matches .admin-refresh-btn's fixed 38px box. A font swap (fallback ->
     Inter once it downloads) changes a glyph's ascent/descent, not just its
     width -- without a fixed height too, that can still grow/shrink this
     whole row vertically for the few seconds until the real font is in,
     which reads as the row's "padding" changing before it settles. */
  min-height: 38px;
}
.ov-date-range {
  display: flex;
  align-items: center;
  gap: 7px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 7px 14px;
  font-size: 0.8rem;
  color: var(--text-secondary);
  white-space: nowrap;
  /* Reserves enough room for the longest possible range string (the 1Y
     format: "Jan 1, 2025 – Dec 31, 2025") so this chip's own width never
     changes -- whether from switching periods, a web-font swap changing
     glyph metrics after first paint, or anything else. A fixed-width
     neighbour is what actually keeps the 7D/30D/90D/1Y buttons from
     shifting horizontally on load, since they sit right after it in the
     same flex row.
     
     NOTE: Updated to account for font-size-adjust normalization and use
     max-width to prevent unexpected expansion during font metric shifts. */
  min-width: 222px;
  max-width: 240px;
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
  box-sizing: border-box;
  /* Prevent text overflow within the container */
  overflow: hidden;
  text-overflow: ellipsis;
}
.ov-date-icon { font-size: 0.95rem; display: flex; flex-shrink: 0; }
.ov-date-text {
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ── Overview range controls, docked to the top-right of the page header ──
   Previously the range chip, the preset switcher and two always-visible
   date inputs sat as separate children of .admin-header-actions. Together
   they were wider than the space left beside the page title, so the whole
   lot wrapped onto its own full-width band beneath the header. Grouping
   them and moving the custom From/To fields into a popover keeps the
   cluster narrow enough to stay on the title's row, right-aligned. */
.ov-range-controls {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
  flex-wrap: nowrap;
}

.ov-date-popover-wrap { position: relative; display: flex; }

/* The header and its action row both clip their overflow to stop the toolbar
   growing the header (.admin-page-header sets overflow-x: hidden, which the
   spec computes to overflow-y: auto -- so it clips vertically too, and
   .admin-header-actions clips outright). That silently swallowed the
   range popover, which hangs below the header by design. Lift the clipping
   only on the Overview tab, where that popover is the one thing that needs
   to escape. */
.admin-page-header.has-range-popover,
.admin-header-actions.has-range-popover {
  overflow: visible;
}
/* .admin-page-header is space-between, which only pushes the actions right
   while both children share a line. Once the controls wrap onto their own
   row, space-between has a single item to place and puts it at flex-start --
   so the cluster jumped from the top-right to the far left. An explicit
   auto margin keeps it right-aligned on the wrapped row too. */
.admin-header-actions.has-range-popover { margin-left: auto; }

/* The chip is a button now (it opens the custom-range popover), so it needs
   the interactive affordances a bare <div> didn't. */
.ov-date-range {
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: border-color 150ms, background 150ms;
}
.ov-date-range:hover { border-color: var(--border-strong); }
.ov-date-range:focus-visible {
  outline: none;
  border-color: var(--color-secondary);
  box-shadow: 0 0 0 4px var(--color-focus-ring);
}
/* A custom range is a deliberate, sticky choice -- mark it so it's obvious
   the presets are no longer what's driving the page. */
.ov-date-range.is-custom {
  border-color: var(--color-secondary);
  color: var(--text-primary);
}
.ov-date-caret { margin-left: auto; flex-shrink: 0; opacity: 0.6; }

.ov-date-popover {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 40;
  min-width: 240px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-panel);
}
.ov-date-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-secondary);
}
.ov-date-field input {
  padding: 8px 10px;
  border-radius: var(--radius-xs);
  border: 1px solid var(--border);
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 0.82rem;
  font-family: inherit;
}
.ov-date-field input:focus-visible {
  outline: none;
  border-color: var(--color-secondary);
  box-shadow: 0 0 0 3px var(--color-focus-ring);
}
.ov-date-error { margin: 0; font-size: 0.72rem; color: var(--color-primary); }
.ov-date-clear {
  padding: 7px 10px;
  border-radius: var(--radius-xs);
  border: 1px solid var(--border);
  background: none;
  color: var(--text-primary);
  font-size: 0.78rem;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
}
.ov-date-clear:hover:not(:disabled) { background: var(--color-surface-hover); }
.ov-date-clear:disabled { opacity: 0.5; cursor: not-allowed; }

@media (max-width: 1100px) {
  /* Below the point where the chip and switcher can share the title's row,
     let them wrap as a unit and span the full width rather than each
     control breaking to its own line. */
  .admin-header-actions.has-range-popover { margin-left: 0; width: 100%; }
  .ov-range-controls { margin-left: 0; width: 100%; flex-wrap: wrap; }
  .ov-date-range { min-width: 0; flex: 1 1 auto; max-width: none; }
  .ov-date-popover { right: auto; left: 0; }
}
.ov-period-btns {
  display: flex;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  overflow: hidden;
  flex-shrink: 0;
  box-sizing: border-box;
  /* Constrain width to prevent horizontal expansion */
  max-width: calc(4 * 43px + 3px);
}
.ov-period-btn {
  background: none;
  border: none;
  padding: 7px 13px;
  /* Reserves the same box for "7D" as for "30D"/"90D" regardless of actual
     glyph width, so this button row can't change width either -- the same
     reasoning as .ov-date-range's min-width just above: the fallback system
     font shown before Inter finishes loading (\`font-display: swap\` in
     index.html) renders these labels at different widths than Inter does,
     and without a reserved box that swap visibly shifts this row (and the
     refresh button after it) for the few seconds until the real font loads. */
  min-width: 34px;
  text-align: center;
  line-height: 1;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-muted);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.ov-period-btn:hover { background: var(--bg-tertiary); color: var(--text-primary); }
.ov-period-btn.active { background: var(--color-secondary); color: var(--color-text-on-secondary); border-radius: var(--radius-sm); }
.ov-period-btn:disabled { cursor: default; }
.ov-period-btns.is-loading { opacity: 0.6; }

/* ── Seller KPI row ──────────────────────────────────────────── */
.seller-kpi-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--space-2);
}
@media (max-width: 1100px) { .seller-kpi-row { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 640px)  { .seller-kpi-row { grid-template-columns: 1fr; } }

.seller-kpi-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 16px 18px;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  box-shadow: var(--shadow-card);
}
.skc-icon {
  width: 42px;
  height: 42px;
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  flex-shrink: 0;
}
.skc-body { flex: 1 1; min-width: 0; }
.skc-label {
  font-size: 0.72rem;
  color: var(--text-muted);
  font-weight: 500;
  margin: 0 0 4px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.skc-value {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 3px;
}
.skc-sub {
  font-size: 0.7rem;
  color: var(--text-muted);
  margin: 0;
}
.skc-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
}

/* ── Revenue chart + Top Sellers row ─────────────────────────── */
.ov-chart-seller-row {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  gap: 20px;
  align-items: start;
}
@media (max-width: 1000px) { .ov-chart-seller-row { grid-template-columns: 1fr; } }

/* chart legend */
.rev-chart-legend {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  flex-wrap: wrap;
}
.rcl-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.rcl-label {
  font-size: 0.75rem;
  color: var(--text-muted);
}

/* Top Sellers card */
.ov-top-sellers-card { overflow: hidden; }
.ts-table-head {
  display: flex;
  gap: var(--space-1);
  padding: 0 0 10px;
  border-bottom: 1px solid var(--border);
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.ts-col-seller { flex: 1 1; }
.ts-col-gmv { width: 80px; text-align: right; }
.ts-col-orders { width: 60px; text-align: right; }
.ts-list { list-style: none; padding: 0; margin: 10px 0 0; display: flex; flex-direction: column; gap: 0; }
.ts-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid var(--border);
}
.ts-item:last-child { border-bottom: none; }
.ts-rank {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--text-muted);
  width: 16px;
  text-align: center;
  flex-shrink: 0;
}
.ts-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--color-brand-white);
  flex-shrink: 0;
}
.ts-info { flex: 1 1; min-width: 0; }
.ts-name {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ts-stats { text-align: right; }
.ts-gmv {
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 2px;
  white-space: nowrap;
}
.ts-orders-count {
  font-size: 0.75rem;
  color: var(--text-muted);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: flex-end;
}
.ts-growth {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 2px 5px;
  border-radius: var(--radius-xl);
  font-size: 0.68rem;
  font-weight: 600;
  white-space: nowrap;
}
.ts-growth-up { background: var(--color-secondary-soft); color: var(--color-secondary); }
.ts-growth-down { background: var(--color-primary-soft); color: var(--color-primary); }
.ts-growth-flat,
.ts-growth-new { background: var(--bg-tertiary); color: var(--text-muted); }

.ov-view-all-link {
  background: none;
  border: none;
  color: var(--color-secondary);
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  margin-top: 14px;
  display: block;
}
.ov-view-all-link:hover { text-decoration: underline; }

/* ── Bottom row: Category + Recent Orders + Goal ─────────────── */
.ov-bottom-row {
  display: grid;
  /* minmax(0, …) rather than a bare fr -- otherwise a card whose content
     (e.g. a chart) has a wider natural min-content size than its fair
     share pins that whole column at its content width instead of shrinking,
     stealing space from its siblings and throwing the row out of balance. */
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.35fr) minmax(0, 1fr);
  gap: 20px;
  align-items: stretch;
}
.ov-bottom-row > .ov-card { display: flex; flex-direction: column; height: 100%; }
/* Body wrapper fills the remaining card height. Centring the content here used
   to split the leftover height into two dead bands (measured 62-88px above AND
   below the orders table), because the row is only as tall as its tallest card
   and the shorter cards centre inside it. Content now starts at the top and the
   card-specific rules below hand the slack to whichever element should absorb
   it, so the cards stay equal-height with no empty gaps. */
.ov-card-fill {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 0;
}
/* Every card in this row distributes its own leftover height between its
   sections rather than pooling it into one visible gap. Scoped to the bottom
   row so the location-row cards below keep their existing top-aligned layout. */
.ov-bottom-row .ov-card-fill { justify-content: space-between; }
@media (max-width: 1100px) { .ov-bottom-row { grid-template-columns: 1fr 1fr; } }
@media (max-width: 700px)  { .ov-bottom-row { grid-template-columns: 1fr; } }

/* Category donut */
.cat-donut-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  pointer-events: none;
}
.cat-donut-val {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  line-height: 1.2;
  white-space: nowrap;
}
.cat-donut-sub {
  font-size: 0.7rem;
  color: var(--text-muted);
  margin: 0;
}
.cat-donut-legend {
  list-style: none;
  padding: 0;
  margin: 10px 0 0;
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.cdl-item {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  font-size: 0.78rem;
}
.cdl-dot { width: 9px; height: 9px; border-radius: 50%; flex-shrink: 0; }
.cdl-name { flex: 1 1; color: var(--text-secondary); }
.cdl-val { font-weight: 600; color: var(--text-primary); white-space: nowrap; }
.cdl-pct { color: var(--text-muted); font-size: 0.72rem; }

/* Recent orders v2 -- fixed column widths so five columns always fit the card
   instead of pushing it into a horizontal scroll. Anything too long clips with
   an ellipsis; the cells carry a title with the full value.

   Breakpoints below are CONTAINER queries, not viewport ones: in the 3-up row
   this card is only ~384px wide at a 1280px viewport, so a viewport media query
   is blind to exactly the case that needs handling. */
.ov-orders-card { container-type: inline-size; }
.ro-table-v2 { table-layout: fixed; width: 100%; }
.ro-table-v2 th,
.ro-table-v2 td {
  padding: 10px 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ro-table-v2 th { font-size: 0.68rem; text-transform: uppercase; letter-spacing: 0.02em; }
.ro-table-v2 th:nth-child(1), .ro-table-v2 td:nth-child(1) { width: 15%; }
.ro-table-v2 th:nth-child(2), .ro-table-v2 td:nth-child(2) { width: 27%; }
.ro-table-v2 th:nth-child(3), .ro-table-v2 td:nth-child(3) { width: 13%; }
.ro-table-v2 th:nth-child(4), .ro-table-v2 td:nth-child(4) { width: 21%; }
.ro-table-v2 th:nth-child(5), .ro-table-v2 td:nth-child(5) { width: 24%; }
/* The status pill is sized for full-width tables, where \`white-space: nowrap\`
   is free. In a ~90px column "out for delivery" can't fit on one line, and an
   inline-flex pill won't ellipsis its own text. Wrapping keeps the label intact;
   \`overflow-wrap: anywhere\` stops a single long word ("processing") from
   forcing the pill wider than its cell and re-creating a sideways scroll. */
.ro-table-v2 td:nth-child(5) { white-space: normal; }
.ro-table-v2 .status {
  max-width: 100%;
  padding: 3px 7px;
  gap: 4px;
  font-size: 0.68rem;
  line-height: 1.3;
  display: inline-flex;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* Date is the most droppable column once the card itself gets narrow. */
@container (max-width: 400px) {
  .ro-table-v2 th:nth-child(3), .ro-table-v2 td:nth-child(3) { display: none; }
  .ro-table-v2 th:nth-child(1), .ro-table-v2 td:nth-child(1) { width: 17%; }
  .ro-table-v2 th:nth-child(2), .ro-table-v2 td:nth-child(2) { width: 31%; }
  .ro-table-v2 th:nth-child(4), .ro-table-v2 td:nth-child(4) { width: 26%; }
  .ro-table-v2 th:nth-child(5), .ro-table-v2 td:nth-child(5) { width: 26%; }
}
/* Fill the card: the table takes the leftover height and distributes it across
   its rows, so there's no dead band between the last row and the pagination. */
.ov-orders-card .ov-card-fill > .ro-table-wrap { flex: 1 1; display: flex; }
.ov-orders-card .ro-table-v2 { height: 100%; }
.ov-orders-card .admin-pagination { margin-top: auto; }
.ro-id { font-size: 0.78rem; font-weight: 600; color: var(--text-secondary); }

/* The shared pagination is sized for full-page tables; tighten it inside a card. */
.ov-card .admin-pagination { padding: 14px 0 2px; gap: 8px; flex-wrap: wrap; }
.ov-card .admin-page-btn { padding: 6px 12px; font-size: 0.8rem; }
.ov-card .admin-page-info { font-size: 0.78rem; }

/* Revenue goal -- the ring is a centred hero rather than the middle of a 3-up
   flex row. Flanking it with text columns meant a narrowing card squeezed those
   columns until the \$-amounts collided with the ring. */
.goal-ring-wrap {
  width: clamp(150px, 58%, 190px);
  aspect-ratio: 1;
  margin: 4px auto 18px;
}
.goal-ring { display: block; width: 100%; height: 100%; }
.goal-ring-track {
  fill: none;
  stroke: var(--bg-tertiary);
  stroke-width: 26;
}
.goal-ring-fill {
  fill: none;
  stroke-width: 26;
  stroke-linecap: round;
  transition: stroke-dashoffset 800ms ease;
}
/* SVG user units, not CSS pixels -- these scale with the ring, so the labels
   keep the same proportions (and stay inside the hole) at every card width. */
.goal-ring-pct { font-size: 38px; font-weight: 800; fill: var(--text-primary); }
.goal-ring-status { font-size: 14px; font-weight: 600; }

.goal-endpoints {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 10px;
  padding-bottom: 18px;
  border-bottom: 1px solid var(--border);
}
.goal-endpoint { min-width: 0; }
.goal-endpoint-target { text-align: right; }
.goal-endpoint-val {
  font-size: clamp(0.95rem, 0.75rem + 0.6vw, 1.15rem);
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  white-space: nowrap;
}
.goal-endpoint-label {
  font-size: 0.72rem;
  color: var(--text-muted);
  margin: 3px 0 0;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

/* Ring / endpoints / stats spread into this card's leftover height via the
   shared \`.ov-bottom-row .ov-card-fill\` space-between rule above. */
.goal-stats-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-top: 18px;
}
.goal-stat-row { display: flex; align-items: center; gap: 12px; }
.goal-stat-icon {
  width: 40px; height: 40px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.goal-stat-info { flex: 1 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
.goal-stat-label { font-size: 0.75rem; color: var(--text-muted); text-transform: uppercase; letter-spacing: 0.03em; }
.goal-stat-val { font-size: 0.95rem; font-weight: 700; color: var(--text-primary); white-space: nowrap; }

/* The title is this header's first child directly (no wrapper div), so the
   generic \`.ov-card-header > div:first-child\` flex rule misses it. */
.ov-goal-card .ov-card-title { flex: 1 1 auto; min-width: 0; }
.ov-goal-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.goal-edit-btn {
  border: none;
  background: var(--bg-tertiary);
  width: 26px;
  height: 26px;
  border-radius: var(--radius-sm);
  font-size: 0.8rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 150ms;
}
.goal-edit-btn:hover { background: var(--border); }

.goal-edit-form { margin-top: 4px; }
.goal-edit-label {
  display: block;
  font-size: 0.78rem;
  color: var(--text-muted);
  margin-bottom: 8px;
}
.goal-edit-row {
  display: flex;
  align-items: center;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 0 12px;
  background: var(--bg-primary);
}
.goal-edit-prefix {
  font-weight: 700;
  color: var(--text-secondary);
  margin-right: 4px;
}
.goal-edit-input {
  flex: 1 1;
  min-width: 0;
  border: none;
  background: transparent;
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text-primary);
  padding: 10px 0;
}
.goal-edit-input:focus { outline: none; }
.goal-edit-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}
.goal-edit-cancel {
  padding: 6px 14px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  background: transparent;
  color: var(--text-secondary);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
}
.goal-edit-cancel:hover { background: var(--bg-tertiary); }

/* ── Seller Location Analytics ───────────────────────────────── */
.ov-location-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 18px;
  margin-top: 28px;
}
@media (max-width: 900px) { .ov-location-row { grid-template-columns: 1fr; } }

.ov-location-card { min-height: 280px; }
.ov-card-sub {
  font-size: 0.73rem;
  color: var(--text-muted);
  margin: 2px 0 0;
}

.loc-list {
  list-style: none; padding: 0; margin: 14px 0 0;
  display: flex; flex-direction: column; gap: 11px;
}
.loc-item {
  display: flex; align-items: center; gap: 10px;
}
.loc-rank {
  width: 22px; min-width: 22px;
  font-size: 0.72rem; font-weight: 800;
  color: var(--text-muted); text-align: center;
}
.loc-info {
  flex: 1 1; min-width: 0;
}
.loc-name-row {
  display: flex; align-items: center; gap: 7px; margin-bottom: 4px;
}
.loc-city {
  font-size: 0.82rem; font-weight: 700;
  color: var(--text-primary); white-space: nowrap;
  overflow: hidden; text-overflow: ellipsis;
}
.loc-crown {
  font-size: 0.65rem; font-weight: 700;
  background: var(--color-primary-soft); color: var(--color-primary);
  padding: 1px 7px; border-radius: var(--radius-xl);
  white-space: nowrap;
}
.loc-crown-grow {
  background: var(--color-secondary-soft); color: var(--color-secondary);
}
.loc-bar-wrap {
  height: 5px; background: var(--bg-tertiary);
  border-radius: var(--radius-pill); overflow: hidden;
}
.loc-bar-fill {
  height: 100%; border-radius: var(--radius-pill);
  transition: width 600ms cubic-bezier(0.25,0.46,0.45,0.94);
}
.loc-count {
  font-size: 0.75rem; font-weight: 700;
  color: var(--text-secondary); white-space: nowrap;
  min-width: 60px; text-align: right;
}

/* ═══════════════════════════════════════════════════════════════
   DELIVERY REVIEW SYSTEM  (v2 — no shiver, emoji, animated)
   ═══════════════════════════════════════════════════════════════ */

/* ── Reviewed badge on order header ──────────────────────────── */
.order-reviewed-badge {
  font-size: 0.72rem;
  font-weight: 600;
  background: var(--color-primary-soft);
  color: var(--color-primary);
  border: 1px solid var(--color-primary-soft);
  padding: 2px 9px;
  border-radius: var(--radius-xl);
}

/* ── Section separator inside order card ────────────────────── */
.dr-order-section {
  margin-top: 20px;
  border-top: 1px solid var(--border);
  padding-top: 18px;
}

/* ── Prompt strip (unreviewed delivered order) ───────────────── */
.dr-prompt {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  background: linear-gradient(135deg, var(--color-primary-soft) 0%, color-mix(in srgb, var(--color-primary) 16%, transparent) 100%);
  border: 1px solid var(--color-primary-soft);
  border-left: 4px solid var(--color-primary);
  border-radius: var(--radius-sm);
  padding: 16px 20px;
  flex-wrap: wrap;
  transition: box-shadow 200ms ease;
}
.dr-prompt:hover { box-shadow: 0 4px 20px rgba(255, 103, 0,0.12); }
.dark .dr-prompt {
  background: linear-gradient(135deg, rgba(255, 103, 0,0.08) 0%, rgba(251,146,60,0.05) 100%);
  border-color: rgba(255, 103, 0,0.3);
}
.dr-prompt-content { display: flex; align-items: center; gap: 14px; }
.dr-prompt-stars-preview {
  display: flex;
  gap: 1px;
}
.dp-star {
  font-size: 1.3rem;
  color: var(--color-primary);
  animation: dp-star-pulse 2s ease-in-out infinite;
}
.dp-star:nth-child(2) { animation-delay: 0.1s; }
.dp-star:nth-child(3) { animation-delay: 0.2s; }
.dp-star:nth-child(4) { animation-delay: 0.3s; }
.dp-star:nth-child(5) { animation-delay: 0.4s; }
@keyframes dp-star-pulse {
  0%, 100% { opacity: 0.45; transform: scale(0.95); }
  50%       { opacity: 1;    transform: scale(1.05); }
}
.dr-prompt-title {
  font-size: 0.92rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 3px;
}
.dr-prompt-sub {
  font-size: 0.77rem;
  color: var(--text-muted);
  margin: 0;
}
.dr-prompt-btn {
  flex-shrink: 0;
  padding: 9px 20px;
  border-radius: var(--radius-sm);
  border: none;
  background: linear-gradient(135deg, var(--color-primary) 0%, color-mix(in srgb, var(--color-primary) 80%, var(--color-brand-navy)) 100%);
  color: var(--color-brand-white);
  font-size: 0.85rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 160ms ease, box-shadow 160ms ease, opacity 160ms;
  box-shadow: 0 4px 14px rgba(255, 103, 0,0.35);
  white-space: nowrap;
}
.dr-prompt-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(255, 103, 0,0.45);
}
.dr-prompt-btn:active { transform: translateY(0); }

/* ── Review summary card (post-submission) ───────────────────── */
.dr-summary {
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 18px 20px;
  animation: dr-slide-up 300ms var(--ease-out-expo, cubic-bezier(0.16,1,0.3,1)) both;
  box-shadow: var(--shadow-card);
}
.dr-summary-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.dr-summary-badge {
  font-size: 0.78rem;
  font-weight: 700;
  background: var(--color-secondary-soft);
  color: var(--color-secondary);
  border: 1px solid var(--color-secondary-soft);
  padding: 3px 12px;
  border-radius: var(--radius-xl);
}
.dr-summary-date { font-size: 0.74rem; color: var(--text-muted); }
.dr-summary-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
@media (max-width: 600px) { .dr-summary-grid { grid-template-columns: 1fr; } }
.dr-summary-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-left: 3px solid var(--sc, var(--accent));
  border-radius: var(--radius-sm);
}
.dr-summary-icon { font-size: 1.3rem; flex-shrink: 0; margin-top: 1px; }
.dr-summary-info { flex: 1 1; min-width: 0; }
.dr-summary-label {
  font-size: 0.76rem;
  font-weight: 600;
  color: var(--text-muted);
  display: block;
  margin-bottom: 5px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.dr-summary-stars { display: flex; align-items: center; gap: 1px; margin-bottom: 4px; }
.dr-sum-star { font-size: 1rem; color: var(--border); }
.dr-sum-star.lit { color: var(--color-primary); }
.dr-sum-fb { font-size: 1rem; margin-left: 6px; }
.dr-summary-note {
  font-size: 0.76rem;
  color: var(--text-muted);
  margin: 4px 0 0;
  line-height: 1.45;
  word-break: break-word;
}

/* ── Modal overlay ───────────────────────────────────────────── */
.dr-overlay {
  position: fixed;
  inset: 0;
  background: rgba(1, 13, 33,0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 9000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-2);
  overflow-y: auto;
}
.dr-modal {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  width: 100%;
  max-width: 560px;
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  box-shadow: 0 32px 80px rgba(1, 13, 33,0.25), 0 0 0 1px rgba(255,255,255,0.04);
  animation: dr-slide-up 300ms cubic-bezier(0.16,1,0.3,1) both;
  scrollbar-width: thin;
}
@keyframes dr-slide-up {
  from { opacity: 0; transform: translateY(28px) scale(0.96); }
  to   { opacity: 1; transform: translateY(0)    scale(1); }
}

/* ── Modal header ────────────────────────────────────────────── */
.dr-modal-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px 24px 16px;
  position: sticky;
  top: 0;
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border);
  z-index: 2;
}
.dr-modal-head::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(255, 103, 0,0.04) 0%, transparent 60%);
  pointer-events: none;
  border-radius: var(--radius-xl) var(--radius-xl) 0 0;
}
.dr-modal-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 4px;
}
.dr-modal-sub {
  font-size: 0.77rem;
  color: var(--text-muted);
  margin: 0;
}
.dr-close {
  width: 32px;
  height: 32px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: 0.9rem;
  color: var(--text-muted);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 140ms, color 140ms, transform 140ms;
}
.dr-close:hover {
  background: var(--color-primary-soft);
  color: var(--color-primary);
  border-color: var(--color-primary-soft);
  transform: scale(1.05);
}

/* ── Progress chips row ──────────────────────────────────────── */
.dr-progress-row {
  display: flex;
  gap: var(--space-1);
  padding: 14px 24px;
  flex-wrap: wrap;
  border-bottom: 1px solid var(--border);
}
.dr-progress-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.73rem;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: var(--radius-xl);
  border: 1.5px solid var(--border);
  color: var(--text-muted);
  background: var(--bg-tertiary);
  transition: all 200ms cubic-bezier(0.34,1.56,0.64,1);
}
.dr-progress-chip.done {
  border-color: var(--chip-color);
  color: var(--chip-color);
  background: color-mix(in srgb, var(--chip-color) 10%, transparent);
  transform: scale(1.03);
}

/* ── Form ────────────────────────────────────────────────────── */
.dr-form {
  padding: 8px 24px 24px;
  display: flex;
  flex-direction: column;
}

/* ── Section ─────────────────────────────────────────────────── */
.dr-section {
  padding: 20px 0 20px 14px;
  border-left: 3px solid var(--sc, var(--accent));
  margin-left: 0;
  border-bottom: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  gap: 14px;
  transition: border-color 300ms ease;
}
.dr-section:last-of-type { border-bottom: none; }

.dr-section-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.dr-section-icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  flex-shrink: 0;
  transition: transform 300ms cubic-bezier(0.34,1.56,0.64,1);
}
.dr-section.rated .dr-section-icon-wrap { transform: scale(1.1); }
.dr-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 3px;
}
.dr-section-desc {
  font-size: 0.77rem;
  color: var(--text-muted);
  margin: 0;
}

/* ── Stars ────────────────────────────────────────────────────── */
.dr-picker-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 14px;
}
.dr-stars {
  display: flex;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  gap: 0;                    /* no gaps — cursor is always over a star */
  padding: 4px 2px;
}
.dr-star {
  font-size: 2.1rem;
  line-height: 1;
  /* Fixed width so transform: scale never causes layout shift */
  width: 42px;
  text-align: center;
  display: inline-block;
  color: var(--border);
  transition:
    color    120ms ease,
    transform 200ms cubic-bezier(0.34,1.56,0.64,1),
    filter   120ms ease;
  transform-origin: center bottom;
}
.dark .dr-star { color: var(--text-secondary); }
.dr-star.lit {
  color: var(--color-primary);
  filter: drop-shadow(0 2px 6px rgba(255, 103, 0,0.45));
}
.dr-star.peak {
  transform: scale(1.35);
  color: var(--color-primary);
  filter: drop-shadow(0 3px 8px rgba(255, 103, 0,0.55));
}

/* ── Feedback label slot (always reserved, no layout shift) ───── */
.dr-fb-slot {
  min-width: 90px;
  height: 30px;
  display: flex;
  align-items: center;
}
.dr-fb {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.82rem;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: var(--radius-xl);
  animation: dr-fb-pop 220ms cubic-bezier(0.34,1.56,0.64,1) both;
  white-space: nowrap;
}
@keyframes dr-fb-pop {
  from { opacity: 0; transform: scale(0.5) translateY(4px); }
  to   { opacity: 1; transform: scale(1)   translateY(0); }
}
.fb-sad  { background: var(--color-primary-soft); color: var(--color-primary); }
.fb-low  { background: var(--color-primary-soft); color: var(--color-primary); }
.fb-mid  { background: var(--color-secondary-soft); color: var(--accent-hover); }
.fb-high { background: var(--color-secondary-soft); color: var(--color-secondary); }
.fb-wow  {
  background: linear-gradient(135deg, var(--color-primary-soft) 0%, color-mix(in srgb, var(--color-primary) 16%, transparent) 100%);
  color: var(--color-primary);
  font-size: 0.95rem;
  animation: dr-fb-pop 280ms cubic-bezier(0.34,1.56,0.64,1) both,
             dr-wow-bounce 600ms 280ms cubic-bezier(0.34,1.56,0.64,1) both;
}
@keyframes dr-wow-bounce {
  0%   { transform: scale(1); }
  40%  { transform: scale(1.12) rotate(-2deg); }
  70%  { transform: scale(0.96) rotate(1deg); }
  100% { transform: scale(1); }
}

/* ── Conditional fields (slide in) ───────────────────────────── */
.dr-cond-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
  animation: dr-cond-in 260ms cubic-bezier(0.16,1,0.3,1) both;
  border-left: 2px dashed var(--sc, var(--accent));
  padding-left: 12px;
  margin-left: 4px;
}
@keyframes dr-cond-in {
  from { opacity: 0; transform: translateY(-10px); max-height: 0; }
  to   { opacity: 1; transform: translateY(0);    max-height: 200px; }
}
.dr-field-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.dr-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-secondary);
}
.dr-req { color: var(--danger); margin-left: 2px; }
.dr-opt { color: var(--text-muted); font-weight: 400; }
.dr-textarea {
  width: 100%;
  padding: 10px 13px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 0.83rem;
  resize: vertical;
  font-family: inherit;
  box-sizing: border-box;
  transition: border-color 160ms ease, box-shadow 160ms ease;
  line-height: 1.5;
}
.dr-textarea:focus {
  outline: none;
  border-color: var(--sc, var(--accent));
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--sc, var(--accent)) 15%, transparent);
}
.dr-char {
  font-size: 0.7rem;
  color: var(--text-muted);
  text-align: right;
  margin-top: -2px;
}

/* ── Actions bar ─────────────────────────────────────────────── */
.dr-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 18px;
  border-top: 1px solid var(--border);
  margin-top: 10px;
  flex-wrap: wrap;
}
.dr-rated-count {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  font-size: 0.77rem;
  color: var(--text-muted);
}
.dr-rated-dots { display: flex; gap: 5px; }
.dr-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--border);
  transition: background 250ms cubic-bezier(0.34,1.56,0.64,1), transform 250ms cubic-bezier(0.34,1.56,0.64,1);
}
.dr-dot.done {
  background: var(--accent);
  transform: scale(1.3);
}
.dr-action-btns { display: flex; align-items: center; gap: 10px; }

.dr-error {
  font-size: 0.82rem;
  color: var(--color-primary);
  background: var(--color-primary-soft);
  border: 1px solid var(--color-primary-soft);
  border-radius: var(--radius-sm);
  padding: 10px 14px;
  margin-top: 8px;
  animation: dr-slide-up 200ms ease both;
}

/* ── Submit button ───────────────────────────────────────────── */
.dr-submit-btn {
  padding: 10px 22px;
  border-radius: var(--radius-sm);
  border: none;
  font-size: 0.85rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 160ms ease, box-shadow 160ms ease, background 200ms ease, opacity 160ms;
  background: var(--bg-tertiary);
  color: var(--text-muted);
  border: 1.5px solid var(--border);
}
.dr-submit-btn.ready {
  background: linear-gradient(135deg, var(--accent-secondary) 0%, color-mix(in srgb, var(--accent-secondary) 80%, transparent) 100%);
  color: var(--color-brand-white);
  border-color: transparent;
  box-shadow: 0 4px 18px color-mix(in srgb, var(--accent-secondary) 35%, transparent);
}
.dr-submit-btn.ready:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 24px color-mix(in srgb, var(--accent-secondary) 45%, transparent);
}
.dr-submit-btn.ready:active { transform: translateY(0); }
.dr-submit-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.dr-submitting {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
}
.dr-spin {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255,255,255,0.3);
  border-top-color: var(--color-brand-white);
  border-radius: 50%;
  animation: spin 600ms linear infinite;
}

/* ── Responsive ──────────────────────────────────────────────── */
/* No breakpoint existed here before -- the 5-star row (5 x 42px + gap)
   plus the reserved feedback-label slot didn't fit a ~375px phone even
   with .dr-picker-wrap's flex-wrap fallback above, so it read as an
   internal horizontal scrollbar cutting off the feedback badge. */
@media (max-width: 480px) {
  .dr-form { padding: 8px 16px 20px; }
  .dr-section { padding: 16px 0 16px 10px; }
  .dr-modal-head { padding: 18px 16px 14px; }
  .dr-star { width: 34px; font-size: 1.7rem; }
  .dr-picker-wrap { gap: 6px 10px; }
}

/* ═══════════════════════════════════════════════════════════════
   ADMIN — REVIEWS TAB
   ═══════════════════════════════════════════════════════════════ */

.rv-root { display: flex; flex-direction: column; gap: 20px; }

/* ── Summary row ─────────────────────────────────────────────── */
.rv-summary-row {
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: var(--space-2);
  align-items: start;
}
@media (max-width: 900px) { .rv-summary-row { grid-template-columns: 1fr; } }

/* Overall score card */
.rv-overall-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 22px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  box-shadow: var(--shadow-card);
}
.rv-overall-score {
  font-size: 3.2rem;
  font-weight: 800;
  color: var(--text-primary);
  line-height: 1;
}
.rv-overall-stars { display: flex; gap: 3px; }
.rv-big-star { font-size: 1.3rem; color: var(--border-strong); transition: color 150ms; }
.rv-big-star.lit { color: var(--color-primary); }
.rv-overall-label {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-top: 4px;
}
.rv-overall-sub { font-size: 0.75rem; color: var(--text-muted); }

/* Distribution bars */
.rv-dist { width: 100%; margin-top: 12px; display: flex; flex-direction: column; gap: 5px; }
.rv-dist-row { display: flex; align-items: center; gap: 6px; }
.rv-dist-star { font-size: 0.72rem; color: var(--text-muted); width: 20px; text-align: right; flex-shrink: 0; }
.rv-dist-bar-bg {
  flex: 1 1;
  height: 8px;
  background: var(--bg-tertiary);
  border-radius: var(--radius-pill);
  overflow: hidden;
}
.rv-dist-bar-fill {
  height: 100%;
  background: var(--color-primary);
  border-radius: var(--radius-pill);
  transition: width 600ms cubic-bezier(0.16,1,0.3,1);
}
.rv-dist-count { font-size: 0.72rem; color: var(--text-muted); width: 16px; flex-shrink: 0; }

/* Per-category grid */
.rv-cats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}
@media (max-width: 1100px) { .rv-cats-grid { grid-template-columns: repeat(2, 1fr); } }

.rv-cat-card {
  background: color-mix(in srgb, var(--rvc, var(--accent)) 9%, var(--bg-secondary));
  border: 1px solid var(--border);
  border-top: 4px solid var(--rvc, var(--accent));
  border-radius: var(--radius-md);
  padding: 16px 14px;
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  box-shadow: var(--shadow-card);
}
.rv-cat-top { display: flex; align-items: center; gap: var(--space-1); }
.rv-cat-icon { font-size: 1.2rem; }
.rv-cat-label { font-size: 0.78rem; font-weight: 600; color: var(--text-muted); }
.rv-cat-score {
  font-size: 1.8rem;
  font-weight: 800;
  color: var(--text-primary);
  line-height: 1;
}
.rv-cat-bar-bg {
  height: 6px;
  background: var(--bg-tertiary);
  border-radius: var(--radius-pill);
  overflow: hidden;
}
.rv-cat-bar-fill {
  height: 100%;
  background: var(--rvc, var(--accent));
  border-radius: var(--radius-pill);
  transition: width 600ms cubic-bezier(0.16,1,0.3,1);
}
.rv-cat-stars { display: flex; gap: 1px; }

/* ── Filters ─────────────────────────────────────────────────── */
.rv-filters {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.rv-filter-chips { display: flex; gap: 6px; flex-wrap: wrap; }
.rv-filter-chip {
  padding: 5px 14px;
  border-radius: var(--radius-xl);
  border: 1.5px solid var(--border);
  background: var(--bg-secondary);
  color: var(--text-muted);
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 160ms ease;
}
.rv-filter-chip:hover { border-color: var(--color-primary); color: var(--color-primary); }
.rv-filter-chip.active {
  background: var(--color-primary);
  border-color: var(--color-primary);
  color: var(--color-text-on-primary);
}

/* ── Review card ─────────────────────────────────────────────── */
.rv-list { display: flex; flex-direction: column; gap: 10px; }

.rv-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-left: 4px solid var(--band, var(--accent));
  border-radius: var(--radius-sm);
  overflow: hidden;
  transition: box-shadow 200ms ease;
  box-shadow: var(--shadow-card);
}
.rv-card:hover { box-shadow: 0 4px 20px rgba(1, 13, 33,0.07); }
.rv-card.open { box-shadow: 0 6px 28px rgba(1, 13, 33,0.1); }

.rv-card-head {
  width: 100%;
  background: none;
  border: none;
  padding: 14px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  gap: 12px;
}
.rv-card-head:hover { background: var(--bg-tertiary); }

.rv-card-left { display: flex; align-items: center; gap: 12px; }
.rv-customer-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 800;
  color: var(--color-brand-white);
  flex-shrink: 0;
  opacity: 0.92;
}
.rv-customer-name {
  font-size: 0.88rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 2px;
}
.rv-order-meta {
  font-size: 0.74rem;
  color: var(--text-muted);
  margin: 0;
}
.rv-card-right { display: flex; align-items: center; gap: 10px; flex-shrink: 0; }
.rv-avg-badge {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--color-brand-white);
  padding: 4px 10px;
  border-radius: var(--radius-xl);
}
.rv-chevron { font-size: 0.7rem; color: var(--text-muted); }

/* Quick category summary (always shown) */
.rv-quick-cats {
  display: flex;
  gap: var(--space-2);
  padding: 0 18px 14px;
  flex-wrap: wrap;
  border-bottom: 1px solid var(--border);
}
.rv-qcat { display: flex; align-items: center; gap: 6px; }
.rv-qcat-icon { font-size: 1rem; }

/* Mini stars */
.rv-ministars { display: inline-flex; align-items: center; gap: 2px; }
.rv-mstar { font-size: 0.85rem; color: var(--border-strong); }
.rv-mstar.lit { color: var(--color-primary); }
.rv-mstar-num {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--text-muted);
  margin-left: 3px;
}
.rv-mstar-emoji { font-size: 0.85rem; margin-left: 2px; }

/* Expanded detail */
.rv-detail {
  padding: 14px 18px 16px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  animation: dr-slide-up 220ms cubic-bezier(0.16,1,0.3,1) both;
}
@media (max-width: 700px) { .rv-detail { grid-template-columns: 1fr; } }

.rv-detail-row {
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-left: 3px solid var(--rvc, var(--accent));
  border-radius: var(--radius-sm);
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}
.rv-detail-cat { display: flex; align-items: center; gap: 10px; }
.rv-detail-icon { font-size: 1.2rem; }
.rv-detail-label {
  font-size: 0.74rem;
  font-weight: 700;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0 0 4px;
}
.rv-detail-notes { display: flex; flex-direction: column; gap: 4px; padding-top: 4px; border-top: 1px dashed var(--border); }
.rv-detail-note {
  font-size: 0.78rem;
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.45;
}

/* ═══════════════════════════════════════════════════════════
   NEW SITE HEADER — announcement bar + main navbar
   ═══════════════════════════════════════════════════════════ */

.site-header {
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 12px rgba(1, 13, 33, 0.08);
}

/* ── Announcement bar ─────────────────────────────────────── */
/* The promotional/flash-sale bar is navy in both themes. Stated directly
   rather than via --text-primary (which is white in dark mode and only
   looked right because of a separate dark override further down), and its
   text uses the non-flipping on-navy tokens. */
.ann-bar {
  background: var(--color-brand-navy);
  color: var(--color-on-navy-secondary);
  /* Clears the status bar / display cutout. Android 15+ forces edge-to-edge
     for targetSdk 35+, so the WebView really does start behind the clock and
     battery -- without this the flash-sale text renders underneath them.
     Two sources because they disagree by platform: iOS Safari and Android
     WebView >=140 expose env(), while Capacitor's SystemBars plugin injects
     --safe-area-inset-* onto <html> (its \`insetsHandling: "css"\` default).
     max() takes whichever is real; on the desktop web both are 0 and this
     resolves to no padding at all. */
  padding-top: max(env(safe-area-inset-top, 0px), var(--safe-area-inset-top, 0px));
}

.ann-bar-inner {
  max-width: 1440px;
  margin: 0 auto;
  padding: 7px 24px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: var(--space-2);
}

.ann-text {
  grid-column: 2;
  text-align: center;
  font-size: 0.85rem;
  font-weight: 500;
  /* Sits on the always-navy flash bar. --bg-tertiary resolved to a 9% white
     wash in dark mode, leaving this all but invisible. */
  color: var(--color-on-navy);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  letter-spacing: 0.1px;
}

.ann-right {
  grid-column: 3;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
}

/* ── On-device API connection screen ───────────────────────
   Long-press the header logo in the packaged app. Styled from the brand
   tokens like everything else rather than left unstyled as a debug panel,
   because it is the one screen reached when the app cannot load anything --
   it should not also look broken. */
.devapi-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(1, 13, 33, 0.62);
  /* Clears the status bar and the gesture bar on an edge-to-edge screen, so
     neither the title nor the reset link sits under system chrome. */
  padding-top: max(20px, env(safe-area-inset-top, 0px), var(--safe-area-inset-top, 0px));
  padding-bottom: max(20px, env(safe-area-inset-bottom, 0px), var(--safe-area-inset-bottom, 0px));
}
.devapi-card {
  width: 100%;
  max-width: 400px;
  max-height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-panel);
  padding: 18px;
}
.devapi-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}
.devapi-title {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
}
.devapi-close {
  background: none;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 6px;
  display: inline-flex;
}
.devapi-note {
  margin: 0 0 14px;
  font-size: 0.82rem;
  line-height: 1.5;
  color: var(--text-secondary);
}
.devapi-facts { margin: 0 0 14px; }
.devapi-facts > div {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 0;
  border-bottom: 1px solid var(--border);
}
.devapi-facts dt { font-size: 0.78rem; color: var(--text-secondary); }
.devapi-facts dd {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-primary);
  text-align: right;
  /* Addresses are unspaced strings, so without this a long one widens the
     dialog instead of wrapping. */
  word-break: break-all;
}
.devapi-label {
  display: block;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-secondary);
  margin-bottom: 6px;
}
.devapi-input {
  width: 100%;
  box-sizing: border-box;
  padding: 11px 12px;
  font-size: 0.9rem;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--bg-primary);
  color: var(--text-primary);
}
.devapi-input:focus {
  outline: none;
  border-color: var(--color-secondary);
}
.devapi-msg {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin: 9px 0 0;
  font-size: 0.78rem;
  line-height: 1.45;
}
/* Only four hues exist, so neither state may rest on colour: each line also
   carries its own icon (check versus warning triangle). */
.devapi-good { color: var(--color-secondary-text); }
/* Navy, not orange: orange on a light surface is 2.92:1 and cannot reach AA
   at any size, so the failure state is carried by the warning triangle and
   the wording instead of by hue. */
.devapi-bad { color: var(--text-primary); }
.devapi-actions {
  display: flex;
  gap: 10px;
  margin-top: 16px;
}
.devapi-btn {
  flex: 1 1;
  padding: 11px 14px;
  border-radius: var(--radius-sm);
  border: none;
  font-size: 0.86rem;
  font-weight: 700;
  cursor: pointer;
}
.devapi-btn:disabled { opacity: 0.55; cursor: not-allowed; }
.devapi-btn-test {
  background: transparent;
  border: 1px solid var(--color-secondary);
  color: var(--color-secondary-text);
}
.devapi-btn-save {
  background: var(--color-secondary);
  color: var(--color-text-on-secondary);
}
.devapi-reset {
  display: block;
  width: 100%;
  margin-top: 10px;
  padding: 8px;
  background: none;
  border: none;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-decoration: underline;
  cursor: pointer;
}

/* ── App-only flash-sale card ──────────────────────────────
   Rendered in place of .ann-bar-inner inside the Capacitor shell. Sits on
   the navy bar as a raised panel so the promotion reads as a card rather
   than as part of the status-bar strip above it. Everything here is brand
   navy/orange/blue/white -- the "red" price tag of a typical sale banner is
   orange, which is the palette's promotional colour anyway. */
/* The gradient lives on the bar rather than on the card so it runs the full
   width and, critically, also fills the safe-area strip the bar reserves for
   the status bar. Painting it on the card instead left the status-bar band a
   flat navy that read as a seam above the promotion. */
.is-native-app .ann-bar,
html.m-installed .ann-bar {
  background: linear-gradient(
    135deg,
    color-mix(in srgb, var(--color-brand-navy) 82%, var(--color-brand-blue)) 0%,
    var(--color-brand-navy) 55%,
    color-mix(in srgb, var(--color-brand-navy) 88%, var(--color-brand-blue)) 100%
  );
}

/* Full-bleed band, not a floating card: no margin, no radius and no shadow,
   so the promotion spans the whole header and meets the navbar directly.
   An earlier version inset it by 8/12/10px with a 16px radius, which left
   navy gutters down both sides and a visible gap above the navbar. */
.ann-app-card {
  display: flex;
  align-items: center;
  gap: 11px;
  margin: 0;
  padding: 9px 14px 11px;
  /* Transparent so the bar's gradient shows through as one continuous
     surface from the status bar down to the navbar edge. */
  background: transparent;
  border: none;
  border-radius: 0;
}

/* Orange fill carries the promotion; the glyph on it must be navy, since
   white on orange is 2.8:1 and fails AA. */
.ann-app-badge {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: var(--radius-sm);
  background: var(--color-primary);
  color: var(--color-text-on-primary);
}

.ann-app-block {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}
.ann-app-block-end { align-items: flex-end; text-align: right; }

/* The four sizes below were picked when the root was 16px. The mobile layer
   now sets 18px (see mobile/tokens.css), which pushed them up by an eighth
   and left the two blocks fighting for the width: at 360px the divider had
   already collapsed to its 12px minimum and a label was overflowing its box.
   They are retuned here rather than scaled back with a wrapper, because these
   classes only ever render inside the packaged app -- the website's
   announcement strip uses .ann-bar-inner instead. */
.ann-app-kicker {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.54rem;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  /* Fixed navy surface in both themes, so the non-flipping on-navy token --
     --text-secondary would go navy-on-navy in light mode. */
  color: var(--color-on-navy-secondary);
  white-space: nowrap;
}

.ann-app-headline {
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.01em;
  color: var(--color-brand-blue);
  white-space: nowrap;
}

.ann-app-sub {
  font-size: 0.6rem;
  font-weight: 600;
  color: var(--color-on-navy);
  white-space: nowrap;
}

.ann-app-timer {
  font-size: 0.58rem;
  font-weight: 600;
  color: var(--color-on-navy-muted);
  white-space: nowrap;
}

/* Pushes the delivery block to the far edge and puts a hairline between the
   two offers, so they never read as one run-on sentence. */
.ann-app-rule {
  flex: 1 0 auto;
  align-self: stretch;
  min-width: 11px;
  border-right: 1px solid color-mix(in srgb, var(--color-brand-white) 17%, transparent);
}

/* Very narrow phones: the delivery block is the first thing to go, since the
   discount and its countdown are what the banner exists for. */
@media (max-width: 359px) {
  .ann-app-rule,
  .ann-app-block-end { display: none; }
}

.ann-countdown {
  display: inline-block;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  color: var(--color-primary);
  letter-spacing: 0.3px;
}

/* The countdown is the whole point of this banner, so on narrow screens it
   must never get clipped by the ellipsis above -- drop the redundant Sign In
   button (the bottom nav's Account tab already covers it on mobile) and let
   the text wrap onto two lines instead of truncating. */
@media (max-width: 768px) {
  .ann-bar-inner { grid-template-columns: 1fr; padding: 6px 14px; }
  .ann-text {
    grid-column: 1;
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    font-size: 0.74rem;
    line-height: 1.4;
  }
  .ann-right { display: none; }
}

.ann-auth-btn {
  background: none;
  border: none;
  color: var(--color-on-navy-secondary);
  font-size: 0.84rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 3px 8px;
  border-radius: var(--radius-xs);
  transition: color 150ms, background 150ms;
  white-space: nowrap;
}
.ann-auth-btn:hover { color: var(--bg-tertiary); background: rgba(255,255,255,0.07); }

/* ── Main navbar ──────────────────────────────────────────── */
.main-navbar {
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border);
}

.main-navbar-inner {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 24px;
  height: 64px;
  display: flex;
  align-items: center;
  gap: 20px;
}

/* Logo */
.nb-logo {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 9px;
  flex-shrink: 0;
  padding: 0;
  text-decoration: none;
}
.nb-logo-icon {
  font-size: 1.5rem;
  width: 38px;
  height: 38px;
  background: linear-gradient(135deg, var(--accent), var(--accent-hover));
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: transform 180ms var(--ease-spring);
}
.nb-logo:hover .nb-logo-icon { transform: scale(1.08); }
.nb-logo-text-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1;
}
.nb-logo-name {
  font-size: 1.36rem;
  font-weight: 800;
  color: var(--text-primary);
  letter-spacing: -0.5px;
  white-space: nowrap;
  /* The bag icon's artwork fills its box edge-to-edge, but a text line's box
     includes descender space below the baseline (for the "y" here) that the
     icon has no equivalent of -- centering the two as plain flex siblings
     therefore reads as the text sitting low. Nudge it up to compensate. */
  transform: translateY(-2px);
}
.nb-logo-tagline {
  font-size: 0.58rem;
  font-weight: 600;
  color: var(--text-secondary);
  letter-spacing: 0.01em;
  white-space: nowrap;
  margin-top: 3px;
}

/* Category nav links */
.nb-cat-nav {
  display: flex;
  align-items: center;
  gap: 0;
  flex: 1 1;
  overflow-x: auto;
  scrollbar-width: none;
}
.nb-cat-nav::-webkit-scrollbar { display: none; }

.nb-cat-link {
  background: none;
  border: none;
  /* Now an <a> rather than a <button> (crawlers only follow anchors), so the
     UA's link underline has to be turned off to keep the nav looking the
     same. Colour is already set explicitly just below. */
  text-decoration: none;
  padding: 8px 11px;
  min-height: 44px;
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  position: relative;
  transition: color 150ms, background 150ms;
}
.nb-cat-link:hover {
  color: var(--accent);
  background: rgba(59, 130, 246, 0.06);
}
.nb-cat-link.active {
  color: var(--accent);
  font-weight: 700;
  background: rgba(59, 130, 246, 0.06);
}
.nb-cat-icon {
  font-size: 0.95rem;
  line-height: 1;
}

.nb-cat-link.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 8px;
  right: 8px;
  height: 2px;
  background: var(--accent);
  border-radius: var(--radius-xs) var(--radius-xs) 0 0;
}

/* Right icon actions */
.nb-actions {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}

.nb-icon {
  background: none;
  border: none;
  cursor: pointer;
  width: 40px;
  height: 40px;
  padding: 0;
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  font-size: 1.15rem;
  position: relative;
  transition: color 150ms, background 150ms;
}
.nb-icon:hover {
  color: var(--accent);
  background: rgba(59, 130, 246, 0.07);
}
.nb-icon svg { flex-shrink: 0; pointer-events: none; }

/* Reset cart-icon-btn overrides when inside new navbar */
.nb-icon.cart-icon-btn { font-size: 1rem; padding: 0; }

.nb-badge {
  position: absolute;
  top: 3px;
  right: 3px;
  background: var(--danger);
  color: var(--color-text-on-primary);
  border-radius: 50%;
  min-width: 17px;
  height: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.62rem;
  font-weight: 700;
  pointer-events: none;
  line-height: 1;
}

/* Expandable search row */
.nb-search-row {
  border-top: 1px solid var(--border);
  padding: 10px 24px;
  background: var(--bg-secondary);
  animation: slideDown 180ms ease-out;
}
.nb-search-inner {
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--bg-tertiary);
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 8px 14px;
  transition: border-color 200ms, box-shadow 200ms, background 200ms;
}
.nb-search-inner:focus-within {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  background: var(--bg-secondary);
}
.nb-search-icon {
  color: var(--text-tertiary);
  flex-shrink: 0;
}
.nb-search-input {
  flex: 1 1;
  border: none;
  background: none;
  font-size: 0.95rem;
  color: var(--text-primary);
  outline: none;
}
.nb-search-input::placeholder { color: var(--text-tertiary); }

.nb-search-clear {
  background: none;
  border: none;
  color: var(--text-tertiary);
  cursor: pointer;
  padding: 2px 6px;
  border-radius: var(--radius-xs);
  font-size: 0.82rem;
  line-height: 1;
  transition: color 120ms, background 120ms;
}
.nb-search-clear:hover { color: var(--text-primary); background: var(--border); }

.nb-search-close-btn {
  background: none;
  border: 1.5px solid var(--border);
  color: var(--text-secondary);
  cursor: pointer;
  padding: 5px 12px;
  border-radius: var(--radius-xs);
  font-size: 0.82rem;
  font-weight: 500;
  transition: all 150ms;
  white-space: nowrap;
  flex-shrink: 0;
}
.nb-search-close-btn:hover {
  background: var(--bg-tertiary);
  border-color: var(--accent);
  color: var(--accent);
}

/* ── Dark mode tweaks ─────────────────────────────────────── */
:root[data-theme="dark"] .ann-bar { background: var(--color-brand-navy); }
:root[data-theme="dark"] .ann-sel { border-color: rgba(1, 13, 33,0.15); }
:root[data-theme="dark"] .nb-cat-link:hover,
:root[data-theme="dark"] .nb-cat-link.active { background: color-mix(in srgb, var(--accent-secondary) 10%, transparent); }
:root[data-theme="dark"] .nb-icon:hover { color: var(--color-secondary); background: color-mix(in srgb, var(--accent-secondary) 10%, transparent); }
:root[data-theme="dark"] .user-dropdown-menu { background: var(--bg-secondary); }

/* ═══════════════════════════════════════════════════════════
   SubPageHeader — shared header for all inner pages
   ═══════════════════════════════════════════════════════════ */
.sub-page-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border);
  box-shadow: 0 1px 8px rgba(1, 13, 33, 0.06);
}

.sub-page-header-inner {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 24px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
}

.sub-page-header-flush .sub-page-header-inner {
  padding: 0 20px;
}
@media (max-width: 640px) {
  .sub-page-header-flush .sub-page-header-inner {
    padding: 0 12px;
  }
}

/* Left: logo + breadcrumb */
.sph-left {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  overflow: hidden;
}

.sph-logo-icon {
  font-size: 1.4rem;
  width: 34px;
  height: 34px;
  background: linear-gradient(135deg, var(--accent), var(--accent-hover));
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.sph-logo-name {
  font-size: 1.05rem;
  font-weight: 800;
  color: var(--text-primary);
  letter-spacing: -0.4px;
  white-space: nowrap;
}

.sph-sep {
  color: var(--text-tertiary);
  font-size: 1rem;
  -webkit-user-select: none;
          user-select: none;
}

.sph-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Right: user name + theme toggle + back button */
.sph-right {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  flex-shrink: 0;
}

.sph-user {
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--text-secondary);
  background: var(--bg-tertiary);
  padding: 4px 10px;
  border-radius: var(--radius-xl);
  white-space: nowrap;
}

.sph-theme {
  background: none;
  border: none;
  cursor: pointer;
  width: 34px;
  height: 34px;
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  color: var(--text-secondary);
  transition: background 150ms;
}
.sph-theme:hover { background: var(--bg-tertiary); }

.sph-back {
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: 1.5px solid var(--border);
  color: var(--text-primary);
  font-size: 0.88rem;
  font-weight: 600;
  padding: 7px 14px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: background 150ms, border-color 150ms, color 150ms;
  white-space: nowrap;
}
.sph-back:hover {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--color-text-on-secondary);
}
.sph-back:hover svg { stroke: white; }
.sph-back svg { transition: stroke 150ms; }

.sph-mobile-user { display: none; }
.sph-mobile-username { font-size: 1.05rem; font-weight: 800; color: var(--text-primary); }

@media (max-width: 768px) {
  /* On pages that opt in (mobileShowName), swap the logo for the
     signed-in user's name + role instead of squeezing both into a
     narrow header row. */
  .sph-left.sph-mobile-name-mode .sph-logo-icon-wrap,
  .sph-left.sph-mobile-name-mode .sph-logo-name,
  .sph-left.sph-mobile-name-mode .sph-sep,
  .sph-left.sph-mobile-name-mode .sph-title {
    display: none;
  }
  .sph-left.sph-mobile-name-mode .sph-mobile-user {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  /* Avoid showing the name twice (it's already in sph-left now) */
  .sph-left.sph-mobile-name-mode ~ .sph-right .sph-user { display: none; }

  .sph-theme.sph-theme-hide-mobile { display: none; }
}

/* ═══════════════════════════════════════════════════════════
   Navbar "More" dropdown
   ═══════════════════════════════════════════════════════════ */
.nb-more-container {
  position: relative;
  padding-bottom: 10px;  /* bridges the gap so onMouseLeave doesn't fire mid-crossing */
}

.nb-more-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--text-secondary);
  padding: 8px 10px;
  border-radius: var(--radius-sm);
  transition: color 150ms, background 150ms;
  white-space: nowrap;
  height: 40px;
}
.nb-more-btn:hover,
.nb-more-btn.open {
  color: var(--accent);
  background: rgba(59, 130, 246, 0.07);
}
.nb-more-caret {
  flex-shrink: 0;
  transition: transform 200ms var(--ease-in-out);
}

/* Dropdown panel */
.nb-more-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  min-width: 240px;
  box-shadow: 0 8px 28px rgba(1, 13, 33, 0.13);
  z-index: 200;
  overflow: hidden;
  animation: slideDown 180ms ease-out;
}

.nb-more-heading {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: var(--text-tertiary);
  padding: 12px 18px 8px;
  border-bottom: 1px solid var(--border);
}

.nb-more-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 13px 18px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  font-size: 0.92rem;
  font-weight: 500;
  color: var(--text-primary);
  transition: background 130ms, color 130ms;
}
.nb-more-item:hover {
  background: var(--bg-tertiary);
  color: var(--accent);
}
.nb-more-item:hover .nb-more-icon svg {
  stroke: var(--accent);
}
.nb-more-item:last-child {
  border-radius: 0 0 var(--radius-sm) var(--radius-sm);
}

.nb-more-icon {
  width: 38px;
  height: 38px;
  border-radius: var(--radius-sm);
  background: var(--bg-tertiary);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 130ms;
}
.nb-more-item:hover .nb-more-icon {
  background: rgba(59, 130, 246, 0.1);
}
.nb-more-icon svg {
  color: var(--text-secondary);
  transition: stroke 130ms;
}

:root[data-theme="dark"] .nb-more-menu {
  box-shadow: 0 8px 28px rgba(1, 13, 33, 0.4);
}

/* ── Auth modal tabs ─────────────────────────────────────── */
.modal-auth-tabs {
  display: flex;
  border-bottom: 2px solid var(--border);
  margin: 24px 28px 0;
  gap: 0;
}

.modal-auth-tab {
  flex: 1 1;
  background: none;
  border: none;
  padding: 12px 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: color 150ms, border-color 150ms;
}

.modal-auth-tab:hover { color: var(--accent); }

.modal-auth-tab.active {
  color: var(--accent);
  border-bottom-color: var(--accent);
}

/* ═══════════════════════════════════════════════════════════════
   SELLER MANAGEMENT MODULE
═══════════════════════════════════════════════════════════════ */

.sl-root {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-height: 100%;
}

/* Sub-navigation */
.sl-subnav {
  display: flex;
  gap: 4px;
  padding: 0 0 20px;
  flex-wrap: wrap;
}
.sl-subnav-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  color: var(--text-secondary);
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 150ms;
  position: relative;
}
.sl-subnav-btn:hover {
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border-color: var(--accent);
}
.sl-subnav-btn.active {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--color-text-on-secondary);
}
.sl-subnav-badge {
  background: var(--danger);
  color: var(--color-text-on-primary);
  font-size: 0.7rem;
  font-weight: 700;
  padding: 1px 5px;
  border-radius: var(--radius-sm);
  min-width: 18px;
  text-align: center;
  line-height: 1.5;
}

/* Page wrapper */
.sl-page {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ── Stats Grid ── */
.sl-stats-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 14px;
}
@media (max-width: 1200px) { .sl-stats-grid { grid-template-columns: repeat(3, 1fr); } }
@media (max-width: 768px)  { .sl-stats-grid { grid-template-columns: repeat(2, 1fr); } }

.sl-stat-card {
  background: color-mix(in srgb, var(--sc, var(--color-secondary)) 9%, var(--bg-secondary));
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: var(--space-2);
  display: flex;
  gap: 12px;
  align-items: flex-start;
  border-top: 4px solid var(--sc, var(--color-secondary));
  box-shadow: var(--shadow-card);
}
.sl-stat-icon {
  font-size: 1.5rem;
  line-height: 1;
  flex-shrink: 0;
}
.sl-stat-body { flex: 1 1; min-width: 0; }
.sl-stat-label {
  font-size: 0.75rem;
  color: var(--text-secondary);
  margin: 0 0 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sl-stat-value {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}
.sl-stat-sub {
  font-size: 0.72rem;
  color: var(--text-secondary);
  margin: 2px 0 0;
}
.sl-stat-trend {
  font-size: 0.72rem;
  font-weight: 600;
  margin: 3px 0 0;
}

/* ── Charts ── */
.sl-charts-row {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: var(--space-2);
}
@media (max-width: 900px) { .sl-charts-row { grid-template-columns: 1fr; } }

.sl-chart-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 18px;
  box-shadow: var(--shadow-card);
}
.sl-chart-wide { grid-column: span 1; }
.sl-chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}
.sl-chart-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}
.sl-chart-wide .sl-chart-title {
  font-size: 1.3rem;
  font-weight: 700;
}
.sl-chart-period {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-secondary);
  background: var(--bg-tertiary);
  border-radius: var(--radius-xl);
  padding: 6px 14px;
}

.sl-status-mini-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  margin-bottom: 20px;
}
@media (max-width: 700px) { .sl-status-mini-row { grid-template-columns: 1fr; } }

.sl-status-mini {
  display: flex;
  align-items: center;
  gap: 14px;
  background: color-mix(in srgb, var(--smc, var(--accent)) 9%, var(--bg-secondary));
  border: 1px solid color-mix(in srgb, var(--smc, var(--accent)) 22%, var(--border));
  border-radius: var(--radius-lg);
  padding: 16px 18px;
}

.sl-status-mini-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--smc, var(--accent));
  color: var(--color-brand-white);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 800;
  flex-shrink: 0;
}

.sl-status-mini-label {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 2px;
}

.sl-status-mini-value {
  font-size: 1.6rem;
  font-weight: 800;
  color: var(--smc, var(--accent));
  margin: 0;
  line-height: 1;
}
.sl-chart-tip {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 8px 12px;
  font-size: 0.82rem;
  box-shadow: var(--shadow-card);
}
.sl-chart-tip-label {
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 4px;
}

/* ── Card ── */
.sl-card {
  background: var(--bg-primary);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: 0 1px 6px rgba(1, 13, 33,0.06);
}
.sl-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid var(--border);
}
.sl-card-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

/* ── Table ── */
.sl-table-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.sl-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.86rem;
}
.sl-table th {
  padding: 11px 20px;
  text-align: left;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--text-secondary);
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border);
  white-space: nowrap;
}
.sl-table td {
  padding: 14px 20px;
  border-bottom: 1px solid var(--border);
  color: var(--text-primary);
  vertical-align: middle;
}
.sl-table tbody tr:last-child td { border-bottom: none; }
.sl-tr-hover { transition: background 120ms; }
.sl-tr-hover:hover td { background: var(--bg-secondary); }

/* ── Seller cell ── */
.sl-seller-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}
.sl-avatar {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  background: linear-gradient(135deg, rgba(59, 130, 246,0.12), rgba(59, 130, 246,0.04));
  border: 1px solid rgba(59, 130, 246,0.18);
  border-radius: var(--radius-sm);
  flex-shrink: 0;
}
.sl-avatar-lg {
  width: 52px;
  height: 52px;
  font-size: 1.7rem;
  border-radius: var(--radius-sm);
}

/* An uploaded logo fills the frame the emoji would otherwise sit in. */
.sl-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Defence in depth. These boxes are a fixed 40/52/64px but had no overflow
   rule, so any content wider than the box simply painted over whatever sat
   beside it -- which is how an /uploads path rendered as text came to spill
   across an entire seller application card. Clipping here means the worst a
   bad value can do now is look wrong inside its own frame. */
.sl-avatar,
.sl-avatar-lg,
.sl-profile-avatar {
  overflow: hidden;
}
.sl-seller-name {
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  line-height: 1.3;
}
.sl-seller-sub {
  font-size: 0.78rem;
  color: var(--text-secondary);
  margin: 2px 0 0;
}
.sl-seller-bio {
  font-size: 0.8rem;
  color: var(--text-secondary);
  margin: 4px 0 0;
  max-width: 340px;
}

/* ── Badges / chips ── */
.sl-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: var(--radius-xl);
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--bc, var(--text-muted));
  background: color-mix(in srgb, var(--bc, var(--text-muted)) 12%, transparent);
  border: 1px solid color-mix(in srgb, var(--bc, var(--text-muted)) 25%, transparent);
  white-space: nowrap;
}
.sl-badge::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--bc, var(--text-muted));
  flex-shrink: 0;
}
.sl-verified {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: var(--radius-xl);
  font-size: 0.72rem;
  font-weight: 600;
  white-space: nowrap;
}
.sl-cat-chip {
  display: inline-flex;
  padding: 4px 10px;
  border-radius: var(--radius-xl);
  font-size: 0.76rem;
  font-weight: 600;
  background: rgba(59, 130, 246,0.1);
  color: var(--color-secondary);
  border: 1px solid rgba(59, 130, 246,0.2);
  white-space: nowrap;
}
.sl-stars {
  display: inline-flex;
  align-items: center;
  gap: 1px;
  font-size: 0.85rem;
}

/* Numbers and color helpers */
.sl-num    { text-align: right; font-variant-numeric: tabular-nums; font-size: 0.9rem; }
/* Right-align numeric-column headers so the label sits over its right-aligned
   values (default .sl-table th is left-aligned, which left the header text
   floating to the left of the numbers). */
.sl-table th.sl-num { text-align: right; font-size: 0.72rem; }
.sl-positive  { color: var(--color-secondary); font-weight: 700; }
.sl-info { color: var(--color-secondary); font-weight: 700; }
[data-theme='dark'] .sl-positive  { color: var(--color-secondary); }
[data-theme='dark'] .sl-info { color: var(--color-secondary); }
.sl-yellow { color: var(--color-primary); font-weight: 600; }
.sl-orange { color: var(--color-primary); font-weight: 600; }
.sl-muted  { color: var(--text-secondary); }
.sl-empty  { text-align: center; color: var(--text-secondary); font-size: 0.88rem; padding: 40px 0; }

/* ── Filter bar ── */
.sl-filter-bar {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}
.sl-search-wrap {
  flex: 1 1;
  min-width: 200px;
  position: relative;
  display: flex;
  align-items: center;
}
.sl-search-ico {
  position: absolute;
  left: 10px;
  color: var(--text-secondary);
  pointer-events: none;
}
.sl-search-input {
  width: 100%;
  padding: 8px 12px 8px 34px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  color: var(--text-primary);
  font-size: 0.85rem;
  outline: none;
  transition: border-color 150ms;
}
.sl-search-input:focus { border-color: var(--accent); }
.sl-search-input::placeholder { color: var(--text-secondary); }
.sl-filter-chips { display: flex; gap: 6px; }
.sl-chip {
  padding: 6px 12px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  color: var(--text-secondary);
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 150ms;
}
.sl-chip:hover { border-color: var(--accent); color: var(--accent); }
.sl-chip.active { background: var(--accent); border-color: var(--accent); color: var(--color-text-on-secondary); }
.sl-select {
  padding: 7px 10px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  color: var(--text-primary);
  font-size: 0.82rem;
  cursor: pointer;
  outline: none;
}
.sl-count-label {
  font-size: 0.8rem;
  color: var(--text-secondary);
  white-space: nowrap;
}

/* ── Actions ── */
.sl-action-row { display: flex; gap: 6px; }
.sl-action-btn {
  padding: 5px 10px;
  border-radius: var(--radius-xs);
  font-size: 0.77rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: opacity 150ms, transform 80ms;
}
.sl-action-btn:hover { opacity: 0.85; transform: translateY(-1px); }
.sl-btn-view { background: rgba(59, 130, 246,0.15); color: var(--color-secondary); }
.sl-btn-ok   { background: rgba(59, 130, 246,0.15);  color: var(--color-secondary); }
.sl-btn-warn { background: rgba(255, 103, 0,0.15);   color: var(--color-primary); }

.sl-link-btn {
  background: none;
  border: none;
  color: var(--accent);
  font-size: 0.85rem;
  font-weight: 700;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: var(--radius-sm);
  transition: background 150ms;
}
.sl-link-btn:hover { background: rgba(59, 130, 246,0.08); text-decoration: none; }

/* Primary / danger / ghost buttons */
.sl-btn-primary {
  padding: 8px 16px;
  background: var(--accent);
  color: var(--color-text-on-secondary);
  border: none;
  border-radius: var(--radius-sm);
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 150ms, transform 80ms;
  white-space: nowrap;
}
.sl-btn-primary:hover { opacity: 0.88; transform: translateY(-1px); }
.sl-btn-danger {
  padding: 8px 16px;
  background: rgba(255, 103, 0,0.15);
  color: var(--color-primary);
  border: 1px solid rgba(255, 103, 0,0.3);
  border-radius: var(--radius-sm);
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 150ms;
}
.sl-btn-danger:hover { background: rgba(255, 103, 0,0.25); }
.sl-btn-ghost {
  padding: 8px 16px;
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: 0.82rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 150ms;
  white-space: nowrap;
}
.sl-btn-ghost:hover { background: var(--bg-secondary); color: var(--text-primary); border-color: var(--accent); }
.sl-btn-warn { background: rgba(255, 103, 0,0.15); color: var(--color-primary); border: none; }
.sl-btn-ok   { background: rgba(59, 130, 246,0.15); color: var(--color-secondary); border: none; }
.sl-btn-lg { padding: 10px 20px; font-size: 0.9rem; }

/* ── Seller Profile ── */
.sl-profile-header {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  overflow: hidden;
  box-shadow: var(--shadow-card);
}
.sl-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 12px 20px;
  background: none;
  border: none;
  border-bottom: 1px solid var(--border);
  color: var(--accent);
  font-size: 0.84rem;
  font-weight: 500;
  cursor: pointer;
  width: 100%;
  text-align: left;
}
.sl-back-btn:hover { background: var(--bg-tertiary); }
.sl-profile-hero {
  display: flex;
  gap: 20px;
  padding: 20px;
  align-items: flex-start;
  flex-wrap: wrap;
}
.sl-profile-avatar {
  width: 64px;
  height: 64px;
  font-size: 2.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-tertiary);
  border-radius: var(--radius-md);
  flex-shrink: 0;
}
.sl-profile-info { flex: 1 1; min-width: 200px; }
.sl-profile-name-row {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  flex-wrap: wrap;
  margin-bottom: 6px;
}
.sl-profile-store {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}
.sl-profile-owner {
  font-size: 0.82rem;
  color: var(--text-secondary);
  margin: 0 0 4px;
}
.sl-profile-meta {
  font-size: 0.8rem;
  color: var(--text-secondary);
  margin: 0 0 6px;
}
.sl-profile-bio {
  font-size: 0.84rem;
  color: var(--text-secondary);
  margin: 0;
}
.sl-profile-actions {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  flex-shrink: 0;
  min-width: 160px;
}
.sl-profile-stats {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  border-top: 1px solid var(--border);
}
@media (max-width: 900px) { .sl-profile-stats { grid-template-columns: repeat(3, 1fr); } }
.sl-pstat {
  padding: 14px 16px;
  text-align: center;
  border-right: 1px solid var(--border);
}
.sl-pstat:last-child { border-right: none; }
.sl-pstat-val {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}
.sl-pstat-label {
  font-size: 0.72rem;
  color: var(--text-secondary);
  margin: 2px 0 0;
}

/* Profile sub-tabs */
.sl-profile-tabs {
  display: flex;
  gap: 4px;
  border-bottom: 2px solid var(--border);
  padding: 0;
  flex-wrap: wrap;
}
.sl-profile-tab {
  padding: 10px 18px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  color: var(--text-secondary);
  font-size: 0.86rem;
  font-weight: 500;
  cursor: pointer;
  transition: color 150ms, border-color 150ms;
  white-space: nowrap;
}
.sl-profile-tab:hover { color: var(--text-primary); }
.sl-profile-tab.active { color: var(--accent); border-bottom-color: var(--accent); font-weight: 600; }

/* Category performance bars */
.sl-cat-perf { display: flex; flex-direction: column; gap: 12px; padding: 4px 0; }
.sl-cat-row  { display: flex; align-items: center; gap: 10px; }
.sl-cat-name { font-size: 0.8rem; color: var(--text-secondary); width: 80px; flex-shrink: 0; }
.sl-cat-bar-wrap { flex: 1 1; height: 6px; background: var(--bg-tertiary); border-radius: var(--radius-xs); overflow: hidden; }
.sl-cat-bar { height: 100%; border-radius: var(--radius-xs); transition: width 600ms ease; }
.sl-cat-val { font-size: 0.78rem; color: var(--text-secondary); width: 60px; text-align: right; flex-shrink: 0; }

/* Documents */
.sl-docs-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  padding: var(--space-2);
}
@media (max-width: 700px) { .sl-docs-grid { grid-template-columns: 1fr; } }
.sl-doc-card {
  background: var(--bg-tertiary);
  border: 1px solid var(--ds, var(--border));
  border-radius: var(--radius-sm);
  padding: var(--space-2);
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: var(--shadow-card);
}
.sl-doc-icon { font-size: 1.8rem; line-height: 1; }
.sl-doc-info { flex: 1 1; }
.sl-doc-name { font-size: 0.86rem; font-weight: 600; color: var(--text-primary); margin: 0 0 2px; }
.sl-doc-date { font-size: 0.75rem; color: var(--text-secondary); margin: 0; }
.sl-doc-actions { display: flex; gap: 6px; }

/* Approval */
.sl-approval-banner {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: 20px;
  background: linear-gradient(135deg, rgba(255, 103, 0,0.15), rgba(255, 103, 0,0.1));
  border: 1px solid rgba(255, 103, 0,0.3);
  border-radius: var(--radius-sm);
}
.sl-approval-count {
  font-size: 2.5rem;
  font-weight: 800;
  color: var(--color-primary);
  line-height: 1;
}
.sl-approval-title { font-size: 1rem; font-weight: 700; color: var(--text-primary); margin: 0; }
.sl-approval-sub   { font-size: 0.82rem; color: var(--text-secondary); margin: 2px 0 0; }

.sl-approval-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 20px;
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 20px;
  align-items: start;
  box-shadow: var(--shadow-card);
}
@media (max-width: 800px) { .sl-approval-card { grid-template-columns: 1fr; 
  box-shadow: var(--shadow-card);
} }
.sl-approval-left { display: flex; gap: 14px; align-items: flex-start; }
.sl-approval-docs { display: flex; flex-direction: column; gap: var(--space-1); min-width: 200px; }
.sl-approval-doc-title { font-size: 0.78rem; font-weight: 600; color: var(--text-secondary); text-transform: uppercase; letter-spacing: 0.05em; margin: 0 0 2px; }
.sl-approval-doc-row { display: flex; align-items: center; gap: var(--space-1); font-size: 0.82rem; }
.sl-approval-actions { display: flex; flex-direction: column; gap: var(--space-1); min-width: 160px; }

/* Approval tabs (Pending / Waitlist / Rejected) */
.sl-approval-tabs {
  display: flex;
  gap: 6px;
}
.sl-approval-tab {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  padding: 8px 18px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  color: var(--text-secondary);
  font-size: 0.84rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 150ms;
}
.sl-approval-tab:hover { border-color: var(--tc, var(--accent)); color: var(--text-primary); }
.sl-approval-tab.active { background: color-mix(in srgb, var(--tc, var(--accent)) 12%, transparent); border-color: var(--tc, var(--accent)); color: var(--tc, var(--accent)); font-weight: 600; }
.sl-approval-tab-badge { font-size: 0.7rem; font-weight: 700; color: var(--color-brand-white); padding: 1px 6px; border-radius: var(--radius-sm); }

/* Waitlist button */
.sl-btn-waitlist {
  padding: 8px 16px;
  background: rgba(59, 130, 246,0.15);
  color: var(--color-secondary);
  border: 1px solid rgba(59, 130, 246,0.3);
  border-radius: var(--radius-sm);
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 150ms;
  white-space: nowrap;
}
.sl-btn-waitlist:hover { background: rgba(59, 130, 246,0.25); }

/* ═══════════════════════════════════════════════════════════════
   SELLER REGISTRATION FORM
═══════════════════════════════════════════════════════════════ */

.sr-page {
  min-height: 100vh;
  background: var(--bg-primary);
  display: flex;
  flex-direction: column;
}
.sr-container {
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  padding: 32px 24px 60px;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  box-sizing: border-box;
}
@media (max-width: 640px) {
  .sr-container { padding: 24px 12px 48px; }
}

/* Header */
.sr-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-card);
}
.sr-header-brand { display: flex; align-items: center; gap: 12px; }
.sr-header-logo  { font-size: 1.8rem; line-height: 1; }
.sr-header-store { font-weight: 700; color: var(--text-primary); margin: 0; font-size: 1rem; }
.sr-header-sub   { font-size: 0.78rem; color: var(--text-secondary); margin: 0; }
.sr-close-btn {
  padding: 7px 14px;
  background: none;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  color: var(--text-secondary);
  font-size: 0.82rem;
  cursor: pointer;
  transition: all 150ms;
}
.sr-close-btn:hover { border-color: var(--color-primary); color: var(--color-primary); }

/* Progress */
.sr-progress-wrap { display: flex; flex-direction: column; gap: 12px; }
.sr-progress-bar-bg {
  height: 5px;
  background: var(--bg-tertiary);
  border-radius: var(--radius-xs);
  overflow: hidden;
}
.sr-progress-bar-fill {
  height: 100%;
  background: var(--accent);
  border-radius: var(--radius-xs);
  transition: width 400ms ease;
}
.sr-progress-steps {
  display: flex;
  justify-content: space-between;
  gap: 4px;
}
.sr-progress-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex: 1 1;
  opacity: 0.4;
  transition: opacity 200ms;
}
.sr-progress-step.active, .sr-progress-step.done { opacity: 1; }
.sr-progress-dot {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 700;
  background: var(--bg-secondary);
  border: 2px solid var(--border);
  color: var(--text-secondary);
  transition: all 200ms;
}
.sr-progress-step.active .sr-progress-dot {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--color-text-on-secondary);
}
.sr-progress-step.done .sr-progress-dot {
  background: var(--color-secondary);
  border-color: var(--color-secondary);
  color: var(--color-text-on-secondary);
}
.sr-progress-label {
  font-size: 0.68rem;
  color: var(--text-secondary);
  text-align: center;
  line-height: 1.2;
  white-space: nowrap;
}
@media (max-width: 600px) { .sr-progress-label { display: none; } }

/* Card */
.sr-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-card);
}
.sr-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid var(--border);
  background: var(--bg-tertiary);
}
.sr-card-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}
.sr-step-count { font-size: 0.8rem; color: var(--text-secondary); }

/* Step body */
.sr-step-body { padding: var(--space-3); display: flex; flex-direction: column; gap: 18px; }
.sr-step-intro { font-size: 0.88rem; color: var(--text-secondary); margin: 0; }

/* Fields */
.sr-field { display: flex; flex-direction: column; gap: 5px; }
.sr-label { font-size: 0.83rem; font-weight: 600; color: var(--text-primary); }
.sr-req   { color: var(--color-primary); margin-left: 3px; }
.sr-hint  { font-size: 0.76rem; color: var(--text-secondary); margin: 0; }
.sr-field-err { font-size: 0.76rem; color: var(--color-primary); margin: 0; }
.sr-char-count { font-size: 0.72rem; color: var(--text-secondary); text-align: right; margin: 2px 0 0; }

.sr-input, .sr-select, .sr-textarea {
  padding: 10px 13px;
  background: var(--bg-primary);
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  color: var(--text-primary);
  font-size: 0.88rem;
  outline: none;
  transition: border-color 150ms, box-shadow 150ms;
  width: 100%;
  box-sizing: border-box;
  font-family: inherit;
}
.sr-input:focus, .sr-select:focus, .sr-textarea:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(59, 130, 246,0.12);
}
.sr-input.err, .sr-select.err, .sr-textarea.err { border-color: var(--color-primary); }
.sr-input::placeholder, .sr-textarea::placeholder { color: var(--text-secondary); opacity: 0.65; }
.sr-textarea { resize: vertical; min-height: 100px; }
.sr-select { cursor: pointer; appearance: none; background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); background-repeat: no-repeat; background-position: right 10px center; padding-right: 34px; }
/* Seller signup is a five-field form on a phone, each field 38px tall.
   Deliberately not applied to .sr-textarea, which sizes from its rows. */
@media (max-width: 768px) {
  .sr-input, .sr-select { min-height: 44px; }
}

/* Seller application: clear light-blue form definition. */
.sr-header,
.sr-card {
  border: 1.5px solid var(--color-secondary-soft);
}
.sr-card-header { border-bottom-color: var(--color-secondary-soft); }
.sr-input,
.sr-select,
.sr-textarea {
  border-color: var(--color-secondary);
  background: var(--bg-secondary);
}
.sr-input:hover,
.sr-select:hover,
.sr-textarea:hover { border-color: var(--color-secondary); }
.sr-input:focus,
.sr-select:focus,
.sr-textarea:focus {
  border-color: var(--color-secondary-hover);
  box-shadow: 0 0 0 3px rgba(59,130,246,0.16);
}
.sr-radio-card,
.sr-payout-card,
.sr-review-section,
.sr-check-row {
  border-color: var(--color-secondary-soft);
}
.sr-header-logo {
  width: 42px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 9px;
}
.sr-header-logo img { width: 40px !important; height: 40px !important; object-fit: contain; }
.sr-header-sub { white-space: nowrap; font-size: 0.7rem; }

.sr-logo-upload {
  min-height: 82px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  border: 1.5px dashed var(--color-secondary);
  border-radius: 10px;
  background: color-mix(in srgb, var(--color-secondary) 5%, var(--bg-secondary));
}
.sr-logo-preview {
  width: 62px;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 62px;
  overflow: hidden;
  color: var(--color-secondary);
  background: var(--bg-primary);
  border: 1px solid var(--color-secondary-soft);
  border-radius: 12px;
}
.sr-logo-preview img { width: 100%; height: 100%; object-fit: cover; }
.sr-logo-upload-actions { display: flex; align-items: center; flex-wrap: wrap; gap: 7px; min-width: 0; }
.sr-logo-upload-btn,
.sr-logo-remove-btn {
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 11px;
  border-radius: 8px;
  font: inherit;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}
.sr-logo-upload-btn { color: var(--color-text-on-secondary); background: var(--color-secondary-hover); border: 1px solid var(--color-secondary-hover); }
.sr-logo-upload-btn.uploading { opacity: 0.65; cursor: wait; }
.sr-logo-remove-btn { color: var(--color-primary); background: transparent; border: 1px solid var(--color-primary); }
.sr-logo-upload-actions .sr-field-err { flex-basis: 100%; }

@media (max-width: 520px) {
  .sr-logo-upload { align-items: flex-start; }
  .sr-header-sub { font-size: 0.62rem; }
}

.sr-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
@media (max-width: 560px) { .sr-grid-2 { grid-template-columns: 1fr; } }

/* Avatar picker */
.sr-avatar-grid { display: flex; flex-wrap: wrap; gap: 6px; }
.sr-avatar-btn {
  width: 36px;
  height: 36px;
  font-size: 1.2rem;
  background: var(--bg-primary);
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 150ms;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sr-avatar-btn:hover { border-color: var(--accent); transform: scale(1.1); }
.sr-avatar-btn.selected { border-color: var(--accent); background: rgba(59, 130, 246,0.12); }

/* Radio cards */
.sr-radio-group { display: flex; flex-direction: column; gap: 10px; }
.sr-radio-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  background: var(--bg-primary);
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 150ms;
}
.sr-radio-card:hover { border-color: var(--accent); }
.sr-radio-card.selected { border-color: var(--accent); background: rgba(59, 130, 246,0.07); }
.sr-radio-input { display: none; }
.sr-radio-icon  { font-size: 1.4rem; flex-shrink: 0; }
.sr-radio-label { font-size: 0.88rem; font-weight: 600; color: var(--text-primary); margin: 0; }
.sr-radio-desc  { font-size: 0.76rem; color: var(--text-secondary); margin: 2px 0 0; }

/* Payout method cards */
.sr-payout-methods { display: flex; gap: 10px; flex-wrap: wrap; }
.sr-payout-card {
  flex: 1 1;
  min-width: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-1);
  padding: 16px 12px;
  background: var(--bg-primary);
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 150ms;
}
.sr-payout-card:hover { border-color: var(--accent); }
.sr-payout-card.selected { border-color: var(--accent); background: rgba(59, 130, 246,0.07); }
.sr-payout-icon  { font-size: 1.6rem; }
.sr-payout-label { font-size: 0.82rem; font-weight: 600; color: var(--text-primary); }

/* Info box */
.sr-info-box {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 12px 16px;
  background: rgba(59, 130, 246,0.08);
  border: 1px solid rgba(59, 130, 246,0.2);
  border-radius: var(--radius-sm);
  font-size: 0.83rem;
  color: var(--text-secondary);
  line-height: 1.5;
}
.sr-info-stripe { background: rgba(255, 103, 0,0.08); border-color: rgba(255, 103, 0,0.2); }
.sr-info-icon { font-size: 1rem; flex-shrink: 0; margin-top: 1px; }

/* Commission box */
.sr-commission-box {
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  overflow: hidden;
  box-shadow: var(--shadow-card);
}
.sr-commission-header {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  padding: 12px 16px;
  font-size: 0.88rem;
  font-weight: 700;
  color: var(--text-primary);
  border-bottom: 1px solid var(--border);
}
.sr-commission-rows { display: flex; flex-direction: column; }
.sr-commission-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  font-size: 0.84rem;
  border-bottom: 1px solid var(--border);
}
.sr-commission-row:last-child { border-bottom: none; }
.sr-commission-row span { color: var(--text-secondary); }
.sr-commission-row strong { color: var(--text-primary); }

/* Review section */
.sr-review-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
@media (max-width: 560px) { .sr-review-grid { grid-template-columns: 1fr; } }
.sr-review-section {
  background: var(--bg-primary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  overflow: hidden;
}
.sr-review-section-title {
  padding: 10px 14px;
  font-size: 0.76rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-secondary);
  background: var(--bg-tertiary);
  border-bottom: 1px solid var(--border);
  margin: 0;
}
.sr-review-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 14px;
  font-size: 0.82rem;
  border-bottom: 1px solid var(--border);
}
.sr-review-row:last-child { border-bottom: none; }
.sr-review-label { color: var(--text-secondary); flex-shrink: 0; }
.sr-review-val   { color: var(--text-primary); font-weight: 500; text-align: right; word-break: break-all; }

/* Agreements */
.sr-agreements { display: flex; flex-direction: column; gap: 10px; }
.sr-check-row {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  cursor: pointer;
  font-size: 0.84rem;
  color: var(--text-primary);
  line-height: 1.5;
}
.sr-check-row.err { color: var(--color-primary); }
.sr-checkbox {
  width: 17px;
  height: 17px;
  flex-shrink: 0;
  margin-top: 2px;
  accent-color: var(--accent);
  cursor: pointer;
}
.sr-link { color: var(--accent); text-decoration: underline; cursor: pointer; }

/* Footer nav */
.sr-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-top: 1px solid var(--border);
  background: var(--bg-tertiary);
}
.sr-btn-back {
  padding: 10px 20px;
  background: none;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  color: var(--text-secondary);
  font-size: 0.88rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 150ms;
}
.sr-btn-back:hover { border-color: var(--accent); color: var(--text-primary); }
.sr-btn-next {
  padding: 10px 28px;
  background: var(--accent);
  border: none;
  border-radius: var(--radius-sm);
  color: var(--color-text-on-secondary);
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 150ms, transform 80ms;
}
.sr-btn-next:hover { opacity: 0.88; transform: translateY(-1px); }
.sr-btn-submit {
  padding: 10px 28px;
  background: linear-gradient(135deg, var(--color-secondary), color-mix(in srgb, var(--color-secondary) 80%, var(--color-brand-navy)));
  border: none;
  border-radius: var(--radius-sm);
  color: var(--color-brand-white);
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 150ms, transform 80ms;
  display: flex;
  align-items: center;
  gap: var(--space-1);
}
.sr-btn-submit:hover:not(:disabled) { opacity: 0.88; transform: translateY(-1px); }
.sr-btn-submit:disabled { opacity: 0.6; cursor: not-allowed; }
.sr-spinner { display: inline-block; animation: sr-spin 0.8s linear infinite; }
@keyframes sr-spin { to { transform: rotate(360deg); } }

/* Success screen */
.sr-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 24px;
  gap: 20px;
  max-width: 560px;
  margin: 0 auto;
}
.sr-success-icon { font-size: 4rem; }
.sr-success-title { font-size: 1.6rem; font-weight: 800; color: var(--text-primary); margin: 0; }
.sr-success-sub { font-size: 0.92rem; color: var(--text-secondary); margin: 0; }
.sr-success-card {
  width: 100%;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  overflow: hidden;
  box-shadow: var(--shadow-card);
}
.sr-success-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 18px;
  font-size: 0.86rem;
  border-bottom: 1px solid var(--border);
  color: var(--text-secondary);
}
.sr-success-row:last-child { border-bottom: none; }
.sr-app-id { font-family: monospace; font-size: 0.9rem; color: var(--accent); letter-spacing: 0.08em; }
.sr-success-steps {
  width: 100%;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  overflow: hidden;
  text-align: left;
  box-shadow: var(--shadow-card);
}
.sr-success-steps-title {
  padding: 14px 18px;
  font-size: 0.86rem;
  font-weight: 700;
  color: var(--text-primary);
  border-bottom: 1px solid var(--border);
  margin: 0;
}
.sr-success-step {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 12px 18px;
  border-bottom: 1px solid var(--border);
}
.sr-success-step:last-child { border-bottom: none; }
.sr-success-step-num {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--accent);
  color: var(--color-text-on-secondary);
  font-size: 0.75rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.sr-success-step-label { font-size: 0.85rem; font-weight: 600; color: var(--text-primary); margin: 0; }
.sr-success-step-desc  { font-size: 0.78rem; color: var(--text-secondary); margin: 2px 0 0; }
.sr-success-home-btn {
  padding: 12px 32px;
  background: var(--accent);
  border: none;
  border-radius: var(--radius-sm);
  color: var(--color-text-on-secondary);
  font-size: 0.92rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 150ms, transform 80ms;
}
.sr-success-home-btn:hover { opacity: 0.88; transform: translateY(-1px); }

/* Success screen actions row */
.sr-success-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}
.sr-success-track-btn {
  padding: 12px 28px;
  background: var(--bg-secondary);
  border: 1.5px solid var(--accent);
  border-radius: var(--radius-sm);
  color: var(--accent);
  font-size: 0.92rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 150ms;
}
.sr-success-track-btn:hover { background: rgba(59, 130, 246,0.08); transform: translateY(-1px); }

/* ═══════════════════════════════════════════════════════════════
   APPLICATION TRACKER
═══════════════════════════════════════════════════════════════ */

.at-page {
  min-height: 100vh;
  background: var(--bg-primary);
}
.at-container {
  max-width: 640px;
  margin: 0 auto;
  padding: 28px 20px 60px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Header */
.at-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-card);
}
.at-back-btn {
  padding: 7px 14px;
  background: none;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  color: var(--text-secondary);
  font-size: 0.82rem;
  cursor: pointer;
  transition: all 150ms;
  white-space: nowrap;
}
.at-back-btn:hover { border-color: var(--accent); color: var(--accent); }
.at-header-brand { display: flex; align-items: center; gap: 10px; }
.at-header-store { font-weight: 700; color: var(--text-primary); margin: 0; font-size: 0.95rem; }
.at-header-sub   { font-size: 0.74rem; color: var(--text-secondary); margin: 0; }

/* Search card */
.at-search-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 28px 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: var(--shadow-card);
}
.at-search-label {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}
.at-search-hint {
  font-size: 0.83rem;
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.5;
}
.at-input-row {
  display: flex;
  gap: 10px;
  margin-top: 4px;
}
.at-input {
  flex: 1 1;
  padding: 11px 16px;
  background: var(--bg-primary);
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  color: var(--text-primary);
  font-size: 1rem;
  font-weight: 600;
  font-family: monospace;
  letter-spacing: 0.06em;
  outline: none;
  transition: border-color 150ms, box-shadow 150ms;
}
.at-input:focus { border-color: var(--accent); box-shadow: 0 0 0 3px rgba(59, 130, 246,0.12); }
.at-input.err   { border-color: var(--color-primary); }
.at-input::placeholder { font-weight: 400; letter-spacing: 0.02em; color: var(--text-secondary); opacity: 0.65; }
.at-search-btn {
  padding: 11px 22px;
  background: var(--accent);
  border: none;
  border-radius: var(--radius-sm);
  color: var(--color-text-on-secondary);
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 150ms, transform 80ms;
}
.at-search-btn:hover:not(:disabled) { opacity: 0.88; transform: translateY(-1px); }
.at-search-btn:disabled { opacity: 0.45; cursor: not-allowed; }
.at-input-err { font-size: 0.78rem; color: var(--color-primary); margin: 0; }

/* Result */
.at-result {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* Status banner */
.at-status-banner {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: 18px 20px;
  border: 1.5px solid;
  border-radius: var(--radius-sm);
  position: relative;
  overflow: hidden;
}
.at-status-icon { font-size: 2rem; line-height: 1; flex-shrink: 0; }
.at-status-text { flex: 1 1; }
.at-status-label { font-size: 1.15rem; font-weight: 800; margin: 0; }
.at-status-appid { font-size: 0.8rem; font-family: monospace; letter-spacing: 0.06em; color: var(--text-secondary); margin: 2px 0 0; }
.at-status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  animation: at-pulse 2s ease-in-out infinite;
  flex-shrink: 0;
}
@keyframes at-pulse { 0%,100% { opacity: 1; transform: scale(1); } 50% { opacity: 0.5; transform: scale(1.4); } }

/* Info card */
.at-info-card {
  display: flex;
  gap: 14px;
  align-items: center;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: var(--space-2);
  box-shadow: var(--shadow-card);
}
.at-info-avatar { font-size: 2rem; width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; background: var(--bg-tertiary); border-radius: var(--radius-sm); flex-shrink: 0; }
.at-info-store  { font-size: 1rem; font-weight: 700; color: var(--text-primary); margin: 0; }
.at-info-meta   { font-size: 0.8rem; color: var(--text-secondary); margin: 2px 0 0; }
.at-info-date   { font-size: 0.78rem; color: var(--text-secondary); margin: 3px 0 0; }

/* Message box */
.at-message-box {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-left: 4px solid;
  border-radius: var(--radius-sm);
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-shadow: var(--shadow-card);
}
.at-message { font-size: 0.88rem; color: var(--text-primary); margin: 0; }
.at-next    { font-size: 0.83rem; color: var(--text-secondary); margin: 0; }

.at-upload-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: var(--shadow-card);
}
.at-upload-title { margin: 0 0 10px; font-size: 0.88rem; font-weight: 600; color: var(--text-primary); }

/* Timeline */
.at-timeline-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 18px;
  box-shadow: var(--shadow-card);
}
.at-timeline-title {
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-secondary);
  margin: 0 0 16px;
}
.at-timeline {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.at-timeline-row {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}
.at-timeline-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
}
.at-timeline-dot {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid var(--border);
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  font-size: 0.75rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 200ms;
  flex-shrink: 0;
}
.at-timeline-dot.active { border-width: 2.5px; }
.at-timeline-line {
  width: 2px;
  height: 28px;
  background: var(--border);
  margin: 3px 0;
  transition: background 200ms;
}
.at-timeline-line.done { background: inherit; }
.at-timeline-label {
  font-size: 0.86rem;
  font-weight: 500;
  padding: 4px 0 28px;
  margin: 0;
  transition: color 200ms;
}
.at-timeline-row:last-child .at-timeline-label { padding-bottom: 0; }

/* Contact note */
.at-contact-note {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 12px 16px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: 0.82rem;
  color: var(--text-secondary);
  line-height: 1.5;
  box-shadow: var(--shadow-card);
}

/* Not found */
.at-not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 40px 20px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  text-align: center;
  box-shadow: var(--shadow-card);
}
.at-nf-icon  { font-size: 2.5rem; }
.at-nf-title { font-size: 1rem; font-weight: 700; color: var(--text-primary); margin: 0; }
.at-nf-sub   { font-size: 0.83rem; color: var(--text-secondary); margin: 0; }

/* Help cards */
.at-help-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
@media (max-width: 560px) { .at-help-row { grid-template-columns: 1fr; } }
.at-help-card {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: var(--space-2);
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: 1.4rem;
  box-shadow: var(--shadow-card);
}
.at-help-title { font-size: 0.84rem; font-weight: 600; color: var(--text-primary); margin: 0 0 4px; }
.at-help-desc  { font-size: 0.78rem; color: var(--text-secondary); margin: 0; line-height: 1.5; }




/* ════════════════════════════════════════════════════════
   SHOP LAYOUT — filters + products
   ════════════════════════════════════════════════════════ */

.shop-layout {
  display: grid;
  grid-template-columns: 240px 1fr;
  align-items: start;
  background: var(--bg-primary);
  min-height: calc(100vh - 160px);
}
/* That min-height holds the row open to roughly a screenful, which is what
   stops a short result set leaving a mostly-empty page. With the sidebar
   present it does the opposite on a tall screen: align-items:start pins both
   columns to the top, so on a 1366px iPad the row is stretched to ~1206px
   while the filter card is ~807px and the leftover ~400px reads as a gap
   under the filters. A 900px laptop never shows it because there the row is
   ~740px and the card is taller than it. Below 900px the sidebar is hidden
   and the main column is the whole page, where holding the row open is still
   worth doing -- so this only lifts the floor where the sidebar exists. */
@media (min-width: 901px) {
  .shop-layout { min-height: 0; }
}

/* ── Left filter sidebar ─────────────────────────────── */
/* .shop-filters is a transparent sticky positioning shell only — its
   height is whatever's left of the viewport, which is usually taller
   than the filter content. Giving IT the background/border would leave
   a big empty box trailing below the actual controls while stuck mid-scroll.
   .sf-card carries the visible card styling and is sized to its own content. */
.shop-filters {
  position: sticky;
  top: var(--topbar-h, 164px);
  max-height: calc(100vh - var(--topbar-h, 164px));
  overflow-y: auto;
  padding: 16px;
  scrollbar-width: none;
}
.shop-filters::-webkit-scrollbar { display: none; }

.sf-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 20px 16px;
}

.sf-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.sf-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
}
.sf-clear-all {
  background: none;
  border: none;
  color: var(--accent);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
}
.sf-clear-all:hover { text-decoration: underline; }

.sf-section {
  border-top: 1px solid var(--border);
  padding: 14px 0;
}
.sf-section-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-primary);
  cursor: pointer;
  margin-bottom: 10px;
}
.sf-chevron { color: var(--text-secondary); font-size: 0.75rem; }

.sf-list { display: flex; flex-direction: column; gap: var(--space-1); }

.sf-checkbox-row {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  cursor: pointer;
  font-size: 0.83rem;
  color: var(--text-secondary);
}
.sf-checkbox-row input[type="checkbox"] {
  width: 15px; height: 15px; accent-color: var(--accent); cursor: pointer; flex-shrink: 0;
}
.sf-cat-name { flex: 1 1; }
.sf-count {
  font-size: 0.75rem;
  color: var(--text-tertiary);
  background: var(--bg-tertiary);
  padding: 1px 7px;
  border-radius: var(--radius-sm);
}
.sf-stars-row { display: flex; gap: 1px; }
.sf-star-label { font-size: 0.78rem; color: var(--text-secondary); }
.sf-stock-row { padding: 4px 0; }

/* Price range */
.sf-price-wrap { display: flex; flex-direction: column; gap: 10px; }
.sf-slider {
  width: 100%;
  accent-color: var(--accent);
  cursor: pointer;
}
.sf-price-labels {
  display: flex;
  justify-content: space-between;
  font-size: 0.78rem;
  color: var(--text-secondary);
}
.sf-price-inputs {
  display: flex;
  align-items: center;
  gap: 6px;
}
.sf-price-input {
  width: 70px;
  padding: 6px 8px;
  border: 1px solid var(--border);
  border-radius: var(--radius-xs);
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 0.82rem;
  outline: none;
}
.sf-price-input:focus { border-color: var(--accent); }
.sf-price-sep { color: var(--text-secondary); font-size: 0.8rem; }

/* ── Center: main product area ───────────────────────── */
.shop-main {
  padding: 16px 20px;
  min-width: 0;
}

/* Stats bar */
.shop-stats-bar {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  margin-bottom: 20px;
  overflow: hidden;
  box-shadow: var(--shadow-card);
  position: sticky;
  top: 0;
  z-index: 5;
}
.ssb-track {
  display: flex;
  align-items: center;
  padding: 14px 20px;
}
.ssb-items {
  display: flex;
  align-items: center;
  flex: 1 1;
  min-width: 0;
}
.ssb-items[aria-hidden="true"] { display: none; }
.ssb-item {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
  min-width: 0;
  padding: 0 12px;
}
.ssb-items:first-child .ssb-item:first-child { padding-left: 0; }
.ssb-items:last-child  .ssb-item:last-child  { padding-right: 0; }
.ssb-icon { flex-shrink: 0; display: flex; }
.ssb-positive  { color: var(--success); }
.ssb-attention { color: var(--color-primary); }
.ssb-info { color: var(--accent-secondary); }
.ssb-blue   { color: var(--accent); }
.ssb-value  { font-size: 0.9rem; font-weight: 700; color: var(--text-primary); margin: 0; line-height: 1.2; }
.ssb-label  { font-size: 0.72rem; color: var(--text-secondary); margin: 0; }
.ssb-sep { width: 1px; background: var(--border); align-self: stretch; flex-shrink: 0; margin: 0 4px; }

@media (max-width: 768px) {
  .shop-stats-bar {
    position: static;
    background: none;
    border: none;
    border-radius: 0;
    box-shadow: none;
  }
  .ssb-track {
    padding: 12px 0;
    width: max-content;
    animation: ssb-marquee 16s linear infinite;
  }
  .ssb-items { flex: 0 0 auto; }
  .ssb-items[aria-hidden="true"] { display: flex; }
  .ssb-item { flex: 0 0 auto; width: 140px; padding: 0 14px; }
  .ssb-sep { margin: 0 2px; }
}

@keyframes ssb-marquee {
  from { transform: translateX(0); }
  to   { transform: translateX(-50%); }
}

/* Stopping the marquee is right, but stopping it alone left the content
   stranded: the track is ~1350px wide inside a ~344px bar with
   overflow:hidden, so only the first two stats were reachable and the rest
   were invisible for good. Give it a real scroller instead, and drop the
   duplicated set -- that copy exists solely to make the loop seamless, and
   with no loop running it is just the same four stats a second time. */
@media (max-width: 768px) and (prefers-reduced-motion: reduce) {
  .ssb-track { animation: none; }
  .shop-stats-bar {
    overflow-x: auto;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
  }
  .shop-stats-bar::-webkit-scrollbar { display: none; }
  .ssb-items[aria-hidden="true"] { display: none; }
}

/* Product header row */
.shop-hdr-row {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 14px;
  gap: 12px;
  flex-wrap: wrap;
}
.shop-hdr-title { font-size: 1.25rem; font-weight: 700; margin: 0 0 4px; color: var(--text-primary); }
.shop-hdr-sub   { font-size: 0.8rem; color: var(--text-secondary); margin: 0; }

.shop-controls { display: flex; align-items: center; gap: var(--space-1); }
.shop-sort-lbl  { font-size: 0.82rem; color: var(--text-secondary); white-space: nowrap; }
.shop-sort-sel {
  padding: 6px 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius-xs);
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 0.83rem;
  outline: none;
  cursor: pointer;
}
/* 31px tall was the shortest control on the category page. */
@media (max-width: 768px) {
  .shop-sort-sel { min-height: 44px; }
}

/* Product grid — 4 columns */
.pcard-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  /* Split deliberately: 8px between columns, 16px between rows.
     
     Horizontally the gap only has to separate two edges that are drawn
     anyway, since every card carries its own border and elevation -- at 16px
     that rail read as more deliberate than the cards, and took about 48px out
     of a four-column row the product images could use instead.

     Vertically it is doing different work. Rows stack a card's price and
     rating directly above the next card's image, and at 8px those run
     together into one column of text with a picture in it. The 16px is what
     keeps each row reading as a row, so it stays. */
  column-gap: var(--space-1);
  row-gap: var(--space-2);
}
/* With only the filter rail beside it, 4 columns hold their width down to
   ~1080px (≈195px per card); below that step down so cards stay comfortable. */
@media (max-width: 1080px) { .pcard-grid { grid-template-columns: repeat(3, 1fr); } }
@media (max-width: 900px)  { .pcard-grid { grid-template-columns: repeat(2, 1fr); } }

/* ── Product card ────────────────────────────────────── */
.pcard {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  overflow: hidden;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  transition: transform 220ms ease, box-shadow 220ms ease;
  animation: card-appear 380ms ease both;
  box-shadow: 0 2px 10px rgba(1, 13, 33,0.07);
}
.pcard:hover {
  transform: translateY(-5px);
  box-shadow: 0 18px 44px rgba(1, 13, 33,0.15);
}
.pcard.pcard-oos { opacity: 0.72; }

/* ── Product card on mobile: quiet, and it stays put ──────────────────────
   Tapping Add to Cart made the entire card flash white. Two causes, and only
   one of them is meant to be visible:

   - .pcard carries \`animation: card-appear\`, which is opacity 0 -> 1. Adding
     to the cart updates state and re-renders the grid, the animation replays,
     and the card fades up from transparent. Over a light page that reads as
     the whole card flashing white. The button's own ripple is a deliberate
     white wash, but it is clipped to the button by overflow:hidden -- that
     part was always correct.
   - The card is clickable, so on Android it also takes the WebView's default
     tap highlight. index.css clears that for buttons and links; an <article>
     with an onClick is neither, so it was still highlighting.

   Both are removed for the mobile layer rather than for the desktop site,
   where the entry animation is wanted and a pointer raises no tap highlight
   to begin with. The tap highlight is an Android WebView default, but mobile
   browsers apply one too, so this belongs on every touch surface rather than
   on the packaged app alone.

   The rest is the calmer treatment: square corners, a plain hairline border,
   and no lift or shadow. Hover effects are noise on a touch screen anyway --
   a phone latches :hover after a tap, so the "lift" would stick on whichever
   card was last touched. The border uses --border, which is navy at low
   opacity; it reads as the grey wanted here without inventing a grey, since
   the palette has no grey ramp. */
html.m-app .pcard {
  animation: none;
  transition: none;
  border-radius: 0;
  border: 1px solid var(--border);
  box-shadow: none;
  -webkit-tap-highlight-color: transparent;
}

html.m-app .pcard:hover {
  transform: none;
  box-shadow: none;
}

html.m-app .pcard:hover .pcard-img-wrap img { transform: none; }

/* Dark top section (image + actions always visible) */
.pcard-top {
  background: linear-gradient(155deg, var(--color-brand-navy) 0%, var(--text-primary) 100%);
  display: flex;
  flex-direction: column;
}
:root[data-theme="light"] .pcard-top {
  background: var(--bg-tertiary);
}

/* Image wrap */
.pcard-img-wrap {
  position: relative;
  height: 185px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.pcard-img-wrap img {
  width: 100%; height: 100%; object-fit: cover;
  transition: transform 300ms ease, opacity 220ms ease;
}

.pimg-placeholder {
  z-index: 1;
}
.pcard:hover .pcard-img-wrap img { transform: scale(1.06); }

/* Badge — ribbon style */
.pcard-badge {
  position: absolute;
  top: 14px; left: 0;
  font-size: 0.68rem;
  font-weight: 800;
  padding: 5px 14px 5px 10px;
  clip-path: polygon(0 0, 100% 0, 88% 50%, 100% 100%, 0 100%);
  z-index: 2;
  letter-spacing: 0.05em;
  white-space: nowrap;
  text-transform: uppercase;
}
.pcard-badge-bestseller { background: var(--color-primary); color: var(--color-text-on-primary); }
/* Informational badge (not a promotion) -> blue, never orange. */
.pcard-badge-toprated   { background: var(--color-secondary); color: var(--color-text-on-secondary); }
.pcard-badge-limited    { background: var(--danger); color: var(--color-text-on-primary); }
.pcard-badge-oos        { background: var(--text-secondary); color: var(--color-brand-white); }

/* Heart button — circular white */
.pcard-heart {
  position: absolute;
  top: 12px; right: 12px;
  width: 36px; height: 36px;
  /* The chip is a FIXED white circle in both themes (it sits on product
     photography, not on the page surface), so its icon has to be a fixed
     navy too. --text-secondary flips to white in dark mode, which made the
     heart white-on-white -- invisible until hover recoloured it orange. */
  background: rgba(255,255,255,0.95);
  border: none;
  border-radius: 50%;
  color: rgba(1, 13, 33, 0.68);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(1, 13, 33,0.25);
  z-index: 3;
  transition: color 150ms, transform 150ms;
}
/* The white chip stays 36px -- it sits on product photography and a bigger
   circle starts covering the product. The touchable area is grown to 44px
   instead, which costs nothing visually. Worth doing precisely because this
   is the save affordance repeated on every card in the grid. */
.pcard-heart::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 44px;
  height: 44px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
}
.pcard-heart:hover { color: var(--color-primary); transform: scale(1.12); }

/* OOS overlay */
.pcard-oos-overlay {
  position: absolute; inset: 0;
  background: rgba(1, 13, 33,0.62);
  display: flex; align-items: center; justify-content: center;
  z-index: 3;
}
.pcard-oos-overlay span {
  background: var(--text-secondary); color: var(--color-brand-white);
  font-size: 0.72rem; font-weight: 700;
  padding: 5px 14px; border-radius: var(--radius-xs);
  text-transform: uppercase; letter-spacing: 0.06em;
}

/* Actions, at the foot of the card body.
 *
 * These used to sit directly under the image, above the product's own details.
 * They now come after the name, rating and price, so the card reads as what it
 * is and then what you can do about it.
 *
 * No horizontal padding of its own: .pcard-body already gutters the column, and
 * a second inset would step the buttons in from the title above them.
 *
 * margin-top:auto is what lines the buttons up across a row of cards whose
 * titles wrap to different heights -- without it every card in a row ends its
 * button at a different y. */
.pcard-actions {
  margin-top: auto;
  padding: 10px 0 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Quick row — two side-by-side buttons */
.pcard-quick-row {
  display: flex;
  gap: 9px;
}
/* Hidden on mobile for testing -- revert by deleting this rule. */
@media (max-width: 900px) {
  .pcard-quick-row { display: none; }
}
/* These are sized by the grid, not by their text, and the text is translated.
 * "Quick View" is ten characters; Kiswahili's "Muhtasari wa Haraka" is
 * nineteen, and on a 244px card it ran past both ends of the button -- the eye
 * icon pushed out of the box entirely, the compare icon crushed to a sliver,
 * and the labels bleeding over the borders.
 *
 * overflow:hidden plus an ellipsis on the label (below) is the fix that holds
 * for every language rather than for the ones we happened to measure: the words
 * give way, the icon never does, and the full label stays on the title and
 * aria-label. */
.pcard-quick-btn {
  flex: 1 1;
  min-width: 0;
  min-height: 34px;
  background: rgba(255,255,255,0.09);
  border: 1px solid rgba(255,255,255,0.22);
  border-radius: var(--radius-sm);
  color: rgba(255,255,255,0.92);
  font-size: 0.74rem;
  font-weight: 600;
  padding: 6px 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  transition: background 150ms, border-color 150ms;
  white-space: nowrap;
  overflow: hidden;
}

/* The icon is the part that still identifies the button once the words are
   trimmed, so it is the part that must not shrink. */
.pcard-quick-btn > svg { flex: 0 0 auto; }

.pcard-quick-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.pcard-quick-btn:hover { background: rgba(255,255,255,0.2); border-color: rgba(255,255,255,0.42); }

/* These sat on .pcard-top, which is --bg-tertiary in light mode, so a
   --bg-secondary fill separated them from it. In the card body that pairing is
   inverted -- the body IS --bg-secondary -- and the same fill left them as
   white-on-white, readable only by their border. Swapped, so the button still
   reads as a button on the surface it now sits on. */
:root[data-theme="light"] .pcard-quick-btn {
  background: var(--bg-tertiary);
  border-color: var(--border);
  color: var(--text-primary);
}
:root[data-theme="light"] .pcard-quick-btn:hover {
  background: color-mix(in srgb, var(--color-brand-navy) 8%, transparent);
  border-color: var(--text-tertiary);
}

@media (max-width: 900px) {
  .pcard-quick-label { display: none; }
  .pcard-quick-btn { padding: 8px; }
}

/* Add to Cart */
/* Add to Cart is blue with a navy label and navy cart icon (5.6:1, clears AA;
   white on this blue would be 3.1:1 and fail). Same treatment at every
   breakpoint -- the action must not change colour between mobile and desktop. */
.pcard-add-cart-btn {
  width: 100%;
  min-height: 38px;
  background: var(--color-secondary);
  border: none;
  border-radius: var(--radius-md);
  color: var(--color-text-on-secondary);
  font-size: 0.85rem;
  font-weight: 700;
  padding: 8px 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-1);
  transition: background 150ms;
  letter-spacing: 0.01em;
}
.pcard-add-cart-btn:hover:not(:disabled) { background: var(--color-secondary-hover); }
/* Unavailable: a flat navy-tinted chip, not a faded blue one -- opacity alone
   left it reading as "a button that's briefly busy". Never green, and never
   an active-looking colour. */
.pcard-add-cart-btn:disabled {
  background: rgba(1, 13, 33, 0.1);
  color: rgba(1, 13, 33, 0.5);
  cursor: not-allowed;
}
[data-theme="dark"] .pcard-add-cart-btn:disabled {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.5);
}

/* There used to be two Add to Cart buttons -- one over the image, one at the
   foot of the body -- so each breakpoint could show the one that suited its
   layout without moving a DOM node between two different flex parents. Now that
   the actions live in the body at every width, both would sit in the same
   parent with one permanently hidden, which is just a duplicate waiting to be
   shown twice. One button, shown everywhere.

   Mobile keeps it as the only action: .pcard-quick-row is hidden above 900px
   down, leaving .pcard-actions holding the button alone. */
@media (max-width: 900px) {
  /* A comfortable touch target -- the desktop base is deliberately slimmer for
     a mouse. */
  .pcard-add-cart-btn { min-height: 44px; padding: 11px 14px; }
}

/* Add to Cart, trimmed back for the mobile layer.

   The layer's 18px root (see mobile/tokens.css) is what made this heavy: the
   button's 0.85rem label went from 13.6px to 15.3px, so a full-width slab
   that was already 44px tall became the loudest thing in a 183px card --
   louder than the product title it sits under, which inverts the card's
   hierarchy.

   Only the button is pulled back, not the root, because the larger type is
   right everywhere else. 40px still reads as a deliberate touch target while
   letting the title and price lead again, and the card itself remains tappable
   for opening the product, so this is a shortcut rather than the only way in.

   Specificity note: this needs two classes to beat .pcard-add-cart-btn in the
   media query above -- media queries add no specificity of their own. */
html.m-app .pcard-add-cart-btn {
  min-height: 40px;
  font-size: 0.72rem;
  padding: 9px 12px;
  gap: 6px;
}
/* The icon is a hardcoded 17px SVG in the markup; CSS dimensions override the
   width/height attributes, so it can be brought down in proportion here
   without touching the component. */
html.m-app .pcard-add-cart-btn > svg {
  width: 15px;
  height: 15px;
}

/* Card body */
.pcard-body {
  padding: 10px 13px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
  /* So the quick buttons below can size their labels against THIS card rather
     than the window. The card's width comes from the grid's column count, which
     does not track the viewport in any fixed way -- at 1024px the cards are
     wider than at 1180px, because the column count drops. A media query cannot
     see that; a container query is measuring the thing that actually
     constrains the text. */
  container-type: inline-size;
}

/* Below this there is no honest way to show two labelled buttons side by side,
   so the words go and the icons speak -- which is already what happens on a
   phone, and reads far better than "Muhtas…" next to "لingani…".
   Deliberately a card-width threshold, not a language check: it is right for
   whichever translation happens to be longest, including ones not written yet.
   The ellipsis rule above still covers everything just above this line. */
@container (max-width: 250px) {
  .pcard-quick-label { display: none; }
  .pcard-quick-btn { padding: 6px 8px; }
}
.pcard-title {
  font-size: 0.95rem;
  font-weight: 800;
  color: var(--text-primary);
  line-height: 1.35;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Product titles are real <a href> elements so crawlers (and "open in new
   tab") can follow them -- these rules keep them looking exactly like the
   plain text they replaced, inheriting the heading's own colour and weight
   instead of picking up the UA's blue underline. Hover still gets an
   underline as the affordance that this is a link. */
.pcard-title-link {
  color: inherit;
  text-decoration: none;
}
.pcard-title-link:hover {
  text-decoration: underline;
}
/* The card already has its own focus treatment; without this the nested link
   draws a second outline inside it on keyboard navigation. */
.pcard-title-link:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
  border-radius: 3px;
}

/* Rating row */
.pcard-rating-row {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
}
/* ══════════════════════════════════════════════════════════════════════════
   Product ratings — the ONLY place --color-rating (green) is allowed.

   Every rating surface in the app routes through the three rules below, so
   the green lives in one token and one block rather than being pasted into
   each card variant. Filled stars are green; empty stars are navy at 15%;
   review counts and the "No reviews" placeholder are muted navy. Green is
   never used here for stock, buttons, discounts or success states.
   ══════════════════════════════════════════════════════════════════════════ */
.pcard-stars { display: flex; gap: 1px; font-size: 0.9rem; }
.rating-star-filled { color: var(--color-rating); }
.rating-star-empty  { color: var(--color-rating-empty); }
.pcard-review-cnt,
.product-review-count { font-size: 0.75rem; color: var(--color-review-muted); }
/* No stars, no empty pill, no "0.0" -- just a plain muted line. */
.pcard-no-rating,
.product-no-reviews { font-size: 0.75rem; color: var(--color-review-muted); }

/* The rating pill sits over the product image, lower-left. Only rendered
   when a real rating exists (see the product card), so there is never an
   empty green pill. Kept compact and clear of the wishlist control, which
   is pinned to the opposite (top-right) corner. */
.product-rating-pill,
.pcard-rating-badge {
  position: absolute;
  bottom: 10px; left: 10px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 9px;
  border-radius: 999px;
  background: var(--color-rating);
  color: var(--color-rating-on-fill);
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  z-index: 2;
}
/* The star glyph matches the label it sits beside -- navy, not white. */
.product-rating-pill svg,
.pcard-rating-badge svg { color: var(--color-rating-on-fill); }

@media (max-width: 600px) {
  /* Narrow cards: keep the pill legible without crowding the image. */
  .product-rating-pill,
  .pcard-rating-badge { padding: 4px 7px; font-size: 12px; bottom: 8px; left: 8px; }
}

/* Seller */
.pcard-seller { font-size: 0.75rem; color: var(--text-secondary); margin: 0; }
.pcard-seller-name { color: var(--accent); font-weight: 600; }
[data-theme="dark"] .pcard-seller-name { color: var(--color-secondary-soft); }
.pcard-verified { color: var(--success); font-size: 0.8rem; }

/* Price row */
.pcard-price-row {
  display: flex;
  align-items: baseline;
  gap: 6px;
  row-gap: 2px;
  flex-wrap: wrap;
}
.pcard-price    { font-size: 1.32rem; font-weight: 800; color: var(--text-primary); letter-spacing: -0.01em; white-space: nowrap; }
.pcard-original { font-size: 0.78rem; color: var(--text-tertiary); text-decoration: line-through; font-weight: 500; white-space: nowrap; }

/* Stock row */
.pcard-stock-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.74rem;
  flex-wrap: wrap;
}
.pcard-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-weight: 700;
  padding: 3px 9px 3px 8px;
  border-radius: var(--radius-xl);
  white-space: nowrap;
}
.pcard-status-dot { width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0; }

/* There is deliberately no ".pcard-status-in" any more: a plain "In Stock"
   badge is not rendered at all (see the product card in App.js). Only the two
   exceptional states get a pill.

   Low stock is a genuine urgency/commercial signal -> orange, with a dot.
   Out of stock is *neutral information*, not an error -> muted navy, so it
   recedes instead of shouting in the same colour as the buy button. It
   carries a warning icon as well as the label, since with four colours the
   tint alone can't distinguish "urgent" from "unavailable". */
.pcard-status-low { background: var(--color-primary-soft); color: var(--color-primary); }
.pcard-status-low .pcard-status-dot { background: var(--color-primary); }

.pcard-status-oos {
  background: rgba(1, 13, 33, 0.06);
  color: rgba(1, 13, 33, 0.58);
}
[data-theme="dark"] .pcard-status-oos {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.62);
}

.pcard-sold { color: var(--text-tertiary); margin-left: auto; font-weight: 500; }

/* Delivery row */
.pcard-delivery {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.74rem;
  color: var(--text-secondary);
}
.pcard-delivery strong { color: var(--accent); font-weight: 600; }
[data-theme="dark"] .pcard-delivery strong { color: var(--color-secondary-soft); }


/* ── Cart body ───────────────────────────────────────── */
/* The shop page used to host these .cs-* blocks in a right-hand sidebar; that
   sidebar is gone and the cart now lives only on the full-screen /cart page
   (see .cart-page-header / .cart-page-body below), which renders the same
   renderCartBody() markup. */

/* Cart items */
.cs-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 4px 28px;
}

.cs-empty-illustration {
  position: relative;
  width: 132px;
  height: 132px;
  border-radius: 50%;
  background: radial-gradient(circle at 50% 45%, rgba(59, 130, 246,0.12), rgba(59, 130, 246,0.04) 70%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
}
.cs-empty-cart-icon { color: var(--accent); }
.cs-empty-sparkle {
  position: absolute;
  color: var(--accent);
  opacity: 0.55;
  font-size: 0.9rem;
}
.cs-empty-sparkle-1 { top: 14px;    left: 18px; font-size: 0.7rem; }
.cs-empty-sparkle-2 { top: 8px;     right: 28px; }
.cs-empty-sparkle-3 { bottom: 18px; right: 14px; font-size: 0.7rem; }
.cs-empty-heart-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 28px;
  height: 28px;
  border-radius: 50% 50% 50% 4px;
  background: var(--accent);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-card);
}

.cs-empty-title {
  font-size: 1.05rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0 0 8px;
}
.cs-empty-sub {
  font-size: 0.82rem;
  color: var(--text-secondary);
  text-align: center;
  line-height: 1.5;
  margin: 0 0 20px;
}
.cs-empty-continue-btn {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: var(--accent);
  color: var(--color-text-on-secondary);
  border: none;
  border-radius: var(--radius-sm);
  padding: 12px 14px;
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;
  margin-bottom: 10px;
  transition: background 150ms;
}
.cs-empty-continue-btn:hover { background: var(--accent-hover); }
.cs-empty-categories-btn {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: transparent;
  color: var(--accent);
  border: 1.5px solid var(--accent);
  border-radius: var(--radius-sm);
  padding: 11px 14px;
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;
  margin-bottom: 4px;
  transition: background 150ms;
}
.cs-empty-categories-btn:hover { background: rgba(59, 130, 246,0.08); }

.cs-empty-checkout-hint {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 0.76rem;
  color: var(--text-tertiary);
  margin: 0 0 14px;
}
/* Item list. Each cart line is its own card; the bare .cs-* rules below are the
   compact treatment still used by the "saved for later" list, and .cs-item
   descendant rules scale them up for the main list. */
.cs-items { display: flex; flex-direction: column; gap: 12px; }
.cs-item {
  display: grid;
  grid-template-columns: 140px minmax(0, 1fr) auto;
  gap: 20px;
  align-items: start;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 14px;
}
.cs-item-img {
  width: 64px; height: 64px;
  object-fit: cover;
  border-radius: var(--radius-sm);
  background: var(--bg-tertiary);
  flex-shrink: 0;
}
.cs-item .cs-item-img { width: 100%; height: auto; aspect-ratio: 1 / 1; }
.cs-item-info { flex: 1 1; min-width: 0; }
.cs-item .cs-item-info { padding-top: 2px; }
.cs-item-name {
  font-size: 0.8rem;
  font-weight: 500;
  margin: 0 0 3px;
  color: var(--text-primary);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.cs-item .cs-item-name { font-size: 0.95rem; font-weight: 700; margin-bottom: 5px; }
.cs-item-size { font-size: 0.74rem; color: var(--text-secondary); margin: 0 0 3px; }
.cs-item-price { font-size: 0.8rem; font-weight: 700; color: var(--text-primary); margin: 0 0 5px; }
.cs-item .cs-item-price { font-size: 1.02rem; font-weight: 800; margin-bottom: 13px; }
.cs-qty-row { display: flex; align-items: center; gap: 10px; }
.cs-item .cs-qty-row { margin-bottom: 13px; }
.cs-qty-max-hint { font-size: 0.7rem; color: var(--text-muted); }

/* Stepper — one bordered group with hairline dividers, not three loose chips */
.cs-qty-group {
  display: inline-flex;
  align-items: stretch;
  border: 1px solid var(--border);
  border-radius: var(--radius-xs);
  overflow: hidden;
  background: var(--bg-secondary);
}
.cs-qty-btn {
  width: 42px; height: 38px;
  background: var(--bg-secondary);
  border: none;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  color: var(--text-primary);
  transition: background 120ms, color 120ms;
}
.cs-qty-btn:hover:not(:disabled) { background: var(--accent); color: var(--color-text-on-secondary); }
.cs-qty-btn:disabled { opacity: 0.4; cursor: not-allowed; }
.cs-qty {
  min-width: 44px;
  display: flex; align-items: center; justify-content: center;
  border-left: 1px solid var(--border);
  border-right: 1px solid var(--border);
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-primary);
}

/* Remove | Save for later */
.cs-item-actions { display: flex; align-items: center; gap: 14px; }
.cs-item-action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  padding: 0;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--accent);
  cursor: pointer;
}
.cs-item-action:hover { text-decoration: underline; text-underline-offset: 3px; }
.cs-item-action--danger { color: var(--danger); }
.cs-item-action-sep { width: 1px; min-height: 16px; align-self: stretch; background: var(--border); }

/* Qty tag pinned top-right, line total bottom-right */
.cs-item-aside {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  align-self: stretch;
  gap: 12px;
  text-align: right;
}
.cs-item-qty-tag { font-size: 0.8rem; color: var(--text-tertiary); white-space: nowrap; }
.cs-item-line-total { font-size: 1.02rem; font-weight: 800; color: var(--text-primary); white-space: nowrap; }

.cs-save-later-btn { background: none; border: none; font-size: 0.75rem; color: var(--accent); cursor: pointer; padding: 0; text-decoration: underline; text-underline-offset: 2px; }
.cs-save-later-btn:hover { opacity: 0.75; }
.cs-saved-title { font-size: 0.88rem; font-weight: 700; color: var(--text-secondary); margin: 0 0 10px; }
.cs-saved-item { display: flex; gap: 12px; padding: 10px 0; border-bottom: 1px solid var(--border); }
.cs-saved-item:last-child { border-bottom: none; padding-bottom: 0; }

/* Totals — sit inside the order-summary card, under its own header, so no
   top border of their own here. */
.cs-totals {
  margin-bottom: 18px;
  display: flex;
  flex-direction: column;
  gap: 9px;
}
.cs-total-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 0.88rem;
  color: var(--text-secondary);
}
.cs-shipping-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.cs-shipping-label svg { color: var(--text-tertiary); cursor: help; }
.cs-shipping-tbd {
  font-size: 0.84rem;
  font-style: italic;
  color: var(--text-tertiary, var(--text-muted));
}
.cs-total-final {
  font-weight: 700;
  font-size: 1rem;
  color: var(--text-primary);
  padding-top: 14px;
  border-top: 1px solid var(--border);
  margin-top: 5px;
}
.cs-total-final strong { font-size: 1.2rem; }
.cs-total-note {
  margin: 4px 0 0;
  font-size: 0.76rem;
  color: var(--text-muted);
  line-height: 1.4;
}

/* CTA buttons */
.cs-checkout-btn {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: var(--accent);
  color: var(--color-text-on-secondary);
  border: none;
  border-radius: var(--radius-sm);
  padding: 13px 16px;
  font-size: 0.92rem;
  font-weight: 700;
  cursor: pointer;
  margin-bottom: 10px;
  transition: background 150ms;
}
.cs-checkout-btn:hover:not(:disabled) { background: var(--accent-hover); }
.cs-checkout-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.cs-view-cart-btn {
  box-sizing: border-box;
  width: 100%;
  background: transparent;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 12px 16px;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-primary);
  cursor: pointer;
  transition: background 150ms;
}
.cs-view-cart-btn:hover:not(:disabled) { background: var(--bg-tertiary); }
.cs-view-cart-btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* Trust badges — their own card, rows split by hairlines */
.cs-trust {
  display: flex;
  flex-direction: column;
}
.cs-trust-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 15px 0;
  border-top: 1px solid var(--border);
}
.cs-trust-item:first-child { border-top: none; padding-top: 0; }
.cs-trust-item:last-child { padding-bottom: 0; }
.cs-trust-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.cs-trust-icon--blue   { background: rgba(59, 130, 246,0.12); color: var(--accent); }
.cs-trust-icon--positive  { background: color-mix(in srgb, var(--success) 12%, transparent);  color: var(--success); }
.cs-trust-icon--info { background: color-mix(in srgb, var(--accent-secondary) 12%, transparent); color: var(--accent-secondary); }
.cs-trust-title { font-size: 0.86rem; font-weight: 700; color: var(--text-primary); margin: 0 0 1px; }
.cs-trust-sub   { font-size: 0.78rem; color: var(--text-secondary); margin: 0; }

/* Free shipping progress */
.cs-free-ship {
  background: rgba(59, 130, 246,0.06);
  border: 1px solid rgba(59, 130, 246,0.2);
  border-radius: var(--radius-sm);
  padding: 12px 14px;
  margin-top: 4px;
}
.cs-fs-title    { font-size: 0.82rem; font-weight: 700; color: var(--text-primary); margin: 0 0 4px; }
.cs-fs-sub      { font-size: 0.75rem; color: var(--text-secondary); margin: 0 0 8px; }
.cs-fs-track    { height: 6px; background: var(--border); border-radius: var(--radius-xs); overflow: hidden; margin-bottom: 6px; }
.cs-fs-bar      { height: 100%; background: var(--accent); border-radius: var(--radius-xs); transition: width 400ms ease; }
.cs-fs-progress { font-size: 0.72rem; color: var(--text-secondary); margin: 0; }

/* ════════════════════════════════════════════════════════
   CART PAGE — the only cart surface, at every width
   ════════════════════════════════════════════════════════ */

.cart-page-header {
  border-bottom: 1px solid var(--border);
  background: var(--bg-secondary);
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 20;
}
.cph-inner {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 16px;
  max-width: 1240px;
  margin: 0 auto;
  padding: 14px 24px;
}
/* Back and close are the same bordered square -- close is just pushed to the
   far end, which also lets the title sit tight against the back arrow. */
.cph-back,
.cph-close {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-xs);
  color: var(--text-primary);
  cursor: pointer;
  flex-shrink: 0;
  transition: background 120ms;
}
.cph-back:hover,
.cph-close:hover { background: var(--bg-tertiary); }
.cph-close { margin-left: auto; color: var(--text-secondary); }
.cph-title {
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0;
}

.cart-page-body {
  box-sizing: border-box;
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 24px;
  flex: 1 1;
}

/* Items left, sticky order summary right */
.cartpg-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: 24px;
  align-items: start;
}
.cartpg-col {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.cartpg-side {
  position: sticky;
  top: 88px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
/* An empty cart has nothing to put in the left column, so it drops to a single
   centred column rather than leaving half the page blank. */
.cartpg-empty-layout {
  max-width: 460px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cartpg-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 18px;
}

/* Section header: accent glyph tile + title. Used above the item list (bare,
   spaced by .cartpg-col's gap) and inside the order-summary card. */
.cartpg-hd {
  display: flex;
  align-items: center;
  gap: 12px;
}
.cartpg-card > .cartpg-hd { margin-bottom: 16px; }
.cartpg-hd-icon,
.cartpg-help-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-sm);
  background: rgba(59, 130, 246, 0.12);
  color: var(--accent);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.cartpg-hd-title {
  font-size: 1.05rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0;
}

/* Support prompt under the item list */
.cartpg-help {
  display: flex;
  align-items: center;
  gap: 14px;
}
.cartpg-help-text { flex: 1 1; min-width: 0; }
.cartpg-help-title { font-size: 0.92rem; font-weight: 700; color: var(--text-primary); margin: 0 0 2px; }
.cartpg-help-sub { font-size: 0.82rem; color: var(--text-secondary); margin: 0; }
.cartpg-help-btn {
  flex-shrink: 0;
  background: transparent;
  border: 1px solid var(--accent);
  border-radius: var(--radius-xs);
  color: var(--accent);
  padding: 10px 18px;
  font-size: 0.86rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 150ms;
}
.cartpg-help-btn:hover { background: rgba(59, 130, 246, 0.08); }

@media (max-width: 1000px) {
  /* Summary drops below the items rather than squeezing both into a narrow
     split -- 360px of summary plus a 140px thumbnail leaves the item text
     nowhere to go. */
  .cartpg-grid { grid-template-columns: minmax(0, 1fr); }
  .cartpg-side { position: static; }
}
@media (max-width: 640px) {
  .cph-inner { padding: 12px 14px; gap: 12px; }
  .cph-title { font-size: 1.2rem; }
  .cph-back, .cph-close { width: 38px; height: 38px; }
  .cart-page-body { padding: 16px 12px 32px; }
  .cartpg-card { padding: 14px; }
  /* Thumbnail shrinks and the qty/total column wraps to a full-width footer
     row, so the name and stepper keep a usable width on a phone. */
  .cs-item { grid-template-columns: 96px minmax(0, 1fr); gap: 14px; padding: 12px; }
  .cs-item-aside {
    grid-column: 1 / -1;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid var(--border);
    padding-top: 12px;
  }
  .cartpg-help { flex-wrap: wrap; }
  .cartpg-help-btn { width: 100%; }
}

/* ── Responsive collapse ─────────────────────────────── */
/* Narrow the filter rail as the grid steps down to 3 columns, then drop it
   entirely on phones where the category sheet in the bottom nav takes over. */
@media (max-width: 1080px) {
  .shop-layout { grid-template-columns: 220px 1fr; }
  .pcard-grid  { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 900px) {
  .shop-layout { grid-template-columns: 1fr; }
  .shop-filters { display: none; }
  .pcard-grid  { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 640px) {
  /* Let cards run closer to the screen edge on phones, and shrink the gap
     between cards so more of the fixed 2-column width goes to each card
     instead of the gutter between them. */
  .shop-main { padding: 16px 8px; }
  .pcard-grid { gap: 8px; }
}

/* ════════════════════════════════════════════════════════
   NAVBAR REDESIGN — two-row layout
   ════════════════════════════════════════════════════════ */

/* Override old single-row inner */
.main-navbar-inner { display: none; }
.nb-search-row { display: none; }

/* Row 1: Logo + Search + Actions */
.nb-top {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 10px 24px;
  max-width: 1440px;
  margin: 0 auto;
}

/* Persistent inline search bar */
/* min-width:0 is the whole of it. A flex item's default min-width is \`auto\`,
   which floors it at its content's minimum size -- so \`flex: 1\` here could
   grow the search bar but never shrink it past the width its input wanted,
   and the overflow was pushed onto .nb-actions to the right of it instead.
   With the floor removed the search bar yields first, which is the correct
   order of sacrifice: a narrower search field is usable, a cart button off
   the edge of the screen is not. */
.nb-search-wrap { position: relative; flex: 1 1; min-width: 0; display: flex; }
.nb-search-wrap .nb-search-bar { flex: 1 1; }
.nb-autocomplete {
  position: absolute; top: calc(100% + 6px); left: 0; right: 0; z-index: 200;
  background: var(--bg-primary); border: 1px solid var(--border); border-radius: 12px;
  box-shadow: 0 8px 32px rgba(1, 13, 33,0.15); overflow: hidden;
}
.nb-ac-item {
  display: flex; align-items: center; gap: 10px; width: 100%; padding: 10px 14px;
  background: none; border: none; cursor: pointer; text-align: left; transition: background 0.1s;
}
.nb-ac-item:hover { background: var(--bg-secondary); }
.nb-ac-img { width: 38px; height: 38px; border-radius: 8px; object-fit: cover; flex-shrink: 0; }
.nb-ac-info { flex: 1 1; min-width: 0; }
.nb-ac-name { display: block; font-size: 0.85rem; font-weight: 600; color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.nb-ac-cat { display: block; font-size: 0.72rem; color: var(--text-muted); }
.nb-ac-price { font-size: 0.85rem; font-weight: 700; color: var(--accent); flex-shrink: 0; }

.nb-search-bar {
  flex: 1 1;
  display: flex;
  align-items: center;
  height: 44px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--bg-primary);
  overflow: hidden;
  transition: border-color 200ms, box-shadow 200ms;
  min-width: 0;
}
.nb-search-bar:focus-within {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(59, 130, 246,0.1);
}
.nb-sb-search-icon {
  padding: 0 10px;
  color: var(--text-tertiary);
  flex-shrink: 0;
}
.nb-sb-input {
  flex: 1 1;
  border: none;
  background: transparent;
  outline: none;
  color: var(--text-primary);
  font-size: 0.96rem;
  min-width: 0;
}
.nb-sb-input::placeholder { color: var(--text-tertiary); }
/* hide the native search clear button */
.nb-sb-input::-webkit-search-cancel-button { display: none; }
.nb-sb-clear {
  background: none;
  border: none;
  color: var(--text-tertiary);
  cursor: pointer;
  padding: 2px 7px;
  font-size: 0.8rem;
  border-radius: var(--radius-xs);
  flex-shrink: 0;
  transition: color 120ms;
}
.nb-sb-clear:hover { color: var(--text-primary); }
.nb-sb-divider {
  width: 1px;
  height: 22px;
  background: var(--border);
  flex-shrink: 0;
  margin: 0 2px;
}
.nb-sb-cat {
  border: none;
  background: transparent;
  outline: none;
  color: var(--text-secondary);
  font-size: 0.88rem;
  padding: 0 4px 0 8px;
  cursor: pointer;
  max-width: 130px;
  white-space: nowrap;
  appearance: none;
  -webkit-appearance: none;
}
.nb-sb-caret {
  color: var(--text-tertiary);
  flex-shrink: 0;
  margin-right: 2px;
  pointer-events: none;
}
.nb-sb-btn {
  background: var(--accent);
  border: none;
  height: 44px;
  min-width: 50px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--color-text-on-secondary);
  flex-shrink: 0;
  transition: background 150ms;
}
.nb-sb-btn:hover { background: var(--accent-hover); }

.nb-mobile-search-btn {
  display: none;
  background: var(--bg-tertiary);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  color: var(--text-primary);
  cursor: pointer;
  align-items: center;
  justify-content: center;
}
.nb-sb-back {
  display: none;
  background: none;
  border: none;
  padding: 0 8px 0 12px;
  color: var(--text-secondary);
  flex-shrink: 0;
  cursor: pointer;
  align-items: center;
}

/* Mobile: drop the inline category picker/search button, keep a clean pill */
@media (max-width: 768px) {
  .nb-sb-divider, .nb-sb-cat, .nb-sb-caret, .nb-sb-btn { display: none; }
  .nb-search-bar { border-radius: var(--radius-lg); background: var(--bg-tertiary); border-color: transparent; }

  .nb-top { padding: 10px 12px; gap: 10px; }

  /* Icon-only wordmark on mobile -- the "AcyMart" text and tagline are
     dropped to save header width, keeping just the bag icon as the
     tappable home link. */
  .nb-logo-text-block { display: none; }

  /* Search bar collapses to a single icon button until tapped open */
  .nb-search-bar { display: none; }
  .nb-search-bar.nb-search-expanded { display: flex; flex: 1 1; }
  .nb-mobile-search-btn { display: flex; margin-left: auto; }
  .nb-sb-back { display: flex; }

  /* Group search + theme toggle together at the right edge instead of
     leaving them stranded near the logo with dead space after them */
  .nb-actions { gap: 8px; }

  /* Language switcher: icon-only on mobile (drop the "English"/"Français"
     text label) so it matches the theme toggle it sits next to instead of
     being the one text-heavy control left in an otherwise icon-only row.
     Scoped to the navbar instance only -- the footer's language switcher
     keeps its text label, since it isn't fighting for space there. */
  .nb-actions .lang-switcher-current { display: none; }
  .nb-actions .lang-switcher-btn {
    width: 44px;
    height: 44px;
    justify-content: center;
    padding: 0;
  }
}

/* Action buttons (account / wishlist / cart) */
.nb-actions {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}
.nb-action-btn {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  min-height: 44px;
  background: none;
  border: none;
  padding: 6px 10px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  color: var(--text-primary);
  transition: background 150ms;
  text-align: left;
  white-space: nowrap;
}
.nb-action-btn:hover { background: var(--bg-tertiary); }

/* Below 768px the bottom nav already covers account/wishlist/cart —
   these text-label buttons don't shrink and were forcing horizontal
   page overflow at narrow widths, so hide them and keep just the
   theme toggle (which the bottom nav has no equivalent for). */
@media (max-width: 768px) {
  .nb-action-btn { display: none; }
}

/* ── The band the rule above did not cover ────────────────────────────────
 *
 * Hiding the buttons below 768px fixed the phone and left 769px to about
 * 1150px broken, which is laptops and tablets in landscape. .nb-actions is
 * flex-shrink:0 with nowrap labels, so it holds its full width and simply
 * leaves the screen. Measured on the homepage:
 *
 *            signed out        signed in
 *   820px    172px off-screen  284px off-screen
 *   960px     32px             144px
 *   1024px    fits              80px   <- iPad landscape
 *   1100px    fits               4px
 *
 * Signing in makes it worse because the account button appears, which is
 * exactly backwards: the person with an account is the one who loses the
 * cart button off the edge of the screen.
 *
 * The labels are what cost the width, not the controls, so the labels go and
 * the icons stay. Every one of these buttons already carries an aria-label
 * (see App.js), so nothing is lost to a screen reader -- this is the same
 * icon-only treatment the header uses under 768px, applied one breakpoint
 * earlier instead of jumping straight from full labels to nothing.
 *
 * The page does not scroll sideways in this band -- the overflow is clipped --
 * so the failure is silent and looks like missing buttons rather than a layout
 * bug, which is why it outlived the 768px fix. */
@media (min-width: 769px) and (max-width: 1150px) {
  /* .nb-actions prefixed on every one of these: the plain .nb-action-text rule
     is defined a few lines BELOW this block, and a media query adds no
     specificity -- so an unprefixed .nb-action-text here loses on source order
     and the labels stay put. Measured that exact failure: the gap changed, the
     labels did not. */
  .nb-actions .nb-action-text { display: none; }
  .nb-actions .nb-action-btn { padding: 6px 8px; }
  .nb-actions { gap: 4px; }
}

.nb-action-icon-wrap {
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}
.nb-action-text {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
}
.nb-action-label {
  font-size: 0.78rem;
  color: var(--text-secondary);
}
.nb-action-sub {
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--text-primary);
}
/* Override old nb-badge positioning for new icon wrap context */
.nb-action-icon-wrap .nb-badge {
  top: -6px;
  right: -8px;
}
/* Wishlist count -- an informational counter, so blue. */
.nb-badge-count {
  background: var(--color-secondary);
  color: var(--color-text-on-secondary);
}
.nb-theme-btn {
  background: none;
  border: none;
  cursor: pointer;
  width: 44px;
  height: 44px;
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  margin-left: 2px;
  transition: background 150ms;
}
.nb-theme-btn:hover { background: var(--bg-tertiary); }

/* ── Visible keyboard focus for icon-only controls (previously had none) ── */
.nb-action-btn:focus-visible,
.nb-theme-btn:focus-visible,
.pcard-heart:focus-visible,
.pcard-quick-btn:focus-visible,
.pcard-add-cart-btn:focus-visible,
.bn-item:focus-visible,
.btn:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
}

/* ── Button press ripple (pure CSS, no pointer tracking) ── */
.btn,
.pcard-add-cart-btn,
.nb-action-btn {
  position: relative;
  overflow: hidden;
}
.btn::after,
.pcard-add-cart-btn::after {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(255,255,255,0.35);
  opacity: 0;
  transform: scale(0.6);
  border-radius: inherit;
  pointer-events: none;
  transition: transform var(--dur-base) var(--ease-out-expo), opacity var(--dur-base) ease;
}
.nb-action-btn::after {
  content: '';
  position: absolute;
  inset: 0;
  background: var(--accent);
  opacity: 0;
  transform: scale(0.6);
  border-radius: inherit;
  pointer-events: none;
  transition: transform var(--dur-base) var(--ease-out-expo), opacity var(--dur-base) ease;
}
.btn:active::after,
.pcard-add-cart-btn:active::after {
  opacity: 1;
  transform: scale(1);
  transition: transform 0ms, opacity 0ms;
}
.nb-action-btn:active::after {
  opacity: 0.1;
  transform: scale(1);
  transition: transform 0ms, opacity 0ms;
}

/* ── No press ripple on mobile ────────────────────────────────────────────
   The white wash above is a pointer-era affordance and it does not survive
   contact with a touch screen. :active is applied instantly and then held --
   a touch browser keeps it after the finger lifts, until something else is
   touched, and the packaged WebView behaves the same way.
   So Add to Cart lit up white and stayed white until the next tap, which
   reads as a one-or-two-second flash rather than a press.

   Removing the pseudo-element outright rather than shortening the fade: no
   duration makes a latched state correct, and the button does not need to
   confirm anything on its own -- the cart badge in the bottom nav increments
   immediately, which is why the toast was dropped as well. */
html.m-app .btn::after,
html.m-app .pcard-add-cart-btn::after,
html.m-app .nb-action-btn::after {
  content: none;
}

/* Row 2: Category nav strip */
.nb-cat-row {
  border-top: 1px solid var(--border);
}
/* Replaced on mobile by MobileTopBar's icon-based category strip */
@media (max-width: 768px) {
  .nb-cat-row { display: none; }
}
.nb-cat-row-inner {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  height: 44px;
}
.nb-all-cats-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  border-right: 1px solid var(--border);
  padding: 0 16px 0 0;
  margin-right: 4px;
  font-size: 0.93rem;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  white-space: nowrap;
  height: 100%;
  flex-shrink: 0;
  transition: color 150ms;
}
.nb-all-cats-btn:hover,
.nb-all-cats-btn.active { color: var(--accent); }

.nb-deals-link {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 14px;
  margin-right: 2px;
  background: none;
  border: none;
  /* Now an <a>, not a <button> -- see .nb-cat-link. */
  text-decoration: none;
  border-bottom: 2px solid transparent;
  font-size: 0.93rem;
  font-weight: 700;
  /* Navy label with an orange flame icon and orange underline/tint, rather
     than orange type: orange on white is 2.92:1 and can't pass AA at this
     size. The promotional read comes from the icon and the fill instead --
     "navy text with orange icons, borders or backgrounds" per the brand
     accessibility rules. */
  color: var(--text-primary);
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 150ms;
}
.nb-deals-link svg { color: var(--color-primary); }
.nb-deals-link:hover { background: rgba(255, 103, 0, 0.08); }
.nb-deals-link.active {
  border-bottom-color: var(--color-primary);
  background: rgba(255, 103, 0, 0.08);
}

/* Override old nb-cat-nav for new row context */
.nb-cat-row .nb-cat-nav {
  display: flex;
  align-items: center;
  flex: 1 1;
  height: 100%;
  overflow-x: auto;
  scrollbar-width: none;
  gap: 0;
}
.nb-cat-row .nb-cat-nav::-webkit-scrollbar { display: none; }
.nb-cat-row .nb-cat-link {
  height: 100%;
  padding: 0 12px;
  font-size: 0.93rem;
  font-weight: 600;
  color: var(--text-secondary);
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: color 150ms, border-color 150ms;
}
.nb-cat-row .nb-cat-link:hover { color: var(--accent); background: rgba(59, 130, 246,0.04); }
.nb-cat-row .nb-cat-link.active {
  color: var(--accent);
  font-weight: 700;
  border-bottom-color: var(--accent);
  background: rgba(59, 130, 246,0.04);
}

/* Dark mode tweaks */
:root[data-theme="dark"] .nb-action-btn:hover { background: color-mix(in srgb, var(--accent-secondary) 10%, transparent); }
:root[data-theme="dark"] .nb-theme-btn:hover  { background: color-mix(in srgb, var(--accent-secondary) 10%, transparent); }
:root[data-theme="dark"] .nb-sb-cat { color: var(--text-secondary); }
:root[data-theme="dark"] .nb-cat-row .nb-cat-link:hover,
:root[data-theme="dark"] .nb-cat-row .nb-cat-link.active { background: color-mix(in srgb, var(--accent-secondary) 10%, transparent); }

/* ════════════════════════════════════════════════════════
   PRODUCT DETAIL PAGE v2 — Amazon / Flipkart / Shopify UX
   ════════════════════════════════════════════════════════ */
.pdp-page {
  box-sizing: border-box;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 16px 24px 56px;
  background: var(--bg-primary);
}

/* Breadcrumb */
.pdp-breadcrumb {
  display: flex; align-items: center; gap: 6px;
  font-size: 0.82rem; color: var(--text-secondary);
  margin-bottom: 16px; flex-wrap: wrap;
}
.pdp-back-link {
  background: none; border: none; color: var(--accent);
  font-size: 0.82rem; cursor: pointer; padding: 0; font-weight: 600;
}
.pdp-back-link:hover { text-decoration: underline; }
.pdp-bc-sep { color: var(--text-tertiary); }
/* Breadcrumb crumbs are <a href> now (see ProductDetailPage) -- keep the
   muted look they had as spans, with an underline on hover as the cue. */
.pdp-bc-item { color: var(--text-secondary); text-decoration: none; }
a.pdp-bc-item:hover { color: var(--accent); text-decoration: underline; }
.pdp-bc-current { color: var(--text-primary); font-weight: 500; }

/* Main 3-column grid */
.pdp-main {
  display: grid;
  grid-template-columns: 420px 1fr 300px;
  gap: var(--space-3);
  align-items: start;
  margin-bottom: 20px;
}

/* ════ LEFT: Gallery ════ */
.pdp-gallery { display: flex; gap: 10px; }

.pdp-thumbs {
  display: flex; flex-direction: column; gap: var(--space-1);
  width: 70px; flex-shrink: 0;
}
.pdp-thumb {
  width: 70px; height: 70px;
  border: 2px solid var(--border); border-radius: var(--radius-sm);
  overflow: hidden; background: var(--bg-secondary);
  cursor: pointer; padding: 4px; transition: all 150ms;
  display: flex; align-items: center; justify-content: center;
  position: relative;
}
.pdp-thumb:hover { border-color: var(--accent); transform: scale(1.03); }
.pdp-thumb.active {
  border-color: var(--accent);
  box-shadow: 0 0 0 2px rgba(59, 130, 246,0.25);
}
.pdp-thumb img { width: 100%; height: 100%; object-fit: contain; }
.pdp-thumb-view-badge {
  position: absolute; bottom: 3px; left: 50%; transform: translateX(-50%);
  background: rgba(1, 13, 33,0.65); color: var(--color-brand-white);
  font-size: 0.52rem; padding: 2px 6px; border-radius: var(--radius-xs);
  white-space: nowrap; pointer-events: none;
}
.pdp-img-view-label {
  position: absolute; bottom: 12px; left: 12px;
  background: rgba(1, 13, 33,0.6); color: var(--color-brand-white);
  font-size: 0.72rem; font-weight: 600;
  padding: 4px 10px; border-radius: var(--radius-xs);
  letter-spacing: 0.03em; pointer-events: none; z-index: 3;
}
.pdp-thumb-video-badge {
  position: absolute; bottom: 3px; right: 3px;
  background: rgba(1, 13, 33,0.7); color: var(--color-brand-white);
  font-size: 0.55rem; padding: 2px 5px; border-radius: var(--radius-xs);
  font-weight: 900; line-height: 1;
}

/* Main image wrapper */
.pdp-main-img-wrap {
  flex: 1 1;
  background: var(--bg-secondary); border: 1px solid var(--border);
  border-radius: var(--radius-lg); overflow: hidden;
  display: flex; flex-direction: column;
  box-shadow: var(--shadow-card);
}
.pdp-main-img-stage {
  flex: 1 1; position: relative;
  display: flex; align-items: center; justify-content: center;
  overflow: hidden; cursor: zoom-in;
  min-height: 320px;
}
.pdp-main-img-inner {
  width: 100%; height: 100%;
  display: flex; align-items: center; justify-content: center;
  overflow: hidden;
  transition: transform 400ms cubic-bezier(0.25,0.46,0.45,0.94);
}
.pdp-main-img-stage:hover .pdp-main-img-inner { transform: scale(1.09); }
.pdp-main-img {
  width: 100%; height: 420px;
  object-fit: contain; padding: var(--space-3);
  pointer-events: none; -webkit-user-select: none; user-select: none;
  transition: opacity 220ms ease;
}
.pdp-main-img-fallback {
  width: 100%; height: 420px;
  display: flex; align-items: center; justify-content: center;
  color: var(--text-tertiary);
}
@media (prefers-reduced-motion: reduce) {
  .pdp-main-img { transition: none; }
}

/* Badge overlay */
.pdp-img-badge {
  position: absolute; top: 14px; left: 0;
  background: var(--success); color: var(--color-text-on-secondary);
  font-size: 0.65rem; font-weight: 800; letter-spacing: 0.07em;
  padding: 4px 12px 4px 10px; border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
  z-index: 2; text-transform: uppercase;
}
.pdp-img-badge.hot  { background: var(--color-primary); }

/* Wishlist heart */
.pdp-img-heart {
  position: absolute; top: 14px; right: 14px;
  width: 38px; height: 38px;
  background: var(--bg-primary); border: 1px solid var(--border);
  border-radius: 50%; box-shadow: 0 2px 10px rgba(1, 13, 33,0.12);
  font-size: 1.15rem; color: var(--text-muted);
  cursor: pointer; display: flex; align-items: center; justify-content: center;
  z-index: 2; transition: all 150ms;
}
.pdp-img-heart:hover { color: var(--danger); border-color: var(--danger); transform: scale(1.1); }
.pdp-img-heart.active { color: var(--danger); }

/* Prev/Next arrows */
.pdp-img-prev, .pdp-img-next {
  position: absolute; top: 50%; transform: translateY(-50%);
  width: 36px; height: 36px;
  background: var(--bg-primary); border: 1px solid var(--border);
  border-radius: 50%; cursor: pointer; font-size: 1.2rem; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
  z-index: 2; transition: all 150ms;
  box-shadow: 0 2px 10px rgba(1, 13, 33,0.1);
  opacity: 0;
}
.pdp-main-img-stage:hover .pdp-img-prev,
.pdp-main-img-stage:hover .pdp-img-next { opacity: 1; }
.pdp-img-prev { left: 12px; }
.pdp-img-next { right: 12px; }
.pdp-img-prev:hover, .pdp-img-next:hover {
  background: var(--accent); color: var(--color-text-on-secondary); border-color: var(--accent);
}

/* 360 + video overlay buttons */
.pdp-img-overlay-btns {
  position: absolute; bottom: 14px; left: 50%; transform: translateX(-50%);
  display: flex; gap: var(--space-1); z-index: 2;
  opacity: 0; transition: opacity 200ms;
}
.pdp-main-img-stage:hover .pdp-img-overlay-btns { opacity: 1; }
.pdp-360-trigger, .pdp-video-trigger {
  background: rgba(1, 13, 33,0.68); color: var(--color-brand-white);
  border: none; border-radius: var(--radius-sm); cursor: pointer;
  font-size: 0.73rem; font-weight: 700; padding: 7px 14px;
  display: flex; align-items: center; gap: 5px;
  backdrop-filter: blur(6px); transition: background 150ms;
  white-space: nowrap;
}
.pdp-360-trigger:hover, .pdp-video-trigger:hover { background: rgba(1, 13, 33,0.88); }

/* Image counter */
.pdp-img-counter {
  position: absolute; top: 14px; left: 50%; transform: translateX(-50%);
  background: rgba(1, 13, 33,0.62); color: var(--color-brand-white);
  font-size: 0.7rem; font-weight: 700; padding: 3px 10px; border-radius: var(--radius-sm);
  z-index: 2; backdrop-filter: blur(4px); letter-spacing: 0.04em;
}

/* Zoom hint */
.pdp-zoom-hint {
  position: absolute; bottom: 14px; right: 14px;
  background: rgba(1, 13, 33,0.4); color: var(--color-brand-white);
  font-size: 0.65rem; padding: 3px 8px; border-radius: var(--radius-sm);
  z-index: 2; pointer-events: none;
  opacity: 0; transition: opacity 200ms;
}
.pdp-main-img-stage:hover .pdp-zoom-hint { opacity: 1; }

/* Image card config panel — quantity */
.pdp-img-config {
  border-top: 1px solid var(--border);
  padding: 10px 16px 12px;
  display: flex; flex-direction: column; gap: var(--space-1);
  background: var(--bg-secondary);
}
.pdp-img-qty-row {
  display: flex; align-items: center; gap: 12px;
}
.pdp-img-config-label {
  font-size: 0.78rem; color: var(--text-secondary);
  white-space: nowrap; min-width: 72px;
}
.pdp-img-config-label strong { color: var(--text-primary); font-weight: 700; }

/* Colour + Size selectors -- sit together in the center info column, right
   above the price block (matches the reference layout: swatch circles for
   colour, pill buttons for size). */
.pdp-variant-row { display: flex; gap: 28px; flex-wrap: wrap; margin: 2px 0 4px; }
.pdp-variant-group { display: flex; flex-direction: column; gap: 8px; }
.pdp-variant-group-label { font-size: 0.82rem; color: var(--text-secondary); }
.pdp-variant-group-label strong { color: var(--text-primary); font-weight: 700; }
.pdp-variant-swatches { display: flex; gap: 10px; flex-wrap: wrap; align-items: center; }

.pdp-color-swatch {
  width: 32px; height: 32px; border-radius: 50%; flex-shrink: 0;
  border: 2px solid var(--border); cursor: pointer; padding: 0;
  background-color: var(--bg-tertiary); background-size: cover; background-position: center;
  display: flex; align-items: center; justify-content: center;
  transition: border-color 150ms, transform 150ms, box-shadow 150ms;
}
.pdp-color-swatch:hover { transform: scale(1.08); }
.pdp-color-swatch.active {
  border-color: var(--accent);
  box-shadow: 0 0 0 2px var(--bg-primary), 0 0 0 4px var(--accent);
}
.pdp-color-swatch-fallback {
  font-size: 0.62rem; font-weight: 700; color: var(--text-secondary);
}

/* ════ CENTER: Product info ════ */
.pdp-info { min-width: 0; }

.pdp-cat-label {
  display: inline-flex; align-items: center; gap: 7px;
  font-size: 0.72rem; font-weight: 800; letter-spacing: 0.1em;
  color: var(--accent); text-transform: uppercase; margin-bottom: 10px;
}
.pdp-cat-label::before {
  content: '';
  display: inline-block; width: 16px; height: 2px;
  background: var(--accent); border-radius: 1px;
}

.pdp-title {
  font-size: 1.65rem; font-weight: 800; line-height: 1.28;
  color: var(--text-primary); margin: 0 0 14px;
  letter-spacing: -0.015em;
}

/* Rating row */
.pdp-rating-row {
  display: flex; align-items: center; gap: var(--space-1);
  flex-wrap: wrap; margin-bottom: 12px;
  padding-bottom: 12px; border-bottom: 1px solid var(--border);
}
.pdp-stars { display: flex; gap: 2px; }
.pdp-rating-score {
  font-size: 0.88rem; font-weight: 800; color: var(--text-primary);
  background: rgba(255, 103, 0,0.12); border: 1px solid rgba(255, 103, 0,0.3);
  padding: 2px 8px; border-radius: var(--radius-xs);
}
.pdp-review-cnt { font-size: 0.82rem; color: var(--text-secondary); }
.pdp-qa-count { font-size: 0.82rem; color: var(--accent); font-weight: 600; cursor: pointer; }
.pdp-qa-count:hover { text-decoration: underline; }

/* Badges row */
.pdp-badges-row {
  display: flex; gap: var(--space-1); flex-wrap: wrap; margin-bottom: 12px;
}
.pdp-bestseller-badge {
  display: inline-flex; align-items: center; gap: 5px;
  background: linear-gradient(135deg, var(--color-primary), color-mix(in srgb, var(--color-primary) 80%, var(--color-brand-navy)));
  color: var(--color-text-on-primary); font-size: 0.75rem; font-weight: 700;
  padding: 5px 12px; border-radius: var(--radius-xs); letter-spacing: 0.02em;
}
.pdp-trending-badge {
  display: inline-flex; align-items: center; gap: 5px;
  background: linear-gradient(135deg, var(--accent), var(--accent-secondary));
  color: var(--color-brand-white); font-size: 0.75rem; font-weight: 700;
  padding: 5px 12px; border-radius: var(--radius-xs);
}
.pdp-verified-badge {
  display: inline-flex; align-items: center; gap: 5px;
  background: color-mix(in srgb, var(--success) 10%, transparent); border: 1px solid color-mix(in srgb, var(--success) 30%, transparent);
  color: var(--color-secondary-text); font-size: 0.75rem; font-weight: 700;
  padding: 5px 12px; border-radius: var(--radius-xs);
}
[data-theme="dark"] .pdp-verified-badge {
  color: var(--success); border-color: color-mix(in srgb, var(--success) 30%, transparent); background: color-mix(in srgb, var(--success) 10%, transparent);
}

/* Short description */
.pdp-desc-short {
  font-size: 0.88rem; color: var(--text-secondary);
  line-height: 1.65; margin-bottom: 12px;
}

/* Feature chips */
.pdp-feature-chips {
  display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 14px;
}
.pdp-feature-chip {
  background: var(--bg-secondary); border: 1px solid var(--border);
  color: var(--text-secondary); font-size: 0.78rem;
  padding: 5px 12px; border-radius: var(--radius-xl); transition: all 150ms;
}
.pdp-feature-chip:hover { border-color: var(--accent); color: var(--accent); background: rgba(59, 130, 246,0.05); }

/* Price block */
.pdp-price-block { margin-bottom: 14px; }
.pdp-price-row {
  display: flex; align-items: baseline; gap: 12px; flex-wrap: wrap; margin-bottom: 4px;
}
.pdp-price {
  font-size: 2.4rem; font-weight: 900; color: var(--text-primary);
  line-height: 1; letter-spacing: -0.02em;
}
.pdp-original { font-size: 1rem; color: var(--text-tertiary); text-decoration: line-through; }
.pdp-tax-note { font-size: 0.76rem; color: var(--text-tertiary); margin: 4px 0 0; }

/* Quick trust mini-grid */
.pdp-quick-trust {
  display: grid; grid-template-columns: repeat(2, 1fr); gap: var(--space-1); margin-bottom: 14px;
}
.pdp-qt-item {
  display: flex; align-items: center; gap: var(--space-1);
  background: var(--bg-secondary); border: 1px solid var(--border);
  border-radius: var(--radius-sm); padding: 8px 10px; transition: border-color 150ms;
}
.pdp-qt-item:hover { border-color: var(--accent); }
.pdp-qt-icon { font-size: 1rem; flex-shrink: 0; }
.pdp-qt-text { color: var(--text-primary); font-weight: 600; font-size: 0.8rem; }
/* Was an inline style on the span in ProductDetailPage.js, which meant its
   0.7rem couldn't be reached by the mobile type floor below -- inline styles
   can't be media-queried. Same values, now addressable. */
.pdp-qt-sub { color: var(--text-tertiary); font-size: 0.75rem; }

/* Stock status */
.pdp-stock-status {
  display: inline-flex; align-items: center; gap: 6px;
  font-size: 0.88rem; font-weight: 700; margin-bottom: 14px;
  padding: 6px 14px; border-radius: var(--radius-sm);
}
.pdp-in-stock {
  color: var(--color-secondary-text);
  background: color-mix(in srgb, var(--success) 8%, transparent); border: 1px solid color-mix(in srgb, var(--success) 20%, transparent);
}
[data-theme="dark"] .pdp-in-stock {
  color: var(--success); background: color-mix(in srgb, var(--success) 8%, transparent); border-color: color-mix(in srgb, var(--success) 20%, transparent);
}
/* Unavailable is neutral information, not an error -- muted navy so it
   doesn't compete with the orange buy action. */
.pdp-oos {
  color: rgba(1, 13, 33, 0.58);
  background: rgba(1, 13, 33, 0.06);
  border: 1px solid rgba(1, 13, 33, 0.12);
}
[data-theme="dark"] .pdp-oos {
  color: rgba(255, 255, 255, 0.62);
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.12);
}

.pdp-critical-stock {
  color: var(--danger);
  background: color-mix(in srgb, var(--danger) 8%, transparent);
  border: 1px solid color-mix(in srgb, var(--danger) 20%, transparent);
}

@keyframes pdp-shiver {
  0%,12%,100% { transform: translateX(0); }
  2%  { transform: translateX(-5px) rotate(-0.6deg); }
  4%  { transform: translateX(5px)  rotate(0.6deg);  }
  6%  { transform: translateX(-4px) rotate(-0.4deg); }
  8%  { transform: translateX(4px)  rotate(0.4deg);  }
  10% { transform: translateX(-2px); }
}
.pdp-shiver {
  display: inline-block;
  animation: pdp-shiver 5s ease-in-out infinite;
}

.pdp-low-stock {
  font-size: 0.78rem; font-weight: 700; color: var(--color-primary);
  background: rgba(255, 103, 0,0.1); border: 1px solid rgba(255, 103, 0,0.25);
  padding: 3px 10px; border-radius: var(--radius-xs);
}

/* Seller info block */
.pdp-seller-inline {
  display: flex; align-items: center; gap: 10px; flex-wrap: wrap;
  background: var(--bg-secondary); border: 1px solid var(--border);
  border-radius: var(--radius-sm); padding: 10px 14px; margin-bottom: 14px;
  transition: border-color 150ms;
}
.pdp-seller-inline:hover { border-color: var(--accent); }
.pdp-sil-avatar {
  width: 36px; height: 36px; border-radius: var(--radius-sm); flex-shrink: 0;
  background: linear-gradient(135deg, var(--accent-secondary), var(--accent));
  color: var(--color-brand-white); font-size: 1rem; font-weight: 800;
  display: flex; align-items: center; justify-content: center;
}
.pdp-sil-body { flex: 1 1; min-width: 0; }
.pdp-sil-row { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; margin-bottom: 2px; }
.pdp-sil-label { font-size: 0.78rem; color: var(--text-tertiary); }
.pdp-sil-name { font-size: 0.88rem; font-weight: 700; color: var(--text-primary); }
.pdp-sil-verified {
  background: var(--success); color: var(--color-text-on-secondary);
  font-size: 0.62rem; font-weight: 800; letter-spacing: 0.05em;
  padding: 2px 6px; border-radius: var(--radius-xs);
}
.pdp-sil-meta { display: flex; align-items: center; gap: 5px; }
.pdp-sil-stars { color: var(--color-primary); font-size: 0.75rem; letter-spacing: 1px; }
.pdp-sil-rating { font-size: 0.75rem; color: var(--text-secondary); }
.pdp-sil-store {
  background: none; border: 1.5px solid var(--accent); color: var(--accent);
  font-size: 0.78rem; font-weight: 700; padding: 6px 14px; border-radius: var(--radius-xs);
  cursor: pointer; transition: all 150ms; white-space: nowrap; flex-shrink: 0;
}
.pdp-sil-store:hover { background: var(--accent); color: var(--color-text-on-secondary); }

/* Color variants */
.pdp-colors-wrap { margin-bottom: 14px; }
.pdp-colors-label { font-size: 0.84rem; color: var(--text-secondary); margin-bottom: 8px; }
.pdp-swatches { display: flex; gap: var(--space-1); flex-wrap: wrap; }
.pdp-swatch {
  width: 30px; height: 30px; border-radius: 50%;
  border: 3px solid transparent; cursor: pointer;
  transition: all 150ms; outline: 2px solid var(--border);
}
.pdp-swatch:hover { transform: scale(1.12); }
.pdp-swatch.active { border-color: var(--color-brand-white); outline-color: var(--accent); transform: scale(1.12); }

/* Quantity */
.pdp-qty-row {
  display: flex; align-items: center; gap: 12px; margin-bottom: 0; flex-wrap: wrap;
}
.pdp-qty-label { font-size: 0.88rem; color: var(--text-secondary); font-weight: 500; }
.pdp-qty-ctrl {
  display: flex; align-items: center;
  border: 1.5px solid var(--border); border-radius: var(--radius-sm); overflow: hidden;
}
.pdp-qty-btn {
  background: var(--bg-secondary); border: none;
  width: 38px; height: 38px; font-size: 1.15rem; font-weight: 700;
  cursor: pointer; color: var(--text-primary); transition: all 120ms;
}
.pdp-qty-btn:hover { background: var(--accent); color: var(--color-text-on-secondary); }
.pdp-qty-val {
  min-width: 42px; text-align: center; font-weight: 700; font-size: 0.95rem;
  border-left: 1.5px solid var(--border); border-right: 1.5px solid var(--border);
  padding: 0 8px; line-height: 38px; color: var(--text-primary);
}

/* ════ RIGHT: Purchase sidebar ════ */
.pdp-sidebar {
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: sticky;
  /* Product pages use the compact 60px SubPageHeader. The global
     --topbar-h measures the much taller storefront navigation and was
     forcing this column down by more than 100px. */
  top: 72px;
  align-self: start;
  /* Use the empty space beside the breadcrumb so the purchase controls
     align with the top edge of the product content. */
  margin-top: -30px;
}

/* Delivery card */
.pdp-delivery-card {
  background: var(--bg-secondary); border: 1px solid var(--border);
  border-radius: var(--radius-sm); padding: 14px 16px;
  box-shadow: var(--shadow-card);
}
.pdp-del-hd {
  display: flex; align-items: center; justify-content: space-between;
  font-size: 0.82rem; color: var(--text-secondary); margin-bottom: 12px;
}
.pdp-del-hd strong { color: var(--text-primary); }
.pdp-change-btn {
  background: none; border: none; color: var(--accent);
  font-size: 0.8rem; font-weight: 600; cursor: pointer; padding: 0;
}
.pdp-change-btn:hover { text-decoration: underline; }
.pdp-del-section-title {
  font-size: 0.82rem; font-weight: 700; color: var(--text-primary); margin-bottom: 8px;
}
.pdp-del-opt {
  display: flex; align-items: flex-start; gap: 10px;
  padding: var(--space-1); border-radius: var(--radius-sm); cursor: pointer; transition: background 120ms;
}
.pdp-del-opt:hover { background: var(--bg-tertiary); }
.pdp-del-selected { background: rgba(59, 130, 246,0.06); }
[data-theme="dark"] .pdp-del-selected { background: rgba(59, 130, 246,0.08); }
.pdp-del-opt input[type="radio"] { margin-top: 3px; accent-color: var(--accent); flex-shrink: 0; }
.pdp-del-opt-body { flex: 1 1; }
.pdp-del-name { font-size: 0.82rem; font-weight: 600; color: var(--text-primary); margin: 0; }
.pdp-del-free { color: var(--color-secondary-text); font-weight: 800; margin-left: 5px; font-size: 0.78rem; }
.pdp-del-date { font-size: 0.74rem; color: var(--text-secondary); margin: 2px 0 0; }
.pdp-del-price { font-size: 0.85rem; font-weight: 700; color: var(--text-primary); flex-shrink: 0; }

/* Size chip buttons (used within .pdp-variant-swatches, above) */
.pdp-size-chip {
  min-width: 42px; height: 38px; padding: 0 12px;
  border: 1px solid var(--border); border-radius: var(--radius-sm);
  background: var(--bg-primary); color: var(--text-primary);
  font-size: 0.85rem; font-weight: 600; cursor: pointer; transition: all 150ms;
}
.pdp-size-chip:hover { border-color: var(--accent); }
.pdp-size-chip.active { border-color: var(--accent); background: var(--accent); color: var(--color-text-on-secondary); }
.pdp-size-chip.oos {
  cursor: not-allowed; color: var(--text-tertiary); background: var(--bg-secondary);
  text-decoration: line-through; opacity: 0.6;
}
.pdp-size-chip.oos:hover { border-color: var(--border); }
.pdp-size-error { font-size: 0.78rem; color: var(--danger); font-weight: 600; margin: 8px 0 0; }

/* CTA buttons */
.pdp-sidebar-actions { display: flex; flex-direction: column; gap: var(--space-1); }

/* Back-in-stock notify form */
.pdp-notify-wrap {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 16px;
}
.pdp-notify-form { display: flex; flex-direction: column; gap: 10px; }
.pdp-notify-label { font-size: 0.85rem; font-weight: 600; color: var(--text-primary); margin: 0; }
.pdp-notify-email-hint { font-size: 0.8rem; color: var(--text-secondary); margin: 0; }
.pdp-notify-input {
  width: 100%; padding: 10px 12px; border: 1px solid var(--border);
  border-radius: var(--radius-sm); background: var(--bg-primary);
  color: var(--text-primary); font-size: 0.9rem; box-sizing: border-box;
}
.pdp-notify-input:focus { outline: none; border-color: var(--accent); }
.pdp-notify-btn {
  width: 100%; padding: 12px; border: none; border-radius: var(--radius-sm);
  background: var(--accent); color: var(--color-text-on-secondary); font-weight: 700; font-size: 0.95rem;
  cursor: pointer; transition: background 150ms;
}
.pdp-notify-btn:hover:not(:disabled) { background: var(--accent-hover); }
.pdp-notify-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.pdp-notify-sent {
  display: flex; align-items: center; gap: 8px;
  color: var(--success); font-weight: 600; font-size: 0.9rem;
}
.pdp-notify-sent span { font-size: 1.1rem; }
.pdp-notify-error { font-size: 0.8rem; color: var(--color-primary); margin: 0; }

.pdp-add-cart-btn {
  width: 100%; padding: 15px;
  background: linear-gradient(135deg, var(--accent), var(--accent-hover)); color: var(--color-brand-white);
  border: none; border-radius: var(--radius-sm);
  font-size: 1rem; font-weight: 700; letter-spacing: 0.02em;
  cursor: pointer; transition: all 150ms;
  box-shadow: 0 4px 14px rgba(59, 130, 246,0.35);
}
.pdp-add-cart-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, var(--accent-hover), var(--color-secondary-hover));
  box-shadow: 0 6px 20px rgba(59, 130, 246,0.45); transform: translateY(-1px);
}
.pdp-add-cart-btn:active:not(:disabled) { transform: translateY(0); }
.pdp-add-cart-btn:disabled { opacity: 0.45; cursor: not-allowed; box-shadow: none; }

.pdp-buy-now-btn {
  width: 100%; padding: 15px;
  background: linear-gradient(135deg, var(--color-primary), color-mix(in srgb, var(--color-primary) 80%, var(--color-brand-navy))); color: var(--color-brand-white);
  border: none; border-radius: var(--radius-sm);
  font-size: 1rem; font-weight: 700; letter-spacing: 0.02em;
  cursor: pointer; transition: all 150ms;
  box-shadow: 0 4px 14px rgba(255, 103, 0,0.35);
}
.pdp-buy-now-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, var(--color-primary), color-mix(in srgb, var(--color-primary) 80%, var(--color-brand-navy)));
  box-shadow: 0 6px 20px rgba(255, 103, 0,0.45); transform: translateY(-1px);
}
.pdp-buy-now-btn:active:not(:disabled) { transform: translateY(0); }
.pdp-buy-now-btn:disabled { opacity: 0.45; cursor: not-allowed; box-shadow: none; }

/* Trust benefits 2x2 */
.pdp-benefits-card {
  background: var(--bg-secondary); border: 1px solid var(--border);
  border-radius: var(--radius-sm); padding: 12px 14px;
  display: grid; grid-template-columns: 1fr 1fr; gap: 10px 8px;
  box-shadow: var(--shadow-card);
}
.pdp-benefit-item { display: flex; align-items: flex-start; gap: var(--space-1); }
.pdp-benefit-icon { font-size: 1.05rem; flex-shrink: 0; margin-top: 1px; }
.pdp-benefit-title { font-size: 0.78rem; font-weight: 700; color: var(--text-primary); margin: 0; }
.pdp-benefit-sub { font-size: 0.68rem; color: var(--text-secondary); margin: 0; }

/* Offer card */
.pdp-offer-card {
  background: linear-gradient(135deg, rgba(59, 130, 246,0.06), color-mix(in srgb, var(--accent-secondary) 6%, transparent));
  border: 1px solid rgba(59, 130, 246,0.18); border-radius: var(--radius-sm); padding: 12px 14px;
}
[data-theme="dark"] .pdp-offer-card {
  background: linear-gradient(135deg, rgba(59, 130, 246,0.1), color-mix(in srgb, var(--accent-secondary) 10%, transparent));
  border-color: rgba(59, 130, 246,0.22);
}
.pdp-offer-title { font-size: 0.88rem; font-weight: 700; color: var(--text-primary); margin: 0 0 3px; }
.pdp-offer-sub { font-size: 0.78rem; color: var(--text-secondary); margin: 0 0 8px; }
.pdp-offer-code-row {
  display: flex; align-items: center; gap: var(--space-1);
  background: var(--bg-secondary); border: 1.5px dashed var(--accent);
  border-radius: var(--radius-xs); padding: 6px 10px; margin-bottom: 6px;
  font-size: 0.82rem; color: var(--text-secondary);
}
.pdp-offer-code { color: var(--accent); font-weight: 900; font-size: 0.92rem; letter-spacing: 0.06em; }
.pdp-offer-copy {
  background: none; border: none; cursor: pointer; color: var(--text-secondary);
  margin-left: auto; font-size: 0.9rem; transition: color 150ms;
}
.pdp-offer-copy:hover { color: var(--accent); }
.pdp-offer-timer { font-size: 0.75rem; color: var(--text-secondary); margin: 0; }

/* Social sharing */
.pdp-share-row { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; flex-wrap: wrap; }
.pdp-share-label { font-size: 0.78rem; color: var(--text-muted); font-weight: 600; }
.pdp-share-btn { display: inline-flex; align-items: center; gap: 5px; padding: 4px 10px; border-radius: 6px; font-size: 0.75rem; font-weight: 600; cursor: pointer; text-decoration: none; border: 1px solid var(--border); background: var(--bg-secondary); color: var(--text-secondary); transition: all 0.15s; }
.pdp-share-btn:hover { border-color: var(--accent); color: var(--accent); }
.pdp-share-wa { color: var(--success) !important; border-color: color-mix(in srgb, var(--success) 30%, transparent) !important; background: color-mix(in srgb, var(--success) 6%, transparent) !important; }
.pdp-share-wa:hover { background: color-mix(in srgb, var(--success) 12%, transparent) !important; }
.pdp-share-x { color: var(--text-primary) !important; }

/* Buyer protection badge */
.pdp-buyer-protection {
  margin-top: 12px; padding: 12px 14px;
  border: 1px solid color-mix(in srgb, var(--success) 25%, transparent); border-radius: var(--radius-sm);
  background: color-mix(in srgb, var(--success) 5%, transparent);
}
[data-theme="dark"] .pdp-buyer-protection {
  background: color-mix(in srgb, var(--success) 8%, transparent); border-color: color-mix(in srgb, var(--success) 20%, transparent);
}
.pdp-bp-header { display: flex; align-items: center; gap: 7px; font-size: 0.85rem; font-weight: 700; color: var(--success); margin-bottom: 7px; }
[data-theme="dark"] .pdp-bp-header { color: var(--success); }
.pdp-bp-list { margin: 0; padding: 0 0 0 20px; list-style: disc; }
.pdp-bp-list li { font-size: 0.78rem; color: var(--text-secondary); line-height: 1.7; }

/* ════ Feature Strip — full width, immediately below main ════ */
.pdp-feature-strip {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 0;
  border: 1px solid var(--border); border-radius: var(--radius-md);
  overflow: hidden; background: var(--bg-secondary);
  margin-bottom: 24px;
  box-shadow: var(--shadow-card);
}
.pdp-fs-item {
  display: flex; flex-direction: column; align-items: center;
  gap: 5px; padding: 18px 10px; text-align: center;
  border-right: 1px solid var(--border);
  transition: background 150ms;
}
.pdp-fs-item:last-child { border-right: none; }
.pdp-fs-item:hover { background: var(--bg-tertiary); }
.pdp-fs-icon { font-size: 1.6rem; line-height: 1; margin-bottom: 2px; }
.pdp-fs-title {
  font-size: 0.8rem; font-weight: 700; color: var(--text-primary);
  margin: 0; line-height: 1.3;
}
.pdp-fs-sub { font-size: 0.7rem; color: var(--text-secondary); margin: 0; }

/* Legacy hl-bar (kept for backwards compat) */
.pdp-hl-bar {
  display: grid; grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  gap: 0; border: 1px solid var(--border); border-radius: var(--radius-sm);
  overflow: hidden; background: var(--bg-secondary); margin-bottom: 20px;
  box-shadow: var(--shadow-card);
}
.pdp-hl-item {
  display: flex; align-items: center; gap: var(--space-1);
  padding: 12px 14px; border-right: 1px solid var(--border);
}
.pdp-hl-item:last-child { border-right: none; }
.pdp-hl-icon { font-size: 1.2rem; flex-shrink: 0; }
.pdp-hl-text { font-size: 0.78rem; font-weight: 600; color: var(--text-secondary); }

/* ════ Frequently Bought Together ════ */
.pdp-fbt { margin-bottom: 24px; }
.pdp-section-h2 {
  font-size: 1.05rem; font-weight: 800; margin: 0 0 12px;
  color: var(--text-primary); letter-spacing: -0.01em;
}
.pdp-fbt-row {
  display: flex; align-items: center; flex-wrap: wrap; gap: 12px;
  background: var(--bg-secondary); border: 1px solid var(--border);
  border-radius: var(--radius-sm); padding: 18px 22px;
  box-shadow: var(--shadow-card);
}
.pdp-fbt-item { display: flex; align-items: center; }
.pdp-fbt-plus { font-size: 1.5rem; color: var(--text-tertiary); margin: 0 14px; }
.pdp-fbt-card { display: flex; flex-direction: column; align-items: center; gap: 5px; width: 148px; }
.pdp-fbt-img {
  width: 92px; height: 92px; object-fit: contain;
  border-radius: var(--radius-sm); background: var(--bg-tertiary); padding: 6px;
}
.pdp-fbt-name {
  font-size: 0.75rem; color: var(--text-secondary); text-align: center;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
}
.pdp-fbt-rating-row { display: flex; align-items: center; justify-content: center; gap: 4px; }
.pdp-fbt-price { font-size: 0.88rem; font-weight: 700; color: var(--text-primary); }
.pdp-fbt-total-col { display: flex; flex-direction: column; align-items: flex-start; gap: var(--space-1); margin-left: auto; }
.pdp-fbt-eq { font-size: 1.5rem; color: var(--text-tertiary); }
.pdp-fbt-total-label { font-size: 0.9rem; color: var(--text-secondary); margin: 0; }
.pdp-fbt-save { font-size: 0.84rem; font-weight: 600; margin: 0; }
.pdp-fbt-add-all {
  background: linear-gradient(135deg, var(--accent), var(--accent-hover)); color: var(--color-brand-white);
  border: none; border-radius: var(--radius-sm); padding: 11px 20px;
  font-size: 0.88rem; font-weight: 700; cursor: pointer;
  transition: all 150ms; white-space: nowrap;
  box-shadow: 0 3px 10px rgba(59, 130, 246,0.28);
}
.pdp-fbt-add-all:hover {
  background: linear-gradient(135deg, var(--accent-hover), var(--color-secondary-hover));
  transform: translateY(-1px);
}

/* ════ Tabs ════ */
.pdp-tabs-section { margin-bottom: 24px; }
.pdp-tabs {
  display: flex; gap: 0;
  border-bottom: 2px solid var(--border);
  overflow-x: auto; scrollbar-width: none;
  position: sticky; top: 0; z-index: 20;
  background: var(--bg-primary); padding-top: 4px;
}
.pdp-tabs::-webkit-scrollbar { display: none; }
.pdp-tab {
  background: none; border: none; border-bottom: 2.5px solid transparent;
  margin-bottom: -2px; padding: 12px 20px;
  font-size: 0.88rem; font-weight: 500; color: var(--text-secondary);
  cursor: pointer; white-space: nowrap;
  transition: color 150ms, border-color 150ms;
}
.pdp-tab:hover { color: var(--accent); }
.pdp-tab.active { color: var(--accent); font-weight: 700; border-bottom-color: var(--accent); }
.pdp-tab-body {
  background: var(--bg-secondary); border: 1px solid var(--border);
  border-top: none; border-radius: 0 0 var(--radius-sm) var(--radius-sm);
  padding: 22px 26px;
  box-shadow: var(--shadow-card);
}
.pdp-tab-desc p { font-size: 0.9rem; color: var(--text-secondary); line-height: 1.7; margin-bottom: 14px; }
.pdp-desc-list { padding-left: 20px; margin: 0; }
.pdp-desc-list li { font-size: 0.88rem; color: var(--text-secondary); line-height: 1.7; margin-bottom: 6px; }
.pdp-qa-empty { text-align: center; padding: 32px 20px; font-size: 0.88rem; color: var(--text-secondary); }
.pdp-qa-section { display: flex; flex-direction: column; gap: 24px; }
.pdp-qa-form { display: flex; flex-direction: column; gap: 10px; padding: 16px; background: var(--bg-secondary); border-radius: 12px; border: 1px solid var(--border); }
.pdp-qa-form-title { margin: 0; font-size: 0.92rem; font-weight: 700; color: var(--text-primary); }
.pdp-qa-input { width: 100%; padding: 10px 12px; border-radius: 8px; border: 1px solid var(--border); background: var(--bg-primary); color: var(--text-primary); font-size: 0.88rem; resize: vertical; box-sizing: border-box; font-family: inherit; }
.pdp-qa-anon-row { display: flex; gap: 8px; flex-wrap: wrap; }
.pdp-qa-name-input { flex: 1 1; min-width: 140px; padding: 8px 12px; border-radius: 8px; border: 1px solid var(--border); background: var(--bg-primary); color: var(--text-primary); font-size: 0.85rem; }
.pdp-qa-submit-btn { align-self: flex-start; padding: 8px 18px; borderRadius: 8px; background: var(--accent); color: var(--color-text-on-secondary); border: none; font-weight: 700; cursor: pointer; font-size: 0.85rem; border-radius: 8px; }
.pdp-qa-submit-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.pdp-qa-msg { font-size: 0.82rem; margin: 0; }
.pdp-qa-msg--ok { color: var(--success); }
.pdp-qa-msg--err { color: var(--danger); }
.pdp-qa-list { display: flex; flex-direction: column; gap: 16px; }
.pdp-qa-item { border: 1px solid var(--border); border-radius: 12px; overflow: hidden; }
.pdp-qa-q-row, .pdp-qa-a-row { display: flex; gap: 12px; padding: 12px 16px; align-items: flex-start; }
.pdp-qa-a-row { background: var(--bg-secondary); border-top: 1px solid var(--border); }
.pdp-qa-a-pending { opacity: 0.6; }
.pdp-qa-badge { width: 24px; height: 24px; border-radius: 6px; display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 0.8rem; flex-shrink: 0; margin-top: 2px; }
.pdp-qa-badge--q { background: var(--color-secondary-soft); color: var(--color-secondary-hover); }
.pdp-qa-badge--a { background: var(--color-secondary-soft); color: var(--success); }
[data-theme="dark"] .pdp-qa-badge--q { background: rgba(59, 130, 246,0.2); }
[data-theme="dark"] .pdp-qa-badge--a { background: color-mix(in srgb, var(--success) 20%, transparent); }
.pdp-qa-text { margin: 0 0 3px; font-size: 0.88rem; color: var(--text-primary); line-height: 1.5; }
.pdp-qa-text--muted { color: var(--text-muted); font-style: italic; }
.pdp-qa-meta { margin: 0; font-size: 0.73rem; color: var(--text-muted); }

/* ════ Related products ════ */
.pdp-related { margin-bottom: 32px; }
.pdp-related-grid {
  display: grid; grid-template-columns: repeat(auto-fill, minmax(190px, 1fr)); gap: var(--space-2);
}
.pdp-related-card {
  position: relative;
  background: var(--bg-secondary); border: 1px solid var(--border);
  border-radius: var(--radius-sm); overflow: hidden; cursor: pointer;
  box-shadow: var(--shadow-card);
  transition: transform 200ms, box-shadow 200ms;
}
.pdp-related-card:hover { transform: translateY(-4px); box-shadow: 0 10px 28px rgba(1, 13, 33,0.12); }
.pdp-related-card img {
  width: 100%; height: 150px; object-fit: contain;
  padding: 12px; background: var(--bg-tertiary);
}
.pdp-related-body { padding: 12px; display: flex; flex-direction: column; gap: 6px; }
.pdp-related-body h4 {
  font-size: 0.83rem; font-weight: 600; margin: 0; color: var(--text-primary);
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
}
.pdp-related-rating-row { display: flex; align-items: center; gap: 5px; }
.pdp-related-seller { font-size: 0.75rem; color: var(--text-secondary); margin: 0; }
.pdp-related-seller-name { color: var(--accent); font-weight: 600; }
[data-theme="dark"] .pdp-related-seller-name { color: var(--color-secondary-soft); }
.pdp-related-price-row { display: flex; align-items: baseline; gap: 6px; flex-wrap: wrap; }
.pdp-related-price { font-size: 0.92rem; font-weight: 700; color: var(--text-primary); margin: 0; }
.pdp-related-original { font-size: 0.75rem; color: var(--text-tertiary); text-decoration: line-through; font-weight: 500; }
.pdp-related-stock-row { display: flex; }

/* ════ Responsive ════ */
@media (max-width: 1280px) {
  .pdp-main { grid-template-columns: 380px 1fr 280px; gap: 20px; }
}
@media (max-width: 1100px) {
  .pdp-main { grid-template-columns: 340px 1fr; }
  .pdp-sidebar { display: none; }
}
@media (max-width: 900px) {
  .pdp-main { grid-template-columns: 300px 1fr; gap: var(--space-2); }
  .pdp-title { font-size: 1.4rem; }
  .pdp-price { font-size: 2rem; }
  .pdp-feature-strip { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 768px) {
  .pdp-page { padding: 12px 14px 40px; }
  .pdp-main { grid-template-columns: 1fr; gap: var(--space-2); }
  .pdp-sidebar { display: flex; position: static; margin-top: 0; }
  .pdp-gallery { flex-direction: column-reverse; }
  .pdp-thumbs { flex-direction: row; width: 100%; }
  .pdp-thumb { width: 58px; height: 58px; }
  .pdp-main-img-stage { min-height: 280px; max-height: 340px; }
  .pdp-main-img { height: 260px; }
  .pdp-title { font-size: 1.3rem; }
  .pdp-price { font-size: 1.8rem; }
  .pdp-feature-strip { grid-template-columns: repeat(3, 1fr); }
  .pdp-tabs { position: static; }
  .pdp-quick-trust { grid-template-columns: 1fr 1fr; }

  /* Relax the boxed-card feel -- let the summary and description content
     sit directly on the page background instead of in their own card. */
  .pdp-fbt-row {
    background: transparent;
    border: none;
    box-shadow: none;
    padding: 0;
  }
  .pdp-tab-body {
    background: transparent;
    border: none;
    box-shadow: none;
    padding: 16px 0 0;
  }
}
@media (max-width: 480px) {
  .pdp-feature-strip { grid-template-columns: repeat(2, 1fr); }
  .pdp-main-img { height: 230px; }
  .pdp-fbt-row { flex-direction: column; align-items: flex-start; }
  .pdp-fbt-total-col { margin-left: 0; }
  .pdp-quick-trust { grid-template-columns: 1fr; }
}

/* ════════════════════════════════════════════════════════
   ORDER HISTORY PAGE — modern table design
   ════════════════════════════════════════════════════════ */
.oh-page {
  max-width: 1440px;
  margin: 0 auto;
  padding: 24px 24px 56px;
  background: var(--bg-primary);
  animation: slideIn 300ms ease-out;
}

/* Header */
.oh-page-header {
  display: flex; align-items: flex-start; justify-content: space-between;
  margin-bottom: 24px; gap: var(--space-2); flex-wrap: wrap;
}
.oh-page-title {
  font-size: 1.8rem; font-weight: 800; color: var(--text-primary);
  margin: 0 0 6px; letter-spacing: -0.02em;
}
.oh-breadcrumb {
  display: flex; align-items: center; gap: 6px;
  font-size: 0.82rem; color: var(--text-secondary);
}
.oh-bc-sep { color: var(--text-tertiary); }
.oh-bc-active { color: var(--text-primary); font-weight: 500; }
.oh-export-btn {
  display: flex; align-items: center; gap: var(--space-1);
  background: var(--bg-secondary); border: 1px solid var(--border);
  color: var(--text-primary); font-size: 0.85rem; font-weight: 600;
  padding: 10px 18px; border-radius: var(--radius-sm); cursor: pointer;
  transition: all 150ms; white-space: nowrap;
}
.oh-export-btn:hover { border-color: var(--accent); color: var(--accent); }

/* Stats cards */
.oh-stats-grid {
  display: grid; grid-template-columns: repeat(6, 1fr); gap: 12px;
  margin-bottom: 20px;
}
.oh-stat-card {
  display: flex; align-items: center; gap: 12px;
  background: var(--bg-secondary); border: 1.5px solid var(--border);
  border-radius: var(--radius-sm); padding: 14px 16px;
  box-shadow: var(--shadow-card);
  cursor: pointer; transition: all 150ms; text-align: left;
}
.oh-stat-card:hover { border-color: var(--accent); transform: translateY(-1px); }
.oh-stat-card.active { border-color: var(--accent); background: rgba(59, 130, 246,0.06); }
[data-theme="dark"] .oh-stat-card.active { background: rgba(59, 130, 246,0.08); }
.oh-stat-icon {
  width: 42px; height: 42px; border-radius: var(--radius-sm); flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  font-size: 1.1rem;
}
.oh-stat-body { min-width: 0; }
.oh-stat-label { font-size: 0.75rem; color: var(--text-secondary); margin: 0 0 2px; white-space: nowrap; }
.oh-stat-count { font-size: 1.4rem; font-weight: 800; color: var(--text-primary); margin: 0; line-height: 1.1; }
.oh-stat-sub { font-size: 0.72rem; color: var(--text-secondary); margin: 2px 0 0; }

/* Filters bar */
.oh-filters-bar {
  display: flex; align-items: center; gap: 12px;
  margin-bottom: 20px; flex-wrap: wrap;
}
.oh-search-wrap {
  flex: 1 1; min-width: 240px;
  display: flex; align-items: center; gap: 10px;
  background: var(--bg-secondary); border: 1.5px solid var(--border);
  border-radius: var(--radius-sm); padding: 0 14px;
  transition: border-color 150ms;
}
.oh-search-wrap:focus-within { border-color: var(--accent); }
.oh-search-icon { font-size: 0.95rem; color: var(--text-tertiary); flex-shrink: 0; }
.oh-search-input {
  background: none; border: none; outline: none;
  font-size: 0.88rem; color: var(--text-primary);
  width: 100%; height: 42px; padding: 0;
}
.oh-search-input::placeholder { color: var(--text-tertiary); }
.oh-filter-right { display: flex; align-items: center; gap: 10px; }
.oh-date-select {
  background: var(--bg-secondary); border: 1.5px solid var(--border);
  color: var(--text-primary); font-size: 0.85rem;
  padding: 10px 14px; border-radius: var(--radius-sm); cursor: pointer;
  outline: none; transition: border-color 150ms;
}
.oh-date-select:focus { border-color: var(--accent); }
.oh-filter-btn {
  display: flex; align-items: center; gap: 7px;
  background: var(--bg-secondary); border: 1.5px solid var(--border);
  color: var(--text-primary); font-size: 0.85rem; font-weight: 600;
  padding: 10px 16px; border-radius: var(--radius-sm); cursor: pointer;
  transition: all 150ms;
}
.oh-filter-btn:hover { border-color: var(--accent); color: var(--accent); }

/* Empty state */
.oh-empty {
  display: flex; flex-direction: column; align-items: center;
  padding: 64px 20px; text-align: center;
}
.oh-empty-icon { font-size: 3rem; margin-bottom: 12px; }
.oh-empty-title { font-size: 1.1rem; font-weight: 700; color: var(--text-primary); margin: 0 0 6px; }
.oh-empty-sub { font-size: 0.88rem; color: var(--text-secondary); margin: 0; }

/* Table wrapper */
.oh-table-wrap {
  background: var(--bg-secondary); border: 1px solid var(--border);
  border-radius: var(--radius-md); overflow: hidden; margin-bottom: 20px;
  box-shadow: var(--shadow-card);
}

/* Table header row */
.oh-table-header {
  display: grid;
  grid-template-columns: 140px 1fr 120px 140px 170px 180px;
  gap: 0;
  background: var(--bg-tertiary); border-bottom: 1px solid var(--border);
  padding: 0;
}
.oh-th {
  font-size: 0.75rem; font-weight: 700; color: var(--text-secondary);
  text-transform: uppercase; letter-spacing: 0.06em;
  padding: 12px 16px;
}

/* Row wrapper (holds row + optional expand panel) */
.oh-row-wrap { border-bottom: 1px solid var(--border); transition: background var(--dur-base) var(--ease-in-out), box-shadow var(--dur-base) var(--ease-in-out), transform var(--dur-base) var(--ease-in-out); position: relative; z-index: 1; }
.oh-row-wrap:last-child { border-bottom: none; }
.oh-row-wrap:hover { background: rgba(59, 130, 246,0.02); box-shadow: var(--shadow-card); transform: translateY(-1px); z-index: 2; }
.oh-row-wrap.oh-row-expanded { background: rgba(59, 130, 246,0.03); }

/* Data row */
.oh-row {
  display: grid;
  grid-template-columns: 140px 1fr 120px 140px 170px 180px;
  gap: 0; align-items: center;
}

/* Cells */
.oh-cell { padding: 16px 16px; }
.oh-cell-label {
  font-size: 0.7rem; font-weight: 600; color: var(--text-tertiary);
  text-transform: uppercase; letter-spacing: 0.06em; margin: 0 0 4px;
}

/* Order ID cell */
.oh-order-id { font-size: 0.88rem; font-weight: 700; color: var(--accent); margin: 0; }
.oh-order-date { font-size: 0.75rem; color: var(--text-secondary); margin: 0; line-height: 1.4; }

/* Product cell */
.oh-cell-product { display: flex; align-items: center; gap: 12px; }
.oh-prod-img {
  width: 60px; height: 60px; object-fit: contain;
  border-radius: var(--radius-sm); background: var(--bg-tertiary);
  border: 1px solid var(--border); padding: 4px; flex-shrink: 0;
}
.oh-prod-img-placeholder {
  width: 60px; height: 60px; border-radius: var(--radius-sm);
  background: var(--bg-tertiary); border: 1px solid var(--border);
  display: flex; align-items: center; justify-content: center;
  font-size: 1.4rem; flex-shrink: 0;
}
.oh-prod-info { min-width: 0; }
.oh-prod-name {
  font-size: 0.88rem; font-weight: 600; color: var(--text-primary);
  margin: 0 0 3px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  max-width: 220px;
}
.oh-prod-seller { font-size: 0.75rem; color: var(--text-secondary); margin: 0 0 3px; }
.oh-prod-price { font-size: 0.82rem; color: var(--text-secondary); margin: 0; }
.oh-prod-qty { color: var(--text-tertiary); }
.oh-prod-more { font-size: 0.72rem; color: var(--accent); margin: 2px 0 0; font-weight: 600; }

/* Total cell */
.oh-amount { font-size: 1rem; font-weight: 800; color: var(--text-primary); margin: 4px 0 6px; }
.oh-paid-badge {
  display: inline-block;
  background: color-mix(in srgb, var(--success) 12%, transparent); border: 1px solid color-mix(in srgb, var(--success) 30%, transparent);
  color: var(--success); font-size: 0.72rem; font-weight: 700;
  padding: 2px 9px; border-radius: var(--radius-xs); letter-spacing: 0.04em;
}
[data-theme="dark"] .oh-paid-badge { color: var(--success); border-color: color-mix(in srgb, var(--success) 30%, transparent); background: color-mix(in srgb, var(--success) 10%, transparent); }
.oh-cod-badge {
  background: rgba(255, 103, 0,0.12); border-color: rgba(255, 103, 0,0.3);
  color: var(--color-primary);
}
[data-theme="dark"] .oh-cod-badge { color: var(--color-primary); border-color: rgba(255, 103, 0,0.3); background: rgba(255, 103, 0,0.1); }

/* Payment method cell */
.oh-pay-method { display: flex; align-items: center; gap: var(--space-1); margin-top: 4px; }
.oh-pay-icon {
  display: inline-flex; align-items: center; justify-content: center;
  font-size: 0.65rem; font-weight: 900; letter-spacing: 0.04em;
  width: 36px; height: 24px; border-radius: var(--radius-xs);
  /* A flex item with a width still shrinks -- flex-shrink defaults to 1, and
     the width is only a starting size. In a narrow column the COD/PAY chip was
     squeezed to 31.86px against its declared 36px, which reads as a slightly
     squashed badge rather than as an obvious bug, so it survived a long time. */
  flex-shrink: 0;
}
.oh-pay-visa   { background: #1a1f71; color: var(--color-brand-white); }
.oh-pay-mc     { background: linear-gradient(135deg, #eb001b, #f79e1b); color: var(--color-brand-white); }
.oh-pay-paypal { background: #003087; color: var(--color-brand-white); font-size: 0.8rem; }
.oh-pay-masked { font-size: 0.82rem; color: var(--text-secondary); letter-spacing: 0.04em; }

/* Status cell */
.oh-status-badge {
  display: inline-block;
  font-size: 0.75rem; font-weight: 700; letter-spacing: 0.04em;
  padding: 4px 12px; border-radius: var(--radius-xs); margin: 4px 0 6px;
}
.oh-status-sub { font-size: 0.72rem; color: var(--text-secondary); margin: 0; line-height: 1.5; }

/* Actions cell */
.oh-cell-actions { display: flex; flex-direction: column; gap: var(--space-1); padding: 12px 16px; }
.oh-view-btn {
  width: 100%; padding: 9px 16px;
  background: var(--accent); color: var(--color-text-on-secondary);
  border: none; border-radius: var(--radius-sm);
  font-size: 0.82rem; font-weight: 700; cursor: pointer;
  transition: all 150ms;
}
.oh-view-btn:hover { background: var(--accent-hover); transform: translateY(-1px); }
.oh-cancel-btn {
  width: 100%; padding: 8px 16px;
  background: color-mix(in srgb, var(--danger) 8%, transparent); color: var(--danger);
  border: 1px solid color-mix(in srgb, var(--danger) 30%, transparent); border-radius: var(--radius-sm);
  font-size: 0.82rem; font-weight: 600; cursor: pointer;
  transition: all 150ms;
}
.oh-cancel-btn:hover { background: color-mix(in srgb, var(--danger) 15%, transparent); }
.oh-buy-again-btn {
  width: 100%; padding: 8px 16px;
  background: var(--bg-tertiary); color: var(--text-primary);
  border: 1px solid var(--border); border-radius: var(--radius-sm);
  font-size: 0.82rem; font-weight: 600; cursor: pointer;
  transition: all 150ms;
}
.oh-buy-again-btn:hover { border-color: var(--accent); color: var(--accent); }

/* Detail expand panel */
.oh-detail-panel {
  padding: 0 20px 20px;
  border-top: 1px solid var(--border);
  background: var(--bg-primary);
}
.oh-detail-section-title {
  font-size: 0.78rem; font-weight: 700; color: var(--text-secondary);
  text-transform: uppercase; letter-spacing: 0.06em;
  margin: 16px 0 10px;
}
.oh-detail-items { display: flex; flex-direction: column; gap: var(--space-1); }
.oh-detail-item {
  display: flex; align-items: center; gap: 12px;
  background: var(--bg-secondary); border: 1px solid var(--border);
  border-radius: var(--radius-sm); padding: 10px 14px;
}
.oh-detail-item-img {
  width: 40px; height: 40px; object-fit: contain;
  border-radius: var(--radius-xs); background: var(--bg-tertiary); padding: 3px;
}
.oh-detail-item-name { flex: 1 1; font-size: 0.85rem; color: var(--text-primary); font-weight: 500; }
.oh-detail-item-qty  { font-size: 0.82rem; color: var(--text-secondary); }
.oh-detail-item-price { font-size: 0.88rem; font-weight: 700; color: var(--text-primary); }
.oh-detail-addr { font-size: 0.85rem; color: var(--text-secondary); line-height: 1.6; }
.oh-detail-addr p { margin: 0; }

/* Pagination */
.oh-pagination {
  display: flex; align-items: center; justify-content: space-between;
  flex-wrap: wrap; gap: 12px;
}
.oh-pagination-info { font-size: 0.85rem; color: var(--text-secondary); margin: 0; }
.oh-page-btns { display: flex; align-items: center; gap: 6px; }
.oh-page-arrow {
  width: 36px; height: 36px;
  background: var(--bg-secondary); border: 1px solid var(--border);
  color: var(--text-primary); font-size: 1.1rem; font-weight: 700;
  border-radius: var(--radius-sm); cursor: pointer; display: flex; align-items: center; justify-content: center;
  transition: all 150ms;
}
.oh-page-arrow:hover:not(:disabled) { border-color: var(--accent); color: var(--accent); }
.oh-page-arrow:disabled { opacity: 0.35; cursor: not-allowed; }
.oh-page-num {
  width: 36px; height: 36px;
  background: var(--bg-secondary); border: 1px solid var(--border);
  color: var(--text-secondary); font-size: 0.85rem; font-weight: 600;
  border-radius: var(--radius-sm); cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: all 150ms;
}
.oh-page-num:hover { border-color: var(--accent); color: var(--accent); }
.oh-page-num.active {
  background: var(--accent); border-color: var(--accent); color: var(--color-text-on-secondary);
}
.oh-page-ellipsis { font-size: 0.85rem; color: var(--text-tertiary); padding: 0 4px; }

/* Responsive */
@media (max-width: 1200px) {
  .oh-stats-grid { grid-template-columns: repeat(3, 1fr); }
  .oh-table-header,
  .oh-row { grid-template-columns: 130px 1fr 110px 130px 150px 160px; }
}
@media (max-width: 1024px) {
  .oh-stats-grid { grid-template-columns: repeat(3, 1fr); }
  .oh-table-wrap { overflow-x: auto; }
  .oh-table-header,
  .oh-row { min-width: 900px; }
}
@media (max-width: 768px) {
  .oh-page { padding: 16px 14px 40px; }
  .oh-stats-grid { grid-template-columns: repeat(2, 1fr); }
  .oh-page-title { font-size: 1.4rem; }
}
/* Stacked card layout for the order list on phones -- the grid-table
   forced a 900px min-width and horizontal scroll, cramming the whole
   row into a thin sliver of the viewport. Below 640px each row becomes
   its own full-width card instead. */
@media (max-width: 640px) {
  .oh-page { padding: 14px 8px 40px; }
  .oh-table-wrap {
    background: transparent; border: none; box-shadow: none;
    overflow: visible; margin-bottom: 0;
  }
  .oh-table-header { display: none; }
  .oh-row-wrap {
    display: block; border-bottom: none; margin-bottom: 14px;
    background: var(--bg-secondary); border: 1px solid var(--border);
    border-radius: var(--radius-md); box-shadow: var(--shadow-card);
    overflow: hidden;
  }
  .oh-row-wrap:last-child { margin-bottom: 0; }
  .oh-row-wrap:hover { transform: none; }
  .oh-row { display: block; min-width: 0; }
  .oh-cell { padding: 14px 16px; border-bottom: 1px solid var(--border); }
  .oh-cell:last-child { border-bottom: none; }
  .oh-cell-product { flex-wrap: wrap; }
  .oh-prod-name { max-width: none; white-space: normal; }
  .oh-cell-actions { flex-direction: row; gap: 10px; padding: 14px 16px; }
  .oh-cell-actions button { flex: 1 1; width: auto; }
  .oh-detail-panel { padding: 0 16px 16px; }
}
@media (max-width: 480px) {
  .oh-stats-grid { grid-template-columns: 1fr 1fr; }
  .oh-stat-card { padding: 10px 12px; gap: var(--space-1); }
  .oh-stat-count { font-size: 1.2rem; }
}

/* ═══════════════════════════════════════════════════════════
   ADDRESS BOOK  (.ab-*)
   ══════════════════════════════════════════════════════════ */

.ab-page {
  min-height: 100vh;
  background: var(--bg-secondary);
  padding: 32px 24px 60px;
}

/* Page header */
.ab-page-hdr {
  max-width: 760px;
  margin: 0 auto 28px;
}
.ab-page-title {
  font-size: 1.75rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0 0 6px;
}
.ab-page-sub {
  font-size: 0.9rem;
  color: var(--text-secondary);
  margin: 0;
}

/* Cards grid */
.ab-cards-grid {
  max-width: 760px;
  margin: 0 auto 28px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
  gap: var(--space-2);
}

/* Address card */
.ab-card {
  background: var(--bg-primary);
  border: 1.5px solid var(--border);
  border-radius: var(--radius-md);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 0;
  transition: box-shadow 150ms, border-color 150ms;
  box-shadow: 0 1px 4px rgba(1, 13, 33,0.06);
}
.ab-card:hover {
  box-shadow: 0 4px 16px rgba(1, 13, 33,0.1);
}
.ab-card--default {
  border-color: var(--accent);
  border-width: 2px;
}
.ab-card--selected {
  border-color: var(--accent);
  border-width: 2px;
  background: rgba(59, 130, 246,0.04);
}

/* Card top row */
.ab-card-top {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}
.ab-card-icon-wrap {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(59, 130, 246,0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--accent);
}
.ab-card-name {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
  flex: 1 1;
}
.ab-default-badge {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  background: var(--accent);
  color: var(--color-text-on-secondary);
  padding: 3px 10px;
  border-radius: var(--radius-xl);
  white-space: nowrap;
}
.ab-selected-check {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--accent);
  color: var(--color-text-on-secondary);
  font-size: 0.75rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* Info rows */
.ab-card-info {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding-bottom: 14px;
}
.ab-info-row {
  display: flex;
  align-items: flex-start;
  gap: var(--space-1);
  font-size: 0.85rem;
  color: var(--text-secondary);
  line-height: 1.5;
}
.ab-info-icon {
  display: flex;
  align-items: center;
  padding-top: 2px;
  flex-shrink: 0;
  color: var(--text-secondary);
  opacity: 0.7;
}

/* Card actions */
.ab-card-actions {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding-top: 14px;
  border-top: 1px solid var(--border);
  margin-top: auto;
}
.ab-edit-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  padding: 0;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--accent);
  cursor: pointer;
  transition: opacity 150ms;
}
.ab-edit-btn:hover { opacity: 0.75; }
.ab-set-default-btn {
  background: none;
  border: none;
  padding: 0;
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--text-secondary);
  cursor: pointer;
  transition: color 150ms;
}
.ab-set-default-btn:hover { color: var(--accent); }
.ab-remove-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  padding: 0;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--danger);
  cursor: pointer;
  transition: opacity 150ms;
  margin-left: auto;
}
.ab-remove-btn:hover { opacity: 0.75; }

/* Add New Address card */
.ab-add-card {
  border: 2px dashed var(--border);
  border-radius: var(--radius-md);
  padding: 28px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-1);
  cursor: pointer;
  transition: border-color 150ms, background 150ms;
  background: transparent;
  min-height: 160px;
}
.ab-add-card:hover {
  border-color: var(--accent);
  background: rgba(59, 130, 246,0.03);
}
.ab-add-plus {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--accent);
  color: var(--color-text-on-secondary);
  font-size: 1.6rem;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 300;
  transition: transform 150ms;
}
.ab-add-card:hover .ab-add-plus { transform: scale(1.08); }
.ab-add-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--accent);
}
.ab-add-sub {
  font-size: 0.8rem;
  color: var(--text-secondary);
  text-align: center;
}

/* Inline form */
.ab-form-wrap {
  max-width: 760px;
  margin: 0 auto 28px;
}
.ab-form {
  background: var(--bg-primary);
  border: 1.5px solid var(--border);
  border-radius: var(--radius-md);
  padding: 28px;
  box-shadow: 0 1px 4px rgba(1, 13, 33,0.06);
}
.ab-form-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 20px;
}
.ab-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
.ab-form-field { display: flex; flex-direction: column; gap: 5px; }
.ab-form-full { grid-column: 1 / -1; }
.ab-form-field label {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-secondary);
}
.ab-form-field input,
.ab-form-field textarea {
  height: 40px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 0 12px;
  font-size: 0.88rem;
  background: var(--bg-secondary);
  color: var(--text-primary);
  outline: none;
  transition: border-color 150ms;
  font-family: inherit;
}
.ab-form-field textarea {
  height: auto;
  padding: 10px 12px;
  resize: vertical;
}
.ab-form-field input:focus,
.ab-form-field textarea:focus { border-color: var(--accent); }
.ab-form-btns {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}
.ab-cancel-btn {
  background: var(--bg-secondary);
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 0 20px;
  height: 40px;
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  transition: border-color 150ms;
}
.ab-cancel-btn:hover { border-color: var(--text-secondary); }

/* Security banner */
.ab-security-banner {
  max-width: 760px;
  margin: 0 auto;
  background: var(--bg-primary);
  border: 1.5px solid var(--border);
  border-radius: var(--radius-md);
  padding: 20px 24px;
  display: flex;
  align-items: center;
  gap: var(--space-2);
  overflow: hidden;
  position: relative;
  box-shadow: 0 1px 4px rgba(1, 13, 33,0.06);
}
.ab-sec-shield {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: rgba(59, 130, 246,0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ab-sec-text {
  flex: 1 1;
}
.ab-sec-text strong {
  display: block;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 3px;
}
.ab-sec-text p {
  font-size: 0.82rem;
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.5;
}
.ab-sec-watermark {
  position: absolute;
  right: -10px;
  bottom: -10px;
  opacity: 1;
  pointer-events: none;
}

/* Dark mode adjustments */
[data-theme='dark'] .ab-card--default,
[data-theme='dark'] .ab-card--selected {
  background: rgba(59, 130, 246,0.08);
}

/* Responsive */
@media (max-width: 600px) {
  .ab-page { padding: 20px 8px 40px; }
  .ab-cards-grid { grid-template-columns: 1fr; }
  .ab-form-grid { grid-template-columns: 1fr; }
  .ab-form-full { grid-column: 1; }
  .ab-form { padding: 18px; }
  .ab-form-field input { height: 44px; font-size: 0.95rem; }
}

/* ═══════════════════════════════════════════════════════════
   DELIVERY MAP PICKER  (.dmp-*)
   Built entirely from existing theme CSS variables so dark mode is
   automatic via [data-theme] -- the only literal-color exceptions are the
   Leaflet tile layer itself (an external raster image, not stylable) and
   the small inline error/hint text tones below.
   ══════════════════════════════════════════════════════════ */

.dmp-wrap {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}
.dmp-locate-btn {
  align-self: flex-start;
  background: var(--bg-primary);
  border: 1.5px solid var(--border);
  border-radius: var(--radius-md);
  color: var(--text-primary);
  font-size: 0.88rem;
  font-weight: 600;
  padding: 10px 16px;
  min-height: 40px;
  cursor: pointer;
  transition: border-color 150ms, background 150ms;
}
.dmp-locate-btn:hover:not(:disabled) { border-color: var(--accent); }
.dmp-locate-btn:disabled { opacity: 0.6; cursor: default; }
.dmp-locate-error {
  font-size: 0.82rem;
  color: var(--color-primary);
  background: rgba(180,83,9,0.1);
  border-radius: 8px;
  padding: 8px 12px;
}
.dmp-map-box {
  width: 100%;
  min-height: 260px;
  height: 300px;
  border-radius: var(--radius-md);
  overflow: hidden;
  border: 1.5px solid var(--border);
}
.dmp-map {
  width: 100%;
  height: 100%;
}
/* Stands in for the leaflet map while its chunk loads. It is rendered with
   .dmp-map-box alongside it, so it inherits that box's exact height -- and the
   240px mobile override further down -- and the address form does not jump
   when the real map swaps in. */
.dmp-map-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  color: var(--text-secondary);
  background: var(--bg-secondary);
}
.dmp-hint {
  font-size: 0.82rem;
  color: var(--text-secondary);
  margin: 0;
}
@media (max-width: 600px) {
  .dmp-map-box { height: 240px; }
  .dmp-locate-btn { width: 100%; text-align: center; }
}

/* ── Guest address map pin (.addr-pin-*) ──────────────────────────────────
   The collapsed entry point to DeliveryMapPicker on the two address forms a
   guest sees. Blue throughout, not orange: this is secondary interaction and
   information, while orange is reserved for the commercial actions (Add to
   Cart, Place Order) that sit on these same screens. Making the pin orange
   would put it in direct competition with the button the customer is meant
   to press next.

   The label stays navy in every state. Blue is carried by the border, the
   icon disc and the tint, because blue text this small on white is 3.68:1
   and misses AA -- the same reason links here use --color-secondary-text. */
.addr-pin-block {
  width: 100%;
  margin: 4px 0 14px;
}
.addr-pin-toggle {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  text-align: left;
  padding: 12px 14px;
  background: var(--color-surface);
  border: 1.5px dashed var(--color-border-strong);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: border-color 150ms, background 150ms;
}
.addr-pin-toggle:hover {
  border-color: var(--color-secondary);
  background: var(--color-surface-hover);
}
/* Solid once a pin exists: dashed reads as "empty slot", and this slot is
   now filled. */
.addr-pin-toggle-set {
  border-style: solid;
  border-color: var(--color-secondary);
  background: var(--color-secondary-soft);
}
.addr-pin-toggle-icon {
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: var(--color-secondary-soft);
  font-size: 1rem;
  line-height: 1;
}
.addr-pin-toggle-set .addr-pin-toggle-icon {
  background: var(--color-secondary);
}
.addr-pin-toggle-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.addr-pin-toggle-text strong {
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--text-primary);
}
.addr-pin-toggle-text small {
  font-size: 0.78rem;
  color: var(--text-secondary);
  /* Coordinates and a reverse-geocoded area name can run long on a phone;
     one line that truncates beats a wrapped block that shifts the button. */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.addr-pin-label {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 8px;
}
.addr-pin-done {
  align-self: flex-start;
  margin-top: 10px;
  padding: 9px 18px;
  background: var(--color-secondary);
  color: var(--color-text-on-secondary);
  border: none;
  border-radius: var(--radius-md);
  font-size: 0.86rem;
  font-weight: 700;
  cursor: pointer;
}
.addr-pin-done:hover { background: var(--color-secondary-hover); }

@media (max-width: 600px) {
  .addr-pin-done { width: 100%; text-align: center; }
}

/* ═══════════════════════════════════════════════════════════
   ORDER DETAIL PANEL  (.odp-*)
   ══════════════════════════════════════════════════════════ */

.odp-wrap {
  padding: 24px 28px 32px;
  background: var(--bg-secondary);
  border-top: 2px solid var(--border);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.odp-back {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: none;
  border: none;
  color: var(--accent);
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  width: fit-content;
  transition: opacity 150ms;
}
.odp-back:hover { opacity: 0.75; }

/* Summary bar */
.odp-summary-bar {
  background: var(--bg-primary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 20px 24px;
  display: flex;
  align-items: flex-start;
  gap: 28px;
  flex-wrap: wrap;
  box-shadow: 0 1px 4px rgba(1, 13, 33,0.05);
}
.odp-sum-identity { min-width: 160px; }
.odp-sum-order-num {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-secondary);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin: 0 0 3px;
}
.odp-sum-order-num strong { color: var(--accent); font-size: 0.92rem; }
.odp-sum-date { font-size: 0.8rem; color: var(--text-secondary); margin: 0 0 8px; }
.odp-sum-status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: var(--radius-xl);
  font-size: 0.75rem;
  font-weight: 700;
}
.odp-sum-delivered { font-size: 0.78rem; color: var(--text-secondary); margin: 6px 0 0; }

.odp-sum-product { display: flex; align-items: center; gap: 10px; }
.odp-sum-thumb {
  width: 48px; height: 48px;
  object-fit: contain;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  background: var(--bg-secondary);
}
.odp-sum-sold-label { font-size: 0.75rem; color: var(--text-secondary); margin: 0 0 2px; }
.odp-sum-seller { font-size: 0.86rem; font-weight: 600; color: var(--accent); margin: 0; cursor: pointer; }
.odp-sum-seller:hover { text-decoration: underline; }

.odp-sum-amount { text-align: center; }
.odp-sum-field-label { font-size: 0.75rem; color: var(--text-secondary); margin: 0 0 4px; }
.odp-sum-total { font-size: 1.35rem; font-weight: 800; color: var(--text-primary); margin: 0 0 6px; }
.odp-paid-chip {
  display: inline-block;
  background: color-mix(in srgb, var(--success) 12%, transparent);
  color: var(--success);
  border: 1px solid color-mix(in srgb, var(--success) 25%, transparent);
  border-radius: var(--radius-xl);
  font-size: 0.72rem;
  font-weight: 700;
  padding: 2px 8px;
}
[data-theme='dark'] .odp-paid-chip { color: var(--success); }
.odp-cod-chip {
  background: rgba(255, 103, 0,0.12);
  color: var(--color-primary);
  border-color: rgba(255, 103, 0,0.25);
}
[data-theme='dark'] .odp-cod-chip { color: var(--color-primary); }
.odp-cod-text { color: var(--color-primary); font-weight: 600; font-size: 0.84rem; }
[data-theme='dark'] .odp-cod-text { color: var(--color-primary); }

.odp-sum-payment { min-width: 120px; }
.odp-sum-addr-col { min-width: 160px; }

/* ── Changing the delivery address on a placed order ───────────────────── */

.odp-sum-addr-hint { color: var(--text-muted); }

/* A link, not a button: it opens a form rather than doing anything, and next
   to Invoice/Buy Again/Open Dispute a fourth filled button would read as a
   fourth equally-likely action. Blue is the interaction colour; orange is
   reserved for commercial actions. */
.odp-addr-change {
  margin-top: 8px;
  padding: 0;
  background: none;
  border: none;
  font: inherit;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--color-secondary-text);
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.odp-addr-change:hover { color: var(--color-brand-navy); }
.odp-addr-change:focus-visible { outline: 2px solid var(--color-secondary); outline-offset: 2px; border-radius: 4px; }

.odp-addr-form {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 6px;
  max-width: 340px;
}

.odp-addr-label {
  font-size: 0.76rem;
  font-weight: 600;
  color: var(--text-secondary);
  margin-top: 6px;
}

.odp-addr-optional { font-weight: 500; color: var(--text-muted); }

.odp-addr-input {
  width: 100%;
  box-sizing: border-box;
  padding: 8px 10px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  font: inherit;
  font-size: 0.88rem;
}

.odp-addr-input:focus-visible {
  outline: 2px solid var(--color-secondary);
  outline-offset: 1px;
  border-color: var(--color-secondary);
}

.odp-addr-textarea { resize: vertical; min-height: 64px; }

/* Carries an icon as well as the colour: with only four hues in this system,
   orange is danger and promotion both, so an error may never be signalled by
   colour alone. */
.odp-addr-error {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin: 8px 0 0;
  font-size: 0.8rem;
  line-height: 1.5;
  color: var(--color-primary);
}

.odp-addr-error svg { flex: 0 0 auto; margin-top: 2px; }

.odp-addr-actions { display: flex; gap: 8px; margin-top: 12px; }

.odp-addr-save {
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  background: var(--color-secondary);
  color: var(--color-text-on-secondary);
  font: inherit;
  font-size: 0.85rem;
  font-weight: 700;
  cursor: pointer;
}

.odp-addr-save:disabled { opacity: 0.6; cursor: default; }

.odp-addr-cancel {
  padding: 8px 16px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: transparent;
  color: var(--text-secondary);
  font: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
}

/* The one case worth reading twice: the delivery fee moved, so the total did. */
.odp-addr-notice {
  margin: 8px 0 0;
  font-size: 0.8rem;
  line-height: 1.5;
  color: var(--text-secondary);
  max-width: 340px;
}
.odp-sum-addr-name { font-size: 0.86rem; font-weight: 600; color: var(--text-primary); margin: 0 0 2px; }
.odp-sum-addr-text { font-size: 0.8rem; color: var(--text-secondary); margin: 0; line-height: 1.5; }

.odp-sum-btns { display: flex; flex-direction: column; gap: var(--space-1); margin-left: auto; }
.odp-invoice-btn, .odp-buy-again-btn {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 9px 18px;
  border-radius: var(--radius-sm);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 150ms, border-color 150ms;
  white-space: nowrap;
}
.odp-invoice-btn {
  background: var(--bg-primary);
  border: 1.5px solid var(--border);
  color: var(--accent);
}
.odp-invoice-btn:hover { border-color: var(--accent); background: rgba(59, 130, 246,0.04); }
.odp-buy-again-btn {
  background: var(--bg-primary);
  border: 1.5px solid var(--border);
  color: var(--text-primary);
}
.odp-buy-again-btn:hover { border-color: var(--accent); }

/* Timeline card */
.odp-timeline-card {
  background: var(--bg-primary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 28px 32px;
  box-shadow: 0 1px 4px rgba(1, 13, 33,0.05);
}
.odp-timeline {
  display: flex;
  align-items: flex-start;
  gap: 0;
}
.odp-tl-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
  position: relative;
}
.odp-tl-track {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  position: relative;
}
.odp-tl-dot {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-secondary);
  border: 2px solid var(--border);
  color: var(--text-secondary);
  z-index: 1;
  flex-shrink: 0;
  transition: background 200ms, border-color 200ms;
}
.odp-tl-dot--done {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--color-text-on-secondary);
}
.odp-tl-dot--current:not(.odp-tl-dot--done) {
  border-color: var(--accent);
  color: var(--accent);
  background: rgba(59, 130, 246,0.08);
}
.odp-tl-line {
  flex: 1 1;
  height: 3px;
  background: var(--border);
  position: absolute;
  left: calc(50% + 22px);
  right: calc(-50% + 22px);
  top: 50%;
  transform: translateY(-50%);
  z-index: 0;
  transition: background 300ms;
}
.odp-tl-line--filled { background: var(--accent); }
.odp-tl-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  margin-top: 10px;
  text-align: center;
}
.odp-tl-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-secondary);
}
.odp-tl-label--done { color: var(--text-primary); }
.odp-tl-time { font-size: 0.75rem; color: var(--text-secondary); }
.odp-tl-track-btn {
  background: none;
  border: none;
  color: var(--accent);
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  margin-top: 2px;
}
.odp-tl-track-btn:hover { text-decoration: underline; }
.odp-tl-otp-note {
  display: block;
  font-size: 0.78rem;
  color: var(--text-secondary);
  margin-top: 4px;
  max-width: 260px;
}
.odp-timeline-cancelled {
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--danger);
  font-weight: 700;
  font-size: 0.92rem;
  padding: 16px 0;
}
.odp-tl-cancelled-date { color: var(--text-secondary); font-weight: 400; font-size: 0.82rem; }
.odp-timeline-refunded { color: var(--accent-secondary); }
.odp-timeline-exchanged { color: var(--accent-secondary); }

/* Two-column body */
.odp-body {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: var(--space-2);
  align-items: start;
}

/* Items card */
.odp-items-card {
  background: var(--bg-primary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(1, 13, 33,0.05);
}
.odp-items-hdr {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border);
}
.odp-items-title { font-size: 0.95rem; font-weight: 700; color: var(--text-primary); }
.odp-items-count {
  background: rgba(59, 130, 246,0.1);
  color: var(--accent);
  font-size: 0.75rem;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: var(--radius-xl);
}
.odp-items-list { display: flex; flex-direction: column; }
.odp-item-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border);
  transition: background 120ms;
}
.odp-item-row:last-child { border-bottom: none; }
.odp-item-row:hover { background: var(--bg-secondary); }
.odp-item-img-wrap { flex-shrink: 0; }
.odp-item-img {
  width: 56px; height: 56px;
  object-fit: contain;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  background: var(--bg-secondary);
  padding: 4px;
}
.odp-item-ph {
  width: 56px; height: 56px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  background: var(--bg-secondary);
  display: flex; align-items: center; justify-content: center;
  font-size: 1.4rem;
}
.odp-item-info { flex: 1 1; min-width: 0; }
.odp-item-name { font-size: 0.9rem; font-weight: 600; color: var(--text-primary); margin: 0 0 3px; }
.odp-item-sku  { font-size: 0.75rem; color: var(--text-secondary); margin: 0 0 2px; }
.odp-item-qty  { font-size: 0.75rem; color: var(--text-secondary); margin: 0; }
.odp-item-price {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-primary);
  white-space: nowrap;
  flex-shrink: 0;
}
.odp-item-btns { display: flex; gap: var(--space-1); flex-shrink: 0; }
.odp-review-btn {
  padding: 7px 14px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: border-color 150ms;
}
.odp-review-btn:hover { border-color: var(--accent); color: var(--accent); }
.odp-support-btn {
  padding: 7px 14px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--bg-primary);
  color: var(--text-secondary);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: border-color 150ms;
}
.odp-support-btn:hover { border-color: var(--text-secondary); }

/* Order summary footer */
.odp-order-summary {
  padding: 16px 20px;
  border-top: 1px solid var(--border);
  background: var(--bg-secondary);
  box-shadow: var(--shadow-card);
}
.odp-os-title { font-size: 0.85rem; font-weight: 700; color: var(--text-primary); margin: 0 0 12px; }
.odp-os-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.84rem;
  color: var(--text-secondary);
  margin-bottom: 6px;
}
.odp-os-free { color: var(--success); font-weight: 600; }
[data-theme='dark'] .odp-os-free { color: var(--success); }
.odp-os-total {
  font-size: 0.95rem;
  font-weight: 800;
  color: var(--text-primary);
  border-top: 1px solid var(--border);
  padding-top: 10px;
  margin-top: 6px;
  margin-bottom: 0;
}

/* Right side cards */
.odp-right { display: flex; flex-direction: column; gap: 14px; }
.odp-side-card {
  background: var(--bg-primary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 18px 20px;
  box-shadow: 0 1px 4px rgba(1, 13, 33,0.05);
}
.odp-side-title {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  font-size: 0.92rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 14px;
}
.odp-delivery-key-card { text-align: center; }
.odp-delivery-key-card .odp-side-title { justify-content: center; }
.odp-delivery-key-value {
  font-size: 1.7rem;
  font-weight: 800;
  letter-spacing: 4px;
  color: var(--text-primary);
  background: var(--bg-secondary);
  border-radius: var(--radius-md);
  padding: 10px 0;
  margin-bottom: 14px;
}
.odp-delivery-key-qr {
  display: flex;
  justify-content: center;
  padding: 12px;
  background: var(--color-brand-white);
  border-radius: var(--radius-md);
  width: fit-content;
  margin: 0 auto;
}
.odp-detail-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 10px;
}
.odp-dl { font-size: 0.78rem; color: var(--text-secondary); margin: 0; }
.odp-dv { font-size: 0.84rem; color: var(--text-primary); font-weight: 500; margin: 0; }
/* Right-aligned ONLY in the row shape this was written for: .odp-detail-row is
   a space-between flex row, label left and value right, and there it is correct.
   The Payment Details card uses the same two class names stacked instead --
   value under its label -- and the global rule pushed the customer name and
   billing address to the right edge while their labels stayed left. Measured at
   a 368px viewport: label starting at x=46, value ending at x=322. */
.odp-detail-row .odp-dv { text-align: right; }
.odp-tracking { display: flex; align-items: center; gap: 6px; font-family: monospace; font-size: 0.78rem; }
.odp-copy-btn {
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  transition: color 150ms;
}
.odp-copy-btn:hover { color: var(--accent); }
.odp-track-ship-btn {
  width: 100%;
  padding: 9px;
  margin-top: 6px;
  border: 1.5px solid var(--accent);
  border-radius: var(--radius-sm);
  background: rgba(59, 130, 246,0.05);
  color: var(--accent);
  font-size: 0.86rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 150ms;
}
.odp-track-ship-btn:hover { background: rgba(59, 130, 246,0.1); }
.odp-payment-cols {
  display: grid;
  /* auto-fit, not a fixed \`1fr 1fr\`, because this card gets narrow in two
     different ways: stacked full-width on a phone, and side by side in the
     <=900px flex row where .odp-side-card is only min-width:240px.
     Two fixed tracks gave 132px each at a 368px viewport, which wrapped the
     label "Payment Method" onto two lines and broke "Cash on Delivery" in half
     beside its COD chip -- the card looked broken without anything actually
     overflowing, which is why it did not show up as clipping.
     Below ~312px of grid the tracks collapse to one and each field gets the
     full card width. */
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
}
.odp-help-link {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  width: 100%;
  padding: 11px 12px;
  background: none;
  border: none;
  border-radius: var(--radius-sm);
  font-size: 0.84rem;
  font-weight: 500;
  color: var(--text-primary);
  cursor: pointer;
  text-align: left;
  transition: background 150ms;
  border-bottom: 1px solid var(--border);
}
.odp-help-link:last-child { border-bottom: none; }
.odp-help-link:hover { background: var(--bg-secondary); }

/* Responsive */
@media (max-width: 900px) {
  .odp-body { grid-template-columns: 1fr; }
  .odp-right { flex-direction: row; flex-wrap: wrap; }
  .odp-side-card { flex: 1 1; min-width: 240px; }
}
@media (max-width: 640px) {
  .odp-wrap { padding: 16px 14px 24px; }
  /* align-items:stretch, not the flex-start inherited from the row layout.
   *
   * Turning the bar into a column turns align-items into a HORIZONTAL rule, and
   * flex-start sizes every child to its own content -- so the delivery address
   * and the three-button row both grew past the card and were clipped by it.
   * Measured at a 400px viewport: the card ended at 375 and both ran to 417.
   * Stretch makes them the width of the card, which is what lets the address
   * wrap instead of running off the edge. */
  .odp-summary-bar { flex-direction: column; gap: var(--space-2); align-items: stretch; }
  /* Wrapping matters now that there are three of these (Invoice, Buy Again,
   * and Dispute once an order can have one). In a row that cannot wrap, the
   * third simply left the card. */
  .odp-sum-btns { flex-direction: row; flex-wrap: wrap; margin-left: 0; }
  /* A long address is one unbroken run of words; without this it is the child
   * that decides the column's width. */
  .odp-sum-addr-col, .odp-sum-addr-text { min-width: 0; overflow-wrap: anywhere; }
  /* text-align:center is right in the row layout, where this block is a narrow
   * column of its own. Stretched to the full card width it centred the total
   * while every field around it stayed left-aligned. */
  .odp-sum-amount { text-align: left; }
  .odp-timeline-card { padding: 20px 16px; }
  .odp-tl-label { font-size: 0.72rem; }
  .odp-item-row { flex-wrap: wrap; }
  .odp-item-btns { width: 100%; margin-top: 8px; }
}

.odp-left { display: flex; flex-direction: column; gap: 14px; }

/* ═══════════════════════════════════════════════════════════
   BUY AGAIN TOAST  (.odp-buyagain-toast)
   ══════════════════════════════════════════════════════════ */
.odp-buyagain-toast {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  background: color-mix(in srgb, var(--success) 10%, transparent);
  border: 1px solid color-mix(in srgb, var(--success) 30%, transparent);
  color: var(--success);
  font-size: 0.86rem;
  font-weight: 600;
  padding: 10px 16px;
  border-radius: var(--radius-sm);
  animation: toast-in 250ms ease;
}
[data-theme='dark'] .odp-buyagain-toast { color: var(--success); }
@keyframes toast-in { from { opacity: 0; transform: translateY(-6px); } to { opacity: 1; transform: none; } }

/* ═══════════════════════════════════════════════════════════
   DISPUTE PAGE  (.dp-*)
   ══════════════════════════════════════════════════════════ */
.dp-page { max-width: 1100px; margin: 0 auto; display: flex; flex-direction: column; gap: 20px; }

.dp-empty, .dp-loading {
  font-size: 0.9rem;
  color: var(--text-secondary);
  padding: 20px 0;
  text-align: center;
}

/* Banner */
.dp-banner {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 18px 20px;
  background: rgba(255, 103, 0,0.07);
  border: 1px solid rgba(255, 103, 0,0.2);
  border-radius: var(--radius-md);
}
.dp-banner-icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 50%;
  background: rgba(255, 103, 0,0.12);
  color: var(--color-primary);
  display: flex;
  align-items: center;
  justify-content: center;
}
.dp-banner-title { font-size: 1.02rem; font-weight: 700; color: var(--text-primary); margin: 0 0 4px; }
.dp-banner-sub { font-size: 0.86rem; color: var(--text-secondary); margin: 0; }

/* Stepper */
.dp-stepper { display: flex; justify-content: center; padding: 4px 0 6px; }
.dp-step { display: flex; flex-direction: column; align-items: center; flex: 1 1; max-width: 160px; position: relative; }
.dp-step-track { display: flex; align-items: center; width: 100%; justify-content: center; position: relative; }
.dp-step-dot {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-secondary);
  border: 2px solid var(--border);
  color: var(--text-secondary);
  font-size: 0.86rem;
  font-weight: 700;
  z-index: 1;
  flex-shrink: 0;
  transition: background 200ms, border-color 200ms, color 200ms;
}
.dp-step-dot--done { background: var(--accent); border-color: var(--accent); color: var(--color-text-on-secondary); }
.dp-step-dot--current:not(.dp-step-dot--done) { background: var(--color-primary); border-color: var(--color-primary); color: var(--color-text-on-primary); }
.dp-step-line {
  flex: 1 1;
  height: 3px;
  background: var(--border);
  position: absolute;
  left: calc(50% + 20px);
  right: calc(-50% + 20px);
  top: 50%;
  transform: translateY(-50%);
  z-index: 0;
  transition: background 300ms;
}
.dp-step-line--filled { background: var(--accent); }
.dp-step-label { margin-top: 8px; font-size: 0.8rem; font-weight: 600; color: var(--text-secondary); text-align: center; }
.dp-step-label--active { color: var(--text-primary); }

/* Two-column layout */
.dp-layout { display: grid; grid-template-columns: 340px 1fr; gap: 20px; align-items: start; }
@media (max-width: 900px) {
  .dp-layout { grid-template-columns: 1fr; }
}

/* Left: order picker */
.dp-left { display: flex; flex-direction: column; gap: 12px; }
.dp-left-header h2 { font-size: 1rem; font-weight: 700; color: var(--text-primary); margin: 0; }
.dp-order-list { display: flex; flex-direction: column; gap: 10px; max-height: 560px; overflow-y: auto; }

.dp-order-card {
  background: var(--bg-primary);
  border: 1.5px solid var(--border);
  border-radius: var(--radius-md);
  padding: 14px 16px;
  cursor: pointer;
  transition: border-color 150ms, box-shadow 150ms;
}
.dp-order-card:hover { border-color: var(--accent); }
.dp-order-card--selected { border-color: var(--accent); box-shadow: 0 0 0 2px rgba(59, 130, 246,0.15); }

.dp-order-card-top { display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; }
.dp-order-id { font-size: 0.86rem; font-weight: 700; color: var(--text-primary); }
.dp-order-status-badge {
  font-size: 0.7rem;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: var(--radius-xl);
  background: rgba(255, 103, 0,0.12);
  color: var(--color-primary);
}
.dp-order-card-body { display: flex; gap: 12px; margin-bottom: 12px; }
.dp-order-thumb { width: 56px; height: 56px; border-radius: var(--radius-sm); object-fit: cover; flex-shrink: 0; }
.dp-order-thumb-placeholder { display: flex; align-items: center; justify-content: center; background: var(--bg-tertiary); color: var(--text-tertiary); }
.dp-order-info { min-width: 0; }
.dp-order-name { font-size: 0.86rem; font-weight: 600; color: var(--text-primary); margin: 0 0 2px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.dp-order-variant { font-size: 0.76rem; color: var(--text-secondary); margin: 0 0 2px; }
.dp-order-price { font-size: 0.8rem; color: var(--text-secondary); margin: 0; }

.dp-raise-btn {
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: var(--radius-sm);
  background: var(--accent);
  color: var(--color-text-on-secondary);
  font-size: 0.86rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 150ms;
}
.dp-raise-btn:hover { background: var(--accent-hover); }

.dp-order-dispute-pill {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 9px;
  border-radius: var(--radius-sm);
  background: var(--bg-tertiary);
  font-size: 0.8rem;
  font-weight: 700;
}

.dp-view-all-link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 11px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  background: none;
  color: var(--text-primary);
  font-size: 0.86rem;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 150ms;
}
.dp-view-all-link:hover { border-color: var(--accent); }

.dp-side-card {
  background: var(--bg-primary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 16px 18px;
}
.dp-side-title { display: flex; align-items: center; gap: var(--space-1); font-size: 0.88rem; font-weight: 700; color: var(--text-primary); margin: 0 0 4px; }
.dp-side-sub { font-size: 0.8rem; color: var(--text-secondary); margin: 0; }

/* Right: form / status card */
.dp-form-card, .dp-status-card {
  background: var(--bg-primary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 22px 24px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.dp-form-title { font-size: 1.05rem; font-weight: 700; color: var(--text-primary); margin: 0 0 2px; }
.dp-form-sub { font-size: 0.84rem; color: var(--text-secondary); margin: 0 0 16px; }

.dp-field-label { font-size: 0.82rem; font-weight: 600; color: var(--text-secondary); margin: 12px 0 6px; }
.dp-select, .dp-textarea {
  width: 100%;
  padding: 10px 12px;
  border-radius: var(--radius-sm);
  border: 1.5px solid var(--border);
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 0.88rem;
  font-family: inherit;
  outline: none;
  box-sizing: border-box;
}
.dp-select:focus, .dp-textarea:focus { border-color: var(--accent); }
.dp-textarea { resize: vertical; }
.dp-char-count { font-size: 0.72rem; color: var(--text-tertiary); text-align: right; margin: 4px 0 0; }

.dp-issue-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
@media (max-width: 480px) { .dp-issue-grid { grid-template-columns: 1fr; } }

.dp-issue-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 0.85rem;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: border-color 150ms, background 150ms;
}
.dp-issue-card:hover { border-color: var(--accent); }
.dp-issue-card--selected { border-color: var(--accent); background: rgba(59, 130, 246,0.06); }
.dp-issue-radio {
  margin-left: auto;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid var(--border);
  flex-shrink: 0;
}
.dp-issue-card--selected .dp-issue-radio { border-color: var(--accent); background: var(--accent); box-shadow: inset 0 0 0 3px var(--bg-secondary); }

.dp-dropzone {
  margin-top: 4px;
  border: 2px dashed var(--border);
  border-radius: var(--radius-md);
  padding: 26px 20px;
  text-align: center;
  cursor: pointer;
  transition: border-color 150ms, background 150ms;
  color: var(--text-secondary);
}
.dp-dropzone:hover, .dp-dropzone-over { border-color: var(--accent); background: rgba(59, 130, 246,0.04); }
.dp-dropzone-text { font-size: 0.86rem; color: var(--text-primary); margin: 8px 0 2px; font-weight: 600; }
.dp-dropzone-hint { font-size: 0.75rem; color: var(--text-tertiary); margin: 0; }

.dp-photo-grid { display: flex; gap: 10px; flex-wrap: wrap; margin-top: 12px; }
.dp-photo-slot {
  position: relative;
  width: 76px;
  height: 76px;
  border-radius: var(--radius-sm);
  border: 1.5px solid var(--border);
  overflow: hidden;
  flex-shrink: 0;
}
.dp-photo-thumb { width: 100%; height: 100%; object-fit: cover; display: block; }
.dp-photo-spinner, .dp-photo-error {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(1, 13, 33,0.45);
  color: var(--color-brand-white);
}
.dp-photo-error { background: color-mix(in srgb, var(--danger) 60%, transparent); font-weight: 800; }
.dp-photo-remove {
  position: absolute;
  top: 3px;
  right: 3px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: none;
  background: rgba(1, 13, 33,0.6);
  color: var(--color-brand-white);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.dp-submit-msg { font-size: 0.82rem; color: var(--danger); margin: 10px 0 0; }
.dp-submit-btn {
  width: 100%;
  margin-top: 18px;
  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);
  color: white;
  border: none;
  padding: 13px 20px;
  font-weight: 700;
  font-size: 0.95rem;
  cursor: pointer;
  border-radius: var(--radius-sm);
  transition: opacity 150ms;
}
.dp-submit-btn:disabled { opacity: 0.55; cursor: not-allowed; }

/* Read-only status card */
.dp-status-row { display: flex; justify-content: space-between; align-items: center; padding: 9px 0; border-bottom: 1px solid var(--border); font-size: 0.86rem; }
.dp-status-row:last-of-type { border-bottom: none; }
.dp-status-label { font-size: 0.78rem; color: var(--text-secondary); font-weight: 600; }
.dp-status-block { margin-top: 14px; }
.dp-status-desc { font-size: 0.86rem; color: var(--text-primary); line-height: 1.5; margin: 4px 0 0; }

.dp-status-explainer { font-size: 0.82rem; color: var(--text-secondary); line-height: 1.5; margin: 8px 0 0; }

.dp-decision-card {
  margin-top: 16px;
  padding: 16px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  background: var(--bg-secondary);
}
.dp-decision-title { display: flex; align-items: center; gap: 6px; font-size: 0.88rem; font-weight: 700; color: var(--text-primary); margin: 0 0 6px; }
.dp-decision-card .dp-status-row { border-bottom-color: var(--border); }
.dp-decision-card .dp-status-block:first-of-type { margin-top: 10px; }

/* How Disputes Work footer */
.dp-howitworks {
  background: var(--bg-primary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 22px 24px;
}
.dp-howitworks-title { font-size: 0.98rem; font-weight: 700; color: var(--text-primary); margin: 0 0 18px; }
.dp-howitworks-row { display: flex; align-items: flex-start; gap: 12px; }
.dp-howitworks-item { flex: 1 1; min-width: 0; }
.dp-howitworks-icon {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(59, 130, 246,0.1);
  color: var(--accent);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}
.dp-howitworks-item-title { font-size: 0.85rem; font-weight: 700; color: var(--text-primary); margin: 0 0 4px; }
.dp-howitworks-item-desc { font-size: 0.78rem; color: var(--text-secondary); margin: 0; line-height: 1.4; }
.dp-howitworks-line { flex: 0 0 24px; height: 2px; margin-top: 19px; border-top: 2px dashed var(--border); }
@media (max-width: 700px) {
  .dp-howitworks-row { flex-direction: column; }
  .dp-howitworks-line { display: none; }
}

/* Conversation (buyer-visible message thread on an existing dispute) */
.dp-conv-section { margin-top: 18px; padding-top: 18px; border-top: 1px solid var(--border); }
.dp-conv-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 320px;
  overflow-y: auto;
  margin: 10px 0 12px;
}
.dp-conv-empty { font-size: 0.82rem; color: var(--text-tertiary); margin: 4px 0; }
.dp-conv-msg {
  max-width: 82%;
  padding: 10px 13px;
  border-radius: var(--radius-md);
  background: var(--bg-tertiary);
}
.dp-conv-msg--buyer { align-self: flex-end; background: rgba(59, 130, 246,0.1); }
.dp-conv-msg--admin { align-self: flex-start; }
.dp-conv-msg-head { display: flex; justify-content: space-between; gap: 10px; margin-bottom: 3px; }
.dp-conv-msg-author { font-size: 0.75rem; font-weight: 700; color: var(--text-primary); }
.dp-conv-msg-time { font-size: 0.7rem; color: var(--text-tertiary); }
.dp-conv-msg-text { font-size: 0.85rem; color: var(--text-primary); margin: 0; line-height: 1.45; white-space: pre-wrap; }
.dp-conv-composer { display: flex; gap: 8px; align-items: flex-end; }
.dp-conv-input {
  flex: 1 1;
  padding: 9px 12px;
  border-radius: var(--radius-sm);
  border: 1.5px solid var(--border);
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 0.86rem;
  font-family: inherit;
  resize: vertical;
  outline: none;
}
.dp-conv-input:focus { border-color: var(--accent); }
.dp-conv-send-btn {
  padding: 9px 18px;
  border: none;
  border-radius: var(--radius-sm);
  background: var(--accent);
  color: var(--color-text-on-secondary);
  font-weight: 700;
  font-size: 0.86rem;
  cursor: pointer;
  flex-shrink: 0;
}
.dp-conv-send-btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* ═══════════════════════════════════════════════════════════
   ADMIN DISPUTES TAB  (.dsp-*)
   ══════════════════════════════════════════════════════════ */
.dsp-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; flex-wrap: wrap; margin-bottom: 18px; }
.dsp-header h2 { margin: 0 0 4px; font-size: 1.2rem; font-weight: 700; color: var(--text-primary); }
.dsp-header p { margin: 0; font-size: 0.85rem; color: var(--text-secondary); }

.dsp-toolbar-btn {
  display: flex; align-items: center; gap: 6px;
  padding: 9px 14px; border: 1px solid var(--border); border-radius: var(--radius-sm);
  background: var(--bg-secondary); color: var(--text-primary);
  font-size: 0.82rem; font-weight: 600; cursor: pointer; white-space: nowrap;
  transition: border-color 150ms;
}
.dsp-toolbar-btn:hover { border-color: var(--accent); }
.dsp-toolbar-btn:disabled { opacity: 0.6; cursor: default; }

.dsp-popover-wrap { position: relative; }
.dsp-popover {
  position: absolute; top: calc(100% + 6px); right: 0; z-index: 40;
  min-width: 220px; background: var(--bg-primary); border: 1px solid var(--border);
  border-radius: var(--radius-md); box-shadow: 0 12px 32px rgba(1, 13, 33,0.18); padding: 12px 14px;
}
.dsp-popover-title { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--text-muted); margin: 0 0 8px; }
.dsp-popover-check { display: flex; align-items: center; gap: 8px; font-size: 0.84rem; color: var(--text-primary); padding: 5px 0; cursor: pointer; }
.dsp-popover-dates { display: flex; flex-direction: column; gap: 10px; min-width: 200px; }
.dsp-popover-date-label { display: flex; flex-direction: column; gap: 4px; font-size: 0.76rem; color: var(--text-secondary); font-weight: 600; }
.dsp-popover-date-label input { padding: 7px 9px; border-radius: 8px; border: 1px solid var(--border); background: var(--bg-secondary); color: var(--text-primary); font-size: 0.82rem; }
.dsp-popover-clear { align-self: flex-start; border: none; background: none; color: var(--accent); font-size: 0.78rem; font-weight: 600; cursor: pointer; padding: 0; }

/* Stat-filter cards -- reuse the .oh-stat-card visual language but every
   card IS the filter control (like the customer-facing order stat cards),
   not a separate non-interactive KPI display. */
.dsp-stat-row { display: grid; grid-template-columns: repeat(6, 1fr); gap: 12px; margin-bottom: 20px; }
@media (max-width: 1100px) { .dsp-stat-row { grid-template-columns: repeat(3, 1fr); } }
@media (max-width: 640px)  { .dsp-stat-row { grid-template-columns: repeat(2, 1fr); } }
.dsp-stat-card {
  display: flex; flex-direction: column; align-items: flex-start; gap: 6px;
  background: var(--bg-secondary); border: 1.5px solid var(--border);
  border-radius: var(--radius-sm); padding: 14px 16px;
  cursor: pointer; transition: all 150ms; text-align: left;
}
.dsp-stat-card:hover { border-color: var(--accent); transform: translateY(-1px); }
.dsp-stat-card.active { border-color: var(--accent); background: rgba(59, 130, 246,0.06); }
[data-theme="dark"] .dsp-stat-card.active { background: rgba(59, 130, 246,0.08); }
.dsp-stat-icon { width: 34px; height: 34px; border-radius: 9px; display: flex; align-items: center; justify-content: center; }
.dsp-stat-count { font-size: 1.3rem; font-weight: 800; color: var(--text-primary); line-height: 1.1; }
.dsp-stat-label { font-size: 0.74rem; color: var(--text-secondary); font-weight: 600; }

/* Two-column layout -- list-only by default, list+sidebar once a dispute is
   selected. No existing conditionally-docked-sidebar precedent elsewhere in
   this app, so this is new layout CSS rather than a reused class. */
.dsp-layout { display: block; }
.dsp-layout--split { display: grid; grid-template-columns: 1fr 400px; gap: 18px; align-items: start; }
@media (max-width: 1000px) { .dsp-layout--split { grid-template-columns: 1fr; } }

.dsp-list { display: flex; flex-direction: column; gap: 12px; }
.dsp-card {
  background: var(--bg-secondary); border: 1.5px solid var(--border); border-radius: 12px;
  padding: 16px 20px; cursor: pointer; transition: border-color 150ms;
}
.dsp-card:hover { border-color: var(--accent); }
.dsp-card--selected { border-color: var(--accent); box-shadow: 0 0 0 2px rgba(59, 130, 246,0.15); }
.dsp-card-badges { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; margin-bottom: 8px; }
.dsp-badge { padding: 2px 10px; border-radius: 20px; font-size: 0.73rem; font-weight: 700; }
.dsp-badge--muted { background: var(--bg-tertiary); color: var(--text-secondary); }
.dsp-card-order-row {
  display: flex; align-items: center; justify-content: space-between; gap: 10px;
  font-size: 0.78rem; color: var(--text-secondary); padding: 8px 0; margin-bottom: 4px;
  border-top: 1px solid var(--border); border-bottom: 1px solid var(--border);
}
.dsp-card-counts { display: flex; align-items: center; gap: 12px; flex-shrink: 0; }
.dsp-card-counts svg { vertical-align: -2px; margin-right: 3px; }
.dsp-card-actions { margin-top: 12px; display: flex; gap: 8px; flex-wrap: wrap; align-items: flex-end; }
.dsp-notes-input {
  flex: 1 1; min-width: 180px; padding: 8px 11px; border-radius: 8px; border: 1px solid var(--border);
  background: var(--bg-primary); color: var(--text-primary); font-size: 0.8rem; font-family: inherit; resize: vertical;
}

/* Sidebar */
.dsp-sidebar {
  background: var(--bg-secondary); border: 1px solid var(--border); border-radius: 12px;
  padding: 18px 20px; position: sticky; top: 12px; max-height: calc(100vh - 100px); overflow-y: auto;
}
.dsp-sidebar-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; margin-bottom: 14px; }
.dsp-sidebar-close { border: none; background: var(--bg-tertiary); color: var(--text-secondary); width: 28px; height: 28px; border-radius: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer; flex-shrink: 0; }
.dsp-sidebar-tabs { display: flex; gap: 4px; border-bottom: 1px solid var(--border); margin-bottom: 16px; }
.dsp-sidebar-tab {
  display: flex; align-items: center; gap: 6px;
  padding: 9px 12px; border: none; background: none; color: var(--text-secondary);
  font-size: 0.82rem; font-weight: 600; cursor: pointer; border-bottom: 2px solid transparent; margin-bottom: -1px;
}
.dsp-sidebar-tab.active { color: var(--accent); border-bottom-color: var(--accent); }
.dsp-tab-count { background: var(--bg-tertiary); color: var(--text-secondary); border-radius: 20px; padding: 0 6px; font-size: 0.7rem; font-weight: 700; }
.dsp-sidebar-tab.active .dsp-tab-count { background: rgba(59, 130, 246,0.15); color: var(--accent); }

.dsp-sidebar-body { display: flex; flex-direction: column; gap: 14px; }
.dsp-info-card { background: var(--bg-primary); border: 1px solid var(--border); border-radius: var(--radius-sm); padding: 14px 16px; }
.dsp-info-title { font-size: 0.82rem; font-weight: 700; color: var(--text-primary); margin: 0 0 10px; }
.dsp-modal-label { display: block; font-size: 0.8rem; font-weight: 700; color: var(--text-primary); margin: 0 0 6px; }
.dsp-detail-row { display: flex; justify-content: space-between; align-items: center; gap: 10px; font-size: 0.82rem; color: var(--text-secondary); padding: 5px 0; margin: 0; }
.dsp-detail-row span:last-child { color: var(--text-primary); font-weight: 500; display: flex; align-items: center; gap: 4px; }
.dsp-order-product-row { display: flex; align-items: center; gap: 10px; margin-bottom: 10px; }
.dsp-order-thumb { width: 42px; height: 42px; border-radius: 8px; object-fit: cover; flex-shrink: 0; }
.dsp-order-thumb-placeholder { display: flex; align-items: center; justify-content: center; background: var(--bg-tertiary); color: var(--text-tertiary); }
.dsp-copy-btn { border: none; background: none; color: var(--text-secondary); cursor: pointer; display: inline-flex; align-items: center; padding: 2px; }
.dsp-copy-btn:hover { color: var(--accent); }

/* Conversation tab (admin side) -- same message-bubble idea as the
   customer-facing .dp-conv-* rules, mirrored role-wise (admin right-aligned
   here since the admin is "us" in this view). */
.dsp-conv-list { display: flex; flex-direction: column; gap: 10px; max-height: 280px; overflow-y: auto; margin-bottom: 12px; }
.dsp-conv-empty { font-size: 0.82rem; color: var(--text-tertiary); }
.dsp-conv-msg { max-width: 85%; padding: 9px 12px; border-radius: var(--radius-md); background: var(--bg-primary); border: 1px solid var(--border); }
.dsp-conv-msg--admin { align-self: flex-end; background: rgba(59, 130, 246,0.1); border-color: rgba(59, 130, 246,0.25); }
.dsp-conv-msg--buyer { align-self: flex-start; }
.dsp-conv-msg--seller { align-self: flex-end; background: rgba(59, 130, 246,0.1); border-color: rgba(59, 130, 246,0.25); }
.dsp-conv-msg-head { display: flex; justify-content: space-between; gap: 10px; margin-bottom: 3px; }
.dsp-conv-msg-author { font-size: 0.73rem; font-weight: 700; color: var(--text-primary); }
.dsp-conv-msg-time { font-size: 0.68rem; color: var(--text-tertiary); }
.dsp-conv-msg-text { font-size: 0.83rem; color: var(--text-primary); margin: 0; line-height: 1.4; white-space: pre-wrap; }
.dsp-conv-composer { display: flex; gap: 8px; align-items: flex-end; }
.dsp-conv-input { flex: 1 1; padding: 8px 11px; border-radius: 8px; border: 1px solid var(--border); background: var(--bg-primary); color: var(--text-primary); font-size: 0.83rem; font-family: inherit; resize: vertical; }
.dsp-conv-send-btn { padding: 8px 16px; border: none; border-radius: 8px; background: var(--color-secondary); color: var(--color-text-on-secondary); font-weight: 700; font-size: 0.82rem; cursor: pointer; flex-shrink: 0; }
.dsp-conv-send-btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* Evidence tab */
.dsp-evidence-grid { display: flex; gap: 10px; flex-wrap: wrap; }
.dsp-evidence-thumb { width: 84px; height: 84px; border-radius: 10px; object-fit: cover; border: 1px solid var(--border); }

/* Timeline tab -- honest 1-2 real data points, not a fabricated audit log */
.dsp-timeline { display: flex; flex-direction: column; gap: 4px; }
.dsp-timeline-point { display: flex; align-items: flex-start; gap: 12px; padding: 8px 0; position: relative; }
.dsp-timeline-point:not(:last-child)::before {
  content: ''; position: absolute; left: 5px; top: 22px; bottom: -4px; width: 2px; background: var(--border);
}
.dsp-timeline-dot { width: 12px; height: 12px; border-radius: 50%; background: var(--border); flex-shrink: 0; margin-top: 4px; }
.dsp-timeline-dot--current { background: var(--accent); }

/* ═══════════════════════════════════════════════════════════
   RETURNS TAB (admin)  (.ret-*)
   Layout/sidebar/timeline mechanics cloned from the .dsp-* rules above for
   visual consistency; the card body and refund/exchange panels below are
   new since a return carries different data than a dispute.
   ══════════════════════════════════════════════════════════ */
.ret-layout { display: block; }
.ret-layout--split { display: grid; grid-template-columns: 1fr 400px; gap: 18px; align-items: start; }
@media (max-width: 1000px) { .ret-layout--split { grid-template-columns: 1fr; } }

.ret-list { display: flex; flex-direction: column; gap: 12px; }
.ret-card {
  background: var(--bg-secondary); border: 1.5px solid var(--border); border-radius: 12px;
  padding: 16px 20px; cursor: pointer; transition: border-color 150ms;
}
.ret-card:hover { border-color: var(--accent); }
.ret-card--selected { border-color: var(--accent); box-shadow: 0 0 0 2px rgba(59, 130, 246,0.15); }
.ret-card-badges { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; margin-bottom: 12px; }
.ret-card-icon { width: 26px; height: 26px; border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.ret-badge { padding: 2px 10px; border-radius: 20px; font-size: 0.73rem; font-weight: 700; }
.ret-badge--muted { background: var(--bg-tertiary); color: var(--text-secondary); }

.ret-card-grid {
  display: grid; grid-template-columns: repeat(5, 1fr); gap: 14px;
  padding-bottom: 12px; margin-bottom: 4px; border-bottom: 1px solid var(--border);
}
@media (max-width: 900px) { .ret-card-grid { grid-template-columns: repeat(2, 1fr); } }
.ret-card-label { font-size: 0.7rem; font-weight: 700; color: var(--text-tertiary); text-transform: uppercase; letter-spacing: 0.04em; margin: 0 0 3px; }
.ret-card-value { font-size: 0.84rem; color: var(--text-primary); font-weight: 600; margin: 0; }
.ret-card-sub { font-size: 0.76rem; color: var(--text-muted); margin: 2px 0 0; }
.ret-resolution-value { display: flex; align-items: center; gap: 5px; }

.ret-warning-banner {
  display: flex; align-items: center; gap: 8px;
  background: rgba(255, 103, 0,0.1); border: 1px solid rgba(255, 103, 0,0.3); color: var(--color-primary);
  border-radius: 8px; padding: 9px 14px; font-size: 0.82rem; font-weight: 600; margin: 12px 0;
}
[data-theme="dark"] .ret-warning-banner { color: var(--color-primary); }

.ret-refund-panel {
  background: var(--bg-primary); border: 1px solid var(--border); border-radius: 8px;
  padding: 12px 14px; margin: 12px 0;
}
.ret-refund-panel-title { font-size: 0.76rem; font-weight: 700; color: var(--text-secondary); text-transform: uppercase; letter-spacing: 0.04em; margin: 0 0 10px; }
.ret-refund-panel-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; }
@media (max-width: 900px) { .ret-refund-panel-grid { grid-template-columns: repeat(2, 1fr); } }
/* The sidebar is a fixed 400px column regardless of viewport width, too
   narrow for 4 columns even when the page itself is wide. */
.ret-sidebar .ret-refund-panel-grid { grid-template-columns: repeat(2, 1fr); }

.ret-exchange-panel {
  display: flex; align-items: center; gap: 10px;
  background: rgba(59, 130, 246,0.08); border: 1px solid rgba(59, 130, 246,0.25); color: var(--color-secondary);
  border-radius: 8px; padding: 10px 14px; margin: 12px 0;
}
[data-theme="dark"] .ret-exchange-panel { background: rgba(59, 130, 246,0.12); }
.ret-tracking-input {
  width: 120px; padding: 6px 9px; border-radius: 6px; border: 1px solid var(--border);
  background: var(--bg-secondary); color: var(--text-primary); font-size: 0.78rem;
}

.ret-card-actions { margin-top: 12px; display: flex; gap: 8px; flex-wrap: wrap; }
.ret-action-btn {
  padding: 7px 14px; border-radius: 8px; font-size: 0.8rem; font-weight: 700; cursor: pointer;
  background: var(--bg-tertiary); color: var(--text-primary); border: 1px solid var(--border);
}
.ret-action-btn:hover:not(:disabled) { border-color: var(--accent); }
.ret-action-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.ret-action-btn--primary { background: var(--color-secondary); color: var(--color-text-on-secondary); border-color: var(--color-secondary); }
.ret-action-btn--warn { background: var(--color-primary); color: var(--color-text-on-primary); border-color: var(--color-primary); }
.ret-action-btn--danger { background: rgba(255, 103, 0,0.1); color: var(--color-primary); border-color: rgba(255, 103, 0,0.3); }
[data-theme="dark"] .ret-action-btn--danger { background: rgba(255, 103, 0,0.15); }

.ret-sidebar {
  background: var(--bg-secondary); border: 1px solid var(--border); border-radius: 12px;
  padding: 18px 20px; position: sticky; top: 12px; max-height: calc(100vh - 100px); overflow-y: auto;
}
.ret-sidebar-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; margin-bottom: 16px; }

/* ═══════════════════════════════════════════════════════════
   INVOICE MODAL  (.inv-*)
   ══════════════════════════════════════════════════════════ */
.inv-overlay {
  position: fixed;
  inset: 0;
  background: rgba(1, 13, 33,0.65);
  z-index: 1100;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40px 16px;
  overflow-y: auto;
  backdrop-filter: blur(3px);
}
/* Fixed A4 page (210mm x 297mm). Background/text colors inside .inv-doc are
   deliberately hardcoded rather than theme variables further down — an
   invoice is a document meant to be printed/shared, so it must always render
   as plain white paper with dark ink, never inverted by the app's dark mode. */
.inv-modal {
  background: var(--color-brand-white);
  border-radius: 10px;
  width: 210mm;
  max-width: 96vw;
  min-height: 297mm;
  box-shadow: 0 24px 60px rgba(1, 13, 33,0.35);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.inv-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-bottom: 1px solid var(--border);
  background: var(--bg-secondary);
  flex-shrink: 0;
}
.inv-print-btn {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 8px 16px;
  background: var(--accent);
  color: var(--color-text-on-secondary);
  border: none;
  border-radius: var(--radius-sm);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 150ms;
}
.inv-print-btn:hover { background: var(--accent-hover); }
.inv-close-btn {
  width: 34px; height: 34px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  background: var(--bg-primary);
  color: var(--text-secondary);
  cursor: pointer;
  font-size: 1rem;
  display: flex; align-items: center; justify-content: center;
}
.inv-close-btn:hover { background: var(--bg-secondary); }


/* ═══════════════════════════════════════════════════════════
   TRACK SHIPMENT MODAL  (.ts-*)
   ══════════════════════════════════════════════════════════ */
.ts-overlay {
  position: fixed;
  inset: 0;
  background: rgba(1, 13, 33,0.55);
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  backdrop-filter: blur(3px);
}
.ts-modal {
  background: var(--bg-primary);
  border-radius: var(--radius-xl);
  width: 100%;
  max-width: 520px;
  box-shadow: 0 24px 60px rgba(1, 13, 33,0.25);
  max-height: 90vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.ts-hdr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 16px;
  border-bottom: 1px solid var(--border);
  position: sticky;
  top: 0;
  background: var(--bg-primary);
  z-index: 1;
}
.ts-hdr-left { display: flex; align-items: center; gap: 12px; }
.ts-hdr-title { font-size: 1.05rem; font-weight: 800; color: var(--text-primary); margin: 0; }
.ts-hdr-sub { font-size: 0.78rem; color: var(--text-secondary); margin: 2px 0 0; }
.ts-close {
  width: 34px; height: 34px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  background: var(--bg-secondary);
  color: var(--text-secondary);
  cursor: pointer;
  font-size: 1rem;
  display: flex; align-items: center; justify-content: center;
}
.ts-close:hover { background: var(--border); }

/* Cancelled state */
.ts-cancelled-msg {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: 28px 24px;
  color: var(--danger);
}
.ts-cancelled-icon {
  width: 40px; height: 40px;
  background: color-mix(in srgb, var(--danger) 12%, transparent);
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 1.1rem;
  font-weight: 700;
  flex-shrink: 0;
}
.ts-cancelled-title { font-size: 0.95rem; font-weight: 700; margin: 0 0 4px; }
.ts-refunded-msg { color: var(--accent-secondary); }
.ts-refunded-msg .ts-cancelled-icon { background: color-mix(in srgb, var(--accent-secondary) 12%, transparent); }
.ts-exchanged-msg { color: var(--accent-secondary); }
.ts-exchanged-msg .ts-cancelled-icon { background: color-mix(in srgb, var(--accent-secondary) 12%, transparent); }
.ts-cancelled-sub { font-size: 0.84rem; color: var(--text-secondary); margin: 0; }

/* Tracking number card */
.ts-num-card {
  margin: 16px 20px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 16px 20px;
  box-shadow: var(--shadow-card);
}
.ts-num-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}
.ts-num-label { font-size: 0.75rem; color: var(--text-secondary); margin: 0 0 4px; font-weight: 600; }
.ts-num-val { font-family: 'Courier New', monospace; font-size: 0.95rem; font-weight: 700; color: var(--text-primary); margin: 0; letter-spacing: 0.05em; }
.ts-copy-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 12px;
  border: 1px solid var(--border);
  border-radius: var(--radius-xs);
  background: var(--bg-primary);
  color: var(--text-secondary);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: border-color 150ms, color 150ms;
}
.ts-copy-btn:hover { border-color: var(--accent); color: var(--accent); }
.ts-meta-row {
  display: flex;
  gap: var(--space-2);
  flex-wrap: wrap;
}
.ts-meta-cell { flex: 1 1; min-width: 100px; }
.ts-meta-label { font-size: 0.72rem; color: var(--text-secondary); margin: 0 0 4px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; }
.ts-meta-val { font-size: 0.84rem; color: var(--text-primary); font-weight: 600; margin: 0; }
.ts-status-pill {
  display: inline-block;
  padding: 3px 10px;
  border-radius: var(--radius-xl);
  font-size: 0.75rem;
  font-weight: 700;
}
.ts-delivered-text { color: var(--success); font-weight: 700; }
[data-theme='dark'] .ts-delivered-text { color: var(--success); }

/* Tracking timeline */
.ts-timeline {
  padding: 4px 20px 24px;
}
.ts-tl-heading {
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-secondary);
  margin: 0 0 16px;
}
.ts-tl-item {
  display: flex;
  gap: var(--space-2);
  opacity: 0.4;
}
.ts-tl-item.ts-tl-done { opacity: 1; }
.ts-tl-item.ts-tl-current { opacity: 1; }
.ts-tl-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  width: 28px;
}
.ts-tl-dot {
  width: 28px; height: 28px;
  border-radius: 50%;
  border: 2px solid var(--border);
  background: var(--bg-secondary);
  display: flex; align-items: center; justify-content: center;
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--text-secondary);
  flex-shrink: 0;
  transition: background 200ms;
}
.ts-tl-dot.ts-tl-dot-done {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--color-text-on-secondary);
}
.ts-tl-dot.ts-tl-dot-pulse {
  border-color: var(--accent);
  color: var(--accent);
  background: rgba(59, 130, 246,0.08);
  box-shadow: 0 0 0 4px rgba(59, 130, 246,0.12);
}
.ts-tl-vert {
  width: 2px;
  flex: 1 1;
  min-height: 32px;
  background: var(--border);
  margin: 4px 0;
  transition: background 300ms;
}
.ts-tl-vert.ts-tl-vert-filled { background: var(--accent); }
.ts-tl-right {
  padding-bottom: 24px;
  flex: 1 1;
  padding-top: 4px;
}
.ts-tl-label {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--text-secondary);
  margin: 0 0 3px;
}
.ts-tl-label.ts-tl-label-done { color: var(--text-primary); }
.ts-tl-location { font-size: 0.8rem; color: var(--text-secondary); margin: 0 0 2px; }
.ts-tl-time { font-size: 0.76rem; color: var(--text-secondary); margin: 0; }

@media (max-width: 540px) {
  .ts-modal { max-width: 100%; border-radius: var(--radius-md) var(--radius-md) 0 0; }
}

/* ═══════════════════════════════════════════════════════════
   INVOICE — the printable document itself (.inv-doc and below).
   Fixed light palette throughout (see note on .inv-modal above).
   ══════════════════════════════════════════════════════════ */
.inv-doc {
  padding: 40px 44px 36px;
  color: var(--text-primary);
  flex: 1 1;
}
.inv-header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 28px; }
.inv-brand-col { display: flex; gap: 14px; align-items: flex-start; }
.inv-logo-box {
  width: 52px; height: 52px;
  background: var(--color-brand-white);
  border: 1.5px solid var(--border);
  border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 1px 4px rgba(1, 13, 33,.06);
}
.inv-brand-name  { font-size: 1.25rem; font-weight: 800; color: var(--text-primary); margin: 0 0 2px; display: block; }
.inv-brand-tagline { font-size: .78rem; color: var(--text-secondary); margin: 0 0 10px; display: block; }
.inv-hdr-contacts { display: flex; flex-direction: column; gap: 4px; }
.inv-hdr-contact  { font-size: .78rem; color: var(--text-secondary); display: flex; align-items: center; gap: 5px; }

.inv-meta-col { text-align: right; }
.inv-title { font-size: 2rem; font-weight: 900; letter-spacing: .12em; color: var(--text-primary); margin: 0 0 14px; }
.inv-meta-tbl { display: flex; flex-direction: column; gap: 5px; margin-bottom: 12px; }
.inv-meta-row { display: flex; justify-content: flex-end; gap: 20px; font-size: .85rem; }
.inv-meta-label { color: var(--text-secondary); }
.inv-meta-val   { color: var(--text-primary); font-weight: 700; min-width: 90px; text-align: right; }
.inv-paid-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: color-mix(in srgb, var(--success) 12%, transparent);
  color: var(--success);
  border: 1.5px solid color-mix(in srgb, var(--success) 35%, transparent);
  border-radius: 8px;
  font-size: .8rem;
  font-weight: 800;
  padding: 5px 14px;
}
.inv-pending-badge {
  background: rgba(255, 103, 0,.12);
  color: var(--color-primary);
  border-color: rgba(255, 103, 0,.4);
}

.inv-divider { height: 1px; background: var(--border); margin: 0 0 24px; }

/* Address cards */
.inv-addr-row { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 28px; }
.inv-addr-label {
  font-size: .68rem;
  font-weight: 800;
  letter-spacing: .1em;
  text-transform: uppercase;
  color: var(--color-secondary-hover);
  margin: 0 0 10px;
  display: block;
}
.inv-addr-card {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 14px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-radius: 10px;
  margin-bottom: 10px;
}
.inv-addr-icon-box {
  width: 44px; height: 44px;
  border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.inv-addr-icon-store    { background: rgba(59, 130, 246,.1); }
.inv-addr-icon-customer { background: color-mix(in srgb, var(--success) 10%, transparent); }
.inv-addr-name { font-size: .92rem; font-weight: 700; color: var(--text-primary); margin: 0 0 4px; display: block; }
.inv-addr-line { font-size: .82rem; color: var(--text-secondary); margin: 0 0 2px; display: block; }
.inv-addr-contact-row  { display: flex; align-items: center; gap: 6px; font-size: .8rem; color: var(--text-secondary); padding: 0 4px; }

/* Items table */
.inv-table { width: 100%; border-collapse: collapse; margin-bottom: 28px; border: 1px solid var(--border); border-radius: 10px; overflow: hidden; }
.inv-thead-row { background: var(--bg-tertiary); }
.inv-th {
  padding: 11px 14px;
  font-size: .72rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: .07em;
  color: var(--color-secondary-hover);
  border-bottom: 1.5px solid var(--border);
  text-align: left;
}
.inv-th.inv-th-c { text-align: center; }
.inv-th.inv-th-r { text-align: right; }
.inv-td { padding: 14px; font-size: .86rem; color: var(--text-primary); border-bottom: 1px solid var(--bg-tertiary); vertical-align: middle; }
.inv-td.inv-td-c { text-align: center; }
.inv-td.inv-td-r { text-align: right; font-weight: 700; }
.inv-item-cell { display: flex; align-items: center; gap: 12px; }
.inv-item-img-box {
  width: 44px; height: 44px;
  border-radius: 8px;
  background: var(--bg-tertiary);
  display: flex; align-items: center; justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
}
.inv-item-thumb { width: 44px; height: 44px; object-fit: contain; }
.inv-item-name { font-size: .88rem; font-weight: 600; color: var(--text-primary); margin: 0 0 3px; display: block; }
.inv-item-sku  { font-size: .74rem; color: var(--text-muted); margin: 0; display: block; }

/* Bottom row */
.inv-bottom-row { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 28px; align-items: start; }
.inv-thanks-col { display: flex; flex-direction: column; gap: 16px; }
.inv-thanks-hdr {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 14px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-radius: 10px;
}
.inv-thanks-icon  { font-size: 1.6rem; flex-shrink: 0; }
.inv-thanks-title { font-size: .9rem; font-weight: 700; color: var(--color-secondary-hover); margin: 0 0 4px; display: block; }
.inv-thanks-sub   { font-size: .8rem; color: var(--text-secondary); margin: 0; display: block; }
.inv-bottom-contacts { display: flex; flex-direction: column; gap: 6px; padding: 0 4px; }
.inv-contact-row { display: flex; align-items: center; gap: 6px; font-size: .8rem; color: var(--text-secondary); }

.inv-totals-col { border: 1px solid var(--border); border-radius: 10px; overflow: hidden; }
.inv-total-row { display: flex; justify-content: space-between; padding: 10px 16px; font-size: .84rem; color: var(--text-secondary); border-bottom: 1px solid var(--bg-tertiary); }
.inv-discount-row { color: var(--color-primary); }
.inv-free-text { color: var(--success); font-weight: 600; }
.inv-totals-divider { height: 1.5px; background: var(--border); }
.inv-grand-row { display: flex; justify-content: space-between; align-items: center; padding: 14px 16px; font-size: .95rem; font-weight: 800; color: var(--text-primary); }
.inv-grand-amount { font-size: 1.4rem; font-weight: 900; color: var(--color-secondary-hover); }
.inv-paid-success {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 10px 16px;
  background: color-mix(in srgb, var(--success) 8%, transparent);
  border-top: 1px solid color-mix(in srgb, var(--success) 20%, transparent);
  font-size: .82rem;
  color: var(--success);
  font-weight: 600;
}
.inv-payment-pending-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 7px;
  padding: 10px 16px;
  background: rgba(255, 103, 0,.08);
  border-top: 1px solid rgba(255, 103, 0,.2);
  font-size: .82rem;
  color: var(--color-primary);
  font-weight: 600;
}

/* Footer */
.inv-footer { border-top: 1px solid var(--border); padding-top: 18px; padding-bottom: 8px; text-align: center; }
.inv-footer-inner {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 12px 20px;
  font-size: .8rem;
  color: var(--text-secondary);
}
.inv-footer-shield { font-size: 1.2rem; }

@media (max-width: 640px) {
  .inv-modal { width: 100%; min-height: 0; }
  .inv-doc { padding: 24px 20px; }
  .inv-bottom-row { grid-template-columns: 1fr; }
  .inv-addr-row   { grid-template-columns: 1fr; }
}

@media print {
  .inv-overlay { position: static; background: none; padding: 0; overflow: visible; }
  .inv-modal { box-shadow: none; border-radius: 0; width: 100%; min-height: 0; }
  .inv-actions { display: none; }
}

/* ═══════════════════════════════════════════════════════════
   LOGO  — gradient "Store" text + nav icon alignment
   ══════════════════════════════════════════════════════════ */
.logo-store-text {
  color: var(--color-primary);
}

/* Navbar logo: align SVG icon with text */
.nb-logo {
  display: flex;
  align-items: center;
  gap: var(--space-1);
}
.nb-logo svg { display: block; flex-shrink: 0; }

/* Sub-page header logo */
.sph-left { display: flex; align-items: center; gap: var(--space-1); }
.sph-left svg { display: block; flex-shrink: 0; }

/* ── Wishlist Page ───────────────────────────────────────── */
.wl-page { max-width: 1200px; margin: 0 auto; padding: 0 0 48px; }
.wl-loading { padding: 60px; text-align: center; color: var(--text-secondary); font-size: 0.9rem; }

/* Header */
.wl-header {
  display: flex; align-items: center; justify-content: space-between;
  flex-wrap: wrap; gap: var(--space-2); margin-bottom: 28px;
}
.wl-header-left { display: flex; align-items: center; gap: 18px; }
.wl-icon-wrap {
  width: 60px; height: 60px; border-radius: 50%;
  background: rgba(59, 130, 246,0.18);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.wl-title   { font-size: 1.75rem; font-weight: 800; color: var(--text-primary); margin: 0 0 3px; }
.wl-subtitle { font-size: 0.85rem; color: var(--text-secondary); margin: 0; }

.wl-header-actions { display: flex; gap: 10px; flex-wrap: wrap; }
.wl-share-btn {
  display: flex; align-items: center; gap: 7px;
  background: transparent; border: 1px solid var(--border);
  border-radius: var(--radius-sm); color: var(--text-primary);
  font-size: 0.84rem; font-weight: 600; padding: 10px 18px;
  cursor: pointer; transition: border-color 150ms, background 150ms;
}
.wl-share-btn:hover { border-color: var(--accent); background: rgba(59, 130, 246,0.06); }
.wl-add-all-btn {
  display: flex; align-items: center; gap: 7px;
  background: var(--accent); border: none; border-radius: var(--radius-sm);
  color: var(--color-text-on-secondary); font-size: 0.84rem; font-weight: 700; padding: 10px 20px;
  cursor: pointer; transition: background 150ms;
}
.wl-add-all-btn:hover:not(:disabled) { background: var(--accent-hover); }
.wl-add-all-btn:disabled { opacity: 0.45; cursor: not-allowed; }

/* Controls bar */
.wl-controls {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 18px; gap: 12px; flex-wrap: wrap;
}
.wl-count { font-size: 0.9rem; font-weight: 600; color: var(--text-secondary); }
.wl-controls-right { display: flex; align-items: center; gap: 10px; }

.wl-view-toggle {
  display: flex; border: 1px solid var(--border); border-radius: var(--radius-sm); overflow: hidden;
}
.wl-view-btn {
  background: transparent; border: none; padding: 8px 12px;
  color: var(--text-tertiary); cursor: pointer; transition: background 150ms, color 150ms;
  display: flex; align-items: center;
}
.wl-view-btn.active  { background: var(--accent); color: var(--color-text-on-secondary); }
.wl-view-btn:not(.active):hover { background: var(--bg-primary); color: var(--text-primary); }

.wl-sort-select {
  background: var(--bg-secondary); border: 1px solid var(--border);
  border-radius: var(--radius-sm); color: var(--text-primary);
  font-size: 0.83rem; padding: 8px 14px; cursor: pointer; outline: none;
}

/* List / Grid containers */
.wl-list { display: flex; flex-direction: column; gap: var(--space-2); }
.wl-grid  {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 18px;
}

/* Item card */
.wl-item {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-card);
  transition: box-shadow 200ms, border-color 200ms;
}
.wl-list .wl-item {
  display: grid;
  grid-template-columns: 280px 1fr 220px;
  align-items: stretch;
}
.wl-grid .wl-item { display: flex; flex-direction: column; }
.wl-item:hover { box-shadow: 0 6px 28px rgba(1, 13, 33,0.12); border-color: rgba(59, 130, 246,0.25); }
.wl-item-oos { opacity: 0.68; }

/* Image */
.wl-item-img-wrap {
  position: relative; overflow: hidden;
  background: var(--bg-tertiary); flex-shrink: 0;
}
.wl-list .wl-item-img-wrap { height: 100%; min-height: 190px; }
.wl-grid .wl-item-img-wrap { height: 200px; }
.wl-item-img-wrap img {
  width: 100%; height: 100%; object-fit: cover;
  transition: transform 300ms ease;
}
.wl-item:hover .wl-item-img-wrap img { transform: scale(1.05); }

.wl-item-heart {
  position: absolute; top: 12px; right: 12px;
  width: 34px; height: 34px; border-radius: 50%;
  background: var(--bg-secondary); border: 1px solid var(--border); cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  box-shadow: var(--shadow-sm);
  transition: transform 150ms;
  z-index: 2;
}
.wl-item-heart:hover { transform: scale(1.14); }


/* Body */
.wl-item-body {
  padding: 18px 20px 14px;
  display: flex; flex-direction: column; gap: 7px; flex: 1 1;
}
.wl-item-cat {
  font-size: 0.7rem; font-weight: 700; letter-spacing: 0.05em;
  padding: 4px 11px; border-radius: var(--radius-xl); align-self: flex-start;
  text-transform: uppercase;
}
.wl-item-name {
  font-size: 1.18rem; font-weight: 800; color: var(--text-primary);
  margin: 0; line-height: 1.3;
}
.wl-item-rating { display: flex; align-items: center; gap: 1px; }
.wl-star        { font-size: 1rem; line-height: 1; }
.wl-rating-cnt  { font-size: 0.78rem; color: var(--text-tertiary); margin-left: 5px; }
.wl-item-desc {
  font-size: 0.82rem; color: var(--text-secondary); margin: 0;
  line-height: 1.55; display: -webkit-box;
  -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
}

/* Feature tags */
.wl-feature-tags {
  display: flex; flex-wrap: wrap; gap: 6px; margin-top: 4px;
}
.wl-feat-tag {
  display: inline-flex; align-items: center; gap: 5px;
  background: transparent;
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  font-size: 0.72rem; font-weight: 500; color: var(--text-secondary);
  padding: 4px 10px;
  white-space: nowrap;
}
[data-theme="dark"] .wl-feat-tag { border-color: rgba(255,255,255,0.12); }

/* Actions panel */
.wl-item-actions {
  padding: 18px 18px 16px;
  display: flex; flex-direction: column; gap: 9px;
  border-left: 1px solid var(--border);
  justify-content: center;
}
.wl-grid .wl-item-actions {
  border-left: none; border-top: 1px solid var(--border);
}

.wl-price-row  { display: flex; align-items: baseline; gap: 9px; }
.wl-price      { font-size: 1.4rem; font-weight: 800; color: var(--text-primary); }
.wl-original   { font-size: 0.82rem; color: var(--text-tertiary); text-decoration: line-through; }

.wl-stock {
  display: flex; align-items: center; gap: 7px;
  font-size: 0.8rem; font-weight: 600;
}
.wl-stock-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.wl-in-stock  { color: var(--success); }
.wl-oos       { color: var(--danger); }

.wl-add-cart-btn {
  width: 100%; background: var(--accent); border: none; border-radius: var(--radius-sm);
  color: var(--color-text-on-secondary); font-size: 0.84rem; font-weight: 700; padding: 10px 14px;
  cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 7px;
  transition: background 150ms;
}
.wl-add-cart-btn:hover:not(:disabled) { background: var(--accent-hover); }
.wl-add-cart-btn:disabled { opacity: 0.4; cursor: not-allowed; }

.wl-move-cart-btn {
  width: 100%; background: transparent;
  border: 1px solid var(--border); border-radius: var(--radius-sm);
  color: var(--text-primary); font-size: 0.84rem; font-weight: 600; padding: 9px 14px;
  cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 7px;
  transition: border-color 150ms, background 150ms;
}
.wl-move-cart-btn:hover:not(:disabled) { border-color: var(--accent); background: rgba(59, 130, 246,0.06); }
.wl-move-cart-btn:disabled { opacity: 0.4; cursor: not-allowed; }

.wl-remove-btn {
  background: none; border: none; color: var(--danger);
  font-size: 0.8rem; font-weight: 600; cursor: pointer; padding: 3px 0;
  display: flex; align-items: center; gap: 6px; transition: opacity 150ms;
  align-self: flex-start;
}
.wl-remove-btn:hover { opacity: 0.72; }

/* Bottom feature strip */
.wl-features {
  display: grid; grid-template-columns: repeat(3, 1fr);
  gap: 0; margin-top: 36px;
  background: var(--bg-secondary); border: 1px solid var(--border);
  border-radius: var(--radius-md); overflow: hidden;
  box-shadow: var(--shadow-card);
}
.wl-feature-item {
  display: flex; align-items: center; gap: var(--space-2);
  padding: 22px 24px;
  border-right: 1px solid var(--border);
}
.wl-feature-item:last-child { border-right: none; }
.wl-feature-icon {
  width: 50px; height: 50px; border-radius: 50%; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
}
.wl-feature-title { font-size: 0.9rem; font-weight: 700; color: var(--text-primary); margin: 0 0 3px; }
.wl-feature-desc  { font-size: 0.78rem; color: var(--text-secondary); margin: 0; line-height: 1.45; }

/* Empty state */
.wl-empty { text-align: center; padding: 90px 20px; color: var(--text-secondary); }
.wl-empty-icon {
  width: 84px; height: 84px; border-radius: 50%;
  background: var(--bg-primary); border: 2px solid var(--border);
  display: flex; align-items: center; justify-content: center; margin: 0 auto 20px;
}
.wl-empty h3 { font-size: 1.1rem; color: var(--text-primary); margin: 0 0 8px; }
.wl-empty p  { font-size: 0.85rem; margin: 0; }

/* Responsive */
@media (max-width: 900px) {
  .wl-list .wl-item { grid-template-columns: 200px 1fr; }
  .wl-item-actions  { grid-column: 1 / -1; border-left: none; border-top: 1px solid var(--border); }
}
@media (max-width: 600px) {
  .wl-list .wl-item { grid-template-columns: 1fr; }
  .wl-list .wl-item-img-wrap { height: 200px; }
  .wl-features { grid-template-columns: 1fr; }
  .wl-feature-item { border-right: none; border-bottom: 1px solid var(--border); }
  .wl-feature-item:last-child { border-bottom: none; }
}

/* ── Customer Dashboard ──────────────────────────────────────── */
.dash-page {
  max-width: 1100px;
  margin: 0 auto;
}

.dash-greeting {
  font-size: 1.4rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0 0 var(--space-3);
}

.dash-stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--space-2);
  margin-bottom: var(--space-4);
}

.dash-stat-card {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  background: var(--bg-secondary);
  border: 1.5px solid var(--border);
  border-radius: var(--radius-md);
  padding: var(--space-2);
  box-shadow: var(--shadow-card);
}

.dash-stat-icon {
  font-size: 1.6rem;
  flex-shrink: 0;
}
.dash-stat-card > div { min-width: 0; }

.dash-stat-value {
  font-size: 1.25rem;
  font-weight: 800;
  color: var(--text-primary);
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dash-stat-label {
  font-size: 0.75rem;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dash-stat-sub {
  font-size: 0.7rem;
  font-weight: 700;
  color: var(--accent);
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 480px) {
  /* Icon-beside-text doesn't leave enough room for a full currency
     value in a 2-column grid -- stack icon above text so the value
     gets the card's full width instead of sharing it. */
  .dash-stat-card { flex-direction: column; align-items: flex-start; gap: 6px; }
  .dash-stat-value { font-size: 1.1rem; }
}

.dash-section {
  margin-bottom: var(--space-4);
}

.dash-section-hdr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-2);
}

.dash-section-hdr h3 {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.dash-section-link {
  background: none;
  border: none;
  color: var(--accent);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
}

.dash-empty {
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.dash-orders-table {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-card);
}

.dash-order-row {
  display: grid;
  grid-template-columns: 110px 1fr 120px 100px;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  font-size: 0.85rem;
  border-bottom: 1px solid var(--border);
}
.dash-order-row:last-child { border-bottom: none; }

.dash-order-id { font-weight: 700; color: var(--text-primary); }
.dash-order-date { color: var(--text-secondary); }
.dash-order-total { font-weight: 700; text-align: right; color: var(--text-primary); }

.dash-order-status {
  font-size: 0.72rem;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: var(--radius-pill);
  text-align: center;
  width: fit-content;
  text-transform: capitalize;
}
.dash-status-delivered { background: rgba(59, 130, 246,0.12); color: var(--success); }
.dash-status-shipped   { background: rgba(59,130,246,0.12); color: var(--accent); }
.dash-status-processing,
.dash-status-confirmed { background: rgba(255, 103, 0,0.12); color: var(--color-primary); }
.dash-status-cancelled { background: color-mix(in srgb, var(--danger) 12%, transparent); color: var(--danger); }
.dash-status-received,
.dash-status-pending  { background: var(--bg-tertiary); color: var(--text-secondary); }

.dash-card-strip {
  display: flex;
  gap: 12px;
  overflow-x: auto;
}

.dash-mini-card {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 140px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 10px;
  gap: 4px;
  box-shadow: var(--shadow-card);
}

.dash-mini-card img {
  width: 100%;
  height: 90px;
  object-fit: contain;
  border-radius: var(--radius-sm);
  margin-bottom: 4px;
}

.dash-mini-name {
  font-size: 0.78rem;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dash-mini-price {
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--text-primary);
}

.dash-mini-buy-btn {
  margin-top: 4px;
  min-height: 36px;
  background: var(--accent);
  color: var(--color-text-on-secondary);
  border: none;
  border-radius: var(--radius-sm);
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
}
.dash-mini-buy-btn:hover { background: var(--accent-hover); }

@media (max-width: 900px) {
  .dash-stats-grid { grid-template-columns: repeat(2, 1fr); }
  .dash-order-row { grid-template-columns: 90px 1fr 90px; }
  .dash-order-date { display: none; }
}

/* ── 404 / Not Found ─────────────────────────────────────────── */
.nf-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--bg-primary);
  color: var(--text-primary);
}

.nf-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 24px 0;
}
.nf-logo-name {
  font-size: 1.3rem;
  font-weight: 800;
  color: var(--text-primary);
}

.nf-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 20px;
}

.nf-code {
  font-size: 6rem;
  font-weight: 800;
  color: var(--accent);
  line-height: 1;
}

.nf-title {
  font-size: 1.4rem;
  font-weight: 700;
  margin: 8px 0 8px;
}

.nf-desc {
  color: var(--text-secondary);
  font-size: 0.95rem;
  max-width: 380px;
  margin: 0 0 24px;
}

.nf-home-btn {
  flex: none;
  padding: 12px 28px;
}

/* ── Footer ──────────────────────────────────────────────────── */
.ftr {
  margin-top: auto;
  font-size: 0.85rem;
}

/* Trust bar */
.ftr-trust-bar {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--space-2);
  background: var(--bg-secondary);
  border-top: 1px solid var(--border);
  padding: var(--space-3) var(--space-4);
}
.ftr-trust-item {
  display: flex;
  align-items: center;
  gap: 14px;
}
.ftr-trust-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  flex-shrink: 0;
}
.ftr-trust-icon--blue   { background: rgba(59,130,246,0.14); }
.ftr-trust-icon--positive  { background: color-mix(in srgb, var(--success) 14%, transparent); }
.ftr-trust-icon--orange { background: rgba(255, 103, 0,0.14); }
.ftr-trust-icon--info { background: color-mix(in srgb, var(--accent-secondary) 14%, transparent); }
/* The trust bar sits on --bg-secondary (a white band ABOVE the navy footer),
   not on the navy itself -- so unlike the rest of the footer it takes the
   normal theme-adaptive text tokens. */
.ftr-trust-title { font-weight: 700; color: var(--text-primary); font-size: 0.92rem; }
.ftr-trust-sub   { color: var(--text-secondary); font-size: 0.78rem; margin-top: 2px; }

/* Everything below the trust bar is a fixed dark zone regardless of site theme */
.ftr-cta-row,
.ftr-links-row,
.ftr-meta-row,
.ftr-bottom-bar {
  background: var(--color-brand-navy);
  color: var(--color-on-navy-secondary);
}

.ftr-cta-row {
  display: grid;
  grid-template-columns: 1.3fr 1fr 1fr;
  gap: var(--space-4);
  align-items: center;
  padding: var(--space-4);
  border-top: 1px solid rgba(255,255,255,0.14);
}
.ftr-cta-row > * { min-width: 0; }
.ftr-brand-block { padding-right: var(--space-2); }
.ftr-brand-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-bottom: var(--space-2);
}
.ftr-brand-name { font-size: 1.3rem; font-weight: 800; color: var(--color-brand-white); }
.ftr-brand-tag  { font-weight: 700; color: var(--color-brand-white); margin: 0 0 8px; font-size: 0.92rem; }
.ftr-brand-desc { color: var(--color-on-navy-muted); line-height: 1.5; margin: 0; }

.ftr-cta-block {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  padding: 0 var(--space-2);
  position: relative;
  min-width: 0;
}
.ftr-cta-block::before {
  content: '';
  position: absolute;
  left: calc(-1 * var(--space-2));
  top: 4px;
  bottom: 4px;
  width: 1px;
  background: rgba(255,255,255,0.16);
}
.ftr-cta-top {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  width: 100%;
}
.ftr-cta-top > div { min-width: 0; }
.ftr-cta-icon {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: rgba(59,130,246,0.18);
  color: var(--color-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  flex-shrink: 0;
}
.ftr-cta-icon--info { background: rgba(1, 13, 33,0.18); color: var(--color-secondary); }
.ftr-cta-title { font-weight: 700; color: var(--color-brand-white); font-size: 0.95rem; margin-bottom: 4px; }
.ftr-cta-sub { color: var(--color-on-navy-muted); margin: 0; font-size: 0.82rem; line-height: 1.4; }
.ftr-cta-btn {
  flex: none;
  /* Solid brand blue, not the translucent hover variant: over the navy footer
     that flattened to a lighter blue and dropped navy-on-blue to 4.33:1, just
     under AA. Solid #3B82F6 gives 5.6:1. */
  background: var(--color-secondary);
  color: var(--color-text-on-secondary);
  font-size: 0.85rem;
  padding: 10px 18px;
  gap: 8px;
}
.ftr-cta-btn:hover { background: var(--color-secondary-hover); }

/* Seller-benefit bullets -- mobile-only, see breakpoint below */
.ftr-cta-features { display: none; }
.ftr-cta-feature { display: flex; align-items: flex-start; gap: 8px; min-width: 0; }
.ftr-cta-feature-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ftr-cta-feature-icon--blue   { background: rgba(59,130,246,0.18);  color: var(--color-secondary); }
.ftr-cta-feature-icon--positive  { background: color-mix(in srgb, var(--success) 18%, transparent);   color: var(--success); }
.ftr-cta-feature-icon--info { background: rgba(1, 13, 33,0.18); color: var(--color-secondary); }
.ftr-cta-feature-title { font-weight: 700; color: var(--color-brand-white); font-size: 0.78rem; line-height: 1.2; }
.ftr-cta-feature-sub   { color: var(--color-on-navy-muted); font-size: 0.7rem; line-height: 1.3; margin-top: 2px; }

.ftr-subscribe-row {
  display: flex;
  gap: 8px;
  width: 100%;
}
.ftr-subscribe-input-wrap {
  position: relative;
  flex: 1 1;
  min-width: 0;
}
.ftr-subscribe-input-icon {
  position: absolute;
  left: 13px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--color-on-navy-muted);
  display: flex;
  pointer-events: none;
}
.ftr-subscribe-row input {
  box-sizing: border-box;
  width: 100%;
  min-height: 40px;
  padding: 0 14px 0 38px;
  border-radius: var(--radius-sm);
  border: 1px solid rgba(255,255,255,0.25);
  background: rgba(255,255,255,0.1);
  color: var(--color-brand-white);
  font-size: 0.85rem;
}
.ftr-subscribe-row input::placeholder { color: var(--color-on-navy-muted); }
.ftr-subscribe-row input:focus { outline: none; border-color: var(--color-brand-navy); }
.ftr-subscribe-btn {
  flex: none;
  min-height: 40px;
  padding: 0 18px;
  background: var(--color-brand-navy);
  color: var(--color-brand-white);
  border: none;
  border-radius: var(--radius-sm);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 150ms;
}
.ftr-subscribe-btn:hover { background: var(--color-primary-hover); }

/* Link columns */
.ftr-links-row {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: var(--space-3);
  padding: var(--space-4);
  border-top: 1px solid rgba(255,255,255,0.14);
}
.ftr-col-title {
  color: var(--color-brand-white);
  font-size: 0.8rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  margin: 0 0 10px;
}
.ftr-col-title::after {
  content: '';
  display: block;
  width: 28px;
  height: 3px;
  border-radius: var(--radius-pill);
  background: var(--color-brand-navy);
  margin-top: 8px;
}
.ftr-link-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 2px; }
.ftr-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 32px;
  background: none;
  border: none;
  /* Entries with a real destination render as <a href> so crawlers can reach
     the legal/company/support pages; the rest are still <button>. Both share
     this class, so the link underline is cancelled here. */
  text-decoration: none;
  color: var(--color-on-navy-muted);
  font-size: 0.84rem;
  text-align: left;
  cursor: pointer;
  padding: 4px 0;
  transition: color 150ms, transform 150ms;
}
.ftr-link svg { opacity: 0; transform: translateX(-4px); transition: opacity 150ms, transform 150ms; }
.ftr-link:hover { color: var(--color-brand-white); }
.ftr-link:hover svg { opacity: 1; transform: translateX(0); }
.ftr-link:focus-visible { outline: 2px solid var(--color-secondary); outline-offset: 2px; }

/* Social row */
.ftr-meta-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  border-top: 1px solid rgba(255,255,255,0.14);
  align-items: start;
}
.ftr-meta-title {
  color: var(--color-brand-white);
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  margin: 0 0 12px;
}

.ftr-social-row { display: flex; gap: 10px; flex-wrap: wrap; }
.ftr-social-btn {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  color: var(--color-brand-white);
  font-weight: 800;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ftr-social-btn--fb { background: #1877f2; }
.ftr-social-btn--ig { background: linear-gradient(135deg, #f58529, #dd2a7b, #8134af); }
.ftr-social-btn--x  { background: #000; }
/* TikTok's mark is black, same as X above -- a third-party brand colour, kept
   literal. --text-primary made it navy-on-navy and it vanished into the footer. */
.ftr-social-btn--tt { background: #000; }
.ftr-social-btn--yt { background: #ff0000; }
.ftr-social-btn--li { background: #0a66c2; font-size: 0.75rem; }

/* Bottom bar */
.ftr-bottom-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  padding: var(--space-2) var(--space-4);
  border-top: 1px solid rgba(255,255,255,0.14);
  background: var(--color-brand-navy);
  color: var(--color-on-navy-secondary);
  font-size: 0.78rem;
}
.ftr-bottom-links { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.ftr-bottom-link {
  background: none;
  border: none;
  /* Mixed <a>/<button> like .ftr-link -- see that rule. */
  text-decoration: none;
  color: var(--color-on-navy-muted);
  font-size: 0.78rem;
  cursor: pointer;
  /* 50x18 measured, against the 24px minimum. inline-flex so the vertical
     padding actually makes a box -- on the default inline display, top and
     bottom padding paints but does not change the hit area. */
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 2px 4px;
}
.ftr-bottom-link:hover { color: var(--color-brand-white); }
.ftr-bottom-sep { color: var(--color-on-navy-secondary); margin-right: 8px; }

@media (max-width: 1024px) {
  .ftr-trust-bar { grid-template-columns: repeat(2, 1fr); }
  .ftr-cta-row { grid-template-columns: 1fr; }
  .ftr-cta-block::before { display: none; }
  .ftr-links-row { grid-template-columns: repeat(3, 1fr); }
  .ftr-meta-row { grid-template-columns: 1fr; }
}
@media (max-width: 640px) {
  .ftr-trust-bar { grid-template-columns: 1fr; padding: var(--space-2); }
  .ftr-links-row { grid-template-columns: repeat(2, 1fr); padding: var(--space-3); }
  .ftr-cta-row { padding: var(--space-3); gap: var(--space-3); }
  .ftr-meta-row { padding: var(--space-3); }
  .ftr-bottom-bar { flex-direction: column; align-items: flex-start; text-align: left; }

  /* Seller-signup and newsletter CTA cards get the full "stand out" treatment on mobile */
  .ftr-cta-block {
    box-sizing: border-box;
    align-items: stretch;
    padding: var(--space-3);
    background: rgba(255,255,255,0.035);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: var(--radius-lg);
  }
  .ftr-cta-block::before { display: none; }
  .ftr-cta-icon {
    width: 64px;
    height: 64px;
    border-radius: 18px;
    font-size: 1.7rem;
  }
  .ftr-cta-title { font-size: 1.05rem; }
  .ftr-cta-sub { font-size: 0.85rem; }
  .ftr-cta-features {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    padding-top: var(--space-2);
    border-top: 1px solid rgba(255,255,255,0.12);
  }
  .ftr-cta-feature { flex-direction: column; gap: 8px; }
  .ftr-cta-btn { box-sizing: border-box; width: 100%; min-height: 48px; font-size: 0.95rem; }
}

/* ════════════════════════════════════════════════════════════════
   Operations Dashboard (ops-*)
   ════════════════════════════════════════════════════════════════ */
.ops-root {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Funnel */
.ops-funnel-card { padding: 20px 24px; }
.ops-funnel { display: flex; flex-direction: column; gap: 14px; margin-top: 8px; }
.ops-funnel-step { display: flex; align-items: center; gap: 16px; }
.ops-funnel-bar-track {
  flex: 1 1;
  height: 28px;
  background: var(--surface-raised, var(--bg-tertiary));
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
}
@media (prefers-color-scheme: dark) { .ops-funnel-bar-track { background: rgba(255,255,255,0.06); } }
:root[data-theme="dark"]  .ops-funnel-bar-track { background: rgba(255,255,255,0.06); }
:root[data-theme="light"] .ops-funnel-bar-track { background: var(--bg-tertiary); }
.ops-funnel-bar { height: 100%; border-radius: 6px; transition: width 0.6s ease; min-width: 3%; }
.ops-funnel-arrow { position: absolute; right: 10px; font-size: 11px; font-weight: 600; color: var(--text-muted); white-space: nowrap; }
.ops-funnel-meta { display: flex; flex-direction: column; align-items: flex-end; width: 130px; flex-shrink: 0; }
.ops-funnel-val   { font-size: 16px; font-weight: 800; line-height: 1.1; }
.ops-funnel-label { font-size: 12px; font-weight: 600; color: var(--text-primary); }
.ops-funnel-sub   { font-size: 10px; color: var(--text-muted); }

/* GMV row */
.ops-gmv-row {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 12px;
}
@media (max-width: 1200px) { .ops-gmv-row { grid-template-columns: repeat(3, 1fr); } }
@media (max-width: 640px)  { .ops-gmv-row { grid-template-columns: repeat(2, 1fr); } }
.ops-gmv-card {
  background: var(--surface-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 14px 16px;
  display: grid;
  grid-template-rows: 36px 2.5em auto 1fr;
  row-gap: 4px;
}
.ops-gmv-icon {
  width: 32px; height: 32px; border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  font-size: 15px;
}
.ops-gmv-label { align-self: center; font-size: 11px; line-height: 1.25; color: var(--text-muted); font-weight: 500; margin: 0; }
.ops-gmv-val   { font-size: 18px; font-weight: 800; color: var(--text-primary); line-height: 1.1; margin: 0; white-space: nowrap; }
.ops-gmv-sub   { align-self: end; font-size: 10px; color: var(--text-muted); margin: 2px 0 0; }

/* Sort chips -- mobile only.
   Hidden here rather than in the mobile layer, because the desktop <select>
   is the control on a wide screen and two sort widgets on one page would be
   two sources of truth to keep in sync. mobile/feed.css turns this on and
   the select off, so exactly one is live at any width. */
.shop-sort-chips { display: none; }

/* New-order banner
   Orange, because this is the one thing on the dashboard asking to be acted
   on commercially -- and navy on orange is 7.4:1, so the text stays legible
   without the white that fails AA on this fill. The dot pulses to catch the
   eye of someone already looking elsewhere on the page; it is decorative and
   the wording carries the meaning on its own. */
.admin-neworder-banner {
  display: flex;
  align-items: center;
  gap: 14px;
  background: var(--color-primary-soft, rgba(255, 103, 0, 0.12));
  border: 1px solid var(--color-primary);
  border-radius: var(--radius-lg);
  padding: 13px 16px;
  margin-bottom: 18px;
}

.admin-neworder-pulse {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--color-primary);
  flex-shrink: 0;
  animation: admin-neworder-ping 1.8s ease-out infinite;
}

@keyframes admin-neworder-ping {
  0%   { box-shadow: 0 0 0 0 rgba(255, 103, 0, 0.55); }
  70%  { box-shadow: 0 0 0 9px rgba(255, 103, 0, 0); }
  100% { box-shadow: 0 0 0 0 rgba(255, 103, 0, 0); }
}

@media (prefers-reduced-motion: reduce) {
  .admin-neworder-pulse { animation: none; }
}

.admin-neworder-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1 1;
}
.admin-neworder-text strong { font-size: 14px; color: var(--text-primary); }
.admin-neworder-detail {
  font-size: 12px;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.admin-neworder-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.admin-neworder-cta {
  background: var(--color-primary);
  color: var(--color-text-on-primary);
  border: none;
  border-radius: var(--radius-sm);
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}
.admin-neworder-cta:hover { filter: brightness(0.94); }

.admin-neworder-secondary {
  background: none;
  border: 1px solid var(--color-primary);
  color: var(--text-primary);
  border-radius: var(--radius-sm);
  padding: 7px 12px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
}

.admin-neworder-dismiss {
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: 20px;
  line-height: 1;
  padding: 0 4px;
  cursor: pointer;
}
.admin-neworder-dismiss:hover { color: var(--text-primary); }

.admin-neworder-cta:focus-visible,
.admin-neworder-secondary:focus-visible,
.admin-neworder-dismiss:focus-visible {
  outline: 2px solid var(--color-secondary);
  outline-offset: 2px;
}

@media (max-width: 720px) {
  .admin-neworder-banner { flex-wrap: wrap; }
  .admin-neworder-text { flex-basis: 100%; }
  .admin-neworder-actions { margin-left: auto; }
}

/* Sales-channel panel (app vs website) */
.ops-channel-panel {
  background: var(--surface-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 16px;
}
.ops-channel-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.ops-channel-title  { font-size: 13px; font-weight: 700; color: var(--text-primary); margin: 0; }
.ops-channel-period { font-size: 10px; color: var(--text-muted); }

/* One track, one segment per channel with revenue. */
.ops-channel-bar {
  display: flex;
  height: 8px;
  border-radius: 999px;
  overflow: hidden;
  background: var(--bg-tertiary);
  margin-bottom: 14px;
}
.ops-channel-bar-seg { display: block; height: 100%; }

.ops-channel-rows { display: grid; gap: 8px; }
.ops-channel-row {
  display: grid;
  grid-template-columns: 8px 18px minmax(90px, 1.4fr) 46px minmax(64px, 1fr) minmax(64px, 1fr) minmax(74px, 1fr) 62px;
  align-items: center;
  gap: 8px;
  font-size: 11px;
}
.ops-channel-dot  { width: 8px; height: 8px; border-radius: 50%; }
.ops-channel-icon { display: flex; align-items: center; justify-content: center; }
.ops-channel-name  { font-weight: 600; color: var(--text-primary); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.ops-channel-share { font-weight: 700; color: var(--text-primary); font-variant-numeric: tabular-nums; }
.ops-channel-val   { font-size: 13px; font-weight: 800; color: var(--text-primary); font-variant-numeric: tabular-nums; white-space: nowrap; }
.ops-channel-meta  { color: var(--text-muted); font-variant-numeric: tabular-nums; white-space: nowrap; }

/* Direction is carried by the caret as well as the colour -- with only four
   brand hues, up and down cannot be told apart by hue alone. */
.ops-channel-trend { font-weight: 700; font-variant-numeric: tabular-nums; white-space: nowrap; text-align: right; }
.ops-channel-trend.is-up   { color: var(--color-secondary-text); }
.ops-channel-trend.is-down { color: var(--color-primary); }
/* Not a movement, so not up/down orange or blue-green: this channel simply
   had no previous period to be measured against. Blue is information's role. */
.ops-channel-trend-new     { color: var(--color-secondary-text); font-weight: 600; }
.ops-channel-trend-none    { color: var(--text-muted); }

.ops-channel-note {
  margin: 12px 0 0;
  font-size: 10px;
  line-height: 1.45;
  color: var(--text-muted);
}

/* The row is a table on a wide screen and a stack on a narrow one -- eight
   columns at 11px is unreadable below roughly 900px. */
@media (max-width: 900px) {
  .ops-channel-row {
    grid-template-columns: 8px 18px 1fr auto;
    row-gap: 2px;
  }
  .ops-channel-share { grid-column: 4; text-align: right; }
  .ops-channel-val   { grid-column: 3 / 5; }
  .ops-channel-meta  { grid-column: 3 / 5; }
  .ops-channel-trend { grid-column: 3 / 5; text-align: left; }
}

/* Rate cards */
.ops-rates-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}
@media (max-width: 900px) { .ops-rates-row { grid-template-columns: repeat(2, 1fr); } }
.ops-rate-card {
  background: var(--surface-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 4px;
  position: relative;
  overflow: hidden;
}
.ops-rate-wave {
  position: absolute;
  left: 0; right: 0; bottom: 0;
  width: 100%; height: 60px;
  z-index: 0;
}
.ops-rate-icon {
  width: 36px; height: 36px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  font-size: 16px; margin-bottom: 4px;
  position: relative; z-index: 1;
}
.ops-rate-label { font-size: 11px; color: var(--text-muted); font-weight: 500; position: relative; z-index: 1; }
.ops-rate-val   { font-size: 26px; font-weight: 900; line-height: 1.1; position: relative; z-index: 1; }
.ops-rate-note  { font-size: 10px; color: var(--text-muted); margin-top: 2px; position: relative; z-index: 1; }

/* Charts row */
.ops-charts-row {
  display: grid;
  grid-template-columns: 1fr 200px 260px;
  gap: 16px;
  align-items: start;
}
@media (max-width: 1100px) { .ops-charts-row { grid-template-columns: 1fr 1fr; } }
@media (max-width: 680px)  { .ops-charts-row { grid-template-columns: 1fr; } }
.ops-chart-wide  { padding: 18px 20px; }
.ops-donut-card  { padding: 18px 20px; }
.ops-health-card { padding: 18px 20px; display: flex; flex-direction: column; gap: 0; }
.ops-health-row {
  display: flex; align-items: center; gap: 10px;
  padding: 9px 0; border-bottom: 1px solid var(--border);
}
.ops-health-row:last-child { border-bottom: none; }
.ops-health-icon {
  width: 28px; height: 28px; border-radius: 7px;
  display: flex; align-items: center; justify-content: center;
  font-size: 13px; flex-shrink: 0;
}
.ops-health-body { flex: 1 1; min-width: 0; }
.ops-health-label { font-size: 12px; font-weight: 600; color: var(--text-primary); }
.ops-health-sub   { font-size: 10px; color: var(--text-muted); }
.ops-health-val   { font-size: 18px; font-weight: 800; flex-shrink: 0; }

/* Products row */
.ops-products-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 20px;
  align-items: stretch;
}
@media (max-width: 760px) { .ops-products-row { grid-template-columns: 1fr; } }
.ops-top-prods-card { padding: 18px 20px; }
.ops-products-row .ops-health-card,
.ops-products-row .ops-low-stock-card { min-height: 310px; padding: 22px 24px; }
.ops-products-row .ov-card-header { margin-bottom: 12px; }
.ops-products-row .ov-card-title { font-size: 1.35rem; font-weight: 750; letter-spacing: -0.025em; }

.ops-health-layout {
  flex: 1 1;
  display: grid;
  grid-template-columns: minmax(180px, 0.8fr) minmax(230px, 1.2fr);
  align-items: center;
  gap: 18px;
}
.ops-health-donut { display: flex; align-items: center; justify-content: center; min-width: 0; }
.ops-health-metrics { min-width: 0; }
.ops-health-metric {
  display: grid;
  grid-template-columns: 12px minmax(0, 1fr) auto;
  align-items: center;
  column-gap: 10px;
  min-height: 42px;
  border-bottom: 1px solid var(--border);
}
.ops-health-metric:last-child { border-bottom: 0; }
.ops-health-dot { width: 10px; height: 10px; border-radius: 50%; }
.ops-health-metric-label { min-width: 0; color: var(--text-secondary); font-size: 0.9rem; white-space: nowrap; }
.ops-health-now { margin-left: 6px; color: var(--text-muted); font-size: 0.78rem; font-weight: 600; }
.ops-health-metric-value { color: var(--text-primary); font-size: 0.95rem; font-weight: 750; }

.ops-low-stock-card { padding: 18px 20px; }
.ops-low-threshold {
  color: var(--color-primary);
  background: color-mix(in srgb, var(--color-primary) 7%, transparent);
  border: 1px solid color-mix(in srgb, var(--color-primary) 22%, var(--border));
  border-radius: 8px;
  padding: 6px 11px;
  font-size: 0.82rem;
  white-space: nowrap;
}
.ops-low-list { display: flex; flex-direction: column; gap: 8px; }

.ops-top-table  { display: flex; flex-direction: column; margin-top: 8px; }
.ops-top-thead  {
  display: flex; align-items: center; gap: 6px;
  padding: 6px 0 8px; border-bottom: 1px solid var(--border);
  font-size: 11px; color: var(--text-muted); font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em;
}
.ops-top-rank-col { width: 24px; flex-shrink: 0; }
.ops-top-row {
  display: flex; align-items: center; gap: 6px;
  padding: 6px 0;
}
.ops-top-rank  { width: 24px; font-size: 11px; font-weight: 700; color: var(--text-muted); flex-shrink: 0; }
.ops-top-name  { flex: 1 1; font-size: 13px; color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.ops-top-units { width: 52px; text-align: right; font-size: 12px; color: var(--text-secondary); }
.ops-top-rev   { width: 88px; text-align: right; font-size: 13px; font-weight: 700; color: var(--text-primary); }

.ops-low-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 16px;
  min-height: 64px;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: 9px;
}
.ops-low-info { min-width: 0; }
.ops-low-name { margin: 0; font-size: 0.9rem; font-weight: 700; color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.ops-low-cat { margin: 4px 0 0; font-size: 0.78rem; color: var(--text-muted); }
.ops-low-badge  {
  min-width: 86px;
  padding: 7px 10px;
  border-left: 1px solid var(--border);
  border-radius: 7px;
  color: var(--color-primary);
  background: color-mix(in srgb, var(--color-primary) 10%, transparent);
  font-size: 0.78rem;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
}
.ops-low-badge.is-low { background: color-mix(in srgb, var(--color-primary) 8%, transparent); }

@media (max-width: 1100px) {
  .ops-health-layout { grid-template-columns: 160px minmax(200px, 1fr); gap: 10px; }
  .ops-health-donut { transform: scale(0.86); margin: -12px; }
}
@media (max-width: 520px) {
  .ops-products-row .ops-health-card,
  .ops-products-row .ops-low-stock-card { min-height: 0; padding: 18px; }
  .ops-health-layout { grid-template-columns: 1fr; }
  .ops-health-donut { transform: none; margin: -8px 0; }
  .ops-health-metric-label { white-space: normal; }
}

/* Row of 3 equal cards (top products / fraud alerts / delivery) */
.ops-row-3 {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  align-items: stretch;
}
@media (max-width: 1100px) { .ops-row-3 { grid-template-columns: 1fr 1fr; } }
@media (max-width: 760px)  { .ops-row-3 { grid-template-columns: 1fr; } }
.ops-fraud-card { padding: 18px 20px; }
.ops-city-card  { padding: 18px 20px; }

.ops-fraud-row {
  display: flex; align-items: center; gap: 10px;
  padding: 6px 0;
}

.ops-city-table { display: flex; flex-direction: column; margin-top: 4px; }
.ops-city-thead {
  display: flex; align-items: center; gap: 4px;
  padding: 6px 0 8px; border-bottom: 1px solid var(--border);
  font-size: 10px; color: var(--text-muted); font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em;
}
.ops-city-row {
  display: flex; align-items: center; gap: 4px;
  padding: 6px 0;
}

/* ── KPI summary row ─────────────────────────────────────────────── */
.ops-kpi-row {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 14px;
}
@media (max-width: 1200px) { .ops-kpi-row { grid-template-columns: repeat(3, 1fr); } }
@media (max-width: 640px)  { .ops-kpi-row { grid-template-columns: repeat(2, 1fr); } }
.ops-kpi-card {
  background: var(--surface-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.ops-kpi-top { display: flex; align-items: center; gap: 8px; }
.ops-kpi-icon {
  width: 34px; height: 34px; border-radius: 9px;
  display: flex; align-items: center; justify-content: center;
  font-size: 15px; flex-shrink: 0;
}
.ops-kpi-label { font-size: 12px; color: var(--text-secondary); font-weight: 600; }
.ops-kpi-value { font-size: 22px; font-weight: 800; color: var(--text-primary); margin: 2px 0 0; }
.ops-kpi-note  { font-size: 11px; color: var(--text-muted); margin: 0; }
.ops-kpi-arrow.up   { color: var(--color-secondary); font-weight: 700; }
.ops-kpi-arrow.down { color: var(--color-primary); font-weight: 700; }

/* ── Row of 4 (funnel / revenue / breakdown / health) ──────────────── */
.ops-row-4 {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  align-items: stretch;
}
@media (max-width: 1300px) { .ops-row-4 { grid-template-columns: 1fr 1fr; } }
@media (max-width: 680px)  { .ops-row-4 { grid-template-columns: 1fr; } }

/* Compact conversion funnel (v2) */
.ops-funnel-card-v2 { padding: 18px 20px; }
.opsf2-list { display: flex; flex-direction: column; gap: 12px; margin-top: 4px; }
.opsf2-step { display: flex; align-items: center; gap: 8px; }
.opsf2-label-col { width: 78px; flex-shrink: 0; display: flex; flex-direction: column; }
.opsf2-label     { font-size: 11px; font-weight: 600; color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.opsf2-pct-sub   { font-size: 10px; color: var(--text-muted); }
.opsf2-track {
  flex: 1 1; height: 10px; border-radius: 6px; overflow: hidden;
  background: rgba(255,255,255,0.06);
}
:root[data-theme="light"] .opsf2-track { background: var(--bg-tertiary); }
.opsf2-bar   { height: 100%; border-radius: 6px; transition: width 0.6s ease; min-width: 3%; }
.opsf2-right { width: 50px; flex-shrink: 0; text-align: right; display: flex; flex-direction: column; }
.opsf2-count { font-size: 13px; font-weight: 800; line-height: 1.1; }
.opsf2-pct   { font-size: 10px; color: var(--text-muted); }

/* ══════════════════════════════════════════════════════════════════
   Add Product page redesign
   ══════════════════════════════════════════════════════════════════ */

.admin-pf-header-v2 { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; }
.admin-pf-header-actions { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }

.admin-pf-btn-draft, .admin-pf-btn-publish {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 9px 16px; border-radius: 10px; font-size: 0.85rem; font-weight: 700;
  cursor: pointer; transition: all 150ms; white-space: nowrap;
}
.admin-pf-btn-draft {
  background: var(--bg-secondary); color: var(--text-primary); border: 1px solid var(--border);
}
.admin-pf-btn-draft:hover { background: var(--border); }
.admin-pf-btn-publish {
  background: var(--accent); color: var(--color-text-on-secondary); border: 1px solid var(--accent);
}
.admin-pf-btn-publish:hover { filter: brightness(1.08); }

/* Collapsible "optional" sections (Variants / Shipping / Features / Specs) --
   the form is a single scrolling page (no wizard); these stay closed by
   default so a simple product's form is short, and auto-open on edit when
   the product already has data in them (see startEdit's advOpen seeding). */
.admin-pf-section-collapsible { gap: 0; }
.admin-pf-section-toggle {
  display: flex; align-items: center; justify-content: space-between; gap: 10px;
  width: 100%; background: none; border: none; padding: 0; margin: 0;
  cursor: pointer; text-align: left; color: var(--text-secondary);
}
.admin-pf-section-collapsible .admin-pf-section-title { margin: 0; }
.admin-pf-section-collapsible > .admin-pf-section-toggle ~ * { margin-top: 14px; }
.admin-pf-optional-tag {
  font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em;
  color: var(--text-tertiary); background: var(--bg-tertiary);
  border: 1px solid var(--border); border-radius: 20px; padding: 2px 8px; margin-left: 4px;
}

/* Icon-prefixed inputs (Category / SKU) -- same shell pattern as the price inputs */
.admin-pf-icon-wrap {
  display: flex; align-items: center;
  border: 1px solid var(--border); border-radius: 8px; overflow: hidden;
  background: var(--bg-primary); transition: border-color 0.15s;
}
.admin-pf-icon-wrap:focus-within { border-color: var(--accent); }
.admin-pf-icon-prefix {
  padding: 0 10px; height: 100%; display: flex; align-items: center;
  font-size: 0.85rem; color: var(--text-secondary);
  background: var(--bg-tertiary); border-right: 1px solid var(--border);
  flex-shrink: 0;
}
.admin-pf-icon-input { border: none !important; border-radius: 0 !important; background: transparent !important; flex: 1 1; }

/* Tag chips */
.admin-pf-tag-wrap {
  display: flex; align-items: flex-start;
  border: 1px solid var(--border); border-radius: 8px; overflow: hidden;
  background: var(--bg-primary); transition: border-color 0.15s;
}
.admin-pf-tag-wrap:focus-within { border-color: var(--accent); }
.admin-pf-tag-wrap .admin-pf-icon-prefix { align-self: stretch; height: auto; }
.admin-pf-tag-chips {
  flex: 1 1; display: flex; flex-wrap: wrap; align-items: center; gap: 6px;
  padding: 8px 10px; min-height: 40px; box-sizing: border-box;
}
.admin-pf-tag-chip {
  display: inline-flex; align-items: center; gap: 5px;
  background: color-mix(in srgb, var(--accent) 15%, transparent);
  color: var(--accent); font-size: 0.78rem; font-weight: 600;
  padding: 4px 6px 4px 10px; border-radius: 20px; white-space: nowrap;
}
.admin-pf-tag-chip button {
  background: none; border: none; color: inherit; cursor: pointer;
  font-size: 0.7rem; padding: 2px; display: flex; align-items: center; opacity: 0.7;
}
.admin-pf-tag-chip button:hover { opacity: 1; }
.admin-pf-tag-input {
  flex: 1 1; min-width: 90px; border: none; outline: none; background: transparent;
  color: var(--text-primary); font-size: 0.9rem; font-family: inherit; padding: 4px 0;
}
.admin-pf-hint { font-size: 0.72rem; color: var(--text-tertiary); margin: 4px 0 0; }

/* Per-size stock rows (Add Product / seller product form) */
.admin-pf-size-rows { display: flex; flex-direction: column; gap: 6px; margin-bottom: 8px; }
.admin-pf-size-row {
  display: flex; align-items: center; gap: 10px;
  border: 1px solid var(--border); border-radius: 8px; padding: 6px 10px;
  background: var(--bg-primary);
}
.admin-pf-size-label { font-size: 0.85rem; font-weight: 700; color: var(--text-primary); width: 44px; flex-shrink: 0; }
.admin-pf-size-stock-input { flex: 1 1; padding: 6px 10px !important; font-size: 0.85rem !important; }
.admin-pf-size-remove {
  background: none; border: none; color: var(--text-tertiary); cursor: pointer;
  font-size: 0.85rem; padding: 4px; flex-shrink: 0;
}
.admin-pf-size-remove:hover { color: var(--color-primary); }

/* Colour tags (Add Product / seller product form) -- reuses .admin-pf-tag-chip
   styling, just rendered as a standalone row above its input like sizes. */
.admin-pf-color-tags { padding: 0; min-height: 0; margin-bottom: 8px; }

/* Variant (colour x size) table */
.admin-pf-variants-empty {
  border: 1px dashed var(--border); border-radius: 8px;
  padding: 20px; text-align: center;
  color: var(--text-tertiary); font-size: 0.85rem;
}
/* overflow-x: auto -- the row below has a wide intrinsic min-width (7
   columns of inputs/selects that won't shrink past their own content), and
   without this the table refused to shrink to fit .spf-main and instead
   overflowed horizontally into the Product Preview sidebar next to it. Now
   it scrolls within its own card instead. */
.admin-pf-variants-table { display: flex; flex-direction: column; gap: 6px; overflow-x: auto; }
.admin-pf-variants-head {
  display: grid; grid-template-columns: 90px 70px 1.3fr 90px 1.1fr 90px 100px;
  gap: 8px; padding: 0 10px;
  font-size: 0.7rem; font-weight: 700; color: var(--text-tertiary);
  text-transform: uppercase; letter-spacing: 0.04em;
  min-width: 640px;
}
.admin-pf-variants-row {
  display: grid; grid-template-columns: 90px 70px 1.3fr 90px 1.1fr 90px 100px;
  gap: 8px; align-items: center;
  border: 1px solid var(--border); border-radius: 8px; padding: 8px 10px;
  background: var(--bg-primary);
  min-width: 640px;
}
.admin-pf-variants-cell-label { font-size: 0.85rem; font-weight: 700; color: var(--text-primary); }
.admin-pf-variants-color-cell { display: flex; align-items: center; gap: 8px; }
.admin-pf-color-swatch { width: 14px; height: 14px; border-radius: 50%; border: 1px solid var(--border); flex-shrink: 0; }
.admin-pf-variants-count { margin: 4px 0 0; padding: 0 10px; font-size: 0.78rem; color: var(--text-tertiary); }
.admin-pf-variant-img-slot {
  display: flex; align-items: center; gap: 6px;
  position: relative;
}
.admin-pf-variant-img, .admin-pf-variant-img-empty {
  width: 30px; height: 30px; border-radius: 6px; object-fit: cover;
  background: var(--bg-tertiary); border: 1px solid var(--border);
  display: flex; align-items: center; justify-content: center;
  color: var(--text-tertiary); flex-shrink: 0;
}
.admin-pf-variant-img-btn {
  font-size: 0.72rem; font-weight: 600; color: var(--accent);
  cursor: pointer; white-space: nowrap;
}
.admin-pf-variant-img-btn:hover { text-decoration: underline; }
@media (max-width: 900px) {
  .admin-pf-variants-head { display: none; }
  .admin-pf-variants-row { grid-template-columns: 1fr 1fr; row-gap: 6px; }
  .admin-pf-variants-row .admin-pf-variants-cell-label::before { content: ''; }
}

/* Stock status pill (auto-computed, not manually editable) */
.admin-pf-stock-status {
  display: inline-flex; align-items: center; gap: 8px;
  border: 1px solid var(--border); border-radius: 8px;
  padding: 0 12px; height: 40px; box-sizing: border-box;
  font-size: 0.88rem; font-weight: 700; color: var(--text-primary);
  background: var(--bg-primary); width: 100%;
}
.admin-pf-stock-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }

/* Unified media grid: compact upload tile + preview slots share one row */
.admin-image-grid-v2 { align-items: stretch; }
.admin-dropzone-compact {
  width: 96px; height: 100px; flex-shrink: 0;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  padding: 8px; border-radius: 10px;
  box-sizing: border-box;
}
.admin-dropzone-compact .admin-dropzone-icon { font-size: 1.3rem; margin-bottom: 4px; }
.admin-dropzone-text-compact { font-size: 0.72rem; font-weight: 700; color: var(--accent); margin: 0; text-align: center; }

/* Sidebar: preview + publishing + tips, scrolls together as a sticky group */
.admin-pf-sidebar { display: flex; flex-direction: column; gap: 16px; position: sticky; top: 16px; }
.admin-pf-sidebar .admin-preview-card { position: static; }

.admin-preview-wishlist {
  position: absolute; top: 10px; right: 10px; z-index: 2;
  width: 30px; height: 30px; border-radius: 50%;
  background: var(--bg-primary); border: 1px solid var(--border);
  display: flex; align-items: center; justify-content: center;
  font-size: 0.95rem; color: var(--text-secondary);
}

.admin-preview-cart-btn {
  margin-top: 10px; width: 100%; padding: 11px; border: none; border-radius: 10px;
  background: var(--accent); color: var(--color-text-on-secondary); font-size: 0.88rem; font-weight: 700;
  cursor: default; display: flex; align-items: center; justify-content: center; gap: 6px;
}

.admin-pf-publish-card, .admin-pf-tips-card {
  background: var(--bg-primary); border: 1px solid var(--border);
  border-radius: 14px; padding: 16px;
}
.admin-pf-publish-row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 10px 0; border-bottom: 1px solid var(--border);
  font-size: 0.85rem; color: var(--text-secondary);
}
.admin-pf-publish-row:last-child { border-bottom: none; }
.admin-pf-publish-select {
  border: 1px solid var(--border); border-radius: 8px; background: var(--bg-secondary);
  color: var(--text-primary); font-size: 0.82rem; font-weight: 600; padding: 6px 10px; cursor: pointer;
}

.admin-pf-tips-card p { font-size: 0.82rem; color: var(--text-secondary); margin: 8px 0 0; line-height: 1.5; }

/* Toggle switch */
.admin-pf-toggle { position: relative; display: inline-block; width: 40px; height: 22px; flex-shrink: 0; }
.admin-pf-toggle input { position: absolute; opacity: 0; width: 0; height: 0; }
.admin-pf-toggle-track {
  position: absolute; inset: 0; background: var(--border); border-radius: 22px; transition: background 0.15s;
}
.admin-pf-toggle-knob {
  position: absolute; top: 2px; left: 2px; width: 18px; height: 18px; border-radius: 50%;
  background: var(--color-brand-white); transition: transform 0.15s; box-shadow: 0 1px 3px rgba(1, 13, 33,0.3);
}
.admin-pf-toggle input:checked + .admin-pf-toggle-track { background: var(--accent); }
.admin-pf-toggle input:checked + .admin-pf-toggle-track .admin-pf-toggle-knob { transform: translateX(18px); }

/* ══════════════════════════════════════════════════════════════════
   Add Product page redesign v3 — exact visual spec (blue-bordered
   fields, icon-prefixed inputs, card-row optional sections). Scoped
   under .admin-pf-card-v2 (the Add Product page's own wrapper) rather
   than editing the base .admin-pf-* rules above, since those same
   class names are shared with the Banners and Careers admin forms,
   which this redesign intentionally does not touch.
   ══════════════════════════════════════════════════════════════════ */
.admin-pf-card-v2 {
  --pf-primary: var(--color-secondary);
  --pf-primary-dark: var(--color-secondary-hover);
  --pf-primary-soft: var(--color-secondary-soft);
  --pf-focus-ring: rgba(59, 130, 246, 0.16);
  --pf-field-bg: var(--bg-tertiary);
  --pf-heading: var(--text-primary);
  --pf-label: var(--text-secondary);
  --pf-text: var(--text-secondary);
  --pf-muted: var(--text-muted);
  --pf-divider: var(--border);
  --pf-danger: var(--color-primary);
  --pf-success: var(--color-secondary);
  --pf-info: var(--color-secondary);
  --pf-info-soft: var(--color-secondary-soft);
  --pf-positive: var(--color-secondary);
  --pf-positive-soft: var(--color-secondary-soft);
  --pf-card-radius: 16px;
  --pf-field-radius: 10px;
  --pf-field-height: 56px;
  --pf-card-shadow: 0 3px 10px rgba(16,24,40,0.07), 0 1px 2px rgba(16,24,40,0.04);
}
/* Dark-theme equivalents -- the supplied spec is light-only; these keep the
   same structure/contrast intent (bright accent on dark neutrals) rather
   than shipping a broken dark admin panel. */
:root[data-theme="dark"] .admin-pf-card-v2 {
  --pf-primary: var(--color-secondary);
  --pf-primary-dark: var(--color-secondary);
  --pf-primary-soft: rgba(91,147,255,0.16);
  --pf-focus-ring: rgba(91,147,255,0.28);
  --pf-field-bg: var(--color-brand-navy);
  --pf-heading: var(--bg-tertiary);
  --pf-label: var(--border);
  --pf-text: var(--border-strong);
  --pf-muted: var(--text-muted);
  --pf-divider: var(--text-secondary);
  --pf-danger: var(--color-primary);
  --pf-success: var(--color-secondary);
  --pf-info: var(--color-secondary);
  --pf-info-soft: rgba(59, 130, 246,0.16);
  --pf-positive: var(--color-secondary);
  --pf-positive-soft: rgba(59, 130, 246, 0.16);
  --pf-card-shadow: 0 2px 10px rgba(1, 13, 33,0.35);
}

.admin-pf-card-v2 .admin-form-header h2 {
  margin: 0; color: var(--pf-heading); font-size: 28px; font-weight: 750; line-height: 1.2;
}

/* Section cards */
.admin-pf-card-v2 .admin-pf-section {
  border-color: var(--pf-divider);
  border-radius: var(--pf-card-radius);
  padding: 24px;
  gap: 18px;
  margin-bottom: 20px;
  box-shadow: var(--pf-card-shadow);
}
.admin-pf-card-v2 .admin-pf-section-title {
  gap: 14px; font-size: 21px; font-weight: 750; color: var(--pf-heading); margin: 0; line-height: 1.3;
}
.admin-pf-card-v2 .admin-pf-section-icon { width: 46px; height: 46px; border-radius: 11px; }
.admin-pf-card-v2 .admin-pf-section-icon svg { width: 21px; height: 21px; }
.admin-pf-card-v2 .admin-pf-section-sub { font-size: 14px; color: var(--pf-muted); margin: 0; line-height: 1.5; }

/* Fields & labels */
.admin-pf-card-v2 .admin-pf-field { gap: 7px; min-width: 0; }
.admin-pf-card-v2 .admin-pf-label { font-size: 15px; font-weight: 650; color: var(--pf-label); line-height: 1.3; }
.admin-pf-card-v2 .admin-pf-req { color: var(--pf-danger); margin-left: 2px; }
.admin-pf-card-v2 .admin-pf-char-count { color: var(--pf-muted); }
.admin-pf-card-v2 .admin-pf-hint { color: var(--pf-muted); font-size: 13px; }

/* Bare text/select/textarea controls */
.admin-pf-card-v2 .admin-pf-input,
.admin-pf-card-v2 .admin-pf-textarea {
  border: 1.5px solid var(--pf-primary);
  border-radius: var(--pf-field-radius);
  background: var(--pf-field-bg);
  color: var(--pf-heading);
  font-size: 16px;
  min-height: calc(var(--pf-field-height) - 3px);
  padding: 0 18px;
  transition: border-color 160ms ease, box-shadow 160ms ease, background-color 160ms ease;
}
.admin-pf-card-v2 .admin-pf-input:hover,
.admin-pf-card-v2 .admin-pf-textarea:hover { border-color: var(--pf-primary-dark); }
.admin-pf-card-v2 .admin-pf-input:focus,
.admin-pf-card-v2 .admin-pf-textarea:focus {
  background: var(--bg-secondary);
  border-color: var(--pf-primary);
  box-shadow: 0 0 0 5px var(--pf-focus-ring);
}
.admin-pf-card-v2 .admin-pf-textarea { min-height: 98px; padding: 10px 14px; line-height: 1.5; }

/* Compact Add Product density. This is deliberately scoped to the product
   editor because Careers and other admin forms reuse the admin-pf classes. */
.admin-product-editor-compact {
  --pf-field-height: 46px;
  padding: 14px 16px 16px;
}
.admin-product-editor-compact .admin-pf-header-v2 {
  gap: 8px;
  margin-bottom: 12px;
}
.admin-product-editor-compact .admin-form-header h2 { font-size: 24px; }
.admin-product-editor-compact .admin-pf-header-actions { gap: 8px; }
.admin-product-editor-compact .admin-pf-btn-draft,
.admin-product-editor-compact .admin-pf-btn-publish {
  padding: 7px 13px;
  border-radius: 8px;
}
.admin-product-editor-compact .admin-product-form-layout {
  grid-template-columns: minmax(0, 1fr) 250px;
  gap: 14px;
}
.admin-product-editor-compact .admin-pf-section {
  padding: 16px 18px;
  gap: 12px;
  margin-bottom: 12px;
  border-radius: 13px;
}
.admin-product-editor-compact .admin-pf-section-title {
  gap: 10px;
  font-size: 18px;
}
.admin-product-editor-compact .admin-pf-section-icon {
  width: 38px;
  height: 38px;
  border-radius: 9px;
}
.admin-product-editor-compact .admin-pf-section-icon svg { width: 18px; height: 18px; }
.admin-product-editor-compact .admin-pf-field { gap: 5px; }
.admin-product-editor-compact .admin-pf-label { font-size: 13px; }
.admin-product-editor-compact .admin-pf-input,
.admin-product-editor-compact .admin-pf-icon-input,
.admin-product-editor-compact .admin-pf-tag-input,
.admin-product-editor-compact .admin-pf-price-input { font-size: 14px; }
.admin-product-editor-compact .admin-pf-icon-prefix { width: 46px; flex-basis: 46px; }
.admin-product-editor-compact .admin-pf-row-2,
.admin-product-editor-compact .admin-pf-row-3 { gap: 10px; }
.admin-product-editor-compact .admin-pf-icon-wrap--textarea,
.admin-product-editor-compact .admin-pf-icon-wrap--textarea .admin-pf-textarea { min-height: 82px; }
.admin-product-editor-compact .admin-pf-textarea { min-height: 82px; padding: 9px 12px; }
.admin-product-editor-compact .admin-preview-card,
.admin-product-editor-compact .admin-pf-publish-card,
.admin-product-editor-compact .admin-pf-tips-card { padding: 12px; }
.admin-product-editor-compact .admin-pf-sidebar { gap: 12px; }
.admin-product-editor-compact .admin-preview-img-wrap { height: 145px; }
.admin-product-editor-compact .admin-pf-section-collapsible { min-height: 56px; padding: 8px 18px; }
.admin-product-editor-compact .admin-pf-section-collapsible.admin-pf-section-open { padding: 16px 18px; }

@media (max-width: 900px) {
  .admin-product-editor-compact .admin-product-form-layout { grid-template-columns: 1fr; }
}

/* Icon-prefixed shells (Title / Description / Category / SKU / Tags / Sizes / Colours) */
.admin-pf-card-v2 .admin-pf-icon-wrap,
.admin-pf-card-v2 .admin-pf-tag-wrap {
  border: 1.5px solid var(--pf-primary);
  border-radius: var(--pf-field-radius);
  background: var(--pf-field-bg);
  min-height: var(--pf-field-height);
  transition: border-color 160ms ease, box-shadow 160ms ease, background-color 160ms ease;
}
.admin-pf-card-v2 .admin-pf-icon-wrap:hover,
.admin-pf-card-v2 .admin-pf-tag-wrap:hover { border-color: var(--pf-primary-dark); }
.admin-pf-card-v2 .admin-pf-icon-wrap:focus-within,
.admin-pf-card-v2 .admin-pf-tag-wrap:focus-within {
  background: var(--bg-secondary);
  border-color: var(--pf-primary);
  box-shadow: 0 0 0 5px var(--pf-focus-ring);
}
.admin-pf-card-v2 .admin-pf-icon-prefix {
  width: 58px; flex: 0 0 58px; justify-content: center;
  color: var(--pf-muted);
  background: transparent;
  border-right: 1px solid var(--pf-primary);
}
.admin-pf-card-v2 .admin-pf-icon-input,
.admin-pf-card-v2 .admin-pf-tag-input,
.admin-pf-card-v2 .admin-pf-tag-chips { font-size: 16px; color: var(--pf-heading); }
.admin-pf-card-v2 .admin-pf-icon-input { padding: 0 18px; }
.admin-pf-card-v2 .admin-pf-tag-chips { min-height: calc(var(--pf-field-height) - 3px); padding: 6px 14px; }

/* Icon-wrapped textarea variant (Short Description) */
.admin-pf-card-v2 .admin-pf-icon-wrap--textarea { align-items: stretch; min-height: 100px; }
.admin-pf-card-v2 .admin-pf-icon-wrap--textarea .admin-pf-icon-prefix { align-items: flex-start; padding-top: 10px; height: auto; }
.admin-pf-card-v2 .admin-pf-icon-wrap--textarea .admin-pf-textarea { border: none; border-radius: 0; background: transparent; min-height: 98px; }

/* Pricing addons (currency / percent) */
.admin-pf-card-v2 .admin-pf-price-wrap {
  border: 1.5px solid var(--pf-primary);
  border-radius: var(--pf-field-radius);
  background: var(--pf-field-bg);
  min-height: var(--pf-field-height);
  transition: border-color 160ms ease, box-shadow 160ms ease, background-color 160ms ease;
}
.admin-pf-card-v2 .admin-pf-price-wrap:hover { border-color: var(--pf-primary-dark); }
.admin-pf-card-v2 .admin-pf-price-wrap:focus-within {
  background: var(--bg-secondary); border-color: var(--pf-primary); box-shadow: 0 0 0 5px var(--pf-focus-ring);
}
.admin-pf-card-v2 .admin-pf-price-sym {
  width: 54px; flex: 0 0 54px; justify-content: center;
  color: var(--pf-text); font-size: 18px; font-weight: 600;
  background: transparent; border-right: 1px solid var(--pf-primary); line-height: normal;
}
.admin-pf-card-v2 .admin-pf-price-input { font-size: 16px; color: var(--pf-heading); padding: 0 18px; }

/* Quantity stepper */
.admin-pf-card-v2 .admin-pf-qty-ctrl {
  box-sizing: border-box;
  display: grid; grid-template-columns: 58px minmax(80px, 1fr) 58px;
  align-self: stretch; width: 100%;
  border: 1.5px solid var(--pf-primary); border-radius: var(--pf-field-radius);
  background: var(--pf-field-bg); min-height: var(--pf-field-height);
}
.admin-pf-card-v2 .admin-pf-qty-ctrl:focus-within { background: var(--bg-secondary); box-shadow: 0 0 0 5px var(--pf-focus-ring); }
.admin-pf-card-v2 .admin-pf-qty-btn {
  width: auto; height: auto; background: var(--bg-tertiary); color: var(--pf-heading);
  font-size: 21px; font-weight: 700;
}
.admin-pf-card-v2 .admin-pf-qty-btn:first-child { border-right: 1px solid var(--pf-primary); }
.admin-pf-card-v2 .admin-pf-qty-btn:last-child { border-left: 1px solid var(--pf-primary); }
.admin-pf-card-v2 .admin-pf-qty-btn:hover { color: var(--pf-primary); background: var(--pf-primary-soft); }
.admin-pf-card-v2 .admin-pf-qty-input { width: 100%; padding: 0 16px; color: var(--pf-heading); font-size: 16px; font-weight: 600; text-align: center; }

/* Stock status pill */
.admin-pf-card-v2 .admin-pf-stock-status {
  border: 1.5px solid var(--pf-primary); border-radius: var(--pf-field-radius);
  background: var(--pf-field-bg); min-height: var(--pf-field-height); height: auto; padding: 0 18px;
  color: var(--pf-heading); font-size: 16px; font-weight: 700; width: 100%;
}
.admin-pf-card-v2 .admin-pf-stock-dot { width: 11px; height: 11px; background: var(--pf-success); box-shadow: 0 0 0 4px rgba(34,199,106,0.14); }

/* Product Media dropzone -- full-width dashed blue drop area; uploaded
   thumbnails render below it (see JSX), not beside it. */
.admin-pf-card-v2 .admin-dropzone {
  border: 2px dashed var(--pf-primary);
  border-radius: 12px;
  background: var(--pf-field-bg);
  transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}
.admin-pf-card-v2 .admin-dropzone:hover,
.admin-pf-card-v2 .admin-dropzone-over {
  background: var(--pf-primary-soft); border-color: var(--pf-primary-dark); box-shadow: 0 0 0 5px var(--pf-focus-ring);
}
.admin-pf-card-v2 .admin-dropzone:active { transform: scale(0.998); }
.admin-pf-card-v2 .admin-dropzone-full {
  box-sizing: border-box;
  width: 100%; min-height: 128px; padding: 20px;
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px;
}
.admin-pf-card-v2 .admin-dropzone-full .admin-dropzone-icon { color: var(--pf-heading); font-size: 1.9rem; margin: 0; }
.admin-pf-card-v2 .admin-dropzone-full .admin-dropzone-text-compact { color: var(--pf-primary); font-size: 16px; font-weight: 750; }
.admin-pf-card-v2 .admin-dropzone-full .admin-dropzone-hint { color: var(--pf-muted); font-size: 13px; margin: 2px 0 0; }
.admin-pf-card-v2 .admin-image-grid { margin-top: 2px; }

/* Collapsed "optional" sections -- flat card-row look while collapsed,
   expands back to normal card padding when open (see advOpen state). */
.admin-pf-card-v2 .admin-pf-section-collapsible {
  padding: 12px 22px; min-height: 68px; justify-content: center;
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}
.admin-pf-card-v2 .admin-pf-section-collapsible:hover {
  border-color: var(--pf-primary);
  box-shadow: 0 0 0 4px rgba(59, 130, 246,0.09), var(--pf-card-shadow);
  transform: translateY(-1px);
}
.admin-pf-card-v2 .admin-pf-section-collapsible.admin-pf-section-open { padding: 24px; min-height: 0; }
.admin-pf-card-v2 .admin-pf-section-collapsible.admin-pf-section-open:hover {
  transform: none; box-shadow: var(--pf-card-shadow); border-color: var(--pf-divider);
}
.admin-pf-card-v2 .admin-pf-section-collapsible .admin-pf-section-icon { width: 42px; height: 42px; border-radius: 10px; }
.admin-pf-card-v2 .admin-pf-section-collapsible .admin-pf-section-title { font-size: 17px; }
.admin-pf-card-v2 .admin-pf-section-toggle { color: inherit; }
.admin-pf-card-v2 .admin-pf-section-arrow { flex-shrink: 0; color: var(--pf-muted); display: flex; }
.admin-pf-card-v2 .admin-pf-optional-tag {
  color: var(--pf-muted); background: var(--bg-tertiary); border-color: var(--pf-divider);
  font-size: 11px; padding: 2px 10px; min-height: 24px; display: inline-flex; align-items: center;
}

/* Solid-blue Save/Publish button, exact spec colour (base .admin-pf-btn-publish
   uses the site's generic --accent instead). Used on Commission & Tax too. */
.admin-pf-card-v2 .admin-pf-btn-publish { background: var(--pf-primary); border-color: var(--pf-primary); }
.admin-pf-card-v2 .admin-pf-btn-publish:disabled,
.admin-pf-card-v2 .admin-pf-btn-draft:disabled { opacity: 0.5; cursor: not-allowed; }

/* Highlighted "current value" panel -- Commission & Tax's rate/currency cards */
.admin-pf-card-v2 .admin-pf-rate-panel {
  display: flex; align-items: center; justify-content: space-between; gap: 12px;
  background: var(--pf-primary-soft); border-radius: var(--pf-field-radius);
  padding: 16px 18px;
}
.admin-pf-card-v2 .admin-pf-rate-panel-label { font-size: 14px; color: var(--pf-text); }
.admin-pf-card-v2 .admin-pf-rate-panel-value { font-size: 24px; font-weight: 800; color: var(--pf-primary); }
.admin-pf-card-v2 .admin-pf-rate-panel-sub { font-size: 12px; color: var(--pf-muted); margin-top: 8px; text-align: right; }

/* Bordered input + Save button side by side */
.admin-pf-card-v2 .admin-pf-input-row { display: flex; gap: 10px; align-items: stretch; }
.admin-pf-card-v2 .admin-pf-input-row .admin-pf-price-wrap,
.admin-pf-card-v2 .admin-pf-input-row .admin-pf-icon-wrap { flex: 1 1; }
.admin-pf-card-v2 .admin-pf-input-row .admin-pf-btn-publish,
.admin-pf-card-v2 .admin-pf-input-row .admin-pf-btn-draft { flex-shrink: 0; padding-left: 22px; padding-right: 22px; }

/* Two cards side by side (Marketplace Commission / Sales Tax) */
.admin-ct-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; align-items: start; margin-bottom: 20px; }
@media (max-width: 900px) { .admin-ct-grid { grid-template-columns: 1fr; } }
.admin-ct-grid .admin-pf-section { margin-bottom: 0; }

/* Careers page -- plain (non-icon) card titles + a small count badge, since
   the supplied reference doesn't use the icon-box header pattern here. */
.admin-pf-card-v2 .admin-pf-section-title--plain { font-size: 19px; margin: 0; }
.admin-pf-card-v2 .admin-pf-count-badge {
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 22px; height: 22px; padding: 0 7px; border-radius: 999px;
  background: var(--pf-primary-soft); color: var(--pf-primary); font-size: 12px; font-weight: 800;
}

/* Careers stat tiles -- rounded-square icon badges + bigger bold values,
   consistent with the Overview page's own KPI tiles. */
.admin-pf-card-v2 .admin-careers-stat-tile { border-color: var(--pf-divider); border-radius: var(--pf-field-radius); padding: 18px; box-sizing: border-box; }
.admin-pf-card-v2 .admin-careers-stat-icon { width: 44px; height: 44px; border-radius: 12px; }
.admin-pf-card-v2 .admin-careers-stat-value { font-size: 30px; color: var(--pf-heading); }
.admin-pf-card-v2 .admin-careers-stat-label { color: var(--pf-text); font-size: 13px; }
.admin-pf-card-v2 .admin-careers-stat-trend { font-size: 12px; }

/* Open Positions table + General Applications row, restyled to sit inside
   a .admin-pf-section card instead of standing alone. */
.admin-pf-card-v2 .admin-products-table { border-color: var(--pf-divider); box-shadow: none; margin-bottom: 0; }
.admin-pf-card-v2 .admin-table-header { background: var(--pf-field-bg); color: var(--pf-muted); }
.admin-pf-card-v2 .admin-product-row:hover { background: var(--pf-primary-soft); }
.admin-pf-card-v2 .admin-pf-list-row {
  box-sizing: border-box;
  display: flex; align-items: center; justify-content: space-between; gap: 10px;
  width: 100%; text-align: left; cursor: pointer;
  border: 1px solid var(--pf-divider); border-radius: var(--pf-field-radius);
  padding: 14px 16px; background: var(--pf-field-bg);
  transition: border-color 160ms ease, box-shadow 160ms ease;
}
.admin-pf-card-v2 .admin-pf-list-row:hover { border-color: var(--pf-primary); box-shadow: 0 0 0 3px var(--pf-focus-ring); }

/* Rich text editor (Job Description) -- same blue-bordered field shell as
   every other input on this page. */
.admin-pf-card-v2 .admin-rte {
  border: 1.5px solid var(--pf-primary); border-radius: var(--pf-field-radius);
  background: var(--pf-field-bg);
  transition: border-color 160ms ease, box-shadow 160ms ease, background-color 160ms ease;
}
.admin-pf-card-v2 .admin-rte:hover { border-color: var(--pf-primary-dark); }
.admin-pf-card-v2 .admin-rte:focus-within {
  background: var(--bg-secondary); border-color: var(--pf-primary); box-shadow: 0 0 0 5px var(--pf-focus-ring);
}
.admin-pf-card-v2 .admin-rte-toolbar { background: transparent; border-bottom-color: var(--pf-divider); padding: 8px 10px; }
.admin-pf-card-v2 .admin-rte-toolbar button { color: var(--pf-muted); }
.admin-pf-card-v2 .admin-rte-toolbar button:hover { background: var(--pf-primary-soft); color: var(--pf-primary); }
.admin-pf-card-v2 .admin-rte-body { font-size: 16px; color: var(--pf-heading); padding: 14px 18px; min-height: 110px; }
.admin-pf-card-v2 .admin-rte-body:empty::before { color: var(--pf-muted); }

@media (max-width: 900px) {
  .admin-pf-card-v2 .admin-careers-stats { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 640px) {
  .admin-pf-card-v2 .admin-pf-input-row { flex-direction: column; }
  .admin-pf-card-v2 .admin-form-header h2 { font-size: 23px; }
  .admin-pf-card-v2 .admin-pf-section { padding: 17px 14px; border-radius: 13px; }
  .admin-pf-card-v2 .admin-pf-section-title { font-size: 18px; gap: 11px; }
  .admin-pf-card-v2 .admin-pf-section-icon { width: 40px; height: 40px; }
  .admin-pf-card-v2 .admin-pf-icon-prefix,
  .admin-pf-card-v2 .admin-pf-price-sym { width: 48px; flex-basis: 48px; }
  .admin-pf-card-v2 .admin-pf-section-collapsible { padding: 10px 14px; min-height: 64px; }
  .admin-pf-card-v2 .admin-pf-section-collapsible.admin-pf-section-open { padding: 17px 14px; }
  .admin-pf-card-v2 .admin-pf-section-collapsible .admin-pf-section-title { font-size: 15px; }
}

/* ══════════════════════════════════════════════════════════════════
   Order Tracking page
   ══════════════════════════════════════════════════════════════════ */
.ot-page {
  --ot-gold: var(--color-primary);
  min-height: 100vh; background: var(--bg-secondary); padding-bottom: 48px;
}

.ot-header-title h1, .ot-card-title, .ot-help-title, .ot-notfound h2 {
  font-family: Georgia, 'Times New Roman', Times, serif;
}

.ot-header {
  display: flex; align-items: center; gap: 16px; flex-wrap: wrap;
  padding: 20px 28px; background: var(--bg-primary); border-bottom: 1px solid var(--border);
}
.ot-back-btn {
  width: 44px; height: 44px; border-radius: 12px; flex-shrink: 0;
  border: 1px solid color-mix(in srgb, var(--ot-gold) 45%, var(--border));
  background: var(--bg-primary);
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; color: var(--text-primary); transition: background 150ms;
}
.ot-back-btn:hover { background: var(--bg-secondary); }
.ot-header-title { flex: 1 1; min-width: 200px; }
.ot-header-title h1 { margin: 0; font-size: 1.7rem; font-weight: 700; color: var(--text-primary); letter-spacing: -0.01em; }
.ot-header-meta { display: flex; align-items: center; gap: 10px; margin-top: 8px; flex-wrap: wrap; }
.ot-id { font-size: 0.85rem; color: var(--text-secondary); font-family: monospace; }

.ot-placed-pill {
  display: inline-flex; align-items: center; gap: 6px;
  font-size: 0.75rem; font-weight: 600; color: var(--text-secondary);
  background: var(--bg-secondary); border: 1px solid var(--border);
  padding: 4px 12px; border-radius: 20px;
}

.ot-schedule-pill {
  display: inline-flex; align-items: center; gap: 6px;
  font-size: 0.75rem; font-weight: 700; padding: 4px 12px; border-radius: 20px;
  background: color-mix(in srgb, var(--success) 12%, transparent); color: var(--success);
}
.ot-schedule-pill::before { content: '●'; font-size: 0.6em; }

.ot-header-actions { display: flex; align-items: center; gap: 10px; }
.ot-invoice-btn {
  display: flex; align-items: center; gap: 7px;
  padding: 11px 18px; border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--accent) 45%, var(--border));
  background: var(--bg-primary); color: var(--accent); font-weight: 700; font-size: 0.86rem;
  cursor: pointer; white-space: nowrap; transition: background 150ms;
}
.ot-invoice-btn:hover { background: color-mix(in srgb, var(--accent) 8%, transparent); }
.ot-kebab-wrap { position: relative; }
.ot-kebab-btn {
  width: 42px; height: 42px; border-radius: 12px; border: 1px solid var(--border);
  background: var(--bg-primary); cursor: pointer; color: var(--text-primary); font-size: 1.2rem;
}
.ot-kebab-menu {
  position: absolute; right: 0; top: 48px; z-index: 20; overflow: hidden;
  background: var(--bg-primary); border: 1px solid var(--border); border-radius: 12px;
  box-shadow: 0 8px 24px rgba(1, 13, 33,0.18); min-width: 170px;
  display: flex; flex-direction: column;
}
.ot-kebab-menu button, .ot-kebab-menu a {
  display: block; text-align: left; padding: 10px 14px; background: none; border: none;
  color: var(--text-primary); font-size: 0.85rem; cursor: pointer; text-decoration: none;
}
.ot-kebab-menu button:hover, .ot-kebab-menu a:hover { background: var(--bg-secondary); }

.ot-body { max-width: 1140px; margin: 0 auto; padding: 28px 24px; }

.ot-card { background: var(--bg-primary); border: 1px solid var(--border); border-radius: 18px; padding: 26px; box-shadow: 0 4px 20px rgba(1, 13, 33,0.06); }

.ot-search-card { max-width: 520px; margin: 0 auto; }
.ot-search-title { margin: 0 0 4px; font-weight: 700; font-size: 1rem; color: var(--text-primary); }
.ot-search-hint { margin: 0 0 16px; font-size: 0.85rem; color: var(--text-secondary); }
.ot-search-row { display: flex; gap: 10px; flex-wrap: wrap; }
.ot-search-input {
  flex: 1 1 220px; padding: 11px 14px; border-radius: 10px; border: 1px solid var(--border);
  background: var(--bg-secondary); color: var(--text-primary); font-size: 0.92rem;
}
.ot-search-input.err { border-color: var(--danger); }
.ot-search-btn { padding: 11px 22px; border-radius: 10px; border: none; cursor: pointer; background: var(--accent); color: var(--color-text-on-secondary); font-weight: 700; font-size: 0.9rem; }
.ot-search-err { margin: 10px 0 0; font-size: 0.82rem; color: var(--danger); }

.ot-loading { text-align: center; padding: 48px; color: var(--text-secondary); }
.ot-loading-icon { font-size: 36px; margin-bottom: 10px; }

.ot-notfound { text-align: center; padding: 40px; max-width: 480px; margin: 0 auto; }
.ot-notfound-icon { font-size: 48px; margin-bottom: 12px; }
.ot-notfound h2 { color: var(--text-primary); margin: 0 0 8px; }
.ot-notfound p { color: var(--text-secondary); margin: 0; }

.ot-grid { display: grid; grid-template-columns: 1.6fr 1fr; gap: 22px; align-items: start; margin-bottom: 22px; }
@media (max-width: 860px) { .ot-grid { grid-template-columns: 1fr; } }

.ot-card-title {
  margin: 0 0 4px; font-size: 1.2rem; font-weight: 700; color: var(--text-primary);
  border-left: 4px solid var(--ot-gold); padding-left: 12px;
}
.ot-card-sub { margin: 0 0 22px; font-size: 0.85rem; color: var(--text-secondary); padding-left: 16px; }

.ot-return-banner {
  display: flex; align-items: flex-start; gap: 10px;
  background: color-mix(in srgb, var(--accent-secondary) 8%, transparent); border: 1px solid color-mix(in srgb, var(--accent-secondary) 25%, transparent); color: var(--accent-secondary);
  border-radius: 8px; padding: 10px 14px; margin: 0 0 18px;
}
[data-theme="dark"] .ot-return-banner { background: color-mix(in srgb, var(--accent-secondary) 14%, transparent); }
.ot-return-banner-icon { flex-shrink: 0; margin-top: 1px; }
.ot-return-banner-title { margin: 0; font-size: 0.85rem; font-weight: 700; }
.ot-return-banner-sub { margin: 2px 0 0; font-size: 0.78rem; color: var(--text-secondary); }

.ot-cancelled { text-align: center; padding: 24px 0; color: var(--danger); }
.ot-cancelled span { font-size: 36px; }
.ot-cancelled p { margin: 8px 0 0; font-weight: 700; }
.ot-cancelled.ot-refunded { color: var(--accent-secondary); }
.ot-cancelled.ot-exchanged { color: var(--accent-secondary); }

.ot-live-map-wrap { margin-top: 20px; padding-top: 18px; border-top: 1px solid var(--border); }
.ot-live-map-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }
.ot-live-map-title { display: flex; align-items: center; gap: 6px; font-weight: 700; font-size: 0.85rem; color: var(--text-primary); }
.ot-live-map-freshness { font-size: 0.72rem; font-weight: 600; color: var(--success); }
.ot-live-map-freshness.stale { color: var(--text-muted); }
.ot-live-map-wrap .leaflet-container { z-index: 0; }

/* Cash-on-delivery "have this ready for the courier" callout. Calm blue while
   the order is still being prepared, escalating to a stronger amber once it's
   actually out for delivery and the cash is imminently needed. */
.ot-cash-due {
  display: flex; align-items: center; gap: 14px;
  margin-top: 20px; padding: 14px 16px;
  border-radius: 12px;
  background: rgba(59, 130, 246, 0.08);
  border: 1px solid rgba(59, 130, 246, 0.22);
}
.ot-cash-due-active {
  background: rgba(255, 103, 0, 0.12);
  border-color: rgba(255, 103, 0, 0.4);
}
.ot-cash-due-icon {
  display: flex; align-items: center; justify-content: center;
  width: 40px; height: 40px; border-radius: 50%; flex-shrink: 0;
  background: rgba(59, 130, 246, 0.15); color: var(--color-secondary-hover);
}
.ot-cash-due-active .ot-cash-due-icon { background: rgba(255, 103, 0, 0.2); color: var(--color-primary); }
.ot-cash-due-label { margin: 0; font-size: 0.82rem; font-weight: 600; color: var(--text-secondary); }
.ot-cash-due-amount { margin: 2px 0 0; font-size: 1.35rem; font-weight: 800; color: var(--text-primary); }

.ot-timeline { display: flex; flex-direction: column; }
.ot-tl-row { display: flex; gap: 16px; }
.ot-tl-icon-col { display: flex; flex-direction: column; align-items: center; flex-shrink: 0; }
.ot-tl-icon {
  width: 46px; height: 46px; border-radius: 50%; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center; font-size: 1.2rem;
  background: var(--bg-primary); border: 2px solid var(--border); color: var(--text-secondary);
  transition: all 200ms;
}
.ot-tl-active .ot-tl-icon {
  background: var(--accent); border-color: var(--accent);
  box-shadow: 0 0 0 5px color-mix(in srgb, var(--accent) 18%, transparent);
}
/* Delivered gets its own solid green fill once reached, rather than the shared accent color */
.ot-tl-step-delivered.ot-tl-done .ot-tl-icon,
.ot-tl-step-delivered.ot-tl-active .ot-tl-icon { background: var(--success); border-color: var(--success); box-shadow: 0 0 0 5px color-mix(in srgb, var(--success) 18%, transparent); }
.ot-tl-step-processing .ot-tl-icon       { color: var(--accent-secondary); }
.ot-tl-step-shipped .ot-tl-icon          { color: var(--color-primary); }
.ot-tl-step-out_for_delivery .ot-tl-icon { color: var(--color-secondary); }
.ot-tl-step-delivered .ot-tl-icon        { color: var(--success); }
.ot-tl-active .ot-tl-icon, .ot-tl-step-delivered.ot-tl-done .ot-tl-icon { color: var(--color-brand-white); }

.ot-tl-line { width: 0; flex: 1 1; min-height: 26px; margin: 2px 0; border-left: 2px dashed var(--border); }
.ot-tl-done .ot-tl-line { border-left-style: solid; border-left-color: var(--accent); }

.ot-tl-body { flex: 1 1; padding: 4px 0 26px; position: relative; }
.ot-tl-row:last-child .ot-tl-body { padding-bottom: 0; }
.ot-tl-highlight {
  background: color-mix(in srgb, var(--accent) 7%, transparent);
  border: 1px solid color-mix(in srgb, var(--accent) 16%, transparent);
  border-radius: 14px; padding: 14px 46px 14px 16px;
  margin: -10px 0 16px -16px; width: calc(100% + 16px); box-sizing: border-box;
}
.ot-tl-check-badge {
  position: absolute; top: 50%; right: 16px; transform: translateY(-50%);
  width: 28px; height: 28px; border-radius: 50%;
  background: color-mix(in srgb, var(--accent) 22%, transparent); color: var(--accent);
  display: flex; align-items: center; justify-content: center;
}
.ot-tl-head { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.ot-tl-label { font-weight: 700; font-size: 1rem; color: var(--text-primary); }
.ot-tl-pill { font-size: 0.7rem; font-weight: 700; padding: 3px 10px; border-radius: 20px; }
.ot-tl-pill-completed, .ot-tl-pill-in-progress { background: color-mix(in srgb, var(--accent) 16%, transparent); color: var(--accent); }
.ot-tl-pill-pending { background: var(--bg-tertiary); color: var(--text-secondary); }
.ot-tl-desc { margin: 5px 0 0; font-size: 0.85rem; color: var(--text-secondary); }

.ot-summary-box { border: 1px solid var(--border); border-radius: 14px; padding: 16px; margin-bottom: 18px; }
.ot-summary-box-head { display: flex; align-items: center; justify-content: space-between; font-size: 0.88rem; font-weight: 700; color: var(--text-primary); }
.ot-summary-box-head button { background: none; border: none; color: var(--accent); font-weight: 700; font-size: 0.82rem; cursor: pointer; padding: 4px; }
.ot-summary-item { display: flex; align-items: center; gap: 12px; padding: 12px 0; border-top: 1px solid var(--border); }
.ot-summary-item img { width: 56px; height: 56px; object-fit: cover; border-radius: 10px; flex-shrink: 0; background: var(--bg-secondary); }
.ot-summary-item-info { flex: 1 1; min-width: 0; }
.ot-summary-item-name { margin: 0; font-size: 0.92rem; font-weight: 700; color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.ot-summary-item-meta { margin: 3px 0 0; font-size: 0.8rem; color: var(--text-secondary); }
.ot-summary-item-qty { font-size: 0.85rem; color: var(--text-secondary); flex-shrink: 0; }

.ot-totals { display: flex; flex-direction: column; gap: 10px; padding-bottom: 18px; margin-bottom: 18px; border-bottom: 1px solid var(--border); }
.ot-total-row { display: flex; justify-content: space-between; font-size: 0.9rem; color: var(--text-secondary); }
.ot-discount-row { color: var(--color-primary); }
.ot-grand-row { font-size: 1.15rem; font-weight: 800; color: var(--text-primary); padding-top: 10px; border-top: 1px solid var(--border); }

.ot-secure-banner {
  position: relative; overflow: hidden;
  display: flex; gap: 12px; align-items: flex-start;
  background: color-mix(in srgb, var(--accent) 7%, transparent);
  border: 1px solid color-mix(in srgb, var(--accent) 14%, transparent);
  border-radius: 14px; padding: 14px 44px 14px 14px;
}
.ot-secure-icon {
  width: 36px; height: 36px; border-radius: 50%; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center; font-size: 1.05rem;
  background: color-mix(in srgb, var(--accent) 16%, transparent);
}
.ot-secure-title { margin: 0; font-size: 0.88rem; font-weight: 700; color: var(--text-primary); }
.ot-secure-sub { margin: 3px 0 0; font-size: 0.78rem; color: var(--text-secondary); }
.ot-secure-lock {
  position: absolute; right: 14px; top: 50%; transform: translateY(-50%);
  color: var(--text-secondary); opacity: 0.55;
}

.ot-seller-card { margin-bottom: 18px; }
.ot-seller-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
.ot-seller-name { margin: 0; font-weight: 700; font-size: 0.9rem; color: var(--text-primary); }
.ot-seller-status { font-size: 0.72rem; font-weight: 700; padding: 3px 10px; border-radius: 20px; background: var(--bg-tertiary); color: var(--text-secondary); text-transform: capitalize; }
.ot-seller-status-delivered { background: var(--color-secondary-soft); color: var(--success); }
.ot-seller-status-cancelled { background: var(--color-primary-soft); color: var(--color-primary); }
.ot-tracking-num { background: var(--bg-secondary); border-radius: 8px; padding: 8px 12px; margin-bottom: 12px; font-size: 0.85rem; }
.ot-tracking-num strong { font-family: monospace; color: var(--text-primary); }
.ot-seller-item { display: flex; align-items: center; gap: 10px; margin-bottom: 8px; }
.ot-seller-item img { width: 40px; height: 40px; object-fit: cover; border-radius: 8px; flex-shrink: 0; }
.ot-seller-item p { margin: 0; font-size: 0.88rem; color: var(--text-primary); }
.ot-seller-item p span { color: var(--text-secondary); }
.ot-status-history { margin-top: 12px; }
.ot-status-history summary { font-size: 0.8rem; color: var(--text-secondary); cursor: pointer; }
.ot-status-history > div { margin-top: 8px; padding-left: 8px; border-left: 2px solid var(--border); margin-left: 4px; }
.ot-history-row { margin-bottom: 8px; }
.ot-history-status { margin: 0; font-size: 0.82rem; font-weight: 600; color: var(--text-primary); text-transform: capitalize; }
.ot-history-note, .ot-history-time { margin: 0; font-size: 0.76rem; color: var(--text-secondary); }

.ot-help-banner {
  position: relative; overflow: hidden;
  display: flex; align-items: center; gap: 16px; flex-wrap: wrap; margin-bottom: 18px;
  background: linear-gradient(135deg, color-mix(in srgb, var(--ot-gold) 6%, var(--bg-primary)) 0%, var(--bg-primary) 65%);
}
.ot-help-icon {
  width: 46px; height: 46px; border-radius: 50%; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center; font-size: 1.3rem;
  background: color-mix(in srgb, var(--ot-gold) 12%, transparent);
  border: 1px solid color-mix(in srgb, var(--ot-gold) 45%, transparent);
}
.ot-help-text { flex: 1 1; min-width: 200px; }
.ot-help-title { margin: 0; font-weight: 700; font-size: 1.05rem; color: var(--text-primary); }
.ot-help-sub { margin: 3px 0 0; font-size: 0.85rem; color: var(--text-secondary); }
.ot-contact-btn {
  display: inline-flex; align-items: center; gap: 8px; padding: 12px 22px; border-radius: 12px;
  border: none; background: var(--accent); color: var(--color-text-on-secondary); font-weight: 700; font-size: 0.9rem;
  text-decoration: none; white-space: nowrap; transition: filter 150ms;
}
.ot-contact-btn:hover { filter: brightness(1.08); }

.ot-another-btn { display: block; margin: 0 auto; background: none; border: none; color: var(--accent); font-weight: 600; font-size: 0.88rem; cursor: pointer; padding: 8px; }

/* ── Unified motion tokens + UX polish (non-functional) ───────── */
:root {
  --motion-fast: 140ms;
  --motion-normal: 210ms;
  --motion-page: 260ms;
  --motion-drawer: 280ms;
  --motion-ease-enter: cubic-bezier(0.22, 1, 0.36, 1);
  --motion-ease-exit: cubic-bezier(0.4, 0, 1, 1);
}

.page-fade-in {
  animation: routeFadeUp var(--motion-page) var(--motion-ease-enter);
}

@keyframes routeFadeUp {
  from {
    opacity: 0;
    transform: translate3d(0, 8px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.shop-hdr-title,
.active-filters-label {
  transition: color var(--motion-fast) ease, opacity var(--motion-fast) ease;
}

.pcard-grid.list-transitioning .pcard,
.pcard-grid.list-transitioning .pcard-skeleton {
  animation: listItemIn var(--motion-normal) var(--motion-ease-enter) both;
}

.pcard-grid.list-transitioning .pcard:nth-child(2n),
.pcard-grid.list-transitioning .pcard-skeleton:nth-child(2n) {
  animation-delay: 30ms;
}

.pcard-grid.list-transitioning .pcard:nth-child(3n),
.pcard-grid.list-transitioning .pcard-skeleton:nth-child(3n) {
  animation-delay: 50ms;
}

@keyframes listItemIn {
  from {
    opacity: 0;
    transform: translate3d(0, 6px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.loading.loading-inline {
  min-height: 120px;
  font-size: 0.92rem;
}

body.overlay-open {
  overflow: hidden;
  touch-action: none;
}

.modal-overlay,
.bn-cat-sheet-overlay,
.mas-backdrop {
  animation: overlayFade var(--motion-normal) var(--motion-ease-enter);
}

.modal-content {
  animation: dialogIn var(--motion-drawer) var(--motion-ease-enter);
}

.bn-cat-sheet,
.mas-sheet {
  animation: sheetIn var(--motion-drawer) var(--motion-ease-enter);
}

@keyframes overlayFade {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes dialogIn {
  from {
    opacity: 0;
    transform: translate3d(0, 8px, 0) scale(0.99);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
  }
}

@keyframes sheetIn {
  from {
    opacity: 0;
    transform: translate3d(0, 14px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.pcard-heart:disabled {
  opacity: 0.55;
  cursor: wait;
  transform: none;
}

.btn-place-order[aria-busy='true'] {
  opacity: 0.78;
  cursor: wait;
}

.toast {
  transition: transform var(--motion-fast) ease, opacity var(--motion-fast) ease;
}

.toast-warning {
  background: var(--color-primary-soft);
  color: var(--color-primary);
  border: 1px solid var(--color-primary);
}

.toast-warning .toast-icon {
  background: var(--color-primary);
  color: var(--color-text-on-primary);
}

.toast-undo {
  border: none;
  background: transparent;
  color: currentColor;
  font-weight: 700;
  font-size: 0.85em;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
  padding: 2px 4px;
  flex-shrink: 0;
  white-space: nowrap;
}
.toast-undo:hover,
.toast-undo:focus-visible { opacity: 0.8; }

.toast-dismiss {
  margin-left: auto;
  border: none;
  background: transparent;
  color: currentColor;
  opacity: 0.72;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 6px;
}

.toast-dismiss:hover,
.toast-dismiss:focus-visible {
  opacity: 1;
  background: color-mix(in srgb, currentColor 12%, transparent);
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 1ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 1ms !important;
    scroll-behavior: auto !important;
  }

  .page-fade-in,
  .pcard-grid.list-transitioning .pcard,
  .pcard-grid.list-transitioning .pcard-skeleton,
  .modal-content,
  .bn-cat-sheet,
  .mas-sheet {
    animation: none !important;
  }
}

/* ═══════════════════════════════════════════════════════════════
   DELIVERY CONFIRMATION PORTAL  (.dc-*)
   Public, no-login page for the delivery agent -- see DeliveryConfirmPage.js
   ═══════════════════════════════════════════════════════════════ */
.dc-page {
  min-height: 100vh;
  /* 100dvh tracks the real, keyboard-adjusted visible viewport on mobile --
     plain 100vh stays fixed to the pre-keyboard height, which is what made
     this centered layout visibly jump/resize when the delivery key field
     was focused and the on-screen keyboard opened. */
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  overflow-y: auto;
  background: var(--bg-primary);
}
.dc-card {
  position: relative;
  box-sizing: border-box;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: 24px;
  padding: 40px;
  width: 100%;
  max-width: 440px;
  box-shadow: var(--shadow-panel);
}
.dc-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  margin-bottom: 20px;
}
.dc-back-btn:hover { color: var(--text-primary); }
.dc-icon-wrap {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: color-mix(in srgb, var(--accent-secondary) 12%, transparent);
  color: var(--accent-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
}
.dc-title { margin: 0 0 8px; font-size: 1.35rem; text-align: center; color: var(--text-primary); }
.dc-sub { margin: 0 0 24px; font-size: 0.85rem; color: var(--text-secondary); text-align: center; line-height: 1.5; }

.dc-form { display: flex; flex-direction: column; gap: 14px; }
.dc-field { display: flex; flex-direction: column; gap: 6px; }
.dc-field label { font-size: 0.8rem; font-weight: 600; color: var(--text-secondary); }
.dc-field input,
.dc-field textarea {
  box-sizing: border-box;
  width: 100%;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 12px 14px;
  font-size: 0.95rem;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-family: inherit;
  resize: none;
}
.dc-field input:focus,
.dc-field textarea:focus {
  border-color: var(--accent);
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.dc-result-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 16px 18px;
  margin-bottom: 18px;
  text-align: left;
}
.dc-result-row { display: flex; justify-content: space-between; gap: 12px; padding: 6px 0; font-size: 0.88rem; border-bottom: 1px solid var(--border); }
.dc-result-row:last-child { border-bottom: none; }
.dc-result-label { color: var(--text-secondary); }
.dc-result-value { color: var(--text-primary); font-weight: 600; text-align: right; }
.dc-result-items { margin: 4px 0 0; padding: 0; list-style: none; font-size: 0.85rem; color: var(--text-primary); }
.dc-result-items li { display: flex; justify-content: space-between; padding: 4px 0; }

.dc-mode-toggle {
  display: flex;
  gap: 6px;
  background: var(--bg-secondary);
  border-radius: var(--radius-lg);
  padding: 4px;
  margin-bottom: 16px;
}
.dc-mode-btn {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 9px 10px;
  border: none;
  border-radius: calc(var(--radius-lg) - 4px);
  background: transparent;
  color: var(--text-secondary);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 120ms ease, color 120ms ease;
}
.dc-mode-btn.active { background: var(--bg-primary); color: var(--text-primary); box-shadow: 0 1px 4px rgba(1, 13, 33,0.08); }

.dc-qr-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: var(--radius-lg);
  overflow: hidden;
  /* Letterboxing behind the live camera feed -- navy rather than pure black,
     so the scanner frame still reads as part of the app. */
  background: var(--color-brand-navy);
}
.dc-qr-video { width: 100%; height: 100%; object-fit: cover; display: block; }

.dc-logout-link {
  background: none; border: none; color: var(--text-secondary); font-size: 0.8rem;
  text-decoration: underline; cursor: pointer; margin-top: 14px; display: block; text-align: center; width: 100%;
}
.dc-access-denied { text-align: center; padding: 12px 0; color: var(--text-secondary); font-size: 0.88rem; }

.dc-error {
  background: color-mix(in srgb, var(--danger) 10%, transparent);
  color: var(--danger);
  border: 1px solid color-mix(in srgb, var(--danger) 30%, transparent);
  border-radius: var(--radius-sm);
  padding: 10px 14px;
  font-size: 0.85rem;
}

.dc-submit-btn {
  padding: 13px 20px;
  border-radius: var(--radius-lg);
  border: none;
  /* Confirming a delivery is the page's primary action -> orange. */
  background: var(--color-primary);
  color: var(--color-text-on-primary);
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 120ms ease, box-shadow 120ms ease, opacity 120ms ease;
}
.dc-submit-btn:hover { box-shadow: 0 6px 20px color-mix(in srgb, var(--accent-secondary) 35%, transparent); }
.dc-submit-btn:disabled { opacity: 0.6; cursor: not-allowed; }

/* Active Deliveries list. Previously built from inline styles on the elements
   themselves, which left no way to express the one rule the layout actually
   needs: a flex child defaults to min-width:auto and so refuses to shrink below
   its content, which pushed the order/total line onto a second row next to a
   nowrap button. min-width:0 on the text column is what lets it wrap the long
   address instead of forcing the row wider than the card. */
.dc-active-list { display: flex; flex-direction: column; gap: 10px; }
.dc-active-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 12px 14px;
}
.dc-active-info { min-width: 0; }
.dc-active-name { margin: 0 0 3px; font-weight: 700; font-size: 0.9rem; }
.dc-active-address { margin: 0; font-size: 0.8rem; color: var(--text-secondary); }
/* The order number and total read as one unit, so keep them off a line break
   even when the address above them wraps. */
.dc-active-meta { margin: 3px 0 0; font-size: 0.78rem; color: var(--text-muted); white-space: nowrap; }

/* Row-level action inside the Active Deliveries list, rather than the page's
   primary action -- so it sits at button size instead of filling the width.
   flex-shrink:0 keeps the label from being squeezed into a wrap by a long
   customer address. */
.dc-share-btn {
  flex-shrink: 0;
  width: auto;
  padding: 8px 14px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

/* Stop is the one state that reverses something already running, so it has to
   read differently from Share/Resume at a glance. It previously set an inline
   background of --color-brand-orange, which is the same value .dc-submit-btn
   already paints -- the two states rendered identically and only the label and
   icon distinguished them. Blue is the sanctioned secondary-interaction hue;
   the IconX and the "Stop" label still carry the meaning on their own, since
   with four hues colour can never be the only signal. */
.dc-stop-btn {
  background: var(--color-secondary);
  color: var(--color-text-on-secondary);
}
.dc-stop-btn:hover { box-shadow: 0 6px 20px color-mix(in srgb, var(--color-secondary) 35%, transparent); }

.dc-success { text-align: center; padding: 12px 0; }
.dc-success-icon { color: var(--success); display: inline-flex; margin-bottom: 10px; }
.dc-success-title { margin: 0 0 6px; font-size: 1.1rem; font-weight: 700; color: var(--text-primary); }
.dc-success-sub { margin: 0 0 20px; font-size: 0.85rem; color: var(--text-secondary); }

@media (max-width: 480px) {
  .dc-card { padding: 28px 20px; }
}

/* ── Product comparison bar + modal ────────────────────────────────── */
.compare-bar {
  position: fixed;
  left: 50%;
  bottom: 16px;
  transform: translateX(-50%);
  z-index: 1500;
  display: flex;
  align-items: center;
  gap: 14px;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  box-shadow: 0 10px 30px rgba(1, 13, 33,0.2);
  padding: 10px 16px;
  max-width: calc(100vw - 24px);
}
.compare-bar-thumbs { display: flex; gap: 6px; }
.compare-bar-thumb { position: relative; width: 40px; height: 40px; border-radius: 8px; overflow: hidden; flex-shrink: 0; }
.compare-bar-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
.compare-bar-thumb button {
  position: absolute; top: -4px; right: -4px; width: 16px; height: 16px; border-radius: 50%;
  background: var(--danger); color: var(--color-text-on-primary); border: none; display: flex; align-items: center; justify-content: center; cursor: pointer;
}
.compare-bar-title { font-size: 0.85rem; font-weight: 600; color: var(--text-primary); white-space: nowrap; }
.compare-bar-actions { display: flex; gap: 8px; align-items: center; }
.compare-bar-clear {
  background: none; border: none; color: var(--text-secondary); font-size: 0.8rem; cursor: pointer; padding: 8px 4px; white-space: nowrap;
}
.compare-bar-btn { padding: 8px 16px; font-size: 0.85rem; white-space: nowrap; }

.compare-modal-overlay {
  position: fixed; inset: 0; background: rgba(1, 13, 33,0.75); display: flex; align-items: center; justify-content: center;
  z-index: 2000; padding: 20px;
}
.compare-modal {
  background: var(--bg-secondary); border-radius: var(--radius-xl); width: 100%; max-width: 900px; max-height: 85vh;
  display: flex; flex-direction: column; overflow: hidden;
}
.compare-modal-header {
  display: flex; align-items: center; justify-content: space-between; padding: 18px 22px; border-bottom: 1px solid var(--border);
}
.compare-modal-header h2 { margin: 0; font-size: 1.1rem; color: var(--text-primary); }
.compare-modal-close {
  background: none; border: none; color: var(--text-secondary); cursor: pointer; width: 32px; height: 32px;
  display: flex; align-items: center; justify-content: center; border-radius: 50%;
}
.compare-modal-close:hover { background: var(--bg-tertiary); }
.compare-modal-table-wrap { overflow: auto; padding: 18px 22px; }
.compare-modal-table { border-collapse: collapse; width: 100%; }
.compare-modal-table th {
  text-align: left; padding: 10px 14px; font-size: 0.8rem; color: var(--text-secondary); white-space: nowrap; vertical-align: top;
}
.compare-modal-table td {
  padding: 10px 14px; font-size: 0.85rem; color: var(--text-primary); border-top: 1px solid var(--border); min-width: 160px; text-align: center;
}
.compare-modal-table td img, .compare-modal-table td picture { width: 80px; height: 80px; object-fit: cover; border-radius: 8px; margin: 0 auto; display: block; }
.compare-modal-link {
  background: none; border: none; color: var(--accent, var(--accent-secondary)); cursor: pointer; font-weight: 600; font-size: 0.85rem; text-align: center; padding: 0;
}
.compare-modal-row-actions { display: flex; flex-direction: column; gap: 6px; align-items: center; }
.compare-modal-remove { background: none; border: none; color: var(--danger); cursor: pointer; font-size: 0.78rem; }
/* Selected state -> blue, per the selection/interaction role. */
.pcard-quick-btn.active { background: var(--color-secondary); color: var(--color-text-on-secondary); }

@media (max-width: 480px) {
  .compare-bar { flex-wrap: wrap; justify-content: center; }
  .compare-bar-title { width: 100%; text-align: center; }
}

/* ── Support chat widget ──────────────────────────────────── */
.chat-widget-wrap {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 9500;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
/* BottomNav's tab bar (see BottomNav.css) takes over the bottom of the
   screen at this same width, with the Account tab as its rightmost item --
   directly under where this widget would otherwise sit. Lift it above the
   bar instead of overlapping the tab. */
@media (max-width: 768px) {
  .chat-widget-wrap { bottom: calc(56px + env(safe-area-inset-bottom, 0px) + 14px); }
}

/* The launcher is docked to the right edge, not floating over the page.
   A round FAB parked above the content followed the customer down every
   scroll and sat on top of whatever was underneath it; anchored to the edge
   and vertically centred, the tab stays visible without ever covering a
   product image or the bottom of a form. Blue, not orange: opening support
   is an informational action, and orange is reserved for commercial ones.

   It docks flush to the edge with its label and icon both visible, rounded
   on the inboard side only so it reads as a tab attached to the screen edge
   rather than a floating control. An earlier revision pushed it 32px past the
   edge to leave only a sliver showing; that lost the icon entirely and left a
   tap target 12px wide, so it is back to a full tab. */
.chat-side-tab {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9500;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 9px;
  padding: 15px 11px;
  border: none;
  border-radius: var(--radius-sm) 0 0 var(--radius-sm);
  /* Navy on blue, never white -- white on this fill is 3.1:1 and fails AA. */
  background: var(--color-secondary);
  color: var(--color-text-on-secondary);
  cursor: pointer;
  box-shadow: var(--shadow-panel);
  transition: transform 0.15s ease;
}

/* Slides a little further out on pointer devices. Guarded by hover:hover
   because a phone latches :hover after a tap, which would otherwise leave the
   tab stuck in its extended position for the rest of the session. */
@media (hover: hover) {
  .chat-side-tab:hover { transform: translateY(-50%) translateX(-4px); }
}
.chat-side-tab:focus-visible { transform: translateY(-50%) translateX(-4px); }

.chat-side-tab-label {
  writing-mode: vertical-rl;
  font-size: 0.72rem;
  line-height: 1;
  font-weight: 700;
  letter-spacing: 0.06em;
}

/* Arabic runs the whole document RTL (App.js sets documentElement.dir), so
   the tab and the panel it opens both move to the near edge together --
   splitting them across opposite edges would read as two features. The
   geometry mirrors with it: the strip is now the tab's right edge, so the
   label has to align there instead. */
/* \`left: 0\`, mirroring the LTR rule's \`right: 0\`.
 *
 * This read \`calc(-1 * var(--chat-tab-hidden))\`, and --chat-tab-hidden is
 * defined nowhere -- not in CSS, not set inline from JS. calc() with an
 * undefined custom property is invalid at computed-value time, so \`left\` fell
 * back to \`auto\`; with \`right: auto\` set on the line above it, the tab had no
 * horizontal anchor at all and sat wherever static flow left it. In Arabic,
 * which is the only place this rule applies (App.js sets documentElement.dir),
 * the support tab was simply in the wrong place. */
[dir="rtl"] .chat-side-tab {
  right: auto;
  left: 0;
  align-items: flex-end;
  padding: 16px 1px 16px 0;
  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
}
@media (hover: hover) {
  [dir="rtl"] .chat-side-tab:hover { transform: translateY(-50%) translateX(6px); }
}
[dir="rtl"] .chat-side-tab:focus-visible { transform: translateY(-50%) translateX(6px); }

/* The phone and packaged-app variants that used to sit here (a 44x44 square
   with the wordmark collapsed until pressed) are gone: the strip design above
   is now the single treatment on web and in the app, so there is nothing left
   to override per platform. */
[dir="rtl"] .chat-widget-wrap { right: auto; left: 20px; align-items: flex-start; }

.chat-widget-panel {
  width: min(360px, calc(100vw - 32px));
  height: min(520px, calc(100vh - 120px));
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-panel);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.chat-widget-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-secondary) 100%);
  color: var(--color-brand-white);
  flex-shrink: 0;
}
.chat-widget-header-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 0.95rem;
}
.chat-widget-close {
  background: rgba(255,255,255,0.15);
  border: none;
  color: var(--color-brand-white);
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.chat-widget-close:hover { background: rgba(255,255,255,0.28); }

.chat-widget-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.chat-widget-msg {
  max-width: 82%;
  padding: 9px 13px;
  border-radius: 14px;
  font-size: 0.87rem;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
}
.chat-widget-msg-assistant {
  align-self: flex-start;
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border-bottom-left-radius: 4px;
}
.chat-widget-msg-user {
  align-self: flex-end;
  background: var(--accent);
  color: var(--color-text-on-secondary);
  border-bottom-right-radius: 4px;
}
.chat-widget-typing {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 12px 14px;
}
.chat-widget-typing span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--text-muted);
  animation: chatWidgetTyping 1.2s infinite ease-in-out;
}
.chat-widget-typing span:nth-child(2) { animation-delay: 0.15s; }
.chat-widget-typing span:nth-child(3) { animation-delay: 0.3s; }
@keyframes chatWidgetTyping {
  0%, 60%, 100% { opacity: 0.35; transform: translateY(0); }
  30% { opacity: 1; transform: translateY(-3px); }
}

/* Products the assistant found, rendered as buttons under its reply instead
   of as links inside it. The model is told never to write a URL: a tap target
   carrying the real image, name and current price is easier to read and
   can't be mistyped. Deliberately no discount percentage -- product cards
   never show one anywhere in this app (see CLAUDE.md). */
.chat-product-list {
  align-self: flex-start;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.chat-product-card {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px;
  text-align: left;
  background: var(--bg-primary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: border-color 0.15s ease, transform 0.15s ease;
}
.chat-product-card:hover {
  border-color: var(--color-secondary);
  transform: translateY(-1px);
}
.chat-product-thumb {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: var(--radius-xs);
  object-fit: cover;
  background: var(--bg-tertiary);
}
.chat-product-thumb-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
}
.chat-product-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.chat-product-name {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.chat-product-meta {
  display: flex;
  align-items: baseline;
  gap: 6px;
  flex-wrap: wrap;
}
.chat-product-price {
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--text-primary);
}
.chat-product-was {
  font-size: 0.72rem;
  color: var(--text-muted);
}
/* Carries its own words rather than relying on colour -- with only four
   hues, out-of-stock can't be signalled by a tint alone. */
.chat-product-oos {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--text-muted);
}
.chat-product-cta {
  flex-shrink: 0;
  padding: 5px 10px;
  border-radius: var(--radius-pill);
  font-size: 0.72rem;
  font-weight: 700;
  background: var(--color-secondary);
  color: var(--color-text-on-secondary);
}

.chat-widget-error {
  margin: 0 14px 8px;
  padding: 8px 12px;
  border-radius: var(--radius-xs);
  background: color-mix(in srgb, var(--danger) 12%, transparent);
  color: var(--danger);
  font-size: 0.8rem;
  flex-shrink: 0;
}

.chat-widget-input-row {
  display: flex;
  gap: 8px;
  padding: 12px;
  border-top: 1px solid var(--border);
  flex-shrink: 0;
}
.chat-widget-input-row input {
  flex: 1 1;
  /* An <input> reports a min-content width of roughly its \`size\` attribute,
     which defaults to 20 characters -- and a flex child will not shrink below
     min-content unless told to. So the field held ~20ch regardless of the
     panel and pushed the 38px send button past the card's right edge. It
     first showed up under the mobile layer's larger root, which made those 20
     characters physically wider, but the bug was always here. */
  min-width: 0;
  padding: 9px 13px;
  border-radius: var(--radius-pill);
  border: 1px solid var(--border);
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 0.87rem;
}
.chat-widget-input-row input:focus { outline: none; border-color: var(--accent); }
.chat-widget-input-row button {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: none;
  background: var(--accent);
  color: var(--color-text-on-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}
.chat-widget-input-row button:hover:not(:disabled) { background: var(--accent-hover); }
.chat-widget-input-row button:disabled { opacity: 0.5; cursor: not-allowed; }

@media (max-width: 480px) {
  .chat-widget-wrap { right: 12px; }
  .chat-widget-panel { width: calc(100vw - 24px); height: min(70vh, 520px); }
}

/* ── Compact admin density: reference screens ─────────────────────────────
   Keep these pages visually comfortable at 100% browser zoom without using
   transform/zoom (which would blur text and break sticky positioning). */

/* Add Product: one step tighter than the initial compact pass. */
.admin-product-editor-compact {
  --pf-field-height: 42px;
  padding: 0;
  background: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}
.admin-product-editor-compact .admin-pf-header-v2 { margin-bottom: 9px; }
.admin-product-editor-compact .admin-form-header h2 { font-size: 21px; }
.admin-product-editor-compact .admin-product-form-layout {
  grid-template-columns: minmax(0, 1fr) 220px;
  gap: 11px;
}
.admin-product-editor-compact .admin-pf-section {
  padding: 13px 14px;
  gap: 9px;
  margin-bottom: 9px;
}
.admin-product-editor-compact .admin-pf-section-title { font-size: 16px; gap: 8px; }
.admin-product-editor-compact .admin-pf-section-icon { width: 34px; height: 34px; }
.admin-product-editor-compact .admin-pf-label { font-size: 12px; }
.admin-product-editor-compact .admin-pf-hint,
.admin-product-editor-compact .admin-pf-char-count { font-size: 11px; }
.admin-product-editor-compact .admin-pf-icon-prefix { width: 42px; flex-basis: 42px; }
.admin-product-editor-compact .admin-pf-icon-wrap > .admin-pf-input,
.admin-product-editor-compact .admin-pf-tag-wrap .admin-pf-tag-input {
  /* The outer icon shell is the control. Strip the browser/base input card
     so Category, SKU, Tags, Sizes and Colours render as one clean field. */
  border: 0 !important;
  border-radius: 0 !important;
  outline: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
  min-height: 0;
  height: 100%;
  min-width: 0;
}
.admin-product-editor-compact .admin-pf-tag-chips {
  min-width: 0;
  overflow: hidden;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}
.admin-product-editor-compact .admin-pf-tag-wrap { height: var(--pf-field-height); min-height: var(--pf-field-height); }
.admin-product-editor-compact .admin-pf-tag-wrap--plain {
  border: 1.5px solid var(--pf-primary);
  border-radius: var(--pf-field-radius);
  background: var(--pf-field-bg);
}
.admin-product-editor-compact .admin-pf-tag-wrap .admin-pf-tag-chips {
  height: 100%;
  min-height: 0;
  padding: 0 12px;
  align-items: center;
}
.admin-product-editor-compact .admin-pf-tag-wrap .admin-pf-tag-input {
  align-self: stretch;
  box-sizing: border-box;
  height: 100%;
  margin: 0;
  padding: 0;
  line-height: normal;
}
.admin-product-editor-compact .admin-pf-row-3 > .admin-pf-field > .admin-pf-input,
.admin-product-editor-compact .admin-pf-row-3 > .admin-pf-field > .admin-pf-icon-wrap,
.admin-product-editor-compact .admin-pf-row-3 > .admin-pf-field > .admin-pf-tag-wrap {
  height: var(--pf-field-height);
  min-height: var(--pf-field-height);
  box-sizing: border-box;
}
.admin-product-editor-compact .admin-pf-icon-wrap--category .admin-pf-icon-prefix {
  width: 34px;
  flex-basis: 34px;
  padding: 0;
}
.admin-product-editor-compact .admin-pf-icon-wrap--category { position: relative; }
.admin-product-editor-compact .admin-pf-icon-wrap--category select {
  appearance: none;
  -webkit-appearance: none;
  padding-right: 38px !important;
}
.admin-product-editor-compact .admin-pf-icon-wrap--category::after {
  content: '';
  position: absolute;
  right: 15px;
  top: 50%;
  width: 7px;
  height: 7px;
  border-right: 2px solid var(--pf-heading);
  border-bottom: 2px solid var(--pf-heading);
  transform: translateY(-70%) rotate(45deg);
  pointer-events: none;
}
.admin-product-editor-compact .admin-pf-icon-wrap--textarea,
.admin-product-editor-compact .admin-pf-icon-wrap--textarea .admin-pf-textarea,
.admin-product-editor-compact .admin-pf-textarea { min-height: 72px; }
.admin-product-editor-compact .admin-preview-img-wrap { height: 120px; }
.admin-product-editor-compact .admin-pf-sidebar { gap: 9px; }
.admin-product-editor-compact .admin-preview-card,
.admin-product-editor-compact .admin-pf-publish-card,
.admin-product-editor-compact .admin-pf-tips-card { padding: 10px; }

/* Disputes */
.dsp-header { margin-bottom: 12px; gap: 10px; }
.dsp-header h2 { font-size: 1.05rem; }
.dsp-header p { font-size: 0.78rem; }
.dsp-toolbar-btn { min-height: 38px; padding: 7px 11px; font-size: 0.78rem; }
.dsp-stat-row { gap: 8px; margin-bottom: 14px; }
.dsp-stat-card { padding: 12px 14px; gap: 7px; border-radius: 11px; }
.dsp-stat-icon { width: 30px; height: 30px; }
.dsp-stat-count { font-size: 1.12rem; }
.dsp-stat-label { font-size: 0.68rem; }
.dsp-list { gap: 8px; }
.dsp-card { padding: 12px 14px; border-radius: 11px; }
.dsp-card-badges { margin-bottom: 5px; gap: 7px; }
.dsp-card-order-row { padding: 7px 10px; }
.dsp-card-actions { margin-top: 8px; gap: 6px; }
.dsp-notes-input { min-height: 38px; padding: 7px 10px; }

/* Coupons */
.cpn-section { gap: 14px; }
.cpn-card { padding: 16px 18px; border-radius: 13px; }
.cpn-card-head { margin-bottom: 12px; gap: 9px; }
.cpn-card-icon { width: 36px; height: 36px; }
.cpn-card-title { font-size: 1.05rem; }
.cpn-form-grid { gap: 12px 14px; }
.cpn-field { gap: 5px; }
.cpn-label { font-size: 0.76rem; }
.cpn-input-wrap { min-height: 42px; }
.cpn-input { min-height: 42px; padding-top: 7px; padding-bottom: 7px; font-size: 0.84rem; }
.cpn-input-icon { width: 42px; }
.cpn-hint { font-size: 0.7rem; margin-top: 2px; }
.cpn-options { margin-top: 14px; padding: 13px 15px; }
.cpn-options-grid { gap: 14px; }
.cpn-submit { min-height: 40px; padding: 8px 16px; }
.cpn-list-head { margin-bottom: 12px; }
.cpn-search input,
.cpn-sort,
.cpn-filter-btn { min-height: 38px; padding-top: 7px; padding-bottom: 7px; }
.cpn-table-header,
.cpn-row { padding-top: 10px; padding-bottom: 10px; }

/* Careers */
.admin-section.admin-pf-card-v2 .admin-careers-grid { gap: 14px; }
.admin-section.admin-pf-card-v2 .admin-careers-grid > div:first-child { gap: 14px !important; }
.admin-section.admin-pf-card-v2 .admin-careers-grid .admin-pf-section {
  padding: 16px;
  gap: 12px;
  margin-bottom: 0;
  border-radius: 13px;
}
.admin-section.admin-pf-card-v2 .admin-careers-grid .admin-pf-section-title--plain { font-size: 16px; }
.admin-section.admin-pf-card-v2 .admin-careers-stats { gap: 9px; }
.admin-section.admin-pf-card-v2 .admin-careers-stat-tile { padding: 12px; }
.admin-section.admin-pf-card-v2 .admin-careers-stat-icon { width: 36px; height: 36px; }
.admin-section.admin-pf-card-v2 .admin-careers-stat-value { font-size: 24px; }
.admin-section.admin-pf-card-v2 .admin-careers-stat-label { font-size: 12px; }
.admin-section.admin-pf-card-v2 .admin-careers-stat-trend { font-size: 10px; }
.admin-section.admin-pf-card-v2 .admin-careers-grid .admin-pf-input { min-height: 42px; font-size: 14px; padding: 0 12px; }
.admin-section.admin-pf-card-v2 .admin-careers-grid .admin-pf-label { font-size: 12px; }
.admin-section.admin-pf-card-v2 .admin-careers-grid form { gap: 12px !important; }
.admin-section.admin-pf-card-v2 .admin-rte-toolbar { padding: 5px 7px; }
.admin-section.admin-pf-card-v2 .admin-rte-toolbar button { width: 26px; height: 26px; }
.admin-section.admin-pf-card-v2 .admin-rte-body { min-height: 82px; padding: 10px 12px; font-size: 14px; }
.admin-section.admin-pf-card-v2 .admin-careers-grid .admin-pf-textarea { min-height: 72px; padding: 9px 12px; font-size: 14px; }
.admin-section.admin-pf-card-v2 .admin-products-table .admin-table-header,
.admin-section.admin-pf-card-v2 .admin-products-table .admin-product-row { padding-top: 9px; padding-bottom: 9px; }

/* Product catalogue beneath Add Product. Give each content type a guarded
   track and scroll the table as a unit on narrow screens; cells must never
   paint over adjacent columns. */
.admin-product-catalog-table {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}
.admin-product-catalog-table .admin-table-header,
.admin-product-catalog-table .admin-product-row {
  grid-template-columns: minmax(0, 2fr) minmax(80px, 0.7fr) minmax(90px, 0.65fr) 70px minmax(220px, 1.45fr);
  min-width: 0;
  box-sizing: border-box;
  gap: 10px;
}
.admin-product-catalog-table .admin-product-name,
.admin-product-catalog-table .admin-product-name > div,
.admin-product-catalog-table .admin-product-price-cell { min-width: 0; }
.admin-product-catalog-table .admin-product-price-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  overflow: hidden;
}
.admin-product-catalog-table .admin-product-price-cell > * {
  margin-left: 0 !important;
  max-width: 100%;
  white-space: nowrap;
}
.admin-product-catalog-table .admin-category-chip {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
}
.admin-product-catalog-table .admin-row-actions {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 5px;
  min-width: 0;
}
.admin-product-catalog-table .admin-row-actions .btn-admin-edit,
.admin-product-catalog-table .admin-row-actions button {
  min-width: 0;
  padding: 6px 7px;
  font-size: 0.76rem;
  white-space: nowrap;
}
.admin-product-catalog-table .admin-product-delete-btn {
  background: var(--color-primary);
  border-color: var(--color-primary);
  color: var(--color-text-on-primary);
}
.admin-product-catalog-table .admin-product-delete-btn:hover,
.admin-product-catalog-table .admin-product-delete-btn:focus-visible {
  background: var(--color-primary);
  border-color: var(--color-primary);
  color: var(--color-text-on-primary);
}

@media (max-width: 1200px) {
  .admin-product-catalog-table { border: 0; background: transparent; }
  .admin-product-catalog-table .admin-table-header { display: none; }
  .admin-product-catalog-table .admin-product-row {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-template-areas:
      "product product product"
      "category price stock"
      "actions actions actions";
    gap: 10px 14px;
    margin-bottom: 10px;
    padding: 13px 14px;
    border: 1px solid var(--border);
    border-radius: 12px;
    background: var(--bg-secondary);
  }
  .admin-product-catalog-table .admin-product-row > :nth-child(1) { grid-area: product; }
  .admin-product-catalog-table .admin-product-row > :nth-child(2) { grid-area: category; justify-self: start; }
  .admin-product-catalog-table .admin-product-row > :nth-child(3) { grid-area: price; }
  .admin-product-catalog-table .admin-product-row > :nth-child(4) { grid-area: stock; justify-self: start; }
  .admin-product-catalog-table .admin-product-row > :nth-child(5) { grid-area: actions; }
  .admin-product-catalog-table .admin-row-actions { grid-template-columns: repeat(4, minmax(0, 1fr)); }
}

@media (max-width: 560px) {
  .admin-product-catalog-table .admin-product-row {
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      "product product"
      "category stock"
      "price price"
      "actions actions";
  }
  .admin-product-catalog-table .admin-row-actions { grid-template-columns: 1fr 1fr; }
}

@media (max-width: 900px) {
  .admin-product-editor-compact .admin-product-form-layout { grid-template-columns: 1fr; }
}

/* ── Homepage "Shop by Category" carousel rows ───────────────── */
/* Amazon/Flipkart-style widget layout: the page background shows through
   between rows (each one reads as its own distinct section, not one
   continuous strip), and each row is a plain white/dark card with exactly
   one light shadow tier -- not a shadowed panel wrapping shadowed cards.
   Cards inside share the same background as their row (no border, no
   shadow at rest) and are separated by whitespace alone, the way real
   marketplace product tiles are -- only a small hover lift, never both a
   panel shadow and a card shadow stacked at once. */
.cat-row { padding: 6px 12px; background: var(--bg-primary); }
.cat-row-inner {
  max-width: 1440px;
  margin: 0 auto;
  padding: 16px 20px 18px;
  background: var(--bg-secondary);
  border-radius: 8px;
  box-shadow: var(--shadow-sm);
}
.cat-row-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.cat-row-title-group {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}
.cat-row-icon {
  flex-shrink: 0;
  /* Only ever the Top Sales flame -- a promotional marker, so orange against
     the navy section heading beside it. */
  color: var(--color-primary);
  display: flex;
  align-items: center;
  justify-content: center;
}
.cat-row-title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: -0.01em;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cat-row-viewall {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  flex-shrink: 0;
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--accent);
  background: none;
  border: none;
  /* Measured at 63x15. WCAG 2.2 AA (2.5.8) asks for 24x24 on a control, and
     the exception for links inline in a sentence does not apply here -- this
     is a standalone button at the end of a section heading, with nothing
     around it to explain a miss. Vertical padding rather than a min-height,
     so the text stays on the heading's baseline instead of the button growing
     downward away from it. */
  padding: 5px 2px;
  min-height: 24px;
  white-space: nowrap;
  cursor: pointer;
  text-decoration: none;
  transition: gap 150ms;
}
.cat-row-viewall:hover { gap: 6px; text-decoration: underline; }

.cat-carousel-track {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  scroll-snap-type: x proximity;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 2px 4px 8px;
}
.cat-carousel-track::-webkit-scrollbar { display: none; }

.cat-carousel-card {
  flex: 0 0 168px;
  scroll-snap-align: start;
  background: var(--bg-secondary);
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.cat-carousel-card:hover { transform: translateY(-2px); box-shadow: var(--shadow-sm); }
.cat-carousel-card-oos { opacity: 0.72; }

/* The square is the WRAPPER's, not the image's.
 *
 * It used to come from \`aspect-ratio\` on the <img>, which works only while
 * there is an <img> to measure. ProductImage renders no <img> at all once a
 * photo has failed -- just its placeholder, which is absolutely positioned and
 * therefore contributes no height -- so a card whose image 404'd collapsed to
 * nothing and the whole row lost its pictures' worth of height.
 *
 * Same reason .pcard-img-wrap carries an explicit height. The image keeps its
 * own aspect-ratio for the ordinary case, where it is what fills the box. */
.cat-carousel-card-img-wrap { position: relative; aspect-ratio: 1 / 1; background: var(--bg-primary); }
.cat-carousel-card-img { width: 100%; height: 100%; aspect-ratio: 1 / 1; object-fit: cover; display: block; }

/* Priority badge -- same color language as the main product grid's
   .pcard-badge-* (bestseller/toprated/deal/limited/oos) so a product reads
   the same way whether it's here or in the full catalogue grid. */
.cat-carousel-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 0.66rem;
  font-weight: 800;
  letter-spacing: 0.03em;
  padding: 3px 8px;
  border-radius: 20px;
  text-transform: uppercase;
  white-space: nowrap;
}
.cat-carousel-badge-bestseller { background: var(--color-primary); color: var(--color-text-on-primary); }
.cat-carousel-badge-toprated   { background: var(--color-secondary); color: var(--color-text-on-secondary); }
.cat-carousel-badge-limited    { background: var(--danger); color: var(--color-text-on-primary); }
.cat-carousel-badge-oos        { background: var(--text-secondary); color: var(--color-brand-white); }

.cat-carousel-oos-overlay {
  position: absolute; inset: 0;
  background: rgba(1, 13, 33,0.6);
  display: flex; align-items: center; justify-content: center;
  z-index: 2;
}
.cat-carousel-oos-overlay span {
  background: var(--text-secondary); color: var(--color-brand-white);
  font-size: 0.68rem; font-weight: 700;
  padding: 4px 12px; border-radius: var(--radius-xs);
  text-transform: uppercase; letter-spacing: 0.05em;
}

/* Quick View hint -- purely a visual affordance (the whole card is already
   clickable), so it's a plain overlay rather than its own button. Hidden on
   touch devices via the hover media query, since there's no hover state there. */
.cat-carousel-quickview {
  position: absolute;
  left: 0; right: 0; bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 7px 0;
  background: rgba(1, 13, 33,0.72);
  color: var(--color-brand-white);
  font-size: 0.7rem;
  font-weight: 700;
  opacity: 0;
  transform: translateY(100%);
  transition: opacity 160ms, transform 160ms;
  z-index: 2;
}
@media (hover: hover) {
  .cat-carousel-card:hover .cat-carousel-quickview { opacity: 1; transform: translateY(0); }
}

/* Touch devices already have the natural gesture (swipe) for this -- a pair
   of small arrow buttons stacked over 172px-wide cards just eats into card
   content and adds nothing a touchscreen user needs. Same precedent as
   .pcard-quick-row being hidden on touch elsewhere in this file. Dots take
   over as the touch-side position indicator instead (see .cat-carousel-dots). */
@media (hover: none) {
  .cat-carousel-outer .carousel-arrow { display: none; }
}

.cat-carousel-outer-wrap { position: relative; }
/* 18px gap for the same reason as .carousel-dots above: 6px dot + 18px =
   24px centre to centre, so the invisible 24px hit areas meet without
   overlapping. */
.cat-carousel-dots {
  display: flex;
  justify-content: center;
  gap: 18px;
  padding: 10px 0 2px;
}
.cat-carousel-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--border);
  border: none;
  cursor: pointer;
  transition: background 200ms, width 200ms;
  padding: 0;
  position: relative;
}
/* 6px is the smallest target in the app -- a quarter of the 24px minimum.
   Same treatment as .carousel-dot: grow the touchable area, not the dot. */
.cat-carousel-dot::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 24px;
  height: 24px;
  transform: translate(-50%, -50%);
}
.cat-carousel-dot.active { background: var(--accent); width: 16px; border-radius: var(--radius-xs); }

/* Must come after the unconditional display:flex above -- same specificity,
   so source order decides, and a media-scoped rule earlier in the file
   loses to a later unconditional one regardless of whether it matches.
   (This is exactly the bug that shipped: dots and arrows both showing on
   desktop at once, because this rule used to sit above .cat-carousel-dots.) */
@media (hover: hover) {
  .cat-carousel-dots { display: none; }
}

.cat-carousel-card-body { padding: 11px 12px 13px; }
.cat-carousel-card-name {
  margin: 0 0 6px;
  font-size: 0.83rem;
  font-weight: 600;
  line-height: 1.35;
  color: var(--text-primary);
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  min-height: 2.3em;
}
.cat-carousel-card-price { display: flex; align-items: baseline; gap: 5px; flex-wrap: wrap; }
/* Prices are navy, not orange. Orange on white measures 2.92:1 -- it cannot
   reach WCAG AA as text at any size or weight, which is why the brand rules
   forbid orange small text on white outright. The orange commercial highlight
   on these cards is the discount pill (orange fill, navy label, 7.4:1), which
   carries the promotion without putting orange type on a white background. */
.cat-carousel-price { font-weight: 700; font-size: 0.93rem; color: var(--text-primary); }
.cat-carousel-price-sale { font-weight: 700; font-size: 0.93rem; color: var(--text-primary); }
.cat-carousel-price-was { font-size: 0.72rem; color: var(--text-secondary); text-decoration: line-through; }
/* "X% off" in green, next to the price -- the Flipkart/Amazon convention of
   repeating the discount as plain text beside the price, not just as an
   image-corner badge. */

.cat-carousel-card-rating-row {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.72rem;
  color: var(--text-secondary);
  margin-top: 5px;
  min-height: 1.1em;
}
/* Small green rating pill (value + star), the Flipkart convention -- reads
   as a distinct at-a-glance rating chip rather than a plain star row. */
.cat-carousel-rating-pill {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  background: var(--color-rating);
  /* Same 3.30:1 problem as .product-rating-pill -- see --color-rating-on-fill. */
  color: var(--color-rating-on-fill);
  font-size: 0.68rem;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 999px;
  line-height: 1.4;
}
.cat-carousel-review-cnt { color: var(--text-secondary); }
.cat-carousel-no-rating { font-size: 0.7rem; color: var(--color-review-muted); }

@media (max-width: 640px) {
  .cat-row { padding: 4px 8px; }
  .cat-row-inner { padding: 12px 14px 14px; border-radius: 6px; }
  .cat-row-title { font-size: 0.98rem; }
}

@media (max-width: 600px) {
  .cat-carousel-card { flex: 0 0 138px; }
}

@media (max-width: 380px) {
  .cat-carousel-card { flex: 0 0 122px; }
}

/* ── Pull-to-refresh indicator ────────────────────────────────────────
   A small fixed badge that fades/grows in as the user pulls down at the
   top of the page -- the page itself never moves, only this indicator. */
.ptr-indicator {
  position: fixed;
  top: 10px;
  left: 50%;
  z-index: 2000;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-card);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--accent);
  pointer-events: none;
}
.ptr-indicator.refreshing { animation: ptr-spin 700ms linear infinite; }
@keyframes ptr-spin {
  from { transform: translateX(-50%) rotate(0deg); }
  to { transform: translateX(-50%) rotate(360deg); }
}

/* ═══════════════════════════════════════════════════════════
   About Us page — aligned to the navbar's max-width like the
   other public sub-pages (Careers, Help Center, Become a Seller).
   Green is used as a fixed brand accent for this page specifically,
   independent of light/dark mode, matching the reference design.
   ═══════════════════════════════════════════════════════════ */
.about-page { max-width: 1440px; margin: 0 auto; padding: 8px 24px 80px; display: flex; flex-direction: column; gap: 64px; }
@media (max-width: 640px) { .about-page { padding: 8px 12px 60px; gap: 48px; } }

.about-eyebrow { display: inline-block; font-size: 0.78rem; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; color: var(--success); margin-bottom: 12px; }
.about-eyebrow-center { display: block; text-align: center; }

/* ── Hero ─────────────────────────────────────────────────── */
.about-hero { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; align-items: center; }
@media (max-width: 900px) { .about-hero { grid-template-columns: 1fr; gap: 32px; } }

.about-hero-title { font-size: 2.3rem; font-weight: 800; line-height: 1.15; color: var(--text-primary); margin: 0 0 16px; }
@media (max-width: 640px) { .about-hero-title { font-size: 1.7rem; } }
.about-hero-sub { font-size: 0.95rem; color: var(--text-secondary); line-height: 1.7; max-width: 480px; margin: 0 0 28px; }
.about-hero-actions { display: flex; flex-wrap: wrap; gap: 12px; }

.about-btn-primary {
  display: inline-flex; align-items: center; gap: 8px; background: var(--success); color: var(--color-text-on-secondary); border: none;
  border-radius: 999px; padding: 13px 24px; font-weight: 700; font-size: 0.9rem; cursor: pointer;
}
.about-btn-primary:hover { background: var(--color-secondary); }
.about-btn-outline {
  display: inline-flex; align-items: center; gap: 8px; background: var(--bg-secondary); color: var(--text-primary);
  border: 1px solid var(--border); border-radius: 999px; padding: 13px 24px; font-weight: 700; font-size: 0.9rem; cursor: pointer;
}
.about-btn-outline:hover { border-color: var(--success); color: var(--success); }

.about-hero-visual { position: relative; display: flex; justify-content: center; padding: 20px; }
.about-hero-img-wrap {
  width: 320px; height: 320px; border-radius: 50%; overflow: hidden; flex-shrink: 0;
  box-shadow: 0 20px 60px color-mix(in srgb, var(--success) 18%, transparent); border: 6px solid color-mix(in srgb, var(--success) 10%, transparent);
}
.about-hero-img { width: 100%; height: 100%; object-fit: cover; object-position: 50% 18%; display: block; }

.about-float-card {
  position: absolute; display: flex; align-items: center; gap: 10px; background: var(--bg-secondary);
  border: 1px solid var(--border); border-radius: 14px; padding: 10px 14px; box-shadow: var(--shadow-card);
  font-size: 0.72rem; max-width: 160px;
}
.about-float-card strong { display: block; font-size: 0.92rem; color: var(--text-primary); }
.about-float-title { margin: 0; color: var(--text-muted); font-size: 0.66rem; text-transform: uppercase; letter-spacing: 0.03em; }
.about-float-card span:not(.about-float-title) { color: var(--text-secondary); }
.about-float-icon {
  flex-shrink: 0; width: 30px; height: 30px; border-radius: 50%; display: inline-flex; align-items: center;
  justify-content: center; background: color-mix(in srgb, var(--success) 12%, transparent); color: var(--success);
}
.about-float-1 { top: 6%; left: -4%; }
.about-float-2 { top: 6%; right: -4%; }
.about-float-3 { bottom: 22%; left: -8%; }
.about-float-4 { bottom: 8%; right: -6%; }
@media (max-width: 900px) {
  .about-hero-img-wrap { width: 240px; height: 240px; }
  .about-float-card { position: static; max-width: none; margin: 6px; }
  .about-hero-visual { flex-wrap: wrap; gap: 10px; }
}

/* ── Stats strip ──────────────────────────────────────────── */
.about-stats {
  display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; background: color-mix(in srgb, var(--success) 6%, transparent);
  border-radius: var(--radius-lg); padding: 32px 24px;
}
@media (max-width: 640px) { .about-stats { grid-template-columns: repeat(2, 1fr); } }
.about-stat { text-align: center; }
.about-stat-icon {
  display: inline-flex; align-items: center; justify-content: center; width: 44px; height: 44px; border-radius: 50%;
  background: var(--bg-secondary); border: 1px solid color-mix(in srgb, var(--success) 25%, transparent); color: var(--success); margin-bottom: 10px;
}
.about-stat-value { font-size: 1.5rem; font-weight: 800; color: var(--success); margin: 0; }
.about-stat-label { font-size: 0.8rem; color: var(--text-secondary); margin: 2px 0 0; }

/* ── Why We Exist ─────────────────────────────────────────── */
.about-why { text-align: center; }
.about-section-title { font-size: 1.6rem; font-weight: 800; color: var(--text-primary); margin: 0 0 12px; }
.about-section-sub { font-size: 0.92rem; color: var(--text-secondary); max-width: 560px; margin: 0 auto; line-height: 1.6; }
.about-value-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-top: 36px; text-align: left; }
@media (max-width: 800px) { .about-value-grid { grid-template-columns: 1fr; } }
.about-value-card { background: var(--bg-secondary); border: 1px solid var(--border); border-radius: var(--radius-md); padding: 22px 20px; }
.about-value-icon {
  display: inline-flex; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 12px;
  background: color-mix(in srgb, var(--success) 10%, transparent); color: var(--success); margin-bottom: 14px;
}
.about-value-title { font-size: 1rem; font-weight: 700; color: var(--text-primary); margin: 0 0 6px; }
.about-value-text { font-size: 0.85rem; color: var(--text-secondary); line-height: 1.6; margin: 0; }

/* ── Vision ───────────────────────────────────────────────── */
.about-vision {
  display: grid; grid-template-columns: 0.9fr 1.1fr; gap: 40px; align-items: center; background: color-mix(in srgb, var(--success) 6%, transparent);
  border-radius: var(--radius-lg); padding: 32px;
}
@media (max-width: 900px) { .about-vision { grid-template-columns: 1fr; padding: 24px; } }
.about-vision-img-wrap { border-radius: var(--radius-lg); overflow: hidden; aspect-ratio: 4/3; }
.about-vision-img { width: 100%; height: 100%; object-fit: cover; object-position: 50% 15%; display: block; }
.about-vision-items { display: flex; flex-wrap: wrap; gap: 24px; margin-top: 8px; }
.about-vision-item { flex: 1 1 140px; }
.about-vision-icon {
  display: inline-flex; align-items: center; justify-content: center; width: 34px; height: 34px; border-radius: 50%;
  background: color-mix(in srgb, var(--success) 12%, transparent); color: var(--success); margin-bottom: 8px;
}
.about-vision-item-title { font-size: 0.88rem; font-weight: 700; color: var(--text-primary); margin: 0 0 2px; }
.about-vision-item-text { font-size: 0.78rem; color: var(--text-secondary); margin: 0; }

/* ── Bottom CTA banner ────────────────────────────────────── */
.about-cta {
  display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 20px;
  background: linear-gradient(135deg, var(--success), var(--color-secondary)); border-radius: var(--radius-lg); padding: 32px 36px; color: var(--color-brand-white);
}
.about-cta-icon {
  width: 48px; height: 48px; border-radius: 14px; background: rgba(255,255,255,0.15); display: inline-flex;
  align-items: center; justify-content: center; flex-shrink: 0;
}
.about-cta-copy { flex: 1 1; min-width: 220px; }
.about-cta-title { font-size: 1.2rem; font-weight: 800; margin: 0 0 4px; }
.about-cta-sub { font-size: 0.9rem; margin: 0; opacity: 0.9; }
.about-cta-actions { display: flex; flex-wrap: wrap; gap: 12px; }
.about-btn-white {
  display: inline-flex; align-items: center; gap: 8px; background: var(--color-brand-white); color: var(--color-secondary); border: none;
  border-radius: 999px; padding: 12px 22px; font-weight: 700; font-size: 0.88rem; cursor: pointer;
}
.about-btn-outline-white {
  display: inline-flex; align-items: center; gap: 8px; background: transparent; color: var(--color-brand-white);
  border: 1px solid rgba(255,255,255,0.5); border-radius: 999px; padding: 12px 22px; font-weight: 700; font-size: 0.88rem; cursor: pointer;
}
.about-btn-outline-white:hover { background: rgba(255,255,255,0.12); }

/* ── Brands (seller directory) page ──────────────────────────────────── */
.brands-search-box {
  display: flex; align-items: center; gap: 8px;
  background: var(--bg-secondary); border: 1px solid var(--border); border-radius: var(--radius-md);
  padding: 10px 14px; color: var(--text-muted); margin-bottom: 24px;
}
.brands-search-box input { flex: 1 1; border: none; background: none; outline: none; font-size: 0.88rem; color: var(--text-primary); }
.brands-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 14px; }
.brands-card {
  display: flex; flex-direction: column; align-items: flex-start; gap: 6px; text-align: left;
  background: var(--bg-secondary); border: 1px solid var(--border); border-radius: var(--radius-md);
  padding: 18px 16px; cursor: pointer;
}
.brands-card:hover { border-color: var(--accent); }
.brands-card-logo { font-size: 1.8rem; line-height: 1; margin-bottom: 4px; }
.brands-card-name { font-size: 0.98rem; font-weight: 700; color: var(--text-primary); }
.brands-card-tagline { font-size: 0.8rem; color: var(--text-secondary); }
.brands-card-meta { display: flex; align-items: center; gap: 10px; font-size: 0.78rem; color: var(--text-muted); margin-top: 4px; flex-wrap: wrap; }
.brands-card-meta span { display: inline-flex; align-items: center; gap: 4px; }

/* Admin Settings: compact, visible cards that use the available canvas. */
.admin-settings-module {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  align-items: start;
  width: 100%;
  min-width: 0;
}

.admin-settings-module .admin-settings-heading {
  grid-column: 1 / -1;
  margin: 0 0 2px;
  color: var(--text-primary);
  font-size: 18px;
  font-weight: 750;
}

.admin-settings-module .admin-settings-card {
  width: 100%;
  max-width: none !important;
  min-width: 0;
  margin: 0;
  padding: 16px 18px;
  border: 1.5px solid color-mix(in srgb, var(--accent) 46%, var(--border));
  border-radius: 13px;
  box-sizing: border-box;
}

.admin-settings-module .admin-settings-card:hover { border-color: var(--accent); }
.admin-settings-module .admin-settings-account-card { grid-column: 1 / -1; }
.admin-settings-module .admin-form-header { margin-bottom: 13px; }
.admin-settings-module .admin-form-title {
  display: flex;
  align-items: center;
  gap: 9px;
  margin: 0;
  font-size: 17px;
}

.admin-settings-module .admin-settings-card-icon {
  width: 35px;
  height: 35px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 35px;
  color: var(--accent);
  background: color-mix(in srgb, var(--accent) 12%, transparent);
  border-radius: 9px;
}

.admin-settings-module .si-field-grid { gap: 11px 12px; }
.admin-settings-module .si-field { gap: 4px; }
.admin-settings-module .si-label { color: var(--text-primary); font-size: 12px; }
.admin-settings-module .si-input {
  min-height: 40px;
  padding: 7px 11px;
  border: 1.5px solid var(--accent);
  border-radius: 9px;
  background: var(--bg-primary);
}
.admin-settings-module .si-input:hover { border-color: var(--accent-hover, var(--accent)); }
.admin-settings-module .si-input:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent) 16%, transparent);
}

.admin-settings-module .admin-settings-invoice-preview {
  border: 1px solid color-mix(in srgb, var(--accent) 35%, var(--border));
}
.admin-settings-module .dmp-map-box {
  min-height: 220px;
  height: 250px;
  border-color: var(--accent);
  border-radius: 10px;
}
.admin-settings-module .dmp-locate-btn {
  min-height: 38px;
  padding: 8px 13px;
  color: var(--accent);
  border-color: var(--accent);
}

.admin-settings-module .admin-settings-primary-btn {
  min-height: 40px;
  padding: 8px 16px !important;
  background: var(--accent) !important;
  color: var(--color-brand-white) !important;
  border: 1px solid var(--accent) !important;
  border-radius: 8px !important;
  font-size: 13px !important;
}
.admin-settings-module .admin-settings-primary-btn:hover:not(:disabled) {
  background: var(--accent-hover, var(--accent)) !important;
  border-color: var(--accent-hover, var(--accent)) !important;
}

.admin-settings-module .admin-settings-account-card .si-field-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.admin-settings-module .admin-settings-account-card .si-field-full { grid-column: span 1; }

@media (max-width: 1100px) {
  .admin-settings-module { grid-template-columns: minmax(0, 1fr); }
  .admin-settings-module .admin-settings-heading,
  .admin-settings-module .admin-settings-account-card { grid-column: 1; }
}

@media (max-width: 760px) {
  .admin-settings-module .admin-settings-account-card .si-field-grid { grid-template-columns: minmax(0, 1fr); }
  .admin-settings-module .admin-settings-account-card .si-field-full { grid-column: 1; }
}

@media (max-width: 640px) {
  .admin-settings-module .admin-settings-card { padding: 14px; }
  .admin-settings-module .dmp-map-box { height: 220px; }
}

/* Returns module: clear hierarchy, guarded content, responsive details. */
.admin-returns-module {
  width: 100%;
  min-width: 0;
}

.admin-returns-module .dsp-header {
  display: none;
}

.admin-returns-module .dsp-header h2 {
  font-size: 22px;
}

/* Module titles live in .admin-page-header; body cards start with content. */
.admin-section > .dsp-header,
.admin-settings-module > .admin-settings-heading {
  display: none;
}

.admin-header-module-tools {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
}

.admin-header-search {
  width: clamp(190px, 20vw, 285px);
  min-height: 38px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 11px;
  color: var(--text-muted);
  background: var(--bg-primary);
  border: 1.5px solid var(--accent);
  border-radius: 9px;
  box-sizing: border-box;
}

.admin-header-search input {
  width: 100%;
  min-width: 0;
  padding: 0;
  color: var(--text-primary);
  background: transparent;
  border: 0;
  outline: 0;
  font: inherit;
  font-size: 13px;
}

.admin-header-module-tools .dsp-toolbar-btn {
  min-height: 38px;
  border-color: color-mix(in srgb, var(--accent) 55%, var(--border));
  background: var(--bg-primary);
  white-space: nowrap;
}

.admin-header-module-tools .dsp-toolbar-btn:hover {
  border-color: var(--accent);
  color: var(--accent);
}

.admin-header-module-tools .dsp-popover {
  z-index: 120;
}

@media (max-width: 1180px) {
  .admin-page-header:has(.admin-header-module-tools) > div:first-child {
    flex: 1 1 100%;
  }

  .admin-page-header:has(.admin-header-module-tools) .admin-header-actions {
    width: 100%;
  }

  .admin-header-module-tools {
    flex: 1 1 auto;
    justify-content: flex-start;
  }
}

@media (max-width: 700px) {
  .admin-header-search {
    width: 100%;
  }

  .admin-header-module-tools {
    width: 100%;
  }
}

.admin-returns-module .ret-filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
  margin-bottom: 14px;
  padding: 10px;
  background: var(--bg-secondary);
  border: 1.5px solid color-mix(in srgb, var(--accent) 42%, var(--border));
  border-radius: 12px;
}

.admin-returns-module .ret-filter-btn {
  min-height: 32px;
  padding: 5px 11px !important;
  border-radius: 999px !important;
  background-color: var(--bg-primary);
  line-height: 1.2;
  white-space: nowrap;
  transition: border-color 150ms ease, background-color 150ms ease, transform 150ms ease;
}

.admin-returns-module .ret-filter-btn:hover {
  border-color: var(--accent) !important;
  transform: translateY(-1px);
}

.admin-returns-module .ret-layout,
.admin-returns-module .ret-list {
  width: 100%;
  min-width: 0;
}

.admin-returns-module .ret-layout--split {
  grid-template-columns: minmax(0, 1fr) minmax(310px, 360px);
  gap: 14px;
}

.admin-returns-module .ret-card {
  min-width: 0;
  padding: 13px 15px;
  border-color: color-mix(in srgb, var(--accent) 42%, var(--border));
  background: var(--bg-secondary);
  box-sizing: border-box;
}

.admin-returns-module .ret-card:hover,
.admin-returns-module .ret-card--selected {
  border-color: var(--accent);
}

.admin-returns-module .ret-card-badges {
  gap: 7px;
  margin-bottom: 10px;
}

.admin-returns-module .ret-card-badges > span:nth-last-child(2) {
  min-width: 0;
  overflow-wrap: anywhere;
}

.admin-returns-module .ret-card-grid {
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 10px;
  padding-bottom: 10px;
}

.admin-returns-module .ret-layout--split .ret-card-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.admin-returns-module .ret-card-grid > div,
.admin-returns-module .ret-refund-panel-grid > div {
  min-width: 0;
}

.admin-returns-module .ret-card-value,
.admin-returns-module .ret-card-sub {
  overflow-wrap: anywhere;
  line-height: 1.3;
}

.admin-returns-module .ret-refund-panel {
  border-color: color-mix(in srgb, var(--accent) 32%, var(--border));
}

.admin-returns-module .ret-exchange-panel {
  flex-wrap: wrap;
}

.admin-returns-module .ret-tracking-input {
  min-height: 34px;
  border: 1.5px solid var(--accent);
}

.admin-returns-module .ret-card-actions {
  gap: 6px;
  margin-top: 10px;
}

.admin-returns-module .ret-action-btn {
  min-height: 34px;
  padding: 6px 10px;
  border-color: color-mix(in srgb, var(--accent) 45%, var(--border));
}

.admin-returns-module .ret-action-btn--primary {
  background: var(--accent);
  border-color: var(--accent);
}

.admin-returns-module .ret-action-btn--danger,
.admin-returns-module .ret-action-btn--danger:hover:not(:disabled) {
  color: var(--color-text-on-primary);
  background: var(--color-primary);
  border-color: var(--color-primary);
}

/* Commission, tax and currency cards: compact and consistently aligned. */
.admin-commission-module .admin-ct-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: stretch;
  gap: 14px;
  margin-bottom: 14px;
}
.admin-commission-module .admin-pf-section {
  min-width: 0;
  padding: 16px 18px;
  gap: 12px;
  margin-bottom: 14px;
  border: 1.5px solid color-mix(in srgb, var(--pf-primary) 42%, var(--pf-divider));
  border-radius: 13px;
}
.admin-commission-module .admin-ct-grid .admin-pf-section {
  height: 100%;
  margin-bottom: 0;
  box-sizing: border-box;
}
.admin-commission-module .admin-pf-section-title { gap: 9px; font-size: 17px; }
.admin-commission-module .admin-pf-section-icon { width: 36px; height: 36px; border-radius: 9px; }
.admin-commission-module .admin-pf-section-icon svg { width: 17px; height: 17px; }
.admin-commission-module .admin-ct-grid .admin-pf-section-sub { min-height: 42px; }
.admin-commission-module .admin-pf-section-sub { font-size: 12px; line-height: 1.45; }
.admin-commission-module .admin-pf-rate-panel {
  min-height: 58px;
  padding: 10px 13px;
  border: 1px solid color-mix(in srgb, var(--pf-primary) 28%, var(--pf-divider));
  box-sizing: border-box;
}
.admin-commission-module .admin-pf-rate-panel-label { font-size: 12px; }
.admin-commission-module .admin-pf-rate-panel-value { font-size: 20px; }
.admin-commission-module .admin-ct-grid form { margin-top: auto; }
.admin-commission-module .admin-pf-field { gap: 5px; }
.admin-commission-module .admin-pf-label { font-size: 12px; }
.admin-commission-module .admin-pf-input,
.admin-commission-module .admin-pf-price-wrap {
  min-height: 40px;
  height: 40px;
  border-color: var(--pf-primary);
  border-radius: 9px;
  box-sizing: border-box;
}
.admin-commission-module .admin-pf-input { padding: 0 11px; font-size: 13px; }
.admin-commission-module .admin-pf-price-wrap .admin-pf-input { height: 100%; min-height: 0; }
.admin-commission-module .admin-pf-price-sym { width: 40px; flex-basis: 40px; font-size: 13px; }
.admin-commission-module .admin-pf-input-row { align-items: center; gap: 8px; }
.admin-commission-module .admin-pf-input-row .admin-pf-btn-publish,
.admin-commission-module .admin-pf-input-row .admin-pf-btn-draft {
  min-height: 40px;
  padding: 7px 15px;
  border-radius: 8px;
}
.admin-commission-module .admin-pf-hint { margin: 0; font-size: 11px; line-height: 1.35; }
.admin-commission-module > .admin-pf-section form { gap: 11px !important; }

@media (max-width: 900px) {
  .admin-commission-module .admin-ct-grid { grid-template-columns: minmax(0, 1fr); }
  .admin-commission-module .admin-ct-grid .admin-pf-section-sub { min-height: 0; }
}
@media (max-width: 520px) {
  .admin-commission-module .admin-pf-section { padding: 14px; }
  .admin-commission-module .admin-pf-input-row { align-items: stretch; flex-direction: column; }
}

.admin-returns-module .ret-sidebar {
  min-width: 0;
  padding: 15px;
  border: 1.5px solid var(--accent);
  border-radius: 12px;
}

.admin-returns-module .dsp-info-card {
  min-width: 0;
  border: 1px solid color-mix(in srgb, var(--accent) 30%, var(--border));
}

.admin-returns-module .dsp-detail-row > span:last-child {
  min-width: 0;
  overflow-wrap: anywhere;
  text-align: right;
}

@media (max-width: 1120px) {
  .admin-returns-module .ret-layout--split {
    grid-template-columns: minmax(0, 1fr);
  }

  .admin-returns-module .ret-sidebar {
    position: static;
    max-height: none;
  }
}

@media (max-width: 820px) {
  .admin-returns-module .ret-card-grid,
  .admin-returns-module .ret-layout--split .ret-card-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .admin-returns-module .ret-refund-panel-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 520px) {
  .admin-returns-module .ret-filter-bar {
    align-items: stretch;
  }

  .admin-returns-module .ret-filter-btn {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 7px);
    white-space: normal;
  }

  .admin-returns-module .ret-card-grid,
  .admin-returns-module .ret-layout--split .ret-card-grid,
  .admin-returns-module .ret-refund-panel-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .admin-returns-module .ret-card-actions .ret-action-btn {
    flex: 1 1 100%;
  }
}


/* Coupon form controls: keep their boundaries clear on light backgrounds. */
.cpn-section .cpn-input {
  border: 1.5px solid var(--accent);
  background: var(--bg-secondary);
}

.cpn-section .cpn-input:hover {
  border-color: var(--accent-hover, var(--accent));
}

.cpn-section .cpn-input:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent) 16%, transparent);
}

.cpn-section .cpn-input:disabled {
  opacity: 1;
  border-color: color-mix(in srgb, var(--accent) 42%, var(--border));
  background: var(--bg-tertiary);
  color: var(--text-muted);
}

.cpn-section .cpn-input-suffix {
  border-left-color: var(--accent);
}

.cpn-section .cpn-options {
  border: 1.5px solid var(--accent);
  background: var(--bg-secondary);
}

.cpn-section .cpn-segment {
  border: 1.5px solid var(--accent);
}

.cpn-section .cpn-options-row {
  align-items: flex-start;
}

.cpn-section .cpn-options-row .cpn-submit {
  margin-top: 23px;
  margin-left: auto;
  align-self: flex-start;
}

@media (max-width: 700px) {
  .cpn-section .cpn-options-row .cpn-submit {
    width: 100%;
    margin-top: 4px;
    justify-content: center;
  }
}

/* Keep every coupon column and action inside the All Coupons card. */
.cpn-section .cpn-table-wrap {
  width: 100%;
  min-width: 0;
  overflow: hidden;
}

.cpn-section .cpn-table-header,
.cpn-section .cpn-row {
  min-width: 0;
  grid-template-columns:
    minmax(84px, 1.05fr)
    minmax(78px, 0.9fr)
    minmax(82px, 0.9fr)
    minmax(70px, 0.75fr)
    minmax(66px, 0.7fr)
    minmax(82px, 0.9fr)
    minmax(78px, 0.85fr)
    minmax(196px, 1.55fr);
  gap: 8px;
  padding-left: 12px;
  padding-right: 12px;
}

.cpn-section .cpn-table-header > *,
.cpn-section .cpn-row > * {
  min-width: 0;
}

.cpn-section .cpn-actions {
  justify-content: flex-start;
  flex-wrap: nowrap;
  gap: 5px;
}

.cpn-section .cpn-act {
  min-width: 0;
  padding: 6px 8px;
  white-space: nowrap;
}

@media (max-width: 900px) {
  .cpn-section .cpn-table-header {
    display: none;
  }

  .cpn-section .cpn-row {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px 16px;
    padding: 14px;
  }

  .cpn-section .cpn-actions {
    grid-column: 1 / -1;
    flex-wrap: wrap;
    padding-top: 2px;
  }
}

@media (max-width: 520px) {
  .cpn-section .cpn-row {
    grid-template-columns: minmax(0, 1fr);
  }

  .cpn-section .cpn-actions {
    grid-column: 1;
  }
}

/* ════════════════════════════════════════════════════════════════════════
   Destructive confirmation dialog

   Replaces the old inline "Sure? Yes / No" that expanded inside the row it
   belonged to. That pattern had two problems: it reflowed the card as you
   read it (the row grew, everything below jumped), and its two buttons were
   built from unrelated classes -- \`btn danger\` and \`btn-admin-edit\` -- so
   they disagreed on border, padding, radius and font size. The pair now
   shares one class and differs only in hue.

   Uses the scoped --color-confirm-* tokens; see their note at the top of
   this file for why red/green are permitted here and nowhere else.
   ════════════════════════════════════════════════════════════════════════ */
.confirm-overlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(1, 13, 33, 0.55);
  backdrop-filter: blur(6px);
  animation: confirm-overlay-in 160ms ease-out;
}

.confirm-dialog {
  width: 100%;
  max-width: 440px;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 18px;
  padding: 28px;
  box-shadow: 0 28px 80px rgba(1, 13, 33, 0.32);
  animation: confirm-dialog-in 200ms cubic-bezier(0.16, 1, 0.3, 1);
  text-align: center;
}

@keyframes confirm-overlay-in {
  from { opacity: 0; }
  to   { opacity: 1; }
}

@keyframes confirm-dialog-in {
  from { opacity: 0; transform: translateY(12px) scale(0.97); }
  to   { opacity: 1; transform: none; }
}

/* Respect a reduced-motion preference: the dialog still appears, it just
   doesn't travel. */
@media (prefers-reduced-motion: reduce) {
  .confirm-overlay,
  .confirm-dialog { animation: none; }
}

/* The icon is what carries "this is destructive" for anyone who can't
   separate the two hues -- it is not decorative. */
.confirm-dialog-icon {
  width: 52px;
  height: 52px;
  margin: 0 auto 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-confirm-danger-soft);
  color: var(--color-confirm-danger);
}

.confirm-dialog-title {
  margin: 0 0 8px;
  font-size: 1.12rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--text-primary);
}

.confirm-dialog-message {
  margin: 0 0 26px;
  font-size: 0.9rem;
  line-height: 1.55;
  color: var(--text-secondary);
}

/* Quotes the name of the thing being deleted, so the dialog says what it is
   about to destroy rather than "this item". */
.confirm-dialog-subject {
  font-weight: 600;
  color: var(--text-primary);
}

.confirm-dialog-actions {
  display: flex;
  gap: 12px;
}

/* One class for both buttons. Everything geometric lives here so the pair
   can never drift apart again; the modifiers below set colour only. */
.confirm-btn {
  flex: 1 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;
  padding: 12px 18px;
  border: 1.5px solid transparent;
  border-radius: var(--radius-sm);
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition: background 150ms ease, border-color 150ms ease, transform 120ms ease;
}

.confirm-btn:active { transform: translateY(1px); }

.confirm-btn:focus-visible {
  outline: 2px solid var(--color-focus-ring);
  outline-offset: 2px;
}

.confirm-btn-cancel {
  background: var(--color-confirm-safe);
  border-color: var(--color-confirm-safe);
  color: var(--color-confirm-on-fill);
}

.confirm-btn-cancel:hover {
  background: var(--color-confirm-safe-hover);
  border-color: var(--color-confirm-safe-hover);
}

.confirm-btn-danger {
  background: var(--color-confirm-danger);
  border-color: var(--color-confirm-danger);
  color: var(--color-confirm-on-fill);
}

.confirm-btn-danger:hover {
  background: var(--color-confirm-danger-hover);
  border-color: var(--color-confirm-danger-hover);
}

@media (max-width: 420px) {
  .confirm-dialog { padding: 24px 20px; }
  /* Stack reversed so the safe option sits under the thumb. */
  .confirm-dialog-actions { flex-direction: column-reverse; }
}

/* ════════════════════════════════════════════════════════════════════════
   Admin chrome polish

   Additive and scoped to admin surfaces. Nothing here introduces a colour:
   every value is an existing brand token, a transparency of one, or a
   geometry change. The goal is that the dashboard reads as one considered
   system rather than a set of screens built at different times.

   Four things were inconsistent across the admin screens:
     1. Row action buttons disagreed on height, radius and transition, so a
        row of Edit / Hide / Delete sat on three different baselines.
     2. Focus styling was inherited from the browser in most places, which
        is the most visible "unfinished" tell on an internal tool.
     3. Elevation was a single flat shadow, so cards read as stickers on the
        page rather than surfaces above it.
     4. Headings used default tracking, which looks loose at large sizes.
   ════════════════════════════════════════════════════════════════════════ */

/* ── 1. One geometry for every row action ──────────────────────────────── */
.admin-banner-action,
.cpn-act,
.btn-admin-edit,
.admin-product-delete-btn {
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 10px;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  /* Transform is included so the press feedback below is smooth, and the
     shorthand replaces three separate per-class transition declarations
     that had drifted to different durations. */
  transition: background 160ms ease, border-color 160ms ease, color 160ms ease,
              transform 120ms ease, box-shadow 160ms ease;
}

/* A press should feel mechanical. 1px is enough to register and small
   enough not to disturb the row. */
.admin-banner-action:active,
.cpn-act:active,
.btn-admin-edit:active,
.admin-product-delete-btn:active {
  transform: translateY(1px);
}

/* ── 2. A single, visible focus treatment ──────────────────────────────── */
/* :focus-visible rather than :focus, so a mouse click doesn't leave a ring
   behind but keyboard navigation is always obvious. */
.admin-banner-action:focus-visible,
.cpn-act:focus-visible,
.btn-admin-edit:focus-visible,
.admin-product-delete-btn:focus-visible,
.cpn-segment button:focus-visible,
.cpn-submit:focus-visible,
.admin-page-btn:focus-visible {
  outline: 2px solid var(--color-focus-ring);
  outline-offset: 2px;
}

/* ── 3. Layered elevation ──────────────────────────────────────────────── */
/* Two shadows instead of one: a tight contact shadow that anchors the card
   to the page, plus a wider, softer ambient shadow. A single blurred shadow
   reads as a halo; the pair reads as depth. */
.admin-content .cpn-card,
.admin-content .admin-banner-editor-compact {
  box-shadow:
    0 1px 2px rgba(1, 13, 33, 0.05),
    0 8px 24px -12px rgba(1, 13, 33, 0.18);
  transition: box-shadow 220ms ease, border-color 220ms ease;
}

.admin-content .cpn-card:hover,
.admin-content .admin-banner-editor-compact:hover {
  box-shadow:
    0 1px 2px rgba(1, 13, 33, 0.06),
    0 16px 40px -16px rgba(1, 13, 33, 0.24);
}

/* On the navy canvas a drop shadow is nearly invisible, so depth comes from
   a light hairline along the top edge instead: the same trick a physical
   bevel uses, and it survives against a dark background where a shadow
   does not. */
[data-theme="dark"] .admin-content .cpn-card,
[data-theme="dark"] .admin-content .admin-banner-editor-compact {
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.05),
    0 12px 32px -16px rgba(0, 0, 0, 0.6);
}

/* ── 4. Heading tracking ───────────────────────────────────────────────── */
/* Type set at display sizes looks loose at default tracking. Tightening
   slightly is one of the cheapest ways to make an interface read as
   deliberate; the effect is invisible individually and obvious in
   aggregate. Body text is left alone, where tight tracking hurts. */
.admin-page-title,
.admin-section h2,
.cpn-card-title,
.confirm-dialog-title {
  letter-spacing: -0.015em;
}

/* ── 5. Row hover ──────────────────────────────────────────────────────── */
/* The banner and coupon lists are scannable rows; a hover tint makes the
   row you are about to act on unambiguous, which matters when the action
   at the end of it is Delete. */
.admin-content .cpn-row-item:hover,
.admin-content .admin-banner-row:hover {
  background: var(--color-surface-hover);
}

/* ── 6. Respect reduced motion ─────────────────────────────────────────── */
@media (prefers-reduced-motion: reduce) {
  .admin-banner-action,
  .cpn-act,
  .btn-admin-edit,
  .admin-product-delete-btn,
  .admin-content .cpn-card,
  .admin-content .admin-banner-editor-compact {
    transition: none;
  }
  .admin-banner-action:active,
  .cpn-act:active,
  .btn-admin-edit:active,
  .admin-product-delete-btn:active {
    transform: none;
  }
}

/* ════════════════════════════════════════════════════════════════════════
   Checkout redesign (steps 2 and 3)

   Shared vocabulary for both checkout screens, so the two steps read as one
   flow rather than two pages that happen to follow each other:

     .co-panel            a titled card, the unit both columns are built from
     .co-field-label      the small bold label above a control group
     .co-protection-note  the blue reassurance strip above each CTA
     .co-under-cta        the quiet line under a CTA saying what happens next

   Every colour here is a brand token or a transparency of one.
   ════════════════════════════════════════════════════════════════════════ */

/* ── Trust bar ─────────────────────────────────────────────────────────────
   Sits above the header and is navy in BOTH themes, so its text uses
   --color-on-navy*, which never flips, rather than --text-*, which is navy in
   light mode and would disappear here. */
.checkout-trustbar {
  background: var(--color-brand-navy);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.checkout-trustbar-inner {
  width: min(1120px, calc(100% - 32px));
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(18px, 6vw, 72px);
  padding: 10px 0;
}

.ctb-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: var(--color-on-navy);
  white-space: nowrap;
}

.ctb-item svg {
  color: var(--color-on-navy-secondary);
  flex-shrink: 0;
}

/* Below ~640px three items no longer fit on one line. Dropping the third
   keeps the bar to a single row rather than letting it wrap into a block that
   pushes the header down the page. */
@media (max-width: 640px) {
  .checkout-trustbar-inner { gap: 20px; padding: 8px 0; }
  .ctb-item { font-size: 0.74rem; }
  .ctb-item:last-child { display: none; }
}

/* ── Panels ───────────────────────────────────────────────────────────── */
.co-panel {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 1px 2px rgba(1, 13, 33, 0.04), 0 10px 30px -18px rgba(1, 13, 33, 0.2);
}

[data-theme="dark"] .co-panel {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04), 0 12px 32px -18px rgba(0, 0, 0, 0.6);
}

.co-panel-title {
  margin: 0 0 18px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--color-border);
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: -0.015em;
  color: var(--text-primary);
}

.co-field-label {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 0 0 10px;
  font-size: 0.86rem;
  font-weight: 700;
  color: var(--text-primary);
}

.co-optional {
  font-weight: 400;
  color: var(--text-muted);
  font-size: 0.8rem;
}

/* ── Mobile money number ──────────────────────────────────────────────────
   Shown under the online-payment card once it is selected. The prompt goes to
   whatever number is typed here, which is often not the delivery number, so
   the field has to be visible rather than assumed.

   Blue for the focus ring, not orange: this is secondary interaction, and
   orange is reserved for the commercial action -- the Place Order button sits
   directly below and must stay the only orange thing in view. */
.payment-method-phone {
  margin: 12px 0 2px;
  padding: 14px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--bg-secondary);
}

.co-input {
  width: 100%;
  box-sizing: border-box;
  padding: 11px 13px;
  font: inherit;
  font-size: 0.94rem;
  color: var(--text-primary);
  background: var(--bg-primary);
  border: 1.5px solid var(--border);
  border-radius: 10px;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.co-input::placeholder { color: var(--text-muted); }

.co-input:focus {
  outline: none;
  border-color: var(--color-secondary);
  box-shadow: 0 0 0 3px var(--color-secondary-soft);
}

/* Keyboard users get the same ring the mouse path gets -- :focus above is
   removed from the outline, so this must not rely on the browser default. */
.co-input:focus-visible {
  outline: 2px solid var(--color-secondary);
  outline-offset: 1px;
}

.co-field-hint {
  margin: 8px 0 0;
  font-size: 0.78rem;
  line-height: 1.45;
  color: var(--text-muted);
}

@media (prefers-reduced-motion: reduce) {
  .co-input { transition: none; }
}

/* ── Selected payment method ──────────────────────────────────────────────
   Cash on delivery is the only method, so this confirms rather than chooses.
   It still carries a radio and a chip: without them the card is just a
   paragraph, and nothing signals that a payment method has been settled. */
/* The two selectable methods, shown only when online payment is on.
   Deliberately the same geometry as .co-selected below, so choosing one
   changes its colour and its marker and nothing else -- carrying the base
   card's 2px border and 18px/20px padding, the chosen card visibly jumped as
   it was picked.

   Declared ABOVE .co-selected on purpose: a chosen card carries both classes,
   the two selectors are the same specificity (0,2,0), and source order is the
   only thing that decides which colours win. */
.payment-method-card.co-choice {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  border: 1.5px solid var(--border);
  background: var(--bg-secondary);
  border-radius: 14px;
  padding: 16px 18px;
}

/* flex-wrap is the same insurance the mobile layer takes, and for the same
   reason -- see the note on this pair in mobile/screens.css. There is far more
   room here (a 589px card at 1280px against 314px on a phone), so nothing wraps
   at any label length we have; it is here so that a long one degrades the same
   way on both instead of only being handled on phones. */
.payment-method-card.co-selected {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  border: 1.5px solid var(--color-secondary);
  background: var(--color-secondary-soft);
  border-radius: 14px;
  padding: 16px 18px;
}

/* The method name. Takes the slack so the chip is pushed to the far edge
   without needing a margin of its own, and min-width:0 lets it wrap on a word
   boundary at the narrowest screens instead of holding the row open. */
.co-selected-title {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
}

/* Size only -- every marker in these cards, chosen or not. An 18px ring beside
   a 1rem title read as an unticked checkbox rather than a radio. */
.payment-method-card.co-selected .co-radio,
.payment-method-card.co-choice .co-radio {
  width: 26px;
  height: 26px;
  min-width: 26px;
  margin-top: 0;
  align-self: center;
}

/* The filled disc is for the chosen one ONLY. Scoped to .co-radio-on rather
   than to the card, because in the chooser an unchosen card also has a marker
   and it must stay a hollow ring -- filling both is what would turn a choice
   into two identical ticks. */
.payment-method-card.co-selected .co-radio-on,
.payment-method-card.co-choice .co-radio-on {
  border: none;
  background: var(--color-secondary);
}

/* The check: two sides of a box, rotated. The base rule draws a centred dot
   here (inset:3px, a 50% radius and a fill), so each of those is reset rather
   than overridden piecemeal -- inset:auto has to come first, or the top/left
   below it would be the thing that gets ignored. */
.payment-method-card.co-selected .co-radio-on::after,
.payment-method-card.co-choice .co-radio-on::after {
  content: "";
  position: absolute;
  inset: auto;
  top: 5px;
  left: 9px;
  width: 5px;
  height: 10px;
  border: solid var(--color-text-on-secondary);
  border-width: 0 2px 2px 0;
  border-radius: 0;
  background: none;
  transform: rotate(45deg);
}

.co-radio {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-top: 2px;
  border-radius: 50%;
  border: 2px solid var(--color-secondary);
  display: inline-block;
  position: relative;
}

.co-radio-on::after {
  content: "";
  position: absolute;
  inset: 3px;
  border-radius: 50%;
  background: var(--color-secondary);
}

.co-selected-chip {
  flex-shrink: 0;
  align-self: center;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid var(--color-secondary);
  background: var(--color-surface);
  color: var(--color-secondary-text);
  font-size: 0.76rem;
  font-weight: 700;
  white-space: nowrap;
}

/* The phone-width rules that used to live here -- wrapping the row, giving
   the copy column a 190px flex-basis, dropping the chip onto its own line --
   are gone with the blurb they existed for. The card is now a marker, a short
   title and a chip: at 320px that is roughly 236px of content, so there is
   nothing left to wrap and no width for the chip to steal.

   The .co-cod-features block (three icon-and-label reassurances, app only)
   went at the same time. Worth recording why rather than just deleting it: as
   a fourth child it landed in the first column of the mobile layer's
   three-column grid, sized that \`auto\` track to its own width, and left the
   copy track -- minmax(0, 1fr) -- at exactly zero, which set the title one
   character per line down an 816px-tall card. */

/* ── Checkout runs to the screen edge on mobile ───────────────────────────
   Two nested paddings stood between the cards and the glass: .checkout-step-pad
   contributes 20px a side and .checkout-container another 30px, so on a 390px
   screen the cards had 290px to work with and every long label inside them --
   the coupon placeholder, "Amount Payable on Delivery" -- was wrapping or
   truncating for want of room that the gutters were holding.

   Those gutters are a desktop device: they stop an 800px column from touching
   a 1400px viewport. On a phone the viewport *is* the column, so the padding
   buys nothing and costs 100px of every row.

   Going full-bleed means the panels also drop the chrome that only reads
   correctly when a card floats: side borders, corner radius, and the outer
   container's shadow. Horizontal rules between stacked panels do the
   separating instead, which is what a phone list wants anyway. Vertical
   padding is untouched -- this is about width, not density. */
html.m-app .checkout-step-pad {
  padding-left: 0;
  padding-right: 0;
}

html.m-app .checkout-container,
html.m-app .order-summary-container {
  width: 100%;
  max-width: none;
  padding-left: 0;
  padding-right: 0;
  border-left: 0;
  border-right: 0;
  border-radius: 0;
  box-shadow: none;
}

/* The two-column variant sets width: min(1120px, calc(100% - 32px)), which is
   a *width* constraint rather than padding and so survived zeroing the paddings
   above -- it was the last 16px a side. Matched with the :has() included so
   this outranks it on specificity instead of relying on source order, which
   is what the plain rule above lost on. */
html.m-app .checkout-container:has(.checkout-side) {
  width: 100%;
  max-width: none;
  gap: 0;
}

/* The panels themselves reach the edge. Each keeps a small inner padding so
   text is never quite against the glass, and a top border replaces the boxed
   look as the divider between one panel and the next.

   18px, down from the 20-30px these carried. The panels going full-bleed only
   moved the outer gutters; the inner padding was still holding content in by
   that much again on each side.

   14px was the first attempt and it read as content spilling off the screen --
   text with almost nothing between it and the bezel has no margin for the
   eye to rest against, and on a rounded display it looks like an overflow bug
   rather than a layout choice. 18px keeps the width won by going full-bleed
   while giving the text an edge to sit against. */
html.m-app .co-panel,
html.m-app .cod-order-recap,
html.m-app .cod-address-recap,
html.m-app .cod-payment-section,
html.m-app .summary-left {
  border-radius: 0;
  border-left: 0;
  border-right: 0;
  box-shadow: none;
  padding-left: 18px;
  padding-right: 18px;
}

/* Nested cards inside those panels -- the selected payment method and the
   "N additional items" row -- were each adding their own inset on top of the
   panel's, so content sat ~32px from the edge behind two card borders. Kept
   slightly tighter than the panel so the nesting still reads. */
html.m-app .payment-method-card.co-selected,
html.m-app .co-more-items {
  padding-left: 14px;
  padding-right: 14px;
}

/* ── Checkout type, corrected for the mobile layer's larger root ───────────
   These are not layout bugs like the card above -- they are sizes that were
   right at a 16px root and got carried up by the mobile layer's 18px one, so
   they are pulled back wherever that root applies. That is now the app and
   the phone browser alike; the desktop site is unaffected either way.

   The coupon field is the clearest case: it sets Courier New with 0.08em of
   extra tracking, so at 0.95rem it rendered 17.1px of monospace and the
   placeholder was cut to "Enter cou". Monospace is much wider per character
   than the sans everything else uses, which is why this one field broke while
   the fields around it did not.

   The summary total is the other: an 18.9px label beside a 21.2px amount in a
   space-between row left the label wrapping onto three lines. Holding the
   amount on one line keeps the wrapping in the label, where it reads. */
/* ── Address block ────────────────────────────────────────────────────────
   The heading and the Change button shared a row with the address itself, so
   the button hung off the side of a four-line block and the whole thing sat
   in a tinted box inside an already-bordered panel.

   Change moves up beside "Delivering to:", which is the row it belongs to --
   it acts on the address, it is not part of it. The address then reads as a
   plain block with room to breathe, and one nested box disappears. */
/* Change sits at the top-right of the address, on the same line as the name
   it acts on, rather than stranded on its own row underneath four lines of
   address. It is a control over the block, not another line of it.

   Laid out on .address-display because that is where the button actually
   lives in the markup -- it is a sibling of .address-info, not of the
   heading, so placing it from .address-section (the first attempt) moved
   nothing at all. */
html.m-app .address-display {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  column-gap: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  background: var(--color-surface-subtle);
}

html.m-app .address-info { grid-column: 1; min-width: 0; }

html.m-app .co-change-btn {
  grid-column: 2;
  grid-row: 1;
  align-self: start;
  white-space: nowrap;
}

/* The address is four short lines; default paragraph spacing made it twice as
   tall as it needed to be. */
html.m-app .address-info p { margin: 0 0 3px; line-height: 1.45; }
html.m-app .address-info p:last-child { margin-bottom: 0; }

/* ── Coupon group gets its own room ───────────────────────────────────────
   The panel flattens its sub-sections to plain groups (see the .co-panel
   rules further down), which is right for the notes field but left the coupon
   control sitting flush against the panel's own padding with nothing marking
   it as a thing you interact with. A light surface and a little padding give
   it back the space without reinstating the bordered card-in-a-card. */
html.m-app .co-panel .coupon-section {
  padding: 14px;
  border-radius: 12px;
  background: var(--color-surface-subtle);
}

/* ── Trust bar and the order-protection note, pulled in ───────────────────
   The trust bar sizes itself with width: min(1120px, calc(100% - 32px)),
   which put it at 16px a side while every panel below it sits at 18px -- a
   two-pixel disagreement down the whole page. Matching them lines the top
   strip up with the content it introduces.

   The protection note was a full-width tinted bar carrying a sentence in
   semibold: at that width it competed with the Place Order button directly
   beneath it, when its job is to reassure quietly. Lighter weight, smaller
   text and tighter padding put it back in a supporting role. */
html.m-app .checkout-trustbar-inner {
  width: 100%;
  padding-left: 32px;
  padding-right: 32px;
  box-sizing: border-box;
  gap: clamp(12px, 4vw, 32px);
}

/* ── The CTA and its two notes line up with the amount, not the panel ─────
   These were already flush with the summary panel's outer edge at 18px. The
   trouble is that the panel is not what the eye compares them to: the payable
   total sits inside a tinted box with its own 14px of padding, so the figure
   reads at 32px while a full-width button reads at 18px. Same panel, two
   different left edges, and the button looks like it overhangs.

   Matching the inner box puts the button, the protection note and the trust
   strip on the same line as the number they refer to. 32px = the panel's 18
   plus that box's 14. */
html.m-app .btn-place-order,
html.m-app .co-protection-note,
html.m-app .co-under-cta {
  margin-left: 14px;
  margin-right: 14px;
  width: auto;
}

/* The 14px sides match the CTA above -- both sit on the payable total's inner
   edge rather than the panel's. Written as one shorthand because an earlier
   \`margin: 14px 0 12px\` here silently reset the horizontal margin set further
   up the file, leaving this note flush at 18px while the button moved to 32. */
html.m-app .co-protection-note {
  margin: 14px 14px 12px;
  padding: 9px 12px;
  font-size: 0.72rem;
  font-weight: 500;
  line-height: 1.35;
}

/* ── Coupon row, evened up ────────────────────────────────────────────────
   The field and the Apply button were different heights because each was
   sized by its own padding rather than to a shared measure -- the input's
   10px vertical plus its border came out taller than the button's. Both now
   take the same explicit height, so they read as one control.

   The ticket glyph in front of the field goes: at this width it cost ~24px of
   a row that has a field and a button to fit, and it labelled something the
   heading ("Have a coupon?") and the placeholder already name twice. */
html.m-app .coupon-ticket-icon { display: none; }

html.m-app .coupon-input-row {
  align-items: stretch;
  gap: 8px;
}

html.m-app .coupon-input {
  height: 42px;
  box-sizing: border-box;
  padding: 0 12px;
  font-size: 0.8rem;
  letter-spacing: 0.04em;
}

html.m-app .coupon-apply-btn {
  height: 42px;
  box-sizing: border-box;
  padding: 0 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

html.m-app .price-row {
  font-size: 0.85rem;
  gap: 12px;
}

/* The payable amount is the one number the shopper is deciding on, so in the
   app it gets its own tinted panel instead of being another row in the list.
   align-items: center keeps the figure optically centred against a label that
   wraps to two lines, which is the normal case at this width. */
html.m-app .price-row.total {
  align-items: center;
  font-size: 0.92rem;
  margin-top: 14px;
  padding: 12px 14px;
  border-top: 0;
  border-radius: var(--radius-sm);
  background: var(--color-surface-subtle);
}

/* Blue, not navy: this is the figure the eye should land on first, and blue
   is the palette's informational hue. It stays a fill-free colour on a tinted
   surface, where --color-secondary-text clears AA comfortably. */
html.m-app .price-row.total span:last-child {
  font-size: 1.18rem;
  font-weight: 800;
  white-space: nowrap;
  color: var(--color-secondary-text);
}

/* ── Coupon row ───────────────────────────────────────────────────────── */
.coupon-input-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.coupon-ticket-icon {
  display: inline-flex;
  color: var(--text-muted);
  flex-shrink: 0;
}

.coupon-input-row .coupon-input {
  flex: 1 1;
  min-width: 0;
}

/* ── Reward points ────────────────────────────────────────────────────────
   Orange because redeeming points is a commercial action, which is the role
   orange carries in this system. The balance is the reason to opt in, so it
   is the largest thing in the block. */
.co-points-row {
  display: flex;
  align-items: center;
  gap: 18px;
  flex-wrap: wrap;
}

.co-points-card {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  border-radius: 14px;
  border: 1.5px solid var(--color-primary);
  background: var(--color-primary-soft);
}

.co-points-medal {
  display: inline-flex;
  color: var(--color-primary);
}

.co-points-figures {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
}

.co-points-count {
  font-size: 1.05rem;
  font-weight: 800;
  color: var(--color-primary);
  letter-spacing: -0.01em;
}

.co-points-value {
  font-size: 0.78rem;
  color: var(--text-secondary);
}

.co-points-opt {
  flex: 1 1;
  min-width: 190px;
}

.co-points-opt .rewards-redeem-toggle { margin: 0 0 4px; }
.co-points-opt .rewards-redeem-hint { margin: 0; }

/* ── Delivering-to header with Change ─────────────────────────────────── */
.co-recap-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.co-recap-head h3 {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 7px;
}

.co-change-btn {
  flex-shrink: 0;
  padding: 6px 14px;
  border-radius: 9px;
  border: 1px solid var(--color-secondary);
  background: transparent;
  color: var(--color-secondary-text);
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 150ms ease, color 150ms ease;
}

.co-change-btn:hover {
  background: var(--color-secondary);
  color: var(--color-text-on-secondary);
}

.co-change-btn:focus-visible {
  outline: 2px solid var(--color-focus-ring);
  outline-offset: 2px;
}

/* ── Collapsed extra items ────────────────────────────────────────────── */
.co-more-items {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px;
  margin-top: 12px;
  border: 1px solid var(--color-border);
  border-radius: 14px;
  background: var(--color-surface-subtle);
}

.co-more-thumbs {
  display: flex;
  flex-shrink: 0;
}

.co-more-thumb {
  width: 42px;
  height: 42px;
  object-fit: cover;
  border-radius: 9px;
  border: 2px solid var(--color-surface);
  background: var(--color-surface);
}

/* Overlap the stack so a long cart reads as one group rather than a row of
   loose thumbnails competing with the item above it. */
.co-more-thumb + .co-more-thumb { margin-left: -12px; }

.co-more-text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.co-more-count {
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--text-primary);
}

.co-more-sub {
  font-size: 0.78rem;
  color: var(--text-muted);
}

.co-more-price {
  font-weight: 700;
  color: var(--text-primary);
  white-space: nowrap;
}

.co-more-btn {
  flex-shrink: 0;
  padding: 8px 16px;
  border-radius: 9px;
  border: 1px solid var(--color-secondary);
  background: transparent;
  color: var(--color-secondary-text);
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 150ms ease, color 150ms ease;
}

.co-more-btn:hover {
  background: var(--color-secondary);
  color: var(--color-text-on-secondary);
}

.co-more-btn:focus-visible {
  outline: 2px solid var(--color-focus-ring);
  outline-offset: 2px;
}

@media (max-width: 560px) {
  /* This row is thumbnails, a two-line description, a price and a button. On a
     phone they cannot all share a line, and the previous wrap left the
     description as the only flexible item -- with min-width:0 it shrank to its
     narrowest, setting "3 additional items" and "Included in this order" one
     word per line and stretching the card to five times its height.

     A floor on the description is what fixes it: it may shrink, but not below
     a width that still reads as a sentence. The button then takes a row of its
     own rather than competing for what is left. */
  .co-more-items { flex-wrap: wrap; }
  .co-more-text { flex: 1 1 auto; min-width: 130px; }
  .co-more-price { margin-left: auto; }
  .co-more-btn { flex: 1 1 100%; margin-left: 0; text-align: center; }
}

/* ── Reassurance strip and CTA sub-line ───────────────────────────────── */
.co-protection-note {
  display: flex;
  align-items: center;
  gap: 9px;
  margin: 18px 0 14px;
  padding: 11px 14px;
  border-radius: 11px;
  background: var(--color-secondary-soft);
  color: var(--color-secondary-text);
  font-size: 0.81rem;
  font-weight: 600;
  line-height: 1.4;
}

.co-protection-note svg { flex-shrink: 0; }

.co-under-cta {
  margin: 10px 0 0;
  text-align: center;
  font-size: 0.78rem;
  color: var(--text-muted);
}

/* The CTA now carries an icon and a total, so it has to lay them out. */
.btn-place-order {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
}

/* ── Stepper, tightened to sit with the rest ──────────────────────────── */
.checkout-steps {
  padding: 18px 40px 4px;
  margin-bottom: 28px;
}

.step-number {
  width: 38px;
  height: 38px;
  font-size: 0.95rem;
}

.step:not(:last-child)::after {
  top: 18px;
  left: calc(50% + 22px);
  width: calc(100% - 44px);
}

.step.completed .step-number { font-size: 1rem; }
.step-label { font-size: 0.85rem; }

@media (max-width: 640px) {
  .checkout-steps { padding: 14px 8px 2px; }
  .step-number { width: 32px; height: 32px; font-size: 0.85rem; }
  .step:not(:last-child)::after {
    top: 15px;
    left: calc(50% + 19px);
    width: calc(100% - 38px);
  }
  .step-label { font-size: 0.72rem; text-align: center; }
}

/* ── Payment step: two columns ────────────────────────────────────────────
   .checkout-container was an 800px single-column card holding everything
   stacked: payment method, notes, coupon, points, then the order summary,
   the address and the commit button underneath. On that layout the total a
   shopper is agreeing to sat below the fold, past the controls that change
   it, so committing meant scrolling back up to check the number.

   The payment step now splits into a form column and a sticky rail. Scoped
   with :has() to the step that actually has a rail, so the address step's
   own container width is untouched. */
.checkout-container:has(.checkout-side) {
  width: min(1120px, calc(100% - 32px));
  max-width: 1120px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);
  gap: 24px;
  align-items: start;
  /* The columns are cards in their own right now, so the wrapper stops
     being one. */
  background: transparent;
  border: none;
  box-shadow: none;
  padding: 0;
  max-width: 1120px;
}

/* The form column was centred at 560px for the single-column layout; inside
   a grid track it should simply fill its column. */
.checkout-container:has(.checkout-side) .cod-payment-section {
  max-width: none;
  margin: 0;
}

.checkout-side {
  display: flex;
  flex-direction: column;
  position: sticky;
  /* Clears the sticky site header so the rail doesn't slide under it. */
  top: 88px;
}

.checkout-side .cod-order-recap,
.checkout-side .cod-address-recap {
  margin-bottom: 16px;
}

.checkout-side .co-protection-note { margin-top: 0; }

/* Below the two-column breakpoint the rail stops being a rail: sticky
   positioning on a stacked column just pins it mid-scroll. */
@media (max-width: 900px) {
  .checkout-container:has(.checkout-side) {
    grid-template-columns: minmax(0, 1fr);
  }
  .checkout-side { position: static; }
}

/* Fallback for engines without :has(). They keep the previous single-column
   card, which is the layout that shipped before this change rather than a
   broken one. Firefox gained :has() in 121 and Safari in 15.4, so this is a
   narrow tail. */
@supports not selector(:has(*)) {
  .checkout-side { position: static; }
}

/* ── Flatten the sub-sections inside the payment panel ────────────────────
   .order-notes-section, .coupon-section and .rewards-redeem-section were
   each styled as their own bordered grey card, from when the payment step
   was one narrow column and those boxes were what separated the controls.
   Inside .co-panel that nests a card in a card, and the uppercase headings
   read as three competing titles alongside the panel's own.

   They become plain groups here: the panel supplies the frame, .co-field-label
   supplies the heading. Scoped to .co-panel so the same classes keep their
   previous look anywhere else they are used. */
.co-panel .order-notes-section,
.co-panel .coupon-section,
.co-panel .rewards-redeem-section {
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 0;
  margin-top: 22px;
}

/* The label is sentence case and sits directly above its control. The
   uppercase treatment came from the old section-card headings. */
.co-panel .co-field-label,
.co-panel .order-notes-section h3,
.co-panel .coupon-section h3,
.co-panel .rewards-redeem-section h3 {
  text-transform: none;
  letter-spacing: normal;
  font-size: 0.86rem;
  font-weight: 700;
  color: var(--text-primary);
}

/* Same reason: the coupon field inherited an uppercase, letter-spaced
   placeholder from the boxed treatment. */
.co-panel .coupon-input,
.co-panel .coupon-input::placeholder {
  text-transform: none;
  letter-spacing: normal;
}

/* The panel already carries the outer border, so the first group under the
   title should not add a second rule line above itself. */
.co-panel .order-notes-section:first-of-type { margin-top: 0; }

/* ── Flatten the Order Summary panel ──────────────────────────────────────
   .address-section and .order-items-section were each their own bordered,
   shadowed card, from when .summary-left was a bare column and those boxes
   were what gave the step structure. Inside .co-panel that stacks four
   frames deep: panel > section card > grey .order-items wrapper > item card.

   The panel is the frame now. The address box and the item cards keep their
   own borders, because those are the things a shopper actually picks out;
   the containers between them do not need to be visible at all.

   Scoped to .summary-left.co-panel, so .address-section keeps its previous
   card treatment on the address step, which still uses it standalone. */
.summary-left.co-panel .address-section,
.summary-left.co-panel .order-items-section {
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
}

/* The sections are siblings in a flex column with its own gap, so their old
   card margins would now double the spacing. */
.summary-left.co-panel .address-section { margin-bottom: 4px; }

/* The list wrapper was tinted to separate it from the page. Against the
   panel it just adds a fifth surface behind the item cards. */
.summary-left.co-panel .order-items {
  background: transparent;
  border: none;
  padding: 0;
}

/* Section headings inside the panel follow the same rule as step 3: sentence
   case, sitting directly above their content, with the panel title as the
   only display-weight heading on the card. */
.summary-left.co-panel .address-section h3,
.summary-left.co-panel .order-items-section h3 {
  text-transform: none;
  letter-spacing: normal;
  font-size: 0.86rem;
  font-weight: 700;
  color: var(--text-primary);
}

/* Price Details carries both .price-details and .co-panel, which each supply
   a background, border and padding. Let .co-panel own the frame so the two
   columns are built from the same thing. */
.summary-right .price-details.co-panel {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
}

/* ── Per-size stock breakdown (admin product form) ────────────────────────
   Tracking stock per size exists so a seller can see which size is running
   out while the others are fine; a single total hides precisely that. These
   chips sit under the total and name each level's count.

   Low and sold-out use the same tones as the status dot above them: orange
   for "needs attention", muted navy for "gone". Each chip also states its
   count in words, so the state never rests on colour alone. */
.admin-pf-stock-breakdown {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.admin-pf-stock-chip {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  padding: 5px 11px;
  border-radius: 999px;
  border: 1px solid var(--color-border);
  background: var(--color-surface-subtle);
  font-size: 0.76rem;
  color: var(--text-secondary);
  white-space: nowrap;
}

.admin-pf-stock-chip strong {
  font-weight: 700;
  color: var(--text-primary);
}

.admin-pf-stock-chip.is-low {
  border-color: var(--color-primary);
  background: var(--color-primary-soft);
  color: var(--color-primary);
}

.admin-pf-stock-chip.is-low strong { color: var(--color-primary); }

.admin-pf-stock-chip.is-out {
  color: var(--text-muted);
  border-style: dashed;
}

.admin-pf-stock-chip.is-out strong { color: var(--text-muted); }

/* The total is derived in this state, so it should not look typeable. */
.admin-pf-qty-input[readonly] {
  background: var(--color-surface-subtle);
  cursor: default;
}

.admin-pf-qty-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ── Mobile marketplace checkout finish ──────────────────────────────────
   These rules complete the shared checkout language across the address,
   review and payment steps while preserving the existing DOM and behavior. */
.checkout-address-container .address-section,
.checkout-address-container .address-form-section {
  width: 100%;
  box-sizing: border-box;
}

.checkout-address-container .address-display {
  border: 1px solid var(--color-border);
  background: var(--color-surface-subtle);
  border-radius: var(--radius-md);
  padding: 18px;
  transition: border-color 180ms ease, box-shadow 180ms ease, background 180ms ease;
}

.checkout-address-container .address-display:hover {
  border-color: var(--color-secondary);
  box-shadow: 0 10px 28px -20px color-mix(in srgb, var(--color-brand-navy) 38%, transparent);
}

.co-address-detail,
.co-address-note,
.zone-check-status {
  display: flex;
  align-items: flex-start;
  gap: 7px;
}

.co-address-detail svg,
.co-address-note svg,
.zone-check-status svg {
  flex: 0 0 auto;
  margin-top: 3px;
}

.co-address-detail { color: var(--text-secondary); }

.co-address-note {
  margin-top: 8px !important;
  padding: 9px 10px;
  border-left: 3px solid var(--color-secondary);
  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
  background: var(--color-secondary-soft);
  color: var(--text-secondary);
}

.zone-check-status {
  margin-top: 10px !important;
  padding-top: 10px;
  border-top: 1px solid var(--color-border);
  font-weight: 700;
}

.fi-qty-arrow {
  display: inline-flex;
  align-items: center;
  pointer-events: none;
}

.dmp-locate-btn,
.ab-cancel-btn,
.ab-default-badge,
.brands-card-logo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
}

.co-panel,
.fi-item,
.payment-method-card,
.checkout-del-opt,
.co-more-items,
.address-display,
.coupon-input,
.order-notes-input,
.co-change-btn,
.co-more-btn,
.coupon-apply-btn,
.btn-place-order {
  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease,
    background-color 180ms ease, color 180ms ease, opacity 180ms ease;
}

.payment-method-card[style*="cursor: pointer"]:hover,
.checkout-del-opt:hover,
.fi-item:hover,
.co-more-items:hover {
  border-color: var(--color-secondary);
  box-shadow: 0 12px 30px -22px color-mix(in srgb, var(--color-brand-navy) 42%, transparent);
}

.payment-method-card[style*="cursor: pointer"]:active,
.checkout-del-opt:active,
.co-change-btn:active,
.co-more-btn:active,
.coupon-apply-btn:active,
.btn-place-order:active {
  transform: scale(0.985);
}

.coupon-input:focus,
.order-notes-input:focus {
  border-color: var(--color-secondary);
  box-shadow: 0 0 0 3px var(--color-secondary-soft);
  outline: none;
}

@media (max-width: 640px) {
  .checkout-address-container {
    padding: 0;
  }

  .checkout-address-container > .address-section,
  .checkout-address-container > .address-form-section {
    padding: 22px 18px 28px;
    border-radius: 0;
  }

  .checkout-address-container h2 {
    margin-bottom: 16px;
    font-size: 1.1rem;
    letter-spacing: -0.015em;
  }

  .checkout-address-container .form-row {
    grid-template-columns: 1fr;
  }

  html.m-app .co-panel-title {
    margin-bottom: 16px;
    padding-bottom: 12px;
  }

  html.m-app .payment-method-card.co-selected {
    border-width: 1px;
    background: linear-gradient(135deg, var(--color-secondary-soft), var(--color-surface));
  }

  html.m-app .price-row.total {
    box-shadow: inset 3px 0 0 var(--color-secondary);
  }

  html.m-app .btn-place-order {
    min-height: 50px;
    border-radius: 12px;
    box-shadow: 0 12px 24px -16px color-mix(in srgb, var(--color-primary) 70%, transparent);
  }
}

@media (prefers-reduced-motion: reduce) {
  .co-panel,
  .fi-item,
  .payment-method-card,
  .checkout-del-opt,
  .co-more-items,
  .address-display,
  .coupon-input,
  .order-notes-input,
  .co-change-btn,
  .co-more-btn,
  .coupon-apply-btn,
  .btn-place-order {
    transition: none;
  }
}

/* ── Highlight suggestion status (admin product form) ─────────────────────
   Sits above the highlight rows after an image upload has triggered an
   analysis. Blue for in-progress and success, since blue carries information
   in this system; orange for the failed read, which is the one state that
   wants attention. Both also carry an icon and say what to do next, so the
   state never rests on colour. */
.admin-hl-suggest {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding: 9px 13px;
  border-radius: 10px;
  font-size: 0.79rem;
  font-weight: 600;
  line-height: 1.4;
  background: var(--color-secondary-soft);
  color: var(--color-secondary-text);
}

.admin-hl-suggest svg { flex-shrink: 0; }

.admin-hl-suggest-error {
  background: var(--color-primary-soft);
  color: var(--color-primary);
}

.admin-hl-suggest-unavailable {
  background: var(--color-surface-subtle);
  color: var(--text-muted);
}

/* Reading an image takes a few seconds; a still label reads as a stuck form. */
.admin-hl-suggest-loading svg {
  animation: admin-hl-pulse 1.1s ease-in-out infinite;
}

@keyframes admin-hl-pulse {
  0%, 100% { opacity: 1; }
  50%      { opacity: 0.35; }
}

@media (prefers-reduced-motion: reduce) {
  .admin-hl-suggest-loading svg { animation: none; }
}

/* ── Mobile type floor ────────────────────────────────────────────────────
   No text on a customer-facing phone screen goes below 12px (0.75rem).

   These are 21 rules that measured between 9.9px and 11.8px at a 360px
   viewport -- rating pills, strikethrough prices, review counts, the
   "VERIFIED" seller badge, the countdown. They read fine on a 27" monitor
   at arm's length and poorly on a phone held at arm's length, which is the
   whole problem: they were sized against the desktop layout they were
   designed in.

   Scoped to mobile, and last in the file, so desktop stays pixel-identical
   and these override the base rules without needing !important. The two
   mobile-only components (BottomNav, MobileTopBar) are fixed at source
   instead, since they never render above this width anyway.

   This is a floor, not a type scale. If the palette ever grows a real scale
   the right move is to delete this block and fix the sizes at source. */
@media (max-width: 768px) {
  .pdp-sil-verified,
  .sr-header-sub,
  .about-float-title,
  .about-float-card,
  .cat-carousel-rating-pill,
  .cat-carousel-no-rating,
  .cat-carousel-price-was,
  .cat-carousel-review-cnt,
  .ftr-cta-feature-sub,
  .pdp-img-counter,
  .pdp-cat-label,
  .pdp-360-trigger,
  .pdp-del-date,
  .ssb-label,
  .ann-countdown,
  /* Lives in the rotating hero slides, so it is only measurable while its
     own slide is the visible one. */
  .slide-badge {
    font-size: 0.75rem;
  }
  /* Matches the base rule's two-class specificity. */
  .pcard-rating-badge.product-rating-pill { font-size: 0.75rem; }
}

/* Account, cart and checkout equivalents of the two floors above. These
   pages are behind a login, so the first pass over the public storefront
   never measured them; the same two problems were waiting here. */
@media (max-width: 768px) {
  /* Type floor -- see the block above for the reasoning. */
  .oh-cell-label,
  .oh-stat-sub,
  .oh-status-sub,
  .oh-pay-icon,
  .oh-paid-badge,
  .ab-default-badge,
  .pf-info-label,
  .dash-order-status,
  .dash-stat-sub,
  .ntf-badge,
  .ntf-absolute,
  .ntf-tab-count,
  .step-label,
  .ctb-item,
  .fi-qty-arrow,
  .cs-qty-max-hint {
    font-size: 0.75rem;
  }

  /* Tap floor, standalone controls. The quantity select on the checkout
     summary measured 8x15px -- it has no border and no padding, so it
     collapsed to the width of the caret beside it. Changing quantity at
     checkout is not a control anyone should have to aim at. */
  .fi-qty-select { min-width: 44px; min-height: 44px; }
  .sph-back,
  .co-change-btn,
  .co-more-btn,
  .cs-qty-btn,
  .oh-view-btn,
  .oh-buy-again-btn,
  .oh-export-btn,
  .oh-date-select,
  .wl-share-btn,
  .wl-add-all-btn,
  .ntf-tab,
  .ntf-mark-all,
  .cartpg-help-btn,
  .coupon-input,
  .ntf-filter-btn,
  .ntf-search-input,
  .oh-search-input {
    min-height: 44px;
  }
  /* Icon-only, so they need the width too. */
  .ntf-menu-btn,
  .ntf-page-arrow,
  .pf-input-eye,
  .pf-avatar-edit {
    min-width: 44px;
    min-height: 44px;
  }

  /* Inline text actions inside dense list rows ("Remove", "Save for later",
     "Edit"). These sit in tight stacks, so 44px each would space the rows
     out badly. Held to 32px instead -- above the 24px WCAG 2.2 AA floor,
     and double what they were at padding:0. */
  .ab-edit-btn,
  .ab-remove-btn,
  .cs-item-action,
  .dash-section-link {
    min-height: 32px;
    padding-top: 4px;
    padding-bottom: 4px;
  }
}

/* Standalone controls that measured under the 24px WCAG 2.2 AA floor on a
   phone: a back button, breadcrumb links, the footer's legal row, and the
   contact details. Each is a real navigation target rather than a link
   inside a sentence, so the exception for inline links doesn't cover them.
   Padding rather than height, so nothing shifts around them. */
@media (max-width: 768px) {
  .pdp-back-link,
  .pdp-bc-item,
  .ftr-bottom-link,
  .contact-info-value,
  .pdp-change-btn,
  .pdp-offer-copy {
    min-height: 24px;
    display: inline-flex;
    align-items: center;
  }
}

/* Hover-only affordances on touch devices.
   "Hover to zoom" is an instruction a touch user cannot act on, and its
   reveal rule is not gated -- mobile browsers latch :hover on tap, so it
   can appear and say something meaningless. The quick-view label already
   only reveals under (hover: hover), so it is never visible here; removing
   it from the tree as well drops ~30 dead nodes from a product grid. */
@media (hover: none) {
  .pdp-zoom-hint,
  .cat-carousel-quickview {
    display: none;
  }
}

/* ── Top Sales eligibility, in admin Settings ─────────────────────────────
   A checkbox that governs the two fields under it, plus a percent suffix.
   Reuses .si-field-grid / .si-input from Store Information so the two cards
   in this tab share one field geometry rather than drifting apart. */
.ts-rule-toggle {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px 16px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--bg-secondary);
  cursor: pointer;
}

.ts-rule-toggle input[type="checkbox"] {
  /* Nudged down onto the first line of the label rather than the top of the
     block, which is where it sits once the hint wraps to three lines. */
  margin-top: 2px;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  accent-color: var(--color-secondary);
  cursor: pointer;
}

.ts-rule-toggle > span {
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-size: 0.86rem;
  color: var(--text-primary);
  min-width: 0;
}

.ts-rule-hint,
.ts-field-hint {
  font-size: 0.78rem;
  font-weight: 400;
  line-height: 1.45;
  color: var(--text-secondary);
}

.ts-field-hint { margin: 6px 0 0; }

/* The % sits inside the field's box rather than beside it, so the number and
   its unit read as one control and the field keeps the grid's width. */
.ts-suffix-field {
  position: relative;
  display: flex;
  align-items: center;
}

.ts-suffix-field .si-input {
  width: 100%;
  /* Room for the suffix, so a three-digit value never runs under it. */
  padding-right: 34px;
}

.ts-suffix {
  position: absolute;
  right: 12px;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-secondary);
  pointer-events: none;
}

/* A disabled field still has to be readable -- it says what the rule WOULD be
   if the checkbox above were on, which is the thing being decided. */
.ts-suffix-field .si-input:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;6EAyB6E;;AAE7E;;EAEE,2EAA2E;EAC3E,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;;EAE5B;;;;;;gCAM8B;EAC9B,uBAAuB;EACvB;;;;kBAIgB;EAChB,+CAA+C;EAC/C,4CAA4C;EAC5C,iEAAiE;EACjE,2CAA2C;EAC3C,oDAAoD;EACpD,2CAA2C;;EAE3C;;;;;;;;;;;;;;wCAcsC;EACtC,+BAA+B;EAC/B,qCAAqC;EACrC,oDAAoD;EACpD,6BAA6B;EAC7B,mCAAmC;EACnC,kDAAkD;EAClD,gCAAgC;;EAEhC;;;;;;;;;;;;;;;;oDAgBkD;EAClD,4BAA4B;EAC5B,iDAAiD;EACjD,mDAAmD;;EAEnD,2EAA2E;EAC3E,sCAAsC;EACtC,yCAAyC;EACzC,8CAA8C;EAC9C,4CAA4C;EAC5C;;mEAEiE;EACjE,qCAAqC;EACrC;;;wDAGsD;EACtD,gDAAgD;EAChD,iDAAiD;;EAEjD,2EAA2E;EAC3E,6CAA6C;EAC7C,6CAA6C;EAC7C,wCAAwC;;EAExC,2EAA2E;EAC3E,qCAAqC;EACrC,4CAA4C;;EAE5C,2EAA2E;EAC3E;;;;;;;;4EAQ0E;EAC1E,2FAA2F;EAC3F,iGAAiG;EACjG,4CAA4C;EAC5C,iDAAiD;;EAEjD,2EAA2E;EAC3E;;;;yEAIuE;EACvE,2FAA2F;EAC3F,iGAAiG;EACjG,+CAA+C;EAC/C;;;;;;;wCAOsC;EACtC,gGAAgG;EAChG,0DAA0D;EAC1D,mDAAmD;;EAEnD;;;;;sDAKoD;EACpD,yCAAyC;EACzC,oDAAoD;EACpD,gDAAgD;;EAEhD,4CAA4C;EAC5C,sCAAsC;;EAEtC,4CAA4C;EAC5C,4CAA4C;;EAE5C;;;;;;;;qEAQmE;EACnE,kCAAkC;EAClC,oCAAoC;EACpC,kCAAkC;EAClC,uEAAuE;EACvE,yEAAyE;EACzE,uEAAuE;EACvE,uEAAuE;EACvE,yEAAyE;EACzE,iCAAiC;EACjC,qCAAqC;;EAErC,2EAA2E;EAC3E,+BAA+B;EAC/B,oCAAoC;EACpC,gDAAgD;EAChD;;;;;;;sEAOoE;EACpE,mCAAmC;EACnC,yCAAyC;EACzC,6CAA6C;EAC7C,sCAAsC;EACtC,qCAAqC;EACrC,6BAA6B;EAC7B,2CAA2C;EAC3C,qCAAqC;EACrC,4CAA4C;EAC5C,qCAAqC;EACrC,yCAAyC;EACzC;;;;gEAI8D;EAC9D,2CAA2C;EAC3C,+CAA+C;EAC/C;2EACyE;EACzE,8BAA8B;EAC9B,+BAA+B;EAC/B,iCAAiC;EACjC,8BAA8B;EAC9B,+EAA+E;EAC/E,iFAAiF;;EAEjF,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;;EAEf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;;;mDAemD;;AAEnD;EACE;;;iEAG+D;EAC/D,qCAAqC;EACrC,0CAA0C;EAC1C,kDAAkD;EAClD,gDAAgD;EAChD,0EAA0E;EAC1E,qCAAqC;EACrC,kDAAkD;EAClD,iDAAiD;;EAEjD,8CAA8C;EAC9C,gDAAgD;EAChD,4CAA4C;;EAE5C,yCAAyC;EACzC,gDAAgD;EAChD,+CAA+C;EAC/C;;wDAEsD;EACtD,kFAAkF;EAClF;qEACmE;EACnE,8CAA8C;EAC9C,+CAA+C;;EAE/C;;;;gEAI8D;EAC9D,+BAA+B;EAC/B,qCAAqC;EACrC,oDAAoD;EACpD,6BAA6B;EAC7B,mCAAmC;EACnC,mDAAmD;;EAEnD;uEACqE;EACrE,4BAA4B;EAC5B,kDAAkD;EAClD,oDAAoD;EACpD,gDAAgD;;EAEhD,6CAA6C;EAC7C,gDAAgD;EAChD,4CAA4C;EAC5C,sCAAsC;;EAEtC,2CAA2C;EAC3C,4CAA4C;;EAE5C,2EAA2E;EAC3E,+BAA+B;EAC/B,iDAAiD;EACjD,wCAAwC;EACxC,yCAAyC;EACzC,6CAA6C;EAC7C,yCAAyC;EACzC,qCAAqC;EACrC,6BAA6B;EAC7B,2CAA2C;EAC3C,qCAAqC;EACrC,4CAA4C;EAC5C,mDAAmD;EACnD,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA,gEAAgE;AAChE;EACE,kDAAkD;EAClD,8CAA8C;EAC9C,6CAA6C;EAC7C,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;EACE,kFAAkF;AACpF;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,6DAA6D;EAC/D;;EAEA;6EAC2E;EAC3E;;IAEE,6DAA6D;EAC/D;AACF;;AAEA;;;;;2EAK2E;AAC3E;EACE,aAAa;AACf;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,UAAU;EACV,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,+EAA+E;EAC/E,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;EAC/B,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB,GAAG,8DAA8D;AACtF;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,4CAA4C;EAC5C,aAAa;EACb,aAAa;EACb,mCAAmC;AACrC;;AAEA,sBAAsB;AACtB,iBAAiB,kBAAkB,EAAE,qBAAqB,EAAE;AAC5D;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,gBAAgB,EAAE,YAAY,EAAE,eAAe;EAC/C,4BAA4B,EAAE,iBAAiB,EAAE,gBAAgB;EACjE,gBAAgB;AAClB;AACA,2BAA2B,0BAA0B,EAAE;AACvD,yBAAyB,mBAAmB,EAAE;AAC9C;EACE,kBAAkB,EAAE,SAAS,EAAE,QAAQ;EACvC,+BAA+B,EAAE,+BAA+B;EAChE,+BAA+B,EAAE,gBAAgB;EACjD,4CAA4C,EAAE,aAAa;EAC3D,mCAAmC,EAAE,gBAAgB;AACvD;AACA,kCAAkC,WAAW,EAAE,OAAO,EAAE;AACxD;EACE,cAAc,EAAE,WAAW,EAAE,gBAAgB;EAC7C,gBAAgB,EAAE,YAAY,EAAE,eAAe;EAC/C,kBAAkB,EAAE,kBAAkB,EAAE,0BAA0B;AACpE;AACA,oCAAoC,iBAAiB,EAAE;AACvD,8BAA8B,8BAA8B,EAAE;AAC9D,+BAA+B,oBAAoB,EAAE,gBAAgB,EAAE;;AAEvE;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;8DAE8D;AAC9D;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,MAAM;EACN,UAAU;EACV,+BAA+B;EAC/B,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kFAAkF;EAClF,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,+BAA+B;EAC/B,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,+BAA+B;EAC/B,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,aAAa;AACb,8DAA8D;AAC9D,YAAY,aAAa,EAAE;AAC3B,cAAc,eAAe,EAAE;AAC/B;EACE,WAAW;EACX,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,oBAAoB;EACpB,aAAa;EACb,gDAAgD;AAClD;AACA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;AACA,6BAA6B,0BAA0B,EAAE;;AAEzD,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,mCAAmC;EACnC,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;AACA;0CAC0C,YAAY,EAAE;AACxD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;AAChB;AACA,0BAA0B,8BAA8B,EAAE,0BAA0B,EAAE;;AAEtF,0BAA0B;AAC1B;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;AACA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,2BAA2B;AAC7B;AACA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;AACA,kCAAkC,+BAA+B,EAAE;AACnE;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;;sEAEsE;;AAEtE;EACE,cAAc,SAAS,EAAE;EACzB,wBAAwB,cAAc,EAAE;EACxC,eAAe,WAAW,EAAE;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,qBAAqB;AACvB;;AAEA,6DAA6D;AAC7D;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,uFAAuF;AACzF;;AAEA;EACE,2BAA2B;EAC3B,4EAA4E;AAC9E;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,UAAU;EACV,wCAAwC;EACxC,cAAc;AAChB;;AAEA,uBAAuB,oBAAoB,EAAE,sBAAsB,EAAE;;AAErE,qBAAqB;AACrB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gCAAgC;EAChC,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,oDAAoD;EACpD,UAAU;EACV,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA,wCAAwC,gCAAgC,EAAE;;AAE1E;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,6EAA6E;AAC7E;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,kCAAkC,kCAAkC,EAAE;;AAEtE,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,oCAAoC,kCAAkC,EAAE;;AAExE,cAAc;AACd;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;;;;;+DAK+D;AAC/D;;;;;;;;;;;;;EAaE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B;;oCAEkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;;gEAGgE;AAChE;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,gDAAgD;EAChD,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;EACrB,+CAA+C;EAC/C,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,8CAA8C;AAC9C;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,8EAA8E;AAChF;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,wCAAwC;EACxC,0CAA0C;EAC1C,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;EACX,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;;EAEE,2BAA2B;EAC3B,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,8DAA8D;EAC9D,oBAAoB;EACpB,gEAAgE;AAClE;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;;yDAEyD;AACzD;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,6BAA6B;EAC7B,aAAa;AACf;;AAEA;;mDAEmD;AACnD;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,yGAAyG;EACzG,kBAAkB;EAClB,0DAA0D;AAC5D;AACA;EACE,WAAW,aAAa,EAAE,sBAAsB,EAAE;EAClD,WAAW,aAAa,EAAE,sBAAsB,EAAE;AACpD;;AAEA;;;;uEAIuE;AACvE;EACE,kBAAkB;EAClB,uBAAuB;EACvB,uDAAuD;AACzD;AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,uDAAuD;AACzD;AACA;EACE,OAAO,qBAAqB,EAAE,UAAU,EAAE;EAC1C,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;EACnB,OAAO,uBAAuB,EAAE,UAAU,EAAE;AAC9C;AACA;EACE,iDAAiD,eAAe,EAAE,sBAAsB,EAAE,aAAa,EAAE;EACzG,2BAA2B,aAAa,EAAE;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yCAAyC;EACzC,+BAA+B;EAC/B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,qEAAqE;AACrE;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;;;;;iDAKiD;AACjD;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA,iCAAiC,0BAA0B,EAAE;;AAE7D;EACE;IACE,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,eAAe;IACf,+BAA+B;EACjC;AACF;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;AACnB;AACA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;AACA;EACE,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,6CAA6C;AAC/C;;AAEA;;;;yEAIyE;AACzE,iBAAiB,kBAAkB,EAAE,cAAc,EAAE,WAAW,EAAE;AAClE,uBAAuB,WAAW,EAAE,sBAAsB,EAAE,mBAAmB,EAAE;AACjF;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mDAAmD;AACrD;AACA,uBAAuB,0BAA0B,EAAE,8BAA8B,EAAE;;AAEnF;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,8DAA8D;EAC9D,oBAAoB;EACpB,oEAAoE;EACpE,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,sFAAsF;AACxF;;AAEA;EACE,OAAO,UAAU,EAAE,kCAAkC,EAAE;EACvD,OAAO,UAAU,EAAE,+BAA+B,EAAE;AACtD;;AAEA;EACE,cAAc,eAAe,EAAE;AACjC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;;;;kEAIgE;EAChE,6BAA6B;EAC7B,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+DAA+D;EAC/D,qBAAqB;EACrB,qEAAqE;EACrE,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;AACA,2BAA2B,2BAA2B,EAAE,eAAe,EAAE;;AAEzE;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;;;;;;;;;;;;2EAY2E;AAC3E;;EAEE,aAAa;EACb,uBAAuB;AACzB;;AAEA,4BAA4B,uBAAuB,EAAE;AACrD,sBAAsB,UAAU,EAAE;;AAElC;EACE,iBAAiB,aAAa,EAAE;EAChC,4BAA4B,uBAAuB,EAAE;AACvD;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;8EAC8E;AAC9E,gCAAgC,aAAa,EAAE;;AAE/C,wBAAwB;AACxB;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;EAEE,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,+DAA+D;EAC/D,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,4EAA4E;EAC5E,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,wEAAwE;EACxE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,+DAA+D;EAC/D,qBAAqB;AACvB;;AAEA;EACE,8DAA8D;EAC9D,oBAAoB;AACtB;;AAEA;EACE,wEAAwE;EACxE,8BAA8B;AAChC;;AAEA;EACE,wEAAwE;EACxE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;;mEAEmE;;AAEnE;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,mEAAmE;AACnE;EACE,YAAY;EACZ,cAAc;EACd,2EAA2E;EAC3E,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,kDAAkD;AACpD;AACA,oCAAoC,aAAa,EAAE;;AAEnD;EACE,WAAW;AACb;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,YAAY;EACZ,4BAA4B;EAC5B,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,eAAe;EACf,cAAc;EACd,mDAAmD;AACrD;AACA,8BAA8B,kCAAkC,EAAE,+BAA+B,EAAE;AACnG,iDAAiD,cAAc,EAAE;;AAEjE;EACE,iBAAiB,gBAAgB,EAAE;AACrC;;AAEA,qCAAqC,mCAAmC,EAAE;;AAE1E;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,+CAA+C,mCAAmC,EAAE;;AAEpF;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf;gDAC8C;EAC9C,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,SAAS;EACT,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA,mEAAmE;AACnE;EACE,SAAO;EACP,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;EAEE,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA,mBAAmB,eAAe,EAAE,cAAc,EAAE,WAAW,EAAE,kBAAkB,EAAE;AACrF;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;AACA,oBAAoB,cAAc,EAAE,iBAAiB,EAAE;;AAEvD;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA,mEAAmE;AACnE;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA,mEAAmE;AACnE;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,0DAA0D;EAC1D,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;;iDAaiD;AACjD,yCAAyC,mCAAmC,EAAE;;AAE9E;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,6FAA6F;AAC/F;;AAEA,2BAA2B,yBAAyB,EAAE,qCAAqC,EAAE;AAC7F,8BAA8B,qCAAqC,EAAE;;AAErE,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD,sEAAsE;AACtE,8DAA8D;AAC9D;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,QAAQ;IACR,yBAAyB;IACzB,eAAe;IACf,QAAQ;EACV;AACF;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;;EAEvB;;;4EAG0E;EAC1E,oCAAoC;EACpC,+CAA+C;EAC/C,8CAA8C;EAC9C,yCAAyC;EACzC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;EAC3B,iCAAiC;EACjC,oCAAoC;EACpC,iCAAiC;EACjC,2CAA2C;EAC3C,qCAAqC;EACrC,+CAA+C;EAC/C,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,+EAA+E;AACjF;AACA,oCAAoC,aAAa,EAAE;AACnD;EACE,oCAAoC;EACpC,yCAAyC;EACzC,wCAAwC;EACxC,sCAAsC;EACtC,sCAAsC;EACtC,gCAAgC;EAChC,yBAAyB;EACzB,+BAA+B;EAC/B,6BAA6B;EAC7B,mCAAmC;EACnC,iCAAiC;EACjC,oCAAoC;EACpC,iCAAiC;EACjC,uCAAuC;EACvC,qCAAqC;EACrC,4CAA4C;EAC5C,iDAAiD;AACnD;;AAEA;;;yBAGyB;AACzB;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,6EAA6E;EAC7E,6EAA6E;EAC7E,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;AACA,yBAAyB,2BAA2B,EAAE,cAAc,EAAE;AACtE,yBAAyB,SAAO,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACxE,gCAAgC,cAAc,EAAE,kBAAkB,EAAE;AACpE;EACE,cAAc,EAAE,gCAAgC,EAAE,cAAc,EAAE,YAAY;EAC9E,gBAAgB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,kBAAkB;EAC3E,eAAe,EAAE,mBAAmB,EAAE,wBAAwB;AAChE;AACA,8BAA8B,wBAAwB,EAAE;;AAExD,mEAAmE;AACnE;;;;;;;;;;;0EAW0E;AAC1E;EACE,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;AACA,YAAY,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;AAC3E,iBAAiB,mBAAmB,EAAE;AACtC,YAAY,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AAChF;EACE,WAAW;EACX,sBAAsB;EACtB,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;EACjB,oBAAoB;AACtB;AACA,yBAAyB,wBAAwB,EAAE;AACnD,kBAAkB,aAAa,EAAE,2BAA2B,EAAE;AAC9D;EACE,iBAAiB,0BAA0B,EAAE;AAC/C;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,kCAAkC;EAClC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA,sBAAsB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAEvE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uBAAuB,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC9E,mBAAmB,6BAA6B,EAAE;AAClD,mBAAmB,2BAA2B,EAAE;;AAEhD;EACE,wDAAwD,0BAA0B,EAAE;EACpF,sBAAsB,gBAAgB,EAAE;AAC1C;;AAEA,uEAAuE;AACvE;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;EAC9C,6BAA6B;AAC/B;AACA,wBAAwB,2BAA2B,EAAE,mCAAmC,EAAE;AAC1F;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;AACA,uBAAuB,iBAAiB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AAC9E,uBAAuB,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE;AAC1F,uBAAuB,oBAAoB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AAC5G,uBAAuB,kBAAkB,EAAE,2BAA2B,EAAE,SAAS,EAAE;;AAEnF;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;AACA,2BAA2B,2BAA2B,EAAE,kBAAkB,EAAE;;AAE5E;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,mCAAmC;EACnC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;AACA,+BAA+B,8BAA8B,EAAE;;AAE/D;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yBAAyB;AAC3B;AACA,0CAA0C,UAAU,EAAE;;AAEtD;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,cAAc;AAChB;AACA,uBAAuB,2BAA2B,EAAE,oBAAoB,EAAE;;AAE1E,uEAAuE;AACvE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA,gCAAgC,gCAAgC,EAAE,mCAAmC,EAAE;;AAEvG;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB,0BAA0B,EAAE;AACrD;;AAEA,uEAAuE;AACvE;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA,0BAA0B,gBAAgB,EAAE;;AAE5C;EACE,kBAAkB,0BAA0B,EAAE;AAChD;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB;AACA,4BAA4B,SAAO,EAAE;;AAErC,uEAAuE;AACvE;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,gBAAgB,2BAA2B,EAAE;;AAE7C;;EAEE,WAAW;EACX,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;;;;;;;;sEASsE;AACtE;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;2EAE2E;AAC3E,yBAAyB,6BAA6B,EAAE,0BAA0B,EAAE;;AAEpF;;;;;;8DAM8D;AAC9D;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,6CAA6C;EAC7C,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mCAAmC;EACnC,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,oBAAoB,SAAO,EAAE,YAAY,EAAE;AAC3C;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mDAAmD;AACrD;AACA,qCAAqC,8BAA8B,EAAE,0BAA0B,EAAE;AACjG,yBAAyB,aAAa,EAAE,mBAAmB,EAAE;;AAE7D;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACjE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;uEACuE;AACvE,qBAAqB,kBAAkB,EAAE,cAAc,EAAE;AACzD;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B;;8DAE4D;EAC5D,4BAA4B;EAC5B,aAAa;EACb,oBAAoB;EACpB,4BAA4B;AAC9B;AACA,2DAA2D;AAC3D,qDAAqD,oBAAoB,EAAE;AAC3E;EACE,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;EACjB,oBAAoB;EACpB,0DAA0D;AAC5D;AACA,wCAAwC,wBAAwB,EAAE;AAClE,6CAA6C,+BAA+B,EAAE;AAC9E;EACE,aAAa;EACb,2BAA2B;EAC3B,8CAA8C;AAChD;AACA;mEACmE;AACnE,0CAA0C,mBAAmB,EAAE;;AAE/D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,8EAA8E;AAChF;AACA,uBAAuB,YAAY,EAAE,mBAAmB,EAAE;AAC1D;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,uBAAuB;EACvB,4BAA4B;AAC9B;AACA,0CAA0C,8BAA8B,EAAE,0BAA0B,EAAE;AACtG;gEACgE;AAChE;EACE,SAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,qCAAqC;AACvC;AACA,0CAA0C,4DAA4D,EAAE;;AAExG;EACE,eAAe,8BAA8B,EAAE;EAC/C,qBAAqB,cAAc,EAAE,WAAW,EAAE;AACpD;;AAEA;;;;;kEAKkE;AAClE;EACE,mCAAmC;EACnC,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX;;;iEAG+D;EAC/D,gBAAgB;EAChB,2CAA2C;EAC3C,8BAA8B;EAC9B;kCACgC;EAChC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,2BAA2B,SAAO,EAAE,YAAY,EAAE;AAClD;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,uBAAuB;EACvB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gDAAgD;AAClD;AACA,2BAA2B,kCAAkC,EAAE,oCAAoC,EAAE;;AAErG;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT;;sEAEoE;EACpE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB;+BAC6B;EAC7B,YAAY;EACZ,YAAY;AACd;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,sBAAsB;EACtB,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,+BAA+B;EAC/B,gDAAgD;AAClD;AACA;;0EAE0E;AAC1E;EACE,WAAW;EACX,UAAU;AACZ;AACA,wCAAwC,4BAA4B,EAAE;AACtE;;EAEE,aAAa;EACb,oCAAoC;EACpC,2CAA2C;AAC7C;AACA,mCAAmC,mCAAmC,EAAE,+BAA+B,EAAE;;AAEzG;sDACsD;AACtD;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA,2BAA2B,mBAAmB,EAAE;AAChD;EACE,oBAAoB,0BAA0B,EAAE;AAClD;;AAEA;0DAC0D;AAC1D,0BAA0B,kBAAkB,EAAE,cAAc,EAAE;AAC9D;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;EACxB,aAAa;EACb,oBAAoB;EACpB,uBAAuB;AACzB;AACA,+DAA+D,6BAA6B,EAAE;AAC9F,gCAAgC,kBAAkB,EAAE;AACpD,wEAAwE;AACxE,+CAA+C,8BAA8B,EAAE;;AAE/E;kEACkE;AAClE;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,mBAAmB,0BAA0B,EAAE;AACjD;AACA;;;;aAIa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,gDAAgD;EAChD,4DAA4D;EAC5D,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;AACnB;AACA,0CAA0C,oCAAoC,EAAE,kCAAkC,EAAE;AACpH;EACE,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;AACjC;AACA;;;;2EAI2E;AAC3E;EACE,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,gDAAgD;AAClD;AACA,gDAAgD,oCAAoC,EAAE;AACtF;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,+CAA+C;EAC/C,iDAAiD;EACjD,8CAA8C;AAChD;AACA,iDAAiD,oCAAoC,EAAE,2CAA2C,EAAE;;AAEpI;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,uCAAuC;EACvC,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;AAC9C;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;AACA,gCAAgC,kCAAkC,EAAE;AACpE;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;EACxC,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;AACA,+CAA+C,wCAAwC,EAAE;AACzF;mCACmC,aAAa,EAAE,mBAAmB,EAAE;;AAEvE;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;AACjB;;AAEA,kBAAkB,aAAa,EAAE,qCAAqC,EAAE,SAAS,EAAE;AACnF,kBAAkB,aAAa,EAAE,qCAAqC,EAAE,SAAS,EAAE;;AAEnF;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,8BAA8B;AAChC;AACA,oCAAoC,2BAA2B,EAAE;AACjE;EACE,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,8BAA8B;EAC9B,qCAAqC;EACrC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;EAClC,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,0BAA0B,yBAAyB,EAAE;AACrD;EACE,WAAW;EACX,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB,8BAA8B,EAAE;AACpD;AACA;EACE,mCAAmC,0BAA0B,EAAE;AACjE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mEAAmE;AACnE;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,2DAA2D;EAC3D,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iBAAiB,uCAAuC,EAAE,6BAA6B,EAAE,6CAA6C,EAAE;AACxI,6BAA6B,kCAAkC,EAAE,qCAAqC,EAAE;AACxG,iBAAiB,qCAAqC,EAAE,2BAA2B,EAAE,2CAA2C,EAAE;AAClI,6BAA6B,gCAAgC,EAAE,mCAAmC,EAAE;AACpG,iBAAiB,uCAAuC,EAAE,mCAAmC,EAAE,6CAA6C,EAAE;AAC9I,6BAA6B,yBAAyB,EAAE,qCAAqC,EAAE;;AAE/F,qCAAqC,uCAAuC,EAAE,6BAA6B,EAAE,oCAAoC,EAAE;AACnJ,qCAAqC,qCAAqC,EAAE,gCAAgC,EAAE,kCAAkC,EAAE;AAClJ,qCAAqC,mBAAmB,EAAE,kCAAkC,EAAE,0CAA0C,EAAE;;AAE1I,mEAAmE;AACnE;EACE,qGAAqG;EACrG,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,kBAAkB,uCAAuC,EAAE,6BAA6B,EAAE;AAC1F,kBAAkB,qCAAqC,EAAE,2BAA2B,EAAE;;AAEtF,sCAAsC,uCAAuC,EAAE,6BAA6B,EAAE;AAC9G,sCAAsC,qCAAqC,EAAE,2BAA2B,EAAE;;AAE1G,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,qBAAqB,iBAAiB,EAAE,YAAY,EAAE;AACtD,qBAAqB,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,SAAS,EAAE;AACpG,qBAAqB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE,YAAY,EAAE;;AAEhG,mEAAmE;AACnE;;;sCAGsC;AACtC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;;AAEA,uCAAuC,yBAAyB,EAAE,qCAAqC,EAAE,2BAA2B,EAAE;AACtI,2BAA2B,YAAY,EAAE,mBAAmB,EAAE;;AAE9D;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oFAAoF;EACpF,+BAA+B;EAC/B,kDAAkD;EAClD,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,sBAAsB,qCAAqC,EAAE;AAC/D;;AAEA,mEAAmE;AACnE;EACE,sEAAsE;AACxE;;AAEA;EACE,wBAAwB;EACxB,sEAAsE;AACxE;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,mEAAmE;AACnE;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA,mBAAmB,yCAAyC,EAAE;;AAE9D,mEAAmE;AACnE,mBAAmB,kCAAkC,EAAE;;AAEvD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,oCAAoC;EACpC,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,cAAc,0BAA0B,EAAE;AAC1C,cAAc,oBAAoB,EAAE,kCAAkC,EAAE;;AAExE;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;;EAEE,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,wEAAwE;AAC1E;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,OAAO,UAAU,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,SAAS,EAAE,kBAAkB,EAAE;EAC/F,OAAO,UAAU,EAAE,2BAA2B,EAAE,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC/G;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,mDAAmD;AACrD;;AAEA,mBAAmB,yBAAyB,EAAE;AAC9C,mBAAmB,gCAAgC,EAAE;AACrD,mBAAmB,0BAA0B,EAAE;;AAE/C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,yBAAyB,oBAAoB,EAAE;AAC/C,yBAAyB,2BAA2B,EAAE;AACtD,yBAAyB,qBAAqB,EAAE;;AAEhD;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,cAAc,qBAAqB,EAAE;AACrC,cAAc,4BAA4B,EAAE;;AAE5C,4DAA4D;AAC5D;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,iBAAiB;EACjB,4BAA4B;EAC5B,gDAAgD;EAChD,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;EACrC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,qBAAqB;AACvB;;AAEA,kBAAkB,0BAA0B,EAAE;;AAE9C,eAAe,+BAA+B,EAAE;;AAEhD;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA,aAAa,uCAAuC,EAAE,6BAA6B,EAAE;AACrF,aAAa,qCAAqC,EAAE,2BAA2B,EAAE;AACjF,aAAa,qCAAqC,EAAE,2BAA2B,EAAE;;AAEjF;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,mBAAmB,uCAAuC,EAAE,6BAA6B,EAAE;AAC3F,mBAAmB,qCAAqC,EAAE,2BAA2B,EAAE;AACvF,mBAAmB,qCAAqC,EAAE,2BAA2B,EAAE;AACvF,mBAAmB,6BAA6B,EAAE,4BAA4B,EAAE,+BAA+B,EAAE;;AAEjH,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;;;4EAG4E;AAC5E;;EAEE,8DAA8D;AAChE;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb;;yEAEuE;EACvE,0DAA0D;EAC1D,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA,0BAA0B,YAAY,EAAE;AACxC,wCAAwC,YAAY,EAAE;AACtD,4CAA4C,WAAW,EAAE,eAAe,EAAE,YAAY,EAAE,gBAAgB,EAAE;AAC1G,+CAA+C,YAAY,EAAE;AAC7D;EACE,sBAAsB,0BAA0B,EAAE;AACpD;AACA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;AACf;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,uBAAuB,qCAAqC,EAAE;AAChE;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA,4BAA4B,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAC7F,4BAA4B,kBAAkB,EAAE,4BAA4B,EAAE;AAC9E,4BAA4B,kBAAkB,EAAE,wBAAwB,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;AACzI,+BAA+B,6BAA6B,EAAE;AAC9D,iCAAiC,2BAA2B,EAAE;;AAE9D,yDAAyD;AACzD;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,sCAAsC;EACtC,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;AACjB;AACA,kCAAkC,8BAA8B,EAAE,0BAA0B,EAAE;AAC9F;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;AACA,yCAAyC,kBAAkB,EAAE,aAAa,EAAE;;AAE5E;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,iBAAiB;EACjB,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,wEAAwE;AAC1E;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,oBAAoB;AACtB;AACA,yBAAyB,aAAa,EAAE,2BAA2B,EAAE;;AAErE;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;AACrB;AACA,sCAAsC,yBAAyB,EAAE,qCAAqC,EAAE,2BAA2B,EAAE;AACrI,0BAA0B,YAAY,EAAE,mBAAmB,EAAE;;AAE7D;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,sCAAsC;AACxC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,6BAA6B;EAC7B,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA,6BAA6B,kCAAkC,EAAE;;AAEjE,wDAAwD;AACxD;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA,4CAA4C,SAAO,EAAE;;AAErD;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;AACA,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC9D,gBAAgB,oBAAoB,EAAE,wBAAwB,EAAE,cAAc,EAAE;AAChF,gBAAgB,gBAAgB,EAAE,0BAA0B,EAAE,mBAAmB,EAAE;AACnF,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;AAClF;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,6BAA6B,EAAE,kBAAkB,EAAE,gBAAgB;EACnE,gBAAgB,EAAE,kBAAkB,EAAE,YAAY,EAAE,sBAAsB;AAC5E;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;;;;;IAME,aAAa;EACf;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;;;IAIE,aAAa;EACf;AACF;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;;AAEA;;8BAE8B;AAC9B;EACE,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,8BAA8B,8BAA8B,EAAE;AAChE;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,oFAAoF;AACpF,gBAAgB,iBAAiB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACxE,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACpF,wBAAwB,WAAW,EAAE,YAAY,EAAE,+EAA+E,EAAE,kBAAkB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,cAAc,EAAE,6BAA6B,EAAE,uCAAuC,EAAE;AACpT,sBAAsB,eAAe,EAAE,0BAA0B,EAAE,sCAAsC,EAAE,iBAAiB,EAAE,wBAAwB,EAAE;AACxJ,qBAAqB,SAAS,EAAE,wBAAwB,EAAE,kBAAkB,EAAE;AAC9E,kBAAkB,aAAa,EAAE,2CAA2C,EAAE,SAAS,EAAE,kBAAkB,EAAE;AAC7G,gBAAgB,aAAa,EAAE,SAAS,EAAE,YAAY,EAAE;AACxD,kEAAkE,+BAA+B,EAAE,mBAAmB,EAAE,+BAA+B,EAAE,8BAA8B,EAAE;AACzL,uBAAuB,aAAa,EAAE,0CAA0C,EAAE,SAAS,EAAE,aAAa,EAAE,uBAAuB,EAAE;AACrI,kBAAkB,WAAW,EAAE,YAAY,EAAE,+EAA+E,EAAE,kBAAkB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,kCAAkC,EAAE,uCAAuC,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACzU,2EAA2E,SAAS,EAAE,0BAA0B,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACrJ,wEAAwE,eAAe,EAAE,4BAA4B,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AAC9J,qBAAqB,aAAa,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACjE,oBAAoB,aAAa,EAAE,0CAA0C,EAAE,SAAS,EAAE,kBAAkB,EAAE;AAC9G,+DAA+D,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,6BAA6B,EAAE,uCAAuC,EAAE;AAC1P,sBAAsB,eAAe,EAAE;AACvC,2BAA2B,0BAA0B,EAAE;AACvD,wBAAwB,aAAa,EAAE,gDAAgD,EAAE,SAAS,EAAE;AACpG,wBAAwB,aAAa,EAAE,uBAAuB,EAAE;AAChE,8BAA8B,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC7E,0BAA0B,kCAAkC,EAAE,gBAAgB,EAAE;AAChF,iBAAiB,gBAAgB,EAAE,SAAS,EAAE,aAAa,EAAE,SAAS,EAAE;AACxE,qBAAqB,aAAa,EAAE;AACpC,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,2BAA2B,EAAE;AAClG,wBAAwB,gBAAgB,EAAE,aAAa,EAAE,QAAQ,EAAE,gBAAgB,EAAE,UAAU,EAAE;AACjG,0BAA0B,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,4BAA4B,EAAE,iBAAiB,EAAE,qBAAqB,EAAE;AACjJ,gCAAgC,0BAA0B,EAAE;AAC5D,6BAA6B,WAAW,EAAE,YAAY,EAAE,+EAA+E,EAAE,kBAAkB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,cAAc,EAAE,kCAAkC,EAAE,uCAAuC,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACnW,iBAAiB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,wCAAwC,EAAE,oBAAoB,EAAE,kCAAkC,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AACtT,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,mCAAmC,EAAE;AAC7I,yBAAyB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,6BAA6B,EAAE,uCAAuC,EAAE;AACpN,yBAAyB,0BAA0B,EAAE,kBAAkB,EAAE;AACzE,oBAAoB,eAAe,EAAE,4BAA4B,EAAE,kBAAkB,EAAE;AACvF,wCAAwC,2CAA2C,EAAE;AACrF,wBAAwB,gBAAgB,EAAE;AAC1C,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACvE,gCAAgC,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,cAAc,EAAE,6BAA6B,EAAE,uCAAuC,EAAE;AAC3O,4BAA4B,eAAe,EAAE;AAC7C,2BAA2B,eAAe,EAAE,kBAAkB,EAAE,4BAA4B,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AACrI,gCAAgC,eAAe,EAAE;AACjD,0BAA0B,kCAAkC,EAAE,gBAAgB,EAAE;AAChF;;;;;kEAKkE;AAClE,4BAA4B;0CACc,0BAA0B,EAAE,EAAE,iBAAiB,gBAAgB,EAAE,gDAAgD,EAAE,EAAE,gDAAgD,gBAAgB,EAAE,EAAE;AACnO,4BAA4B,gBAAgB,iBAAiB,EAAE,EAAE,mBAAmB,mBAAmB,EAAE,EAAE,wBAAwB,WAAW,EAAE,YAAY,EAAE,EAAE,wCAAwC,0BAA0B,EAAE,EAAE,gDAAgD,cAAc,EAAE,EAAE,uBAAuB,SAAS,EAAE,kBAAkB,EAAE,EAAE,oBAAoB,0CAA0C,EAAE,QAAQ,EAAE,EAAE,2BAA2B,WAAW,EAAE,YAAY,EAAE,EAAE;;AAEpe,0EAA0E;AAC1E,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACnE;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;AAClB;AACA,iBAAiB,2BAA2B,EAAE;AAC9C;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;AACA,eAAe,wBAAwB,EAAE,cAAc,EAAE,gCAAgC,EAAE,aAAa,EAAE;AAC1G,8BAA8B,yBAAyB,EAAE,oBAAoB,EAAE;AAC/E;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,uEAAuE;AACvE,gBAAgB,iBAAiB,EAAE,cAAc,EAAE,8BAA8B,EAAE;AACnF,4BAA4B,gBAAgB,8BAA8B,EAAE,EAAE;;AAE9E;EACE,kBAAkB;EAClB,8HAA8H;EAC9H,qCAAqC;EACrC,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,wEAAwE,EAAE,6BAA6B,EAAE,mBAAmB;AAC9H;AACA,sBAAsB,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE;AACxG,sBAAsB,6BAA6B,EAAE;AACrD,oBAAoB,kBAAkB,EAAE,2BAA2B,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AAC9H,uBAAuB,aAAa,EAAE,qCAAqC,EAAE,SAAS,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC1H,4BAA4B,uBAAuB,0BAA0B,EAAE,EAAE;AACjF,sBAAsB,kCAAkC,EAAE,wCAAwC,EAAE,+BAA+B,EAAE,kBAAkB,EAAE;AACzJ,sBAAsB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,wEAAwE,EAAE,6BAA6B,EAAE,mBAAmB,EAAE;AACxQ,uBAAuB,kBAAkB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,eAAe,EAAE;AACzG,sBAAsB,iBAAiB,EAAE,wBAAwB,EAAE,SAAS,EAAE,gBAAgB,EAAE;;AAEhG,gBAAgB,WAAW,EAAE;AAC7B,sBAAsB,aAAa,EAAE,eAAe,EAAE,SAAS,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AAC3G;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB;EAC/E,+BAA+B,EAAE,+BAA+B,EAAE,+BAA+B;EACjG,kBAAkB,EAAE,wBAAwB;AAC9C;AACA,4BAA4B,SAAO,EAAE,YAAY,EAAE,gBAAgB,EAAE,aAAa,EAAE,kBAAkB,EAAE,0BAA0B,EAAE;AACpI,wBAAwB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;AAClE;EACE,iBAAiB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,+BAA+B;EAClG,+BAA+B,EAAE,oBAAoB,EAAE,iBAAiB,EAAE,eAAe,EAAE,mBAAmB;AAChH;AACA,8BAA8B,yBAAyB,EAAE,2BAA2B,EAAE,qCAAqC,EAAE;AAC7H,0CAA0C,2BAA2B,EAAE,oBAAoB,EAAE;;AAE7F;EACE,gBAAgB,EAAE,kBAAkB,EAAE,+BAA+B,EAAE,+BAA+B;EACtG,+BAA+B,EAAE,kBAAkB;AACrD;AACA,qBAAqB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACxG,oBAAoB,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;AACxF;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,kBAAkB;EACzF,yBAAyB,EAAE,qCAAqC,EAAE,YAAY,EAAE,+BAA+B;EAC/G,kBAAkB,EAAE,eAAe;AACrC;AACA,wCAAwC,gBAAgB,EAAE;;AAE1D,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAClE,gBAAgB,+BAA+B,EAAE,+BAA+B,EAAE,+BAA+B,EAAE,gBAAgB,EAAE,aAAa,EAAE;AACpJ,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AACnE,qBAAqB,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AACzJ,qBAAqB,eAAe,EAAE,YAAY,EAAE;AACpD,wBAAwB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACvG,sBAAsB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;;AAEzG;EACE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,cAAc;EAC/D,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB;AACpE;AACA,8BAA8B,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAEnF,yBAAyB,aAAa,EAAE,sBAAsB,EAAE,qBAAqB,EAAE,SAAS,EAAE,cAAc,EAAE;AAClH,oBAAoB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AAC7I,yBAAyB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,cAAc,EAAE;AACtF;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,eAAe;EACtF,kBAAkB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,iBAAiB;EAChG,mBAAmB;AACrB;;AAEA;EACE,oBAAoB,eAAe,EAAE;EACrC,yBAAyB,mBAAmB,EAAE,eAAe,EAAE,SAAS,EAAE,YAAY,EAAE;EACxF,yBAAyB,mBAAmB,EAAE,mBAAmB,EAAE,WAAW,EAAE,8BAA8B,EAAE;AAClH;;AAEA,qBAAqB,iBAAiB,EAAE,gBAAgB,EAAE,mCAAmC,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AACnK,qBAAqB,gBAAgB,EAAE,0BAA0B,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAC3G,wBAAwB,gBAAgB,EAAE,kBAAkB,EAAE;AAC9D,wBAAwB,kBAAkB,EAAE;AAC5C,qBAAqB,qBAAqB,EAAE,qBAAqB,EAAE;AACnE,sBAAsB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,mCAAmC,EAAE;AAClJ,qBAAqB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE;AAC/E,4BAA4B,qBAAqB,0BAA0B,EAAE,EAAE;AAC/E,sBAAsB,kBAAkB,EAAE,mBAAmB,EAAE;AAC/D,2BAA2B,qBAAqB,EAAE,oBAAoB,EAAE,kBAAkB,EAAE;AAC5F,4BAA4B,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AAC5G,0BAA0B,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;AAC9F,iBAAiB,kBAAkB,EAAE,kBAAkB,EAAE,4BAA4B,EAAE,iBAAiB,EAAE,+BAA+B,EAAE,+BAA+B,EAAE,+BAA+B,EAAE;AAC7M,mBAAmB,oBAAoB,EAAE,gBAAgB,EAAE;AAC3D,+BAA+B,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAClK,gCAAgC,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,oBAAoB,EAAE,8DAA8D,EAAE,oEAAoE,EAAE,oBAAoB,EAAE,gBAAgB,EAAE;AAC7T,uBAAuB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,aAAa,EAAE,+BAA+B,EAAE,+BAA+B,EAAE,+BAA+B,EAAE;AAC3L,qBAAqB,sBAAsB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,gCAAgC,EAAE,oBAAoB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,+BAA+B,EAAE,eAAe,EAAE;AACtR,2BAA2B,+BAA+B,EAAE;AAC5D,wBAAwB,oBAAoB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,YAAY,EAAE,oBAAoB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAClO,0BAA0B,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,eAAe,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,+BAA+B,EAAE,+BAA+B,EAAE,+BAA+B,EAAE,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC3W,gCAAgC,2BAA2B,EAAE;AAC7D,6BAA6B,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACrK,mCAAmC,eAAe,EAAE,cAAc,EAAE;;AAEpE,uEAAuE;AACvE,kBAAkB,aAAa,EAAE,gCAAgC,EAAE,SAAS,EAAE,kBAAkB,EAAE;AAClG,4BAA4B,kBAAkB,0BAA0B,EAAE,EAAE;AAC5E,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACtE,oBAAoB,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE;AACvE;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,wEAAwE,EAAE,8BAA8B;EACvJ,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,cAAc;AAC7E;AACA,sBAAsB,kBAAkB,EAAE,wBAAwB,EAAE,eAAe,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AACxI,sBAAsB,kBAAkB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,SAAS,EAAE,qBAAqB,EAAE;AAC1H;;gEAEgE;AAChE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;AACA,6BAA6B,0BAA0B,EAAE;;AAEzD,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAClE,oBAAoB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE;AAC9E,4BAA4B,oBAAoB,0BAA0B,EAAE,EAAE;AAC9E,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAClE,iBAAiB,iBAAiB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AACpF;EACE,sBAAsB,EAAE,WAAW,EAAE,+BAA+B,EAAE,+BAA+B;EACrG,kBAAkB,EAAE,iBAAiB,EAAE,6BAA6B,EAAE,0BAA0B,EAAE,oBAAoB,EAAE,gBAAgB;AAC1I;AACA;;mCAEmC;AACnC;EACE,iBAAiB,gBAAgB,EAAE;AACrC;AACA,uBAAuB,2BAA2B,EAAE,aAAa,EAAE,4CAA4C,EAAE;;AAEjH,gBAAgB,kBAAkB,EAAE,kBAAkB,EAAE;AACxD,qBAAqB,qBAAqB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE;AACvF,sBAAsB,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACxG,oBAAoB,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;;AAExF;EACE,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,cAAc;AAChB;;AAEA,kBAAkB;AAClB,eAAe,iBAAiB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACvE,kBAAkB,mBAAmB,EAAE;AACvC,qBAAqB,eAAe,EAAE,0BAA0B,EAAE,mCAAmC,EAAE,uBAAuB,EAAE;AAChI,oBAAoB,gBAAgB,EAAE,4BAA4B,EAAE,iBAAiB,EAAE;AACvF,kCAAkC,wBAAwB,EAAE,kBAAkB,EAAE;AAChF,iBAAiB,aAAa,EAAE,0DAA0D,EAAE,SAAS,EAAE,kBAAkB,EAAE;AAC3H,iCAAiC,+BAA+B,EAAE,+BAA+B,EAAE,mBAAmB,EAAE,8BAA8B,EAAE;AACxJ,mBAAmB,kBAAkB,EAAE;AACvC,kBAAkB,aAAa,EAAE,+CAA+C,EAAE,SAAS,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,sCAAsC,EAAE;AAC7K,6BAA6B,gBAAgB,EAAE;AAC/C,iBAAiB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,YAAY,EAAE,kCAAkC,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC3N,oCAAoC,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,6BAA6B,EAAE,uEAAuE,EAAE,cAAc,EAAE;AAC/Q,qBAAqB,eAAe,EAAE,0BAA0B,EAAE,kBAAkB,EAAE;AACtF,oBAAoB,SAAS,EAAE,4BAA4B,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AACpG,eAAe,aAAa,EAAE,SAAS,EAAE;AACzC,eAAe,aAAa,EAAE;AAC9B,kBAAkB,gBAAgB,EAAE,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,0BAA0B,EAAE,eAAe,EAAE;AAChI,+BAA+B,WAAW,EAAE,YAAY,EAAE;AAC1D,kBAAkB,gBAAgB,EAAE,UAAU,EAAE,gBAAgB,EAAE,aAAa,EAAE,SAAS,EAAE;AAC5F,kBAAkB,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE,4BAA4B,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACxI,sBAAsB,qBAAqB,EAAE,cAAc,EAAE,eAAe,EAAE;AAC9E,mBAAmB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,6BAA6B,EAAE,iBAAiB,EAAE,qBAAqB,EAAE;AACjJ,kBAAkB,oBAAoB,EAAE;AACxC,gDAAgD,WAAW,EAAE,gBAAgB,EAAE,cAAc,EAAE,SAAS,EAAE,sCAAsC,EAAE,uBAAuB,EAAE,aAAa,EAAE,+CAA+C,EAAE,mBAAmB,EAAE,SAAS,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE,qBAAqB,EAAE;AACjW,gCAAgC,gBAAgB,EAAE;AAClD,sBAAsB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACrE,gDAAgD,cAAc,EAAE;AAChE,yBAAyB,kBAAkB,EAAE,kBAAkB,EAAE;AACjE,wBAAwB,4BAA4B,EAAE,kBAAkB,EAAE;AAC1E,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,mCAAmC,EAAE,4BAA4B,EAAE,kBAAkB,EAAE;AAC3L,mBAAmB,UAAU,EAAE,YAAY,EAAE,cAAc,EAAE,yBAAyB,EAAE;AACxF,mBAAmB,6BAA6B,EAAE,qBAAqB,EAAE;AACzE,4BAA4B,iBAAiB,0BAA0B,EAAE,EAAE;AAC3E,4BAA4B,eAAe,mBAAmB,EAAE,EAAE,kBAAkB,+CAA+C,EAAE,SAAS,EAAE,eAAe,EAAE,EAAE,eAAe,WAAW,EAAE,YAAY,EAAE,EAAE,iCAAiC,kBAAkB,EAAE,mBAAmB,EAAE,EAAE,iBAAiB,eAAe,EAAE,EAAE;;AAE/T,8BAA8B;AAC9B,iBAAiB,oBAAoB,EAAE;AACvC,qCAAqC,iBAAiB,EAAE,cAAc,EAAE;AACxE,yBAAyB,mBAAmB,EAAE;AAC9C,4BAA4B,eAAe,EAAE,oCAAoC,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,0BAA0B,EAAE;AAC7K,2BAA2B,SAAS,EAAE,eAAe,EAAE,4BAA4B,EAAE;AACrF,iBAAiB,aAAa,EAAE,0DAA0D,EAAE,SAAS,EAAE,oBAAoB,EAAE;AAC7H,iCAAiC,aAAa,EAAE,mBAAmB,EAAE,+BAA+B,EAAE;AACtG,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AACxE,yBAAyB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,cAAc,EAAE,6BAA6B,EAAE,uEAAuE,EAAE;AACpQ,gCAAgC,+BAA+B,EAAE,kCAAkC,EAAE;AACrG,4BAA4B,eAAe,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAC/G,2BAA2B,SAAS,EAAE,kBAAkB,EAAE,4BAA4B,EAAE;AACxF,oBAAoB,gBAAgB,EAAE,mCAAmC,EAAE;AAC3E,+BAA+B,kBAAkB,EAAE,aAAa,EAAE,+CAA+C,EAAE,mBAAmB,EAAE,SAAS,EAAE,gBAAgB,EAAE,eAAe,EAAE,sCAAsC,EAAE,eAAe,EAAE;AAC/O,0CAA0C,gBAAgB,EAAE;AAC5D,gBAAgB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,6BAA6B,EAAE,uEAAuE,EAAE;AAC3O,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;AAC/E,uBAAuB,0BAA0B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACzF,sBAAsB,4BAA4B,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AAC3F,qCAAqC,kBAAkB,EAAE,UAAU,EAAE,oBAAoB,EAAE;AAC3F,iBAAiB,WAAW,EAAE,YAAY,EAAE,qDAAqD,EAAE,kBAAkB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,kBAAkB,EAAE,6BAA6B,EAAE;AAC9O,+CAA+C,YAAY,EAAE,oCAAoC,EAAE,kCAAkC,EAAE;AACvI,4CAA4C,iFAAiF,EAAE;AAC/H,wBAAwB,aAAa,EAAE,4BAA4B,EAAE,SAAS,EAAE;AAChF,yBAAyB,aAAa,EAAE,8BAA8B,EAAE,gBAAgB,EAAE,+BAA+B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACjK,gCAAgC,gBAAgB,EAAE,SAAS,EAAE,uBAAuB,EAAE,0BAA0B,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ,EAAE,aAAa,EAAE,iBAAiB,EAAE,eAAe,EAAE;AAC5O,uCAAuC,YAAY,EAAE,kCAAkC,EAAE;AACzF,uBAAuB,gBAAgB,EAAE,4BAA4B,EAAE,iBAAiB,EAAE;AAC1F,yBAAyB,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE,gBAAgB,EAAE,aAAa,EAAE,+EAA+E,EAAE,kBAAkB,EAAE,6BAA6B,EAAE,sEAAsE,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AAChW,6BAA6B,cAAc,EAAE,eAAe,EAAE;AAC9D,4BAA4B,aAAa,EAAE,SAAS,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACzF,iGAAiG,gBAAgB,EAAE,eAAe,EAAE,kBAAkB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ,EAAE,aAAa,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC5S,yBAAyB,wCAAwC,EAAE,YAAY,EAAE,kCAAkC,EAAE;AACrH,uBAAuB,+BAA+B,EAAE,0BAA0B,EAAE,+BAA+B,EAAE;AACrH,oDAAoD,2BAA2B,EAAE;AACjF,2BAA2B,cAAc,EAAE,aAAa,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AACtF,+BAA+B,SAAS,EAAE,2BAA2B,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC5G,iCAAiC,gBAAgB,EAAE,eAAe,EAAE,+BAA+B,EAAE,kBAAkB,EAAE,6BAA6B,EAAE,0BAA0B,EAAE;AACpL,iCAAiC,aAAa,EAAE,QAAQ,EAAE;AAC1D,0BAA0B,sCAAsC,EAAE,gCAAgC,EAAE,YAAY,EAAE;AAClH,0BAA0B,+BAA+B,EAAE,8BAA8B,EAAE,0BAA0B,EAAE;AACvH,yBAAyB,2BAA2B,EAAE,kBAAkB,EAAE,SAAS,EAAE;AACrF,2BAA2B,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,mCAAmC,EAAE,4BAA4B,EAAE,kBAAkB,EAAE;AACrM,6BAA6B,UAAU,EAAE,YAAY,EAAE,cAAc,EAAE,yBAAyB,EAAE;AAClG,6BAA6B,6BAA6B,EAAE,qBAAqB,EAAE;AACnF,4BAA4B,iBAAiB,0BAA0B,EAAE,EAAE;AAC3E;EACE,iBAAiB,uBAAuB,EAAE;EAC1C,iCAAiC,aAAa,EAAE;EAChD,yBAAyB,mBAAmB,EAAE;EAC9C,2BAA2B,iBAAiB,EAAE;EAC9C,+BAA+B,+CAA+C,EAAE,SAAS,EAAE,gBAAgB,EAAE;EAC7G,wCAAwC,WAAW,EAAE,YAAY,EAAE;EACnE,gCAAgC,kBAAkB,EAAE;EACpD,qCAAqC,cAAc,EAAE;EACrD,2BAA2B,eAAe,EAAE,QAAQ,EAAE,eAAe,EAAE;AACzE;;AAEA,0EAA0E;AAC1E,YAAY,gBAAgB,EAAE,cAAc,EAAE;;AAE9C,cAAc,aAAa,EAAE,uBAAuB,EAAE,8BAA8B,EAAE,SAAS,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACvI,aAAa,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAC/F,WAAW,SAAS,EAAE,kBAAkB,EAAE,4BAA4B,EAAE;AACxE;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,gBAAgB,EAAE,+BAA+B,EAAE,oBAAoB;EACvE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe;EACrD,iBAAiB,EAAE,+BAA+B,EAAE,mBAAmB;EACvE,4BAA4B;AAC9B;AACA,sBAAsB,oCAAoC,EAAE;;AAE5D,YAAY,aAAa,EAAE,QAAQ,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;AACxH,+BAA+B,aAAa,EAAE;AAC9C;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc;EAC5D,iBAAiB,EAAE,mBAAmB,EAAE,+BAA+B;EACvE,+BAA+B,EAAE,4BAA4B;EAC7D,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,qBAAqB;AAC9E;AACA,iBAAiB,2BAA2B,EAAE,0BAA0B,EAAE;AAC1E,kBAAkB,yBAAyB,EAAE,2BAA2B,EAAE,qCAAqC,EAAE;AACjH;EACE,gCAAgC,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,gBAAgB;AAC/G;AACA,iCAAiC,kCAAkC,EAAE;AACrE,qCAAqC,iCAAiC,EAAE;;AAExE,eAAe,aAAa,EAAE,SAAS,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAC/E,mBAAmB,kBAAkB,EAAE,SAAO,EAAE,gBAAgB,EAAE;AAClE,mBAAmB,kBAAkB,EAAE,UAAU,EAAE,QAAQ,EAAE,2BAA2B,EAAE,2BAA2B,EAAE,oBAAoB,EAAE;AAC7I;EACE,WAAW,EAAE,sBAAsB,EAAE,0BAA0B,EAAE,+BAA+B;EAChG,+BAA+B,EAAE,+BAA+B,EAAE,0BAA0B,EAAE,kBAAkB;AAClH;AACA,0BAA0B,aAAa,EAAE,2BAA2B,EAAE;;AAEtE,oBAAoB,kBAAkB,EAAE;AACxC;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,YAAY;EAC1D,iBAAiB,EAAE,+BAA+B,EAAE,+BAA+B;EACnF,+BAA+B,EAAE,0BAA0B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,mBAAmB;AACzI;AACA,wBAAwB,2BAA2B,EAAE;AACrD;EACE,kBAAkB,EAAE,qBAAqB,EAAE,QAAQ,EAAE,WAAW;EAChE,6BAA6B,EAAE,+BAA+B,EAAE,+BAA+B;EAC/F,2CAA2C,EAAE,aAAa,EAAE,gBAAgB;EAC5E,aAAa,EAAE,sBAAsB,EAAE,SAAS;AAClD;AACA,0BAA0B,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AAC/I;EACE,gBAAgB,EAAE,kBAAkB,EAAE,+BAA+B,EAAE,+BAA+B,EAAE,0BAA0B,EAAE,kBAAkB;AACxJ;AACA,qBAAqB,sBAAsB,EAAE,gBAAgB,EAAE,YAAY,EAAE,oBAAoB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,eAAe,EAAE,UAAU,EAAE;;AAErK,YAAY,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAE9D,gBAAgB,YAAY,EAAE,+BAA+B,EAAE;;AAE/D;EACE,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,SAAS;EAC9F,kBAAkB,EAAE,2BAA2B,EAAE,kBAAkB;AACrE;AACA,eAAe,SAAS,EAAE,kBAAkB,EAAE;;AAE9C;EACE,kBAAkB;EAClB,aAAa,EAAE,uBAAuB,EAAE,SAAS;EACjD,+BAA+B,EAAE,+BAA+B,EAAE,+BAA+B;EACjG,aAAa,EAAE,gDAAgD;AACjE;AACA,oBAAoB,2BAA2B,EAAE,eAAe,EAAE,oCAAoC,EAAE;AACxG,kBAAkB,2CAA2C,EAAE;;AAE/D;EACE,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7D,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;AAC7D;;AAEA,YAAY,SAAO,EAAE,YAAY,EAAE;AACnC,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;AAC/E,kBAAkB,SAAS,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAC/F;EACE,8BAA8B,EAAE,4BAA4B,EAAE,mBAAmB;EACjF,gBAAgB,EAAE,iBAAiB,EAAE,gBAAgB;AACvD;AACA,WAAW,eAAe,EAAE,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;;AAEhG,YAAY,cAAc,EAAE,aAAa,EAAE,sBAAsB,EAAE,qBAAqB,EAAE,QAAQ,EAAE,iBAAiB,EAAE;AACvH,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,2BAA2B,EAAE,mBAAmB,EAAE;AACpI,gBAAgB,kBAAkB,EAAE,2BAA2B,EAAE,aAAa,EAAE,mBAAmB,EAAE;;AAErG,WAAW,kBAAkB,EAAE,SAAS,EAAE,UAAU,EAAE,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,yBAAyB,EAAE;;AAE9H,iBAAiB,kBAAkB,EAAE,cAAc,EAAE;AACrD;EACE,gBAAgB,EAAE,YAAY,EAAE,2BAA2B,EAAE,eAAe;EAC5E,YAAY,EAAE,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;AAC/F;AACA,sBAAsB,8BAA8B,EAAE,0BAA0B,EAAE;AAClF;EACE,kBAAkB,EAAE,qBAAqB,EAAE,QAAQ,EAAE,WAAW;EAChE,6BAA6B,EAAE,+BAA+B,EAAE,+BAA+B;EAC/F,2CAA2C,EAAE,YAAY,EAAE,gBAAgB;EAC3E,aAAa,EAAE,sBAAsB,EAAE,QAAQ;AACjD;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,YAAY,EAAE,gBAAgB;EAC9F,iBAAiB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,eAAe;AACxG;AACA,yBAAyB,8BAA8B,EAAE;AACzD,mBAAmB,+BAA+B,EAAE;AACpD,4BAA4B,YAAY,EAAE,mBAAmB,EAAE;;AAE/D,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACpI,uBAAuB,SAAS,EAAE,iBAAiB,EAAE,2BAA2B,EAAE;AAClF,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAChE;EACE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,WAAW,EAAE,YAAY;EACtF,kBAAkB,EAAE,+BAA+B,EAAE,+BAA+B,EAAE,0BAA0B,EAAE,eAAe;AACnI;AACA,2BAA2B,YAAY,EAAE,mBAAmB,EAAE;AAC9D;EACE,eAAe,EAAE,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC1F,kBAAkB,EAAE,yBAAyB,EAAE,qCAAqC,EAAE,gBAAgB,EAAE,kBAAkB;AAC5H;;AAEA;EACE,YAAY,eAAe,EAAE;EAC7B,YAAY,mBAAmB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,QAAQ,EAAE,WAAW,EAAE,gBAAgB,EAAE;AAC9H;;;AAGA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,SAAO;EACT;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;;;;;;IAME,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,SAAO;EACT;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,6BAA6B;IAC7B,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,SAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,+BAA+B;IAC/B,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;IAC1B,mBAAmB;EACrB;AACF;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,8BAA8B;EAC9B,MAAM;EACN,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;4CAE4C;AAC5C;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,cAAc;EACd,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,+BAA+B;AACjC;;AAEA;;wCAEwC;AACxC;EACE,qCAAqC;EACrC,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE;IACE,oCAAoC;IACpC,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;;;yDAGyD;AACzD;EACE,qBAAqB,iBAAiB,EAAE;EACxC,sBAAsB,aAAa,EAAE;EACrC,8BAA8B,WAAW,EAAE;EAC3C;IACE,aAAa;IACb,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,+BAA+B;EAC/B,aAAa;EACb,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA,kEAAkE;AAClE;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA,sCAAsC;AACtC;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,WAAW;EACX,uBAAuB;AACzB;;AAEA,gBAAgB,4BAA4B,EAAE;;AAE9C;EACE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EAEf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA,kCAAkC;AAClC;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;AACX;;AAEA,WAAW,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE;;AAE9E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA,+EAA+E;AAC/E;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB,0BAA0B,cAAc,EAAE;;AAE1C,iBAAiB,6BAA6B,EAAE;AAChD,uBAAuB,oCAAoC,EAAE;;AAE7D;EACE,UAAU;EACV,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA,wCAAwC,2BAA2B,EAAE,eAAe,EAAE;AACtF,0BAA0B,sCAAsC,EAAE;;AAElE,mBAAmB;AACnB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,wDAAwD;AACxD;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA,kBAAkB;AAClB;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;;8DAE8D;AAC9D;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,+EAA+E;EAC/E,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,sBAAsB;AACtB;EACE;IACE,MAAM;EACR;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,wBAAwB,uBAAuB,EAAE;EACjD;;mBAEiB,aAAa,EAAE;EAChC,iCAAiC,SAAS,EAAE,sBAAsB,EAAE;EACpE,kBAAkB,SAAS,EAAE,aAAa,EAAE;EAC5C,WAAW,gBAAgB,EAAE;EAC7B,UAAU,WAAW,EAAE,YAAY,EAAE;AACvC;;AAEA,4DAA4D;AAC5D;EACE,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,eAAe,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAEjE;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA,oBAAoB,2CAA2C,EAAE;;AAEjE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA,aAAa;AACb;EACE,aAAa;EACb,uBAAuB;EACvB,MAAM;EACN,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;EACP,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,UAAU;EACV,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA,iBAAiB,eAAe,EAAE;AAClC,iBAAiB,kBAAkB,EAAE,gBAAgB,EAAE;;AAEvD;EACE,kBAAkB;EAClB,SAAS;EACT,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;EACX,yBAAyB;AAC3B;;AAEA,wBAAwB,yBAAyB,EAAE;;AAEnD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,sCAAsC,oBAAoB,EAAE;;AAE5D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,qCAAqC;EACrC,2BAA2B;EAC3B,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B,eAAe,eAAe,EAAE;AAChC,kBAAkB,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,yBAAyB,EAAE,sBAAsB,EAAE,eAAe,EAAE;;AAE1J;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA,yBAAyB,mBAAmB,EAAE;AAC9C,oBAAoB,SAAO,EAAE,0BAA0B,EAAE;AACzD,oBAAoB,4BAA4B,EAAE,kBAAkB,EAAE;AACtE,oBAAoB,gBAAgB,EAAE,0BAA0B,EAAE;;AAElE;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,wBAAwB,0BAA0B,EAAE,kBAAkB,EAAE;;AAExE;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA,wBAAwB,kBAAkB,EAAE,4BAA4B,EAAE;AAC1E,0BAA0B,kBAAkB,EAAE,0BAA0B,EAAE;;AAE1E,4DAA4D;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA,4DAA4D;AAC5D,qBAAqB,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE;;AAEjF;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,mGAAmG;AACrG;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,wFAAwF;EACxF,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,YAAY,8BAA8B,EAAE;EAC5C,kBAAkB,0BAA0B,EAAE;EAC9C,uBAAuB,cAAc,EAAE;AACzC;;AAEA;EACE,YAAY,0BAA0B,EAAE;AAC1C;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2EAA2E;EAC3E,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,0CAA0C;EAC1C,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,wEAAwE;EACxE,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wEAAwE;EACxE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,gBAAgB,YAAY,EAAE;;AAE9B;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,wEAAwE;EACxE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,6BAA6B,aAAa,EAAE;;AAE5C;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,cAAc;EACd,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA,yEAAyE;AACzE;EACE,YAAY;EACZ,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,wEAAwE;EACxE,8BAA8B;AAChC;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;0EACwE;EACxE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;EACrB;EACA,mBAAmB,aAAa,EAAE;AACpC;;AAEA,2DAA2D;AAC3D;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;2EAC2E;AAC3E;EACE,eAAe;EACf,iEAAiE;EACjE,8DAA8D;AAChE;;AAEA;;;;;;;;4CAQ4C;;AAE5C;;+CAE+C;AAC/C;;EAEE,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;AAC/B;AACA,6BAA6B,qBAAqB,EAAE;AACpD,+BAA+B,oBAAoB,EAAE;;AAErD;EACE,aAAa;EACb,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mEAAmE;AACnE;;EAEE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0GAA0G;EAC1G,yBAAyB;EACzB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;;;wCAIsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,4HAA4H;EAC5H,4BAA4B;EAC5B;;;qEAGmE;AACrE;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,UAAU;EACV,gDAAgD;EAChD,uCAAuC;EACvC,yCAAyC;AAC3C;AACA,kCAAkC,WAAW,EAAE,YAAY,EAAE;AAC7D,kCAAkC,UAAU,EAAE,WAAW,EAAE;AAC3D,cAAc,gCAAgC,EAAE;AAChD,cAAc,kCAAkC,EAAE;AAClD,cAAc,0BAA0B,EAAE;AAC1C,cAAc,yBAAyB,EAAE;AACzC,cAAc,mBAAmB,EAAE;AACnC,cAAc,kCAAkC,EAAE;;AAElD;EACE,OAAO,UAAU,EAAE,oEAAoE,EAAE;EACzF,OAAO,UAAU,EAAE,wEAAwE,EAAE;EAC7F,OAAO,UAAU,EAAE,sEAAsE,EAAE;EAC3F,OAAO,UAAU,EAAE,wEAAwE,EAAE;AAC/F;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,+DAA+D;EAC/D,qEAAqE;EACrE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;;;;;;iEAQiE;;AAEjE;;;oEAGoE;AACpE;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,6CAA6C;EAC7C,+BAA+B;AACjC;;AAEA;;;wEAGwE;AACxE;EACE,gDAAgD;EAChD,QAAQ;AACV;AACA,uBAAuB,aAAa,EAAE,QAAQ,EAAE;AAChD,uBAAuB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACtE,wBAAwB,kBAAkB,EAAE,kBAAkB,EAAE;AAChE,wBAAwB,kBAAkB,EAAE,gBAAgB,EAAE;AAC9D,6BAA6B,aAAa,EAAE;AAC5C,uBAAuB,iBAAiB,EAAE;AAC1C,4BAA4B,aAAa,EAAE;;AAE3C;;+BAE+B;AAC/B,iCAAiC,aAAa,EAAE;;AAEhD;;;;;;;;wEAQwE;AACxE;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;0DAE0D;AAC1D;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;8CAe8C;AAC9C;EACE,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;;;;;;;;gCASgC;AAChC;EACE,aAAa;EACb,0CAA0C;EAC1C;;aAEW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;;;;;;;;;;+DAU+D;AAC/D;;EAEE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA,sBAAsB,cAAc,EAAE;AACtC,8BAA8B,cAAc,EAAE,mBAAmB,EAAE,eAAe,EAAE;;AAEpF;;;uCAGuC;AACvC;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB;;;GAGC;AACH;AACA,4BAA4B,sBAAsB,EAAE,gCAAgC,EAAE;;AAEtF,qBAAqB;AACrB;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;6DAI6D;AAC7D;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;AACA,gBAAgB,0BAA0B,EAAE,4BAA4B,EAAE,qCAAqC,EAAE;AACjH;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,4BAA4B;EAC5B,qCAAqC;EACrC,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,OAAO,yEAAyE,EAAE;EAClF,OAAO,yEAAyE,EAAE;EAClF,OAAO,wEAAwE,EAAE;AACnF;;AAEA;EACE,SAAO;EACP,WAAW;EACX,gBAAgB;EAChB,4HAA4H;AAC9H;AACA,iBAAiB,sBAAsB,EAAE,gCAAgC,EAAE;;AAE3E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;AACrB;AACA,kBAAkB,qBAAqB,EAAE;AACzC,oBAAoB,0BAA0B,EAAE,gBAAgB,EAAE;;AAElE;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,+DAA+D;EAC/D,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;yEACyE;AACzE;EACE,uBAAuB,mBAAmB,EAAE,eAAe,EAAE;AAC/D;;AAEA;EACE,aAAa,iBAAiB,EAAE;EAChC,WAAW,kBAAkB,EAAE;EAC/B,uBAAuB,eAAe,EAAE;AAC1C;;AAEA,eAAe;AACf;EACE,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;AACA,mBAAmB,iCAAiC,EAAE;AACtD,sBAAsB,+DAA+D,EAAE;AACvF,mBAAmB,kCAAkC,EAAE;AACvD,iBAAiB,wEAAwE,EAAE;;AAE3F,YAAY,SAAO,EAAE,YAAY,EAAE;;AAEnC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,+DAA+D;EAC/D,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,UAAU;EACV,sBAAsB;AACxB;AACA,sBAAsB,oBAAoB,EAAE;;AAE5C;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;AACA,yBAAyB,2BAA2B,EAAE,gBAAgB,EAAE;;AAExE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,+DAA+D;EAC/D,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB,qCAAqC,EAAE;AAChE;;AAEA;;;;EAIE,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,4BAA4B,0BAA0B,EAAE;AACxD,sBAAsB,gCAAgC,EAAE;;AAExD;EACE,kBAAkB;AACpB;AACA,kCAAkC,oBAAoB,EAAE;;AAExD;;;EAGE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,sCAAsC;AACxC;AACA,qCAAqC,mBAAmB,EAAE;;AAE1D;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA,2BAA2B,SAAO,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACnG;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,SAAS;AACX;AACA,cAAc,oBAAoB,EAAE,gBAAgB,EAAE;AACtD;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,sBAAsB,0BAA0B,EAAE;AACpD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA,YAAY,SAAO,EAAE,YAAY,EAAE;;AAEnC;EACE,aAAa;EACb,kBAAkB;EAClB,4BAA4B;AAC9B;AACA,kCAAkC,0BAA0B,EAAE;;AAE9D;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,oGAAoG;EACpG,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,YAAY,8BAA8B,EAAE;EAC5C,qBAAqB,WAAW,EAAE;AACpC;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,wEAAwE;EACxE,8EAA8E;EAC9E,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA,YAAY,SAAO,EAAE,gBAAgB,EAAE;AACvC,aAAa,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AAChG,WAAW,iBAAiB,EAAE,4BAA4B,EAAE,SAAS,EAAE;;AAEvE;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;AACA,iBAAiB,kBAAkB,EAAE;AACrC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,mBAAmB,EAAE;EAC9C,8BAA8B,SAAO,EAAE;AACzC;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA,eAAe,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,SAAS,EAAE;;AAE5F;;;;;;;0CAO0C;AAC1C;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,YAAY,gDAAgD,EAAE;AAChE;;AAEA;;;sBAGsB;AACtB;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,6CAA6C;EAC7C,8BAA8B;AAChC;AACA,kBAAkB,8BAA8B,EAAE,2BAA2B,EAAE;;AAE/E;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA,aAAa,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAC/E;iEACiE;AACjE,cAAc,iBAAiB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE;AAC/E,kBAAkB,0BAA0B,EAAE;;AAE9C,mEAAmE;AACnE;EACE,8BAA8B;EAC9B,8EAA8E;EAC9E,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,+BAA+B;EAC/B,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,+BAA+B;EAC/B,kBAAkB;EAClB,qCAAqC;EACrC,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,8DAA8D;EAC9D,oEAAoE;EACpE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA,0BAA0B,0BAA0B,EAAE;;AAEtD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;;4DAE4D;AAC5D;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,yEAAyE;AAC3E;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA,yBAAyB,mBAAmB,EAAE;AAC9C,oBAAoB,8BAA8B,EAAE;;AAEpD;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;qEAEqE;AACrE,eAAe,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAEjE;EACE,4GAA4G;EAC5G,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,oEAAoE;AACtE;;AAEA,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACrF;EACE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,cAAc;EAC9D,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,uEAAuE,EAAE,6BAA6B;AACxG;AACA,kBAAkB,SAAS,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAC/F;EACE,iBAAiB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACtE,uBAAuB,EAAE,+BAA+B,EAAE,4BAA4B;EACtF,+BAA+B,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,eAAe;AAC1G;AACA,yBAAyB,8BAA8B,EAAE,0BAA0B,EAAE;;AAErF,cAAc;AACd,iBAAiB,aAAa,EAAE,qCAAqC,EAAE,cAAc,EAAE;AACvF,4BAA4B,iBAAiB,0BAA0B,EAAE,EAAE;;AAE3E,aAAa,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;AAC5E,aAAa,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAC/E,WAAW,wBAAwB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AAE1E,kBAAkB,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAC1E;EACE,kBAAkB,EAAE,UAAU,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3F,wBAAwB,EAAE,gBAAgB,EAAE,oBAAoB;AAClE;AACA,4CAA4C,kBAAkB,EAAE;AAChE;EACE,WAAW,EAAE,sBAAsB;EACnC,6BAA6B,EAAE,+BAA+B;EAC9D,+BAA+B,EAAE,0BAA0B;EAC3D,4BAA4B,EAAE,iBAAiB,EAAE,oBAAoB;EACrE,gDAAgD;AAClD;AACA,0BAA0B,wBAAwB,EAAE;AACpD,mBAAmB,aAAa,EAAE,2BAA2B,EAAE,wEAAwE,EAAE;AACzI,sBAAsB,YAAY,EAAE,mBAAmB,EAAE;AACzD;EACE,kBAAkB,EAAE,UAAU,EAAE,QAAQ,EAAE,WAAW,EAAE,WAAW;EAClE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,4BAA4B,EAAE,gBAAgB,EAAE,iBAAiB;EACjE,oCAAoC,EAAE,8BAA8B;EACpE,oDAAoD;AACtD;AACA;EACE,gBAAgB,EAAE,wBAAwB,EAAE,eAAe;EAC3D,mBAAmB;EACnB,yDAAwQ;EACxQ,4BAA4B,EAAE,sCAAsC;AACtE;AACA,YAAY,SAAS,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;;AAErE,2BAA2B;AAC3B,eAAe,gBAAgB,EAAE,+BAA+B,EAAE,+BAA+B,EAAE,kBAAkB,EAAE,kEAAkE,EAAE;AAC3L,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,mBAAmB,EAAE;AACzJ,oBAAoB,oBAAoB,EAAE,4BAA4B,EAAE;AACxE,mBAAmB,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE,eAAe,EAAE;AACvF,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACrE,oBAAoB,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AACxF,oBAAoB,eAAe,EAAE,kBAAkB,EAAE,wBAAwB,EAAE,gBAAgB,EAAE;;AAErG;;;;;;;;;;yBAUyB;AACzB;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B,EAAE,+BAA+B;EAC9D,+BAA+B,EAAE,YAAY,EAAE,QAAQ;AACzD;AACA;EACE,SAAO;EACP,YAAY,EAAE,uBAAuB,EAAE,4BAA4B;EACnE,iBAAiB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,2CAA2C;EACpG,eAAe,EAAE,yCAAyC,EAAE,oBAAoB;EAChF,mBAAmB;AACrB;AACA,6BAA6B,8DAA8D,EAAE,oBAAoB,EAAE;AACnH,uDAAuD,yBAAyB,EAAE,qCAAqC,EAAE;;AAEzH;wDACwD;AACxD;EACE,eAAe,YAAY,EAAE,WAAW,EAAE;AAC5C;;AAEA;EACE,iBAAiB,EAAE,kBAAkB;EACrC,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,yBAAyB,EAAE,YAAY,EAAE,qCAAqC;EAC9E,+BAA+B,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,eAAe;EACzG,4BAA4B,EAAE,oBAAoB;AACpD;AACA,oBAAoB,+BAA+B,EAAE;;AAErD,2BAA2B;AAC3B,sBAAsB,mBAAmB,EAAE;AAC3C,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AACrE,kBAAkB,iBAAiB,EAAE,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE;AACrG,cAAc,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE;AACtE,kBAAkB,kBAAkB,EAAE,UAAU,EAAE,wBAAwB,EAAE,oBAAoB,EAAE;AAClG;EACE,6BAA6B,EAAE,+BAA+B,EAAE,+BAA+B;EAC/F,0BAA0B,EAAE,0BAA0B,EAAE,kBAAkB,EAAE,YAAY,EAAE,oBAAoB;AAChH;AACA,iCAAiC,wBAAwB,EAAE;AAC3D,0BAA0B,aAAa,EAAE,2BAA2B,EAAE;AACtE;EACE,gBAAgB,EAAE,wBAAwB,EAAE,eAAe;EAC3D,6BAA6B,EAAE,+BAA+B,EAAE,+BAA+B;EAC/F,4BAA4B,EAAE,0BAA0B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,oBAAoB;EACpH,yDAAwQ;EACxQ,4BAA4B,EAAE,sCAAsC;AACtE;AACA;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,6BAA6B,EAAE,+BAA+B,EAAE,+BAA+B;EAC/F,4BAA4B,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,oBAAoB;AAC9H;AACA,wBAAwB,8BAA8B,EAAE;AACxD,yBAAyB,2BAA2B,EAAE,oBAAoB,EAAE;;AAE5E,UAAU;AACV,kBAAkB,+BAA+B,EAAE,+BAA+B,EAAE,gBAAgB,EAAE;AACtG;EACE,aAAa;EACb,kFAAkF;EAClF,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,kBAAkB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,sBAAsB;EACvF,wBAAwB,EAAE,sCAAsC;AAClE;AACA,WAAW,sCAAsC,EAAE,kBAAkB,EAAE,4BAA4B,EAAE;AACrG,sBAAsB,mBAAmB,EAAE;AAC3C,iBAAiB,mEAAmE,EAAE;AACtF,mBAAmB,6DAA6D,EAAE,uCAAuC,EAAE;;AAE3H;EACE,qBAAqB,EAAE,qCAAqC,EAAE,gBAAgB,EAAE,sBAAsB;EACtG,cAAc,EAAE,uEAAuE;EACvF,6EAA6E;EAC7E,+BAA+B,EAAE,gBAAgB,EAAE,kBAAkB;AACvE;AACA,YAAY,4BAA4B,EAAE;AAC1C,gBAAgB,gBAAgB,EAAE,0BAA0B,EAAE;AAC9D,aAAa,4BAA4B,EAAE;AAC3C;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,iBAAiB,EAAE,iCAAiC,EAAE,kBAAkB,EAAE,gBAAgB;AAC5F;AACA,kBAAkB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,cAAc,EAAE;;AAE/E,eAAe,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;AAC9E;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,uBAAuB,EAAE,+BAA+B,EAAE,+BAA+B;EACzF,iBAAiB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,eAAe,EAAE,oBAAoB;EAC7F,4BAA4B,EAAE,6DAA6D;AAC7F;AACA,gBAAgB,6BAA6B,EAAE,yEAAyE,EAAE;AAC1H,sBAAsB,uEAAuE,EAAE;AAC/F,kBAAkB,2BAA2B,EAAE,uEAAuE,EAAE;AACxH,wBAAwB,qEAAqE,EAAE;AAC/F,kBAAkB,2BAA2B,EAAE,uEAAuE,EAAE;AACxH,wBAAwB,qEAAqE,EAAE;;AAE/F;EACE,kBAAkB,gBAAgB,EAAE;EACpC,8BAA8B,gBAAgB,EAAE;AAClD;;AAEA,oEAAoE;AACpE;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,uDAAuD;EACvD,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;gEAEgE;;AAEhE,qCAAqC;AACrC;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,+BAA+B;EAC/B,yCAAyC;EACzC,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA,8DAA8D;AAC9D;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA,8DAA8D;AAC9D;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,4DAA4D;EAC5D,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,aAAa;AACb;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,8DAA8D;AAC9D;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,4DAA4D;EAC5D,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iEAAiE;EACjE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;gEAEgE;;AAEhE;EACE,8BAA8B;EAC9B,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;2DAE2D;AAC3D;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yGAAyG;EACzG,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS,EAAE,WAAW;EACtB,YAAY,EAAE,aAAa;EAC3B,uFAAuF;EACvF,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,SAAS;EACT,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,6CAA6C;EAC7C,2CAA2C;AAC7C;AACA,2BAA2B,2BAA2B,EAAE,4CAA4C,EAAE;;AAEtG;EACE,uBAAuB,kBAAkB,EAAE;AAC7C;;AAEA,4CAA4C;AAC5C;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;EAIE,gDAAgD;AAClD;;AAEA;;;;EAIE,aAAa;EACb,2BAA2B;EAC3B,wEAAwE;AAC1E;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,gDAAgD;EAChD,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,iCAAiC;EACjC,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,8DAA8D;EAC9D,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,8DAA8D;EAC9D,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mEAAmE;EACnE,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,sEAAsE;EACtE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,mEAAmE;AACrE;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;EAGE,sCAAsC;EACtC,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,0EAA0E;EAC1E,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE;IACE,+CAA+C;EACjD;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0CAA0C;IAC1C,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,gDAAgD;EAClD;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA,8EAA8E;AAC9E;EACE,0DAA0D;AAC5D;;AAEA;EACE,gFAAgF;EAChF,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,gFAAgF;EAChF,8BAA8B;EAC9B,iBAAiB;EACjB,2BAA2B;EAC3B,gFAAgF;AAClF;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,6EAA6E;AAC/E;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB;;;;;;SAMO;EACP,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,gFAAgF;IAChF,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;;IAEE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;AACpB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA,qCAAqC,aAAa,EAAE;;AAEpD;EACE,YAAiC;EAAjC,cAAiC;EAAjC,mCAAiC;EACjC,wBAAwB;EACxB,aAAa;EACb,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,yGAAyG;EACzG,aAAa;EACb,oBAAoB;EACpB,UAAU;AACZ;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,YAAY;EACZ,uFAAuF;EACvF,uBAAuB;EACvB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA,2EAA2E;AAC3E;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,+GAA+G;EAC/G,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV;;;iEAG+D;EAC/D,gCAAgC;EAChC,iBAAiB;EACjB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;8EAE8E;AAC9E;EACE,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;;iCAEiC;AACjC,mBAAmB,oCAAoC,EAAE,8BAA8B,EAAE;AACzF,mBAAmB,gCAAgC,EAAE,+BAA+B,EAAE;;AAEtF;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,oCAAoC,0BAA0B,EAAE;;;AAGhE,uCAAuC;AACvC;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,kCAAkC;EAClC,sCAAsC;EACtC,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,8CAA8C;EAC9C,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA,wBAAwB,SAAS,EAAE;AACnC,wBAAwB,UAAU,EAAE;;AAEpC,0CAA0C;AAC1C;;;;2DAI2D;AAC3D;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yCAAyC;EACzC,UAAU;EACV,kBAAkB;AACpB;AACA;;sEAEsE;AACtE;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,+BAA+B;AACjC;;AAEA,oBAAoB;AACpB;EACE;IACE,YAAgC;IAAhC,cAAgC;IAAhC,kCAAgC;IAChC,aAAa;EACf;;EAEA,eAAe,aAAa,EAAE;EAC9B,iBAAiB,cAAc,EAAE;AACnC;;AAEA,mBAAmB;AACnB;EACE;IACE,aAAa;IACb,aAAa;EACf;;EAEA,eAAe,aAAa,EAAE;EAC9B,iBAAiB,cAAc,EAAE;;EAEjC,iBAAiB,kBAAkB,EAAE;EACrC,iBAAiB,aAAa,EAAE;;EAEhC;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;;gEAEgE;;AAEhE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iCAAiC;EACjC,+BAA+B;EAC/B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;;mEAEmE;;AAEnE,kEAAkE;AAClE;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,oCAAoC,EAAE;AAC3D;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,sEAAsE;AACtE;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,OAAO,mBAAmB,EAAE;EAC5B,OAAO,sBAAsB,EAAE;EAC/B,OAAO,sBAAsB,EAAE;EAC/B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,OAAO,8CAA8C,EAAE;EACvD,OAAO,4CAA4C,IAAI;EACvD,OAAO,2CAA2C,IAAI;AACxD;;AAEA,kEAAkE;AAClE;EACE,0DAA0D;AAC5D;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,mEAAmE;AACnE;EACE,iDAAiD;AACnD;;AAEA,mEAAmE;AACnE,gBAAgB,sCAAsC,EAAE;AACxD,6BAA6B,sBAAsB,EAAE;AACrD,6BAA6B,sBAAsB,EAAE;AACrD,6BAA6B,sBAAsB,EAAE;AACrD,6BAA6B,sBAAsB,EAAE;AACrD,6BAA6B,sBAAsB,EAAE;AACrD,6BAA6B,sBAAsB,EAAE;AACrD,6BAA6B,sBAAsB,EAAE;AACrD,6BAA6B,sBAAsB,EAAE;;AAErD,mEAAmE;AACnE;EACE,4DAA4D;AAC9D;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,kEAAkE;EAClE,8BAA8B;AAChC;;AAEA,mEAAmE;AACnE,WAAW,kDAAkD;EAC3D,8BAA8B;AAChC;AACA,wBAAwB,qBAAqB,EAAE;AAC/C,wBAAwB,qBAAqB,EAAE;AAC/C,wBAAwB,sBAAsB,EAAE;;AAEhD,mEAAmE;AACnE;EACE,qDAAqD;AACvD;;AAEA,mEAAmE;AACnE;EACE,uDAAuD;AACzD;;AAEA,mEAAmE;AACnE;EACE,yDAAyD;AAC3D;;AAEA,mEAAmE;AACnE;EACE,0CAA0C;AAC5C;;AAEA,mEAAmE;AACnE;EACE,mDAAmD;EACnD,2BAA2B;AAC7B;;AAEA,mEAAmE;AACnE;;;;;;EAME,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA,mEAAmE;AACnE;EACE;2DACyD;AAC3D;;AAEA;EACE,kDAAkD;AACpD;;AAEA,mEAAmE;AACnE;EACE,4EAA4E;AAC9E;;AAEA,mEAAmE;AACnE;EACE;2DACyD;AAC3D;;AAEA,6BAA6B,sBAAsB,EAAE;AACrD,wCAAwC,sBAAsB,EAAE;;AAEhE,mEAAmE;AACnE;EACE;8DAC4D;AAC9D;AACA;EACE,sCAAsC;EACtC,wDAAwD;AAC1D;;AAEA,mEAAmE;AACnE;;;EAGE;2DACyD;AAC3D;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA,mEAAmE;AACnE;EACE,6DAA6D;AAC/D;;AAEA,kEAAkE;AAClE;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;IACtC,gCAAgC;EAClC;AACF;;AAEA;;oEAEoE;;AAEpE,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;oBAGoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,yCAAyC;EACzC,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;AACA,wBAAwB,SAAO,EAAE,YAAY,EAAE;AAC/C;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA,+CAA+C,mCAAmC,EAAE;AACpF,mCAAmC,aAAa,EAAE,mBAAmB,EAAE;AACvE,4CAA4C,gCAAgC,EAAE;;AAE9E,mEAAmE;AACnE;EACE,iJAAiJ;EACjJ,0CAA0C;EAC1C,kDAAkD;EAClD,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,oEAAoE;AACtE;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;AACX;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;AACrB;AACA,6BAA6B,kBAAkB,qCAAqC,EAAE,EAAE;AACxF,6BAA6B,kBAAkB,0BAA0B,EAAE,EAAE;;AAE7E;EACE,iJAAiJ;EACjJ,0CAA0C;EAC1C,kDAAkD;EAClD,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;AACA,kBAAkB,eAAe,EAAE,cAAc,EAAE;AACnD;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;AACjC;AACA,YAAY,uCAAuC,EAAE,6BAA6B,EAAE;AACpF,YAAY,qCAAqC,EAAE,2BAA2B,EAAE;AAChF,mBAAmB,iBAAiB,EAAE;AACtC;EACE,iBAAiB;EACjB,wBAAwB;EACxB,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;AACA,aAAa,kBAAkB,EAAE;;AAEjC,mEAAmE;AACnE;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,qEAAqE;EACrE,sEAAsE;EACtE,+BAA+B;AACjC;AACA,qBAAqB,oBAAoB,EAAE,oBAAoB,EAAE,cAAc,EAAE,eAAe,EAAE;AAClG,qBAAqB,SAAS,EAAE,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;AACpG,4BAA4B,0BAA0B,EAAE;;AAExD;EACE,oBAAoB,EAAE,mBAAmB,EAAE,wBAAwB,EAAE,YAAY;AACnF;AACA,2DAA2D,oBAAoB,EAAE,aAAa,EAAE;AAChG;EACE,aAAa,EAAE,uBAAuB,EAAE,QAAQ;EAChD,gBAAgB,EAAE,iBAAiB,EAAE,oCAAoC;EACzE,kBAAkB,EAAE,wBAAwB,EAAE,gBAAgB;AAChE;AACA,4BAA4B,cAAc,EAAE,eAAe,EAAE;AAC7D,+BAA+B,4BAA4B,EAAE;;AAE7D,mEAAmE;AACnE;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA,8BAA8B,gBAAgB,EAAE;AAChD;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,SAAO;AACT;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,8BAA8B;AAChC;AACA;EACE;qBACmB,0BAA0B,EAAE;AACjD;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,mEAAmE;AACnE;;4DAE4D;AAC5D;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,sCAAsC;EACtC,0BAA0B;AAC5B;AACA,wBAAwB,mBAAmB,EAAE;AAC7C,gBAAgB,8BAA8B,EAAE;AAChD,iBAAiB,yFAAyF,EAAE;AAC5G,uBAAuB,4FAA4F,EAAE;;AAErH;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA,eAAe,4BAA4B,EAAE,mBAAmB,EAAE;AAClE,eAAe,gBAAgB,EAAE,mBAAmB,EAAE;AACtD,eAAe,wBAAwB,EAAE,mBAAmB,EAAE;;AAE9D,mEAAmE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,2BAA2B;EAC3B,gBAAgB;AAClB;AACA,wBAAwB,aAAa,EAAE,eAAe,EAAE;AACxD,YAAY,iBAAiB,EAAE;;AAE/B,mEAAmE;AACnE;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,8BAA8B;EAC9B,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA,mEAAmE;AACnE;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;EACjB,0CAA0C;AAC5C;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;AACA,mBAAmB,aAAa,EAAE;;AAElC;;oEAEoE;;AAEpE,mEAAmE;AACnE;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;AACA;;;;;uEAKuE;AACvE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY,YAAY,4DAA4D;EACpF,eAAe;EACf,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;sEAEsE;AACtE;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,yEAAyE;EACzE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,iDAAiD;AACnD;;AAEA;EACE,OAAO,2CAA2C,EAAE;EACpD,OAAO,2CAA2C,EAAE;EACpD,OAAO,yCAAyC,EAAE;AACpD;;AAEA;EACE,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,yEAAyE;EACzE,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;;;6CAG6C;AAC7C;EACE,4BAA4B,aAAa,EAAE;EAC3C;wBACsB,eAAe,EAAE;AACzC;;AAEA;EACE,2CAA2C,eAAe,EAAE;AAC9D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gEAAgE;EAChE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;EAGE;;;;qEAImE;EACnE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB;;;;;;;;;2EASyE;EACzE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,sBAAsB;EACtB,+CAA+C;EAC/C,gBAAgB;EAChB,uBAAuB;AACzB;AACA,gBAAgB,kBAAkB,EAAE,aAAa,EAAE,cAAc,EAAE;AACnE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;;;;qEAMqE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,wBAAwB,kBAAkB,EAAE,aAAa,EAAE;;AAE3D;;;;;;eAMe;AACf;;EAEE,iBAAiB;AACnB;AACA;;;;+DAI+D;AAC/D,0CAA0C,iBAAiB,EAAE;;AAE7D;qDACqD;AACrD;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gDAAgD;AAClD;AACA,uBAAuB,kCAAkC,EAAE;AAC3D;EACE,aAAa;EACb,oCAAoC;EACpC,6CAA6C;AAC/C;AACA;uDACuD;AACvD;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;AACA,iBAAiB,iBAAiB,EAAE,cAAc,EAAE,YAAY,EAAE;;AAElE;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,oCAAoC;EACpC,6CAA6C;AAC/C;AACA,iBAAiB,SAAS,EAAE,kBAAkB,EAAE,2BAA2B,EAAE;AAC7E;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;AACA,sCAAsC,sCAAsC,EAAE;AAC9E,0BAA0B,YAAY,EAAE,mBAAmB,EAAE;;AAE7D;EACE;;wCAEsC;EACtC,0CAA0C,cAAc,EAAE,WAAW,EAAE;EACvE,qBAAqB,cAAc,EAAE,WAAW,EAAE,eAAe,EAAE;EACnE,iBAAiB,YAAY,EAAE,cAAc,EAAE,eAAe,EAAE;EAChE,mBAAmB,WAAW,EAAE,OAAO,EAAE;AAC3C;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,oDAAoD;EACpD,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB;;;;;;8EAM4E;EAC5E,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,yCAAyC;AAC3C;AACA,uBAAuB,8BAA8B,EAAE,0BAA0B,EAAE;AACnF,wBAAwB,kCAAkC,EAAE,qCAAqC,EAAE,+BAA+B,EAAE;AACpI,0BAA0B,eAAe,EAAE;AAC3C,6BAA6B,YAAY,EAAE;;AAE3C,mEAAmE;AACnE;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;AACA,6BAA6B,kBAAkB,qCAAqC,EAAE,EAAE;AACxF,6BAA6B,kBAAkB,0BAA0B,EAAE,EAAE;;AAE7E;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;AACA,YAAY,SAAO,EAAE,YAAY,EAAE;AACnC;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,kBAAkB;AACpB;AACA,6BAA6B,uBAAuB,0BAA0B,EAAE,EAAE;;AAElF,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,qBAAqB;AACrB,uBAAuB,gBAAgB,EAAE;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;AACA,iBAAiB,SAAO,EAAE;AAC1B,cAAc,WAAW,EAAE,iBAAiB,EAAE;AAC9C,iBAAiB,WAAW,EAAE,iBAAiB,EAAE;AACjD,WAAW,gBAAgB,EAAE,UAAU,EAAE,gBAAgB,EAAE,aAAa,EAAE,sBAAsB,EAAE,MAAM,EAAE;AAC1G;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,sCAAsC;AACxC;AACA,sBAAsB,mBAAmB,EAAE;AAC3C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;AAChB;AACA,WAAW,SAAO,EAAE,YAAY,EAAE;AAClC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,YAAY,iBAAiB,EAAE;AAC/B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,gBAAgB,uCAAuC,EAAE,6BAA6B,EAAE;AACxF,kBAAkB,qCAAqC,EAAE,2BAA2B,EAAE;AACtF;iBACiB,8BAA8B,EAAE,wBAAwB,EAAE;;AAE3E;EACE,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;AACA,0BAA0B,0BAA0B,EAAE;;AAEtD,mEAAmE;AACnE;EACE,aAAa;EACb;;;4EAG0E;EAC1E,sEAAsE;EACtE,SAAS;EACT,oBAAoB;AACtB;AACA,4BAA4B,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE;AACjF;;;;;2DAK2D;AAC3D;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;AACf;AACA;;gFAEgF;AAChF,+BAA+B,8BAA8B,EAAE;AAC/D,6BAA6B,iBAAiB,8BAA8B,EAAE,EAAE;AAChF,6BAA6B,iBAAiB,0BAA0B,EAAE,EAAE;;AAE5E,mBAAmB;AACnB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA,WAAW,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,cAAc,EAAE;AACxE,YAAY,SAAO,EAAE,4BAA4B,EAAE;AACnD,WAAW,gBAAgB,EAAE,0BAA0B,EAAE,mBAAmB,EAAE;AAC9E,WAAW,wBAAwB,EAAE,kBAAkB,EAAE;;AAEzD;;;;;;sDAMsD;AACtD,kBAAkB,2BAA2B,EAAE;AAC/C,eAAe,mBAAmB,EAAE,WAAW,EAAE;AACjD;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,kBAAkB,kBAAkB,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AACzF,6DAA6D,UAAU,EAAE;AACzE,6DAA6D,UAAU,EAAE;AACzE,6DAA6D,UAAU,EAAE;AACzE,6DAA6D,UAAU,EAAE;AACzE,6DAA6D,UAAU,EAAE;AACzE;;;;4EAI4E;AAC5E,+BAA+B,mBAAmB,EAAE;AACpD;EACE,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,wEAAwE;AACxE;EACE,6DAA6D,aAAa,EAAE;EAC5E,6DAA6D,UAAU,EAAE;EACzE,6DAA6D,UAAU,EAAE;EACzE,6DAA6D,UAAU,EAAE;EACzE,6DAA6D,UAAU,EAAE;AAC3E;AACA;+EAC+E;AAC/E,iDAAiD,SAAO,EAAE,aAAa,EAAE;AACzE,+BAA+B,YAAY,EAAE;AAC7C,oCAAoC,gBAAgB,EAAE;AACtD,SAAS,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;;AAE7E,mFAAmF;AACnF,6BAA6B,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;AAC7E,2BAA2B,iBAAiB,EAAE,iBAAiB,EAAE;AACjE,4BAA4B,kBAAkB,EAAE;;AAEhD;;wDAEwD;AACxD;EACE,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;AACvB;AACA,aAAa,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE;AACxD;EACE,UAAU;EACV,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,wCAAwC;AAC1C;AACA;8EAC8E;AAC9E,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE;AAC/E,oBAAoB,eAAe,EAAE,gBAAgB,EAAE;;AAEvD;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,oBAAoB;EACpB,sCAAsC;AACxC;AACA,iBAAiB,YAAY,EAAE;AAC/B,wBAAwB,iBAAiB,EAAE;AAC3C;EACE,mDAAmD;EACnD,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;oEACoE;AACpE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;AACA,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAChE;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,cAAc;AAChB;AACA,kBAAkB,SAAO,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC1F,mBAAmB,kBAAkB,EAAE,wBAAwB,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AACpH,iBAAiB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,mBAAmB,EAAE;;AAExG;qEACqE;AACrE,+BAA+B,cAAc,EAAE,YAAY,EAAE;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,YAAY;EACZ,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA,uBAAuB,yBAAyB,EAAE;;AAElD,kBAAkB,eAAe,EAAE;AACnC;EACE,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;AACnB;AACA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;AACA,yBAAyB,aAAa,EAAE;AACxC;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA,0BAA0B,8BAA8B,EAAE;;AAE1D,mEAAmE;AACnE;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,gBAAgB;AAClB;AACA,4BAA4B,mBAAmB,0BAA0B,EAAE,EAAE;;AAE7E,oBAAoB,iBAAiB,EAAE;AACvC;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gBAAgB,EAAE,UAAU,EAAE,gBAAgB;EAC9C,aAAa,EAAE,sBAAsB,EAAE,SAAS;AAClD;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;AAC/C;AACA;EACE,WAAW,EAAE,eAAe;EAC5B,kBAAkB,EAAE,gBAAgB;EACpC,wBAAwB,EAAE,kBAAkB;AAC9C;AACA;EACE,SAAO,EAAE,YAAY;AACvB;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB;AAClE;AACA;EACE,kBAAkB,EAAE,gBAAgB;EACpC,0BAA0B,EAAE,mBAAmB;EAC/C,gBAAgB,EAAE,uBAAuB;AAC3C;AACA;EACE,kBAAkB,EAAE,gBAAgB;EACpC,qCAAqC,EAAE,2BAA2B;EAClE,gBAAgB,EAAE,+BAA+B;EACjD,mBAAmB;AACrB;AACA;EACE,uCAAuC,EAAE,6BAA6B;AACxE;AACA;EACE,WAAW,EAAE,8BAA8B;EAC3C,iCAAiC,EAAE,gBAAgB;AACrD;AACA;EACE,YAAY,EAAE,iCAAiC;EAC/C,yDAAyD;AAC3D;AACA;EACE,kBAAkB,EAAE,gBAAgB;EACpC,4BAA4B,EAAE,mBAAmB;EACjD,eAAe,EAAE,iBAAiB;AACpC;;AAEA;;oEAEoE;;AAEpE,mEAAmE;AACnE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,2BAA2B;EAC3B,2CAA2C;EAC3C,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,kEAAkE;AAClE;EACE,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,iIAAiI;EACjI,2CAA2C;EAC3C,2CAA2C;EAC3C,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;AACA,mBAAmB,6CAA6C,EAAE;AAClE;EACE,0FAA0F;EAC1F,mCAAmC;AACrC;AACA,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AACpE;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,gDAAgD;AAClD;AACA,wBAAwB,qBAAqB,EAAE;AAC/C,wBAAwB,qBAAqB,EAAE;AAC/C,wBAAwB,qBAAqB,EAAE;AAC/C,wBAAwB,qBAAqB,EAAE;AAC/C;EACE,WAAW,aAAa,EAAE,sBAAsB,EAAE;EAClD,YAAY,UAAU,KAAK,sBAAsB,EAAE;AACrD;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,wIAAwI;EACxI,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sEAAsE;EACtE,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;AACA,wBAAwB,wBAAwB,EAAE;;AAElD,mEAAmE;AACnE;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,kFAAkF;EAClF,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;EACvC,6BAA6B;EAC7B,6CAA6C;EAC7C,iBAAiB;EACjB,+BAA+B;AACjC;AACA,mBAAmB,kBAAkB,EAAE,wBAAwB,EAAE;AACjE;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA,4BAA4B,mBAAmB,0BAA0B,EAAE,EAAE;AAC7E;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,+CAA+C;EAC/C,+BAA+B;AACjC;AACA,mBAAmB,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE;AACvE,mBAAmB,SAAO,EAAE,YAAY,EAAE;AAC1C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;AACA,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AACtF,eAAe,eAAe,EAAE,oBAAoB,EAAE;AACtD,mBAAmB,2BAA2B,EAAE;AAChD,aAAa,eAAe,EAAE,gBAAgB,EAAE;AAChD;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,8EAA8E;EAC9E,4DAA4D;EAC5D,qBAAqB;AACvB;AACA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,oCAAoC,EAAE;AAC3D;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,MAAM;EACN,+BAA+B;EAC/B,sCAAsC;EACtC,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,+EAA+E;EAC/E,oBAAoB;EACpB,oDAAoD;AACtD;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0DAA0D;AAC5D;AACA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,iCAAiC;EACjC,wBAAwB;EACxB,8BAA8B;EAC9B,oDAAoD;AACtD;AACA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,kEAAkE;EAClE,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE;EACE,yBAAyB;EACzB,+CAA+C;EAC/C,cAAc;EACd,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mCAAmC;AACrC;AACA,2BAA2B,mBAAmB,EAAE;;AAEhD;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,0DAA0D;AAC5D;AACA,0CAA0C,qBAAqB,EAAE;AACjE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;AACX;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;AACA;EACE,aAAa;EACb,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,MAAM,qBAAqB,2CAA2C;EACtE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8DAA8D;EAC9D,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB;;;uBAGqB;EACrB,+BAA+B;AACjC;AACA,iBAAiB,4BAA4B,EAAE;AAC/C;EACE,2BAA2B;EAC3B,qDAAqD;AACvD;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA,oEAAoE;AACpE;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,8DAA8D;EAC9D,mBAAmB;AACrB;AACA;EACE,OAAO,UAAU,EAAE,qCAAqC,EAAE;EAC1D,OAAO,UAAU,EAAE,mCAAmC,EAAE;AAC1D;AACA,WAAW,qCAAqC,EAAE,2BAA2B,EAAE;AAC/E,WAAW,qCAAqC,EAAE,2BAA2B,EAAE;AAC/E,WAAW,uCAAuC,EAAE,0BAA0B,EAAE;AAChF,WAAW,uCAAuC,EAAE,6BAA6B,EAAE;AACnF;EACE,iIAAiI;EACjI,2BAA2B;EAC3B,kBAAkB;EAClB;0EACwE;AAC1E;AACA;EACE,OAAO,mBAAmB,EAAE;EAC5B,OAAO,oCAAoC,EAAE;EAC7C,OAAO,mCAAmC,EAAE;EAC5C,OAAO,mBAAmB,EAAE;AAC9B;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,2DAA2D;EAC3D,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE,aAAa,EAAE;EAChE,OAAO,UAAU,EAAE,wBAAwB,KAAK,iBAAiB,EAAE;AACrE;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA,UAAU,oBAAoB,EAAE,gBAAgB,EAAE;AAClD,UAAU,wBAAwB,EAAE,gBAAgB,EAAE;AACtD;EACE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,0DAA0D;EAC1D,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,mFAAmF;AACrF;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA,iBAAiB,aAAa,EAAE,QAAQ,EAAE;AAC1C;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,2GAA2G;AAC7G;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;;AAEjE;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,qCAAqC;EACrC,2CAA2C;EAC3C,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6FAA6F;EAC7F,8BAA8B;EAC9B,wBAAwB;EACxB,iCAAiC;AACnC;AACA;EACE,kIAAkI;EAClI,+BAA+B;EAC/B,yBAAyB;EACzB,mFAAmF;AACrF;AACA;EACE,2BAA2B;EAC3B,mFAAmF;AACrF;AACA,8BAA8B,wBAAwB,EAAE;AACxD,0BAA0B,YAAY,EAAE,mBAAmB,EAAE;AAC7D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,0CAA0C;EAC1C,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,mEAAmE;AACnE;;;kEAGkE;AAClE;EACE,WAAW,sBAAsB,EAAE;EACnC,cAAc,yBAAyB,EAAE;EACzC,iBAAiB,uBAAuB,EAAE;EAC1C,WAAW,WAAW,EAAE,iBAAiB,EAAE;EAC3C,kBAAkB,aAAa,EAAE;AACnC;;AAEA;;oEAEoE;;AAEpE,WAAW,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAE7D,mEAAmE;AACnE;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;AACA,4BAA4B,kBAAkB,0BAA0B,EAAE,EAAE;;AAE5E,uBAAuB;AACvB;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;AACA,oBAAoB,aAAa,EAAE,QAAQ,EAAE;AAC7C,eAAe,iBAAiB,EAAE,2BAA2B,EAAE,uBAAuB,EAAE;AACxF,mBAAmB,2BAA2B,EAAE;AAChD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;AACA,kBAAkB,kBAAkB,EAAE,wBAAwB,EAAE;;AAEhE,sBAAsB;AACtB,WAAW,WAAW,EAAE,gBAAgB,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC3F,eAAe,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC7D,gBAAgB,kBAAkB,EAAE,wBAAwB,EAAE,WAAW,EAAE,iBAAiB,EAAE,cAAc,EAAE;AAC9G;EACE,SAAO;EACP,WAAW;EACX,8BAA8B;EAC9B,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gCAAgC;EAChC,iCAAiC;EACjC,kDAAkD;AACpD;AACA,iBAAiB,kBAAkB,EAAE,wBAAwB,EAAE,WAAW,EAAE,cAAc,EAAE;;AAE5F,sBAAsB;AACtB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA,6BAA6B,gBAAgB,qCAAqC,EAAE,EAAE;;AAEtF;EACE,iFAAiF;EACjF,+BAA+B;EAC/B,+CAA+C;EAC/C,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;AAChC;AACA,cAAc,aAAa,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AACvE,eAAe,iBAAiB,EAAE;AAClC,gBAAgB,kBAAkB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE;AAChF;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,WAAW;EACX,8BAA8B;EAC9B,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,qCAAqC;EACrC,iCAAiC;EACjC,kDAAkD;AACpD;AACA,gBAAgB,aAAa,EAAE,QAAQ,EAAE;;AAEzC,mEAAmE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA,mBAAmB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;AAC7D;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,iCAAiC;EACjC,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;AACA,wBAAwB,kCAAkC,EAAE,2BAA2B,EAAE;AACzF;EACE,gCAAgC;EAChC,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA,mEAAmE;AACnE,WAAW,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAE7D;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,iDAAiD;EACjD,+BAA+B;EAC/B,gBAAgB;EAChB,iCAAiC;EACjC,8BAA8B;AAChC;AACA,iBAAiB,2CAA2C,EAAE;AAC9D,gBAAgB,0CAA0C,EAAE;;AAE5D;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;AACA,sBAAsB,8BAA8B,EAAE;;AAEtD,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC/D;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;EACd,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;AACX;AACA,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,cAAc,EAAE;AAChF;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,+BAA+B;AACjC;AACA,cAAc,iBAAiB,EAAE,wBAAwB,EAAE;;AAE3D,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,sCAAsC;AACxC;AACA,WAAW,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACzD,gBAAgB,eAAe,EAAE;;AAEjC,eAAe;AACf,gBAAgB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACrE,YAAY,kBAAkB,EAAE,2BAA2B,EAAE;AAC7D,gBAAgB,2BAA2B,EAAE;AAC7C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;AACA,kBAAkB,kBAAkB,EAAE,gBAAgB,EAAE;;AAExD,oBAAoB;AACpB;EACE,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,4DAA4D;AAC9D;AACA,4BAA4B,aAAa,0BAA0B,EAAE,EAAE;;AAEvE;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,gDAAgD;EAChD,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAChE,kBAAkB,iBAAiB,EAAE;AACrC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;AACA,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,oCAAoC,EAAE;AAC5H;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;EACT,iBAAiB;AACnB;;AAEA;;gEAEgE;;AAEhE;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,4CAA4C;AAC9C;;AAEA,gEAAgE;AAChE;;;+CAG+C;AAC/C;EACE,mCAAmC;EACnC,qCAAqC;EACrC;;;;;;;qCAOmC;EACnC,gFAAgF;AAClF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB;yDACuD;EACvD,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;;;;oCAIoC;AACpC;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iCAAiC;EACjC;qEACmE;EACnE,sFAAsF;EACtF,+FAA+F;AACjG;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA,gBAAgB,gBAAgB,EAAE;AAClC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,sCAAsC;AACxC;AACA,mBAAmB,kBAAkB,EAAE,4BAA4B,EAAE;AACrE;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB;kCACgC;EAChC,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;0DAC0D;AAC1D,eAAe,kCAAkC,EAAE;AACnD;;mCAEmC;AACnC,cAAc,0BAA0B,EAAE;AAC1C;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA,uBAAuB,aAAa,EAAE,mBAAmB,EAAE;AAC3D;EACE,uBAAuB;EACvB,wCAAwC;EACxC,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;;;;8DAK8D;AAC9D;;;uDAGuD;AACvD;;EAEE;;;;;GAKC;AACH;;AAEA;;;qEAGqE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,sBAAsB;EACtB;2DACyD;EACzD,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;2CAC2C;AAC3C;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA,qBAAqB,qBAAqB,EAAE,iBAAiB,EAAE;;AAE/D;;;;;;oDAMoD;AACpD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB;4DAC0D;EAC1D,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;2DAC2D;AAC3D;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,qFAAqF;AACvF;;AAEA;+DAC+D;AAC/D;EACE;uBACqB,aAAa,EAAE;AACtC;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;;;wDAGwD;AACxD;EACE,iBAAiB,0BAA0B,EAAE,iBAAiB,EAAE;EAChE;IACE,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;EACA,aAAa,aAAa,EAAE;AAC9B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,yCAAyC;EACzC,mBAAmB;AACrB;AACA,sBAAsB,yBAAyB,EAAE,kCAAkC,EAAE;;AAErF,gEAAgE;AAChE;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,uEAAuE;EACvE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,8CAA8C;AAChD;AACA,+BAA+B,sBAAsB,EAAE;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;EACnB;;;0EAGwE;EACxE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,SAAO;EACP,gBAAgB;EAChB,qBAAqB;AACvB;AACA,iCAAiC,aAAa,EAAE;;AAEhD;EACE,gBAAgB;EAChB,YAAY;EACZ;;yDAEuD;EACvD,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,oBAAoB;EACpB,oCAAoC;AACtC;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,oBAAoB;EACpB,oCAAoC;AACtC;AACA,eAAe,cAAc,EAAE,oBAAoB,EAAE;;AAErD,yDAAyD;AACzD,yBAAyB,eAAe,EAAE,UAAU,EAAE;;AAEtD;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,mCAAmC;EACnC,kBAAkB;EAClB,+BAA+B;EAC/B,mCAAmC;AACrC;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,+BAA+B;EAC/B,iBAAiB;EACjB,kEAAkE;AACpE;AACA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,+BAA+B;AACjC;AACA;EACE,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;AACf;AACA,gCAAgC,2BAA2B,EAAE;;AAE7D;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,yCAAyC;AAC3C;AACA,yBAAyB,0BAA0B,EAAE,yBAAyB,EAAE;;AAEhF;EACE,gBAAgB;EAChB,iCAAiC;EACjC,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,gEAAgE;AAChE,oCAAoC,mCAAmC,EAAE;AACzE,oCAAoC,kCAAkC,EAAE;AACxE;+CAC+C,wEAAwE,EAAE;AACzH,0CAA0C,6BAA6B,EAAE,wEAAwE,EAAE;AACnJ,+CAA+C,+BAA+B,EAAE;;AAEhF;;gEAEgE;AAChE;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,+BAA+B;EAC/B,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,uEAAuE;EACvE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,8BAA8B;EAC9B,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA,mBAAmB,8BAA8B,EAAE;;AAEnD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iCAAiC;EACjC,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,6DAA6D;EAC7D,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,qCAAqC;AACvC;AACA,sBAAsB,aAAa,EAAE;AACrC,gBAAgB,wBAAwB,EAAE;;AAE1C,mBAAmB,aAAa,EAAE;AAClC,uBAAuB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;;AAEzF;EACE;;yBAEuB;EACvB;;;;IAIE,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;EACA,gEAAgE;EAChE,wDAAwD,aAAa,EAAE;;EAEvE,mCAAmC,aAAa,EAAE;AACpD;;AAEA;;gEAEgE;AAChE;EACE,kBAAkB;EAClB,oBAAoB,GAAG,8DAA8D;AACvF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,+BAA+B;EAC/B,yCAAyC;EACzC,mBAAmB;EACnB,YAAY;AACd;AACA;;EAEE,oBAAoB;EACpB,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,8CAA8C;AAChD;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,4CAA4C;EAC5C,YAAY;EACZ,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,yCAAyC;AAC3C;AACA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,MAAM;AACR;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,wBAAwB,oBAAoB,EAAE;;AAE9C;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,qCAAqC;AACvC;AACA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA,6BAA6B,iBAAiB,qCAAqC,EAAE,EAAE;AACvF,6BAA6B,iBAAiB,qCAAqC,EAAE,EAAE;;AAEvF;EACE,yFAAyF;EACzF,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,uDAAuD;EACvD,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;AACA,gBAAgB,SAAO,EAAE,YAAY,EAAE;AACvC;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA,4BAA4B,iBAAiB,0BAA0B,EAAE,EAAE;;AAE3E;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;AAChC;AACA,iBAAiB,mBAAmB,EAAE;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;AACA,4BAA4B,sBAAsB,0BAA0B,EAAE,EAAE;;AAEhF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iFAAiF;EACjF,kFAAkF;EAClF,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;EACT,cAAc;AAChB;AACA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,0BAA0B;EAC1B,sBAAsB;AACxB;AACA,mCAAmC,mBAAmB,EAAE;AACxD,eAAe,4BAA4B,EAAE;AAC7C,wBAAwB,+BAA+B,EAAE;;AAEzD,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,qFAAqF;EACrF,yCAAyC;EACzC,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,uEAAuE;AACvE;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;6DAI6D;AAC7D;;;EAGE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,6EAA6E;EAC7E,mFAAmF;EACnF,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,6BAA6B;EAC7B,wCAAwC;EACxC,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B,aAAa,iBAAiB,EAAE,kCAAkC,EAAE,iBAAiB,EAAE;AACvF;;0CAE0C;AAC1C,sBAAsB,iBAAiB,EAAE,kBAAkB,EAAE;AAC7D,gBAAgB,6BAA6B,EAAE,gBAAgB,EAAE;AACjE,WAAW,6BAA6B,EAAE,gBAAgB,EAAE;AAC5D,oCAAoC,6BAA6B,EAAE;AACnE,+BAA+B,6BAA6B,EAAE;AAC9D,aAAa,2BAA2B,EAAE,gBAAgB,EAAE;AAC5D,aAAa,2BAA2B,EAAE,gBAAgB,EAAE;AAC5D,aAAa,4BAA4B,EAAE;AAC3C,aAAa,kBAAkB,EAAE,4BAA4B,EAAE,kBAAkB,EAAE,eAAe,EAAE;;AAEpG,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,4BAA4B;EAC5B,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;AACA,yBAAyB,2BAA2B,EAAE;AACtD,gCAAgC,4BAA4B,EAAE;AAC9D,mBAAmB,aAAa,EAAE,QAAQ,EAAE;AAC5C;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA,iBAAiB,2BAA2B,EAAE,oBAAoB,EAAE;AACpE,kBAAkB,yBAAyB,EAAE,2BAA2B,EAAE,qCAAqC,EAAE;AACjH;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB,iBAAiB,aAAa,EAAE,QAAQ,EAAE;AAC1C;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,yCAAyC;AAC3C;AACA,uBAAuB,aAAa,EAAE,2BAA2B,EAAE;AACnE,eAAe,mCAAmC,EAAE,6BAA6B,EAAE;AACnF,eAAe,mCAAmC,GAAG,6BAA6B,EAAE;AACpF,eAAe,kCAAkC,IAAI,2BAA2B,EAAE;;AAElF;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA,qBAAqB,mCAAmC,EAAE,qBAAqB,EAAE;;AAEjF,qCAAqC;AACrC;EACE,iBAAiB;EACjB,yBAAyB;EACzB,qCAAqC;EACrC,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,mBAAmB;AACrB;AACA,wBAAwB,aAAa,EAAE,2BAA2B,EAAE;AACpE;EACE,iBAAiB;EACjB,kCAAkC;EAClC,2BAA2B;EAC3B,uCAAuC;EACvC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA,uBAAuB,kCAAkC,EAAE;AAC3D;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;AACA,sBAAsB,+BAA+B,EAAE,0BAA0B,EAAE,2BAA2B,EAAE;AAChH,eAAe,kCAAkC,EAAE,2BAA2B,EAAE,YAAY,EAAE;AAC9F,eAAe,mCAAmC,EAAE,6BAA6B,EAAE,YAAY,EAAE;AACjG,aAAa,kBAAkB,EAAE,iBAAiB,EAAE;;AAEpD,yBAAyB;AACzB;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,sCAAsC;EACtC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA,qBAAqB,8BAA8B,EAAE;AACrD;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,cAAc;AAChB;AACA,mBAAmB,SAAO,EAAE,gBAAgB,EAAE;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,mCAAmC;AACrC;AACA,4BAA4B,oBAAoB,qCAAqC,EAAE,EAAE;AACzF;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;AACvC;AACA,uBAAuB,kBAAkB,EAAE;AAC3C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,QAAQ;EACR,sCAAsC;EACtC,UAAU;EACV,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;AACrB;AACA,wBAAwB,0BAA0B,EAAE;AACpD,yBAAyB,oBAAoB,EAAE,kCAAkC,EAAE,gBAAgB,EAAE;;AAErG,8BAA8B;AAC9B,eAAe,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,cAAc,EAAE;AACjF,eAAe,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC9D,eAAe,iBAAiB,EAAE,4BAA4B,EAAE,WAAW,EAAE,cAAc,EAAE;AAC7F,mBAAmB,SAAO,EAAE,WAAW,EAAE,8BAA8B,EAAE,+BAA+B,EAAE,gBAAgB,EAAE;AAC5H,cAAc,YAAY,EAAE,+BAA+B,EAAE,4BAA4B,EAAE;AAC3F,cAAc,kBAAkB,EAAE,4BAA4B,EAAE,WAAW,EAAE,iBAAiB,EAAE,cAAc,EAAE;;AAEhH,cAAc;AACd;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,uBAAuB;AACzB;AACA,4BAA4B,gBAAgB,0BAA0B,EAAE,EAAE;AAC1E;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,+BAA+B;EAC/B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8BAA8B;AAChC;AACA,eAAe,iBAAiB,EAAE,cAAc,EAAE;AAClD,eAAe,SAAO,EAAE;AACxB,eAAe,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AAClG,eAAe,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;AAC5E,kBAAkB,aAAa,EAAE,QAAQ,EAAE;;AAE3C,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kFAAkF;EAClF,uCAAuC;EACvC,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;AAChB;AACA,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,SAAS,EAAE;AAC/F,qBAAqB,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE;;AAExF;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,kBAAkB;EAClB,8BAA8B;AAChC;AACA,4BAA4B,oBAAoB,0BAA0B;EACxE,8BAA8B;AAChC,EAAE;AACF,oBAAoB,aAAa,EAAE,SAAS,EAAE,uBAAuB,EAAE;AACvE,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AAClG,yBAAyB,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,yBAAyB,EAAE,sBAAsB,EAAE,eAAe,EAAE;AACjK,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACpG,uBAAuB,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAErG,kDAAkD;AAClD;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA,yBAAyB,sCAAsC,EAAE,0BAA0B,EAAE;AAC7F,0BAA0B,yEAAyE,EAAE,sCAAsC,EAAE,+BAA+B,EAAE,gBAAgB,EAAE;AAChM,yBAAyB,iBAAiB,EAAE,gBAAgB,EAAE,+BAA+B,EAAE,gBAAgB,EAAE,+BAA+B,EAAE;;AAElJ,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mCAAmC;EACnC,6BAA6B;EAC7B,wCAAwC;EACxC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;AACA,yBAAyB,mCAAmC,EAAE;;AAE9D;;iEAEiE;;AAEjE;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,gBAAgB,uBAAuB,EAAE;AAC3C;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;AAChC;AACA,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAClE,mBAAmB,iBAAiB,EAAE,cAAc,EAAE;AACtD,mBAAmB,gBAAgB,EAAE,0BAA0B,EAAE,SAAS,EAAE,eAAe,EAAE;AAC7F,mBAAmB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;AAChF;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;AACA,sBAAsB,kCAAkC,EAAE,2BAA2B,EAAE;;AAEvF,aAAa;AACb,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACtE;EACE,WAAW;EACX,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,YAAY;EACZ,yBAAyB;AAC3B;AACA,mDAAmD,UAAU,EAAE;AAC/D;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,qCAAqC;AACvC;AACA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,4BAA4B,qBAAqB,aAAa,EAAE,EAAE;;AAElE,SAAS;AACT;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;AACA,iBAAiB,iBAAiB,EAAE,4BAA4B,EAAE;;AAElE,cAAc;AACd,gBAAgB,uBAAuB,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC3F,iBAAiB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;;AAE9E,WAAW;AACX,YAAY,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC7D,YAAY,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAC9E,YAAY,2BAA2B,EAAE,gBAAgB,EAAE;AAC3D,YAAY,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;AACzE,gBAAgB,kBAAkB,EAAE,2BAA2B,EAAE,SAAS,EAAE;AAC5E,iBAAiB,kBAAkB,EAAE,4BAA4B,EAAE,iBAAiB,EAAE,eAAe,EAAE;;AAEvG;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;EACjC,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;AACA,kDAAkD,kCAAkC,EAAE;AACtF,oDAAoD,4BAA4B,EAAE,aAAa,EAAE;AACjG,eAAe,gBAAgB,EAAE,iBAAiB,EAAE;AACpD,aAAa,eAAe,EAAE,gBAAgB,EAAE,yDAAoO,EAAE,4BAA4B,EAAE,sCAAsC,EAAE,mBAAmB,EAAE;AACjX;yEACyE;AACzE;EACE,wBAAwB,gBAAgB,EAAE;AAC5C;;AAEA,0DAA0D;AAC1D;;EAEE,+CAA+C;AACjD;AACA,kBAAkB,gDAAgD,EAAE;AACpE;;;EAGE,oCAAoC;EACpC,+BAA+B;AACjC;AACA;;qBAEqB,oCAAoC,EAAE;AAC3D;;;EAGE,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA;;;;EAIE,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;AACA,sBAAsB,sBAAsB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC5F,iBAAiB,mBAAmB,EAAE,iBAAiB,EAAE;;AAEzD;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,8EAA8E;AAChF;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,6BAA6B;EAC7B,6CAA6C;EAC7C,mBAAmB;AACrB;AACA,uBAAuB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;AACrE,0BAA0B,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,QAAQ,EAAE,YAAY,EAAE;AACvG;;EAEE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,sBAAsB,qCAAqC,EAAE,wCAAwC,EAAE,8CAA8C,EAAE;AACvJ,gCAAgC,aAAa,EAAE,YAAY,EAAE;AAC7D,sBAAsB,2BAA2B,EAAE,uBAAuB,EAAE,sCAAsC,EAAE;AACpH,wCAAwC,gBAAgB,EAAE;;AAE1D;EACE,kBAAkB,uBAAuB,EAAE;EAC3C,iBAAiB,kBAAkB,EAAE;AACvC;;AAEA,aAAa,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE;AACvE,4BAA4B,aAAa,0BAA0B,EAAE,EAAE;;AAEvE,kBAAkB;AAClB,kBAAkB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;AAC5D;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,iCAAiC;EACjC,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,uBAAuB,2BAA2B,EAAE,qBAAqB,EAAE;AAC3E,0BAA0B,2BAA2B,EAAE,mCAAmC,EAAE;;AAE5F,gBAAgB;AAChB,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;EACjC,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;AACvB;AACA,uBAAuB,2BAA2B,EAAE;AACpD,0BAA0B,2BAA2B,EAAE,mCAAmC,EAAE;AAC5F,kBAAkB,aAAa,EAAE;AACjC,kBAAkB,iBAAiB,EAAE,cAAc,EAAE;AACrD,kBAAkB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,SAAS,EAAE;AAC/F,kBAAkB,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE;;AAErF,wBAAwB;AACxB,qBAAqB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;AAChE;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;EACjC,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;AACvB;AACA,wBAAwB,2BAA2B,EAAE;AACrD,2BAA2B,2BAA2B,EAAE,mCAAmC,EAAE;AAC7F,mBAAmB,iBAAiB,EAAE;AACtC,mBAAmB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;;AAErF,aAAa;AACb;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,wCAAwC;EACxC,+BAA+B;EAC/B,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA,kBAAkB,kCAAkC,EAAE,mCAAmC,EAAE;AAC3F,gBAAgB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;;AAElE,mBAAmB;AACnB;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,sCAAsC;AACxC;AACA,sBAAsB,aAAa,EAAE,sBAAsB,EAAE;AAC7D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;AACxC;AACA,gCAAgC,mBAAmB,EAAE;AACrD,0BAA0B,4BAA4B,EAAE;AACxD,4BAA4B,0BAA0B,EAAE;;AAExD,mBAAmB;AACnB,kBAAkB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE;AAC5E,4BAA4B,kBAAkB,0BAA0B,EAAE,EAAE;AAC5E;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,8BAA8B;EAC9B,sCAAsC;EACtC,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;AACA,4BAA4B,mBAAmB,EAAE;AACjD,mBAAmB,4BAA4B,EAAE,cAAc,EAAE;AACjE,mBAAmB,0BAA0B,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,qBAAqB,EAAE;;AAE3G,eAAe;AACf,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACnE;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA,oBAAoB,2BAA2B,EAAE;AACjD;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;AACA,WAAW,oBAAoB,EAAE,0BAA0B,EAAE,eAAe,EAAE;;AAE9E,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA,qBAAqB,2BAA2B,EAAE,0BAA0B,EAAE;AAC9E;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,+BAA+B;EAC/B,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;AACA,qBAAqB,aAAa,EAAE,2BAA2B,EAAE;AACjE;EACE,kBAAkB;EAClB,oIAAoI;EACpI,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA,sCAAsC,aAAa,EAAE,2BAA2B,EAAE;AAClF,0BAA0B,YAAY,EAAE,mBAAmB,EAAE;AAC7D,cAAc,qBAAqB,EAAE,uCAAuC,EAAE;AAC9E,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;AACA,mBAAmB,eAAe,EAAE;AACpC,oBAAoB,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,SAAS,EAAE;AAChG,kBAAkB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;AAC/E;EACE,WAAW;EACX,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,4BAA4B;AAC9B;AACA,6BAA6B,mBAAmB,EAAE;AAClD,aAAa,sBAAsB,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,sBAAsB,EAAE;AACtG;EACE,WAAW;EACX,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,sCAAsC;EACtC,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;AACxC;AACA,8BAA8B,mBAAmB,EAAE;AACnD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA,yBAAyB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,SAAS,EAAE;AACtG,yBAAyB,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE;AAC5F;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;AACA,6BAA6B,aAAa,EAAE,2BAA2B,EAAE;;AAEzE,+BAA+B;AAC/B;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,iCAAiC;EACjC,+BAA+B;EAC/B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA,8BAA8B,mCAAmC,EAAE,2BAA2B,EAAE;;AAEhG;;iEAEiE;;AAEjE;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;AACA,qBAAqB,2BAA2B,EAAE,oBAAoB,EAAE;AACxE,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAClE,mBAAmB,gBAAgB,EAAE,0BAA0B,EAAE,SAAS,EAAE,kBAAkB,EAAE;AAChG,mBAAmB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;;AAEhF,gBAAgB;AAChB;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;AACA;EACE,SAAO;EACP,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;EACjC,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,gDAAgD;AAClD;AACA,kBAAkB,2BAA2B,EAAE,6CAA6C,EAAE;AAC9F,kBAAkB,kCAAkC,EAAE;AACtD,yBAAyB,gBAAgB,EAAE,sBAAsB,EAAE,4BAA4B,EAAE,aAAa,EAAE;AAChH;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,+BAA+B;EAC/B,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;AAC3C;AACA,sCAAsC,aAAa,EAAE,2BAA2B,EAAE;AAClF,0BAA0B,aAAa,EAAE,mBAAmB,EAAE;AAC9D,gBAAgB,kBAAkB,EAAE,2BAA2B,EAAE,SAAS,EAAE;;AAE5E,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;AACA,kBAAkB,eAAe,EAAE,cAAc,EAAE,cAAc,EAAE;AACnE,kBAAkB,SAAO,EAAE;AAC3B,mBAAmB,kBAAkB,EAAE,gBAAgB,EAAE,SAAS,EAAE;AACpE,mBAAmB,iBAAiB,EAAE,sBAAsB,EAAE,sBAAsB,EAAE,4BAA4B,EAAE,eAAe,EAAE;AACrI;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,cAAc;AAChB;AACA,sBAAsB,UAAU,UAAU,EAAE,mBAAmB,EAAE,EAAE,MAAM,YAAY,EAAE,qBAAqB,EAAE,EAAE;;AAEhH,cAAc;AACd;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;AAChC;AACA,kBAAkB,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,8BAA8B,EAAE,+BAA+B,EAAE,cAAc,EAAE;AAC5M,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,SAAS,EAAE;AAC5F,kBAAkB,iBAAiB,EAAE,4BAA4B,EAAE,eAAe,EAAE;AACpF,kBAAkB,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE;;AAErF,gBAAgB;AAChB;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,8BAA8B;AAChC;AACA,cAAc,kBAAkB,EAAE,0BAA0B,EAAE,SAAS,EAAE;AACzE,cAAc,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;;AAE3E;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA,mBAAmB,gBAAgB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;;AAEvG,aAAa;AACb;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;AAChB;AACA,0BAA0B,mBAAmB,EAAE;AAC/C;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,4BAA4B;AAC9B;AACA,yBAAyB,mBAAmB,EAAE;AAC9C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;AACA,iDAAiD,iBAAiB,EAAE;;AAEpE,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,8BAA8B;AAChC;AACA,eAAe,iBAAiB,EAAE;AAClC,eAAe,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,SAAS,EAAE;AACzF,eAAe,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;;AAE5E,eAAe;AACf,eAAe,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE;AACzE,4BAA4B,eAAe,0BAA0B,EAAE,EAAE;AACzE;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,8BAA8B;AAChC;AACA,iBAAiB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACpG,iBAAiB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE,gBAAgB,EAAE;;;;;AAKhG;;6DAE6D;;AAE7D;EACE,aAAa;EACb,gCAAgC;EAChC,kBAAkB;EAClB,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;;;;;;;;0EAQ0E;AAC1E;EACE,eAAe,aAAa,EAAE;AAChC;;AAEA,2DAA2D;AAC3D;;;;+EAI+E;AAC/E;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,gDAAgD;EAChD,gBAAgB;EAChB,aAAa;EACb,qBAAqB;AACvB;AACA,mCAAmC,aAAa,EAAE;;AAElD;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;AACA,sBAAsB,0BAA0B,EAAE;;AAElD;EACE,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;AACrB;AACA,cAAc,4BAA4B,EAAE,kBAAkB,EAAE;;AAEhE,WAAW,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE;;AAEvE;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,WAAW,EAAE,YAAY,EAAE,2BAA2B,EAAE,eAAe,EAAE,cAAc;AACzF;AACA,eAAe,SAAO,EAAE;AACxB;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,8BAA8B;EAC9B,gBAAgB;EAChB,+BAA+B;AACjC;AACA,gBAAgB,aAAa,EAAE,QAAQ,EAAE;AACzC,iBAAiB,kBAAkB,EAAE,4BAA4B,EAAE;AACnE,gBAAgB,cAAc,EAAE;;AAEhC,gBAAgB;AAChB,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACnE;EACE,WAAW;EACX,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;AACf;AACA,wBAAwB,2BAA2B,EAAE;AACrD,gBAAgB,4BAA4B,EAAE,iBAAiB,EAAE;;AAEjE,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA,cAAc;AACd;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;AACA,iCAAiC,aAAa,EAAE;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;EACZ,eAAe;AACjB;AACA,+CAA+C,eAAe,EAAE;AAChE,+CAA+C,gBAAgB,EAAE;AACjE,YAAY,cAAc,EAAE,aAAa,EAAE;AAC3C,iBAAiB,qBAAqB,EAAE;AACxC,iBAAiB,2BAA2B,EAAE;AAC9C,YAAY,8BAA8B,EAAE;AAC5C,cAAc,oBAAoB,EAAE;AACpC,cAAc,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,SAAS,EAAE,gBAAgB,EAAE;AAC5G,cAAc,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;AAC3E,WAAW,UAAU,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,cAAc,EAAE,aAAa,EAAE;;AAEtG;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,0CAA0C;EAC5C;EACA,aAAa,cAAc,EAAE;EAC7B,iCAAiC,aAAa,EAAE;EAChD,YAAY,cAAc,EAAE,YAAY,EAAE,eAAe,EAAE;EAC3D,WAAW,aAAa,EAAE;AAC5B;;AAEA;EACE,OAAO,wBAAwB,EAAE;EACjC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;;;;;uEAKuE;AACvE;EACE,aAAa,eAAe,EAAE;EAC9B;IACE,gBAAgB;IAChB,qBAAqB;IACrB,iCAAiC;EACnC;EACA,qCAAqC,aAAa,EAAE;EACpD,iCAAiC,aAAa,EAAE;AAClD;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA,kBAAkB,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,0BAA0B,EAAE;AACrG,kBAAkB,iBAAiB,EAAE,4BAA4B,EAAE,SAAS,EAAE;;AAE9E,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AAC1E,kBAAkB,kBAAkB,EAAE,4BAA4B,EAAE,mBAAmB,EAAE;AACzF;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;AACA,6DAA6D;AAC7D;EACE,iBAAiB,gBAAgB,EAAE;AACrC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,qCAAqC;EACrC;;;;;;;;;;oDAUkD;EAClD,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;+EAC+E;AAC/E,6BAA6B,cAAc,qCAAqC,EAAE,EAAE;AACpF,6BAA6B,cAAc,qCAAqC,EAAE,EAAE;;AAEpF,2DAA2D;AAC3D;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uDAAuD;EACvD,sCAAsC;EACtC,2CAA2C;AAC7C;AACA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;AACA,mBAAmB,aAAa,EAAE;;AAElC;;;;;;;;;;;;;;;;;;;;;;;;;kCAyBkC;AAClC;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,8CAA8C,eAAe,EAAE;;AAE/D,sDAAsD;AACtD;EACE,yFAAyF;EACzF,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,WAAW,EAAE,YAAY,EAAE,iBAAiB;EAC5C,oDAAoD;AACtD;;AAEA;EACE,UAAU;AACZ;AACA,mCAAmC,sBAAsB,EAAE;;AAE3D,yBAAyB;AACzB;EACE,kBAAkB;EAClB,SAAS,EAAE,OAAO;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,2DAA2D;EAC3D,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA,0BAA0B,gCAAgC,EAAE,mCAAmC,EAAE;AACjG,iEAAiE;AACjE,0BAA0B,kCAAkC,EAAE,qCAAqC,EAAE;AACrG,0BAA0B,yBAAyB,EAAE,mCAAmC,EAAE;AAC1F,0BAA0B,iCAAiC,EAAE,+BAA+B,EAAE;;AAE9F,kCAAkC;AAClC;EACE,kBAAkB;EAClB,SAAS,EAAE,WAAW;EACtB,WAAW,EAAE,YAAY;EACzB;;;0EAGwE;EACxE,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,UAAU;EACV,wCAAwC;AAC1C;AACA;;;+DAG+D;AAC/D;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;AACpB;AACA,qBAAqB,2BAA2B,EAAE,sBAAsB,EAAE;;AAE1E,gBAAgB;AAChB;EACE,kBAAkB,EAAE,QAAQ;EAC5B,gCAAgC;EAChC,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,UAAU;AACZ;AACA;EACE,iCAAiC,EAAE,+BAA+B;EAClE,kBAAkB,EAAE,gBAAgB;EACpC,iBAAiB,EAAE,+BAA+B;EAClD,yBAAyB,EAAE,sBAAsB;AACnD;;AAEA;;;;;;;;;;;6BAW6B;AAC7B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,QAAQ;AACV;AACA,kEAAkE;AAClE;EACE,mBAAmB,aAAa,EAAE;AACpC;AACA;;;;;;;;;gBASgB;AAChB;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,wCAAwC;EACxC,+BAA+B;EAC/B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gDAAgD;EAChD,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;qDACqD;AACrD,yBAAyB,cAAc,EAAE;;AAEzC;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;AACA,yBAAyB,iCAAiC,EAAE,oCAAoC,EAAE;;AAElG;;;;qDAIqD;AACrD;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,uEAAuE;EACvE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB,aAAa,EAAE;EACpC,mBAAmB,YAAY,EAAE;AACnC;;AAEA,gBAAgB;AAChB;;gFAEgF;AAChF;EACE,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,YAAY;EACZ,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;AACxB;AACA,2CAA2C,wCAAwC,EAAE;AACrF;;8BAE8B;AAC9B;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;;;;;;;;2DAQ2D;AAC3D;EACE;eACa;EACb,sBAAsB,gBAAgB,EAAE,kBAAkB,EAAE;AAC9D;;AAEA;;;;;;;;;;;;;;wEAcwE;AACxE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;AACV;AACA;;oCAEoC;AACpC;EACE,WAAW;EACX,YAAY;AACd;;AAEA,cAAc;AACd;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP;;;;;2BAKyB;EACzB,2BAA2B;AAC7B;;AAEA;;;;;0EAK0E;AAC1E;EACE,qBAAqB,aAAa,EAAE;EACpC,mBAAmB,gBAAgB,EAAE;AACvC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;;;qDAIqD;AACrD;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;6DAC6D;AAC7D;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;;;;;;;;+EAQ+E;AAC/E,eAAe,aAAa,EAAE,QAAQ,EAAE,iBAAiB,EAAE;AAC3D,sBAAsB,0BAA0B,EAAE;AAClD,sBAAsB,gCAAgC,EAAE;AACxD;wBACwB,kBAAkB,EAAE,gCAAgC,EAAE;AAC9E,kEAAkE;AAClE;sBACsB,kBAAkB,EAAE,gCAAgC,EAAE;;AAE5E;;;kDAGkD;AAClD;;EAEE,kBAAkB;EAClB,YAAY,EAAE,UAAU;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,+BAA+B;EAC/B,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;AACA,wEAAwE;AACxE;0BAC0B,kCAAkC,EAAE;;AAE9D;EACE,oEAAoE;EACpE;wBACsB,gBAAgB,EAAE,eAAe,EAAE,WAAW,EAAE,SAAS,EAAE;AACnF;;AAEA,WAAW;AACX,gBAAgB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;AAC7E,qBAAqB,oBAAoB,EAAE,gBAAgB,EAAE;AAC7D,yCAAyC,kCAAkC,EAAE;AAC7E,kBAAkB,qBAAqB,EAAE,iBAAiB,EAAE;;AAE5D,cAAc;AACd;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;AACA,kBAAkB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAClI,kBAAkB,kBAAkB,EAAE,2BAA2B,EAAE,6BAA6B,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAEzI,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;AACrB;AACA,oBAAoB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,cAAc,EAAE;;AAEjF;;;;;;;;8DAQ8D;AAC9D,oBAAoB,qCAAqC,EAAE,2BAA2B,EAAE;AACxF,sCAAsC,gCAAgC,EAAE;;AAExE;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;AACA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA,cAAc,2BAA2B,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;;AAEhF,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;AAC9B;AACA,yBAAyB,oBAAoB,EAAE,gBAAgB,EAAE;AACjE,6CAA6C,kCAAkC,EAAE;;;AAGjF,2DAA2D;AAC3D;;;6BAG6B;;AAE7B,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,oGAAoG;EACpG,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,sBAAsB,oBAAoB,EAAE;AAC5C;EACE,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,iBAAiB;AACnB;AACA,sBAAsB,SAAS,KAAK,UAAU,EAAE,iBAAiB,EAAE;AACnE,sBAAsB,QAAQ,MAAM,WAAW,EAAE;AACjD,sBAAsB,YAAY,EAAE,WAAW,EAAE,iBAAiB,EAAE;AACpE;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;EACzB,qCAAqC;EACrC,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;AACA,+BAA+B,+BAA+B,EAAE;AAChE;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,uBAAuB;EACvB,oBAAoB;EACpB,iCAAiC;EACjC,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;AACA,iCAAiC,mCAAmC,EAAE;;AAEtE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;;sDAEsD;AACtD,YAAY,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC9D;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;AACf;AACA;EACE,WAAW,EAAE,YAAY;EACzB,iBAAiB;EACjB,+BAA+B;EAC/B,8BAA8B;EAC9B,cAAc;AAChB;AACA,wBAAwB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACxE,gBAAgB,SAAO,EAAE,YAAY,EAAE;AACvC,yBAAyB,gBAAgB,EAAE;AAC3C;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA,yBAAyB,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACnF,gBAAgB,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE;AACnF,iBAAiB,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACnG,0BAA0B,kBAAkB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AACrF,cAAc,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC7D,uBAAuB,mBAAmB,EAAE;AAC5C,mBAAmB,iBAAiB,EAAE,wBAAwB,EAAE;;AAEhE,+EAA+E;AAC/E;EACE,oBAAoB;EACpB,oBAAoB;EACpB,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,WAAW,EAAE,YAAY;EACzB,+BAA+B;EAC/B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,0BAA0B;EAC1B,yCAAyC;AAC3C;AACA,mCAAmC,yBAAyB,EAAE,qCAAqC,EAAE;AACrG,uBAAuB,YAAY,EAAE,mBAAmB,EAAE;AAC1D;EACE,eAAe;EACf,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,oCAAoC;EACpC,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAClE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;AACA,wBAAwB,0BAA0B,EAAE,0BAA0B,EAAE;AAChF,0BAA0B,oBAAoB,EAAE;AAChD,sBAAsB,UAAU,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,yBAAyB,EAAE;;AAEpG,sDAAsD;AACtD;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;AACA,mBAAmB,iBAAiB,EAAE,2BAA2B,EAAE,mBAAmB,EAAE;AACxF,sBAAsB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,mBAAmB,EAAE;;AAE7G,qBAAqB,gBAAgB,EAAE,YAAY,EAAE,kBAAkB,EAAE,oBAAoB,EAAE,eAAe,EAAE,UAAU,EAAE,0BAA0B,EAAE,0BAA0B,EAAE;AACpL,2BAA2B,aAAa,EAAE;AAC1C,kBAAkB,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;AACxG,iBAAiB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE,sCAAsC,EAAE;AACpG,4BAA4B,mBAAmB,EAAE,iBAAiB,EAAE;;AAEpE;kCACkC;AAClC;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA,yBAAyB,2BAA2B,EAAE,YAAY,EAAE;AACpE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;AAChD;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,mCAAmC;EACnC,eAAe;AACjB;AACA,yBAAyB,iBAAiB,EAAE;AAC5C;EACE,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;EACzB,qCAAqC;EACrC,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;AACA,wCAAwC,+BAA+B,EAAE;AACzE,4BAA4B,YAAY,EAAE,mBAAmB,EAAE;AAC/D;EACE,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,4BAA4B;AAC9B;AACA,yCAAyC,8BAA8B,EAAE;AACzE,6BAA6B,YAAY,EAAE,mBAAmB,EAAE;;AAEhE,2DAA2D;AAC3D;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mCAAmC;AACrC;AACA,6BAA6B,gBAAgB,EAAE,cAAc,EAAE;AAC/D,4BAA4B,iBAAiB,EAAE;AAC/C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA,yBAAyB,mCAAmC,EAAE,oBAAoB,EAAE;AACpF,4BAA4B,+DAA+D,GAAG,qBAAqB,EAAE;AACrH,uBAAuB,wEAAwE,EAAE,8BAA8B,EAAE;AACjI,kBAAkB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACrG,kBAAkB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;;AAE/E,2BAA2B;AAC3B;EACE,mCAAmC;EACnC,wCAAwC;EACxC,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;AACjB;AACA,kBAAkB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACrG,kBAAkB,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE;AACrF,kBAAkB,WAAW,EAAE,yBAAyB,EAAE,+BAA+B,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACjI,kBAAkB,YAAY,EAAE,yBAAyB,EAAE,+BAA+B,EAAE,4BAA4B,EAAE;AAC1H,kBAAkB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;;AAE/E;;6DAE6D;;AAE7D;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;yEACyE;AACzE;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;AACA;mBACmB,8BAA8B,EAAE;AACnD,aAAa,iBAAiB,EAAE,4BAA4B,EAAE;AAC9D;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,SAAO;AACT;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;4DAC4D;AAC5D;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;oEACoE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA,4BAA4B,mBAAmB,EAAE;AACjD;;EAEE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,oCAAoC;EACpC,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA,oBAAoB,SAAO,EAAE,YAAY,EAAE;AAC3C,qBAAqB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACxG,mBAAmB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;AAChF;EACE,cAAc;EACd,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,yBAAyB,oCAAoC,EAAE;;AAE/D;EACE;;qBAEmB;EACnB,eAAe,qCAAqC,EAAE;EACtD,eAAe,gBAAgB,EAAE;AACnC;AACA;EACE,aAAa,kBAAkB,EAAE,SAAS,EAAE;EAC5C,aAAa,iBAAiB,EAAE;EAChC,wBAAwB,WAAW,EAAE,YAAY,EAAE;EACnD,kBAAkB,uBAAuB,EAAE;EAC3C,eAAe,aAAa,EAAE;EAC9B;mEACiE;EACjE,WAAW,0CAA0C,EAAE,SAAS,EAAE,aAAa,EAAE;EACjF;IACE,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,mCAAmC;IACnC,iBAAiB;EACnB;EACA,eAAe,eAAe,EAAE;EAChC,mBAAmB,WAAW,EAAE;AAClC;;AAEA,2DAA2D;AAC3D;8EAC8E;AAC9E;EACE,eAAe,gCAAgC,EAAE;EACjD,eAAe,qCAAqC,EAAE;AACxD;AACA;EACE,eAAe,0BAA0B,EAAE;EAC3C,gBAAgB,aAAa,EAAE;EAC/B,eAAe,qCAAqC,EAAE;AACxD;AACA;EACE;;0CAEwC;EACxC,aAAa,iBAAiB,EAAE;EAChC,cAAc,QAAQ,EAAE;AAC1B;;AAEA;;6DAE6D;;AAE7D,kCAAkC;AAClC,qBAAqB,aAAa,EAAE;AACpC,iBAAiB,aAAa,EAAE;;AAEhC,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;;;;;;mCAMmC;AACnC,kBAAkB,kBAAkB,EAAE,SAAO,EAAE,YAAY,EAAE,aAAa,EAAE;AAC5E,iCAAiC,SAAO,EAAE;AAC1C;EACE,kBAAkB,EAAE,qBAAqB,EAAE,OAAO,EAAE,QAAQ,EAAE,YAAY;EAC1E,6BAA6B,EAAE,+BAA+B,EAAE,mBAAmB;EACnF,2CAA2C,EAAE,gBAAgB;AAC/D;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,WAAW,EAAE,kBAAkB;EAC9E,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,gBAAgB,EAAE,2BAA2B;AAChG;AACA,oBAAoB,+BAA+B,EAAE;AACrD,aAAa,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,cAAc,EAAE;AAC/F,cAAc,SAAO,EAAE,YAAY,EAAE;AACrC,cAAc,cAAc,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAChK,aAAa,cAAc,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;AAC3E,eAAe,kBAAkB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,cAAc,EAAE;;AAE3F;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iCAAiC;EACjC,+BAA+B;EAC/B,6BAA6B;EAC7B,gBAAgB;EAChB,gDAAgD;EAChD,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;AACd;AACA,4BAA4B,2BAA2B,EAAE;AACzD,wCAAwC;AACxC,6CAA6C,aAAa,EAAE;AAC5D;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;EACd,uBAAuB;AACzB;AACA,qBAAqB,0BAA0B,EAAE;AACjD;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,aAAa;AACf;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qCAAqC;EACrC,cAAc;EACd,4BAA4B;AAC9B;AACA,mBAAmB,+BAA+B,EAAE;;AAEpD;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,6EAA6E;AAC7E;EACE,uDAAuD,aAAa,EAAE;EACtE,iBAAiB,+BAA+B,EAAE,8BAA8B,EAAE,yBAAyB,EAAE;;EAE7G,UAAU,kBAAkB,EAAE,SAAS,EAAE;;EAEzC;;0BAEwB;EACxB,sBAAsB,aAAa,EAAE;;EAErC,mEAAmE;EACnE,iBAAiB,aAAa,EAAE;EAChC,oCAAoC,aAAa,EAAE,SAAO,EAAE;EAC5D,wBAAwB,aAAa,EAAE,iBAAiB,EAAE;EAC1D,cAAc,aAAa,EAAE;;EAE7B;qEACmE;EACnE,cAAc,QAAQ,EAAE;;EAExB;;;;qEAImE;EACnE,qCAAqC,aAAa,EAAE;EACpD;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,UAAU;EACZ;AACF;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;AACA,uBAAuB,8BAA8B,EAAE;;AAEvD;;;+DAG+D;AAC/D;EACE,iBAAiB,aAAa,EAAE;AAClC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;iDAyBiD;AACjD;EACE;;;;sBAIoB;EACpB,8BAA8B,aAAa,EAAE;EAC7C,6BAA6B,gBAAgB,EAAE;EAC/C,cAAc,QAAQ,EAAE;AAC1B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA,gEAAgE;AAChE;EACE,SAAS;EACT,WAAW;AACb;AACA,yDAAyD;AACzD;EACE,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA,sBAAsB,8BAA8B,EAAE;;AAEtD,8EAA8E;AAC9E;;;;;;;EAOE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;;;EAGE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,UAAU;EACV,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,wFAAwF;AAC1F;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,UAAU;EACV,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,wFAAwF;AAC1F;AACA;;EAEE,UAAU;EACV,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;;;;;;;;;;;6DAW6D;AAC7D;;;EAGE,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,mCAAmC;AACrC;AACA,mEAAmE;AACnE;EACE,cAAc,aAAa,EAAE;AAC/B;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,uBAAuB;AACzB;AACA;0BAC0B,oBAAoB,EAAE;;AAEhD;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,oDAAoD;EACpD,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB;;;;2BAIyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,4BAA4B;AAC9B;AACA,qBAAqB,2BAA2B,EAAE;AAClD,uBAAuB,mCAAmC,EAAE;AAC5D;EACE,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,MAAM;AACR;AACA,6CAA6C,aAAa,EAAE;AAC5D;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2CAA2C;AAC7C;AACA,iCAAiC,oBAAoB,EAAE,mCAAmC,EAAE;AAC5F;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA,qBAAqB;AACrB,gDAAgD,wEAAwE,EAAE;AAC1H,gDAAgD,wEAAwE,EAAE;AAC1H,sCAAsC,4BAA4B,EAAE;AACpE;2DAC2D,wEAAwE,EAAE;;AAErI;;6DAE6D;AAC7D;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,kBAAkB,EAAE,4BAA4B;EAChD,mBAAmB,EAAE,eAAe;AACtC;AACA;EACE,gBAAgB,EAAE,YAAY,EAAE,oBAAoB;EACpD,kBAAkB,EAAE,eAAe,EAAE,UAAU,EAAE,gBAAgB;AACnE;AACA,uBAAuB,0BAA0B,EAAE;AACnD,cAAc,2BAA2B,EAAE;AAC3C;yEACyE;AACzE,eAAe,4BAA4B,EAAE,qBAAqB,EAAE;AACpE,sBAAsB,oBAAoB,EAAE,0BAA0B,EAAE;AACxE,kBAAkB,0BAA0B,EAAE,gBAAgB,EAAE;;AAEhE,uBAAuB;AACvB;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B,eAAe,aAAa,EAAE,SAAS,EAAE;;AAEzC;EACE,aAAa,EAAE,sBAAsB,EAAE,mBAAmB;EAC1D,WAAW,EAAE,cAAc;AAC7B;AACA;EACE,WAAW,EAAE,YAAY;EACzB,+BAA+B,EAAE,+BAA+B;EAChE,gBAAgB,EAAE,+BAA+B;EACjD,eAAe,EAAE,YAAY,EAAE,qBAAqB;EACpD,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,kBAAkB;AACpB;AACA,mBAAmB,2BAA2B,EAAE,sBAAsB,EAAE;AACxE;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;AACA,iBAAiB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACjE;EACE,kBAAkB,EAAE,WAAW,EAAE,SAAS,EAAE,2BAA2B;EACvE,gCAAgC,EAAE,+BAA+B;EACjE,kBAAkB,EAAE,gBAAgB,EAAE,+BAA+B;EACrE,mBAAmB,EAAE,oBAAoB;AAC3C;AACA;EACE,kBAAkB,EAAE,YAAY,EAAE,UAAU;EAC5C,+BAA+B,EAAE,+BAA+B;EAChE,kBAAkB,EAAE,gBAAgB;EACpC,iBAAiB,EAAE,+BAA+B;EAClD,sBAAsB,EAAE,oBAAoB,EAAE,UAAU;AAC1D;AACA;EACE,kBAAkB,EAAE,WAAW,EAAE,UAAU;EAC3C,+BAA+B,EAAE,+BAA+B;EAChE,kBAAkB,EAAE,gBAAgB,EAAE,+BAA+B;EACrE,gBAAgB,EAAE,cAAc;AAClC;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,+BAA+B,EAAE,+BAA+B;EAChE,+BAA+B,EAAE,gBAAgB;EACjD,aAAa,EAAE,sBAAsB;EACrC,8BAA8B;AAChC;AACA;EACE,SAAO,EAAE,kBAAkB;EAC3B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,gBAAgB,EAAE,eAAe;EACjC,iBAAiB;AACnB;AACA;EACE,WAAW,EAAE,YAAY;EACzB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,gBAAgB;EAChB,6DAA6D;AAC/D;AACA,gDAAgD,sBAAsB,EAAE;AACxE;EACE,WAAW,EAAE,aAAa;EAC1B,mBAAmB,EAAE,uBAAuB;EAC5C,oBAAoB,EAAE,yBAAiB,EAAjB,iBAAiB;EACvC,8BAA8B;AAChC;AACA;EACE,WAAW,EAAE,aAAa;EAC1B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,2BAA2B;AAC7B;AACA;EACE,gBAAgB,gBAAgB,EAAE;AACpC;;AAEA,kBAAkB;AAClB;EACE,kBAAkB,EAAE,SAAS,EAAE,OAAO;EACtC,0BAA0B,EAAE,qCAAqC;EACjE,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB;EAC5D,0BAA0B,EAAE,oDAAoD;EAChF,UAAU,EAAE,yBAAyB;AACvC;AACA,sBAAsB,gCAAgC,EAAE;;AAExD,mBAAmB;AACnB;EACE,kBAAkB,EAAE,SAAS,EAAE,WAAW;EAC1C,WAAW,EAAE,YAAY;EACzB,6BAA6B,EAAE,+BAA+B;EAC9D,kBAAkB,EAAE,2CAA2C;EAC/D,kBAAkB,EAAE,wBAAwB;EAC5C,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC5E,UAAU,EAAE,qBAAqB;AACnC;AACA,uBAAuB,oBAAoB,EAAE,2BAA2B,EAAE,qBAAqB,EAAE;AACjG,wBAAwB,oBAAoB,EAAE;;AAE9C,qBAAqB;AACrB;EACE,kBAAkB,EAAE,QAAQ,EAAE,2BAA2B;EACzD,WAAW,EAAE,YAAY;EACzB,6BAA6B,EAAE,+BAA+B;EAC9D,kBAAkB,EAAE,eAAe,EAAE,iBAAiB,EAAE,gBAAgB;EACxE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,UAAU,EAAE,qBAAqB;EACjC,0CAA0C;EAC1C,UAAU;AACZ;AACA;0CAC0C,UAAU,EAAE;AACtD,gBAAgB,UAAU,EAAE;AAC5B,gBAAgB,WAAW,EAAE;AAC7B;EACE,yBAAyB,EAAE,qCAAqC,EAAE,2BAA2B;AAC/F;;AAEA,gCAAgC;AAChC;EACE,kBAAkB,EAAE,YAAY,EAAE,SAAS,EAAE,2BAA2B;EACxE,aAAa,EAAE,mBAAmB,EAAE,UAAU;EAC9C,UAAU,EAAE,yBAAyB;AACvC;AACA,kDAAkD,UAAU,EAAE;AAC9D;EACE,gCAAgC,EAAE,+BAA+B;EACjE,YAAY,EAAE,+BAA+B,EAAE,eAAe;EAC9D,kBAAkB,EAAE,gBAAgB,EAAE,iBAAiB;EACvD,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,0BAA0B,EAAE,4BAA4B;EACxD,mBAAmB;AACrB;AACA,mDAAmD,gCAAgC,EAAE;;AAErF,kBAAkB;AAClB;EACE,kBAAkB,EAAE,SAAS,EAAE,SAAS,EAAE,2BAA2B;EACrE,gCAAgC,EAAE,+BAA+B;EACjE,iBAAiB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,+BAA+B;EACvF,UAAU,EAAE,0BAA0B,EAAE,sBAAsB;AAChE;;AAEA,cAAc;AACd;EACE,kBAAkB,EAAE,YAAY,EAAE,WAAW;EAC7C,+BAA+B,EAAE,+BAA+B;EAChE,kBAAkB,EAAE,gBAAgB,EAAE,+BAA+B;EACrE,UAAU,EAAE,oBAAoB;EAChC,UAAU,EAAE,yBAAyB;AACvC;AACA,2CAA2C,UAAU,EAAE;;AAEvD,uCAAuC;AACvC;EACE,mCAAmC;EACnC,uBAAuB;EACvB,aAAa,EAAE,sBAAsB,EAAE,mBAAmB;EAC1D,+BAA+B;AACjC;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;AAC/C;AACA;EACE,kBAAkB,EAAE,4BAA4B;EAChD,mBAAmB,EAAE,eAAe;AACtC;AACA,+BAA+B,0BAA0B,EAAE,gBAAgB,EAAE;;AAE7E;;oCAEoC;AACpC,mBAAmB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE,iBAAiB,EAAE;AACjF,qBAAqB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACtE,2BAA2B,kBAAkB,EAAE,4BAA4B,EAAE;AAC7E,kCAAkC,0BAA0B,EAAE,gBAAgB,EAAE;AAChF,wBAAwB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE,mBAAmB,EAAE;;AAExF;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,cAAc;EAC7D,+BAA+B,EAAE,eAAe,EAAE,UAAU;EAC5D,oCAAoC,EAAE,sBAAsB,EAAE,2BAA2B;EACzF,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,iEAAiE;AACnE;AACA,0BAA0B,sBAAsB,EAAE;AAClD;EACE,2BAA2B;EAC3B,gEAAgE;AAClE;AACA;EACE,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B;AACpE;;AAEA,mCAAmC;AACnC,YAAY,YAAY,EAAE;;AAE1B;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,kBAAkB,EAAE,gBAAgB,EAAE,qBAAqB;EAC3D,oBAAoB,EAAE,yBAAyB,EAAE,mBAAmB;AACtE;AACA;EACE,WAAW;EACX,qBAAqB,EAAE,WAAW,EAAE,WAAW;EAC/C,yBAAyB,EAAE,kBAAkB;AAC/C;;AAEA;EACE,kBAAkB,EAAE,gBAAgB,EAAE,iBAAiB;EACvD,0BAA0B,EAAE,gBAAgB;EAC5C,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE,aAAa,EAAE,mBAAmB,EAAE,mBAAmB;EACvD,eAAe,EAAE,mBAAmB;EACpC,oBAAoB,EAAE,sCAAsC;AAC9D;AACA,aAAa,aAAa,EAAE,QAAQ,EAAE;AACtC;EACE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B;EAChE,kCAAkC,EAAE,uCAAuC;EAC3E,gBAAgB,EAAE,+BAA+B;AACnD;AACA,kBAAkB,kBAAkB,EAAE,4BAA4B,EAAE;AACpE,gBAAgB,kBAAkB,EAAE,oBAAoB,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC7F,sBAAsB,0BAA0B,EAAE;;AAElD,eAAe;AACf;EACE,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,mBAAmB;AAC1E;AACA;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,gIAAgI;EAChI,mCAAmC,EAAE,kBAAkB,EAAE,gBAAgB;EACzE,iBAAiB,EAAE,+BAA+B,EAAE,sBAAsB;AAC5E;AACA;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,2EAA2E;EAC3E,+BAA+B,EAAE,kBAAkB,EAAE,gBAAgB;EACrE,iBAAiB,EAAE,+BAA+B;AACpD;AACA;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,+DAA+D,EAAE,qEAAqE;EACtI,kCAAkC,EAAE,kBAAkB,EAAE,gBAAgB;EACxE,iBAAiB,EAAE,+BAA+B;AACpD;AACA;EACE,qBAAqB,EAAE,iEAAiE,EAAE,+DAA+D;AAC3J;;AAEA,sBAAsB;AACtB;EACE,kBAAkB,EAAE,4BAA4B;EAChD,iBAAiB,EAAE,mBAAmB;AACxC;;AAEA,kBAAkB;AAClB;EACE,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,mBAAmB;AAC/D;AACA;EACE,+BAA+B,EAAE,+BAA+B;EAChE,4BAA4B,EAAE,kBAAkB;EAChD,iBAAiB,EAAE,+BAA+B,EAAE,qBAAqB;AAC3E;AACA,0BAA0B,2BAA2B,EAAE,oBAAoB,EAAE,mCAAmC,EAAE;;AAElH,gBAAgB;AAChB,mBAAmB,mBAAmB,EAAE;AACxC;EACE,aAAa,EAAE,qBAAqB,EAAE,SAAS,EAAE,eAAe,EAAE,kBAAkB;AACtF;AACA;EACE,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B;EAC/D,cAAc,EAAE,uBAAuB;AACzC;AACA,gBAAgB,eAAe,EAAE,2BAA2B,EAAE,6BAA6B,EAAE;AAC7F,gBAAgB,kBAAkB,EAAE,2BAA2B,EAAE,eAAe,EAAE;;AAElF,0BAA0B;AAC1B;EACE,aAAa,EAAE,qCAAqC,EAAE,mBAAmB,EAAE,mBAAmB;AAChG;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,mBAAmB;EACvD,+BAA+B,EAAE,+BAA+B;EAChE,+BAA+B,EAAE,iBAAiB,EAAE,8BAA8B;AACpF;AACA,qBAAqB,2BAA2B,EAAE;AAClD,eAAe,eAAe,EAAE,cAAc,EAAE;AAChD,eAAe,0BAA0B,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAChF;;0DAE0D;AAC1D,cAAc,2BAA2B,EAAE,kBAAkB,EAAE;;AAE/D,iBAAiB;AACjB;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,kBAAkB,EAAE,gBAAgB,EAAE,mBAAmB;EACzD,iBAAiB,EAAE,+BAA+B;AACpD;AACA;EACE,kCAAkC;EAClC,8DAA8D,EAAE,qEAAqE;AACvI;AACA;EACE,qBAAqB,EAAE,8DAA8D,EAAE,iEAAiE;AAC1J;AACA;gDACgD;AAChD;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,uCAAuC;AACzC;AACA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,oEAAoE;AACtE;;AAEA;EACE,cAAc,wBAAwB,EAAE;EACxC,MAAM,2CAA2C,EAAE;EACnD,MAAM,0CAA0C,GAAG;EACnD,MAAM,2CAA2C,EAAE;EACnD,MAAM,0CAA0C,GAAG;EACnD,MAAM,2BAA2B,EAAE;AACrC;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB,EAAE,gBAAgB,EAAE,2BAA2B;EACjE,iCAAiC,EAAE,wCAAwC;EAC3E,iBAAiB,EAAE,+BAA+B;AACpD;;AAEA,sBAAsB;AACtB;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe;EAC9D,+BAA+B,EAAE,+BAA+B;EAChE,+BAA+B,EAAE,kBAAkB,EAAE,mBAAmB;EACxE,8BAA8B;AAChC;AACA,2BAA2B,2BAA2B,EAAE;AACxD;EACE,WAAW,EAAE,YAAY,EAAE,+BAA+B,EAAE,cAAc;EAC1E,2EAA2E;EAC3E,+BAA+B,EAAE,eAAe,EAAE,gBAAgB;EAClE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;AAC7D;AACA,gBAAgB,SAAO,EAAE,YAAY,EAAE;AACvC,eAAe,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,kBAAkB,EAAE;AAClG,iBAAiB,kBAAkB,EAAE,2BAA2B,EAAE;AAClE,gBAAgB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAClF;EACE,0BAA0B,EAAE,qCAAqC;EACjE,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB;EAC5D,gBAAgB,EAAE,+BAA+B;AACnD;AACA,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC9D,iBAAiB,2BAA2B,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AACvF,kBAAkB,kBAAkB,EAAE,4BAA4B,EAAE;AACpE;EACE,gBAAgB,EAAE,iCAAiC,EAAE,oBAAoB;EACzE,kBAAkB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,+BAA+B;EACxF,eAAe,EAAE,qBAAqB,EAAE,mBAAmB,EAAE,cAAc;AAC7E;AACA,uBAAuB,yBAAyB,EAAE,qCAAqC,EAAE;;AAEzF,mBAAmB;AACnB,mBAAmB,mBAAmB,EAAE;AACxC,oBAAoB,kBAAkB,EAAE,4BAA4B,EAAE,kBAAkB,EAAE;AAC1F,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACrE;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,6BAA6B,EAAE,eAAe;EAC9C,qBAAqB,EAAE,gCAAgC;AACzD;AACA,oBAAoB,sBAAsB,EAAE;AAC5C,qBAAqB,sCAAsC,EAAE,4BAA4B,EAAE,sBAAsB,EAAE;;AAEnH,aAAa;AACb;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,gBAAgB,EAAE,eAAe;AAClF;AACA,iBAAiB,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;AACrF;EACE,aAAa,EAAE,mBAAmB;EAClC,iCAAiC,EAAE,+BAA+B,EAAE,gBAAgB;AACtF;AACA;EACE,+BAA+B,EAAE,YAAY;EAC7C,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,gBAAgB;EAC/D,eAAe,EAAE,0BAA0B,EAAE,qBAAqB;AACpE;AACA,qBAAqB,yBAAyB,EAAE,qCAAqC,EAAE;AACvF;EACE,eAAe,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB;EACzE,sCAAsC,EAAE,uCAAuC;EAC/E,cAAc,EAAE,iBAAiB,EAAE,0BAA0B;AAC/D;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB;;mDAEiD;EACjD,SAAS;EACT,iBAAiB;EACjB;sDACoD;EACpD,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,+BAA+B,EAAE,+BAA+B;EAChE,+BAA+B,EAAE,kBAAkB;EACnD,8BAA8B;AAChC;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,kBAAkB,EAAE,4BAA4B,EAAE,mBAAmB;AACvE;AACA,qBAAqB,0BAA0B,EAAE;AACjD;EACE,gBAAgB,EAAE,YAAY,EAAE,oBAAoB;EACpD,iBAAiB,EAAE,gBAAgB,EAAE,eAAe,EAAE,UAAU;AAClE;AACA,wBAAwB,0BAA0B,EAAE;AACpD;EACE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,kBAAkB;AACtF;AACA;EACE,aAAa,EAAE,uBAAuB,EAAE,SAAS;EACjD,uBAAuB,EAAE,+BAA+B,EAAE,eAAe,EAAE,4BAA4B;AACzG;AACA,qBAAqB,8BAA8B,EAAE;AACrD,oBAAoB,mCAAmC,EAAE;AACzD,wCAAwC,mCAAmC,EAAE;AAC7E,mCAAmC,eAAe,EAAE,2BAA2B,EAAE,cAAc,EAAE;AACjG,oBAAoB,SAAO,EAAE;AAC7B,gBAAgB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,SAAS,EAAE;AAC7F,gBAAgB,kCAAkC,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC5G,gBAAgB,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE;AACnF,iBAAiB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,cAAc,EAAE;;AAEnG,iEAAiE;AACjE;EACE,eAAe,EAAE,YAAY,EAAE,eAAe;EAC9C,+BAA+B,EAAE,+BAA+B;EAChE,6BAA6B,EAAE,0BAA0B;EACzD,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,qBAAqB;AAC9E;AACA,uBAAuB,2BAA2B,EAAE;AACpD,wBAAwB,2BAA2B,EAAE,yBAAyB,EAAE,qCAAqC,EAAE;AACvH;EACE,mBAAmB,EAAE,2BAA2B,EAAE,+BAA+B;EACjF,6BAA6B,EAAE,YAAY;AAC7C;AACA,2BAA2B,2BAA2B,EAAE;AACxD,kBAAkB,kBAAkB,EAAE,oBAAoB,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAE/F,gBAAgB;AAChB,uBAAuB,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE;;AAEnF,8BAA8B;AAC9B;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;AACf;AACA,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACrE,oBAAoB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,SAAS,EAAE;AACjG,yBAAyB,iBAAiB,EAAE,4BAA4B,EAAE,SAAS,EAAE;AACrF;EACE,WAAW,EAAE,kBAAkB,EAAE,+BAA+B;EAChE,+BAA+B,EAAE,6BAA6B;EAC9D,0BAA0B,EAAE,iBAAiB,EAAE,sBAAsB;AACvE;AACA,0BAA0B,aAAa,EAAE,2BAA2B,EAAE;AACtE;EACE,WAAW,EAAE,aAAa,EAAE,YAAY,EAAE,+BAA+B;EACzE,yBAAyB,EAAE,qCAAqC,EAAE,gBAAgB,EAAE,kBAAkB;EACtG,eAAe,EAAE,4BAA4B;AAC/C;AACA,uCAAuC,+BAA+B,EAAE;AACxE,2BAA2B,YAAY,EAAE,mBAAmB,EAAE;AAC9D;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,qBAAqB,EAAE,gBAAgB,EAAE,iBAAiB;AAC5D;AACA,wBAAwB,iBAAiB,EAAE;AAC3C,oBAAoB,iBAAiB,EAAE,2BAA2B,EAAE,SAAS,EAAE;;AAE/E;EACE,WAAW,EAAE,aAAa;EAC1B,uEAAuE,EAAE,+BAA+B;EACxG,YAAY,EAAE,+BAA+B;EAC7C,eAAe,EAAE,gBAAgB,EAAE,sBAAsB;EACzD,eAAe,EAAE,qBAAqB;EACtC,8CAA8C;AAChD;AACA;EACE,sFAAsF;EACtF,8CAA8C,EAAE,2BAA2B;AAC7E;AACA,0CAA0C,wBAAwB,EAAE;AACpE,6BAA6B,aAAa,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAEnF;EACE,WAAW,EAAE,aAAa;EAC1B,gIAAgI,EAAE,+BAA+B;EACjK,YAAY,EAAE,+BAA+B;EAC7C,eAAe,EAAE,gBAAgB,EAAE,sBAAsB;EACzD,eAAe,EAAE,qBAAqB;EACtC,6CAA6C;AAC/C;AACA;EACE,gIAAgI;EAChI,6CAA6C,EAAE,2BAA2B;AAC5E;AACA,yCAAyC,wBAAwB,EAAE;AACnE,4BAA4B,aAAa,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAElF,uBAAuB;AACvB;EACE,+BAA+B,EAAE,+BAA+B;EAChE,+BAA+B,EAAE,kBAAkB;EACnD,aAAa,EAAE,8BAA8B,EAAE,aAAa;EAC5D,8BAA8B;AAChC;AACA,oBAAoB,aAAa,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACjF,oBAAoB,kBAAkB,EAAE,cAAc,EAAE,eAAe,EAAE;AACzE,qBAAqB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,SAAS,EAAE;AAClG,mBAAmB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;;AAEhF,eAAe;AACf;EACE,yHAAyH;EACzH,yCAAyC,EAAE,+BAA+B,EAAE,kBAAkB;AAChG;AACA;EACE,yHAAyH;EACzH,qCAAqC;AACvC;AACA,mBAAmB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACtG,iBAAiB,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE;AACpF;EACE,aAAa,EAAE,mBAAmB,EAAE,mBAAmB;EACvD,+BAA+B,EAAE,kCAAkC;EACnE,+BAA+B,EAAE,iBAAiB,EAAE,kBAAkB;EACtE,kBAAkB,EAAE,4BAA4B;AAClD;AACA,kBAAkB,oBAAoB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,sBAAsB,EAAE;AACtG;EACE,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,4BAA4B;EAC7E,iBAAiB,EAAE,iBAAiB,EAAE,uBAAuB;AAC/D;AACA,wBAAwB,oBAAoB,EAAE;AAC9C,mBAAmB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;;AAEhF,mBAAmB;AACnB,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACrG,mBAAmB,kBAAkB,EAAE,wBAAwB,EAAE,gBAAgB,EAAE;AACnF,iBAAiB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,qBAAqB,EAAE,+BAA+B,EAAE,+BAA+B,EAAE,4BAA4B,EAAE,qBAAqB,EAAE;AAClT,uBAAuB,2BAA2B,EAAE,oBAAoB,EAAE;AAC1E,gBAAgB,gCAAgC,EAAE,4EAA4E,EAAE,yEAAyE,EAAE;AAC3M,sBAAsB,0EAA0E,EAAE;AAClG,eAAe,qCAAqC,EAAE;;AAEtD,2BAA2B;AAC3B;EACE,gBAAgB,EAAE,kBAAkB;EACpC,qEAAqE,EAAE,+BAA+B;EACtG,8DAA8D;AAChE;AACA;EACE,8DAA8D,EAAE,iEAAiE;AACnI;AACA,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,kBAAkB,EAAE;AAChJ,qCAAqC,qBAAqB,EAAE;AAC5D,eAAe,SAAS,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACjE,kBAAkB,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;;AAEtF,iEAAiE;AACjE;EACE,aAAa;EACb,2DAA2D;EAC3D,MAAM;EACN,+BAA+B,EAAE,+BAA+B;EAChE,gBAAgB,EAAE,+BAA+B;EACjD,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa,EAAE,sBAAsB,EAAE,mBAAmB;EAC1D,QAAQ,EAAE,kBAAkB,EAAE,kBAAkB;EAChD,qCAAqC;EACrC,4BAA4B;AAC9B;AACA,0BAA0B,kBAAkB,EAAE;AAC9C,qBAAqB,8BAA8B,EAAE;AACrD,eAAe,iBAAiB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACtE;EACE,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B;EAC/D,SAAS,EAAE,gBAAgB;AAC7B;AACA,cAAc,iBAAiB,EAAE,4BAA4B,EAAE,SAAS,EAAE;;AAE1E,8CAA8C;AAC9C;EACE,aAAa,EAAE,2DAA2D;EAC1E,MAAM,EAAE,+BAA+B,EAAE,+BAA+B;EACxE,gBAAgB,EAAE,+BAA+B,EAAE,mBAAmB;EACtE,8BAA8B;AAChC;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,mBAAmB;EACvD,kBAAkB,EAAE,qCAAqC;AAC3D;AACA,0BAA0B,kBAAkB,EAAE;AAC9C,eAAe,iBAAiB,EAAE,cAAc,EAAE;AAClD,eAAe,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;;AAEnF,yCAAyC;AACzC,WAAW,mBAAmB,EAAE;AAChC;EACE,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB;EACtD,0BAA0B,EAAE,uBAAuB;AACrD;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,SAAS;EAC9D,+BAA+B,EAAE,+BAA+B;EAChE,+BAA+B,EAAE,kBAAkB;EACnD,8BAA8B;AAChC;AACA,gBAAgB,aAAa,EAAE,mBAAmB,EAAE;AACpD,gBAAgB,iBAAiB,EAAE,2BAA2B,EAAE,cAAc,EAAE;AAChF,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,YAAY,EAAE;AACpG;EACE,WAAW,EAAE,YAAY,EAAE,mBAAmB;EAC9C,+BAA+B,EAAE,8BAA8B,EAAE,YAAY;AAC/E;AACA;EACE,kBAAkB,EAAE,4BAA4B,EAAE,kBAAkB;EACpE,oBAAoB,EAAE,qBAAqB,EAAE,4BAA4B,EAAE,gBAAgB;AAC7F;AACA,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ,EAAE;AAC7F,iBAAiB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACnF,qBAAqB,aAAa,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;AAC7H,cAAc,iBAAiB,EAAE,2BAA2B,EAAE;AAC9D,uBAAuB,iBAAiB,EAAE,4BAA4B,EAAE,SAAS,EAAE;AACnF,gBAAgB,kBAAkB,EAAE,gBAAgB,EAAE,SAAS,EAAE;AACjE;EACE,uEAAuE,EAAE,+BAA+B;EACxG,YAAY,EAAE,+BAA+B,EAAE,kBAAkB;EACjE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe;EACrD,qBAAqB,EAAE,mBAAmB;EAC1C,8CAA8C;AAChD;AACA;EACE,sFAAsF;EACtF,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB,oBAAoB,mBAAmB,EAAE;AACzC;EACE,aAAa,EAAE,MAAM;EACrB,sCAAsC;EACtC,gBAAgB,EAAE,qBAAqB;EACvC,gBAAgB,EAAE,MAAM,EAAE,WAAW;EACrC,6BAA6B,EAAE,gBAAgB;AACjD;AACA,+BAA+B,aAAa,EAAE;AAC9C;EACE,gBAAgB,EAAE,YAAY,EAAE,sCAAsC;EACtE,mBAAmB,EAAE,kBAAkB;EACvC,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B;EAClE,eAAe,EAAE,mBAAmB;EACpC,2CAA2C;AAC7C;AACA,iBAAiB,oBAAoB,EAAE;AACvC,kBAAkB,oBAAoB,EAAE,gBAAgB,EAAE,kCAAkC,EAAE;AAC9F;EACE,+BAA+B,EAAE,+BAA+B;EAChE,gBAAgB,EAAE,oDAAoD;EACtE,kBAAkB;EAClB,8BAA8B;AAChC;AACA,kBAAkB,iBAAiB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC1G,iBAAiB,kBAAkB,EAAE,SAAS,EAAE;AAChD,oBAAoB,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC5G,gBAAgB,kBAAkB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,4BAA4B,EAAE;AAC1G,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACpE,eAAe,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,aAAa,EAAE,+BAA+B,EAAE,mBAAmB,EAAE,+BAA+B,EAAE;AACvK,qBAAqB,SAAS,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAClG,gBAAgB,WAAW,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,+BAA+B,EAAE,6BAA6B,EAAE,0BAA0B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,oBAAoB,EAAE;AACrP,mBAAmB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;AAC7D,qBAAqB,SAAO,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,+BAA+B,EAAE,6BAA6B,EAAE,0BAA0B,EAAE,kBAAkB,EAAE;AACvM,qBAAqB,sBAAsB,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,qCAAqC,EAAE,YAAY,EAAE,gBAAgB,EAAE,eAAe,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAC9O,8BAA8B,YAAY,EAAE,mBAAmB,EAAE;AACjE,cAAc,kBAAkB,EAAE,SAAS,EAAE;AAC7C,kBAAkB,qBAAqB,EAAE;AACzC,mBAAmB,oBAAoB,EAAE;AACzC,eAAe,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACjE,eAAe,+BAA+B,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACvF,+BAA+B,aAAa,EAAE,SAAS,EAAE,kBAAkB,EAAE,uBAAuB,EAAE;AACtG,gBAAgB,+BAA+B,EAAE,mCAAmC,EAAE;AACtF,oBAAoB,YAAY,EAAE;AAClC,gBAAgB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE;AAClM,mBAAmB,uCAAuC,EAAE,mCAAmC,EAAE;AACjG,mBAAmB,uCAAuC,EAAE,qBAAqB,EAAE;AACnF,uCAAuC,kCAAkC,EAAE;AAC3E,uCAAuC,+DAA+D,EAAE;AACxG,eAAe,eAAe,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE;AAClG,sBAAsB,wBAAwB,EAAE,kBAAkB,EAAE;AACpE,eAAe,SAAS,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;;AAExE,+BAA+B;AAC/B,eAAe,mBAAmB,EAAE;AACpC;EACE,aAAa,EAAE,4DAA4D,EAAE,mBAAmB;AAClG;AACA;EACE,kBAAkB;EAClB,+BAA+B,EAAE,+BAA+B;EAChE,+BAA+B,EAAE,gBAAgB,EAAE,eAAe;EAClE,8BAA8B;EAC9B,6CAA6C;AAC/C;AACA,0BAA0B,2BAA2B,EAAE,4CAA4C,EAAE;AACrG;EACE,WAAW,EAAE,aAAa,EAAE,mBAAmB;EAC/C,aAAa,EAAE,8BAA8B;AAC/C;AACA,oBAAoB,aAAa,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACpF;EACE,kBAAkB,EAAE,gBAAgB,EAAE,SAAS,EAAE,0BAA0B;EAC3E,oBAAoB,EAAE,qBAAqB,EAAE,4BAA4B,EAAE,gBAAgB;AAC7F;AACA,0BAA0B,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACxE,sBAAsB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;AACnF,2BAA2B,oBAAoB,EAAE,gBAAgB,EAAE;AACnE,+CAA+C,kCAAkC,EAAE;AACnF,yBAAyB,aAAa,EAAE,qBAAqB,EAAE,QAAQ,EAAE,eAAe,EAAE;AAC1F,qBAAqB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,SAAS,EAAE;AAClG,wBAAwB,kBAAkB,EAAE,2BAA2B,EAAE,6BAA6B,EAAE,gBAAgB,EAAE;AAC1H,yBAAyB,aAAa,EAAE;;AAExC,yBAAyB;AACzB;EACE,YAAY,sCAAsC,EAAE,SAAS,EAAE;AACjE;AACA;EACE,YAAY,gCAAgC,EAAE;EAC9C,eAAe,aAAa,EAAE;AAChC;AACA;EACE,YAAY,gCAAgC,EAAE,mBAAmB,EAAE;EACnE,aAAa,iBAAiB,EAAE;EAChC,aAAa,eAAe,EAAE;EAC9B,qBAAqB,qCAAqC,EAAE;AAC9D;AACA;EACE,YAAY,uBAAuB,EAAE;EACrC,YAAY,0BAA0B,EAAE,mBAAmB,EAAE;EAC7D,eAAe,aAAa,EAAE,gBAAgB,EAAE,aAAa,EAAE;EAC/D,eAAe,8BAA8B,EAAE;EAC/C,cAAc,mBAAmB,EAAE,WAAW,EAAE;EAChD,aAAa,WAAW,EAAE,YAAY,EAAE;EACxC,sBAAsB,iBAAiB,EAAE,iBAAiB,EAAE;EAC5D,gBAAgB,aAAa,EAAE;EAC/B,aAAa,iBAAiB,EAAE;EAChC,aAAa,iBAAiB,EAAE;EAChC,qBAAqB,qCAAqC,EAAE;EAC5D,YAAY,gBAAgB,EAAE;EAC9B,mBAAmB,8BAA8B,EAAE;;EAEnD;wEACsE;EACtE;IACE,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE,qBAAqB,qCAAqC,EAAE;EAC5D,gBAAgB,aAAa,EAAE;EAC/B,eAAe,sBAAsB,EAAE,uBAAuB,EAAE;EAChE,qBAAqB,cAAc,EAAE;EACrC,mBAAmB,0BAA0B,EAAE;AACjD;;AAEA;;6DAE6D;AAC7D;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA,WAAW;AACX;EACE,aAAa,EAAE,uBAAuB,EAAE,8BAA8B;EACtE,mBAAmB,EAAE,mBAAmB,EAAE,eAAe;AAC3D;AACA;EACE,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B;EAC/D,eAAe,EAAE,uBAAuB;AAC1C;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,kBAAkB,EAAE,4BAA4B;AAClD;AACA,aAAa,2BAA2B,EAAE;AAC1C,gBAAgB,0BAA0B,EAAE,gBAAgB,EAAE;AAC9D;EACE,aAAa,EAAE,mBAAmB,EAAE,mBAAmB;EACvD,+BAA+B,EAAE,+BAA+B;EAChE,0BAA0B,EAAE,kBAAkB,EAAE,gBAAgB;EAChE,kBAAkB,EAAE,+BAA+B,EAAE,eAAe;EACpE,qBAAqB,EAAE,mBAAmB;AAC5C;AACA,uBAAuB,2BAA2B,EAAE,oBAAoB,EAAE;;AAE1E,gBAAgB;AAChB;EACE,aAAa,EAAE,qCAAqC,EAAE,SAAS;EAC/D,mBAAmB;AACrB;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,+BAA+B,EAAE,iCAAiC;EAClE,+BAA+B,EAAE,kBAAkB;EACnD,8BAA8B;EAC9B,eAAe,EAAE,qBAAqB,EAAE,gBAAgB;AAC1D;AACA,sBAAsB,2BAA2B,EAAE,2BAA2B,EAAE;AAChF,uBAAuB,2BAA2B,EAAE,mCAAmC,EAAE;AACzF,2CAA2C,mCAAmC,EAAE;AAChF;EACE,WAAW,EAAE,YAAY,EAAE,+BAA+B,EAAE,cAAc;EAC1E,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,iBAAiB;AACnB;AACA,gBAAgB,YAAY,EAAE;AAC9B,iBAAiB,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE,mBAAmB,EAAE;AACzG,iBAAiB,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,SAAS,EAAE,gBAAgB,EAAE;AAC/G,eAAe,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE;;AAElF,gBAAgB;AAChB;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,mBAAmB,EAAE,eAAe;AACtC;AACA;EACE,SAAO,EAAE,gBAAgB;EACzB,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,+BAA+B,EAAE,iCAAiC;EAClE,+BAA+B,EAAE,eAAe;EAChD,8BAA8B;AAChC;AACA,+BAA+B,2BAA2B,EAAE;AAC5D,kBAAkB,kBAAkB,EAAE,2BAA2B,EAAE,cAAc,EAAE;AACnF;EACE,gBAAgB,EAAE,YAAY,EAAE,aAAa;EAC7C,kBAAkB,EAAE,0BAA0B;EAC9C,WAAW,EAAE,YAAY,EAAE,UAAU;AACvC;AACA,gCAAgC,2BAA2B,EAAE;AAC7D,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAClE;EACE,+BAA+B,EAAE,iCAAiC;EAClE,0BAA0B,EAAE,kBAAkB;EAC9C,kBAAkB,EAAE,+BAA+B,EAAE,eAAe;EACpE,aAAa,EAAE,8BAA8B;AAC/C;AACA,wBAAwB,2BAA2B,EAAE;AACrD;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,+BAA+B,EAAE,iCAAiC;EAClE,0BAA0B,EAAE,kBAAkB,EAAE,gBAAgB;EAChE,kBAAkB,EAAE,+BAA+B,EAAE,eAAe;EACpE,qBAAqB;AACvB;AACA,uBAAuB,2BAA2B,EAAE,oBAAoB,EAAE;;AAE1E,gBAAgB;AAChB;EACE,aAAa,EAAE,sBAAsB,EAAE,mBAAmB;EAC1D,kBAAkB,EAAE,kBAAkB;AACxC;AACA,iBAAiB,eAAe,EAAE,mBAAmB,EAAE;AACvD,kBAAkB,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACpG,gBAAgB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;;AAE7E,kBAAkB;AAClB;EACE,+BAA+B,EAAE,+BAA+B;EAChE,+BAA+B,EAAE,gBAAgB,EAAE,mBAAmB;EACtE,8BAA8B;AAChC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,wDAAwD;EACxD,MAAM;EACN,8BAA8B,EAAE,sCAAsC;EACtE,UAAU;AACZ;AACA;EACE,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B;EAClE,yBAAyB,EAAE,sBAAsB;EACjD,kBAAkB;AACpB;;AAEA,oDAAoD;AACpD,eAAe,sCAAsC,EAAE,sJAAsJ,EAAE,kBAAkB,EAAE,UAAU,EAAE;AAC/O,0BAA0B,mBAAmB,EAAE;AAC/C,qBAAqB,mCAAmC,EAAE,8BAA8B,EAAE,2BAA2B,EAAE,UAAU,EAAE;AACnI,+BAA+B,mCAAmC,EAAE;;AAEpE,aAAa;AACb;EACE,aAAa;EACb,wDAAwD;EACxD,MAAM,EAAE,mBAAmB;AAC7B;;AAEA,UAAU;AACV,WAAW,kBAAkB,EAAE;AAC/B;EACE,iBAAiB,EAAE,gBAAgB,EAAE,2BAA2B;EAChE,yBAAyB,EAAE,sBAAsB,EAAE,eAAe;AACpE;;AAEA,kBAAkB;AAClB,eAAe,kBAAkB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,SAAS,EAAE;AACtF,iBAAiB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE,gBAAgB,EAAE;;AAEhG,iBAAiB;AACjB,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAClE;EACE,WAAW,EAAE,YAAY,EAAE,mBAAmB;EAC9C,+BAA+B,EAAE,8BAA8B;EAC/D,+BAA+B,EAAE,YAAY,EAAE,cAAc;AAC/D;AACA;EACE,WAAW,EAAE,YAAY,EAAE,+BAA+B;EAC1D,8BAA8B,EAAE,+BAA+B;EAC/D,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,iBAAiB,EAAE,cAAc;AACnC;AACA,gBAAgB,YAAY,EAAE;AAC9B;EACE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B;EAChE,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB;EAC/E,gBAAgB;AAClB;AACA,kBAAkB,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE;AACrF,iBAAiB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;AAC9E,eAAe,2BAA2B,EAAE;AAC5C,gBAAgB,kBAAkB,EAAE,oBAAoB,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAE7F,eAAe;AACf,aAAa,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,iBAAiB,EAAE;AAC/F;EACE,qBAAqB;EACrB,+DAA+D,EAAE,qEAAqE;EACtI,qBAAqB,EAAE,kBAAkB,EAAE,gBAAgB;EAC3D,gBAAgB,EAAE,+BAA+B,EAAE,sBAAsB;AAC3E;AACA,qCAAqC,qBAAqB,EAAE,iEAAiE,EAAE,+DAA+D,EAAE;AAChM;EACE,kCAAkC,EAAE,mCAAmC;EACvE,2BAA2B;AAC7B;AACA,oCAAoC,2BAA2B,EAAE,mCAAmC,EAAE,iCAAiC,EAAE;;AAEzI,wBAAwB;AACxB,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAC3F;EACE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB;EAC5D,WAAW,EAAE,YAAY,EAAE,+BAA+B;EAC1D;;;gFAG8E;EAC9E,cAAc;AAChB;AACA,iBAAiB,mBAAmB,EAAE,+BAA+B,EAAE;AACvE,iBAAiB,qDAAqD,EAAE,+BAA+B,EAAE;AACzG,iBAAiB,mBAAmB,EAAE,+BAA+B,EAAE,iBAAiB,EAAE;AAC1F,iBAAiB,kBAAkB,EAAE,4BAA4B,EAAE,sBAAsB,EAAE;;AAE3F,gBAAgB;AAChB;EACE,qBAAqB;EACrB,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB;EAC5D,iBAAiB,EAAE,+BAA+B,EAAE,iBAAiB;AACvE;AACA,iBAAiB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE,gBAAgB,EAAE;;AAEhG,iBAAiB;AACjB,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACnG;EACE,WAAW,EAAE,iBAAiB;EAC9B,yBAAyB,EAAE,qCAAqC;EAChE,YAAY,EAAE,+BAA+B;EAC7C,kBAAkB,EAAE,gBAAgB,EAAE,eAAe;EACrD,qBAAqB;AACvB;AACA,qBAAqB,+BAA+B,EAAE,2BAA2B,EAAE;AACnF;EACE,WAAW,EAAE,iBAAiB;EAC9B,6DAA6D,EAAE,oBAAoB;EACnF,oEAAoE,EAAE,+BAA+B;EACrG,kBAAkB,EAAE,gBAAgB,EAAE,eAAe;EACrD,qBAAqB;AACvB;AACA,uBAAuB,8DAA8D,EAAE;AACvF;EACE,WAAW,EAAE,iBAAiB;EAC9B,8BAA8B,EAAE,0BAA0B;EAC1D,+BAA+B,EAAE,+BAA+B;EAChE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe;EACrD,qBAAqB;AACvB;AACA,0BAA0B,2BAA2B,EAAE,oBAAoB,EAAE;;AAE7E,wBAAwB;AACxB;EACE,oBAAoB;EACpB,mCAAmC;EACnC,6BAA6B;AAC/B;AACA;EACE,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B;EAClE,yBAAyB,EAAE,sBAAsB;EACjD,mBAAmB;AACrB;AACA,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE;AAC/E;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,+BAA+B,EAAE,+BAA+B;EAChE,+BAA+B,EAAE,kBAAkB;AACrD;AACA;EACE,WAAW,EAAE,YAAY,EAAE,mBAAmB;EAC9C,+BAA+B,EAAE,8BAA8B,EAAE,YAAY;AAC/E;AACA,uBAAuB,SAAO,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE;AAClG,uBAAuB,kBAAkB,EAAE,4BAA4B,EAAE;AACzE,wBAAwB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAC1F,kBAAkB,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;AACtF,oBAAoB,SAAS,EAAE;;AAE/B,eAAe;AACf;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,eAAe,EAAE,SAAS;AAC5B;AACA,sBAAsB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;AACnF,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC9D;EACE,WAAW,EAAE,YAAY;EACzB,+BAA+B,EAAE,+BAA+B;EAChE,0BAA0B,EAAE,iBAAiB,EAAE,gBAAgB;EAC/D,+BAA+B,EAAE,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC7G,qBAAqB;AACvB;AACA,sCAAsC,2BAA2B,EAAE,oBAAoB,EAAE;AACzF,0BAA0B,aAAa,EAAE,mBAAmB,EAAE;AAC9D;EACE,WAAW,EAAE,YAAY;EACzB,+BAA+B,EAAE,+BAA+B;EAChE,4BAA4B,EAAE,kBAAkB,EAAE,gBAAgB;EAClE,+BAA+B,EAAE,eAAe;EAChD,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,qBAAqB;AACvB;AACA,qBAAqB,2BAA2B,EAAE,oBAAoB,EAAE;AACxE;EACE,yBAAyB,EAAE,2BAA2B,EAAE,qCAAqC;AAC/F;AACA,oBAAoB,kBAAkB,EAAE,2BAA2B,EAAE,cAAc,EAAE;;AAErF,eAAe;AACf;EACE,iBAAiB,qCAAqC,EAAE;EACxD;YACU,wDAAwD,EAAE;AACtE;AACA;EACE,iBAAiB,qCAAqC,EAAE;EACxD,iBAAiB,gBAAgB,EAAE;EACnC;YACU,gBAAgB,EAAE;AAC9B;AACA;EACE,WAAW,uBAAuB,EAAE;EACpC,iBAAiB,qCAAqC,EAAE;EACxD,iBAAiB,iBAAiB,EAAE;AACtC;AACA;;;qCAGqC;AACrC;EACE,WAAW,sBAAsB,EAAE;EACnC;IACE,uBAAuB,EAAE,YAAY,EAAE,gBAAgB;IACvD,iBAAiB,EAAE,gBAAgB;EACrC;EACA,mBAAmB,aAAa,EAAE;EAClC;IACE,cAAc,EAAE,mBAAmB,EAAE,mBAAmB;IACxD,+BAA+B,EAAE,+BAA+B;IAChE,+BAA+B,EAAE,8BAA8B;IAC/D,gBAAgB;EAClB;EACA,0BAA0B,gBAAgB,EAAE;EAC5C,qBAAqB,eAAe,EAAE;EACtC,UAAU,cAAc,EAAE,YAAY,EAAE;EACxC,WAAW,kBAAkB,EAAE,sCAAsC,EAAE;EACvE,sBAAsB,mBAAmB,EAAE;EAC3C,mBAAmB,eAAe,EAAE;EACpC,gBAAgB,eAAe,EAAE,mBAAmB,EAAE;EACtD,mBAAmB,mBAAmB,EAAE,SAAS,EAAE,kBAAkB,EAAE;EACvE,0BAA0B,SAAO,EAAE,WAAW,EAAE;EAChD,mBAAmB,oBAAoB,EAAE;AAC3C;AACA;EACE,iBAAiB,8BAA8B,EAAE;EACjD,gBAAgB,kBAAkB,EAAE,mBAAmB,EAAE;EACzD,iBAAiB,iBAAiB,EAAE;AACtC;;AAEA;;+DAE+D;;AAE/D;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,SAAS;AACX;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,4DAA4D;EAC5D,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,gDAAgD;EAChD,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAO;AACT;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;EACrC,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;AAC3B;AACA,qBAAqB,aAAa,EAAE;AACpC;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,uBAAuB;AACzB;AACA,4BAA4B,oBAAoB,EAAE;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;AACA,uBAAuB,aAAa,EAAE;;AAEtC,yBAAyB;AACzB;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gDAAgD;EAChD,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA,kCAAkC,sBAAsB,EAAE;AAC1D;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,+BAA+B;EAC/B,aAAa;EACb,0CAA0C;AAC5C;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAClE,gBAAgB,mBAAmB,EAAE;AACrC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;;EAEE,YAAY;EACZ,iCAAiC;EACjC,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;gCACgC,2BAA2B,EAAE;AAC7D;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,+BAA+B;EAC/B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,8BAA8B;AAChC;AACA,uBAAuB,mCAAmC,EAAE;;AAE5D,oBAAoB;AACpB;EACE,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,iCAAiC;EACjC,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,SAAO;AACT;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;;EAEE,mCAAmC;AACrC;;AAEA,eAAe;AACf;EACE,WAAW,sBAAsB,EAAE;EACnC,iBAAiB,0BAA0B,EAAE;EAC7C,gBAAgB,0BAA0B,EAAE;EAC5C,gBAAgB,cAAc,EAAE;EAChC,WAAW,aAAa,EAAE;EAC1B,uBAAuB,YAAY,EAAE,kBAAkB,EAAE;AAC3D;;AAEA;;;;;;+DAM+D;;AAE/D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,iCAAiC;EACjC,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;AACA,uCAAuC,2BAA2B,EAAE;AACpE,2BAA2B,YAAY,EAAE,eAAe,EAAE;AAC1D;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;;gCAGgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;AACX;AACA;EACE,eAAe,aAAa,EAAE;EAC9B,kBAAkB,WAAW,EAAE,kBAAkB,EAAE;AACrD;;AAEA;;;;;;;;;;4EAU4E;AAC5E;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,+CAA+C;EAC/C,+BAA+B;EAC/B,eAAe;EACf,gDAAgD;AAClD;AACA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;AACA;gBACgB;AAChB;EACE,mBAAmB;EACnB,oCAAoC;EACpC,uCAAuC;AACzC;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,cAAc;AAChB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B;4EAC0E;EAC1E,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,qCAAqC;EACrC,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA,uBAAuB,wCAAwC,EAAE;;AAEjE;EACE,iBAAiB,WAAW,EAAE,kBAAkB,EAAE;AACpD;;AAEA;;+DAE+D;;AAE/D;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;AACA,kBAAkB,aAAa,EAAE;;AAEjC,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,0CAA0C;AAC5C;AACA,oBAAoB,gBAAgB,EAAE;AACtC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;AACA,4BAA4B,oBAAoB,EAAE,kBAAkB,EAAE;AACtE,gBAAgB,iBAAiB,EAAE,4BAA4B,EAAE,eAAe,EAAE;AAClF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;AACA,qBAAqB,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE;;AAExF,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAClE;EACE,WAAW,EAAE,YAAY;EACzB,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;AACjC;AACA,sBAAsB,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE;AACzF,kBAAkB,kBAAkB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,SAAS,EAAE,eAAe,EAAE;AAC1G,wBAAwB,0BAA0B,EAAE;;AAEpD,kBAAkB,kBAAkB,EAAE;AACtC,uBAAuB,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE;AAC1F,iBAAiB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACpG;EACE,qBAAqB;EACrB,+DAA+D;EAC/D,qBAAqB;EACrB,qEAAqE;EACrE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA,qCAAqC,qBAAqB,EAAE;AAC5D;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,oCAAoC;AACtC;AACA,oCAAoC,2BAA2B,EAAE;AACjE,gBAAgB,2BAA2B,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACnF,oCAAoC,2BAA2B,EAAE;;AAEjE,mBAAmB,gBAAgB,EAAE;AACrC,oBAAoB,gBAAgB,EAAE;;AAEtC,6EAA6E;;AAE7E,qBAAqB,wBAAwB,EAAE;;AAE/C;;;qCAGqC;AACrC;EACE,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,yBAAyB,8BAA8B,EAAE;AACzD,iCAAiC,yCAAyC,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;;AAErH;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,qBAAqB,gBAAgB,EAAE,wBAAwB,EAAE;;AAEjE;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA,qBAAqB,gBAAgB,EAAE,gBAAgB,EAAE;;AAEzD;;kBAEkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,sBAAsB,cAAc,EAAE,eAAe,EAAE;;AAEvD,oBAAoB,aAAa,EAAE,QAAQ,EAAE,gBAAgB,EAAE;;AAE/D;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,qCAAqC;EACrC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,0BAA0B,YAAY,EAAE,eAAe,EAAE;;AAEzD;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gFAAgF;AAChF;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA,qBAAqB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACxG,qBAAqB,iBAAiB,EAAE,4BAA4B,EAAE,SAAS,EAAE,gBAAgB,EAAE;;AAEnG,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;AAC/F;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,oBAAoB;AACtB;AACA,yBAAyB,2BAA2B,EAAE,mCAAmC,EAAE;AAC3F;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,0BAA0B;AAC5B;AACA,2BAA2B,2BAA2B,EAAE;;AAExD,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,MAAM;AACR;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;EACP,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,UAAU;EACV,cAAc;EACd,gDAAgD;AAClD;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,qCAAqC;AACvC;AACA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,mCAAmC;AACrC;AACA;EACE,SAAO;EACP,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,4BAA4B;AAC9B;AACA,uBAAuB,yBAAyB,EAAE;AAClD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA,sBAAsB,0BAA0B,EAAE;AAClD,eAAe,kBAAkB,EAAE,4BAA4B,EAAE;AACjE;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,eAAe;AACjB;AACA,0BAA0B,0BAA0B,EAAE;AACtD;EACE,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA,yBAAyB,4BAA4B,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC7F,yBAAyB,8BAA8B,EAAE;AACzD,0BAA0B,8BAA8B,EAAE;;AAE1D,oBAAoB;AACpB;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;AACxC;AACA,mBAAmB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACrF;EACE,kCAAkC;EAClC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;AACjC;AACA,kBAAkB,aAAa,EAAE,sBAAsB,EAAE;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,4BAA4B;AAC9B;AACA,2BAA2B,mBAAmB,EAAE;AAChD,sBAAsB,+BAA+B,EAAE;AACvD,qBAAqB,cAAc,EAAE;AACrC;EACE,WAAW,EAAE,YAAY;EACzB,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,YAAY;AACd;AACA;EACE,WAAW,EAAE,YAAY;EACzB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,iBAAiB;AACnB;AACA,iBAAiB,SAAO,EAAE,YAAY,EAAE;AACxC,iBAAiB,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACnG,iBAAiB,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE;AACpF,iBAAiB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;AAC9E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;AAChB;AACA,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACrE;EACE,iBAAiB;EACjB,iCAAiC;EACjC,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;AACA,wBAAwB,2BAA2B,EAAE,oBAAoB,EAAE;AAC3E;EACE,iBAAiB;EACjB,iCAAiC;EACjC,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;AACA,yBAAyB,mCAAmC,EAAE;;AAE9D,yBAAyB;AACzB;EACE,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;EAC/B,8BAA8B;AAChC;AACA,gBAAgB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE;AACpG;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;AACA,eAAe,qBAAqB,EAAE,gBAAgB,EAAE;AACxD,mCAAmC,qBAAqB,EAAE;AAC1D;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB,aAAa,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC/D;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA,yBAAyB,kBAAkB,EAAE;AAC7C,yCAAyC,uBAAuB,EAAE;AAClE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,oCAAoC;EACpC,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA,UAAU,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;AACvE,UAAU,kBAAkB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,SAAS,EAAE;AACvF;;;;;qEAKqE;AACrE,0BAA0B,iBAAiB,EAAE;AAC7C,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,sBAAsB,EAAE,kBAAkB,EAAE;AAC1G;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,sBAAsB,oBAAoB,EAAE;AAC5C;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,+BAA+B;EAC/B,mCAAmC;EACnC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,4BAA4B,kCAAkC,EAAE;AAChE;EACE,aAAa;EACb;;;;;;;;uBAQqB;EACrB,2DAA2D;EAC3D,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,sCAAsC;AACxC;AACA,4BAA4B,mBAAmB,EAAE;AACjD,uBAAuB,+BAA+B,EAAE;;AAExD,eAAe;AACf;EACE,YAAY,0BAA0B,EAAE;EACxC,aAAa,mBAAmB,EAAE,eAAe,EAAE;EACnD,iBAAiB,SAAO,EAAE,gBAAgB,EAAE;AAC9C;AACA;EACE,YAAY,uBAAuB,EAAE;EACrC;;;;;;;4CAO0C;EAC1C,mBAAmB,sBAAsB,EAAE,mBAAmB,EAAE,oBAAoB,EAAE;EACtF;;kCAEgC;EAChC,gBAAgB,mBAAmB,EAAE,eAAe,EAAE,cAAc,EAAE;EACtE;uCACqC;EACrC,wCAAwC,YAAY,EAAE,uBAAuB,EAAE;EAC/E;;uDAEqD;EACrD,kBAAkB,gBAAgB,EAAE;EACpC,qBAAqB,kBAAkB,EAAE;EACzC,gBAAgB,kBAAkB,EAAE;EACpC,gBAAgB,eAAe,EAAE;EACjC,iBAAiB,WAAW,EAAE,eAAe,EAAE;AACjD;;AAEA,YAAY,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAE9D;;+DAE+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,+DAA+D;EAC/D,qEAAqE;EACrE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;AAChC;AACA,0CAA0C,qBAAqB,EAAE;AACjE,sBAAsB,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,eAAe,EAAE,EAAE;;AAE5G;;+DAE+D;AAC/D,WAAW,iBAAiB,EAAE,cAAc,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAEhG;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,uCAAuC;EACvC,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,mBAAmB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACtG,iBAAiB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;;AAE9E,YAAY;AACZ,cAAc,aAAa,EAAE,uBAAuB,EAAE,kBAAkB,EAAE;AAC1E,WAAW,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,SAAO,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACtH,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,uBAAuB,EAAE,kBAAkB,EAAE;AAC/G;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,6DAA6D;AAC/D;AACA,qBAAqB,yBAAyB,EAAE,2BAA2B,EAAE,qCAAqC,EAAE;AACpH,gDAAgD,gCAAgC,EAAE,kCAAkC,EAAE,mCAAmC,EAAE;AAC3J;EACE,SAAO;EACP,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,4BAA4B;AAC9B;AACA,wBAAwB,yBAAyB,EAAE;AACnD,iBAAiB,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,kBAAkB,EAAE;AACzH,yBAAyB,0BAA0B,EAAE;;AAErD,sBAAsB;AACtB,aAAa,aAAa,EAAE,gCAAgC,EAAE,SAAS,EAAE,kBAAkB,EAAE;AAC7F;EACE,aAAa,0BAA0B,EAAE;AAC3C;;AAEA,uBAAuB;AACvB,WAAW,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC7D,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,SAAS,EAAE;AAC/F,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;;AAExG;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,gDAAgD;AAClD;AACA,uBAAuB,2BAA2B,EAAE;AACpD,2BAA2B,2BAA2B,EAAE,6CAA6C,EAAE;;AAEvG,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,mBAAmB,EAAE;AAC9G,eAAe,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACjF;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,kCAAkC;EAClC,2BAA2B;AAC7B;AACA,sBAAsB,aAAa,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACrE,kBAAkB,WAAW,EAAE,YAAY,EAAE,+BAA+B,EAAE,iBAAiB,EAAE,cAAc,EAAE;AACjH,8BAA8B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,8BAA8B,EAAE,2BAA2B,EAAE;AACxJ,iBAAiB,YAAY,EAAE;AAC/B,iBAAiB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACpK,oBAAoB,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE;AACvF,kBAAkB,iBAAiB,EAAE,4BAA4B,EAAE,SAAS,EAAE;;AAE9E;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,sBAAsB,+BAA+B,EAAE;;AAEvD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,iCAAiC;EACjC,+BAA+B;EAC/B,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;AACA,0BAA0B,2BAA2B,EAAE;;AAEvD;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;AACpB;AACA,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AAC7J,eAAe,iBAAiB,EAAE,4BAA4B,EAAE,SAAS,EAAE;;AAE3E,8BAA8B;AAC9B;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA,iBAAiB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACpG,eAAe,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;;AAEnF,kBAAkB,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,kBAAkB,EAAE;AAC1G;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,iCAAiC;EACjC,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;AACxB;AACA,uCAAuC,2BAA2B,EAAE;AACpE,eAAe,gBAAgB,EAAE;AACjC,iBAAiB,kBAAkB,EAAE,2BAA2B,EAAE,iBAAiB,EAAE,eAAe,EAAE;;AAEtG,iBAAiB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE;AAC3E,4BAA4B,iBAAiB,0BAA0B,EAAE,EAAE;;AAE3E;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,iCAAiC;EACjC,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;AACA,uBAAuB,2BAA2B,EAAE;AACpD,2BAA2B,2BAA2B,EAAE,mCAAmC,EAAE;AAC7F;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;AAChB;AACA,2CAA2C,2BAA2B,EAAE,yBAAyB,EAAE,+CAA+C,EAAE;;AAEpJ;EACE,eAAe;EACf,gCAAgC;EAChC,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gDAAgD;EAChD,4BAA4B;AAC9B;AACA,wCAAwC,2BAA2B,EAAE,mCAAmC,EAAE;AAC1G,oBAAoB,kBAAkB,EAAE,0BAA0B,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACzG,oBAAoB,kBAAkB,EAAE,2BAA2B,EAAE,SAAS,EAAE;;AAEhF,iBAAiB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC9E;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;AAChB;AACA,kBAAkB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,cAAc,EAAE;AAChF;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,+BAA+B;AACjC;AACA,kBAAkB,8DAA8D,EAAE,gBAAgB,EAAE;AACpG;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,iBAAiB,kBAAkB,EAAE,oBAAoB,EAAE,gBAAgB,EAAE;AAC7E;EACE,WAAW;EACX,gBAAgB;EAChB,+EAA+E;EAC/E,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;AAC3B;AACA,0BAA0B,aAAa,EAAE,mBAAmB,EAAE;;AAE9D,0BAA0B;AAC1B,iBAAiB,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,cAAc,EAAE,sCAAsC,EAAE,kBAAkB,EAAE;AACjK,8BAA8B,mBAAmB,EAAE;AACnD,mBAAmB,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;AACvF,mBAAmB,gBAAgB,EAAE;AACrC,kBAAkB,kBAAkB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAErG,uBAAuB,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAE5G;EACE,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;AACjC;AACA,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACtJ,mCAAmC,kCAAkC,EAAE;AACvE,mDAAmD,gBAAgB,EAAE;;AAErE,6BAA6B;AAC7B;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;AACpB;AACA,uBAAuB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE;AAC3G,qBAAqB,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE;AACxE,sBAAsB,SAAO,EAAE,YAAY,EAAE;AAC7C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,4BAA4B,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AAC/G,2BAA2B,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE,gBAAgB,EAAE;AAC1G,sBAAsB,cAAc,EAAE,WAAW,EAAE,gBAAgB,EAAE,oCAAoC,EAAE;AAC3G;EACE,qBAAqB,sBAAsB,EAAE;EAC7C,sBAAsB,aAAa,EAAE;AACvC;;AAEA,uEAAuE;AACvE,mBAAmB,gBAAgB,EAAE,iBAAiB,EAAE,mCAAmC,EAAE;AAC7F;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,iBAAiB,kBAAkB,EAAE,2BAA2B,EAAE,aAAa,EAAE;AACjF;EACE,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;AAChC;AACA,sBAAsB,oBAAoB,EAAE,kCAAkC,EAAE;AAChF,sBAAsB,sBAAsB,EAAE;AAC9C,oBAAoB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE,kBAAkB,EAAE;AAClG,sBAAsB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACxF,oBAAoB,iBAAiB,EAAE,2BAA2B,EAAE;AACpE,oBAAoB,kBAAkB,EAAE,0BAA0B,EAAE,SAAS,EAAE,iBAAiB,EAAE,qBAAqB,EAAE;AACzH,oBAAoB,aAAa,EAAE,QAAQ,EAAE,qBAAqB,EAAE;AACpE;EACE,SAAO;EACP,iBAAiB;EACjB,+BAA+B;EAC/B,iCAAiC;EACjC,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;AACf;AACA,uBAAuB,2BAA2B,EAAE;AACpD;EACE,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;EACzB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA,6BAA6B,YAAY,EAAE,mBAAmB,EAAE;;AAEhE;;+DAE+D;AAC/D,cAAc,aAAa,EAAE,uBAAuB,EAAE,8BAA8B,EAAE,SAAS,EAAE,eAAe,EAAE,mBAAmB,EAAE;AACvI,iBAAiB,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACnG,gBAAgB,SAAS,EAAE,kBAAkB,EAAE,4BAA4B,EAAE;;AAE7E;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,iBAAiB,EAAE,+BAA+B,EAAE,+BAA+B;EACnF,+BAA+B,EAAE,0BAA0B;EAC3D,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,mBAAmB;EAC1E,8BAA8B;AAChC;AACA,yBAAyB,2BAA2B,EAAE;AACtD,4BAA4B,YAAY,EAAE,eAAe,EAAE;;AAE3D,oBAAoB,kBAAkB,EAAE;AACxC;EACE,kBAAkB,EAAE,qBAAqB,EAAE,QAAQ,EAAE,WAAW;EAChE,gBAAgB,EAAE,6BAA6B,EAAE,+BAA+B;EAChF,+BAA+B,EAAE,4CAA4C,EAAE,kBAAkB;AACnG;AACA,qBAAqB,kBAAkB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,sBAAsB,EAAE,wBAAwB,EAAE,eAAe,EAAE;AACzJ,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,cAAc,EAAE,eAAe,EAAE;AACpJ,qBAAqB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACzF,0BAA0B,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;AAC/I,gCAAgC,gBAAgB,EAAE,kBAAkB,EAAE,+BAA+B,EAAE,+BAA+B,EAAE,0BAA0B,EAAE,kBAAkB,EAAE;AACxL,qBAAqB,sBAAsB,EAAE,YAAY,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,UAAU,EAAE;;AAEtK;;gDAEgD;AAChD,gBAAgB,aAAa,EAAE,qCAAqC,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACtG,6BAA6B,gBAAgB,qCAAqC,EAAE,EAAE;AACtF,6BAA6B,gBAAgB,qCAAqC,EAAE,EAAE;AACtF;EACE,aAAa,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,QAAQ;EACxE,+BAA+B,EAAE,iCAAiC;EAClE,+BAA+B,EAAE,kBAAkB;EACnD,eAAe,EAAE,qBAAqB,EAAE,gBAAgB;AAC1D;AACA,uBAAuB,2BAA2B,EAAE,2BAA2B,EAAE;AACjF,wBAAwB,2BAA2B,EAAE,mCAAmC,EAAE;AAC1F,4CAA4C,mCAAmC,EAAE;AACjF,iBAAiB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AAC7H,kBAAkB,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE;AACrG,kBAAkB,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;;AAEtF;;oEAEoE;AACpE,cAAc,cAAc,EAAE;AAC9B,qBAAqB,aAAa,EAAE,gCAAgC,EAAE,SAAS,EAAE,kBAAkB,EAAE;AACrG,6BAA6B,qBAAqB,0BAA0B,EAAE,EAAE;;AAEhF,YAAY,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC9D;EACE,+BAA+B,EAAE,iCAAiC,EAAE,mBAAmB;EACvF,kBAAkB,EAAE,eAAe,EAAE,8BAA8B;AACrE;AACA,kBAAkB,2BAA2B,EAAE;AAC/C,sBAAsB,2BAA2B,EAAE,6CAA6C,EAAE;AAClG,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE,kBAAkB,EAAE;AACvG,aAAa,iBAAiB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC3F,oBAAoB,8BAA8B,EAAE,4BAA4B,EAAE;AAClF;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS;EAC7E,kBAAkB,EAAE,4BAA4B,EAAE,cAAc,EAAE,kBAAkB;EACpF,mCAAmC,EAAE,sCAAsC;AAC7E;AACA,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,cAAc,EAAE;AAClF,uBAAuB,oBAAoB,EAAE,iBAAiB,EAAE;AAChE,oBAAoB,gBAAgB,EAAE,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE,qBAAqB,EAAE;AACvG;EACE,SAAO,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,+BAA+B;EACjG,6BAA6B,EAAE,0BAA0B,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,gBAAgB;AACtH;;AAEA,YAAY;AACZ;EACE,+BAA+B,EAAE,+BAA+B,EAAE,mBAAmB;EACrF,kBAAkB,EAAE,gBAAgB,EAAE,SAAS,EAAE,+BAA+B,EAAE,gBAAgB;AACpG;AACA,sBAAsB,aAAa,EAAE,uBAAuB,EAAE,8BAA8B,EAAE,SAAS,EAAE,mBAAmB,EAAE;AAC9H,qBAAqB,YAAY,EAAE,8BAA8B,EAAE,4BAA4B,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,cAAc,EAAE;AAC9O,oBAAoB,aAAa,EAAE,QAAQ,EAAE,sCAAsC,EAAE,mBAAmB,EAAE;AAC1G;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,iBAAiB,EAAE,YAAY,EAAE,gBAAgB,EAAE,4BAA4B;EAC/E,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,oCAAoC,EAAE,mBAAmB;AAClH;AACA,0BAA0B,oBAAoB,EAAE,kCAAkC,EAAE;AACpF,iBAAiB,8BAA8B,EAAE,4BAA4B,EAAE,mBAAmB,EAAE,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACzJ,yCAAyC,mCAAmC,EAAE,oBAAoB,EAAE;;AAEpG,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACtE,iBAAiB,6BAA6B,EAAE,+BAA+B,EAAE,+BAA+B,EAAE,kBAAkB,EAAE;AACtI,kBAAkB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE;AACtG,mBAAmB,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACrH,kBAAkB,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,SAAS,EAAE,kBAAkB,EAAE,4BAA4B,EAAE,cAAc,EAAE,SAAS,EAAE;AAC9K,kCAAkC,0BAA0B,EAAE,gBAAgB,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC9H,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,mBAAmB,EAAE;AAC7F,mBAAmB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,cAAc,EAAE;AACrG,+BAA+B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,8BAA8B,EAAE,2BAA2B,EAAE;AACzJ,gBAAgB,YAAY,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,eAAe,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,YAAY,EAAE;AACxJ,sBAAsB,oBAAoB,EAAE;;AAE5C;;gDAEgD;AAChD,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC7H,kBAAkB,kBAAkB,EAAE,2BAA2B,EAAE;AACnE,gBAAgB,cAAc,EAAE,iBAAiB,EAAE,+BAA+B,EAAE,6BAA6B,EAAE,+BAA+B,EAAE;AACpJ,uBAAuB,oBAAoB,EAAE,kCAAkC,EAAE,qCAAqC,EAAE;AACxH,uBAAuB,sBAAsB,EAAE;AAC/C,wBAAwB,oBAAoB,EAAE,kCAAkC,EAAE,qCAAqC,EAAE;AACzH,qBAAqB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE,kBAAkB,EAAE;AACnG,uBAAuB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACzF,qBAAqB,kBAAkB,EAAE,2BAA2B,EAAE;AACtE,qBAAqB,kBAAkB,EAAE,0BAA0B,EAAE,SAAS,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AACzH,qBAAqB,aAAa,EAAE,QAAQ,EAAE,qBAAqB,EAAE;AACrE,kBAAkB,SAAO,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,+BAA+B,EAAE,6BAA6B,EAAE,0BAA0B,EAAE,kBAAkB,EAAE,oBAAoB,EAAE,gBAAgB,EAAE;AAC1N,qBAAqB,iBAAiB,EAAE,YAAY,EAAE,kBAAkB,EAAE,kCAAkC,EAAE,qCAAqC,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE,cAAc,EAAE;AAC5N,8BAA8B,YAAY,EAAE,mBAAmB,EAAE;;AAEjE,iBAAiB;AACjB,qBAAqB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;AAChE,sBAAsB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,+BAA+B,EAAE;;AAE1H,4EAA4E;AAC5E,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACjE,sBAAsB,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE,cAAc,EAAE,kBAAkB,EAAE;AAC7G;EACE,WAAW,EAAE,kBAAkB,EAAE,SAAS,EAAE,SAAS,EAAE,YAAY,EAAE,UAAU,EAAE,yBAAyB;AAC5G;AACA,oBAAoB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,cAAc,EAAE,eAAe,EAAE;AAC/H,6BAA6B,yBAAyB,EAAE;;AAExD;;;;;+DAK+D;AAC/D,cAAc,cAAc,EAAE;AAC9B,qBAAqB,aAAa,EAAE,gCAAgC,EAAE,SAAS,EAAE,kBAAkB,EAAE;AACrG,6BAA6B,qBAAqB,0BAA0B,EAAE,EAAE;;AAEhF,YAAY,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC9D;EACE,+BAA+B,EAAE,iCAAiC,EAAE,mBAAmB;EACvF,kBAAkB,EAAE,eAAe,EAAE,8BAA8B;AACrE;AACA,kBAAkB,2BAA2B,EAAE;AAC/C,sBAAsB,2BAA2B,EAAE,6CAA6C,EAAE;AAClG,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE,mBAAmB,EAAE;AACxG,iBAAiB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,cAAc,EAAE;AAC7I,aAAa,iBAAiB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC3F,oBAAoB,8BAA8B,EAAE,4BAA4B,EAAE;;AAElF;EACE,aAAa,EAAE,qCAAqC,EAAE,SAAS;EAC/D,oBAAoB,EAAE,kBAAkB,EAAE,sCAAsC;AAClF;AACA,4BAA4B,iBAAiB,qCAAqC,EAAE,EAAE;AACtF,kBAAkB,iBAAiB,EAAE,gBAAgB,EAAE,2BAA2B,EAAE,yBAAyB,EAAE,sBAAsB,EAAE,eAAe,EAAE;AACxJ,kBAAkB,kBAAkB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,SAAS,EAAE;AAC/F,gBAAgB,kBAAkB,EAAE,wBAAwB,EAAE,eAAe,EAAE;AAC/E,wBAAwB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAEtE;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,iCAAiC,EAAE,uCAAuC,EAAE,2BAA2B;EACvG,kBAAkB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,cAAc;AAC7F;AACA,0CAA0C,2BAA2B,EAAE;;AAEvE;EACE,6BAA6B,EAAE,+BAA+B,EAAE,kBAAkB;EAClF,kBAAkB,EAAE,cAAc;AACpC;AACA,0BAA0B,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,yBAAyB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AACnK,yBAAyB,aAAa,EAAE,qCAAqC,EAAE,SAAS,EAAE;AAC1F,4BAA4B,yBAAyB,qCAAqC,EAAE,EAAE;AAC9F;4DAC4D;AAC5D,sCAAsC,qCAAqC,EAAE;;AAE7E;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,mCAAmC,EAAE,yCAAyC,EAAE,6BAA6B;EAC7G,kBAAkB,EAAE,kBAAkB,EAAE,cAAc;AACxD;AACA,0CAA0C,mCAAmC,EAAE;AAC/E;EACE,YAAY,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,+BAA+B;EACnF,+BAA+B,EAAE,0BAA0B,EAAE,kBAAkB;AACjF;;AAEA,oBAAoB,gBAAgB,EAAE,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;AAChF;EACE,iBAAiB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,eAAe;EAC3F,8BAA8B,EAAE,0BAA0B,EAAE,+BAA+B;AAC7F;AACA,uCAAuC,2BAA2B,EAAE;AACpE,2BAA2B,YAAY,EAAE,mBAAmB,EAAE;AAC9D,2BAA2B,kCAAkC,EAAE,qCAAqC,EAAE,oCAAoC,EAAE;AAC5I,wBAAwB,gCAAgC,EAAE,mCAAmC,EAAE,kCAAkC,EAAE;AACnI,0BAA0B,iCAAiC,EAAE,2BAA2B,EAAE,mCAAmC,EAAE;AAC/H,8CAA8C,kCAAkC,EAAE;;AAElF;EACE,+BAA+B,EAAE,+BAA+B,EAAE,mBAAmB;EACrF,kBAAkB,EAAE,gBAAgB,EAAE,SAAS,EAAE,+BAA+B,EAAE,gBAAgB;AACpG;AACA,sBAAsB,aAAa,EAAE,uBAAuB,EAAE,8BAA8B,EAAE,SAAS,EAAE,mBAAmB,EAAE;;AAE9H;;+DAE+D;AAC/D;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;;;+EAG+E;AAC/E;EACE,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,4CAA4C;EAC5C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,qCAAqC;EACrC,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,uBAAuB,+BAA+B,EAAE;AACxD;EACE,WAAW,EAAE,YAAY;EACzB,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;AAC7D;AACA,uBAAuB,+BAA+B,EAAE;;;AAGxD;;+DAE+D;AAC/D;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,4CAA4C;EAC5C,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,sCAAsC;EACtC,gBAAgB;EAChB,MAAM;EACN,6BAA6B;EAC7B,UAAU;AACZ;AACA,eAAe,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC9D,gBAAgB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,SAAS,EAAE;AAC7F,cAAc,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE;AACjF;EACE,WAAW,EAAE,YAAY;EACzB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;AAC7D;AACA,kBAAkB,yBAAyB,EAAE;;AAE7C,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,WAAW,EAAE,YAAY;EACzB,8DAA8D;EAC9D,kBAAkB;EAClB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA,sBAAsB,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC7E,mBAAmB,8BAA8B,EAAE;AACnD,sCAAsC,wEAAwE,EAAE;AAChH,oBAAoB,8BAA8B,EAAE;AACpD,uCAAuC,wEAAwE,EAAE;AACjH,oBAAoB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;;AAEjF,yBAAyB;AACzB;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA,gBAAgB,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACrG,cAAc,qCAAqC,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,SAAS,EAAE,sBAAsB,EAAE;AAC1J;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,2CAA2C;AAC7C;AACA,qBAAqB,2BAA2B,EAAE,oBAAoB,EAAE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA,gBAAgB,SAAO,EAAE,gBAAgB,EAAE;AAC3C,iBAAiB,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AACzJ,eAAe,kBAAkB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,SAAS,EAAE;AAC5F;EACE,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;AACA,qBAAqB,qBAAqB,EAAE,gBAAgB,EAAE;AAC9D,yCAAyC,qBAAqB,EAAE;;AAEhE,sBAAsB;AACtB;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA,yBAAyB,UAAU,EAAE;AACrC,4BAA4B,UAAU,EAAE;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,qCAAqC;AACvC;AACA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,mCAAmC;EACnC,6CAA6C;AAC/C;AACA;EACE,UAAU;EACV,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,4BAA4B;AAC9B;AACA,gCAAgC,yBAAyB,EAAE;AAC3D;EACE,oBAAoB;EACpB,SAAO;EACP,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;AACA,gCAAgC,0BAA0B,EAAE;AAC5D,kBAAkB,iBAAiB,EAAE,4BAA4B,EAAE,eAAe,EAAE;AACpF,cAAc,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;;AAE3E;EACE,YAAY,eAAe,EAAE,oDAAoD,EAAE;AACrF;;AAEA;;;+DAG+D;AAC/D;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,SAAO;AACT;AACA,cAAc,aAAa,EAAE,8BAA8B,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC3G,iBAAiB,aAAa,EAAE,SAAS,EAAE,uBAAuB,EAAE;AACpE;EACE,WAAW,EAAE,YAAY;EACzB,oCAAoC;EACpC,iCAAiC;EACjC,mBAAmB;EACnB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,cAAc;EACd,yCAAyC;AAC3C;AACA,mBAAmB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE,cAAc,EAAE;AACtH,qBAAqB,iBAAiB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACxG,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACrE,oBAAoB,iBAAiB,EAAE,4BAA4B,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAEnH,gBAAgB,iBAAiB,EAAE;AACnC,aAAa,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE;AACrH,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACtF,gBAAgB,aAAa,EAAE,yBAAyB,EAAE,SAAS,EAAE,iBAAiB,EAAE;AACxF,kBAAkB,4BAA4B,EAAE;AAChD,kBAAkB,0BAA0B,EAAE,gBAAgB,EAAE,eAAe,EAAE,iBAAiB,EAAE;AACpG;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,+DAA+D;EAC/D,qBAAqB;EACrB,uEAAuE;EACvE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA,eAAe,WAAW,EAAE,yBAAyB,EAAE,gBAAgB,EAAE;;AAEzE,kBAAkB;AAClB,gBAAgB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE,mBAAmB,EAAE;AAC/F;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW,EAAE,YAAY;EACzB,mBAAmB;EACnB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,cAAc;AAChB;AACA,0BAA0B,iCAAiC,EAAE;AAC7D,0BAA0B,+DAA+D,EAAE;AAC3F,iBAAiB,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE,cAAc,EAAE;AACnH,iBAAiB,iBAAiB,EAAE,4BAA4B,EAAE,eAAe,EAAE,cAAc,EAAE;AACnG,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,cAAc,EAAE;;AAEvI,gBAAgB;AAChB,aAAa,WAAW,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,+BAA+B,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AAClJ,iBAAiB,8BAA8B,EAAE;AACjD;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mCAAmC;EACnC,wCAAwC;EACxC,gBAAgB;AAClB;AACA,mBAAmB,kBAAkB,EAAE;AACvC,mBAAmB,iBAAiB,EAAE;AACtC,UAAU,aAAa,EAAE,iBAAiB,EAAE,0BAA0B,EAAE,2CAA2C,EAAE,sBAAsB,EAAE;AAC7I,mBAAmB,kBAAkB,EAAE;AACvC,mBAAmB,iBAAiB,EAAE,gBAAgB,EAAE;AACxD,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAChE;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,gBAAgB;EAChB,cAAc;AAChB;AACA,kBAAkB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AAClE,iBAAiB,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE,cAAc,EAAE;AACnH,iBAAiB,iBAAiB,EAAE,wBAAwB,EAAE,SAAS,EAAE,cAAc,EAAE;;AAEzF,eAAe;AACf,kBAAkB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACrH,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACpE;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;EAC/B,mBAAmB;AACrB;AACA,oBAAoB,iBAAiB,EAAE,cAAc,EAAE;AACvD,oBAAoB,gBAAgB,EAAE,gBAAgB,EAAE,mCAAmC,EAAE,eAAe,EAAE,cAAc,EAAE;AAC9H,oBAAoB,gBAAgB,EAAE,4BAA4B,EAAE,SAAS,EAAE,cAAc,EAAE;AAC/F,uBAAuB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,cAAc,EAAE;AACxF,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;;AAEjH,kBAAkB,+BAA+B,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AAC1F,iBAAiB,aAAa,EAAE,8BAA8B,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,4BAA4B,EAAE,2CAA2C,EAAE;AAClL,oBAAoB,2BAA2B,EAAE;AACjD,iBAAiB,qBAAqB,EAAE,gBAAgB,EAAE;AAC1D,sBAAsB,aAAa,EAAE,yBAAyB,EAAE;AAChE,iBAAiB,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAC1K,oBAAoB,iBAAiB,EAAE,gBAAgB,EAAE,mCAAmC,EAAE;AAC9F;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,8DAA8D;EAC9D,yEAAyE;EACzE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iCAAiC;EACjC,0CAA0C;EAC1C,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,WAAW;AACX,cAAc,mCAAmC,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AAC/G;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA,qBAAqB,iBAAiB,EAAE;;AAExC;EACE,aAAa,WAAW,EAAE,aAAa,EAAE;EACzC,WAAW,kBAAkB,EAAE;EAC/B,kBAAkB,0BAA0B,EAAE;EAC9C,kBAAkB,0BAA0B,EAAE;AAChD;;AAEA;EACE,eAAe,gBAAgB,EAAE,gBAAgB,EAAE,UAAU,EAAE,iBAAiB,EAAE;EAClF,aAAa,gBAAgB,EAAE,gBAAgB,EAAE,WAAW,EAAE,aAAa,EAAE;EAC7E,eAAe,aAAa,EAAE;AAChC;;AAEA;;+DAE+D;AAC/D;EACE,2BAA2B;AAC7B;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA,eAAe,cAAc,EAAE,cAAc,EAAE;;AAE/C,yBAAyB;AACzB,YAAY,aAAa,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AACrE,gBAAgB,cAAc,EAAE,cAAc,EAAE;;AAEhD,+DAA+D;AAC/D,WAAW,iBAAiB,EAAE,cAAc,EAAE,iBAAiB,EAAE;AACjE,cAAc,aAAa,EAAE,kBAAkB,EAAE,4BAA4B,EAAE,iBAAiB,EAAE;;AAElG,WAAW;AACX;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,eAAe,EAAE,mBAAmB,EAAE,mBAAmB;AAC3D;AACA,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AACjE;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,mCAAmC;EACnC,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,cAAc;AAC7E;AACA,cAAc,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACjG,eAAe,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;;AAE5E,qBAAqB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;AAChE;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,uBAAuB,EAAE,+BAA+B;EACxD,+BAA+B,EAAE,0BAA0B;EAC3D,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB;EACxD,eAAe,EAAE,gDAAgD;AACnE;AACA,sBAAsB,2BAA2B,EAAE,mCAAmC,EAAE;AACxF;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,yBAAyB,EAAE,YAAY,EAAE,+BAA+B;EACxE,qCAAqC,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB;EAC/F,eAAe,EAAE,4BAA4B;AAC/C;AACA,uCAAuC,+BAA+B,EAAE;AACxE,2BAA2B,aAAa,EAAE,mBAAmB,EAAE;;AAE/D,iBAAiB;AACjB;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,mBAAmB,EAAE,SAAS,EAAE,eAAe;AACjD;AACA,YAAY,iBAAiB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AAC/E,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;;AAEpE;EACE,aAAa,EAAE,+BAA+B,EAAE,+BAA+B,EAAE,gBAAgB;AACnG;AACA;EACE,uBAAuB,EAAE,YAAY,EAAE,iBAAiB;EACxD,2BAA2B,EAAE,eAAe,EAAE,yCAAyC;EACvF,aAAa,EAAE,mBAAmB;AACpC;AACA,uBAAuB,yBAAyB,EAAE,qCAAqC,EAAE;AACzF,kCAAkC,6BAA6B,EAAE,0BAA0B,EAAE;;AAE7F;EACE,+BAA+B,EAAE,+BAA+B;EAChE,+BAA+B,EAAE,0BAA0B;EAC3D,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,aAAa;AACvE;;AAEA,2BAA2B;AAC3B,WAAW,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE;AACvE;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,cAAc;AACd;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,8BAA8B;EAC9B,gDAAgD;AAClD;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,oBAAoB;AACtB;AACA,oBAAoB,aAAa,EAAE,sBAAsB,EAAE;AAC3D,iBAAiB,2CAA2C,EAAE,qCAAqC,EAAE;AACrG,eAAe,aAAa,EAAE;;AAE9B,UAAU;AACV;EACE,kBAAkB,EAAE,gBAAgB;EACpC,8BAA8B,EAAE,cAAc;AAChD;AACA,6BAA6B,YAAY,EAAE,iBAAiB,EAAE;AAC9D,6BAA6B,aAAa,EAAE;AAC5C;EACE,WAAW,EAAE,YAAY,EAAE,iBAAiB;EAC5C,gCAAgC;AAClC;AACA,uCAAuC,sBAAsB,EAAE;;AAE/D;EACE,kBAAkB,EAAE,SAAS,EAAE,WAAW;EAC1C,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,+BAA+B,EAAE,+BAA+B,EAAE,eAAe;EACjF,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,4BAA4B;EAC5B,2BAA2B;EAC3B,UAAU;AACZ;AACA,uBAAuB,sBAAsB,EAAE;;;AAG/C,SAAS;AACT;EACE,uBAAuB;EACvB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,SAAO;AAC1D;AACA;EACE,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB;EAC3D,iBAAiB,EAAE,+BAA+B,EAAE,sBAAsB;EAC1E,yBAAyB;AAC3B;AACA;EACE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B;EAChE,SAAS,EAAE,gBAAgB;AAC7B;AACA,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAChE,kBAAkB,eAAe,EAAE,cAAc,EAAE;AACnD,kBAAkB,kBAAkB,EAAE,2BAA2B,EAAE,gBAAgB,EAAE;AACrF;EACE,kBAAkB,EAAE,4BAA4B,EAAE,SAAS;EAC3D,iBAAiB,EAAE,oBAAoB;EACvC,qBAAqB,EAAE,4BAA4B,EAAE,gBAAgB;AACvE;;AAEA,iBAAiB;AACjB;EACE,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,eAAe;AAC3D;AACA;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B;EAClE,iBAAiB;EACjB,mBAAmB;AACrB;AACA,mCAAmC,oCAAoC,EAAE;;AAEzE,kBAAkB;AAClB;EACE,uBAAuB;EACvB,aAAa,EAAE,sBAAsB,EAAE,QAAQ;EAC/C,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,iBAAiB,EAAE,mCAAmC;AACxD;;AAEA,iBAAiB,aAAa,EAAE,qBAAqB,EAAE,QAAQ,EAAE;AACjE,iBAAiB,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAClF,iBAAiB,kBAAkB,EAAE,2BAA2B,EAAE,6BAA6B,EAAE;;AAEjG;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,iBAAiB,EAAE,gBAAgB;AACrC;AACA,gBAAgB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,cAAc,EAAE;AAC7E,gBAAgB,qBAAqB,EAAE;AACvC,gBAAgB,oBAAoB,EAAE;;AAEtC;EACE,WAAW,EAAE,yBAAyB,EAAE,YAAY,EAAE,+BAA+B;EACrF,qCAAqC,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB;EAC/F,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ;EACtF,4BAA4B;AAC9B;AACA,wCAAwC,+BAA+B,EAAE;AACzE,4BAA4B,YAAY,EAAE,mBAAmB,EAAE;;AAE/D;EACE,WAAW,EAAE,uBAAuB;EACpC,+BAA+B,EAAE,+BAA+B;EAChE,0BAA0B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,iBAAiB;EACnF,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ;EACtF,gDAAgD;AAClD;AACA,yCAAyC,2BAA2B,EAAE,mCAAmC,EAAE;AAC3G,6BAA6B,YAAY,EAAE,mBAAmB,EAAE;;AAEhE;EACE,gBAAgB,EAAE,YAAY,EAAE,oBAAoB;EACpD,iBAAiB,EAAE,gBAAgB,EAAE,eAAe,EAAE,cAAc;EACpE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,yBAAyB;EACvE,sBAAsB;AACxB;AACA,uBAAuB,aAAa,EAAE;;AAEtC,yBAAyB;AACzB;EACE,aAAa,EAAE,qCAAqC;EACpD,MAAM,EAAE,gBAAgB;EACxB,+BAA+B,EAAE,+BAA+B;EAChE,+BAA+B,EAAE,gBAAgB;EACjD,8BAA8B;AAChC;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,mBAAmB;EACvD,kBAAkB;EAClB,qCAAqC;AACvC;AACA,8BAA8B,kBAAkB,EAAE;AAClD;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,cAAc;EAC7D,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;AAC7D;AACA,oBAAoB,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACtG,oBAAoB,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE,iBAAiB,EAAE;;AAEpG,gBAAgB;AAChB,YAAY,kBAAkB,EAAE,kBAAkB,EAAE,4BAA4B,EAAE;AAClF;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,6BAA6B,EAAE,+BAA+B;EAC9D,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,mBAAmB;AAClF;AACA,eAAe,iBAAiB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AAC/E,eAAe,kBAAkB,EAAE,SAAS,EAAE;;AAE9C,eAAe;AACf;EACE,oBAAoB,gCAAgC,EAAE;EACtD,oBAAoB,mBAAmB,EAAE,iBAAiB,EAAE,mCAAmC,EAAE;AACnG;AACA;EACE,oBAAoB,0BAA0B,EAAE;EAChD,6BAA6B,aAAa,EAAE;EAC5C,eAAe,0BAA0B,EAAE;EAC3C,mBAAmB,kBAAkB,EAAE,sCAAsC,EAAE;EAC/E,8BAA8B,mBAAmB,EAAE;AACrD;;AAEA,mEAAmE;AACnE;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,+BAA+B;EAC/B,iCAAiC;EACjC,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA,wBAAwB,YAAY,EAAE;;AAEtC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;;wDAEsD;EACtD,kBAAkB,sBAAsB,EAAE,uBAAuB,EAAE,QAAQ,EAAE;EAC7E,mBAAmB,iBAAiB,EAAE;AACxC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;AACxC;AACA,6BAA6B,mBAAmB,EAAE;;AAElD,iBAAiB,gBAAgB,EAAE,0BAA0B,EAAE;AAC/D,mBAAmB,4BAA4B,EAAE;AACjD,oBAAoB,gBAAgB,EAAE,iBAAiB,EAAE,0BAA0B,EAAE;;AAErF;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA,yBAAyB,mCAAmC,EAAE,qBAAqB,EAAE;AACrF,yBAAyB,iCAAiC,EAAE,oBAAoB,EAAE;AAClF;yBACyB,kCAAkC,EAAE,2BAA2B,EAAE;AAC1F,yBAAyB,8DAA8D,EAAE,oBAAoB,EAAE;AAC/G;wBACwB,8BAA8B,EAAE,4BAA4B,EAAE;;AAEtF;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qCAAqC;EACrC,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA,2BAA2B,+BAA+B,EAAE;;AAE5D;EACE,mBAAmB,qCAAqC,EAAE;EAC1D,kBAAkB,oCAAoC,EAAE;EACxD,mBAAmB,aAAa,EAAE;AACpC;;AAEA,mEAAmE;AACnE;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA,mEAAmE;AACnE;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,+BAA+B;EAC/B,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;AACA,0BAA0B,iCAAiC,EAAE;AAC7D,6BAA6B,+DAA+D,EAAE;AAC9F,0BAA0B,kCAAkC,EAAE;AAC9D,wBAAwB,wEAAwE,EAAE;AAClG;;uCAEuC;AACvC,mBAAmB,gBAAgB,EAAE,0BAA0B,EAAE,kBAAkB,EAAE;AACrF,mBAAmB,4BAA4B,EAAE,kBAAkB,EAAE,eAAe,EAAE;;AAEtF,iFAAiF;AACjF;;;;EAIE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;AACA,mBAAmB,YAAY,EAAE;AACjC,mBAAmB,6BAA6B,EAAE;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,6BAA6B;AAC/B;AACA,kBAAkB,iBAAiB,EAAE,gBAAgB,EAAE,+BAA+B,EAAE;AACxF,kBAAkB,gBAAgB,EAAE,+BAA+B,EAAE,eAAe,EAAE,kBAAkB,EAAE;AAC1G,kBAAkB,iCAAiC,EAAE,gBAAgB,EAAE,SAAS,EAAE;;AAElF;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,QAAQ;EACR,WAAW;EACX,UAAU;EACV,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;AACA,qBAAqB,YAAY,EAAE;AACnC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;AACA,sBAAsB,gCAAgC,EAAE,6BAA6B,EAAE;AACvF,iBAAiB,gBAAgB,EAAE,+BAA+B,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAC5G,eAAe,iCAAiC,EAAE,SAAS,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACnG;EACE,UAAU;EACV;;2CAEyC;EACzC,kCAAkC;EAClC,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;AACV;AACA,qBAAqB,wCAAwC,EAAE;;AAE/D,gEAAgE;AAChE,oBAAoB,aAAa,EAAE;AACnC,mBAAmB,aAAa,EAAE,uBAAuB,EAAE,QAAQ,EAAE,YAAY,EAAE;AACnF;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA,gCAAgC,iCAAiC,GAAG,6BAA6B,EAAE;AACnG,mCAAmC,+DAA+D,IAAI,qBAAqB,EAAE;AAC7H,8BAA8B,gCAAgC,EAAE,6BAA6B,EAAE;AAC/F,yBAAyB,gBAAgB,EAAE,+BAA+B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAClH,yBAAyB,iCAAiC,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAElH;EACE,aAAa;EACb,QAAQ;EACR,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAO;EACP,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,iCAAiC;EACjC,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,wCAAwC;EACxC,iCAAiC;EACjC,+BAA+B;EAC/B,kBAAkB;AACpB;AACA,wCAAwC,iCAAiC,EAAE;AAC3E,iCAAiC,aAAa,EAAE,qCAAqC,EAAE;AACvF;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,+BAA+B;EAC/B,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,2BAA2B,sCAAsC,EAAE;;AAEnE,iBAAiB;AACjB;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;AACA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,iCAAiC;EACjC,mCAAmC;EACnC,eAAe;AACjB;AACA,iBAAiB,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC3G;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ;;2DAEyD;EACzD,qBAAqB;EACrB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,wCAAwC;AAC1C;AACA,gBAAgB,UAAU,EAAE,2BAA2B,EAAE,0CAA0C,EAAE;AACrG,kBAAkB,+BAA+B,EAAE;AACnD,sBAAsB,UAAU,EAAE,wBAAwB,EAAE;AAC5D,0BAA0B,yCAAyC,EAAE,mBAAmB,EAAE;;AAE1F,eAAe;AACf;EACE,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,sCAAsC;EACtC,4CAA4C;EAC5C,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,kBAAkB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;AAC7D;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,sBAAsB,mBAAmB,EAAE;AAC3C,sBAAsB,8DAA8D,EAAE;AACtF,sBAAsB,gBAAgB,EAAE;AACxC;kFACkF;AAClF,sBAAsB,gBAAgB,EAAE;AACxC,sBAAsB,mBAAmB,EAAE;AAC3C,sBAAsB,mBAAmB,EAAE,kBAAkB,EAAE;;AAE/D,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,sCAAsC;EACtC,4CAA4C;EAC5C,mCAAmC;EACnC,qCAAqC;EACrC,kBAAkB;AACpB;AACA,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;AACnF;EACE,gBAAgB;EAChB,YAAY;EACZ,wDAAwD;EACxD,qBAAqB;EACrB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf;;8DAE4D;EAC5D,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA,yBAAyB,+BAA+B,EAAE;AAC1D,kBAAkB,qCAAqC,EAAE,iBAAiB,EAAE;;AAE5E;EACE,iBAAiB,qCAAqC,EAAE;EACxD,eAAe,0BAA0B,EAAE;EAC3C,yBAAyB,aAAa,EAAE;EACxC,iBAAiB,qCAAqC,EAAE;EACxD,gBAAgB,0BAA0B,EAAE;AAC9C;AACA;EACE,iBAAiB,0BAA0B,EAAE,uBAAuB,EAAE;EACtE,iBAAiB,qCAAqC,EAAE,uBAAuB,EAAE;EACjF,eAAe,uBAAuB,EAAE,mBAAmB,EAAE;EAC7D,gBAAgB,uBAAuB,EAAE;EACzC,kBAAkB,sBAAsB,EAAE,uBAAuB,EAAE,gBAAgB,EAAE;;EAErF,wFAAwF;EACxF;IACE,sBAAsB;IACtB,oBAAoB;IACpB,uBAAuB;IACvB,mCAAmC;IACnC,uCAAuC;IACvC,+BAA+B;EACjC;EACA,yBAAyB,aAAa,EAAE;EACxC;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;EACnB;EACA,iBAAiB,kBAAkB,EAAE;EACrC,eAAe,kBAAkB,EAAE;EACnC;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,2BAA2B;IAC3B,4CAA4C;EAC9C;EACA,mBAAmB,sBAAsB,EAAE,QAAQ,EAAE;EACrD,eAAe,sBAAsB,EAAE,WAAW,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC5F;;AAEA;;qEAEqE;AACrE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,WAAW;AACX,mBAAmB,kBAAkB,EAAE;AACvC,cAAc,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,eAAe,EAAE;AACjF,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAClE;EACE,SAAO;EACP,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA,sCAAsC,wBAAwB,kCAAkC,EAAE,EAAE;AACpG,kDAAkD,kCAAkC,EAAE;AACtF,kDAAkD,8BAA8B,EAAE;AAClF,kBAAkB,YAAY,EAAE,kBAAkB,EAAE,2BAA2B,EAAE,aAAa,EAAE;AAChG,oBAAoB,kBAAkB,EAAE,WAAW,EAAE,eAAe,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,mBAAmB,EAAE;AACvI,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,qBAAqB,EAAE,YAAY,EAAE,cAAc,EAAE;AAC/G,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACzE,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACnF,oBAAoB,eAAe,EAAE,wBAAwB,EAAE;;AAE/D,YAAY;AACZ;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA,6BAA6B,eAAe,qCAAqC,EAAE,EAAE;AACrF,6BAA6B,eAAe,qCAAqC,EAAE,EAAE;AACrF;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,uCAAuC;EACvC,YAAY;AACd;AACA;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,eAAe;AACjB;AACA,iBAAiB,kBAAkB,EAAE,eAAe,EAAE,iBAAiB,EAAE,wBAAwB,EAAE,gBAAgB,EAAE,SAAS,EAAE;AAChI,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,SAAS,EAAE,mBAAmB,EAAE;AAClI,iBAAiB,eAAe,EAAE,eAAe,EAAE,wBAAwB,EAAE,eAAe,EAAE;;AAE9F;;;;yDAIyD;AACzD,mBAAmB,aAAa,EAAE;;AAElC;;;;;gDAKgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8DAA8D;EAC9D,sCAAsC;EACtC,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,OAAO,2CAA2C,EAAE;EACpD,OAAO,0CAA0C,EAAE;EACnD,OAAO,wCAAwC,EAAE;AACnD;;AAEA;EACE,wBAAwB,eAAe,EAAE;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;AACA,8BAA8B,eAAe,EAAE,0BAA0B,EAAE;AAC3E;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,4BAA4B,wBAAwB,EAAE;;AAEtD;EACE,gBAAgB;EAChB,sCAAsC;EACtC,0BAA0B;EAC1B,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA,gCAAgC,0BAA0B,EAAE;;AAE5D;;;EAGE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,eAAe,EAAE;EAC1C,uBAAuB,gBAAgB,EAAE;EACzC,0BAA0B,iBAAiB,EAAE;AAC/C;;AAEA,yCAAyC;AACzC;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;AACf;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,SAAS,EAAE;AAChG,sBAAsB,eAAe,EAAE,wBAAwB,EAAE;;AAEjE,qDAAqD;AACrD;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA,uBAAuB,cAAc,EAAE,YAAY,EAAE;;AAErD,oBAAoB,aAAa,EAAE,QAAQ,EAAE;AAC7C;EACE,aAAa;EACb,mHAAmH;EACnH,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA,oBAAoB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE;AACjE,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AACjF,qBAAqB,gBAAgB,EAAE,0BAA0B,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AACnI,qBAAqB,gBAAgB,EAAE,0BAA0B,EAAE,kCAAkC,EAAE;AACvG,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,kCAAkC,EAAE,mBAAmB,EAAE;AAC7I,qBAAqB,wBAAwB,EAAE,kCAAkC,EAAE,mBAAmB,EAAE;;AAExG;+DAC+D;AAC/D,qBAAqB,gBAAgB,EAAE,kCAAkC,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;AACnH,6BAA6B,kCAAkC,EAAE;AACjE,6BAA6B,2BAA2B,EAAE;AAC1D;+EAC+E;AAC/E,6BAA6B,kCAAkC,EAAE,gBAAgB,EAAE;AACnF,6BAA6B,wBAAwB,EAAE;;AAEvD;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;uDACuD;AACvD;EACE;IACE,wCAAwC;IACxC,YAAY;EACd;EACA,qBAAqB,cAAc,EAAE,iBAAiB,EAAE;EACxD,qBAAqB,kBAAkB,EAAE;EACzC,qBAAqB,kBAAkB,EAAE;EACzC,qBAAqB,kBAAkB,EAAE,gBAAgB,EAAE;AAC7D;;AAEA,eAAe;AACf;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA,4BAA4B,iBAAiB,qCAAqC,EAAE,EAAE;AACtF;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,OAAO,EAAE,QAAQ,EAAE,SAAS;EAC5B,WAAW,EAAE,YAAY;EACzB,UAAU;AACZ;AACA;EACE,WAAW,EAAE,YAAY,EAAE,mBAAmB;EAC9C,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,eAAe,EAAE,kBAAkB;EACnC,kBAAkB,EAAE,UAAU;AAChC;AACA,kBAAkB,eAAe,EAAE,wBAAwB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,UAAU,EAAE;AAC/G,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,UAAU,EAAE;AACvG,kBAAkB,eAAe,EAAE,wBAAwB,EAAE,eAAe,EAAE,kBAAkB,EAAE,UAAU,EAAE;;AAE9G,eAAe;AACf;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,kBAAkB;AACpB;AACA,6BAA6B,kBAAkB,8BAA8B,EAAE,EAAE;AACjF,6BAA6B,kBAAkB,0BAA0B,EAAE,EAAE;AAC7E,mBAAmB,kBAAkB,EAAE;AACvC,mBAAmB,kBAAkB,EAAE;AACvC,mBAAmB,kBAAkB,EAAE,aAAa,EAAE,sBAAsB,EAAE,MAAM,EAAE;AACtF;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,cAAc,EAAE,sCAAsC;AACxD;AACA,6BAA6B,mBAAmB,EAAE;AAClD;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,eAAe,EAAE,cAAc;AACjC;AACA,mBAAmB,SAAO,EAAE,YAAY,EAAE;AAC1C,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACnF,oBAAoB,eAAe,EAAE,wBAAwB,EAAE;AAC/D,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAEvE,iBAAiB;AACjB;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,oBAAoB;AACtB;AACA,4BAA4B,oBAAoB,0BAA0B,EAAE,EAAE;AAC9E,sBAAsB,kBAAkB,EAAE;AAC1C;wCACwC,iBAAiB,EAAE,kBAAkB,EAAE;AAC/E,oCAAoC,mBAAmB,EAAE;AACzD,mCAAmC,kBAAkB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE;;AAEnG;EACE,SAAO;EACP,aAAa;EACb,gEAAgE;EAChE,mBAAmB;EACnB,SAAS;AACX;AACA,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,YAAY,EAAE;AAC/F,sBAAsB,YAAY,EAAE;AACpC;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;AACA,gCAAgC,gBAAgB,EAAE;AAClD,kBAAkB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACjE,2BAA2B,YAAY,EAAE,4BAA4B,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;AAC/G,kBAAkB,gBAAgB,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACpG,2BAA2B,0BAA0B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAE7F,sBAAsB,kBAAkB,EAAE;AAC1C;EACE,2BAA2B;EAC3B,oEAAoE;EACpE,6EAA6E;EAC7E,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAEjE,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,eAAe,EAAE;AAC1E;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,kBAAkB,EAAE,sCAAsC;EAC1D,eAAe,EAAE,wBAAwB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,sBAAsB;AAChH;AACA,oBAAoB,WAAW,EAAE,cAAc,EAAE;AACjD;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,cAAc;AAChB;AACA,iBAAiB,WAAW,EAAE,eAAe,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,cAAc,EAAE;AAC3G,iBAAiB,SAAO,EAAE,eAAe,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACvI,iBAAiB,WAAW,EAAE,iBAAiB,EAAE,eAAe,EAAE,4BAA4B,EAAE;AAChG,iBAAiB,WAAW,EAAE,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;;AAEhH;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;AACA,gBAAgB,YAAY,EAAE;AAC9B,gBAAgB,SAAS,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC5J,eAAe,eAAe,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;AAC9E;EACE,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,2BAA2B;EAC3B,qEAAqE;EACrE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA,wBAAwB,oEAAoE,EAAE;;AAE9F;EACE,qBAAqB,+CAA+C,EAAE,SAAS,EAAE;EACjF,oBAAoB,sBAAsB,EAAE,aAAa,EAAE;AAC7D;AACA;EACE;0CACwC,aAAa,EAAE,aAAa,EAAE;EACtE,qBAAqB,0BAA0B,EAAE;EACjD,oBAAoB,eAAe,EAAE,cAAc,EAAE;EACrD,2BAA2B,mBAAmB,EAAE;AAClD;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,oBAAoB;AACtB;AACA,6BAA6B,aAAa,8BAA8B,EAAE,EAAE;AAC5E,6BAA6B,aAAa,0BAA0B,EAAE,EAAE;AACxE,kBAAkB,kBAAkB,EAAE;AACtC,kBAAkB,kBAAkB,EAAE;;AAEtC;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,cAAc;AAChB;;AAEA,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,eAAe,EAAE;AAC1E;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,kBAAkB,EAAE,sCAAsC;EAC1D,eAAe,EAAE,wBAAwB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,sBAAsB;AAChH;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA,6BAA6B,eAAe,qCAAqC,EAAE,EAAE;AACrF,6BAA6B,eAAe,qCAAqC,EAAE,EAAE;AACrF;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA,eAAe,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC7D;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,eAAe,EAAE,cAAc;AACjC;AACA,iBAAiB,eAAe,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;AAClF,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACjG,iBAAiB,eAAe,EAAE,wBAAwB,EAAE,SAAS,EAAE;AACvE,sBAAsB,6BAA6B,EAAE,gBAAgB,EAAE;AACvE,sBAAsB,2BAA2B,EAAE,gBAAgB,EAAE;;AAErE,yEAAyE;AACzE;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,oBAAoB;AACtB;AACA,6BAA6B,aAAa,8BAA8B,EAAE,EAAE;AAC5E,6BAA6B,aAAa,0BAA0B,EAAE,EAAE;;AAExE,mCAAmC;AACnC,sBAAsB,kBAAkB,EAAE;AAC1C,cAAc,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,eAAe,EAAE;AACjF,cAAc,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC5D,mBAAmB,WAAW,EAAE,cAAc,EAAE,aAAa,EAAE,sBAAsB,EAAE;AACvF,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAClJ,mBAAmB,eAAe,EAAE,wBAAwB,EAAE;AAC9D;EACE,SAAO,EAAE,YAAY,EAAE,kBAAkB,EAAE,gBAAgB;EAC3D,kCAAkC;AACpC;AACA,yCAAyC,8BAA8B,EAAE;AACzE,eAAe,YAAY,EAAE,kBAAkB,EAAE,2BAA2B,EAAE,aAAa,EAAE;AAC7F,eAAe,WAAW,EAAE,cAAc,EAAE,iBAAiB,EAAE,aAAa,EAAE,sBAAsB,EAAE;AACtG,eAAe,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACpE,eAAe,eAAe,EAAE,wBAAwB,EAAE;;AAE1D;;uEAEuE;;AAEvE,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,eAAe,EAAE,SAAS,EAAE;AACtH,2BAA2B,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE;;AAE3F;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,iBAAiB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,gBAAgB;EAC5E,eAAe,EAAE,qBAAqB,EAAE,mBAAmB;AAC7D;AACA;EACE,+BAA+B,EAAE,0BAA0B,EAAE,+BAA+B;AAC9F;AACA,4BAA4B,yBAAyB,EAAE;AACvD;EACE,yBAAyB,EAAE,qCAAqC,EAAE,+BAA+B;AACnG;AACA,8BAA8B,wBAAwB,EAAE;;AAExD;;;4EAG4E;AAC5E,gCAAgC,MAAM,EAAE;AACxC;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS;EAC7E,WAAW,EAAE,gBAAgB,EAAE,YAAY,EAAE,UAAU,EAAE,SAAS;EAClE,eAAe,EAAE,gBAAgB,EAAE,4BAA4B;AACjE;AACA,wDAAwD,SAAS,EAAE;AACnE,+DAA+D,gBAAgB,EAAE;AACjF;EACE,kBAAkB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,sBAAsB;EACvF,2BAA2B,EAAE,8BAA8B;EAC3D,+BAA+B,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB;AAC1F;;AAEA,oFAAoF;AACpF;EACE,aAAa,EAAE,mBAAmB;EAClC,+BAA+B,EAAE,kBAAkB,EAAE,gBAAgB;EACrE,6BAA6B,EAAE,8BAA8B;AAC/D;AACA,mCAAmC,2BAA2B,EAAE;AAChE;EACE,eAAe,EAAE,YAAY,EAAE,aAAa,EAAE,mBAAmB;EACjE,kBAAkB,EAAE,4BAA4B;EAChD,8BAA8B,EAAE,qCAAqC;EACrE,cAAc;AAChB;AACA,uBAAuB,uBAAuB,EAAE,2BAA2B,EAAE,kCAAkC,EAAE,SAAO,EAAE;;AAE1H,cAAc;AACd;EACE,aAAa,EAAE,uBAAuB;EACtC,+BAA+B,EAAE,kBAAkB,EAAE,gBAAgB;EACrE,6BAA6B,EAAE,8BAA8B;AAC/D;AACA,kCAAkC,2BAA2B,EAAE;AAC/D,2CAA2C,mBAAmB,EAAE,YAAY,EAAE;AAC9E;EACE,SAAO,EAAE,aAAa,EAAE,eAAe,EAAE,mBAAmB,EAAE,QAAQ;EACtE,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB;AAC7D;AACA;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,8DAA8D;EAC9D,oBAAoB,EAAE,kBAAkB,EAAE,gBAAgB;EAC1D,yBAAyB,EAAE,mBAAmB,EAAE,mBAAmB;AACrE;AACA;EACE,gBAAgB,EAAE,YAAY,EAAE,cAAc,EAAE,eAAe;EAC/D,iBAAiB,EAAE,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,YAAY;AACnF;AACA,kCAAkC,UAAU,EAAE;AAC9C;EACE,SAAO,EAAE,eAAe,EAAE,YAAY,EAAE,aAAa,EAAE,uBAAuB;EAC9E,0BAA0B,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,cAAc;AACrF;AACA,iBAAiB,kBAAkB,EAAE,2BAA2B,EAAE,eAAe,EAAE;;AAEnF,4DAA4D;AAC5D,sBAAsB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AAC3F;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,+BAA+B,EAAE,kBAAkB,EAAE,iBAAiB;EACtE,6BAA6B;AAC/B;AACA,uBAAuB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,WAAW,EAAE,cAAc,EAAE;AACtH,6BAA6B,SAAO,EAAE,4BAA4B,EAAE,6BAA6B,EAAE;AACnG;EACE,gBAAgB,EAAE,YAAY,EAAE,2BAA2B,EAAE,eAAe;EAC5E,kBAAkB,EAAE,YAAY,EAAE,cAAc;AAClD;AACA,8BAA8B,2BAA2B,EAAE;;AAE3D;2EAC2E;AAC3E,uBAAuB,UAAU,EAAE,aAAa,EAAE,kBAAkB,EAAE;;AAEtE,kCAAkC;AAClC;EACE,gCAAgC,EAAE,kBAAkB;EACpD,aAAa,EAAE,kBAAkB;EACjC,2BAA2B,EAAE,kBAAkB;AACjD;AACA;;;;4CAI4C;AAC5C,2BAA2B,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AAC9F;EACE,aAAa,EAAE,4DAA4D;EAC3E,QAAQ,EAAE,eAAe;EACzB,iBAAiB,EAAE,gBAAgB,EAAE,2BAA2B;EAChE,yBAAyB,EAAE,sBAAsB;EACjD,gBAAgB;AAClB;AACA;EACE,aAAa,EAAE,4DAA4D;EAC3E,QAAQ,EAAE,mBAAmB;EAC7B,+BAA+B,EAAE,kBAAkB,EAAE,iBAAiB;EACtE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA,gCAAgC,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAClG,gCAAgC,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC9E,yBAAyB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,+BAA+B,EAAE,cAAc,EAAE;AACzH,2BAA2B,eAAe,EAAE,eAAe,EAAE,kBAAkB,EAAE,2BAA2B,EAAE;AAC9G;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,kBAAkB;AACpB;AACA;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,iBAAiB;EAChE,8BAA8B,EAAE,+BAA+B;EAC/D,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,2BAA2B,EAAE,cAAc;AAC7C;AACA;EACE,kBAAkB,EAAE,gBAAgB,EAAE,oBAAoB;EAC1D,eAAe,EAAE,mBAAmB;AACtC;AACA,kCAAkC,0BAA0B,EAAE;AAC9D;EACE,0BAA0B,aAAa,EAAE;EACzC,yBAAyB,8BAA8B,EAAE,YAAY,EAAE;EACvE,+DAA+D,WAAW,EAAE;AAC9E;;AAEA,6DAA6D;AAC7D;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,+BAA+B,EAAE,kBAAkB;EACnD,eAAe,EAAE,YAAY,EAAE,sBAAsB;EACrD,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B;EAChE,6BAA6B,EAAE,WAAW;AAC5C;AACA,sBAAsB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,cAAc,EAAE;;AAEnF,0EAA0E;AAC1E,uBAAuB,oBAAoB,EAAE;AAC7C;EACE,WAAW,EAAE,aAAa,EAAE,cAAc;EAC1C,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,uBAAuB;EACnF,YAAY,EAAE,mBAAmB;EACjC,sBAAsB;AACxB;AACA,+CAA+C,iBAAiB,EAAE,kBAAkB,EAAE;AACtF,+BAA+B,kBAAkB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,SAAS,EAAE,kBAAkB,EAAE;;AAE1H,6EAA6E;AAC7E,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,gBAAgB,EAAE,SAAS,EAAE;AACnG,wCAAwC,gBAAgB,EAAE;;AAE1D;EACE,kBAAkB,EAAE,SAAS,EAAE,WAAW,EAAE,UAAU;EACtD,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,6BAA6B,EAAE,+BAA+B;EAC9D,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,kBAAkB,EAAE,4BAA4B;AAClD;;AAEA;EACE,gBAAgB,EAAE,WAAW,EAAE,aAAa,EAAE,YAAY,EAAE,mBAAmB;EAC/E,yBAAyB,EAAE,qCAAqC,EAAE,kBAAkB,EAAE,gBAAgB;EACtG,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ;AACxF;;AAEA;EACE,6BAA6B,EAAE,+BAA+B;EAC9D,mBAAmB,EAAE,aAAa;AACpC;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,eAAe,EAAE,sCAAsC;EACvD,kBAAkB,EAAE,4BAA4B;AAClD;AACA,mCAAmC,mBAAmB,EAAE;AACxD;EACE,+BAA+B,EAAE,kBAAkB,EAAE,+BAA+B;EACpF,0BAA0B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,eAAe;AACtG;;AAEA,wBAAwB,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAE7G,kBAAkB;AAClB,mBAAmB,kBAAkB,EAAE,qBAAqB,EAAE,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;AACzG,yBAAyB,kBAAkB,EAAE,UAAU,EAAE,QAAQ,EAAE,SAAS,EAAE;AAC9E;EACE,kBAAkB,EAAE,QAAQ,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,4BAA4B;AAC5G;AACA;EACE,kBAAkB,EAAE,QAAQ,EAAE,SAAS,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EACtF,oCAAoC,EAAE,2BAA2B,EAAE,yCAAyC;AAC9G;AACA,0DAA0D,yBAAyB,EAAE;AACrF,gFAAgF,2BAA2B,EAAE;;AAE7G;;;;;;;uEAOuE;AACvE;EACE,oCAAoC;EACpC,+CAA+C;EAC/C,8CAA8C;EAC9C,yCAAyC;EACzC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;EAC3B,iCAAiC;EACjC,oCAAoC;EACpC,iCAAiC;EACjC,2CAA2C;EAC3C,qCAAqC;EACrC,+CAA+C;EAC/C,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,+EAA+E;AACjF;AACA;;6CAE6C;AAC7C;EACE,oCAAoC;EACpC,yCAAyC;EACzC,wCAAwC;EACxC,sCAAsC;EACtC,sCAAsC;EACtC,gCAAgC;EAChC,yBAAyB;EACzB,+BAA+B;EAC/B,6BAA6B;EAC7B,mCAAmC;EACnC,iCAAiC;EACjC,oCAAoC;EACpC,iCAAiC;EACjC,uCAAuC;EACvC,qCAAqC;EACrC,4CAA4C;EAC5C,iDAAiD;AACnD;;AAEA;EACE,SAAS,EAAE,wBAAwB,EAAE,eAAe,EAAE,gBAAgB,EAAE,gBAAgB;AAC1F;;AAEA,kBAAkB;AAClB;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,SAAS,EAAE,gBAAgB;AACrG;AACA,2CAA2C,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AAC3F,+CAA+C,WAAW,EAAE,YAAY,EAAE;AAC1E,0CAA0C,eAAe,EAAE,sBAAsB,EAAE,SAAS,EAAE,gBAAgB,EAAE;;AAEhH,oBAAoB;AACpB,oCAAoC,QAAQ,EAAE,YAAY,EAAE;AAC5D,oCAAoC,eAAe,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AACjH,kCAAkC,uBAAuB,EAAE,gBAAgB,EAAE;AAC7E,yCAAyC,sBAAsB,EAAE;AACjE,mCAAmC,sBAAsB,EAAE,eAAe,EAAE;;AAE5E,uCAAuC;AACvC;;EAEE,qCAAqC;EACrC,qCAAqC;EACrC,8BAA8B;EAC9B,wBAAwB;EACxB,eAAe;EACf,8CAA8C;EAC9C,eAAe;EACf,uFAAuF;AACzF;AACA;6CAC6C,oCAAoC,EAAE;AACnF;;EAEE,+BAA+B;EAC/B,+BAA+B;EAC/B,0CAA0C;AAC5C;AACA,uCAAuC,gBAAgB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAE/F;6EAC6E;AAC7E;EACE,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,QAAQ;EACR,mBAAmB;AACrB;AACA,sDAAsD,eAAe,EAAE;AACvE,yDAAyD,QAAQ,EAAE;AACnE;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,2CAA2C;EAC3C,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA,2DAA2D,WAAW,EAAE,YAAY,EAAE;AACtF,gDAAgD,QAAQ,EAAE;AAC1D,gDAAgD,eAAe,EAAE;AACjE;;;sDAGsD,eAAe,EAAE;AACvE,sDAAsD,WAAW,EAAE,gBAAgB,EAAE;AACrF;gDACgD,SAAS,EAAE;AAC3D;iFACiF,gBAAgB,EAAE;AACnG,mDAAmD,gBAAgB,EAAE,iBAAiB,EAAE;AACxF;;oDAEoD,aAAa,EAAE;AACnE,kDAAkD,SAAS,EAAE;AAC7D,wDAAwD,aAAa,EAAE;AACvE,8DAA8D,gBAAgB,EAAE,iBAAiB,EAAE;AACnG,oFAAoF,kBAAkB,EAAE;;AAExG;EACE,2DAA2D,0BAA0B,EAAE;AACzF;;AAEA,yFAAyF;AACzF;;EAEE,qCAAqC;EACrC,qCAAqC;EACrC,8BAA8B;EAC9B,kCAAkC;EAClC,uFAAuF;AACzF;AACA;6CAC6C,oCAAoC,EAAE;AACnF;;EAEE,+BAA+B;EAC/B,+BAA+B;EAC/B,0CAA0C;AAC5C;AACA;EACE,WAAW,EAAE,cAAc,EAAE,uBAAuB;EACpD,sBAAsB;EACtB,uBAAuB;EACvB,yCAAyC;AAC3C;AACA;;wCAEwC,eAAe,EAAE,wBAAwB,EAAE;AACnF,yCAAyC,eAAe,EAAE;AAC1D,wCAAwC,8CAA8C,EAAE,iBAAiB,EAAE;;AAE3G,sDAAsD;AACtD,kDAAkD,oBAAoB,EAAE,iBAAiB,EAAE;AAC3F,wEAAwE,uBAAuB,EAAE,iBAAiB,EAAE,YAAY,EAAE;AAClI,qEAAqE,YAAY,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,gBAAgB,EAAE;;AAEhJ,wCAAwC;AACxC;EACE,qCAAqC;EACrC,qCAAqC;EACrC,8BAA8B;EAC9B,kCAAkC;EAClC,uFAAuF;AACzF;AACA,+CAA+C,oCAAoC,EAAE;AACrF;EACE,+BAA+B,EAAE,+BAA+B,EAAE,0CAA0C;AAC9G;AACA;EACE,WAAW,EAAE,cAAc,EAAE,uBAAuB;EACpD,qBAAqB,EAAE,eAAe,EAAE,gBAAgB;EACxD,uBAAuB,EAAE,yCAAyC,EAAE,mBAAmB;AACzF;AACA,0CAA0C,eAAe,EAAE,wBAAwB,EAAE,eAAe,EAAE;;AAEtG,qBAAqB;AACrB;EACE,sBAAsB;EACtB,aAAa,EAAE,kDAAkD;EACjE,mBAAmB,EAAE,WAAW;EAChC,qCAAqC,EAAE,qCAAqC;EAC5E,8BAA8B,EAAE,kCAAkC;AACpE;AACA,oDAAoD,+BAA+B,EAAE,0CAA0C,EAAE;AACjI;EACE,WAAW,EAAE,YAAY,EAAE,8BAA8B,EAAE,wBAAwB;EACnF,eAAe,EAAE,gBAAgB;AACnC;AACA,kDAAkD,yCAAyC,EAAE;AAC7F,iDAAiD,wCAAwC,EAAE;AAC3F,4CAA4C,wBAAwB,EAAE,kCAAkC,EAAE;AAC1G,wCAAwC,WAAW,EAAE,eAAe,EAAE,wBAAwB,EAAE,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;;AAEvJ,sBAAsB;AACtB;EACE,qCAAqC,EAAE,qCAAqC;EAC5E,8BAA8B,EAAE,kCAAkC,EAAE,YAAY,EAAE,eAAe;EACjG,wBAAwB,EAAE,eAAe,EAAE,gBAAgB,EAAE,WAAW;AAC1E;AACA,wCAAwC,WAAW,EAAE,YAAY,EAAE,6BAA6B,EAAE,2CAA2C,EAAE;;AAE/I;yDACyD;AACzD;EACE,oCAAoC;EACpC,mBAAmB;EACnB,8BAA8B;EAC9B,6GAA6G;AAC/G;AACA;;EAEE,kCAAkC,EAAE,oCAAoC,EAAE,0CAA0C;AACtH;AACA,2CAA2C,uBAAuB,EAAE;AACpE;EACE,sBAAsB;EACtB,WAAW,EAAE,iBAAiB,EAAE,aAAa;EAC7C,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ;AAC/F;AACA,8DAA8D,wBAAwB,EAAE,iBAAiB,EAAE,SAAS,EAAE;AACtH,sEAAsE,wBAAwB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACnI,8DAA8D,sBAAsB,EAAE,eAAe,EAAE,eAAe,EAAE;AACxH,sCAAsC,eAAe,EAAE;;AAEvD;uEACuE;AACvE;EACE,kBAAkB,EAAE,gBAAgB,EAAE,uBAAuB;EAC7D,gFAAgF;AAClF;AACA;EACE,+BAA+B;EAC/B,oEAAoE;EACpE,2BAA2B;AAC7B;AACA,wEAAwE,aAAa,EAAE,aAAa,EAAE;AACtG;EACE,eAAe,EAAE,iCAAiC,EAAE,+BAA+B;AACrF;AACA,yEAAyE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACzH,0EAA0E,eAAe,EAAE;AAC3F,6CAA6C,cAAc,EAAE;AAC7D,4CAA4C,cAAc,EAAE,sBAAsB,EAAE,aAAa,EAAE;AACnG;EACE,sBAAsB,EAAE,8BAA8B,EAAE,+BAA+B;EACvF,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,mBAAmB;AACjG;;AAEA;6EAC6E;AAC7E,0CAA0C,6BAA6B,EAAE,+BAA+B,EAAE;AAC1G;iDACiD,YAAY,EAAE,mBAAmB,EAAE;;AAEpF,gFAAgF;AAChF;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS;EAC7E,kCAAkC,EAAE,qCAAqC;EACzE,kBAAkB;AACpB;AACA,+CAA+C,eAAe,EAAE,qBAAqB,EAAE;AACvF,+CAA+C,eAAe,EAAE,gBAAgB,EAAE,wBAAwB,EAAE;AAC5G,6CAA6C,eAAe,EAAE,sBAAsB,EAAE,eAAe,EAAE,iBAAiB,EAAE;;AAE1H,8CAA8C;AAC9C,wCAAwC,aAAa,EAAE,SAAS,EAAE,oBAAoB,EAAE;AACxF;4DAC4D,SAAO,EAAE;AACrE;4DAC4D,cAAc,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;;AAErH,gEAAgE;AAChE,iBAAiB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AACpH,4BAA4B,iBAAiB,0BAA0B,EAAE,EAAE;AAC3E,mCAAmC,gBAAgB,EAAE;;AAErD;yEACyE;AACzE,mDAAmD,eAAe,EAAE,SAAS,EAAE;AAC/E;EACE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,eAAe,EAAE,YAAY,EAAE,cAAc,EAAE,oBAAoB;EACnE,kCAAkC,EAAE,wBAAwB,EAAE,eAAe,EAAE,gBAAgB;AACjG;;AAEA;uDACuD;AACvD,6CAA6C,+BAA+B,EAAE,qCAAqC,EAAE,aAAa,EAAE,sBAAsB,EAAE;AAC5J,6CAA6C,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AAC7F,8CAA8C,eAAe,EAAE,wBAAwB,EAAE;AACzF,8CAA8C,qBAAqB,EAAE,eAAe,EAAE;AACtF,8CAA8C,eAAe,EAAE;;AAE/D;wDACwD;AACxD,0CAA0C,+BAA+B,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC/G,wCAAwC,8BAA8B,EAAE,sBAAsB,EAAE;AAChG,6CAA6C,kCAAkC,EAAE;AACjF;EACE,sBAAsB;EACtB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS;EAC7E,WAAW,EAAE,gBAAgB,EAAE,eAAe;EAC9C,mCAAmC,EAAE,qCAAqC;EAC1E,kBAAkB,EAAE,8BAA8B;EAClD,0DAA0D;AAC5D;AACA,6CAA6C,+BAA+B,EAAE,0CAA0C,EAAE;;AAE1H;oCACoC;AACpC;EACE,qCAAqC,EAAE,qCAAqC;EAC5E,8BAA8B;EAC9B,uFAAuF;AACzF;AACA,qCAAqC,oCAAoC,EAAE;AAC3E;EACE,+BAA+B,EAAE,+BAA+B,EAAE,0CAA0C;AAC9G;AACA,uCAAuC,uBAAuB,EAAE,sCAAsC,EAAE,iBAAiB,EAAE;AAC3H,8CAA8C,sBAAsB,EAAE;AACtE,oDAAoD,kCAAkC,EAAE,wBAAwB,EAAE;AAClH,oCAAoC,eAAe,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AACtH,kDAAkD,sBAAsB,EAAE;;AAE1E;EACE,yCAAyC,qCAAqC,EAAE;AAClF;;AAEA;EACE,wCAAwC,sBAAsB,EAAE;EAChE,0CAA0C,eAAe,EAAE;EAC3D,sCAAsC,kBAAkB,EAAE,mBAAmB,EAAE;EAC/E,4CAA4C,eAAe,EAAE,SAAS,EAAE;EACxE,2CAA2C,WAAW,EAAE,YAAY,EAAE;EACtE;0CACwC,WAAW,EAAE,gBAAgB,EAAE;EACvE,kDAAkD,kBAAkB,EAAE,gBAAgB,EAAE;EACxF,wEAAwE,kBAAkB,EAAE;EAC5F,0EAA0E,eAAe,EAAE;AAC7F;;AAEA;;uEAEuE;AACvE;EACE,+BAA+B;EAC/B,iBAAiB,EAAE,+BAA+B,EAAE,oBAAoB;AAC1E;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe;EAC9D,kBAAkB,EAAE,6BAA6B,EAAE,sCAAsC;AAC3F;AACA;EACE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,cAAc;EAC9D,uEAAuE;EACvE,6BAA6B;EAC7B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,eAAe,EAAE,0BAA0B,EAAE,4BAA4B;AAC3E;AACA,qBAAqB,+BAA+B,EAAE;AACtD,mBAAmB,SAAO,EAAE,gBAAgB,EAAE;AAC9C,sBAAsB,SAAS,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,uBAAuB,EAAE;AAC3H,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE,eAAe,EAAE;AACnG,SAAS,kBAAkB,EAAE,4BAA4B,EAAE,sBAAsB,EAAE;;AAEnF;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B;EAClE,+BAA+B,EAAE,+BAA+B;EAChE,iBAAiB,EAAE,mBAAmB;AACxC;;AAEA;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,kBAAkB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,mBAAmB;EAC5E,+DAA+D,EAAE,qBAAqB;AACxF;AACA,4BAA4B,YAAY,EAAE,gBAAgB,EAAE;;AAE5D,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AACpE;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,kBAAkB,EAAE,mBAAmB;EACvC,sEAAsE;EACtE,6BAA6B,EAAE,oBAAoB,EAAE,gBAAgB,EAAE,kBAAkB;EACzF,eAAe,EAAE,mBAAmB,EAAE,4BAA4B;AACpE;AACA,wBAAwB,6DAA6D,EAAE;AACvF,iBAAiB,kBAAkB,EAAE;AACrC;EACE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,+BAA+B;EAC/E,6BAA6B,EAAE,eAAe,EAAE,0BAA0B,EAAE,iBAAiB;AAC/F;AACA;EACE,kBAAkB,EAAE,QAAQ,EAAE,SAAS,EAAE,WAAW,EAAE,gBAAgB;EACtE,6BAA6B,EAAE,+BAA+B,EAAE,mBAAmB;EACnF,2CAA2C,EAAE,gBAAgB;EAC7D,aAAa,EAAE,sBAAsB;AACvC;AACA;EACE,cAAc,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,YAAY;EACpF,0BAA0B,EAAE,kBAAkB,EAAE,eAAe,EAAE,qBAAqB;AACxF;AACA,sDAAsD,+BAA+B,EAAE;;AAEvF,WAAW,iBAAiB,EAAE,cAAc,EAAE,kBAAkB,EAAE;;AAElE,WAAW,6BAA6B,EAAE,+BAA+B,EAAE,mBAAmB,EAAE,aAAa,EAAE,2CAA2C,EAAE;;AAE5J,kBAAkB,gBAAgB,EAAE,cAAc,EAAE;AACpD,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,0BAA0B,EAAE;AACnG,kBAAkB,gBAAgB,EAAE,kBAAkB,EAAE,4BAA4B,EAAE;AACtF,iBAAiB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;AAC5D;EACE,eAAe,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,+BAA+B;EACzF,+BAA+B,EAAE,0BAA0B,EAAE,kBAAkB;AACjF;AACA,uBAAuB,2BAA2B,EAAE;AACpD,iBAAiB,kBAAkB,EAAE,mBAAmB,EAAE,YAAY,EAAE,eAAe,EAAE,yBAAyB,EAAE,qCAAqC,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAChM,iBAAiB,gBAAgB,EAAE,kBAAkB,EAAE,oBAAoB,EAAE;;AAE7E,cAAc,kBAAkB,EAAE,aAAa,EAAE,4BAA4B,EAAE;AAC/E,mBAAmB,eAAe,EAAE,mBAAmB,EAAE;;AAEzD,eAAe,kBAAkB,EAAE,aAAa,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACpF,oBAAoB,eAAe,EAAE,mBAAmB,EAAE;AAC1D,kBAAkB,0BAA0B,EAAE,eAAe,EAAE;AAC/D,iBAAiB,4BAA4B,EAAE,SAAS,EAAE;;AAE1D,WAAW,aAAa,EAAE,gCAAgC,EAAE,SAAS,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AAChH,4BAA4B,WAAW,0BAA0B,EAAE,EAAE;;AAErE;EACE,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B;EAChF,qCAAqC,EAAE,kBAAkB;AAC3D;AACA,eAAe,gBAAgB,EAAE,kBAAkB,EAAE,4BAA4B,EAAE,kBAAkB,EAAE;;AAEvG;EACE,aAAa,EAAE,uBAAuB,EAAE,SAAS;EACjD,uEAAuE,EAAE,8EAA8E,EAAE,8BAA8B;EACvL,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB;AAC1D;AACA,wCAAwC,wEAAwE,EAAE;AAClH,yBAAyB,cAAc,EAAE,eAAe,EAAE;AAC1D,0BAA0B,SAAS,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC3E,wBAAwB,eAAe,EAAE,kBAAkB,EAAE,4BAA4B,EAAE;;AAE3F,gBAAgB,kBAAkB,EAAE,eAAe,EAAE,oBAAoB,EAAE;AAC3E,qBAAqB,eAAe,EAAE;AACtC,kBAAkB,eAAe,EAAE,gBAAgB,EAAE;AACrD,4BAA4B,8BAA8B,EAAE;AAC5D,6BAA6B,8BAA8B,EAAE;;AAE7D,oBAAoB,gBAAgB,EAAE,iBAAiB,EAAE,mCAAmC,EAAE;AAC9F,oBAAoB,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AAC7G,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,0BAA0B,EAAE;AACrI,yBAAyB,kBAAkB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AACtF,+BAA+B,wBAAwB,EAAE;AACzD,uCAAuC,UAAU,EAAE;;AAEnD;;iEAEiE;AACjE;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,gBAAgB,EAAE,kBAAkB;EACpC,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;AAC5C;AACA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,cAAc;EAC7D,oCAAoC,EAAE,mCAAmC;AAC3E;AACA,wCAAwC,kCAAkC,EAAE,2BAA2B,EAAE;AACzG,qBAAqB,SAAS,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AACpG,sBAAsB,eAAe,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;;AAEzG,eAAe,aAAa,EAAE,sBAAsB,EAAE;AACtD,aAAa,aAAa,EAAE,SAAS,EAAE;AACvC,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC9F;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,cAAc;EAC7D,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,iBAAiB;EAC9E,6BAA6B,EAAE,+BAA+B,EAAE,4BAA4B;EAC5F,qBAAqB;AACvB;AACA;EACE,yBAAyB,EAAE,2BAA2B;EACtD,wEAAwE;AAC1E;AACA,8FAA8F;AAC9F;iDACiD,0BAA0B,EAAE,4BAA4B,EAAE,yEAAyE,EAAE;AACtL,2CAA2C,8BAA8B,EAAE;AAC3E,2CAA2C,2BAA2B,EAAE;AACxE,2CAA2C,6BAA6B,EAAE;AAC1E,2CAA2C,qBAAqB,EAAE;AAClE,0EAA0E,+BAA+B,EAAE;;AAE3G,cAAc,QAAQ,EAAE,SAAO,EAAE,gBAAgB,EAAE,aAAa,EAAE,qCAAqC,EAAE;AACzG,0BAA0B,wBAAwB,EAAE,gCAAgC,EAAE;;AAEtF,cAAc,SAAO,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AAChE,oCAAoC,iBAAiB,EAAE;AACvD;EACE,6DAA6D;EAC7D,oEAAoE;EACpE,mBAAmB,EAAE,4BAA4B;EACjD,0BAA0B,EAAE,wBAAwB,EAAE,sBAAsB;AAC9E;AACA;EACE,kBAAkB,EAAE,QAAQ,EAAE,WAAW,EAAE,2BAA2B;EACtE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,8DAA8D,EAAE,oBAAoB;EACpF,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;AAC7D;AACA,cAAc,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE;AAC9E,eAAe,gBAAgB,EAAE,eAAe,EAAE,0BAA0B,EAAE;AAC9E,cAAc,iBAAiB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;AAC3F,iDAAiD,8DAA8D,EAAE,oBAAoB,EAAE;AACvI,sBAAsB,8BAA8B,EAAE,4BAA4B,EAAE;AACpF,cAAc,eAAe,EAAE,kBAAkB,EAAE,4BAA4B,EAAE;;AAEjF,kBAAkB,+BAA+B,EAAE,mBAAmB,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAC5G,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAC7J,8BAA8B,gBAAgB,EAAE,YAAY,EAAE,oBAAoB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE,YAAY,EAAE;AACzJ,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE,mCAAmC,EAAE;AACxH,uBAAuB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,cAAc,EAAE,+BAA+B,EAAE;AAC3I,wBAAwB,SAAO,EAAE,YAAY,EAAE;AAC/C,wBAAwB,SAAS,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACrK,wBAAwB,eAAe,EAAE,iBAAiB,EAAE,4BAA4B,EAAE;AAC1F,uBAAuB,kBAAkB,EAAE,4BAA4B,EAAE,cAAc,EAAE;;AAEzF,aAAa,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,sCAAsC,EAAE;AAClJ,gBAAgB,aAAa,EAAE,8BAA8B,EAAE,iBAAiB,EAAE,4BAA4B,EAAE;AAChH,mBAAmB,2BAA2B,EAAE;AAChD,gBAAgB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,iBAAiB,EAAE,mCAAmC,EAAE;;AAE1I;EACE,kBAAkB,EAAE,gBAAgB;EACpC,aAAa,EAAE,SAAS,EAAE,uBAAuB;EACjD,6DAA6D;EAC7D,oEAAoE;EACpE,mBAAmB,EAAE,4BAA4B;AACnD;AACA;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,cAAc;EAC7D,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,kBAAkB;EAC/E,8DAA8D;AAChE;AACA,mBAAmB,SAAS,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAChG,iBAAiB,eAAe,EAAE,kBAAkB,EAAE,4BAA4B,EAAE;AACpF;EACE,kBAAkB,EAAE,WAAW,EAAE,QAAQ,EAAE,2BAA2B;EACtE,4BAA4B,EAAE,aAAa;AAC7C;;AAEA,kBAAkB,mBAAmB,EAAE;AACvC,kBAAkB,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AAC3G,kBAAkB,SAAS,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,0BAA0B,EAAE;AAC9F,oBAAoB,kBAAkB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,4BAA4B,EAAE,0BAA0B,EAAE;AAC5L,8BAA8B,uCAAuC,EAAE,qBAAqB,EAAE;AAC9F,8BAA8B,qCAAqC,EAAE,2BAA2B,EAAE;AAClG,mBAAmB,+BAA+B,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACpI,0BAA0B,sBAAsB,EAAE,0BAA0B,EAAE;AAC9E,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,kBAAkB,EAAE;AACrF,sBAAsB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,cAAc,EAAE;AACxG,oBAAoB,SAAS,EAAE,kBAAkB,EAAE,0BAA0B,EAAE;AAC/E,yBAAyB,4BAA4B,EAAE;AACvD,qBAAqB,gBAAgB,EAAE;AACvC,6BAA6B,iBAAiB,EAAE,4BAA4B,EAAE,eAAe,EAAE;AAC/F,2BAA2B,eAAe,EAAE,iBAAiB,EAAE,oCAAoC,EAAE,gBAAgB,EAAE;AACvH,kBAAkB,kBAAkB,EAAE;AACtC,qBAAqB,SAAS,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,0BAA0B,EAAE;AAC9H,qCAAqC,SAAS,EAAE,kBAAkB,EAAE,4BAA4B,EAAE;;AAElG;EACE,kBAAkB,EAAE,gBAAgB;EACpC,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE,mBAAmB;EACnF,uHAAuH;AACzH;AACA;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,cAAc;EAC7D,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,iBAAiB;EAC9E,+DAA+D;EAC/D,qEAAqE;AACvE;AACA,gBAAgB,SAAO,EAAE,gBAAgB,EAAE;AAC3C,iBAAiB,SAAS,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,0BAA0B,EAAE;AAC9F,eAAe,eAAe,EAAE,kBAAkB,EAAE,4BAA4B,EAAE;AAClF;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,mBAAmB;EAC5F,YAAY,EAAE,yBAAyB,EAAE,qCAAqC,EAAE,gBAAgB,EAAE,iBAAiB;EACnH,qBAAqB,EAAE,mBAAmB,EAAE,wBAAwB;AACtE;AACA,wBAAwB,wBAAwB,EAAE;;AAElD,kBAAkB,cAAc,EAAE,cAAc,EAAE,gBAAgB,EAAE,YAAY,EAAE,oBAAoB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE,YAAY,EAAE;;AAE7K,oEAAoE;AACpE;EACE,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,mDAAmD;EACnD,8CAA8C;AAChD;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,UAAU;IACV,+BAA+B;EACjC;AACF;;AAEA;;EAEE,0EAA0E;AAC5E;;AAEA;;EAEE,wEAAwE;AAC1E;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,UAAU;IACV,+BAA+B;EACjC;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,oEAAoE;AACtE;;AAEA;EACE,iEAAiE;AACnE;;AAEA;;EAEE,gEAAgE;AAClE;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;IACE,UAAU;IACV,+BAA+B;EACjC;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;4BAC4B,YAAY,EAAE;;AAE1C;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,6DAA6D;AAC/D;;AAEA;EACE;;;IAGE,kCAAkC;IAClC,uCAAuC;IACvC,mCAAmC;IACnC,gCAAgC;EAClC;;EAEA;;;;;;IAME,0BAA0B;EAC5B;AACF;;AAEA;;;oEAGoE;AACpE;EACE,iBAAiB;EACjB;;;qDAGmD;EACnD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;EAC/B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,mBAAmB;AACrB;AACA,qBAAqB,0BAA0B,EAAE;AACjD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wEAAwE;EACxE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,YAAY,eAAe,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,0BAA0B,EAAE;AACjG,UAAU,gBAAgB,EAAE,kBAAkB,EAAE,4BAA4B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAEpH,WAAW,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC7D,YAAY,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC7D,kBAAkB,iBAAiB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AACrF;;EAEE,sBAAsB;EACtB,WAAW;EACX,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,oBAAoB;EACpB,YAAY;AACd;AACA;;EAEE,2BAA2B;EAC3B,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA,iBAAiB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE,cAAc,EAAE,kBAAkB,EAAE,sCAAsC,EAAE;AACvJ,4BAA4B,mBAAmB,EAAE;AACjD,mBAAmB,4BAA4B,EAAE;AACjD,mBAAmB,0BAA0B,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AACpF,mBAAmB,eAAe,EAAE,UAAU,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,0BAA0B,EAAE;AAClH,sBAAsB,aAAa,EAAE,8BAA8B,EAAE,cAAc,EAAE;;AAErF;EACE,aAAa;EACb,QAAQ;EACR,+BAA+B;EAC/B,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,2CAA2C;EAC3C,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;AACA,sBAAsB,6BAA6B,EAAE,0BAA0B,EAAE,0CAA0C,EAAE;;AAE7H;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB;2DACyD;EACzD,mCAAmC;AACrC;AACA,eAAe,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,cAAc,EAAE;;AAE7E;EACE,gBAAgB,EAAE,YAAY,EAAE,4BAA4B,EAAE,iBAAiB;EAC/E,0BAA0B,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,kBAAkB,EAAE,WAAW;AAChH;AACA,oBAAoB,kBAAkB,EAAE,eAAe,EAAE,4BAA4B,EAAE,kBAAkB,EAAE;;AAE3G;EACE,8DAA8D;EAC9D,oBAAoB;EACpB,oEAAoE;EACpE,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,kEAAkE;EAClE,gCAAgC;EAChC,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2EAA2E;AAC7E;AACA,uBAAuB,mFAAmF,EAAE;AAC5G,0BAA0B,YAAY,EAAE,mBAAmB,EAAE;;AAE7D;;;;;4DAK4D;AAC5D,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACpE;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;AACA,kBAAkB,YAAY,EAAE;AAChC,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AACxE,qBAAqB,SAAS,EAAE,iBAAiB,EAAE,4BAA4B,EAAE;AACjF;4CAC4C;AAC5C,kBAAkB,eAAe,EAAE,kBAAkB,EAAE,wBAAwB,EAAE,mBAAmB,EAAE;;AAEtG;;;sBAGsB;AACtB;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;;;;;wDAMwD;AACxD;EACE,kCAAkC;EAClC,qCAAqC;AACvC;AACA,qBAAqB,kFAAkF,EAAE;;AAEzG,cAAc,kBAAkB,EAAE,eAAe,EAAE;AACnD,mBAAmB,qBAAqB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE;AACrF,oBAAoB,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACtG,kBAAkB,gBAAgB,EAAE,kBAAkB,EAAE,4BAA4B,EAAE;;AAEtF;EACE,WAAW,kBAAkB,EAAE;AACjC;;AAEA,yEAAyE;AACzE;EACE,eAAe;EACf,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,2CAA2C;EAC3C,kBAAkB;EAClB,6BAA6B;AAC/B;AACA,sBAAsB,aAAa,EAAE,QAAQ,EAAE;AAC/C,qBAAqB,kBAAkB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC1H,yBAAyB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,cAAc,EAAE;AACvF;EACE,kBAAkB,EAAE,SAAS,EAAE,WAAW,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EACzF,yBAAyB,EAAE,mCAAmC,EAAE,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe;AAC5J;AACA,qBAAqB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,mBAAmB,EAAE;AAC5G,uBAAuB,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACrE;EACE,gBAAgB,EAAE,YAAY,EAAE,4BAA4B,EAAE,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,mBAAmB;AACzI;AACA,mBAAmB,iBAAiB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;;AAE/E;EACE,eAAe,EAAE,QAAQ,EAAE,gCAAgC,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EACxH,aAAa,EAAE,aAAa;AAC9B;AACA;EACE,+BAA+B,EAAE,+BAA+B,EAAE,WAAW,EAAE,gBAAgB,EAAE,gBAAgB;EACjH,aAAa,EAAE,sBAAsB,EAAE,gBAAgB;AACzD;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,kBAAkB,EAAE,sCAAsC;AAChI;AACA,2BAA2B,SAAS,EAAE,iBAAiB,EAAE,0BAA0B,EAAE;AACrF;EACE,gBAAgB,EAAE,YAAY,EAAE,4BAA4B,EAAE,eAAe,EAAE,WAAW,EAAE,YAAY;EACxG,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,kBAAkB;AACjF;AACA,6BAA6B,8BAA8B,EAAE;AAC7D,4BAA4B,cAAc,EAAE,kBAAkB,EAAE;AAChE,uBAAuB,yBAAyB,EAAE,WAAW,EAAE;AAC/D;EACE,gBAAgB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,4BAA4B,EAAE,mBAAmB,EAAE,mBAAmB;AACjI;AACA;EACE,kBAAkB,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,mCAAmC,EAAE,gBAAgB,EAAE,kBAAkB;AAC/I;AACA,+DAA+D,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,cAAc,EAAE,cAAc,EAAE;AACjK;EACE,gBAAgB,EAAE,YAAY,EAAE,6CAA6C,EAAE,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,UAAU;AACtK;AACA,6BAA6B,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACnG,wBAAwB,gBAAgB,EAAE,YAAY,EAAE,oBAAoB,EAAE,eAAe,EAAE,kBAAkB,EAAE;AACnH,gEAAgE;AAChE,0BAA0B,kCAAkC,EAAE,qCAAqC,EAAE;;AAErG;EACE,eAAe,eAAe,EAAE,uBAAuB,EAAE;EACzD,qBAAqB,WAAW,EAAE,kBAAkB,EAAE;AACxD;;AAEA,gEAAgE;AAChE;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;AACA;;;wCAGwC;AACxC;EACE,oBAAoB,4DAA4D,EAAE;AACpF;;AAEA;;;;;;;;;;;uDAWuD;AACvD;EACE,eAAe;EACf,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,oDAAoD;EACpD,2EAA2E;EAC3E,kCAAkC;EAClC,qCAAqC;EACrC,eAAe;EACf,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;;oEAEoE;AACpE;EACE,uBAAuB,4CAA4C,EAAE;AACvE;AACA,+BAA+B,4CAA4C,EAAE;;AAE7E;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;sCAIsC;AACtC;;;;;;;;mDAQmD;AACnD;EACE,WAAW;EACX,OAAO;EACP,qBAAqB;EACrB,wBAAwB;EACxB,oDAAoD;AACtD;AACA;EACE,mCAAmC,2CAA2C,EAAE;AAClF;AACA,2CAA2C,2CAA2C,EAAE;;AAExF;;;8BAG8B;AAC9B,gCAAgC,WAAW,EAAE,UAAU,EAAE,uBAAuB,EAAE;;AAElF;EACE,qCAAqC;EACrC,uCAAuC;EACvC,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mFAAmF;EACnF,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,YAAY;EACZ,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA,2BAA2B,kCAAkC,EAAE;;AAE/D;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,qCAAqC;EACrC,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,qDAAqD;AACvD;AACA,wCAAwC,sBAAsB,EAAE;AAChE,wCAAwC,qBAAqB,EAAE;AAC/D;EACE,gBAAgB,aAAa,EAAE,wBAAwB,EAAE;EACzD,MAAM,UAAU,EAAE,2BAA2B,EAAE;AACjD;;AAEA;;;;yDAIyD;AACzD;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,yDAAyD;AAC3D;AACA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;2DAC2D;AAC3D;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,8DAA8D;EAC9D,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,SAAO;EACP;;;;;gEAK8D;EAC9D,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;EACjC,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;AACpB;AACA,qCAAqC,aAAa,EAAE,2BAA2B,EAAE;AACjF;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;AACA,qDAAqD,+BAA+B,EAAE;AACtF,yCAAyC,YAAY,EAAE,mBAAmB,EAAE;;AAE5E;EACE,oBAAoB,WAAW,EAAE;EACjC,qBAAqB,yBAAyB,EAAE,wBAAwB,EAAE;AAC5E;;AAEA;;yEAEyE;;AAEzE,iEAAiE;AACjE;EACE,uBAAuB;EACvB,UAAU;EACV,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;AACA,oDAAoD,kBAAkB,EAAE;AACxE,sDAAsD,eAAe,EAAE;AACvE;EACE,2CAA2C;EAC3C,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;AACpB;AACA,wDAAwD,eAAe,EAAE,QAAQ,EAAE;AACnF,uDAAuD,WAAW,EAAE,YAAY,EAAE;AAClF,gDAAgD,eAAe,EAAE;AACjE;qDACqD,eAAe,EAAE;AACtE,sDAAsD,WAAW,EAAE,gBAAgB,EAAE;AACrF;;EAEE;2EACyE;EACzE,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;EAC3B,kCAAkC;EAClC,aAAa;EACb,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA,mDAAmD,8BAA8B,EAAE,kCAAkC,EAAE;AACvH;EACE,qCAAqC;EACrC,qCAAqC;EACrC,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;AACA;;;EAGE,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;AACA,8DAA8D,kBAAkB,EAAE;AAClF;EACE,gBAAgB;EAChB,wBAAwB;EACxB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,WAAW;EACX,yCAAyC;EACzC,0CAA0C;EAC1C,yCAAyC;EACzC,oBAAoB;AACtB;AACA;;mDAEmD,gBAAgB,EAAE;AACrE,wDAAwD,aAAa,EAAE;AACvE,kDAAkD,QAAQ,EAAE;AAC5D;;oDAEoD,aAAa,EAAE;;AAEnE,aAAa;AACb,cAAc,mBAAmB,EAAE,SAAS,EAAE;AAC9C,iBAAiB,kBAAkB,EAAE;AACrC,gBAAgB,kBAAkB,EAAE;AACpC,mBAAmB,gBAAgB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AAC5E,gBAAgB,QAAQ,EAAE,mBAAmB,EAAE;AAC/C,iBAAiB,kBAAkB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACpE,iBAAiB,WAAW,EAAE,YAAY,EAAE;AAC5C,kBAAkB,kBAAkB,EAAE;AACtC,kBAAkB,kBAAkB,EAAE;AACtC,YAAY,QAAQ,EAAE;AACtB,YAAY,kBAAkB,EAAE,mBAAmB,EAAE;AACrD,mBAAmB,kBAAkB,EAAE,QAAQ,EAAE;AACjD,sBAAsB,iBAAiB,EAAE;AACzC,oBAAoB,eAAe,EAAE,QAAQ,EAAE;AAC/C,mBAAmB,gBAAgB,EAAE,iBAAiB,EAAE;;AAExD,YAAY;AACZ,eAAe,SAAS,EAAE;AAC1B,YAAY,kBAAkB,EAAE,mBAAmB,EAAE;AACrD,iBAAiB,mBAAmB,EAAE,QAAQ,EAAE;AAChD,iBAAiB,WAAW,EAAE,YAAY,EAAE;AAC5C,kBAAkB,kBAAkB,EAAE;AACtC,iBAAiB,cAAc,EAAE;AACjC,aAAa,QAAQ,EAAE;AACvB,aAAa,kBAAkB,EAAE;AACjC,kBAAkB,gBAAgB,EAAE;AACpC,aAAa,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AAC1F,kBAAkB,WAAW,EAAE;AAC/B,YAAY,iBAAiB,EAAE,eAAe,EAAE;AAChD,eAAe,gBAAgB,EAAE,kBAAkB,EAAE;AACrD,oBAAoB,SAAS,EAAE;AAC/B,cAAc,gBAAgB,EAAE,iBAAiB,EAAE;AACnD,iBAAiB,mBAAmB,EAAE;AACtC;;kBAEkB,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC3E;WACW,iBAAiB,EAAE,oBAAoB,EAAE;;AAEpD,YAAY;AACZ,sDAAsD,SAAS,EAAE;AACjE,wEAAwE,oBAAoB,EAAE;AAC9F;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;AACA,qFAAqF,eAAe,EAAE;AACtG,uDAAuD,QAAQ,EAAE;AACjE,2DAA2D,aAAa,EAAE;AAC1E,2DAA2D,WAAW,EAAE,YAAY,EAAE;AACtF,4DAA4D,eAAe,EAAE;AAC7E,4DAA4D,eAAe,EAAE;AAC7E,4DAA4D,eAAe,EAAE;AAC7E,sEAAsE,gBAAgB,EAAE,eAAe,EAAE,eAAe,EAAE;AAC1H,sEAAsE,eAAe,EAAE;AACvF,2DAA2D,oBAAoB,EAAE;AACjF,qDAAqD,gBAAgB,EAAE;AACvE,4DAA4D,WAAW,EAAE,YAAY,EAAE;AACvF,kDAAkD,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACzG,yEAAyE,gBAAgB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AAC/H;2EAC2E,gBAAgB,EAAE,mBAAmB,EAAE;;AAElH;;iCAEiC;AACjC;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,yGAAyG;EACzG,YAAY;EACZ,sBAAsB;EACtB,SAAS;AACX;AACA;;yDAEyD,YAAY,EAAE;AACvE;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,mCAAmC;AACrC;AACA;;EAEE,gCAAgC;EAChC,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,+BAA+B,SAAS,EAAE,uBAAuB,EAAE;EACnE,mDAAmD,aAAa,EAAE;EAClE;IACE,gDAAgD;IAChD;;;+BAG2B;IAC3B,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,mBAAmB;IACnB,+BAA+B;EACjC;EACA,kEAAkE,kBAAkB,EAAE;EACtF,kEAAkE,mBAAmB,EAAE,mBAAmB,EAAE;EAC5G,kEAAkE,gBAAgB,EAAE;EACpF,kEAAkE,gBAAgB,EAAE,mBAAmB,EAAE;EACzG,kEAAkE,kBAAkB,EAAE;EACtF,kDAAkD,gDAAgD,EAAE;AACtG;;AAEA;EACE;IACE,8BAA8B;IAC9B;;;;uBAImB;EACrB;EACA,kDAAkD,8BAA8B,EAAE;AACpF;;AAEA;EACE,2DAA2D,0BAA0B,EAAE;AACzF;;AAEA,mEAAmE;AACnE;;;;;;;oDAOoD;AACpD,WAAW,iBAAiB,EAAE,6BAA6B,EAAE;AAC7D;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA;EACE,cAAc;EACd;0CACwC;EACxC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ;;;;;6BAK2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;AACvB;AACA,yBAAyB,QAAQ,EAAE,0BAA0B,EAAE;;AAE/D;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,wBAAwB;EACxB,oBAAoB;AACtB;AACA,yCAAyC,aAAa,EAAE;;AAExD;EACE,eAAe;EACf,wBAAwB;EACxB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,uDAAuD;AACzD;AACA,2BAA2B,2BAA2B,EAAE,4BAA4B,EAAE;AACtF,yBAAyB,aAAa,EAAE;;AAExC;;;;;;;;;4EAS4E;AAC5E,8BAA8B,kBAAkB,EAAE,mBAAmB,EAAE,6BAA6B,EAAE;AACtG,yBAAyB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,cAAc,EAAE;;AAE5G;;kEAEkE;AAClE;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA,iCAAiC,gCAAgC,EAAE,mCAAmC,EAAE;AACxG,iCAAiC,kCAAkC,EAAE,qCAAqC,EAAE;AAC5G,iCAAiC,yBAAyB,EAAE,mCAAmC,EAAE;AACjG,iCAAiC,iCAAiC,EAAE,+BAA+B,EAAE;;AAErG;EACE,kBAAkB,EAAE,QAAQ;EAC5B,+BAA+B;EAC/B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,UAAU;AACZ;AACA;EACE,iCAAiC,EAAE,+BAA+B;EAClE,kBAAkB,EAAE,gBAAgB;EACpC,iBAAiB,EAAE,+BAA+B;EAClD,yBAAyB,EAAE,sBAAsB;AACnD;;AAEA;;iFAEiF;AACjF;EACE,kBAAkB;EAClB,OAAO,EAAE,QAAQ,EAAE,SAAS;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,gCAAgC;EAChC,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,2BAA2B;EAC3B,0CAA0C;EAC1C,UAAU;AACZ;AACA;EACE,mDAAmD,UAAU,EAAE,wBAAwB,EAAE;AAC3F;;AAEA;;;;gFAIgF;AAChF;EACE,sCAAsC,aAAa,EAAE;AACvD;;AAEA,2BAA2B,kBAAkB,EAAE;AAC/C;;iBAEiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,yCAAyC;EACzC,UAAU;EACV,kBAAkB;AACpB;AACA;2EAC2E;AAC3E;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;AACA,2BAA2B,yBAAyB,EAAE,WAAW,EAAE,+BAA+B,EAAE;;AAEpG;;;;8EAI8E;AAC9E;EACE,qBAAqB,aAAa,EAAE;AACtC;;AAEA,0BAA0B,uBAAuB,EAAE;AACnD;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,iBAAiB;AACnB;AACA,2BAA2B,aAAa,EAAE,qBAAqB,EAAE,QAAQ,EAAE,eAAe,EAAE;AAC5F;;;;6EAI6E;AAC7E,sBAAsB,gBAAgB,EAAE,kBAAkB,EAAE,0BAA0B,EAAE;AACxF,2BAA2B,gBAAgB,EAAE,kBAAkB,EAAE,0BAA0B,EAAE;AAC7F,0BAA0B,kBAAkB,EAAE,4BAA4B,EAAE,6BAA6B,EAAE;AAC3G;;wBAEwB;;AAExB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;AACnB;AACA;wEACwE;AACxE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,+EAA+E;EAC/E,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;AACA,2BAA2B,4BAA4B,EAAE;AACzD,0BAA0B,iBAAiB,EAAE,gCAAgC,EAAE;;AAE/E;EACE,WAAW,gBAAgB,EAAE;EAC7B,iBAAiB,uBAAuB,EAAE,kBAAkB,EAAE;EAC9D,iBAAiB,kBAAkB,EAAE;AACvC;;AAEA;EACE,qBAAqB,eAAe,EAAE;AACxC;;AAEA;EACE,qBAAqB,eAAe,EAAE;AACxC;;AAEA;;yEAEyE;AACzE;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;AACtB;AACA,4BAA4B,yCAAyC,EAAE;AACvE;EACE,OAAO,wCAAwC,EAAE;EACjD,KAAK,0CAA0C,EAAE;AACnD;;AAEA;;;;;gEAKgE;AAChE,cAAc,iBAAiB,EAAE,cAAc,EAAE,sBAAsB,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC3H,4BAA4B,cAAc,sBAAsB,EAAE,SAAS,EAAE,EAAE;;AAE/E,iBAAiB,qBAAqB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,mBAAmB,EAAE;AAC7K,wBAAwB,cAAc,EAAE,kBAAkB,EAAE;;AAE5D,gEAAgE;AAChE,cAAc,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE,mBAAmB,EAAE;AAC7F,4BAA4B,cAAc,0BAA0B,EAAE,SAAS,EAAE,EAAE;;AAEnF,oBAAoB,iBAAiB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE;AAC1H,4BAA4B,oBAAoB,iBAAiB,EAAE,EAAE;AACrE,kBAAkB,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC1H,sBAAsB,aAAa,EAAE,eAAe,EAAE,SAAS,EAAE;;AAEjE;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,0BAA0B,EAAE,qCAAqC,EAAE,YAAY;EACpI,oBAAoB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,eAAe;AAChG;AACA,2BAA2B,kCAAkC,EAAE;AAC/D;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,+BAA+B,EAAE,0BAA0B;EAChH,+BAA+B,EAAE,oBAAoB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,eAAe;AACjI;AACA,2BAA2B,4BAA4B,EAAE,qBAAqB,EAAE;;AAEhF,qBAAqB,kBAAkB,EAAE,aAAa,EAAE,uBAAuB,EAAE,aAAa,EAAE;AAChG;EACE,YAAY,EAAE,aAAa,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,cAAc;EACjF,2EAA2E,EAAE,qEAAqE;AACpJ;AACA,kBAAkB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,wBAAwB,EAAE,cAAc,EAAE;;AAE1G;EACE,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,+BAA+B;EAClG,+BAA+B,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,8BAA8B;EACxG,kBAAkB,EAAE,gBAAgB;AACtC;AACA,2BAA2B,cAAc,EAAE,kBAAkB,EAAE,0BAA0B,EAAE;AAC3F,qBAAqB,SAAS,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AACjI,iDAAiD,4BAA4B,EAAE;AAC/E;EACE,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,oBAAoB,EAAE,mBAAmB;EACxG,uBAAuB,EAAE,+DAA+D,EAAE,qBAAqB;AACjH;AACA,iBAAiB,OAAO,EAAE,SAAS,EAAE;AACrC,iBAAiB,OAAO,EAAE,UAAU,EAAE;AACtC,iBAAiB,WAAW,EAAE,SAAS,EAAE;AACzC,iBAAiB,UAAU,EAAE,UAAU,EAAE;AACzC;EACE,uBAAuB,YAAY,EAAE,aAAa,EAAE;EACpD,oBAAoB,gBAAgB,EAAE,eAAe,EAAE,WAAW,EAAE;EACpE,qBAAqB,eAAe,EAAE,SAAS,EAAE;AACnD;;AAEA,gEAAgE;AAChE;EACE,aAAa,EAAE,qCAAqC,EAAE,SAAS,EAAE,8DAA8D;EAC/H,+BAA+B,EAAE,kBAAkB;AACrD;AACA,4BAA4B,eAAe,qCAAqC,EAAE,EAAE;AACpF,cAAc,kBAAkB,EAAE;AAClC;EACE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EACjH,+BAA+B,EAAE,qEAAqE,EAAE,qBAAqB,EAAE,mBAAmB;AACpJ;AACA,oBAAoB,iBAAiB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,SAAS,EAAE;AAC3F,oBAAoB,iBAAiB,EAAE,4BAA4B,EAAE,eAAe,EAAE;;AAEtF,gEAAgE;AAChE,aAAa,kBAAkB,EAAE;AACjC,uBAAuB,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE;AAC1G,qBAAqB,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC3H,oBAAoB,aAAa,EAAE,qCAAqC,EAAE,SAAS,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACzH,4BAA4B,oBAAoB,0BAA0B,EAAE,EAAE;AAC9E,oBAAoB,+BAA+B,EAAE,+BAA+B,EAAE,+BAA+B,EAAE,kBAAkB,EAAE;AAC3I;EACE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB;EAClH,+DAA+D,EAAE,qBAAqB,EAAE,mBAAmB;AAC7G;AACA,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACrG,oBAAoB,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE,SAAS,EAAE;;AAEnG,gEAAgE;AAChE;EACE,aAAa,EAAE,kCAAkC,EAAE,SAAS,EAAE,mBAAmB,EAAE,8DAA8D;EACjJ,+BAA+B,EAAE,aAAa;AAChD;AACA,4BAA4B,gBAAgB,0BAA0B,EAAE,aAAa,EAAE,EAAE;AACzF,yBAAyB,+BAA+B,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAC/F,oBAAoB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,wBAAwB,EAAE,cAAc,EAAE;AAC5G,sBAAsB,aAAa,EAAE,eAAe,EAAE,SAAS,EAAE,eAAe,EAAE;AAClF,qBAAqB,eAAe,EAAE;AACtC;EACE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EACjH,+DAA+D,EAAE,qBAAqB,EAAE,kBAAkB;AAC5G;AACA,2BAA2B,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AAC9G,0BAA0B,kBAAkB,EAAE,4BAA4B,EAAE,SAAS,EAAE;;AAEvF,gEAAgE;AAChE;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,eAAe,EAAE,SAAS;EAC9F,2EAA2E,EAAE,+BAA+B,EAAE,kBAAkB,EAAE,+BAA+B;AACnK;AACA;EACE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,kCAAkC,EAAE,oBAAoB;EACxG,mBAAmB,EAAE,uBAAuB,EAAE,cAAc;AAC9D;AACA,kBAAkB,SAAO,EAAE,gBAAgB,EAAE;AAC7C,mBAAmB,iBAAiB,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACzE,iBAAiB,iBAAiB,EAAE,SAAS,EAAE,YAAY,EAAE;AAC7D,qBAAqB,aAAa,EAAE,eAAe,EAAE,SAAS,EAAE;AAChE;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,oCAAoC,EAAE,6BAA6B,EAAE,YAAY;EACtI,oBAAoB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,eAAe;AACjG;AACA;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,uBAAuB,EAAE,+BAA+B;EAC7G,uCAAuC,EAAE,oBAAoB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,eAAe;AAC1I;AACA,iCAAiC,kCAAkC,EAAE;;AAErE,2EAA2E;AAC3E;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,+BAA+B,EAAE,+BAA+B,EAAE,+BAA+B;EACjG,kBAAkB,EAAE,wBAAwB,EAAE,mBAAmB;AACnE;AACA,2BAA2B,SAAO,EAAE,YAAY,EAAE,gBAAgB,EAAE,aAAa,EAAE,kBAAkB,EAAE,0BAA0B,EAAE;AACnI,eAAe,aAAa,EAAE,4DAA4D,EAAE,SAAS,EAAE;AACvG;EACE,aAAa,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,QAAQ,EAAE,gBAAgB;EAC1F,+BAA+B,EAAE,+BAA+B,EAAE,+BAA+B;EACjG,kBAAkB,EAAE,eAAe;AACrC;AACA,qBAAqB,2BAA2B,EAAE;AAClD,oBAAoB,iBAAiB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AAC3E,oBAAoB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACtF,uBAAuB,iBAAiB,EAAE,4BAA4B,EAAE;AACxE,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,kBAAkB,EAAE,wBAAwB,EAAE,eAAe,EAAE,eAAe,EAAE;AACnJ,yBAAyB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAE9E,0EAA0E;AAC1E;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,wEAAwE;EACxE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,oDAAoD,2BAA2B,EAAE;AACjF,sDAAsD,mBAAmB,EAAE;AAC3E,4CAA4C,mBAAmB,EAAE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,8DAA8D;EAC9D,kBAAkB;AACpB;;AAEA,wCAAwC,cAAc,EAAE;AACxD,mCAAmC,QAAQ,EAAE;AAC7C,mCAAmC,0BAA0B,EAAE,eAAe,EAAE;AAChF;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,6BAA6B;AAC/B;AACA,yCAAyC,gDAAgD,EAAE;AAC3F;EACE,2BAA2B;EAC3B,wEAAwE;AAC1E;;AAEA;EACE,sEAAsE;AACxE;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,oCAAoC;EACpC,0CAA0C;EAC1C,0CAA0C;EAC1C,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,yDAAyD;EACzD,2DAA2D;AAC7D;;AAEA;EACE,gDAAgD;AAClD;AACA,qEAAqE,mBAAmB,EAAE;;AAE1F;EACE,yBAAyB,qCAAqC,EAAE;EAChE;wDACsD,cAAc,EAAE;AACxE;;AAEA;EACE,qEAAqE,qCAAqC,EAAE;EAC5G,qEAAqE,cAAc,EAAE;AACvF;;AAEA;EACE,8CAA8C,aAAa,EAAE;EAC7D,sCAAsC,aAAa,EAAE;AACvD;;AAEA,0EAA0E;AAC1E;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA,6EAA6E;AAC7E;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,wBAAwB;EACxB,6BAA6B;EAC7B,iCAAiC;EACjC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,0BAA0B;EAC1B,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kEAAkE;EAClE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,+BAA+B;EAC/B,wEAAwE;EACxE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;EAC/B,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;EACnB,sFAAsF;AACxF;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0DAA0D;EAC1D,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kEAAkE;EAClE,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,gDAAgD;EAChD,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kEAAkE;AACpE;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;EAEE,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA,0EAA0E;AAC1E;EACE,gDAAgD;EAChD,oBAAoB;EACpB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,gFAAgF;EAChF,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;AACA,mDAAmD,QAAQ,EAAE,eAAe,EAAE;AAC9E,kDAAkD,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACjG,sDAAsD,WAAW,EAAE,YAAY,EAAE;AACjF,gEAAgE,gBAAgB,EAAE;AAClF,iDAAiD,eAAe,EAAE,iBAAiB,EAAE;AACrF;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8EAA8E;EAC9E,sBAAsB;AACxB;AACA,sDAAsD,eAAe,EAAE;AACvE,sDAAsD,eAAe,EAAE;AACvE,+CAA+C,gBAAgB,EAAE;AACjE,2CAA2C,QAAQ,EAAE;AACrD,2CAA2C,eAAe,EAAE;AAC5D;;EAEE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,sBAAsB;AACxB;AACA,2CAA2C,eAAe,EAAE,eAAe,EAAE;AAC7E,gEAAgE,YAAY,EAAE,aAAa,EAAE;AAC7F,+CAA+C,WAAW,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC/F,+CAA+C,mBAAmB,EAAE,QAAQ,EAAE;AAC9E;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA,0CAA0C,SAAS,EAAE,eAAe,EAAE,iBAAiB,EAAE;AACzF,oDAAoD,oBAAoB,EAAE;;AAE1E;EACE,0CAA0C,qCAAqC,EAAE;EACjF,gEAAgE,aAAa,EAAE;AACjF;AACA;EACE,6CAA6C,aAAa,EAAE;EAC5D,+CAA+C,oBAAoB,EAAE,sBAAsB,EAAE;AAC/F;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sEAAsE;AACxE;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,mBAAmB;EACrB;;EAEA;;;IAGE,qCAAqC;EACvC;;EAEA;IACE,cAAc;EAChB;AACF;;;AAGA,4EAA4E;AAC5E;EACE,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,wEAAwE;AAC1E;;AAEA;EACE,UAAU;EACV,kEAAkE;EAClE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA,qEAAqE;AACrE;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ;;;;;;;;yBAQuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,cAAc;IACd,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;;;;;;;;;;;;6EAY6E;AAC7E;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iCAAiC;EAEjC,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,gEAAgE;EAChE,kBAAkB;AACpB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,eAAe,EAAE;AACtC;;AAEA;oBACoB;AACpB;EACE;oBACkB,eAAe,EAAE;AACrC;;AAEA;mDACmD;AACnD;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;8CAC8C;AAC9C;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;sEACsE;AACtE;EACE,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gFAAgF;AAClF;;AAEA,sBAAsB,0BAA0B,EAAE;;AAElD;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,6CAA6C;EAC7C,+CAA+C;AACjD;;AAEA;EACE,kBAAkB,kBAAkB,EAAE;EACtC,4DAA4D;EAC5D,0BAA0B,8BAA8B,EAAE;AAC5D;;AAEA;;;;;;;;;;;;;;;;6EAgB6E;;AAE7E,6EAA6E;AAC7E;;;;EAIE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB;;+CAE6C;EAC7C;yDACuD;AACzD;;AAEA;mCACmC;AACnC;;;;EAIE,0BAA0B;AAC5B;;AAEA,6EAA6E;AAC7E;sDACsD;AACtD;;;;;;;EAOE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA,6EAA6E;AAC7E;;8CAE8C;AAC9C;;EAEE;;0CAEwC;EACxC,0DAA0D;AAC5D;;AAEA;;EAEE;;2CAEyC;AAC3C;;AAEA;;;cAGc;AACd;;EAEE;;wCAEsC;AACxC;;AAEA,6EAA6E;AAC7E;;;oEAGoE;AACpE;;;;EAIE,wBAAwB;AAC1B;;AAEA,6EAA6E;AAC7E;;gCAEgC;AAChC;;EAEE,sCAAsC;AACxC;;AAEA,6EAA6E;AAC7E;EACE;;;;;;IAME,gBAAgB;EAClB;EACA;;;;IAIE,eAAe;EACjB;AACF;;AAEA;;;;;;;;;;;;6EAY6E;;AAE7E;;;yCAGyC;AACzC;EACE,mCAAmC;EACnC,kDAAkD;AACpD;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;;qCAEqC;AACrC;EACE,2BAA2B,SAAS,EAAE,cAAc,EAAE;EACtD,YAAY,kBAAkB,EAAE;EAChC,uBAAuB,aAAa,EAAE;AACxC;;AAEA,4EAA4E;AAC5E;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mFAAmF;AACrF;;AAEA;EACE,yFAAyF;AAC3F;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;;;;;;;gEAOgE;AAChE;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B,iCAAiC;EACjC,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA,yBAAyB,wBAAwB,EAAE;;AAEnD;EACE,aAAa;EACb,oCAAoC;EACpC,iDAAiD;AACnD;;AAEA;4EAC4E;AAC5E;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,YAAY,gBAAgB,EAAE;AAChC;;AAEA;;;2EAG2E;AAC3E;;;;;;;;+CAQ+C;AAC/C;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,iCAAiC;EACjC,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;yDAIyD;AACzD;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,0CAA0C;EAC1C,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;uEAEuE;AACvE;EACE,cAAc;EACd,YAAY;EACZ,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;mEACmE;AACnE;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;;;8BAG8B;AAC9B;;EAEE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;;;mDAGmD;AACnD;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,UAAU;EACV,YAAY;EACZ,4CAA4C;EAC5C,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,wCAAwC;EACxC,gCAAgC;EAChC,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;gDAWgD;;AAEhD;;;;;;;;;;;;;;;8DAe8D;AAC9D;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;0CAI0C;AAC1C;EACE,WAAW;EACX,eAAe;EACf,MAAM;AACR;;AAEA;;;;;;;;;;;;kDAYkD;AAClD;;;;;EAKE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;gEAGgE;AAChE;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;wEAcwE;AACxE;;;;;;;qEAOqE;AACrE;;;;;;;oBAOoB;AACpB;EACE,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA,2BAA2B,cAAc,EAAE,YAAY,EAAE;;AAEzD;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;6BAC6B;AAC7B,6BAA6B,eAAe,EAAE,iBAAiB,EAAE;AACjE,wCAAwC,gBAAgB,EAAE;;AAE1D;;;;;uEAKuE;AACvE;EACE,aAAa;EACb,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;;;;;;;;;+DAS+D;AAC/D;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;;;;;;;;;wBASwB;AACxB;;;EAGE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;+EAG+E;AAC/E;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;;;;;uEAQuE;AACvE,iCAAiC,aAAa,EAAE;;AAEhD;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;;;gEAGgE;AAChE;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;;iEAEiE;AACjE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;;;uCAGuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA,wCAAwC,eAAe,EAAE;AACzD,sCAAsC,SAAS,EAAE;;AAEjD,4EAA4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,uBAAuB;EACvB,kCAAkC;EAClC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;uDACuD;AACvD,kCAAkC,kBAAkB,EAAE;;AAEtD;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,uBAAuB;EACvB,kCAAkC;EAClC,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE;;;;;;;;kDAQgD;EAChD,iBAAiB,eAAe,EAAE;EAClC,gBAAgB,cAAc,EAAE,gBAAgB,EAAE;EAClD,iBAAiB,iBAAiB,EAAE;EACpC,eAAe,cAAc,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACrE;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,0BAA0B,cAAc,EAAE;;AAE1C;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,4EAA4E;AAC5E;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA,+BAA+B,eAAe,EAAE;AAChD,cAAc,kBAAkB,EAAE;;AAElC;EACE,kBAAkB,qBAAqB,EAAE;EACzC,eAAe,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;EAC9D;IACE,SAAS;IACT,sBAAsB;IACtB,wBAAwB;EAC1B;EACA,cAAc,kBAAkB,EAAE,kBAAkB,EAAE;AACxD;;AAEA;;;;;;;;;sCASsC;AACtC;EACE,qCAAqC;EACrC,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,sDAAsD;EACtD,SAAS;EACT,kBAAkB;EAClB;iBACe;EACf,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,iBAAiB;AACnB;;AAEA;mDACmD;AACnD;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sEAAsE;EACtE,SAAS;AACX;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,qCAAqC,aAAa,EAAE;;AAEpD;6DAC6D;AAC7D;EACE;IACE,qCAAqC;EACvC;EACA,iBAAiB,gBAAgB,EAAE;AACrC;;AAEA;;;iBAGiB;AACjB;EACE,iBAAiB,gBAAgB,EAAE;AACrC;;AAEA;;;;;;;;;+CAS+C;AAC/C;;;EAGE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;iEACiE;AACjE;;;;EAIE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;0CAC0C;AAC1C;;EAEE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;0DAC0D;AAC1D,+CAA+C,aAAa,EAAE;;AAE9D;;;;;;;;;;;wEAWwE;AACxE;;EAEE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;+CAC+C;AAC/C,0CAA0C,kBAAkB,EAAE;;AAE9D;8DAC8D;AAC9D;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU;AACZ;;AAEA;;6CAE6C;AAC7C;;EAEE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;2CAE2C;AAC3C;EACE,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;;;;;;;8DAO8D;AAC9D;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,uCAAuC;EACvC,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA,qCAAqC,2BAA2B,EAAE;;AAElE;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA,qCAAqC,wBAAwB,EAAE;;AAE/D,wEAAwE;AACxE;EACE,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;6EAE6E;AAC7E;;EAEE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;EACb,iFAAiF;AACnF;;AAEA;EACE,oCAAoC;EACpC,0FAA0F;AAC5F;;AAEA;;;EAGE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;;;EAGE,cAAc;EACd,eAAe;AACjB;;AAEA,qBAAqB,4BAA4B,EAAE;;AAEnD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,6CAA6C;EAC7C,oDAAoD;EACpD,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;;;EAIE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;;;;;;;;;;;;EAYE;qEACmE;AACrE;;AAEA;;;;EAIE,oCAAoC;EACpC,0FAA0F;AAC5F;;AAEA;;;;;;EAME,uBAAuB;AACzB;;AAEA;;EAEE,oCAAoC;EACpC,iDAAiD;EACjD,aAAa;AACf;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;;IAEE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,sFAAsF;EACxF;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,uFAAuF;EACzF;AACF;;AAEA;EACE;;;;;;;;;;;;IAYE,gBAAgB;EAClB;AACF;;AAEA;;;;;iCAKiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA,wBAAwB,cAAc,EAAE;;AAExC;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA,+EAA+E;AAC/E;EACE,mDAAmD;AACrD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,WAAW,aAAa,EAAE;AAC5B;;AAEA;EACE,gCAAgC,eAAe,EAAE;AACnD;;AAEA;;;;;;;;;;;;;;;;wEAgBwE;AACxE;EACE;;;;;;;;;;;;;;;;;;IAkBE,kBAAkB;EACpB;EACA,mDAAmD;EACnD,0CAA0C,kBAAkB,EAAE;AAChE;;AAEA;;kEAEkE;AAClE;EACE,yDAAyD;EACzD;;;;;;;;;;;;;;;;IAgBE,kBAAkB;EACpB;;EAEA;;;8DAG4D;EAC5D,iBAAiB,eAAe,EAAE,gBAAgB,EAAE;EACpD;;;;;;;;;;;;;;;;;IAiBE,gBAAgB;EAClB;EACA,2CAA2C;EAC3C;;;;IAIE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;;8CAG4C;EAC5C;;;;IAIE,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;;;;+DAI+D;AAC/D;EACE;;;;;;IAME,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;EACrB;AACF;;AAEA;;;;;uEAKuE;AACvE;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;;;qEAGqE;AACrE;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE;wEACsE;EACtE,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,iBAAiB,eAAe,EAAE;;AAElC;uEACuE;AACvE;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qEAAqE;EACrE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;qEACqE;AACrE;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["/* ════════════════════════════════════════════════════════════════════════\n   AcyMart design tokens — the four-color brand system.\n\n   The interface is restricted to exactly four brand colors. Every other\n   value in this file is derived from them by transparency or by mixing\n   them against each other; no unrelated grey, green, red, amber, violet or\n   teal ramp exists any more. Product photography, seller-uploaded images\n   and promotional banner artwork are exempt -- the restriction covers the\n   application chrome, not the content inside it.\n\n     Navy   #010D21  structure, text, dark canvas\n     Orange #FF6700  primary commercial actions and promotions\n     Blue   #3B82F6  secondary interaction, selection, information\n     White  #FFFFFF  primary light surface, text on dark\n\n   Because only four hues are available, colour can no longer carry meaning\n   on its own -- \"success\" and \"error\" are not distinguishable by hue. Every\n   status must therefore also carry an icon or a text label; see theme.js's\n   STATUS_TONE for the shared vocabulary, and the .status-* rules below.\n\n   The legacy token names (--bg-primary, --text-primary, --danger, --success\n   and friends) are kept as aliases because several thousand call sites\n   reference them. They now resolve to brand values, so re-pointing them\n   here is what rolls the palette out across the whole app at once. Prefer\n   the semantic --color-* names in new code.\n   ════════════════════════════════════════════════════════════════════════ */\n\n:root,\n:root[data-theme=\"light\"] {\n  /* ── Brand foundation — the only raw brand hexes in the system ───────── */\n  --color-brand-navy: #010D21;\n  --color-brand-orange: #FF6700;\n  --color-brand-blue: #3B82F6;\n  --color-brand-white: #FFFFFF;\n\n  /* ── Rating green — a narrow, deliberate exception ───────────────────────\n     Green is NOT a fifth brand colour. It is approved for exactly one thing:\n     product ratings (the pill over the image, and the filled stars under the\n     product name). It must never be used for stock status, buttons, checkout\n     discounts, success messages, navigation, or anything else -- those all\n     stay on navy/orange/blue. Always reference the token; never paste\n     #16A34A into a component. */\n  --color-rating: #16A34A;\n  /* Text sitting ON the green fill, and the same rule the orange and blue\n     fills already follow: navy, never white. White on #16A34A is 3.30:1 and\n     fails AA for text this size; navy is 5.90:1. The green itself is\n     unchanged, so the filled stars (a graphic, judged at 3:1) are\n     unaffected. */\n  --color-rating-on-fill: var(--color-brand-navy);\n  --color-rating-soft: rgba(22, 163, 74, 0.12);\n  /* Unfilled stars in a partial rating: navy at 15%, not a grey. */\n  --color-rating-empty: rgba(1, 13, 33, 0.15);\n  /* Review counts and the \"No reviews\" placeholder. */\n  --color-review-muted: rgba(1, 13, 33, 0.56);\n\n  /* ── Confirm-dialog red/green — the second narrow exception ──────────────\n     Like the rating green above, these are NOT new brand colours. They are\n     approved for exactly one surface: the destructive-confirmation dialog\n     (.confirm-dialog), where the choice is irreversible and the two options\n     must be told apart instantly, under stress, without reading.\n\n     Everything else in the admin chrome stays on navy/orange/blue: Edit,\n     Hide, Save, Create, status pills, charts and toasts are all unchanged.\n     Do not reach for these for a general \"success\" or \"error\" state, and\n     never paste the hexes into a component.\n\n     Contrast on white: #C0261B is 5.6:1, #15803D is 4.8:1, both AA for\n     body text. The filled variants pair with white text (5.6:1 and 4.8:1\n     respectively), and each button also carries an icon and a verb, so\n     meaning never rests on hue alone. */\n  --color-confirm-danger: #C0261B;\n  --color-confirm-danger-hover: #A21D14;\n  --color-confirm-danger-soft: rgba(192, 38, 27, 0.12);\n  --color-confirm-safe: #15803D;\n  --color-confirm-safe-hover: #116932;\n  --color-confirm-safe-soft: rgba(21, 128, 61, 0.12);\n  --color-confirm-on-fill: #FFFFFF;\n\n  /* ── Order-confirmed green — the third narrow exception ─────────────────\n     Requested for the packaged app's order-confirmation banner, and recorded\n     here rather than pasted into a component so it follows the same rule as\n     the two exceptions above: an exception is a named token or it is not\n     approved.\n\n     Worth being straight about the tension. The palette notes say success\n     shares blue and that the rating green must never appear on a success\n     message, and on the website that still holds -- .order-success-trust is\n     unchanged there. This applies to one banner on one surface, the app's\n     order-placed screen, where a green confirmation is the near-universal\n     convention on a phone and the moment is the single most reassuring one\n     in the flow.\n\n     4.9:1 on white and lifted for the navy canvas, so both are AA for body\n     text. The banner also carries a check icon and an explicit sentence, so\n     nothing here depends on hue being understood. */\n  --color-app-success: #15803D;\n  --color-app-success-soft: rgba(21, 128, 61, 0.12);\n  --color-app-success-border: rgba(21, 128, 61, 0.28);\n\n  /* ── Surfaces ────────────────────────────────────────────────────────── */\n  --color-page: var(--color-brand-white);\n  --color-surface: var(--color-brand-white);\n  --color-surface-subtle: rgba(1, 13, 33, 0.035);\n  --color-surface-hover: rgba(1, 13, 33, 0.06);\n  /* Opaque twin of --color-surface-subtle (navy 3.5% flattened onto white).\n     Needed wherever a translucent fill would let another surface show\n     through: sticky headers, dropdown panels, table header rows. */\n  --color-surface-subtle-solid: #F6F7F8;\n  /* Inverse surface: solid navy in light mode, used for badges and pills\n     that need to read as \"filled dark\". In dark mode the page is already\n     navy, so a solid navy fill would vanish -- it lifts to a translucent\n     white instead. Pair with --color-text-on-inverse. */\n  --color-surface-inverse: var(--color-brand-navy);\n  --color-text-on-inverse: var(--color-brand-white);\n\n  /* ── Text ────────────────────────────────────────────────────────────── */\n  --color-text-primary: var(--color-brand-navy);\n  --color-text-secondary: rgba(1, 13, 33, 0.68);\n  --color-text-muted: rgba(1, 13, 33, 0.5);\n\n  /* ── Borders ─────────────────────────────────────────────────────────── */\n  --color-border: rgba(1, 13, 33, 0.12);\n  --color-border-strong: rgba(1, 13, 33, 0.22);\n\n  /* ── Primary (commercial) ────────────────────────────────────────────── */\n  /* The FILL orange, mixed 25% toward navy (#C05108).\n     \n     Buttons carry a white label throughout the app, which pure #FF6700 cannot\n     support: white on it is 2.92:1, well under the 4.5:1 AA needs for a\n     button's ~15px text. Mixed a quarter of the way to navy it reaches\n     4.75:1, and still reads unmistakably as the brand orange.\n     \n     --color-brand-orange stays exactly #FF6700 and is what the charts and the\n     logo use; this is the role token for surfaces that carry text on top. */\n  --color-primary: color-mix(in srgb, var(--color-brand-orange) 75%, var(--color-brand-navy));\n  --color-primary-hover: color-mix(in srgb, var(--color-brand-orange) 66%, var(--color-brand-navy));\n  --color-primary-soft: rgba(255, 103, 0, 0.1);\n  --color-text-on-primary: var(--color-brand-white);\n\n  /* ── Secondary (interaction / selection) ─────────────────────────────── */\n  /* The FILL blue, mixed 15% toward navy (#3270D6) -- the same value\n     --color-secondary-text already used, for the same reason one step along:\n     white on pure #3B82F6 is 3.68:1 and fails AA, and at this depth it is\n     4.75:1. Fills and their labels now agree with links instead of being a\n     slightly different blue. --color-brand-blue stays pure for charts. */\n  --color-secondary: color-mix(in srgb, var(--color-brand-blue) 85%, var(--color-brand-navy));\n  --color-secondary-hover: color-mix(in srgb, var(--color-brand-blue) 74%, var(--color-brand-navy));\n  --color-secondary-soft: rgba(59, 130, 246, 0.1);\n  /* Brand blue as TEXT on a light surface is only 3.68:1 -- below AA for\n     anything under 24px. This is the same blue mixed 15% toward navy\n     (4.72:1), which is \"controlled mixing of the official colours\" rather\n     than a new hue, and still reads unmistakably as the brand blue. Use it\n     for links and small blue labels; use --color-secondary itself for fills,\n     borders and icons, where the 3:1 non-text threshold applies and the pure\n     blue passes. Dark mode overrides this back to pure blue, which is already\n     high-contrast on the navy canvas. */\n  --color-secondary-text: color-mix(in srgb, var(--color-brand-blue) 85%, var(--color-brand-navy));\n  /* White on the fill blue above is 4.75:1 and clears AA. */\n  --color-text-on-secondary: var(--color-brand-white);\n\n  /* ── Foregrounds for permanently-navy surfaces ───────────────────────────\n     The footer, the flash-sale bar and the admin sidebar are navy in BOTH\n     themes, so their text can't use --text-* : those flip to navy in light\n     mode and would disappear against the navy behind them. These three are\n     defined only here and deliberately never overridden in the dark block,\n     so they stay white-based whatever the theme is. */\n  --color-on-navy: var(--color-brand-white);\n  --color-on-navy-secondary: rgba(255, 255, 255, 0.72);\n  --color-on-navy-muted: rgba(255, 255, 255, 0.55);\n\n  --color-focus-ring: rgba(59, 130, 246, 0.25);\n  --color-overlay: rgba(1, 13, 33, 0.64);\n\n  --shadow-sm: 0 2px 8px rgba(1, 13, 33, 0.06);\n  --shadow-md: 0 8px 24px rgba(1, 13, 33, 0.1);\n\n  /* ── Chart series ramp ───────────────────────────────────────────────────\n     Categorical scale for dashboards. Only the brand hues are available, so\n     additional series are separated by opacity rather than by borrowing an\n     unrelated colour. Step 3 rides --accent-secondary, which is navy in\n     light mode and white in dark, so the \"structural\" series stays legible\n     on either canvas. Charts must still carry labels/legends -- eight steps\n     from three hues are not reliably distinguishable by colour alone.\n     Referenced from JS via theme.js's CHART_SERIES; kept as CSS variables\n     because recharts writes these into SVG fill/stroke attributes. */\n  --chart-1: var(--color-brand-blue);\n  --chart-2: var(--color-brand-orange);\n  --chart-3: var(--accent-secondary);\n  --chart-4: color-mix(in srgb, var(--color-brand-blue) 55%, transparent);\n  --chart-5: color-mix(in srgb, var(--color-brand-orange) 55%, transparent);\n  --chart-6: color-mix(in srgb, var(--accent-secondary) 45%, transparent);\n  --chart-7: color-mix(in srgb, var(--color-brand-blue) 28%, transparent);\n  --chart-8: color-mix(in srgb, var(--color-brand-orange) 28%, transparent);\n  --chart-grid: var(--color-border);\n  --chart-axis: var(--color-text-muted);\n\n  /* ── Legacy aliases (resolve onto the tokens above) ──────────────────── */\n  --bg-primary: var(--color-page);\n  --bg-secondary: var(--color-surface);\n  --bg-tertiary: var(--color-surface-subtle-solid);\n  /* The admin overview cards -- .ops-kpi-card, .ops-gmv-card, .ops-rate-card\n     and .ops-channel-panel -- all set `background: var(--surface-card)`, but\n     that token was never declared anywhere. An undeclared custom property\n     resolves to nothing, so every one of those cards has been rendering with\n     no background at all, showing the page canvas through in both themes and\n     leaving only their 1px border to suggest a card. Aliased onto the surface\n     they were evidently written for. --bg-secondary is itself redefined per\n     theme, so this single declaration is correct in light and dark. */\n  --surface-card: var(--bg-secondary);\n  --text-primary: var(--color-text-primary);\n  --text-secondary: var(--color-text-secondary);\n  --text-tertiary: rgba(1, 13, 33, 0.58);\n  --text-muted: var(--color-text-muted);\n  --border: var(--color-border);\n  --border-strong: var(--color-border-strong);\n  --accent: var(--color-secondary-text);\n  --accent-hover: var(--color-secondary-hover);\n  --brand-navy: var(--color-brand-navy);\n  --brand-orange: var(--color-brand-orange);\n  /* The navy foreground/tint accent. In dark mode navy has no foreground\n     role (the canvas is navy), so this lifts to white there -- which makes\n     every `color-mix(--accent-secondary N%, transparent)` tint resolve to\n     the white-N% surface the dark spec asks for, automatically. Solid\n     fills must use --color-surface-inverse instead, not this. */\n  --accent-secondary: var(--color-brand-navy);\n  --accent-secondary-hover: rgba(1, 13, 33, 0.78);\n  /* Only four hues exist, so danger/warning share orange and success shares\n     blue. Always pair these with an icon or label -- never colour alone. */\n  --danger: var(--color-primary);\n  --warning: var(--color-primary);\n  --success: var(--color-secondary);\n  --info: var(--color-secondary);\n  --shadow-card: 0 2px 8px rgba(1, 13, 33, 0.09), 0 0 0 1px rgba(1, 13, 33, 0.05);\n  --shadow-panel: 0 4px 24px rgba(1, 13, 33, 0.10), 0 1px 4px rgba(1, 13, 33, 0.06);\n\n  /* Spacing scale */\n  --space-1: 8px;\n  --space-2: 16px;\n  --space-3: 24px;\n  --space-4: 32px;\n\n  /* Radius scale */\n  --radius-xs: 6px;\n  --radius-sm: 12px;\n  --radius-md: 14px;\n  --radius-lg: 16px;\n  --radius-xl: 20px;\n  --radius-pill: 999px;\n}\n\n/* ── Mobile type scale: now lives in mobile/tokens.css ─────────────────────\n   The 18px root that lifts this stylesheet's type for the phone used to be\n   declared here as `.is-native-app { font-size: 18px }`, which meant only the\n   packaged Capacitor shell ever got it.\n\n   That was the wrong condition. The mobile design layer it feeds is applied\n   to the shell AND to any viewport <= 768px (see mobile/mobileUI.js), and\n   every size in that layer is stated in rem -- so a phone browser rendered\n   the whole mobile design 12.5% smaller than the app did. One design, two\n   sizes, and the browser's was the cramped one.\n\n   The root now sits on html.m-app in mobile/tokens.css, alongside the scale\n   it governs, so the app at 390px and the browser at 390px are the same app.\n   The reasoning that was here -- why a root change rather than a thousand\n   individual edits, and what 1.125x does to the ramp -- moved with it.\n   Nothing is declared at this point in the file. */\n\n:root[data-theme=\"dark\"] {\n  /* Dark mode is the same four colours re-weighted: navy becomes the canvas,\n     white becomes the structural foreground, orange and blue keep their\n     exact light-mode responsibilities so an action never changes meaning\n     between themes. No second dark navy, and never pure black. */\n  --color-page: var(--color-brand-navy);\n  --color-surface: rgba(255, 255, 255, 0.05);\n  --color-surface-subtle: rgba(255, 255, 255, 0.035);\n  --color-surface-hover: rgba(255, 255, 255, 0.09);\n  /* White 5% flattened onto #010D21, for the same \"must be opaque\" cases. */\n  --color-surface-subtle-solid: #0E192C;\n  --color-surface-inverse: rgba(255, 255, 255, 0.12);\n  --color-text-on-inverse: var(--color-brand-white);\n\n  --color-text-primary: var(--color-brand-white);\n  --color-text-secondary: rgba(255, 255, 255, 0.7);\n  --color-text-muted: rgba(255, 255, 255, 0.5);\n\n  --color-border: rgba(255, 255, 255, 0.12);\n  --color-border-strong: rgba(255, 255, 255, 0.22);\n  --color-secondary-text: var(--color-brand-blue);\n  /* The button fill on the navy canvas. Kept at the same depth as light mode\n     rather than reverting to pure blue: buttons carry a white label in both\n     themes, and pure #3B82F6 gives white only 3.68:1. */\n  --accent: color-mix(in srgb, var(--color-brand-blue) 85%, var(--color-brand-navy));\n  /* Rating green keeps the same hue on the navy canvas (5.1:1 against\n     #010D21); only the neutrals it pairs with flip to white-based. */\n  --color-rating-empty: rgba(255, 255, 255, 0.2);\n  --color-review-muted: rgba(255, 255, 255, 0.62);\n\n  /* Confirm-dialog red/green, lifted for the navy canvas. The light-mode\n     values are tuned for white and drop to ~3:1 on navy, so both hues move\n     up in lightness here: #F2564A reads 5.0:1 and #2FBF6A 7.1:1 against\n     #010D21. The filled variants keep navy text rather than white, which is\n     the same rule the orange and blue fills follow elsewhere. */\n  --color-confirm-danger: #F2564A;\n  --color-confirm-danger-hover: #FF6E63;\n  --color-confirm-danger-soft: rgba(242, 86, 74, 0.18);\n  --color-confirm-safe: #2FBF6A;\n  --color-confirm-safe-hover: #45D07E;\n  --color-confirm-safe-soft: rgba(47, 191, 106, 0.18);\n\n  /* The light green drops to roughly 3:1 on the navy canvas, so the app's\n     confirmation banner takes the same lift the confirm dialog does. */\n  --color-app-success: #2FBF6A;\n  --color-app-success-soft: rgba(47, 191, 106, 0.16);\n  --color-app-success-border: rgba(47, 191, 106, 0.34);\n  --color-confirm-on-fill: var(--color-brand-navy);\n\n  --color-primary-soft: rgba(255, 103, 0, 0.16);\n  --color-secondary-soft: rgba(59, 130, 246, 0.16);\n  --color-focus-ring: rgba(59, 130, 246, 0.35);\n  --color-overlay: rgba(1, 13, 33, 0.78);\n\n  --shadow-sm: 0 2px 8px rgba(1, 13, 33, 0.3);\n  --shadow-md: 0 8px 24px rgba(1, 13, 33, 0.4);\n\n  /* ── Legacy aliases ──────────────────────────────────────────────────── */\n  --bg-primary: var(--color-page);\n  --bg-secondary: var(--color-surface-subtle-solid);\n  --bg-tertiary: rgba(255, 255, 255, 0.09);\n  --text-primary: var(--color-text-primary);\n  --text-secondary: var(--color-text-secondary);\n  --text-tertiary: rgba(255, 255, 255, 0.6);\n  --text-muted: var(--color-text-muted);\n  --border: var(--color-border);\n  --border-strong: var(--color-border-strong);\n  --brand-navy: var(--color-brand-navy);\n  --accent-secondary: var(--color-brand-white);\n  --accent-secondary-hover: rgba(255, 255, 255, 0.82);\n  --shadow-card: 0 2px 8px rgba(1, 13, 33, 0.35);\n  --shadow-panel: 0 4px 24px rgba(1, 13, 33, 0.4);\n}\n\n/* ── Animation system variables ───────────────────────────── */\n:root {\n  --ease-spring:   cubic-bezier(0.34, 1.56, 0.64, 1);\n  --ease-out-expo: cubic-bezier(0.16, 1, 0.3, 1);\n  --ease-in-out:   cubic-bezier(0.4, 0, 0.2, 1);\n  --dur-fast:  110ms;\n  --dur-base:  220ms;\n  --dur-slow:  380ms;\n}\n\n/* Global dark-mode colour transition — targeted, not everything */\n*, *::before, *::after {\n  transition: background-color 240ms ease, color 160ms ease, border-color 200ms ease;\n}\n\n.app-shell {\n  min-height: 100vh;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  display: flex;\n  flex-direction: column;\n}\n\n@media (max-width: 768px) {\n  .app-shell-with-bottom-nav {\n    padding-bottom: calc(56px + env(safe-area-inset-bottom, 0px));\n  }\n\n  /* The taller bar an installed app gets, packaged or PWA -- both are driven\n     by thumb rather than cursor and both sit over the system gesture area. */\n  .is-native-app .app-shell-with-bottom-nav,\n  html.m-installed .app-shell-with-bottom-nav {\n    padding-bottom: calc(60px + env(safe-area-inset-bottom, 0px));\n  }\n}\n\n/* The padding that wraps the account and info pages (My Orders, Wishlist,\n   Profile, Notifications, Dashboard, Dispute, the legal pages). This was\n   seven copies of style={{ padding: '20px' }} inline on the wrapper div,\n   which no stylesheet could reach -- the mobile layer needs to drop the\n   horizontal half so those pages can sit on the same edge as everything\n   else, and an inline style outranks it. Same 20px as before on desktop. */\n.page-shell-pad {\n  padding: 20px;\n}\n\n/* Topbar */\n.topbar {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 0;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  box-shadow: var(--shadow-sm);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  border-bottom: 1px solid var(--border);\n}\n\n.navbar-top {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: 12px 20px;\n  background: var(--bg-secondary);\n  flex-wrap: wrap;\n}\n\n.brand-button {\n  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);\n  border: none;\n  border-radius: var(--radius-sm);\n  padding: 10px 16px;\n  cursor: pointer;\n  transition: transform 200ms ease;\n  flex-shrink: 0;\n}\n\n.brand-button:hover {\n  transform: scale(1.05);\n}\n\n.brand {\n  font-size: 1.4rem;\n  font-weight: 800;\n  margin: 0;\n  letter-spacing: -0.5px;\n  color: white;\n}\n\n.navbar-search {\n  display: flex;\n  flex: 1;\n  min-width: 280px;\n}\n\n.search-input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  font-size: 0.95rem;\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  transition: all 200ms ease;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: var(--accent);\n  background: var(--bg-secondary);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.navbar-actions-top {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n  flex-shrink: 0;\n}\n\n.btn-icon-text {\n  background: none;\n  border: none;\n  color: var(--text-primary);\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 0.9rem;\n  padding: 8px 12px;\n  border-radius: var(--radius-xs);\n  transition: all 120ms ease;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.btn-icon-text:hover {\n  background: var(--bg-tertiary);\n  transform: translateY(-1px);\n}\n\n.cart-icon-btn {\n  background: none;\n  border: none;\n  font-size: 1.6rem;\n  cursor: pointer;\n  padding: 8px 12px;\n  border-radius: var(--radius-xs);\n  transition: all 120ms ease;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cart-icon-btn:hover {\n  background: var(--bg-tertiary);\n  transform: scale(1.1);\n}\n\n.cart-badge {\n  position: absolute;\n  top: 0;\n  right: 0;\n  background: var(--danger);\n  color: var(--color-text-on-primary);\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n/* User Dropdown Menu */\n.user-dropdown-container {\n  position: relative;\n  display: inline-block;\n  padding-bottom: 8px;  /* bridges the gap so onMouseLeave doesn't fire mid-crossing */\n}\n\n.user-dropdown-toggle {\n  cursor: pointer;\n  user-select: none;\n}\n\n.user-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  min-width: 200px;\n  box-shadow: 0 4px 12px rgba(1, 13, 33, 0.15);\n  z-index: 1000;\n  margin-top: 0;\n  animation: slideDown 200ms ease-out;\n}\n\n/* Language Switcher */\n.lang-switcher { position: relative; display: inline-block; }\n.lang-switcher-btn {\n  display: flex; align-items: center; gap: 6px;\n  background: none; border: none; cursor: pointer;\n  color: var(--text-secondary); font-size: 0.8rem; font-weight: 600;\n  padding: 8px 6px;\n}\n.lang-switcher-btn:hover { color: var(--text-primary); }\n.lang-switcher-current { white-space: nowrap; }\n.lang-switcher-menu {\n  position: absolute; top: 100%; right: 0;\n  background: var(--bg-secondary); border: 1px solid var(--border);\n  border-radius: var(--radius-sm); min-width: 150px;\n  box-shadow: 0 4px 12px rgba(1, 13, 33, 0.15); z-index: 1000;\n  animation: slideDown 200ms ease-out; overflow: hidden;\n}\n[dir=\"rtl\"] .lang-switcher-menu { right: auto; left: 0; }\n.lang-switcher-option {\n  display: block; width: 100%; text-align: left;\n  background: none; border: none; cursor: pointer;\n  padding: 10px 14px; font-size: 0.85rem; color: var(--text-primary);\n}\n[dir=\"rtl\"] .lang-switcher-option { text-align: right; }\n.lang-switcher-option:hover { background: var(--bg-tertiary); }\n.lang-switcher-option.active { color: var(--accent); font-weight: 700; }\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.dropdown-item {\n  position: relative;\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 12px 16px;\n  background: none;\n  border: none;\n  color: var(--text-primary);\n  cursor: pointer;\n  font-size: 0.95rem;\n  transition: all 120ms ease;\n  font-weight: 500;\n}\n\n.dropdown-item-badge {\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  font-size: 0.68rem;\n  font-weight: 700;\n  min-width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 5px;\n  box-sizing: border-box;\n}\n\n.dropdown-item:hover {\n  background: var(--bg-tertiary);\n  color: var(--accent);\n}\n\n.dropdown-item:first-child {\n  border-radius: var(--radius-sm) var(--radius-sm) 0 0;\n}\n\n/* Nested under the item above it (e.g. Track Order under My Orders) --\n   same left padding as regular items so the icon column stays aligned;\n   the smaller/lighter type is what signals it's a sub-item. */\n.dropdown-item-sub {\n  padding: 9px 16px;\n  font-size: 0.85rem;\n  font-weight: 400;\n  color: var(--text-secondary);\n}\n\n.dropdown-divider {\n  height: 1px;\n  border: none;\n  background: var(--border);\n  margin: 4px 0;\n}\n\n.logout-item {\n  color: var(--danger);\n}\n\n.logout-item:hover {\n  background: color-mix(in srgb, var(--danger) 10%, transparent);\n}\n\n.logout-item:last-child {\n  border-radius: 0 0 var(--radius-sm) var(--radius-sm);\n}\n\n.navbar-categories-bottom {\n  display: flex;\n  gap: 0;\n  padding: 0;\n  background: var(--bg-secondary);\n  border-top: 1px solid var(--border);\n  overflow-x: auto;\n  scroll-behavior: smooth;\n}\n\n.navbar-categories-bottom::-webkit-scrollbar {\n  height: 4px;\n}\n\n.navbar-categories-bottom::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.navbar-categories-bottom::-webkit-scrollbar-thumb {\n  background: var(--border-strong);\n  border-radius: var(--radius-xs);\n}\n\n.category-icon-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 12px 18px;\n  background: none;\n  border: none;\n  border-bottom: 3px solid transparent;\n  color: var(--text-secondary);\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 0.85rem;\n  white-space: nowrap;\n  transition: all 200ms ease;\n  flex-shrink: 0;\n}\n\n.category-icon-btn:hover {\n  color: var(--accent);\n  background: rgba(59, 130, 246, 0.05);\n}\n\n.category-icon-btn.active {\n  color: var(--accent);\n  border-bottom-color: var(--accent);\n}\n\n.category-icon {\n  font-size: 1.4rem;\n  display: block;\n}\n\n.category-label {\n  display: block;\n}\n\n.topbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  flex: 0 0 auto;\n}\n\n.user-name {\n  background: rgba(255, 255, 255, 0.1);\n  padding: 6px 12px;\n  border-radius: var(--radius-xl);\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.btn-text {\n  background: none;\n  border: none;\n  color: var(--bg-tertiary);\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 0.95rem;\n  padding: 6px 12px;\n  border-radius: var(--radius-sm);\n  transition: all 120ms ease;\n  white-space: nowrap;\n}\n\n.btn-text:hover {\n  background: rgba(255, 255, 255, 0.15);\n  transform: translateY(-1px);\n}\n\n.btn-icon {\n  background: none;\n  border: none;\n  font-size: 1.4rem;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: var(--radius-sm);\n}\n\n.btn-icon:hover {\n  transform: scale(1.1);\n}\n\n.cart-pill {\n  background: var(--accent);\n  border: none;\n  border-radius: var(--radius-pill);\n  padding: 10px 16px;\n  font-weight: 700;\n  color: var(--color-text-on-secondary);\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 200ms ease;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.cart-pill:hover {\n  background: var(--accent-hover);\n  transform: scale(1.05);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);\n}\n\n/* Hero Section */\n.hero {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-3);\n  padding: 42px 28px;\n  background: linear-gradient(135deg, var(--accent) 0%, var(--color-secondary) 100%);\n  color: white;\n  flex-wrap: wrap;\n}\n\n.hero-copy {\n  max-width: 760px;\n}\n\n.hero-copy h1 {\n  margin: 0 0 16px;\n  font-size: clamp(2.5rem, 4vw, 4rem);\n  line-height: 1.05;\n  font-weight: 800;\n}\n\n.hero-copy p {\n  margin: 0;\n  font-size: 1.05rem;\n  color: var(--border);\n}\n\n.hero-state {\n  display: grid;\n  gap: 18px;\n  width: min(100%, 360px);\n}\n\n.hero-state div {\n  background: rgba(255, 255, 255, 0.14);\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  border-radius: var(--radius-xl);\n  padding: 22px;\n  animation: slideIn 600ms ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.hero-state strong {\n  display: block;\n  font-size: 1.9rem;\n  margin-bottom: 6px;\n}\n\n.hero-state span {\n  color: var(--color-secondary-soft);\n  font-size: 0.9rem;\n}\n\n/* Content Grid */\n.content-grid {\n  width: min(1280px, 100%);\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1.7fr 0.95fr;\n  gap: var(--space-3);\n  padding: 24px 28px 40px;\n}\n\n.product-panel,\n.cart-panel {\n  background: var(--bg-secondary);\n  border-radius: 28px;\n  box-shadow: var(--shadow-panel);\n  border: 1px solid var(--border);\n  padding: var(--space-3);\n}\n\n.panel-header h2 {\n  margin: 0 0 8px;\n  font-size: 1.6rem;\n  font-weight: 700;\n}\n\n.panel-header p {\n  margin: 0;\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n}\n\n/* Controls */\n/* ── Legacy controls (kept for backward compat) ─────────── */\n.controls { display: none; }\n.search-box { flex: 1 1 320px; }\n.search-box input {\n  width: 100%;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 14px 16px;\n  font-size: 1rem;\n  outline: none;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n}\n.search-box input:focus {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246,0.1);\n}\n\n/* ── Filter bar ─────────────────────────────────────────── */\n.filter-bar {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin: 20px 0 18px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 16px 20px;\n  box-shadow: var(--shadow-sm);\n}\n\n/* Search row */\n.filter-search-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.filter-search-icon {\n  position: absolute;\n  left: 14px;\n  font-size: 1rem;\n  pointer-events: none;\n}\n.filter-search-input {\n  width: 100%;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 11px 40px 11px 42px;\n  font-size: 0.95rem;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-family: inherit;\n  outline: none;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n.filter-search-input:focus {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246,0.1);\n}\n.filter-search-clear {\n  position: absolute;\n  right: 12px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--text-muted);\n  font-size: 0.85rem;\n  padding: 4px;\n  line-height: 1;\n}\n.filter-search-clear:hover { color: var(--text-primary); }\n\n/* Filter row */\n.filter-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n  flex-wrap: wrap;\n  border-top: 1px solid var(--border);\n  padding-top: 12px;\n}\n.filter-section {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n.filter-section-right {\n  margin-left: auto;\n  flex-direction: row;\n  align-items: center;\n  gap: 12px;\n}\n.filter-label {\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--text-muted);\n}\n\n/* Price range inputs */\n.price-range-inputs {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.price-range-currency {\n  font-size: 0.82rem;\n  color: var(--text-muted);\n  font-weight: 600;\n}\n.price-range-sep {\n  font-size: 0.82rem;\n  color: var(--text-muted);\n}\n.price-input {\n  width: 80px;\n  padding: 7px 10px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 0.85rem;\n  font-family: inherit;\n  outline: none;\n}\n.price-input:focus {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 2px rgba(59, 130, 246,0.1);\n}\n.price-input::-webkit-inner-spin-button,\n.price-input::-webkit-outer-spin-button { opacity: 0.5; }\n.filter-clear-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--text-muted);\n  font-size: 0.8rem;\n  padding: 4px 6px;\n  border-radius: var(--radius-xs);\n  line-height: 1;\n}\n.filter-clear-btn:hover { background: var(--bg-tertiary); color: var(--text-primary); }\n\n/* Rating filter buttons */\n.rating-filter-row {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n.rating-filter-btn {\n  background: var(--bg-primary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xl);\n  padding: 5px 12px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.13s;\n}\n.rating-filter-btn:hover {\n  border-color: var(--color-primary);\n  color: var(--color-primary);\n}\n.rating-filter-btn.active {\n  background: var(--color-primary-soft);\n  border-color: var(--color-primary);\n  color: var(--color-primary);\n}\n.dark .rating-filter-btn.active {\n  background: #78350f44;\n  color: var(--color-primary);\n}\n\n/* In-stock toggle */\n.stock-toggle {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 0.82rem;\n  color: var(--text-secondary);\n  cursor: pointer;\n  white-space: nowrap;\n  font-weight: 500;\n}\n.stock-toggle input[type=\"checkbox\"] {\n  width: 15px;\n  height: 15px;\n  accent-color: var(--accent);\n  cursor: pointer;\n}\n\n/* Active filters summary */\n.active-filters {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n  flex-wrap: wrap;\n  border-top: 1px solid var(--border);\n  padding-top: 10px;\n}\n.active-filters-label {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--text-muted);\n  margin-right: 4px;\n}\n.active-filter-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  border-radius: var(--radius-xl);\n  padding: 3px 10px 3px 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n.active-filter-tag button {\n  background: none;\n  border: none;\n  color: rgba(255,255,255,0.8);\n  cursor: pointer;\n  font-size: 0.75rem;\n  padding: 0;\n  line-height: 1;\n}\n.active-filter-tag button:hover { color: var(--color-brand-white); }\n.active-filters-reset {\n  background: none;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xl);\n  padding: 3px 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-muted);\n  cursor: pointer;\n  margin-left: auto;\n}\n.active-filters-reset:hover {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n/* .shop-pagination / .shop-page-btn / .shop-page-info lived here. The shop\n   grows the list as you reach the end of it at every width now, so there is no\n   Prev/Next to style -- see the infinite-scroll sentinel in App.js. */\n\n@media (max-width: 700px) {\n  .filter-row { gap: 14px; }\n  .filter-section-right { margin-left: 0; }\n  .price-input { width: 68px; }\n}\n\n.category-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.chip {\n  border: 1px solid var(--border);\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  border-radius: var(--radius-pill);\n  padding: 10px 16px;\n  cursor: pointer;\n  transition: all 120ms ease;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.chip:hover {\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  border-color: var(--accent);\n  transform: translateY(-2px);\n}\n\n.chip.active {\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  border-color: var(--accent);\n}\n\n/* Product Grid */\n.product-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 20px;\n  justify-items: center;\n}\n\n/* ── New Flipkart-style product card ───────────────────── */\n.product-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  width: 100%;\n  max-width: 360px;\n  position: relative;\n  overflow: hidden;\n  box-shadow: var(--shadow-card);\n  transition: transform 300ms var(--ease-out-expo), box-shadow 300ms var(--ease-out-expo);\n}\n\n.product-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 12px 32px rgba(1, 13, 33,0.14), 0 0 0 1px rgba(1, 13, 33,0.06);\n}\n\n[data-theme=\"dark\"] .product-card:hover {\n  box-shadow: 0 12px 32px rgba(1, 13, 33,0.45);\n}\n\n/* Image section */\n.card-img-wrap {\n  position: relative;\n  background: var(--bg-tertiary);\n  height: 210px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px;\n  overflow: hidden;\n}\n\n.card-img-wrap img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  transition: transform 300ms ease;\n}\n\n.product-card:hover .card-img-wrap img {\n  transform: scale(1.05);\n}\n\n/* Wishlist heart */\n.card-wishlist {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  font-size: 1.05rem;\n  color: var(--text-tertiary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: var(--shadow-sm);\n  z-index: 2;\n  transition: color 180ms, transform 180ms;\n  line-height: 1;\n}\n\n.card-wishlist:hover { color: var(--danger); transform: scale(1.15); }\n\n/* Low-stock ribbon */\n.card-stock-ribbon {\n  position: absolute;\n  top: 10px;\n  left: 0;\n  background: var(--color-primary);\n  color: var(--color-text-on-primary);\n  font-size: 0.68rem;\n  font-weight: 700;\n  padding: 3px 10px 3px 8px;\n  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;\n  z-index: 2;\n  letter-spacing: 0.03em;\n}\n\n/* Out-of-stock overlay */\n.card-oos-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(255,255,255,0.65);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3;\n}\n\n[data-theme=\"dark\"] .card-oos-overlay { background: rgba(1, 13, 33,0.65); }\n\n.card-oos-overlay span {\n  background: var(--text-secondary);\n  color: var(--color-brand-white);\n  font-size: 0.78rem;\n  font-weight: 700;\n  padding: 5px 14px;\n  border-radius: var(--radius-xs);\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n/* Card body — must be position:relative so the hover section anchors to it */\n.card-body {\n  padding: 10px 12px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  flex: 1;\n  position: relative;\n}\n\n.card-title {\n  font-size: 0.88rem;\n  font-weight: 400;\n  color: var(--accent);\n  line-height: 1.4;\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  min-height: 2.5em;\n}\n\n[data-theme=\"dark\"] .card-title { color: var(--color-secondary-soft); }\n\n/* Rating row */\n.card-meta-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.card-rating-pill {\n  background: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n  font-size: 0.74rem;\n  font-weight: 700;\n  padding: 2px 7px;\n  border-radius: var(--radius-xs);\n  white-space: nowrap;\n  letter-spacing: 0.02em;\n}\n\n.card-review-cnt {\n  font-size: 0.78rem;\n  color: var(--text-tertiary);\n}\n\n.card-no-rating {\n  font-size: 0.78rem;\n  color: var(--text-tertiary);\n  font-style: italic;\n}\n\n.card-assured {\n  margin-left: auto;\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--accent);\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  white-space: nowrap;\n}\n\n[data-theme=\"dark\"] .card-assured { color: var(--color-secondary-soft); }\n\n/* Price row */\n.card-price-row {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin-top: 2px;\n}\n\n/* Tabular figures on money.\n   The default proportional digits give every price a different width, so a\n   grid of cards shows a ragged column of prices -- barely noticeable at\n   \"$12.99\" and very noticeable at \"SSP 150,228\", where the digits are most of\n   the string. tabular-nums makes every digit the same advance width, so\n   prices line up down a column and the eye can compare them. */\n.card-price,\n.card-mrp,\n.cat-carousel-price,\n.cat-carousel-price-sale,\n.cat-carousel-price-was,\n.detail-price,\n.cs-item-price,\n.cs-item-line-total,\n.admin-preview-price,\n.admin-price,\n.admin-product-price-cell,\n.dash-mini-price,\n.fi-price {\n  font-variant-numeric: tabular-nums;\n}\n\n.card-price {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  /* The currency code is joined to the digits by a non-breaking space (see\n     currency.js), so this only guards against a break inside the number\n     itself in a very narrow card. */\n  white-space: nowrap;\n}\n\n.card-mrp {\n  font-size: 0.8rem;\n  color: var(--text-tertiary);\n  text-decoration: line-through;\n}\n\n.card-off {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--color-secondary);\n}\n\n/* ── Hover-reveal section ──────────────────────────────────\n   Absolutely positioned so it slides up over the card bottom\n   without changing the card's height or touching the grid layout.\n   ─────────────────────────────────────────────────────────── */\n.card-hover-section {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--bg-secondary);\n  border-top: 1px solid var(--border);\n  padding: 10px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  transform: translateY(100%);\n  transition: transform 260ms var(--ease-out-expo);\n  z-index: 5;\n  box-shadow: 0 -4px 12px rgba(1, 13, 33,0.06);\n}\n\n.product-card:hover .card-hover-section {\n  transform: translateY(0);\n}\n\n.card-compare {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 0.82rem;\n  color: var(--text-secondary);\n  cursor: pointer;\n  user-select: none;\n}\n\n.card-compare input[type=\"checkbox\"] {\n  width: 14px;\n  height: 14px;\n  accent-color: var(--accent);\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n/* Color swatches */\n.card-swatches {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.color-swatch {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  border: 2px solid var(--border);\n  cursor: pointer;\n  display: inline-block;\n  transition: border-color 150ms, transform 150ms;\n  box-shadow: 0 1px 3px rgba(1, 13, 33,0.18);\n  flex-shrink: 0;\n}\n\n.color-swatch:hover {\n  border-color: var(--accent);\n  transform: scale(1.2);\n}\n\n/* Add to cart inside hover */\n.card-cart-btn {\n  width: 100%;\n  padding: 8px 12px;\n  font-size: 0.85rem;\n  border-radius: var(--radius-xs);\n}\n\n/* legacy selectors kept for cart panel etc. */\n.price {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.product-buttons {\n  display: flex;\n  gap: var(--space-1);\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.btn {\n  flex: 1;\n  min-width: 60px;\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: var(--radius-lg);\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  padding: 10px 12px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 0.85rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: transform 120ms ease, background 120ms ease, box-shadow 120ms ease;\n}\n\n.btn:hover {\n  transform: translateY(-2px);\n  background: var(--accent-hover);\n  box-shadow: 0 8px 16px rgba(59, 130, 246, 0.3);\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn.submit {\n  width: 100%;\n}\n\n.btn-spinner {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  margin-right: 8px;\n  border: 2px solid rgba(255,255,255,0.35);\n  border-top-color: var(--color-brand-white);\n  border-radius: 50%;\n  animation: spin 700ms linear infinite;\n  flex-shrink: 0;\n}\n\n.btn.danger {\n  background: var(--danger);\n}\n\n.btn.danger:hover {\n  background: var(--color-primary);\n}\n\n/* Cart Panel */\n.user-menu {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--border);\n}\n\n.user-menu .btn-text {\n  color: var(--text-primary);\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-sm);\n  padding: 10px 14px;\n  text-align: left;\n}\n\n.user-menu .btn-text:hover {\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n}\n\n.cart-items {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n\n.cart-item {\n  display: grid;\n  grid-template-columns: 88px 1fr auto;\n  gap: var(--space-2);\n  align-items: center;\n  padding: var(--space-2);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xl);\n  animation: slideIn 300ms ease-out;\n}\n\n.cart-item img {\n  width: 88px;\n  height: 88px;\n  object-fit: cover;\n  border-radius: var(--radius-xl);\n}\n\n.cart-item h3 {\n  margin: 0 0 6px;\n  font-size: 1rem;\n  color: var(--text-primary);\n}\n\n.cart-item p {\n  margin: 0 0 12px;\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.quantity-row {\n  display: inline-flex;\n  gap: var(--space-1);\n  align-items: center;\n}\n\n.quantity-row button {\n  width: 34px;\n  height: 34px;\n  border: 1px solid var(--border);\n  background: var(--bg-secondary);\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 700;\n  transition: all 120ms ease;\n}\n\n.quantity-row button:hover {\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  border-color: var(--accent);\n}\n\n.remove-button {\n  border: none;\n  background: transparent;\n  color: var(--danger);\n  font-weight: 700;\n  cursor: pointer;\n  font-size: 0.9rem;\n  padding: 6px;\n  border-radius: var(--radius-sm);\n  transition: all 120ms ease;\n}\n\n.remove-button:hover {\n  background: color-mix(in srgb, var(--danger) 10%, transparent);\n}\n\n.cart-summary {\n  display: grid;\n  gap: 12px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  padding: 18px;\n  border-radius: var(--radius-xl);\n  margin: 20px 0;\n  box-shadow: var(--shadow-card);\n}\n\n.cart-summary div {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.cart-summary span {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.cart-summary strong {\n  font-size: 1.1rem;\n  color: var(--text-primary);\n}\n\n/* Checkout Form */\n.checkout-form {\n  display: grid;\n  gap: 14px;\n}\n\n.checkout-form h3 {\n  margin: 0 0 12px;\n  font-size: 1.2rem;\n  color: var(--text-primary);\n}\n\n.checkout-form input,\n.checkout-form textarea {\n  width: 100%;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 14px 16px;\n  font-size: 0.98rem;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-family: inherit;\n}\n\n.checkout-form input:focus,\n.checkout-form textarea:focus {\n  border-color: var(--accent);\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.checkout-form textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n/* Alerts */\n.alert {\n  border-radius: var(--radius-xl);\n  padding: var(--space-2);\n  margin-top: 16px;\n  font-size: 0.95rem;\n  border: 1px solid transparent;\n  animation: slideIn 300ms ease-out;\n}\n\n.alert.danger {\n  background: color-mix(in srgb, var(--danger) 10%, transparent);\n  color: var(--danger);\n  border-color: color-mix(in srgb, var(--danger) 30%, transparent);\n}\n\n.alert.info {\n  background: rgba(59, 130, 246, 0.1);\n  color: var(--accent);\n  border-color: rgba(59, 130, 246, 0.3);\n}\n\n.alert.success {\n  background: rgba(59, 130, 246, 0.1);\n  color: var(--success);\n  border-color: rgba(59, 130, 246, 0.3);\n}\n\n/* App boot loader — full-screen branded spinner shown while the app\n   first initializes (auth check + minimum display time so it doesn't\n   just flash by). Not used for in-app page navigation. */\n.app-boot-loader {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 18px;\n  background: var(--bg-primary);\n  z-index: 9999;\n}\n\n/* Soft ambient halo pulsing behind the whole mark, in lockstep with the\n   arrow glow below -- adds depth around the icon as it brightens instead of\n   the glowing arrow being the only thing moving. */\n.acy-loader-halo {\n  position: absolute;\n  inset: -18%;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(255,140,26,0.35) 0%, rgba(56,189,248,0.18) 55%, transparent 75%);\n  filter: blur(10px);\n  animation: acy-loader-halo-pulse 1.6s ease-in-out infinite;\n}\n@keyframes acy-loader-halo-pulse {\n  0%, 100% { opacity: 0.35; transform: scale(0.88); }\n  50%      { opacity: 0.85; transform: scale(1.08); }\n}\n\n/* Loader arrow glow — the whole traced arrow curve (see LOADER_TRAIL_PATH\n   in Logo.js) breathes brighter and dimmer together, in lockstep with the\n   ambient halo above, rather than a small dash travelling along it. The\n   blurred glow layer's stroke-width pulses too so the light visibly swells\n   around the arrow at its brightest instead of just fading in place. */\n.acy-loader-arrow-glow {\n  stroke-width: 16px;\n  stroke-dasharray: 18 82;\n  animation: acy-loader-arrow-travel 1.7s linear infinite;\n}\n.acy-loader-arrow-core {\n  stroke-width: 5px;\n  stroke-dasharray: 12 88;\n  animation: acy-loader-arrow-travel 1.7s linear infinite;\n}\n@keyframes acy-loader-arrow-travel {\n  0%   { stroke-dashoffset: 20; opacity: 0; }\n  8%   { opacity: 1; }\n  90%  { opacity: 1; }\n  100% { stroke-dashoffset: -100; opacity: 0; }\n}\n@media (prefers-reduced-motion: reduce) {\n  .acy-loader-arrow-glow, .acy-loader-arrow-core { animation: none; stroke-dasharray: none; opacity: 0.45; }\n  .acy-loader-travel-spark { display: none; }\n}\n\n.abl-wordmark {\n  font-size: 1.3rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: var(--text-primary);\n}\n\n.abl-message {\n  font-size: 0.88rem;\n  color: var(--text-secondary);\n  margin: -8px 0 0;\n}\n\n/* Loading & Empty States */\n.loading,\n.empty-state {\n  padding: var(--space-4);\n  text-align: center;\n  border-radius: var(--radius-xl);\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  font-size: 1rem;\n}\n\n.loading::after {\n  content: '';\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  margin-left: 8px;\n  border: 3px solid rgba(59, 130, 246, 0.3);\n  border-top-color: var(--accent);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ── Auth Gate (checkout + page-level) ─────────────────────────── */\n.auth-gate-page {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  background: var(--bg-primary);\n  min-height: calc(100vh - 70px);\n}\n\n.auth-gate-box {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 36px 40px 32px;\n  width: 100%;\n  max-width: 460px;\n  box-shadow: 0 8px 32px rgba(1, 13, 33,0.10);\n  text-align: center;\n}\n\n.auth-gate-icon-wrap {\n  font-size: 2.4rem;\n  margin-bottom: 14px;\n  line-height: 1;\n}\n\n.auth-gate-box h2 {\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 8px;\n}\n\n.auth-gate-sub {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n  margin: 0 0 24px;\n  line-height: 1.55;\n}\n\n.auth-gate-tabs {\n  display: flex;\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n  border: 1px solid var(--border);\n  margin-bottom: 20px;\n}\n\n.auth-gate-tab {\n  flex: 1;\n  padding: 10px 14px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  background: var(--bg-primary);\n  color: var(--text-secondary);\n  border: none;\n  cursor: pointer;\n  transition: background 180ms, color 180ms;\n}\n\n.auth-gate-tab.active {\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n}\n\n/* --bg-tertiary, not --bg-card: there is no --bg-card token and never was, so\n   this declaration was invalid and dropped, and the tab had no hover state at\n   all. A var() naming something undefined fails silently -- the property is\n   simply discarded -- which is why this survived: nothing logs, nothing looks\n   obviously wrong, the hover just does nothing. --bg-tertiary is what the\n   other 38 hover backgrounds in this file use. */\n.auth-gate-tab:hover:not(.active) {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n.auth-gate-switch {\n  margin: 18px 0 0;\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n.auth-gate-switch button {\n  background: none;\n  border: none;\n  padding: 0;\n  color: var(--accent);\n  font-weight: 600;\n  font-size: inherit;\n  cursor: pointer;\n}\n.auth-gate-switch button:hover { text-decoration: underline; }\n\n@media (max-width: 640px) {\n  .auth-gate-page {\n    padding: 20px 12px;\n  }\n  .auth-gate-box {\n    padding: 28px 20px 24px;\n    max-width: 100%;\n    border-radius: var(--radius-md);\n  }\n}\n\n/* Strip the card wrapper from embedded login/register forms */\n.auth-gate-box .auth-page {\n  min-height: 0;\n  padding: 0;\n  background: transparent;\n}\n\n.auth-gate-divider {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 20px 0 4px;\n  color: var(--text-secondary);\n  font-size: 0.8rem;\n}\n.auth-gate-divider::before,\n.auth-gate-divider::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: var(--border);\n}\n\n.auth-gate-guest-btn {\n  width: 100%;\n  padding: 11px;\n  background: transparent;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n}\n.auth-gate-guest-btn:hover {\n  background: var(--bg-tertiary);\n  border-color: var(--text-secondary);\n}\n\n.auth-gate-box .auth-container {\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  padding: 0;\n  max-width: none;\n  box-shadow: none;\n}\n\n.auth-gate-box .auth-container h1 {\n  display: none;\n}\n\n/* Auth Pages */\n.auth-page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: calc(100vh - 80px);\n  padding: 20px;\n  background: var(--bg-primary);\n}\n\n.auth-container {\n  box-sizing: border-box;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: 28px;\n  padding: 40px;\n  width: 100%;\n  max-width: 420px;\n  box-shadow: var(--shadow-panel);\n}\n\n.auth-container h1 {\n  margin: 0 0 28px;\n  font-size: 1.8rem;\n  text-align: center;\n  color: var(--text-primary);\n}\n\n.auth-form {\n  display: grid;\n  gap: var(--space-2);\n}\n\n.auth-form input {\n  box-sizing: border-box;\n  width: 100%;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 14px 16px;\n  font-size: 1rem;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n}\n\n.auth-form input:focus {\n  border-color: var(--accent);\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n/* Show/hide eye toggle -- shared across every password field in the app\n   (see PasswordInput.js). The wrapper is a plain block so it takes on\n   whatever width/height the input inside it would have on its own; the\n   toggle button just needs the input's own right padding bumped enough to\n   clear the icon, regardless of which form's input styling is in play. */\n.pw-input-wrap { position: relative; display: block; width: 100%; }\n.pw-input-wrap input { width: 100%; box-sizing: border-box; padding-right: 42px; }\n.pw-toggle-btn {\n  position: absolute;\n  right: 6px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  padding: 6px;\n  cursor: pointer;\n  color: var(--text-muted);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: color 120ms ease, background 120ms ease;\n}\n.pw-toggle-btn:hover { color: var(--text-primary); background: var(--bg-tertiary); }\n\n.auth-forgot-link {\n  display: block;\n  margin: -6px 0 0;\n  background: none;\n  border: none;\n  color: var(--accent);\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  text-align: right;\n  padding: 4px 2px;\n  justify-self: end;\n}\n\n.auth-error {\n  background: color-mix(in srgb, var(--danger) 10%, transparent);\n  color: var(--danger);\n  border: 1px solid color-mix(in srgb, var(--danger) 30%, transparent);\n  border-radius: var(--radius-sm);\n  padding: 12px 14px;\n  font-size: 0.9rem;\n  animation: fieldErrorIn var(--motion-normal, 210ms) var(--motion-ease-enter, ease-out);\n}\n\n@keyframes fieldErrorIn {\n  from { opacity: 0; transform: translate3d(0, -4px, 0); }\n  to   { opacity: 1; transform: translate3d(0, 0, 0); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .auth-error { animation: none; }\n}\n\n.otp-sub {\n  margin: 0 0 20px;\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  text-align: center;\n  line-height: 1.5;\n}\n\n.otp-digit-row {\n  display: flex;\n  gap: clamp(5px, 2vw, 10px);\n  justify-content: center;\n  margin: 4px 0 16px;\n  width: 100%;\n}\n\n.otp-digit-box {\n  /* Fluid sizing (not a fixed 46px) so 6 boxes + their gaps always fit\n     within the narrowest phone viewport instead of overflowing the card --\n     scales down smoothly rather than needing a stack of breakpoints. The\n     28px floor (with the modal padding trimmed below) still leaves margin\n     to spare even inside the auth modal on a 320px-wide screen. */\n  width: clamp(28px, 9vw, 46px);\n  height: clamp(38px, 12vw, 56px);\n  min-width: 0;\n  text-align: center;\n  font-size: clamp(1rem, 4.5vw, 1.5rem);\n  font-weight: 700;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.otp-digit-box:focus {\n  border-color: var(--accent);\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.otp-digit-box-err {\n  border-color: var(--danger);\n}\n\n.otp-digit-box:disabled {\n  opacity: 0.6;\n}\n\n.otp-verifying {\n  text-align: center;\n  font-size: 0.82rem;\n  color: var(--text-tertiary);\n  margin: -4px 0 12px;\n}\n\n.otp-expiry {\n  text-align: center;\n  font-size: 0.8rem;\n  color: var(--text-tertiary);\n  margin: 0 0 14px;\n}\n\n.otp-expired {\n  color: var(--danger);\n  font-weight: 600;\n}\n\n.otp-verify-btn {\n  width: 100%;\n}\n\n.otp-info {\n  background: color-mix(in srgb, var(--success) 10%, transparent);\n  color: var(--success);\n  border: 1px solid color-mix(in srgb, var(--success) 30%, transparent);\n  border-radius: var(--radius-sm);\n  padding: 12px 14px;\n  font-size: 0.85rem;\n}\n\n.otp-resend-btn {\n  display: block;\n  width: 100%;\n  margin-top: 14px;\n  background: none;\n  border: none;\n  color: var(--accent);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  text-align: center;\n  padding: 6px;\n}\n.otp-resend-btn:disabled { color: var(--text-tertiary); cursor: default; }\n\n.otp-back-btn {\n  display: block;\n  width: 100%;\n  margin-top: 4px;\n  background: none;\n  border: none;\n  color: var(--text-tertiary);\n  font-size: 0.82rem;\n  cursor: pointer;\n  text-align: center;\n  padding: 6px;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(1, 13, 33, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: var(--bg-secondary);\n  border-radius: 28px;\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n  box-shadow: 0 25px 50px rgba(1, 13, 33, 0.3);\n}\n\n.modal-close {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  background: none;\n  border: none;\n  font-size: 1.8rem;\n  cursor: pointer;\n  color: var(--text-secondary);\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  transition: all 120ms ease;\n  z-index: 10;\n}\n\n.modal-close:hover {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n/* LoginPage/RegisterPage are also used as standalone full-height pages\n   elsewhere, so strip their page-level sizing when nested inside another\n   container -- otherwise .auth-page's min-height balloons the host to\n   near-viewport height.\n\n   Two hosts nest them: the auth modal, and the delivery agent sign-in card\n   (.dc-card). The delivery card was missing these overrides, which left an\n   860px .auth-page inside a card holding a ~300px form -- a dead gap under the\n   heading and a 1149px card that ran off a 900px viewport, so an agent had to\n   scroll before they could reach the password field.\n\n   They differ only in padding: the modal supplies none of its own, while\n   .dc-card already pads 40px, so there the nested page must add nothing. */\n.modal-content .auth-page,\n.dc-card .auth-page {\n  min-height: 0;\n  background: transparent;\n}\n\n.modal-content .auth-page { padding: 24px 28px 32px; }\n.dc-card .auth-page { padding: 0; }\n\n@media (max-width: 480px) {\n  .modal-overlay { padding: 10px; }\n  .modal-content .auth-page { padding: 20px 14px 24px; }\n}\n\n.modal-content .auth-container,\n.dc-card .auth-container {\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  padding: 0;\n  max-width: none;\n  box-shadow: none;\n}\n\n/* The card already carries its own \"Delivery Agent Sign In\" title in .dc-title,\n   so LoginPage's own <h1> repeats it -- and puts a second <h1> on the page. */\n.dc-card .auth-container > h1 { display: none; }\n\n/* Product Detail Page */\n.product-detail-page {\n  animation: slideIn 300ms ease-out;\n}\n\n.back-button {\n  background: none;\n  border: none;\n  color: var(--accent);\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 1rem;\n  padding: 8px 12px;\n  border-radius: var(--radius-sm);\n  transition: all 120ms ease;\n  margin-bottom: 20px;\n}\n\n.back-button:hover {\n  background: var(--bg-tertiary);\n  transform: translateX(-4px);\n}\n\n.product-detail-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 40px;\n  margin-bottom: 40px;\n  animation: slideIn 300ms ease-out;\n}\n\n.detail-image {\n  border-radius: var(--radius-xl);\n  overflow: hidden;\n  height: 400px;\n}\n\n.detail-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.detail-info {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.detail-label {\n  color: var(--accent);\n  font-weight: 700;\n  text-transform: uppercase;\n  font-size: 0.85rem;\n  letter-spacing: 0.5px;\n}\n\n.detail-info h1 {\n  margin: 0;\n  font-size: 2.2rem;\n  color: var(--text-primary);\n  line-height: 1.2;\n}\n\n.detail-rating {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.stars {\n  font-size: 1.2rem;\n  font-weight: 700;\n}\n\n.review-count {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.detail-description {\n  font-size: 1rem;\n  line-height: 1.6;\n  color: var(--text-secondary);\n}\n\n.detail-price {\n  font-size: 2rem;\n  font-weight: 800;\n  color: var(--accent);\n}\n\n/* Reviews Section */\n.reviews-section {\n  margin-top: 40px;\n  padding-top: 40px;\n  border-top: 1px solid var(--border);\n}\n\n.reviews-section h2 {\n  margin: 0 0 24px;\n  font-size: 1.6rem;\n  color: var(--text-primary);\n}\n\n.review-form {\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-xl);\n  padding: var(--space-3);\n  margin-bottom: 24px;\n  display: grid;\n  gap: var(--space-2);\n}\n\n.form-group {\n  display: grid;\n  gap: var(--space-1);\n}\n\n.form-group label {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-size: 0.9rem;\n}\n\n/* Muted \"(optional)\" / hint text inline in a field label. */\n.field-optional {\n  font-weight: 400;\n  color: var(--text-muted);\n  font-size: 0.8em;\n}\n\n.form-group select,\n.form-group textarea {\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 12px 14px;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 0.95rem;\n  font-family: inherit;\n}\n\n.reviews-list {\n  display: grid;\n  gap: var(--space-2);\n}\n\n.review-card {\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-lg);\n  padding: 18px;\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-card);\n}\n\n.review-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.review-header strong {\n  color: var(--text-primary);\n}\n\n.review-rating {\n  color: var(--color-primary);\n}\n\n.review-verified-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: var(--success);\n  background: color-mix(in srgb, var(--success) 12%, transparent);\n  border-radius: 999px;\n  padding: 2px 8px;\n}\n\n.review-card p {\n  margin: 0 0 12px;\n  color: var(--text-secondary);\n  line-height: 1.6;\n}\n\n.review-card small {\n  color: var(--text-tertiary);\n  font-size: 0.85rem;\n}\n\n/* Order History */\n.order-history-page,\n.wishlist-page {\n  animation: slideIn 300ms ease-out;\n}\n\n.order-history-page h1,\n.wishlist-page h1 {\n  margin: 0 0 28px;\n  font-size: 2rem;\n  color: var(--text-primary);\n}\n\n.orders-list {\n  display: grid;\n  gap: 18px;\n}\n\n.order-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xl);\n  padding: var(--space-3);\n  box-shadow: var(--shadow-card);\n  transition: all 200ms ease;\n}\n\n.order-card:hover {\n  box-shadow: 0 8px 24px rgba(1, 13, 33, 0.13), 0 0 0 1px rgba(1, 13, 33,0.05);\n  border-color: rgba(59, 130, 246,0.25);\n}\n\n[data-theme=\"dark\"] .order-card:hover {\n  box-shadow: 0 8px 24px rgba(1, 13, 33,0.4);\n  border-color: rgba(59, 130, 246,0.2);\n}\n\n.order-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 18px;\n  gap: var(--space-2);\n}\n\n.order-header h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  color: var(--text-primary);\n}\n\n.order-header p {\n  margin: 6px 0 0;\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.status,\n.order-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border-radius: var(--radius-xl);\n  font-weight: 600;\n  font-size: 0.85rem;\n  white-space: nowrap;\n  text-transform: capitalize;\n}\n\n.status::before,\n.order-status::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n  flex-shrink: 0;\n}\n\n.status-received {\n  background: color-mix(in srgb, var(--accent-secondary) 10%, transparent);\n  color: var(--accent-secondary);\n}\n\n.status-processing {\n  background: rgba(255, 103, 0, 0.1);\n  color: var(--color-primary);\n}\n\n.status-shipped {\n  background: rgba(59, 130, 246, 0.1);\n  color: var(--color-secondary);\n}\n\n.status-out_for_delivery {\n  background: rgba(59, 130, 246, 0.1);\n  color: var(--color-secondary);\n}\n\n.status-delivered {\n  background: color-mix(in srgb, var(--success) 10%, transparent);\n  color: var(--success);\n}\n\n.status-cancelled {\n  background: color-mix(in srgb, var(--danger) 10%, transparent);\n  color: var(--danger);\n}\n\n.status-refunded {\n  background: color-mix(in srgb, var(--accent-secondary) 10%, transparent);\n  color: var(--accent-secondary);\n}\n\n.status-exchanged {\n  background: color-mix(in srgb, var(--accent-secondary) 10%, transparent);\n  color: var(--accent-secondary);\n}\n\n.order-items {\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-lg);\n  padding: var(--space-2);\n  margin-bottom: 16px;\n  display: grid;\n  gap: 10px;\n}\n\n.order-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n  border-bottom: 1px solid var(--border);\n  font-size: 0.95rem;\n}\n\n.order-item:last-child {\n  border-bottom: none;\n}\n\n.order-footer {\n  text-align: right;\n  font-size: 1.1rem;\n  color: var(--text-primary);\n}\n\n/* ══════════════════════════════════════════════════════════════\n   ADMIN SHELL — sidebar + main layout\n   ══════════════════════════════════════════════════════════════ */\n\n.admin-shell {\n  display: flex;\n  height: 100vh;\n  overflow: hidden;\n  background: var(--bg-primary);\n}\n\n/* ── Sidebar ─────────────────────────────────────────────────── */\n.admin-sidebar {\n  width: 230px;\n  flex-shrink: 0;\n  /* Navy in both themes -- see .ann-bar for why this isn't --text-primary. */\n  background: var(--color-brand-navy);\n  border-right: none;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: none;\n  transition: width var(--motion-normal, 210ms) ease;\n}\n.admin-sidebar::-webkit-scrollbar { display: none; }\n\n.admin-sidebar-collapsed {\n  width: 64px;\n}\n\n.admin-sidebar-collapsed .admin-nav-label,\n.admin-sidebar-collapsed .admin-nav-spacer,\n.admin-sidebar-collapsed .admin-nav-count,\n.admin-sidebar-collapsed .admin-nav-badge {\n  display: none;\n}\n\n.admin-sidebar-collapsed .admin-nav-item {\n  justify-content: center;\n  padding: 12px 0;\n}\n\n.admin-sidebar-collapsed .admin-nav-icon {\n  width: 20px;\n  font-size: 1.2rem;\n}\n\n.admin-sidebar-toggle {\n  margin-left: auto;\n  background: rgba(255,255,255,0.06);\n  border: none;\n  color: rgba(255,255,255,0.7);\n  width: 26px; height: 26px;\n  border-radius: 7px;\n  display: flex; align-items: center; justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 150ms ease, color 150ms ease;\n}\n.admin-sidebar-toggle:hover { background: rgba(255,255,255,0.14); color: var(--color-brand-white); }\n.admin-sidebar-collapsed .admin-sidebar-toggle { margin-left: 0; }\n\n@media (prefers-reduced-motion: reduce) {\n  .admin-sidebar { transition: none; }\n}\n\n[data-theme=\"dark\"] .admin-sidebar { background: var(--color-brand-navy); }\n\n.admin-sidebar-brand {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 20px 16px 16px;\n  border-bottom: 1px solid rgba(255,255,255,0.08);\n}\n\n.admin-sidebar-collapsed .admin-sidebar-brand {\n  padding: 16px 8px;\n  flex-direction: column;\n  justify-content: center;\n  gap: 10px;\n}\n\n.admin-sidebar-logo-icon {\n  width: 40px;\n  height: 40px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 40px;\n  overflow: hidden;\n  border-radius: 9px;\n  background: var(--text-primary);\n  box-shadow: none;\n}\n\n[data-theme=\"dark\"] .admin-sidebar-logo-icon { background: var(--color-brand-navy); }\n\n.admin-sidebar-logo-icon img {\n  width: 38px !important;\n  height: 38px !important;\n  object-fit: contain;\n}\n\n.admin-sidebar-store {\n  font-weight: 700;\n  font-size: 1rem;\n  /* Sits on the always-navy sidebar, so it can't use a surface token that\n     resolves to a 9% white wash in dark mode. */\n  color: var(--color-on-navy);\n  margin: 0;\n}\n\n.admin-sidebar-role {\n  max-width: none;\n  font-size: 0.56rem;\n  line-height: 1.3;\n  color: rgba(255,255,255,0.45);\n  margin: 0;\n  text-transform: none;\n  letter-spacing: 0.015em;\n  white-space: nowrap;\n}\n\n.admin-sidebar:not(.admin-sidebar-collapsed) .admin-sidebar-toggle {\n  position: absolute;\n  top: 18px;\n  right: 10px;\n}\n\n/* ── Nav ─────────────────────────────────────────────────────── */\n.admin-nav {\n  flex: 1;\n  padding: 12px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.admin-nav-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: var(--radius-sm);\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: rgba(255,255,255,0.55);\n  font-size: 0.95rem;\n  font-weight: 600;\n  text-align: left;\n  transition: background 160ms ease, color 160ms ease;\n}\n\n.admin-nav-item:hover {\n  background: rgba(255,255,255,0.08);\n  color: rgba(255,255,255,0.9);\n}\n\n.admin-nav-item.active {\n  background: rgba(255,255,255,0.14);\n  color: var(--color-brand-white);\n  font-weight: 700;\n}\n\n.admin-nav-item.active .admin-nav-count,\n.admin-nav-item.active .admin-nav-badge {\n  background: rgba(255,255,255,0.25);\n  color: var(--color-brand-white);\n}\n\n.admin-nav-icon  { font-size: 1rem; flex-shrink: 0; width: 20px; text-align: center; }\n.admin-nav-label {\n  flex: 1 1 auto;\n  min-width: 0;\n  text-align: left;\n  line-height: 1.25;\n  white-space: normal;\n  overflow-wrap: normal;\n}\n.admin-nav-spacer { flex: 0 0 auto; margin-left: auto; }\n\n.admin-nav-item-long {\n  min-height: 48px;\n  align-items: flex-start;\n  padding-top: 9px;\n  padding-bottom: 9px;\n}\n\n.admin-nav-item-long .admin-nav-icon {\n  margin-top: 2px;\n}\n\n.admin-nav-item-long .admin-nav-label {\n  font-size: 0.9rem;\n  line-height: 1.28;\n}\n\n.admin-nav-item-long .admin-nav-count,\n.admin-nav-item-long .admin-nav-badge {\n  flex-shrink: 0;\n  margin-top: 0;\n}\n\n.admin-nav-count {\n  font-size: 0.72rem;\n  font-weight: 600;\n  background: rgba(255,255,255,0.12);\n  color: rgba(255,255,255,0.55);\n  border-radius: var(--radius-xl);\n  padding: 2px 7px;\n  min-width: 22px;\n  text-align: center;\n}\n\n.admin-nav-badge {\n  font-size: 0.7rem;\n  font-weight: 700;\n  background: var(--color-primary);\n  color: var(--color-text-on-primary);\n  border-radius: var(--radius-xl);\n  padding: 2px 7px;\n  min-width: 20px;\n  text-align: center;\n  animation: badge-pop 0.4s var(--ease-spring, ease) both;\n}\n\n/* ── Sidebar footer ──────────────────────────────────────────── */\n.admin-sidebar-footer {\n  padding: 8px 8px 12px;\n  border-top: 1px solid rgba(255,255,255,0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.admin-logout-item {\n  color: var(--color-primary) !important;\n}\n\n.admin-logout-item:hover {\n  background: rgba(255, 103, 0,0.15) !important;\n  color: var(--color-primary-soft) !important;\n}\n\n/* ── Main area ───────────────────────────────────────────────── */\n.admin-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.admin-page-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--space-2);\n  padding: 20px 28px 18px;\n  border-bottom: 1px solid var(--border);\n  background: var(--bg-secondary);\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  /* Prevent horizontal overflow during font metric shifts */\n  overflow-x: hidden;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* On the dark canvas the header bar takes the sidebar's navy. It shares\n * --bg-secondary with the cards, which is right in light mode -- both are\n * surfaces lifted off a grey page -- but on the dark canvas it put the strip\n * running along the top of every admin screen at exactly the card colour,\n * beside a sidebar that stays navy. Chrome and content read as the same\n * material.\n *\n * The cards keep --bg-secondary: they are content, and the difference is now\n * what separates them from the frame around them. The date picker, period\n * buttons and refresh button inside the bar keep it too, so they stop being\n * defined by their borders alone and lift off the navy as controls.\n *\n * The bottom hairline stays: the content behind the bar is navy as well, and\n * the rule is what marks where the frame ends. */\n[data-theme=\"dark\"] .admin-page-header { background: var(--color-brand-navy); }\n\n.admin-breadcrumb {\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n  margin: 0 0 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.admin-page-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.admin-refresh-btn {\n  width: 38px;\n  height: 38px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border);\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  font-size: 1.1rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: var(--shadow-card);\n  transition: background 160ms ease, color 160ms ease, transform 200ms var(--ease-spring, ease);\n}\n\n.admin-refresh-btn:hover { background: var(--accent); color: var(--color-text-on-secondary); }\n.admin-refresh-btn.spinning { animation: spin 700ms linear infinite; }\n\n@keyframes spin { to { transform: rotate(360deg); } }\n\n/* ── Responsive adjustments for admin header ────────────────────── */\n/* Prevent layout shift on narrow screens when elements wrap */\n@media (max-width: 1024px) {\n  .admin-header-actions {\n    max-width: 100%;\n  }\n  \n  .ov-date-range {\n    min-width: auto;\n    max-width: 180px;\n    font-size: 0.75rem;\n    padding: 6px 10px;\n  }\n  \n  .ov-period-btns {\n    max-width: none;\n  }\n  \n  .ov-period-btn {\n    padding: 6px 11px;\n    min-width: 32px;\n    font-size: 0.75rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .admin-page-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n  \n  .admin-header-actions {\n    order: 3;\n    justify-content: flex-end;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n}\n\n.admin-content {\n  flex: 1;\n  overflow-y: auto;\n  scrollbar-width: none;\n  padding: 24px 28px 40px;\n\n  /* Shared design tokens for the admin redesign rollout (Add Product,\n     Commission & Tax, ...) -- declared once here so every admin page can\n     opt into the same look via new component classes without redeclaring\n     these. Values match the exact spec supplied for the Add Product page. */\n  --pf-primary: var(--color-secondary);\n  --pf-primary-dark: var(--color-secondary-hover);\n  --pf-primary-soft: var(--color-secondary-soft);\n  --pf-focus-ring: rgba(59, 130, 246, 0.16);\n  --pf-field-bg: var(--bg-tertiary);\n  --pf-heading: var(--text-primary);\n  --pf-label: var(--text-secondary);\n  --pf-text: var(--text-secondary);\n  --pf-muted: var(--text-muted);\n  --pf-divider: var(--border);\n  --pf-danger: var(--color-primary);\n  --pf-success: var(--color-secondary);\n  --pf-info: var(--color-secondary);\n  --pf-info-soft: var(--color-secondary-soft);\n  --pf-positive: var(--color-secondary);\n  --pf-positive-soft: var(--color-secondary-soft);\n  --pf-card-radius: 16px;\n  --pf-field-radius: 10px;\n  --pf-field-height: 56px;\n  --pf-card-shadow: 0 3px 10px rgba(16,24,40,0.07), 0 1px 2px rgba(16,24,40,0.04);\n}\n.admin-content::-webkit-scrollbar { display: none; }\n:root[data-theme=\"dark\"] .admin-content {\n  --pf-primary: var(--color-secondary);\n  --pf-primary-dark: var(--color-secondary);\n  --pf-primary-soft: rgba(91,147,255,0.16);\n  --pf-focus-ring: rgba(91,147,255,0.28);\n  --pf-field-bg: var(--color-brand-navy);\n  --pf-heading: var(--bg-tertiary);\n  --pf-label: var(--border);\n  --pf-text: var(--border-strong);\n  --pf-muted: var(--text-muted);\n  --pf-divider: var(--text-secondary);\n  --pf-danger: var(--color-primary);\n  --pf-success: var(--color-secondary);\n  --pf-info: var(--color-secondary);\n  --pf-info-soft: rgba(59, 130, 246,0.16);\n  --pf-positive: var(--color-secondary);\n  --pf-positive-soft: rgba(59, 130, 246, 0.16);\n  --pf-card-shadow: 0 2px 10px rgba(1, 13, 33,0.35);\n}\n\n/* Shown on every tab when the logged-in admin hasn't enabled 2FA yet --\n   requireAdmin.js blocks nearly every admin API call in that state, so\n   without this the dashboard just silently shows zeros/empty everywhere\n   with no explanation. */\n.admin-2fa-banner {\n  display: flex; align-items: center; gap: 14px;\n  background: color-mix(in srgb, var(--color-primary) 12%, var(--bg-secondary));\n  border: 1px solid color-mix(in srgb, var(--color-primary) 35%, var(--border));\n  border-radius: 12px;\n  padding: 14px 18px;\n  margin-bottom: 20px;\n  color: var(--text-primary);\n}\n.admin-2fa-banner-icon { color: var(--color-primary); flex-shrink: 0; }\n.admin-2fa-banner-text { flex: 1; font-size: 0.88rem; line-height: 1.5; }\n.admin-2fa-banner-text strong { display: block; margin-bottom: 2px; }\n.admin-2fa-banner-btn {\n  flex-shrink: 0; background: var(--color-primary); color: #1a1200; border: none;\n  font-weight: 700; font-size: 0.82rem; padding: 9px 16px; border-radius: 8px;\n  cursor: pointer; white-space: nowrap; transition: filter 0.15s;\n}\n.admin-2fa-banner-btn:hover { filter: brightness(1.08); }\n\n/* ── Section utils ───────────────────────────────────────────── */\n/* fill-mode deliberately NOT \"both\" -- fade-up's keyframes animate\n   transform, and \"both\"/\"forwards\" would permanently persist the final\n   `transform: translateY(0)` on this element even after the 260ms\n   animation ends. Per the CSS spec, ANY non-none transform on an ancestor\n   (even a visual no-op like translateY(0)) makes it a containing block for\n   position:fixed descendants -- trapping every modal rendered inside an\n   .admin-section (there are ~9 in AdminDashboard.js) inside this element's\n   box instead of the real viewport, so its full-screen backdrop and\n   centering never actually covered the screen. Dropping the fill-mode is\n   visually identical (the element's un-animated resting state is already\n   opacity:1/transform:none, matching fade-up's \"to\" keyframe) but lets\n   `transform` genuinely resolve back to `none` once the animation ends. */\n.admin-section {\n  animation: fade-up 260ms var(--ease-out-expo, ease);\n}\n\n.admin-section-heading {\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 28px 0 14px;\n  padding-top: 20px;\n  border-top: 1px solid var(--border);\n}\n\n.admin-form-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 20px 22px;\n  margin-bottom: 20px;\n  box-shadow: var(--shadow-card);\n}\n\n/* ── Store Information (Settings tab) ──────────────────────────── */\n.si-field-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 14px 16px;\n}\n.si-field { display: flex; flex-direction: column; gap: 5px; min-width: 0; }\n.si-field-full { grid-column: 1 / -1; }\n.si-label { font-size: 0.82rem; font-weight: 600; color: var(--text-secondary); }\n.si-input {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 10px 12px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  font-family: inherit;\n}\n.si-input::placeholder { color: var(--text-muted); }\n.si-input:focus { outline: none; border-color: var(--accent); }\n@media (max-width: 640px) {\n  .si-field-grid { grid-template-columns: 1fr; }\n}\n\n/* ── Add Product: live preview ─────────────────────────────────── */\n.admin-product-form-layout {\n  display: grid;\n  grid-template-columns: 1fr 300px;\n  gap: 20px;\n  align-items: start;\n}\n\n.admin-product-form-main {\n  min-width: 0;\n}\n\n.admin-banner-form-layout {\n  display: grid;\n  grid-template-columns: 1fr 420px;\n  gap: 20px;\n  align-items: start;\n}\n\n.admin-banner-form-main {\n  min-width: 0;\n}\n\n.admin-banner-preview-card .carousel-slide {\n  width: 100%;\n}\n\n.admin-preview-card {\n  background: var(--bg-primary);\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  padding: 16px;\n  position: sticky;\n  top: 16px;\n}\n\n.admin-preview-label {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 3px;\n}\n\n.admin-preview-sub {\n  font-size: 0.74rem;\n  color: var(--text-secondary);\n  margin: 0 0 12px;\n}\n\n.admin-preview-img-wrap {\n  position: relative;\n  background: var(--bg-tertiary);\n  border-radius: 10px;\n  height: 180px;\n  overflow: hidden;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.admin-preview-badge {\n  position: absolute;\n  top: 10px;\n  left: 0;\n  background: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n  font-size: 0.68rem;\n  font-weight: 800;\n  padding: 4px 10px 4px 8px;\n  border-radius: 0 8px 8px 0;\n  z-index: 2;\n  letter-spacing: 0.04em;\n}\n\n.admin-preview-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  padding: 8px;\n}\n\n.admin-preview-img-empty {\n  font-size: 2.6rem;\n  opacity: 0.35;\n}\n\n.admin-preview-info { display: flex; flex-direction: column; gap: 5px; }\n\n.admin-preview-cat {\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--accent);\n  margin: 0;\n}\n\n.admin-preview-name {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n  line-height: 1.3;\n}\n\n.admin-preview-price-row {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.admin-preview-price {\n  font-size: 1.3rem;\n  font-weight: 800;\n  color: var(--text-primary);\n}\n\n.admin-preview-compare {\n  font-size: 0.82rem;\n  color: var(--text-tertiary);\n  text-decoration: line-through;\n}\n\n.admin-preview-off {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--color-secondary);\n  background: rgba(59, 130, 246,0.1);\n  padding: 2px 7px;\n  border-radius: 5px;\n}\n\n.admin-preview-stock { font-size: 0.78rem; font-weight: 700; margin: 4px 0 0; }\n.admin-stock-in  { color: var(--color-secondary); }\n.admin-stock-out { color: var(--color-primary); }\n\n@media (max-width: 900px) {\n  .admin-product-form-layout, .admin-banner-form-layout { grid-template-columns: 1fr; }\n  .admin-preview-card { position: static; }\n}\n\n/* ── Add Product: image upload dropzone ──────────────────────────── */\n.admin-dropzone {\n  border: 2px dashed var(--border);\n  border-radius: 12px;\n  padding: 24px 20px;\n  text-align: center;\n  cursor: pointer;\n  transition: border-color 0.2s, background 0.2s;\n  background: var(--bg-primary);\n}\n.admin-dropzone:hover { border-color: var(--accent); background: rgba(59, 130, 246,0.03); }\n.admin-dropzone-over {\n  border-color: var(--accent);\n  background: rgba(59, 130, 246,0.06);\n}\n.admin-dropzone-icon { font-size: 1.8rem; display: block; margin-bottom: 6px; }\n.admin-dropzone-text { font-size: 0.85rem; color: var(--text-secondary); margin: 0 0 4px; }\n.admin-dropzone-link { color: var(--accent); font-weight: 600; text-decoration: underline; cursor: pointer; }\n.admin-dropzone-hint { font-size: 0.74rem; color: var(--text-tertiary); margin: 0; }\n\n.admin-images-label {\n  font-size: 0.82rem;\n  color: var(--text-secondary);\n  margin: 4px 0 0;\n}\n.admin-images-label span { color: var(--text-tertiary); font-size: 0.76rem; }\n\n.admin-image-grid {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-top: 4px;\n}\n\n.admin-img-slot {\n  position: relative;\n  width: 96px;\n  border-radius: 10px;\n  border: 2px solid var(--border);\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.admin-img-slot-primary {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 2px rgba(59, 130, 246,0.3);\n}\n\n.admin-img-thumb {\n  width: 100%;\n  height: 80px;\n  object-fit: cover;\n  display: block;\n  border-radius: 8px 8px 0 0;\n}\n\n.admin-img-view-select {\n  width: 100%;\n  font-size: 0.6rem;\n  border: none;\n  border-top: 1px solid var(--border);\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  padding: 3px 4px;\n  cursor: pointer;\n  text-align: center;\n  outline: none;\n  flex-shrink: 0;\n}\n.admin-img-view-select:hover { background: var(--bg-tertiary); }\n\n.admin-img-cover-badge {\n  position: absolute;\n  top: 4px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  font-size: 0.62rem;\n  font-weight: 700;\n  padding: 2px 7px;\n  border-radius: 4px;\n  white-space: nowrap;\n  letter-spacing: 0.04em;\n}\n\n.admin-img-remove {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: rgba(1, 13, 33,0.65);\n  border: none;\n  color: var(--color-brand-white);\n  font-size: 0.65rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.15s;\n}\n.admin-img-slot:hover .admin-img-remove { opacity: 1; }\n\n.admin-img-spinner {\n  position: absolute;\n  inset: 0;\n  background: rgba(1, 13, 33,0.4);\n  color: var(--color-brand-white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.4rem;\n  animation: spin 1s linear infinite;\n}\n\n.admin-img-error {\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: var(--color-primary);\n  color: var(--color-text-on-primary);\n  font-size: 0.75rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.admin-img-add {\n  width: 96px;\n  height: 96px;\n  border-radius: 10px;\n  border: 2px dashed var(--border);\n  background: var(--bg-primary);\n  cursor: pointer;\n  font-size: 1.6rem;\n  color: var(--text-tertiary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: border-color 0.15s, color 0.15s;\n  flex-shrink: 0;\n}\n.admin-img-add:hover { border-color: var(--accent); color: var(--accent); }\n\n/* ── Add Product: feature highlights editor ──────────────────────── */\n.admin-highlights-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.admin-highlight-row {\n  display: grid;\n  grid-template-columns: 170px 1fr 1fr 32px;\n  gap: 8px;\n  align-items: center;\n}\n\n.admin-highlight-icon-select {\n  width: 100%;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 9px 10px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 0.85rem;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.admin-highlight-remove {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: var(--bg-tertiary);\n  border: none;\n  color: var(--text-secondary);\n  font-size: 0.75rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.admin-highlight-remove:hover { background: var(--color-primary); color: var(--color-text-on-primary); }\n\n.admin-highlight-add {\n  align-self: flex-start;\n  font-size: 0.82rem !important;\n  padding: 6px 12px !important;\n}\n\n@media (max-width: 700px) {\n  .admin-highlight-row { grid-template-columns: 1fr; }\n}\n\n/* ── Add Product: specifications editor ──────────────────────────── */\n.admin-spec-template-btn {\n  align-self: flex-start;\n  font-size: 0.82rem !important;\n  padding: 6px 12px !important;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.admin-spec-row {\n  display: grid;\n  grid-template-columns: 150px 1fr 1fr 32px;\n  gap: 8px;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.admin-spec-row input[type=\"text\"] {\n  width: 100%;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 9px 10px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 0.85rem;\n  font-family: inherit;\n  box-sizing: border-box;\n}\n\n.admin-spec-group-input { font-weight: 600; }\n\n@media (max-width: 700px) {\n  .admin-spec-row { grid-template-columns: 1fr; }\n}\n\n.banner-feature-row {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin-bottom: 8px;\n}\n.banner-feature-row input { flex: 1; }\n\n/* ── Add Product: sectioned form (mirrors seller's Add Product) ──── */\n.admin-pf-section {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  padding: 20px 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  margin-bottom: 14px;\n  box-shadow: var(--shadow-card);\n}\n\n.admin-pf-section-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 2px;\n}\n\n.admin-pf-section-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 9px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  flex-shrink: 0;\n}\n\n.admin-pf-section-sub {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  margin: -8px 0 4px;\n}\n\n.admin-pf-field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.admin-pf-label {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.admin-pf-req { color: var(--color-primary); }\n\n.admin-pf-input,\n.admin-pf-textarea {\n  width: 100%;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 10px 12px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  font-family: inherit;\n  box-sizing: border-box;\n}\n\n/* `min-height: 80px` and `resize` used to live in the shared block above,\n   which meant every single-line <input class=\"admin-pf-input\"> rendered at\n   textarea height with a resize affordance it can't even use. Nearly every\n   admin form was already papering over it with its own min-height override\n   (see .admin-banner-editor-compact, .admin-pf-card-v2,\n   .admin-product-editor-compact) -- the forms that didn't, like the Add\n   Delivery Agent modal, ended up with 80px-tall name and email boxes.\n\n   Scoped by element rather than class so a <textarea> still gets the\n   intended height whichever of the two classes it happens to carry. */\ntextarea.admin-pf-input,\n.admin-pf-textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n/* Native <option> popups don't inherit the <select>'s background in most\n   browsers -- they fall back to the OS's own white listbox, which leaves\n   dark-mode text (light-on-white) unreadable unless set explicitly here. */\n.admin-pf-input option { background: var(--bg-primary); color: var(--text-primary); }\n\n/* ── Add Delivery Agent modal ──────────────────────────────────────\n   Replaces a form built entirely from inline styles. Beyond being hard to\n   read, that version had no header treatment, no close button, and inherited\n   the 80px textarea min-height above, so the name/email fields rendered as\n   tall empty boxes. Kept theme-reactive (var(--bg-*)) rather than following\n   .admin-modal-panel's fixed-dark identity, because this modal opens over\n   the light Super Admin content area, not the dark sidebar. */\n.dagent-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(1, 13, 33, 0.5);\n  backdrop-filter: blur(2px);\n  z-index: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n.dagent-modal {\n  background: var(--bg-primary);\n  border: 1px solid var(--border);\n  border-radius: 18px;\n  width: 100%;\n  max-width: 430px;\n  box-shadow: 0 24px 64px rgba(1, 13, 33, 0.28);\n  overflow: hidden;\n}\n.dagent-head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 20px 22px 16px;\n  border-bottom: 1px solid var(--border);\n}\n.dagent-head-icon {\n  width: 38px;\n  height: 38px;\n  flex-shrink: 0;\n  border-radius: 10px;\n  background: rgba(59, 130, 246, 0.1);\n  color: var(--accent);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.dagent-head-text { flex: 1; min-width: 0; }\n.dagent-title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  line-height: 1.3;\n}\n.dagent-sub {\n  margin: 2px 0 0;\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n}\n.dagent-close {\n  flex-shrink: 0;\n  width: 30px;\n  height: 30px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-muted);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 140ms ease, color 140ms ease;\n}\n.dagent-close:hover:not(:disabled) { background: var(--bg-tertiary); color: var(--text-primary); }\n.dagent-close:disabled { opacity: 0.45; cursor: not-allowed; }\n\n.dagent-body {\n  padding: 18px 22px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.dagent-field { display: flex; flex-direction: column; gap: 6px; }\n.dagent-label {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n/* The leading icon sits in the wrapper rather than the input so it stays put\n   while the input keeps full-width behaviour and its own focus ring. */\n.dagent-input-wrap { position: relative; display: block; }\n.dagent-input-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  /* --text-muted is the same grey as the placeholder, which left these\n     1.5px-stroke glyphs barely legible against the field. --text-secondary\n     separates the icon from the placeholder text beside it. */\n  color: var(--text-secondary);\n  display: flex;\n  pointer-events: none;\n  transition: color 140ms ease;\n}\n/* Sharpen the active field's icon along with its border. */\n.dagent-input-wrap:focus-within .dagent-input-icon { color: var(--accent); }\n.dagent-input-wrap input {\n  width: 100%;\n  box-sizing: border-box;\n  height: 44px;\n  min-height: 0;\n  padding: 0 12px 0 38px;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  font-family: inherit;\n  transition: border-color 140ms ease, box-shadow 140ms ease;\n}\n.dagent-input-wrap input::placeholder { color: var(--text-muted); }\n.dagent-input-wrap input:hover:not(:focus) { border-color: var(--text-muted); }\n.dagent-input-wrap input:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n/* Password field: PasswordInput renders its own .pw-input-wrap around the\n   input, so the icon padding and the eye button have to coexist. */\n.dagent-input-wrap .pw-input-wrap input { padding-right: 42px; }\n\n.dagent-error {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin: 0;\n  padding: 9px 11px;\n  border-radius: 9px;\n  background: rgba(255, 103, 0, 0.08);\n  border: 1px solid rgba(255, 103, 0, 0.25);\n  color: var(--color-primary);\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.dagent-foot {\n  display: flex;\n  gap: 10px;\n  padding: 0 22px 20px;\n}\n.dagent-btn {\n  height: 42px;\n  border-radius: 10px;\n  font-size: 0.88rem;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 140ms ease, border-color 140ms ease, opacity 140ms ease;\n}\n.dagent-btn:disabled { opacity: 0.6; cursor: not-allowed; }\n.dagent-btn-cancel {\n  flex: 0 0 auto;\n  padding: 0 18px;\n  border: 1px solid var(--border);\n  background: transparent;\n  color: var(--text-secondary);\n}\n.dagent-btn-cancel:hover:not(:disabled) { background: var(--bg-tertiary); color: var(--text-primary); }\n/* The primary action takes the remaining width so the pair reads as one\n   bar and the destructive-free default is the obvious target. */\n.dagent-btn-submit {\n  flex: 1;\n  border: none;\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n}\n.dagent-btn-submit:hover:not(:disabled) { background: var(--accent-dark, var(--color-secondary-hover)); }\n\n@media (max-width: 480px) {\n  .dagent-foot { flex-direction: column-reverse; }\n  .dagent-btn-cancel { flex: 1 1 auto; width: 100%; }\n}\n\n/* ── \"Add Admin\" modal ────────────────────────────────────────────\n   Deliberately fixed-dark rather than theme-reactive (var(--bg-*)) --\n   matches the existing .admin-sidebar, which is likewise a hardcoded\n   var(--text-primary) regardless of the site's light/dark toggle. This is an\n   admin-only surface with its own settled dark identity, not a\n   customer-facing one that needs to flip with the theme switch. */\n.admin-modal-panel {\n  background: var(--color-brand-navy);\n  border: 1px solid rgba(255,255,255,0.08);\n  border-radius: 20px;\n  padding: 32px;\n  width: 100%;\n  /* Widened from 480px to fit the two-column field grid below. In one\n     column the Add Admin form ran past the viewport, and because the whole\n     panel was the scroll container the Cancel/Create buttons sat below the\n     fold -- the modal opened with no visible way to submit it. */\n  max-width: 620px;\n  box-shadow: 0 24px 70px rgba(1, 13, 33,0.5);\n  max-height: calc(100vh - 32px);\n  /* Scroll the body instead of the panel so the header and footer stay put\n     however long the form gets. */\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.admin-modal-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 28px;\n}\n.admin-modal-icon-badge {\n  flex-shrink: 0;\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  background: rgba(59,130,246,0.15);\n  color: var(--color-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.admin-modal-header-text { flex: 1; min-width: 0; }\n.admin-modal-header-text h3 {\n  margin: 0;\n  font-size: 1.4rem;\n  font-weight: 800;\n  color: var(--color-brand-white);\n  letter-spacing: -0.01em;\n}\n.admin-modal-header-text p {\n  margin: 6px 0 0;\n  font-size: 0.9rem;\n  color: var(--text-muted);\n  line-height: 1.4;\n}\n.admin-modal-close {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  border: 1px solid rgba(255,255,255,0.12);\n  background: transparent;\n  color: var(--border-strong);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 150ms, border-color 150ms;\n}\n.admin-modal-close:hover { background: rgba(255,255,255,0.06); border-color: rgba(255,255,255,0.22); }\n\n.admin-modal-body {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  /* min-height:0 lets this shrink inside the flex panel so it -- not the\n     panel -- is what scrolls. Without it a flex child refuses to go below\n     its content height and the footer gets pushed off-screen again. */\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  /* Room for the focus ring, which would otherwise be clipped by the\n     scroll container's edge. */\n  padding: 3px;\n  margin: -3px;\n}\n.admin-modal-field label {\n  display: block;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: var(--border);\n  margin-bottom: 8px;\n}\n.admin-modal-field input,\n.admin-modal-field select {\n  width: 100%;\n  box-sizing: border-box;\n  background: rgba(255,255,255,0.03);\n  border: 1px solid rgba(255,255,255,0.12);\n  border-radius: 12px;\n  padding: 13px 15px;\n  font-size: 0.95rem;\n  font-family: inherit;\n  color: var(--color-brand-white);\n  transition: border-color 150ms, box-shadow 150ms;\n}\n/* `width: 100%` above was written for text fields, but it also caught the\n   Granted Areas checkboxes -- stretching each one into a ~360px-wide box\n   that shoved its label to the far right and wrapped it onto two lines. */\n.admin-modal-field input[type=\"checkbox\"] {\n  width: auto;\n  padding: 0;\n}\n.admin-modal-field input::placeholder { color: var(--text-secondary); }\n.admin-modal-field input:focus,\n.admin-modal-field select:focus {\n  outline: none;\n  border-color: var(--color-secondary);\n  box-shadow: 0 0 0 3px rgba(59,130,246,0.25);\n}\n.admin-modal-field select option { background: var(--color-brand-navy); color: var(--color-brand-white); }\n\n/* Two-column field grid. Collapses to one column on narrow viewports, where\n   side-by-side fields would be too cramped to read. */\n.admin-modal-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 18px;\n}\n.admin-modal-field--full { grid-column: 1 / -1; }\n@media (max-width: 560px) {\n  .admin-modal-grid { grid-template-columns: 1fr; }\n}\n\n/* Leading icons. The icon lives in the wrapper rather than the field so the\n   input keeps its own full-width sizing and focus ring. */\n.admin-modal-input-wrap { position: relative; display: block; }\n.admin-modal-input-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-muted);\n  display: flex;\n  pointer-events: none;\n  transition: color 150ms;\n}\n.admin-modal-input-wrap:focus-within .admin-modal-input-icon { color: var(--color-secondary); }\n.admin-modal-input-wrap input { padding-left: 42px; }\n/* PasswordInput nests its own wrapper and eye button inside this one. */\n.admin-modal-input-wrap .pw-input-wrap input { padding-right: 44px !important; }\n\n/* Sub-label under a field heading. Sits between the bold <label> and the\n   control, so its top margin cancels the label's bottom margin. */\n.admin-modal-hint {\n  margin: -4px 0 10px;\n  font-size: 0.82rem;\n  color: var(--text-muted);\n  line-height: 1.4;\n}\n\n/* Granted-areas picker, shared by the Add Admin and Edit Access modals so\n   the same choice looks the same in both. The whole tile is the label, which\n   gives a much larger hit target than a bare 13px checkbox. */\n.admin-area-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n@media (max-width: 560px) {\n  .admin-area-grid { grid-template-columns: 1fr; }\n}\n/* Scoped under .admin-area-grid purely for specificity: a bare\n   `.admin-area-tile` (0,1,0) loses to `.admin-modal-field label` (0,1,1),\n   which would force display:block and drop each label onto its own line\n   below the checkbox. Tiles only ever live inside the grid, so this costs\n   nothing. */\n.admin-area-grid .admin-area-tile {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  padding: 13px 14px;\n  border: 1px solid rgba(255,255,255,0.12);\n  border-radius: 12px;\n  background: rgba(255,255,255,0.02);\n  cursor: pointer;\n  transition: border-color 150ms, background 150ms;\n  /* Also overrides that rule's bold/blocky label treatment. */\n  font-size: 0.88rem;\n  font-weight: 500;\n  color: var(--border-strong);\n  margin-bottom: 0;\n  line-height: 1.35;\n}\n.admin-area-grid .admin-area-tile:hover { border-color: rgba(255,255,255,0.24); background: rgba(255,255,255,0.04); }\n.admin-area-grid .admin-area-tile--on {\n  border-color: rgba(59,130,246,0.55);\n  background: rgba(59,130,246,0.1);\n  color: var(--color-brand-white);\n}\n/* Drawn rather than left native. accent-color only recolours the *checked*\n   fill -- an unchecked native checkbox keeps its white UA background, which\n   on this near-black panel read as four glaring white squares. appearance:\n   none lets the unchecked state be a soft outline instead, and the tick is\n   a rotated CSS border so there's no SVG to keep in sync with the state. */\n.admin-area-tile input[type=\"checkbox\"] {\n  appearance: none;\n  -webkit-appearance: none;\n  flex-shrink: 0;\n  width: 17px;\n  height: 17px;\n  margin: 0;\n  border: 1.5px solid rgba(255,255,255,0.28);\n  border-radius: 5px;\n  background: rgba(255,255,255,0.04);\n  display: grid;\n  place-content: center;\n  cursor: pointer;\n  transition: background 140ms, border-color 140ms;\n}\n.admin-area-tile input[type=\"checkbox\"]:hover { border-color: rgba(255,255,255,0.45); }\n.admin-area-tile input[type=\"checkbox\"]:checked {\n  background: var(--color-secondary-hover);\n  border-color: var(--color-secondary-hover);\n}\n.admin-area-tile input[type=\"checkbox\"]:checked::after {\n  content: '';\n  width: 9px;\n  height: 5px;\n  border-left: 2px solid var(--color-brand-white);\n  border-bottom: 2px solid var(--color-brand-white);\n  transform: rotate(-45deg) translate(1px, -2px);\n}\n.admin-area-grid .admin-area-tile:focus-within { border-color: var(--color-secondary); box-shadow: 0 0 0 3px rgba(59,130,246,0.25); }\n\n.admin-modal-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: rgba(255, 103, 0,0.1);\n  border: 1px solid rgba(255, 103, 0,0.3);\n  color: var(--color-primary-soft);\n  font-size: 0.85rem;\n}\n\n.admin-modal-footer {\n  display: flex;\n  gap: 12px;\n  margin-top: 28px;\n  padding-top: 24px;\n  border-top: 1px solid rgba(255,255,255,0.08);\n}\n.admin-modal-btn-cancel {\n  flex: 0 0 auto;\n  min-width: 120px;\n  padding: 14px 20px;\n  border-radius: 12px;\n  border: 1px solid rgba(255,255,255,0.14);\n  background: transparent;\n  color: var(--border);\n  font-weight: 700;\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: background 150ms;\n}\n.admin-modal-btn-cancel:hover { background: rgba(255,255,255,0.06); }\n.admin-modal-btn-submit {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 14px 20px;\n  border-radius: 12px;\n  border: none;\n  background: var(--color-secondary-hover);\n  color: var(--color-text-on-secondary);\n  font-weight: 700;\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: background 150ms;\n}\n.admin-modal-btn-submit:hover:not(:disabled) { background: var(--color-secondary-hover); }\n.admin-modal-btn-submit:disabled,\n.admin-modal-btn-cancel:disabled { opacity: 0.55; cursor: not-allowed; }\n\n.admin-pf-char-count {\n  font-size: 0.72rem;\n  color: var(--text-tertiary);\n  text-align: right;\n  margin-top: 4px;\n}\n\n.admin-pf-row-3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; }\n.admin-pf-row-2 { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; }\n\n.admin-pf-price-wrap {\n  display: flex;\n  align-items: center;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  overflow: hidden;\n  background: var(--bg-primary);\n  transition: border-color 0.15s;\n}\n.admin-pf-price-wrap:focus-within { border-color: var(--accent); }\n.admin-pf-price-sym {\n  padding: 0 8px;\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  background: var(--bg-tertiary);\n  border-right: 1px solid var(--border);\n  height: 100%;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  line-height: 36px;\n}\n.admin-pf-price-sym-r {\n  border-right: none;\n  border-left: 1px solid var(--border);\n}\n.admin-pf-price-input {\n  border: none !important;\n  border-radius: 0 !important;\n  background: transparent !important;\n  flex: 1;\n}\n\n.admin-pf-qty-ctrl {\n  display: flex;\n  align-items: center;\n  align-self: flex-start;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  overflow: hidden;\n  width: fit-content;\n}\n.admin-pf-qty-btn {\n  width: 36px;\n  height: 36px;\n  border: none;\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  font-size: 1.1rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.admin-pf-qty-btn:hover { background: var(--border); }\n.admin-pf-qty-input {\n  width: 64px;\n  border: none !important;\n  border-radius: 0 !important;\n  background: transparent !important;\n  text-align: center;\n}\n.admin-pf-in-stock {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: var(--color-secondary);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n@media (max-width: 700px) {\n  .admin-pf-row-3 { grid-template-columns: 1fr 1fr; }\n}\n@media (max-width: 480px) {\n  .admin-pf-row-3, .admin-pf-row-2 { grid-template-columns: 1fr; }\n}\n\n.admin-table-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n}\n\n/* ── Toast notifications ─────────────────────────────────────── */\n.toast-stack {\n  position: fixed;\n  bottom: 24px;\n  right: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  z-index: 9999;\n  pointer-events: none;\n}\n\n.toast {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 18px;\n  border-radius: var(--radius-sm);\n  font-size: 0.88rem;\n  font-weight: 500;\n  box-shadow: 0 4px 20px rgba(1, 13, 33,0.15);\n  animation: slide-down 260ms var(--ease-out-expo, ease) both;\n  max-width: 320px;\n  pointer-events: auto;\n}\n\n.toast-icon {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.toast-success { background: var(--color-secondary-soft); color: var(--color-secondary); border: 1px solid var(--color-secondary-soft); }\n.toast-success .toast-icon { background: var(--color-secondary); color: var(--color-text-on-secondary); }\n.toast-error   { background: var(--color-primary-soft); color: var(--color-primary); border: 1px solid var(--color-primary-soft); }\n.toast-error   .toast-icon { background: var(--color-primary); color: var(--color-text-on-primary); }\n.toast-info    { background: var(--color-secondary-soft); color: var(--color-secondary-hover); border: 1px solid var(--color-secondary-soft); }\n.toast-info    .toast-icon { background: var(--accent); color: var(--color-text-on-secondary); }\n\n[data-theme=\"dark\"] .toast-success { background: var(--color-secondary-soft); color: var(--color-secondary); border-color: var(--color-secondary); }\n[data-theme=\"dark\"] .toast-error   { background: var(--color-primary-soft); color: var(--color-primary-soft); border-color: var(--color-primary); }\n[data-theme=\"dark\"] .toast-info    { background: #0f1d3d; color: var(--color-secondary-soft); border-color: var(--color-secondary-hover); }\n\n/* ── Skeleton shimmer ────────────────────────────────────────── */\n.skeleton {\n  background: linear-gradient(90deg, var(--bg-tertiary) 25%, var(--border) 50%, var(--bg-tertiary) 75%);\n  background-size: 200% 100%;\n  animation: shimmer 1.4s ease infinite;\n}\n\n@keyframes shimmer {\n  0%   { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n.skeleton-row {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  padding: 12px 0;\n}\n\n/* ── KPI header/footer/trend ─────────────────────────────────── */\n.kpi-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.kpi-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: var(--radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  flex-shrink: 0;\n}\n\n.kpi-footer {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n  margin-top: 2px;\n}\n\n.kpi-trend {\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 2px 6px;\n  border-radius: var(--radius-xl);\n}\n\n.kpi-trend-up   { background: var(--color-secondary-soft); color: var(--color-secondary); }\n.kpi-trend-down { background: var(--color-primary-soft); color: var(--color-primary); }\n\n[data-theme=\"dark\"] .kpi-trend-up   { background: var(--color-secondary-soft); color: var(--color-secondary); }\n[data-theme=\"dark\"] .kpi-trend-down { background: var(--color-primary-soft); color: var(--color-primary); }\n\n/* ── Empty state ─────────────────────────────────────────────── */\n.admin-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 48px 24px;\n  gap: var(--space-1);\n}\n\n.admin-empty-icon  { font-size: 2.5rem; opacity: 0.4; }\n.admin-empty-title { font-size: 0.95rem; font-weight: 600; color: var(--text-secondary); margin: 0; }\n.admin-empty-sub   { font-size: 0.82rem; color: var(--text-secondary); margin: 0; opacity: 0.7; }\n\n/* ── Inline delete confirm ───────────────────────────────────── */\n/* Superseded by .confirm-dialog (see the destructive-confirmation block at\n   the end of this file). Kept only because .inline-confirm-label is still a\n   convenient hook if a compact inline confirm is ever wanted again; no\n   component references these today. */\n.inline-confirm {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.inline-confirm-label {\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n}\n\n/* ── Pagination ──────────────────────────────────────────────── */\n.admin-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2);\n  padding: 20px 0 4px;\n}\n\n.admin-page-btn {\n  padding: 8px 18px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 0.88rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 160ms ease, color 160ms ease;\n}\n\n.admin-page-btn:hover:not(:disabled) { background: var(--accent); color: var(--color-text-on-secondary); border-color: var(--accent); }\n.admin-page-btn:disabled { opacity: 0.4; cursor: not-allowed; }\n\n.admin-page-info {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n/* ── Orders status summary row ───────────────────────────────── */\n.orders-summary-row {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.orders-status-card {\n  background: color-mix(in srgb, var(--scolor, var(--accent)) 9%, var(--bg-secondary));\n  border: 1px solid var(--border);\n  border-top: 4px solid var(--scolor, var(--accent));\n  border-radius: var(--radius-md);\n  padding: 16px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  box-shadow: var(--shadow-card);\n}\n\n.osc-count {\n  font-size: 1.85rem;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.osc-label {\n  font-size: 0.85rem;\n  font-weight: 700;\n  text-transform: capitalize;\n  color: var(--text-primary);\n}\n\n.osc-bar-bg {\n  height: 6px;\n  background: var(--bg-tertiary);\n  border-radius: 999px;\n  margin-top: 8px;\n  overflow: hidden;\n}\n\n.osc-bar-fill {\n  height: 100%;\n  border-radius: 999px;\n  transition: width 600ms var(--ease-out-expo, ease);\n}\n\n@media (max-width: 768px) {\n  .orders-summary-row { grid-template-columns: repeat(3, 1fr); }\n}\n\n/* ── Orders table extra columns ──────────────────────────────── */\n.admin-orders-header {\n  grid-template-columns: 132px 1fr 70px 90px 72px 100px 130px !important;\n}\n\n.admin-order-row {\n  display: grid !important;\n  grid-template-columns: 132px 1fr 70px 90px 72px 100px 130px !important;\n}\n\n.order-items-count {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  align-self: center;\n}\n\n.order-date-cell {\n  font-size: 0.82rem;\n  color: var(--text-secondary);\n  align-self: center;\n}\n\n/* ── Ghost button ────────────────────────────────────────────── */\n.btn-ghost {\n  background: transparent !important;\n  border: 1px solid var(--border) !important;\n  color: var(--text-primary) !important;\n}\n\n.btn-ghost:hover { background: var(--bg-tertiary) !important; }\n\n/* ── Legacy .admin-dashboard removed — kept for backward compat. */\n.admin-dashboard { animation: fade-up 260ms ease both; }\n\n.admin-tabs {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 28px;\n  border-bottom: 2px solid var(--border);\n}\n\n.tab {\n  background: none;\n  border: none;\n  padding: 14px 18px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  font-size: 1rem;\n  border-bottom: 3px solid transparent;\n  transition: all 120ms ease;\n  margin-bottom: -2px;\n}\n\n.tab:hover  { color: var(--text-primary); }\n.tab.active { color: var(--accent); border-bottom-color: var(--accent); }\n\n.admin-section h2 {\n  margin: 0 0 18px;\n  font-size: 1.3rem;\n  color: var(--text-primary);\n  padding-top: 20px;\n  border-top: 1px solid var(--border);\n}\n\n.product-form,\n.product-form {\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-lg);\n  padding: 20px;\n  display: grid;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.product-form input,\n.product-form textarea {\n  width: 100%;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 12px 14px;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 0.95rem;\n  font-family: inherit;\n}\n\n.products-table,\n.orders-table {\n  background: var(--bg-secondary);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border);\n  overflow: hidden;\n  box-shadow: var(--shadow-card);\n}\n\n.product-row,\n.order-row {\n  display: grid;\n  grid-template-columns: auto 1fr auto auto auto;\n  gap: var(--space-2);\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border);\n  font-size: 0.95rem;\n}\n\n.status-select {\n  padding: 8px 12px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: border-color 150ms, box-shadow 150ms;\n}\n\n.status-select:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent) 18%, transparent);\n}\n\n.product-row:last-child,\n.order-row:last-child {\n  border-bottom: none;\n}\n\n.product-row span,\n.order-row span {\n  color: var(--text-primary);\n}\n\n/* ── Password Strength Meter ─────────────────────────── */\n.strength-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 12px 14px;\n  animation: strength-fade-in 180ms ease-out;\n}\n\n.strength-wrapper-closing {\n  animation: strength-fade-out 220ms ease-in forwards;\n}\n\n@keyframes strength-fade-in {\n  from { opacity: 0; transform: translateY(-6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes strength-fade-out {\n  from { opacity: 1; transform: translateY(0); max-height: 160px; margin: 0; padding: 12px 14px; }\n  to   { opacity: 0; transform: translateY(-6px); max-height: 0; margin: 0; padding: 0 14px; overflow: hidden; }\n}\n\n.strength-bar-track {\n  height: 6px;\n  border-radius: var(--radius-xs);\n  background: var(--border);\n  overflow: hidden;\n}\n\n.strength-bar-fill {\n  height: 100%;\n  border-radius: var(--radius-xs);\n  transition: width 300ms ease, background 300ms ease;\n}\n\n.strength-weak   { background: var(--danger); }\n.strength-fair   { background: var(--color-primary); }\n.strength-strong { background: var(--success); }\n\n.strength-label {\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.strength-label-weak   { color: var(--danger); }\n.strength-label-fair   { color: var(--color-primary); }\n.strength-label-strong { color: var(--success); }\n\n.strength-checks {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.strength-checks li {\n  font-size: 0.8rem;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.check-pass { color: var(--success); }\n.check-fail { color: var(--text-secondary); }\n\n/* ── Address Book ─────────────────────────────────────── */\n.address-book {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.address-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 14px;\n  margin-bottom: 4px;\n}\n\n.address-card {\n  position: relative;\n  background: var(--bg-secondary);\n  border: 2px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: var(--space-2);\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  transition: border-color 150ms, background 150ms;\n  cursor: default;\n  box-shadow: var(--shadow-card);\n}\n\n.address-card p {\n  margin: 2px 0;\n  line-height: 1.5;\n}\n\n.address-card.selected {\n  border-color: var(--accent);\n  background: rgba(59, 130, 246, 0.05);\n  cursor: pointer;\n}\n\n.address-card.is-default {\n  border-color: var(--accent);\n}\n\n[data-theme='dark'] .address-card.selected,\n[data-theme='dark'] .address-card.is-default {\n  background: rgba(59, 130, 246, 0.1);\n}\n\n.address-default-badge {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  padding: 2px 8px;\n  border-radius: var(--radius-xl);\n}\n\n.address-card-name {\n  font-weight: 600;\n  color: var(--text-primary) !important;\n  margin-bottom: 6px !important;\n}\n\n.address-card-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 12px;\n  padding-top: 10px;\n  border-top: 1px solid var(--border);\n}\n\n.btn-link {\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--accent);\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.btn-link:hover { text-decoration: underline; }\n\n.danger-link { color: var(--danger) !important; }\n\n.address-form-inline {\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 20px;\n  margin-top: 16px;\n  box-shadow: var(--shadow-card);\n}\n\n.address-form-inline h3 {\n  margin: 0 0 16px;\n  font-size: 1rem;\n  color: var(--text-primary);\n}\n\n/* ── Stock Badges ─────────────────────────────────────── */\n.product-image-wrap {\n  position: relative;\n  overflow: hidden;\n}\n\n.product-image-wrap img {\n  display: block;\n  width: 100%;\n}\n\n.stock-badge {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  padding: 3px 9px;\n  border-radius: var(--radius-xl);\n  pointer-events: none;\n}\n\n.badge-in  { background: var(--color-secondary-soft); color: var(--color-secondary); }\n.badge-low { background: var(--color-primary-soft); color: var(--color-primary); }\n.badge-oos { background: var(--color-primary-soft); color: var(--color-primary); }\n\n.product-card.out-of-stock {\n  opacity: 0.72;\n}\n\n.detail-stock-badge {\n  display: inline-block;\n  font-size: 0.82rem;\n  font-weight: 600;\n  padding: 4px 12px;\n  border-radius: var(--radius-xl);\n  margin-bottom: 12px;\n}\n\n/* Admin stock pill */\n.admin-stock-pill {\n  display: inline-block;\n  font-size: 0.82rem;\n  font-weight: 700;\n  padding: 3px 10px;\n  border-radius: var(--radius-xl);\n  text-align: center;\n}\n\n.stock-ok        { background: var(--color-secondary-soft); color: var(--color-secondary); }\n.stock-low       { background: var(--color-primary-soft); color: var(--color-primary); }\n.stock-oos       { background: var(--color-primary-soft); color: var(--color-primary); }\n.stock-unlimited { background: var(--bg-primary); color: var(--text-secondary); border: 1px solid var(--border); }\n\n/* ── Admin Dashboard Improvements ────────────────────── */\n.admin-form-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.product-form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.product-form-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.admin-products-table,\n.admin-orders-table {\n  background: var(--bg-secondary);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border);\n  overflow: hidden;\n  margin-bottom: 24px;\n  box-shadow: var(--shadow-card);\n}\n\n.admin-table-header {\n  display: grid;\n  gap: 12px;\n  padding: 12px 20px;\n  background: var(--bg-tertiary);\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--text-secondary);\n  border-bottom: 1px solid var(--border);\n}\n\n.admin-products-table .admin-table-header {\n  grid-template-columns: 1fr 120px 100px 80px 290px;\n}\n\n/* Customers tab reuses .admin-products-table's row/border/hover styling but\n   needs its own column layout (Customer/Orders/Spent/Cancelled/Refunded/Last\n   Order/Actions instead of Product/Category/Price/Stock/Actions) -- scoped\n   override, must come after the shared rule above to win on source order. */\n.admin-customers-table .admin-table-header,\n.admin-customers-table .admin-product-row {\n  grid-template-columns: 1.4fr 90px 100px 110px 110px 100px 90px;\n}\n\n.admin-orders-table .admin-table-header {\n  grid-template-columns: 132px 1fr 70px 90px 72px 100px 130px;\n}\n\n.admin-product-row {\n  display: grid;\n  grid-template-columns: 1fr 120px 100px 80px 290px;\n  gap: 12px;\n  align-items: center;\n  padding: 14px 20px;\n  border-bottom: 1px solid var(--border);\n  transition: background 150ms;\n}\n\n.admin-product-row:last-child {\n  border-bottom: none;\n}\n\n.admin-product-row:hover {\n  background: var(--bg-tertiary);\n}\n\n.admin-product-row.editing {\n  background: rgba(59, 130, 246, 0.06);\n  border-left: 3px solid var(--accent);\n}\n\n.admin-product-name {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.admin-product-thumb {\n  width: 48px;\n  height: 48px;\n  object-fit: cover;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n  flex-shrink: 0;\n}\n\n.admin-product-title {\n  display: block;\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.admin-product-desc {\n  display: block;\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.admin-category-chip {\n  display: inline-block;\n  font-size: 0.78rem;\n  font-weight: 600;\n  padding: 3px 10px;\n  border-radius: var(--radius-xl);\n  background: var(--bg-primary);\n  border: 1px solid var(--border);\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n.admin-price {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-size: 0.95rem;\n}\n\n.admin-row-actions {\n  display: flex;\n  gap: var(--space-1);\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.btn-admin-edit {\n  padding: 6px 14px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--accent);\n  background: transparent;\n  color: var(--accent);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 150ms;\n}\n\n.btn-admin-edit:hover {\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n}\n\n/* ── Careers tab ─────────────────────────────────────────────────── */\n.admin-careers-grid {\n  display: grid;\n  /* The left-side stats/table has a wide intrinsic size. A plain `1fr`\n     therefore refuses to shrink and pushes the form past the viewport when\n     the admin sidebar is open. Explicitly allow both tracks to shrink. */\n  grid-template-columns: minmax(0, 1fr) minmax(320px, 380px);\n  gap: 20px;\n  align-items: start;\n  width: 100%;\n  min-width: 0;\n}\n.admin-careers-grid > * { min-width: 0; }\n.admin-careers-grid .admin-pf-section { min-width: 0; }\n.admin-careers-grid .admin-products-table { width: 100%; max-width: 100%; min-width: 0; overflow: hidden; }\n.admin-careers-grid .admin-careers-stat-tile { min-width: 0; }\n@media (max-width: 1100px) {\n  .admin-careers-grid { grid-template-columns: 1fr; }\n}\n.admin-careers-form-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 20px;\n}\n.admin-careers-stats {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 14px;\n}\n@media (max-width: 900px) {\n  .admin-careers-stats { grid-template-columns: repeat(2, 1fr); }\n}\n.admin-careers-stat-tile {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 16px;\n}\n.admin-careers-stat-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n}\n.admin-careers-stat-value { font-size: 1.5rem; font-weight: 800; color: var(--text-primary); }\n.admin-careers-stat-label { font-size: 0.82rem; color: var(--text-secondary); }\n.admin-careers-stat-trend { font-size: 0.75rem; color: var(--text-muted); display: flex; align-items: center; gap: 3px; margin-top: 2px; }\n.admin-careers-stat-trend.up { color: var(--color-secondary); }\n.admin-careers-stat-trend.down { color: var(--color-primary); }\n\n/* Lightweight rich-text editor (job description field) */\n.admin-rte {\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  background: var(--bg-primary);\n}\n.admin-rte-toolbar {\n  display: flex;\n  gap: 2px;\n  padding: 6px 8px;\n  border-bottom: 1px solid var(--border);\n  background: var(--bg-secondary);\n}\n.admin-rte-toolbar button {\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: none;\n  border-radius: var(--radius-sm);\n  color: var(--text-secondary);\n  cursor: pointer;\n}\n.admin-rte-toolbar button:hover { background: var(--bg-tertiary); color: var(--text-primary); }\n.admin-rte-body {\n  min-height: 120px;\n  max-height: 280px;\n  overflow-y: auto;\n  padding: 10px 12px;\n  font-size: 0.88rem;\n  color: var(--text-primary);\n  outline: none;\n}\n.admin-rte-body:empty::before {\n  content: attr(data-placeholder);\n  color: var(--text-muted);\n}\n.admin-rte-body ul, .admin-rte-body ol { padding-left: 20px; margin: 6px 0; }\n\n.admin-search-input {\n  flex: 1;\n  min-width: 200px;\n  padding: 10px 16px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  font-family: inherit;\n  transition: border-color 150ms, box-shadow 150ms;\n}\n\n.admin-search-input:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent) 18%, transparent);\n}\n\n.admin-otp-input {\n  width: 100%;\n  padding: 4px 8px;\n  font-size: 0.78rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-family: inherit;\n}\n.admin-otp-input:focus { outline: none; border-color: var(--accent); }\n\n.admin-otp-btn {\n  padding: 4px 10px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  cursor: pointer;\n  white-space: nowrap;\n}\n.admin-otp-btn:hover:not(:disabled) { background: var(--accent); color: var(--color-text-on-secondary); border-color: var(--accent); }\n.admin-otp-btn:disabled { opacity: 0.4; cursor: not-allowed; }\n\n.admin-result-count {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  margin-bottom: 10px;\n}\n\n.admin-order-row {\n  display: grid;\n  grid-template-columns: 132px 1fr 70px 90px 72px 100px 130px;\n  gap: 12px;\n  align-items: center;\n  padding: 14px 20px;\n  border-bottom: 1px solid var(--border);\n}\n\n.admin-order-row:last-child {\n  border-bottom: none;\n}\n\n/* Wrapper so the expand panel is outside the grid row */\n.admin-order-block {\n  border-bottom: 1px solid var(--border);\n}\n.admin-order-block:last-child {\n  border-bottom: none;\n}\n.admin-order-block .admin-order-row {\n  border-bottom: none;\n}\n\n/* \"X sellers ▼\" toggle button */\n.admin-seller-toggle {\n  display: inline-block;\n  margin-top: 3px;\n  font-size: 0.7rem;\n  background: rgba(59, 130, 246,0.1);\n  color: var(--color-secondary);\n  border: 1px solid rgba(59, 130, 246,0.25);\n  border-radius: var(--radius-xs);\n  padding: 1px 6px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.admin-seller-toggle:hover { background: rgba(59, 130, 246,0.2); }\n\n/* \"Seller managed\" label replaces the Update dropdown */\n.admin-seller-managed-label {\n  font-size: 0.75rem;\n  color: var(--color-secondary);\n  font-style: italic;\n}\n\n/* Seller breakdown panel */\n.admin-seller-breakdown {\n  background: var(--bg-tertiary);\n  border-top: 1px dashed var(--border);\n  padding: 12px 20px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.admin-seller-suborder {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  box-shadow: var(--shadow-card);\n}\n\n.admin-suborder-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.admin-suborder-store {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.admin-suborder-store-name {\n  font-weight: 600;\n  font-size: 0.88rem;\n}\n\n.admin-suborder-seller-email {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n}\n\n.admin-suborder-meta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n}\n\n.admin-suborder-id {\n  font-family: monospace;\n  font-size: 0.72rem;\n  color: var(--text-secondary);\n}\n\n.admin-suborder-items {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  border-top: 1px solid var(--border);\n  padding-top: 8px;\n}\n\n.admin-suborder-item-row {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n  font-size: 0.82rem;\n}\n.admin-suborder-item-row span:first-child { flex: 1; }\n\n.admin-suborder-earnings {\n  display: flex;\n  gap: var(--space-2);\n  flex-wrap: wrap;\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n  border-top: 1px solid var(--border);\n  padding-top: 8px;\n}\n\n.admin-suborder-timeline {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  border-top: 1px solid var(--border);\n  padding-top: 8px;\n}\n\n.admin-timeline-chip {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.75rem;\n}\n\n.admin-order-row:hover {\n  background: var(--bg-tertiary);\n}\n\n.order-id-cell {\n  font-family: monospace;\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  align-items: flex-start;\n}\n.order-id-top { display: flex; align-items: center; gap: 6px; }\n.order-id-doc { display: inline-flex; color: var(--text-muted); flex-shrink: 0; }\n.order-id-num { font-weight: 600; color: var(--text-primary); white-space: nowrap; }\n.order-id-badges { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }\n.order-risk-badge {\n  display: inline-flex; align-items: center; gap: 2px;\n  font-family: var(--font-sans); font-size: 0.62rem; font-weight: 700;\n  padding: 1px 5px; border-radius: 4px; cursor: help; letter-spacing: 0.02em;\n}\n\n.order-customer-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.order-customer-cell span:first-child {\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: var(--text-primary);\n}\n\n.order-customer-email {\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@media (max-width: 768px) {\n  .product-form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .admin-products-table .admin-table-header,\n  .admin-product-row {\n    grid-template-columns: 1fr auto;\n  }\n\n  .admin-products-table .admin-table-header span:nth-child(2),\n  .admin-products-table .admin-table-header span:nth-child(3),\n  .admin-products-table .admin-table-header span:nth-child(4),\n  .admin-product-row .admin-category-chip,\n  .admin-product-row .admin-price,\n  .admin-product-row .admin-stock-pill {\n    display: none;\n  }\n\n  .admin-orders-table .admin-table-header,\n  .admin-order-row {\n    grid-template-columns: 1fr auto;\n  }\n\n  .admin-orders-table .admin-table-header span:nth-child(3),\n  .admin-orders-table .admin-table-header span:nth-child(4),\n  .admin-order-row .admin-price,\n  .admin-order-row .status {\n    display: none;\n  }\n}\n\n/* Settings Pages */\n.settings-container {\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.legal-page {\n  max-width: 720px;\n  margin: 0 auto;\n  padding-bottom: var(--space-4);\n}\n\n/* Card/grid-based hub pages (e.g. Help Center) align to the same\n   max-width + padding as the navbar instead of the narrower prose column\n   used by legal/text pages. */\n.legal-page.legal-page-wide {\n  max-width: 1440px;\n  padding: 0 24px var(--space-4);\n}\n@media (max-width: 640px) {\n  .legal-page.legal-page-wide { padding: 0 12px var(--space-4); }\n}\n\n.legal-title {\n  font-size: 1.9rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  margin: 0 0 6px;\n}\n\n.legal-updated {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  margin: 0 0 var(--space-3);\n}\n\n.legal-section {\n  margin-bottom: var(--space-3);\n}\n\n.legal-section h2 {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 8px;\n}\n\n.legal-section p,\n.legal-section li {\n  font-size: 0.92rem;\n  line-height: 1.65;\n  color: var(--text-secondary);\n}\n\n.legal-section ul {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.legal-section li {\n  margin-bottom: 6px;\n}\n\n.legal-section a {\n  color: var(--accent);\n  font-weight: 600;\n}\n\n/* Privacy policy — its outer edge deliberately matches the 1440px subpage header. */\n.privacy-page { max-width: 1440px; margin: 0 auto; padding: 4px 0 28px; }\n.privacy-heading { display: flex; align-items: center; gap: 16px; margin: 0 0 22px; }\n.privacy-heading-icon { width: 52px; height: 52px; border: 1px solid color-mix(in srgb, var(--color-secondary) 22%, var(--border)); border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; flex: 0 0 auto; color: var(--color-secondary); background: var(--color-secondary-soft); }\n.privacy-heading h1 { margin: 0 0 3px; color: var(--text-primary); font-size: clamp(1.8rem, 3vw, 2.35rem); line-height: 1.05; letter-spacing: -0.035em; }\n.privacy-heading p { margin: 0; color: var(--text-muted); font-size: 0.86rem; }\n.privacy-layout { display: grid; grid-template-columns: minmax(0, 1fr) 330px; gap: 22px; align-items: start; }\n.privacy-main { display: grid; gap: 12px; min-width: 0; }\n.privacy-policy-card, .privacy-compact-card, .privacy-side-card { border: 1px solid var(--border); border-radius: 10px; background: var(--bg-secondary); box-shadow: var(--shadow-card); }\n.privacy-policy-card { display: grid; grid-template-columns: 28px minmax(0, 1fr); gap: 14px; padding: 18px; scroll-margin-top: 20px; }\n.privacy-number { width: 26px; height: 26px; border: 1px solid color-mix(in srgb, var(--color-secondary) 35%, var(--border)); border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; color: var(--color-secondary-text); background: var(--color-secondary-soft); font-size: 0.78rem; font-weight: 750; }\n.privacy-policy-card h2, .privacy-compact-card h2, .privacy-side-card h2 { margin: 0; color: var(--text-primary); font-size: 1rem; font-weight: 750; }\n.privacy-policy-card p, .privacy-compact-card p, .privacy-side-card p { margin: 7px 0 0; color: var(--text-secondary); font-size: 0.84rem; line-height: 1.55; }\n.privacy-info-list { display: grid; gap: 10px; margin-top: 10px; }\n.privacy-info-row { display: grid; grid-template-columns: 34px minmax(0, 1fr); gap: 10px; align-items: start; }\n.privacy-info-row > span, .privacy-compact-card > div > span { width: 32px; height: 32px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; color: var(--color-secondary); background: var(--color-secondary-soft); }\n.privacy-info-row p { margin: 4px 0 0; }\n.privacy-info-row strong { color: var(--text-primary); }\n.privacy-compact-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }\n.privacy-compact-card { padding: 16px; scroll-margin-top: 20px; }\n.privacy-compact-card > div { display: flex; align-items: center; gap: 10px; }\n.privacy-compact-card a { color: var(--color-secondary-text); font-weight: 700; }\n.privacy-aside { position: sticky; top: 20px; display: grid; gap: 12px; }\n.privacy-side-card { padding: 18px; }\n.privacy-side-title { display: flex; align-items: center; gap: 10px; color: var(--color-primary); }\n.privacy-side-card ol { list-style: none; display: grid; gap: 7px; margin: 16px 0 0; padding: 0; }\n.privacy-side-card li a { display: flex; align-items: center; gap: 10px; color: var(--text-secondary); font-size: 0.8rem; text-decoration: none; }\n.privacy-side-card li a:hover { color: var(--text-primary); }\n.privacy-side-card li span { width: 22px; height: 22px; border: 1px solid color-mix(in srgb, var(--color-secondary) 35%, var(--border)); border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; flex: 0 0 auto; color: var(--color-secondary-text); background: var(--color-secondary-soft); font-size: 0.7rem; font-weight: 700; }\n.privacy-email { display: inline-flex; align-items: center; justify-content: center; gap: 8px; max-width: 100%; margin-top: 14px; padding: 9px 14px; border: 1px solid var(--color-secondary); border-radius: 999px; color: var(--color-secondary-text); font-size: 0.78rem; font-weight: 700; text-decoration: none; }\n.privacy-footer { display: flex; align-items: center; gap: 14px; margin-top: 18px; padding: 18px 4px 0; border-top: 1px solid var(--border); }\n.privacy-footer > span { width: 42px; height: 42px; border-radius: 9px; display: inline-flex; align-items: center; justify-content: center; color: var(--color-secondary); background: var(--color-secondary-soft); }\n.privacy-footer strong { color: var(--text-primary); font-size: 0.88rem; }\n.privacy-footer p { margin: 3px 0 0; color: var(--text-secondary); font-size: 0.78rem; }\n.policy-document-page .privacy-layout { grid-template-columns: minmax(0, 1fr) 330px; }\n.policy-document-card { min-height: 92px; }\n.policy-document-title { display: flex; align-items: center; gap: 9px; }\n.policy-document-title > span { width: 30px; height: 30px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; flex: 0 0 auto; color: var(--color-secondary); background: var(--color-secondary-soft); }\n.policy-document-copy > p { margin-top: 9px; }\n.policy-document-copy ul { margin: 9px 0 0; padding-left: 20px; color: var(--text-secondary); font-size: 0.84rem; line-height: 1.55; }\n.policy-document-copy li + li { margin-top: 5px; }\n.policy-document-copy a { color: var(--color-secondary-text); font-weight: 700; }\n/* .policy-document-page .privacy-layout (0,2,0) outranks a bare\n   .privacy-layout (0,1,0) -- a media query adds no specificity -- so\n   Terms & Conditions and Returns & Refunds, the two pages carrying that\n   class, kept the 330px sidebar column below 900px. That squeezed\n   .privacy-main to zero width and pushed .privacy-aside past the right\n   edge. The collapse rule has to match that specificity to win. */\n@media (max-width: 900px) { .privacy-layout,\n  .policy-document-page .privacy-layout { grid-template-columns: 1fr; } .privacy-aside { position: static; grid-template-columns: repeat(2, minmax(0, 1fr)); } .privacy-aside .privacy-side-card:first-child { grid-row: span 2; } }\n@media (max-width: 640px) { .privacy-page { padding: 0 0 76px; } .privacy-heading { margin-bottom: 18px; } .privacy-heading-icon { width: 46px; height: 46px; } .privacy-compact-grid, .privacy-aside { grid-template-columns: 1fr; } .privacy-aside .privacy-side-card:first-child { grid-row: auto; } .privacy-policy-card { gap: 10px; padding: 15px 13px; } .privacy-info-row { grid-template-columns: 30px minmax(0, 1fr); gap: 8px; } .privacy-info-row > span { width: 30px; height: 30px; } }\n\n/* ── FAQ accordion (shared by FAQ, Seller FAQs, Help Center) ────────── */\n.faq-accordion { display: flex; flex-direction: column; gap: 10px; }\n.faq-item {\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  background: var(--bg-secondary);\n  overflow: hidden;\n}\n.faq-item.open { border-color: var(--accent); }\n.faq-question {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 16px;\n  background: none;\n  border: none;\n  text-align: left;\n  font-size: 0.92rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  cursor: pointer;\n}\n.faq-chevron { color: var(--text-muted); flex-shrink: 0; transition: transform 150ms ease; display: flex; }\n.faq-item.open .faq-chevron { transform: rotate(180deg); color: var(--accent); }\n.faq-answer {\n  padding: 0 16px 16px;\n  font-size: 0.88rem;\n  line-height: 1.6;\n  color: var(--text-secondary);\n}\n\n/* ── Careers ─────────────────────────────────────────────────────── */\n.careers-page { max-width: 1440px; margin: 0 auto; padding: 0 24px var(--space-4); }\n@media (max-width: 640px) { .careers-page { padding: 0 12px var(--space-4); } }\n\n.careers-hero {\n  text-align: center;\n  background: linear-gradient(180deg, var(--text-primary), color-mix(in srgb, var(--text-primary) 82%, var(--color-brand-navy)));\n  border-radius: var(--radius-lg, 16px);\n  padding: 40px 24px 32px;\n  margin-bottom: 28px;\n  color: var(--bg-tertiary);\n}\n.careers-hero-icon {\n  display: inline-flex; align-items: center; justify-content: center;\n  width: 56px; height: 56px; border-radius: 50%;\n  background: color-mix(in srgb, var(--accent-secondary) 18%, transparent); color: var(--color-secondary); margin-bottom: 14px;\n}\n.careers-hero-title { font-size: 1.9rem; font-weight: 800; margin: 0 0 10px; color: var(--bg-tertiary); }\n.careers-hero-brand { color: var(--color-secondary); }\n.careers-hero-sub { font-size: 0.95rem; color: var(--border-strong); max-width: 560px; margin: 0 auto 30px; line-height: 1.6; }\n.careers-value-props { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; max-width: 720px; margin: 0 auto; }\n@media (max-width: 640px) { .careers-value-props { grid-template-columns: 1fr; } }\n.careers-value-prop { background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: var(--radius-md); padding: 18px 14px; }\n.careers-value-icon { display: inline-flex; align-items: center; justify-content: center; width: 36px; height: 36px; border-radius: 10px; background: color-mix(in srgb, var(--accent-secondary) 16%, transparent); color: var(--color-secondary); margin-bottom: 10px; }\n.careers-value-title { font-size: 0.92rem; font-weight: 700; color: var(--bg-tertiary); margin: 0 0 4px; }\n.careers-value-text { font-size: 0.8rem; color: var(--text-muted); margin: 0; line-height: 1.5; }\n\n.careers-body { width: 100%; }\n.careers-search-row { display: flex; flex-wrap: wrap; gap: 12px; align-items: center; margin-bottom: 20px; }\n.careers-search-box {\n  display: flex; align-items: center; gap: 8px; flex: 1 1 220px; min-width: 200px;\n  background: var(--bg-secondary); border: 1px solid var(--border); border-radius: var(--radius-md);\n  padding: 10px 14px; color: var(--text-muted);\n}\n.careers-search-box input { flex: 1; border: none; background: none; outline: none; font-size: 0.88rem; color: var(--text-primary); }\n.careers-filter-pills { display: flex; flex-wrap: wrap; gap: 8px; }\n.careers-filter-pill {\n  font-size: 0.8rem; font-weight: 600; color: var(--text-secondary); background: var(--bg-secondary);\n  border: 1px solid var(--border); border-radius: 999px; padding: 8px 14px; cursor: pointer; white-space: nowrap;\n}\n.careers-filter-pill.active { background: var(--accent); border-color: var(--accent); color: var(--color-text-on-secondary); }\n.careers-filter-pill:hover:not(.active) { border-color: var(--accent); color: var(--accent); }\n\n.careers-cta-card {\n  margin-top: 20px; text-align: center; background: var(--bg-secondary); border: 1px solid var(--border);\n  border-radius: var(--radius-md); padding: 28px 20px;\n}\n.careers-cta-title { font-size: 1.05rem; font-weight: 700; color: var(--text-primary); margin: 0 0 4px; }\n.careers-cta-text { font-size: 0.85rem; color: var(--text-secondary); margin: 0 0 16px; }\n.careers-cta-btn {\n  display: inline-flex; align-items: center; gap: 8px; font-weight: 700; font-size: 0.88rem;\n  background: var(--accent); color: var(--color-text-on-secondary); border: none; border-radius: var(--radius-md);\n  padding: 10px 20px; cursor: pointer;\n}\n.careers-cta-card .careers-apply-form { text-align: left; }\n\n.careers-list { display: flex; flex-direction: column; gap: 12px; }\n.careers-card { border: 1px solid var(--border); border-radius: var(--radius-md); background: var(--bg-secondary); overflow: hidden; padding: 18px; }\n.careers-card-row { display: flex; align-items: center; gap: 18px; }\n.careers-card-icon { flex-shrink: 0; width: 44px; height: 44px; border-radius: 12px; display: inline-flex; align-items: center; justify-content: center; }\n.careers-card-main { flex: 1 1 240px; min-width: 0; }\n.careers-card-summary { font-size: 0.85rem; color: var(--text-secondary); margin: 0; line-height: 1.5; }\n.careers-card-title { font-size: 0.98rem; font-weight: 700; color: var(--text-primary); margin: 0 0 4px; }\n\n.careers-card-meta-col {\n  display: flex; flex-direction: column; gap: 6px; flex-shrink: 0;\n  font-size: 0.82rem; color: var(--text-secondary); min-width: 150px;\n}\n.careers-card-meta-col span { display: inline-flex; align-items: center; gap: 6px; }\n\n.careers-card-type-col { display: flex; flex-direction: column; align-items: flex-end; gap: 10px; flex-shrink: 0; }\n.careers-type-dot { display: inline-flex; align-items: center; gap: 6px; font-size: 0.82rem; font-weight: 600; color: var(--text-secondary); }\n.careers-type-dot span { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }\n.careers-view-details {\n  display: inline-flex; align-items: center; gap: 6px; background: none; cursor: pointer;\n  font-size: 0.82rem; font-weight: 700; padding: 7px 14px; border-radius: 999px; border: 1px solid;\n  white-space: nowrap;\n}\n\n@media (max-width: 760px) {\n  .careers-card-row { flex-wrap: wrap; }\n  .careers-card-meta-col { flex-direction: row; flex-wrap: wrap; gap: 12px; min-width: 0; }\n  .careers-card-type-col { flex-direction: row; align-items: center; width: 100%; justify-content: space-between; }\n}\n\n.careers-card-body { padding-top: 14px; margin-top: 14px; border-top: 1px solid var(--border); font-size: 0.88rem; line-height: 1.6; color: var(--text-secondary); }\n.careers-req-title { font-weight: 700; color: var(--text-primary); margin: 12px 0 6px; font-size: 0.85rem; }\n.careers-card-body ul { margin: 0 0 14px; padding-left: 20px; }\n.careers-card-body li { margin-bottom: 4px; }\n.careers-apply-btn { display: inline-block; text-decoration: none; }\n.careers-apply-form { display: flex; flex-direction: column; gap: 14px; margin-top: 10px; padding-top: 14px; border-top: 1px solid var(--border); }\n.careers-apply-row { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }\n@media (max-width: 480px) { .careers-apply-row { grid-template-columns: 1fr; } }\n.careers-apply-sent { text-align: center; padding: 20px 0 6px; }\n.careers-apply-sent-icon { color: var(--success); display: inline-flex; margin-bottom: 8px; }\n.careers-apply-sent-title { font-size: 1rem; font-weight: 700; color: var(--text-primary); margin: 0 0 4px; }\n.careers-apply-sent-sub { font-size: 0.85rem; color: var(--text-secondary); margin: 0 0 14px; }\n.careers-empty { text-align: center; padding: 30px 20px; color: var(--text-secondary); font-size: 0.9rem; background: var(--bg-secondary); border: 1px solid var(--border); border-radius: var(--radius-md); }\n.careers-empty a { color: var(--accent); font-weight: 600; }\n.careers-apply-section-title { font-size: 0.9rem; font-weight: 700; color: var(--text-primary); margin: 4px 0 -2px; display: flex; align-items: center; gap: 8px; }\n.careers-apply-required-badge { font-size: 0.65rem; font-weight: 700; letter-spacing: 0.03em; text-transform: uppercase; color: var(--danger); background: color-mix(in srgb, var(--danger) 10%, transparent); border: 1px solid color-mix(in srgb, var(--danger) 30%, transparent); border-radius: 999px; padding: 2px 8px; }\n.careers-apply-entry { display: flex; flex-direction: column; gap: 12px; padding: 12px; background: var(--bg-secondary); border: 1px solid var(--border); border-radius: var(--radius-md); }\n.careers-apply-add { align-self: flex-start; display: inline-flex; align-items: center; gap: 6px; background: none; border: 1px dashed var(--border); color: var(--accent); font-size: 0.8rem; font-weight: 600; padding: 6px 12px; border-radius: var(--radius-md); cursor: pointer; }\n.careers-apply-add:hover { background: var(--bg-secondary); }\n.careers-apply-remove { align-self: flex-end; display: inline-flex; align-items: center; gap: 4px; background: none; border: none; color: var(--danger); font-size: 0.75rem; font-weight: 600; padding: 2px 4px; cursor: pointer; }\n.careers-apply-file-btn { display: inline-flex; align-items: center; gap: 8px; width: fit-content; max-width: 100%; font-size: 0.85rem; color: var(--text-primary); background: var(--bg-secondary); border: 1px solid var(--border); border-radius: var(--radius-md); padding: 9px 14px; cursor: pointer; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.careers-apply-file-btn:hover { border-color: var(--accent); }\n.careers-apply-declaration { display: flex; align-items: flex-start; gap: 10px; font-size: 0.85rem; color: var(--text-secondary); line-height: 1.4; cursor: pointer; }\n.careers-apply-declaration input { margin-top: 3px; flex-shrink: 0; }\n\n/* ── Contact Us ──────────────────────────────────────────────────── */\n.contact-layout { display: grid; grid-template-columns: 220px 1fr; gap: 28px; align-items: start; }\n@media (max-width: 640px) { .contact-layout { grid-template-columns: 1fr; } }\n.contact-info-col { display: flex; flex-direction: column; gap: 18px; }\n.contact-info-row { display: flex; align-items: flex-start; gap: 10px; }\n.contact-info-icon {\n  width: 32px; height: 32px; border-radius: 50%; background: color-mix(in srgb, var(--accent-secondary) 12%, transparent); color: var(--accent-secondary);\n  display: flex; align-items: center; justify-content: center; flex-shrink: 0;\n}\n.contact-info-label { font-size: 0.75rem; color: var(--text-muted); margin: 0 0 2px; text-transform: uppercase; letter-spacing: 0.04em; }\n.contact-info-value { font-size: 0.88rem; color: var(--text-primary); font-weight: 600; margin: 0; text-decoration: none; }\n/* Only the anchor form is a control -- the same class is used on a plain <p>\n   for values that are not links (an address, opening hours), and giving those\n   a 24px floor would space the contact block out for nothing. */\na.contact-info-value {\n  display: inline-flex;\n  align-items: center;\n  min-height: 24px;\n}\na.contact-info-value:hover { text-decoration: underline; }\n\n.contact-form { display: flex; flex-direction: column; gap: 14px; }\n.contact-form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }\n@media (max-width: 480px) { .contact-form-row { grid-template-columns: 1fr; } }\n.contact-field { display: flex; flex-direction: column; gap: 5px; }\n.contact-label { font-size: 0.8rem; font-weight: 600; color: var(--text-secondary); }\n.contact-input {\n  box-sizing: border-box; width: 100%; border: 1px solid var(--border); border-radius: var(--radius-md);\n  padding: 10px 12px; font-size: 0.9rem; background: var(--bg-primary); color: var(--text-primary); font-family: inherit; resize: vertical;\n}\n/* These land at 38px on a phone, under the 44px comfortable-tap floor, and a\n   contact form is where a mis-tap costs the most. Mobile only -- a mouse\n   doesn't need the extra height. */\n@media (max-width: 768px) {\n  .contact-input { min-height: 44px; }\n}\n.contact-input:focus { border-color: var(--accent); outline: none; box-shadow: 0 0 0 3px rgba(59, 130, 246,0.1); }\n\n.contact-sent { text-align: center; padding: 30px 20px; }\n.contact-sent-icon { color: var(--success); display: inline-flex; margin-bottom: 10px; }\n.contact-sent-title { font-size: 1.1rem; font-weight: 700; color: var(--text-primary); margin: 0 0 6px; }\n.contact-sent-sub { font-size: 0.88rem; color: var(--text-secondary); margin: 0 0 18px; }\n\n.settings-container h1 {\n  font-size: 2rem;\n  margin-bottom: 24px;\n  color: var(--text-primary);\n}\n\n.settings-panel {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: var(--space-3);\n  box-shadow: var(--shadow-card);\n}\n\n.settings-panel h2 {\n  font-size: 1.3rem;\n  margin-bottom: 18px;\n  color: var(--text-primary);\n}\n\n.settings-panel h3 {\n  font-size: 1.1rem;\n  margin: 16px 0 12px;\n  color: var(--text-primary);\n}\n\n.address-form {\n  display: grid;\n  gap: var(--space-2);\n}\n\n.address-form label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-weight: 500;\n}\n\n.address-form span {\n  color: var(--text-primary);\n  font-size: 0.95rem;\n  font-weight: 600;\n}\n\n.address-form input {\n  padding: 10px 12px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  font-size: 0.95rem;\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  transition: all 200ms ease;\n}\n\n.address-form input:focus {\n  outline: none;\n  border-color: var(--accent);\n  background: var(--bg-secondary);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.setting-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 0;\n  gap: 12px;\n}\n\n.setting-item span {\n  color: var(--text-primary);\n  font-weight: 500;\n}\n\n.setting-item input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  accent-color: var(--accent);\n}\n\n.settings-panel hr {\n  border: none;\n  border-top: 1px solid var(--border);\n  margin: 16px 0;\n}\n\n/* Cookie policy */\n.cookie-page { max-width: 1440px; margin: 0 auto; padding: 4px 0 28px; }\n.cookie-heading { margin-bottom: 24px; }\n.cookie-heading h1 { margin: 0 0 8px; color: var(--text-primary); font-size: clamp(2rem, 3vw, 2.6rem); letter-spacing: -0.04em; }\n.cookie-heading p { margin: 0 0 12px; color: var(--text-secondary); font-size: 0.9rem; }\n.cookie-heading .cookie-updated { color: var(--text-muted); font-size: 0.82rem; }\n.cookie-layout { display: grid; grid-template-columns: minmax(0, 1.9fr) minmax(340px, 1fr); gap: 30px; align-items: start; }\n.cookie-sections, .cookie-card { background: var(--bg-secondary); border: 1px solid var(--border); border-radius: 14px; box-shadow: var(--shadow-card); }\n.cookie-sections { padding: 10px 24px; }\n.cookie-section { display: grid; grid-template-columns: 30px 52px minmax(0, 1fr); gap: 18px; align-items: center; min-height: 102px; border-bottom: 1px solid var(--border); }\n.cookie-section:last-child { border-bottom: 0; }\n.cookie-number { width: 26px; height: 26px; border-radius: 6px; display: inline-flex; align-items: center; justify-content: center; color: white; background: var(--color-secondary); font-size: 0.8rem; font-weight: 700; }\n.cookie-icon, .cookie-choice-icon { width: 48px; height: 48px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; color: var(--color-secondary); background: color-mix(in srgb, var(--color-secondary) 10%, transparent); flex: 0 0 auto; }\n.cookie-section h2 { margin: 0 0 4px; color: var(--text-primary); font-size: 0.98rem; }\n.cookie-section p { margin: 0; color: var(--text-secondary); font-size: 0.82rem; line-height: 1.45; }\n.cookie-side { display: grid; gap: 18px; }\n.cookie-card { padding: 24px; }\n.cookie-card h2 { margin: 0 0 20px; display: flex; align-items: center; gap: 12px; color: var(--text-primary); font-size: 1rem; }\n.cookie-card h2 .cookie-icon { width: 42px; height: 42px; }\n.cookie-card ul { list-style: none; padding: 0; margin: 0 0 20px; display: grid; gap: 18px; }\n.cookie-card li { display: flex; align-items: flex-start; gap: 12px; color: var(--text-secondary); font-size: 0.8rem; line-height: 1.4; }\n.cookie-card li svg { color: var(--success); flex: 0 0 auto; margin-top: 1px; }\n.cookie-card > a { display: inline-flex; align-items: center; gap: 8px; color: var(--color-secondary); font-size: 0.8rem; text-decoration: none; }\n.cookie-choices { padding-bottom: 12px; }\n.cookie-choices > a, .cookie-choices > button { width: 100%; min-height: 66px; padding: 8px 0; border: 0; border-bottom: 1px solid var(--border); background: transparent; display: grid; grid-template-columns: 42px minmax(0, 1fr) auto; align-items: center; gap: 12px; text-align: left; color: var(--text-primary); cursor: pointer; text-decoration: none; }\n.cookie-choices > :last-child { border-bottom: 0; }\n.cookie-choice-icon { width: 40px; height: 40px; border-radius: 9px; }\n.cookie-choices strong, .cookie-choices small { display: block; }\n.cookie-choices strong { margin-bottom: 3px; font-size: 0.82rem; }\n.cookie-choices small { color: var(--text-secondary); font-size: 0.74rem; }\n.cookie-footer { display: flex; align-items: center; gap: 12px; min-height: 76px; margin-top: 28px; border-top: 1px solid var(--border); color: var(--text-secondary); font-size: 0.82rem; }\n.cookie-footer i { width: 1px; height: 22px; margin: 0 12px; background: var(--border); }\n.cookie-footer a { color: var(--color-secondary); text-decoration: none; }\n@media (max-width: 900px) { .cookie-layout { grid-template-columns: 1fr; } }\n@media (max-width: 600px) { .cookie-page { padding: 4px 0 76px; } .cookie-section { grid-template-columns: 26px 42px minmax(0, 1fr); gap: 10px; padding: 12px 0; } .cookie-icon { width: 40px; height: 40px; } .cookie-sections, .cookie-card { padding-left: 16px; padding-right: 16px; } .cookie-footer { flex-wrap: wrap; } }\n\n/* Customer account settings */\n.settings-page { padding: 38px 24px 0; }\n.settings-page .settings-container { max-width: 1440px; margin: 0 auto; }\n.settings-page-heading { margin-bottom: 30px; }\n.settings-page-heading h1 { margin: 0 0 6px; font-size: clamp(2rem, 3vw, 2.55rem); line-height: 1.1; font-weight: 800; letter-spacing: -0.035em; color: var(--text-primary); }\n.settings-page-heading p { margin: 0; font-size: 1rem; color: var(--text-secondary); }\n.settings-grid { display: grid; grid-template-columns: minmax(0, 1.2fr) minmax(400px, 1fr); gap: 22px; align-items: stretch; }\n.settings-page .settings-panel { padding: 28px; border-radius: 14px; background: var(--bg-secondary); }\n.settings-section-head { display: flex; align-items: center; gap: 16px; }\n.settings-section-icon { width: 48px; height: 48px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; flex: 0 0 auto; color: var(--color-secondary); background: color-mix(in srgb, var(--color-secondary) 11%, transparent); }\n.settings-section-icon.strong { color: var(--color-brand-white); background: var(--color-secondary); }\n.settings-section-head h2 { margin: 0 0 4px; font-size: 1.15rem; font-weight: 750; color: var(--text-primary); }\n.settings-section-head p { margin: 0; font-size: 0.86rem; color: var(--text-secondary); }\n.settings-options { margin-top: 24px; border-top: 1px solid var(--border); }\n.settings-page .setting-item { position: relative; display: grid; grid-template-columns: 48px minmax(0, 1fr) 28px; align-items: center; gap: 16px; min-height: 94px; padding: 14px 0; border-bottom: 1px solid var(--border); cursor: pointer; }\n.settings-page .setting-item:last-child { border-bottom: 0; }\n.setting-icon { width: 48px; height: 48px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; color: var(--color-secondary); background: color-mix(in srgb, var(--color-secondary) 10%, transparent); }\n.setting-copy { display: flex; flex-direction: column; gap: 5px; min-width: 0; }\n.setting-copy strong { color: var(--text-primary); font-size: 0.95rem; font-weight: 700; }\n.setting-copy small { color: var(--text-secondary); font-size: 0.82rem; line-height: 1.35; }\n.settings-page .setting-item input { position: absolute; opacity: 0; pointer-events: none; }\n.setting-check { width: 26px; height: 26px; border: 1px solid var(--border-strong, var(--border)); border-radius: 6px; display: inline-flex; align-items: center; justify-content: center; color: transparent; background: var(--bg-primary); }\n.setting-item input:checked + .setting-check { color: white; border-color: var(--color-secondary); background: var(--color-secondary); }\n.setting-item:focus-within .setting-check { box-shadow: 0 0 0 3px color-mix(in srgb, var(--color-secondary) 18%, transparent); }\n.settings-side-column { display: grid; grid-template-rows: auto 1fr; gap: 18px; }\n.settings-theme-toggle { display: grid; grid-template-columns: 1fr 1fr; margin-top: 24px; border: 1px solid var(--border); border-radius: 9px; overflow: hidden; }\n.settings-theme-toggle button { min-height: 50px; border: 0; background: transparent; color: var(--text-primary); display: flex; align-items: center; justify-content: center; gap: 9px; font: inherit; font-size: 0.9rem; cursor: pointer; }\n.settings-theme-toggle button.active { color: white; background: var(--color-secondary); }\n.settings-theme-note { margin: 10px 0 0; color: var(--text-secondary); font-size: 0.8rem; }\n.settings-privacy-note { display: flex; align-items: flex-start; gap: 12px; margin-top: 22px; padding: 16px; border: 1px solid color-mix(in srgb, var(--color-secondary) 22%, var(--border)); border-radius: 9px; color: var(--color-secondary); background: color-mix(in srgb, var(--color-secondary) 5%, transparent); font-size: 0.82rem; line-height: 1.45; }\n.settings-privacy-note svg { flex: 0 0 auto; margin-top: 1px; }\n.settings-privacy-actions { display: flex; gap: 14px; margin-top: 16px; flex-wrap: wrap; }\n.settings-download-btn, .settings-delete-btn, .settings-delete-danger, .settings-delete-cancel { min-height: 44px; padding: 0 22px; border-radius: 8px; display: inline-flex; align-items: center; justify-content: center; gap: 9px; font: inherit; font-size: 0.84rem; font-weight: 650; cursor: pointer; }\n.settings-download-btn { border: 1px solid var(--color-secondary); color: white; background: var(--color-secondary); }\n.settings-delete-btn { border: 1px solid var(--border); color: var(--text-primary); background: var(--bg-secondary); }\n.settings-delete-btn svg, .settings-delete-danger { color: var(--color-primary); }\n.settings-delete-confirm { flex: 1 0 100%; display: grid; gap: 9px; padding-top: 4px; }\n.settings-delete-confirm > p { margin: 0; color: var(--color-primary); font-size: 0.8rem; font-weight: 600; }\n.settings-delete-confirm input { min-height: 42px; padding: 0 12px; border: 1px solid var(--border); border-radius: 8px; background: var(--bg-primary); color: var(--text-primary); }\n.settings-delete-confirm > div { display: flex; gap: 8px; }\n.settings-delete-danger { border: 1px solid var(--color-primary); background: var(--color-primary); color: white; }\n.settings-delete-cancel { border: 1px solid var(--border); background: var(--bg-tertiary); color: var(--text-primary); }\n.settings-delete-error { color: var(--color-primary); font-size: 0.78rem; margin: 0; }\n.settings-privacy-footer { display: flex; align-items: center; gap: 12px; margin-top: 30px; min-height: 70px; border-top: 1px solid var(--border); color: var(--text-secondary); font-size: 0.82rem; }\n.settings-privacy-footer i { width: 1px; height: 22px; margin: 0 10px; background: var(--border); }\n.settings-privacy-footer a { color: var(--color-secondary); text-decoration: none; }\n@media (max-width: 900px) { .settings-grid { grid-template-columns: 1fr; } }\n@media (max-width: 600px) {\n  .settings-page { padding: 24px 14px 82px; }\n  .settings-page .settings-panel { padding: 20px; }\n  .settings-page-heading { margin-bottom: 20px; }\n  .settings-page-heading p { font-size: 0.9rem; }\n  .settings-page .setting-item { grid-template-columns: 42px minmax(0, 1fr) 25px; gap: 11px; min-height: 84px; }\n  .setting-icon, .settings-section-icon { width: 42px; height: 42px; }\n  .settings-theme-toggle button { font-size: 0.82rem; }\n  .settings-privacy-actions > button { flex: 1 1 100%; }\n  .settings-privacy-footer { flex-wrap: wrap; gap: 8px; padding: 18px 0; }\n}\n\n/* ── Notifications page (NotificationsPage.js) ──────────────────────── */\n.ntf-page { max-width: 900px; margin: 0 auto; }\n\n.ntf-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; margin-bottom: 18px; flex-wrap: wrap; }\n.ntf-title { margin: 0 0 4px; font-size: 1.4rem; font-weight: 800; color: var(--text-primary); }\n.ntf-sub { margin: 0; font-size: 0.86rem; color: var(--text-secondary); }\n.ntf-mark-all {\n  display: flex; align-items: center; gap: 6px;\n  background: none; border: 1px solid var(--accent); color: var(--accent);\n  font-size: 0.82rem; font-weight: 700; cursor: pointer;\n  padding: 8px 14px; border-radius: var(--radius-sm); white-space: nowrap;\n  transition: background 150ms;\n}\n.ntf-mark-all:hover { background: rgba(59, 130, 246, 0.08); }\n\n.ntf-tabs { display: flex; gap: 8px; overflow-x: auto; padding-bottom: 4px; margin-bottom: 14px; scrollbar-width: none; }\n.ntf-tabs::-webkit-scrollbar { display: none; }\n.ntf-tab {\n  display: flex; align-items: center; gap: 6px; flex-shrink: 0;\n  padding: 8px 14px; border-radius: 20px; border: 1px solid var(--border);\n  background: var(--bg-secondary); color: var(--text-secondary);\n  font-size: 0.84rem; font-weight: 600; cursor: pointer; transition: all 150ms;\n}\n.ntf-tab:hover { border-color: var(--accent); color: var(--text-primary); }\n.ntf-tab.active { background: var(--accent); border-color: var(--accent); color: var(--color-text-on-secondary); }\n.ntf-tab-count {\n  background: rgba(1, 13, 33,0.08); border-radius: 10px; padding: 1px 7px; font-size: 0.72rem; font-weight: 700;\n}\n.ntf-tab.active .ntf-tab-count { background: rgba(255,255,255,0.25); }\n[data-theme=\"dark\"] .ntf-tab-count { background: rgba(255,255,255,0.1); }\n\n.ntf-toolbar { display: flex; gap: 10px; margin-bottom: 16px; flex-wrap: wrap; }\n.ntf-search-wrap { position: relative; flex: 1; min-width: 200px; }\n.ntf-search-icon { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: var(--text-tertiary); pointer-events: none; }\n.ntf-search-input {\n  width: 100%; box-sizing: border-box; padding: 9px 12px 9px 34px; border-radius: var(--radius-sm);\n  border: 1px solid var(--border); background: var(--bg-secondary); color: var(--text-primary); font-size: 0.86rem;\n}\n.ntf-search-input:focus { outline: none; border-color: var(--accent); }\n\n.ntf-popover-wrap { position: relative; }\n.ntf-filter-btn {\n  display: flex; align-items: center; gap: 6px; height: 100%;\n  padding: 9px 14px; border-radius: var(--radius-sm); border: 1px solid var(--border);\n  background: var(--bg-secondary); color: var(--text-primary); font-size: 0.84rem; font-weight: 600; cursor: pointer; white-space: nowrap;\n}\n.ntf-filter-btn:hover { border-color: var(--accent); }\n.ntf-popover {\n  position: absolute; top: calc(100% + 6px); right: 0; z-index: 20;\n  background: var(--bg-primary); border: 1px solid var(--border); border-radius: var(--radius-sm);\n  box-shadow: 0 8px 24px rgba(1, 13, 33,0.15); padding: 14px; min-width: 220px;\n  display: flex; flex-direction: column; gap: 10px;\n}\n.ntf-popover-date-label { display: flex; flex-direction: column; gap: 4px; font-size: 0.78rem; font-weight: 600; color: var(--text-secondary); }\n.ntf-popover-date-label input {\n  padding: 7px 8px; border-radius: 6px; border: 1px solid var(--border); background: var(--bg-secondary); color: var(--text-primary); font-size: 0.82rem;\n}\n.ntf-popover-clear { align-self: flex-start; background: none; border: none; color: var(--accent); font-size: 0.8rem; font-weight: 600; cursor: pointer; padding: 0; }\n\n.ntf-list { display: flex; flex-direction: column; gap: 10px; }\n\n.ntf-skeleton { height: 82px; border-radius: var(--radius-sm); }\n\n.ntf-empty {\n  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 10px;\n  padding: 60px 20px; color: var(--text-tertiary); text-align: center;\n}\n.ntf-empty p { margin: 0; font-size: 0.88rem; }\n\n.ntf-card {\n  position: relative;\n  display: flex; align-items: flex-start; gap: 12px;\n  background: var(--bg-secondary); border: 1px solid var(--border); border-radius: var(--radius-sm);\n  padding: 14px; transition: border-color 150ms, box-shadow 150ms;\n}\n.ntf-card--unread { border-color: var(--accent); cursor: pointer; background: rgba(59, 130, 246, 0.04); }\n.ntf-card:hover { box-shadow: 0 2px 10px rgba(1, 13, 33,0.08); }\n\n.ntf-icon {\n  flex-shrink: 0; width: 38px; height: 38px; border-radius: 50%;\n  display: flex; align-items: center; justify-content: center;\n}\n\n.ntf-body { flex: 1; min-width: 0; }\n.ntf-body-top { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }\n.ntf-item-title { margin: 0; font-size: 0.92rem; font-weight: 700; color: var(--text-primary); }\n.ntf-badge {\n  background: var(--bg-tertiary); color: var(--text-secondary); border-radius: 20px;\n  padding: 2px 9px; font-size: 0.7rem; font-weight: 700;\n}\n.ntf-msg { margin: 4px 0 0; font-size: 0.84rem; color: var(--text-secondary); line-height: 1.4; }\n\n.ntf-meta { flex-shrink: 0; display: flex; flex-direction: column; align-items: flex-end; gap: 3px; text-align: right; }\n.ntf-relative { display: flex; align-items: center; gap: 4px; font-size: 0.76rem; color: var(--text-tertiary); white-space: nowrap; }\n.ntf-absolute { font-size: 0.72rem; color: var(--text-tertiary); opacity: 0.75; white-space: nowrap; }\n\n.ntf-dot { position: absolute; top: 14px; left: -6px; width: 8px; height: 8px; border-radius: 50%; background: var(--accent); }\n\n.ntf-menu-wrap { position: relative; flex-shrink: 0; }\n.ntf-menu-btn {\n  background: none; border: none; color: var(--text-tertiary); cursor: pointer;\n  padding: 4px; border-radius: 6px; display: flex; align-items: center; justify-content: center;\n}\n.ntf-menu-btn:hover { background: var(--bg-tertiary); color: var(--text-primary); }\n.ntf-menu {\n  position: absolute; top: calc(100% + 4px); right: 0; z-index: 20;\n  background: var(--bg-primary); border: 1px solid var(--border); border-radius: var(--radius-sm);\n  box-shadow: 0 8px 24px rgba(1, 13, 33,0.15); padding: 6px; min-width: 160px;\n  display: flex; flex-direction: column; gap: 2px;\n}\n.ntf-menu button {\n  display: flex; align-items: center; gap: 8px; background: none; border: none; text-align: left;\n  padding: 8px 10px; border-radius: 6px; font-size: 0.82rem; color: var(--text-primary); cursor: pointer;\n}\n.ntf-menu button:hover { background: var(--bg-tertiary); }\n.ntf-menu-danger { color: var(--danger) !important; }\n.ntf-menu button:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.ntf-pagination { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-top: 18px; flex-wrap: wrap; }\n.ntf-pagination-info { margin: 0; font-size: 0.8rem; color: var(--text-tertiary); }\n.ntf-page-btns { display: flex; align-items: center; gap: 10px; }\n.ntf-page-arrow {\n  display: flex; align-items: center; justify-content: center; width: 32px; height: 32px;\n  border-radius: 50%; border: 1px solid var(--border); background: var(--bg-secondary); color: var(--text-primary); cursor: pointer;\n}\n.ntf-page-arrow:disabled { opacity: 0.4; cursor: not-allowed; }\n.ntf-page-current {\n  min-width: 32px; height: 32px; display: flex; align-items: center; justify-content: center;\n  border-radius: 50%; background: var(--accent); color: var(--color-text-on-secondary); font-weight: 700; font-size: 0.84rem;\n}\n\n@media (max-width: 640px) {\n  .ntf-card { flex-wrap: wrap; }\n  .ntf-meta { flex-direction: row; align-items: center; gap: 8px; margin-left: 50px; order: 3; width: 100%; text-align: left; }\n}\n\n\n/* Responsive */\n@media (max-width: 980px) {\n  .content-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .hero {\n    text-align: center;\n    justify-content: center;\n  }\n\n  .product-detail-container {\n    grid-template-columns: 1fr;\n    gap: var(--space-3);\n  }\n\n  .detail-image {\n    height: 300px;\n  }\n\n  .cart-item {\n    grid-template-columns: 88px 1fr;\n  }\n\n  .navbar-top {\n    flex-wrap: wrap;\n  }\n\n  .navbar-search {\n    min-width: 240px;\n    flex: 1;\n  }\n\n  .navbar-categories-bottom {\n    overflow-x: auto;\n  }\n\n  .category-icon-btn {\n    padding: 10px 16px;\n  }\n}\n\n@media (max-width: 640px) {\n  .topbar,\n  .hero,\n  .content-grid,\n  .product-panel,\n  .cart-panel,\n  .auth-container {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n\n  .navbar-top {\n    flex-direction: column;\n    gap: 10px;\n    padding: 10px 12px;\n  }\n\n  .brand {\n    font-size: 1.2rem;\n  }\n\n  .brand-button {\n    padding: 8px 12px;\n    flex: 0 0 auto;\n  }\n\n  .navbar-search {\n    min-width: 100%;\n    flex: 1;\n  }\n\n  .search-input {\n    padding: 10px 12px;\n    font-size: 0.9rem;\n  }\n\n  .navbar-actions-top {\n    width: 100%;\n    justify-content: space-around;\n    gap: 4px;\n  }\n\n  .btn-icon-text {\n    font-size: 0.75rem;\n    padding: 6px 8px;\n    flex: 1;\n    text-align: center;\n  }\n\n  .cart-icon-btn {\n    font-size: 1.4rem;\n    padding: 6px 8px;\n  }\n\n  .category-icon-btn {\n    padding: 8px 12px;\n    font-size: 0.75rem;\n  }\n\n  .category-icon {\n    font-size: 1.2rem;\n  }\n\n  .navbar-categories-bottom {\n    overflow-x: auto;\n  }\n\n  .hero {\n    padding-top: 20px;\n    padding-bottom: 20px;\n  }\n\n  .hero-copy h1 {\n    font-size: 1.6rem;\n  }\n\n  .product-grid {\n    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  }\n\n  .product-card img {\n    height: 140px;\n  }\n\n  .cart-item {\n    grid-template-columns: 70px 1fr;\n    gap: 12px;\n  }\n\n  .cart-item img {\n    width: 70px;\n    height: 70px;\n  }\n\n  .auth-container {\n    padding: 28px 16px;\n  }\n\n  .auth-container h1 {\n    font-size: 1.4rem;\n    margin-bottom: 20px;\n  }\n\n  .product-detail-container {\n    gap: 18px;\n  }\n\n  .detail-image {\n    height: 240px;\n  }\n\n  .detail-info h1 {\n    font-size: 1.6rem;\n  }\n\n  .detail-price {\n    font-size: 1.6rem;\n  }\n\n  .admin-tabs {\n    flex-direction: column;\n  }\n\n  .product-row,\n  .order-row {\n    grid-template-columns: 1fr;\n    gap: var(--space-1);\n  }\n}\n\n/* Checkout Multi-Step Styles */\n.checkout-steps {\n  display: flex;\n  justify-content: space-between;\n  gap: 0;\n  width: min(1120px, calc(100% - 32px));\n  max-width: 1120px;\n  margin: 0 auto 40px;\n  padding: 20px 40px;\n  box-sizing: border-box;\n}\n\n.step {\n  position: relative;\n  flex: 1 1 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-1);\n}\n\n/* Each step draws the segment leading to the next one. Keeping the segments\n   on the steps makes their centres stay aligned even when labels differ in\n   width or the checkout becomes narrower. */\n.step:not(:last-child)::after {\n  content: '';\n  position: absolute;\n  z-index: 0;\n  top: 23px;\n  left: calc(50% + 24px);\n  width: calc(100% - 48px);\n  height: 2px;\n  background: var(--border);\n}\n\n.step.completed:not(:last-child)::after {\n  background: var(--accent);\n}\n\n.step-number {\n  position: relative;\n  z-index: 1;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: var(--bg-tertiary);\n  border: 2px solid var(--border);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  color: var(--text-secondary);\n  font-size: 1.1rem;\n}\n\n.step.active .step-number {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: var(--color-text-on-secondary);\n}\n\n.step.completed .step-number {\n  background: var(--success);\n  border-color: var(--success);\n  color: var(--color-text-on-secondary);\n  font-size: 1.3rem;\n}\n\n.step-label {\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n.step.active .step-label {\n  color: var(--accent);\n  font-weight: 600;\n}\n\n.checkout-step-pad {\n  padding: 40px 20px;\n}\n\n/* Checkout Container */\n.checkout-container {\n  max-width: 800px;\n  margin: 0 auto;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 30px;\n  box-shadow: var(--shadow-panel);\n}\n\n/* Delivery-address checkout needs more horizontal room than the compact\n   payment/summary steps. Keep this scoped so those steps retain their\n   intentionally narrow reading width. */\n.checkout-address-container {\n  width: min(1120px, calc(100% - 32px));\n  max-width: 1120px;\n  box-sizing: border-box;\n  padding: 34px 40px;\n}\n\n.checkout-address-container .address-section {\n  margin-bottom: 0;\n}\n\n.checkout-address-container .ab-page {\n  min-height: 0;\n  padding: 10px 0 0;\n  background: transparent;\n}\n\n.checkout-address-container .ab-cards-grid {\n  max-width: none;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 24px;\n  margin-bottom: 18px;\n}\n\n.checkout-address-container .ab-card {\n  min-width: 0;\n  min-height: 190px;\n  padding: 26px 28px;\n}\n\n.checkout-address-container .ab-card-top {\n  gap: 14px;\n  margin-bottom: 18px;\n}\n\n.checkout-address-container .ab-card-info {\n  gap: 10px;\n  padding-bottom: 0;\n}\n\n.checkout-address-container .ab-info-row {\n  gap: 12px;\n  font-size: 0.9rem;\n  line-height: 1.65;\n  overflow-wrap: anywhere;\n}\n\n@media (max-width: 850px) {\n  .checkout-address-container {\n    width: min(680px, calc(100% - 24px));\n    padding: 26px;\n  }\n\n  .checkout-address-container .ab-cards-grid {\n    grid-template-columns: 1fr;\n    gap: 18px;\n  }\n}\n\n/* On mobile these two paddings stack with .ab-page's own mobile padding\n   (used for the address-card picker embedded in checkout step 1), leaving\n   the cards with a large, cramped-looking margin on both edges. Cut both\n   back so the cards can actually use the screen width. */\n@media (max-width: 600px) {\n  .checkout-step-pad { padding: 20px 8px; }\n  .checkout-container { padding: 12px; }\n  .checkout-address-container { width: 100%; }\n  .checkout-address-container .ab-card {\n    min-height: 0;\n    padding: 20px;\n  }\n}\n\n.address-section {\n  margin-bottom: 30px;\n}\n\n.address-section h2,\n.address-form-section h2 {\n  font-size: 1.2rem;\n  margin-bottom: 20px;\n  color: var(--text-primary);\n}\n\n.address-display {\n  background: var(--bg-tertiary);\n  padding: 20px;\n  border-radius: var(--radius-sm);\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.address-info {\n  flex: 1;\n}\n\n.address-info p {\n  margin: 4px 0;\n  color: var(--text-primary);\n  font-size: 0.95rem;\n}\n\n.address-info p strong {\n  font-weight: 600;\n}\n\n.btn-link {\n  background: none;\n  border: none;\n  color: var(--accent);\n  cursor: pointer;\n  font-weight: 600;\n  padding: 0;\n  text-decoration: underline;\n  font-size: 0.95rem;\n}\n\n.btn-link:hover {\n  color: var(--accent-hover);\n}\n\n.address-form-section {\n  margin-bottom: 20px;\n}\n\n.form-group {\n  margin-bottom: 16px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 500;\n  color: var(--text-primary);\n  font-size: 0.95rem;\n}\n\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  font-size: 0.95rem;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-family: inherit;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: var(--space-2);\n}\n\n/* Order Summary */\n.checkout-summary-pad {\n  padding: 22px 30px 48px;\n}\n\n.checkout-summary-pad .checkout-steps {\n  margin-bottom: 24px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.order-summary-container {\n  display: grid;\n  grid-template-columns: minmax(0, 1.8fr) minmax(340px, 0.9fr);\n  gap: 24px;\n  width: 100%;\n  max-width: 1440px;\n  margin: 0 auto;\n  align-items: start;\n}\n\n.summary-left {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  min-width: 0;\n}\n\n.summary-left .address-section,\n.summary-left .order-items-section {\n  background: var(--bg-secondary);\n  padding: 24px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-card);\n}\n\n.summary-left .address-display {\n  margin-bottom: 0;\n  padding: 20px 22px;\n  border: 1px solid var(--border);\n}\n\n.summary-left h3 {\n  font-size: 1.1rem;\n  margin-bottom: 15px;\n  color: var(--text-primary);\n}\n\n.order-items {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n/* ── Flipkart-style order item ──────────────────────────────── */\n.fi-item {\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  margin-bottom: 12px;\n  background: var(--bg-secondary);\n  overflow: hidden;\n  box-shadow: var(--shadow-card);\n}\n\n.fi-content-row {\n  display: flex;\n  gap: 20px;\n  padding: 18px 20px 16px;\n}\n\n/* Left column: image + qty dropdown */\n.fi-left {\n  flex: 0 0 90px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n}\n\n.fi-img {\n  width: 90px;\n  height: 90px;\n  object-fit: contain;\n  border-radius: var(--radius-xs);\n  background: var(--bg-primary);\n  padding: 4px;\n}\n\n.fi-qty-wrap {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xs);\n  padding: 4px 8px;\n  background: var(--bg-primary);\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  width: 100%;\n  justify-content: center;\n}\n\n.fi-qty-label { color: var(--text-secondary); }\n\n.fi-qty-select {\n  border: none;\n  background: transparent;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n  padding: 0;\n}\n\n.fi-qty-arrow {\n  font-size: 0.6rem;\n  color: var(--text-secondary);\n  pointer-events: none;\n}\n\n/* Right column: product details */\n.fi-right {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.fi-name {\n  font-size: 0.92rem;\n  font-weight: 500;\n  color: var(--text-primary);\n  line-height: 1.4;\n  margin: 0;\n}\n\n.fi-size { font-size: 0.78rem; color: var(--text-secondary); margin: 2px 0 0; }\n\n.fi-meta-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin: 2px 0;\n}\n\n.fi-rating-pill {\n  background: var(--color-rating);\n  color: var(--color-brand-white);\n  font-size: 0.7rem;\n  font-weight: 700;\n  padding: 2px 6px;\n  border-radius: var(--radius-xs);\n}\n\n.fi-review-cnt {\n  font-size: 0.72rem;\n  color: var(--text-secondary);\n}\n\n.fi-assured {\n  font-size: 0.72rem;\n  color: var(--color-secondary);\n  font-weight: 600;\n}\n\n.fi-price-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--space-1);\n  row-gap: 2px;\n  margin: 3px 0;\n}\n\n.fi-mrp {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  text-decoration: line-through;\n}\n\n.fi-price {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.fi-line-total {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n.fi-delivery {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 4px;\n}\n\n.fi-express-badge {\n  font-size: 0.68rem;\n  font-weight: 800;\n  color: var(--color-secondary);\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.fi-delivery-text {\n  font-size: 0.76rem;\n  color: var(--text-secondary);\n}\n\n/* Action row */\n.fi-actions {\n  display: flex;\n  align-items: stretch;\n  border-top: 1px solid var(--border);\n}\n\n.fi-action-btn {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  padding: 10px 6px;\n  font-size: 0.78rem;\n  font-weight: 500;\n  color: var(--text-secondary);\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: background 140ms, color 140ms;\n  text-align: center;\n}\n\n/* Same undefined --bg-card as .auth-gate-tab above; same silent no-op hover. */\n.fi-action-btn:hover {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n.fi-action-remove { }\n.fi-action-remove:hover { color: #c62828; }\n\n.fi-action-buy { color: var(--color-secondary); }\n.fi-action-buy:hover { background: rgba(40, 116, 240, 0.07); }\n\n.fi-action-sep {\n  width: 1px;\n  background: var(--border);\n  align-self: stretch;\n}\n\n/* Checkout delivery selector */\n.checkout-del-opt {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  background: var(--bg-primary);\n  transition: border-color 150ms;\n  font-size: 0.84rem;\n}\n.checkout-del-opt > div {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n}\n.checkout-del-opt > div > span {\n  margin-left: 0 !important;\n  line-height: 1.35;\n}\n.checkout-del-opt input[type=\"radio\"] { accent-color: var(--accent); cursor: pointer; }\n.checkout-del-opt:hover { border-color: var(--accent) !important; }\n\n/* Savings banner */\n.fi-savings-banner {\n  margin-top: 12px;\n  padding: 10px 14px;\n  background: #e8f5e9;\n  color: #2e7d32;\n  border-radius: var(--radius-xs);\n  font-size: 0.82rem;\n  font-weight: 600;\n}\n\n[data-theme=\"dark\"] .fi-savings-banner {\n  background: rgba(46, 125, 50, 0.18);\n  color: #81c784;\n}\n\n/* Right sticky column — card + button scroll together */\n.summary-right {\n  position: sticky;\n  top: 72px;\n  align-self: start;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n/* Price Details */\n.price-details {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 24px;\n  box-shadow: var(--shadow-card);\n}\n\n.price-details h3 {\n  font-size: 1.2rem;\n  margin-bottom: 20px;\n  color: var(--text-primary);\n}\n\n.price-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 14px;\n  font-size: 0.95rem;\n  color: var(--text-secondary);\n}\n\n.price-row.total {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--border);\n  font-weight: 600;\n  font-size: 1.05rem;\n  color: var(--text-primary);\n}\n\n/* The total is the row the shopper is actually deciding on, so it outweighs\n   everything above it: navy (not an accent colour), heavier, and a step up in\n   size. Accent colours are for actions; this is the number. */\n.price-row.total span:last-child {\n  color: var(--text-primary);\n  font-weight: 800;\n  font-size: 1.18rem;\n  letter-spacing: -0.01em;\n}\n\n.free {\n  color: var(--success);\n  font-weight: 600;\n}\n\n.savings {\n  color: var(--success);\n  font-size: 0.85rem;\n  margin-top: 12px;\n  font-weight: 500;\n}\n\n.btn-place-order {\n  width: 100%;\n  margin-top: 20px;\n  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  font-weight: 600;\n  cursor: pointer;\n  border-radius: var(--radius-sm);\n  font-size: 1rem;\n  transition: all 200ms ease;\n}\n\n.btn-place-order:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n/* Mobile Responsive */\n@media (max-width: 980px) {\n  .checkout-steps {\n    gap: 0;\n  }\n\n  .order-summary-container {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .summary-right {\n    position: static;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 680px) {\n  .checkout-summary-pad { padding: 18px 12px 36px; }\n  .summary-left .address-section,\n  .summary-left .order-items-section,\n  .price-details { padding: 18px; }\n  .summary-left .address-display { gap: 16px; flex-direction: column; }\n  .fi-content-row { gap: 14px; padding: 14px; }\n  .fi-left { flex-basis: 76px; }\n  .fi-img { width: 76px; height: 76px; }\n}\n\n/* ── Order Timeline ───────────────────────────────────── */\n.order-history-page h1 {\n  margin-bottom: 24px;\n  font-size: 1.8rem;\n  color: var(--text-primary);\n}\n\n.orders-list { display: flex; flex-direction: column; gap: 14px; }\n\n.order-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  transition: box-shadow 150ms;\n  box-shadow: var(--shadow-card);\n}\n\n.order-card:hover { box-shadow: 0 2px 12px rgba(1, 13, 33,0.08); }\n\n.order-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 20px;\n  background: none;\n  border: none;\n  width: 100%;\n  cursor: pointer;\n  text-align: left;\n  gap: 12px;\n}\n\n.order-header-left h3 {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 3px;\n}\n\n.order-date {\n  font-size: 0.82rem;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n.order-header-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.order-total-badge {\n  font-weight: 700;\n  font-size: 1rem;\n  color: var(--text-primary);\n}\n\n.order-chevron {\n  font-size: 0.7rem;\n  color: var(--text-secondary);\n}\n\n.order-card-body {\n  padding: 0 20px 20px;\n  border-top: 1px solid var(--border);\n}\n\n/* Timeline */\n.order-timeline {\n  display: flex;\n  align-items: flex-start;\n  gap: 0;\n  padding: 20px 0 16px;\n  overflow-x: auto;\n}\n\n.timeline-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n  position: relative;\n  gap: 6px;\n}\n\n.timeline-dot {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 2px solid var(--border);\n  background: var(--bg-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  z-index: 1;\n  position: relative;\n  transition: all 200ms;\n}\n\n.timeline-step.done .timeline-dot {\n  border-color: var(--accent);\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n}\n\n.timeline-step.current .timeline-dot {\n  border-color: var(--accent);\n  background: var(--accent);\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.18);\n}\n\n.timeline-icon { font-size: 1rem; }\n.timeline-num  { font-size: 0.82rem; font-weight: 700; }\n\n.timeline-line {\n  position: absolute;\n  top: 18px;\n  left: calc(50% + 18px);\n  width: calc(100% - 36px);\n  height: 2px;\n  background: var(--border);\n}\n\n.timeline-line.filled { background: var(--accent); }\n\n.timeline-label {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-align: center;\n  white-space: nowrap;\n}\n\n.timeline-step.done .timeline-label { color: var(--accent); }\n\n.timeline-cancelled {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-1);\n  margin: 16px 0;\n  padding: 8px 16px;\n  background: var(--color-primary-soft);\n  color: var(--color-primary);\n  border-radius: var(--radius-sm);\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n/* Order items inside card */\n.order-items { margin-top: 4px; }\n.order-items h4 { font-size: 0.85rem; font-weight: 600; color: var(--text-secondary); text-transform: uppercase; letter-spacing: 0.06em; margin: 0 0 8px; }\n\n.order-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 0;\n  border-bottom: 1px solid var(--border);\n  font-size: 0.9rem;\n}\n\n.order-item:last-child { border-bottom: none; }\n.order-item-name  { flex: 1; color: var(--text-primary); }\n.order-item-qty   { color: var(--text-secondary); font-size: 0.82rem; }\n.order-item-price { font-weight: 600; color: var(--text-primary); }\n\n.order-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-top: 14px;\n  padding-top: 14px;\n  border-top: 1px solid var(--border);\n  gap: var(--space-2);\n  flex-wrap: wrap;\n}\n\n.order-address {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n.order-address strong { color: var(--text-primary); margin-bottom: 2px; }\n\n.order-total-row {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n}\n\n.order-total-row span { font-size: 0.82rem; color: var(--text-secondary); }\n.order-total-row strong { font-size: 1.15rem; color: var(--text-primary); }\n\n/* ── Product Card Ratings ─────────────────────────────── */\n.card-rating {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 6px;\n  font-size: 0.82rem;\n}\n\n.card-stars {\n  color: var(--color-primary);\n  letter-spacing: 1px;\n  font-size: 0.85rem;\n}\n\n.card-rating-val {\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.card-review-count {\n  color: var(--text-secondary);\n}\n\n.detail-stars {\n  color: var(--color-primary);\n  font-size: 1.1rem;\n  letter-spacing: 2px;\n}\n\n.card-rating-empty {\n  color: var(--text-secondary);\n  font-size: 0.78rem;\n  font-style: italic;\n}\n\n/* ── Sort + Controls Row ──────────────────────────────── */\n.controls-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.sort-select {\n  padding: 8px 12px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 0.88rem;\n  font-family: inherit;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.sort-select:focus {\n  outline: none;\n  border-color: var(--accent);\n}\n\n/* ── Admin Analytics ──────────────────────────────────── */\n.analytics-section { display: flex; flex-direction: column; gap: var(--space-3); }\n\n.kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: var(--space-2);\n}\n\n.kpi-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 20px 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  border-top: 3px solid var(--kpi-color, var(--accent));\n  position: relative;\n  overflow: hidden;\n  box-shadow: var(--shadow-card);\n  transition: transform 280ms var(--ease-out-expo, ease), box-shadow 280ms var(--ease-out-expo, ease);\n}\n\n.kpi-card::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(135deg, var(--kpi-color, var(--accent)) 0%, transparent 60%);\n  opacity: 0.04;\n  pointer-events: none;\n}\n\n.kpi-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 12px 32px rgba(1, 13, 33,0.14);\n}\n\n[data-theme=\"dark\"] .kpi-card:hover {\n  box-shadow: 0 12px 32px rgba(1, 13, 33,0.4);\n}\n\n.kpi-label {\n  font-size: 0.78rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--text-secondary);\n}\n\n.kpi-value {\n  font-size: 1.65rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  line-height: 1.1;\n}\n\n.kpi-sub {\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n}\n\n.analytics-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--space-2);\n}\n\n.analytics-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 20px;\n  box-shadow: var(--shadow-card);\n}\n\n.analytics-card.wide {\n  grid-column: 1 / -1;\n}\n\n.analytics-card h3 {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 16px;\n}\n\n.chart-tooltip {\n  background: var(--bg-primary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 10px 14px;\n  font-size: 0.85rem;\n  color: var(--text-primary);\n}\n\n.chart-tooltip-label {\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n/* Top products list */\n.top-products-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.top-product-item {\n  display: grid;\n  grid-template-columns: 28px 1fr auto auto;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-sm);\n  font-size: 0.88rem;\n}\n\n.top-rank {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--text-secondary);\n}\n\n.top-name {\n  font-weight: 500;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.top-units {\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n.top-revenue {\n  font-weight: 700;\n  color: var(--accent);\n  white-space: nowrap;\n}\n\n/* Recent orders list */\n.recent-orders-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n}\n\n.recent-order-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 12px;\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-sm);\n}\n\n.recent-order-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.recent-order-id {\n  font-size: 0.75rem;\n  font-family: monospace;\n  color: var(--text-secondary);\n}\n\n.recent-order-name {\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.recent-order-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.recent-order-total {\n  font-weight: 700;\n  font-size: 0.9rem;\n  color: var(--text-primary);\n}\n\n@media (max-width: 900px) {\n  .kpi-grid { grid-template-columns: 1fr 1fr; }\n  .analytics-grid { grid-template-columns: 1fr; }\n  .analytics-card.wide { grid-column: 1; }\n}\n\n@media (max-width: 500px) {\n  .kpi-grid { grid-template-columns: 1fr; }\n}\n\n/* ── Profile Page ─────────────────────────────────────── */\n.pf-page {\n  max-width: 640px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n.pf-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: var(--space-3);\n  box-shadow: var(--shadow-card);\n}\n\n.pf-avatar-row {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n}\n\n.pf-avatar-wrap {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.pf-avatar {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--accent), var(--accent-secondary));\n  color: var(--color-brand-white);\n  font-size: 2rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pf-avatar-img {\n  object-fit: cover;\n}\n\n.pf-avatar-spinner {\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  background: rgba(1, 13, 33, 0.45);\n  display: flex;\n}\n\n.pf-avatar-spinner::after {\n  content: '';\n  margin: auto;\n  width: 22px;\n  height: 22px;\n  border: 3px solid rgba(255, 255, 255, 0.35);\n  border-top-color: var(--color-brand-white);\n  border-radius: 50%;\n  animation: spin 800ms linear infinite;\n}\n\n.pf-avatar-edit {\n  position: absolute;\n  right: -2px;\n  bottom: -2px;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  color: var(--accent);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: var(--shadow-card);\n  cursor: pointer;\n  padding: 0;\n}\n\n.pf-avatar-edit:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.pf-identity {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.pf-name {\n  font-size: 1.3rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.pf-role-badge {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: var(--accent-secondary);\n  background: color-mix(in srgb, var(--accent-secondary) 12%, transparent);\n  border-radius: var(--radius-pill);\n  padding: 3px 12px;\n  width: fit-content;\n}\n\n.pf-info-row {\n  display: flex;\n  align-items: center;\n  margin-top: var(--space-3);\n  padding-top: var(--space-3);\n  border-top: 1px solid var(--border);\n}\n\n.pf-info-item {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.pf-info-divider {\n  width: 1px;\n  height: 32px;\n  background: var(--border);\n  margin: 0 var(--space-2);\n}\n\n.pf-info-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: color-mix(in srgb, var(--accent-secondary) 12%, transparent);\n  color: var(--accent-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.pf-info-text { min-width: 0; }\n\n.pf-info-label {\n  font-size: 0.74rem;\n  color: var(--text-muted);\n}\n\n.pf-info-value {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pf-card-hdr {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: var(--space-3);\n}\n\n.pf-card-hdr-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-sm);\n  background: color-mix(in srgb, var(--accent-secondary) 12%, transparent);\n  color: var(--accent-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.pf-card-hdr h3 {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.pf-card-hdr p {\n  font-size: 0.82rem;\n  color: var(--text-secondary);\n  margin: 2px 0 0;\n}\n\n.pf-form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n\n.pf-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.pf-field-label {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.pf-input-wrap {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 0 14px;\n  background: var(--bg-primary);\n}\n\n.pf-input-wrap:focus-within {\n  border-color: var(--accent);\n}\n\n.pf-input-icon {\n  color: var(--text-muted);\n  display: flex;\n  flex-shrink: 0;\n}\n\n.pf-input-wrap input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  padding: 12px 0;\n  font-size: 0.92rem;\n  color: var(--text-primary);\n}\n\n.pf-input-wrap input:focus { outline: none; }\n\n.pf-input-eye {\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  display: flex;\n  flex-shrink: 0;\n  padding: 4px;\n}\n\n.pf-btn-primary,\n.pf-btn-secondary {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 46px;\n  border-radius: var(--radius-sm);\n  font-size: 0.95rem;\n  font-weight: 700;\n  cursor: pointer;\n  margin-top: 6px;\n}\n\n/* \"Save changes\" is a primary commercial action -> orange, navy label. */\n.pf-btn-primary {\n  border: none;\n  background: var(--color-primary);\n  color: var(--color-text-on-primary);\n}\n\n.pf-btn-primary:hover:not(:disabled) {\n  background: var(--accent-secondary-hover);\n}\n\n.pf-btn-secondary {\n  border: none;\n  background: color-mix(in srgb, var(--accent-secondary) 12%, transparent);\n  color: var(--accent-secondary);\n}\n\n.pf-btn-secondary:hover:not(:disabled) {\n  background: color-mix(in srgb, var(--accent-secondary) 20%, transparent);\n}\n\n.pf-btn-primary:disabled,\n.pf-btn-secondary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n@media (max-width: 480px) {\n  /* Side-by-side email + member-since truncates the email at narrow\n     widths -- stack them so each value gets the full row width instead. */\n  .pf-info-row {\n    flex-direction: column;\n    align-items: stretch;\n    gap: var(--space-2);\n  }\n  .pf-info-divider { display: none; }\n}\n\n/* ── Cash on Delivery Payment Step ───────────────────── */\n.cod-payment-section {\n  max-width: 560px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n.cod-payment-section h2 {\n  font-size: 1.4rem;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.payment-method-card {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: 18px 20px;\n  border: 2px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: var(--bg-secondary);\n  cursor: pointer;\n  transition: border-color 200ms;\n  box-shadow: var(--shadow-card);\n}\n\n.payment-method-card.selected {\n  border-color: var(--accent);\n  background: rgba(59, 130, 246, 0.05);\n}\n\n/* COD-only confirmation panel (no method to choose): not a clickable chooser,\n   so drop the pointer affordance and read as a settled, confirmed state. */\n.payment-method-cod-confirm {\n  cursor: default;\n  border-color: color-mix(in srgb, var(--success) 40%, transparent);\n  background: color-mix(in srgb, var(--success) 6%, transparent);\n}\n\n/* .payment-method-icon and .payment-method-info are gone, here and in\n   mobile/screens.css. Every payment card is now a marker, a .co-selected-title\n   and (on the chosen one) a chip -- no glyph tile, no title-and-blurb column --\n   so nothing rendered these any more.\n\n   Deleted rather than left in place on purpose. Orphaned rules describing a\n   structure that no longer exists are the same trap the mobile layer's\n   three-column grid turned out to be: confident, specific, and about a card\n   that had changed shape underneath them. */\n\n/* .payment-method-check is gone: the chooser marked its chosen card with a\n   standalone tick glyph, and that job now belongs to the filled marker and the\n   Selected chip. Nothing else referenced it. */\n.cod-order-recap,\n.cod-address-recap {\n  padding: 18px 20px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: var(--bg-secondary);\n  box-shadow: var(--shadow-card);\n}\n\n.cod-order-recap h3,\n.cod-address-recap h3 {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 14px;\n}\n\n.zone-check-status {\n  margin-top: 8px !important;\n  font-weight: 600;\n  font-size: 0.85rem !important;\n}\n.zone-check-status.zone-ok { color: var(--success); }\n.zone-check-status.zone-warn { color: var(--danger); }\n\n.cod-address-recap p {\n  margin: 4px 0;\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n}\n\n.cod-address-recap p strong {\n  color: var(--text-primary);\n}\n\n/* ── Order Success Page ──────────────────────────────────────── */\n.order-success-wrap,\n.order-success-wrap * {\n  box-sizing: border-box;\n}\n\n.order-success-wrap {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  text-align: center;\n}\n\n.order-success-hero {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 10px;\n}\n\n.order-success-icon {\n  position: relative;\n  z-index: 1;\n  width: 84px;\n  height: 84px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(34,255,122,0.18) 0%, rgba(34,255,122,0.05) 55%, transparent 100%);\n  border: 3px solid #2dff85;\n  color: var(--color-brand-white);\n  font-size: 2.1rem;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow:\n    0 0 10px 2px rgba(45,255,133,0.85),\n    0 0 28px 8px rgba(45,255,133,0.5),\n    0 0 56px 18px rgba(45,255,133,0.28),\n    inset 0 0 18px rgba(45,255,133,0.35);\n  animation: scale-in 0.35s ease-out;\n}\n\n[data-theme=\"light\"] .order-success-icon {\n  background: radial-gradient(circle, var(--success) 0%, color-mix(in srgb, var(--success) 78%, var(--color-brand-navy)) 100%);\n  border-color: var(--success);\n  box-shadow:\n    0 0 10px 2px color-mix(in srgb, var(--success) 45%, transparent),\n    0 0 28px 8px color-mix(in srgb, var(--success) 30%, transparent),\n    0 0 56px 18px color-mix(in srgb, var(--success) 16%, transparent);\n}\n\n.order-success-confetti {\n  position: absolute;\n  inset: -40px;\n  pointer-events: none;\n}\n\n.confetti-piece {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 9px;\n  height: 9px;\n  border-radius: 2.5px;\n  opacity: 0;\n  animation: confetti-burst 1.8s ease-out forwards;\n  animation-delay: calc(var(--i) * 0.04s);\n  transform: rotate(calc(var(--i) * 37deg));\n}\n.confetti-piece:nth-child(3n)   { width: 11px; height: 11px; }\n.confetti-piece:nth-child(3n+1) { width: 7px; height: 7px; }\n.confetti-0 { background: var(--color-primary); }\n.confetti-1 { background: var(--color-secondary); }\n.confetti-2 { background: var(--success); }\n.confetti-3 { background: var(--danger); }\n.confetti-4 { background: #a855f7; }\n.confetti-5 { background: var(--color-secondary); }\n\n@keyframes confetti-burst {\n  0%   { opacity: 1; transform: rotate(calc(var(--i) * 37deg)) translate(0, 0) scale(0.6); }\n  18%  { opacity: 1; transform: rotate(calc(var(--i) * 37deg)) translate(0, -58px) scale(1.1); }\n  70%  { opacity: 1; transform: rotate(calc(var(--i) * 37deg)) translate(0, -58px) scale(1); }\n  100% { opacity: 0; transform: rotate(calc(var(--i) * 37deg)) translate(0, -70px) scale(0.7); }\n}\n\n.order-success-title {\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.order-success-sub {\n  font-size: 1.02rem;\n  color: var(--text-secondary);\n  margin: 0 0 16px;\n  max-width: 420px;\n}\n\n.order-success-trust {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: color-mix(in srgb, var(--success) 10%, transparent);\n  border: 1px solid color-mix(in srgb, var(--success) 30%, transparent);\n  color: var(--success);\n  font-size: 0.94rem;\n  font-weight: 600;\n  border-radius: 999px;\n  padding: 8px 18px;\n  margin-bottom: 20px;\n}\n\n/* ── Order-placed screen, mobile treatment ────────────────────────────────\n   The desktop version is a long report: a pill-shaped confirmation, four\n   stat cards in a row, a \"What's Next?\" explainer and a recommendations\n   grid. On a phone that becomes a lot of scrolling before the two facts that\n   actually matter -- it worked, and here is the order number.\n\n   Everything below hangs off html.m-app, so the packaged app and the phone\n   browser get the same screen. The desktop site keeps its layout, which suits\n   a wide viewport and is doing SEO work a phone does not need. */\n\n/* The confirmation is a full-width band rather than a centred pill: on a\n   narrow screen a pill either wraps awkwardly or shrinks the sentence, and a\n   band reads as a status bar for the whole page. Square corners requested;\n   they also let it sit flush against the content above and below. */\nhtml.m-app .order-success-trust {\n  display: flex;\n  width: 100%;\n  box-sizing: border-box;\n  justify-content: center;\n  text-align: left;\n  border-radius: 0;\n  border-left: 0;\n  border-right: 0;\n  padding: 12px 16px;\n  font-size: 0.82rem;\n  background: var(--color-app-success-soft);\n  border-color: var(--color-app-success-border);\n  color: var(--color-app-success);\n}\n\n/* Two columns, not four. At four the labels (\"PAYMENT METHOD\", \"EST\n   DELIVERY\") were wrapping inside 90px cards and the values underneath them\n   broke mid-word. The secondary line in each card goes too -- the date range\n   and \"Pay on delivery\" are detail the tracking page already carries. */\nhtml.m-app .order-success-stats {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n}\nhtml.m-app .oss-card { padding: 10px; gap: 8px; }\nhtml.m-app .oss-icon { width: 26px; height: 26px; border-radius: 7px; }\nhtml.m-app .oss-label { font-size: 0.62rem; margin-bottom: 1px; }\nhtml.m-app .oss-value { font-size: 0.78rem; line-height: 1.3; }\nhtml.m-app .oss-sub-detail { display: none; }\nhtml.m-app .oss-pill { font-size: 0.6rem; }\nhtml.m-app .oss-fast-pill { display: none; }\n\n/* Removed in the app: it explains what the tracker directly above it is\n   already showing, and the three mini-items repeat the email/notification\n   promises made at checkout. */\nhtml.m-app .order-success-next { display: none; }\n\n/* ── The order-placed page gets its edges back ────────────────────────────\n   Everything on this screen was running 0 -> 390: the tracker, the stat\n   cards and the items list all touched both bezels, so cards that are drawn\n   with a border had that border sitting on the edge of the glass and read as\n   clipped rather than as cards.\n\n   Checkout is the surface that benefits from full-bleed -- it is a form, and\n   width is what its rows need. This screen is a receipt: a stack of discrete\n   cards, which need an edge to sit against to look like cards at all. */\nhtml.m-app .order-success-wrap {\n  padding-left: 14px;\n  padding-right: 14px;\n  box-sizing: border-box;\n}\n\n/* The confirmation band is the exception and stays edge to edge. It is a\n   status bar for the whole screen rather than one of the cards, so it is\n   pulled back out through the padding just added above. */\nhtml.m-app .order-success-trust {\n  width: calc(100% + 28px);\n  margin-left: -14px;\n  margin-right: -14px;\n}\n\n/* ── Progress tracker goes vertical on a phone ────────────────────────────\n   Four steps laid out across 390px leaves about 60px each, so every label\n   (\"Order Received\", \"Payment Confirmed\") is squeezed into a two-line stack\n   under a 32px dot, and the timestamps below them have nowhere to go. The\n   horizontal form is right on a wide canvas and wrong in the hand.\n\n   Stacked, each step gets the full width: dot on the left, label and its\n   timestamp beside it, and the connector running down between dots. This is\n   the ordinary shape of a progress list on a phone, and it leaves room for\n   the timestamp to be read rather than truncated.\n\n   Done with grid rather than new markup. The step's three children -- dot,\n   label, and either a timestamp or the \"In Progress\" pill -- are siblings\n   with no wrapper around the text pair, so a flex row would put all three\n   side by side. Named areas place the dot in a column of its own spanning\n   both rows, and the text stacks beside it. */\nhtml.m-app .order-success-tracker {\n  flex-direction: column;\n  align-items: stretch;\n  padding: 16px 18px;\n}\n\n/* The dot column is a fixed 38px -- the width of the largest dot -- rather\n   than sized to each step's own content.\n\n   That difference is what made the column look ragged. The active step's dot\n   is 38px while the rest are 32px, so an auto-sized column gave that one step\n   a wider first track: its dot centre landed 3px right of the others and its\n   label 6px right, leaving the connectors zig-zagging between them and the\n   text edge stepping in and out. Pinning the track and centring the dot inside\n   it puts every dot, every connector and every label on one axis, whatever\n   size the dot happens to be. */\nhtml.m-app .ost-step {\n  display: grid;\n  grid-template-columns: 38px minmax(0, 1fr);\n  grid-template-areas:\n    \"dot label\"\n    \"dot sub\";\n  align-items: center;\n  column-gap: 13px;\n  text-align: left;\n}\n\nhtml.m-app .ost-dot {\n  grid-area: dot;\n  justify-self: center;\n}\n/* max-width: none is the load-bearing line here.\n\n   The horizontal layout caps these at 80px below 820px and 60px below 600px,\n   because there each label had to fit a narrow column. Stacked, that cap is\n   exactly wrong: the label had a 301px track available and was still being\n   held to 60px, wrapping \"Order Received\" onto two lines with 240px of empty\n   column beside it -- which is what made the list look ragged.\n\n   Specificity alone did not fix it. This selector already outranks the media\n   query's, but width and max-width are different properties, so a wider width\n   never contended with the cap; it had to be lifted by name. */\nhtml.m-app .ost-label,\nhtml.m-app .ost-sub {\n  max-width: none;\n  width: 100%;\n  justify-self: stretch;\n  white-space: normal;\n}\n\nhtml.m-app .ost-label {\n  grid-area: label;\n  margin: 0;\n}\nhtml.m-app .ost-sub { grid-area: sub; }\nhtml.m-app .ost-pill-active { grid-area: sub; justify-self: start; margin-top: 3px; }\n\n/* The connector is a sibling of the steps, not a child, so in a column it\n   becomes a short vertical rule. 18px puts its 2px width centred on 19 --\n   the middle of the 38px dot track above -- so it meets every dot dead centre\n   regardless of that dot's own size. */\nhtml.m-app .ost-line {\n  flex: 0 0 auto;\n  width: 2px;\n  height: 20px;\n  margin: 3px 0 3px 18px;\n  background-image: repeating-linear-gradient(\n    to bottom,\n    var(--border) 0, var(--border) 5px, transparent 5px, transparent 10px\n  );\n}\nhtml.m-app .ost-line-done { background-image: none; background-color: var(--success); }\n\n/* Progress tracker */\n.order-success-tracker {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-card);\n  padding: 20px 16px;\n  margin-bottom: 16px;\n}\n\n/* Each step is sized to its own content (dot + label), so dot and label\n   share the same center automatically. Connecting lines are separate\n   flex:1 siblings that absorb all the space between steps — this is what\n   keeps the first dot flush-left, the last dot flush-right, and every gap\n   in between equal, with no leftover slack on either edge. */\n.ost-step {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.ost-dot {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: var(--bg-tertiary);\n  border: 2px solid var(--border);\n  color: var(--text-tertiary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.95rem;\n  flex-shrink: 0;\n}\n.ost-dot-done { background: var(--success); border-color: var(--success); color: var(--color-text-on-secondary); }\n.ost-dot-active {\n  width: 38px;\n  height: 38px;\n  background: var(--success);\n  border-color: var(--success);\n  color: var(--color-text-on-secondary);\n  font-size: 1.1rem;\n  animation: pulse-ring-active 1.6s ease-out infinite;\n}\n\n@keyframes pulse-ring-active {\n  0%   { box-shadow: 0 0 0 0   color-mix(in srgb, var(--success) 45%, transparent); }\n  70%  { box-shadow: 0 0 0 10px color-mix(in srgb, var(--success) 0%, transparent); }\n  100% { box-shadow: 0 0 0 0   color-mix(in srgb, var(--success) 0%, transparent); }\n}\n\n.ost-line {\n  flex: 1;\n  height: 2px;\n  margin-top: 15px;\n  background-image: repeating-linear-gradient(to right, var(--border) 0, var(--border) 5px, transparent 5px, transparent 10px);\n}\n.ost-line-done { background-image: none; background-color: var(--success); }\n\n.ost-label {\n  font-size: 0.86rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin: 8px 0 2px;\n  white-space: nowrap;\n}\n.ost-label-done { color: var(--success); }\n.ost-label-active { color: var(--text-primary); font-weight: 700; }\n\n.ost-sub {\n  font-size: 0.78rem;\n  color: var(--text-tertiary);\n  margin: 0;\n  white-space: nowrap;\n}\n\n.ost-pill-active {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: var(--success);\n  background: color-mix(in srgb, var(--success) 12%, transparent);\n  border-radius: 999px;\n  padding: 2px 9px;\n  margin-top: 1px;\n  white-space: nowrap;\n}\n\n/* Below ~820px, steps no longer have room to sit at their natural width —\n   let labels wrap instead of forcing the row wider than its container. */\n@media (max-width: 820px) {\n  .ost-label, .ost-sub { white-space: normal; max-width: 80px; }\n}\n\n@media (max-width: 600px) {\n  .ost-label { font-size: 0.7rem; }\n  .ost-sub { font-size: 0.66rem; }\n  .ost-label, .ost-sub { max-width: 60px; }\n}\n\n/* Stat cards */\n.order-success-stats {\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.oss-card {\n  text-align: left;\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  box-shadow: var(--shadow-card);\n  padding: 12px;\n  min-width: 0;\n}\n\n.oss-icon {\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.05rem;\n  flex-shrink: 0;\n}\n.oss-icon-blue   { background: rgba(59,130,246,0.15); }\n.oss-icon-positive  { background: color-mix(in srgb, var(--success) 15%, transparent); }\n.oss-icon-orange { background: rgba(255, 103, 0,0.15); }\n.oss-icon-info { background: color-mix(in srgb, var(--accent-secondary) 15%, transparent); }\n\n.oss-body { flex: 1; min-width: 0; }\n\n.oss-label {\n  font-size: 0.76rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: var(--text-tertiary);\n  margin: 0 0 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.oss-value {\n  font-size: 0.94rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n  overflow-wrap: break-word;\n}\n.oss-pill {\n  display: inline-block;\n  background: color-mix(in srgb, var(--success) 15%, transparent);\n  color: var(--success);\n  font-size: 0.7rem;\n  font-weight: 800;\n  padding: 1px 6px;\n  border-radius: 4px;\n  margin-left: 4px;\n}\n\n.oss-copy-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.82rem;\n  color: var(--text-tertiary);\n  margin-left: 4px;\n  padding: 0;\n  vertical-align: middle;\n}\n.oss-copy-btn:hover { color: var(--accent); }\n\n.oss-sub-detail {\n  font-size: 0.82rem;\n  color: var(--text-tertiary);\n  margin: 3px 0 0;\n}\n.oss-sub-detail-orange { color: var(--color-primary); font-weight: 600; }\n\n.oss-fast-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: var(--success);\n  background: color-mix(in srgb, var(--success) 12%, transparent);\n  border-radius: 999px;\n  padding: 2px 9px;\n  margin-top: 5px;\n}\n\n@media (max-width: 700px) {\n  .order-success-stats { grid-template-columns: repeat(2, 1fr); }\n}\n\n.order-success-card,\n.order-success-items,\n.order-success-address,\n.order-success-summary {\n  width: 100%;\n  text-align: left;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-card);\n  padding: 18px 20px;\n  margin-bottom: 16px;\n}\n\n.order-success-card hr,\n.order-success-summary hr {\n  border: none;\n  border-top: 1px solid var(--border);\n  margin: 10px 0;\n}\n\n.order-success-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.98rem;\n  color: var(--text-secondary);\n  padding: 5px 0;\n}\n\n.order-success-row strong { color: var(--text-primary); }\n.order-success-free { color: var(--success) !important; }\n\n.order-success-row.total {\n  font-size: 1.18rem;\n}\n.order-success-row.total strong { color: var(--accent); }\n\n.order-success-items h3,\n.order-success-address h3,\n.order-success-summary h3 {\n  font-size: 1.08rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 12px;\n}\n\n.order-success-item-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 0;\n  border-bottom: 1px solid var(--border);\n}\n.order-success-item-row:last-child { border-bottom: none; }\n\n.order-success-item-row img {\n  width: 48px;\n  height: 48px;\n  border-radius: 8px;\n  object-fit: cover;\n  background: var(--bg-tertiary);\n  flex-shrink: 0;\n}\n\n.order-success-item-info { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }\n.order-success-item-name {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.order-success-item-meta {\n  font-size: 0.88rem;\n  color: var(--text-tertiary);\n  margin: 0;\n}\n.osi-seller { color: var(--accent); font-weight: 600; }\n.osi-qty-pill {\n  display: inline-block;\n  align-self: flex-start;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  background: var(--bg-tertiary);\n  border-radius: 20px;\n  padding: 2px 10px;\n}\n.order-success-item-total {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  flex-shrink: 0;\n}\n\n/* Delivering to / Summary two-column */\n.order-success-cols {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n@media (max-width: 700px) {\n  .order-success-cols { grid-template-columns: 1fr; }\n}\n\n.osa-body {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n}\n\n.osa-info { flex: 1; min-width: 0; }\n\n.order-success-address p {\n  margin: 4px 0;\n  font-size: 0.98rem;\n  color: var(--text-secondary);\n}\n.order-success-address p strong { color: var(--text-primary); }\n\n.order-success-map {\n  position: relative;\n  width: 100px;\n  height: 90px;\n  flex-shrink: 0;\n  border-radius: var(--radius-sm);\n  background: repeating-linear-gradient(45deg, var(--bg-tertiary) 0 10px, var(--bg-primary) 10px 20px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.6rem;\n  opacity: 0.6;\n  overflow: hidden;\n}\n.order-success-map-pin {\n  position: absolute;\n  font-size: 1.3rem;\n  opacity: 1;\n  filter: drop-shadow(0 2px 3px rgba(1, 13, 33,0.3));\n}\n\n@media (max-width: 480px) {\n  .osa-body { flex-direction: column-reverse; }\n  .order-success-map { width: 100%; }\n}\n\n/* What's next */\n.order-success-next {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 14px;\n  background: color-mix(in srgb, var(--accent-secondary) 10%, transparent);\n  border: 1px solid color-mix(in srgb, var(--accent-secondary) 30%, transparent);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  padding: 16px 20px;\n  margin-bottom: 20px;\n  text-align: left;\n}\n\n.osn-icon {\n  position: relative;\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  background: var(--success);\n  color: var(--color-text-on-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.32rem;\n  flex-shrink: 0;\n}\n\n.osn-icon-badge {\n  position: absolute;\n  bottom: -3px;\n  right: -3px;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  font-size: 0.68rem;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid var(--bg-secondary);\n}\n\n.osn-text { flex: 1; min-width: 180px; }\n.osn-title { font-size: 1.02rem; font-weight: 700; color: var(--text-primary); margin: 0 0 2px; }\n.osn-sub { font-size: 0.9rem; color: var(--text-secondary); margin: 0; }\n\n.osn-mini-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n.osn-mini {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  min-width: 64px;\n  text-align: center;\n}\n.osn-mini-icon { font-size: 1.22rem; }\n.osn-mini-label {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n.order-success-actions {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 28px;\n}\n\n@media (min-width: 600px) {\n  .order-success-actions { flex-direction: row; }\n  .order-success-actions .btn { flex: 1; }\n}\n\n/* You may also like */\n.order-success-recs {\n  width: 100%;\n  text-align: left;\n}\n.osr-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n.osr-head h3 { font-size: 1.12rem; font-weight: 700; color: var(--text-primary); margin: 0; }\n\n/* minmax(0, 1fr), not 1fr. A 1fr track's automatic minimum is `auto`, which\n   for a card containing an <img width:100%> resolves to the image's INTRINSIC\n   width -- so the column refuses to shrink below the source image and the grid\n   blows out of its container. On the order confirmation at 360px that made\n   each card 221px wide in a 340px grid, running the second column 138px off\n   the right of the screen. minmax(0, ...) lets the track shrink to the space\n   actually available; min-width:0 on the card is the same fix one level down,\n   for the flex/grid children inside it. */\n.osr-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n@media (max-width: 700px) {\n  .osr-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n}\n\n/* With equal columns each card is ~180px, where a 100px contained image left\n   the product floating in empty space. Cover fills the tile, and the name is\n   clamped so a long one wraps to two lines instead of setting the card's\n   height by itself. */\nhtml.m-app .osr-card img {\n  height: 120px;\n  object-fit: cover;\n}\n\nhtml.m-app .osr-name {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  min-height: 2.6em;\n}\n\n.osr-card {\n  min-width: 0;\n  position: relative;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 10px;\n  cursor: pointer;\n  transition: box-shadow 0.15s, transform 0.15s;\n  box-shadow: var(--shadow-card);\n}\n.osr-card:hover { box-shadow: var(--shadow-card); transform: translateY(-2px); }\n\n.osr-heart {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  color: var(--text-secondary);\n  cursor: pointer;\n  z-index: 1;\n}\n\n.osr-card img {\n  width: 100%;\n  height: 100px;\n  object-fit: contain;\n  background: var(--bg-tertiary);\n  border-radius: 6px;\n  margin-bottom: 8px;\n}\n\n.osr-name {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.osr-price-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.osr-price { font-size: 0.95rem; font-weight: 700; color: var(--text-primary); }\n/* The number is navy (green text on this surface is 3.30:1); the star keeps\n   the rating green, which is a graphic and clears its 3:1 bar. */\n.osr-rating { font-size: 0.8rem; color: var(--text-primary); font-weight: 600; }\n.osr-rating svg { color: var(--color-rating); }\n\n/* ── Coupon Section (Checkout Step 3) ────────────────────────── */\n.order-notes-section {\n  background: var(--bg-tertiary);\n  border: 1px solid color-mix(in srgb, var(--accent-secondary) 25%, transparent);\n  border-radius: var(--radius-sm);\n  padding: 18px 20px;\n  margin-top: 16px;\n}\n.order-notes-section h3 {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin: 0 0 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n.order-notes-textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  font-family: inherit;\n  resize: vertical;\n  box-sizing: border-box;\n  line-height: 1.5;\n}\n.order-notes-textarea:focus {\n  outline: none;\n  border-color: var(--accent-secondary);\n}\n\n.coupon-section {\n  background: var(--bg-tertiary);\n  border: 1px dashed var(--border);\n  border-radius: var(--radius-sm);\n  padding: 18px 20px;\n  box-shadow: var(--shadow-card);\n}\n\n.coupon-section h3 {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin: 0 0 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.coupon-input-row {\n  display: flex;\n  gap: 10px;\n}\n\n.coupon-input {\n  flex: 1;\n  min-width: 0;\n  padding: 10px 14px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  font-size: 0.95rem;\n  font-family: 'Courier New', monospace;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  transition: border-color 200ms;\n}\n\n.coupon-input:focus {\n  outline: none;\n  border-color: var(--accent);\n}\n\n.coupon-apply-btn {\n  flex: 0 0 auto;\n  padding: 10px 20px;\n  font-size: 0.9rem;\n  white-space: nowrap;\n}\n\n.coupon-feedback {\n  margin-top: 10px;\n  padding: 10px 14px;\n  border-radius: var(--radius-sm);\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n}\n\n.coupon-success {\n  background: rgba(59, 130, 246, 0.12);\n  border: 1px solid rgba(59, 130, 246, 0.35);\n  color: var(--success);\n}\n\n.coupon-error {\n  background: color-mix(in srgb, var(--danger) 10%, transparent);\n  border: 1px solid color-mix(in srgb, var(--danger) 30%, transparent);\n  color: var(--danger);\n}\n\n.coupon-remove {\n  margin-left: auto;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: inherit;\n  opacity: 0.7;\n  font-size: 1rem;\n  padding: 0 4px;\n  line-height: 1;\n}\n\n.rewards-redeem-section { margin-top: var(--space-2); }\n\n.rewards-redeem-toggle {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  cursor: pointer;\n  text-transform: none;\n  letter-spacing: normal;\n}\n\n.rewards-redeem-controls {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 12px;\n}\n.rewards-redeem-controls input[type=\"range\"] {\n  flex: 1;\n  accent-color: var(--accent);\n}\n.rewards-redeem-value {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--success);\n  white-space: nowrap;\n}\n\n.rewards-redeem-hint {\n  margin: 10px 0 0;\n  font-size: 0.78rem;\n  color: var(--text-tertiary);\n}\n\n.coupon-remove:hover {\n  opacity: 1;\n}\n\n/* Deductions in the order summary (coupon discount, reward points, wallet\n   credit) read in brand orange -- never green. Green in this app is reserved\n   for product ratings and must not appear on a money row. */\n.discount-row {\n  color: var(--color-primary);\n  font-weight: 600;\n}\n\n/* ── Coupons Admin Table ─────────────────────────────────────── */\n.coupons-header {\n  grid-template-columns: 140px 120px 100px 80px 100px 90px 160px !important;\n}\n\n.coupons-table {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  box-shadow: var(--shadow-card);\n}\n\n.coupon-row {\n  display: grid;\n  grid-template-columns: 140px 120px 100px 80px 100px 90px 160px;\n  gap: 12px;\n  align-items: center;\n  padding: 12px 20px;\n  border-bottom: 1px solid var(--border);\n  font-size: 0.88rem;\n}\n\n.coupon-row:last-child { border-bottom: none; }\n.coupon-row:hover { background: var(--bg-tertiary); }\n\n.coupon-code-badge {\n  display: inline-block;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xs);\n  padding: 3px 8px;\n  font-family: 'Courier New', monospace;\n  font-size: 0.85rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  color: var(--accent);\n}\n\n.coupon-active {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: var(--success);\n  font-size: 0.82rem;\n  font-weight: 600;\n}\n\n.coupon-inactive {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: var(--text-tertiary);\n  font-size: 0.82rem;\n}\n\n/* ════════════════════════════════════════════════════════════════\n   Coupons — redesigned submenu\n   ════════════════════════════════════════════════════════════════ */\n.cpn-section { display: flex; flex-direction: column; gap: 24px; }\n\n.cpn-card {\n  background: linear-gradient(155deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0) 42%), var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 24px;\n  box-shadow: inset 0 1px 0 rgba(255,255,255,0.04), var(--shadow-card);\n}\n\n.cpn-card-head { display: flex; align-items: center; gap: 12px; margin-bottom: 22px; }\n.cpn-card-icon {\n  width: 38px; height: 38px; border-radius: 10px; flex-shrink: 0;\n  display: flex; align-items: center; justify-content: center;\n  background: color-mix(in srgb, var(--color-secondary) 18%, transparent); color: var(--color-secondary);\n}\n.cpn-card-title { margin: 0; font-size: 1.15rem; font-weight: 700; color: var(--text-primary); }\n.cpn-cancel-edit {\n  margin-left: auto; display: inline-flex; align-items: center; gap: 5px;\n  background: transparent; border: 1px solid var(--border); color: var(--text-secondary);\n  border-radius: var(--radius-sm); padding: 6px 12px; font-size: 0.8rem; font-weight: 600; cursor: pointer;\n}\n.cpn-cancel-edit:hover { background: var(--bg-tertiary); color: var(--text-primary); }\n\n/* form grid */\n.cpn-form-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 18px 20px; }\n@media (max-width: 900px) { .cpn-form-grid { grid-template-columns: 1fr; } }\n\n.cpn-field { display: flex; flex-direction: column; gap: 8px; min-width: 0; }\n.cpn-label { font-size: 0.85rem; font-weight: 600; color: var(--text-primary); }\n.cpn-opt { color: var(--text-muted); font-weight: 500; font-size: 0.8rem; }\n\n.cpn-input-wrap { position: relative; display: flex; align-items: center; }\n.cpn-input-icon {\n  position: absolute; left: 12px; display: flex; align-items: center; justify-content: center;\n  color: var(--text-muted); font-weight: 700; pointer-events: none;\n}\n.cpn-input-icon-pct, .cpn-input-icon-hash { font-size: 0.95rem; }\n.cpn-input {\n  width: 100%; box-sizing: border-box;\n  background: var(--bg-primary); border: 1px solid var(--border);\n  border-radius: var(--radius-sm); color: var(--text-primary);\n  padding: 11px 14px 11px 38px; font-size: 0.9rem; font-family: inherit;\n  transition: border-color 150ms, box-shadow 150ms;\n}\n.cpn-input::placeholder { color: var(--text-muted); }\n.cpn-input:focus { outline: none; border-color: var(--accent); box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent) 18%, transparent); }\n.cpn-input:disabled { opacity: 0.5; cursor: not-allowed; }\n.cpn-input-suffix {\n  position: absolute; right: 1px; top: 1px; bottom: 1px; width: 40px;\n  display: flex; align-items: center; justify-content: center;\n  color: var(--text-secondary); font-weight: 700; font-size: 0.9rem;\n  border-left: 1px solid var(--border); background: var(--bg-tertiary);\n  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;\n}\n.cpn-select {\n  appearance: none; -webkit-appearance: none; cursor: pointer;\n  padding-right: 34px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%2394a3b8' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat; background-position: right 12px center;\n}\n.cpn-hint { margin: 0; font-size: 0.78rem; color: var(--text-muted); }\n\n/* additional options box */\n.cpn-options { margin-top: 22px; border: 1px solid var(--border); border-radius: var(--radius-md); padding: 18px 20px; background: color-mix(in srgb, var(--bg-primary) 55%, transparent); }\n.cpn-options-head { display: flex; align-items: center; gap: 8px; font-size: 0.88rem; font-weight: 700; color: var(--text-primary); margin-bottom: 16px; }\n.cpn-options-icon { display: inline-flex; color: var(--text-secondary); }\n.cpn-options-row { display: flex; align-items: flex-start; gap: 32px; flex-wrap: wrap; }\n.cpn-option-group { display: flex; flex-direction: column; gap: 8px; }\n.cpn-option-label { font-size: 0.82rem; font-weight: 600; color: var(--text-secondary); }\n.cpn-options-hint { margin: 4px 0 0; font-size: 0.78rem; color: var(--text-muted); max-width: 260px; }\n\n/* Segmented toggle (Status, Usage Limit).\n   `display: flex` + a shared min-width rather than `inline-flex`, because\n   .cpn-option-group is a stretch-aligned flex column: an inline-flex segment\n   inherited whatever width the widest sibling had. Under \"Usage Limit\" that\n   sibling is the 260px hint, so the control stretched but its two buttons\n   stayed content-sized, leaving dead space to the right of \"Limited\" while\n   the \"Status\" pair beside it hugged its content. The two controls therefore\n   rendered at different widths on the same row.\n   The min-width pins both segments to one size, and `flex: 1` below splits\n   each into equal halves, so either option reads as one half of a toggle\n   whichever is active. */\n.cpn-segment {\n  display: flex;\n  min-width: 240px;\n  background: var(--bg-primary); border: 1px solid var(--border);\n  border-radius: var(--radius-sm); padding: 3px; gap: 3px;\n}\n.cpn-segment button {\n  flex: 1;\n  border: none; background: transparent; color: var(--text-secondary);\n  padding: 6px 16px; font-size: 0.82rem; font-weight: 600; border-radius: calc(var(--radius-sm) - 4px);\n  cursor: pointer; transition: background 150ms, color 150ms; font-family: inherit;\n  white-space: nowrap;\n}\n.cpn-segment button.active { background: color-mix(in srgb, var(--accent) 22%, transparent); color: var(--accent); }\n:root[data-theme=\"light\"] .cpn-segment button.active { background: var(--accent); color: var(--color-text-on-secondary); }\n\n/* Below the min-width the segment would push the options card wider than the\n   viewport, so let it collapse to the column instead. */\n@media (max-width: 520px) {\n  .cpn-segment { min-width: 0; width: 100%; }\n}\n\n.cpn-submit {\n  margin-left: auto; align-self: center;\n  display: inline-flex; align-items: center; gap: 8px;\n  background: var(--accent); border: none; color: var(--color-text-on-secondary);\n  border-radius: var(--radius-sm); padding: 12px 24px; font-size: 0.9rem; font-weight: 700; cursor: pointer;\n  transition: background 150ms; font-family: inherit;\n}\n.cpn-submit:hover { background: var(--accent-hover); }\n\n/* All coupons list tools */\n.cpn-card-head-list { align-items: center; }\n.cpn-card-head-left { display: flex; align-items: center; gap: 12px; }\n.cpn-list-tools { margin-left: auto; display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }\n.cpn-search { position: relative; display: flex; align-items: center; }\n.cpn-search svg { position: absolute; left: 11px; color: var(--text-muted); pointer-events: none; }\n.cpn-search input {\n  background: var(--bg-primary); border: 1px solid var(--border); border-radius: var(--radius-sm);\n  color: var(--text-primary); padding: 8px 12px 8px 32px; font-size: 0.85rem; width: 200px; font-family: inherit;\n}\n.cpn-search input::placeholder { color: var(--text-muted); }\n.cpn-search input:focus { outline: none; border-color: var(--accent); }\n.cpn-sort {\n  appearance: none; -webkit-appearance: none; cursor: pointer;\n  background: var(--bg-primary); border: 1px solid var(--border); border-radius: var(--radius-sm);\n  color: var(--text-secondary); padding: 8px 30px 8px 12px; font-size: 0.82rem; font-weight: 600; font-family: inherit;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%2394a3b8' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat; background-position: right 11px center;\n}\n.cpn-filter-btn {\n  display: inline-flex; align-items: center; gap: 7px;\n  background: var(--bg-primary); border: 1px solid var(--border); border-radius: var(--radius-sm);\n  color: var(--text-secondary); padding: 8px 14px; font-size: 0.82rem; font-weight: 600; cursor: pointer; font-family: inherit;\n}\n.cpn-filter-btn:hover { background: var(--bg-tertiary); }\n.cpn-filter-btn.active { border-color: var(--accent); color: var(--accent); }\n\n/* table */\n.cpn-table-wrap { border: 1px solid var(--border); border-radius: var(--radius-md); overflow: hidden; }\n.cpn-table-header, .cpn-row {\n  display: grid;\n  grid-template-columns: 120px 110px 120px 100px 90px 120px 110px minmax(250px, 1fr);\n  gap: 14px;\n  align-items: center;\n  padding: 13px 18px;\n}\n.cpn-table-header {\n  background: var(--bg-tertiary);\n  font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em;\n  color: var(--text-muted); border-bottom: 1px solid var(--border);\n}\n.cpn-row { border-bottom: 1px solid var(--border); font-size: 0.88rem; transition: background 150ms; }\n.cpn-row:last-child { border-bottom: none; }\n.cpn-row:hover { background: color-mix(in srgb, var(--bg-tertiary) 55%, transparent); }\n.cpn-row-editing { background: color-mix(in srgb, var(--accent) 8%, transparent); box-shadow: inset 3px 0 0 var(--accent); }\n\n.cpn-code {\n  display: inline-block; font-family: 'Courier New', monospace; font-weight: 700; letter-spacing: 0.05em;\n  color: #a5b4fc; background: color-mix(in srgb, var(--color-secondary) 15%, transparent);\n  border: 1px solid color-mix(in srgb, var(--color-secondary) 30%, transparent);\n  border-radius: var(--radius-xs); padding: 4px 9px; font-size: 0.82rem;\n}\n.cpn-type { color: var(--text-secondary); }\n.cpn-discount { font-weight: 700; color: var(--text-primary); }\n.cpn-muted { color: var(--text-secondary); }\n.cpn-status {\n  display: inline-flex; align-items: center; gap: 6px;\n  padding: 4px 11px; border-radius: var(--radius-pill); font-size: 0.78rem; font-weight: 700;\n}\n.cpn-status-dot { width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0; }\n\n.cpn-actions { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }\n.cpn-act {\n  display: inline-flex; align-items: center; gap: 5px;\n  background: transparent; border: 1px solid var(--border); border-radius: var(--radius-sm);\n  padding: 6px 12px; font-size: 0.8rem; font-weight: 600; cursor: pointer; font-family: inherit;\n  color: var(--text-secondary); transition: background 150ms, border-color 150ms, color 150ms;\n}\n.cpn-act-edit { color: var(--color-secondary); border-color: color-mix(in srgb, var(--color-secondary) 40%, transparent); }\n.cpn-act-edit:hover { background: color-mix(in srgb, var(--color-secondary) 14%, transparent); }\n.cpn-act-toggle { color: var(--color-primary); border-color: color-mix(in srgb, var(--color-primary) 40%, transparent); }\n.cpn-act-toggle:hover { background: color-mix(in srgb, var(--color-primary) 14%, transparent); }\n.cpn-act-delete { color: var(--color-primary); border-color: color-mix(in srgb, var(--color-primary) 40%, transparent); }\n.cpn-act-delete:hover { background: color-mix(in srgb, var(--color-primary) 14%, transparent); }\n\n@media (max-width: 1100px) {\n  .cpn-table-wrap { overflow-x: auto; }\n  .cpn-table-header, .cpn-row { min-width: 920px; }\n}\n\n/* ── Related Products ─────────────────────────────────────────── */\n.related-products {\n  margin-top: 48px;\n  padding-top: 32px;\n  border-top: 1px solid var(--border);\n}\n\n.related-products h2 {\n  font-size: 1.3rem;\n  font-weight: 700;\n  margin: 0 0 20px;\n  color: var(--text-primary);\n}\n\n.related-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: var(--space-2);\n}\n\n.related-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n  cursor: pointer;\n  transition: transform 200ms ease, box-shadow 200ms ease;\n  box-shadow: var(--shadow-card);\n}\n\n.related-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 20px rgba(1, 13, 33, 0.12);\n}\n\n.related-card img {\n  width: 100%;\n  height: 150px;\n  object-fit: cover;\n}\n\n.related-card-body {\n  padding: 12px;\n}\n\n.related-card-body h4 {\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin: 0 0 4px;\n  color: var(--text-primary);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.related-card-body .related-price {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--accent);\n  margin: 0 0 8px;\n}\n\n.related-card-body .btn {\n  width: 100%;\n  padding: 7px;\n  font-size: 0.82rem;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   PRODUCT DETAIL — RICH PAGE\n   ═══════════════════════════════════════════════════════════ */\n\n/* 360° image wrap & trigger button */\n.detail-image-wrap {\n  position: relative;\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  background: var(--bg-tertiary);\n}\n\n.detail-image-wrap img {\n  width: 100%;\n  display: block;\n  border-radius: var(--radius-lg);\n}\n\n.view-360-btn {\n  position: absolute;\n  bottom: 14px;\n  right: 14px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: rgba(1, 13, 33, 0.7);\n  color: var(--color-brand-white);\n  border: 1.5px solid rgba(255,255,255,0.3);\n  border-radius: var(--radius-xl);\n  padding: 7px 14px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  backdrop-filter: blur(6px);\n  transition: background 200ms;\n}\n\n.view-360-btn:hover {\n  background: rgba(59, 130, 246, 0.85);\n}\n\n.btn-360-icon {\n  font-weight: 800;\n  font-size: 0.9rem;\n  letter-spacing: -0.5px;\n}\n\n/* Feature chips row (below product name) */\n.feature-chips-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin: 10px 0;\n}\n\n.feature-chip {\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xl);\n  padding: 4px 10px;\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n.feature-chip strong {\n  color: var(--text-primary);\n  margin-left: 3px;\n}\n\n/* 3 Buy action buttons */\n.buy-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.buy-add-cart {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  border: 2px solid var(--accent);\n}\n\n.buy-add-cart:hover:not(:disabled) {\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n}\n\n.buy-now {\n  background: var(--color-primary);\n  color: var(--text-primary);\n  border: none;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.buy-now:hover:not(:disabled) {\n  background: var(--color-primary);\n  color: var(--color-text-on-primary);\n}\n\n/* ── 360° Viewer Modal ──────────────────────────────────── */\n.modal360-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(1, 13, 33, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  padding: 20px;\n}\n\n.modal360-box {\n  background: var(--bg-secondary);\n  border-radius: var(--radius-xl);\n  padding: 28px;\n  width: 100%;\n  max-width: 500px;\n  position: relative;\n  user-select: none;\n}\n\n.modal360-close {\n  position: absolute;\n  top: 14px;\n  right: 18px;\n  background: none;\n  border: none;\n  font-size: 1.6rem;\n  cursor: pointer;\n  color: var(--text-secondary);\n  line-height: 1;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal360-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  margin: 0 0 4px;\n}\n\n.modal360-hint {\n  font-size: 0.82rem;\n  color: var(--text-tertiary);\n  margin: 0 0 16px;\n}\n\n.modal360-stage {\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  position: relative;\n  cursor: grab;\n  height: 300px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal360-stage.dragging {\n  cursor: grabbing;\n}\n\n.modal360-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  pointer-events: none;\n  transition: transform 0.04s linear;\n}\n\n.modal360-badge {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  background: rgba(1, 13, 33,0.55);\n  color: var(--color-brand-white);\n  font-size: 0.78rem;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: var(--radius-sm);\n  letter-spacing: 0.05em;\n  backdrop-filter: blur(4px);\n}\n\n.modal360-track {\n  position: relative;\n  height: 4px;\n  background: var(--border);\n  border-radius: var(--radius-xs);\n  margin: 12px 0 16px;\n  overflow: visible;\n}\n\n.modal360-thumb {\n  position: absolute;\n  top: -5px;\n  width: 14px;\n  height: 14px;\n  background: var(--accent);\n  border-radius: 50%;\n  transform: translateX(-50%);\n  transition: left 0.04s linear;\n  pointer-events: none;\n}\n\n.modal360-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.modal360-actions .btn {\n  flex: 1;\n  padding: 9px;\n  font-size: 0.88rem;\n}\n\n/* ── Product Highlights ─────────────────────────────────── */\n.product-highlights {\n  margin-top: 40px;\n  padding: 28px 30px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-card);\n}\n\n.product-highlights h2 {\n  font-size: 1.15rem;\n  font-weight: 700;\n  margin: 0 0 20px;\n  color: var(--text-primary);\n}\n\n.highlights-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));\n  gap: 12px;\n}\n\n.highlight-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-sm);\n  padding: 12px 14px;\n  border: 1px solid var(--border);\n}\n\n.highlight-icon {\n  font-size: 1.4rem;\n  width: 36px;\n  height: 36px;\n  background: var(--bg-secondary);\n  border-radius: var(--radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.highlight-text {\n  font-size: 0.88rem;\n  font-weight: 500;\n  color: var(--text-primary);\n  line-height: 1.3;\n}\n\n/* ── Spec / Warranty / Manufacturer Tabs ────────────────── */\n.product-tabs-section {\n  margin-top: 32px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  background: var(--bg-secondary);\n  box-shadow: var(--shadow-card);\n}\n\n.product-tabs {\n  display: flex;\n  border-bottom: 1px solid var(--border);\n  background: var(--bg-tertiary);\n  overflow-x: auto;\n}\n\n.tab-btn {\n  padding: 14px 24px;\n  background: none;\n  border: none;\n  border-bottom: 3px solid transparent;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  transition: color 200ms, border-color 200ms;\n  margin-bottom: -1px;\n}\n\n.tab-btn:hover {\n  color: var(--text-primary);\n}\n\n.tab-btn.active {\n  color: var(--accent);\n  border-bottom-color: var(--accent);\n  background: var(--bg-secondary);\n}\n\n.tab-content {\n  padding: 24px 28px;\n}\n\n/* Specs */\n.specs-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: var(--space-3);\n}\n\n.spec-group-title {\n  font-size: 0.88rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--accent);\n  margin: 0 0 10px;\n}\n\n.spec-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.spec-table tr:not(:last-child) td {\n  border-bottom: 1px solid var(--border);\n}\n\n.spec-key {\n  padding: 8px 0;\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  width: 45%;\n  vertical-align: top;\n}\n\n.spec-val {\n  padding: 8px 0 8px 12px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n/* Warranty */\n.warranty-box {\n  display: flex;\n  gap: 18px;\n  align-items: flex-start;\n}\n\n.warranty-icon {\n  font-size: 2.5rem;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.warranty-box p {\n  font-size: 0.92rem;\n  line-height: 1.7;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n/* Manufacturer */\n.manufacturer-box h4 {\n  font-size: 1.05rem;\n  font-weight: 700;\n  margin: 0 0 16px;\n  color: var(--text-primary);\n}\n\n.mfr-row {\n  display: flex;\n  gap: 14px;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--border);\n  font-size: 0.88rem;\n}\n\n.mfr-row:last-child {\n  border-bottom: none;\n}\n\n.mfr-row span:first-child {\n  width: 110px;\n  flex-shrink: 0;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.mfr-row span:last-child {\n  color: var(--text-primary);\n}\n\n/* ── Feature Rating Bars ────────────────────────────────── */\n.feature-rating-bars {\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 20px 22px;\n  margin-bottom: 24px;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 12px 24px;\n  box-shadow: var(--shadow-card);\n}\n\n.fr-bar-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.fr-label {\n  font-size: 0.82rem;\n  color: var(--text-secondary);\n  min-width: 110px;\n  flex-shrink: 0;\n}\n\n.fr-track {\n  flex: 1;\n  height: 6px;\n  background: var(--border);\n  border-radius: var(--radius-xs);\n  overflow: hidden;\n}\n\n.fr-fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--accent), var(--success));\n  border-radius: var(--radius-xs);\n  transition: width 600ms ease;\n}\n\n.fr-value {\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  min-width: 38px;\n  text-align: right;\n  white-space: nowrap;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   HERO CAROUSEL  — Flipkart-style multi-card layout\n   ═══════════════════════════════════════════════════════════ */\n\n.hero-carousel {\n  background: var(--bg-tertiary);\n  user-select: none;\n  padding: 8px 0 0;\n}\n\n/* Branded welcome hero shown when no admin banners are configured, so the\n   homepage never opens on a bare category bar. Deep-blue brand gradient with\n   white text -- reads the same in light and dark themes. */\n.hero-fallback {\n  margin: 8px 20px 0;\n  border-radius: 16px;\n  background: linear-gradient(120deg, var(--color-brand-navy) 0%, #1e63c4 55%, var(--color-secondary) 100%);\n  color: var(--color-brand-white);\n  overflow: hidden;\n  position: relative;\n}\n.hero-fallback::after {\n  content: '';\n  position: absolute;\n  top: -40%; right: -10%;\n  width: 380px; height: 380px;\n  background: radial-gradient(circle, rgba(255,255,255,0.14) 0%, rgba(255,255,255,0) 70%);\n  pointer-events: none;\n}\n.hero-fallback-inner {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 48px 32px;\n  position: relative;\n  z-index: 1;\n}\n.hero-fallback-title {\n  margin: 0;\n  font-size: clamp(1.5rem, 4vw, 2.4rem);\n  font-weight: 800;\n  letter-spacing: -0.02em;\n}\n.hero-fallback-sub {\n  margin: 10px 0 0;\n  font-size: clamp(0.9rem, 2vw, 1.05rem);\n  max-width: 520px;\n  opacity: 0.92;\n}\n.hero-fallback-cta {\n  margin-top: 22px;\n  background: var(--color-brand-white);\n  color: var(--color-brand-navy);\n  border: none;\n  border-radius: 10px;\n  padding: 12px 28px;\n  font-weight: 700;\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: transform 0.15s, box-shadow 0.15s;\n  box-shadow: 0 6px 18px rgba(1, 13, 33,0.18);\n}\n.hero-fallback-cta:hover { transform: translateY(-2px); box-shadow: 0 10px 24px rgba(1, 13, 33,0.24); }\n\n@media (max-width: 520px) {\n  .hero-fallback-inner { padding: 36px 22px; }\n}\n\n/* Compact, clearly defined Banner editor. */\n.admin-banner-editor-compact .admin-form-card {\n  padding: 14px 16px 16px;\n  margin-bottom: 14px;\n}\n\n.admin-banner-editor-compact .admin-form-header {\n  margin-bottom: 12px;\n}\n\n.admin-banner-editor-compact .admin-form-header h2 {\n  font-size: 22px;\n}\n\n.admin-banner-editor-compact .admin-banner-form-layout {\n  grid-template-columns: minmax(0, 1fr) 360px;\n  gap: 14px;\n}\n\n.admin-banner-editor-compact .admin-pf-section {\n  padding: 14px 16px;\n  gap: 11px;\n  margin-bottom: 11px;\n  border-radius: 12px;\n}\n\n.admin-banner-editor-compact .admin-pf-section-title {\n  font-size: 16px;\n}\n\n.admin-banner-editor-compact .admin-pf-row-2 {\n  gap: 10px;\n}\n\n.admin-banner-editor-compact .admin-pf-field {\n  gap: 5px;\n}\n\n.admin-banner-editor-compact .admin-pf-label {\n  font-size: 13px;\n}\n\n.admin-banner-editor-compact .admin-pf-input,\n.admin-banner-editor-compact .admin-pf-textarea,\n.admin-banner-editor-compact .banner-feature-row input,\n.admin-banner-editor-compact .color-hex {\n  min-height: 40px;\n  border: 1.5px solid var(--accent);\n  border-radius: 9px;\n  padding: 7px 11px;\n  background: var(--bg-primary);\n  box-sizing: border-box;\n}\n\n.admin-banner-editor-compact .admin-pf-textarea {\n  min-height: 62px;\n  max-height: 100px;\n  line-height: 1.4;\n}\n\n.admin-banner-editor-compact .admin-pf-input:hover,\n.admin-banner-editor-compact .admin-pf-textarea:hover,\n.admin-banner-editor-compact .banner-feature-row input:hover,\n.admin-banner-editor-compact .color-hex:hover {\n  border-color: var(--accent-hover, var(--accent));\n}\n\n.admin-banner-editor-compact .admin-pf-input:focus,\n.admin-banner-editor-compact .admin-pf-textarea:focus,\n.admin-banner-editor-compact .banner-feature-row input:focus,\n.admin-banner-editor-compact .color-hex:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent) 16%, transparent);\n}\n\n.admin-banner-editor-compact .admin-preview-card {\n  padding: 12px;\n  border-radius: 12px;\n}\n\n.admin-banner-editor-compact .admin-highlight-add {\n  align-self: flex-start;\n  background: var(--accent);\n  border-color: var(--accent);\n  color: var(--color-text-on-secondary);\n  padding: 8px 14px;\n  border-radius: 8px;\n  font-weight: 700;\n}\n\n.admin-banner-editor-compact .admin-highlight-add:hover {\n  background: var(--accent-hover, var(--accent));\n  border-color: var(--accent-hover, var(--accent));\n  color: var(--color-brand-white);\n}\n\n.admin-banner-editor-compact .admin-banner-image-actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.admin-banner-editor-compact .admin-banner-upload-divider,\n.admin-banner-editor-compact .admin-banner-upload-hint {\n  color: var(--text-muted);\n  font-size: 12px;\n}\n\n.admin-banner-editor-compact .admin-banner-upload-btn,\n.admin-banner-editor-compact .admin-banner-image-remove {\n  min-height: 34px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  border-radius: 8px;\n  padding: 7px 12px;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.admin-banner-editor-compact .admin-banner-upload-btn {\n  color: var(--color-text-on-secondary);\n  background: var(--accent);\n  border: 1px solid var(--accent);\n}\n\n.admin-banner-editor-compact .admin-banner-upload-btn:hover {\n  background: var(--accent-hover, var(--accent));\n}\n\n.admin-banner-editor-compact .admin-banner-upload-btn.uploading {\n  cursor: wait;\n  opacity: 0.7;\n}\n\n.admin-banner-editor-compact .admin-banner-image-remove {\n  color: var(--color-primary);\n  background: transparent;\n  border: 1px solid var(--color-primary);\n}\n\n.admin-banner-editor-compact .admin-banner-image-remove:hover {\n  color: var(--color-text-on-primary);\n  background: var(--color-primary);\n}\n\n.admin-banner-editor-compact .admin-banner-list-card {\n  width: 100%;\n  min-width: 0;\n  margin-top: 14px;\n  padding: 14px 16px 16px;\n  background: var(--bg-secondary);\n  border: 1.5px solid var(--accent);\n  border-radius: 13px;\n  box-shadow: var(--shadow-card);\n  box-sizing: border-box;\n}\n\n.admin-banner-editor-compact .admin-banner-list-head {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  margin-bottom: 12px;\n}\n\n.admin-banner-editor-compact .admin-banner-list-head h2 {\n  margin: 0;\n  color: var(--text-primary);\n  font-size: 17px;\n  font-weight: 750;\n}\n\n.admin-banner-editor-compact .admin-banner-list-icon {\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--accent);\n  background: color-mix(in srgb, var(--accent) 12%, transparent);\n  border-radius: 9px;\n}\n\n.admin-banner-editor-compact .admin-banner-count {\n  min-width: 25px;\n  height: 25px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--accent);\n  background: color-mix(in srgb, var(--accent) 12%, transparent);\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 750;\n}\n\n.admin-banner-editor-compact .banners-list {\n  gap: 8px;\n}\n\n.admin-banner-editor-compact .banner-list-row {\n  display: grid;\n  grid-template-columns: 68px minmax(0, 1fr) auto minmax(214px, auto);\n  gap: 12px;\n  min-width: 0;\n  padding: 10px 12px;\n  border: 1px solid color-mix(in srgb, var(--accent) 45%, var(--border));\n  border-radius: 10px;\n  background: var(--bg-primary);\n}\n\n.admin-banner-editor-compact .banner-list-row:hover {\n  border-color: var(--accent);\n  background: color-mix(in srgb, var(--accent) 3%, var(--bg-primary));\n}\n\n.admin-banner-editor-compact .banner-list-swatch {\n  width: 68px;\n  height: 46px;\n}\n\n.admin-banner-editor-compact .banner-list-info {\n  min-width: 0;\n}\n\n.admin-banner-editor-compact .banner-list-title,\n.admin-banner-editor-compact .banner-list-sub {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.admin-banner-editor-compact .banner-list-meta {\n  margin-top: 2px;\n  gap: 5px;\n}\n\n.admin-banner-editor-compact .admin-row-actions {\n  justify-content: flex-end;\n  flex-wrap: nowrap;\n  gap: 6px;\n}\n\n.admin-banner-editor-compact .admin-banner-action {\n  min-height: 34px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  padding: 6px 10px;\n  border-radius: 8px;\n  white-space: nowrap;\n}\n\n.admin-banner-editor-compact .admin-banner-delete,\n.admin-banner-editor-compact .admin-banner-delete:hover,\n.admin-banner-editor-compact .admin-banner-delete:focus-visible {\n  border: 1px solid var(--color-primary);\n  background: var(--color-primary);\n  color: var(--color-text-on-primary);\n}\n\n.admin-banner-editor-compact .admin-banner-pagination {\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 0 0;\n  border-top: 1px solid color-mix(in srgb, var(--accent) 25%, var(--border));\n  margin-top: 12px;\n}\n\n.admin-banner-editor-compact .admin-banner-page-range {\n  color: var(--text-secondary);\n  font-size: 12px;\n}\n\n.admin-banner-editor-compact .admin-banner-page-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.admin-banner-editor-compact .admin-banner-pagination .admin-page-btn {\n  min-height: 34px;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 11px;\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n@media (max-width: 850px) {\n  .admin-banner-editor-compact .banner-list-row {\n    grid-template-columns: 68px minmax(0, 1fr) auto;\n  }\n\n  .admin-banner-editor-compact .admin-row-actions {\n    grid-column: 1 / -1;\n    justify-content: flex-end;\n  }\n}\n\n@media (max-width: 560px) {\n  .admin-banner-editor-compact .admin-banner-list-card {\n    padding: 12px;\n  }\n\n  .admin-banner-editor-compact .banner-list-row {\n    grid-template-columns: 56px minmax(0, 1fr);\n    gap: 9px;\n  }\n\n  .admin-banner-editor-compact .banner-list-swatch {\n    width: 56px;\n    height: 44px;\n  }\n\n  .admin-banner-editor-compact .banner-list-row > .coupon-active,\n  .admin-banner-editor-compact .banner-list-row > .coupon-inactive {\n    grid-column: 2;\n    justify-self: start;\n  }\n\n  .admin-banner-editor-compact .admin-row-actions {\n    grid-column: 1 / -1;\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .admin-banner-editor-compact .admin-banner-pagination {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .admin-banner-editor-compact .admin-banner-page-controls {\n    justify-content: space-between;\n  }\n}\n\n/* Careers overview and positions: fully contained, responsive, no x-scroll. */\n.admin-section.admin-pf-card-v2 .admin-careers-grid {\n  grid-template-columns: minmax(0, 1fr) minmax(300px, 350px);\n}\n\n.admin-section.admin-pf-card-v2 .admin-careers-grid .admin-pf-section {\n  border: 1.5px solid color-mix(in srgb, var(--pf-primary) 42%, var(--pf-divider));\n  overflow: hidden;\n}\n\n.admin-section.admin-pf-card-v2 .admin-table-toolbar {\n  min-width: 0;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.admin-section.admin-pf-card-v2 .ov-period-btns {\n  border: 1.5px solid var(--pf-primary);\n  background: var(--pf-field-bg);\n}\n\n.admin-section.admin-pf-card-v2 .admin-careers-stat-tile {\n  border: 1.5px solid color-mix(in srgb, var(--pf-primary) 32%, var(--pf-divider));\n  background: var(--pf-field-bg);\n  min-height: 138px;\n  justify-content: flex-start;\n  transition: border-color 160ms ease, transform 160ms ease, box-shadow 160ms ease;\n}\n\n.admin-section.admin-pf-card-v2 .admin-careers-stat-tile:hover {\n  border-color: var(--pf-primary);\n  transform: translateY(-1px);\n  box-shadow: 0 5px 14px color-mix(in srgb, var(--pf-primary) 10%, transparent);\n}\n\n.admin-section.admin-pf-card-v2 .admin-careers-stat-label {\n  min-height: 2.4em;\n  line-height: 1.2;\n}\n\n.admin-section.admin-pf-card-v2 .admin-careers-stat-trend {\n  line-height: 1.25;\n  white-space: normal;\n}\n\n.admin-careers-positions-table {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden !important;\n  box-sizing: border-box;\n}\n\n.admin-careers-positions-table .admin-table-header,\n.admin-careers-positions-table .admin-product-row {\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  grid-template-columns:\n    minmax(145px, 1.4fr)\n    minmax(92px, 0.9fr)\n    minmax(78px, 0.72fr)\n    minmax(72px, 0.68fr)\n    minmax(72px, 0.65fr)\n    104px;\n  gap: 7px;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.admin-careers-positions-table .admin-table-header {\n  font-size: 10px;\n  letter-spacing: 0.035em;\n}\n\n.admin-careers-positions-table .admin-product-row > * {\n  min-width: 0;\n}\n\n.admin-careers-positions-table .admin-product-title,\n.admin-careers-positions-table .admin-career-department-cell,\n.admin-careers-positions-table .admin-career-location-cell {\n  overflow-wrap: anywhere;\n  line-height: 1.25;\n}\n\n.admin-careers-positions-table .admin-category-chip {\n  display: inline-flex;\n  max-width: 100%;\n  box-sizing: border-box;\n  white-space: normal;\n  text-align: center;\n  line-height: 1.15;\n}\n\n.admin-careers-positions-table .admin-career-applications-cell {\n  min-width: 0;\n}\n\n.admin-careers-positions-table .admin-career-actions-cell {\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: nowrap;\n}\n\n.admin-careers-positions-table .admin-career-actions-cell .btn-admin-edit {\n  width: 30px;\n  height: 30px;\n  padding: 0 !important;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 30px;\n}\n\n.admin-careers-positions-table .admin-career-actions-cell .btn-admin-edit:last-child {\n  color: var(--color-brand-white) !important;\n  background: var(--color-primary);\n  border-color: var(--color-primary) !important;\n}\n\n@media (max-width: 1250px) {\n  .admin-section.admin-pf-card-v2 .admin-careers-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .admin-section.admin-pf-card-v2 .admin-careers-grid > div:last-child {\n    position: static !important;\n  }\n}\n\n@media (max-width: 760px) {\n  .admin-careers-positions-table {\n    border: 0;\n    background: transparent;\n  }\n\n  .admin-careers-positions-table .admin-table-header {\n    display: none;\n  }\n\n  .admin-careers-positions-table .admin-product-row {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 10px 14px;\n    margin-bottom: 9px;\n    padding: 12px;\n    border: 1.5px solid color-mix(in srgb, var(--pf-primary) 35%, var(--pf-divider));\n    border-radius: 10px;\n    background: var(--pf-field-bg);\n  }\n\n  .admin-careers-positions-table .admin-career-position-cell,\n  .admin-careers-positions-table .admin-career-actions-cell {\n    grid-column: 1 / -1;\n  }\n\n  .admin-careers-positions-table .admin-career-actions-cell {\n    justify-content: flex-start;\n    padding-top: 2px;\n  }\n}\n\n@media (max-width: 520px) {\n  .admin-section.admin-pf-card-v2 .admin-careers-stats {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .admin-section.admin-pf-card-v2 .admin-careers-stat-tile {\n    min-height: 0;\n  }\n\n  .admin-careers-positions-table .admin-product-row {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .admin-careers-positions-table .admin-career-position-cell,\n  .admin-careers-positions-table .admin-career-actions-cell {\n    grid-column: 1;\n  }\n}\n\n.admin-banner-editor-compact .admin-banner-preview-card .carousel-slide {\n  height: 205px;\n}\n\n@media (max-width: 1120px) {\n  .admin-banner-editor-compact .admin-banner-form-layout {\n    grid-template-columns: minmax(0, 1fr) 310px;\n  }\n}\n\n@media (max-width: 900px) {\n  .admin-banner-editor-compact .admin-banner-form-layout {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .admin-banner-editor-compact .admin-preview-card {\n    position: static;\n  }\n}\n\n/* Wrapper holds the track + absolute arrows */\n.carousel-track-outer {\n  position: relative;\n}\n\n/* Horizontally scrollable track — 2 cards visible */\n.carousel-track {\n  display: flex;\n  gap: var(--space-1);\n  overflow-x: auto;\n  scroll-snap-type: x mandatory;\n  padding: 0 8px;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.carousel-track::-webkit-scrollbar { display: none; }\n\n.carousel-slide {\n  flex: 0 0 calc((100% - 16px) / 3);\n  scroll-snap-align: start;\n  height: 230px;\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  overflow: hidden;\n  position: relative;\n  box-shadow: 0 3px 12px rgba(1, 13, 33,0.16);\n  transition: box-shadow 200ms, transform 200ms;\n}\n\n.carousel-slide::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at 78% 55%, var(--glow, var(--color-brand-white)) 0%, transparent 62%);\n  opacity: 0.25;\n  pointer-events: none;\n  z-index: 0;\n}\n\n/* Glossy diagonal sheen across the artwork */\n.carousel-slide::after {\n  content: '';\n  position: absolute;\n  top: -60%;\n  left: -25%;\n  width: 55%;\n  height: 220%;\n  background: linear-gradient(115deg, rgba(255,255,255,0.22) 0%, rgba(255,255,255,0) 65%);\n  transform: rotate(8deg);\n  z-index: 2;\n  pointer-events: none;\n}\n\n.carousel-slide:hover {\n  box-shadow: 0 8px 26px rgba(1, 13, 33,0.22);\n  transform: translateY(-2px);\n}\n\n/* Image fills the entire card; a gradient overlay keeps the text legible */\n.slide-bg-img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: 0;\n  transition: transform 400ms ease;\n}\n\n.carousel-slide:hover .slide-bg-img {\n  transform: scale(1.05);\n}\n\n.slide-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  background: linear-gradient(90deg, rgba(1, 13, 33,0.8) 0%, rgba(1, 13, 33,0.52) 45%, rgba(1, 13, 33,0.14) 100%);\n  pointer-events: none;\n}\n\n.slide-inner {\n  display: flex;\n  align-items: center;\n  height: 230px;\n  padding: 0;\n  position: relative;\n}\n\n.slide-content {\n  position: relative;\n  z-index: 2;\n  color: var(--color-brand-white);\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-width: 68%;\n  padding: 20px 22px 18px;\n  min-width: 0;\n  text-shadow: 0 1px 4px rgba(1, 13, 33,0.35);\n}\n\n.slide-features {\n  list-style: none;\n  margin: 4px 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.slide-feature-item {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 0.82rem;\n  font-weight: 500;\n  opacity: 0.92;\n  line-height: 1.3;\n}\n\n.slide-feature-icon {\n  font-size: 0.78rem;\n  flex-shrink: 0;\n  color: var(--color-primary);\n}\n\n.slide-discount-badge {\n  position: absolute;\n  right: 14px;\n  bottom: 14px;\n  z-index: 2;\n  /* A solid orange pill with a navy label, matching every other discount pill\n     in the app. Orange text on a translucent navy scrim measured 1.5:1 over\n     light banner artwork -- the scrim can't guarantee a background when the\n     image underneath is unknown, so the pill supplies its own. */\n  background: var(--color-primary);\n  padding: 6px 14px;\n  border-radius: var(--radius-xl);\n  font-size: 0.8rem;\n  font-weight: 800;\n  color: var(--color-text-on-primary);\n}\n\n/* Promotional label -- orange fill, navy text. The per-banner badgeColor that\n   used to drive this is no longer applied to any text or control (see\n   BannerSlide.js); it only tints the ambient --glow behind the artwork now. */\n.slide-badge {\n  display: inline-block;\n  padding: 4px 11px;\n  border-radius: var(--radius-xl);\n  font-size: 0.74rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  background: var(--color-primary);\n  color: var(--color-text-on-primary);\n  width: fit-content;\n  margin-bottom: 3px;\n}\n\n.slide-brand {\n  font-size: 0.8rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  opacity: 0.7;\n  margin-bottom: 2px;\n}\n\nh2.slide-title {\n  font-size: 1.55rem;\n  font-weight: 800;\n  line-height: 1.18;\n  margin: 0;\n  color: inherit;\n}\n\n.slide-subtitle {\n  font-size: 0.94rem;\n  font-weight: 600;\n  margin: 0;\n  color: var(--color-primary);\n  opacity: 0.95;\n  line-height: 1.3;\n}\n\n.slide-body {\n  font-size: 0.85rem;\n  line-height: 1.45;\n  margin: 0;\n  opacity: 0.78;\n}\n\n/* CTA pushed to bottom */\n.slide-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  margin-top: auto;\n  padding: 9px 18px;\n  border-radius: var(--radius-xl);\n  font-size: 0.86rem;\n  font-weight: 700;\n  border: none;\n  cursor: pointer;\n  transition: transform 180ms, opacity 180ms;\n  width: fit-content;\n}\n\n.slide-cta:hover {\n  transform: translateY(-1px);\n  opacity: 0.9;\n}\n\n/* Fixed white pill over banner artwork -- the label must be a fixed navy, not\n   --text-primary, which flips to white in dark mode and made this button read\n   as an empty white rectangle. */\n.slide-cta-light { background: var(--color-brand-white); color: var(--color-brand-navy); }\n.slide-cta-dark  { background: rgba(1, 13, 33,0.72); color: var(--color-brand-white); }\n\n.slide-cta-arrow {\n  font-size: 1.02rem;\n  transition: transform 180ms;\n}\n\n.slide-cta:hover .slide-cta-arrow { transform: translateX(3px); }\n\n\n/* Arrows — positioned over the track */\n.carousel-arrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(255,255,255,0.92);\n  border: 1px solid var(--border-strong);\n  color: #555;\n  font-size: 1.8rem;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: box-shadow 150ms, background 150ms;\n  z-index: 10;\n  line-height: 1;\n  padding-bottom: 2px;\n  box-shadow: 0 2px 8px rgba(1, 13, 33,0.14);\n}\n\n.carousel-arrow:hover {\n  background: var(--color-brand-white);\n  box-shadow: 0 4px 16px rgba(1, 13, 33,0.22);\n}\n\n.carousel-arrow-left  { left: 4px; }\n.carousel-arrow-right { right: 4px; }\n\n/* Dots — below the track in normal flow */\n/* 16px gap, not 6px: the dot itself stays 8px, but each one carries a 24px\n   invisible hit area (see .carousel-dot::after) and two 24px targets can't\n   sit closer than 24px apart without overlapping -- tapping \"next\" would\n   land on the dot beside it. 8 + 16 = 24px centre to centre, exactly\n   touching, which is the tightest they can legally pack. */\n.carousel-dots {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  padding: 8px 0 6px;\n}\n\n.carousel-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #c0c0c0;\n  border: none;\n  cursor: pointer;\n  transition: background 220ms, width 220ms;\n  padding: 0;\n  position: relative;\n}\n/* An 8px button is a third of the 24px minimum tap target. Rather than\n   inflate the dot -- these read as dots precisely because they're small --\n   extend only the touchable area, centred on the dot and invisible. */\n.carousel-dot::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 24px;\n  height: 24px;\n  transform: translate(-50%, -50%);\n}\n\n.carousel-dot.active {\n  background: var(--color-secondary);\n  width: 20px;\n  border-radius: var(--radius-xs);\n}\n\n/* Tablet: 2 cards */\n@media (max-width: 900px) {\n  .carousel-slide {\n    flex: 0 0 calc((100% - 8px) / 2);\n    height: 210px;\n  }\n\n  .slide-inner { height: 210px; }\n  .slide-content { max-width: 78%; }\n}\n\n/* Mobile: 1 card */\n@media (max-width: 600px) {\n  .carousel-slide {\n    flex: 0 0 88%;\n    height: 185px;\n  }\n\n  .slide-inner { height: 185px; }\n  .slide-content { max-width: 88%; }\n\n  .slide-title   { font-size: 1.15rem; }\n  .slide-body    { display: none; }\n\n  .carousel-arrow {\n    width: 28px;\n    height: 28px;\n    font-size: 1.3rem;\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════\n   ADMIN — BANNERS TAB\n   ═══════════════════════════════════════════════════════════ */\n\n.banner-form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  margin-bottom: 32px;\n}\n\n.color-input-wrap {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n}\n\n.color-input-wrap input[type=\"color\"] {\n  width: 40px;\n  height: 38px;\n  padding: 2px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-xs);\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.color-hex {\n  flex: 1;\n  font-family: 'Courier New', monospace;\n  font-size: 0.82rem;\n}\n\n/* Banners list */\n.banners-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.banner-list-row {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 12px 16px;\n  transition: opacity 200ms;\n}\n\n.banner-list-row.banner-inactive {\n  opacity: 0.55;\n}\n\n.banner-list-swatch {\n  width: 72px;\n  height: 50px;\n  border-radius: var(--radius-sm);\n  flex-shrink: 0;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.banner-list-swatch img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.banner-list-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.banner-list-title {\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.banner-list-sub {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n}\n\n.banner-list-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 4px;\n}\n\n.banner-badge-chip {\n  font-size: 0.68rem;\n  font-weight: 700;\n  color: var(--color-brand-white);\n  padding: 2px 7px;\n  border-radius: var(--radius-sm);\n  letter-spacing: 0.05em;\n}\n\n.banner-link-chip,\n.banner-order-chip {\n  font-size: 0.72rem;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xs);\n  padding: 2px 7px;\n  color: var(--text-secondary);\n}\n\n.banner-list-status {\n  flex-shrink: 0;\n}\n\n/* ══════════════════════════════════════════════════════════════\n   ANIMATION SYSTEM\n   ══════════════════════════════════════════════════════════════ */\n\n/* ── Keyframe library ──────────────────────────────────────────*/\n@keyframes fade-up {\n  from { opacity: 0; transform: translateY(22px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes fade-in {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n@keyframes scale-in {\n  from { opacity: 0; transform: scale(0.92) translateY(16px); }\n  to   { opacity: 1; transform: scale(1)    translateY(0); }\n}\n\n@keyframes slide-down {\n  from { opacity: 0; transform: translateY(-16px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* Opacity-only card entrance (avoids conflict with hover transform) */\n@keyframes card-appear {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n@keyframes badge-pop {\n  0%   { transform: scale(1); }\n  35%  { transform: scale(1.55); }\n  65%  { transform: scale(0.86); }\n  100% { transform: scale(1); }\n}\n\n@keyframes pulse-ring {\n  0%   { box-shadow: 0 0 0 0   rgba(59, 130, 246, 0.55); }\n  70%  { box-shadow: 0 0 0 10px rgba(59, 130, 246, 0);   }\n  100% { box-shadow: 0 0 0 0   rgba(59, 130, 246, 0);   }\n}\n\n/* ── Topbar ─────────────────────────────────────────────────── */\n.topbar {\n  transition: box-shadow 280ms var(--ease-in-out) !important;\n}\n\n.is-scrolled .topbar {\n  box-shadow: 0 2px 20px rgba(1, 13, 33, 0.09);\n}\n\n[data-theme=\"dark\"] .is-scrolled .topbar {\n  box-shadow: 0 2px 20px rgba(1, 13, 33, 0.45);\n}\n\n/* ── Auth gate entrance ──────────────────────────────────────── */\n.auth-gate-box {\n  animation: scale-in 400ms var(--ease-spring) both;\n}\n\n/* ── Product card stagger (opacity-only — no transform conflict) */\n.product-card { animation: card-appear 380ms ease both; }\n.product-card:nth-child(1) { animation-delay:   0ms; }\n.product-card:nth-child(2) { animation-delay:  55ms; }\n.product-card:nth-child(3) { animation-delay: 110ms; }\n.product-card:nth-child(4) { animation-delay: 165ms; }\n.product-card:nth-child(5) { animation-delay: 220ms; }\n.product-card:nth-child(6) { animation-delay: 275ms; }\n.product-card:nth-child(7) { animation-delay: 330ms; }\n.product-card:nth-child(8) { animation-delay: 385ms; }\n\n/* ── Checkout containers ─────────────────────────────────────── */\n.checkout-steps {\n  animation: fade-up var(--dur-slow) var(--ease-out-expo) both;\n}\n\n.order-summary-container {\n  animation: fade-up var(--dur-slow) var(--ease-out-expo) 70ms both;\n}\n\n.cod-payment-section {\n  animation: fade-up var(--dur-slow) var(--ease-out-expo) 70ms both;\n}\n\n.price-details {\n  animation: fade-up var(--dur-slow) var(--ease-out-expo) 120ms both;\n  box-shadow: var(--shadow-card);\n}\n\n/* ── Order items stagger ─────────────────────────────────────── */\n.fi-item { animation: fade-up 320ms var(--ease-out-expo) both; \n  box-shadow: var(--shadow-card);\n}\n.fi-item:nth-child(1) { animation-delay:  0ms; }\n.fi-item:nth-child(2) { animation-delay: 70ms; }\n.fi-item:nth-child(3) { animation-delay: 140ms; }\n\n/* ── Alert / toast entrance ──────────────────────────────────── */\n.alert {\n  animation: slide-down 260ms var(--ease-out-expo) both;\n}\n\n/* ── Cart panel ──────────────────────────────────────────────── */\n.cart-panel {\n  animation: fade-up 380ms var(--ease-out-expo) 80ms both;\n}\n\n/* ── Cart badge pop ──────────────────────────────────────────── */\n.cart-badge {\n  transition: transform 300ms var(--ease-spring) !important;\n}\n\n/* ── Checkout step number: pulse on active ───────────────────── */\n.step.active .step-number {\n  animation: pulse-ring 2s ease-out infinite;\n}\n\n/* ── User dropdown slide-in ──────────────────────────────────── */\n.user-dropdown {\n  animation: scale-in 200ms var(--ease-out-expo) both;\n  transform-origin: top right;\n}\n\n/* ── Button press (active state) ─────────────────────────────── */\n.btn:not(:disabled):active,\n.submit:not(:disabled):active,\n.btn-place-order:not(:disabled):active,\n.fi-action-btn:active,\n.btn-icon-text:active,\n.category-icon-btn:active {\n  transform: scale(0.95) !important;\n  transition-duration: 70ms !important;\n}\n\n/* ── Carousel arrows spring ──────────────────────────────────── */\n.carousel-arrow {\n  transition: background 180ms ease, box-shadow 220ms var(--ease-spring),\n              transform 220ms var(--ease-spring) !important;\n}\n\n.carousel-arrow:hover {\n  transform: translateY(-50%) scale(1.14) !important;\n}\n\n/* ── Carousel dot expand ─────────────────────────────────────── */\n.carousel-dot {\n  transition: background 220ms ease, width 300ms var(--ease-spring) !important;\n}\n\n/* ── Category pill scale ─────────────────────────────────────── */\n.category-icon-btn {\n  transition: background 180ms ease, color 180ms ease,\n              transform 220ms var(--ease-spring) !important;\n}\n\n.category-icon-btn.active  { transform: scale(1.06); }\n.category-icon-btn:hover:not(.active) { transform: scale(1.03); }\n\n/* ── KPI admin cards ─────────────────────────────────────────── */\n.kpi-card {\n  transition: transform 280ms var(--ease-out-expo),\n              box-shadow 280ms var(--ease-out-expo) !important;\n}\n.kpi-card:hover {\n  transform: translateY(-4px) !important;\n  box-shadow: 0 12px 32px rgba(1, 13, 33, 0.13) !important;\n}\n\n/* ── Form input focus spring ─────────────────────────────────── */\ninput:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"range\"]),\nselect,\ntextarea {\n  transition: border-color 180ms ease, box-shadow 220ms var(--ease-spring),\n              transform 200ms var(--ease-spring) !important;\n}\n\ninput:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"range\"]):focus,\nselect:focus,\ntextarea:focus {\n  transform: scale(1.008);\n}\n\n/* ── Wishlist heart pop on click ─────────────────────────────── */\n.card-wishlist:active {\n  animation: badge-pop 300ms var(--ease-spring) both !important;\n}\n\n/* ── Honour \"prefer reduced motion\" ─────────────────────────── */\n@media (prefers-reduced-motion: reduce) {\n  *, *::before, *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   DATAFLOW-STYLE OVERVIEW TAB\n   ═══════════════════════════════════════════════════════════════ */\n\n/* ── Root container ──────────────────────────────────────────── */\n.ov-root {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Shown when the period analytics fetch fails. Every secondary figure on the\n   Overview falls back to 0 when that request doesn't land, so without a\n   visible banner a failed load is indistinguishable from a genuinely quiet\n   trading period. */\n.ov-period-error {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  border-radius: 12px;\n  background: rgba(255, 103, 0, 0.08);\n  border: 1px solid rgba(255, 103, 0, 0.28);\n  color: var(--color-primary);\n  font-size: 0.86rem;\n  font-weight: 500;\n}\n.ov-period-error span { flex: 1; min-width: 0; }\n.ov-period-error button {\n  flex-shrink: 0;\n  padding: 6px 14px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 103, 0, 0.4);\n  background: transparent;\n  color: inherit;\n  font-family: inherit;\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n.ov-period-error button:hover:not(:disabled) { background: rgba(255, 103, 0, 0.12); }\n.ov-period-error button:disabled { opacity: 0.55; cursor: not-allowed; }\n:root[data-theme=\"dark\"] .ov-period-error { color: var(--color-primary-soft); }\n\n/* ── Generic overview card ───────────────────────────────────── */\n.ov-card {\n  background: linear-gradient(155deg, rgba(255,255,255,0.07) 0%, rgba(255,255,255,0) 42%), color-mix(in srgb, var(--bg-secondary) 82%, transparent);\n  backdrop-filter: blur(20px) saturate(160%);\n  -webkit-backdrop-filter: blur(20px) saturate(160%);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 20px 22px;\n  box-shadow: inset 0 1px 0 rgba(255,255,255,0.05), var(--shadow-card);\n}\n.ov-card-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  gap: 12px;\n}\n.ov-card-header > div:first-child {\n  flex: 1;\n  min-width: 0;\n}\n.ov-card-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 4px;\n}\n.ov-card-sub {\n  font-size: 0.78rem;\n  color: var(--text-muted);\n  margin: 0;\n}\n\n/* ── KPI Spark 2×2 grid ──────────────────────────────────────── */\n.kpi-spark-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: var(--space-2);\n}\n@media (max-width: 1100px) { .kpi-spark-grid { grid-template-columns: repeat(2, 1fr); } }\n@media (max-width: 640px)  { .kpi-spark-grid { grid-template-columns: 1fr; } }\n\n.kpi-spark-card {\n  background: linear-gradient(155deg, rgba(255,255,255,0.07) 0%, rgba(255,255,255,0) 42%), color-mix(in srgb, var(--bg-secondary) 82%, transparent);\n  backdrop-filter: blur(20px) saturate(160%);\n  -webkit-backdrop-filter: blur(20px) saturate(160%);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 18px 18px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  overflow: hidden;\n  box-shadow: inset 0 1px 0 rgba(255,255,255,0.05), var(--shadow-card);\n}\n\n.ksc-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n.ksc-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.ksc-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: var(--radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.92;\n  flex-shrink: 0;\n}\n.ksc-icon-inner { font-size: 1rem; line-height: 1; }\n.ksc-label {\n  font-size: 0.78rem;\n  color: var(--text-muted);\n  margin: 0 0 3px;\n  font-weight: 500;\n}\n.ksc-trend {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 2px 7px;\n  border-radius: var(--radius-xl);\n}\n.ksc-up   { background: var(--color-secondary-soft); color: var(--color-secondary); }\n.ksc-down { background: var(--color-primary-soft); color: var(--color-primary); }\n.ksc-trend-arrow { font-size: 0.85em; }\n.ksc-period {\n  font-size: 0.7rem;\n  color: var(--text-muted);\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  padding: 2px 8px;\n  border-radius: var(--radius-xl);\n  white-space: nowrap;\n}\n.ksc-value {\n  font-size: 1.55rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 4px 0 2px;\n  line-height: 1.1;\n}\n.ksc-sub {\n  font-size: 0.76rem;\n  color: var(--text-muted);\n  margin: 0 0 2px;\n  font-weight: 500;\n}\n.ksc-chart { margin: 4px -4px 0; }\n\n/* ── Traffic clarity notes ───────────────────────────────────── */\n.traffic-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-top: 16px;\n  padding: 12px 16px;\n  background: color-mix(in srgb, var(--accent) 8%, var(--bg-secondary));\n  border: 1px solid color-mix(in srgb, var(--accent) 30%, var(--border));\n  border-radius: var(--radius-md);\n}\n.traffic-note-icon { display: inline-flex; color: var(--accent); flex-shrink: 0; margin-top: 1px; }\n.traffic-note-text { margin: 0; font-size: 0.83rem; color: var(--text-secondary); line-height: 1.5; }\n.traffic-note-text strong { color: var(--text-primary); }\n\n.traffic-unknown-info {\n  display: inline-flex; align-items: center; color: var(--text-muted); cursor: help;\n}\n.traffic-unknown-info:hover, .traffic-unknown-info:focus { color: var(--accent); outline: none; }\n.traffic-unknown-note {\n  display: flex; align-items: flex-start; gap: 7px;\n  margin: 14px 0 0; padding-top: 12px; border-top: 1px dashed var(--border);\n  font-size: 0.78rem; color: var(--text-muted); line-height: 1.5;\n}\n.traffic-unknown-note svg { flex-shrink: 0; margin-top: 2px; }\n.traffic-unknown-note strong { color: var(--text-secondary); }\n\n/* ── Revenue chart card ──────────────────────────────────────── */\n.ov-revenue-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 22px 24px 16px;\n  box-shadow: var(--shadow-card);\n}\n\n/* stat row (Revenue | Orders) below header */\n.rev-stat-row {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  margin-bottom: 20px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n}\n.rev-stat-block {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  padding: 14px 20px;\n}\n.rev-stat-indicator {\n  width: 4px;\n  height: 36px;\n  border-radius: var(--radius-xs);\n  flex-shrink: 0;\n}\n.rev-stat-label {\n  font-size: 0.73rem;\n  color: var(--text-muted);\n  margin: 0 0 3px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n.rev-stat-value {\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n  line-height: 1.1;\n}\n.rev-stat-divider {\n  width: 1px;\n  height: 52px;\n  background: var(--border);\n  flex-shrink: 0;\n}\n\n/* chart tooltip */\n.rev-tooltip {\n  background: var(--bg-primary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 10px 14px;\n  box-shadow: 0 8px 24px rgba(1, 13, 33,0.18);\n  min-width: 160px;\n}\n.rev-tooltip-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-muted);\n  margin: 0 0 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n.rev-tooltip-row {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n  margin-bottom: 5px;\n}\n.rev-tooltip-row:last-child { margin-bottom: 0; }\n.rev-tooltip-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.rev-tooltip-name {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  flex: 1;\n}\n.rev-tooltip-val {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n/* legacy legend classes kept for other usages */\n.rev-legend {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n  flex-wrap: wrap;\n  margin-top: 2px;\n}\n.rev-leg-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: inline-block;\n  flex-shrink: 0;\n}\n.rev-leg-label {\n  font-size: 0.78rem;\n  color: var(--text-muted);\n}\n.rev-legend strong {\n  font-size: 0.82rem;\n  color: var(--text-primary);\n}\n\n/* ── Two-column row ──────────────────────────────────────────── */\n.ov-two-col {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n.ov-two-col-wide {\n  grid-template-columns: 2fr 1fr;\n}\n@media (max-width: 900px) {\n  .ov-two-col,\n  .ov-two-col-wide { grid-template-columns: 1fr; }\n}\n\n/* ── Order Distribution legend ───────────────────────────────── */\n.dist-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 16px;\n  justify-content: center;\n  margin-top: 4px;\n}\n.dist-leg-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n/* ── Top Sale list ───────────────────────────────────────────── */\n.top-sale-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.top-sale-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.top-sale-thumb {\n  width: 48px;\n  height: 48px;\n  border-radius: var(--radius-sm);\n  object-fit: cover;\n  flex-shrink: 0;\n  border: 1px solid var(--border);\n}\n.top-sale-info {\n  flex: 1;\n  min-width: 0;\n}\n.top-sale-name {\n  font-size: 0.83rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.top-sale-price {\n  font-size: 0.78rem;\n  color: var(--text-muted);\n  margin: 0;\n}\n.top-sale-units {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--text-muted);\n  white-space: nowrap;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  padding: 3px 9px;\n  border-radius: var(--radius-xl);\n}\n\n/* ── Recent Orders table ─────────────────────────────────────── */\n/* No overflow-x here: the v2 table below is table-layout:fixed and always sizes\n   to its column, so a sideways scrollbar would only ever be a symptom of a\n   column width bug rather than a legitimate escape hatch. */\n.ro-table-wrap {\n  margin: 0 -2px;\n}\n.ro-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.82rem;\n}\n.ro-table thead th {\n  padding: 8px 10px;\n  text-align: left;\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 1px solid var(--border);\n}\n.ro-row td {\n  padding: 10px 10px;\n  vertical-align: middle;\n  border-bottom: 1px solid var(--border);\n  color: var(--text-primary);\n}\n.ro-row:last-child td { border-bottom: none; }\n.ro-row:hover { background: var(--bg-tertiary); }\n.ro-row-urgent { background: linear-gradient(90deg, rgba(255, 103, 0, 0.05) 0%, rgba(255, 103, 0, 0) 100%); }\n.ro-row-urgent:hover { background: linear-gradient(90deg, rgba(255, 103, 0, 0.12) 0%, rgba(255, 103, 0, 0.02) 100%); }\n\n.ro-product-cell {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 160px;\n}\n.ro-thumb {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-sm);\n  object-fit: cover;\n  flex-shrink: 0;\n  border: 1px solid var(--border);\n}\n.ro-product-name {\n  font-size: 0.82rem;\n  font-weight: 500;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 140px;\n}\n.ro-customer { color: var(--text-secondary); white-space: nowrap; }\n.ro-total    { font-weight: 600; white-space: nowrap; }\n.ro-date     { color: var(--text-muted); white-space: nowrap; }\n\n/* ── Recent Orders pagination ────────────────────────────────── */\n.ro-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 2px 0;\n  margin-top: 4px;\n  border-top: 1px solid var(--border);\n}\n.ro-showing {\n  font-size: 0.76rem;\n  color: var(--text-muted);\n}\n.ro-pages {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.ro-page-btn {\n  min-width: 30px;\n  height: 30px;\n  padding: 0 4px;\n  border-radius: var(--radius-xs);\n  border: 1px solid var(--border);\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 140ms ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ro-page-btn:hover:not(:disabled) {\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  border-color: var(--accent);\n}\n.ro-page-btn.active {\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  border-color: var(--accent);\n  font-weight: 700;\n}\n.ro-page-btn:disabled { opacity: 0.35; cursor: default; }\n.ro-arrow { font-size: 1.1rem; }\n\n/* ── Category Revenue breakdown ──────────────────────────────── */\n.cat-rev-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.cat-rev-item { }\n.cat-rev-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 5px;\n}\n.cat-rev-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: inline-block;\n  flex-shrink: 0;\n}\n.cat-rev-name {\n  font-size: 0.82rem;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n.cat-rev-pct {\n  font-size: 0.78rem;\n  color: var(--text-muted);\n  font-weight: 500;\n}\n.cat-rev-val {\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  min-width: 68px;\n  text-align: right;\n}\n.cat-rev-bar-bg {\n  height: 7px;\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-pill);\n  overflow: hidden;\n}\n.cat-rev-bar-fill {\n  height: 100%;\n  border-radius: var(--radius-pill);\n  transition: width 600ms var(--ease-out-expo);\n}\n\n/* ── Chart tooltip (shared) ──────────────────────────────────── */\n.chart-tooltip {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 8px 12px;\n  font-size: 0.8rem;\n  box-shadow: 0 4px 16px rgba(1, 13, 33,0.1);\n}\n.chart-tooltip-label {\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 4px;\n}\n.chart-tooltip p { margin: 2px 0; }\n\n/* ═══════════════════════════════════════════════════════════════\n   OVERVIEW REDESIGN v2\n   ═══════════════════════════════════════════════════════════════ */\n\n/* ── Page header extras ──────────────────────────────────────── */\n.admin-page-subtitle {\n  font-size: 0.82rem;\n  color: var(--text-muted);\n  margin: 3px 0 0;\n}\n/* ── Live status + sound, in the admin header ─────────────────────────────\n   Two small controls that belong together: whether the dashboard is still\n   hearing orders, and whether it will make a noise when one arrives. Grouped\n   so they wrap as a pair rather than splitting across two rows of the header.\n   flex-shrink:0 because the header is an overflow-x:auto row -- without it\n   these are the first things squeezed to nothing on a narrow screen. */\n.admin-live-controls {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.admin-live-pill,\n.admin-sound-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 38px;           /* matches .admin-refresh-btn, so the row has one baseline */\n  padding: 0 12px;\n  border-radius: var(--radius-xl);\n  border: 1px solid var(--border);\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  font-size: 0.76rem;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n/* The state dot. Blue when the push socket is up, hollow when it is not --\n   and never the only thing saying which: the pill carries the words \"Live\" or\n   \"Polling\" beside it, because four hues cannot also encode status. */\n.admin-live-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  border: 1.5px solid var(--text-muted);\n  background: transparent;\n}\n\n.admin-live-pill.is-live {\n  border-color: color-mix(in srgb, var(--color-secondary) 40%, transparent);\n  color: var(--color-secondary-text);\n}\n\n.admin-live-pill.is-live .admin-live-dot {\n  border-color: var(--color-secondary);\n  background: var(--color-secondary);\n  animation: admin-live-ping 2.4s ease-out infinite;\n}\n\n@keyframes admin-live-ping {\n  0%   { box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.5); }\n  70%  { box-shadow: 0 0 0 7px rgba(59, 130, 246, 0); }\n  100% { box-shadow: 0 0 0 0 rgba(59, 130, 246, 0); }\n}\n\n.admin-sound-toggle {\n  cursor: pointer;\n  transition: border-color 150ms, color 150ms, background 150ms;\n}\n\n.admin-sound-toggle:hover {\n  border-color: var(--color-secondary);\n  color: var(--color-secondary-text);\n}\n\n.admin-sound-toggle.is-on {\n  border-color: color-mix(in srgb, var(--color-secondary) 40%, transparent);\n  color: var(--color-secondary-text);\n}\n\n.admin-sound-toggle:focus-visible {\n  outline: 2px solid var(--color-secondary);\n  outline-offset: 2px;\n}\n\n/* The label goes before the icon does. At phone width the header is already\n   a scrolling row of controls, and \"Sound on\" spelled out costs more than the\n   speaker glyph earns -- but the glyph alone still says mute-or-not, and the\n   title attribute still carries the words. */\n@media (max-width: 720px) {\n  .admin-sound-toggle-label { display: none; }\n  .admin-live-pill,\n  .admin-sound-toggle { padding: 0 10px; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .admin-live-pill.is-live .admin-live-dot { animation: none; }\n}\n\n.admin-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  /* Constrain width to prevent expansion beyond available space */\n  max-width: 100%;\n  min-width: 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n.admin-header-actions,\n.ov-date-range,\n.ov-period-btns {\n  /* Matches .admin-refresh-btn's fixed 38px box. A font swap (fallback ->\n     Inter once it downloads) changes a glyph's ascent/descent, not just its\n     width -- without a fixed height too, that can still grow/shrink this\n     whole row vertically for the few seconds until the real font is in,\n     which reads as the row's \"padding\" changing before it settles. */\n  min-height: 38px;\n}\n.ov-date-range {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 7px 14px;\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  /* Reserves enough room for the longest possible range string (the 1Y\n     format: \"Jan 1, 2025 – Dec 31, 2025\") so this chip's own width never\n     changes -- whether from switching periods, a web-font swap changing\n     glyph metrics after first paint, or anything else. A fixed-width\n     neighbour is what actually keeps the 7D/30D/90D/1Y buttons from\n     shifting horizontally on load, since they sit right after it in the\n     same flex row.\n     \n     NOTE: Updated to account for font-size-adjust normalization and use\n     max-width to prevent unexpected expansion during font metric shifts. */\n  min-width: 222px;\n  max-width: 240px;\n  flex-shrink: 0;\n  font-variant-numeric: tabular-nums;\n  box-sizing: border-box;\n  /* Prevent text overflow within the container */\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ov-date-icon { font-size: 0.95rem; display: flex; flex-shrink: 0; }\n.ov-date-text {\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* ── Overview range controls, docked to the top-right of the page header ──\n   Previously the range chip, the preset switcher and two always-visible\n   date inputs sat as separate children of .admin-header-actions. Together\n   they were wider than the space left beside the page title, so the whole\n   lot wrapped onto its own full-width band beneath the header. Grouping\n   them and moving the custom From/To fields into a popover keeps the\n   cluster narrow enough to stay on the title's row, right-aligned. */\n.ov-range-controls {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-left: auto;\n  flex-wrap: nowrap;\n}\n\n.ov-date-popover-wrap { position: relative; display: flex; }\n\n/* The header and its action row both clip their overflow to stop the toolbar\n   growing the header (.admin-page-header sets overflow-x: hidden, which the\n   spec computes to overflow-y: auto -- so it clips vertically too, and\n   .admin-header-actions clips outright). That silently swallowed the\n   range popover, which hangs below the header by design. Lift the clipping\n   only on the Overview tab, where that popover is the one thing that needs\n   to escape. */\n.admin-page-header.has-range-popover,\n.admin-header-actions.has-range-popover {\n  overflow: visible;\n}\n/* .admin-page-header is space-between, which only pushes the actions right\n   while both children share a line. Once the controls wrap onto their own\n   row, space-between has a single item to place and puts it at flex-start --\n   so the cluster jumped from the top-right to the far left. An explicit\n   auto margin keeps it right-aligned on the wrapped row too. */\n.admin-header-actions.has-range-popover { margin-left: auto; }\n\n/* The chip is a button now (it opens the custom-range popover), so it needs\n   the interactive affordances a bare <div> didn't. */\n.ov-date-range {\n  cursor: pointer;\n  text-align: left;\n  font-family: inherit;\n  transition: border-color 150ms, background 150ms;\n}\n.ov-date-range:hover { border-color: var(--border-strong); }\n.ov-date-range:focus-visible {\n  outline: none;\n  border-color: var(--color-secondary);\n  box-shadow: 0 0 0 4px var(--color-focus-ring);\n}\n/* A custom range is a deliberate, sticky choice -- mark it so it's obvious\n   the presets are no longer what's driving the page. */\n.ov-date-range.is-custom {\n  border-color: var(--color-secondary);\n  color: var(--text-primary);\n}\n.ov-date-caret { margin-left: auto; flex-shrink: 0; opacity: 0.6; }\n\n.ov-date-popover {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  z-index: 40;\n  min-width: 240px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 14px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-panel);\n}\n.ov-date-field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n.ov-date-field input {\n  padding: 8px 10px;\n  border-radius: var(--radius-xs);\n  border: 1px solid var(--border);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 0.82rem;\n  font-family: inherit;\n}\n.ov-date-field input:focus-visible {\n  outline: none;\n  border-color: var(--color-secondary);\n  box-shadow: 0 0 0 3px var(--color-focus-ring);\n}\n.ov-date-error { margin: 0; font-size: 0.72rem; color: var(--color-primary); }\n.ov-date-clear {\n  padding: 7px 10px;\n  border-radius: var(--radius-xs);\n  border: 1px solid var(--border);\n  background: none;\n  color: var(--text-primary);\n  font-size: 0.78rem;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n}\n.ov-date-clear:hover:not(:disabled) { background: var(--color-surface-hover); }\n.ov-date-clear:disabled { opacity: 0.5; cursor: not-allowed; }\n\n@media (max-width: 1100px) {\n  /* Below the point where the chip and switcher can share the title's row,\n     let them wrap as a unit and span the full width rather than each\n     control breaking to its own line. */\n  .admin-header-actions.has-range-popover { margin-left: 0; width: 100%; }\n  .ov-range-controls { margin-left: 0; width: 100%; flex-wrap: wrap; }\n  .ov-date-range { min-width: 0; flex: 1 1 auto; max-width: none; }\n  .ov-date-popover { right: auto; left: 0; }\n}\n.ov-period-btns {\n  display: flex;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n  flex-shrink: 0;\n  box-sizing: border-box;\n  /* Constrain width to prevent horizontal expansion */\n  max-width: calc(4 * 43px + 3px);\n}\n.ov-period-btn {\n  background: none;\n  border: none;\n  padding: 7px 13px;\n  /* Reserves the same box for \"7D\" as for \"30D\"/\"90D\" regardless of actual\n     glyph width, so this button row can't change width either -- the same\n     reasoning as .ov-date-range's min-width just above: the fallback system\n     font shown before Inter finishes loading (`font-display: swap` in\n     index.html) renders these labels at different widths than Inter does,\n     and without a reserved box that swap visibly shifts this row (and the\n     refresh button after it) for the few seconds until the real font loads. */\n  min-width: 34px;\n  text-align: center;\n  line-height: 1;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n.ov-period-btn:hover { background: var(--bg-tertiary); color: var(--text-primary); }\n.ov-period-btn.active { background: var(--color-secondary); color: var(--color-text-on-secondary); border-radius: var(--radius-sm); }\n.ov-period-btn:disabled { cursor: default; }\n.ov-period-btns.is-loading { opacity: 0.6; }\n\n/* ── Seller KPI row ──────────────────────────────────────────── */\n.seller-kpi-row {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: var(--space-2);\n}\n@media (max-width: 1100px) { .seller-kpi-row { grid-template-columns: repeat(2, 1fr); } }\n@media (max-width: 640px)  { .seller-kpi-row { grid-template-columns: 1fr; } }\n\n.seller-kpi-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 16px 18px;\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  box-shadow: var(--shadow-card);\n}\n.skc-icon {\n  width: 42px;\n  height: 42px;\n  border-radius: var(--radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n  flex-shrink: 0;\n}\n.skc-body { flex: 1; min-width: 0; }\n.skc-label {\n  font-size: 0.72rem;\n  color: var(--text-muted);\n  font-weight: 500;\n  margin: 0 0 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n.skc-value {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 3px;\n}\n.skc-sub {\n  font-size: 0.7rem;\n  color: var(--text-muted);\n  margin: 0;\n}\n.skc-right {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  flex-shrink: 0;\n}\n\n/* ── Revenue chart + Top Sellers row ─────────────────────────── */\n.ov-chart-seller-row {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);\n  gap: 20px;\n  align-items: start;\n}\n@media (max-width: 1000px) { .ov-chart-seller-row { grid-template-columns: 1fr; } }\n\n/* chart legend */\n.rev-chart-legend {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 4px;\n  flex-wrap: wrap;\n}\n.rcl-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.rcl-label {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n/* Top Sellers card */\n.ov-top-sellers-card { overflow: hidden; }\n.ts-table-head {\n  display: flex;\n  gap: var(--space-1);\n  padding: 0 0 10px;\n  border-bottom: 1px solid var(--border);\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n.ts-col-seller { flex: 1; }\n.ts-col-gmv { width: 80px; text-align: right; }\n.ts-col-orders { width: 60px; text-align: right; }\n.ts-list { list-style: none; padding: 0; margin: 10px 0 0; display: flex; flex-direction: column; gap: 0; }\n.ts-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--border);\n}\n.ts-item:last-child { border-bottom: none; }\n.ts-rank {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--text-muted);\n  width: 16px;\n  text-align: center;\n  flex-shrink: 0;\n}\n.ts-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: var(--color-brand-white);\n  flex-shrink: 0;\n}\n.ts-info { flex: 1; min-width: 0; }\n.ts-name {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ts-stats { text-align: right; }\n.ts-gmv {\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 2px;\n  white-space: nowrap;\n}\n.ts-orders-count {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  justify-content: flex-end;\n}\n.ts-growth {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  padding: 2px 5px;\n  border-radius: var(--radius-xl);\n  font-size: 0.68rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.ts-growth-up { background: var(--color-secondary-soft); color: var(--color-secondary); }\n.ts-growth-down { background: var(--color-primary-soft); color: var(--color-primary); }\n.ts-growth-flat,\n.ts-growth-new { background: var(--bg-tertiary); color: var(--text-muted); }\n\n.ov-view-all-link {\n  background: none;\n  border: none;\n  color: var(--color-secondary);\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n  margin-top: 14px;\n  display: block;\n}\n.ov-view-all-link:hover { text-decoration: underline; }\n\n/* ── Bottom row: Category + Recent Orders + Goal ─────────────── */\n.ov-bottom-row {\n  display: grid;\n  /* minmax(0, …) rather than a bare fr -- otherwise a card whose content\n     (e.g. a chart) has a wider natural min-content size than its fair\n     share pins that whole column at its content width instead of shrinking,\n     stealing space from its siblings and throwing the row out of balance. */\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.35fr) minmax(0, 1fr);\n  gap: 20px;\n  align-items: stretch;\n}\n.ov-bottom-row > .ov-card { display: flex; flex-direction: column; height: 100%; }\n/* Body wrapper fills the remaining card height. Centring the content here used\n   to split the leftover height into two dead bands (measured 62-88px above AND\n   below the orders table), because the row is only as tall as its tallest card\n   and the shorter cards centre inside it. Content now starts at the top and the\n   card-specific rules below hand the slack to whichever element should absorb\n   it, so the cards stay equal-height with no empty gaps. */\n.ov-card-fill {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  min-height: 0;\n}\n/* Every card in this row distributes its own leftover height between its\n   sections rather than pooling it into one visible gap. Scoped to the bottom\n   row so the location-row cards below keep their existing top-aligned layout. */\n.ov-bottom-row .ov-card-fill { justify-content: space-between; }\n@media (max-width: 1100px) { .ov-bottom-row { grid-template-columns: 1fr 1fr; } }\n@media (max-width: 700px)  { .ov-bottom-row { grid-template-columns: 1fr; } }\n\n/* Category donut */\n.cat-donut-center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  pointer-events: none;\n}\n.cat-donut-val {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n.cat-donut-sub {\n  font-size: 0.7rem;\n  color: var(--text-muted);\n  margin: 0;\n}\n.cat-donut-legend {\n  list-style: none;\n  padding: 0;\n  margin: 10px 0 0;\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n.cdl-item {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n  font-size: 0.78rem;\n}\n.cdl-dot { width: 9px; height: 9px; border-radius: 50%; flex-shrink: 0; }\n.cdl-name { flex: 1; color: var(--text-secondary); }\n.cdl-val { font-weight: 600; color: var(--text-primary); white-space: nowrap; }\n.cdl-pct { color: var(--text-muted); font-size: 0.72rem; }\n\n/* Recent orders v2 -- fixed column widths so five columns always fit the card\n   instead of pushing it into a horizontal scroll. Anything too long clips with\n   an ellipsis; the cells carry a title with the full value.\n\n   Breakpoints below are CONTAINER queries, not viewport ones: in the 3-up row\n   this card is only ~384px wide at a 1280px viewport, so a viewport media query\n   is blind to exactly the case that needs handling. */\n.ov-orders-card { container-type: inline-size; }\n.ro-table-v2 { table-layout: fixed; width: 100%; }\n.ro-table-v2 th,\n.ro-table-v2 td {\n  padding: 10px 6px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ro-table-v2 th { font-size: 0.68rem; text-transform: uppercase; letter-spacing: 0.02em; }\n.ro-table-v2 th:nth-child(1), .ro-table-v2 td:nth-child(1) { width: 15%; }\n.ro-table-v2 th:nth-child(2), .ro-table-v2 td:nth-child(2) { width: 27%; }\n.ro-table-v2 th:nth-child(3), .ro-table-v2 td:nth-child(3) { width: 13%; }\n.ro-table-v2 th:nth-child(4), .ro-table-v2 td:nth-child(4) { width: 21%; }\n.ro-table-v2 th:nth-child(5), .ro-table-v2 td:nth-child(5) { width: 24%; }\n/* The status pill is sized for full-width tables, where `white-space: nowrap`\n   is free. In a ~90px column \"out for delivery\" can't fit on one line, and an\n   inline-flex pill won't ellipsis its own text. Wrapping keeps the label intact;\n   `overflow-wrap: anywhere` stops a single long word (\"processing\") from\n   forcing the pill wider than its cell and re-creating a sideways scroll. */\n.ro-table-v2 td:nth-child(5) { white-space: normal; }\n.ro-table-v2 .status {\n  max-width: 100%;\n  padding: 3px 7px;\n  gap: 4px;\n  font-size: 0.68rem;\n  line-height: 1.3;\n  display: inline-flex;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n/* Date is the most droppable column once the card itself gets narrow. */\n@container (max-width: 400px) {\n  .ro-table-v2 th:nth-child(3), .ro-table-v2 td:nth-child(3) { display: none; }\n  .ro-table-v2 th:nth-child(1), .ro-table-v2 td:nth-child(1) { width: 17%; }\n  .ro-table-v2 th:nth-child(2), .ro-table-v2 td:nth-child(2) { width: 31%; }\n  .ro-table-v2 th:nth-child(4), .ro-table-v2 td:nth-child(4) { width: 26%; }\n  .ro-table-v2 th:nth-child(5), .ro-table-v2 td:nth-child(5) { width: 26%; }\n}\n/* Fill the card: the table takes the leftover height and distributes it across\n   its rows, so there's no dead band between the last row and the pagination. */\n.ov-orders-card .ov-card-fill > .ro-table-wrap { flex: 1; display: flex; }\n.ov-orders-card .ro-table-v2 { height: 100%; }\n.ov-orders-card .admin-pagination { margin-top: auto; }\n.ro-id { font-size: 0.78rem; font-weight: 600; color: var(--text-secondary); }\n\n/* The shared pagination is sized for full-page tables; tighten it inside a card. */\n.ov-card .admin-pagination { padding: 14px 0 2px; gap: 8px; flex-wrap: wrap; }\n.ov-card .admin-page-btn { padding: 6px 12px; font-size: 0.8rem; }\n.ov-card .admin-page-info { font-size: 0.78rem; }\n\n/* Revenue goal -- the ring is a centred hero rather than the middle of a 3-up\n   flex row. Flanking it with text columns meant a narrowing card squeezed those\n   columns until the $-amounts collided with the ring. */\n.goal-ring-wrap {\n  width: clamp(150px, 58%, 190px);\n  aspect-ratio: 1;\n  margin: 4px auto 18px;\n}\n.goal-ring { display: block; width: 100%; height: 100%; }\n.goal-ring-track {\n  fill: none;\n  stroke: var(--bg-tertiary);\n  stroke-width: 26;\n}\n.goal-ring-fill {\n  fill: none;\n  stroke-width: 26;\n  stroke-linecap: round;\n  transition: stroke-dashoffset 800ms ease;\n}\n/* SVG user units, not CSS pixels -- these scale with the ring, so the labels\n   keep the same proportions (and stay inside the hole) at every card width. */\n.goal-ring-pct { font-size: 38px; font-weight: 800; fill: var(--text-primary); }\n.goal-ring-status { font-size: 14px; font-weight: 600; }\n\n.goal-endpoints {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 10px;\n  padding-bottom: 18px;\n  border-bottom: 1px solid var(--border);\n}\n.goal-endpoint { min-width: 0; }\n.goal-endpoint-target { text-align: right; }\n.goal-endpoint-val {\n  font-size: clamp(0.95rem, 0.75rem + 0.6vw, 1.15rem);\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n  white-space: nowrap;\n}\n.goal-endpoint-label {\n  font-size: 0.72rem;\n  color: var(--text-muted);\n  margin: 3px 0 0;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n/* Ring / endpoints / stats spread into this card's leftover height via the\n   shared `.ov-bottom-row .ov-card-fill` space-between rule above. */\n.goal-stats-list {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding-top: 18px;\n}\n.goal-stat-row { display: flex; align-items: center; gap: 12px; }\n.goal-stat-icon {\n  width: 40px; height: 40px; border-radius: 50%;\n  display: flex; align-items: center; justify-content: center;\n  flex-shrink: 0;\n}\n.goal-stat-info { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }\n.goal-stat-label { font-size: 0.75rem; color: var(--text-muted); text-transform: uppercase; letter-spacing: 0.03em; }\n.goal-stat-val { font-size: 0.95rem; font-weight: 700; color: var(--text-primary); white-space: nowrap; }\n\n/* The title is this header's first child directly (no wrapper div), so the\n   generic `.ov-card-header > div:first-child` flex rule misses it. */\n.ov-goal-card .ov-card-title { flex: 1 1 auto; min-width: 0; }\n.ov-goal-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n.goal-edit-btn {\n  border: none;\n  background: var(--bg-tertiary);\n  width: 26px;\n  height: 26px;\n  border-radius: var(--radius-sm);\n  font-size: 0.8rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 150ms;\n}\n.goal-edit-btn:hover { background: var(--border); }\n\n.goal-edit-form { margin-top: 4px; }\n.goal-edit-label {\n  display: block;\n  font-size: 0.78rem;\n  color: var(--text-muted);\n  margin-bottom: 8px;\n}\n.goal-edit-row {\n  display: flex;\n  align-items: center;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 0 12px;\n  background: var(--bg-primary);\n}\n.goal-edit-prefix {\n  font-weight: 700;\n  color: var(--text-secondary);\n  margin-right: 4px;\n}\n.goal-edit-input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  padding: 10px 0;\n}\n.goal-edit-input:focus { outline: none; }\n.goal-edit-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n}\n.goal-edit-cancel {\n  padding: 6px 14px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n  background: transparent;\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n.goal-edit-cancel:hover { background: var(--bg-tertiary); }\n\n/* ── Seller Location Analytics ───────────────────────────────── */\n.ov-location-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 18px;\n  margin-top: 28px;\n}\n@media (max-width: 900px) { .ov-location-row { grid-template-columns: 1fr; } }\n\n.ov-location-card { min-height: 280px; }\n.ov-card-sub {\n  font-size: 0.73rem;\n  color: var(--text-muted);\n  margin: 2px 0 0;\n}\n\n.loc-list {\n  list-style: none; padding: 0; margin: 14px 0 0;\n  display: flex; flex-direction: column; gap: 11px;\n}\n.loc-item {\n  display: flex; align-items: center; gap: 10px;\n}\n.loc-rank {\n  width: 22px; min-width: 22px;\n  font-size: 0.72rem; font-weight: 800;\n  color: var(--text-muted); text-align: center;\n}\n.loc-info {\n  flex: 1; min-width: 0;\n}\n.loc-name-row {\n  display: flex; align-items: center; gap: 7px; margin-bottom: 4px;\n}\n.loc-city {\n  font-size: 0.82rem; font-weight: 700;\n  color: var(--text-primary); white-space: nowrap;\n  overflow: hidden; text-overflow: ellipsis;\n}\n.loc-crown {\n  font-size: 0.65rem; font-weight: 700;\n  background: var(--color-primary-soft); color: var(--color-primary);\n  padding: 1px 7px; border-radius: var(--radius-xl);\n  white-space: nowrap;\n}\n.loc-crown-grow {\n  background: var(--color-secondary-soft); color: var(--color-secondary);\n}\n.loc-bar-wrap {\n  height: 5px; background: var(--bg-tertiary);\n  border-radius: var(--radius-pill); overflow: hidden;\n}\n.loc-bar-fill {\n  height: 100%; border-radius: var(--radius-pill);\n  transition: width 600ms cubic-bezier(0.25,0.46,0.45,0.94);\n}\n.loc-count {\n  font-size: 0.75rem; font-weight: 700;\n  color: var(--text-secondary); white-space: nowrap;\n  min-width: 60px; text-align: right;\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   DELIVERY REVIEW SYSTEM  (v2 — no shiver, emoji, animated)\n   ═══════════════════════════════════════════════════════════════ */\n\n/* ── Reviewed badge on order header ──────────────────────────── */\n.order-reviewed-badge {\n  font-size: 0.72rem;\n  font-weight: 600;\n  background: var(--color-primary-soft);\n  color: var(--color-primary);\n  border: 1px solid var(--color-primary-soft);\n  padding: 2px 9px;\n  border-radius: var(--radius-xl);\n}\n\n/* ── Section separator inside order card ────────────────────── */\n.dr-order-section {\n  margin-top: 20px;\n  border-top: 1px solid var(--border);\n  padding-top: 18px;\n}\n\n/* ── Prompt strip (unreviewed delivered order) ───────────────── */\n.dr-prompt {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-2);\n  background: linear-gradient(135deg, var(--color-primary-soft) 0%, color-mix(in srgb, var(--color-primary) 16%, transparent) 100%);\n  border: 1px solid var(--color-primary-soft);\n  border-left: 4px solid var(--color-primary);\n  border-radius: var(--radius-sm);\n  padding: 16px 20px;\n  flex-wrap: wrap;\n  transition: box-shadow 200ms ease;\n}\n.dr-prompt:hover { box-shadow: 0 4px 20px rgba(255, 103, 0,0.12); }\n.dark .dr-prompt {\n  background: linear-gradient(135deg, rgba(255, 103, 0,0.08) 0%, rgba(251,146,60,0.05) 100%);\n  border-color: rgba(255, 103, 0,0.3);\n}\n.dr-prompt-content { display: flex; align-items: center; gap: 14px; }\n.dr-prompt-stars-preview {\n  display: flex;\n  gap: 1px;\n}\n.dp-star {\n  font-size: 1.3rem;\n  color: var(--color-primary);\n  animation: dp-star-pulse 2s ease-in-out infinite;\n}\n.dp-star:nth-child(2) { animation-delay: 0.1s; }\n.dp-star:nth-child(3) { animation-delay: 0.2s; }\n.dp-star:nth-child(4) { animation-delay: 0.3s; }\n.dp-star:nth-child(5) { animation-delay: 0.4s; }\n@keyframes dp-star-pulse {\n  0%, 100% { opacity: 0.45; transform: scale(0.95); }\n  50%       { opacity: 1;    transform: scale(1.05); }\n}\n.dr-prompt-title {\n  font-size: 0.92rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 3px;\n}\n.dr-prompt-sub {\n  font-size: 0.77rem;\n  color: var(--text-muted);\n  margin: 0;\n}\n.dr-prompt-btn {\n  flex-shrink: 0;\n  padding: 9px 20px;\n  border-radius: var(--radius-sm);\n  border: none;\n  background: linear-gradient(135deg, var(--color-primary) 0%, color-mix(in srgb, var(--color-primary) 80%, var(--color-brand-navy)) 100%);\n  color: var(--color-brand-white);\n  font-size: 0.85rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 160ms ease, box-shadow 160ms ease, opacity 160ms;\n  box-shadow: 0 4px 14px rgba(255, 103, 0,0.35);\n  white-space: nowrap;\n}\n.dr-prompt-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 18px rgba(255, 103, 0,0.45);\n}\n.dr-prompt-btn:active { transform: translateY(0); }\n\n/* ── Review summary card (post-submission) ───────────────────── */\n.dr-summary {\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 18px 20px;\n  animation: dr-slide-up 300ms var(--ease-out-expo, cubic-bezier(0.16,1,0.3,1)) both;\n  box-shadow: var(--shadow-card);\n}\n.dr-summary-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n.dr-summary-badge {\n  font-size: 0.78rem;\n  font-weight: 700;\n  background: var(--color-secondary-soft);\n  color: var(--color-secondary);\n  border: 1px solid var(--color-secondary-soft);\n  padding: 3px 12px;\n  border-radius: var(--radius-xl);\n}\n.dr-summary-date { font-size: 0.74rem; color: var(--text-muted); }\n.dr-summary-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n@media (max-width: 600px) { .dr-summary-grid { grid-template-columns: 1fr; } }\n.dr-summary-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px 14px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-left: 3px solid var(--sc, var(--accent));\n  border-radius: var(--radius-sm);\n}\n.dr-summary-icon { font-size: 1.3rem; flex-shrink: 0; margin-top: 1px; }\n.dr-summary-info { flex: 1; min-width: 0; }\n.dr-summary-label {\n  font-size: 0.76rem;\n  font-weight: 600;\n  color: var(--text-muted);\n  display: block;\n  margin-bottom: 5px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n.dr-summary-stars { display: flex; align-items: center; gap: 1px; margin-bottom: 4px; }\n.dr-sum-star { font-size: 1rem; color: var(--border); }\n.dr-sum-star.lit { color: var(--color-primary); }\n.dr-sum-fb { font-size: 1rem; margin-left: 6px; }\n.dr-summary-note {\n  font-size: 0.76rem;\n  color: var(--text-muted);\n  margin: 4px 0 0;\n  line-height: 1.45;\n  word-break: break-word;\n}\n\n/* ── Modal overlay ───────────────────────────────────────────── */\n.dr-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(1, 13, 33,0.55);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  z-index: 9000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-2);\n  overflow-y: auto;\n}\n.dr-modal {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xl);\n  width: 100%;\n  max-width: 560px;\n  max-height: calc(100vh - 40px);\n  overflow-y: auto;\n  box-shadow: 0 32px 80px rgba(1, 13, 33,0.25), 0 0 0 1px rgba(255,255,255,0.04);\n  animation: dr-slide-up 300ms cubic-bezier(0.16,1,0.3,1) both;\n  scrollbar-width: thin;\n}\n@keyframes dr-slide-up {\n  from { opacity: 0; transform: translateY(28px) scale(0.96); }\n  to   { opacity: 1; transform: translateY(0)    scale(1); }\n}\n\n/* ── Modal header ────────────────────────────────────────────── */\n.dr-modal-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 24px 24px 16px;\n  position: sticky;\n  top: 0;\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border);\n  z-index: 2;\n}\n.dr-modal-head::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(135deg, rgba(255, 103, 0,0.04) 0%, transparent 60%);\n  pointer-events: none;\n  border-radius: var(--radius-xl) var(--radius-xl) 0 0;\n}\n.dr-modal-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 4px;\n}\n.dr-modal-sub {\n  font-size: 0.77rem;\n  color: var(--text-muted);\n  margin: 0;\n}\n.dr-close {\n  width: 32px;\n  height: 32px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  font-size: 0.9rem;\n  color: var(--text-muted);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: background 140ms, color 140ms, transform 140ms;\n}\n.dr-close:hover {\n  background: var(--color-primary-soft);\n  color: var(--color-primary);\n  border-color: var(--color-primary-soft);\n  transform: scale(1.05);\n}\n\n/* ── Progress chips row ──────────────────────────────────────── */\n.dr-progress-row {\n  display: flex;\n  gap: var(--space-1);\n  padding: 14px 24px;\n  flex-wrap: wrap;\n  border-bottom: 1px solid var(--border);\n}\n.dr-progress-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.73rem;\n  font-weight: 600;\n  padding: 4px 12px;\n  border-radius: var(--radius-xl);\n  border: 1.5px solid var(--border);\n  color: var(--text-muted);\n  background: var(--bg-tertiary);\n  transition: all 200ms cubic-bezier(0.34,1.56,0.64,1);\n}\n.dr-progress-chip.done {\n  border-color: var(--chip-color);\n  color: var(--chip-color);\n  background: color-mix(in srgb, var(--chip-color) 10%, transparent);\n  transform: scale(1.03);\n}\n\n/* ── Form ────────────────────────────────────────────────────── */\n.dr-form {\n  padding: 8px 24px 24px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── Section ─────────────────────────────────────────────────── */\n.dr-section {\n  padding: 20px 0 20px 14px;\n  border-left: 3px solid var(--sc, var(--accent));\n  margin-left: 0;\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  transition: border-color 300ms ease;\n}\n.dr-section:last-of-type { border-bottom: none; }\n\n.dr-section-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n.dr-section-icon-wrap {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n  flex-shrink: 0;\n  transition: transform 300ms cubic-bezier(0.34,1.56,0.64,1);\n}\n.dr-section.rated .dr-section-icon-wrap { transform: scale(1.1); }\n.dr-section-title {\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 3px;\n}\n.dr-section-desc {\n  font-size: 0.77rem;\n  color: var(--text-muted);\n  margin: 0;\n}\n\n/* ── Stars ────────────────────────────────────────────────────── */\n.dr-picker-wrap {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px 14px;\n}\n.dr-stars {\n  display: flex;\n  cursor: pointer;\n  user-select: none;\n  gap: 0;                    /* no gaps — cursor is always over a star */\n  padding: 4px 2px;\n}\n.dr-star {\n  font-size: 2.1rem;\n  line-height: 1;\n  /* Fixed width so transform: scale never causes layout shift */\n  width: 42px;\n  text-align: center;\n  display: inline-block;\n  color: var(--border);\n  transition:\n    color    120ms ease,\n    transform 200ms cubic-bezier(0.34,1.56,0.64,1),\n    filter   120ms ease;\n  transform-origin: center bottom;\n}\n.dark .dr-star { color: var(--text-secondary); }\n.dr-star.lit {\n  color: var(--color-primary);\n  filter: drop-shadow(0 2px 6px rgba(255, 103, 0,0.45));\n}\n.dr-star.peak {\n  transform: scale(1.35);\n  color: var(--color-primary);\n  filter: drop-shadow(0 3px 8px rgba(255, 103, 0,0.55));\n}\n\n/* ── Feedback label slot (always reserved, no layout shift) ───── */\n.dr-fb-slot {\n  min-width: 90px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n}\n.dr-fb {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.82rem;\n  font-weight: 700;\n  padding: 4px 12px;\n  border-radius: var(--radius-xl);\n  animation: dr-fb-pop 220ms cubic-bezier(0.34,1.56,0.64,1) both;\n  white-space: nowrap;\n}\n@keyframes dr-fb-pop {\n  from { opacity: 0; transform: scale(0.5) translateY(4px); }\n  to   { opacity: 1; transform: scale(1)   translateY(0); }\n}\n.fb-sad  { background: var(--color-primary-soft); color: var(--color-primary); }\n.fb-low  { background: var(--color-primary-soft); color: var(--color-primary); }\n.fb-mid  { background: var(--color-secondary-soft); color: var(--accent-hover); }\n.fb-high { background: var(--color-secondary-soft); color: var(--color-secondary); }\n.fb-wow  {\n  background: linear-gradient(135deg, var(--color-primary-soft) 0%, color-mix(in srgb, var(--color-primary) 16%, transparent) 100%);\n  color: var(--color-primary);\n  font-size: 0.95rem;\n  animation: dr-fb-pop 280ms cubic-bezier(0.34,1.56,0.64,1) both,\n             dr-wow-bounce 600ms 280ms cubic-bezier(0.34,1.56,0.64,1) both;\n}\n@keyframes dr-wow-bounce {\n  0%   { transform: scale(1); }\n  40%  { transform: scale(1.12) rotate(-2deg); }\n  70%  { transform: scale(0.96) rotate(1deg); }\n  100% { transform: scale(1); }\n}\n\n/* ── Conditional fields (slide in) ───────────────────────────── */\n.dr-cond-field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  animation: dr-cond-in 260ms cubic-bezier(0.16,1,0.3,1) both;\n  border-left: 2px dashed var(--sc, var(--accent));\n  padding-left: 12px;\n  margin-left: 4px;\n}\n@keyframes dr-cond-in {\n  from { opacity: 0; transform: translateY(-10px); max-height: 0; }\n  to   { opacity: 1; transform: translateY(0);    max-height: 200px; }\n}\n.dr-field-group {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.dr-label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n.dr-req { color: var(--danger); margin-left: 2px; }\n.dr-opt { color: var(--text-muted); font-weight: 400; }\n.dr-textarea {\n  width: 100%;\n  padding: 10px 13px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 0.83rem;\n  resize: vertical;\n  font-family: inherit;\n  box-sizing: border-box;\n  transition: border-color 160ms ease, box-shadow 160ms ease;\n  line-height: 1.5;\n}\n.dr-textarea:focus {\n  outline: none;\n  border-color: var(--sc, var(--accent));\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--sc, var(--accent)) 15%, transparent);\n}\n.dr-char {\n  font-size: 0.7rem;\n  color: var(--text-muted);\n  text-align: right;\n  margin-top: -2px;\n}\n\n/* ── Actions bar ─────────────────────────────────────────────── */\n.dr-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding-top: 18px;\n  border-top: 1px solid var(--border);\n  margin-top: 10px;\n  flex-wrap: wrap;\n}\n.dr-rated-count {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n  font-size: 0.77rem;\n  color: var(--text-muted);\n}\n.dr-rated-dots { display: flex; gap: 5px; }\n.dr-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--border);\n  transition: background 250ms cubic-bezier(0.34,1.56,0.64,1), transform 250ms cubic-bezier(0.34,1.56,0.64,1);\n}\n.dr-dot.done {\n  background: var(--accent);\n  transform: scale(1.3);\n}\n.dr-action-btns { display: flex; align-items: center; gap: 10px; }\n\n.dr-error {\n  font-size: 0.82rem;\n  color: var(--color-primary);\n  background: var(--color-primary-soft);\n  border: 1px solid var(--color-primary-soft);\n  border-radius: var(--radius-sm);\n  padding: 10px 14px;\n  margin-top: 8px;\n  animation: dr-slide-up 200ms ease both;\n}\n\n/* ── Submit button ───────────────────────────────────────────── */\n.dr-submit-btn {\n  padding: 10px 22px;\n  border-radius: var(--radius-sm);\n  border: none;\n  font-size: 0.85rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 160ms ease, box-shadow 160ms ease, background 200ms ease, opacity 160ms;\n  background: var(--bg-tertiary);\n  color: var(--text-muted);\n  border: 1.5px solid var(--border);\n}\n.dr-submit-btn.ready {\n  background: linear-gradient(135deg, var(--accent-secondary) 0%, color-mix(in srgb, var(--accent-secondary) 80%, transparent) 100%);\n  color: var(--color-brand-white);\n  border-color: transparent;\n  box-shadow: 0 4px 18px color-mix(in srgb, var(--accent-secondary) 35%, transparent);\n}\n.dr-submit-btn.ready:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 24px color-mix(in srgb, var(--accent-secondary) 45%, transparent);\n}\n.dr-submit-btn.ready:active { transform: translateY(0); }\n.dr-submit-btn:disabled { opacity: 0.6; cursor: not-allowed; }\n.dr-submitting {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-1);\n}\n.dr-spin {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255,255,255,0.3);\n  border-top-color: var(--color-brand-white);\n  border-radius: 50%;\n  animation: spin 600ms linear infinite;\n}\n\n/* ── Responsive ──────────────────────────────────────────────── */\n/* No breakpoint existed here before -- the 5-star row (5 x 42px + gap)\n   plus the reserved feedback-label slot didn't fit a ~375px phone even\n   with .dr-picker-wrap's flex-wrap fallback above, so it read as an\n   internal horizontal scrollbar cutting off the feedback badge. */\n@media (max-width: 480px) {\n  .dr-form { padding: 8px 16px 20px; }\n  .dr-section { padding: 16px 0 16px 10px; }\n  .dr-modal-head { padding: 18px 16px 14px; }\n  .dr-star { width: 34px; font-size: 1.7rem; }\n  .dr-picker-wrap { gap: 6px 10px; }\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   ADMIN — REVIEWS TAB\n   ═══════════════════════════════════════════════════════════════ */\n\n.rv-root { display: flex; flex-direction: column; gap: 20px; }\n\n/* ── Summary row ─────────────────────────────────────────────── */\n.rv-summary-row {\n  display: grid;\n  grid-template-columns: 260px 1fr;\n  gap: var(--space-2);\n  align-items: start;\n}\n@media (max-width: 900px) { .rv-summary-row { grid-template-columns: 1fr; } }\n\n/* Overall score card */\n.rv-overall-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 22px 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  box-shadow: var(--shadow-card);\n}\n.rv-overall-score {\n  font-size: 3.2rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  line-height: 1;\n}\n.rv-overall-stars { display: flex; gap: 3px; }\n.rv-big-star { font-size: 1.3rem; color: var(--border-strong); transition: color 150ms; }\n.rv-big-star.lit { color: var(--color-primary); }\n.rv-overall-label {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  margin-top: 4px;\n}\n.rv-overall-sub { font-size: 0.75rem; color: var(--text-muted); }\n\n/* Distribution bars */\n.rv-dist { width: 100%; margin-top: 12px; display: flex; flex-direction: column; gap: 5px; }\n.rv-dist-row { display: flex; align-items: center; gap: 6px; }\n.rv-dist-star { font-size: 0.72rem; color: var(--text-muted); width: 20px; text-align: right; flex-shrink: 0; }\n.rv-dist-bar-bg {\n  flex: 1;\n  height: 8px;\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-pill);\n  overflow: hidden;\n}\n.rv-dist-bar-fill {\n  height: 100%;\n  background: var(--color-primary);\n  border-radius: var(--radius-pill);\n  transition: width 600ms cubic-bezier(0.16,1,0.3,1);\n}\n.rv-dist-count { font-size: 0.72rem; color: var(--text-muted); width: 16px; flex-shrink: 0; }\n\n/* Per-category grid */\n.rv-cats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n}\n@media (max-width: 1100px) { .rv-cats-grid { grid-template-columns: repeat(2, 1fr); } }\n\n.rv-cat-card {\n  background: color-mix(in srgb, var(--rvc, var(--accent)) 9%, var(--bg-secondary));\n  border: 1px solid var(--border);\n  border-top: 4px solid var(--rvc, var(--accent));\n  border-radius: var(--radius-md);\n  padding: 16px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  box-shadow: var(--shadow-card);\n}\n.rv-cat-top { display: flex; align-items: center; gap: var(--space-1); }\n.rv-cat-icon { font-size: 1.2rem; }\n.rv-cat-label { font-size: 0.78rem; font-weight: 600; color: var(--text-muted); }\n.rv-cat-score {\n  font-size: 1.8rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  line-height: 1;\n}\n.rv-cat-bar-bg {\n  height: 6px;\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-pill);\n  overflow: hidden;\n}\n.rv-cat-bar-fill {\n  height: 100%;\n  background: var(--rvc, var(--accent));\n  border-radius: var(--radius-pill);\n  transition: width 600ms cubic-bezier(0.16,1,0.3,1);\n}\n.rv-cat-stars { display: flex; gap: 1px; }\n\n/* ── Filters ─────────────────────────────────────────────────── */\n.rv-filters {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.rv-filter-chips { display: flex; gap: 6px; flex-wrap: wrap; }\n.rv-filter-chip {\n  padding: 5px 14px;\n  border-radius: var(--radius-xl);\n  border: 1.5px solid var(--border);\n  background: var(--bg-secondary);\n  color: var(--text-muted);\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 160ms ease;\n}\n.rv-filter-chip:hover { border-color: var(--color-primary); color: var(--color-primary); }\n.rv-filter-chip.active {\n  background: var(--color-primary);\n  border-color: var(--color-primary);\n  color: var(--color-text-on-primary);\n}\n\n/* ── Review card ─────────────────────────────────────────────── */\n.rv-list { display: flex; flex-direction: column; gap: 10px; }\n\n.rv-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-left: 4px solid var(--band, var(--accent));\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n  transition: box-shadow 200ms ease;\n  box-shadow: var(--shadow-card);\n}\n.rv-card:hover { box-shadow: 0 4px 20px rgba(1, 13, 33,0.07); }\n.rv-card.open { box-shadow: 0 6px 28px rgba(1, 13, 33,0.1); }\n\n.rv-card-head {\n  width: 100%;\n  background: none;\n  border: none;\n  padding: 14px 18px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  gap: 12px;\n}\n.rv-card-head:hover { background: var(--bg-tertiary); }\n\n.rv-card-left { display: flex; align-items: center; gap: 12px; }\n.rv-customer-avatar {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  font-weight: 800;\n  color: var(--color-brand-white);\n  flex-shrink: 0;\n  opacity: 0.92;\n}\n.rv-customer-name {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 2px;\n}\n.rv-order-meta {\n  font-size: 0.74rem;\n  color: var(--text-muted);\n  margin: 0;\n}\n.rv-card-right { display: flex; align-items: center; gap: 10px; flex-shrink: 0; }\n.rv-avg-badge {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: var(--color-brand-white);\n  padding: 4px 10px;\n  border-radius: var(--radius-xl);\n}\n.rv-chevron { font-size: 0.7rem; color: var(--text-muted); }\n\n/* Quick category summary (always shown) */\n.rv-quick-cats {\n  display: flex;\n  gap: var(--space-2);\n  padding: 0 18px 14px;\n  flex-wrap: wrap;\n  border-bottom: 1px solid var(--border);\n}\n.rv-qcat { display: flex; align-items: center; gap: 6px; }\n.rv-qcat-icon { font-size: 1rem; }\n\n/* Mini stars */\n.rv-ministars { display: inline-flex; align-items: center; gap: 2px; }\n.rv-mstar { font-size: 0.85rem; color: var(--border-strong); }\n.rv-mstar.lit { color: var(--color-primary); }\n.rv-mstar-num {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--text-muted);\n  margin-left: 3px;\n}\n.rv-mstar-emoji { font-size: 0.85rem; margin-left: 2px; }\n\n/* Expanded detail */\n.rv-detail {\n  padding: 14px 18px 16px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  animation: dr-slide-up 220ms cubic-bezier(0.16,1,0.3,1) both;\n}\n@media (max-width: 700px) { .rv-detail { grid-template-columns: 1fr; } }\n\n.rv-detail-row {\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-left: 3px solid var(--rvc, var(--accent));\n  border-radius: var(--radius-sm);\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n}\n.rv-detail-cat { display: flex; align-items: center; gap: 10px; }\n.rv-detail-icon { font-size: 1.2rem; }\n.rv-detail-label {\n  font-size: 0.74rem;\n  font-weight: 700;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin: 0 0 4px;\n}\n.rv-detail-notes { display: flex; flex-direction: column; gap: 4px; padding-top: 4px; border-top: 1px dashed var(--border); }\n.rv-detail-note {\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n  margin: 0;\n  line-height: 1.45;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   NEW SITE HEADER — announcement bar + main navbar\n   ═══════════════════════════════════════════════════════════ */\n\n.site-header {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  box-shadow: 0 2px 12px rgba(1, 13, 33, 0.08);\n}\n\n/* ── Announcement bar ─────────────────────────────────────── */\n/* The promotional/flash-sale bar is navy in both themes. Stated directly\n   rather than via --text-primary (which is white in dark mode and only\n   looked right because of a separate dark override further down), and its\n   text uses the non-flipping on-navy tokens. */\n.ann-bar {\n  background: var(--color-brand-navy);\n  color: var(--color-on-navy-secondary);\n  /* Clears the status bar / display cutout. Android 15+ forces edge-to-edge\n     for targetSdk 35+, so the WebView really does start behind the clock and\n     battery -- without this the flash-sale text renders underneath them.\n     Two sources because they disagree by platform: iOS Safari and Android\n     WebView >=140 expose env(), while Capacitor's SystemBars plugin injects\n     --safe-area-inset-* onto <html> (its `insetsHandling: \"css\"` default).\n     max() takes whichever is real; on the desktop web both are 0 and this\n     resolves to no padding at all. */\n  padding-top: max(env(safe-area-inset-top, 0px), var(--safe-area-inset-top, 0px));\n}\n\n.ann-bar-inner {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 7px 24px;\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  gap: var(--space-2);\n}\n\n.ann-text {\n  grid-column: 2;\n  text-align: center;\n  font-size: 0.85rem;\n  font-weight: 500;\n  /* Sits on the always-navy flash bar. --bg-tertiary resolved to a 9% white\n     wash in dark mode, leaving this all but invisible. */\n  color: var(--color-on-navy);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin: 0;\n  letter-spacing: 0.1px;\n}\n\n.ann-right {\n  grid-column: 3;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n}\n\n/* ── On-device API connection screen ───────────────────────\n   Long-press the header logo in the packaged app. Styled from the brand\n   tokens like everything else rather than left unstyled as a debug panel,\n   because it is the one screen reached when the app cannot load anything --\n   it should not also look broken. */\n.devapi-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: rgba(1, 13, 33, 0.62);\n  /* Clears the status bar and the gesture bar on an edge-to-edge screen, so\n     neither the title nor the reset link sits under system chrome. */\n  padding-top: max(20px, env(safe-area-inset-top, 0px), var(--safe-area-inset-top, 0px));\n  padding-bottom: max(20px, env(safe-area-inset-bottom, 0px), var(--safe-area-inset-bottom, 0px));\n}\n.devapi-card {\n  width: 100%;\n  max-width: 400px;\n  max-height: 100%;\n  overflow-y: auto;\n  box-sizing: border-box;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-panel);\n  padding: 18px;\n}\n.devapi-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n.devapi-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n.devapi-close {\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  padding: 6px;\n  display: inline-flex;\n}\n.devapi-note {\n  margin: 0 0 14px;\n  font-size: 0.82rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n.devapi-facts { margin: 0 0 14px; }\n.devapi-facts > div {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 6px 0;\n  border-bottom: 1px solid var(--border);\n}\n.devapi-facts dt { font-size: 0.78rem; color: var(--text-secondary); }\n.devapi-facts dd {\n  margin: 0;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  text-align: right;\n  /* Addresses are unspaced strings, so without this a long one widens the\n     dialog instead of wrapping. */\n  word-break: break-all;\n}\n.devapi-label {\n  display: block;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin-bottom: 6px;\n}\n.devapi-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 11px 12px;\n  font-size: 0.9rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n.devapi-input:focus {\n  outline: none;\n  border-color: var(--color-secondary);\n}\n.devapi-msg {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  margin: 9px 0 0;\n  font-size: 0.78rem;\n  line-height: 1.45;\n}\n/* Only four hues exist, so neither state may rest on colour: each line also\n   carries its own icon (check versus warning triangle). */\n.devapi-good { color: var(--color-secondary-text); }\n/* Navy, not orange: orange on a light surface is 2.92:1 and cannot reach AA\n   at any size, so the failure state is carried by the warning triangle and\n   the wording instead of by hue. */\n.devapi-bad { color: var(--text-primary); }\n.devapi-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 16px;\n}\n.devapi-btn {\n  flex: 1;\n  padding: 11px 14px;\n  border-radius: var(--radius-sm);\n  border: none;\n  font-size: 0.86rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n.devapi-btn:disabled { opacity: 0.55; cursor: not-allowed; }\n.devapi-btn-test {\n  background: transparent;\n  border: 1px solid var(--color-secondary);\n  color: var(--color-secondary-text);\n}\n.devapi-btn-save {\n  background: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n}\n.devapi-reset {\n  display: block;\n  width: 100%;\n  margin-top: 10px;\n  padding: 8px;\n  background: none;\n  border: none;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n/* ── App-only flash-sale card ──────────────────────────────\n   Rendered in place of .ann-bar-inner inside the Capacitor shell. Sits on\n   the navy bar as a raised panel so the promotion reads as a card rather\n   than as part of the status-bar strip above it. Everything here is brand\n   navy/orange/blue/white -- the \"red\" price tag of a typical sale banner is\n   orange, which is the palette's promotional colour anyway. */\n/* The gradient lives on the bar rather than on the card so it runs the full\n   width and, critically, also fills the safe-area strip the bar reserves for\n   the status bar. Painting it on the card instead left the status-bar band a\n   flat navy that read as a seam above the promotion. */\n.is-native-app .ann-bar,\nhtml.m-installed .ann-bar {\n  background: linear-gradient(\n    135deg,\n    color-mix(in srgb, var(--color-brand-navy) 82%, var(--color-brand-blue)) 0%,\n    var(--color-brand-navy) 55%,\n    color-mix(in srgb, var(--color-brand-navy) 88%, var(--color-brand-blue)) 100%\n  );\n}\n\n/* Full-bleed band, not a floating card: no margin, no radius and no shadow,\n   so the promotion spans the whole header and meets the navbar directly.\n   An earlier version inset it by 8/12/10px with a 16px radius, which left\n   navy gutters down both sides and a visible gap above the navbar. */\n.ann-app-card {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  margin: 0;\n  padding: 9px 14px 11px;\n  /* Transparent so the bar's gradient shows through as one continuous\n     surface from the status bar down to the navbar edge. */\n  background: transparent;\n  border: none;\n  border-radius: 0;\n}\n\n/* Orange fill carries the promotion; the glyph on it must be navy, since\n   white on orange is 2.8:1 and fails AA. */\n.ann-app-badge {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border-radius: var(--radius-sm);\n  background: var(--color-primary);\n  color: var(--color-text-on-primary);\n}\n\n.ann-app-block {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-width: 0;\n}\n.ann-app-block-end { align-items: flex-end; text-align: right; }\n\n/* The four sizes below were picked when the root was 16px. The mobile layer\n   now sets 18px (see mobile/tokens.css), which pushed them up by an eighth\n   and left the two blocks fighting for the width: at 360px the divider had\n   already collapsed to its 12px minimum and a label was overflowing its box.\n   They are retuned here rather than scaled back with a wrapper, because these\n   classes only ever render inside the packaged app -- the website's\n   announcement strip uses .ann-bar-inner instead. */\n.ann-app-kicker {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.54rem;\n  font-weight: 700;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n  /* Fixed navy surface in both themes, so the non-flipping on-navy token --\n     --text-secondary would go navy-on-navy in light mode. */\n  color: var(--color-on-navy-secondary);\n  white-space: nowrap;\n}\n\n.ann-app-headline {\n  font-size: 0.76rem;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n  color: var(--color-brand-blue);\n  white-space: nowrap;\n}\n\n.ann-app-sub {\n  font-size: 0.6rem;\n  font-weight: 600;\n  color: var(--color-on-navy);\n  white-space: nowrap;\n}\n\n.ann-app-timer {\n  font-size: 0.58rem;\n  font-weight: 600;\n  color: var(--color-on-navy-muted);\n  white-space: nowrap;\n}\n\n/* Pushes the delivery block to the far edge and puts a hairline between the\n   two offers, so they never read as one run-on sentence. */\n.ann-app-rule {\n  flex: 1 0 auto;\n  align-self: stretch;\n  min-width: 11px;\n  border-right: 1px solid color-mix(in srgb, var(--color-brand-white) 17%, transparent);\n}\n\n/* Very narrow phones: the delivery block is the first thing to go, since the\n   discount and its countdown are what the banner exists for. */\n@media (max-width: 359px) {\n  .ann-app-rule,\n  .ann-app-block-end { display: none; }\n}\n\n.ann-countdown {\n  display: inline-block;\n  font-variant-numeric: tabular-nums;\n  font-weight: 700;\n  color: var(--color-primary);\n  letter-spacing: 0.3px;\n}\n\n/* The countdown is the whole point of this banner, so on narrow screens it\n   must never get clipped by the ellipsis above -- drop the redundant Sign In\n   button (the bottom nav's Account tab already covers it on mobile) and let\n   the text wrap onto two lines instead of truncating. */\n@media (max-width: 768px) {\n  .ann-bar-inner { grid-template-columns: 1fr; padding: 6px 14px; }\n  .ann-text {\n    grid-column: 1;\n    white-space: normal;\n    overflow: visible;\n    text-overflow: clip;\n    font-size: 0.74rem;\n    line-height: 1.4;\n  }\n  .ann-right { display: none; }\n}\n\n.ann-auth-btn {\n  background: none;\n  border: none;\n  color: var(--color-on-navy-secondary);\n  font-size: 0.84rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 8px;\n  border-radius: var(--radius-xs);\n  transition: color 150ms, background 150ms;\n  white-space: nowrap;\n}\n.ann-auth-btn:hover { color: var(--bg-tertiary); background: rgba(255,255,255,0.07); }\n\n/* ── Main navbar ──────────────────────────────────────────── */\n.main-navbar {\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border);\n}\n\n.main-navbar-inner {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 0 24px;\n  height: 64px;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n/* Logo */\n.nb-logo {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  flex-shrink: 0;\n  padding: 0;\n  text-decoration: none;\n}\n.nb-logo-icon {\n  font-size: 1.5rem;\n  width: 38px;\n  height: 38px;\n  background: linear-gradient(135deg, var(--accent), var(--accent-hover));\n  border-radius: var(--radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: transform 180ms var(--ease-spring);\n}\n.nb-logo:hover .nb-logo-icon { transform: scale(1.08); }\n.nb-logo-text-block {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  line-height: 1;\n}\n.nb-logo-name {\n  font-size: 1.36rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  letter-spacing: -0.5px;\n  white-space: nowrap;\n  /* The bag icon's artwork fills its box edge-to-edge, but a text line's box\n     includes descender space below the baseline (for the \"y\" here) that the\n     icon has no equivalent of -- centering the two as plain flex siblings\n     therefore reads as the text sitting low. Nudge it up to compensate. */\n  transform: translateY(-2px);\n}\n.nb-logo-tagline {\n  font-size: 0.58rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n  margin-top: 3px;\n}\n\n/* Category nav links */\n.nb-cat-nav {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  flex: 1;\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n.nb-cat-nav::-webkit-scrollbar { display: none; }\n\n.nb-cat-link {\n  background: none;\n  border: none;\n  /* Now an <a> rather than a <button> (crawlers only follow anchors), so the\n     UA's link underline has to be turned off to keep the nav looking the\n     same. Colour is already set explicitly just below. */\n  text-decoration: none;\n  padding: 8px 11px;\n  min-height: 44px;\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  border-radius: var(--radius-sm);\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  white-space: nowrap;\n  position: relative;\n  transition: color 150ms, background 150ms;\n}\n.nb-cat-link:hover {\n  color: var(--accent);\n  background: rgba(59, 130, 246, 0.06);\n}\n.nb-cat-link.active {\n  color: var(--accent);\n  font-weight: 700;\n  background: rgba(59, 130, 246, 0.06);\n}\n.nb-cat-icon {\n  font-size: 0.95rem;\n  line-height: 1;\n}\n\n.nb-cat-link.active::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  left: 8px;\n  right: 8px;\n  height: 2px;\n  background: var(--accent);\n  border-radius: var(--radius-xs) var(--radius-xs) 0 0;\n}\n\n/* Right icon actions */\n.nb-actions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  flex-shrink: 0;\n}\n\n.nb-icon {\n  background: none;\n  border: none;\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border-radius: var(--radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-secondary);\n  font-size: 1.15rem;\n  position: relative;\n  transition: color 150ms, background 150ms;\n}\n.nb-icon:hover {\n  color: var(--accent);\n  background: rgba(59, 130, 246, 0.07);\n}\n.nb-icon svg { flex-shrink: 0; pointer-events: none; }\n\n/* Reset cart-icon-btn overrides when inside new navbar */\n.nb-icon.cart-icon-btn { font-size: 1rem; padding: 0; }\n\n.nb-badge {\n  position: absolute;\n  top: 3px;\n  right: 3px;\n  background: var(--danger);\n  color: var(--color-text-on-primary);\n  border-radius: 50%;\n  min-width: 17px;\n  height: 17px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.62rem;\n  font-weight: 700;\n  pointer-events: none;\n  line-height: 1;\n}\n\n/* Expandable search row */\n.nb-search-row {\n  border-top: 1px solid var(--border);\n  padding: 10px 24px;\n  background: var(--bg-secondary);\n  animation: slideDown 180ms ease-out;\n}\n.nb-search-inner {\n  max-width: 1440px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: var(--bg-tertiary);\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 8px 14px;\n  transition: border-color 200ms, box-shadow 200ms, background 200ms;\n}\n.nb-search-inner:focus-within {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n  background: var(--bg-secondary);\n}\n.nb-search-icon {\n  color: var(--text-tertiary);\n  flex-shrink: 0;\n}\n.nb-search-input {\n  flex: 1;\n  border: none;\n  background: none;\n  font-size: 0.95rem;\n  color: var(--text-primary);\n  outline: none;\n}\n.nb-search-input::placeholder { color: var(--text-tertiary); }\n\n.nb-search-clear {\n  background: none;\n  border: none;\n  color: var(--text-tertiary);\n  cursor: pointer;\n  padding: 2px 6px;\n  border-radius: var(--radius-xs);\n  font-size: 0.82rem;\n  line-height: 1;\n  transition: color 120ms, background 120ms;\n}\n.nb-search-clear:hover { color: var(--text-primary); background: var(--border); }\n\n.nb-search-close-btn {\n  background: none;\n  border: 1.5px solid var(--border);\n  color: var(--text-secondary);\n  cursor: pointer;\n  padding: 5px 12px;\n  border-radius: var(--radius-xs);\n  font-size: 0.82rem;\n  font-weight: 500;\n  transition: all 150ms;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.nb-search-close-btn:hover {\n  background: var(--bg-tertiary);\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n/* ── Dark mode tweaks ─────────────────────────────────────── */\n:root[data-theme=\"dark\"] .ann-bar { background: var(--color-brand-navy); }\n:root[data-theme=\"dark\"] .ann-sel { border-color: rgba(1, 13, 33,0.15); }\n:root[data-theme=\"dark\"] .nb-cat-link:hover,\n:root[data-theme=\"dark\"] .nb-cat-link.active { background: color-mix(in srgb, var(--accent-secondary) 10%, transparent); }\n:root[data-theme=\"dark\"] .nb-icon:hover { color: var(--color-secondary); background: color-mix(in srgb, var(--accent-secondary) 10%, transparent); }\n:root[data-theme=\"dark\"] .user-dropdown-menu { background: var(--bg-secondary); }\n\n/* ═══════════════════════════════════════════════════════════\n   SubPageHeader — shared header for all inner pages\n   ═══════════════════════════════════════════════════════════ */\n.sub-page-header {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border);\n  box-shadow: 0 1px 8px rgba(1, 13, 33, 0.06);\n}\n\n.sub-page-header-inner {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 0 24px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-2);\n}\n\n.sub-page-header-flush .sub-page-header-inner {\n  padding: 0 20px;\n}\n@media (max-width: 640px) {\n  .sub-page-header-flush .sub-page-header-inner {\n    padding: 0 12px;\n  }\n}\n\n/* Left: logo + breadcrumb */\n.sph-left {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n  overflow: hidden;\n}\n\n.sph-logo-icon {\n  font-size: 1.4rem;\n  width: 34px;\n  height: 34px;\n  background: linear-gradient(135deg, var(--accent), var(--accent-hover));\n  border-radius: var(--radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.sph-logo-name {\n  font-size: 1.05rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  letter-spacing: -0.4px;\n  white-space: nowrap;\n}\n\n.sph-sep {\n  color: var(--text-tertiary);\n  font-size: 1rem;\n  user-select: none;\n}\n\n.sph-title {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Right: user name + theme toggle + back button */\n.sph-right {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n  flex-shrink: 0;\n}\n\n.sph-user {\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--text-secondary);\n  background: var(--bg-tertiary);\n  padding: 4px 10px;\n  border-radius: var(--radius-xl);\n  white-space: nowrap;\n}\n\n.sph-theme {\n  background: none;\n  border: none;\n  cursor: pointer;\n  width: 34px;\n  height: 34px;\n  border-radius: var(--radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n  color: var(--text-secondary);\n  transition: background 150ms;\n}\n.sph-theme:hover { background: var(--bg-tertiary); }\n\n.sph-back {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: 1.5px solid var(--border);\n  color: var(--text-primary);\n  font-size: 0.88rem;\n  font-weight: 600;\n  padding: 7px 14px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: background 150ms, border-color 150ms, color 150ms;\n  white-space: nowrap;\n}\n.sph-back:hover {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: var(--color-text-on-secondary);\n}\n.sph-back:hover svg { stroke: white; }\n.sph-back svg { transition: stroke 150ms; }\n\n.sph-mobile-user { display: none; }\n.sph-mobile-username { font-size: 1.05rem; font-weight: 800; color: var(--text-primary); }\n\n@media (max-width: 768px) {\n  /* On pages that opt in (mobileShowName), swap the logo for the\n     signed-in user's name + role instead of squeezing both into a\n     narrow header row. */\n  .sph-left.sph-mobile-name-mode .sph-logo-icon-wrap,\n  .sph-left.sph-mobile-name-mode .sph-logo-name,\n  .sph-left.sph-mobile-name-mode .sph-sep,\n  .sph-left.sph-mobile-name-mode .sph-title {\n    display: none;\n  }\n  .sph-left.sph-mobile-name-mode .sph-mobile-user {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  /* Avoid showing the name twice (it's already in sph-left now) */\n  .sph-left.sph-mobile-name-mode ~ .sph-right .sph-user { display: none; }\n\n  .sph-theme.sph-theme-hide-mobile { display: none; }\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Navbar \"More\" dropdown\n   ═══════════════════════════════════════════════════════════ */\n.nb-more-container {\n  position: relative;\n  padding-bottom: 10px;  /* bridges the gap so onMouseLeave doesn't fire mid-crossing */\n}\n\n.nb-more-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  padding: 8px 10px;\n  border-radius: var(--radius-sm);\n  transition: color 150ms, background 150ms;\n  white-space: nowrap;\n  height: 40px;\n}\n.nb-more-btn:hover,\n.nb-more-btn.open {\n  color: var(--accent);\n  background: rgba(59, 130, 246, 0.07);\n}\n.nb-more-caret {\n  flex-shrink: 0;\n  transition: transform 200ms var(--ease-in-out);\n}\n\n/* Dropdown panel */\n.nb-more-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  min-width: 240px;\n  box-shadow: 0 8px 28px rgba(1, 13, 33, 0.13);\n  z-index: 200;\n  overflow: hidden;\n  animation: slideDown 180ms ease-out;\n}\n\n.nb-more-heading {\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  color: var(--text-tertiary);\n  padding: 12px 18px 8px;\n  border-bottom: 1px solid var(--border);\n}\n\n.nb-more-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 13px 18px;\n  background: none;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  font-size: 0.92rem;\n  font-weight: 500;\n  color: var(--text-primary);\n  transition: background 130ms, color 130ms;\n}\n.nb-more-item:hover {\n  background: var(--bg-tertiary);\n  color: var(--accent);\n}\n.nb-more-item:hover .nb-more-icon svg {\n  stroke: var(--accent);\n}\n.nb-more-item:last-child {\n  border-radius: 0 0 var(--radius-sm) var(--radius-sm);\n}\n\n.nb-more-icon {\n  width: 38px;\n  height: 38px;\n  border-radius: var(--radius-sm);\n  background: var(--bg-tertiary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: background 130ms;\n}\n.nb-more-item:hover .nb-more-icon {\n  background: rgba(59, 130, 246, 0.1);\n}\n.nb-more-icon svg {\n  color: var(--text-secondary);\n  transition: stroke 130ms;\n}\n\n:root[data-theme=\"dark\"] .nb-more-menu {\n  box-shadow: 0 8px 28px rgba(1, 13, 33, 0.4);\n}\n\n/* ── Auth modal tabs ─────────────────────────────────────── */\n.modal-auth-tabs {\n  display: flex;\n  border-bottom: 2px solid var(--border);\n  margin: 24px 28px 0;\n  gap: 0;\n}\n\n.modal-auth-tab {\n  flex: 1;\n  background: none;\n  border: none;\n  padding: 12px 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  transition: color 150ms, border-color 150ms;\n}\n\n.modal-auth-tab:hover { color: var(--accent); }\n\n.modal-auth-tab.active {\n  color: var(--accent);\n  border-bottom-color: var(--accent);\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   SELLER MANAGEMENT MODULE\n═══════════════════════════════════════════════════════════════ */\n\n.sl-root {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  min-height: 100%;\n}\n\n/* Sub-navigation */\n.sl-subnav {\n  display: flex;\n  gap: 4px;\n  padding: 0 0 20px;\n  flex-wrap: wrap;\n}\n.sl-subnav-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 14px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 150ms;\n  position: relative;\n}\n.sl-subnav-btn:hover {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  border-color: var(--accent);\n}\n.sl-subnav-btn.active {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: var(--color-text-on-secondary);\n}\n.sl-subnav-badge {\n  background: var(--danger);\n  color: var(--color-text-on-primary);\n  font-size: 0.7rem;\n  font-weight: 700;\n  padding: 1px 5px;\n  border-radius: var(--radius-sm);\n  min-width: 18px;\n  text-align: center;\n  line-height: 1.5;\n}\n\n/* Page wrapper */\n.sl-page {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* ── Stats Grid ── */\n.sl-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 14px;\n}\n@media (max-width: 1200px) { .sl-stats-grid { grid-template-columns: repeat(3, 1fr); } }\n@media (max-width: 768px)  { .sl-stats-grid { grid-template-columns: repeat(2, 1fr); } }\n\n.sl-stat-card {\n  background: color-mix(in srgb, var(--sc, var(--color-secondary)) 9%, var(--bg-secondary));\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: var(--space-2);\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  border-top: 4px solid var(--sc, var(--color-secondary));\n  box-shadow: var(--shadow-card);\n}\n.sl-stat-icon {\n  font-size: 1.5rem;\n  line-height: 1;\n  flex-shrink: 0;\n}\n.sl-stat-body { flex: 1; min-width: 0; }\n.sl-stat-label {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  margin: 0 0 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.sl-stat-value {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n.sl-stat-sub {\n  font-size: 0.72rem;\n  color: var(--text-secondary);\n  margin: 2px 0 0;\n}\n.sl-stat-trend {\n  font-size: 0.72rem;\n  font-weight: 600;\n  margin: 3px 0 0;\n}\n\n/* ── Charts ── */\n.sl-charts-row {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: var(--space-2);\n}\n@media (max-width: 900px) { .sl-charts-row { grid-template-columns: 1fr; } }\n\n.sl-chart-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 18px;\n  box-shadow: var(--shadow-card);\n}\n.sl-chart-wide { grid-column: span 1; }\n.sl-chart-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 14px;\n}\n.sl-chart-title {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n}\n.sl-chart-wide .sl-chart-title {\n  font-size: 1.3rem;\n  font-weight: 700;\n}\n.sl-chart-period {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-xl);\n  padding: 6px 14px;\n}\n\n.sl-status-mini-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 14px;\n  margin-bottom: 20px;\n}\n@media (max-width: 700px) { .sl-status-mini-row { grid-template-columns: 1fr; } }\n\n.sl-status-mini {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  background: color-mix(in srgb, var(--smc, var(--accent)) 9%, var(--bg-secondary));\n  border: 1px solid color-mix(in srgb, var(--smc, var(--accent)) 22%, var(--border));\n  border-radius: var(--radius-lg);\n  padding: 16px 18px;\n}\n\n.sl-status-mini-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: var(--smc, var(--accent));\n  color: var(--color-brand-white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.2rem;\n  font-weight: 800;\n  flex-shrink: 0;\n}\n\n.sl-status-mini-label {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 2px;\n}\n\n.sl-status-mini-value {\n  font-size: 1.6rem;\n  font-weight: 800;\n  color: var(--smc, var(--accent));\n  margin: 0;\n  line-height: 1;\n}\n.sl-chart-tip {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 8px 12px;\n  font-size: 0.82rem;\n  box-shadow: var(--shadow-card);\n}\n.sl-chart-tip-label {\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 4px;\n}\n\n/* ── Card ── */\n.sl-card {\n  background: var(--bg-primary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  box-shadow: 0 1px 6px rgba(1, 13, 33,0.06);\n}\n.sl-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--border);\n}\n.sl-card-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n/* ── Table ── */\n.sl-table-wrap {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.sl-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.86rem;\n}\n.sl-table th {\n  padding: 11px 20px;\n  text-align: left;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: var(--text-secondary);\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border);\n  white-space: nowrap;\n}\n.sl-table td {\n  padding: 14px 20px;\n  border-bottom: 1px solid var(--border);\n  color: var(--text-primary);\n  vertical-align: middle;\n}\n.sl-table tbody tr:last-child td { border-bottom: none; }\n.sl-tr-hover { transition: background 120ms; }\n.sl-tr-hover:hover td { background: var(--bg-secondary); }\n\n/* ── Seller cell ── */\n.sl-seller-cell {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.sl-avatar {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n  background: linear-gradient(135deg, rgba(59, 130, 246,0.12), rgba(59, 130, 246,0.04));\n  border: 1px solid rgba(59, 130, 246,0.18);\n  border-radius: var(--radius-sm);\n  flex-shrink: 0;\n}\n.sl-avatar-lg {\n  width: 52px;\n  height: 52px;\n  font-size: 1.7rem;\n  border-radius: var(--radius-sm);\n}\n\n/* An uploaded logo fills the frame the emoji would otherwise sit in. */\n.sl-avatar-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* Defence in depth. These boxes are a fixed 40/52/64px but had no overflow\n   rule, so any content wider than the box simply painted over whatever sat\n   beside it -- which is how an /uploads path rendered as text came to spill\n   across an entire seller application card. Clipping here means the worst a\n   bad value can do now is look wrong inside its own frame. */\n.sl-avatar,\n.sl-avatar-lg,\n.sl-profile-avatar {\n  overflow: hidden;\n}\n.sl-seller-name {\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n  line-height: 1.3;\n}\n.sl-seller-sub {\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n  margin: 2px 0 0;\n}\n.sl-seller-bio {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  margin: 4px 0 0;\n  max-width: 340px;\n}\n\n/* ── Badges / chips ── */\n.sl-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 10px;\n  border-radius: var(--radius-xl);\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--bc, var(--text-muted));\n  background: color-mix(in srgb, var(--bc, var(--text-muted)) 12%, transparent);\n  border: 1px solid color-mix(in srgb, var(--bc, var(--text-muted)) 25%, transparent);\n  white-space: nowrap;\n}\n.sl-badge::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--bc, var(--text-muted));\n  flex-shrink: 0;\n}\n.sl-verified {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: var(--radius-xl);\n  font-size: 0.72rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.sl-cat-chip {\n  display: inline-flex;\n  padding: 4px 10px;\n  border-radius: var(--radius-xl);\n  font-size: 0.76rem;\n  font-weight: 600;\n  background: rgba(59, 130, 246,0.1);\n  color: var(--color-secondary);\n  border: 1px solid rgba(59, 130, 246,0.2);\n  white-space: nowrap;\n}\n.sl-stars {\n  display: inline-flex;\n  align-items: center;\n  gap: 1px;\n  font-size: 0.85rem;\n}\n\n/* Numbers and color helpers */\n.sl-num    { text-align: right; font-variant-numeric: tabular-nums; font-size: 0.9rem; }\n/* Right-align numeric-column headers so the label sits over its right-aligned\n   values (default .sl-table th is left-aligned, which left the header text\n   floating to the left of the numbers). */\n.sl-table th.sl-num { text-align: right; font-size: 0.72rem; }\n.sl-positive  { color: var(--color-secondary); font-weight: 700; }\n.sl-info { color: var(--color-secondary); font-weight: 700; }\n[data-theme='dark'] .sl-positive  { color: var(--color-secondary); }\n[data-theme='dark'] .sl-info { color: var(--color-secondary); }\n.sl-yellow { color: var(--color-primary); font-weight: 600; }\n.sl-orange { color: var(--color-primary); font-weight: 600; }\n.sl-muted  { color: var(--text-secondary); }\n.sl-empty  { text-align: center; color: var(--text-secondary); font-size: 0.88rem; padding: 40px 0; }\n\n/* ── Filter bar ── */\n.sl-filter-bar {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.sl-search-wrap {\n  flex: 1;\n  min-width: 200px;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.sl-search-ico {\n  position: absolute;\n  left: 10px;\n  color: var(--text-secondary);\n  pointer-events: none;\n}\n.sl-search-input {\n  width: 100%;\n  padding: 8px 12px 8px 34px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  color: var(--text-primary);\n  font-size: 0.85rem;\n  outline: none;\n  transition: border-color 150ms;\n}\n.sl-search-input:focus { border-color: var(--accent); }\n.sl-search-input::placeholder { color: var(--text-secondary); }\n.sl-filter-chips { display: flex; gap: 6px; }\n.sl-chip {\n  padding: 6px 12px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xl);\n  color: var(--text-secondary);\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 150ms;\n}\n.sl-chip:hover { border-color: var(--accent); color: var(--accent); }\n.sl-chip.active { background: var(--accent); border-color: var(--accent); color: var(--color-text-on-secondary); }\n.sl-select {\n  padding: 7px 10px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  color: var(--text-primary);\n  font-size: 0.82rem;\n  cursor: pointer;\n  outline: none;\n}\n.sl-count-label {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n/* ── Actions ── */\n.sl-action-row { display: flex; gap: 6px; }\n.sl-action-btn {\n  padding: 5px 10px;\n  border-radius: var(--radius-xs);\n  font-size: 0.77rem;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  transition: opacity 150ms, transform 80ms;\n}\n.sl-action-btn:hover { opacity: 0.85; transform: translateY(-1px); }\n.sl-btn-view { background: rgba(59, 130, 246,0.15); color: var(--color-secondary); }\n.sl-btn-ok   { background: rgba(59, 130, 246,0.15);  color: var(--color-secondary); }\n.sl-btn-warn { background: rgba(255, 103, 0,0.15);   color: var(--color-primary); }\n\n.sl-link-btn {\n  background: none;\n  border: none;\n  color: var(--accent);\n  font-size: 0.85rem;\n  font-weight: 700;\n  cursor: pointer;\n  padding: 6px 12px;\n  border-radius: var(--radius-sm);\n  transition: background 150ms;\n}\n.sl-link-btn:hover { background: rgba(59, 130, 246,0.08); text-decoration: none; }\n\n/* Primary / danger / ghost buttons */\n.sl-btn-primary {\n  padding: 8px 16px;\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  border: none;\n  border-radius: var(--radius-sm);\n  font-size: 0.84rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 150ms, transform 80ms;\n  white-space: nowrap;\n}\n.sl-btn-primary:hover { opacity: 0.88; transform: translateY(-1px); }\n.sl-btn-danger {\n  padding: 8px 16px;\n  background: rgba(255, 103, 0,0.15);\n  color: var(--color-primary);\n  border: 1px solid rgba(255, 103, 0,0.3);\n  border-radius: var(--radius-sm);\n  font-size: 0.84rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 150ms;\n}\n.sl-btn-danger:hover { background: rgba(255, 103, 0,0.25); }\n.sl-btn-ghost {\n  padding: 8px 16px;\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  font-size: 0.82rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 150ms;\n  white-space: nowrap;\n}\n.sl-btn-ghost:hover { background: var(--bg-secondary); color: var(--text-primary); border-color: var(--accent); }\n.sl-btn-warn { background: rgba(255, 103, 0,0.15); color: var(--color-primary); border: none; }\n.sl-btn-ok   { background: rgba(59, 130, 246,0.15); color: var(--color-secondary); border: none; }\n.sl-btn-lg { padding: 10px 20px; font-size: 0.9rem; }\n\n/* ── Seller Profile ── */\n.sl-profile-header {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n  box-shadow: var(--shadow-card);\n}\n.sl-back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 12px 20px;\n  background: none;\n  border: none;\n  border-bottom: 1px solid var(--border);\n  color: var(--accent);\n  font-size: 0.84rem;\n  font-weight: 500;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n}\n.sl-back-btn:hover { background: var(--bg-tertiary); }\n.sl-profile-hero {\n  display: flex;\n  gap: 20px;\n  padding: 20px;\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\n.sl-profile-avatar {\n  width: 64px;\n  height: 64px;\n  font-size: 2.2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-md);\n  flex-shrink: 0;\n}\n.sl-profile-info { flex: 1; min-width: 200px; }\n.sl-profile-name-row {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n  flex-wrap: wrap;\n  margin-bottom: 6px;\n}\n.sl-profile-store {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n.sl-profile-owner {\n  font-size: 0.82rem;\n  color: var(--text-secondary);\n  margin: 0 0 4px;\n}\n.sl-profile-meta {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  margin: 0 0 6px;\n}\n.sl-profile-bio {\n  font-size: 0.84rem;\n  color: var(--text-secondary);\n  margin: 0;\n}\n.sl-profile-actions {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  flex-shrink: 0;\n  min-width: 160px;\n}\n.sl-profile-stats {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  border-top: 1px solid var(--border);\n}\n@media (max-width: 900px) { .sl-profile-stats { grid-template-columns: repeat(3, 1fr); } }\n.sl-pstat {\n  padding: 14px 16px;\n  text-align: center;\n  border-right: 1px solid var(--border);\n}\n.sl-pstat:last-child { border-right: none; }\n.sl-pstat-val {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n.sl-pstat-label {\n  font-size: 0.72rem;\n  color: var(--text-secondary);\n  margin: 2px 0 0;\n}\n\n/* Profile sub-tabs */\n.sl-profile-tabs {\n  display: flex;\n  gap: 4px;\n  border-bottom: 2px solid var(--border);\n  padding: 0;\n  flex-wrap: wrap;\n}\n.sl-profile-tab {\n  padding: 10px 18px;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  color: var(--text-secondary);\n  font-size: 0.86rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: color 150ms, border-color 150ms;\n  white-space: nowrap;\n}\n.sl-profile-tab:hover { color: var(--text-primary); }\n.sl-profile-tab.active { color: var(--accent); border-bottom-color: var(--accent); font-weight: 600; }\n\n/* Category performance bars */\n.sl-cat-perf { display: flex; flex-direction: column; gap: 12px; padding: 4px 0; }\n.sl-cat-row  { display: flex; align-items: center; gap: 10px; }\n.sl-cat-name { font-size: 0.8rem; color: var(--text-secondary); width: 80px; flex-shrink: 0; }\n.sl-cat-bar-wrap { flex: 1; height: 6px; background: var(--bg-tertiary); border-radius: var(--radius-xs); overflow: hidden; }\n.sl-cat-bar { height: 100%; border-radius: var(--radius-xs); transition: width 600ms ease; }\n.sl-cat-val { font-size: 0.78rem; color: var(--text-secondary); width: 60px; text-align: right; flex-shrink: 0; }\n\n/* Documents */\n.sl-docs-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 14px;\n  padding: var(--space-2);\n}\n@media (max-width: 700px) { .sl-docs-grid { grid-template-columns: 1fr; } }\n.sl-doc-card {\n  background: var(--bg-tertiary);\n  border: 1px solid var(--ds, var(--border));\n  border-radius: var(--radius-sm);\n  padding: var(--space-2);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  box-shadow: var(--shadow-card);\n}\n.sl-doc-icon { font-size: 1.8rem; line-height: 1; }\n.sl-doc-info { flex: 1; }\n.sl-doc-name { font-size: 0.86rem; font-weight: 600; color: var(--text-primary); margin: 0 0 2px; }\n.sl-doc-date { font-size: 0.75rem; color: var(--text-secondary); margin: 0; }\n.sl-doc-actions { display: flex; gap: 6px; }\n\n/* Approval */\n.sl-approval-banner {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: 20px;\n  background: linear-gradient(135deg, rgba(255, 103, 0,0.15), rgba(255, 103, 0,0.1));\n  border: 1px solid rgba(255, 103, 0,0.3);\n  border-radius: var(--radius-sm);\n}\n.sl-approval-count {\n  font-size: 2.5rem;\n  font-weight: 800;\n  color: var(--color-primary);\n  line-height: 1;\n}\n.sl-approval-title { font-size: 1rem; font-weight: 700; color: var(--text-primary); margin: 0; }\n.sl-approval-sub   { font-size: 0.82rem; color: var(--text-secondary); margin: 2px 0 0; }\n\n.sl-approval-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 20px;\n  display: grid;\n  grid-template-columns: 1fr auto auto;\n  gap: 20px;\n  align-items: start;\n  box-shadow: var(--shadow-card);\n}\n@media (max-width: 800px) { .sl-approval-card { grid-template-columns: 1fr; \n  box-shadow: var(--shadow-card);\n} }\n.sl-approval-left { display: flex; gap: 14px; align-items: flex-start; }\n.sl-approval-docs { display: flex; flex-direction: column; gap: var(--space-1); min-width: 200px; }\n.sl-approval-doc-title { font-size: 0.78rem; font-weight: 600; color: var(--text-secondary); text-transform: uppercase; letter-spacing: 0.05em; margin: 0 0 2px; }\n.sl-approval-doc-row { display: flex; align-items: center; gap: var(--space-1); font-size: 0.82rem; }\n.sl-approval-actions { display: flex; flex-direction: column; gap: var(--space-1); min-width: 160px; }\n\n/* Approval tabs (Pending / Waitlist / Rejected) */\n.sl-approval-tabs {\n  display: flex;\n  gap: 6px;\n}\n.sl-approval-tab {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n  padding: 8px 18px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  color: var(--text-secondary);\n  font-size: 0.84rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 150ms;\n}\n.sl-approval-tab:hover { border-color: var(--tc, var(--accent)); color: var(--text-primary); }\n.sl-approval-tab.active { background: color-mix(in srgb, var(--tc, var(--accent)) 12%, transparent); border-color: var(--tc, var(--accent)); color: var(--tc, var(--accent)); font-weight: 600; }\n.sl-approval-tab-badge { font-size: 0.7rem; font-weight: 700; color: var(--color-brand-white); padding: 1px 6px; border-radius: var(--radius-sm); }\n\n/* Waitlist button */\n.sl-btn-waitlist {\n  padding: 8px 16px;\n  background: rgba(59, 130, 246,0.15);\n  color: var(--color-secondary);\n  border: 1px solid rgba(59, 130, 246,0.3);\n  border-radius: var(--radius-sm);\n  font-size: 0.84rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 150ms;\n  white-space: nowrap;\n}\n.sl-btn-waitlist:hover { background: rgba(59, 130, 246,0.25); }\n\n/* ═══════════════════════════════════════════════════════════════\n   SELLER REGISTRATION FORM\n═══════════════════════════════════════════════════════════════ */\n\n.sr-page {\n  min-height: 100vh;\n  background: var(--bg-primary);\n  display: flex;\n  flex-direction: column;\n}\n.sr-container {\n  max-width: 1440px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 32px 24px 60px;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n  box-sizing: border-box;\n}\n@media (max-width: 640px) {\n  .sr-container { padding: 24px 12px 48px; }\n}\n\n/* Header */\n.sr-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-card);\n}\n.sr-header-brand { display: flex; align-items: center; gap: 12px; }\n.sr-header-logo  { font-size: 1.8rem; line-height: 1; }\n.sr-header-store { font-weight: 700; color: var(--text-primary); margin: 0; font-size: 1rem; }\n.sr-header-sub   { font-size: 0.78rem; color: var(--text-secondary); margin: 0; }\n.sr-close-btn {\n  padding: 7px 14px;\n  background: none;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  color: var(--text-secondary);\n  font-size: 0.82rem;\n  cursor: pointer;\n  transition: all 150ms;\n}\n.sr-close-btn:hover { border-color: var(--color-primary); color: var(--color-primary); }\n\n/* Progress */\n.sr-progress-wrap { display: flex; flex-direction: column; gap: 12px; }\n.sr-progress-bar-bg {\n  height: 5px;\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-xs);\n  overflow: hidden;\n}\n.sr-progress-bar-fill {\n  height: 100%;\n  background: var(--accent);\n  border-radius: var(--radius-xs);\n  transition: width 400ms ease;\n}\n.sr-progress-steps {\n  display: flex;\n  justify-content: space-between;\n  gap: 4px;\n}\n.sr-progress-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  flex: 1;\n  opacity: 0.4;\n  transition: opacity 200ms;\n}\n.sr-progress-step.active, .sr-progress-step.done { opacity: 1; }\n.sr-progress-dot {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  font-weight: 700;\n  background: var(--bg-secondary);\n  border: 2px solid var(--border);\n  color: var(--text-secondary);\n  transition: all 200ms;\n}\n.sr-progress-step.active .sr-progress-dot {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: var(--color-text-on-secondary);\n}\n.sr-progress-step.done .sr-progress-dot {\n  background: var(--color-secondary);\n  border-color: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n}\n.sr-progress-label {\n  font-size: 0.68rem;\n  color: var(--text-secondary);\n  text-align: center;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n@media (max-width: 600px) { .sr-progress-label { display: none; } }\n\n/* Card */\n.sr-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  box-shadow: var(--shadow-card);\n}\n.sr-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--border);\n  background: var(--bg-tertiary);\n}\n.sr-card-title {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n.sr-step-count { font-size: 0.8rem; color: var(--text-secondary); }\n\n/* Step body */\n.sr-step-body { padding: var(--space-3); display: flex; flex-direction: column; gap: 18px; }\n.sr-step-intro { font-size: 0.88rem; color: var(--text-secondary); margin: 0; }\n\n/* Fields */\n.sr-field { display: flex; flex-direction: column; gap: 5px; }\n.sr-label { font-size: 0.83rem; font-weight: 600; color: var(--text-primary); }\n.sr-req   { color: var(--color-primary); margin-left: 3px; }\n.sr-hint  { font-size: 0.76rem; color: var(--text-secondary); margin: 0; }\n.sr-field-err { font-size: 0.76rem; color: var(--color-primary); margin: 0; }\n.sr-char-count { font-size: 0.72rem; color: var(--text-secondary); text-align: right; margin: 2px 0 0; }\n\n.sr-input, .sr-select, .sr-textarea {\n  padding: 10px 13px;\n  background: var(--bg-primary);\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  color: var(--text-primary);\n  font-size: 0.88rem;\n  outline: none;\n  transition: border-color 150ms, box-shadow 150ms;\n  width: 100%;\n  box-sizing: border-box;\n  font-family: inherit;\n}\n.sr-input:focus, .sr-select:focus, .sr-textarea:focus {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246,0.12);\n}\n.sr-input.err, .sr-select.err, .sr-textarea.err { border-color: var(--color-primary); }\n.sr-input::placeholder, .sr-textarea::placeholder { color: var(--text-secondary); opacity: 0.65; }\n.sr-textarea { resize: vertical; min-height: 100px; }\n.sr-select { cursor: pointer; appearance: none; background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\"); background-repeat: no-repeat; background-position: right 10px center; padding-right: 34px; }\n/* Seller signup is a five-field form on a phone, each field 38px tall.\n   Deliberately not applied to .sr-textarea, which sizes from its rows. */\n@media (max-width: 768px) {\n  .sr-input, .sr-select { min-height: 44px; }\n}\n\n/* Seller application: clear light-blue form definition. */\n.sr-header,\n.sr-card {\n  border: 1.5px solid var(--color-secondary-soft);\n}\n.sr-card-header { border-bottom-color: var(--color-secondary-soft); }\n.sr-input,\n.sr-select,\n.sr-textarea {\n  border-color: var(--color-secondary);\n  background: var(--bg-secondary);\n}\n.sr-input:hover,\n.sr-select:hover,\n.sr-textarea:hover { border-color: var(--color-secondary); }\n.sr-input:focus,\n.sr-select:focus,\n.sr-textarea:focus {\n  border-color: var(--color-secondary-hover);\n  box-shadow: 0 0 0 3px rgba(59,130,246,0.16);\n}\n.sr-radio-card,\n.sr-payout-card,\n.sr-review-section,\n.sr-check-row {\n  border-color: var(--color-secondary-soft);\n}\n.sr-header-logo {\n  width: 42px;\n  height: 42px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border-radius: 9px;\n}\n.sr-header-logo img { width: 40px !important; height: 40px !important; object-fit: contain; }\n.sr-header-sub { white-space: nowrap; font-size: 0.7rem; }\n\n.sr-logo-upload {\n  min-height: 82px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px;\n  border: 1.5px dashed var(--color-secondary);\n  border-radius: 10px;\n  background: color-mix(in srgb, var(--color-secondary) 5%, var(--bg-secondary));\n}\n.sr-logo-preview {\n  width: 62px;\n  height: 62px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 62px;\n  overflow: hidden;\n  color: var(--color-secondary);\n  background: var(--bg-primary);\n  border: 1px solid var(--color-secondary-soft);\n  border-radius: 12px;\n}\n.sr-logo-preview img { width: 100%; height: 100%; object-fit: cover; }\n.sr-logo-upload-actions { display: flex; align-items: center; flex-wrap: wrap; gap: 7px; min-width: 0; }\n.sr-logo-upload-btn,\n.sr-logo-remove-btn {\n  min-height: 34px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 6px 11px;\n  border-radius: 8px;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.sr-logo-upload-btn { color: var(--color-text-on-secondary); background: var(--color-secondary-hover); border: 1px solid var(--color-secondary-hover); }\n.sr-logo-upload-btn.uploading { opacity: 0.65; cursor: wait; }\n.sr-logo-remove-btn { color: var(--color-primary); background: transparent; border: 1px solid var(--color-primary); }\n.sr-logo-upload-actions .sr-field-err { flex-basis: 100%; }\n\n@media (max-width: 520px) {\n  .sr-logo-upload { align-items: flex-start; }\n  .sr-header-sub { font-size: 0.62rem; }\n}\n\n.sr-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }\n@media (max-width: 560px) { .sr-grid-2 { grid-template-columns: 1fr; } }\n\n/* Avatar picker */\n.sr-avatar-grid { display: flex; flex-wrap: wrap; gap: 6px; }\n.sr-avatar-btn {\n  width: 36px;\n  height: 36px;\n  font-size: 1.2rem;\n  background: var(--bg-primary);\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: all 150ms;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.sr-avatar-btn:hover { border-color: var(--accent); transform: scale(1.1); }\n.sr-avatar-btn.selected { border-color: var(--accent); background: rgba(59, 130, 246,0.12); }\n\n/* Radio cards */\n.sr-radio-group { display: flex; flex-direction: column; gap: 10px; }\n.sr-radio-card {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 16px;\n  background: var(--bg-primary);\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: all 150ms;\n}\n.sr-radio-card:hover { border-color: var(--accent); }\n.sr-radio-card.selected { border-color: var(--accent); background: rgba(59, 130, 246,0.07); }\n.sr-radio-input { display: none; }\n.sr-radio-icon  { font-size: 1.4rem; flex-shrink: 0; }\n.sr-radio-label { font-size: 0.88rem; font-weight: 600; color: var(--text-primary); margin: 0; }\n.sr-radio-desc  { font-size: 0.76rem; color: var(--text-secondary); margin: 2px 0 0; }\n\n/* Payout method cards */\n.sr-payout-methods { display: flex; gap: 10px; flex-wrap: wrap; }\n.sr-payout-card {\n  flex: 1;\n  min-width: 100px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-1);\n  padding: 16px 12px;\n  background: var(--bg-primary);\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: all 150ms;\n}\n.sr-payout-card:hover { border-color: var(--accent); }\n.sr-payout-card.selected { border-color: var(--accent); background: rgba(59, 130, 246,0.07); }\n.sr-payout-icon  { font-size: 1.6rem; }\n.sr-payout-label { font-size: 0.82rem; font-weight: 600; color: var(--text-primary); }\n\n/* Info box */\n.sr-info-box {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  padding: 12px 16px;\n  background: rgba(59, 130, 246,0.08);\n  border: 1px solid rgba(59, 130, 246,0.2);\n  border-radius: var(--radius-sm);\n  font-size: 0.83rem;\n  color: var(--text-secondary);\n  line-height: 1.5;\n}\n.sr-info-stripe { background: rgba(255, 103, 0,0.08); border-color: rgba(255, 103, 0,0.2); }\n.sr-info-icon { font-size: 1rem; flex-shrink: 0; margin-top: 1px; }\n\n/* Commission box */\n.sr-commission-box {\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n  box-shadow: var(--shadow-card);\n}\n.sr-commission-header {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n  padding: 12px 16px;\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  border-bottom: 1px solid var(--border);\n}\n.sr-commission-rows { display: flex; flex-direction: column; }\n.sr-commission-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 16px;\n  font-size: 0.84rem;\n  border-bottom: 1px solid var(--border);\n}\n.sr-commission-row:last-child { border-bottom: none; }\n.sr-commission-row span { color: var(--text-secondary); }\n.sr-commission-row strong { color: var(--text-primary); }\n\n/* Review section */\n.sr-review-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }\n@media (max-width: 560px) { .sr-review-grid { grid-template-columns: 1fr; } }\n.sr-review-section {\n  background: var(--bg-primary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n}\n.sr-review-section-title {\n  padding: 10px 14px;\n  font-size: 0.76rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--text-secondary);\n  background: var(--bg-tertiary);\n  border-bottom: 1px solid var(--border);\n  margin: 0;\n}\n.sr-review-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 8px 14px;\n  font-size: 0.82rem;\n  border-bottom: 1px solid var(--border);\n}\n.sr-review-row:last-child { border-bottom: none; }\n.sr-review-label { color: var(--text-secondary); flex-shrink: 0; }\n.sr-review-val   { color: var(--text-primary); font-weight: 500; text-align: right; word-break: break-all; }\n\n/* Agreements */\n.sr-agreements { display: flex; flex-direction: column; gap: 10px; }\n.sr-check-row {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  cursor: pointer;\n  font-size: 0.84rem;\n  color: var(--text-primary);\n  line-height: 1.5;\n}\n.sr-check-row.err { color: var(--color-primary); }\n.sr-checkbox {\n  width: 17px;\n  height: 17px;\n  flex-shrink: 0;\n  margin-top: 2px;\n  accent-color: var(--accent);\n  cursor: pointer;\n}\n.sr-link { color: var(--accent); text-decoration: underline; cursor: pointer; }\n\n/* Footer nav */\n.sr-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  border-top: 1px solid var(--border);\n  background: var(--bg-tertiary);\n}\n.sr-btn-back {\n  padding: 10px 20px;\n  background: none;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  color: var(--text-secondary);\n  font-size: 0.88rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 150ms;\n}\n.sr-btn-back:hover { border-color: var(--accent); color: var(--text-primary); }\n.sr-btn-next {\n  padding: 10px 28px;\n  background: var(--accent);\n  border: none;\n  border-radius: var(--radius-sm);\n  color: var(--color-text-on-secondary);\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 150ms, transform 80ms;\n}\n.sr-btn-next:hover { opacity: 0.88; transform: translateY(-1px); }\n.sr-btn-submit {\n  padding: 10px 28px;\n  background: linear-gradient(135deg, var(--color-secondary), color-mix(in srgb, var(--color-secondary) 80%, var(--color-brand-navy)));\n  border: none;\n  border-radius: var(--radius-sm);\n  color: var(--color-brand-white);\n  font-size: 0.9rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: opacity 150ms, transform 80ms;\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n}\n.sr-btn-submit:hover:not(:disabled) { opacity: 0.88; transform: translateY(-1px); }\n.sr-btn-submit:disabled { opacity: 0.6; cursor: not-allowed; }\n.sr-spinner { display: inline-block; animation: sr-spin 0.8s linear infinite; }\n@keyframes sr-spin { to { transform: rotate(360deg); } }\n\n/* Success screen */\n.sr-success {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 48px 24px;\n  gap: 20px;\n  max-width: 560px;\n  margin: 0 auto;\n}\n.sr-success-icon { font-size: 4rem; }\n.sr-success-title { font-size: 1.6rem; font-weight: 800; color: var(--text-primary); margin: 0; }\n.sr-success-sub { font-size: 0.92rem; color: var(--text-secondary); margin: 0; }\n.sr-success-card {\n  width: 100%;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n  box-shadow: var(--shadow-card);\n}\n.sr-success-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 18px;\n  font-size: 0.86rem;\n  border-bottom: 1px solid var(--border);\n  color: var(--text-secondary);\n}\n.sr-success-row:last-child { border-bottom: none; }\n.sr-app-id { font-family: monospace; font-size: 0.9rem; color: var(--accent); letter-spacing: 0.08em; }\n.sr-success-steps {\n  width: 100%;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n  text-align: left;\n  box-shadow: var(--shadow-card);\n}\n.sr-success-steps-title {\n  padding: 14px 18px;\n  font-size: 0.86rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  border-bottom: 1px solid var(--border);\n  margin: 0;\n}\n.sr-success-step {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 12px 18px;\n  border-bottom: 1px solid var(--border);\n}\n.sr-success-step:last-child { border-bottom: none; }\n.sr-success-step-num {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  font-size: 0.75rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.sr-success-step-label { font-size: 0.85rem; font-weight: 600; color: var(--text-primary); margin: 0; }\n.sr-success-step-desc  { font-size: 0.78rem; color: var(--text-secondary); margin: 2px 0 0; }\n.sr-success-home-btn {\n  padding: 12px 32px;\n  background: var(--accent);\n  border: none;\n  border-radius: var(--radius-sm);\n  color: var(--color-text-on-secondary);\n  font-size: 0.92rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 150ms, transform 80ms;\n}\n.sr-success-home-btn:hover { opacity: 0.88; transform: translateY(-1px); }\n\n/* Success screen actions row */\n.sr-success-actions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n}\n.sr-success-track-btn {\n  padding: 12px 28px;\n  background: var(--bg-secondary);\n  border: 1.5px solid var(--accent);\n  border-radius: var(--radius-sm);\n  color: var(--accent);\n  font-size: 0.92rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 150ms;\n}\n.sr-success-track-btn:hover { background: rgba(59, 130, 246,0.08); transform: translateY(-1px); }\n\n/* ═══════════════════════════════════════════════════════════════\n   APPLICATION TRACKER\n═══════════════════════════════════════════════════════════════ */\n\n.at-page {\n  min-height: 100vh;\n  background: var(--bg-primary);\n}\n.at-container {\n  max-width: 640px;\n  margin: 0 auto;\n  padding: 28px 20px 60px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Header */\n.at-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 20px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  box-shadow: var(--shadow-card);\n}\n.at-back-btn {\n  padding: 7px 14px;\n  background: none;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  color: var(--text-secondary);\n  font-size: 0.82rem;\n  cursor: pointer;\n  transition: all 150ms;\n  white-space: nowrap;\n}\n.at-back-btn:hover { border-color: var(--accent); color: var(--accent); }\n.at-header-brand { display: flex; align-items: center; gap: 10px; }\n.at-header-store { font-weight: 700; color: var(--text-primary); margin: 0; font-size: 0.95rem; }\n.at-header-sub   { font-size: 0.74rem; color: var(--text-secondary); margin: 0; }\n\n/* Search card */\n.at-search-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 28px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  box-shadow: var(--shadow-card);\n}\n.at-search-label {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n.at-search-hint {\n  font-size: 0.83rem;\n  color: var(--text-secondary);\n  margin: 0;\n  line-height: 1.5;\n}\n.at-input-row {\n  display: flex;\n  gap: 10px;\n  margin-top: 4px;\n}\n.at-input {\n  flex: 1;\n  padding: 11px 16px;\n  background: var(--bg-primary);\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  color: var(--text-primary);\n  font-size: 1rem;\n  font-weight: 600;\n  font-family: monospace;\n  letter-spacing: 0.06em;\n  outline: none;\n  transition: border-color 150ms, box-shadow 150ms;\n}\n.at-input:focus { border-color: var(--accent); box-shadow: 0 0 0 3px rgba(59, 130, 246,0.12); }\n.at-input.err   { border-color: var(--color-primary); }\n.at-input::placeholder { font-weight: 400; letter-spacing: 0.02em; color: var(--text-secondary); opacity: 0.65; }\n.at-search-btn {\n  padding: 11px 22px;\n  background: var(--accent);\n  border: none;\n  border-radius: var(--radius-sm);\n  color: var(--color-text-on-secondary);\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: opacity 150ms, transform 80ms;\n}\n.at-search-btn:hover:not(:disabled) { opacity: 0.88; transform: translateY(-1px); }\n.at-search-btn:disabled { opacity: 0.45; cursor: not-allowed; }\n.at-input-err { font-size: 0.78rem; color: var(--color-primary); margin: 0; }\n\n/* Result */\n.at-result {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n/* Status banner */\n.at-status-banner {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: 18px 20px;\n  border: 1.5px solid;\n  border-radius: var(--radius-sm);\n  position: relative;\n  overflow: hidden;\n}\n.at-status-icon { font-size: 2rem; line-height: 1; flex-shrink: 0; }\n.at-status-text { flex: 1; }\n.at-status-label { font-size: 1.15rem; font-weight: 800; margin: 0; }\n.at-status-appid { font-size: 0.8rem; font-family: monospace; letter-spacing: 0.06em; color: var(--text-secondary); margin: 2px 0 0; }\n.at-status-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  animation: at-pulse 2s ease-in-out infinite;\n  flex-shrink: 0;\n}\n@keyframes at-pulse { 0%,100% { opacity: 1; transform: scale(1); } 50% { opacity: 0.5; transform: scale(1.4); } }\n\n/* Info card */\n.at-info-card {\n  display: flex;\n  gap: 14px;\n  align-items: center;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: var(--space-2);\n  box-shadow: var(--shadow-card);\n}\n.at-info-avatar { font-size: 2rem; width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; background: var(--bg-tertiary); border-radius: var(--radius-sm); flex-shrink: 0; }\n.at-info-store  { font-size: 1rem; font-weight: 700; color: var(--text-primary); margin: 0; }\n.at-info-meta   { font-size: 0.8rem; color: var(--text-secondary); margin: 2px 0 0; }\n.at-info-date   { font-size: 0.78rem; color: var(--text-secondary); margin: 3px 0 0; }\n\n/* Message box */\n.at-message-box {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-left: 4px solid;\n  border-radius: var(--radius-sm);\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  box-shadow: var(--shadow-card);\n}\n.at-message { font-size: 0.88rem; color: var(--text-primary); margin: 0; }\n.at-next    { font-size: 0.83rem; color: var(--text-secondary); margin: 0; }\n\n.at-upload-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 16px;\n  margin-bottom: 16px;\n  box-shadow: var(--shadow-card);\n}\n.at-upload-title { margin: 0 0 10px; font-size: 0.88rem; font-weight: 600; color: var(--text-primary); }\n\n/* Timeline */\n.at-timeline-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 18px;\n  box-shadow: var(--shadow-card);\n}\n.at-timeline-title {\n  font-size: 0.8rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--text-secondary);\n  margin: 0 0 16px;\n}\n.at-timeline {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n.at-timeline-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n}\n.at-timeline-left {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex-shrink: 0;\n}\n.at-timeline-dot {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 2px solid var(--border);\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  font-size: 0.75rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 200ms;\n  flex-shrink: 0;\n}\n.at-timeline-dot.active { border-width: 2.5px; }\n.at-timeline-line {\n  width: 2px;\n  height: 28px;\n  background: var(--border);\n  margin: 3px 0;\n  transition: background 200ms;\n}\n.at-timeline-line.done { background: inherit; }\n.at-timeline-label {\n  font-size: 0.86rem;\n  font-weight: 500;\n  padding: 4px 0 28px;\n  margin: 0;\n  transition: color 200ms;\n}\n.at-timeline-row:last-child .at-timeline-label { padding-bottom: 0; }\n\n/* Contact note */\n.at-contact-note {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  padding: 12px 16px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  font-size: 0.82rem;\n  color: var(--text-secondary);\n  line-height: 1.5;\n  box-shadow: var(--shadow-card);\n}\n\n/* Not found */\n.at-not-found {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 40px 20px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  text-align: center;\n  box-shadow: var(--shadow-card);\n}\n.at-nf-icon  { font-size: 2.5rem; }\n.at-nf-title { font-size: 1rem; font-weight: 700; color: var(--text-primary); margin: 0; }\n.at-nf-sub   { font-size: 0.83rem; color: var(--text-secondary); margin: 0; }\n\n/* Help cards */\n.at-help-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }\n@media (max-width: 560px) { .at-help-row { grid-template-columns: 1fr; } }\n.at-help-card {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  padding: var(--space-2);\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  font-size: 1.4rem;\n  box-shadow: var(--shadow-card);\n}\n.at-help-title { font-size: 0.84rem; font-weight: 600; color: var(--text-primary); margin: 0 0 4px; }\n.at-help-desc  { font-size: 0.78rem; color: var(--text-secondary); margin: 0; line-height: 1.5; }\n\n\n\n\n/* ════════════════════════════════════════════════════════\n   SHOP LAYOUT — filters + products\n   ════════════════════════════════════════════════════════ */\n\n.shop-layout {\n  display: grid;\n  grid-template-columns: 240px 1fr;\n  align-items: start;\n  background: var(--bg-primary);\n  min-height: calc(100vh - 160px);\n}\n/* That min-height holds the row open to roughly a screenful, which is what\n   stops a short result set leaving a mostly-empty page. With the sidebar\n   present it does the opposite on a tall screen: align-items:start pins both\n   columns to the top, so on a 1366px iPad the row is stretched to ~1206px\n   while the filter card is ~807px and the leftover ~400px reads as a gap\n   under the filters. A 900px laptop never shows it because there the row is\n   ~740px and the card is taller than it. Below 900px the sidebar is hidden\n   and the main column is the whole page, where holding the row open is still\n   worth doing -- so this only lifts the floor where the sidebar exists. */\n@media (min-width: 901px) {\n  .shop-layout { min-height: 0; }\n}\n\n/* ── Left filter sidebar ─────────────────────────────── */\n/* .shop-filters is a transparent sticky positioning shell only — its\n   height is whatever's left of the viewport, which is usually taller\n   than the filter content. Giving IT the background/border would leave\n   a big empty box trailing below the actual controls while stuck mid-scroll.\n   .sf-card carries the visible card styling and is sized to its own content. */\n.shop-filters {\n  position: sticky;\n  top: var(--topbar-h, 164px);\n  max-height: calc(100vh - var(--topbar-h, 164px));\n  overflow-y: auto;\n  padding: 16px;\n  scrollbar-width: none;\n}\n.shop-filters::-webkit-scrollbar { display: none; }\n\n.sf-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 20px 16px;\n}\n\n.sf-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n.sf-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n.sf-clear-all {\n  background: none;\n  border: none;\n  color: var(--accent);\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n}\n.sf-clear-all:hover { text-decoration: underline; }\n\n.sf-section {\n  border-top: 1px solid var(--border);\n  padding: 14px 0;\n}\n.sf-section-hd {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  cursor: pointer;\n  margin-bottom: 10px;\n}\n.sf-chevron { color: var(--text-secondary); font-size: 0.75rem; }\n\n.sf-list { display: flex; flex-direction: column; gap: var(--space-1); }\n\n.sf-checkbox-row {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n  cursor: pointer;\n  font-size: 0.83rem;\n  color: var(--text-secondary);\n}\n.sf-checkbox-row input[type=\"checkbox\"] {\n  width: 15px; height: 15px; accent-color: var(--accent); cursor: pointer; flex-shrink: 0;\n}\n.sf-cat-name { flex: 1; }\n.sf-count {\n  font-size: 0.75rem;\n  color: var(--text-tertiary);\n  background: var(--bg-tertiary);\n  padding: 1px 7px;\n  border-radius: var(--radius-sm);\n}\n.sf-stars-row { display: flex; gap: 1px; }\n.sf-star-label { font-size: 0.78rem; color: var(--text-secondary); }\n.sf-stock-row { padding: 4px 0; }\n\n/* Price range */\n.sf-price-wrap { display: flex; flex-direction: column; gap: 10px; }\n.sf-slider {\n  width: 100%;\n  accent-color: var(--accent);\n  cursor: pointer;\n}\n.sf-price-labels {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n}\n.sf-price-inputs {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.sf-price-input {\n  width: 70px;\n  padding: 6px 8px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xs);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 0.82rem;\n  outline: none;\n}\n.sf-price-input:focus { border-color: var(--accent); }\n.sf-price-sep { color: var(--text-secondary); font-size: 0.8rem; }\n\n/* ── Center: main product area ───────────────────────── */\n.shop-main {\n  padding: 16px 20px;\n  min-width: 0;\n}\n\n/* Stats bar */\n.shop-stats-bar {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  margin-bottom: 20px;\n  overflow: hidden;\n  box-shadow: var(--shadow-card);\n  position: sticky;\n  top: 0;\n  z-index: 5;\n}\n.ssb-track {\n  display: flex;\n  align-items: center;\n  padding: 14px 20px;\n}\n.ssb-items {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  min-width: 0;\n}\n.ssb-items[aria-hidden=\"true\"] { display: none; }\n.ssb-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n  min-width: 0;\n  padding: 0 12px;\n}\n.ssb-items:first-child .ssb-item:first-child { padding-left: 0; }\n.ssb-items:last-child  .ssb-item:last-child  { padding-right: 0; }\n.ssb-icon { flex-shrink: 0; display: flex; }\n.ssb-positive  { color: var(--success); }\n.ssb-attention { color: var(--color-primary); }\n.ssb-info { color: var(--accent-secondary); }\n.ssb-blue   { color: var(--accent); }\n.ssb-value  { font-size: 0.9rem; font-weight: 700; color: var(--text-primary); margin: 0; line-height: 1.2; }\n.ssb-label  { font-size: 0.72rem; color: var(--text-secondary); margin: 0; }\n.ssb-sep { width: 1px; background: var(--border); align-self: stretch; flex-shrink: 0; margin: 0 4px; }\n\n@media (max-width: 768px) {\n  .shop-stats-bar {\n    position: static;\n    background: none;\n    border: none;\n    border-radius: 0;\n    box-shadow: none;\n  }\n  .ssb-track {\n    padding: 12px 0;\n    width: max-content;\n    animation: ssb-marquee 16s linear infinite;\n  }\n  .ssb-items { flex: 0 0 auto; }\n  .ssb-items[aria-hidden=\"true\"] { display: flex; }\n  .ssb-item { flex: 0 0 auto; width: 140px; padding: 0 14px; }\n  .ssb-sep { margin: 0 2px; }\n}\n\n@keyframes ssb-marquee {\n  from { transform: translateX(0); }\n  to   { transform: translateX(-50%); }\n}\n\n/* Stopping the marquee is right, but stopping it alone left the content\n   stranded: the track is ~1350px wide inside a ~344px bar with\n   overflow:hidden, so only the first two stats were reachable and the rest\n   were invisible for good. Give it a real scroller instead, and drop the\n   duplicated set -- that copy exists solely to make the loop seamless, and\n   with no loop running it is just the same four stats a second time. */\n@media (max-width: 768px) and (prefers-reduced-motion: reduce) {\n  .ssb-track { animation: none; }\n  .shop-stats-bar {\n    overflow-x: auto;\n    scrollbar-width: none;\n    -webkit-overflow-scrolling: touch;\n  }\n  .shop-stats-bar::-webkit-scrollbar { display: none; }\n  .ssb-items[aria-hidden=\"true\"] { display: none; }\n}\n\n/* Product header row */\n.shop-hdr-row {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  margin-bottom: 14px;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.shop-hdr-title { font-size: 1.25rem; font-weight: 700; margin: 0 0 4px; color: var(--text-primary); }\n.shop-hdr-sub   { font-size: 0.8rem; color: var(--text-secondary); margin: 0; }\n\n.shop-controls { display: flex; align-items: center; gap: var(--space-1); }\n.shop-sort-lbl  { font-size: 0.82rem; color: var(--text-secondary); white-space: nowrap; }\n.shop-sort-sel {\n  padding: 6px 10px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xs);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 0.83rem;\n  outline: none;\n  cursor: pointer;\n}\n/* 31px tall was the shortest control on the category page. */\n@media (max-width: 768px) {\n  .shop-sort-sel { min-height: 44px; }\n}\n\n/* Product grid — 4 columns */\n.pcard-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  /* Split deliberately: 8px between columns, 16px between rows.\n     \n     Horizontally the gap only has to separate two edges that are drawn\n     anyway, since every card carries its own border and elevation -- at 16px\n     that rail read as more deliberate than the cards, and took about 48px out\n     of a four-column row the product images could use instead.\n\n     Vertically it is doing different work. Rows stack a card's price and\n     rating directly above the next card's image, and at 8px those run\n     together into one column of text with a picture in it. The 16px is what\n     keeps each row reading as a row, so it stays. */\n  column-gap: var(--space-1);\n  row-gap: var(--space-2);\n}\n/* With only the filter rail beside it, 4 columns hold their width down to\n   ~1080px (≈195px per card); below that step down so cards stay comfortable. */\n@media (max-width: 1080px) { .pcard-grid { grid-template-columns: repeat(3, 1fr); } }\n@media (max-width: 900px)  { .pcard-grid { grid-template-columns: repeat(2, 1fr); } }\n\n/* ── Product card ────────────────────────────────────── */\n.pcard {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  transition: transform 220ms ease, box-shadow 220ms ease;\n  animation: card-appear 380ms ease both;\n  box-shadow: 0 2px 10px rgba(1, 13, 33,0.07);\n}\n.pcard:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 18px 44px rgba(1, 13, 33,0.15);\n}\n.pcard.pcard-oos { opacity: 0.72; }\n\n/* ── Product card on mobile: quiet, and it stays put ──────────────────────\n   Tapping Add to Cart made the entire card flash white. Two causes, and only\n   one of them is meant to be visible:\n\n   - .pcard carries `animation: card-appear`, which is opacity 0 -> 1. Adding\n     to the cart updates state and re-renders the grid, the animation replays,\n     and the card fades up from transparent. Over a light page that reads as\n     the whole card flashing white. The button's own ripple is a deliberate\n     white wash, but it is clipped to the button by overflow:hidden -- that\n     part was always correct.\n   - The card is clickable, so on Android it also takes the WebView's default\n     tap highlight. index.css clears that for buttons and links; an <article>\n     with an onClick is neither, so it was still highlighting.\n\n   Both are removed for the mobile layer rather than for the desktop site,\n   where the entry animation is wanted and a pointer raises no tap highlight\n   to begin with. The tap highlight is an Android WebView default, but mobile\n   browsers apply one too, so this belongs on every touch surface rather than\n   on the packaged app alone.\n\n   The rest is the calmer treatment: square corners, a plain hairline border,\n   and no lift or shadow. Hover effects are noise on a touch screen anyway --\n   a phone latches :hover after a tap, so the \"lift\" would stick on whichever\n   card was last touched. The border uses --border, which is navy at low\n   opacity; it reads as the grey wanted here without inventing a grey, since\n   the palette has no grey ramp. */\nhtml.m-app .pcard {\n  animation: none;\n  transition: none;\n  border-radius: 0;\n  border: 1px solid var(--border);\n  box-shadow: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\nhtml.m-app .pcard:hover {\n  transform: none;\n  box-shadow: none;\n}\n\nhtml.m-app .pcard:hover .pcard-img-wrap img { transform: none; }\n\n/* Dark top section (image + actions always visible) */\n.pcard-top {\n  background: linear-gradient(155deg, var(--color-brand-navy) 0%, var(--text-primary) 100%);\n  display: flex;\n  flex-direction: column;\n}\n:root[data-theme=\"light\"] .pcard-top {\n  background: var(--bg-tertiary);\n}\n\n/* Image wrap */\n.pcard-img-wrap {\n  position: relative;\n  height: 185px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n.pcard-img-wrap img {\n  width: 100%; height: 100%; object-fit: cover;\n  transition: transform 300ms ease, opacity 220ms ease;\n}\n\n.pimg-placeholder {\n  z-index: 1;\n}\n.pcard:hover .pcard-img-wrap img { transform: scale(1.06); }\n\n/* Badge — ribbon style */\n.pcard-badge {\n  position: absolute;\n  top: 14px; left: 0;\n  font-size: 0.68rem;\n  font-weight: 800;\n  padding: 5px 14px 5px 10px;\n  clip-path: polygon(0 0, 100% 0, 88% 50%, 100% 100%, 0 100%);\n  z-index: 2;\n  letter-spacing: 0.05em;\n  white-space: nowrap;\n  text-transform: uppercase;\n}\n.pcard-badge-bestseller { background: var(--color-primary); color: var(--color-text-on-primary); }\n/* Informational badge (not a promotion) -> blue, never orange. */\n.pcard-badge-toprated   { background: var(--color-secondary); color: var(--color-text-on-secondary); }\n.pcard-badge-limited    { background: var(--danger); color: var(--color-text-on-primary); }\n.pcard-badge-oos        { background: var(--text-secondary); color: var(--color-brand-white); }\n\n/* Heart button — circular white */\n.pcard-heart {\n  position: absolute;\n  top: 12px; right: 12px;\n  width: 36px; height: 36px;\n  /* The chip is a FIXED white circle in both themes (it sits on product\n     photography, not on the page surface), so its icon has to be a fixed\n     navy too. --text-secondary flips to white in dark mode, which made the\n     heart white-on-white -- invisible until hover recoloured it orange. */\n  background: rgba(255,255,255,0.95);\n  border: none;\n  border-radius: 50%;\n  color: rgba(1, 13, 33, 0.68);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 10px rgba(1, 13, 33,0.25);\n  z-index: 3;\n  transition: color 150ms, transform 150ms;\n}\n/* The white chip stays 36px -- it sits on product photography and a bigger\n   circle starts covering the product. The touchable area is grown to 44px\n   instead, which costs nothing visually. Worth doing precisely because this\n   is the save affordance repeated on every card in the grid. */\n.pcard-heart::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 44px;\n  height: 44px;\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n}\n.pcard-heart:hover { color: var(--color-primary); transform: scale(1.12); }\n\n/* OOS overlay */\n.pcard-oos-overlay {\n  position: absolute; inset: 0;\n  background: rgba(1, 13, 33,0.62);\n  display: flex; align-items: center; justify-content: center;\n  z-index: 3;\n}\n.pcard-oos-overlay span {\n  background: var(--text-secondary); color: var(--color-brand-white);\n  font-size: 0.72rem; font-weight: 700;\n  padding: 5px 14px; border-radius: var(--radius-xs);\n  text-transform: uppercase; letter-spacing: 0.06em;\n}\n\n/* Actions, at the foot of the card body.\n *\n * These used to sit directly under the image, above the product's own details.\n * They now come after the name, rating and price, so the card reads as what it\n * is and then what you can do about it.\n *\n * No horizontal padding of its own: .pcard-body already gutters the column, and\n * a second inset would step the buttons in from the title above them.\n *\n * margin-top:auto is what lines the buttons up across a row of cards whose\n * titles wrap to different heights -- without it every card in a row ends its\n * button at a different y. */\n.pcard-actions {\n  margin-top: auto;\n  padding: 10px 0 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* Quick row — two side-by-side buttons */\n.pcard-quick-row {\n  display: flex;\n  gap: 9px;\n}\n/* Hidden on mobile for testing -- revert by deleting this rule. */\n@media (max-width: 900px) {\n  .pcard-quick-row { display: none; }\n}\n/* These are sized by the grid, not by their text, and the text is translated.\n * \"Quick View\" is ten characters; Kiswahili's \"Muhtasari wa Haraka\" is\n * nineteen, and on a 244px card it ran past both ends of the button -- the eye\n * icon pushed out of the box entirely, the compare icon crushed to a sliver,\n * and the labels bleeding over the borders.\n *\n * overflow:hidden plus an ellipsis on the label (below) is the fix that holds\n * for every language rather than for the ones we happened to measure: the words\n * give way, the icon never does, and the full label stays on the title and\n * aria-label. */\n.pcard-quick-btn {\n  flex: 1;\n  min-width: 0;\n  min-height: 34px;\n  background: rgba(255,255,255,0.09);\n  border: 1px solid rgba(255,255,255,0.22);\n  border-radius: var(--radius-sm);\n  color: rgba(255,255,255,0.92);\n  font-size: 0.74rem;\n  font-weight: 600;\n  padding: 6px 14px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  transition: background 150ms, border-color 150ms;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n/* The icon is the part that still identifies the button once the words are\n   trimmed, so it is the part that must not shrink. */\n.pcard-quick-btn > svg { flex: 0 0 auto; }\n\n.pcard-quick-label {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.pcard-quick-btn:hover { background: rgba(255,255,255,0.2); border-color: rgba(255,255,255,0.42); }\n\n/* These sat on .pcard-top, which is --bg-tertiary in light mode, so a\n   --bg-secondary fill separated them from it. In the card body that pairing is\n   inverted -- the body IS --bg-secondary -- and the same fill left them as\n   white-on-white, readable only by their border. Swapped, so the button still\n   reads as a button on the surface it now sits on. */\n:root[data-theme=\"light\"] .pcard-quick-btn {\n  background: var(--bg-tertiary);\n  border-color: var(--border);\n  color: var(--text-primary);\n}\n:root[data-theme=\"light\"] .pcard-quick-btn:hover {\n  background: color-mix(in srgb, var(--color-brand-navy) 8%, transparent);\n  border-color: var(--text-tertiary);\n}\n\n@media (max-width: 900px) {\n  .pcard-quick-label { display: none; }\n  .pcard-quick-btn { padding: 8px; }\n}\n\n/* Add to Cart */\n/* Add to Cart is blue with a navy label and navy cart icon (5.6:1, clears AA;\n   white on this blue would be 3.1:1 and fail). Same treatment at every\n   breakpoint -- the action must not change colour between mobile and desktop. */\n.pcard-add-cart-btn {\n  width: 100%;\n  min-height: 38px;\n  background: var(--color-secondary);\n  border: none;\n  border-radius: var(--radius-md);\n  color: var(--color-text-on-secondary);\n  font-size: 0.85rem;\n  font-weight: 700;\n  padding: 8px 14px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-1);\n  transition: background 150ms;\n  letter-spacing: 0.01em;\n}\n.pcard-add-cart-btn:hover:not(:disabled) { background: var(--color-secondary-hover); }\n/* Unavailable: a flat navy-tinted chip, not a faded blue one -- opacity alone\n   left it reading as \"a button that's briefly busy\". Never green, and never\n   an active-looking colour. */\n.pcard-add-cart-btn:disabled {\n  background: rgba(1, 13, 33, 0.1);\n  color: rgba(1, 13, 33, 0.5);\n  cursor: not-allowed;\n}\n[data-theme=\"dark\"] .pcard-add-cart-btn:disabled {\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.5);\n}\n\n/* There used to be two Add to Cart buttons -- one over the image, one at the\n   foot of the body -- so each breakpoint could show the one that suited its\n   layout without moving a DOM node between two different flex parents. Now that\n   the actions live in the body at every width, both would sit in the same\n   parent with one permanently hidden, which is just a duplicate waiting to be\n   shown twice. One button, shown everywhere.\n\n   Mobile keeps it as the only action: .pcard-quick-row is hidden above 900px\n   down, leaving .pcard-actions holding the button alone. */\n@media (max-width: 900px) {\n  /* A comfortable touch target -- the desktop base is deliberately slimmer for\n     a mouse. */\n  .pcard-add-cart-btn { min-height: 44px; padding: 11px 14px; }\n}\n\n/* Add to Cart, trimmed back for the mobile layer.\n\n   The layer's 18px root (see mobile/tokens.css) is what made this heavy: the\n   button's 0.85rem label went from 13.6px to 15.3px, so a full-width slab\n   that was already 44px tall became the loudest thing in a 183px card --\n   louder than the product title it sits under, which inverts the card's\n   hierarchy.\n\n   Only the button is pulled back, not the root, because the larger type is\n   right everywhere else. 40px still reads as a deliberate touch target while\n   letting the title and price lead again, and the card itself remains tappable\n   for opening the product, so this is a shortcut rather than the only way in.\n\n   Specificity note: this needs two classes to beat .pcard-add-cart-btn in the\n   media query above -- media queries add no specificity of their own. */\nhtml.m-app .pcard-add-cart-btn {\n  min-height: 40px;\n  font-size: 0.72rem;\n  padding: 9px 12px;\n  gap: 6px;\n}\n/* The icon is a hardcoded 17px SVG in the markup; CSS dimensions override the\n   width/height attributes, so it can be brought down in proportion here\n   without touching the component. */\nhtml.m-app .pcard-add-cart-btn > svg {\n  width: 15px;\n  height: 15px;\n}\n\n/* Card body */\n.pcard-body {\n  padding: 10px 13px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n  /* So the quick buttons below can size their labels against THIS card rather\n     than the window. The card's width comes from the grid's column count, which\n     does not track the viewport in any fixed way -- at 1024px the cards are\n     wider than at 1180px, because the column count drops. A media query cannot\n     see that; a container query is measuring the thing that actually\n     constrains the text. */\n  container-type: inline-size;\n}\n\n/* Below this there is no honest way to show two labelled buttons side by side,\n   so the words go and the icons speak -- which is already what happens on a\n   phone, and reads far better than \"Muhtas…\" next to \"لingani…\".\n   Deliberately a card-width threshold, not a language check: it is right for\n   whichever translation happens to be longest, including ones not written yet.\n   The ellipsis rule above still covers everything just above this line. */\n@container (max-width: 250px) {\n  .pcard-quick-label { display: none; }\n  .pcard-quick-btn { padding: 6px 8px; }\n}\n.pcard-title {\n  font-size: 0.95rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  line-height: 1.35;\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* Product titles are real <a href> elements so crawlers (and \"open in new\n   tab\") can follow them -- these rules keep them looking exactly like the\n   plain text they replaced, inheriting the heading's own colour and weight\n   instead of picking up the UA's blue underline. Hover still gets an\n   underline as the affordance that this is a link. */\n.pcard-title-link {\n  color: inherit;\n  text-decoration: none;\n}\n.pcard-title-link:hover {\n  text-decoration: underline;\n}\n/* The card already has its own focus treatment; without this the nested link\n   draws a second outline inside it on keyboard navigation. */\n.pcard-title-link:focus-visible {\n  outline: 2px solid var(--accent);\n  outline-offset: 2px;\n  border-radius: 3px;\n}\n\n/* Rating row */\n.pcard-rating-row {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  flex-wrap: wrap;\n}\n/* ══════════════════════════════════════════════════════════════════════════\n   Product ratings — the ONLY place --color-rating (green) is allowed.\n\n   Every rating surface in the app routes through the three rules below, so\n   the green lives in one token and one block rather than being pasted into\n   each card variant. Filled stars are green; empty stars are navy at 15%;\n   review counts and the \"No reviews\" placeholder are muted navy. Green is\n   never used here for stock, buttons, discounts or success states.\n   ══════════════════════════════════════════════════════════════════════════ */\n.pcard-stars { display: flex; gap: 1px; font-size: 0.9rem; }\n.rating-star-filled { color: var(--color-rating); }\n.rating-star-empty  { color: var(--color-rating-empty); }\n.pcard-review-cnt,\n.product-review-count { font-size: 0.75rem; color: var(--color-review-muted); }\n/* No stars, no empty pill, no \"0.0\" -- just a plain muted line. */\n.pcard-no-rating,\n.product-no-reviews { font-size: 0.75rem; color: var(--color-review-muted); }\n\n/* The rating pill sits over the product image, lower-left. Only rendered\n   when a real rating exists (see the product card), so there is never an\n   empty green pill. Kept compact and clear of the wishlist control, which\n   is pinned to the opposite (top-right) corner. */\n.product-rating-pill,\n.pcard-rating-badge {\n  position: absolute;\n  bottom: 10px; left: 10px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 5px 9px;\n  border-radius: 999px;\n  background: var(--color-rating);\n  color: var(--color-rating-on-fill);\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1;\n  z-index: 2;\n}\n/* The star glyph matches the label it sits beside -- navy, not white. */\n.product-rating-pill svg,\n.pcard-rating-badge svg { color: var(--color-rating-on-fill); }\n\n@media (max-width: 600px) {\n  /* Narrow cards: keep the pill legible without crowding the image. */\n  .product-rating-pill,\n  .pcard-rating-badge { padding: 4px 7px; font-size: 12px; bottom: 8px; left: 8px; }\n}\n\n/* Seller */\n.pcard-seller { font-size: 0.75rem; color: var(--text-secondary); margin: 0; }\n.pcard-seller-name { color: var(--accent); font-weight: 600; }\n[data-theme=\"dark\"] .pcard-seller-name { color: var(--color-secondary-soft); }\n.pcard-verified { color: var(--success); font-size: 0.8rem; }\n\n/* Price row */\n.pcard-price-row {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  row-gap: 2px;\n  flex-wrap: wrap;\n}\n.pcard-price    { font-size: 1.32rem; font-weight: 800; color: var(--text-primary); letter-spacing: -0.01em; white-space: nowrap; }\n.pcard-original { font-size: 0.78rem; color: var(--text-tertiary); text-decoration: line-through; font-weight: 500; white-space: nowrap; }\n\n/* Stock row */\n.pcard-stock-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.74rem;\n  flex-wrap: wrap;\n}\n.pcard-status-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-weight: 700;\n  padding: 3px 9px 3px 8px;\n  border-radius: var(--radius-xl);\n  white-space: nowrap;\n}\n.pcard-status-dot { width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0; }\n\n/* There is deliberately no \".pcard-status-in\" any more: a plain \"In Stock\"\n   badge is not rendered at all (see the product card in App.js). Only the two\n   exceptional states get a pill.\n\n   Low stock is a genuine urgency/commercial signal -> orange, with a dot.\n   Out of stock is *neutral information*, not an error -> muted navy, so it\n   recedes instead of shouting in the same colour as the buy button. It\n   carries a warning icon as well as the label, since with four colours the\n   tint alone can't distinguish \"urgent\" from \"unavailable\". */\n.pcard-status-low { background: var(--color-primary-soft); color: var(--color-primary); }\n.pcard-status-low .pcard-status-dot { background: var(--color-primary); }\n\n.pcard-status-oos {\n  background: rgba(1, 13, 33, 0.06);\n  color: rgba(1, 13, 33, 0.58);\n}\n[data-theme=\"dark\"] .pcard-status-oos {\n  background: rgba(255, 255, 255, 0.08);\n  color: rgba(255, 255, 255, 0.62);\n}\n\n.pcard-sold { color: var(--text-tertiary); margin-left: auto; font-weight: 500; }\n\n/* Delivery row */\n.pcard-delivery {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.74rem;\n  color: var(--text-secondary);\n}\n.pcard-delivery strong { color: var(--accent); font-weight: 600; }\n[data-theme=\"dark\"] .pcard-delivery strong { color: var(--color-secondary-soft); }\n\n\n/* ── Cart body ───────────────────────────────────────── */\n/* The shop page used to host these .cs-* blocks in a right-hand sidebar; that\n   sidebar is gone and the cart now lives only on the full-screen /cart page\n   (see .cart-page-header / .cart-page-body below), which renders the same\n   renderCartBody() markup. */\n\n/* Cart items */\n.cs-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px 4px 28px;\n}\n\n.cs-empty-illustration {\n  position: relative;\n  width: 132px;\n  height: 132px;\n  border-radius: 50%;\n  background: radial-gradient(circle at 50% 45%, rgba(59, 130, 246,0.12), rgba(59, 130, 246,0.04) 70%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 18px;\n}\n.cs-empty-cart-icon { color: var(--accent); }\n.cs-empty-sparkle {\n  position: absolute;\n  color: var(--accent);\n  opacity: 0.55;\n  font-size: 0.9rem;\n}\n.cs-empty-sparkle-1 { top: 14px;    left: 18px; font-size: 0.7rem; }\n.cs-empty-sparkle-2 { top: 8px;     right: 28px; }\n.cs-empty-sparkle-3 { bottom: 18px; right: 14px; font-size: 0.7rem; }\n.cs-empty-heart-badge {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  width: 28px;\n  height: 28px;\n  border-radius: 50% 50% 50% 4px;\n  background: var(--accent);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: var(--shadow-card);\n}\n\n.cs-empty-title {\n  font-size: 1.05rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  margin: 0 0 8px;\n}\n.cs-empty-sub {\n  font-size: 0.82rem;\n  color: var(--text-secondary);\n  text-align: center;\n  line-height: 1.5;\n  margin: 0 0 20px;\n}\n.cs-empty-continue-btn {\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  border: none;\n  border-radius: var(--radius-sm);\n  padding: 12px 14px;\n  font-size: 0.88rem;\n  font-weight: 700;\n  cursor: pointer;\n  margin-bottom: 10px;\n  transition: background 150ms;\n}\n.cs-empty-continue-btn:hover { background: var(--accent-hover); }\n.cs-empty-categories-btn {\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: transparent;\n  color: var(--accent);\n  border: 1.5px solid var(--accent);\n  border-radius: var(--radius-sm);\n  padding: 11px 14px;\n  font-size: 0.88rem;\n  font-weight: 700;\n  cursor: pointer;\n  margin-bottom: 4px;\n  transition: background 150ms;\n}\n.cs-empty-categories-btn:hover { background: rgba(59, 130, 246,0.08); }\n\n.cs-empty-checkout-hint {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  font-size: 0.76rem;\n  color: var(--text-tertiary);\n  margin: 0 0 14px;\n}\n/* Item list. Each cart line is its own card; the bare .cs-* rules below are the\n   compact treatment still used by the \"saved for later\" list, and .cs-item\n   descendant rules scale them up for the main list. */\n.cs-items { display: flex; flex-direction: column; gap: 12px; }\n.cs-item {\n  display: grid;\n  grid-template-columns: 140px minmax(0, 1fr) auto;\n  gap: 20px;\n  align-items: start;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 14px;\n}\n.cs-item-img {\n  width: 64px; height: 64px;\n  object-fit: cover;\n  border-radius: var(--radius-sm);\n  background: var(--bg-tertiary);\n  flex-shrink: 0;\n}\n.cs-item .cs-item-img { width: 100%; height: auto; aspect-ratio: 1 / 1; }\n.cs-item-info { flex: 1; min-width: 0; }\n.cs-item .cs-item-info { padding-top: 2px; }\n.cs-item-name {\n  font-size: 0.8rem;\n  font-weight: 500;\n  margin: 0 0 3px;\n  color: var(--text-primary);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.cs-item .cs-item-name { font-size: 0.95rem; font-weight: 700; margin-bottom: 5px; }\n.cs-item-size { font-size: 0.74rem; color: var(--text-secondary); margin: 0 0 3px; }\n.cs-item-price { font-size: 0.8rem; font-weight: 700; color: var(--text-primary); margin: 0 0 5px; }\n.cs-item .cs-item-price { font-size: 1.02rem; font-weight: 800; margin-bottom: 13px; }\n.cs-qty-row { display: flex; align-items: center; gap: 10px; }\n.cs-item .cs-qty-row { margin-bottom: 13px; }\n.cs-qty-max-hint { font-size: 0.7rem; color: var(--text-muted); }\n\n/* Stepper — one bordered group with hairline dividers, not three loose chips */\n.cs-qty-group {\n  display: inline-flex;\n  align-items: stretch;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xs);\n  overflow: hidden;\n  background: var(--bg-secondary);\n}\n.cs-qty-btn {\n  width: 42px; height: 38px;\n  background: var(--bg-secondary);\n  border: none;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex; align-items: center; justify-content: center;\n  color: var(--text-primary);\n  transition: background 120ms, color 120ms;\n}\n.cs-qty-btn:hover:not(:disabled) { background: var(--accent); color: var(--color-text-on-secondary); }\n.cs-qty-btn:disabled { opacity: 0.4; cursor: not-allowed; }\n.cs-qty {\n  min-width: 44px;\n  display: flex; align-items: center; justify-content: center;\n  border-left: 1px solid var(--border);\n  border-right: 1px solid var(--border);\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n/* Remove | Save for later */\n.cs-item-actions { display: flex; align-items: center; gap: 14px; }\n.cs-item-action {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--accent);\n  cursor: pointer;\n}\n.cs-item-action:hover { text-decoration: underline; text-underline-offset: 3px; }\n.cs-item-action--danger { color: var(--danger); }\n.cs-item-action-sep { width: 1px; min-height: 16px; align-self: stretch; background: var(--border); }\n\n/* Qty tag pinned top-right, line total bottom-right */\n.cs-item-aside {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: space-between;\n  align-self: stretch;\n  gap: 12px;\n  text-align: right;\n}\n.cs-item-qty-tag { font-size: 0.8rem; color: var(--text-tertiary); white-space: nowrap; }\n.cs-item-line-total { font-size: 1.02rem; font-weight: 800; color: var(--text-primary); white-space: nowrap; }\n\n.cs-save-later-btn { background: none; border: none; font-size: 0.75rem; color: var(--accent); cursor: pointer; padding: 0; text-decoration: underline; text-underline-offset: 2px; }\n.cs-save-later-btn:hover { opacity: 0.75; }\n.cs-saved-title { font-size: 0.88rem; font-weight: 700; color: var(--text-secondary); margin: 0 0 10px; }\n.cs-saved-item { display: flex; gap: 12px; padding: 10px 0; border-bottom: 1px solid var(--border); }\n.cs-saved-item:last-child { border-bottom: none; padding-bottom: 0; }\n\n/* Totals — sit inside the order-summary card, under its own header, so no\n   top border of their own here. */\n.cs-totals {\n  margin-bottom: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n}\n.cs-total-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  font-size: 0.88rem;\n  color: var(--text-secondary);\n}\n.cs-shipping-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n.cs-shipping-label svg { color: var(--text-tertiary); cursor: help; }\n.cs-shipping-tbd {\n  font-size: 0.84rem;\n  font-style: italic;\n  color: var(--text-tertiary, var(--text-muted));\n}\n.cs-total-final {\n  font-weight: 700;\n  font-size: 1rem;\n  color: var(--text-primary);\n  padding-top: 14px;\n  border-top: 1px solid var(--border);\n  margin-top: 5px;\n}\n.cs-total-final strong { font-size: 1.2rem; }\n.cs-total-note {\n  margin: 4px 0 0;\n  font-size: 0.76rem;\n  color: var(--text-muted);\n  line-height: 1.4;\n}\n\n/* CTA buttons */\n.cs-checkout-btn {\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  border: none;\n  border-radius: var(--radius-sm);\n  padding: 13px 16px;\n  font-size: 0.92rem;\n  font-weight: 700;\n  cursor: pointer;\n  margin-bottom: 10px;\n  transition: background 150ms;\n}\n.cs-checkout-btn:hover:not(:disabled) { background: var(--accent-hover); }\n.cs-checkout-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n.cs-view-cart-btn {\n  box-sizing: border-box;\n  width: 100%;\n  background: transparent;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 12px 16px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: background 150ms;\n}\n.cs-view-cart-btn:hover:not(:disabled) { background: var(--bg-tertiary); }\n.cs-view-cart-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* Trust badges — their own card, rows split by hairlines */\n.cs-trust {\n  display: flex;\n  flex-direction: column;\n}\n.cs-trust-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 15px 0;\n  border-top: 1px solid var(--border);\n}\n.cs-trust-item:first-child { border-top: none; padding-top: 0; }\n.cs-trust-item:last-child { padding-bottom: 0; }\n.cs-trust-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.cs-trust-icon--blue   { background: rgba(59, 130, 246,0.12); color: var(--accent); }\n.cs-trust-icon--positive  { background: color-mix(in srgb, var(--success) 12%, transparent);  color: var(--success); }\n.cs-trust-icon--info { background: color-mix(in srgb, var(--accent-secondary) 12%, transparent); color: var(--accent-secondary); }\n.cs-trust-title { font-size: 0.86rem; font-weight: 700; color: var(--text-primary); margin: 0 0 1px; }\n.cs-trust-sub   { font-size: 0.78rem; color: var(--text-secondary); margin: 0; }\n\n/* Free shipping progress */\n.cs-free-ship {\n  background: rgba(59, 130, 246,0.06);\n  border: 1px solid rgba(59, 130, 246,0.2);\n  border-radius: var(--radius-sm);\n  padding: 12px 14px;\n  margin-top: 4px;\n}\n.cs-fs-title    { font-size: 0.82rem; font-weight: 700; color: var(--text-primary); margin: 0 0 4px; }\n.cs-fs-sub      { font-size: 0.75rem; color: var(--text-secondary); margin: 0 0 8px; }\n.cs-fs-track    { height: 6px; background: var(--border); border-radius: var(--radius-xs); overflow: hidden; margin-bottom: 6px; }\n.cs-fs-bar      { height: 100%; background: var(--accent); border-radius: var(--radius-xs); transition: width 400ms ease; }\n.cs-fs-progress { font-size: 0.72rem; color: var(--text-secondary); margin: 0; }\n\n/* ════════════════════════════════════════════════════════\n   CART PAGE — the only cart surface, at every width\n   ════════════════════════════════════════════════════════ */\n\n.cart-page-header {\n  border-bottom: 1px solid var(--border);\n  background: var(--bg-secondary);\n  flex-shrink: 0;\n  position: sticky;\n  top: 0;\n  z-index: 20;\n}\n.cph-inner {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  max-width: 1240px;\n  margin: 0 auto;\n  padding: 14px 24px;\n}\n/* Back and close are the same bordered square -- close is just pushed to the\n   far end, which also lets the title sit tight against the back arrow. */\n.cph-back,\n.cph-close {\n  width: 42px;\n  height: 42px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xs);\n  color: var(--text-primary);\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 120ms;\n}\n.cph-back:hover,\n.cph-close:hover { background: var(--bg-tertiary); }\n.cph-close { margin-left: auto; color: var(--text-secondary); }\n.cph-title {\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.cart-page-body {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 1240px;\n  margin: 0 auto;\n  padding: 24px;\n  flex: 1;\n}\n\n/* Items left, sticky order summary right */\n.cartpg-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 360px;\n  gap: 24px;\n  align-items: start;\n}\n.cartpg-col {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.cartpg-side {\n  position: sticky;\n  top: 88px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n/* An empty cart has nothing to put in the left column, so it drops to a single\n   centred column rather than leaving half the page blank. */\n.cartpg-empty-layout {\n  max-width: 460px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.cartpg-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 18px;\n}\n\n/* Section header: accent glyph tile + title. Used above the item list (bare,\n   spaced by .cartpg-col's gap) and inside the order-summary card. */\n.cartpg-hd {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.cartpg-card > .cartpg-hd { margin-bottom: 16px; }\n.cartpg-hd-icon,\n.cartpg-help-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-sm);\n  background: rgba(59, 130, 246, 0.12);\n  color: var(--accent);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.cartpg-hd-title {\n  font-size: 1.05rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n/* Support prompt under the item list */\n.cartpg-help {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n.cartpg-help-text { flex: 1; min-width: 0; }\n.cartpg-help-title { font-size: 0.92rem; font-weight: 700; color: var(--text-primary); margin: 0 0 2px; }\n.cartpg-help-sub { font-size: 0.82rem; color: var(--text-secondary); margin: 0; }\n.cartpg-help-btn {\n  flex-shrink: 0;\n  background: transparent;\n  border: 1px solid var(--accent);\n  border-radius: var(--radius-xs);\n  color: var(--accent);\n  padding: 10px 18px;\n  font-size: 0.86rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 150ms;\n}\n.cartpg-help-btn:hover { background: rgba(59, 130, 246, 0.08); }\n\n@media (max-width: 1000px) {\n  /* Summary drops below the items rather than squeezing both into a narrow\n     split -- 360px of summary plus a 140px thumbnail leaves the item text\n     nowhere to go. */\n  .cartpg-grid { grid-template-columns: minmax(0, 1fr); }\n  .cartpg-side { position: static; }\n}\n@media (max-width: 640px) {\n  .cph-inner { padding: 12px 14px; gap: 12px; }\n  .cph-title { font-size: 1.2rem; }\n  .cph-back, .cph-close { width: 38px; height: 38px; }\n  .cart-page-body { padding: 16px 12px 32px; }\n  .cartpg-card { padding: 14px; }\n  /* Thumbnail shrinks and the qty/total column wraps to a full-width footer\n     row, so the name and stepper keep a usable width on a phone. */\n  .cs-item { grid-template-columns: 96px minmax(0, 1fr); gap: 14px; padding: 12px; }\n  .cs-item-aside {\n    grid-column: 1 / -1;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    border-top: 1px solid var(--border);\n    padding-top: 12px;\n  }\n  .cartpg-help { flex-wrap: wrap; }\n  .cartpg-help-btn { width: 100%; }\n}\n\n/* ── Responsive collapse ─────────────────────────────── */\n/* Narrow the filter rail as the grid steps down to 3 columns, then drop it\n   entirely on phones where the category sheet in the bottom nav takes over. */\n@media (max-width: 1080px) {\n  .shop-layout { grid-template-columns: 220px 1fr; }\n  .pcard-grid  { grid-template-columns: repeat(3, 1fr); }\n}\n@media (max-width: 900px) {\n  .shop-layout { grid-template-columns: 1fr; }\n  .shop-filters { display: none; }\n  .pcard-grid  { grid-template-columns: repeat(2, 1fr); }\n}\n@media (max-width: 640px) {\n  /* Let cards run closer to the screen edge on phones, and shrink the gap\n     between cards so more of the fixed 2-column width goes to each card\n     instead of the gutter between them. */\n  .shop-main { padding: 16px 8px; }\n  .pcard-grid { gap: 8px; }\n}\n\n/* ════════════════════════════════════════════════════════\n   NAVBAR REDESIGN — two-row layout\n   ════════════════════════════════════════════════════════ */\n\n/* Override old single-row inner */\n.main-navbar-inner { display: none; }\n.nb-search-row { display: none; }\n\n/* Row 1: Logo + Search + Actions */\n.nb-top {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  padding: 10px 24px;\n  max-width: 1440px;\n  margin: 0 auto;\n}\n\n/* Persistent inline search bar */\n/* min-width:0 is the whole of it. A flex item's default min-width is `auto`,\n   which floors it at its content's minimum size -- so `flex: 1` here could\n   grow the search bar but never shrink it past the width its input wanted,\n   and the overflow was pushed onto .nb-actions to the right of it instead.\n   With the floor removed the search bar yields first, which is the correct\n   order of sacrifice: a narrower search field is usable, a cart button off\n   the edge of the screen is not. */\n.nb-search-wrap { position: relative; flex: 1; min-width: 0; display: flex; }\n.nb-search-wrap .nb-search-bar { flex: 1; }\n.nb-autocomplete {\n  position: absolute; top: calc(100% + 6px); left: 0; right: 0; z-index: 200;\n  background: var(--bg-primary); border: 1px solid var(--border); border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(1, 13, 33,0.15); overflow: hidden;\n}\n.nb-ac-item {\n  display: flex; align-items: center; gap: 10px; width: 100%; padding: 10px 14px;\n  background: none; border: none; cursor: pointer; text-align: left; transition: background 0.1s;\n}\n.nb-ac-item:hover { background: var(--bg-secondary); }\n.nb-ac-img { width: 38px; height: 38px; border-radius: 8px; object-fit: cover; flex-shrink: 0; }\n.nb-ac-info { flex: 1; min-width: 0; }\n.nb-ac-name { display: block; font-size: 0.85rem; font-weight: 600; color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.nb-ac-cat { display: block; font-size: 0.72rem; color: var(--text-muted); }\n.nb-ac-price { font-size: 0.85rem; font-weight: 700; color: var(--accent); flex-shrink: 0; }\n\n.nb-search-bar {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  height: 44px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: var(--bg-primary);\n  overflow: hidden;\n  transition: border-color 200ms, box-shadow 200ms;\n  min-width: 0;\n}\n.nb-search-bar:focus-within {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246,0.1);\n}\n.nb-sb-search-icon {\n  padding: 0 10px;\n  color: var(--text-tertiary);\n  flex-shrink: 0;\n}\n.nb-sb-input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  outline: none;\n  color: var(--text-primary);\n  font-size: 0.96rem;\n  min-width: 0;\n}\n.nb-sb-input::placeholder { color: var(--text-tertiary); }\n/* hide the native search clear button */\n.nb-sb-input::-webkit-search-cancel-button { display: none; }\n.nb-sb-clear {\n  background: none;\n  border: none;\n  color: var(--text-tertiary);\n  cursor: pointer;\n  padding: 2px 7px;\n  font-size: 0.8rem;\n  border-radius: var(--radius-xs);\n  flex-shrink: 0;\n  transition: color 120ms;\n}\n.nb-sb-clear:hover { color: var(--text-primary); }\n.nb-sb-divider {\n  width: 1px;\n  height: 22px;\n  background: var(--border);\n  flex-shrink: 0;\n  margin: 0 2px;\n}\n.nb-sb-cat {\n  border: none;\n  background: transparent;\n  outline: none;\n  color: var(--text-secondary);\n  font-size: 0.88rem;\n  padding: 0 4px 0 8px;\n  cursor: pointer;\n  max-width: 130px;\n  white-space: nowrap;\n  appearance: none;\n  -webkit-appearance: none;\n}\n.nb-sb-caret {\n  color: var(--text-tertiary);\n  flex-shrink: 0;\n  margin-right: 2px;\n  pointer-events: none;\n}\n.nb-sb-btn {\n  background: var(--accent);\n  border: none;\n  height: 44px;\n  min-width: 50px;\n  padding: 0 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--color-text-on-secondary);\n  flex-shrink: 0;\n  transition: background 150ms;\n}\n.nb-sb-btn:hover { background: var(--accent-hover); }\n\n.nb-mobile-search-btn {\n  display: none;\n  background: var(--bg-tertiary);\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  color: var(--text-primary);\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n}\n.nb-sb-back {\n  display: none;\n  background: none;\n  border: none;\n  padding: 0 8px 0 12px;\n  color: var(--text-secondary);\n  flex-shrink: 0;\n  cursor: pointer;\n  align-items: center;\n}\n\n/* Mobile: drop the inline category picker/search button, keep a clean pill */\n@media (max-width: 768px) {\n  .nb-sb-divider, .nb-sb-cat, .nb-sb-caret, .nb-sb-btn { display: none; }\n  .nb-search-bar { border-radius: var(--radius-lg); background: var(--bg-tertiary); border-color: transparent; }\n\n  .nb-top { padding: 10px 12px; gap: 10px; }\n\n  /* Icon-only wordmark on mobile -- the \"AcyMart\" text and tagline are\n     dropped to save header width, keeping just the bag icon as the\n     tappable home link. */\n  .nb-logo-text-block { display: none; }\n\n  /* Search bar collapses to a single icon button until tapped open */\n  .nb-search-bar { display: none; }\n  .nb-search-bar.nb-search-expanded { display: flex; flex: 1; }\n  .nb-mobile-search-btn { display: flex; margin-left: auto; }\n  .nb-sb-back { display: flex; }\n\n  /* Group search + theme toggle together at the right edge instead of\n     leaving them stranded near the logo with dead space after them */\n  .nb-actions { gap: 8px; }\n\n  /* Language switcher: icon-only on mobile (drop the \"English\"/\"Français\"\n     text label) so it matches the theme toggle it sits next to instead of\n     being the one text-heavy control left in an otherwise icon-only row.\n     Scoped to the navbar instance only -- the footer's language switcher\n     keeps its text label, since it isn't fighting for space there. */\n  .nb-actions .lang-switcher-current { display: none; }\n  .nb-actions .lang-switcher-btn {\n    width: 44px;\n    height: 44px;\n    justify-content: center;\n    padding: 0;\n  }\n}\n\n/* Action buttons (account / wishlist / cart) */\n.nb-actions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  flex-shrink: 0;\n}\n.nb-action-btn {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n  min-height: 44px;\n  background: none;\n  border: none;\n  padding: 6px 10px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  color: var(--text-primary);\n  transition: background 150ms;\n  text-align: left;\n  white-space: nowrap;\n}\n.nb-action-btn:hover { background: var(--bg-tertiary); }\n\n/* Below 768px the bottom nav already covers account/wishlist/cart —\n   these text-label buttons don't shrink and were forcing horizontal\n   page overflow at narrow widths, so hide them and keep just the\n   theme toggle (which the bottom nav has no equivalent for). */\n@media (max-width: 768px) {\n  .nb-action-btn { display: none; }\n}\n\n/* ── The band the rule above did not cover ────────────────────────────────\n *\n * Hiding the buttons below 768px fixed the phone and left 769px to about\n * 1150px broken, which is laptops and tablets in landscape. .nb-actions is\n * flex-shrink:0 with nowrap labels, so it holds its full width and simply\n * leaves the screen. Measured on the homepage:\n *\n *            signed out        signed in\n *   820px    172px off-screen  284px off-screen\n *   960px     32px             144px\n *   1024px    fits              80px   <- iPad landscape\n *   1100px    fits               4px\n *\n * Signing in makes it worse because the account button appears, which is\n * exactly backwards: the person with an account is the one who loses the\n * cart button off the edge of the screen.\n *\n * The labels are what cost the width, not the controls, so the labels go and\n * the icons stay. Every one of these buttons already carries an aria-label\n * (see App.js), so nothing is lost to a screen reader -- this is the same\n * icon-only treatment the header uses under 768px, applied one breakpoint\n * earlier instead of jumping straight from full labels to nothing.\n *\n * The page does not scroll sideways in this band -- the overflow is clipped --\n * so the failure is silent and looks like missing buttons rather than a layout\n * bug, which is why it outlived the 768px fix. */\n@media (min-width: 769px) and (max-width: 1150px) {\n  /* .nb-actions prefixed on every one of these: the plain .nb-action-text rule\n     is defined a few lines BELOW this block, and a media query adds no\n     specificity -- so an unprefixed .nb-action-text here loses on source order\n     and the labels stay put. Measured that exact failure: the gap changed, the\n     labels did not. */\n  .nb-actions .nb-action-text { display: none; }\n  .nb-actions .nb-action-btn { padding: 6px 8px; }\n  .nb-actions { gap: 4px; }\n}\n\n.nb-action-icon-wrap {\n  position: relative;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n}\n.nb-action-text {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.25;\n}\n.nb-action-label {\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n}\n.nb-action-sub {\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n/* Override old nb-badge positioning for new icon wrap context */\n.nb-action-icon-wrap .nb-badge {\n  top: -6px;\n  right: -8px;\n}\n/* Wishlist count -- an informational counter, so blue. */\n.nb-badge-count {\n  background: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n}\n.nb-theme-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  width: 44px;\n  height: 44px;\n  border-radius: var(--radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n  margin-left: 2px;\n  transition: background 150ms;\n}\n.nb-theme-btn:hover { background: var(--bg-tertiary); }\n\n/* ── Visible keyboard focus for icon-only controls (previously had none) ── */\n.nb-action-btn:focus-visible,\n.nb-theme-btn:focus-visible,\n.pcard-heart:focus-visible,\n.pcard-quick-btn:focus-visible,\n.pcard-add-cart-btn:focus-visible,\n.bn-item:focus-visible,\n.btn:focus-visible {\n  outline: 2px solid var(--accent);\n  outline-offset: 2px;\n}\n\n/* ── Button press ripple (pure CSS, no pointer tracking) ── */\n.btn,\n.pcard-add-cart-btn,\n.nb-action-btn {\n  position: relative;\n  overflow: hidden;\n}\n.btn::after,\n.pcard-add-cart-btn::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: rgba(255,255,255,0.35);\n  opacity: 0;\n  transform: scale(0.6);\n  border-radius: inherit;\n  pointer-events: none;\n  transition: transform var(--dur-base) var(--ease-out-expo), opacity var(--dur-base) ease;\n}\n.nb-action-btn::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: var(--accent);\n  opacity: 0;\n  transform: scale(0.6);\n  border-radius: inherit;\n  pointer-events: none;\n  transition: transform var(--dur-base) var(--ease-out-expo), opacity var(--dur-base) ease;\n}\n.btn:active::after,\n.pcard-add-cart-btn:active::after {\n  opacity: 1;\n  transform: scale(1);\n  transition: transform 0ms, opacity 0ms;\n}\n.nb-action-btn:active::after {\n  opacity: 0.1;\n  transform: scale(1);\n  transition: transform 0ms, opacity 0ms;\n}\n\n/* ── No press ripple on mobile ────────────────────────────────────────────\n   The white wash above is a pointer-era affordance and it does not survive\n   contact with a touch screen. :active is applied instantly and then held --\n   a touch browser keeps it after the finger lifts, until something else is\n   touched, and the packaged WebView behaves the same way.\n   So Add to Cart lit up white and stayed white until the next tap, which\n   reads as a one-or-two-second flash rather than a press.\n\n   Removing the pseudo-element outright rather than shortening the fade: no\n   duration makes a latched state correct, and the button does not need to\n   confirm anything on its own -- the cart badge in the bottom nav increments\n   immediately, which is why the toast was dropped as well. */\nhtml.m-app .btn::after,\nhtml.m-app .pcard-add-cart-btn::after,\nhtml.m-app .nb-action-btn::after {\n  content: none;\n}\n\n/* Row 2: Category nav strip */\n.nb-cat-row {\n  border-top: 1px solid var(--border);\n}\n/* Replaced on mobile by MobileTopBar's icon-based category strip */\n@media (max-width: 768px) {\n  .nb-cat-row { display: none; }\n}\n.nb-cat-row-inner {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 0 24px;\n  display: flex;\n  align-items: center;\n  height: 44px;\n}\n.nb-all-cats-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  border-right: 1px solid var(--border);\n  padding: 0 16px 0 0;\n  margin-right: 4px;\n  font-size: 0.93rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  white-space: nowrap;\n  height: 100%;\n  flex-shrink: 0;\n  transition: color 150ms;\n}\n.nb-all-cats-btn:hover,\n.nb-all-cats-btn.active { color: var(--accent); }\n\n.nb-deals-link {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  padding: 0 14px;\n  margin-right: 2px;\n  background: none;\n  border: none;\n  /* Now an <a>, not a <button> -- see .nb-cat-link. */\n  text-decoration: none;\n  border-bottom: 2px solid transparent;\n  font-size: 0.93rem;\n  font-weight: 700;\n  /* Navy label with an orange flame icon and orange underline/tint, rather\n     than orange type: orange on white is 2.92:1 and can't pass AA at this\n     size. The promotional read comes from the icon and the fill instead --\n     \"navy text with orange icons, borders or backgrounds\" per the brand\n     accessibility rules. */\n  color: var(--text-primary);\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n  transition: background 150ms;\n}\n.nb-deals-link svg { color: var(--color-primary); }\n.nb-deals-link:hover { background: rgba(255, 103, 0, 0.08); }\n.nb-deals-link.active {\n  border-bottom-color: var(--color-primary);\n  background: rgba(255, 103, 0, 0.08);\n}\n\n/* Override old nb-cat-nav for new row context */\n.nb-cat-row .nb-cat-nav {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  height: 100%;\n  overflow-x: auto;\n  scrollbar-width: none;\n  gap: 0;\n}\n.nb-cat-row .nb-cat-nav::-webkit-scrollbar { display: none; }\n.nb-cat-row .nb-cat-link {\n  height: 100%;\n  padding: 0 12px;\n  font-size: 0.93rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  border-radius: 0;\n  cursor: pointer;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  transition: color 150ms, border-color 150ms;\n}\n.nb-cat-row .nb-cat-link:hover { color: var(--accent); background: rgba(59, 130, 246,0.04); }\n.nb-cat-row .nb-cat-link.active {\n  color: var(--accent);\n  font-weight: 700;\n  border-bottom-color: var(--accent);\n  background: rgba(59, 130, 246,0.04);\n}\n\n/* Dark mode tweaks */\n:root[data-theme=\"dark\"] .nb-action-btn:hover { background: color-mix(in srgb, var(--accent-secondary) 10%, transparent); }\n:root[data-theme=\"dark\"] .nb-theme-btn:hover  { background: color-mix(in srgb, var(--accent-secondary) 10%, transparent); }\n:root[data-theme=\"dark\"] .nb-sb-cat { color: var(--text-secondary); }\n:root[data-theme=\"dark\"] .nb-cat-row .nb-cat-link:hover,\n:root[data-theme=\"dark\"] .nb-cat-row .nb-cat-link.active { background: color-mix(in srgb, var(--accent-secondary) 10%, transparent); }\n\n/* ════════════════════════════════════════════════════════\n   PRODUCT DETAIL PAGE v2 — Amazon / Flipkart / Shopify UX\n   ════════════════════════════════════════════════════════ */\n.pdp-page {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 16px 24px 56px;\n  background: var(--bg-primary);\n}\n\n/* Breadcrumb */\n.pdp-breadcrumb {\n  display: flex; align-items: center; gap: 6px;\n  font-size: 0.82rem; color: var(--text-secondary);\n  margin-bottom: 16px; flex-wrap: wrap;\n}\n.pdp-back-link {\n  background: none; border: none; color: var(--accent);\n  font-size: 0.82rem; cursor: pointer; padding: 0; font-weight: 600;\n}\n.pdp-back-link:hover { text-decoration: underline; }\n.pdp-bc-sep { color: var(--text-tertiary); }\n/* Breadcrumb crumbs are <a href> now (see ProductDetailPage) -- keep the\n   muted look they had as spans, with an underline on hover as the cue. */\n.pdp-bc-item { color: var(--text-secondary); text-decoration: none; }\na.pdp-bc-item:hover { color: var(--accent); text-decoration: underline; }\n.pdp-bc-current { color: var(--text-primary); font-weight: 500; }\n\n/* Main 3-column grid */\n.pdp-main {\n  display: grid;\n  grid-template-columns: 420px 1fr 300px;\n  gap: var(--space-3);\n  align-items: start;\n  margin-bottom: 20px;\n}\n\n/* ════ LEFT: Gallery ════ */\n.pdp-gallery { display: flex; gap: 10px; }\n\n.pdp-thumbs {\n  display: flex; flex-direction: column; gap: var(--space-1);\n  width: 70px; flex-shrink: 0;\n}\n.pdp-thumb {\n  width: 70px; height: 70px;\n  border: 2px solid var(--border); border-radius: var(--radius-sm);\n  overflow: hidden; background: var(--bg-secondary);\n  cursor: pointer; padding: 4px; transition: all 150ms;\n  display: flex; align-items: center; justify-content: center;\n  position: relative;\n}\n.pdp-thumb:hover { border-color: var(--accent); transform: scale(1.03); }\n.pdp-thumb.active {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 2px rgba(59, 130, 246,0.25);\n}\n.pdp-thumb img { width: 100%; height: 100%; object-fit: contain; }\n.pdp-thumb-view-badge {\n  position: absolute; bottom: 3px; left: 50%; transform: translateX(-50%);\n  background: rgba(1, 13, 33,0.65); color: var(--color-brand-white);\n  font-size: 0.52rem; padding: 2px 6px; border-radius: var(--radius-xs);\n  white-space: nowrap; pointer-events: none;\n}\n.pdp-img-view-label {\n  position: absolute; bottom: 12px; left: 12px;\n  background: rgba(1, 13, 33,0.6); color: var(--color-brand-white);\n  font-size: 0.72rem; font-weight: 600;\n  padding: 4px 10px; border-radius: var(--radius-xs);\n  letter-spacing: 0.03em; pointer-events: none; z-index: 3;\n}\n.pdp-thumb-video-badge {\n  position: absolute; bottom: 3px; right: 3px;\n  background: rgba(1, 13, 33,0.7); color: var(--color-brand-white);\n  font-size: 0.55rem; padding: 2px 5px; border-radius: var(--radius-xs);\n  font-weight: 900; line-height: 1;\n}\n\n/* Main image wrapper */\n.pdp-main-img-wrap {\n  flex: 1;\n  background: var(--bg-secondary); border: 1px solid var(--border);\n  border-radius: var(--radius-lg); overflow: hidden;\n  display: flex; flex-direction: column;\n  box-shadow: var(--shadow-card);\n}\n.pdp-main-img-stage {\n  flex: 1; position: relative;\n  display: flex; align-items: center; justify-content: center;\n  overflow: hidden; cursor: zoom-in;\n  min-height: 320px;\n}\n.pdp-main-img-inner {\n  width: 100%; height: 100%;\n  display: flex; align-items: center; justify-content: center;\n  overflow: hidden;\n  transition: transform 400ms cubic-bezier(0.25,0.46,0.45,0.94);\n}\n.pdp-main-img-stage:hover .pdp-main-img-inner { transform: scale(1.09); }\n.pdp-main-img {\n  width: 100%; height: 420px;\n  object-fit: contain; padding: var(--space-3);\n  pointer-events: none; user-select: none;\n  transition: opacity 220ms ease;\n}\n.pdp-main-img-fallback {\n  width: 100%; height: 420px;\n  display: flex; align-items: center; justify-content: center;\n  color: var(--text-tertiary);\n}\n@media (prefers-reduced-motion: reduce) {\n  .pdp-main-img { transition: none; }\n}\n\n/* Badge overlay */\n.pdp-img-badge {\n  position: absolute; top: 14px; left: 0;\n  background: var(--success); color: var(--color-text-on-secondary);\n  font-size: 0.65rem; font-weight: 800; letter-spacing: 0.07em;\n  padding: 4px 12px 4px 10px; border-radius: 0 var(--radius-sm) var(--radius-sm) 0;\n  z-index: 2; text-transform: uppercase;\n}\n.pdp-img-badge.hot  { background: var(--color-primary); }\n\n/* Wishlist heart */\n.pdp-img-heart {\n  position: absolute; top: 14px; right: 14px;\n  width: 38px; height: 38px;\n  background: var(--bg-primary); border: 1px solid var(--border);\n  border-radius: 50%; box-shadow: 0 2px 10px rgba(1, 13, 33,0.12);\n  font-size: 1.15rem; color: var(--text-muted);\n  cursor: pointer; display: flex; align-items: center; justify-content: center;\n  z-index: 2; transition: all 150ms;\n}\n.pdp-img-heart:hover { color: var(--danger); border-color: var(--danger); transform: scale(1.1); }\n.pdp-img-heart.active { color: var(--danger); }\n\n/* Prev/Next arrows */\n.pdp-img-prev, .pdp-img-next {\n  position: absolute; top: 50%; transform: translateY(-50%);\n  width: 36px; height: 36px;\n  background: var(--bg-primary); border: 1px solid var(--border);\n  border-radius: 50%; cursor: pointer; font-size: 1.2rem; font-weight: 700;\n  display: flex; align-items: center; justify-content: center;\n  z-index: 2; transition: all 150ms;\n  box-shadow: 0 2px 10px rgba(1, 13, 33,0.1);\n  opacity: 0;\n}\n.pdp-main-img-stage:hover .pdp-img-prev,\n.pdp-main-img-stage:hover .pdp-img-next { opacity: 1; }\n.pdp-img-prev { left: 12px; }\n.pdp-img-next { right: 12px; }\n.pdp-img-prev:hover, .pdp-img-next:hover {\n  background: var(--accent); color: var(--color-text-on-secondary); border-color: var(--accent);\n}\n\n/* 360 + video overlay buttons */\n.pdp-img-overlay-btns {\n  position: absolute; bottom: 14px; left: 50%; transform: translateX(-50%);\n  display: flex; gap: var(--space-1); z-index: 2;\n  opacity: 0; transition: opacity 200ms;\n}\n.pdp-main-img-stage:hover .pdp-img-overlay-btns { opacity: 1; }\n.pdp-360-trigger, .pdp-video-trigger {\n  background: rgba(1, 13, 33,0.68); color: var(--color-brand-white);\n  border: none; border-radius: var(--radius-sm); cursor: pointer;\n  font-size: 0.73rem; font-weight: 700; padding: 7px 14px;\n  display: flex; align-items: center; gap: 5px;\n  backdrop-filter: blur(6px); transition: background 150ms;\n  white-space: nowrap;\n}\n.pdp-360-trigger:hover, .pdp-video-trigger:hover { background: rgba(1, 13, 33,0.88); }\n\n/* Image counter */\n.pdp-img-counter {\n  position: absolute; top: 14px; left: 50%; transform: translateX(-50%);\n  background: rgba(1, 13, 33,0.62); color: var(--color-brand-white);\n  font-size: 0.7rem; font-weight: 700; padding: 3px 10px; border-radius: var(--radius-sm);\n  z-index: 2; backdrop-filter: blur(4px); letter-spacing: 0.04em;\n}\n\n/* Zoom hint */\n.pdp-zoom-hint {\n  position: absolute; bottom: 14px; right: 14px;\n  background: rgba(1, 13, 33,0.4); color: var(--color-brand-white);\n  font-size: 0.65rem; padding: 3px 8px; border-radius: var(--radius-sm);\n  z-index: 2; pointer-events: none;\n  opacity: 0; transition: opacity 200ms;\n}\n.pdp-main-img-stage:hover .pdp-zoom-hint { opacity: 1; }\n\n/* Image card config panel — quantity */\n.pdp-img-config {\n  border-top: 1px solid var(--border);\n  padding: 10px 16px 12px;\n  display: flex; flex-direction: column; gap: var(--space-1);\n  background: var(--bg-secondary);\n}\n.pdp-img-qty-row {\n  display: flex; align-items: center; gap: 12px;\n}\n.pdp-img-config-label {\n  font-size: 0.78rem; color: var(--text-secondary);\n  white-space: nowrap; min-width: 72px;\n}\n.pdp-img-config-label strong { color: var(--text-primary); font-weight: 700; }\n\n/* Colour + Size selectors -- sit together in the center info column, right\n   above the price block (matches the reference layout: swatch circles for\n   colour, pill buttons for size). */\n.pdp-variant-row { display: flex; gap: 28px; flex-wrap: wrap; margin: 2px 0 4px; }\n.pdp-variant-group { display: flex; flex-direction: column; gap: 8px; }\n.pdp-variant-group-label { font-size: 0.82rem; color: var(--text-secondary); }\n.pdp-variant-group-label strong { color: var(--text-primary); font-weight: 700; }\n.pdp-variant-swatches { display: flex; gap: 10px; flex-wrap: wrap; align-items: center; }\n\n.pdp-color-swatch {\n  width: 32px; height: 32px; border-radius: 50%; flex-shrink: 0;\n  border: 2px solid var(--border); cursor: pointer; padding: 0;\n  background-color: var(--bg-tertiary); background-size: cover; background-position: center;\n  display: flex; align-items: center; justify-content: center;\n  transition: border-color 150ms, transform 150ms, box-shadow 150ms;\n}\n.pdp-color-swatch:hover { transform: scale(1.08); }\n.pdp-color-swatch.active {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 2px var(--bg-primary), 0 0 0 4px var(--accent);\n}\n.pdp-color-swatch-fallback {\n  font-size: 0.62rem; font-weight: 700; color: var(--text-secondary);\n}\n\n/* ════ CENTER: Product info ════ */\n.pdp-info { min-width: 0; }\n\n.pdp-cat-label {\n  display: inline-flex; align-items: center; gap: 7px;\n  font-size: 0.72rem; font-weight: 800; letter-spacing: 0.1em;\n  color: var(--accent); text-transform: uppercase; margin-bottom: 10px;\n}\n.pdp-cat-label::before {\n  content: '';\n  display: inline-block; width: 16px; height: 2px;\n  background: var(--accent); border-radius: 1px;\n}\n\n.pdp-title {\n  font-size: 1.65rem; font-weight: 800; line-height: 1.28;\n  color: var(--text-primary); margin: 0 0 14px;\n  letter-spacing: -0.015em;\n}\n\n/* Rating row */\n.pdp-rating-row {\n  display: flex; align-items: center; gap: var(--space-1);\n  flex-wrap: wrap; margin-bottom: 12px;\n  padding-bottom: 12px; border-bottom: 1px solid var(--border);\n}\n.pdp-stars { display: flex; gap: 2px; }\n.pdp-rating-score {\n  font-size: 0.88rem; font-weight: 800; color: var(--text-primary);\n  background: rgba(255, 103, 0,0.12); border: 1px solid rgba(255, 103, 0,0.3);\n  padding: 2px 8px; border-radius: var(--radius-xs);\n}\n.pdp-review-cnt { font-size: 0.82rem; color: var(--text-secondary); }\n.pdp-qa-count { font-size: 0.82rem; color: var(--accent); font-weight: 600; cursor: pointer; }\n.pdp-qa-count:hover { text-decoration: underline; }\n\n/* Badges row */\n.pdp-badges-row {\n  display: flex; gap: var(--space-1); flex-wrap: wrap; margin-bottom: 12px;\n}\n.pdp-bestseller-badge {\n  display: inline-flex; align-items: center; gap: 5px;\n  background: linear-gradient(135deg, var(--color-primary), color-mix(in srgb, var(--color-primary) 80%, var(--color-brand-navy)));\n  color: var(--color-text-on-primary); font-size: 0.75rem; font-weight: 700;\n  padding: 5px 12px; border-radius: var(--radius-xs); letter-spacing: 0.02em;\n}\n.pdp-trending-badge {\n  display: inline-flex; align-items: center; gap: 5px;\n  background: linear-gradient(135deg, var(--accent), var(--accent-secondary));\n  color: var(--color-brand-white); font-size: 0.75rem; font-weight: 700;\n  padding: 5px 12px; border-radius: var(--radius-xs);\n}\n.pdp-verified-badge {\n  display: inline-flex; align-items: center; gap: 5px;\n  background: color-mix(in srgb, var(--success) 10%, transparent); border: 1px solid color-mix(in srgb, var(--success) 30%, transparent);\n  color: var(--color-secondary-text); font-size: 0.75rem; font-weight: 700;\n  padding: 5px 12px; border-radius: var(--radius-xs);\n}\n[data-theme=\"dark\"] .pdp-verified-badge {\n  color: var(--success); border-color: color-mix(in srgb, var(--success) 30%, transparent); background: color-mix(in srgb, var(--success) 10%, transparent);\n}\n\n/* Short description */\n.pdp-desc-short {\n  font-size: 0.88rem; color: var(--text-secondary);\n  line-height: 1.65; margin-bottom: 12px;\n}\n\n/* Feature chips */\n.pdp-feature-chips {\n  display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 14px;\n}\n.pdp-feature-chip {\n  background: var(--bg-secondary); border: 1px solid var(--border);\n  color: var(--text-secondary); font-size: 0.78rem;\n  padding: 5px 12px; border-radius: var(--radius-xl); transition: all 150ms;\n}\n.pdp-feature-chip:hover { border-color: var(--accent); color: var(--accent); background: rgba(59, 130, 246,0.05); }\n\n/* Price block */\n.pdp-price-block { margin-bottom: 14px; }\n.pdp-price-row {\n  display: flex; align-items: baseline; gap: 12px; flex-wrap: wrap; margin-bottom: 4px;\n}\n.pdp-price {\n  font-size: 2.4rem; font-weight: 900; color: var(--text-primary);\n  line-height: 1; letter-spacing: -0.02em;\n}\n.pdp-original { font-size: 1rem; color: var(--text-tertiary); text-decoration: line-through; }\n.pdp-tax-note { font-size: 0.76rem; color: var(--text-tertiary); margin: 4px 0 0; }\n\n/* Quick trust mini-grid */\n.pdp-quick-trust {\n  display: grid; grid-template-columns: repeat(2, 1fr); gap: var(--space-1); margin-bottom: 14px;\n}\n.pdp-qt-item {\n  display: flex; align-items: center; gap: var(--space-1);\n  background: var(--bg-secondary); border: 1px solid var(--border);\n  border-radius: var(--radius-sm); padding: 8px 10px; transition: border-color 150ms;\n}\n.pdp-qt-item:hover { border-color: var(--accent); }\n.pdp-qt-icon { font-size: 1rem; flex-shrink: 0; }\n.pdp-qt-text { color: var(--text-primary); font-weight: 600; font-size: 0.8rem; }\n/* Was an inline style on the span in ProductDetailPage.js, which meant its\n   0.7rem couldn't be reached by the mobile type floor below -- inline styles\n   can't be media-queried. Same values, now addressable. */\n.pdp-qt-sub { color: var(--text-tertiary); font-size: 0.75rem; }\n\n/* Stock status */\n.pdp-stock-status {\n  display: inline-flex; align-items: center; gap: 6px;\n  font-size: 0.88rem; font-weight: 700; margin-bottom: 14px;\n  padding: 6px 14px; border-radius: var(--radius-sm);\n}\n.pdp-in-stock {\n  color: var(--color-secondary-text);\n  background: color-mix(in srgb, var(--success) 8%, transparent); border: 1px solid color-mix(in srgb, var(--success) 20%, transparent);\n}\n[data-theme=\"dark\"] .pdp-in-stock {\n  color: var(--success); background: color-mix(in srgb, var(--success) 8%, transparent); border-color: color-mix(in srgb, var(--success) 20%, transparent);\n}\n/* Unavailable is neutral information, not an error -- muted navy so it\n   doesn't compete with the orange buy action. */\n.pdp-oos {\n  color: rgba(1, 13, 33, 0.58);\n  background: rgba(1, 13, 33, 0.06);\n  border: 1px solid rgba(1, 13, 33, 0.12);\n}\n[data-theme=\"dark\"] .pdp-oos {\n  color: rgba(255, 255, 255, 0.62);\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.12);\n}\n\n.pdp-critical-stock {\n  color: var(--danger);\n  background: color-mix(in srgb, var(--danger) 8%, transparent);\n  border: 1px solid color-mix(in srgb, var(--danger) 20%, transparent);\n}\n\n@keyframes pdp-shiver {\n  0%,12%,100% { transform: translateX(0); }\n  2%  { transform: translateX(-5px) rotate(-0.6deg); }\n  4%  { transform: translateX(5px)  rotate(0.6deg);  }\n  6%  { transform: translateX(-4px) rotate(-0.4deg); }\n  8%  { transform: translateX(4px)  rotate(0.4deg);  }\n  10% { transform: translateX(-2px); }\n}\n.pdp-shiver {\n  display: inline-block;\n  animation: pdp-shiver 5s ease-in-out infinite;\n}\n\n.pdp-low-stock {\n  font-size: 0.78rem; font-weight: 700; color: var(--color-primary);\n  background: rgba(255, 103, 0,0.1); border: 1px solid rgba(255, 103, 0,0.25);\n  padding: 3px 10px; border-radius: var(--radius-xs);\n}\n\n/* Seller info block */\n.pdp-seller-inline {\n  display: flex; align-items: center; gap: 10px; flex-wrap: wrap;\n  background: var(--bg-secondary); border: 1px solid var(--border);\n  border-radius: var(--radius-sm); padding: 10px 14px; margin-bottom: 14px;\n  transition: border-color 150ms;\n}\n.pdp-seller-inline:hover { border-color: var(--accent); }\n.pdp-sil-avatar {\n  width: 36px; height: 36px; border-radius: var(--radius-sm); flex-shrink: 0;\n  background: linear-gradient(135deg, var(--accent-secondary), var(--accent));\n  color: var(--color-brand-white); font-size: 1rem; font-weight: 800;\n  display: flex; align-items: center; justify-content: center;\n}\n.pdp-sil-body { flex: 1; min-width: 0; }\n.pdp-sil-row { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; margin-bottom: 2px; }\n.pdp-sil-label { font-size: 0.78rem; color: var(--text-tertiary); }\n.pdp-sil-name { font-size: 0.88rem; font-weight: 700; color: var(--text-primary); }\n.pdp-sil-verified {\n  background: var(--success); color: var(--color-text-on-secondary);\n  font-size: 0.62rem; font-weight: 800; letter-spacing: 0.05em;\n  padding: 2px 6px; border-radius: var(--radius-xs);\n}\n.pdp-sil-meta { display: flex; align-items: center; gap: 5px; }\n.pdp-sil-stars { color: var(--color-primary); font-size: 0.75rem; letter-spacing: 1px; }\n.pdp-sil-rating { font-size: 0.75rem; color: var(--text-secondary); }\n.pdp-sil-store {\n  background: none; border: 1.5px solid var(--accent); color: var(--accent);\n  font-size: 0.78rem; font-weight: 700; padding: 6px 14px; border-radius: var(--radius-xs);\n  cursor: pointer; transition: all 150ms; white-space: nowrap; flex-shrink: 0;\n}\n.pdp-sil-store:hover { background: var(--accent); color: var(--color-text-on-secondary); }\n\n/* Color variants */\n.pdp-colors-wrap { margin-bottom: 14px; }\n.pdp-colors-label { font-size: 0.84rem; color: var(--text-secondary); margin-bottom: 8px; }\n.pdp-swatches { display: flex; gap: var(--space-1); flex-wrap: wrap; }\n.pdp-swatch {\n  width: 30px; height: 30px; border-radius: 50%;\n  border: 3px solid transparent; cursor: pointer;\n  transition: all 150ms; outline: 2px solid var(--border);\n}\n.pdp-swatch:hover { transform: scale(1.12); }\n.pdp-swatch.active { border-color: var(--color-brand-white); outline-color: var(--accent); transform: scale(1.12); }\n\n/* Quantity */\n.pdp-qty-row {\n  display: flex; align-items: center; gap: 12px; margin-bottom: 0; flex-wrap: wrap;\n}\n.pdp-qty-label { font-size: 0.88rem; color: var(--text-secondary); font-weight: 500; }\n.pdp-qty-ctrl {\n  display: flex; align-items: center;\n  border: 1.5px solid var(--border); border-radius: var(--radius-sm); overflow: hidden;\n}\n.pdp-qty-btn {\n  background: var(--bg-secondary); border: none;\n  width: 38px; height: 38px; font-size: 1.15rem; font-weight: 700;\n  cursor: pointer; color: var(--text-primary); transition: all 120ms;\n}\n.pdp-qty-btn:hover { background: var(--accent); color: var(--color-text-on-secondary); }\n.pdp-qty-val {\n  min-width: 42px; text-align: center; font-weight: 700; font-size: 0.95rem;\n  border-left: 1.5px solid var(--border); border-right: 1.5px solid var(--border);\n  padding: 0 8px; line-height: 38px; color: var(--text-primary);\n}\n\n/* ════ RIGHT: Purchase sidebar ════ */\n.pdp-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  position: sticky;\n  /* Product pages use the compact 60px SubPageHeader. The global\n     --topbar-h measures the much taller storefront navigation and was\n     forcing this column down by more than 100px. */\n  top: 72px;\n  align-self: start;\n  /* Use the empty space beside the breadcrumb so the purchase controls\n     align with the top edge of the product content. */\n  margin-top: -30px;\n}\n\n/* Delivery card */\n.pdp-delivery-card {\n  background: var(--bg-secondary); border: 1px solid var(--border);\n  border-radius: var(--radius-sm); padding: 14px 16px;\n  box-shadow: var(--shadow-card);\n}\n.pdp-del-hd {\n  display: flex; align-items: center; justify-content: space-between;\n  font-size: 0.82rem; color: var(--text-secondary); margin-bottom: 12px;\n}\n.pdp-del-hd strong { color: var(--text-primary); }\n.pdp-change-btn {\n  background: none; border: none; color: var(--accent);\n  font-size: 0.8rem; font-weight: 600; cursor: pointer; padding: 0;\n}\n.pdp-change-btn:hover { text-decoration: underline; }\n.pdp-del-section-title {\n  font-size: 0.82rem; font-weight: 700; color: var(--text-primary); margin-bottom: 8px;\n}\n.pdp-del-opt {\n  display: flex; align-items: flex-start; gap: 10px;\n  padding: var(--space-1); border-radius: var(--radius-sm); cursor: pointer; transition: background 120ms;\n}\n.pdp-del-opt:hover { background: var(--bg-tertiary); }\n.pdp-del-selected { background: rgba(59, 130, 246,0.06); }\n[data-theme=\"dark\"] .pdp-del-selected { background: rgba(59, 130, 246,0.08); }\n.pdp-del-opt input[type=\"radio\"] { margin-top: 3px; accent-color: var(--accent); flex-shrink: 0; }\n.pdp-del-opt-body { flex: 1; }\n.pdp-del-name { font-size: 0.82rem; font-weight: 600; color: var(--text-primary); margin: 0; }\n.pdp-del-free { color: var(--color-secondary-text); font-weight: 800; margin-left: 5px; font-size: 0.78rem; }\n.pdp-del-date { font-size: 0.74rem; color: var(--text-secondary); margin: 2px 0 0; }\n.pdp-del-price { font-size: 0.85rem; font-weight: 700; color: var(--text-primary); flex-shrink: 0; }\n\n/* Size chip buttons (used within .pdp-variant-swatches, above) */\n.pdp-size-chip {\n  min-width: 42px; height: 38px; padding: 0 12px;\n  border: 1px solid var(--border); border-radius: var(--radius-sm);\n  background: var(--bg-primary); color: var(--text-primary);\n  font-size: 0.85rem; font-weight: 600; cursor: pointer; transition: all 150ms;\n}\n.pdp-size-chip:hover { border-color: var(--accent); }\n.pdp-size-chip.active { border-color: var(--accent); background: var(--accent); color: var(--color-text-on-secondary); }\n.pdp-size-chip.oos {\n  cursor: not-allowed; color: var(--text-tertiary); background: var(--bg-secondary);\n  text-decoration: line-through; opacity: 0.6;\n}\n.pdp-size-chip.oos:hover { border-color: var(--border); }\n.pdp-size-error { font-size: 0.78rem; color: var(--danger); font-weight: 600; margin: 8px 0 0; }\n\n/* CTA buttons */\n.pdp-sidebar-actions { display: flex; flex-direction: column; gap: var(--space-1); }\n\n/* Back-in-stock notify form */\n.pdp-notify-wrap {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 16px;\n}\n.pdp-notify-form { display: flex; flex-direction: column; gap: 10px; }\n.pdp-notify-label { font-size: 0.85rem; font-weight: 600; color: var(--text-primary); margin: 0; }\n.pdp-notify-email-hint { font-size: 0.8rem; color: var(--text-secondary); margin: 0; }\n.pdp-notify-input {\n  width: 100%; padding: 10px 12px; border: 1px solid var(--border);\n  border-radius: var(--radius-sm); background: var(--bg-primary);\n  color: var(--text-primary); font-size: 0.9rem; box-sizing: border-box;\n}\n.pdp-notify-input:focus { outline: none; border-color: var(--accent); }\n.pdp-notify-btn {\n  width: 100%; padding: 12px; border: none; border-radius: var(--radius-sm);\n  background: var(--accent); color: var(--color-text-on-secondary); font-weight: 700; font-size: 0.95rem;\n  cursor: pointer; transition: background 150ms;\n}\n.pdp-notify-btn:hover:not(:disabled) { background: var(--accent-hover); }\n.pdp-notify-btn:disabled { opacity: 0.6; cursor: not-allowed; }\n.pdp-notify-sent {\n  display: flex; align-items: center; gap: 8px;\n  color: var(--success); font-weight: 600; font-size: 0.9rem;\n}\n.pdp-notify-sent span { font-size: 1.1rem; }\n.pdp-notify-error { font-size: 0.8rem; color: var(--color-primary); margin: 0; }\n\n.pdp-add-cart-btn {\n  width: 100%; padding: 15px;\n  background: linear-gradient(135deg, var(--accent), var(--accent-hover)); color: var(--color-brand-white);\n  border: none; border-radius: var(--radius-sm);\n  font-size: 1rem; font-weight: 700; letter-spacing: 0.02em;\n  cursor: pointer; transition: all 150ms;\n  box-shadow: 0 4px 14px rgba(59, 130, 246,0.35);\n}\n.pdp-add-cart-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, var(--accent-hover), var(--color-secondary-hover));\n  box-shadow: 0 6px 20px rgba(59, 130, 246,0.45); transform: translateY(-1px);\n}\n.pdp-add-cart-btn:active:not(:disabled) { transform: translateY(0); }\n.pdp-add-cart-btn:disabled { opacity: 0.45; cursor: not-allowed; box-shadow: none; }\n\n.pdp-buy-now-btn {\n  width: 100%; padding: 15px;\n  background: linear-gradient(135deg, var(--color-primary), color-mix(in srgb, var(--color-primary) 80%, var(--color-brand-navy))); color: var(--color-brand-white);\n  border: none; border-radius: var(--radius-sm);\n  font-size: 1rem; font-weight: 700; letter-spacing: 0.02em;\n  cursor: pointer; transition: all 150ms;\n  box-shadow: 0 4px 14px rgba(255, 103, 0,0.35);\n}\n.pdp-buy-now-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, var(--color-primary), color-mix(in srgb, var(--color-primary) 80%, var(--color-brand-navy)));\n  box-shadow: 0 6px 20px rgba(255, 103, 0,0.45); transform: translateY(-1px);\n}\n.pdp-buy-now-btn:active:not(:disabled) { transform: translateY(0); }\n.pdp-buy-now-btn:disabled { opacity: 0.45; cursor: not-allowed; box-shadow: none; }\n\n/* Trust benefits 2x2 */\n.pdp-benefits-card {\n  background: var(--bg-secondary); border: 1px solid var(--border);\n  border-radius: var(--radius-sm); padding: 12px 14px;\n  display: grid; grid-template-columns: 1fr 1fr; gap: 10px 8px;\n  box-shadow: var(--shadow-card);\n}\n.pdp-benefit-item { display: flex; align-items: flex-start; gap: var(--space-1); }\n.pdp-benefit-icon { font-size: 1.05rem; flex-shrink: 0; margin-top: 1px; }\n.pdp-benefit-title { font-size: 0.78rem; font-weight: 700; color: var(--text-primary); margin: 0; }\n.pdp-benefit-sub { font-size: 0.68rem; color: var(--text-secondary); margin: 0; }\n\n/* Offer card */\n.pdp-offer-card {\n  background: linear-gradient(135deg, rgba(59, 130, 246,0.06), color-mix(in srgb, var(--accent-secondary) 6%, transparent));\n  border: 1px solid rgba(59, 130, 246,0.18); border-radius: var(--radius-sm); padding: 12px 14px;\n}\n[data-theme=\"dark\"] .pdp-offer-card {\n  background: linear-gradient(135deg, rgba(59, 130, 246,0.1), color-mix(in srgb, var(--accent-secondary) 10%, transparent));\n  border-color: rgba(59, 130, 246,0.22);\n}\n.pdp-offer-title { font-size: 0.88rem; font-weight: 700; color: var(--text-primary); margin: 0 0 3px; }\n.pdp-offer-sub { font-size: 0.78rem; color: var(--text-secondary); margin: 0 0 8px; }\n.pdp-offer-code-row {\n  display: flex; align-items: center; gap: var(--space-1);\n  background: var(--bg-secondary); border: 1.5px dashed var(--accent);\n  border-radius: var(--radius-xs); padding: 6px 10px; margin-bottom: 6px;\n  font-size: 0.82rem; color: var(--text-secondary);\n}\n.pdp-offer-code { color: var(--accent); font-weight: 900; font-size: 0.92rem; letter-spacing: 0.06em; }\n.pdp-offer-copy {\n  background: none; border: none; cursor: pointer; color: var(--text-secondary);\n  margin-left: auto; font-size: 0.9rem; transition: color 150ms;\n}\n.pdp-offer-copy:hover { color: var(--accent); }\n.pdp-offer-timer { font-size: 0.75rem; color: var(--text-secondary); margin: 0; }\n\n/* Social sharing */\n.pdp-share-row { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; flex-wrap: wrap; }\n.pdp-share-label { font-size: 0.78rem; color: var(--text-muted); font-weight: 600; }\n.pdp-share-btn { display: inline-flex; align-items: center; gap: 5px; padding: 4px 10px; border-radius: 6px; font-size: 0.75rem; font-weight: 600; cursor: pointer; text-decoration: none; border: 1px solid var(--border); background: var(--bg-secondary); color: var(--text-secondary); transition: all 0.15s; }\n.pdp-share-btn:hover { border-color: var(--accent); color: var(--accent); }\n.pdp-share-wa { color: var(--success) !important; border-color: color-mix(in srgb, var(--success) 30%, transparent) !important; background: color-mix(in srgb, var(--success) 6%, transparent) !important; }\n.pdp-share-wa:hover { background: color-mix(in srgb, var(--success) 12%, transparent) !important; }\n.pdp-share-x { color: var(--text-primary) !important; }\n\n/* Buyer protection badge */\n.pdp-buyer-protection {\n  margin-top: 12px; padding: 12px 14px;\n  border: 1px solid color-mix(in srgb, var(--success) 25%, transparent); border-radius: var(--radius-sm);\n  background: color-mix(in srgb, var(--success) 5%, transparent);\n}\n[data-theme=\"dark\"] .pdp-buyer-protection {\n  background: color-mix(in srgb, var(--success) 8%, transparent); border-color: color-mix(in srgb, var(--success) 20%, transparent);\n}\n.pdp-bp-header { display: flex; align-items: center; gap: 7px; font-size: 0.85rem; font-weight: 700; color: var(--success); margin-bottom: 7px; }\n[data-theme=\"dark\"] .pdp-bp-header { color: var(--success); }\n.pdp-bp-list { margin: 0; padding: 0 0 0 20px; list-style: disc; }\n.pdp-bp-list li { font-size: 0.78rem; color: var(--text-secondary); line-height: 1.7; }\n\n/* ════ Feature Strip — full width, immediately below main ════ */\n.pdp-feature-strip {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 0;\n  border: 1px solid var(--border); border-radius: var(--radius-md);\n  overflow: hidden; background: var(--bg-secondary);\n  margin-bottom: 24px;\n  box-shadow: var(--shadow-card);\n}\n.pdp-fs-item {\n  display: flex; flex-direction: column; align-items: center;\n  gap: 5px; padding: 18px 10px; text-align: center;\n  border-right: 1px solid var(--border);\n  transition: background 150ms;\n}\n.pdp-fs-item:last-child { border-right: none; }\n.pdp-fs-item:hover { background: var(--bg-tertiary); }\n.pdp-fs-icon { font-size: 1.6rem; line-height: 1; margin-bottom: 2px; }\n.pdp-fs-title {\n  font-size: 0.8rem; font-weight: 700; color: var(--text-primary);\n  margin: 0; line-height: 1.3;\n}\n.pdp-fs-sub { font-size: 0.7rem; color: var(--text-secondary); margin: 0; }\n\n/* Legacy hl-bar (kept for backwards compat) */\n.pdp-hl-bar {\n  display: grid; grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));\n  gap: 0; border: 1px solid var(--border); border-radius: var(--radius-sm);\n  overflow: hidden; background: var(--bg-secondary); margin-bottom: 20px;\n  box-shadow: var(--shadow-card);\n}\n.pdp-hl-item {\n  display: flex; align-items: center; gap: var(--space-1);\n  padding: 12px 14px; border-right: 1px solid var(--border);\n}\n.pdp-hl-item:last-child { border-right: none; }\n.pdp-hl-icon { font-size: 1.2rem; flex-shrink: 0; }\n.pdp-hl-text { font-size: 0.78rem; font-weight: 600; color: var(--text-secondary); }\n\n/* ════ Frequently Bought Together ════ */\n.pdp-fbt { margin-bottom: 24px; }\n.pdp-section-h2 {\n  font-size: 1.05rem; font-weight: 800; margin: 0 0 12px;\n  color: var(--text-primary); letter-spacing: -0.01em;\n}\n.pdp-fbt-row {\n  display: flex; align-items: center; flex-wrap: wrap; gap: 12px;\n  background: var(--bg-secondary); border: 1px solid var(--border);\n  border-radius: var(--radius-sm); padding: 18px 22px;\n  box-shadow: var(--shadow-card);\n}\n.pdp-fbt-item { display: flex; align-items: center; }\n.pdp-fbt-plus { font-size: 1.5rem; color: var(--text-tertiary); margin: 0 14px; }\n.pdp-fbt-card { display: flex; flex-direction: column; align-items: center; gap: 5px; width: 148px; }\n.pdp-fbt-img {\n  width: 92px; height: 92px; object-fit: contain;\n  border-radius: var(--radius-sm); background: var(--bg-tertiary); padding: 6px;\n}\n.pdp-fbt-name {\n  font-size: 0.75rem; color: var(--text-secondary); text-align: center;\n  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;\n}\n.pdp-fbt-rating-row { display: flex; align-items: center; justify-content: center; gap: 4px; }\n.pdp-fbt-price { font-size: 0.88rem; font-weight: 700; color: var(--text-primary); }\n.pdp-fbt-total-col { display: flex; flex-direction: column; align-items: flex-start; gap: var(--space-1); margin-left: auto; }\n.pdp-fbt-eq { font-size: 1.5rem; color: var(--text-tertiary); }\n.pdp-fbt-total-label { font-size: 0.9rem; color: var(--text-secondary); margin: 0; }\n.pdp-fbt-save { font-size: 0.84rem; font-weight: 600; margin: 0; }\n.pdp-fbt-add-all {\n  background: linear-gradient(135deg, var(--accent), var(--accent-hover)); color: var(--color-brand-white);\n  border: none; border-radius: var(--radius-sm); padding: 11px 20px;\n  font-size: 0.88rem; font-weight: 700; cursor: pointer;\n  transition: all 150ms; white-space: nowrap;\n  box-shadow: 0 3px 10px rgba(59, 130, 246,0.28);\n}\n.pdp-fbt-add-all:hover {\n  background: linear-gradient(135deg, var(--accent-hover), var(--color-secondary-hover));\n  transform: translateY(-1px);\n}\n\n/* ════ Tabs ════ */\n.pdp-tabs-section { margin-bottom: 24px; }\n.pdp-tabs {\n  display: flex; gap: 0;\n  border-bottom: 2px solid var(--border);\n  overflow-x: auto; scrollbar-width: none;\n  position: sticky; top: 0; z-index: 20;\n  background: var(--bg-primary); padding-top: 4px;\n}\n.pdp-tabs::-webkit-scrollbar { display: none; }\n.pdp-tab {\n  background: none; border: none; border-bottom: 2.5px solid transparent;\n  margin-bottom: -2px; padding: 12px 20px;\n  font-size: 0.88rem; font-weight: 500; color: var(--text-secondary);\n  cursor: pointer; white-space: nowrap;\n  transition: color 150ms, border-color 150ms;\n}\n.pdp-tab:hover { color: var(--accent); }\n.pdp-tab.active { color: var(--accent); font-weight: 700; border-bottom-color: var(--accent); }\n.pdp-tab-body {\n  background: var(--bg-secondary); border: 1px solid var(--border);\n  border-top: none; border-radius: 0 0 var(--radius-sm) var(--radius-sm);\n  padding: 22px 26px;\n  box-shadow: var(--shadow-card);\n}\n.pdp-tab-desc p { font-size: 0.9rem; color: var(--text-secondary); line-height: 1.7; margin-bottom: 14px; }\n.pdp-desc-list { padding-left: 20px; margin: 0; }\n.pdp-desc-list li { font-size: 0.88rem; color: var(--text-secondary); line-height: 1.7; margin-bottom: 6px; }\n.pdp-qa-empty { text-align: center; padding: 32px 20px; font-size: 0.88rem; color: var(--text-secondary); }\n.pdp-qa-section { display: flex; flex-direction: column; gap: 24px; }\n.pdp-qa-form { display: flex; flex-direction: column; gap: 10px; padding: 16px; background: var(--bg-secondary); border-radius: 12px; border: 1px solid var(--border); }\n.pdp-qa-form-title { margin: 0; font-size: 0.92rem; font-weight: 700; color: var(--text-primary); }\n.pdp-qa-input { width: 100%; padding: 10px 12px; border-radius: 8px; border: 1px solid var(--border); background: var(--bg-primary); color: var(--text-primary); font-size: 0.88rem; resize: vertical; box-sizing: border-box; font-family: inherit; }\n.pdp-qa-anon-row { display: flex; gap: 8px; flex-wrap: wrap; }\n.pdp-qa-name-input { flex: 1; min-width: 140px; padding: 8px 12px; border-radius: 8px; border: 1px solid var(--border); background: var(--bg-primary); color: var(--text-primary); font-size: 0.85rem; }\n.pdp-qa-submit-btn { align-self: flex-start; padding: 8px 18px; borderRadius: 8px; background: var(--accent); color: var(--color-text-on-secondary); border: none; font-weight: 700; cursor: pointer; font-size: 0.85rem; border-radius: 8px; }\n.pdp-qa-submit-btn:disabled { opacity: 0.6; cursor: not-allowed; }\n.pdp-qa-msg { font-size: 0.82rem; margin: 0; }\n.pdp-qa-msg--ok { color: var(--success); }\n.pdp-qa-msg--err { color: var(--danger); }\n.pdp-qa-list { display: flex; flex-direction: column; gap: 16px; }\n.pdp-qa-item { border: 1px solid var(--border); border-radius: 12px; overflow: hidden; }\n.pdp-qa-q-row, .pdp-qa-a-row { display: flex; gap: 12px; padding: 12px 16px; align-items: flex-start; }\n.pdp-qa-a-row { background: var(--bg-secondary); border-top: 1px solid var(--border); }\n.pdp-qa-a-pending { opacity: 0.6; }\n.pdp-qa-badge { width: 24px; height: 24px; border-radius: 6px; display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 0.8rem; flex-shrink: 0; margin-top: 2px; }\n.pdp-qa-badge--q { background: var(--color-secondary-soft); color: var(--color-secondary-hover); }\n.pdp-qa-badge--a { background: var(--color-secondary-soft); color: var(--success); }\n[data-theme=\"dark\"] .pdp-qa-badge--q { background: rgba(59, 130, 246,0.2); }\n[data-theme=\"dark\"] .pdp-qa-badge--a { background: color-mix(in srgb, var(--success) 20%, transparent); }\n.pdp-qa-text { margin: 0 0 3px; font-size: 0.88rem; color: var(--text-primary); line-height: 1.5; }\n.pdp-qa-text--muted { color: var(--text-muted); font-style: italic; }\n.pdp-qa-meta { margin: 0; font-size: 0.73rem; color: var(--text-muted); }\n\n/* ════ Related products ════ */\n.pdp-related { margin-bottom: 32px; }\n.pdp-related-grid {\n  display: grid; grid-template-columns: repeat(auto-fill, minmax(190px, 1fr)); gap: var(--space-2);\n}\n.pdp-related-card {\n  position: relative;\n  background: var(--bg-secondary); border: 1px solid var(--border);\n  border-radius: var(--radius-sm); overflow: hidden; cursor: pointer;\n  box-shadow: var(--shadow-card);\n  transition: transform 200ms, box-shadow 200ms;\n}\n.pdp-related-card:hover { transform: translateY(-4px); box-shadow: 0 10px 28px rgba(1, 13, 33,0.12); }\n.pdp-related-card img {\n  width: 100%; height: 150px; object-fit: contain;\n  padding: 12px; background: var(--bg-tertiary);\n}\n.pdp-related-body { padding: 12px; display: flex; flex-direction: column; gap: 6px; }\n.pdp-related-body h4 {\n  font-size: 0.83rem; font-weight: 600; margin: 0; color: var(--text-primary);\n  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;\n}\n.pdp-related-rating-row { display: flex; align-items: center; gap: 5px; }\n.pdp-related-seller { font-size: 0.75rem; color: var(--text-secondary); margin: 0; }\n.pdp-related-seller-name { color: var(--accent); font-weight: 600; }\n[data-theme=\"dark\"] .pdp-related-seller-name { color: var(--color-secondary-soft); }\n.pdp-related-price-row { display: flex; align-items: baseline; gap: 6px; flex-wrap: wrap; }\n.pdp-related-price { font-size: 0.92rem; font-weight: 700; color: var(--text-primary); margin: 0; }\n.pdp-related-original { font-size: 0.75rem; color: var(--text-tertiary); text-decoration: line-through; font-weight: 500; }\n.pdp-related-stock-row { display: flex; }\n\n/* ════ Responsive ════ */\n@media (max-width: 1280px) {\n  .pdp-main { grid-template-columns: 380px 1fr 280px; gap: 20px; }\n}\n@media (max-width: 1100px) {\n  .pdp-main { grid-template-columns: 340px 1fr; }\n  .pdp-sidebar { display: none; }\n}\n@media (max-width: 900px) {\n  .pdp-main { grid-template-columns: 300px 1fr; gap: var(--space-2); }\n  .pdp-title { font-size: 1.4rem; }\n  .pdp-price { font-size: 2rem; }\n  .pdp-feature-strip { grid-template-columns: repeat(3, 1fr); }\n}\n@media (max-width: 768px) {\n  .pdp-page { padding: 12px 14px 40px; }\n  .pdp-main { grid-template-columns: 1fr; gap: var(--space-2); }\n  .pdp-sidebar { display: flex; position: static; margin-top: 0; }\n  .pdp-gallery { flex-direction: column-reverse; }\n  .pdp-thumbs { flex-direction: row; width: 100%; }\n  .pdp-thumb { width: 58px; height: 58px; }\n  .pdp-main-img-stage { min-height: 280px; max-height: 340px; }\n  .pdp-main-img { height: 260px; }\n  .pdp-title { font-size: 1.3rem; }\n  .pdp-price { font-size: 1.8rem; }\n  .pdp-feature-strip { grid-template-columns: repeat(3, 1fr); }\n  .pdp-tabs { position: static; }\n  .pdp-quick-trust { grid-template-columns: 1fr 1fr; }\n\n  /* Relax the boxed-card feel -- let the summary and description content\n     sit directly on the page background instead of in their own card. */\n  .pdp-fbt-row {\n    background: transparent;\n    border: none;\n    box-shadow: none;\n    padding: 0;\n  }\n  .pdp-tab-body {\n    background: transparent;\n    border: none;\n    box-shadow: none;\n    padding: 16px 0 0;\n  }\n}\n@media (max-width: 480px) {\n  .pdp-feature-strip { grid-template-columns: repeat(2, 1fr); }\n  .pdp-main-img { height: 230px; }\n  .pdp-fbt-row { flex-direction: column; align-items: flex-start; }\n  .pdp-fbt-total-col { margin-left: 0; }\n  .pdp-quick-trust { grid-template-columns: 1fr; }\n}\n\n/* ════════════════════════════════════════════════════════\n   ORDER HISTORY PAGE — modern table design\n   ════════════════════════════════════════════════════════ */\n.oh-page {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 24px 24px 56px;\n  background: var(--bg-primary);\n  animation: slideIn 300ms ease-out;\n}\n\n/* Header */\n.oh-page-header {\n  display: flex; align-items: flex-start; justify-content: space-between;\n  margin-bottom: 24px; gap: var(--space-2); flex-wrap: wrap;\n}\n.oh-page-title {\n  font-size: 1.8rem; font-weight: 800; color: var(--text-primary);\n  margin: 0 0 6px; letter-spacing: -0.02em;\n}\n.oh-breadcrumb {\n  display: flex; align-items: center; gap: 6px;\n  font-size: 0.82rem; color: var(--text-secondary);\n}\n.oh-bc-sep { color: var(--text-tertiary); }\n.oh-bc-active { color: var(--text-primary); font-weight: 500; }\n.oh-export-btn {\n  display: flex; align-items: center; gap: var(--space-1);\n  background: var(--bg-secondary); border: 1px solid var(--border);\n  color: var(--text-primary); font-size: 0.85rem; font-weight: 600;\n  padding: 10px 18px; border-radius: var(--radius-sm); cursor: pointer;\n  transition: all 150ms; white-space: nowrap;\n}\n.oh-export-btn:hover { border-color: var(--accent); color: var(--accent); }\n\n/* Stats cards */\n.oh-stats-grid {\n  display: grid; grid-template-columns: repeat(6, 1fr); gap: 12px;\n  margin-bottom: 20px;\n}\n.oh-stat-card {\n  display: flex; align-items: center; gap: 12px;\n  background: var(--bg-secondary); border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm); padding: 14px 16px;\n  box-shadow: var(--shadow-card);\n  cursor: pointer; transition: all 150ms; text-align: left;\n}\n.oh-stat-card:hover { border-color: var(--accent); transform: translateY(-1px); }\n.oh-stat-card.active { border-color: var(--accent); background: rgba(59, 130, 246,0.06); }\n[data-theme=\"dark\"] .oh-stat-card.active { background: rgba(59, 130, 246,0.08); }\n.oh-stat-icon {\n  width: 42px; height: 42px; border-radius: var(--radius-sm); flex-shrink: 0;\n  display: flex; align-items: center; justify-content: center;\n  font-size: 1.1rem;\n}\n.oh-stat-body { min-width: 0; }\n.oh-stat-label { font-size: 0.75rem; color: var(--text-secondary); margin: 0 0 2px; white-space: nowrap; }\n.oh-stat-count { font-size: 1.4rem; font-weight: 800; color: var(--text-primary); margin: 0; line-height: 1.1; }\n.oh-stat-sub { font-size: 0.72rem; color: var(--text-secondary); margin: 2px 0 0; }\n\n/* Filters bar */\n.oh-filters-bar {\n  display: flex; align-items: center; gap: 12px;\n  margin-bottom: 20px; flex-wrap: wrap;\n}\n.oh-search-wrap {\n  flex: 1; min-width: 240px;\n  display: flex; align-items: center; gap: 10px;\n  background: var(--bg-secondary); border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm); padding: 0 14px;\n  transition: border-color 150ms;\n}\n.oh-search-wrap:focus-within { border-color: var(--accent); }\n.oh-search-icon { font-size: 0.95rem; color: var(--text-tertiary); flex-shrink: 0; }\n.oh-search-input {\n  background: none; border: none; outline: none;\n  font-size: 0.88rem; color: var(--text-primary);\n  width: 100%; height: 42px; padding: 0;\n}\n.oh-search-input::placeholder { color: var(--text-tertiary); }\n.oh-filter-right { display: flex; align-items: center; gap: 10px; }\n.oh-date-select {\n  background: var(--bg-secondary); border: 1.5px solid var(--border);\n  color: var(--text-primary); font-size: 0.85rem;\n  padding: 10px 14px; border-radius: var(--radius-sm); cursor: pointer;\n  outline: none; transition: border-color 150ms;\n}\n.oh-date-select:focus { border-color: var(--accent); }\n.oh-filter-btn {\n  display: flex; align-items: center; gap: 7px;\n  background: var(--bg-secondary); border: 1.5px solid var(--border);\n  color: var(--text-primary); font-size: 0.85rem; font-weight: 600;\n  padding: 10px 16px; border-radius: var(--radius-sm); cursor: pointer;\n  transition: all 150ms;\n}\n.oh-filter-btn:hover { border-color: var(--accent); color: var(--accent); }\n\n/* Empty state */\n.oh-empty {\n  display: flex; flex-direction: column; align-items: center;\n  padding: 64px 20px; text-align: center;\n}\n.oh-empty-icon { font-size: 3rem; margin-bottom: 12px; }\n.oh-empty-title { font-size: 1.1rem; font-weight: 700; color: var(--text-primary); margin: 0 0 6px; }\n.oh-empty-sub { font-size: 0.88rem; color: var(--text-secondary); margin: 0; }\n\n/* Table wrapper */\n.oh-table-wrap {\n  background: var(--bg-secondary); border: 1px solid var(--border);\n  border-radius: var(--radius-md); overflow: hidden; margin-bottom: 20px;\n  box-shadow: var(--shadow-card);\n}\n\n/* Table header row */\n.oh-table-header {\n  display: grid;\n  grid-template-columns: 140px 1fr 120px 140px 170px 180px;\n  gap: 0;\n  background: var(--bg-tertiary); border-bottom: 1px solid var(--border);\n  padding: 0;\n}\n.oh-th {\n  font-size: 0.75rem; font-weight: 700; color: var(--text-secondary);\n  text-transform: uppercase; letter-spacing: 0.06em;\n  padding: 12px 16px;\n}\n\n/* Row wrapper (holds row + optional expand panel) */\n.oh-row-wrap { border-bottom: 1px solid var(--border); transition: background var(--dur-base) var(--ease-in-out), box-shadow var(--dur-base) var(--ease-in-out), transform var(--dur-base) var(--ease-in-out); position: relative; z-index: 1; }\n.oh-row-wrap:last-child { border-bottom: none; }\n.oh-row-wrap:hover { background: rgba(59, 130, 246,0.02); box-shadow: var(--shadow-card); transform: translateY(-1px); z-index: 2; }\n.oh-row-wrap.oh-row-expanded { background: rgba(59, 130, 246,0.03); }\n\n/* Data row */\n.oh-row {\n  display: grid;\n  grid-template-columns: 140px 1fr 120px 140px 170px 180px;\n  gap: 0; align-items: center;\n}\n\n/* Cells */\n.oh-cell { padding: 16px 16px; }\n.oh-cell-label {\n  font-size: 0.7rem; font-weight: 600; color: var(--text-tertiary);\n  text-transform: uppercase; letter-spacing: 0.06em; margin: 0 0 4px;\n}\n\n/* Order ID cell */\n.oh-order-id { font-size: 0.88rem; font-weight: 700; color: var(--accent); margin: 0; }\n.oh-order-date { font-size: 0.75rem; color: var(--text-secondary); margin: 0; line-height: 1.4; }\n\n/* Product cell */\n.oh-cell-product { display: flex; align-items: center; gap: 12px; }\n.oh-prod-img {\n  width: 60px; height: 60px; object-fit: contain;\n  border-radius: var(--radius-sm); background: var(--bg-tertiary);\n  border: 1px solid var(--border); padding: 4px; flex-shrink: 0;\n}\n.oh-prod-img-placeholder {\n  width: 60px; height: 60px; border-radius: var(--radius-sm);\n  background: var(--bg-tertiary); border: 1px solid var(--border);\n  display: flex; align-items: center; justify-content: center;\n  font-size: 1.4rem; flex-shrink: 0;\n}\n.oh-prod-info { min-width: 0; }\n.oh-prod-name {\n  font-size: 0.88rem; font-weight: 600; color: var(--text-primary);\n  margin: 0 0 3px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;\n  max-width: 220px;\n}\n.oh-prod-seller { font-size: 0.75rem; color: var(--text-secondary); margin: 0 0 3px; }\n.oh-prod-price { font-size: 0.82rem; color: var(--text-secondary); margin: 0; }\n.oh-prod-qty { color: var(--text-tertiary); }\n.oh-prod-more { font-size: 0.72rem; color: var(--accent); margin: 2px 0 0; font-weight: 600; }\n\n/* Total cell */\n.oh-amount { font-size: 1rem; font-weight: 800; color: var(--text-primary); margin: 4px 0 6px; }\n.oh-paid-badge {\n  display: inline-block;\n  background: color-mix(in srgb, var(--success) 12%, transparent); border: 1px solid color-mix(in srgb, var(--success) 30%, transparent);\n  color: var(--success); font-size: 0.72rem; font-weight: 700;\n  padding: 2px 9px; border-radius: var(--radius-xs); letter-spacing: 0.04em;\n}\n[data-theme=\"dark\"] .oh-paid-badge { color: var(--success); border-color: color-mix(in srgb, var(--success) 30%, transparent); background: color-mix(in srgb, var(--success) 10%, transparent); }\n.oh-cod-badge {\n  background: rgba(255, 103, 0,0.12); border-color: rgba(255, 103, 0,0.3);\n  color: var(--color-primary);\n}\n[data-theme=\"dark\"] .oh-cod-badge { color: var(--color-primary); border-color: rgba(255, 103, 0,0.3); background: rgba(255, 103, 0,0.1); }\n\n/* Payment method cell */\n.oh-pay-method { display: flex; align-items: center; gap: var(--space-1); margin-top: 4px; }\n.oh-pay-icon {\n  display: inline-flex; align-items: center; justify-content: center;\n  font-size: 0.65rem; font-weight: 900; letter-spacing: 0.04em;\n  width: 36px; height: 24px; border-radius: var(--radius-xs);\n  /* A flex item with a width still shrinks -- flex-shrink defaults to 1, and\n     the width is only a starting size. In a narrow column the COD/PAY chip was\n     squeezed to 31.86px against its declared 36px, which reads as a slightly\n     squashed badge rather than as an obvious bug, so it survived a long time. */\n  flex-shrink: 0;\n}\n.oh-pay-visa   { background: #1a1f71; color: var(--color-brand-white); }\n.oh-pay-mc     { background: linear-gradient(135deg, #eb001b, #f79e1b); color: var(--color-brand-white); }\n.oh-pay-paypal { background: #003087; color: var(--color-brand-white); font-size: 0.8rem; }\n.oh-pay-masked { font-size: 0.82rem; color: var(--text-secondary); letter-spacing: 0.04em; }\n\n/* Status cell */\n.oh-status-badge {\n  display: inline-block;\n  font-size: 0.75rem; font-weight: 700; letter-spacing: 0.04em;\n  padding: 4px 12px; border-radius: var(--radius-xs); margin: 4px 0 6px;\n}\n.oh-status-sub { font-size: 0.72rem; color: var(--text-secondary); margin: 0; line-height: 1.5; }\n\n/* Actions cell */\n.oh-cell-actions { display: flex; flex-direction: column; gap: var(--space-1); padding: 12px 16px; }\n.oh-view-btn {\n  width: 100%; padding: 9px 16px;\n  background: var(--accent); color: var(--color-text-on-secondary);\n  border: none; border-radius: var(--radius-sm);\n  font-size: 0.82rem; font-weight: 700; cursor: pointer;\n  transition: all 150ms;\n}\n.oh-view-btn:hover { background: var(--accent-hover); transform: translateY(-1px); }\n.oh-cancel-btn {\n  width: 100%; padding: 8px 16px;\n  background: color-mix(in srgb, var(--danger) 8%, transparent); color: var(--danger);\n  border: 1px solid color-mix(in srgb, var(--danger) 30%, transparent); border-radius: var(--radius-sm);\n  font-size: 0.82rem; font-weight: 600; cursor: pointer;\n  transition: all 150ms;\n}\n.oh-cancel-btn:hover { background: color-mix(in srgb, var(--danger) 15%, transparent); }\n.oh-buy-again-btn {\n  width: 100%; padding: 8px 16px;\n  background: var(--bg-tertiary); color: var(--text-primary);\n  border: 1px solid var(--border); border-radius: var(--radius-sm);\n  font-size: 0.82rem; font-weight: 600; cursor: pointer;\n  transition: all 150ms;\n}\n.oh-buy-again-btn:hover { border-color: var(--accent); color: var(--accent); }\n\n/* Detail expand panel */\n.oh-detail-panel {\n  padding: 0 20px 20px;\n  border-top: 1px solid var(--border);\n  background: var(--bg-primary);\n}\n.oh-detail-section-title {\n  font-size: 0.78rem; font-weight: 700; color: var(--text-secondary);\n  text-transform: uppercase; letter-spacing: 0.06em;\n  margin: 16px 0 10px;\n}\n.oh-detail-items { display: flex; flex-direction: column; gap: var(--space-1); }\n.oh-detail-item {\n  display: flex; align-items: center; gap: 12px;\n  background: var(--bg-secondary); border: 1px solid var(--border);\n  border-radius: var(--radius-sm); padding: 10px 14px;\n}\n.oh-detail-item-img {\n  width: 40px; height: 40px; object-fit: contain;\n  border-radius: var(--radius-xs); background: var(--bg-tertiary); padding: 3px;\n}\n.oh-detail-item-name { flex: 1; font-size: 0.85rem; color: var(--text-primary); font-weight: 500; }\n.oh-detail-item-qty  { font-size: 0.82rem; color: var(--text-secondary); }\n.oh-detail-item-price { font-size: 0.88rem; font-weight: 700; color: var(--text-primary); }\n.oh-detail-addr { font-size: 0.85rem; color: var(--text-secondary); line-height: 1.6; }\n.oh-detail-addr p { margin: 0; }\n\n/* Pagination */\n.oh-pagination {\n  display: flex; align-items: center; justify-content: space-between;\n  flex-wrap: wrap; gap: 12px;\n}\n.oh-pagination-info { font-size: 0.85rem; color: var(--text-secondary); margin: 0; }\n.oh-page-btns { display: flex; align-items: center; gap: 6px; }\n.oh-page-arrow {\n  width: 36px; height: 36px;\n  background: var(--bg-secondary); border: 1px solid var(--border);\n  color: var(--text-primary); font-size: 1.1rem; font-weight: 700;\n  border-radius: var(--radius-sm); cursor: pointer; display: flex; align-items: center; justify-content: center;\n  transition: all 150ms;\n}\n.oh-page-arrow:hover:not(:disabled) { border-color: var(--accent); color: var(--accent); }\n.oh-page-arrow:disabled { opacity: 0.35; cursor: not-allowed; }\n.oh-page-num {\n  width: 36px; height: 36px;\n  background: var(--bg-secondary); border: 1px solid var(--border);\n  color: var(--text-secondary); font-size: 0.85rem; font-weight: 600;\n  border-radius: var(--radius-sm); cursor: pointer;\n  display: flex; align-items: center; justify-content: center;\n  transition: all 150ms;\n}\n.oh-page-num:hover { border-color: var(--accent); color: var(--accent); }\n.oh-page-num.active {\n  background: var(--accent); border-color: var(--accent); color: var(--color-text-on-secondary);\n}\n.oh-page-ellipsis { font-size: 0.85rem; color: var(--text-tertiary); padding: 0 4px; }\n\n/* Responsive */\n@media (max-width: 1200px) {\n  .oh-stats-grid { grid-template-columns: repeat(3, 1fr); }\n  .oh-table-header,\n  .oh-row { grid-template-columns: 130px 1fr 110px 130px 150px 160px; }\n}\n@media (max-width: 1024px) {\n  .oh-stats-grid { grid-template-columns: repeat(3, 1fr); }\n  .oh-table-wrap { overflow-x: auto; }\n  .oh-table-header,\n  .oh-row { min-width: 900px; }\n}\n@media (max-width: 768px) {\n  .oh-page { padding: 16px 14px 40px; }\n  .oh-stats-grid { grid-template-columns: repeat(2, 1fr); }\n  .oh-page-title { font-size: 1.4rem; }\n}\n/* Stacked card layout for the order list on phones -- the grid-table\n   forced a 900px min-width and horizontal scroll, cramming the whole\n   row into a thin sliver of the viewport. Below 640px each row becomes\n   its own full-width card instead. */\n@media (max-width: 640px) {\n  .oh-page { padding: 14px 8px 40px; }\n  .oh-table-wrap {\n    background: transparent; border: none; box-shadow: none;\n    overflow: visible; margin-bottom: 0;\n  }\n  .oh-table-header { display: none; }\n  .oh-row-wrap {\n    display: block; border-bottom: none; margin-bottom: 14px;\n    background: var(--bg-secondary); border: 1px solid var(--border);\n    border-radius: var(--radius-md); box-shadow: var(--shadow-card);\n    overflow: hidden;\n  }\n  .oh-row-wrap:last-child { margin-bottom: 0; }\n  .oh-row-wrap:hover { transform: none; }\n  .oh-row { display: block; min-width: 0; }\n  .oh-cell { padding: 14px 16px; border-bottom: 1px solid var(--border); }\n  .oh-cell:last-child { border-bottom: none; }\n  .oh-cell-product { flex-wrap: wrap; }\n  .oh-prod-name { max-width: none; white-space: normal; }\n  .oh-cell-actions { flex-direction: row; gap: 10px; padding: 14px 16px; }\n  .oh-cell-actions button { flex: 1; width: auto; }\n  .oh-detail-panel { padding: 0 16px 16px; }\n}\n@media (max-width: 480px) {\n  .oh-stats-grid { grid-template-columns: 1fr 1fr; }\n  .oh-stat-card { padding: 10px 12px; gap: var(--space-1); }\n  .oh-stat-count { font-size: 1.2rem; }\n}\n\n/* ═══════════════════════════════════════════════════════════\n   ADDRESS BOOK  (.ab-*)\n   ══════════════════════════════════════════════════════════ */\n\n.ab-page {\n  min-height: 100vh;\n  background: var(--bg-secondary);\n  padding: 32px 24px 60px;\n}\n\n/* Page header */\n.ab-page-hdr {\n  max-width: 760px;\n  margin: 0 auto 28px;\n}\n.ab-page-title {\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  margin: 0 0 6px;\n}\n.ab-page-sub {\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n/* Cards grid */\n.ab-cards-grid {\n  max-width: 760px;\n  margin: 0 auto 28px;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));\n  gap: var(--space-2);\n}\n\n/* Address card */\n.ab-card {\n  background: var(--bg-primary);\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  transition: box-shadow 150ms, border-color 150ms;\n  box-shadow: 0 1px 4px rgba(1, 13, 33,0.06);\n}\n.ab-card:hover {\n  box-shadow: 0 4px 16px rgba(1, 13, 33,0.1);\n}\n.ab-card--default {\n  border-color: var(--accent);\n  border-width: 2px;\n}\n.ab-card--selected {\n  border-color: var(--accent);\n  border-width: 2px;\n  background: rgba(59, 130, 246,0.04);\n}\n\n/* Card top row */\n.ab-card-top {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n.ab-card-icon-wrap {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  background: rgba(59, 130, 246,0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: var(--accent);\n}\n.ab-card-name {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  flex: 1;\n}\n.ab-default-badge {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  padding: 3px 10px;\n  border-radius: var(--radius-xl);\n  white-space: nowrap;\n}\n.ab-selected-check {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  font-size: 0.75rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n/* Info rows */\n.ab-card-info {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  padding-bottom: 14px;\n}\n.ab-info-row {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-1);\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  line-height: 1.5;\n}\n.ab-info-icon {\n  display: flex;\n  align-items: center;\n  padding-top: 2px;\n  flex-shrink: 0;\n  color: var(--text-secondary);\n  opacity: 0.7;\n}\n\n/* Card actions */\n.ab-card-actions {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding-top: 14px;\n  border-top: 1px solid var(--border);\n  margin-top: auto;\n}\n.ab-edit-btn {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--accent);\n  cursor: pointer;\n  transition: opacity 150ms;\n}\n.ab-edit-btn:hover { opacity: 0.75; }\n.ab-set-default-btn {\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: 0.82rem;\n  font-weight: 500;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: color 150ms;\n}\n.ab-set-default-btn:hover { color: var(--accent); }\n.ab-remove-btn {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--danger);\n  cursor: pointer;\n  transition: opacity 150ms;\n  margin-left: auto;\n}\n.ab-remove-btn:hover { opacity: 0.75; }\n\n/* Add New Address card */\n.ab-add-card {\n  border: 2px dashed var(--border);\n  border-radius: var(--radius-md);\n  padding: 28px 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-1);\n  cursor: pointer;\n  transition: border-color 150ms, background 150ms;\n  background: transparent;\n  min-height: 160px;\n}\n.ab-add-card:hover {\n  border-color: var(--accent);\n  background: rgba(59, 130, 246,0.03);\n}\n.ab-add-plus {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  font-size: 1.6rem;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 300;\n  transition: transform 150ms;\n}\n.ab-add-card:hover .ab-add-plus { transform: scale(1.08); }\n.ab-add-title {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--accent);\n}\n.ab-add-sub {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  text-align: center;\n}\n\n/* Inline form */\n.ab-form-wrap {\n  max-width: 760px;\n  margin: 0 auto 28px;\n}\n.ab-form {\n  background: var(--bg-primary);\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 28px;\n  box-shadow: 0 1px 4px rgba(1, 13, 33,0.06);\n}\n.ab-form-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 20px;\n}\n.ab-form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n.ab-form-field { display: flex; flex-direction: column; gap: 5px; }\n.ab-form-full { grid-column: 1 / -1; }\n.ab-form-field label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n.ab-form-field input,\n.ab-form-field textarea {\n  height: 40px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 0 12px;\n  font-size: 0.88rem;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  outline: none;\n  transition: border-color 150ms;\n  font-family: inherit;\n}\n.ab-form-field textarea {\n  height: auto;\n  padding: 10px 12px;\n  resize: vertical;\n}\n.ab-form-field input:focus,\n.ab-form-field textarea:focus { border-color: var(--accent); }\n.ab-form-btns {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n}\n.ab-cancel-btn {\n  background: var(--bg-secondary);\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 0 20px;\n  height: 40px;\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: border-color 150ms;\n}\n.ab-cancel-btn:hover { border-color: var(--text-secondary); }\n\n/* Security banner */\n.ab-security-banner {\n  max-width: 760px;\n  margin: 0 auto;\n  background: var(--bg-primary);\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 20px 24px;\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  overflow: hidden;\n  position: relative;\n  box-shadow: 0 1px 4px rgba(1, 13, 33,0.06);\n}\n.ab-sec-shield {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  background: rgba(59, 130, 246,0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.ab-sec-text {\n  flex: 1;\n}\n.ab-sec-text strong {\n  display: block;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 3px;\n}\n.ab-sec-text p {\n  font-size: 0.82rem;\n  color: var(--text-secondary);\n  margin: 0;\n  line-height: 1.5;\n}\n.ab-sec-watermark {\n  position: absolute;\n  right: -10px;\n  bottom: -10px;\n  opacity: 1;\n  pointer-events: none;\n}\n\n/* Dark mode adjustments */\n[data-theme='dark'] .ab-card--default,\n[data-theme='dark'] .ab-card--selected {\n  background: rgba(59, 130, 246,0.08);\n}\n\n/* Responsive */\n@media (max-width: 600px) {\n  .ab-page { padding: 20px 8px 40px; }\n  .ab-cards-grid { grid-template-columns: 1fr; }\n  .ab-form-grid { grid-template-columns: 1fr; }\n  .ab-form-full { grid-column: 1; }\n  .ab-form { padding: 18px; }\n  .ab-form-field input { height: 44px; font-size: 0.95rem; }\n}\n\n/* ═══════════════════════════════════════════════════════════\n   DELIVERY MAP PICKER  (.dmp-*)\n   Built entirely from existing theme CSS variables so dark mode is\n   automatic via [data-theme] -- the only literal-color exceptions are the\n   Leaflet tile layer itself (an external raster image, not stylable) and\n   the small inline error/hint text tones below.\n   ══════════════════════════════════════════════════════════ */\n\n.dmp-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n}\n.dmp-locate-btn {\n  align-self: flex-start;\n  background: var(--bg-primary);\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-md);\n  color: var(--text-primary);\n  font-size: 0.88rem;\n  font-weight: 600;\n  padding: 10px 16px;\n  min-height: 40px;\n  cursor: pointer;\n  transition: border-color 150ms, background 150ms;\n}\n.dmp-locate-btn:hover:not(:disabled) { border-color: var(--accent); }\n.dmp-locate-btn:disabled { opacity: 0.6; cursor: default; }\n.dmp-locate-error {\n  font-size: 0.82rem;\n  color: var(--color-primary);\n  background: rgba(180,83,9,0.1);\n  border-radius: 8px;\n  padding: 8px 12px;\n}\n.dmp-map-box {\n  width: 100%;\n  min-height: 260px;\n  height: 300px;\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  border: 1.5px solid var(--border);\n}\n.dmp-map {\n  width: 100%;\n  height: 100%;\n}\n/* Stands in for the leaflet map while its chunk loads. It is rendered with\n   .dmp-map-box alongside it, so it inherits that box's exact height -- and the\n   240px mobile override further down -- and the address form does not jump\n   when the real map swaps in. */\n.dmp-map-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  background: var(--bg-secondary);\n}\n.dmp-hint {\n  font-size: 0.82rem;\n  color: var(--text-secondary);\n  margin: 0;\n}\n@media (max-width: 600px) {\n  .dmp-map-box { height: 240px; }\n  .dmp-locate-btn { width: 100%; text-align: center; }\n}\n\n/* ── Guest address map pin (.addr-pin-*) ──────────────────────────────────\n   The collapsed entry point to DeliveryMapPicker on the two address forms a\n   guest sees. Blue throughout, not orange: this is secondary interaction and\n   information, while orange is reserved for the commercial actions (Add to\n   Cart, Place Order) that sit on these same screens. Making the pin orange\n   would put it in direct competition with the button the customer is meant\n   to press next.\n\n   The label stays navy in every state. Blue is carried by the border, the\n   icon disc and the tint, because blue text this small on white is 3.68:1\n   and misses AA -- the same reason links here use --color-secondary-text. */\n.addr-pin-block {\n  width: 100%;\n  margin: 4px 0 14px;\n}\n.addr-pin-toggle {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  text-align: left;\n  padding: 12px 14px;\n  background: var(--color-surface);\n  border: 1.5px dashed var(--color-border-strong);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: border-color 150ms, background 150ms;\n}\n.addr-pin-toggle:hover {\n  border-color: var(--color-secondary);\n  background: var(--color-surface-hover);\n}\n/* Solid once a pin exists: dashed reads as \"empty slot\", and this slot is\n   now filled. */\n.addr-pin-toggle-set {\n  border-style: solid;\n  border-color: var(--color-secondary);\n  background: var(--color-secondary-soft);\n}\n.addr-pin-toggle-icon {\n  flex: 0 0 auto;\n  display: grid;\n  place-items: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: var(--color-secondary-soft);\n  font-size: 1rem;\n  line-height: 1;\n}\n.addr-pin-toggle-set .addr-pin-toggle-icon {\n  background: var(--color-secondary);\n}\n.addr-pin-toggle-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n.addr-pin-toggle-text strong {\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n.addr-pin-toggle-text small {\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n  /* Coordinates and a reverse-geocoded area name can run long on a phone;\n     one line that truncates beats a wrapped block that shifts the button. */\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.addr-pin-label {\n  display: block;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n.addr-pin-done {\n  align-self: flex-start;\n  margin-top: 10px;\n  padding: 9px 18px;\n  background: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 0.86rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n.addr-pin-done:hover { background: var(--color-secondary-hover); }\n\n@media (max-width: 600px) {\n  .addr-pin-done { width: 100%; text-align: center; }\n}\n\n/* ═══════════════════════════════════════════════════════════\n   ORDER DETAIL PANEL  (.odp-*)\n   ══════════════════════════════════════════════════════════ */\n\n.odp-wrap {\n  padding: 24px 28px 32px;\n  background: var(--bg-secondary);\n  border-top: 2px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n\n.odp-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  background: none;\n  border: none;\n  color: var(--accent);\n  font-size: 0.88rem;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n  width: fit-content;\n  transition: opacity 150ms;\n}\n.odp-back:hover { opacity: 0.75; }\n\n/* Summary bar */\n.odp-summary-bar {\n  background: var(--bg-primary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 20px 24px;\n  display: flex;\n  align-items: flex-start;\n  gap: 28px;\n  flex-wrap: wrap;\n  box-shadow: 0 1px 4px rgba(1, 13, 33,0.05);\n}\n.odp-sum-identity { min-width: 160px; }\n.odp-sum-order-num {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  margin: 0 0 3px;\n}\n.odp-sum-order-num strong { color: var(--accent); font-size: 0.92rem; }\n.odp-sum-date { font-size: 0.8rem; color: var(--text-secondary); margin: 0 0 8px; }\n.odp-sum-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 10px;\n  border-radius: var(--radius-xl);\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n.odp-sum-delivered { font-size: 0.78rem; color: var(--text-secondary); margin: 6px 0 0; }\n\n.odp-sum-product { display: flex; align-items: center; gap: 10px; }\n.odp-sum-thumb {\n  width: 48px; height: 48px;\n  object-fit: contain;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n  background: var(--bg-secondary);\n}\n.odp-sum-sold-label { font-size: 0.75rem; color: var(--text-secondary); margin: 0 0 2px; }\n.odp-sum-seller { font-size: 0.86rem; font-weight: 600; color: var(--accent); margin: 0; cursor: pointer; }\n.odp-sum-seller:hover { text-decoration: underline; }\n\n.odp-sum-amount { text-align: center; }\n.odp-sum-field-label { font-size: 0.75rem; color: var(--text-secondary); margin: 0 0 4px; }\n.odp-sum-total { font-size: 1.35rem; font-weight: 800; color: var(--text-primary); margin: 0 0 6px; }\n.odp-paid-chip {\n  display: inline-block;\n  background: color-mix(in srgb, var(--success) 12%, transparent);\n  color: var(--success);\n  border: 1px solid color-mix(in srgb, var(--success) 25%, transparent);\n  border-radius: var(--radius-xl);\n  font-size: 0.72rem;\n  font-weight: 700;\n  padding: 2px 8px;\n}\n[data-theme='dark'] .odp-paid-chip { color: var(--success); }\n.odp-cod-chip {\n  background: rgba(255, 103, 0,0.12);\n  color: var(--color-primary);\n  border-color: rgba(255, 103, 0,0.25);\n}\n[data-theme='dark'] .odp-cod-chip { color: var(--color-primary); }\n.odp-cod-text { color: var(--color-primary); font-weight: 600; font-size: 0.84rem; }\n[data-theme='dark'] .odp-cod-text { color: var(--color-primary); }\n\n.odp-sum-payment { min-width: 120px; }\n.odp-sum-addr-col { min-width: 160px; }\n\n/* ── Changing the delivery address on a placed order ───────────────────── */\n\n.odp-sum-addr-hint { color: var(--text-muted); }\n\n/* A link, not a button: it opens a form rather than doing anything, and next\n   to Invoice/Buy Again/Open Dispute a fourth filled button would read as a\n   fourth equally-likely action. Blue is the interaction colour; orange is\n   reserved for commercial actions. */\n.odp-addr-change {\n  margin-top: 8px;\n  padding: 0;\n  background: none;\n  border: none;\n  font: inherit;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--color-secondary-text);\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.odp-addr-change:hover { color: var(--color-brand-navy); }\n.odp-addr-change:focus-visible { outline: 2px solid var(--color-secondary); outline-offset: 2px; border-radius: 4px; }\n\n.odp-addr-form {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: 6px;\n  max-width: 340px;\n}\n\n.odp-addr-label {\n  font-size: 0.76rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin-top: 6px;\n}\n\n.odp-addr-optional { font-weight: 500; color: var(--text-muted); }\n\n.odp-addr-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 8px 10px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font: inherit;\n  font-size: 0.88rem;\n}\n\n.odp-addr-input:focus-visible {\n  outline: 2px solid var(--color-secondary);\n  outline-offset: 1px;\n  border-color: var(--color-secondary);\n}\n\n.odp-addr-textarea { resize: vertical; min-height: 64px; }\n\n/* Carries an icon as well as the colour: with only four hues in this system,\n   orange is danger and promotion both, so an error may never be signalled by\n   colour alone. */\n.odp-addr-error {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  margin: 8px 0 0;\n  font-size: 0.8rem;\n  line-height: 1.5;\n  color: var(--color-primary);\n}\n\n.odp-addr-error svg { flex: 0 0 auto; margin-top: 2px; }\n\n.odp-addr-actions { display: flex; gap: 8px; margin-top: 12px; }\n\n.odp-addr-save {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 8px;\n  background: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n  font: inherit;\n  font-size: 0.85rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.odp-addr-save:disabled { opacity: 0.6; cursor: default; }\n\n.odp-addr-cancel {\n  padding: 8px 16px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-secondary);\n  font: inherit;\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n/* The one case worth reading twice: the delivery fee moved, so the total did. */\n.odp-addr-notice {\n  margin: 8px 0 0;\n  font-size: 0.8rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n  max-width: 340px;\n}\n.odp-sum-addr-name { font-size: 0.86rem; font-weight: 600; color: var(--text-primary); margin: 0 0 2px; }\n.odp-sum-addr-text { font-size: 0.8rem; color: var(--text-secondary); margin: 0; line-height: 1.5; }\n\n.odp-sum-btns { display: flex; flex-direction: column; gap: var(--space-1); margin-left: auto; }\n.odp-invoice-btn, .odp-buy-again-btn {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 9px 18px;\n  border-radius: var(--radius-sm);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 150ms, border-color 150ms;\n  white-space: nowrap;\n}\n.odp-invoice-btn {\n  background: var(--bg-primary);\n  border: 1.5px solid var(--border);\n  color: var(--accent);\n}\n.odp-invoice-btn:hover { border-color: var(--accent); background: rgba(59, 130, 246,0.04); }\n.odp-buy-again-btn {\n  background: var(--bg-primary);\n  border: 1.5px solid var(--border);\n  color: var(--text-primary);\n}\n.odp-buy-again-btn:hover { border-color: var(--accent); }\n\n/* Timeline card */\n.odp-timeline-card {\n  background: var(--bg-primary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 28px 32px;\n  box-shadow: 0 1px 4px rgba(1, 13, 33,0.05);\n}\n.odp-timeline {\n  display: flex;\n  align-items: flex-start;\n  gap: 0;\n}\n.odp-tl-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n  position: relative;\n}\n.odp-tl-track {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: center;\n  position: relative;\n}\n.odp-tl-dot {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-secondary);\n  border: 2px solid var(--border);\n  color: var(--text-secondary);\n  z-index: 1;\n  flex-shrink: 0;\n  transition: background 200ms, border-color 200ms;\n}\n.odp-tl-dot--done {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: var(--color-text-on-secondary);\n}\n.odp-tl-dot--current:not(.odp-tl-dot--done) {\n  border-color: var(--accent);\n  color: var(--accent);\n  background: rgba(59, 130, 246,0.08);\n}\n.odp-tl-line {\n  flex: 1;\n  height: 3px;\n  background: var(--border);\n  position: absolute;\n  left: calc(50% + 22px);\n  right: calc(-50% + 22px);\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 0;\n  transition: background 300ms;\n}\n.odp-tl-line--filled { background: var(--accent); }\n.odp-tl-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n  margin-top: 10px;\n  text-align: center;\n}\n.odp-tl-label {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n.odp-tl-label--done { color: var(--text-primary); }\n.odp-tl-time { font-size: 0.75rem; color: var(--text-secondary); }\n.odp-tl-track-btn {\n  background: none;\n  border: none;\n  color: var(--accent);\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n  margin-top: 2px;\n}\n.odp-tl-track-btn:hover { text-decoration: underline; }\n.odp-tl-otp-note {\n  display: block;\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n  margin-top: 4px;\n  max-width: 260px;\n}\n.odp-timeline-cancelled {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: var(--danger);\n  font-weight: 700;\n  font-size: 0.92rem;\n  padding: 16px 0;\n}\n.odp-tl-cancelled-date { color: var(--text-secondary); font-weight: 400; font-size: 0.82rem; }\n.odp-timeline-refunded { color: var(--accent-secondary); }\n.odp-timeline-exchanged { color: var(--accent-secondary); }\n\n/* Two-column body */\n.odp-body {\n  display: grid;\n  grid-template-columns: 1fr 300px;\n  gap: var(--space-2);\n  align-items: start;\n}\n\n/* Items card */\n.odp-items-card {\n  background: var(--bg-primary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  box-shadow: 0 1px 4px rgba(1, 13, 33,0.05);\n}\n.odp-items-hdr {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border);\n}\n.odp-items-title { font-size: 0.95rem; font-weight: 700; color: var(--text-primary); }\n.odp-items-count {\n  background: rgba(59, 130, 246,0.1);\n  color: var(--accent);\n  font-size: 0.75rem;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: var(--radius-xl);\n}\n.odp-items-list { display: flex; flex-direction: column; }\n.odp-item-row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border);\n  transition: background 120ms;\n}\n.odp-item-row:last-child { border-bottom: none; }\n.odp-item-row:hover { background: var(--bg-secondary); }\n.odp-item-img-wrap { flex-shrink: 0; }\n.odp-item-img {\n  width: 56px; height: 56px;\n  object-fit: contain;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n  background: var(--bg-secondary);\n  padding: 4px;\n}\n.odp-item-ph {\n  width: 56px; height: 56px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n  background: var(--bg-secondary);\n  display: flex; align-items: center; justify-content: center;\n  font-size: 1.4rem;\n}\n.odp-item-info { flex: 1; min-width: 0; }\n.odp-item-name { font-size: 0.9rem; font-weight: 600; color: var(--text-primary); margin: 0 0 3px; }\n.odp-item-sku  { font-size: 0.75rem; color: var(--text-secondary); margin: 0 0 2px; }\n.odp-item-qty  { font-size: 0.75rem; color: var(--text-secondary); margin: 0; }\n.odp-item-price {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.odp-item-btns { display: flex; gap: var(--space-1); flex-shrink: 0; }\n.odp-review-btn {\n  padding: 7px 14px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: border-color 150ms;\n}\n.odp-review-btn:hover { border-color: var(--accent); color: var(--accent); }\n.odp-support-btn {\n  padding: 7px 14px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: var(--bg-primary);\n  color: var(--text-secondary);\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: border-color 150ms;\n}\n.odp-support-btn:hover { border-color: var(--text-secondary); }\n\n/* Order summary footer */\n.odp-order-summary {\n  padding: 16px 20px;\n  border-top: 1px solid var(--border);\n  background: var(--bg-secondary);\n  box-shadow: var(--shadow-card);\n}\n.odp-os-title { font-size: 0.85rem; font-weight: 700; color: var(--text-primary); margin: 0 0 12px; }\n.odp-os-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.84rem;\n  color: var(--text-secondary);\n  margin-bottom: 6px;\n}\n.odp-os-free { color: var(--success); font-weight: 600; }\n[data-theme='dark'] .odp-os-free { color: var(--success); }\n.odp-os-total {\n  font-size: 0.95rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  border-top: 1px solid var(--border);\n  padding-top: 10px;\n  margin-top: 6px;\n  margin-bottom: 0;\n}\n\n/* Right side cards */\n.odp-right { display: flex; flex-direction: column; gap: 14px; }\n.odp-side-card {\n  background: var(--bg-primary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 18px 20px;\n  box-shadow: 0 1px 4px rgba(1, 13, 33,0.05);\n}\n.odp-side-title {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n  font-size: 0.92rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 14px;\n}\n.odp-delivery-key-card { text-align: center; }\n.odp-delivery-key-card .odp-side-title { justify-content: center; }\n.odp-delivery-key-value {\n  font-size: 1.7rem;\n  font-weight: 800;\n  letter-spacing: 4px;\n  color: var(--text-primary);\n  background: var(--bg-secondary);\n  border-radius: var(--radius-md);\n  padding: 10px 0;\n  margin-bottom: 14px;\n}\n.odp-delivery-key-qr {\n  display: flex;\n  justify-content: center;\n  padding: 12px;\n  background: var(--color-brand-white);\n  border-radius: var(--radius-md);\n  width: fit-content;\n  margin: 0 auto;\n}\n.odp-detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n.odp-dl { font-size: 0.78rem; color: var(--text-secondary); margin: 0; }\n.odp-dv { font-size: 0.84rem; color: var(--text-primary); font-weight: 500; margin: 0; }\n/* Right-aligned ONLY in the row shape this was written for: .odp-detail-row is\n   a space-between flex row, label left and value right, and there it is correct.\n   The Payment Details card uses the same two class names stacked instead --\n   value under its label -- and the global rule pushed the customer name and\n   billing address to the right edge while their labels stayed left. Measured at\n   a 368px viewport: label starting at x=46, value ending at x=322. */\n.odp-detail-row .odp-dv { text-align: right; }\n.odp-tracking { display: flex; align-items: center; gap: 6px; font-family: monospace; font-size: 0.78rem; }\n.odp-copy-btn {\n  background: none;\n  border: none;\n  padding: 2px;\n  cursor: pointer;\n  color: var(--text-secondary);\n  display: flex;\n  align-items: center;\n  transition: color 150ms;\n}\n.odp-copy-btn:hover { color: var(--accent); }\n.odp-track-ship-btn {\n  width: 100%;\n  padding: 9px;\n  margin-top: 6px;\n  border: 1.5px solid var(--accent);\n  border-radius: var(--radius-sm);\n  background: rgba(59, 130, 246,0.05);\n  color: var(--accent);\n  font-size: 0.86rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 150ms;\n}\n.odp-track-ship-btn:hover { background: rgba(59, 130, 246,0.1); }\n.odp-payment-cols {\n  display: grid;\n  /* auto-fit, not a fixed `1fr 1fr`, because this card gets narrow in two\n     different ways: stacked full-width on a phone, and side by side in the\n     <=900px flex row where .odp-side-card is only min-width:240px.\n     Two fixed tracks gave 132px each at a 368px viewport, which wrapped the\n     label \"Payment Method\" onto two lines and broke \"Cash on Delivery\" in half\n     beside its COD chip -- the card looked broken without anything actually\n     overflowing, which is why it did not show up as clipping.\n     Below ~312px of grid the tracks collapse to one and each field gets the\n     full card width. */\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 12px;\n}\n.odp-help-link {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n  width: 100%;\n  padding: 11px 12px;\n  background: none;\n  border: none;\n  border-radius: var(--radius-sm);\n  font-size: 0.84rem;\n  font-weight: 500;\n  color: var(--text-primary);\n  cursor: pointer;\n  text-align: left;\n  transition: background 150ms;\n  border-bottom: 1px solid var(--border);\n}\n.odp-help-link:last-child { border-bottom: none; }\n.odp-help-link:hover { background: var(--bg-secondary); }\n\n/* Responsive */\n@media (max-width: 900px) {\n  .odp-body { grid-template-columns: 1fr; }\n  .odp-right { flex-direction: row; flex-wrap: wrap; }\n  .odp-side-card { flex: 1; min-width: 240px; }\n}\n@media (max-width: 640px) {\n  .odp-wrap { padding: 16px 14px 24px; }\n  /* align-items:stretch, not the flex-start inherited from the row layout.\n   *\n   * Turning the bar into a column turns align-items into a HORIZONTAL rule, and\n   * flex-start sizes every child to its own content -- so the delivery address\n   * and the three-button row both grew past the card and were clipped by it.\n   * Measured at a 400px viewport: the card ended at 375 and both ran to 417.\n   * Stretch makes them the width of the card, which is what lets the address\n   * wrap instead of running off the edge. */\n  .odp-summary-bar { flex-direction: column; gap: var(--space-2); align-items: stretch; }\n  /* Wrapping matters now that there are three of these (Invoice, Buy Again,\n   * and Dispute once an order can have one). In a row that cannot wrap, the\n   * third simply left the card. */\n  .odp-sum-btns { flex-direction: row; flex-wrap: wrap; margin-left: 0; }\n  /* A long address is one unbroken run of words; without this it is the child\n   * that decides the column's width. */\n  .odp-sum-addr-col, .odp-sum-addr-text { min-width: 0; overflow-wrap: anywhere; }\n  /* text-align:center is right in the row layout, where this block is a narrow\n   * column of its own. Stretched to the full card width it centred the total\n   * while every field around it stayed left-aligned. */\n  .odp-sum-amount { text-align: left; }\n  .odp-timeline-card { padding: 20px 16px; }\n  .odp-tl-label { font-size: 0.72rem; }\n  .odp-item-row { flex-wrap: wrap; }\n  .odp-item-btns { width: 100%; margin-top: 8px; }\n}\n\n.odp-left { display: flex; flex-direction: column; gap: 14px; }\n\n/* ═══════════════════════════════════════════════════════════\n   BUY AGAIN TOAST  (.odp-buyagain-toast)\n   ══════════════════════════════════════════════════════════ */\n.odp-buyagain-toast {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n  background: color-mix(in srgb, var(--success) 10%, transparent);\n  border: 1px solid color-mix(in srgb, var(--success) 30%, transparent);\n  color: var(--success);\n  font-size: 0.86rem;\n  font-weight: 600;\n  padding: 10px 16px;\n  border-radius: var(--radius-sm);\n  animation: toast-in 250ms ease;\n}\n[data-theme='dark'] .odp-buyagain-toast { color: var(--success); }\n@keyframes toast-in { from { opacity: 0; transform: translateY(-6px); } to { opacity: 1; transform: none; } }\n\n/* ═══════════════════════════════════════════════════════════\n   DISPUTE PAGE  (.dp-*)\n   ══════════════════════════════════════════════════════════ */\n.dp-page { max-width: 1100px; margin: 0 auto; display: flex; flex-direction: column; gap: 20px; }\n\n.dp-empty, .dp-loading {\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  padding: 20px 0;\n  text-align: center;\n}\n\n/* Banner */\n.dp-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 18px 20px;\n  background: rgba(255, 103, 0,0.07);\n  border: 1px solid rgba(255, 103, 0,0.2);\n  border-radius: var(--radius-md);\n}\n.dp-banner-icon {\n  width: 44px;\n  height: 44px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background: rgba(255, 103, 0,0.12);\n  color: var(--color-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.dp-banner-title { font-size: 1.02rem; font-weight: 700; color: var(--text-primary); margin: 0 0 4px; }\n.dp-banner-sub { font-size: 0.86rem; color: var(--text-secondary); margin: 0; }\n\n/* Stepper */\n.dp-stepper { display: flex; justify-content: center; padding: 4px 0 6px; }\n.dp-step { display: flex; flex-direction: column; align-items: center; flex: 1; max-width: 160px; position: relative; }\n.dp-step-track { display: flex; align-items: center; width: 100%; justify-content: center; position: relative; }\n.dp-step-dot {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-secondary);\n  border: 2px solid var(--border);\n  color: var(--text-secondary);\n  font-size: 0.86rem;\n  font-weight: 700;\n  z-index: 1;\n  flex-shrink: 0;\n  transition: background 200ms, border-color 200ms, color 200ms;\n}\n.dp-step-dot--done { background: var(--accent); border-color: var(--accent); color: var(--color-text-on-secondary); }\n.dp-step-dot--current:not(.dp-step-dot--done) { background: var(--color-primary); border-color: var(--color-primary); color: var(--color-text-on-primary); }\n.dp-step-line {\n  flex: 1;\n  height: 3px;\n  background: var(--border);\n  position: absolute;\n  left: calc(50% + 20px);\n  right: calc(-50% + 20px);\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 0;\n  transition: background 300ms;\n}\n.dp-step-line--filled { background: var(--accent); }\n.dp-step-label { margin-top: 8px; font-size: 0.8rem; font-weight: 600; color: var(--text-secondary); text-align: center; }\n.dp-step-label--active { color: var(--text-primary); }\n\n/* Two-column layout */\n.dp-layout { display: grid; grid-template-columns: 340px 1fr; gap: 20px; align-items: start; }\n@media (max-width: 900px) {\n  .dp-layout { grid-template-columns: 1fr; }\n}\n\n/* Left: order picker */\n.dp-left { display: flex; flex-direction: column; gap: 12px; }\n.dp-left-header h2 { font-size: 1rem; font-weight: 700; color: var(--text-primary); margin: 0; }\n.dp-order-list { display: flex; flex-direction: column; gap: 10px; max-height: 560px; overflow-y: auto; }\n\n.dp-order-card {\n  background: var(--bg-primary);\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 14px 16px;\n  cursor: pointer;\n  transition: border-color 150ms, box-shadow 150ms;\n}\n.dp-order-card:hover { border-color: var(--accent); }\n.dp-order-card--selected { border-color: var(--accent); box-shadow: 0 0 0 2px rgba(59, 130, 246,0.15); }\n\n.dp-order-card-top { display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; }\n.dp-order-id { font-size: 0.86rem; font-weight: 700; color: var(--text-primary); }\n.dp-order-status-badge {\n  font-size: 0.7rem;\n  font-weight: 700;\n  padding: 3px 9px;\n  border-radius: var(--radius-xl);\n  background: rgba(255, 103, 0,0.12);\n  color: var(--color-primary);\n}\n.dp-order-card-body { display: flex; gap: 12px; margin-bottom: 12px; }\n.dp-order-thumb { width: 56px; height: 56px; border-radius: var(--radius-sm); object-fit: cover; flex-shrink: 0; }\n.dp-order-thumb-placeholder { display: flex; align-items: center; justify-content: center; background: var(--bg-tertiary); color: var(--text-tertiary); }\n.dp-order-info { min-width: 0; }\n.dp-order-name { font-size: 0.86rem; font-weight: 600; color: var(--text-primary); margin: 0 0 2px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.dp-order-variant { font-size: 0.76rem; color: var(--text-secondary); margin: 0 0 2px; }\n.dp-order-price { font-size: 0.8rem; color: var(--text-secondary); margin: 0; }\n\n.dp-raise-btn {\n  width: 100%;\n  padding: 10px;\n  border: none;\n  border-radius: var(--radius-sm);\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  font-size: 0.86rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 150ms;\n}\n.dp-raise-btn:hover { background: var(--accent-hover); }\n\n.dp-order-dispute-pill {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 100%;\n  padding: 9px;\n  border-radius: var(--radius-sm);\n  background: var(--bg-tertiary);\n  font-size: 0.8rem;\n  font-weight: 700;\n}\n\n.dp-view-all-link {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 100%;\n  padding: 11px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: none;\n  color: var(--text-primary);\n  font-size: 0.86rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: border-color 150ms;\n}\n.dp-view-all-link:hover { border-color: var(--accent); }\n\n.dp-side-card {\n  background: var(--bg-primary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 16px 18px;\n}\n.dp-side-title { display: flex; align-items: center; gap: var(--space-1); font-size: 0.88rem; font-weight: 700; color: var(--text-primary); margin: 0 0 4px; }\n.dp-side-sub { font-size: 0.8rem; color: var(--text-secondary); margin: 0; }\n\n/* Right: form / status card */\n.dp-form-card, .dp-status-card {\n  background: var(--bg-primary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 22px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.dp-form-title { font-size: 1.05rem; font-weight: 700; color: var(--text-primary); margin: 0 0 2px; }\n.dp-form-sub { font-size: 0.84rem; color: var(--text-secondary); margin: 0 0 16px; }\n\n.dp-field-label { font-size: 0.82rem; font-weight: 600; color: var(--text-secondary); margin: 12px 0 6px; }\n.dp-select, .dp-textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: var(--radius-sm);\n  border: 1.5px solid var(--border);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 0.88rem;\n  font-family: inherit;\n  outline: none;\n  box-sizing: border-box;\n}\n.dp-select:focus, .dp-textarea:focus { border-color: var(--accent); }\n.dp-textarea { resize: vertical; }\n.dp-char-count { font-size: 0.72rem; color: var(--text-tertiary); text-align: right; margin: 4px 0 0; }\n\n.dp-issue-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }\n@media (max-width: 480px) { .dp-issue-grid { grid-template-columns: 1fr; } }\n\n.dp-issue-card {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 0.85rem;\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 150ms, background 150ms;\n}\n.dp-issue-card:hover { border-color: var(--accent); }\n.dp-issue-card--selected { border-color: var(--accent); background: rgba(59, 130, 246,0.06); }\n.dp-issue-radio {\n  margin-left: auto;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 2px solid var(--border);\n  flex-shrink: 0;\n}\n.dp-issue-card--selected .dp-issue-radio { border-color: var(--accent); background: var(--accent); box-shadow: inset 0 0 0 3px var(--bg-secondary); }\n\n.dp-dropzone {\n  margin-top: 4px;\n  border: 2px dashed var(--border);\n  border-radius: var(--radius-md);\n  padding: 26px 20px;\n  text-align: center;\n  cursor: pointer;\n  transition: border-color 150ms, background 150ms;\n  color: var(--text-secondary);\n}\n.dp-dropzone:hover, .dp-dropzone-over { border-color: var(--accent); background: rgba(59, 130, 246,0.04); }\n.dp-dropzone-text { font-size: 0.86rem; color: var(--text-primary); margin: 8px 0 2px; font-weight: 600; }\n.dp-dropzone-hint { font-size: 0.75rem; color: var(--text-tertiary); margin: 0; }\n\n.dp-photo-grid { display: flex; gap: 10px; flex-wrap: wrap; margin-top: 12px; }\n.dp-photo-slot {\n  position: relative;\n  width: 76px;\n  height: 76px;\n  border-radius: var(--radius-sm);\n  border: 1.5px solid var(--border);\n  overflow: hidden;\n  flex-shrink: 0;\n}\n.dp-photo-thumb { width: 100%; height: 100%; object-fit: cover; display: block; }\n.dp-photo-spinner, .dp-photo-error {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(1, 13, 33,0.45);\n  color: var(--color-brand-white);\n}\n.dp-photo-error { background: color-mix(in srgb, var(--danger) 60%, transparent); font-weight: 800; }\n.dp-photo-remove {\n  position: absolute;\n  top: 3px;\n  right: 3px;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(1, 13, 33,0.6);\n  color: var(--color-brand-white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.dp-submit-msg { font-size: 0.82rem; color: var(--danger); margin: 10px 0 0; }\n.dp-submit-btn {\n  width: 100%;\n  margin-top: 18px;\n  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);\n  color: white;\n  border: none;\n  padding: 13px 20px;\n  font-weight: 700;\n  font-size: 0.95rem;\n  cursor: pointer;\n  border-radius: var(--radius-sm);\n  transition: opacity 150ms;\n}\n.dp-submit-btn:disabled { opacity: 0.55; cursor: not-allowed; }\n\n/* Read-only status card */\n.dp-status-row { display: flex; justify-content: space-between; align-items: center; padding: 9px 0; border-bottom: 1px solid var(--border); font-size: 0.86rem; }\n.dp-status-row:last-of-type { border-bottom: none; }\n.dp-status-label { font-size: 0.78rem; color: var(--text-secondary); font-weight: 600; }\n.dp-status-block { margin-top: 14px; }\n.dp-status-desc { font-size: 0.86rem; color: var(--text-primary); line-height: 1.5; margin: 4px 0 0; }\n\n.dp-status-explainer { font-size: 0.82rem; color: var(--text-secondary); line-height: 1.5; margin: 8px 0 0; }\n\n.dp-decision-card {\n  margin-top: 16px;\n  padding: 16px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n  background: var(--bg-secondary);\n}\n.dp-decision-title { display: flex; align-items: center; gap: 6px; font-size: 0.88rem; font-weight: 700; color: var(--text-primary); margin: 0 0 6px; }\n.dp-decision-card .dp-status-row { border-bottom-color: var(--border); }\n.dp-decision-card .dp-status-block:first-of-type { margin-top: 10px; }\n\n/* How Disputes Work footer */\n.dp-howitworks {\n  background: var(--bg-primary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 22px 24px;\n}\n.dp-howitworks-title { font-size: 0.98rem; font-weight: 700; color: var(--text-primary); margin: 0 0 18px; }\n.dp-howitworks-row { display: flex; align-items: flex-start; gap: 12px; }\n.dp-howitworks-item { flex: 1; min-width: 0; }\n.dp-howitworks-icon {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  background: rgba(59, 130, 246,0.1);\n  color: var(--accent);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 10px;\n}\n.dp-howitworks-item-title { font-size: 0.85rem; font-weight: 700; color: var(--text-primary); margin: 0 0 4px; }\n.dp-howitworks-item-desc { font-size: 0.78rem; color: var(--text-secondary); margin: 0; line-height: 1.4; }\n.dp-howitworks-line { flex: 0 0 24px; height: 2px; margin-top: 19px; border-top: 2px dashed var(--border); }\n@media (max-width: 700px) {\n  .dp-howitworks-row { flex-direction: column; }\n  .dp-howitworks-line { display: none; }\n}\n\n/* Conversation (buyer-visible message thread on an existing dispute) */\n.dp-conv-section { margin-top: 18px; padding-top: 18px; border-top: 1px solid var(--border); }\n.dp-conv-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 320px;\n  overflow-y: auto;\n  margin: 10px 0 12px;\n}\n.dp-conv-empty { font-size: 0.82rem; color: var(--text-tertiary); margin: 4px 0; }\n.dp-conv-msg {\n  max-width: 82%;\n  padding: 10px 13px;\n  border-radius: var(--radius-md);\n  background: var(--bg-tertiary);\n}\n.dp-conv-msg--buyer { align-self: flex-end; background: rgba(59, 130, 246,0.1); }\n.dp-conv-msg--admin { align-self: flex-start; }\n.dp-conv-msg-head { display: flex; justify-content: space-between; gap: 10px; margin-bottom: 3px; }\n.dp-conv-msg-author { font-size: 0.75rem; font-weight: 700; color: var(--text-primary); }\n.dp-conv-msg-time { font-size: 0.7rem; color: var(--text-tertiary); }\n.dp-conv-msg-text { font-size: 0.85rem; color: var(--text-primary); margin: 0; line-height: 1.45; white-space: pre-wrap; }\n.dp-conv-composer { display: flex; gap: 8px; align-items: flex-end; }\n.dp-conv-input {\n  flex: 1;\n  padding: 9px 12px;\n  border-radius: var(--radius-sm);\n  border: 1.5px solid var(--border);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 0.86rem;\n  font-family: inherit;\n  resize: vertical;\n  outline: none;\n}\n.dp-conv-input:focus { border-color: var(--accent); }\n.dp-conv-send-btn {\n  padding: 9px 18px;\n  border: none;\n  border-radius: var(--radius-sm);\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  font-weight: 700;\n  font-size: 0.86rem;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.dp-conv-send-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* ═══════════════════════════════════════════════════════════\n   ADMIN DISPUTES TAB  (.dsp-*)\n   ══════════════════════════════════════════════════════════ */\n.dsp-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; flex-wrap: wrap; margin-bottom: 18px; }\n.dsp-header h2 { margin: 0 0 4px; font-size: 1.2rem; font-weight: 700; color: var(--text-primary); }\n.dsp-header p { margin: 0; font-size: 0.85rem; color: var(--text-secondary); }\n\n.dsp-toolbar-btn {\n  display: flex; align-items: center; gap: 6px;\n  padding: 9px 14px; border: 1px solid var(--border); border-radius: var(--radius-sm);\n  background: var(--bg-secondary); color: var(--text-primary);\n  font-size: 0.82rem; font-weight: 600; cursor: pointer; white-space: nowrap;\n  transition: border-color 150ms;\n}\n.dsp-toolbar-btn:hover { border-color: var(--accent); }\n.dsp-toolbar-btn:disabled { opacity: 0.6; cursor: default; }\n\n.dsp-popover-wrap { position: relative; }\n.dsp-popover {\n  position: absolute; top: calc(100% + 6px); right: 0; z-index: 40;\n  min-width: 220px; background: var(--bg-primary); border: 1px solid var(--border);\n  border-radius: var(--radius-md); box-shadow: 0 12px 32px rgba(1, 13, 33,0.18); padding: 12px 14px;\n}\n.dsp-popover-title { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--text-muted); margin: 0 0 8px; }\n.dsp-popover-check { display: flex; align-items: center; gap: 8px; font-size: 0.84rem; color: var(--text-primary); padding: 5px 0; cursor: pointer; }\n.dsp-popover-dates { display: flex; flex-direction: column; gap: 10px; min-width: 200px; }\n.dsp-popover-date-label { display: flex; flex-direction: column; gap: 4px; font-size: 0.76rem; color: var(--text-secondary); font-weight: 600; }\n.dsp-popover-date-label input { padding: 7px 9px; border-radius: 8px; border: 1px solid var(--border); background: var(--bg-secondary); color: var(--text-primary); font-size: 0.82rem; }\n.dsp-popover-clear { align-self: flex-start; border: none; background: none; color: var(--accent); font-size: 0.78rem; font-weight: 600; cursor: pointer; padding: 0; }\n\n/* Stat-filter cards -- reuse the .oh-stat-card visual language but every\n   card IS the filter control (like the customer-facing order stat cards),\n   not a separate non-interactive KPI display. */\n.dsp-stat-row { display: grid; grid-template-columns: repeat(6, 1fr); gap: 12px; margin-bottom: 20px; }\n@media (max-width: 1100px) { .dsp-stat-row { grid-template-columns: repeat(3, 1fr); } }\n@media (max-width: 640px)  { .dsp-stat-row { grid-template-columns: repeat(2, 1fr); } }\n.dsp-stat-card {\n  display: flex; flex-direction: column; align-items: flex-start; gap: 6px;\n  background: var(--bg-secondary); border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm); padding: 14px 16px;\n  cursor: pointer; transition: all 150ms; text-align: left;\n}\n.dsp-stat-card:hover { border-color: var(--accent); transform: translateY(-1px); }\n.dsp-stat-card.active { border-color: var(--accent); background: rgba(59, 130, 246,0.06); }\n[data-theme=\"dark\"] .dsp-stat-card.active { background: rgba(59, 130, 246,0.08); }\n.dsp-stat-icon { width: 34px; height: 34px; border-radius: 9px; display: flex; align-items: center; justify-content: center; }\n.dsp-stat-count { font-size: 1.3rem; font-weight: 800; color: var(--text-primary); line-height: 1.1; }\n.dsp-stat-label { font-size: 0.74rem; color: var(--text-secondary); font-weight: 600; }\n\n/* Two-column layout -- list-only by default, list+sidebar once a dispute is\n   selected. No existing conditionally-docked-sidebar precedent elsewhere in\n   this app, so this is new layout CSS rather than a reused class. */\n.dsp-layout { display: block; }\n.dsp-layout--split { display: grid; grid-template-columns: 1fr 400px; gap: 18px; align-items: start; }\n@media (max-width: 1000px) { .dsp-layout--split { grid-template-columns: 1fr; } }\n\n.dsp-list { display: flex; flex-direction: column; gap: 12px; }\n.dsp-card {\n  background: var(--bg-secondary); border: 1.5px solid var(--border); border-radius: 12px;\n  padding: 16px 20px; cursor: pointer; transition: border-color 150ms;\n}\n.dsp-card:hover { border-color: var(--accent); }\n.dsp-card--selected { border-color: var(--accent); box-shadow: 0 0 0 2px rgba(59, 130, 246,0.15); }\n.dsp-card-badges { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; margin-bottom: 8px; }\n.dsp-badge { padding: 2px 10px; border-radius: 20px; font-size: 0.73rem; font-weight: 700; }\n.dsp-badge--muted { background: var(--bg-tertiary); color: var(--text-secondary); }\n.dsp-card-order-row {\n  display: flex; align-items: center; justify-content: space-between; gap: 10px;\n  font-size: 0.78rem; color: var(--text-secondary); padding: 8px 0; margin-bottom: 4px;\n  border-top: 1px solid var(--border); border-bottom: 1px solid var(--border);\n}\n.dsp-card-counts { display: flex; align-items: center; gap: 12px; flex-shrink: 0; }\n.dsp-card-counts svg { vertical-align: -2px; margin-right: 3px; }\n.dsp-card-actions { margin-top: 12px; display: flex; gap: 8px; flex-wrap: wrap; align-items: flex-end; }\n.dsp-notes-input {\n  flex: 1; min-width: 180px; padding: 8px 11px; border-radius: 8px; border: 1px solid var(--border);\n  background: var(--bg-primary); color: var(--text-primary); font-size: 0.8rem; font-family: inherit; resize: vertical;\n}\n\n/* Sidebar */\n.dsp-sidebar {\n  background: var(--bg-secondary); border: 1px solid var(--border); border-radius: 12px;\n  padding: 18px 20px; position: sticky; top: 12px; max-height: calc(100vh - 100px); overflow-y: auto;\n}\n.dsp-sidebar-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; margin-bottom: 14px; }\n.dsp-sidebar-close { border: none; background: var(--bg-tertiary); color: var(--text-secondary); width: 28px; height: 28px; border-radius: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer; flex-shrink: 0; }\n.dsp-sidebar-tabs { display: flex; gap: 4px; border-bottom: 1px solid var(--border); margin-bottom: 16px; }\n.dsp-sidebar-tab {\n  display: flex; align-items: center; gap: 6px;\n  padding: 9px 12px; border: none; background: none; color: var(--text-secondary);\n  font-size: 0.82rem; font-weight: 600; cursor: pointer; border-bottom: 2px solid transparent; margin-bottom: -1px;\n}\n.dsp-sidebar-tab.active { color: var(--accent); border-bottom-color: var(--accent); }\n.dsp-tab-count { background: var(--bg-tertiary); color: var(--text-secondary); border-radius: 20px; padding: 0 6px; font-size: 0.7rem; font-weight: 700; }\n.dsp-sidebar-tab.active .dsp-tab-count { background: rgba(59, 130, 246,0.15); color: var(--accent); }\n\n.dsp-sidebar-body { display: flex; flex-direction: column; gap: 14px; }\n.dsp-info-card { background: var(--bg-primary); border: 1px solid var(--border); border-radius: var(--radius-sm); padding: 14px 16px; }\n.dsp-info-title { font-size: 0.82rem; font-weight: 700; color: var(--text-primary); margin: 0 0 10px; }\n.dsp-modal-label { display: block; font-size: 0.8rem; font-weight: 700; color: var(--text-primary); margin: 0 0 6px; }\n.dsp-detail-row { display: flex; justify-content: space-between; align-items: center; gap: 10px; font-size: 0.82rem; color: var(--text-secondary); padding: 5px 0; margin: 0; }\n.dsp-detail-row span:last-child { color: var(--text-primary); font-weight: 500; display: flex; align-items: center; gap: 4px; }\n.dsp-order-product-row { display: flex; align-items: center; gap: 10px; margin-bottom: 10px; }\n.dsp-order-thumb { width: 42px; height: 42px; border-radius: 8px; object-fit: cover; flex-shrink: 0; }\n.dsp-order-thumb-placeholder { display: flex; align-items: center; justify-content: center; background: var(--bg-tertiary); color: var(--text-tertiary); }\n.dsp-copy-btn { border: none; background: none; color: var(--text-secondary); cursor: pointer; display: inline-flex; align-items: center; padding: 2px; }\n.dsp-copy-btn:hover { color: var(--accent); }\n\n/* Conversation tab (admin side) -- same message-bubble idea as the\n   customer-facing .dp-conv-* rules, mirrored role-wise (admin right-aligned\n   here since the admin is \"us\" in this view). */\n.dsp-conv-list { display: flex; flex-direction: column; gap: 10px; max-height: 280px; overflow-y: auto; margin-bottom: 12px; }\n.dsp-conv-empty { font-size: 0.82rem; color: var(--text-tertiary); }\n.dsp-conv-msg { max-width: 85%; padding: 9px 12px; border-radius: var(--radius-md); background: var(--bg-primary); border: 1px solid var(--border); }\n.dsp-conv-msg--admin { align-self: flex-end; background: rgba(59, 130, 246,0.1); border-color: rgba(59, 130, 246,0.25); }\n.dsp-conv-msg--buyer { align-self: flex-start; }\n.dsp-conv-msg--seller { align-self: flex-end; background: rgba(59, 130, 246,0.1); border-color: rgba(59, 130, 246,0.25); }\n.dsp-conv-msg-head { display: flex; justify-content: space-between; gap: 10px; margin-bottom: 3px; }\n.dsp-conv-msg-author { font-size: 0.73rem; font-weight: 700; color: var(--text-primary); }\n.dsp-conv-msg-time { font-size: 0.68rem; color: var(--text-tertiary); }\n.dsp-conv-msg-text { font-size: 0.83rem; color: var(--text-primary); margin: 0; line-height: 1.4; white-space: pre-wrap; }\n.dsp-conv-composer { display: flex; gap: 8px; align-items: flex-end; }\n.dsp-conv-input { flex: 1; padding: 8px 11px; border-radius: 8px; border: 1px solid var(--border); background: var(--bg-primary); color: var(--text-primary); font-size: 0.83rem; font-family: inherit; resize: vertical; }\n.dsp-conv-send-btn { padding: 8px 16px; border: none; border-radius: 8px; background: var(--color-secondary); color: var(--color-text-on-secondary); font-weight: 700; font-size: 0.82rem; cursor: pointer; flex-shrink: 0; }\n.dsp-conv-send-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* Evidence tab */\n.dsp-evidence-grid { display: flex; gap: 10px; flex-wrap: wrap; }\n.dsp-evidence-thumb { width: 84px; height: 84px; border-radius: 10px; object-fit: cover; border: 1px solid var(--border); }\n\n/* Timeline tab -- honest 1-2 real data points, not a fabricated audit log */\n.dsp-timeline { display: flex; flex-direction: column; gap: 4px; }\n.dsp-timeline-point { display: flex; align-items: flex-start; gap: 12px; padding: 8px 0; position: relative; }\n.dsp-timeline-point:not(:last-child)::before {\n  content: ''; position: absolute; left: 5px; top: 22px; bottom: -4px; width: 2px; background: var(--border);\n}\n.dsp-timeline-dot { width: 12px; height: 12px; border-radius: 50%; background: var(--border); flex-shrink: 0; margin-top: 4px; }\n.dsp-timeline-dot--current { background: var(--accent); }\n\n/* ═══════════════════════════════════════════════════════════\n   RETURNS TAB (admin)  (.ret-*)\n   Layout/sidebar/timeline mechanics cloned from the .dsp-* rules above for\n   visual consistency; the card body and refund/exchange panels below are\n   new since a return carries different data than a dispute.\n   ══════════════════════════════════════════════════════════ */\n.ret-layout { display: block; }\n.ret-layout--split { display: grid; grid-template-columns: 1fr 400px; gap: 18px; align-items: start; }\n@media (max-width: 1000px) { .ret-layout--split { grid-template-columns: 1fr; } }\n\n.ret-list { display: flex; flex-direction: column; gap: 12px; }\n.ret-card {\n  background: var(--bg-secondary); border: 1.5px solid var(--border); border-radius: 12px;\n  padding: 16px 20px; cursor: pointer; transition: border-color 150ms;\n}\n.ret-card:hover { border-color: var(--accent); }\n.ret-card--selected { border-color: var(--accent); box-shadow: 0 0 0 2px rgba(59, 130, 246,0.15); }\n.ret-card-badges { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; margin-bottom: 12px; }\n.ret-card-icon { width: 26px; height: 26px; border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }\n.ret-badge { padding: 2px 10px; border-radius: 20px; font-size: 0.73rem; font-weight: 700; }\n.ret-badge--muted { background: var(--bg-tertiary); color: var(--text-secondary); }\n\n.ret-card-grid {\n  display: grid; grid-template-columns: repeat(5, 1fr); gap: 14px;\n  padding-bottom: 12px; margin-bottom: 4px; border-bottom: 1px solid var(--border);\n}\n@media (max-width: 900px) { .ret-card-grid { grid-template-columns: repeat(2, 1fr); } }\n.ret-card-label { font-size: 0.7rem; font-weight: 700; color: var(--text-tertiary); text-transform: uppercase; letter-spacing: 0.04em; margin: 0 0 3px; }\n.ret-card-value { font-size: 0.84rem; color: var(--text-primary); font-weight: 600; margin: 0; }\n.ret-card-sub { font-size: 0.76rem; color: var(--text-muted); margin: 2px 0 0; }\n.ret-resolution-value { display: flex; align-items: center; gap: 5px; }\n\n.ret-warning-banner {\n  display: flex; align-items: center; gap: 8px;\n  background: rgba(255, 103, 0,0.1); border: 1px solid rgba(255, 103, 0,0.3); color: var(--color-primary);\n  border-radius: 8px; padding: 9px 14px; font-size: 0.82rem; font-weight: 600; margin: 12px 0;\n}\n[data-theme=\"dark\"] .ret-warning-banner { color: var(--color-primary); }\n\n.ret-refund-panel {\n  background: var(--bg-primary); border: 1px solid var(--border); border-radius: 8px;\n  padding: 12px 14px; margin: 12px 0;\n}\n.ret-refund-panel-title { font-size: 0.76rem; font-weight: 700; color: var(--text-secondary); text-transform: uppercase; letter-spacing: 0.04em; margin: 0 0 10px; }\n.ret-refund-panel-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; }\n@media (max-width: 900px) { .ret-refund-panel-grid { grid-template-columns: repeat(2, 1fr); } }\n/* The sidebar is a fixed 400px column regardless of viewport width, too\n   narrow for 4 columns even when the page itself is wide. */\n.ret-sidebar .ret-refund-panel-grid { grid-template-columns: repeat(2, 1fr); }\n\n.ret-exchange-panel {\n  display: flex; align-items: center; gap: 10px;\n  background: rgba(59, 130, 246,0.08); border: 1px solid rgba(59, 130, 246,0.25); color: var(--color-secondary);\n  border-radius: 8px; padding: 10px 14px; margin: 12px 0;\n}\n[data-theme=\"dark\"] .ret-exchange-panel { background: rgba(59, 130, 246,0.12); }\n.ret-tracking-input {\n  width: 120px; padding: 6px 9px; border-radius: 6px; border: 1px solid var(--border);\n  background: var(--bg-secondary); color: var(--text-primary); font-size: 0.78rem;\n}\n\n.ret-card-actions { margin-top: 12px; display: flex; gap: 8px; flex-wrap: wrap; }\n.ret-action-btn {\n  padding: 7px 14px; border-radius: 8px; font-size: 0.8rem; font-weight: 700; cursor: pointer;\n  background: var(--bg-tertiary); color: var(--text-primary); border: 1px solid var(--border);\n}\n.ret-action-btn:hover:not(:disabled) { border-color: var(--accent); }\n.ret-action-btn:disabled { opacity: 0.6; cursor: not-allowed; }\n.ret-action-btn--primary { background: var(--color-secondary); color: var(--color-text-on-secondary); border-color: var(--color-secondary); }\n.ret-action-btn--warn { background: var(--color-primary); color: var(--color-text-on-primary); border-color: var(--color-primary); }\n.ret-action-btn--danger { background: rgba(255, 103, 0,0.1); color: var(--color-primary); border-color: rgba(255, 103, 0,0.3); }\n[data-theme=\"dark\"] .ret-action-btn--danger { background: rgba(255, 103, 0,0.15); }\n\n.ret-sidebar {\n  background: var(--bg-secondary); border: 1px solid var(--border); border-radius: 12px;\n  padding: 18px 20px; position: sticky; top: 12px; max-height: calc(100vh - 100px); overflow-y: auto;\n}\n.ret-sidebar-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; margin-bottom: 16px; }\n\n/* ═══════════════════════════════════════════════════════════\n   INVOICE MODAL  (.inv-*)\n   ══════════════════════════════════════════════════════════ */\n.inv-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(1, 13, 33,0.65);\n  z-index: 1100;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 40px 16px;\n  overflow-y: auto;\n  backdrop-filter: blur(3px);\n}\n/* Fixed A4 page (210mm x 297mm). Background/text colors inside .inv-doc are\n   deliberately hardcoded rather than theme variables further down — an\n   invoice is a document meant to be printed/shared, so it must always render\n   as plain white paper with dark ink, never inverted by the app's dark mode. */\n.inv-modal {\n  background: var(--color-brand-white);\n  border-radius: 10px;\n  width: 210mm;\n  max-width: 96vw;\n  min-height: 297mm;\n  box-shadow: 0 24px 60px rgba(1, 13, 33,0.35);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.inv-actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 20px;\n  border-bottom: 1px solid var(--border);\n  background: var(--bg-secondary);\n  flex-shrink: 0;\n}\n.inv-print-btn {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 8px 16px;\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  border: none;\n  border-radius: var(--radius-sm);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 150ms;\n}\n.inv-print-btn:hover { background: var(--accent-hover); }\n.inv-close-btn {\n  width: 34px; height: 34px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n  background: var(--bg-primary);\n  color: var(--text-secondary);\n  cursor: pointer;\n  font-size: 1rem;\n  display: flex; align-items: center; justify-content: center;\n}\n.inv-close-btn:hover { background: var(--bg-secondary); }\n\n\n/* ═══════════════════════════════════════════════════════════\n   TRACK SHIPMENT MODAL  (.ts-*)\n   ══════════════════════════════════════════════════════════ */\n.ts-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(1, 13, 33,0.55);\n  z-index: 1100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  backdrop-filter: blur(3px);\n}\n.ts-modal {\n  background: var(--bg-primary);\n  border-radius: var(--radius-xl);\n  width: 100%;\n  max-width: 520px;\n  box-shadow: 0 24px 60px rgba(1, 13, 33,0.25);\n  max-height: 90vh;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n.ts-hdr {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px 16px;\n  border-bottom: 1px solid var(--border);\n  position: sticky;\n  top: 0;\n  background: var(--bg-primary);\n  z-index: 1;\n}\n.ts-hdr-left { display: flex; align-items: center; gap: 12px; }\n.ts-hdr-title { font-size: 1.05rem; font-weight: 800; color: var(--text-primary); margin: 0; }\n.ts-hdr-sub { font-size: 0.78rem; color: var(--text-secondary); margin: 2px 0 0; }\n.ts-close {\n  width: 34px; height: 34px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  cursor: pointer;\n  font-size: 1rem;\n  display: flex; align-items: center; justify-content: center;\n}\n.ts-close:hover { background: var(--border); }\n\n/* Cancelled state */\n.ts-cancelled-msg {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: 28px 24px;\n  color: var(--danger);\n}\n.ts-cancelled-icon {\n  width: 40px; height: 40px;\n  background: color-mix(in srgb, var(--danger) 12%, transparent);\n  border-radius: 50%;\n  display: flex; align-items: center; justify-content: center;\n  font-size: 1.1rem;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n.ts-cancelled-title { font-size: 0.95rem; font-weight: 700; margin: 0 0 4px; }\n.ts-refunded-msg { color: var(--accent-secondary); }\n.ts-refunded-msg .ts-cancelled-icon { background: color-mix(in srgb, var(--accent-secondary) 12%, transparent); }\n.ts-exchanged-msg { color: var(--accent-secondary); }\n.ts-exchanged-msg .ts-cancelled-icon { background: color-mix(in srgb, var(--accent-secondary) 12%, transparent); }\n.ts-cancelled-sub { font-size: 0.84rem; color: var(--text-secondary); margin: 0; }\n\n/* Tracking number card */\n.ts-num-card {\n  margin: 16px 20px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 16px 20px;\n  box-shadow: var(--shadow-card);\n}\n.ts-num-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 14px;\n}\n.ts-num-label { font-size: 0.75rem; color: var(--text-secondary); margin: 0 0 4px; font-weight: 600; }\n.ts-num-val { font-family: 'Courier New', monospace; font-size: 0.95rem; font-weight: 700; color: var(--text-primary); margin: 0; letter-spacing: 0.05em; }\n.ts-copy-btn {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 7px 12px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xs);\n  background: var(--bg-primary);\n  color: var(--text-secondary);\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: border-color 150ms, color 150ms;\n}\n.ts-copy-btn:hover { border-color: var(--accent); color: var(--accent); }\n.ts-meta-row {\n  display: flex;\n  gap: var(--space-2);\n  flex-wrap: wrap;\n}\n.ts-meta-cell { flex: 1; min-width: 100px; }\n.ts-meta-label { font-size: 0.72rem; color: var(--text-secondary); margin: 0 0 4px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; }\n.ts-meta-val { font-size: 0.84rem; color: var(--text-primary); font-weight: 600; margin: 0; }\n.ts-status-pill {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: var(--radius-xl);\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n.ts-delivered-text { color: var(--success); font-weight: 700; }\n[data-theme='dark'] .ts-delivered-text { color: var(--success); }\n\n/* Tracking timeline */\n.ts-timeline {\n  padding: 4px 20px 24px;\n}\n.ts-tl-heading {\n  font-size: 0.8rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--text-secondary);\n  margin: 0 0 16px;\n}\n.ts-tl-item {\n  display: flex;\n  gap: var(--space-2);\n  opacity: 0.4;\n}\n.ts-tl-item.ts-tl-done { opacity: 1; }\n.ts-tl-item.ts-tl-current { opacity: 1; }\n.ts-tl-left {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex-shrink: 0;\n  width: 28px;\n}\n.ts-tl-dot {\n  width: 28px; height: 28px;\n  border-radius: 50%;\n  border: 2px solid var(--border);\n  background: var(--bg-secondary);\n  display: flex; align-items: center; justify-content: center;\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--text-secondary);\n  flex-shrink: 0;\n  transition: background 200ms;\n}\n.ts-tl-dot.ts-tl-dot-done {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: var(--color-text-on-secondary);\n}\n.ts-tl-dot.ts-tl-dot-pulse {\n  border-color: var(--accent);\n  color: var(--accent);\n  background: rgba(59, 130, 246,0.08);\n  box-shadow: 0 0 0 4px rgba(59, 130, 246,0.12);\n}\n.ts-tl-vert {\n  width: 2px;\n  flex: 1;\n  min-height: 32px;\n  background: var(--border);\n  margin: 4px 0;\n  transition: background 300ms;\n}\n.ts-tl-vert.ts-tl-vert-filled { background: var(--accent); }\n.ts-tl-right {\n  padding-bottom: 24px;\n  flex: 1;\n  padding-top: 4px;\n}\n.ts-tl-label {\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin: 0 0 3px;\n}\n.ts-tl-label.ts-tl-label-done { color: var(--text-primary); }\n.ts-tl-location { font-size: 0.8rem; color: var(--text-secondary); margin: 0 0 2px; }\n.ts-tl-time { font-size: 0.76rem; color: var(--text-secondary); margin: 0; }\n\n@media (max-width: 540px) {\n  .ts-modal { max-width: 100%; border-radius: var(--radius-md) var(--radius-md) 0 0; }\n}\n\n/* ═══════════════════════════════════════════════════════════\n   INVOICE — the printable document itself (.inv-doc and below).\n   Fixed light palette throughout (see note on .inv-modal above).\n   ══════════════════════════════════════════════════════════ */\n.inv-doc {\n  padding: 40px 44px 36px;\n  color: var(--text-primary);\n  flex: 1;\n}\n.inv-header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 28px; }\n.inv-brand-col { display: flex; gap: 14px; align-items: flex-start; }\n.inv-logo-box {\n  width: 52px; height: 52px;\n  background: var(--color-brand-white);\n  border: 1.5px solid var(--border);\n  border-radius: 12px;\n  display: flex; align-items: center; justify-content: center;\n  flex-shrink: 0;\n  box-shadow: 0 1px 4px rgba(1, 13, 33,.06);\n}\n.inv-brand-name  { font-size: 1.25rem; font-weight: 800; color: var(--text-primary); margin: 0 0 2px; display: block; }\n.inv-brand-tagline { font-size: .78rem; color: var(--text-secondary); margin: 0 0 10px; display: block; }\n.inv-hdr-contacts { display: flex; flex-direction: column; gap: 4px; }\n.inv-hdr-contact  { font-size: .78rem; color: var(--text-secondary); display: flex; align-items: center; gap: 5px; }\n\n.inv-meta-col { text-align: right; }\n.inv-title { font-size: 2rem; font-weight: 900; letter-spacing: .12em; color: var(--text-primary); margin: 0 0 14px; }\n.inv-meta-tbl { display: flex; flex-direction: column; gap: 5px; margin-bottom: 12px; }\n.inv-meta-row { display: flex; justify-content: flex-end; gap: 20px; font-size: .85rem; }\n.inv-meta-label { color: var(--text-secondary); }\n.inv-meta-val   { color: var(--text-primary); font-weight: 700; min-width: 90px; text-align: right; }\n.inv-paid-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  background: color-mix(in srgb, var(--success) 12%, transparent);\n  color: var(--success);\n  border: 1.5px solid color-mix(in srgb, var(--success) 35%, transparent);\n  border-radius: 8px;\n  font-size: .8rem;\n  font-weight: 800;\n  padding: 5px 14px;\n}\n.inv-pending-badge {\n  background: rgba(255, 103, 0,.12);\n  color: var(--color-primary);\n  border-color: rgba(255, 103, 0,.4);\n}\n\n.inv-divider { height: 1px; background: var(--border); margin: 0 0 24px; }\n\n/* Address cards */\n.inv-addr-row { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 28px; }\n.inv-addr-label {\n  font-size: .68rem;\n  font-weight: 800;\n  letter-spacing: .1em;\n  text-transform: uppercase;\n  color: var(--color-secondary-hover);\n  margin: 0 0 10px;\n  display: block;\n}\n.inv-addr-card {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  padding: 14px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  margin-bottom: 10px;\n}\n.inv-addr-icon-box {\n  width: 44px; height: 44px;\n  border-radius: 10px;\n  display: flex; align-items: center; justify-content: center;\n  flex-shrink: 0;\n}\n.inv-addr-icon-store    { background: rgba(59, 130, 246,.1); }\n.inv-addr-icon-customer { background: color-mix(in srgb, var(--success) 10%, transparent); }\n.inv-addr-name { font-size: .92rem; font-weight: 700; color: var(--text-primary); margin: 0 0 4px; display: block; }\n.inv-addr-line { font-size: .82rem; color: var(--text-secondary); margin: 0 0 2px; display: block; }\n.inv-addr-contact-row  { display: flex; align-items: center; gap: 6px; font-size: .8rem; color: var(--text-secondary); padding: 0 4px; }\n\n/* Items table */\n.inv-table { width: 100%; border-collapse: collapse; margin-bottom: 28px; border: 1px solid var(--border); border-radius: 10px; overflow: hidden; }\n.inv-thead-row { background: var(--bg-tertiary); }\n.inv-th {\n  padding: 11px 14px;\n  font-size: .72rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: .07em;\n  color: var(--color-secondary-hover);\n  border-bottom: 1.5px solid var(--border);\n  text-align: left;\n}\n.inv-th.inv-th-c { text-align: center; }\n.inv-th.inv-th-r { text-align: right; }\n.inv-td { padding: 14px; font-size: .86rem; color: var(--text-primary); border-bottom: 1px solid var(--bg-tertiary); vertical-align: middle; }\n.inv-td.inv-td-c { text-align: center; }\n.inv-td.inv-td-r { text-align: right; font-weight: 700; }\n.inv-item-cell { display: flex; align-items: center; gap: 12px; }\n.inv-item-img-box {\n  width: 44px; height: 44px;\n  border-radius: 8px;\n  background: var(--bg-tertiary);\n  display: flex; align-items: center; justify-content: center;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n.inv-item-thumb { width: 44px; height: 44px; object-fit: contain; }\n.inv-item-name { font-size: .88rem; font-weight: 600; color: var(--text-primary); margin: 0 0 3px; display: block; }\n.inv-item-sku  { font-size: .74rem; color: var(--text-muted); margin: 0; display: block; }\n\n/* Bottom row */\n.inv-bottom-row { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 28px; align-items: start; }\n.inv-thanks-col { display: flex; flex-direction: column; gap: 16px; }\n.inv-thanks-hdr {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  padding: 14px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-radius: 10px;\n}\n.inv-thanks-icon  { font-size: 1.6rem; flex-shrink: 0; }\n.inv-thanks-title { font-size: .9rem; font-weight: 700; color: var(--color-secondary-hover); margin: 0 0 4px; display: block; }\n.inv-thanks-sub   { font-size: .8rem; color: var(--text-secondary); margin: 0; display: block; }\n.inv-bottom-contacts { display: flex; flex-direction: column; gap: 6px; padding: 0 4px; }\n.inv-contact-row { display: flex; align-items: center; gap: 6px; font-size: .8rem; color: var(--text-secondary); }\n\n.inv-totals-col { border: 1px solid var(--border); border-radius: 10px; overflow: hidden; }\n.inv-total-row { display: flex; justify-content: space-between; padding: 10px 16px; font-size: .84rem; color: var(--text-secondary); border-bottom: 1px solid var(--bg-tertiary); }\n.inv-discount-row { color: var(--color-primary); }\n.inv-free-text { color: var(--success); font-weight: 600; }\n.inv-totals-divider { height: 1.5px; background: var(--border); }\n.inv-grand-row { display: flex; justify-content: space-between; align-items: center; padding: 14px 16px; font-size: .95rem; font-weight: 800; color: var(--text-primary); }\n.inv-grand-amount { font-size: 1.4rem; font-weight: 900; color: var(--color-secondary-hover); }\n.inv-paid-success {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 10px 16px;\n  background: color-mix(in srgb, var(--success) 8%, transparent);\n  border-top: 1px solid color-mix(in srgb, var(--success) 20%, transparent);\n  font-size: .82rem;\n  color: var(--success);\n  font-weight: 600;\n}\n.inv-payment-pending-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 7px;\n  padding: 10px 16px;\n  background: rgba(255, 103, 0,.08);\n  border-top: 1px solid rgba(255, 103, 0,.2);\n  font-size: .82rem;\n  color: var(--color-primary);\n  font-weight: 600;\n}\n\n/* Footer */\n.inv-footer { border-top: 1px solid var(--border); padding-top: 18px; padding-bottom: 8px; text-align: center; }\n.inv-footer-inner {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  padding: 12px 20px;\n  font-size: .8rem;\n  color: var(--text-secondary);\n}\n.inv-footer-shield { font-size: 1.2rem; }\n\n@media (max-width: 640px) {\n  .inv-modal { width: 100%; min-height: 0; }\n  .inv-doc { padding: 24px 20px; }\n  .inv-bottom-row { grid-template-columns: 1fr; }\n  .inv-addr-row   { grid-template-columns: 1fr; }\n}\n\n@media print {\n  .inv-overlay { position: static; background: none; padding: 0; overflow: visible; }\n  .inv-modal { box-shadow: none; border-radius: 0; width: 100%; min-height: 0; }\n  .inv-actions { display: none; }\n}\n\n/* ═══════════════════════════════════════════════════════════\n   LOGO  — gradient \"Store\" text + nav icon alignment\n   ══════════════════════════════════════════════════════════ */\n.logo-store-text {\n  color: var(--color-primary);\n}\n\n/* Navbar logo: align SVG icon with text */\n.nb-logo {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n}\n.nb-logo svg { display: block; flex-shrink: 0; }\n\n/* Sub-page header logo */\n.sph-left { display: flex; align-items: center; gap: var(--space-1); }\n.sph-left svg { display: block; flex-shrink: 0; }\n\n/* ── Wishlist Page ───────────────────────────────────────── */\n.wl-page { max-width: 1200px; margin: 0 auto; padding: 0 0 48px; }\n.wl-loading { padding: 60px; text-align: center; color: var(--text-secondary); font-size: 0.9rem; }\n\n/* Header */\n.wl-header {\n  display: flex; align-items: center; justify-content: space-between;\n  flex-wrap: wrap; gap: var(--space-2); margin-bottom: 28px;\n}\n.wl-header-left { display: flex; align-items: center; gap: 18px; }\n.wl-icon-wrap {\n  width: 60px; height: 60px; border-radius: 50%;\n  background: rgba(59, 130, 246,0.18);\n  display: flex; align-items: center; justify-content: center; flex-shrink: 0;\n}\n.wl-title   { font-size: 1.75rem; font-weight: 800; color: var(--text-primary); margin: 0 0 3px; }\n.wl-subtitle { font-size: 0.85rem; color: var(--text-secondary); margin: 0; }\n\n.wl-header-actions { display: flex; gap: 10px; flex-wrap: wrap; }\n.wl-share-btn {\n  display: flex; align-items: center; gap: 7px;\n  background: transparent; border: 1px solid var(--border);\n  border-radius: var(--radius-sm); color: var(--text-primary);\n  font-size: 0.84rem; font-weight: 600; padding: 10px 18px;\n  cursor: pointer; transition: border-color 150ms, background 150ms;\n}\n.wl-share-btn:hover { border-color: var(--accent); background: rgba(59, 130, 246,0.06); }\n.wl-add-all-btn {\n  display: flex; align-items: center; gap: 7px;\n  background: var(--accent); border: none; border-radius: var(--radius-sm);\n  color: var(--color-text-on-secondary); font-size: 0.84rem; font-weight: 700; padding: 10px 20px;\n  cursor: pointer; transition: background 150ms;\n}\n.wl-add-all-btn:hover:not(:disabled) { background: var(--accent-hover); }\n.wl-add-all-btn:disabled { opacity: 0.45; cursor: not-allowed; }\n\n/* Controls bar */\n.wl-controls {\n  display: flex; align-items: center; justify-content: space-between;\n  margin-bottom: 18px; gap: 12px; flex-wrap: wrap;\n}\n.wl-count { font-size: 0.9rem; font-weight: 600; color: var(--text-secondary); }\n.wl-controls-right { display: flex; align-items: center; gap: 10px; }\n\n.wl-view-toggle {\n  display: flex; border: 1px solid var(--border); border-radius: var(--radius-sm); overflow: hidden;\n}\n.wl-view-btn {\n  background: transparent; border: none; padding: 8px 12px;\n  color: var(--text-tertiary); cursor: pointer; transition: background 150ms, color 150ms;\n  display: flex; align-items: center;\n}\n.wl-view-btn.active  { background: var(--accent); color: var(--color-text-on-secondary); }\n.wl-view-btn:not(.active):hover { background: var(--bg-primary); color: var(--text-primary); }\n\n.wl-sort-select {\n  background: var(--bg-secondary); border: 1px solid var(--border);\n  border-radius: var(--radius-sm); color: var(--text-primary);\n  font-size: 0.83rem; padding: 8px 14px; cursor: pointer; outline: none;\n}\n\n/* List / Grid containers */\n.wl-list { display: flex; flex-direction: column; gap: var(--space-2); }\n.wl-grid  {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  gap: 18px;\n}\n\n/* Item card */\n.wl-item {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  box-shadow: var(--shadow-card);\n  transition: box-shadow 200ms, border-color 200ms;\n}\n.wl-list .wl-item {\n  display: grid;\n  grid-template-columns: 280px 1fr 220px;\n  align-items: stretch;\n}\n.wl-grid .wl-item { display: flex; flex-direction: column; }\n.wl-item:hover { box-shadow: 0 6px 28px rgba(1, 13, 33,0.12); border-color: rgba(59, 130, 246,0.25); }\n.wl-item-oos { opacity: 0.68; }\n\n/* Image */\n.wl-item-img-wrap {\n  position: relative; overflow: hidden;\n  background: var(--bg-tertiary); flex-shrink: 0;\n}\n.wl-list .wl-item-img-wrap { height: 100%; min-height: 190px; }\n.wl-grid .wl-item-img-wrap { height: 200px; }\n.wl-item-img-wrap img {\n  width: 100%; height: 100%; object-fit: cover;\n  transition: transform 300ms ease;\n}\n.wl-item:hover .wl-item-img-wrap img { transform: scale(1.05); }\n\n.wl-item-heart {\n  position: absolute; top: 12px; right: 12px;\n  width: 34px; height: 34px; border-radius: 50%;\n  background: var(--bg-secondary); border: 1px solid var(--border); cursor: pointer;\n  display: flex; align-items: center; justify-content: center;\n  box-shadow: var(--shadow-sm);\n  transition: transform 150ms;\n  z-index: 2;\n}\n.wl-item-heart:hover { transform: scale(1.14); }\n\n\n/* Body */\n.wl-item-body {\n  padding: 18px 20px 14px;\n  display: flex; flex-direction: column; gap: 7px; flex: 1;\n}\n.wl-item-cat {\n  font-size: 0.7rem; font-weight: 700; letter-spacing: 0.05em;\n  padding: 4px 11px; border-radius: var(--radius-xl); align-self: flex-start;\n  text-transform: uppercase;\n}\n.wl-item-name {\n  font-size: 1.18rem; font-weight: 800; color: var(--text-primary);\n  margin: 0; line-height: 1.3;\n}\n.wl-item-rating { display: flex; align-items: center; gap: 1px; }\n.wl-star        { font-size: 1rem; line-height: 1; }\n.wl-rating-cnt  { font-size: 0.78rem; color: var(--text-tertiary); margin-left: 5px; }\n.wl-item-desc {\n  font-size: 0.82rem; color: var(--text-secondary); margin: 0;\n  line-height: 1.55; display: -webkit-box;\n  -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;\n}\n\n/* Feature tags */\n.wl-feature-tags {\n  display: flex; flex-wrap: wrap; gap: 6px; margin-top: 4px;\n}\n.wl-feat-tag {\n  display: inline-flex; align-items: center; gap: 5px;\n  background: transparent;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xl);\n  font-size: 0.72rem; font-weight: 500; color: var(--text-secondary);\n  padding: 4px 10px;\n  white-space: nowrap;\n}\n[data-theme=\"dark\"] .wl-feat-tag { border-color: rgba(255,255,255,0.12); }\n\n/* Actions panel */\n.wl-item-actions {\n  padding: 18px 18px 16px;\n  display: flex; flex-direction: column; gap: 9px;\n  border-left: 1px solid var(--border);\n  justify-content: center;\n}\n.wl-grid .wl-item-actions {\n  border-left: none; border-top: 1px solid var(--border);\n}\n\n.wl-price-row  { display: flex; align-items: baseline; gap: 9px; }\n.wl-price      { font-size: 1.4rem; font-weight: 800; color: var(--text-primary); }\n.wl-original   { font-size: 0.82rem; color: var(--text-tertiary); text-decoration: line-through; }\n\n.wl-stock {\n  display: flex; align-items: center; gap: 7px;\n  font-size: 0.8rem; font-weight: 600;\n}\n.wl-stock-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }\n.wl-in-stock  { color: var(--success); }\n.wl-oos       { color: var(--danger); }\n\n.wl-add-cart-btn {\n  width: 100%; background: var(--accent); border: none; border-radius: var(--radius-sm);\n  color: var(--color-text-on-secondary); font-size: 0.84rem; font-weight: 700; padding: 10px 14px;\n  cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 7px;\n  transition: background 150ms;\n}\n.wl-add-cart-btn:hover:not(:disabled) { background: var(--accent-hover); }\n.wl-add-cart-btn:disabled { opacity: 0.4; cursor: not-allowed; }\n\n.wl-move-cart-btn {\n  width: 100%; background: transparent;\n  border: 1px solid var(--border); border-radius: var(--radius-sm);\n  color: var(--text-primary); font-size: 0.84rem; font-weight: 600; padding: 9px 14px;\n  cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 7px;\n  transition: border-color 150ms, background 150ms;\n}\n.wl-move-cart-btn:hover:not(:disabled) { border-color: var(--accent); background: rgba(59, 130, 246,0.06); }\n.wl-move-cart-btn:disabled { opacity: 0.4; cursor: not-allowed; }\n\n.wl-remove-btn {\n  background: none; border: none; color: var(--danger);\n  font-size: 0.8rem; font-weight: 600; cursor: pointer; padding: 3px 0;\n  display: flex; align-items: center; gap: 6px; transition: opacity 150ms;\n  align-self: flex-start;\n}\n.wl-remove-btn:hover { opacity: 0.72; }\n\n/* Bottom feature strip */\n.wl-features {\n  display: grid; grid-template-columns: repeat(3, 1fr);\n  gap: 0; margin-top: 36px;\n  background: var(--bg-secondary); border: 1px solid var(--border);\n  border-radius: var(--radius-md); overflow: hidden;\n  box-shadow: var(--shadow-card);\n}\n.wl-feature-item {\n  display: flex; align-items: center; gap: var(--space-2);\n  padding: 22px 24px;\n  border-right: 1px solid var(--border);\n}\n.wl-feature-item:last-child { border-right: none; }\n.wl-feature-icon {\n  width: 50px; height: 50px; border-radius: 50%; flex-shrink: 0;\n  display: flex; align-items: center; justify-content: center;\n}\n.wl-feature-title { font-size: 0.9rem; font-weight: 700; color: var(--text-primary); margin: 0 0 3px; }\n.wl-feature-desc  { font-size: 0.78rem; color: var(--text-secondary); margin: 0; line-height: 1.45; }\n\n/* Empty state */\n.wl-empty { text-align: center; padding: 90px 20px; color: var(--text-secondary); }\n.wl-empty-icon {\n  width: 84px; height: 84px; border-radius: 50%;\n  background: var(--bg-primary); border: 2px solid var(--border);\n  display: flex; align-items: center; justify-content: center; margin: 0 auto 20px;\n}\n.wl-empty h3 { font-size: 1.1rem; color: var(--text-primary); margin: 0 0 8px; }\n.wl-empty p  { font-size: 0.85rem; margin: 0; }\n\n/* Responsive */\n@media (max-width: 900px) {\n  .wl-list .wl-item { grid-template-columns: 200px 1fr; }\n  .wl-item-actions  { grid-column: 1 / -1; border-left: none; border-top: 1px solid var(--border); }\n}\n@media (max-width: 600px) {\n  .wl-list .wl-item { grid-template-columns: 1fr; }\n  .wl-list .wl-item-img-wrap { height: 200px; }\n  .wl-features { grid-template-columns: 1fr; }\n  .wl-feature-item { border-right: none; border-bottom: 1px solid var(--border); }\n  .wl-feature-item:last-child { border-bottom: none; }\n}\n\n/* ── Customer Dashboard ──────────────────────────────────────── */\n.dash-page {\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n.dash-greeting {\n  font-size: 1.4rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  margin: 0 0 var(--space-3);\n}\n\n.dash-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: var(--space-2);\n  margin-bottom: var(--space-4);\n}\n\n.dash-stat-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n  background: var(--bg-secondary);\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: var(--space-2);\n  box-shadow: var(--shadow-card);\n}\n\n.dash-stat-icon {\n  font-size: 1.6rem;\n  flex-shrink: 0;\n}\n.dash-stat-card > div { min-width: 0; }\n\n.dash-stat-value {\n  font-size: 1.25rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dash-stat-label {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dash-stat-sub {\n  font-size: 0.7rem;\n  font-weight: 700;\n  color: var(--accent);\n  margin-top: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@media (max-width: 480px) {\n  /* Icon-beside-text doesn't leave enough room for a full currency\n     value in a 2-column grid -- stack icon above text so the value\n     gets the card's full width instead of sharing it. */\n  .dash-stat-card { flex-direction: column; align-items: flex-start; gap: 6px; }\n  .dash-stat-value { font-size: 1.1rem; }\n}\n\n.dash-section {\n  margin-bottom: var(--space-4);\n}\n\n.dash-section-hdr {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--space-2);\n}\n\n.dash-section-hdr h3 {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.dash-section-link {\n  background: none;\n  border: none;\n  color: var(--accent);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.dash-empty {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.dash-orders-table {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  box-shadow: var(--shadow-card);\n}\n\n.dash-order-row {\n  display: grid;\n  grid-template-columns: 110px 1fr 120px 100px;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  font-size: 0.85rem;\n  border-bottom: 1px solid var(--border);\n}\n.dash-order-row:last-child { border-bottom: none; }\n\n.dash-order-id { font-weight: 700; color: var(--text-primary); }\n.dash-order-date { color: var(--text-secondary); }\n.dash-order-total { font-weight: 700; text-align: right; color: var(--text-primary); }\n\n.dash-order-status {\n  font-size: 0.72rem;\n  font-weight: 700;\n  padding: 4px 10px;\n  border-radius: var(--radius-pill);\n  text-align: center;\n  width: fit-content;\n  text-transform: capitalize;\n}\n.dash-status-delivered { background: rgba(59, 130, 246,0.12); color: var(--success); }\n.dash-status-shipped   { background: rgba(59,130,246,0.12); color: var(--accent); }\n.dash-status-processing,\n.dash-status-confirmed { background: rgba(255, 103, 0,0.12); color: var(--color-primary); }\n.dash-status-cancelled { background: color-mix(in srgb, var(--danger) 12%, transparent); color: var(--danger); }\n.dash-status-received,\n.dash-status-pending  { background: var(--bg-tertiary); color: var(--text-secondary); }\n\n.dash-card-strip {\n  display: flex;\n  gap: 12px;\n  overflow-x: auto;\n}\n\n.dash-mini-card {\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  width: 140px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 10px;\n  gap: 4px;\n  box-shadow: var(--shadow-card);\n}\n\n.dash-mini-card img {\n  width: 100%;\n  height: 90px;\n  object-fit: contain;\n  border-radius: var(--radius-sm);\n  margin-bottom: 4px;\n}\n\n.dash-mini-name {\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dash-mini-price {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.dash-mini-buy-btn {\n  margin-top: 4px;\n  min-height: 36px;\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  border: none;\n  border-radius: var(--radius-sm);\n  font-size: 0.75rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n.dash-mini-buy-btn:hover { background: var(--accent-hover); }\n\n@media (max-width: 900px) {\n  .dash-stats-grid { grid-template-columns: repeat(2, 1fr); }\n  .dash-order-row { grid-template-columns: 90px 1fr 90px; }\n  .dash-order-date { display: none; }\n}\n\n/* ── 404 / Not Found ─────────────────────────────────────────── */\n.nf-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n.nf-logo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 24px 0;\n}\n.nf-logo-name {\n  font-size: 1.3rem;\n  font-weight: 800;\n  color: var(--text-primary);\n}\n\n.nf-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 40px 20px;\n}\n\n.nf-code {\n  font-size: 6rem;\n  font-weight: 800;\n  color: var(--accent);\n  line-height: 1;\n}\n\n.nf-title {\n  font-size: 1.4rem;\n  font-weight: 700;\n  margin: 8px 0 8px;\n}\n\n.nf-desc {\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n  max-width: 380px;\n  margin: 0 0 24px;\n}\n\n.nf-home-btn {\n  flex: none;\n  padding: 12px 28px;\n}\n\n/* ── Footer ──────────────────────────────────────────────────── */\n.ftr {\n  margin-top: auto;\n  font-size: 0.85rem;\n}\n\n/* Trust bar */\n.ftr-trust-bar {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: var(--space-2);\n  background: var(--bg-secondary);\n  border-top: 1px solid var(--border);\n  padding: var(--space-3) var(--space-4);\n}\n.ftr-trust-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n.ftr-trust-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n  flex-shrink: 0;\n}\n.ftr-trust-icon--blue   { background: rgba(59,130,246,0.14); }\n.ftr-trust-icon--positive  { background: color-mix(in srgb, var(--success) 14%, transparent); }\n.ftr-trust-icon--orange { background: rgba(255, 103, 0,0.14); }\n.ftr-trust-icon--info { background: color-mix(in srgb, var(--accent-secondary) 14%, transparent); }\n/* The trust bar sits on --bg-secondary (a white band ABOVE the navy footer),\n   not on the navy itself -- so unlike the rest of the footer it takes the\n   normal theme-adaptive text tokens. */\n.ftr-trust-title { font-weight: 700; color: var(--text-primary); font-size: 0.92rem; }\n.ftr-trust-sub   { color: var(--text-secondary); font-size: 0.78rem; margin-top: 2px; }\n\n/* Everything below the trust bar is a fixed dark zone regardless of site theme */\n.ftr-cta-row,\n.ftr-links-row,\n.ftr-meta-row,\n.ftr-bottom-bar {\n  background: var(--color-brand-navy);\n  color: var(--color-on-navy-secondary);\n}\n\n.ftr-cta-row {\n  display: grid;\n  grid-template-columns: 1.3fr 1fr 1fr;\n  gap: var(--space-4);\n  align-items: center;\n  padding: var(--space-4);\n  border-top: 1px solid rgba(255,255,255,0.14);\n}\n.ftr-cta-row > * { min-width: 0; }\n.ftr-brand-block { padding-right: var(--space-2); }\n.ftr-brand-logo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin-bottom: var(--space-2);\n}\n.ftr-brand-name { font-size: 1.3rem; font-weight: 800; color: var(--color-brand-white); }\n.ftr-brand-tag  { font-weight: 700; color: var(--color-brand-white); margin: 0 0 8px; font-size: 0.92rem; }\n.ftr-brand-desc { color: var(--color-on-navy-muted); line-height: 1.5; margin: 0; }\n\n.ftr-cta-block {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 0 var(--space-2);\n  position: relative;\n  min-width: 0;\n}\n.ftr-cta-block::before {\n  content: '';\n  position: absolute;\n  left: calc(-1 * var(--space-2));\n  top: 4px;\n  bottom: 4px;\n  width: 1px;\n  background: rgba(255,255,255,0.16);\n}\n.ftr-cta-top {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  width: 100%;\n}\n.ftr-cta-top > div { min-width: 0; }\n.ftr-cta-icon {\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  background: rgba(59,130,246,0.18);\n  color: var(--color-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.2rem;\n  flex-shrink: 0;\n}\n.ftr-cta-icon--info { background: rgba(1, 13, 33,0.18); color: var(--color-secondary); }\n.ftr-cta-title { font-weight: 700; color: var(--color-brand-white); font-size: 0.95rem; margin-bottom: 4px; }\n.ftr-cta-sub { color: var(--color-on-navy-muted); margin: 0; font-size: 0.82rem; line-height: 1.4; }\n.ftr-cta-btn {\n  flex: none;\n  /* Solid brand blue, not the translucent hover variant: over the navy footer\n     that flattened to a lighter blue and dropped navy-on-blue to 4.33:1, just\n     under AA. Solid #3B82F6 gives 5.6:1. */\n  background: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n  font-size: 0.85rem;\n  padding: 10px 18px;\n  gap: 8px;\n}\n.ftr-cta-btn:hover { background: var(--color-secondary-hover); }\n\n/* Seller-benefit bullets -- mobile-only, see breakpoint below */\n.ftr-cta-features { display: none; }\n.ftr-cta-feature { display: flex; align-items: flex-start; gap: 8px; min-width: 0; }\n.ftr-cta-feature-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.ftr-cta-feature-icon--blue   { background: rgba(59,130,246,0.18);  color: var(--color-secondary); }\n.ftr-cta-feature-icon--positive  { background: color-mix(in srgb, var(--success) 18%, transparent);   color: var(--success); }\n.ftr-cta-feature-icon--info { background: rgba(1, 13, 33,0.18); color: var(--color-secondary); }\n.ftr-cta-feature-title { font-weight: 700; color: var(--color-brand-white); font-size: 0.78rem; line-height: 1.2; }\n.ftr-cta-feature-sub   { color: var(--color-on-navy-muted); font-size: 0.7rem; line-height: 1.3; margin-top: 2px; }\n\n.ftr-subscribe-row {\n  display: flex;\n  gap: 8px;\n  width: 100%;\n}\n.ftr-subscribe-input-wrap {\n  position: relative;\n  flex: 1;\n  min-width: 0;\n}\n.ftr-subscribe-input-icon {\n  position: absolute;\n  left: 13px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--color-on-navy-muted);\n  display: flex;\n  pointer-events: none;\n}\n.ftr-subscribe-row input {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 40px;\n  padding: 0 14px 0 38px;\n  border-radius: var(--radius-sm);\n  border: 1px solid rgba(255,255,255,0.25);\n  background: rgba(255,255,255,0.1);\n  color: var(--color-brand-white);\n  font-size: 0.85rem;\n}\n.ftr-subscribe-row input::placeholder { color: var(--color-on-navy-muted); }\n.ftr-subscribe-row input:focus { outline: none; border-color: var(--color-brand-navy); }\n.ftr-subscribe-btn {\n  flex: none;\n  min-height: 40px;\n  padding: 0 18px;\n  background: var(--color-brand-navy);\n  color: var(--color-brand-white);\n  border: none;\n  border-radius: var(--radius-sm);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 150ms;\n}\n.ftr-subscribe-btn:hover { background: var(--color-primary-hover); }\n\n/* Link columns */\n.ftr-links-row {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: var(--space-3);\n  padding: var(--space-4);\n  border-top: 1px solid rgba(255,255,255,0.14);\n}\n.ftr-col-title {\n  color: var(--color-brand-white);\n  font-size: 0.8rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  margin: 0 0 10px;\n}\n.ftr-col-title::after {\n  content: '';\n  display: block;\n  width: 28px;\n  height: 3px;\n  border-radius: var(--radius-pill);\n  background: var(--color-brand-navy);\n  margin-top: 8px;\n}\n.ftr-link-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 2px; }\n.ftr-link {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 32px;\n  background: none;\n  border: none;\n  /* Entries with a real destination render as <a href> so crawlers can reach\n     the legal/company/support pages; the rest are still <button>. Both share\n     this class, so the link underline is cancelled here. */\n  text-decoration: none;\n  color: var(--color-on-navy-muted);\n  font-size: 0.84rem;\n  text-align: left;\n  cursor: pointer;\n  padding: 4px 0;\n  transition: color 150ms, transform 150ms;\n}\n.ftr-link svg { opacity: 0; transform: translateX(-4px); transition: opacity 150ms, transform 150ms; }\n.ftr-link:hover { color: var(--color-brand-white); }\n.ftr-link:hover svg { opacity: 1; transform: translateX(0); }\n.ftr-link:focus-visible { outline: 2px solid var(--color-secondary); outline-offset: 2px; }\n\n/* Social row */\n.ftr-meta-row {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--space-3);\n  padding: var(--space-3) var(--space-4);\n  border-top: 1px solid rgba(255,255,255,0.14);\n  align-items: start;\n}\n.ftr-meta-title {\n  color: var(--color-brand-white);\n  font-size: 0.75rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  margin: 0 0 12px;\n}\n\n.ftr-social-row { display: flex; gap: 10px; flex-wrap: wrap; }\n.ftr-social-btn {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  border: none;\n  cursor: pointer;\n  color: var(--color-brand-white);\n  font-weight: 800;\n  font-size: 0.95rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ftr-social-btn--fb { background: #1877f2; }\n.ftr-social-btn--ig { background: linear-gradient(135deg, #f58529, #dd2a7b, #8134af); }\n.ftr-social-btn--x  { background: #000; }\n/* TikTok's mark is black, same as X above -- a third-party brand colour, kept\n   literal. --text-primary made it navy-on-navy and it vanished into the footer. */\n.ftr-social-btn--tt { background: #000; }\n.ftr-social-btn--yt { background: #ff0000; }\n.ftr-social-btn--li { background: #0a66c2; font-size: 0.75rem; }\n\n/* Bottom bar */\n.ftr-bottom-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: var(--space-2) var(--space-4);\n  border-top: 1px solid rgba(255,255,255,0.14);\n  background: var(--color-brand-navy);\n  color: var(--color-on-navy-secondary);\n  font-size: 0.78rem;\n}\n.ftr-bottom-links { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }\n.ftr-bottom-link {\n  background: none;\n  border: none;\n  /* Mixed <a>/<button> like .ftr-link -- see that rule. */\n  text-decoration: none;\n  color: var(--color-on-navy-muted);\n  font-size: 0.78rem;\n  cursor: pointer;\n  /* 50x18 measured, against the 24px minimum. inline-flex so the vertical\n     padding actually makes a box -- on the default inline display, top and\n     bottom padding paints but does not change the hit area. */\n  display: inline-flex;\n  align-items: center;\n  min-height: 24px;\n  padding: 2px 4px;\n}\n.ftr-bottom-link:hover { color: var(--color-brand-white); }\n.ftr-bottom-sep { color: var(--color-on-navy-secondary); margin-right: 8px; }\n\n@media (max-width: 1024px) {\n  .ftr-trust-bar { grid-template-columns: repeat(2, 1fr); }\n  .ftr-cta-row { grid-template-columns: 1fr; }\n  .ftr-cta-block::before { display: none; }\n  .ftr-links-row { grid-template-columns: repeat(3, 1fr); }\n  .ftr-meta-row { grid-template-columns: 1fr; }\n}\n@media (max-width: 640px) {\n  .ftr-trust-bar { grid-template-columns: 1fr; padding: var(--space-2); }\n  .ftr-links-row { grid-template-columns: repeat(2, 1fr); padding: var(--space-3); }\n  .ftr-cta-row { padding: var(--space-3); gap: var(--space-3); }\n  .ftr-meta-row { padding: var(--space-3); }\n  .ftr-bottom-bar { flex-direction: column; align-items: flex-start; text-align: left; }\n\n  /* Seller-signup and newsletter CTA cards get the full \"stand out\" treatment on mobile */\n  .ftr-cta-block {\n    box-sizing: border-box;\n    align-items: stretch;\n    padding: var(--space-3);\n    background: rgba(255,255,255,0.035);\n    border: 1px solid rgba(255,255,255,0.1);\n    border-radius: var(--radius-lg);\n  }\n  .ftr-cta-block::before { display: none; }\n  .ftr-cta-icon {\n    width: 64px;\n    height: 64px;\n    border-radius: 18px;\n    font-size: 1.7rem;\n  }\n  .ftr-cta-title { font-size: 1.05rem; }\n  .ftr-cta-sub { font-size: 0.85rem; }\n  .ftr-cta-features {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px;\n    padding-top: var(--space-2);\n    border-top: 1px solid rgba(255,255,255,0.12);\n  }\n  .ftr-cta-feature { flex-direction: column; gap: 8px; }\n  .ftr-cta-btn { box-sizing: border-box; width: 100%; min-height: 48px; font-size: 0.95rem; }\n}\n\n/* ════════════════════════════════════════════════════════════════\n   Operations Dashboard (ops-*)\n   ════════════════════════════════════════════════════════════════ */\n.ops-root {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Funnel */\n.ops-funnel-card { padding: 20px 24px; }\n.ops-funnel { display: flex; flex-direction: column; gap: 14px; margin-top: 8px; }\n.ops-funnel-step { display: flex; align-items: center; gap: 16px; }\n.ops-funnel-bar-track {\n  flex: 1;\n  height: 28px;\n  background: var(--surface-raised, var(--bg-tertiary));\n  border-radius: 6px;\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n@media (prefers-color-scheme: dark) { .ops-funnel-bar-track { background: rgba(255,255,255,0.06); } }\n:root[data-theme=\"dark\"]  .ops-funnel-bar-track { background: rgba(255,255,255,0.06); }\n:root[data-theme=\"light\"] .ops-funnel-bar-track { background: var(--bg-tertiary); }\n.ops-funnel-bar { height: 100%; border-radius: 6px; transition: width 0.6s ease; min-width: 3%; }\n.ops-funnel-arrow { position: absolute; right: 10px; font-size: 11px; font-weight: 600; color: var(--text-muted); white-space: nowrap; }\n.ops-funnel-meta { display: flex; flex-direction: column; align-items: flex-end; width: 130px; flex-shrink: 0; }\n.ops-funnel-val   { font-size: 16px; font-weight: 800; line-height: 1.1; }\n.ops-funnel-label { font-size: 12px; font-weight: 600; color: var(--text-primary); }\n.ops-funnel-sub   { font-size: 10px; color: var(--text-muted); }\n\n/* GMV row */\n.ops-gmv-row {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 12px;\n}\n@media (max-width: 1200px) { .ops-gmv-row { grid-template-columns: repeat(3, 1fr); } }\n@media (max-width: 640px)  { .ops-gmv-row { grid-template-columns: repeat(2, 1fr); } }\n.ops-gmv-card {\n  background: var(--surface-card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 14px 16px;\n  display: grid;\n  grid-template-rows: 36px 2.5em auto 1fr;\n  row-gap: 4px;\n}\n.ops-gmv-icon {\n  width: 32px; height: 32px; border-radius: 8px;\n  display: flex; align-items: center; justify-content: center;\n  font-size: 15px;\n}\n.ops-gmv-label { align-self: center; font-size: 11px; line-height: 1.25; color: var(--text-muted); font-weight: 500; margin: 0; }\n.ops-gmv-val   { font-size: 18px; font-weight: 800; color: var(--text-primary); line-height: 1.1; margin: 0; white-space: nowrap; }\n.ops-gmv-sub   { align-self: end; font-size: 10px; color: var(--text-muted); margin: 2px 0 0; }\n\n/* Sort chips -- mobile only.\n   Hidden here rather than in the mobile layer, because the desktop <select>\n   is the control on a wide screen and two sort widgets on one page would be\n   two sources of truth to keep in sync. mobile/feed.css turns this on and\n   the select off, so exactly one is live at any width. */\n.shop-sort-chips { display: none; }\n\n/* New-order banner\n   Orange, because this is the one thing on the dashboard asking to be acted\n   on commercially -- and navy on orange is 7.4:1, so the text stays legible\n   without the white that fails AA on this fill. The dot pulses to catch the\n   eye of someone already looking elsewhere on the page; it is decorative and\n   the wording carries the meaning on its own. */\n.admin-neworder-banner {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  background: var(--color-primary-soft, rgba(255, 103, 0, 0.12));\n  border: 1px solid var(--color-primary);\n  border-radius: var(--radius-lg);\n  padding: 13px 16px;\n  margin-bottom: 18px;\n}\n\n.admin-neworder-pulse {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: var(--color-primary);\n  flex-shrink: 0;\n  animation: admin-neworder-ping 1.8s ease-out infinite;\n}\n\n@keyframes admin-neworder-ping {\n  0%   { box-shadow: 0 0 0 0 rgba(255, 103, 0, 0.55); }\n  70%  { box-shadow: 0 0 0 9px rgba(255, 103, 0, 0); }\n  100% { box-shadow: 0 0 0 0 rgba(255, 103, 0, 0); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .admin-neworder-pulse { animation: none; }\n}\n\n.admin-neworder-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1;\n}\n.admin-neworder-text strong { font-size: 14px; color: var(--text-primary); }\n.admin-neworder-detail {\n  font-size: 12px;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.admin-neworder-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.admin-neworder-cta {\n  background: var(--color-primary);\n  color: var(--color-text-on-primary);\n  border: none;\n  border-radius: var(--radius-sm);\n  padding: 8px 14px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.admin-neworder-cta:hover { filter: brightness(0.94); }\n\n.admin-neworder-secondary {\n  background: none;\n  border: 1px solid var(--color-primary);\n  color: var(--text-primary);\n  border-radius: var(--radius-sm);\n  padding: 7px 12px;\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.admin-neworder-dismiss {\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  font-size: 20px;\n  line-height: 1;\n  padding: 0 4px;\n  cursor: pointer;\n}\n.admin-neworder-dismiss:hover { color: var(--text-primary); }\n\n.admin-neworder-cta:focus-visible,\n.admin-neworder-secondary:focus-visible,\n.admin-neworder-dismiss:focus-visible {\n  outline: 2px solid var(--color-secondary);\n  outline-offset: 2px;\n}\n\n@media (max-width: 720px) {\n  .admin-neworder-banner { flex-wrap: wrap; }\n  .admin-neworder-text { flex-basis: 100%; }\n  .admin-neworder-actions { margin-left: auto; }\n}\n\n/* Sales-channel panel (app vs website) */\n.ops-channel-panel {\n  background: var(--surface-card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 16px;\n}\n.ops-channel-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n.ops-channel-title  { font-size: 13px; font-weight: 700; color: var(--text-primary); margin: 0; }\n.ops-channel-period { font-size: 10px; color: var(--text-muted); }\n\n/* One track, one segment per channel with revenue. */\n.ops-channel-bar {\n  display: flex;\n  height: 8px;\n  border-radius: 999px;\n  overflow: hidden;\n  background: var(--bg-tertiary);\n  margin-bottom: 14px;\n}\n.ops-channel-bar-seg { display: block; height: 100%; }\n\n.ops-channel-rows { display: grid; gap: 8px; }\n.ops-channel-row {\n  display: grid;\n  grid-template-columns: 8px 18px minmax(90px, 1.4fr) 46px minmax(64px, 1fr) minmax(64px, 1fr) minmax(74px, 1fr) 62px;\n  align-items: center;\n  gap: 8px;\n  font-size: 11px;\n}\n.ops-channel-dot  { width: 8px; height: 8px; border-radius: 50%; }\n.ops-channel-icon { display: flex; align-items: center; justify-content: center; }\n.ops-channel-name  { font-weight: 600; color: var(--text-primary); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n.ops-channel-share { font-weight: 700; color: var(--text-primary); font-variant-numeric: tabular-nums; }\n.ops-channel-val   { font-size: 13px; font-weight: 800; color: var(--text-primary); font-variant-numeric: tabular-nums; white-space: nowrap; }\n.ops-channel-meta  { color: var(--text-muted); font-variant-numeric: tabular-nums; white-space: nowrap; }\n\n/* Direction is carried by the caret as well as the colour -- with only four\n   brand hues, up and down cannot be told apart by hue alone. */\n.ops-channel-trend { font-weight: 700; font-variant-numeric: tabular-nums; white-space: nowrap; text-align: right; }\n.ops-channel-trend.is-up   { color: var(--color-secondary-text); }\n.ops-channel-trend.is-down { color: var(--color-primary); }\n/* Not a movement, so not up/down orange or blue-green: this channel simply\n   had no previous period to be measured against. Blue is information's role. */\n.ops-channel-trend-new     { color: var(--color-secondary-text); font-weight: 600; }\n.ops-channel-trend-none    { color: var(--text-muted); }\n\n.ops-channel-note {\n  margin: 12px 0 0;\n  font-size: 10px;\n  line-height: 1.45;\n  color: var(--text-muted);\n}\n\n/* The row is a table on a wide screen and a stack on a narrow one -- eight\n   columns at 11px is unreadable below roughly 900px. */\n@media (max-width: 900px) {\n  .ops-channel-row {\n    grid-template-columns: 8px 18px 1fr auto;\n    row-gap: 2px;\n  }\n  .ops-channel-share { grid-column: 4; text-align: right; }\n  .ops-channel-val   { grid-column: 3 / 5; }\n  .ops-channel-meta  { grid-column: 3 / 5; }\n  .ops-channel-trend { grid-column: 3 / 5; text-align: left; }\n}\n\n/* Rate cards */\n.ops-rates-row {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n@media (max-width: 900px) { .ops-rates-row { grid-template-columns: repeat(2, 1fr); } }\n.ops-rate-card {\n  background: var(--surface-card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 16px 18px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 4px;\n  position: relative;\n  overflow: hidden;\n}\n.ops-rate-wave {\n  position: absolute;\n  left: 0; right: 0; bottom: 0;\n  width: 100%; height: 60px;\n  z-index: 0;\n}\n.ops-rate-icon {\n  width: 36px; height: 36px; border-radius: 10px;\n  display: flex; align-items: center; justify-content: center;\n  font-size: 16px; margin-bottom: 4px;\n  position: relative; z-index: 1;\n}\n.ops-rate-label { font-size: 11px; color: var(--text-muted); font-weight: 500; position: relative; z-index: 1; }\n.ops-rate-val   { font-size: 26px; font-weight: 900; line-height: 1.1; position: relative; z-index: 1; }\n.ops-rate-note  { font-size: 10px; color: var(--text-muted); margin-top: 2px; position: relative; z-index: 1; }\n\n/* Charts row */\n.ops-charts-row {\n  display: grid;\n  grid-template-columns: 1fr 200px 260px;\n  gap: 16px;\n  align-items: start;\n}\n@media (max-width: 1100px) { .ops-charts-row { grid-template-columns: 1fr 1fr; } }\n@media (max-width: 680px)  { .ops-charts-row { grid-template-columns: 1fr; } }\n.ops-chart-wide  { padding: 18px 20px; }\n.ops-donut-card  { padding: 18px 20px; }\n.ops-health-card { padding: 18px 20px; display: flex; flex-direction: column; gap: 0; }\n.ops-health-row {\n  display: flex; align-items: center; gap: 10px;\n  padding: 9px 0; border-bottom: 1px solid var(--border);\n}\n.ops-health-row:last-child { border-bottom: none; }\n.ops-health-icon {\n  width: 28px; height: 28px; border-radius: 7px;\n  display: flex; align-items: center; justify-content: center;\n  font-size: 13px; flex-shrink: 0;\n}\n.ops-health-body { flex: 1; min-width: 0; }\n.ops-health-label { font-size: 12px; font-weight: 600; color: var(--text-primary); }\n.ops-health-sub   { font-size: 10px; color: var(--text-muted); }\n.ops-health-val   { font-size: 18px; font-weight: 800; flex-shrink: 0; }\n\n/* Products row */\n.ops-products-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 20px;\n  align-items: stretch;\n}\n@media (max-width: 760px) { .ops-products-row { grid-template-columns: 1fr; } }\n.ops-top-prods-card { padding: 18px 20px; }\n.ops-products-row .ops-health-card,\n.ops-products-row .ops-low-stock-card { min-height: 310px; padding: 22px 24px; }\n.ops-products-row .ov-card-header { margin-bottom: 12px; }\n.ops-products-row .ov-card-title { font-size: 1.35rem; font-weight: 750; letter-spacing: -0.025em; }\n\n.ops-health-layout {\n  flex: 1;\n  display: grid;\n  grid-template-columns: minmax(180px, 0.8fr) minmax(230px, 1.2fr);\n  align-items: center;\n  gap: 18px;\n}\n.ops-health-donut { display: flex; align-items: center; justify-content: center; min-width: 0; }\n.ops-health-metrics { min-width: 0; }\n.ops-health-metric {\n  display: grid;\n  grid-template-columns: 12px minmax(0, 1fr) auto;\n  align-items: center;\n  column-gap: 10px;\n  min-height: 42px;\n  border-bottom: 1px solid var(--border);\n}\n.ops-health-metric:last-child { border-bottom: 0; }\n.ops-health-dot { width: 10px; height: 10px; border-radius: 50%; }\n.ops-health-metric-label { min-width: 0; color: var(--text-secondary); font-size: 0.9rem; white-space: nowrap; }\n.ops-health-now { margin-left: 6px; color: var(--text-muted); font-size: 0.78rem; font-weight: 600; }\n.ops-health-metric-value { color: var(--text-primary); font-size: 0.95rem; font-weight: 750; }\n\n.ops-low-stock-card { padding: 18px 20px; }\n.ops-low-threshold {\n  color: var(--color-primary);\n  background: color-mix(in srgb, var(--color-primary) 7%, transparent);\n  border: 1px solid color-mix(in srgb, var(--color-primary) 22%, var(--border));\n  border-radius: 8px;\n  padding: 6px 11px;\n  font-size: 0.82rem;\n  white-space: nowrap;\n}\n.ops-low-list { display: flex; flex-direction: column; gap: 8px; }\n\n.ops-top-table  { display: flex; flex-direction: column; margin-top: 8px; }\n.ops-top-thead  {\n  display: flex; align-items: center; gap: 6px;\n  padding: 6px 0 8px; border-bottom: 1px solid var(--border);\n  font-size: 11px; color: var(--text-muted); font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em;\n}\n.ops-top-rank-col { width: 24px; flex-shrink: 0; }\n.ops-top-row {\n  display: flex; align-items: center; gap: 6px;\n  padding: 6px 0;\n}\n.ops-top-rank  { width: 24px; font-size: 11px; font-weight: 700; color: var(--text-muted); flex-shrink: 0; }\n.ops-top-name  { flex: 1; font-size: 13px; color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.ops-top-units { width: 52px; text-align: right; font-size: 12px; color: var(--text-secondary); }\n.ops-top-rev   { width: 88px; text-align: right; font-size: 13px; font-weight: 700; color: var(--text-primary); }\n\n.ops-low-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 16px;\n  min-height: 64px;\n  padding: 10px 12px;\n  border: 1px solid var(--border);\n  border-radius: 9px;\n}\n.ops-low-info { min-width: 0; }\n.ops-low-name { margin: 0; font-size: 0.9rem; font-weight: 700; color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.ops-low-cat { margin: 4px 0 0; font-size: 0.78rem; color: var(--text-muted); }\n.ops-low-badge  {\n  min-width: 86px;\n  padding: 7px 10px;\n  border-left: 1px solid var(--border);\n  border-radius: 7px;\n  color: var(--color-primary);\n  background: color-mix(in srgb, var(--color-primary) 10%, transparent);\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-align: center;\n  white-space: nowrap;\n}\n.ops-low-badge.is-low { background: color-mix(in srgb, var(--color-primary) 8%, transparent); }\n\n@media (max-width: 1100px) {\n  .ops-health-layout { grid-template-columns: 160px minmax(200px, 1fr); gap: 10px; }\n  .ops-health-donut { transform: scale(0.86); margin: -12px; }\n}\n@media (max-width: 520px) {\n  .ops-products-row .ops-health-card,\n  .ops-products-row .ops-low-stock-card { min-height: 0; padding: 18px; }\n  .ops-health-layout { grid-template-columns: 1fr; }\n  .ops-health-donut { transform: none; margin: -8px 0; }\n  .ops-health-metric-label { white-space: normal; }\n}\n\n/* Row of 3 equal cards (top products / fraud alerts / delivery) */\n.ops-row-3 {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n  align-items: stretch;\n}\n@media (max-width: 1100px) { .ops-row-3 { grid-template-columns: 1fr 1fr; } }\n@media (max-width: 760px)  { .ops-row-3 { grid-template-columns: 1fr; } }\n.ops-fraud-card { padding: 18px 20px; }\n.ops-city-card  { padding: 18px 20px; }\n\n.ops-fraud-row {\n  display: flex; align-items: center; gap: 10px;\n  padding: 6px 0;\n}\n\n.ops-city-table { display: flex; flex-direction: column; margin-top: 4px; }\n.ops-city-thead {\n  display: flex; align-items: center; gap: 4px;\n  padding: 6px 0 8px; border-bottom: 1px solid var(--border);\n  font-size: 10px; color: var(--text-muted); font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em;\n}\n.ops-city-row {\n  display: flex; align-items: center; gap: 4px;\n  padding: 6px 0;\n}\n\n/* ── KPI summary row ─────────────────────────────────────────────── */\n.ops-kpi-row {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 14px;\n}\n@media (max-width: 1200px) { .ops-kpi-row { grid-template-columns: repeat(3, 1fr); } }\n@media (max-width: 640px)  { .ops-kpi-row { grid-template-columns: repeat(2, 1fr); } }\n.ops-kpi-card {\n  background: var(--surface-card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 16px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.ops-kpi-top { display: flex; align-items: center; gap: 8px; }\n.ops-kpi-icon {\n  width: 34px; height: 34px; border-radius: 9px;\n  display: flex; align-items: center; justify-content: center;\n  font-size: 15px; flex-shrink: 0;\n}\n.ops-kpi-label { font-size: 12px; color: var(--text-secondary); font-weight: 600; }\n.ops-kpi-value { font-size: 22px; font-weight: 800; color: var(--text-primary); margin: 2px 0 0; }\n.ops-kpi-note  { font-size: 11px; color: var(--text-muted); margin: 0; }\n.ops-kpi-arrow.up   { color: var(--color-secondary); font-weight: 700; }\n.ops-kpi-arrow.down { color: var(--color-primary); font-weight: 700; }\n\n/* ── Row of 4 (funnel / revenue / breakdown / health) ──────────────── */\n.ops-row-4 {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 16px;\n  align-items: stretch;\n}\n@media (max-width: 1300px) { .ops-row-4 { grid-template-columns: 1fr 1fr; } }\n@media (max-width: 680px)  { .ops-row-4 { grid-template-columns: 1fr; } }\n\n/* Compact conversion funnel (v2) */\n.ops-funnel-card-v2 { padding: 18px 20px; }\n.opsf2-list { display: flex; flex-direction: column; gap: 12px; margin-top: 4px; }\n.opsf2-step { display: flex; align-items: center; gap: 8px; }\n.opsf2-label-col { width: 78px; flex-shrink: 0; display: flex; flex-direction: column; }\n.opsf2-label     { font-size: 11px; font-weight: 600; color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.opsf2-pct-sub   { font-size: 10px; color: var(--text-muted); }\n.opsf2-track {\n  flex: 1; height: 10px; border-radius: 6px; overflow: hidden;\n  background: rgba(255,255,255,0.06);\n}\n:root[data-theme=\"light\"] .opsf2-track { background: var(--bg-tertiary); }\n.opsf2-bar   { height: 100%; border-radius: 6px; transition: width 0.6s ease; min-width: 3%; }\n.opsf2-right { width: 50px; flex-shrink: 0; text-align: right; display: flex; flex-direction: column; }\n.opsf2-count { font-size: 13px; font-weight: 800; line-height: 1.1; }\n.opsf2-pct   { font-size: 10px; color: var(--text-muted); }\n\n/* ══════════════════════════════════════════════════════════════════\n   Add Product page redesign\n   ══════════════════════════════════════════════════════════════════ */\n\n.admin-pf-header-v2 { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; }\n.admin-pf-header-actions { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }\n\n.admin-pf-btn-draft, .admin-pf-btn-publish {\n  display: inline-flex; align-items: center; gap: 6px;\n  padding: 9px 16px; border-radius: 10px; font-size: 0.85rem; font-weight: 700;\n  cursor: pointer; transition: all 150ms; white-space: nowrap;\n}\n.admin-pf-btn-draft {\n  background: var(--bg-secondary); color: var(--text-primary); border: 1px solid var(--border);\n}\n.admin-pf-btn-draft:hover { background: var(--border); }\n.admin-pf-btn-publish {\n  background: var(--accent); color: var(--color-text-on-secondary); border: 1px solid var(--accent);\n}\n.admin-pf-btn-publish:hover { filter: brightness(1.08); }\n\n/* Collapsible \"optional\" sections (Variants / Shipping / Features / Specs) --\n   the form is a single scrolling page (no wizard); these stay closed by\n   default so a simple product's form is short, and auto-open on edit when\n   the product already has data in them (see startEdit's advOpen seeding). */\n.admin-pf-section-collapsible { gap: 0; }\n.admin-pf-section-toggle {\n  display: flex; align-items: center; justify-content: space-between; gap: 10px;\n  width: 100%; background: none; border: none; padding: 0; margin: 0;\n  cursor: pointer; text-align: left; color: var(--text-secondary);\n}\n.admin-pf-section-collapsible .admin-pf-section-title { margin: 0; }\n.admin-pf-section-collapsible > .admin-pf-section-toggle ~ * { margin-top: 14px; }\n.admin-pf-optional-tag {\n  font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em;\n  color: var(--text-tertiary); background: var(--bg-tertiary);\n  border: 1px solid var(--border); border-radius: 20px; padding: 2px 8px; margin-left: 4px;\n}\n\n/* Icon-prefixed inputs (Category / SKU) -- same shell pattern as the price inputs */\n.admin-pf-icon-wrap {\n  display: flex; align-items: center;\n  border: 1px solid var(--border); border-radius: 8px; overflow: hidden;\n  background: var(--bg-primary); transition: border-color 0.15s;\n}\n.admin-pf-icon-wrap:focus-within { border-color: var(--accent); }\n.admin-pf-icon-prefix {\n  padding: 0 10px; height: 100%; display: flex; align-items: center;\n  font-size: 0.85rem; color: var(--text-secondary);\n  background: var(--bg-tertiary); border-right: 1px solid var(--border);\n  flex-shrink: 0;\n}\n.admin-pf-icon-input { border: none !important; border-radius: 0 !important; background: transparent !important; flex: 1; }\n\n/* Tag chips */\n.admin-pf-tag-wrap {\n  display: flex; align-items: flex-start;\n  border: 1px solid var(--border); border-radius: 8px; overflow: hidden;\n  background: var(--bg-primary); transition: border-color 0.15s;\n}\n.admin-pf-tag-wrap:focus-within { border-color: var(--accent); }\n.admin-pf-tag-wrap .admin-pf-icon-prefix { align-self: stretch; height: auto; }\n.admin-pf-tag-chips {\n  flex: 1; display: flex; flex-wrap: wrap; align-items: center; gap: 6px;\n  padding: 8px 10px; min-height: 40px; box-sizing: border-box;\n}\n.admin-pf-tag-chip {\n  display: inline-flex; align-items: center; gap: 5px;\n  background: color-mix(in srgb, var(--accent) 15%, transparent);\n  color: var(--accent); font-size: 0.78rem; font-weight: 600;\n  padding: 4px 6px 4px 10px; border-radius: 20px; white-space: nowrap;\n}\n.admin-pf-tag-chip button {\n  background: none; border: none; color: inherit; cursor: pointer;\n  font-size: 0.7rem; padding: 2px; display: flex; align-items: center; opacity: 0.7;\n}\n.admin-pf-tag-chip button:hover { opacity: 1; }\n.admin-pf-tag-input {\n  flex: 1; min-width: 90px; border: none; outline: none; background: transparent;\n  color: var(--text-primary); font-size: 0.9rem; font-family: inherit; padding: 4px 0;\n}\n.admin-pf-hint { font-size: 0.72rem; color: var(--text-tertiary); margin: 4px 0 0; }\n\n/* Per-size stock rows (Add Product / seller product form) */\n.admin-pf-size-rows { display: flex; flex-direction: column; gap: 6px; margin-bottom: 8px; }\n.admin-pf-size-row {\n  display: flex; align-items: center; gap: 10px;\n  border: 1px solid var(--border); border-radius: 8px; padding: 6px 10px;\n  background: var(--bg-primary);\n}\n.admin-pf-size-label { font-size: 0.85rem; font-weight: 700; color: var(--text-primary); width: 44px; flex-shrink: 0; }\n.admin-pf-size-stock-input { flex: 1; padding: 6px 10px !important; font-size: 0.85rem !important; }\n.admin-pf-size-remove {\n  background: none; border: none; color: var(--text-tertiary); cursor: pointer;\n  font-size: 0.85rem; padding: 4px; flex-shrink: 0;\n}\n.admin-pf-size-remove:hover { color: var(--color-primary); }\n\n/* Colour tags (Add Product / seller product form) -- reuses .admin-pf-tag-chip\n   styling, just rendered as a standalone row above its input like sizes. */\n.admin-pf-color-tags { padding: 0; min-height: 0; margin-bottom: 8px; }\n\n/* Variant (colour x size) table */\n.admin-pf-variants-empty {\n  border: 1px dashed var(--border); border-radius: 8px;\n  padding: 20px; text-align: center;\n  color: var(--text-tertiary); font-size: 0.85rem;\n}\n/* overflow-x: auto -- the row below has a wide intrinsic min-width (7\n   columns of inputs/selects that won't shrink past their own content), and\n   without this the table refused to shrink to fit .spf-main and instead\n   overflowed horizontally into the Product Preview sidebar next to it. Now\n   it scrolls within its own card instead. */\n.admin-pf-variants-table { display: flex; flex-direction: column; gap: 6px; overflow-x: auto; }\n.admin-pf-variants-head {\n  display: grid; grid-template-columns: 90px 70px 1.3fr 90px 1.1fr 90px 100px;\n  gap: 8px; padding: 0 10px;\n  font-size: 0.7rem; font-weight: 700; color: var(--text-tertiary);\n  text-transform: uppercase; letter-spacing: 0.04em;\n  min-width: 640px;\n}\n.admin-pf-variants-row {\n  display: grid; grid-template-columns: 90px 70px 1.3fr 90px 1.1fr 90px 100px;\n  gap: 8px; align-items: center;\n  border: 1px solid var(--border); border-radius: 8px; padding: 8px 10px;\n  background: var(--bg-primary);\n  min-width: 640px;\n}\n.admin-pf-variants-cell-label { font-size: 0.85rem; font-weight: 700; color: var(--text-primary); }\n.admin-pf-variants-color-cell { display: flex; align-items: center; gap: 8px; }\n.admin-pf-color-swatch { width: 14px; height: 14px; border-radius: 50%; border: 1px solid var(--border); flex-shrink: 0; }\n.admin-pf-variants-count { margin: 4px 0 0; padding: 0 10px; font-size: 0.78rem; color: var(--text-tertiary); }\n.admin-pf-variant-img-slot {\n  display: flex; align-items: center; gap: 6px;\n  position: relative;\n}\n.admin-pf-variant-img, .admin-pf-variant-img-empty {\n  width: 30px; height: 30px; border-radius: 6px; object-fit: cover;\n  background: var(--bg-tertiary); border: 1px solid var(--border);\n  display: flex; align-items: center; justify-content: center;\n  color: var(--text-tertiary); flex-shrink: 0;\n}\n.admin-pf-variant-img-btn {\n  font-size: 0.72rem; font-weight: 600; color: var(--accent);\n  cursor: pointer; white-space: nowrap;\n}\n.admin-pf-variant-img-btn:hover { text-decoration: underline; }\n@media (max-width: 900px) {\n  .admin-pf-variants-head { display: none; }\n  .admin-pf-variants-row { grid-template-columns: 1fr 1fr; row-gap: 6px; }\n  .admin-pf-variants-row .admin-pf-variants-cell-label::before { content: ''; }\n}\n\n/* Stock status pill (auto-computed, not manually editable) */\n.admin-pf-stock-status {\n  display: inline-flex; align-items: center; gap: 8px;\n  border: 1px solid var(--border); border-radius: 8px;\n  padding: 0 12px; height: 40px; box-sizing: border-box;\n  font-size: 0.88rem; font-weight: 700; color: var(--text-primary);\n  background: var(--bg-primary); width: 100%;\n}\n.admin-pf-stock-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }\n\n/* Unified media grid: compact upload tile + preview slots share one row */\n.admin-image-grid-v2 { align-items: stretch; }\n.admin-dropzone-compact {\n  width: 96px; height: 100px; flex-shrink: 0;\n  display: flex; flex-direction: column; align-items: center; justify-content: center;\n  padding: 8px; border-radius: 10px;\n  box-sizing: border-box;\n}\n.admin-dropzone-compact .admin-dropzone-icon { font-size: 1.3rem; margin-bottom: 4px; }\n.admin-dropzone-text-compact { font-size: 0.72rem; font-weight: 700; color: var(--accent); margin: 0; text-align: center; }\n\n/* Sidebar: preview + publishing + tips, scrolls together as a sticky group */\n.admin-pf-sidebar { display: flex; flex-direction: column; gap: 16px; position: sticky; top: 16px; }\n.admin-pf-sidebar .admin-preview-card { position: static; }\n\n.admin-preview-wishlist {\n  position: absolute; top: 10px; right: 10px; z-index: 2;\n  width: 30px; height: 30px; border-radius: 50%;\n  background: var(--bg-primary); border: 1px solid var(--border);\n  display: flex; align-items: center; justify-content: center;\n  font-size: 0.95rem; color: var(--text-secondary);\n}\n\n.admin-preview-cart-btn {\n  margin-top: 10px; width: 100%; padding: 11px; border: none; border-radius: 10px;\n  background: var(--accent); color: var(--color-text-on-secondary); font-size: 0.88rem; font-weight: 700;\n  cursor: default; display: flex; align-items: center; justify-content: center; gap: 6px;\n}\n\n.admin-pf-publish-card, .admin-pf-tips-card {\n  background: var(--bg-primary); border: 1px solid var(--border);\n  border-radius: 14px; padding: 16px;\n}\n.admin-pf-publish-row {\n  display: flex; align-items: center; justify-content: space-between;\n  padding: 10px 0; border-bottom: 1px solid var(--border);\n  font-size: 0.85rem; color: var(--text-secondary);\n}\n.admin-pf-publish-row:last-child { border-bottom: none; }\n.admin-pf-publish-select {\n  border: 1px solid var(--border); border-radius: 8px; background: var(--bg-secondary);\n  color: var(--text-primary); font-size: 0.82rem; font-weight: 600; padding: 6px 10px; cursor: pointer;\n}\n\n.admin-pf-tips-card p { font-size: 0.82rem; color: var(--text-secondary); margin: 8px 0 0; line-height: 1.5; }\n\n/* Toggle switch */\n.admin-pf-toggle { position: relative; display: inline-block; width: 40px; height: 22px; flex-shrink: 0; }\n.admin-pf-toggle input { position: absolute; opacity: 0; width: 0; height: 0; }\n.admin-pf-toggle-track {\n  position: absolute; inset: 0; background: var(--border); border-radius: 22px; transition: background 0.15s;\n}\n.admin-pf-toggle-knob {\n  position: absolute; top: 2px; left: 2px; width: 18px; height: 18px; border-radius: 50%;\n  background: var(--color-brand-white); transition: transform 0.15s; box-shadow: 0 1px 3px rgba(1, 13, 33,0.3);\n}\n.admin-pf-toggle input:checked + .admin-pf-toggle-track { background: var(--accent); }\n.admin-pf-toggle input:checked + .admin-pf-toggle-track .admin-pf-toggle-knob { transform: translateX(18px); }\n\n/* ══════════════════════════════════════════════════════════════════\n   Add Product page redesign v3 — exact visual spec (blue-bordered\n   fields, icon-prefixed inputs, card-row optional sections). Scoped\n   under .admin-pf-card-v2 (the Add Product page's own wrapper) rather\n   than editing the base .admin-pf-* rules above, since those same\n   class names are shared with the Banners and Careers admin forms,\n   which this redesign intentionally does not touch.\n   ══════════════════════════════════════════════════════════════════ */\n.admin-pf-card-v2 {\n  --pf-primary: var(--color-secondary);\n  --pf-primary-dark: var(--color-secondary-hover);\n  --pf-primary-soft: var(--color-secondary-soft);\n  --pf-focus-ring: rgba(59, 130, 246, 0.16);\n  --pf-field-bg: var(--bg-tertiary);\n  --pf-heading: var(--text-primary);\n  --pf-label: var(--text-secondary);\n  --pf-text: var(--text-secondary);\n  --pf-muted: var(--text-muted);\n  --pf-divider: var(--border);\n  --pf-danger: var(--color-primary);\n  --pf-success: var(--color-secondary);\n  --pf-info: var(--color-secondary);\n  --pf-info-soft: var(--color-secondary-soft);\n  --pf-positive: var(--color-secondary);\n  --pf-positive-soft: var(--color-secondary-soft);\n  --pf-card-radius: 16px;\n  --pf-field-radius: 10px;\n  --pf-field-height: 56px;\n  --pf-card-shadow: 0 3px 10px rgba(16,24,40,0.07), 0 1px 2px rgba(16,24,40,0.04);\n}\n/* Dark-theme equivalents -- the supplied spec is light-only; these keep the\n   same structure/contrast intent (bright accent on dark neutrals) rather\n   than shipping a broken dark admin panel. */\n:root[data-theme=\"dark\"] .admin-pf-card-v2 {\n  --pf-primary: var(--color-secondary);\n  --pf-primary-dark: var(--color-secondary);\n  --pf-primary-soft: rgba(91,147,255,0.16);\n  --pf-focus-ring: rgba(91,147,255,0.28);\n  --pf-field-bg: var(--color-brand-navy);\n  --pf-heading: var(--bg-tertiary);\n  --pf-label: var(--border);\n  --pf-text: var(--border-strong);\n  --pf-muted: var(--text-muted);\n  --pf-divider: var(--text-secondary);\n  --pf-danger: var(--color-primary);\n  --pf-success: var(--color-secondary);\n  --pf-info: var(--color-secondary);\n  --pf-info-soft: rgba(59, 130, 246,0.16);\n  --pf-positive: var(--color-secondary);\n  --pf-positive-soft: rgba(59, 130, 246, 0.16);\n  --pf-card-shadow: 0 2px 10px rgba(1, 13, 33,0.35);\n}\n\n.admin-pf-card-v2 .admin-form-header h2 {\n  margin: 0; color: var(--pf-heading); font-size: 28px; font-weight: 750; line-height: 1.2;\n}\n\n/* Section cards */\n.admin-pf-card-v2 .admin-pf-section {\n  border-color: var(--pf-divider);\n  border-radius: var(--pf-card-radius);\n  padding: 24px;\n  gap: 18px;\n  margin-bottom: 20px;\n  box-shadow: var(--pf-card-shadow);\n}\n.admin-pf-card-v2 .admin-pf-section-title {\n  gap: 14px; font-size: 21px; font-weight: 750; color: var(--pf-heading); margin: 0; line-height: 1.3;\n}\n.admin-pf-card-v2 .admin-pf-section-icon { width: 46px; height: 46px; border-radius: 11px; }\n.admin-pf-card-v2 .admin-pf-section-icon svg { width: 21px; height: 21px; }\n.admin-pf-card-v2 .admin-pf-section-sub { font-size: 14px; color: var(--pf-muted); margin: 0; line-height: 1.5; }\n\n/* Fields & labels */\n.admin-pf-card-v2 .admin-pf-field { gap: 7px; min-width: 0; }\n.admin-pf-card-v2 .admin-pf-label { font-size: 15px; font-weight: 650; color: var(--pf-label); line-height: 1.3; }\n.admin-pf-card-v2 .admin-pf-req { color: var(--pf-danger); margin-left: 2px; }\n.admin-pf-card-v2 .admin-pf-char-count { color: var(--pf-muted); }\n.admin-pf-card-v2 .admin-pf-hint { color: var(--pf-muted); font-size: 13px; }\n\n/* Bare text/select/textarea controls */\n.admin-pf-card-v2 .admin-pf-input,\n.admin-pf-card-v2 .admin-pf-textarea {\n  border: 1.5px solid var(--pf-primary);\n  border-radius: var(--pf-field-radius);\n  background: var(--pf-field-bg);\n  color: var(--pf-heading);\n  font-size: 16px;\n  min-height: calc(var(--pf-field-height) - 3px);\n  padding: 0 18px;\n  transition: border-color 160ms ease, box-shadow 160ms ease, background-color 160ms ease;\n}\n.admin-pf-card-v2 .admin-pf-input:hover,\n.admin-pf-card-v2 .admin-pf-textarea:hover { border-color: var(--pf-primary-dark); }\n.admin-pf-card-v2 .admin-pf-input:focus,\n.admin-pf-card-v2 .admin-pf-textarea:focus {\n  background: var(--bg-secondary);\n  border-color: var(--pf-primary);\n  box-shadow: 0 0 0 5px var(--pf-focus-ring);\n}\n.admin-pf-card-v2 .admin-pf-textarea { min-height: 98px; padding: 10px 14px; line-height: 1.5; }\n\n/* Compact Add Product density. This is deliberately scoped to the product\n   editor because Careers and other admin forms reuse the admin-pf classes. */\n.admin-product-editor-compact {\n  --pf-field-height: 46px;\n  padding: 14px 16px 16px;\n}\n.admin-product-editor-compact .admin-pf-header-v2 {\n  gap: 8px;\n  margin-bottom: 12px;\n}\n.admin-product-editor-compact .admin-form-header h2 { font-size: 24px; }\n.admin-product-editor-compact .admin-pf-header-actions { gap: 8px; }\n.admin-product-editor-compact .admin-pf-btn-draft,\n.admin-product-editor-compact .admin-pf-btn-publish {\n  padding: 7px 13px;\n  border-radius: 8px;\n}\n.admin-product-editor-compact .admin-product-form-layout {\n  grid-template-columns: minmax(0, 1fr) 250px;\n  gap: 14px;\n}\n.admin-product-editor-compact .admin-pf-section {\n  padding: 16px 18px;\n  gap: 12px;\n  margin-bottom: 12px;\n  border-radius: 13px;\n}\n.admin-product-editor-compact .admin-pf-section-title {\n  gap: 10px;\n  font-size: 18px;\n}\n.admin-product-editor-compact .admin-pf-section-icon {\n  width: 38px;\n  height: 38px;\n  border-radius: 9px;\n}\n.admin-product-editor-compact .admin-pf-section-icon svg { width: 18px; height: 18px; }\n.admin-product-editor-compact .admin-pf-field { gap: 5px; }\n.admin-product-editor-compact .admin-pf-label { font-size: 13px; }\n.admin-product-editor-compact .admin-pf-input,\n.admin-product-editor-compact .admin-pf-icon-input,\n.admin-product-editor-compact .admin-pf-tag-input,\n.admin-product-editor-compact .admin-pf-price-input { font-size: 14px; }\n.admin-product-editor-compact .admin-pf-icon-prefix { width: 46px; flex-basis: 46px; }\n.admin-product-editor-compact .admin-pf-row-2,\n.admin-product-editor-compact .admin-pf-row-3 { gap: 10px; }\n.admin-product-editor-compact .admin-pf-icon-wrap--textarea,\n.admin-product-editor-compact .admin-pf-icon-wrap--textarea .admin-pf-textarea { min-height: 82px; }\n.admin-product-editor-compact .admin-pf-textarea { min-height: 82px; padding: 9px 12px; }\n.admin-product-editor-compact .admin-preview-card,\n.admin-product-editor-compact .admin-pf-publish-card,\n.admin-product-editor-compact .admin-pf-tips-card { padding: 12px; }\n.admin-product-editor-compact .admin-pf-sidebar { gap: 12px; }\n.admin-product-editor-compact .admin-preview-img-wrap { height: 145px; }\n.admin-product-editor-compact .admin-pf-section-collapsible { min-height: 56px; padding: 8px 18px; }\n.admin-product-editor-compact .admin-pf-section-collapsible.admin-pf-section-open { padding: 16px 18px; }\n\n@media (max-width: 900px) {\n  .admin-product-editor-compact .admin-product-form-layout { grid-template-columns: 1fr; }\n}\n\n/* Icon-prefixed shells (Title / Description / Category / SKU / Tags / Sizes / Colours) */\n.admin-pf-card-v2 .admin-pf-icon-wrap,\n.admin-pf-card-v2 .admin-pf-tag-wrap {\n  border: 1.5px solid var(--pf-primary);\n  border-radius: var(--pf-field-radius);\n  background: var(--pf-field-bg);\n  min-height: var(--pf-field-height);\n  transition: border-color 160ms ease, box-shadow 160ms ease, background-color 160ms ease;\n}\n.admin-pf-card-v2 .admin-pf-icon-wrap:hover,\n.admin-pf-card-v2 .admin-pf-tag-wrap:hover { border-color: var(--pf-primary-dark); }\n.admin-pf-card-v2 .admin-pf-icon-wrap:focus-within,\n.admin-pf-card-v2 .admin-pf-tag-wrap:focus-within {\n  background: var(--bg-secondary);\n  border-color: var(--pf-primary);\n  box-shadow: 0 0 0 5px var(--pf-focus-ring);\n}\n.admin-pf-card-v2 .admin-pf-icon-prefix {\n  width: 58px; flex: 0 0 58px; justify-content: center;\n  color: var(--pf-muted);\n  background: transparent;\n  border-right: 1px solid var(--pf-primary);\n}\n.admin-pf-card-v2 .admin-pf-icon-input,\n.admin-pf-card-v2 .admin-pf-tag-input,\n.admin-pf-card-v2 .admin-pf-tag-chips { font-size: 16px; color: var(--pf-heading); }\n.admin-pf-card-v2 .admin-pf-icon-input { padding: 0 18px; }\n.admin-pf-card-v2 .admin-pf-tag-chips { min-height: calc(var(--pf-field-height) - 3px); padding: 6px 14px; }\n\n/* Icon-wrapped textarea variant (Short Description) */\n.admin-pf-card-v2 .admin-pf-icon-wrap--textarea { align-items: stretch; min-height: 100px; }\n.admin-pf-card-v2 .admin-pf-icon-wrap--textarea .admin-pf-icon-prefix { align-items: flex-start; padding-top: 10px; height: auto; }\n.admin-pf-card-v2 .admin-pf-icon-wrap--textarea .admin-pf-textarea { border: none; border-radius: 0; background: transparent; min-height: 98px; }\n\n/* Pricing addons (currency / percent) */\n.admin-pf-card-v2 .admin-pf-price-wrap {\n  border: 1.5px solid var(--pf-primary);\n  border-radius: var(--pf-field-radius);\n  background: var(--pf-field-bg);\n  min-height: var(--pf-field-height);\n  transition: border-color 160ms ease, box-shadow 160ms ease, background-color 160ms ease;\n}\n.admin-pf-card-v2 .admin-pf-price-wrap:hover { border-color: var(--pf-primary-dark); }\n.admin-pf-card-v2 .admin-pf-price-wrap:focus-within {\n  background: var(--bg-secondary); border-color: var(--pf-primary); box-shadow: 0 0 0 5px var(--pf-focus-ring);\n}\n.admin-pf-card-v2 .admin-pf-price-sym {\n  width: 54px; flex: 0 0 54px; justify-content: center;\n  color: var(--pf-text); font-size: 18px; font-weight: 600;\n  background: transparent; border-right: 1px solid var(--pf-primary); line-height: normal;\n}\n.admin-pf-card-v2 .admin-pf-price-input { font-size: 16px; color: var(--pf-heading); padding: 0 18px; }\n\n/* Quantity stepper */\n.admin-pf-card-v2 .admin-pf-qty-ctrl {\n  box-sizing: border-box;\n  display: grid; grid-template-columns: 58px minmax(80px, 1fr) 58px;\n  align-self: stretch; width: 100%;\n  border: 1.5px solid var(--pf-primary); border-radius: var(--pf-field-radius);\n  background: var(--pf-field-bg); min-height: var(--pf-field-height);\n}\n.admin-pf-card-v2 .admin-pf-qty-ctrl:focus-within { background: var(--bg-secondary); box-shadow: 0 0 0 5px var(--pf-focus-ring); }\n.admin-pf-card-v2 .admin-pf-qty-btn {\n  width: auto; height: auto; background: var(--bg-tertiary); color: var(--pf-heading);\n  font-size: 21px; font-weight: 700;\n}\n.admin-pf-card-v2 .admin-pf-qty-btn:first-child { border-right: 1px solid var(--pf-primary); }\n.admin-pf-card-v2 .admin-pf-qty-btn:last-child { border-left: 1px solid var(--pf-primary); }\n.admin-pf-card-v2 .admin-pf-qty-btn:hover { color: var(--pf-primary); background: var(--pf-primary-soft); }\n.admin-pf-card-v2 .admin-pf-qty-input { width: 100%; padding: 0 16px; color: var(--pf-heading); font-size: 16px; font-weight: 600; text-align: center; }\n\n/* Stock status pill */\n.admin-pf-card-v2 .admin-pf-stock-status {\n  border: 1.5px solid var(--pf-primary); border-radius: var(--pf-field-radius);\n  background: var(--pf-field-bg); min-height: var(--pf-field-height); height: auto; padding: 0 18px;\n  color: var(--pf-heading); font-size: 16px; font-weight: 700; width: 100%;\n}\n.admin-pf-card-v2 .admin-pf-stock-dot { width: 11px; height: 11px; background: var(--pf-success); box-shadow: 0 0 0 4px rgba(34,199,106,0.14); }\n\n/* Product Media dropzone -- full-width dashed blue drop area; uploaded\n   thumbnails render below it (see JSX), not beside it. */\n.admin-pf-card-v2 .admin-dropzone {\n  border: 2px dashed var(--pf-primary);\n  border-radius: 12px;\n  background: var(--pf-field-bg);\n  transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;\n}\n.admin-pf-card-v2 .admin-dropzone:hover,\n.admin-pf-card-v2 .admin-dropzone-over {\n  background: var(--pf-primary-soft); border-color: var(--pf-primary-dark); box-shadow: 0 0 0 5px var(--pf-focus-ring);\n}\n.admin-pf-card-v2 .admin-dropzone:active { transform: scale(0.998); }\n.admin-pf-card-v2 .admin-dropzone-full {\n  box-sizing: border-box;\n  width: 100%; min-height: 128px; padding: 20px;\n  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px;\n}\n.admin-pf-card-v2 .admin-dropzone-full .admin-dropzone-icon { color: var(--pf-heading); font-size: 1.9rem; margin: 0; }\n.admin-pf-card-v2 .admin-dropzone-full .admin-dropzone-text-compact { color: var(--pf-primary); font-size: 16px; font-weight: 750; }\n.admin-pf-card-v2 .admin-dropzone-full .admin-dropzone-hint { color: var(--pf-muted); font-size: 13px; margin: 2px 0 0; }\n.admin-pf-card-v2 .admin-image-grid { margin-top: 2px; }\n\n/* Collapsed \"optional\" sections -- flat card-row look while collapsed,\n   expands back to normal card padding when open (see advOpen state). */\n.admin-pf-card-v2 .admin-pf-section-collapsible {\n  padding: 12px 22px; min-height: 68px; justify-content: center;\n  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;\n}\n.admin-pf-card-v2 .admin-pf-section-collapsible:hover {\n  border-color: var(--pf-primary);\n  box-shadow: 0 0 0 4px rgba(59, 130, 246,0.09), var(--pf-card-shadow);\n  transform: translateY(-1px);\n}\n.admin-pf-card-v2 .admin-pf-section-collapsible.admin-pf-section-open { padding: 24px; min-height: 0; }\n.admin-pf-card-v2 .admin-pf-section-collapsible.admin-pf-section-open:hover {\n  transform: none; box-shadow: var(--pf-card-shadow); border-color: var(--pf-divider);\n}\n.admin-pf-card-v2 .admin-pf-section-collapsible .admin-pf-section-icon { width: 42px; height: 42px; border-radius: 10px; }\n.admin-pf-card-v2 .admin-pf-section-collapsible .admin-pf-section-title { font-size: 17px; }\n.admin-pf-card-v2 .admin-pf-section-toggle { color: inherit; }\n.admin-pf-card-v2 .admin-pf-section-arrow { flex-shrink: 0; color: var(--pf-muted); display: flex; }\n.admin-pf-card-v2 .admin-pf-optional-tag {\n  color: var(--pf-muted); background: var(--bg-tertiary); border-color: var(--pf-divider);\n  font-size: 11px; padding: 2px 10px; min-height: 24px; display: inline-flex; align-items: center;\n}\n\n/* Solid-blue Save/Publish button, exact spec colour (base .admin-pf-btn-publish\n   uses the site's generic --accent instead). Used on Commission & Tax too. */\n.admin-pf-card-v2 .admin-pf-btn-publish { background: var(--pf-primary); border-color: var(--pf-primary); }\n.admin-pf-card-v2 .admin-pf-btn-publish:disabled,\n.admin-pf-card-v2 .admin-pf-btn-draft:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* Highlighted \"current value\" panel -- Commission & Tax's rate/currency cards */\n.admin-pf-card-v2 .admin-pf-rate-panel {\n  display: flex; align-items: center; justify-content: space-between; gap: 12px;\n  background: var(--pf-primary-soft); border-radius: var(--pf-field-radius);\n  padding: 16px 18px;\n}\n.admin-pf-card-v2 .admin-pf-rate-panel-label { font-size: 14px; color: var(--pf-text); }\n.admin-pf-card-v2 .admin-pf-rate-panel-value { font-size: 24px; font-weight: 800; color: var(--pf-primary); }\n.admin-pf-card-v2 .admin-pf-rate-panel-sub { font-size: 12px; color: var(--pf-muted); margin-top: 8px; text-align: right; }\n\n/* Bordered input + Save button side by side */\n.admin-pf-card-v2 .admin-pf-input-row { display: flex; gap: 10px; align-items: stretch; }\n.admin-pf-card-v2 .admin-pf-input-row .admin-pf-price-wrap,\n.admin-pf-card-v2 .admin-pf-input-row .admin-pf-icon-wrap { flex: 1; }\n.admin-pf-card-v2 .admin-pf-input-row .admin-pf-btn-publish,\n.admin-pf-card-v2 .admin-pf-input-row .admin-pf-btn-draft { flex-shrink: 0; padding-left: 22px; padding-right: 22px; }\n\n/* Two cards side by side (Marketplace Commission / Sales Tax) */\n.admin-ct-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; align-items: start; margin-bottom: 20px; }\n@media (max-width: 900px) { .admin-ct-grid { grid-template-columns: 1fr; } }\n.admin-ct-grid .admin-pf-section { margin-bottom: 0; }\n\n/* Careers page -- plain (non-icon) card titles + a small count badge, since\n   the supplied reference doesn't use the icon-box header pattern here. */\n.admin-pf-card-v2 .admin-pf-section-title--plain { font-size: 19px; margin: 0; }\n.admin-pf-card-v2 .admin-pf-count-badge {\n  display: inline-flex; align-items: center; justify-content: center;\n  min-width: 22px; height: 22px; padding: 0 7px; border-radius: 999px;\n  background: var(--pf-primary-soft); color: var(--pf-primary); font-size: 12px; font-weight: 800;\n}\n\n/* Careers stat tiles -- rounded-square icon badges + bigger bold values,\n   consistent with the Overview page's own KPI tiles. */\n.admin-pf-card-v2 .admin-careers-stat-tile { border-color: var(--pf-divider); border-radius: var(--pf-field-radius); padding: 18px; box-sizing: border-box; }\n.admin-pf-card-v2 .admin-careers-stat-icon { width: 44px; height: 44px; border-radius: 12px; }\n.admin-pf-card-v2 .admin-careers-stat-value { font-size: 30px; color: var(--pf-heading); }\n.admin-pf-card-v2 .admin-careers-stat-label { color: var(--pf-text); font-size: 13px; }\n.admin-pf-card-v2 .admin-careers-stat-trend { font-size: 12px; }\n\n/* Open Positions table + General Applications row, restyled to sit inside\n   a .admin-pf-section card instead of standing alone. */\n.admin-pf-card-v2 .admin-products-table { border-color: var(--pf-divider); box-shadow: none; margin-bottom: 0; }\n.admin-pf-card-v2 .admin-table-header { background: var(--pf-field-bg); color: var(--pf-muted); }\n.admin-pf-card-v2 .admin-product-row:hover { background: var(--pf-primary-soft); }\n.admin-pf-card-v2 .admin-pf-list-row {\n  box-sizing: border-box;\n  display: flex; align-items: center; justify-content: space-between; gap: 10px;\n  width: 100%; text-align: left; cursor: pointer;\n  border: 1px solid var(--pf-divider); border-radius: var(--pf-field-radius);\n  padding: 14px 16px; background: var(--pf-field-bg);\n  transition: border-color 160ms ease, box-shadow 160ms ease;\n}\n.admin-pf-card-v2 .admin-pf-list-row:hover { border-color: var(--pf-primary); box-shadow: 0 0 0 3px var(--pf-focus-ring); }\n\n/* Rich text editor (Job Description) -- same blue-bordered field shell as\n   every other input on this page. */\n.admin-pf-card-v2 .admin-rte {\n  border: 1.5px solid var(--pf-primary); border-radius: var(--pf-field-radius);\n  background: var(--pf-field-bg);\n  transition: border-color 160ms ease, box-shadow 160ms ease, background-color 160ms ease;\n}\n.admin-pf-card-v2 .admin-rte:hover { border-color: var(--pf-primary-dark); }\n.admin-pf-card-v2 .admin-rte:focus-within {\n  background: var(--bg-secondary); border-color: var(--pf-primary); box-shadow: 0 0 0 5px var(--pf-focus-ring);\n}\n.admin-pf-card-v2 .admin-rte-toolbar { background: transparent; border-bottom-color: var(--pf-divider); padding: 8px 10px; }\n.admin-pf-card-v2 .admin-rte-toolbar button { color: var(--pf-muted); }\n.admin-pf-card-v2 .admin-rte-toolbar button:hover { background: var(--pf-primary-soft); color: var(--pf-primary); }\n.admin-pf-card-v2 .admin-rte-body { font-size: 16px; color: var(--pf-heading); padding: 14px 18px; min-height: 110px; }\n.admin-pf-card-v2 .admin-rte-body:empty::before { color: var(--pf-muted); }\n\n@media (max-width: 900px) {\n  .admin-pf-card-v2 .admin-careers-stats { grid-template-columns: repeat(2, 1fr); }\n}\n\n@media (max-width: 640px) {\n  .admin-pf-card-v2 .admin-pf-input-row { flex-direction: column; }\n  .admin-pf-card-v2 .admin-form-header h2 { font-size: 23px; }\n  .admin-pf-card-v2 .admin-pf-section { padding: 17px 14px; border-radius: 13px; }\n  .admin-pf-card-v2 .admin-pf-section-title { font-size: 18px; gap: 11px; }\n  .admin-pf-card-v2 .admin-pf-section-icon { width: 40px; height: 40px; }\n  .admin-pf-card-v2 .admin-pf-icon-prefix,\n  .admin-pf-card-v2 .admin-pf-price-sym { width: 48px; flex-basis: 48px; }\n  .admin-pf-card-v2 .admin-pf-section-collapsible { padding: 10px 14px; min-height: 64px; }\n  .admin-pf-card-v2 .admin-pf-section-collapsible.admin-pf-section-open { padding: 17px 14px; }\n  .admin-pf-card-v2 .admin-pf-section-collapsible .admin-pf-section-title { font-size: 15px; }\n}\n\n/* ══════════════════════════════════════════════════════════════════\n   Order Tracking page\n   ══════════════════════════════════════════════════════════════════ */\n.ot-page {\n  --ot-gold: var(--color-primary);\n  min-height: 100vh; background: var(--bg-secondary); padding-bottom: 48px;\n}\n\n.ot-header-title h1, .ot-card-title, .ot-help-title, .ot-notfound h2 {\n  font-family: Georgia, 'Times New Roman', Times, serif;\n}\n\n.ot-header {\n  display: flex; align-items: center; gap: 16px; flex-wrap: wrap;\n  padding: 20px 28px; background: var(--bg-primary); border-bottom: 1px solid var(--border);\n}\n.ot-back-btn {\n  width: 44px; height: 44px; border-radius: 12px; flex-shrink: 0;\n  border: 1px solid color-mix(in srgb, var(--ot-gold) 45%, var(--border));\n  background: var(--bg-primary);\n  display: flex; align-items: center; justify-content: center;\n  cursor: pointer; color: var(--text-primary); transition: background 150ms;\n}\n.ot-back-btn:hover { background: var(--bg-secondary); }\n.ot-header-title { flex: 1; min-width: 200px; }\n.ot-header-title h1 { margin: 0; font-size: 1.7rem; font-weight: 700; color: var(--text-primary); letter-spacing: -0.01em; }\n.ot-header-meta { display: flex; align-items: center; gap: 10px; margin-top: 8px; flex-wrap: wrap; }\n.ot-id { font-size: 0.85rem; color: var(--text-secondary); font-family: monospace; }\n\n.ot-placed-pill {\n  display: inline-flex; align-items: center; gap: 6px;\n  font-size: 0.75rem; font-weight: 600; color: var(--text-secondary);\n  background: var(--bg-secondary); border: 1px solid var(--border);\n  padding: 4px 12px; border-radius: 20px;\n}\n\n.ot-schedule-pill {\n  display: inline-flex; align-items: center; gap: 6px;\n  font-size: 0.75rem; font-weight: 700; padding: 4px 12px; border-radius: 20px;\n  background: color-mix(in srgb, var(--success) 12%, transparent); color: var(--success);\n}\n.ot-schedule-pill::before { content: '●'; font-size: 0.6em; }\n\n.ot-header-actions { display: flex; align-items: center; gap: 10px; }\n.ot-invoice-btn {\n  display: flex; align-items: center; gap: 7px;\n  padding: 11px 18px; border-radius: 12px;\n  border: 1px solid color-mix(in srgb, var(--accent) 45%, var(--border));\n  background: var(--bg-primary); color: var(--accent); font-weight: 700; font-size: 0.86rem;\n  cursor: pointer; white-space: nowrap; transition: background 150ms;\n}\n.ot-invoice-btn:hover { background: color-mix(in srgb, var(--accent) 8%, transparent); }\n.ot-kebab-wrap { position: relative; }\n.ot-kebab-btn {\n  width: 42px; height: 42px; border-radius: 12px; border: 1px solid var(--border);\n  background: var(--bg-primary); cursor: pointer; color: var(--text-primary); font-size: 1.2rem;\n}\n.ot-kebab-menu {\n  position: absolute; right: 0; top: 48px; z-index: 20; overflow: hidden;\n  background: var(--bg-primary); border: 1px solid var(--border); border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(1, 13, 33,0.18); min-width: 170px;\n  display: flex; flex-direction: column;\n}\n.ot-kebab-menu button, .ot-kebab-menu a {\n  display: block; text-align: left; padding: 10px 14px; background: none; border: none;\n  color: var(--text-primary); font-size: 0.85rem; cursor: pointer; text-decoration: none;\n}\n.ot-kebab-menu button:hover, .ot-kebab-menu a:hover { background: var(--bg-secondary); }\n\n.ot-body { max-width: 1140px; margin: 0 auto; padding: 28px 24px; }\n\n.ot-card { background: var(--bg-primary); border: 1px solid var(--border); border-radius: 18px; padding: 26px; box-shadow: 0 4px 20px rgba(1, 13, 33,0.06); }\n\n.ot-search-card { max-width: 520px; margin: 0 auto; }\n.ot-search-title { margin: 0 0 4px; font-weight: 700; font-size: 1rem; color: var(--text-primary); }\n.ot-search-hint { margin: 0 0 16px; font-size: 0.85rem; color: var(--text-secondary); }\n.ot-search-row { display: flex; gap: 10px; flex-wrap: wrap; }\n.ot-search-input {\n  flex: 1 1 220px; padding: 11px 14px; border-radius: 10px; border: 1px solid var(--border);\n  background: var(--bg-secondary); color: var(--text-primary); font-size: 0.92rem;\n}\n.ot-search-input.err { border-color: var(--danger); }\n.ot-search-btn { padding: 11px 22px; border-radius: 10px; border: none; cursor: pointer; background: var(--accent); color: var(--color-text-on-secondary); font-weight: 700; font-size: 0.9rem; }\n.ot-search-err { margin: 10px 0 0; font-size: 0.82rem; color: var(--danger); }\n\n.ot-loading { text-align: center; padding: 48px; color: var(--text-secondary); }\n.ot-loading-icon { font-size: 36px; margin-bottom: 10px; }\n\n.ot-notfound { text-align: center; padding: 40px; max-width: 480px; margin: 0 auto; }\n.ot-notfound-icon { font-size: 48px; margin-bottom: 12px; }\n.ot-notfound h2 { color: var(--text-primary); margin: 0 0 8px; }\n.ot-notfound p { color: var(--text-secondary); margin: 0; }\n\n.ot-grid { display: grid; grid-template-columns: 1.6fr 1fr; gap: 22px; align-items: start; margin-bottom: 22px; }\n@media (max-width: 860px) { .ot-grid { grid-template-columns: 1fr; } }\n\n.ot-card-title {\n  margin: 0 0 4px; font-size: 1.2rem; font-weight: 700; color: var(--text-primary);\n  border-left: 4px solid var(--ot-gold); padding-left: 12px;\n}\n.ot-card-sub { margin: 0 0 22px; font-size: 0.85rem; color: var(--text-secondary); padding-left: 16px; }\n\n.ot-return-banner {\n  display: flex; align-items: flex-start; gap: 10px;\n  background: color-mix(in srgb, var(--accent-secondary) 8%, transparent); border: 1px solid color-mix(in srgb, var(--accent-secondary) 25%, transparent); color: var(--accent-secondary);\n  border-radius: 8px; padding: 10px 14px; margin: 0 0 18px;\n}\n[data-theme=\"dark\"] .ot-return-banner { background: color-mix(in srgb, var(--accent-secondary) 14%, transparent); }\n.ot-return-banner-icon { flex-shrink: 0; margin-top: 1px; }\n.ot-return-banner-title { margin: 0; font-size: 0.85rem; font-weight: 700; }\n.ot-return-banner-sub { margin: 2px 0 0; font-size: 0.78rem; color: var(--text-secondary); }\n\n.ot-cancelled { text-align: center; padding: 24px 0; color: var(--danger); }\n.ot-cancelled span { font-size: 36px; }\n.ot-cancelled p { margin: 8px 0 0; font-weight: 700; }\n.ot-cancelled.ot-refunded { color: var(--accent-secondary); }\n.ot-cancelled.ot-exchanged { color: var(--accent-secondary); }\n\n.ot-live-map-wrap { margin-top: 20px; padding-top: 18px; border-top: 1px solid var(--border); }\n.ot-live-map-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }\n.ot-live-map-title { display: flex; align-items: center; gap: 6px; font-weight: 700; font-size: 0.85rem; color: var(--text-primary); }\n.ot-live-map-freshness { font-size: 0.72rem; font-weight: 600; color: var(--success); }\n.ot-live-map-freshness.stale { color: var(--text-muted); }\n.ot-live-map-wrap .leaflet-container { z-index: 0; }\n\n/* Cash-on-delivery \"have this ready for the courier\" callout. Calm blue while\n   the order is still being prepared, escalating to a stronger amber once it's\n   actually out for delivery and the cash is imminently needed. */\n.ot-cash-due {\n  display: flex; align-items: center; gap: 14px;\n  margin-top: 20px; padding: 14px 16px;\n  border-radius: 12px;\n  background: rgba(59, 130, 246, 0.08);\n  border: 1px solid rgba(59, 130, 246, 0.22);\n}\n.ot-cash-due-active {\n  background: rgba(255, 103, 0, 0.12);\n  border-color: rgba(255, 103, 0, 0.4);\n}\n.ot-cash-due-icon {\n  display: flex; align-items: center; justify-content: center;\n  width: 40px; height: 40px; border-radius: 50%; flex-shrink: 0;\n  background: rgba(59, 130, 246, 0.15); color: var(--color-secondary-hover);\n}\n.ot-cash-due-active .ot-cash-due-icon { background: rgba(255, 103, 0, 0.2); color: var(--color-primary); }\n.ot-cash-due-label { margin: 0; font-size: 0.82rem; font-weight: 600; color: var(--text-secondary); }\n.ot-cash-due-amount { margin: 2px 0 0; font-size: 1.35rem; font-weight: 800; color: var(--text-primary); }\n\n.ot-timeline { display: flex; flex-direction: column; }\n.ot-tl-row { display: flex; gap: 16px; }\n.ot-tl-icon-col { display: flex; flex-direction: column; align-items: center; flex-shrink: 0; }\n.ot-tl-icon {\n  width: 46px; height: 46px; border-radius: 50%; flex-shrink: 0;\n  display: flex; align-items: center; justify-content: center; font-size: 1.2rem;\n  background: var(--bg-primary); border: 2px solid var(--border); color: var(--text-secondary);\n  transition: all 200ms;\n}\n.ot-tl-active .ot-tl-icon {\n  background: var(--accent); border-color: var(--accent);\n  box-shadow: 0 0 0 5px color-mix(in srgb, var(--accent) 18%, transparent);\n}\n/* Delivered gets its own solid green fill once reached, rather than the shared accent color */\n.ot-tl-step-delivered.ot-tl-done .ot-tl-icon,\n.ot-tl-step-delivered.ot-tl-active .ot-tl-icon { background: var(--success); border-color: var(--success); box-shadow: 0 0 0 5px color-mix(in srgb, var(--success) 18%, transparent); }\n.ot-tl-step-processing .ot-tl-icon       { color: var(--accent-secondary); }\n.ot-tl-step-shipped .ot-tl-icon          { color: var(--color-primary); }\n.ot-tl-step-out_for_delivery .ot-tl-icon { color: var(--color-secondary); }\n.ot-tl-step-delivered .ot-tl-icon        { color: var(--success); }\n.ot-tl-active .ot-tl-icon, .ot-tl-step-delivered.ot-tl-done .ot-tl-icon { color: var(--color-brand-white); }\n\n.ot-tl-line { width: 0; flex: 1; min-height: 26px; margin: 2px 0; border-left: 2px dashed var(--border); }\n.ot-tl-done .ot-tl-line { border-left-style: solid; border-left-color: var(--accent); }\n\n.ot-tl-body { flex: 1; padding: 4px 0 26px; position: relative; }\n.ot-tl-row:last-child .ot-tl-body { padding-bottom: 0; }\n.ot-tl-highlight {\n  background: color-mix(in srgb, var(--accent) 7%, transparent);\n  border: 1px solid color-mix(in srgb, var(--accent) 16%, transparent);\n  border-radius: 14px; padding: 14px 46px 14px 16px;\n  margin: -10px 0 16px -16px; width: calc(100% + 16px); box-sizing: border-box;\n}\n.ot-tl-check-badge {\n  position: absolute; top: 50%; right: 16px; transform: translateY(-50%);\n  width: 28px; height: 28px; border-radius: 50%;\n  background: color-mix(in srgb, var(--accent) 22%, transparent); color: var(--accent);\n  display: flex; align-items: center; justify-content: center;\n}\n.ot-tl-head { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }\n.ot-tl-label { font-weight: 700; font-size: 1rem; color: var(--text-primary); }\n.ot-tl-pill { font-size: 0.7rem; font-weight: 700; padding: 3px 10px; border-radius: 20px; }\n.ot-tl-pill-completed, .ot-tl-pill-in-progress { background: color-mix(in srgb, var(--accent) 16%, transparent); color: var(--accent); }\n.ot-tl-pill-pending { background: var(--bg-tertiary); color: var(--text-secondary); }\n.ot-tl-desc { margin: 5px 0 0; font-size: 0.85rem; color: var(--text-secondary); }\n\n.ot-summary-box { border: 1px solid var(--border); border-radius: 14px; padding: 16px; margin-bottom: 18px; }\n.ot-summary-box-head { display: flex; align-items: center; justify-content: space-between; font-size: 0.88rem; font-weight: 700; color: var(--text-primary); }\n.ot-summary-box-head button { background: none; border: none; color: var(--accent); font-weight: 700; font-size: 0.82rem; cursor: pointer; padding: 4px; }\n.ot-summary-item { display: flex; align-items: center; gap: 12px; padding: 12px 0; border-top: 1px solid var(--border); }\n.ot-summary-item img { width: 56px; height: 56px; object-fit: cover; border-radius: 10px; flex-shrink: 0; background: var(--bg-secondary); }\n.ot-summary-item-info { flex: 1; min-width: 0; }\n.ot-summary-item-name { margin: 0; font-size: 0.92rem; font-weight: 700; color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.ot-summary-item-meta { margin: 3px 0 0; font-size: 0.8rem; color: var(--text-secondary); }\n.ot-summary-item-qty { font-size: 0.85rem; color: var(--text-secondary); flex-shrink: 0; }\n\n.ot-totals { display: flex; flex-direction: column; gap: 10px; padding-bottom: 18px; margin-bottom: 18px; border-bottom: 1px solid var(--border); }\n.ot-total-row { display: flex; justify-content: space-between; font-size: 0.9rem; color: var(--text-secondary); }\n.ot-discount-row { color: var(--color-primary); }\n.ot-grand-row { font-size: 1.15rem; font-weight: 800; color: var(--text-primary); padding-top: 10px; border-top: 1px solid var(--border); }\n\n.ot-secure-banner {\n  position: relative; overflow: hidden;\n  display: flex; gap: 12px; align-items: flex-start;\n  background: color-mix(in srgb, var(--accent) 7%, transparent);\n  border: 1px solid color-mix(in srgb, var(--accent) 14%, transparent);\n  border-radius: 14px; padding: 14px 44px 14px 14px;\n}\n.ot-secure-icon {\n  width: 36px; height: 36px; border-radius: 50%; flex-shrink: 0;\n  display: flex; align-items: center; justify-content: center; font-size: 1.05rem;\n  background: color-mix(in srgb, var(--accent) 16%, transparent);\n}\n.ot-secure-title { margin: 0; font-size: 0.88rem; font-weight: 700; color: var(--text-primary); }\n.ot-secure-sub { margin: 3px 0 0; font-size: 0.78rem; color: var(--text-secondary); }\n.ot-secure-lock {\n  position: absolute; right: 14px; top: 50%; transform: translateY(-50%);\n  color: var(--text-secondary); opacity: 0.55;\n}\n\n.ot-seller-card { margin-bottom: 18px; }\n.ot-seller-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }\n.ot-seller-name { margin: 0; font-weight: 700; font-size: 0.9rem; color: var(--text-primary); }\n.ot-seller-status { font-size: 0.72rem; font-weight: 700; padding: 3px 10px; border-radius: 20px; background: var(--bg-tertiary); color: var(--text-secondary); text-transform: capitalize; }\n.ot-seller-status-delivered { background: var(--color-secondary-soft); color: var(--success); }\n.ot-seller-status-cancelled { background: var(--color-primary-soft); color: var(--color-primary); }\n.ot-tracking-num { background: var(--bg-secondary); border-radius: 8px; padding: 8px 12px; margin-bottom: 12px; font-size: 0.85rem; }\n.ot-tracking-num strong { font-family: monospace; color: var(--text-primary); }\n.ot-seller-item { display: flex; align-items: center; gap: 10px; margin-bottom: 8px; }\n.ot-seller-item img { width: 40px; height: 40px; object-fit: cover; border-radius: 8px; flex-shrink: 0; }\n.ot-seller-item p { margin: 0; font-size: 0.88rem; color: var(--text-primary); }\n.ot-seller-item p span { color: var(--text-secondary); }\n.ot-status-history { margin-top: 12px; }\n.ot-status-history summary { font-size: 0.8rem; color: var(--text-secondary); cursor: pointer; }\n.ot-status-history > div { margin-top: 8px; padding-left: 8px; border-left: 2px solid var(--border); margin-left: 4px; }\n.ot-history-row { margin-bottom: 8px; }\n.ot-history-status { margin: 0; font-size: 0.82rem; font-weight: 600; color: var(--text-primary); text-transform: capitalize; }\n.ot-history-note, .ot-history-time { margin: 0; font-size: 0.76rem; color: var(--text-secondary); }\n\n.ot-help-banner {\n  position: relative; overflow: hidden;\n  display: flex; align-items: center; gap: 16px; flex-wrap: wrap; margin-bottom: 18px;\n  background: linear-gradient(135deg, color-mix(in srgb, var(--ot-gold) 6%, var(--bg-primary)) 0%, var(--bg-primary) 65%);\n}\n.ot-help-icon {\n  width: 46px; height: 46px; border-radius: 50%; flex-shrink: 0;\n  display: flex; align-items: center; justify-content: center; font-size: 1.3rem;\n  background: color-mix(in srgb, var(--ot-gold) 12%, transparent);\n  border: 1px solid color-mix(in srgb, var(--ot-gold) 45%, transparent);\n}\n.ot-help-text { flex: 1; min-width: 200px; }\n.ot-help-title { margin: 0; font-weight: 700; font-size: 1.05rem; color: var(--text-primary); }\n.ot-help-sub { margin: 3px 0 0; font-size: 0.85rem; color: var(--text-secondary); }\n.ot-contact-btn {\n  display: inline-flex; align-items: center; gap: 8px; padding: 12px 22px; border-radius: 12px;\n  border: none; background: var(--accent); color: var(--color-text-on-secondary); font-weight: 700; font-size: 0.9rem;\n  text-decoration: none; white-space: nowrap; transition: filter 150ms;\n}\n.ot-contact-btn:hover { filter: brightness(1.08); }\n\n.ot-another-btn { display: block; margin: 0 auto; background: none; border: none; color: var(--accent); font-weight: 600; font-size: 0.88rem; cursor: pointer; padding: 8px; }\n\n/* ── Unified motion tokens + UX polish (non-functional) ───────── */\n:root {\n  --motion-fast: 140ms;\n  --motion-normal: 210ms;\n  --motion-page: 260ms;\n  --motion-drawer: 280ms;\n  --motion-ease-enter: cubic-bezier(0.22, 1, 0.36, 1);\n  --motion-ease-exit: cubic-bezier(0.4, 0, 1, 1);\n}\n\n.page-fade-in {\n  animation: routeFadeUp var(--motion-page) var(--motion-ease-enter);\n}\n\n@keyframes routeFadeUp {\n  from {\n    opacity: 0;\n    transform: translate3d(0, 8px, 0);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n.shop-hdr-title,\n.active-filters-label {\n  transition: color var(--motion-fast) ease, opacity var(--motion-fast) ease;\n}\n\n.pcard-grid.list-transitioning .pcard,\n.pcard-grid.list-transitioning .pcard-skeleton {\n  animation: listItemIn var(--motion-normal) var(--motion-ease-enter) both;\n}\n\n.pcard-grid.list-transitioning .pcard:nth-child(2n),\n.pcard-grid.list-transitioning .pcard-skeleton:nth-child(2n) {\n  animation-delay: 30ms;\n}\n\n.pcard-grid.list-transitioning .pcard:nth-child(3n),\n.pcard-grid.list-transitioning .pcard-skeleton:nth-child(3n) {\n  animation-delay: 50ms;\n}\n\n@keyframes listItemIn {\n  from {\n    opacity: 0;\n    transform: translate3d(0, 6px, 0);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n.loading.loading-inline {\n  min-height: 120px;\n  font-size: 0.92rem;\n}\n\nbody.overlay-open {\n  overflow: hidden;\n  touch-action: none;\n}\n\n.modal-overlay,\n.bn-cat-sheet-overlay,\n.mas-backdrop {\n  animation: overlayFade var(--motion-normal) var(--motion-ease-enter);\n}\n\n.modal-content {\n  animation: dialogIn var(--motion-drawer) var(--motion-ease-enter);\n}\n\n.bn-cat-sheet,\n.mas-sheet {\n  animation: sheetIn var(--motion-drawer) var(--motion-ease-enter);\n}\n\n@keyframes overlayFade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes dialogIn {\n  from {\n    opacity: 0;\n    transform: translate3d(0, 8px, 0) scale(0.99);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0) scale(1);\n  }\n}\n\n@keyframes sheetIn {\n  from {\n    opacity: 0;\n    transform: translate3d(0, 14px, 0);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n.pcard-heart:disabled {\n  opacity: 0.55;\n  cursor: wait;\n  transform: none;\n}\n\n.btn-place-order[aria-busy='true'] {\n  opacity: 0.78;\n  cursor: wait;\n}\n\n.toast {\n  transition: transform var(--motion-fast) ease, opacity var(--motion-fast) ease;\n}\n\n.toast-warning {\n  background: var(--color-primary-soft);\n  color: var(--color-primary);\n  border: 1px solid var(--color-primary);\n}\n\n.toast-warning .toast-icon {\n  background: var(--color-primary);\n  color: var(--color-text-on-primary);\n}\n\n.toast-undo {\n  border: none;\n  background: transparent;\n  color: currentColor;\n  font-weight: 700;\n  font-size: 0.85em;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  cursor: pointer;\n  padding: 2px 4px;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n.toast-undo:hover,\n.toast-undo:focus-visible { opacity: 0.8; }\n\n.toast-dismiss {\n  margin-left: auto;\n  border: none;\n  background: transparent;\n  color: currentColor;\n  opacity: 0.72;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 6px;\n}\n\n.toast-dismiss:hover,\n.toast-dismiss:focus-visible {\n  opacity: 1;\n  background: color-mix(in srgb, currentColor 12%, transparent);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 1ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 1ms !important;\n    scroll-behavior: auto !important;\n  }\n\n  .page-fade-in,\n  .pcard-grid.list-transitioning .pcard,\n  .pcard-grid.list-transitioning .pcard-skeleton,\n  .modal-content,\n  .bn-cat-sheet,\n  .mas-sheet {\n    animation: none !important;\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   DELIVERY CONFIRMATION PORTAL  (.dc-*)\n   Public, no-login page for the delivery agent -- see DeliveryConfirmPage.js\n   ═══════════════════════════════════════════════════════════════ */\n.dc-page {\n  min-height: 100vh;\n  /* 100dvh tracks the real, keyboard-adjusted visible viewport on mobile --\n     plain 100vh stays fixed to the pre-keyboard height, which is what made\n     this centered layout visibly jump/resize when the delivery key field\n     was focused and the on-screen keyboard opened. */\n  min-height: 100dvh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  overflow-y: auto;\n  background: var(--bg-primary);\n}\n.dc-card {\n  position: relative;\n  box-sizing: border-box;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: 24px;\n  padding: 40px;\n  width: 100%;\n  max-width: 440px;\n  box-shadow: var(--shadow-panel);\n}\n.dc-back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n  margin-bottom: 20px;\n}\n.dc-back-btn:hover { color: var(--text-primary); }\n.dc-icon-wrap {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: color-mix(in srgb, var(--accent-secondary) 12%, transparent);\n  color: var(--accent-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 16px;\n}\n.dc-title { margin: 0 0 8px; font-size: 1.35rem; text-align: center; color: var(--text-primary); }\n.dc-sub { margin: 0 0 24px; font-size: 0.85rem; color: var(--text-secondary); text-align: center; line-height: 1.5; }\n\n.dc-form { display: flex; flex-direction: column; gap: 14px; }\n.dc-field { display: flex; flex-direction: column; gap: 6px; }\n.dc-field label { font-size: 0.8rem; font-weight: 600; color: var(--text-secondary); }\n.dc-field input,\n.dc-field textarea {\n  box-sizing: border-box;\n  width: 100%;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 12px 14px;\n  font-size: 0.95rem;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-family: inherit;\n  resize: none;\n}\n.dc-field input:focus,\n.dc-field textarea:focus {\n  border-color: var(--accent);\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.dc-result-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 16px 18px;\n  margin-bottom: 18px;\n  text-align: left;\n}\n.dc-result-row { display: flex; justify-content: space-between; gap: 12px; padding: 6px 0; font-size: 0.88rem; border-bottom: 1px solid var(--border); }\n.dc-result-row:last-child { border-bottom: none; }\n.dc-result-label { color: var(--text-secondary); }\n.dc-result-value { color: var(--text-primary); font-weight: 600; text-align: right; }\n.dc-result-items { margin: 4px 0 0; padding: 0; list-style: none; font-size: 0.85rem; color: var(--text-primary); }\n.dc-result-items li { display: flex; justify-content: space-between; padding: 4px 0; }\n\n.dc-mode-toggle {\n  display: flex;\n  gap: 6px;\n  background: var(--bg-secondary);\n  border-radius: var(--radius-lg);\n  padding: 4px;\n  margin-bottom: 16px;\n}\n.dc-mode-btn {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 9px 10px;\n  border: none;\n  border-radius: calc(var(--radius-lg) - 4px);\n  background: transparent;\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 120ms ease, color 120ms ease;\n}\n.dc-mode-btn.active { background: var(--bg-primary); color: var(--text-primary); box-shadow: 0 1px 4px rgba(1, 13, 33,0.08); }\n\n.dc-qr-wrap {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  /* Letterboxing behind the live camera feed -- navy rather than pure black,\n     so the scanner frame still reads as part of the app. */\n  background: var(--color-brand-navy);\n}\n.dc-qr-video { width: 100%; height: 100%; object-fit: cover; display: block; }\n\n.dc-logout-link {\n  background: none; border: none; color: var(--text-secondary); font-size: 0.8rem;\n  text-decoration: underline; cursor: pointer; margin-top: 14px; display: block; text-align: center; width: 100%;\n}\n.dc-access-denied { text-align: center; padding: 12px 0; color: var(--text-secondary); font-size: 0.88rem; }\n\n.dc-error {\n  background: color-mix(in srgb, var(--danger) 10%, transparent);\n  color: var(--danger);\n  border: 1px solid color-mix(in srgb, var(--danger) 30%, transparent);\n  border-radius: var(--radius-sm);\n  padding: 10px 14px;\n  font-size: 0.85rem;\n}\n\n.dc-submit-btn {\n  padding: 13px 20px;\n  border-radius: var(--radius-lg);\n  border: none;\n  /* Confirming a delivery is the page's primary action -> orange. */\n  background: var(--color-primary);\n  color: var(--color-text-on-primary);\n  font-size: 0.95rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 120ms ease, box-shadow 120ms ease, opacity 120ms ease;\n}\n.dc-submit-btn:hover { box-shadow: 0 6px 20px color-mix(in srgb, var(--accent-secondary) 35%, transparent); }\n.dc-submit-btn:disabled { opacity: 0.6; cursor: not-allowed; }\n\n/* Active Deliveries list. Previously built from inline styles on the elements\n   themselves, which left no way to express the one rule the layout actually\n   needs: a flex child defaults to min-width:auto and so refuses to shrink below\n   its content, which pushed the order/total line onto a second row next to a\n   nowrap button. min-width:0 on the text column is what lets it wrap the long\n   address instead of forcing the row wider than the card. */\n.dc-active-list { display: flex; flex-direction: column; gap: 10px; }\n.dc-active-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  padding: 12px 14px;\n}\n.dc-active-info { min-width: 0; }\n.dc-active-name { margin: 0 0 3px; font-weight: 700; font-size: 0.9rem; }\n.dc-active-address { margin: 0; font-size: 0.8rem; color: var(--text-secondary); }\n/* The order number and total read as one unit, so keep them off a line break\n   even when the address above them wraps. */\n.dc-active-meta { margin: 3px 0 0; font-size: 0.78rem; color: var(--text-muted); white-space: nowrap; }\n\n/* Row-level action inside the Active Deliveries list, rather than the page's\n   primary action -- so it sits at button size instead of filling the width.\n   flex-shrink:0 keeps the label from being squeezed into a wrap by a long\n   customer address. */\n.dc-share-btn {\n  flex-shrink: 0;\n  width: auto;\n  padding: 8px 14px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n}\n\n/* Stop is the one state that reverses something already running, so it has to\n   read differently from Share/Resume at a glance. It previously set an inline\n   background of --color-brand-orange, which is the same value .dc-submit-btn\n   already paints -- the two states rendered identically and only the label and\n   icon distinguished them. Blue is the sanctioned secondary-interaction hue;\n   the IconX and the \"Stop\" label still carry the meaning on their own, since\n   with four hues colour can never be the only signal. */\n.dc-stop-btn {\n  background: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n}\n.dc-stop-btn:hover { box-shadow: 0 6px 20px color-mix(in srgb, var(--color-secondary) 35%, transparent); }\n\n.dc-success { text-align: center; padding: 12px 0; }\n.dc-success-icon { color: var(--success); display: inline-flex; margin-bottom: 10px; }\n.dc-success-title { margin: 0 0 6px; font-size: 1.1rem; font-weight: 700; color: var(--text-primary); }\n.dc-success-sub { margin: 0 0 20px; font-size: 0.85rem; color: var(--text-secondary); }\n\n@media (max-width: 480px) {\n  .dc-card { padding: 28px 20px; }\n}\n\n/* ── Product comparison bar + modal ────────────────────────────────── */\n.compare-bar {\n  position: fixed;\n  left: 50%;\n  bottom: 16px;\n  transform: translateX(-50%);\n  z-index: 1500;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xl);\n  box-shadow: 0 10px 30px rgba(1, 13, 33,0.2);\n  padding: 10px 16px;\n  max-width: calc(100vw - 24px);\n}\n.compare-bar-thumbs { display: flex; gap: 6px; }\n.compare-bar-thumb { position: relative; width: 40px; height: 40px; border-radius: 8px; overflow: hidden; flex-shrink: 0; }\n.compare-bar-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }\n.compare-bar-thumb button {\n  position: absolute; top: -4px; right: -4px; width: 16px; height: 16px; border-radius: 50%;\n  background: var(--danger); color: var(--color-text-on-primary); border: none; display: flex; align-items: center; justify-content: center; cursor: pointer;\n}\n.compare-bar-title { font-size: 0.85rem; font-weight: 600; color: var(--text-primary); white-space: nowrap; }\n.compare-bar-actions { display: flex; gap: 8px; align-items: center; }\n.compare-bar-clear {\n  background: none; border: none; color: var(--text-secondary); font-size: 0.8rem; cursor: pointer; padding: 8px 4px; white-space: nowrap;\n}\n.compare-bar-btn { padding: 8px 16px; font-size: 0.85rem; white-space: nowrap; }\n\n.compare-modal-overlay {\n  position: fixed; inset: 0; background: rgba(1, 13, 33,0.75); display: flex; align-items: center; justify-content: center;\n  z-index: 2000; padding: 20px;\n}\n.compare-modal {\n  background: var(--bg-secondary); border-radius: var(--radius-xl); width: 100%; max-width: 900px; max-height: 85vh;\n  display: flex; flex-direction: column; overflow: hidden;\n}\n.compare-modal-header {\n  display: flex; align-items: center; justify-content: space-between; padding: 18px 22px; border-bottom: 1px solid var(--border);\n}\n.compare-modal-header h2 { margin: 0; font-size: 1.1rem; color: var(--text-primary); }\n.compare-modal-close {\n  background: none; border: none; color: var(--text-secondary); cursor: pointer; width: 32px; height: 32px;\n  display: flex; align-items: center; justify-content: center; border-radius: 50%;\n}\n.compare-modal-close:hover { background: var(--bg-tertiary); }\n.compare-modal-table-wrap { overflow: auto; padding: 18px 22px; }\n.compare-modal-table { border-collapse: collapse; width: 100%; }\n.compare-modal-table th {\n  text-align: left; padding: 10px 14px; font-size: 0.8rem; color: var(--text-secondary); white-space: nowrap; vertical-align: top;\n}\n.compare-modal-table td {\n  padding: 10px 14px; font-size: 0.85rem; color: var(--text-primary); border-top: 1px solid var(--border); min-width: 160px; text-align: center;\n}\n.compare-modal-table td img, .compare-modal-table td picture { width: 80px; height: 80px; object-fit: cover; border-radius: 8px; margin: 0 auto; display: block; }\n.compare-modal-link {\n  background: none; border: none; color: var(--accent, var(--accent-secondary)); cursor: pointer; font-weight: 600; font-size: 0.85rem; text-align: center; padding: 0;\n}\n.compare-modal-row-actions { display: flex; flex-direction: column; gap: 6px; align-items: center; }\n.compare-modal-remove { background: none; border: none; color: var(--danger); cursor: pointer; font-size: 0.78rem; }\n/* Selected state -> blue, per the selection/interaction role. */\n.pcard-quick-btn.active { background: var(--color-secondary); color: var(--color-text-on-secondary); }\n\n@media (max-width: 480px) {\n  .compare-bar { flex-wrap: wrap; justify-content: center; }\n  .compare-bar-title { width: 100%; text-align: center; }\n}\n\n/* ── Support chat widget ──────────────────────────────────── */\n.chat-widget-wrap {\n  position: fixed;\n  right: 20px;\n  bottom: 20px;\n  z-index: 9500;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n/* BottomNav's tab bar (see BottomNav.css) takes over the bottom of the\n   screen at this same width, with the Account tab as its rightmost item --\n   directly under where this widget would otherwise sit. Lift it above the\n   bar instead of overlapping the tab. */\n@media (max-width: 768px) {\n  .chat-widget-wrap { bottom: calc(56px + env(safe-area-inset-bottom, 0px) + 14px); }\n}\n\n/* The launcher is docked to the right edge, not floating over the page.\n   A round FAB parked above the content followed the customer down every\n   scroll and sat on top of whatever was underneath it; anchored to the edge\n   and vertically centred, the tab stays visible without ever covering a\n   product image or the bottom of a form. Blue, not orange: opening support\n   is an informational action, and orange is reserved for commercial ones.\n\n   It docks flush to the edge with its label and icon both visible, rounded\n   on the inboard side only so it reads as a tab attached to the screen edge\n   rather than a floating control. An earlier revision pushed it 32px past the\n   edge to leave only a sliver showing; that lost the icon entirely and left a\n   tap target 12px wide, so it is back to a full tab. */\n.chat-side-tab {\n  position: fixed;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 9500;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 9px;\n  padding: 15px 11px;\n  border: none;\n  border-radius: var(--radius-sm) 0 0 var(--radius-sm);\n  /* Navy on blue, never white -- white on this fill is 3.1:1 and fails AA. */\n  background: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n  cursor: pointer;\n  box-shadow: var(--shadow-panel);\n  transition: transform 0.15s ease;\n}\n\n/* Slides a little further out on pointer devices. Guarded by hover:hover\n   because a phone latches :hover after a tap, which would otherwise leave the\n   tab stuck in its extended position for the rest of the session. */\n@media (hover: hover) {\n  .chat-side-tab:hover { transform: translateY(-50%) translateX(-4px); }\n}\n.chat-side-tab:focus-visible { transform: translateY(-50%) translateX(-4px); }\n\n.chat-side-tab-label {\n  writing-mode: vertical-rl;\n  font-size: 0.72rem;\n  line-height: 1;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n}\n\n/* Arabic runs the whole document RTL (App.js sets documentElement.dir), so\n   the tab and the panel it opens both move to the near edge together --\n   splitting them across opposite edges would read as two features. The\n   geometry mirrors with it: the strip is now the tab's right edge, so the\n   label has to align there instead. */\n/* `left: 0`, mirroring the LTR rule's `right: 0`.\n *\n * This read `calc(-1 * var(--chat-tab-hidden))`, and --chat-tab-hidden is\n * defined nowhere -- not in CSS, not set inline from JS. calc() with an\n * undefined custom property is invalid at computed-value time, so `left` fell\n * back to `auto`; with `right: auto` set on the line above it, the tab had no\n * horizontal anchor at all and sat wherever static flow left it. In Arabic,\n * which is the only place this rule applies (App.js sets documentElement.dir),\n * the support tab was simply in the wrong place. */\n[dir=\"rtl\"] .chat-side-tab {\n  right: auto;\n  left: 0;\n  align-items: flex-end;\n  padding: 16px 1px 16px 0;\n  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;\n}\n@media (hover: hover) {\n  [dir=\"rtl\"] .chat-side-tab:hover { transform: translateY(-50%) translateX(6px); }\n}\n[dir=\"rtl\"] .chat-side-tab:focus-visible { transform: translateY(-50%) translateX(6px); }\n\n/* The phone and packaged-app variants that used to sit here (a 44x44 square\n   with the wordmark collapsed until pressed) are gone: the strip design above\n   is now the single treatment on web and in the app, so there is nothing left\n   to override per platform. */\n[dir=\"rtl\"] .chat-widget-wrap { right: auto; left: 20px; align-items: flex-start; }\n\n.chat-widget-panel {\n  width: min(360px, calc(100vw - 32px));\n  height: min(520px, calc(100vh - 120px));\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-panel);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.chat-widget-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-secondary) 100%);\n  color: var(--color-brand-white);\n  flex-shrink: 0;\n}\n.chat-widget-header-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 700;\n  font-size: 0.95rem;\n}\n.chat-widget-close {\n  background: rgba(255,255,255,0.15);\n  border: none;\n  color: var(--color-brand-white);\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n.chat-widget-close:hover { background: rgba(255,255,255,0.28); }\n\n.chat-widget-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.chat-widget-msg {\n  max-width: 82%;\n  padding: 9px 13px;\n  border-radius: 14px;\n  font-size: 0.87rem;\n  line-height: 1.45;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n.chat-widget-msg-assistant {\n  align-self: flex-start;\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  border-bottom-left-radius: 4px;\n}\n.chat-widget-msg-user {\n  align-self: flex-end;\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  border-bottom-right-radius: 4px;\n}\n.chat-widget-typing {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 12px 14px;\n}\n.chat-widget-typing span {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--text-muted);\n  animation: chatWidgetTyping 1.2s infinite ease-in-out;\n}\n.chat-widget-typing span:nth-child(2) { animation-delay: 0.15s; }\n.chat-widget-typing span:nth-child(3) { animation-delay: 0.3s; }\n@keyframes chatWidgetTyping {\n  0%, 60%, 100% { opacity: 0.35; transform: translateY(0); }\n  30% { opacity: 1; transform: translateY(-3px); }\n}\n\n/* Products the assistant found, rendered as buttons under its reply instead\n   of as links inside it. The model is told never to write a URL: a tap target\n   carrying the real image, name and current price is easier to read and\n   can't be mistyped. Deliberately no discount percentage -- product cards\n   never show one anywhere in this app (see CLAUDE.md). */\n.chat-product-list {\n  align-self: flex-start;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.chat-product-card {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 8px;\n  text-align: left;\n  background: var(--bg-primary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: border-color 0.15s ease, transform 0.15s ease;\n}\n.chat-product-card:hover {\n  border-color: var(--color-secondary);\n  transform: translateY(-1px);\n}\n.chat-product-thumb {\n  width: 44px;\n  height: 44px;\n  flex-shrink: 0;\n  border-radius: var(--radius-xs);\n  object-fit: cover;\n  background: var(--bg-tertiary);\n}\n.chat-product-thumb-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted);\n}\n.chat-product-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.chat-product-name {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.chat-product-meta {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n.chat-product-price {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n.chat-product-was {\n  font-size: 0.72rem;\n  color: var(--text-muted);\n}\n/* Carries its own words rather than relying on colour -- with only four\n   hues, out-of-stock can't be signalled by a tint alone. */\n.chat-product-oos {\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: var(--text-muted);\n}\n.chat-product-cta {\n  flex-shrink: 0;\n  padding: 5px 10px;\n  border-radius: var(--radius-pill);\n  font-size: 0.72rem;\n  font-weight: 700;\n  background: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n}\n\n.chat-widget-error {\n  margin: 0 14px 8px;\n  padding: 8px 12px;\n  border-radius: var(--radius-xs);\n  background: color-mix(in srgb, var(--danger) 12%, transparent);\n  color: var(--danger);\n  font-size: 0.8rem;\n  flex-shrink: 0;\n}\n\n.chat-widget-input-row {\n  display: flex;\n  gap: 8px;\n  padding: 12px;\n  border-top: 1px solid var(--border);\n  flex-shrink: 0;\n}\n.chat-widget-input-row input {\n  flex: 1;\n  /* An <input> reports a min-content width of roughly its `size` attribute,\n     which defaults to 20 characters -- and a flex child will not shrink below\n     min-content unless told to. So the field held ~20ch regardless of the\n     panel and pushed the 38px send button past the card's right edge. It\n     first showed up under the mobile layer's larger root, which made those 20\n     characters physically wider, but the bug was always here. */\n  min-width: 0;\n  padding: 9px 13px;\n  border-radius: var(--radius-pill);\n  border: 1px solid var(--border);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 0.87rem;\n}\n.chat-widget-input-row input:focus { outline: none; border-color: var(--accent); }\n.chat-widget-input-row button {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  border: none;\n  background: var(--accent);\n  color: var(--color-text-on-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.chat-widget-input-row button:hover:not(:disabled) { background: var(--accent-hover); }\n.chat-widget-input-row button:disabled { opacity: 0.5; cursor: not-allowed; }\n\n@media (max-width: 480px) {\n  .chat-widget-wrap { right: 12px; }\n  .chat-widget-panel { width: calc(100vw - 24px); height: min(70vh, 520px); }\n}\n\n/* ── Compact admin density: reference screens ─────────────────────────────\n   Keep these pages visually comfortable at 100% browser zoom without using\n   transform/zoom (which would blur text and break sticky positioning). */\n\n/* Add Product: one step tighter than the initial compact pass. */\n.admin-product-editor-compact {\n  --pf-field-height: 42px;\n  padding: 0;\n  background: transparent;\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n}\n.admin-product-editor-compact .admin-pf-header-v2 { margin-bottom: 9px; }\n.admin-product-editor-compact .admin-form-header h2 { font-size: 21px; }\n.admin-product-editor-compact .admin-product-form-layout {\n  grid-template-columns: minmax(0, 1fr) 220px;\n  gap: 11px;\n}\n.admin-product-editor-compact .admin-pf-section {\n  padding: 13px 14px;\n  gap: 9px;\n  margin-bottom: 9px;\n}\n.admin-product-editor-compact .admin-pf-section-title { font-size: 16px; gap: 8px; }\n.admin-product-editor-compact .admin-pf-section-icon { width: 34px; height: 34px; }\n.admin-product-editor-compact .admin-pf-label { font-size: 12px; }\n.admin-product-editor-compact .admin-pf-hint,\n.admin-product-editor-compact .admin-pf-char-count { font-size: 11px; }\n.admin-product-editor-compact .admin-pf-icon-prefix { width: 42px; flex-basis: 42px; }\n.admin-product-editor-compact .admin-pf-icon-wrap > .admin-pf-input,\n.admin-product-editor-compact .admin-pf-tag-wrap .admin-pf-tag-input {\n  /* The outer icon shell is the control. Strip the browser/base input card\n     so Category, SKU, Tags, Sizes and Colours render as one clean field. */\n  border: 0 !important;\n  border-radius: 0 !important;\n  outline: 0 !important;\n  box-shadow: none !important;\n  background: transparent !important;\n  min-height: 0;\n  height: 100%;\n  min-width: 0;\n}\n.admin-product-editor-compact .admin-pf-tag-chips {\n  min-width: 0;\n  overflow: hidden;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n}\n.admin-product-editor-compact .admin-pf-tag-wrap { height: var(--pf-field-height); min-height: var(--pf-field-height); }\n.admin-product-editor-compact .admin-pf-tag-wrap--plain {\n  border: 1.5px solid var(--pf-primary);\n  border-radius: var(--pf-field-radius);\n  background: var(--pf-field-bg);\n}\n.admin-product-editor-compact .admin-pf-tag-wrap .admin-pf-tag-chips {\n  height: 100%;\n  min-height: 0;\n  padding: 0 12px;\n  align-items: center;\n}\n.admin-product-editor-compact .admin-pf-tag-wrap .admin-pf-tag-input {\n  align-self: stretch;\n  box-sizing: border-box;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  line-height: normal;\n}\n.admin-product-editor-compact .admin-pf-row-3 > .admin-pf-field > .admin-pf-input,\n.admin-product-editor-compact .admin-pf-row-3 > .admin-pf-field > .admin-pf-icon-wrap,\n.admin-product-editor-compact .admin-pf-row-3 > .admin-pf-field > .admin-pf-tag-wrap {\n  height: var(--pf-field-height);\n  min-height: var(--pf-field-height);\n  box-sizing: border-box;\n}\n.admin-product-editor-compact .admin-pf-icon-wrap--category .admin-pf-icon-prefix {\n  width: 34px;\n  flex-basis: 34px;\n  padding: 0;\n}\n.admin-product-editor-compact .admin-pf-icon-wrap--category { position: relative; }\n.admin-product-editor-compact .admin-pf-icon-wrap--category select {\n  appearance: none;\n  -webkit-appearance: none;\n  padding-right: 38px !important;\n}\n.admin-product-editor-compact .admin-pf-icon-wrap--category::after {\n  content: '';\n  position: absolute;\n  right: 15px;\n  top: 50%;\n  width: 7px;\n  height: 7px;\n  border-right: 2px solid var(--pf-heading);\n  border-bottom: 2px solid var(--pf-heading);\n  transform: translateY(-70%) rotate(45deg);\n  pointer-events: none;\n}\n.admin-product-editor-compact .admin-pf-icon-wrap--textarea,\n.admin-product-editor-compact .admin-pf-icon-wrap--textarea .admin-pf-textarea,\n.admin-product-editor-compact .admin-pf-textarea { min-height: 72px; }\n.admin-product-editor-compact .admin-preview-img-wrap { height: 120px; }\n.admin-product-editor-compact .admin-pf-sidebar { gap: 9px; }\n.admin-product-editor-compact .admin-preview-card,\n.admin-product-editor-compact .admin-pf-publish-card,\n.admin-product-editor-compact .admin-pf-tips-card { padding: 10px; }\n\n/* Disputes */\n.dsp-header { margin-bottom: 12px; gap: 10px; }\n.dsp-header h2 { font-size: 1.05rem; }\n.dsp-header p { font-size: 0.78rem; }\n.dsp-toolbar-btn { min-height: 38px; padding: 7px 11px; font-size: 0.78rem; }\n.dsp-stat-row { gap: 8px; margin-bottom: 14px; }\n.dsp-stat-card { padding: 12px 14px; gap: 7px; border-radius: 11px; }\n.dsp-stat-icon { width: 30px; height: 30px; }\n.dsp-stat-count { font-size: 1.12rem; }\n.dsp-stat-label { font-size: 0.68rem; }\n.dsp-list { gap: 8px; }\n.dsp-card { padding: 12px 14px; border-radius: 11px; }\n.dsp-card-badges { margin-bottom: 5px; gap: 7px; }\n.dsp-card-order-row { padding: 7px 10px; }\n.dsp-card-actions { margin-top: 8px; gap: 6px; }\n.dsp-notes-input { min-height: 38px; padding: 7px 10px; }\n\n/* Coupons */\n.cpn-section { gap: 14px; }\n.cpn-card { padding: 16px 18px; border-radius: 13px; }\n.cpn-card-head { margin-bottom: 12px; gap: 9px; }\n.cpn-card-icon { width: 36px; height: 36px; }\n.cpn-card-title { font-size: 1.05rem; }\n.cpn-form-grid { gap: 12px 14px; }\n.cpn-field { gap: 5px; }\n.cpn-label { font-size: 0.76rem; }\n.cpn-input-wrap { min-height: 42px; }\n.cpn-input { min-height: 42px; padding-top: 7px; padding-bottom: 7px; font-size: 0.84rem; }\n.cpn-input-icon { width: 42px; }\n.cpn-hint { font-size: 0.7rem; margin-top: 2px; }\n.cpn-options { margin-top: 14px; padding: 13px 15px; }\n.cpn-options-grid { gap: 14px; }\n.cpn-submit { min-height: 40px; padding: 8px 16px; }\n.cpn-list-head { margin-bottom: 12px; }\n.cpn-search input,\n.cpn-sort,\n.cpn-filter-btn { min-height: 38px; padding-top: 7px; padding-bottom: 7px; }\n.cpn-table-header,\n.cpn-row { padding-top: 10px; padding-bottom: 10px; }\n\n/* Careers */\n.admin-section.admin-pf-card-v2 .admin-careers-grid { gap: 14px; }\n.admin-section.admin-pf-card-v2 .admin-careers-grid > div:first-child { gap: 14px !important; }\n.admin-section.admin-pf-card-v2 .admin-careers-grid .admin-pf-section {\n  padding: 16px;\n  gap: 12px;\n  margin-bottom: 0;\n  border-radius: 13px;\n}\n.admin-section.admin-pf-card-v2 .admin-careers-grid .admin-pf-section-title--plain { font-size: 16px; }\n.admin-section.admin-pf-card-v2 .admin-careers-stats { gap: 9px; }\n.admin-section.admin-pf-card-v2 .admin-careers-stat-tile { padding: 12px; }\n.admin-section.admin-pf-card-v2 .admin-careers-stat-icon { width: 36px; height: 36px; }\n.admin-section.admin-pf-card-v2 .admin-careers-stat-value { font-size: 24px; }\n.admin-section.admin-pf-card-v2 .admin-careers-stat-label { font-size: 12px; }\n.admin-section.admin-pf-card-v2 .admin-careers-stat-trend { font-size: 10px; }\n.admin-section.admin-pf-card-v2 .admin-careers-grid .admin-pf-input { min-height: 42px; font-size: 14px; padding: 0 12px; }\n.admin-section.admin-pf-card-v2 .admin-careers-grid .admin-pf-label { font-size: 12px; }\n.admin-section.admin-pf-card-v2 .admin-careers-grid form { gap: 12px !important; }\n.admin-section.admin-pf-card-v2 .admin-rte-toolbar { padding: 5px 7px; }\n.admin-section.admin-pf-card-v2 .admin-rte-toolbar button { width: 26px; height: 26px; }\n.admin-section.admin-pf-card-v2 .admin-rte-body { min-height: 82px; padding: 10px 12px; font-size: 14px; }\n.admin-section.admin-pf-card-v2 .admin-careers-grid .admin-pf-textarea { min-height: 72px; padding: 9px 12px; font-size: 14px; }\n.admin-section.admin-pf-card-v2 .admin-products-table .admin-table-header,\n.admin-section.admin-pf-card-v2 .admin-products-table .admin-product-row { padding-top: 9px; padding-bottom: 9px; }\n\n/* Product catalogue beneath Add Product. Give each content type a guarded\n   track and scroll the table as a unit on narrow screens; cells must never\n   paint over adjacent columns. */\n.admin-product-catalog-table {\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n}\n.admin-product-catalog-table .admin-table-header,\n.admin-product-catalog-table .admin-product-row {\n  grid-template-columns: minmax(0, 2fr) minmax(80px, 0.7fr) minmax(90px, 0.65fr) 70px minmax(220px, 1.45fr);\n  min-width: 0;\n  box-sizing: border-box;\n  gap: 10px;\n}\n.admin-product-catalog-table .admin-product-name,\n.admin-product-catalog-table .admin-product-name > div,\n.admin-product-catalog-table .admin-product-price-cell { min-width: 0; }\n.admin-product-catalog-table .admin-product-price-cell {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  overflow: hidden;\n}\n.admin-product-catalog-table .admin-product-price-cell > * {\n  margin-left: 0 !important;\n  max-width: 100%;\n  white-space: nowrap;\n}\n.admin-product-catalog-table .admin-category-chip {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  box-sizing: border-box;\n}\n.admin-product-catalog-table .admin-row-actions {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 5px;\n  min-width: 0;\n}\n.admin-product-catalog-table .admin-row-actions .btn-admin-edit,\n.admin-product-catalog-table .admin-row-actions button {\n  min-width: 0;\n  padding: 6px 7px;\n  font-size: 0.76rem;\n  white-space: nowrap;\n}\n.admin-product-catalog-table .admin-product-delete-btn {\n  background: var(--color-primary);\n  border-color: var(--color-primary);\n  color: var(--color-text-on-primary);\n}\n.admin-product-catalog-table .admin-product-delete-btn:hover,\n.admin-product-catalog-table .admin-product-delete-btn:focus-visible {\n  background: var(--color-primary);\n  border-color: var(--color-primary);\n  color: var(--color-text-on-primary);\n}\n\n@media (max-width: 1200px) {\n  .admin-product-catalog-table { border: 0; background: transparent; }\n  .admin-product-catalog-table .admin-table-header { display: none; }\n  .admin-product-catalog-table .admin-product-row {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    grid-template-areas:\n      \"product product product\"\n      \"category price stock\"\n      \"actions actions actions\";\n    gap: 10px 14px;\n    margin-bottom: 10px;\n    padding: 13px 14px;\n    border: 1px solid var(--border);\n    border-radius: 12px;\n    background: var(--bg-secondary);\n  }\n  .admin-product-catalog-table .admin-product-row > :nth-child(1) { grid-area: product; }\n  .admin-product-catalog-table .admin-product-row > :nth-child(2) { grid-area: category; justify-self: start; }\n  .admin-product-catalog-table .admin-product-row > :nth-child(3) { grid-area: price; }\n  .admin-product-catalog-table .admin-product-row > :nth-child(4) { grid-area: stock; justify-self: start; }\n  .admin-product-catalog-table .admin-product-row > :nth-child(5) { grid-area: actions; }\n  .admin-product-catalog-table .admin-row-actions { grid-template-columns: repeat(4, minmax(0, 1fr)); }\n}\n\n@media (max-width: 560px) {\n  .admin-product-catalog-table .admin-product-row {\n    grid-template-columns: 1fr 1fr;\n    grid-template-areas:\n      \"product product\"\n      \"category stock\"\n      \"price price\"\n      \"actions actions\";\n  }\n  .admin-product-catalog-table .admin-row-actions { grid-template-columns: 1fr 1fr; }\n}\n\n@media (max-width: 900px) {\n  .admin-product-editor-compact .admin-product-form-layout { grid-template-columns: 1fr; }\n}\n\n/* ── Homepage \"Shop by Category\" carousel rows ───────────────── */\n/* Amazon/Flipkart-style widget layout: the page background shows through\n   between rows (each one reads as its own distinct section, not one\n   continuous strip), and each row is a plain white/dark card with exactly\n   one light shadow tier -- not a shadowed panel wrapping shadowed cards.\n   Cards inside share the same background as their row (no border, no\n   shadow at rest) and are separated by whitespace alone, the way real\n   marketplace product tiles are -- only a small hover lift, never both a\n   panel shadow and a card shadow stacked at once. */\n.cat-row { padding: 6px 12px; background: var(--bg-primary); }\n.cat-row-inner {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 16px 20px 18px;\n  background: var(--bg-secondary);\n  border-radius: 8px;\n  box-shadow: var(--shadow-sm);\n}\n.cat-row-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n.cat-row-title-group {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  min-width: 0;\n}\n.cat-row-icon {\n  flex-shrink: 0;\n  /* Only ever the Top Sales flame -- a promotional marker, so orange against\n     the navy section heading beside it. */\n  color: var(--color-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.cat-row-title {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.cat-row-viewall {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  flex-shrink: 0;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: var(--accent);\n  background: none;\n  border: none;\n  /* Measured at 63x15. WCAG 2.2 AA (2.5.8) asks for 24x24 on a control, and\n     the exception for links inline in a sentence does not apply here -- this\n     is a standalone button at the end of a section heading, with nothing\n     around it to explain a miss. Vertical padding rather than a min-height,\n     so the text stays on the heading's baseline instead of the button growing\n     downward away from it. */\n  padding: 5px 2px;\n  min-height: 24px;\n  white-space: nowrap;\n  cursor: pointer;\n  text-decoration: none;\n  transition: gap 150ms;\n}\n.cat-row-viewall:hover { gap: 6px; text-decoration: underline; }\n\n.cat-carousel-track {\n  display: flex;\n  gap: 10px;\n  overflow-x: auto;\n  scroll-snap-type: x proximity;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  padding: 2px 4px 8px;\n}\n.cat-carousel-track::-webkit-scrollbar { display: none; }\n\n.cat-carousel-card {\n  flex: 0 0 168px;\n  scroll-snap-align: start;\n  background: var(--bg-secondary);\n  border-radius: 6px;\n  overflow: hidden;\n  cursor: pointer;\n  position: relative;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n.cat-carousel-card:hover { transform: translateY(-2px); box-shadow: var(--shadow-sm); }\n.cat-carousel-card-oos { opacity: 0.72; }\n\n/* The square is the WRAPPER's, not the image's.\n *\n * It used to come from `aspect-ratio` on the <img>, which works only while\n * there is an <img> to measure. ProductImage renders no <img> at all once a\n * photo has failed -- just its placeholder, which is absolutely positioned and\n * therefore contributes no height -- so a card whose image 404'd collapsed to\n * nothing and the whole row lost its pictures' worth of height.\n *\n * Same reason .pcard-img-wrap carries an explicit height. The image keeps its\n * own aspect-ratio for the ordinary case, where it is what fills the box. */\n.cat-carousel-card-img-wrap { position: relative; aspect-ratio: 1 / 1; background: var(--bg-primary); }\n.cat-carousel-card-img { width: 100%; height: 100%; aspect-ratio: 1 / 1; object-fit: cover; display: block; }\n\n/* Priority badge -- same color language as the main product grid's\n   .pcard-badge-* (bestseller/toprated/deal/limited/oos) so a product reads\n   the same way whether it's here or in the full catalogue grid. */\n.cat-carousel-badge {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  z-index: 2;\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 0.66rem;\n  font-weight: 800;\n  letter-spacing: 0.03em;\n  padding: 3px 8px;\n  border-radius: 20px;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n.cat-carousel-badge-bestseller { background: var(--color-primary); color: var(--color-text-on-primary); }\n.cat-carousel-badge-toprated   { background: var(--color-secondary); color: var(--color-text-on-secondary); }\n.cat-carousel-badge-limited    { background: var(--danger); color: var(--color-text-on-primary); }\n.cat-carousel-badge-oos        { background: var(--text-secondary); color: var(--color-brand-white); }\n\n.cat-carousel-oos-overlay {\n  position: absolute; inset: 0;\n  background: rgba(1, 13, 33,0.6);\n  display: flex; align-items: center; justify-content: center;\n  z-index: 2;\n}\n.cat-carousel-oos-overlay span {\n  background: var(--text-secondary); color: var(--color-brand-white);\n  font-size: 0.68rem; font-weight: 700;\n  padding: 4px 12px; border-radius: var(--radius-xs);\n  text-transform: uppercase; letter-spacing: 0.05em;\n}\n\n/* Quick View hint -- purely a visual affordance (the whole card is already\n   clickable), so it's a plain overlay rather than its own button. Hidden on\n   touch devices via the hover media query, since there's no hover state there. */\n.cat-carousel-quickview {\n  position: absolute;\n  left: 0; right: 0; bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  padding: 7px 0;\n  background: rgba(1, 13, 33,0.72);\n  color: var(--color-brand-white);\n  font-size: 0.7rem;\n  font-weight: 700;\n  opacity: 0;\n  transform: translateY(100%);\n  transition: opacity 160ms, transform 160ms;\n  z-index: 2;\n}\n@media (hover: hover) {\n  .cat-carousel-card:hover .cat-carousel-quickview { opacity: 1; transform: translateY(0); }\n}\n\n/* Touch devices already have the natural gesture (swipe) for this -- a pair\n   of small arrow buttons stacked over 172px-wide cards just eats into card\n   content and adds nothing a touchscreen user needs. Same precedent as\n   .pcard-quick-row being hidden on touch elsewhere in this file. Dots take\n   over as the touch-side position indicator instead (see .cat-carousel-dots). */\n@media (hover: none) {\n  .cat-carousel-outer .carousel-arrow { display: none; }\n}\n\n.cat-carousel-outer-wrap { position: relative; }\n/* 18px gap for the same reason as .carousel-dots above: 6px dot + 18px =\n   24px centre to centre, so the invisible 24px hit areas meet without\n   overlapping. */\n.cat-carousel-dots {\n  display: flex;\n  justify-content: center;\n  gap: 18px;\n  padding: 10px 0 2px;\n}\n.cat-carousel-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--border);\n  border: none;\n  cursor: pointer;\n  transition: background 200ms, width 200ms;\n  padding: 0;\n  position: relative;\n}\n/* 6px is the smallest target in the app -- a quarter of the 24px minimum.\n   Same treatment as .carousel-dot: grow the touchable area, not the dot. */\n.cat-carousel-dot::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 24px;\n  height: 24px;\n  transform: translate(-50%, -50%);\n}\n.cat-carousel-dot.active { background: var(--accent); width: 16px; border-radius: var(--radius-xs); }\n\n/* Must come after the unconditional display:flex above -- same specificity,\n   so source order decides, and a media-scoped rule earlier in the file\n   loses to a later unconditional one regardless of whether it matches.\n   (This is exactly the bug that shipped: dots and arrows both showing on\n   desktop at once, because this rule used to sit above .cat-carousel-dots.) */\n@media (hover: hover) {\n  .cat-carousel-dots { display: none; }\n}\n\n.cat-carousel-card-body { padding: 11px 12px 13px; }\n.cat-carousel-card-name {\n  margin: 0 0 6px;\n  font-size: 0.83rem;\n  font-weight: 600;\n  line-height: 1.35;\n  color: var(--text-primary);\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  min-height: 2.3em;\n}\n.cat-carousel-card-price { display: flex; align-items: baseline; gap: 5px; flex-wrap: wrap; }\n/* Prices are navy, not orange. Orange on white measures 2.92:1 -- it cannot\n   reach WCAG AA as text at any size or weight, which is why the brand rules\n   forbid orange small text on white outright. The orange commercial highlight\n   on these cards is the discount pill (orange fill, navy label, 7.4:1), which\n   carries the promotion without putting orange type on a white background. */\n.cat-carousel-price { font-weight: 700; font-size: 0.93rem; color: var(--text-primary); }\n.cat-carousel-price-sale { font-weight: 700; font-size: 0.93rem; color: var(--text-primary); }\n.cat-carousel-price-was { font-size: 0.72rem; color: var(--text-secondary); text-decoration: line-through; }\n/* \"X% off\" in green, next to the price -- the Flipkart/Amazon convention of\n   repeating the discount as plain text beside the price, not just as an\n   image-corner badge. */\n\n.cat-carousel-card-rating-row {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.72rem;\n  color: var(--text-secondary);\n  margin-top: 5px;\n  min-height: 1.1em;\n}\n/* Small green rating pill (value + star), the Flipkart convention -- reads\n   as a distinct at-a-glance rating chip rather than a plain star row. */\n.cat-carousel-rating-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  background: var(--color-rating);\n  /* Same 3.30:1 problem as .product-rating-pill -- see --color-rating-on-fill. */\n  color: var(--color-rating-on-fill);\n  font-size: 0.68rem;\n  font-weight: 700;\n  padding: 2px 6px;\n  border-radius: 999px;\n  line-height: 1.4;\n}\n.cat-carousel-review-cnt { color: var(--text-secondary); }\n.cat-carousel-no-rating { font-size: 0.7rem; color: var(--color-review-muted); }\n\n@media (max-width: 640px) {\n  .cat-row { padding: 4px 8px; }\n  .cat-row-inner { padding: 12px 14px 14px; border-radius: 6px; }\n  .cat-row-title { font-size: 0.98rem; }\n}\n\n@media (max-width: 600px) {\n  .cat-carousel-card { flex: 0 0 138px; }\n}\n\n@media (max-width: 380px) {\n  .cat-carousel-card { flex: 0 0 122px; }\n}\n\n/* ── Pull-to-refresh indicator ────────────────────────────────────────\n   A small fixed badge that fades/grows in as the user pulls down at the\n   top of the page -- the page itself never moves, only this indicator. */\n.ptr-indicator {\n  position: fixed;\n  top: 10px;\n  left: 50%;\n  z-index: 2000;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-card);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--accent);\n  pointer-events: none;\n}\n.ptr-indicator.refreshing { animation: ptr-spin 700ms linear infinite; }\n@keyframes ptr-spin {\n  from { transform: translateX(-50%) rotate(0deg); }\n  to { transform: translateX(-50%) rotate(360deg); }\n}\n\n/* ═══════════════════════════════════════════════════════════\n   About Us page — aligned to the navbar's max-width like the\n   other public sub-pages (Careers, Help Center, Become a Seller).\n   Green is used as a fixed brand accent for this page specifically,\n   independent of light/dark mode, matching the reference design.\n   ═══════════════════════════════════════════════════════════ */\n.about-page { max-width: 1440px; margin: 0 auto; padding: 8px 24px 80px; display: flex; flex-direction: column; gap: 64px; }\n@media (max-width: 640px) { .about-page { padding: 8px 12px 60px; gap: 48px; } }\n\n.about-eyebrow { display: inline-block; font-size: 0.78rem; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; color: var(--success); margin-bottom: 12px; }\n.about-eyebrow-center { display: block; text-align: center; }\n\n/* ── Hero ─────────────────────────────────────────────────── */\n.about-hero { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; align-items: center; }\n@media (max-width: 900px) { .about-hero { grid-template-columns: 1fr; gap: 32px; } }\n\n.about-hero-title { font-size: 2.3rem; font-weight: 800; line-height: 1.15; color: var(--text-primary); margin: 0 0 16px; }\n@media (max-width: 640px) { .about-hero-title { font-size: 1.7rem; } }\n.about-hero-sub { font-size: 0.95rem; color: var(--text-secondary); line-height: 1.7; max-width: 480px; margin: 0 0 28px; }\n.about-hero-actions { display: flex; flex-wrap: wrap; gap: 12px; }\n\n.about-btn-primary {\n  display: inline-flex; align-items: center; gap: 8px; background: var(--success); color: var(--color-text-on-secondary); border: none;\n  border-radius: 999px; padding: 13px 24px; font-weight: 700; font-size: 0.9rem; cursor: pointer;\n}\n.about-btn-primary:hover { background: var(--color-secondary); }\n.about-btn-outline {\n  display: inline-flex; align-items: center; gap: 8px; background: var(--bg-secondary); color: var(--text-primary);\n  border: 1px solid var(--border); border-radius: 999px; padding: 13px 24px; font-weight: 700; font-size: 0.9rem; cursor: pointer;\n}\n.about-btn-outline:hover { border-color: var(--success); color: var(--success); }\n\n.about-hero-visual { position: relative; display: flex; justify-content: center; padding: 20px; }\n.about-hero-img-wrap {\n  width: 320px; height: 320px; border-radius: 50%; overflow: hidden; flex-shrink: 0;\n  box-shadow: 0 20px 60px color-mix(in srgb, var(--success) 18%, transparent); border: 6px solid color-mix(in srgb, var(--success) 10%, transparent);\n}\n.about-hero-img { width: 100%; height: 100%; object-fit: cover; object-position: 50% 18%; display: block; }\n\n.about-float-card {\n  position: absolute; display: flex; align-items: center; gap: 10px; background: var(--bg-secondary);\n  border: 1px solid var(--border); border-radius: 14px; padding: 10px 14px; box-shadow: var(--shadow-card);\n  font-size: 0.72rem; max-width: 160px;\n}\n.about-float-card strong { display: block; font-size: 0.92rem; color: var(--text-primary); }\n.about-float-title { margin: 0; color: var(--text-muted); font-size: 0.66rem; text-transform: uppercase; letter-spacing: 0.03em; }\n.about-float-card span:not(.about-float-title) { color: var(--text-secondary); }\n.about-float-icon {\n  flex-shrink: 0; width: 30px; height: 30px; border-radius: 50%; display: inline-flex; align-items: center;\n  justify-content: center; background: color-mix(in srgb, var(--success) 12%, transparent); color: var(--success);\n}\n.about-float-1 { top: 6%; left: -4%; }\n.about-float-2 { top: 6%; right: -4%; }\n.about-float-3 { bottom: 22%; left: -8%; }\n.about-float-4 { bottom: 8%; right: -6%; }\n@media (max-width: 900px) {\n  .about-hero-img-wrap { width: 240px; height: 240px; }\n  .about-float-card { position: static; max-width: none; margin: 6px; }\n  .about-hero-visual { flex-wrap: wrap; gap: 10px; }\n}\n\n/* ── Stats strip ──────────────────────────────────────────── */\n.about-stats {\n  display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; background: color-mix(in srgb, var(--success) 6%, transparent);\n  border-radius: var(--radius-lg); padding: 32px 24px;\n}\n@media (max-width: 640px) { .about-stats { grid-template-columns: repeat(2, 1fr); } }\n.about-stat { text-align: center; }\n.about-stat-icon {\n  display: inline-flex; align-items: center; justify-content: center; width: 44px; height: 44px; border-radius: 50%;\n  background: var(--bg-secondary); border: 1px solid color-mix(in srgb, var(--success) 25%, transparent); color: var(--success); margin-bottom: 10px;\n}\n.about-stat-value { font-size: 1.5rem; font-weight: 800; color: var(--success); margin: 0; }\n.about-stat-label { font-size: 0.8rem; color: var(--text-secondary); margin: 2px 0 0; }\n\n/* ── Why We Exist ─────────────────────────────────────────── */\n.about-why { text-align: center; }\n.about-section-title { font-size: 1.6rem; font-weight: 800; color: var(--text-primary); margin: 0 0 12px; }\n.about-section-sub { font-size: 0.92rem; color: var(--text-secondary); max-width: 560px; margin: 0 auto; line-height: 1.6; }\n.about-value-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-top: 36px; text-align: left; }\n@media (max-width: 800px) { .about-value-grid { grid-template-columns: 1fr; } }\n.about-value-card { background: var(--bg-secondary); border: 1px solid var(--border); border-radius: var(--radius-md); padding: 22px 20px; }\n.about-value-icon {\n  display: inline-flex; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 12px;\n  background: color-mix(in srgb, var(--success) 10%, transparent); color: var(--success); margin-bottom: 14px;\n}\n.about-value-title { font-size: 1rem; font-weight: 700; color: var(--text-primary); margin: 0 0 6px; }\n.about-value-text { font-size: 0.85rem; color: var(--text-secondary); line-height: 1.6; margin: 0; }\n\n/* ── Vision ───────────────────────────────────────────────── */\n.about-vision {\n  display: grid; grid-template-columns: 0.9fr 1.1fr; gap: 40px; align-items: center; background: color-mix(in srgb, var(--success) 6%, transparent);\n  border-radius: var(--radius-lg); padding: 32px;\n}\n@media (max-width: 900px) { .about-vision { grid-template-columns: 1fr; padding: 24px; } }\n.about-vision-img-wrap { border-radius: var(--radius-lg); overflow: hidden; aspect-ratio: 4/3; }\n.about-vision-img { width: 100%; height: 100%; object-fit: cover; object-position: 50% 15%; display: block; }\n.about-vision-items { display: flex; flex-wrap: wrap; gap: 24px; margin-top: 8px; }\n.about-vision-item { flex: 1 1 140px; }\n.about-vision-icon {\n  display: inline-flex; align-items: center; justify-content: center; width: 34px; height: 34px; border-radius: 50%;\n  background: color-mix(in srgb, var(--success) 12%, transparent); color: var(--success); margin-bottom: 8px;\n}\n.about-vision-item-title { font-size: 0.88rem; font-weight: 700; color: var(--text-primary); margin: 0 0 2px; }\n.about-vision-item-text { font-size: 0.78rem; color: var(--text-secondary); margin: 0; }\n\n/* ── Bottom CTA banner ────────────────────────────────────── */\n.about-cta {\n  display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 20px;\n  background: linear-gradient(135deg, var(--success), var(--color-secondary)); border-radius: var(--radius-lg); padding: 32px 36px; color: var(--color-brand-white);\n}\n.about-cta-icon {\n  width: 48px; height: 48px; border-radius: 14px; background: rgba(255,255,255,0.15); display: inline-flex;\n  align-items: center; justify-content: center; flex-shrink: 0;\n}\n.about-cta-copy { flex: 1; min-width: 220px; }\n.about-cta-title { font-size: 1.2rem; font-weight: 800; margin: 0 0 4px; }\n.about-cta-sub { font-size: 0.9rem; margin: 0; opacity: 0.9; }\n.about-cta-actions { display: flex; flex-wrap: wrap; gap: 12px; }\n.about-btn-white {\n  display: inline-flex; align-items: center; gap: 8px; background: var(--color-brand-white); color: var(--color-secondary); border: none;\n  border-radius: 999px; padding: 12px 22px; font-weight: 700; font-size: 0.88rem; cursor: pointer;\n}\n.about-btn-outline-white {\n  display: inline-flex; align-items: center; gap: 8px; background: transparent; color: var(--color-brand-white);\n  border: 1px solid rgba(255,255,255,0.5); border-radius: 999px; padding: 12px 22px; font-weight: 700; font-size: 0.88rem; cursor: pointer;\n}\n.about-btn-outline-white:hover { background: rgba(255,255,255,0.12); }\n\n/* ── Brands (seller directory) page ──────────────────────────────────── */\n.brands-search-box {\n  display: flex; align-items: center; gap: 8px;\n  background: var(--bg-secondary); border: 1px solid var(--border); border-radius: var(--radius-md);\n  padding: 10px 14px; color: var(--text-muted); margin-bottom: 24px;\n}\n.brands-search-box input { flex: 1; border: none; background: none; outline: none; font-size: 0.88rem; color: var(--text-primary); }\n.brands-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 14px; }\n.brands-card {\n  display: flex; flex-direction: column; align-items: flex-start; gap: 6px; text-align: left;\n  background: var(--bg-secondary); border: 1px solid var(--border); border-radius: var(--radius-md);\n  padding: 18px 16px; cursor: pointer;\n}\n.brands-card:hover { border-color: var(--accent); }\n.brands-card-logo { font-size: 1.8rem; line-height: 1; margin-bottom: 4px; }\n.brands-card-name { font-size: 0.98rem; font-weight: 700; color: var(--text-primary); }\n.brands-card-tagline { font-size: 0.8rem; color: var(--text-secondary); }\n.brands-card-meta { display: flex; align-items: center; gap: 10px; font-size: 0.78rem; color: var(--text-muted); margin-top: 4px; flex-wrap: wrap; }\n.brands-card-meta span { display: inline-flex; align-items: center; gap: 4px; }\n\n/* Admin Settings: compact, visible cards that use the available canvas. */\n.admin-settings-module {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 14px;\n  align-items: start;\n  width: 100%;\n  min-width: 0;\n}\n\n.admin-settings-module .admin-settings-heading {\n  grid-column: 1 / -1;\n  margin: 0 0 2px;\n  color: var(--text-primary);\n  font-size: 18px;\n  font-weight: 750;\n}\n\n.admin-settings-module .admin-settings-card {\n  width: 100%;\n  max-width: none !important;\n  min-width: 0;\n  margin: 0;\n  padding: 16px 18px;\n  border: 1.5px solid color-mix(in srgb, var(--accent) 46%, var(--border));\n  border-radius: 13px;\n  box-sizing: border-box;\n}\n\n.admin-settings-module .admin-settings-card:hover { border-color: var(--accent); }\n.admin-settings-module .admin-settings-account-card { grid-column: 1 / -1; }\n.admin-settings-module .admin-form-header { margin-bottom: 13px; }\n.admin-settings-module .admin-form-title {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  margin: 0;\n  font-size: 17px;\n}\n\n.admin-settings-module .admin-settings-card-icon {\n  width: 35px;\n  height: 35px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 35px;\n  color: var(--accent);\n  background: color-mix(in srgb, var(--accent) 12%, transparent);\n  border-radius: 9px;\n}\n\n.admin-settings-module .si-field-grid { gap: 11px 12px; }\n.admin-settings-module .si-field { gap: 4px; }\n.admin-settings-module .si-label { color: var(--text-primary); font-size: 12px; }\n.admin-settings-module .si-input {\n  min-height: 40px;\n  padding: 7px 11px;\n  border: 1.5px solid var(--accent);\n  border-radius: 9px;\n  background: var(--bg-primary);\n}\n.admin-settings-module .si-input:hover { border-color: var(--accent-hover, var(--accent)); }\n.admin-settings-module .si-input:focus {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent) 16%, transparent);\n}\n\n.admin-settings-module .admin-settings-invoice-preview {\n  border: 1px solid color-mix(in srgb, var(--accent) 35%, var(--border));\n}\n.admin-settings-module .dmp-map-box {\n  min-height: 220px;\n  height: 250px;\n  border-color: var(--accent);\n  border-radius: 10px;\n}\n.admin-settings-module .dmp-locate-btn {\n  min-height: 38px;\n  padding: 8px 13px;\n  color: var(--accent);\n  border-color: var(--accent);\n}\n\n.admin-settings-module .admin-settings-primary-btn {\n  min-height: 40px;\n  padding: 8px 16px !important;\n  background: var(--accent) !important;\n  color: var(--color-brand-white) !important;\n  border: 1px solid var(--accent) !important;\n  border-radius: 8px !important;\n  font-size: 13px !important;\n}\n.admin-settings-module .admin-settings-primary-btn:hover:not(:disabled) {\n  background: var(--accent-hover, var(--accent)) !important;\n  border-color: var(--accent-hover, var(--accent)) !important;\n}\n\n.admin-settings-module .admin-settings-account-card .si-field-grid {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n.admin-settings-module .admin-settings-account-card .si-field-full { grid-column: span 1; }\n\n@media (max-width: 1100px) {\n  .admin-settings-module { grid-template-columns: minmax(0, 1fr); }\n  .admin-settings-module .admin-settings-heading,\n  .admin-settings-module .admin-settings-account-card { grid-column: 1; }\n}\n\n@media (max-width: 760px) {\n  .admin-settings-module .admin-settings-account-card .si-field-grid { grid-template-columns: minmax(0, 1fr); }\n  .admin-settings-module .admin-settings-account-card .si-field-full { grid-column: 1; }\n}\n\n@media (max-width: 640px) {\n  .admin-settings-module .admin-settings-card { padding: 14px; }\n  .admin-settings-module .dmp-map-box { height: 220px; }\n}\n\n/* Returns module: clear hierarchy, guarded content, responsive details. */\n.admin-returns-module {\n  width: 100%;\n  min-width: 0;\n}\n\n.admin-returns-module .dsp-header {\n  display: none;\n}\n\n.admin-returns-module .dsp-header h2 {\n  font-size: 22px;\n}\n\n/* Module titles live in .admin-page-header; body cards start with content. */\n.admin-section > .dsp-header,\n.admin-settings-module > .admin-settings-heading {\n  display: none;\n}\n\n.admin-header-module-tools {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 8px;\n  min-width: 0;\n}\n\n.admin-header-search {\n  width: clamp(190px, 20vw, 285px);\n  min-height: 38px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 11px;\n  color: var(--text-muted);\n  background: var(--bg-primary);\n  border: 1.5px solid var(--accent);\n  border-radius: 9px;\n  box-sizing: border-box;\n}\n\n.admin-header-search input {\n  width: 100%;\n  min-width: 0;\n  padding: 0;\n  color: var(--text-primary);\n  background: transparent;\n  border: 0;\n  outline: 0;\n  font: inherit;\n  font-size: 13px;\n}\n\n.admin-header-module-tools .dsp-toolbar-btn {\n  min-height: 38px;\n  border-color: color-mix(in srgb, var(--accent) 55%, var(--border));\n  background: var(--bg-primary);\n  white-space: nowrap;\n}\n\n.admin-header-module-tools .dsp-toolbar-btn:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.admin-header-module-tools .dsp-popover {\n  z-index: 120;\n}\n\n@media (max-width: 1180px) {\n  .admin-page-header:has(.admin-header-module-tools) > div:first-child {\n    flex: 1 1 100%;\n  }\n\n  .admin-page-header:has(.admin-header-module-tools) .admin-header-actions {\n    width: 100%;\n  }\n\n  .admin-header-module-tools {\n    flex: 1 1 auto;\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 700px) {\n  .admin-header-search {\n    width: 100%;\n  }\n\n  .admin-header-module-tools {\n    width: 100%;\n  }\n}\n\n.admin-returns-module .ret-filter-bar {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 7px;\n  margin-bottom: 14px;\n  padding: 10px;\n  background: var(--bg-secondary);\n  border: 1.5px solid color-mix(in srgb, var(--accent) 42%, var(--border));\n  border-radius: 12px;\n}\n\n.admin-returns-module .ret-filter-btn {\n  min-height: 32px;\n  padding: 5px 11px !important;\n  border-radius: 999px !important;\n  background-color: var(--bg-primary);\n  line-height: 1.2;\n  white-space: nowrap;\n  transition: border-color 150ms ease, background-color 150ms ease, transform 150ms ease;\n}\n\n.admin-returns-module .ret-filter-btn:hover {\n  border-color: var(--accent) !important;\n  transform: translateY(-1px);\n}\n\n.admin-returns-module .ret-layout,\n.admin-returns-module .ret-list {\n  width: 100%;\n  min-width: 0;\n}\n\n.admin-returns-module .ret-layout--split {\n  grid-template-columns: minmax(0, 1fr) minmax(310px, 360px);\n  gap: 14px;\n}\n\n.admin-returns-module .ret-card {\n  min-width: 0;\n  padding: 13px 15px;\n  border-color: color-mix(in srgb, var(--accent) 42%, var(--border));\n  background: var(--bg-secondary);\n  box-sizing: border-box;\n}\n\n.admin-returns-module .ret-card:hover,\n.admin-returns-module .ret-card--selected {\n  border-color: var(--accent);\n}\n\n.admin-returns-module .ret-card-badges {\n  gap: 7px;\n  margin-bottom: 10px;\n}\n\n.admin-returns-module .ret-card-badges > span:nth-last-child(2) {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.admin-returns-module .ret-card-grid {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 10px;\n  padding-bottom: 10px;\n}\n\n.admin-returns-module .ret-layout--split .ret-card-grid {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.admin-returns-module .ret-card-grid > div,\n.admin-returns-module .ret-refund-panel-grid > div {\n  min-width: 0;\n}\n\n.admin-returns-module .ret-card-value,\n.admin-returns-module .ret-card-sub {\n  overflow-wrap: anywhere;\n  line-height: 1.3;\n}\n\n.admin-returns-module .ret-refund-panel {\n  border-color: color-mix(in srgb, var(--accent) 32%, var(--border));\n}\n\n.admin-returns-module .ret-exchange-panel {\n  flex-wrap: wrap;\n}\n\n.admin-returns-module .ret-tracking-input {\n  min-height: 34px;\n  border: 1.5px solid var(--accent);\n}\n\n.admin-returns-module .ret-card-actions {\n  gap: 6px;\n  margin-top: 10px;\n}\n\n.admin-returns-module .ret-action-btn {\n  min-height: 34px;\n  padding: 6px 10px;\n  border-color: color-mix(in srgb, var(--accent) 45%, var(--border));\n}\n\n.admin-returns-module .ret-action-btn--primary {\n  background: var(--accent);\n  border-color: var(--accent);\n}\n\n.admin-returns-module .ret-action-btn--danger,\n.admin-returns-module .ret-action-btn--danger:hover:not(:disabled) {\n  color: var(--color-text-on-primary);\n  background: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n/* Commission, tax and currency cards: compact and consistently aligned. */\n.admin-commission-module .admin-ct-grid {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  align-items: stretch;\n  gap: 14px;\n  margin-bottom: 14px;\n}\n.admin-commission-module .admin-pf-section {\n  min-width: 0;\n  padding: 16px 18px;\n  gap: 12px;\n  margin-bottom: 14px;\n  border: 1.5px solid color-mix(in srgb, var(--pf-primary) 42%, var(--pf-divider));\n  border-radius: 13px;\n}\n.admin-commission-module .admin-ct-grid .admin-pf-section {\n  height: 100%;\n  margin-bottom: 0;\n  box-sizing: border-box;\n}\n.admin-commission-module .admin-pf-section-title { gap: 9px; font-size: 17px; }\n.admin-commission-module .admin-pf-section-icon { width: 36px; height: 36px; border-radius: 9px; }\n.admin-commission-module .admin-pf-section-icon svg { width: 17px; height: 17px; }\n.admin-commission-module .admin-ct-grid .admin-pf-section-sub { min-height: 42px; }\n.admin-commission-module .admin-pf-section-sub { font-size: 12px; line-height: 1.45; }\n.admin-commission-module .admin-pf-rate-panel {\n  min-height: 58px;\n  padding: 10px 13px;\n  border: 1px solid color-mix(in srgb, var(--pf-primary) 28%, var(--pf-divider));\n  box-sizing: border-box;\n}\n.admin-commission-module .admin-pf-rate-panel-label { font-size: 12px; }\n.admin-commission-module .admin-pf-rate-panel-value { font-size: 20px; }\n.admin-commission-module .admin-ct-grid form { margin-top: auto; }\n.admin-commission-module .admin-pf-field { gap: 5px; }\n.admin-commission-module .admin-pf-label { font-size: 12px; }\n.admin-commission-module .admin-pf-input,\n.admin-commission-module .admin-pf-price-wrap {\n  min-height: 40px;\n  height: 40px;\n  border-color: var(--pf-primary);\n  border-radius: 9px;\n  box-sizing: border-box;\n}\n.admin-commission-module .admin-pf-input { padding: 0 11px; font-size: 13px; }\n.admin-commission-module .admin-pf-price-wrap .admin-pf-input { height: 100%; min-height: 0; }\n.admin-commission-module .admin-pf-price-sym { width: 40px; flex-basis: 40px; font-size: 13px; }\n.admin-commission-module .admin-pf-input-row { align-items: center; gap: 8px; }\n.admin-commission-module .admin-pf-input-row .admin-pf-btn-publish,\n.admin-commission-module .admin-pf-input-row .admin-pf-btn-draft {\n  min-height: 40px;\n  padding: 7px 15px;\n  border-radius: 8px;\n}\n.admin-commission-module .admin-pf-hint { margin: 0; font-size: 11px; line-height: 1.35; }\n.admin-commission-module > .admin-pf-section form { gap: 11px !important; }\n\n@media (max-width: 900px) {\n  .admin-commission-module .admin-ct-grid { grid-template-columns: minmax(0, 1fr); }\n  .admin-commission-module .admin-ct-grid .admin-pf-section-sub { min-height: 0; }\n}\n@media (max-width: 520px) {\n  .admin-commission-module .admin-pf-section { padding: 14px; }\n  .admin-commission-module .admin-pf-input-row { align-items: stretch; flex-direction: column; }\n}\n\n.admin-returns-module .ret-sidebar {\n  min-width: 0;\n  padding: 15px;\n  border: 1.5px solid var(--accent);\n  border-radius: 12px;\n}\n\n.admin-returns-module .dsp-info-card {\n  min-width: 0;\n  border: 1px solid color-mix(in srgb, var(--accent) 30%, var(--border));\n}\n\n.admin-returns-module .dsp-detail-row > span:last-child {\n  min-width: 0;\n  overflow-wrap: anywhere;\n  text-align: right;\n}\n\n@media (max-width: 1120px) {\n  .admin-returns-module .ret-layout--split {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .admin-returns-module .ret-sidebar {\n    position: static;\n    max-height: none;\n  }\n}\n\n@media (max-width: 820px) {\n  .admin-returns-module .ret-card-grid,\n  .admin-returns-module .ret-layout--split .ret-card-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .admin-returns-module .ret-refund-panel-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 520px) {\n  .admin-returns-module .ret-filter-bar {\n    align-items: stretch;\n  }\n\n  .admin-returns-module .ret-filter-btn {\n    flex: 1 1 calc(50% - 7px);\n    white-space: normal;\n  }\n\n  .admin-returns-module .ret-card-grid,\n  .admin-returns-module .ret-layout--split .ret-card-grid,\n  .admin-returns-module .ret-refund-panel-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .admin-returns-module .ret-card-actions .ret-action-btn {\n    flex: 1 1 100%;\n  }\n}\n\n\n/* Coupon form controls: keep their boundaries clear on light backgrounds. */\n.cpn-section .cpn-input {\n  border: 1.5px solid var(--accent);\n  background: var(--bg-secondary);\n}\n\n.cpn-section .cpn-input:hover {\n  border-color: var(--accent-hover, var(--accent));\n}\n\n.cpn-section .cpn-input:focus {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent) 16%, transparent);\n}\n\n.cpn-section .cpn-input:disabled {\n  opacity: 1;\n  border-color: color-mix(in srgb, var(--accent) 42%, var(--border));\n  background: var(--bg-tertiary);\n  color: var(--text-muted);\n}\n\n.cpn-section .cpn-input-suffix {\n  border-left-color: var(--accent);\n}\n\n.cpn-section .cpn-options {\n  border: 1.5px solid var(--accent);\n  background: var(--bg-secondary);\n}\n\n.cpn-section .cpn-segment {\n  border: 1.5px solid var(--accent);\n}\n\n.cpn-section .cpn-options-row {\n  align-items: flex-start;\n}\n\n.cpn-section .cpn-options-row .cpn-submit {\n  margin-top: 23px;\n  margin-left: auto;\n  align-self: flex-start;\n}\n\n@media (max-width: 700px) {\n  .cpn-section .cpn-options-row .cpn-submit {\n    width: 100%;\n    margin-top: 4px;\n    justify-content: center;\n  }\n}\n\n/* Keep every coupon column and action inside the All Coupons card. */\n.cpn-section .cpn-table-wrap {\n  width: 100%;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.cpn-section .cpn-table-header,\n.cpn-section .cpn-row {\n  min-width: 0;\n  grid-template-columns:\n    minmax(84px, 1.05fr)\n    minmax(78px, 0.9fr)\n    minmax(82px, 0.9fr)\n    minmax(70px, 0.75fr)\n    minmax(66px, 0.7fr)\n    minmax(82px, 0.9fr)\n    minmax(78px, 0.85fr)\n    minmax(196px, 1.55fr);\n  gap: 8px;\n  padding-left: 12px;\n  padding-right: 12px;\n}\n\n.cpn-section .cpn-table-header > *,\n.cpn-section .cpn-row > * {\n  min-width: 0;\n}\n\n.cpn-section .cpn-actions {\n  justify-content: flex-start;\n  flex-wrap: nowrap;\n  gap: 5px;\n}\n\n.cpn-section .cpn-act {\n  min-width: 0;\n  padding: 6px 8px;\n  white-space: nowrap;\n}\n\n@media (max-width: 900px) {\n  .cpn-section .cpn-table-header {\n    display: none;\n  }\n\n  .cpn-section .cpn-row {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 10px 16px;\n    padding: 14px;\n  }\n\n  .cpn-section .cpn-actions {\n    grid-column: 1 / -1;\n    flex-wrap: wrap;\n    padding-top: 2px;\n  }\n}\n\n@media (max-width: 520px) {\n  .cpn-section .cpn-row {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .cpn-section .cpn-actions {\n    grid-column: 1;\n  }\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n   Destructive confirmation dialog\n\n   Replaces the old inline \"Sure? Yes / No\" that expanded inside the row it\n   belonged to. That pattern had two problems: it reflowed the card as you\n   read it (the row grew, everything below jumped), and its two buttons were\n   built from unrelated classes -- `btn danger` and `btn-admin-edit` -- so\n   they disagreed on border, padding, radius and font size. The pair now\n   shares one class and differs only in hue.\n\n   Uses the scoped --color-confirm-* tokens; see their note at the top of\n   this file for why red/green are permitted here and nowhere else.\n   ════════════════════════════════════════════════════════════════════════ */\n.confirm-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: rgba(1, 13, 33, 0.55);\n  -webkit-backdrop-filter: blur(6px);\n  backdrop-filter: blur(6px);\n  animation: confirm-overlay-in 160ms ease-out;\n}\n\n.confirm-dialog {\n  width: 100%;\n  max-width: 440px;\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: 18px;\n  padding: 28px;\n  box-shadow: 0 28px 80px rgba(1, 13, 33, 0.32);\n  animation: confirm-dialog-in 200ms cubic-bezier(0.16, 1, 0.3, 1);\n  text-align: center;\n}\n\n@keyframes confirm-overlay-in {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n@keyframes confirm-dialog-in {\n  from { opacity: 0; transform: translateY(12px) scale(0.97); }\n  to   { opacity: 1; transform: none; }\n}\n\n/* Respect a reduced-motion preference: the dialog still appears, it just\n   doesn't travel. */\n@media (prefers-reduced-motion: reduce) {\n  .confirm-overlay,\n  .confirm-dialog { animation: none; }\n}\n\n/* The icon is what carries \"this is destructive\" for anyone who can't\n   separate the two hues -- it is not decorative. */\n.confirm-dialog-icon {\n  width: 52px;\n  height: 52px;\n  margin: 0 auto 18px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--color-confirm-danger-soft);\n  color: var(--color-confirm-danger);\n}\n\n.confirm-dialog-title {\n  margin: 0 0 8px;\n  font-size: 1.12rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--text-primary);\n}\n\n.confirm-dialog-message {\n  margin: 0 0 26px;\n  font-size: 0.9rem;\n  line-height: 1.55;\n  color: var(--text-secondary);\n}\n\n/* Quotes the name of the thing being deleted, so the dialog says what it is\n   about to destroy rather than \"this item\". */\n.confirm-dialog-subject {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.confirm-dialog-actions {\n  display: flex;\n  gap: 12px;\n}\n\n/* One class for both buttons. Everything geometric lives here so the pair\n   can never drift apart again; the modifiers below set colour only. */\n.confirm-btn {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 44px;\n  padding: 12px 18px;\n  border: 1.5px solid transparent;\n  border-radius: var(--radius-sm);\n  font-family: inherit;\n  font-size: 0.9rem;\n  font-weight: 700;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 150ms ease, border-color 150ms ease, transform 120ms ease;\n}\n\n.confirm-btn:active { transform: translateY(1px); }\n\n.confirm-btn:focus-visible {\n  outline: 2px solid var(--color-focus-ring);\n  outline-offset: 2px;\n}\n\n.confirm-btn-cancel {\n  background: var(--color-confirm-safe);\n  border-color: var(--color-confirm-safe);\n  color: var(--color-confirm-on-fill);\n}\n\n.confirm-btn-cancel:hover {\n  background: var(--color-confirm-safe-hover);\n  border-color: var(--color-confirm-safe-hover);\n}\n\n.confirm-btn-danger {\n  background: var(--color-confirm-danger);\n  border-color: var(--color-confirm-danger);\n  color: var(--color-confirm-on-fill);\n}\n\n.confirm-btn-danger:hover {\n  background: var(--color-confirm-danger-hover);\n  border-color: var(--color-confirm-danger-hover);\n}\n\n@media (max-width: 420px) {\n  .confirm-dialog { padding: 24px 20px; }\n  /* Stack reversed so the safe option sits under the thumb. */\n  .confirm-dialog-actions { flex-direction: column-reverse; }\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n   Admin chrome polish\n\n   Additive and scoped to admin surfaces. Nothing here introduces a colour:\n   every value is an existing brand token, a transparency of one, or a\n   geometry change. The goal is that the dashboard reads as one considered\n   system rather than a set of screens built at different times.\n\n   Four things were inconsistent across the admin screens:\n     1. Row action buttons disagreed on height, radius and transition, so a\n        row of Edit / Hide / Delete sat on three different baselines.\n     2. Focus styling was inherited from the browser in most places, which\n        is the most visible \"unfinished\" tell on an internal tool.\n     3. Elevation was a single flat shadow, so cards read as stickers on the\n        page rather than surfaces above it.\n     4. Headings used default tracking, which looks loose at large sizes.\n   ════════════════════════════════════════════════════════════════════════ */\n\n/* ── 1. One geometry for every row action ──────────────────────────────── */\n.admin-banner-action,\n.cpn-act,\n.btn-admin-edit,\n.admin-product-delete-btn {\n  min-height: 34px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  border-radius: 10px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  line-height: 1;\n  white-space: nowrap;\n  /* Transform is included so the press feedback below is smooth, and the\n     shorthand replaces three separate per-class transition declarations\n     that had drifted to different durations. */\n  transition: background 160ms ease, border-color 160ms ease, color 160ms ease,\n              transform 120ms ease, box-shadow 160ms ease;\n}\n\n/* A press should feel mechanical. 1px is enough to register and small\n   enough not to disturb the row. */\n.admin-banner-action:active,\n.cpn-act:active,\n.btn-admin-edit:active,\n.admin-product-delete-btn:active {\n  transform: translateY(1px);\n}\n\n/* ── 2. A single, visible focus treatment ──────────────────────────────── */\n/* :focus-visible rather than :focus, so a mouse click doesn't leave a ring\n   behind but keyboard navigation is always obvious. */\n.admin-banner-action:focus-visible,\n.cpn-act:focus-visible,\n.btn-admin-edit:focus-visible,\n.admin-product-delete-btn:focus-visible,\n.cpn-segment button:focus-visible,\n.cpn-submit:focus-visible,\n.admin-page-btn:focus-visible {\n  outline: 2px solid var(--color-focus-ring);\n  outline-offset: 2px;\n}\n\n/* ── 3. Layered elevation ──────────────────────────────────────────────── */\n/* Two shadows instead of one: a tight contact shadow that anchors the card\n   to the page, plus a wider, softer ambient shadow. A single blurred shadow\n   reads as a halo; the pair reads as depth. */\n.admin-content .cpn-card,\n.admin-content .admin-banner-editor-compact {\n  box-shadow:\n    0 1px 2px rgba(1, 13, 33, 0.05),\n    0 8px 24px -12px rgba(1, 13, 33, 0.18);\n  transition: box-shadow 220ms ease, border-color 220ms ease;\n}\n\n.admin-content .cpn-card:hover,\n.admin-content .admin-banner-editor-compact:hover {\n  box-shadow:\n    0 1px 2px rgba(1, 13, 33, 0.06),\n    0 16px 40px -16px rgba(1, 13, 33, 0.24);\n}\n\n/* On the navy canvas a drop shadow is nearly invisible, so depth comes from\n   a light hairline along the top edge instead: the same trick a physical\n   bevel uses, and it survives against a dark background where a shadow\n   does not. */\n[data-theme=\"dark\"] .admin-content .cpn-card,\n[data-theme=\"dark\"] .admin-content .admin-banner-editor-compact {\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.05),\n    0 12px 32px -16px rgba(0, 0, 0, 0.6);\n}\n\n/* ── 4. Heading tracking ───────────────────────────────────────────────── */\n/* Type set at display sizes looks loose at default tracking. Tightening\n   slightly is one of the cheapest ways to make an interface read as\n   deliberate; the effect is invisible individually and obvious in\n   aggregate. Body text is left alone, where tight tracking hurts. */\n.admin-page-title,\n.admin-section h2,\n.cpn-card-title,\n.confirm-dialog-title {\n  letter-spacing: -0.015em;\n}\n\n/* ── 5. Row hover ──────────────────────────────────────────────────────── */\n/* The banner and coupon lists are scannable rows; a hover tint makes the\n   row you are about to act on unambiguous, which matters when the action\n   at the end of it is Delete. */\n.admin-content .cpn-row-item:hover,\n.admin-content .admin-banner-row:hover {\n  background: var(--color-surface-hover);\n}\n\n/* ── 6. Respect reduced motion ─────────────────────────────────────────── */\n@media (prefers-reduced-motion: reduce) {\n  .admin-banner-action,\n  .cpn-act,\n  .btn-admin-edit,\n  .admin-product-delete-btn,\n  .admin-content .cpn-card,\n  .admin-content .admin-banner-editor-compact {\n    transition: none;\n  }\n  .admin-banner-action:active,\n  .cpn-act:active,\n  .btn-admin-edit:active,\n  .admin-product-delete-btn:active {\n    transform: none;\n  }\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n   Checkout redesign (steps 2 and 3)\n\n   Shared vocabulary for both checkout screens, so the two steps read as one\n   flow rather than two pages that happen to follow each other:\n\n     .co-panel            a titled card, the unit both columns are built from\n     .co-field-label      the small bold label above a control group\n     .co-protection-note  the blue reassurance strip above each CTA\n     .co-under-cta        the quiet line under a CTA saying what happens next\n\n   Every colour here is a brand token or a transparency of one.\n   ════════════════════════════════════════════════════════════════════════ */\n\n/* ── Trust bar ─────────────────────────────────────────────────────────────\n   Sits above the header and is navy in BOTH themes, so its text uses\n   --color-on-navy*, which never flips, rather than --text-*, which is navy in\n   light mode and would disappear here. */\n.checkout-trustbar {\n  background: var(--color-brand-navy);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.checkout-trustbar-inner {\n  width: min(1120px, calc(100% - 32px));\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: clamp(18px, 6vw, 72px);\n  padding: 10px 0;\n}\n\n.ctb-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  color: var(--color-on-navy);\n  white-space: nowrap;\n}\n\n.ctb-item svg {\n  color: var(--color-on-navy-secondary);\n  flex-shrink: 0;\n}\n\n/* Below ~640px three items no longer fit on one line. Dropping the third\n   keeps the bar to a single row rather than letting it wrap into a block that\n   pushes the header down the page. */\n@media (max-width: 640px) {\n  .checkout-trustbar-inner { gap: 20px; padding: 8px 0; }\n  .ctb-item { font-size: 0.74rem; }\n  .ctb-item:last-child { display: none; }\n}\n\n/* ── Panels ───────────────────────────────────────────────────────────── */\n.co-panel {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 1px 2px rgba(1, 13, 33, 0.04), 0 10px 30px -18px rgba(1, 13, 33, 0.2);\n}\n\n[data-theme=\"dark\"] .co-panel {\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04), 0 12px 32px -18px rgba(0, 0, 0, 0.6);\n}\n\n.co-panel-title {\n  margin: 0 0 18px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid var(--color-border);\n  font-size: 1.05rem;\n  font-weight: 700;\n  letter-spacing: -0.015em;\n  color: var(--text-primary);\n}\n\n.co-field-label {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin: 0 0 10px;\n  font-size: 0.86rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.co-optional {\n  font-weight: 400;\n  color: var(--text-muted);\n  font-size: 0.8rem;\n}\n\n/* ── Mobile money number ──────────────────────────────────────────────────\n   Shown under the online-payment card once it is selected. The prompt goes to\n   whatever number is typed here, which is often not the delivery number, so\n   the field has to be visible rather than assumed.\n\n   Blue for the focus ring, not orange: this is secondary interaction, and\n   orange is reserved for the commercial action -- the Place Order button sits\n   directly below and must stay the only orange thing in view. */\n.payment-method-phone {\n  margin: 12px 0 2px;\n  padding: 14px;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  background: var(--bg-secondary);\n}\n\n.co-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 11px 13px;\n  font: inherit;\n  font-size: 0.94rem;\n  color: var(--text-primary);\n  background: var(--bg-primary);\n  border: 1.5px solid var(--border);\n  border-radius: 10px;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.co-input::placeholder { color: var(--text-muted); }\n\n.co-input:focus {\n  outline: none;\n  border-color: var(--color-secondary);\n  box-shadow: 0 0 0 3px var(--color-secondary-soft);\n}\n\n/* Keyboard users get the same ring the mouse path gets -- :focus above is\n   removed from the outline, so this must not rely on the browser default. */\n.co-input:focus-visible {\n  outline: 2px solid var(--color-secondary);\n  outline-offset: 1px;\n}\n\n.co-field-hint {\n  margin: 8px 0 0;\n  font-size: 0.78rem;\n  line-height: 1.45;\n  color: var(--text-muted);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .co-input { transition: none; }\n}\n\n/* ── Selected payment method ──────────────────────────────────────────────\n   Cash on delivery is the only method, so this confirms rather than chooses.\n   It still carries a radio and a chip: without them the card is just a\n   paragraph, and nothing signals that a payment method has been settled. */\n/* The two selectable methods, shown only when online payment is on.\n   Deliberately the same geometry as .co-selected below, so choosing one\n   changes its colour and its marker and nothing else -- carrying the base\n   card's 2px border and 18px/20px padding, the chosen card visibly jumped as\n   it was picked.\n\n   Declared ABOVE .co-selected on purpose: a chosen card carries both classes,\n   the two selectors are the same specificity (0,2,0), and source order is the\n   only thing that decides which colours win. */\n.payment-method-card.co-choice {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  border: 1.5px solid var(--border);\n  background: var(--bg-secondary);\n  border-radius: 14px;\n  padding: 16px 18px;\n}\n\n/* flex-wrap is the same insurance the mobile layer takes, and for the same\n   reason -- see the note on this pair in mobile/screens.css. There is far more\n   room here (a 589px card at 1280px against 314px on a phone), so nothing wraps\n   at any label length we have; it is here so that a long one degrades the same\n   way on both instead of only being handled on phones. */\n.payment-method-card.co-selected {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  border: 1.5px solid var(--color-secondary);\n  background: var(--color-secondary-soft);\n  border-radius: 14px;\n  padding: 16px 18px;\n}\n\n/* The method name. Takes the slack so the chip is pushed to the far edge\n   without needing a margin of its own, and min-width:0 lets it wrap on a word\n   boundary at the narrowest screens instead of holding the row open. */\n.co-selected-title {\n  flex: 1 1 auto;\n  min-width: 0;\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n/* Size only -- every marker in these cards, chosen or not. An 18px ring beside\n   a 1rem title read as an unticked checkbox rather than a radio. */\n.payment-method-card.co-selected .co-radio,\n.payment-method-card.co-choice .co-radio {\n  width: 26px;\n  height: 26px;\n  min-width: 26px;\n  margin-top: 0;\n  align-self: center;\n}\n\n/* The filled disc is for the chosen one ONLY. Scoped to .co-radio-on rather\n   than to the card, because in the chooser an unchosen card also has a marker\n   and it must stay a hollow ring -- filling both is what would turn a choice\n   into two identical ticks. */\n.payment-method-card.co-selected .co-radio-on,\n.payment-method-card.co-choice .co-radio-on {\n  border: none;\n  background: var(--color-secondary);\n}\n\n/* The check: two sides of a box, rotated. The base rule draws a centred dot\n   here (inset:3px, a 50% radius and a fill), so each of those is reset rather\n   than overridden piecemeal -- inset:auto has to come first, or the top/left\n   below it would be the thing that gets ignored. */\n.payment-method-card.co-selected .co-radio-on::after,\n.payment-method-card.co-choice .co-radio-on::after {\n  content: \"\";\n  position: absolute;\n  inset: auto;\n  top: 5px;\n  left: 9px;\n  width: 5px;\n  height: 10px;\n  border: solid var(--color-text-on-secondary);\n  border-width: 0 2px 2px 0;\n  border-radius: 0;\n  background: none;\n  transform: rotate(45deg);\n}\n\n.co-radio {\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  margin-top: 2px;\n  border-radius: 50%;\n  border: 2px solid var(--color-secondary);\n  display: inline-block;\n  position: relative;\n}\n\n.co-radio-on::after {\n  content: \"\";\n  position: absolute;\n  inset: 3px;\n  border-radius: 50%;\n  background: var(--color-secondary);\n}\n\n.co-selected-chip {\n  flex-shrink: 0;\n  align-self: center;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  border: 1px solid var(--color-secondary);\n  background: var(--color-surface);\n  color: var(--color-secondary-text);\n  font-size: 0.76rem;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n/* The phone-width rules that used to live here -- wrapping the row, giving\n   the copy column a 190px flex-basis, dropping the chip onto its own line --\n   are gone with the blurb they existed for. The card is now a marker, a short\n   title and a chip: at 320px that is roughly 236px of content, so there is\n   nothing left to wrap and no width for the chip to steal.\n\n   The .co-cod-features block (three icon-and-label reassurances, app only)\n   went at the same time. Worth recording why rather than just deleting it: as\n   a fourth child it landed in the first column of the mobile layer's\n   three-column grid, sized that `auto` track to its own width, and left the\n   copy track -- minmax(0, 1fr) -- at exactly zero, which set the title one\n   character per line down an 816px-tall card. */\n\n/* ── Checkout runs to the screen edge on mobile ───────────────────────────\n   Two nested paddings stood between the cards and the glass: .checkout-step-pad\n   contributes 20px a side and .checkout-container another 30px, so on a 390px\n   screen the cards had 290px to work with and every long label inside them --\n   the coupon placeholder, \"Amount Payable on Delivery\" -- was wrapping or\n   truncating for want of room that the gutters were holding.\n\n   Those gutters are a desktop device: they stop an 800px column from touching\n   a 1400px viewport. On a phone the viewport *is* the column, so the padding\n   buys nothing and costs 100px of every row.\n\n   Going full-bleed means the panels also drop the chrome that only reads\n   correctly when a card floats: side borders, corner radius, and the outer\n   container's shadow. Horizontal rules between stacked panels do the\n   separating instead, which is what a phone list wants anyway. Vertical\n   padding is untouched -- this is about width, not density. */\nhtml.m-app .checkout-step-pad {\n  padding-left: 0;\n  padding-right: 0;\n}\n\nhtml.m-app .checkout-container,\nhtml.m-app .order-summary-container {\n  width: 100%;\n  max-width: none;\n  padding-left: 0;\n  padding-right: 0;\n  border-left: 0;\n  border-right: 0;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n/* The two-column variant sets width: min(1120px, calc(100% - 32px)), which is\n   a *width* constraint rather than padding and so survived zeroing the paddings\n   above -- it was the last 16px a side. Matched with the :has() included so\n   this outranks it on specificity instead of relying on source order, which\n   is what the plain rule above lost on. */\nhtml.m-app .checkout-container:has(.checkout-side) {\n  width: 100%;\n  max-width: none;\n  gap: 0;\n}\n\n/* The panels themselves reach the edge. Each keeps a small inner padding so\n   text is never quite against the glass, and a top border replaces the boxed\n   look as the divider between one panel and the next.\n\n   18px, down from the 20-30px these carried. The panels going full-bleed only\n   moved the outer gutters; the inner padding was still holding content in by\n   that much again on each side.\n\n   14px was the first attempt and it read as content spilling off the screen --\n   text with almost nothing between it and the bezel has no margin for the\n   eye to rest against, and on a rounded display it looks like an overflow bug\n   rather than a layout choice. 18px keeps the width won by going full-bleed\n   while giving the text an edge to sit against. */\nhtml.m-app .co-panel,\nhtml.m-app .cod-order-recap,\nhtml.m-app .cod-address-recap,\nhtml.m-app .cod-payment-section,\nhtml.m-app .summary-left {\n  border-radius: 0;\n  border-left: 0;\n  border-right: 0;\n  box-shadow: none;\n  padding-left: 18px;\n  padding-right: 18px;\n}\n\n/* Nested cards inside those panels -- the selected payment method and the\n   \"N additional items\" row -- were each adding their own inset on top of the\n   panel's, so content sat ~32px from the edge behind two card borders. Kept\n   slightly tighter than the panel so the nesting still reads. */\nhtml.m-app .payment-method-card.co-selected,\nhtml.m-app .co-more-items {\n  padding-left: 14px;\n  padding-right: 14px;\n}\n\n/* ── Checkout type, corrected for the mobile layer's larger root ───────────\n   These are not layout bugs like the card above -- they are sizes that were\n   right at a 16px root and got carried up by the mobile layer's 18px one, so\n   they are pulled back wherever that root applies. That is now the app and\n   the phone browser alike; the desktop site is unaffected either way.\n\n   The coupon field is the clearest case: it sets Courier New with 0.08em of\n   extra tracking, so at 0.95rem it rendered 17.1px of monospace and the\n   placeholder was cut to \"Enter cou\". Monospace is much wider per character\n   than the sans everything else uses, which is why this one field broke while\n   the fields around it did not.\n\n   The summary total is the other: an 18.9px label beside a 21.2px amount in a\n   space-between row left the label wrapping onto three lines. Holding the\n   amount on one line keeps the wrapping in the label, where it reads. */\n/* ── Address block ────────────────────────────────────────────────────────\n   The heading and the Change button shared a row with the address itself, so\n   the button hung off the side of a four-line block and the whole thing sat\n   in a tinted box inside an already-bordered panel.\n\n   Change moves up beside \"Delivering to:\", which is the row it belongs to --\n   it acts on the address, it is not part of it. The address then reads as a\n   plain block with room to breathe, and one nested box disappears. */\n/* Change sits at the top-right of the address, on the same line as the name\n   it acts on, rather than stranded on its own row underneath four lines of\n   address. It is a control over the block, not another line of it.\n\n   Laid out on .address-display because that is where the button actually\n   lives in the markup -- it is a sibling of .address-info, not of the\n   heading, so placing it from .address-section (the first attempt) moved\n   nothing at all. */\nhtml.m-app .address-display {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: start;\n  column-gap: 10px;\n  padding: 12px 14px;\n  border-radius: 12px;\n  background: var(--color-surface-subtle);\n}\n\nhtml.m-app .address-info { grid-column: 1; min-width: 0; }\n\nhtml.m-app .co-change-btn {\n  grid-column: 2;\n  grid-row: 1;\n  align-self: start;\n  white-space: nowrap;\n}\n\n/* The address is four short lines; default paragraph spacing made it twice as\n   tall as it needed to be. */\nhtml.m-app .address-info p { margin: 0 0 3px; line-height: 1.45; }\nhtml.m-app .address-info p:last-child { margin-bottom: 0; }\n\n/* ── Coupon group gets its own room ───────────────────────────────────────\n   The panel flattens its sub-sections to plain groups (see the .co-panel\n   rules further down), which is right for the notes field but left the coupon\n   control sitting flush against the panel's own padding with nothing marking\n   it as a thing you interact with. A light surface and a little padding give\n   it back the space without reinstating the bordered card-in-a-card. */\nhtml.m-app .co-panel .coupon-section {\n  padding: 14px;\n  border-radius: 12px;\n  background: var(--color-surface-subtle);\n}\n\n/* ── Trust bar and the order-protection note, pulled in ───────────────────\n   The trust bar sizes itself with width: min(1120px, calc(100% - 32px)),\n   which put it at 16px a side while every panel below it sits at 18px -- a\n   two-pixel disagreement down the whole page. Matching them lines the top\n   strip up with the content it introduces.\n\n   The protection note was a full-width tinted bar carrying a sentence in\n   semibold: at that width it competed with the Place Order button directly\n   beneath it, when its job is to reassure quietly. Lighter weight, smaller\n   text and tighter padding put it back in a supporting role. */\nhtml.m-app .checkout-trustbar-inner {\n  width: 100%;\n  padding-left: 32px;\n  padding-right: 32px;\n  box-sizing: border-box;\n  gap: clamp(12px, 4vw, 32px);\n}\n\n/* ── The CTA and its two notes line up with the amount, not the panel ─────\n   These were already flush with the summary panel's outer edge at 18px. The\n   trouble is that the panel is not what the eye compares them to: the payable\n   total sits inside a tinted box with its own 14px of padding, so the figure\n   reads at 32px while a full-width button reads at 18px. Same panel, two\n   different left edges, and the button looks like it overhangs.\n\n   Matching the inner box puts the button, the protection note and the trust\n   strip on the same line as the number they refer to. 32px = the panel's 18\n   plus that box's 14. */\nhtml.m-app .btn-place-order,\nhtml.m-app .co-protection-note,\nhtml.m-app .co-under-cta {\n  margin-left: 14px;\n  margin-right: 14px;\n  width: auto;\n}\n\n/* The 14px sides match the CTA above -- both sit on the payable total's inner\n   edge rather than the panel's. Written as one shorthand because an earlier\n   `margin: 14px 0 12px` here silently reset the horizontal margin set further\n   up the file, leaving this note flush at 18px while the button moved to 32. */\nhtml.m-app .co-protection-note {\n  margin: 14px 14px 12px;\n  padding: 9px 12px;\n  font-size: 0.72rem;\n  font-weight: 500;\n  line-height: 1.35;\n}\n\n/* ── Coupon row, evened up ────────────────────────────────────────────────\n   The field and the Apply button were different heights because each was\n   sized by its own padding rather than to a shared measure -- the input's\n   10px vertical plus its border came out taller than the button's. Both now\n   take the same explicit height, so they read as one control.\n\n   The ticket glyph in front of the field goes: at this width it cost ~24px of\n   a row that has a field and a button to fit, and it labelled something the\n   heading (\"Have a coupon?\") and the placeholder already name twice. */\nhtml.m-app .coupon-ticket-icon { display: none; }\n\nhtml.m-app .coupon-input-row {\n  align-items: stretch;\n  gap: 8px;\n}\n\nhtml.m-app .coupon-input {\n  height: 42px;\n  box-sizing: border-box;\n  padding: 0 12px;\n  font-size: 0.8rem;\n  letter-spacing: 0.04em;\n}\n\nhtml.m-app .coupon-apply-btn {\n  height: 42px;\n  box-sizing: border-box;\n  padding: 0 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\nhtml.m-app .price-row {\n  font-size: 0.85rem;\n  gap: 12px;\n}\n\n/* The payable amount is the one number the shopper is deciding on, so in the\n   app it gets its own tinted panel instead of being another row in the list.\n   align-items: center keeps the figure optically centred against a label that\n   wraps to two lines, which is the normal case at this width. */\nhtml.m-app .price-row.total {\n  align-items: center;\n  font-size: 0.92rem;\n  margin-top: 14px;\n  padding: 12px 14px;\n  border-top: 0;\n  border-radius: var(--radius-sm);\n  background: var(--color-surface-subtle);\n}\n\n/* Blue, not navy: this is the figure the eye should land on first, and blue\n   is the palette's informational hue. It stays a fill-free colour on a tinted\n   surface, where --color-secondary-text clears AA comfortably. */\nhtml.m-app .price-row.total span:last-child {\n  font-size: 1.18rem;\n  font-weight: 800;\n  white-space: nowrap;\n  color: var(--color-secondary-text);\n}\n\n/* ── Coupon row ───────────────────────────────────────────────────────── */\n.coupon-input-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.coupon-ticket-icon {\n  display: inline-flex;\n  color: var(--text-muted);\n  flex-shrink: 0;\n}\n\n.coupon-input-row .coupon-input {\n  flex: 1;\n  min-width: 0;\n}\n\n/* ── Reward points ────────────────────────────────────────────────────────\n   Orange because redeeming points is a commercial action, which is the role\n   orange carries in this system. The balance is the reason to opt in, so it\n   is the largest thing in the block. */\n.co-points-row {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  flex-wrap: wrap;\n}\n\n.co-points-card {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 18px;\n  border-radius: 14px;\n  border: 1.5px solid var(--color-primary);\n  background: var(--color-primary-soft);\n}\n\n.co-points-medal {\n  display: inline-flex;\n  color: var(--color-primary);\n}\n\n.co-points-figures {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.25;\n}\n\n.co-points-count {\n  font-size: 1.05rem;\n  font-weight: 800;\n  color: var(--color-primary);\n  letter-spacing: -0.01em;\n}\n\n.co-points-value {\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n}\n\n.co-points-opt {\n  flex: 1;\n  min-width: 190px;\n}\n\n.co-points-opt .rewards-redeem-toggle { margin: 0 0 4px; }\n.co-points-opt .rewards-redeem-hint { margin: 0; }\n\n/* ── Delivering-to header with Change ─────────────────────────────────── */\n.co-recap-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.co-recap-head h3 {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.co-change-btn {\n  flex-shrink: 0;\n  padding: 6px 14px;\n  border-radius: 9px;\n  border: 1px solid var(--color-secondary);\n  background: transparent;\n  color: var(--color-secondary-text);\n  font-family: inherit;\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 150ms ease, color 150ms ease;\n}\n\n.co-change-btn:hover {\n  background: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n}\n\n.co-change-btn:focus-visible {\n  outline: 2px solid var(--color-focus-ring);\n  outline-offset: 2px;\n}\n\n/* ── Collapsed extra items ────────────────────────────────────────────── */\n.co-more-items {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px;\n  margin-top: 12px;\n  border: 1px solid var(--color-border);\n  border-radius: 14px;\n  background: var(--color-surface-subtle);\n}\n\n.co-more-thumbs {\n  display: flex;\n  flex-shrink: 0;\n}\n\n.co-more-thumb {\n  width: 42px;\n  height: 42px;\n  object-fit: cover;\n  border-radius: 9px;\n  border: 2px solid var(--color-surface);\n  background: var(--color-surface);\n}\n\n/* Overlap the stack so a long cart reads as one group rather than a row of\n   loose thumbnails competing with the item above it. */\n.co-more-thumb + .co-more-thumb { margin-left: -12px; }\n\n.co-more-text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.co-more-count {\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.co-more-sub {\n  font-size: 0.78rem;\n  color: var(--text-muted);\n}\n\n.co-more-price {\n  font-weight: 700;\n  color: var(--text-primary);\n  white-space: nowrap;\n}\n\n.co-more-btn {\n  flex-shrink: 0;\n  padding: 8px 16px;\n  border-radius: 9px;\n  border: 1px solid var(--color-secondary);\n  background: transparent;\n  color: var(--color-secondary-text);\n  font-family: inherit;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 150ms ease, color 150ms ease;\n}\n\n.co-more-btn:hover {\n  background: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n}\n\n.co-more-btn:focus-visible {\n  outline: 2px solid var(--color-focus-ring);\n  outline-offset: 2px;\n}\n\n@media (max-width: 560px) {\n  /* This row is thumbnails, a two-line description, a price and a button. On a\n     phone they cannot all share a line, and the previous wrap left the\n     description as the only flexible item -- with min-width:0 it shrank to its\n     narrowest, setting \"3 additional items\" and \"Included in this order\" one\n     word per line and stretching the card to five times its height.\n\n     A floor on the description is what fixes it: it may shrink, but not below\n     a width that still reads as a sentence. The button then takes a row of its\n     own rather than competing for what is left. */\n  .co-more-items { flex-wrap: wrap; }\n  .co-more-text { flex: 1 1 auto; min-width: 130px; }\n  .co-more-price { margin-left: auto; }\n  .co-more-btn { flex: 1 1 100%; margin-left: 0; text-align: center; }\n}\n\n/* ── Reassurance strip and CTA sub-line ───────────────────────────────── */\n.co-protection-note {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  margin: 18px 0 14px;\n  padding: 11px 14px;\n  border-radius: 11px;\n  background: var(--color-secondary-soft);\n  color: var(--color-secondary-text);\n  font-size: 0.81rem;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n.co-protection-note svg { flex-shrink: 0; }\n\n.co-under-cta {\n  margin: 10px 0 0;\n  text-align: center;\n  font-size: 0.78rem;\n  color: var(--text-muted);\n}\n\n/* The CTA now carries an icon and a total, so it has to lay them out. */\n.btn-place-order {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n}\n\n/* ── Stepper, tightened to sit with the rest ──────────────────────────── */\n.checkout-steps {\n  padding: 18px 40px 4px;\n  margin-bottom: 28px;\n}\n\n.step-number {\n  width: 38px;\n  height: 38px;\n  font-size: 0.95rem;\n}\n\n.step:not(:last-child)::after {\n  top: 18px;\n  left: calc(50% + 22px);\n  width: calc(100% - 44px);\n}\n\n.step.completed .step-number { font-size: 1rem; }\n.step-label { font-size: 0.85rem; }\n\n@media (max-width: 640px) {\n  .checkout-steps { padding: 14px 8px 2px; }\n  .step-number { width: 32px; height: 32px; font-size: 0.85rem; }\n  .step:not(:last-child)::after {\n    top: 15px;\n    left: calc(50% + 19px);\n    width: calc(100% - 38px);\n  }\n  .step-label { font-size: 0.72rem; text-align: center; }\n}\n\n/* ── Payment step: two columns ────────────────────────────────────────────\n   .checkout-container was an 800px single-column card holding everything\n   stacked: payment method, notes, coupon, points, then the order summary,\n   the address and the commit button underneath. On that layout the total a\n   shopper is agreeing to sat below the fold, past the controls that change\n   it, so committing meant scrolling back up to check the number.\n\n   The payment step now splits into a form column and a sticky rail. Scoped\n   with :has() to the step that actually has a rail, so the address step's\n   own container width is untouched. */\n.checkout-container:has(.checkout-side) {\n  width: min(1120px, calc(100% - 32px));\n  max-width: 1120px;\n  box-sizing: border-box;\n  display: grid;\n  grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);\n  gap: 24px;\n  align-items: start;\n  /* The columns are cards in their own right now, so the wrapper stops\n     being one. */\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  padding: 0;\n  max-width: 1120px;\n}\n\n/* The form column was centred at 560px for the single-column layout; inside\n   a grid track it should simply fill its column. */\n.checkout-container:has(.checkout-side) .cod-payment-section {\n  max-width: none;\n  margin: 0;\n}\n\n.checkout-side {\n  display: flex;\n  flex-direction: column;\n  position: sticky;\n  /* Clears the sticky site header so the rail doesn't slide under it. */\n  top: 88px;\n}\n\n.checkout-side .cod-order-recap,\n.checkout-side .cod-address-recap {\n  margin-bottom: 16px;\n}\n\n.checkout-side .co-protection-note { margin-top: 0; }\n\n/* Below the two-column breakpoint the rail stops being a rail: sticky\n   positioning on a stacked column just pins it mid-scroll. */\n@media (max-width: 900px) {\n  .checkout-container:has(.checkout-side) {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .checkout-side { position: static; }\n}\n\n/* Fallback for engines without :has(). They keep the previous single-column\n   card, which is the layout that shipped before this change rather than a\n   broken one. Firefox gained :has() in 121 and Safari in 15.4, so this is a\n   narrow tail. */\n@supports not selector(:has(*)) {\n  .checkout-side { position: static; }\n}\n\n/* ── Flatten the sub-sections inside the payment panel ────────────────────\n   .order-notes-section, .coupon-section and .rewards-redeem-section were\n   each styled as their own bordered grey card, from when the payment step\n   was one narrow column and those boxes were what separated the controls.\n   Inside .co-panel that nests a card in a card, and the uppercase headings\n   read as three competing titles alongside the panel's own.\n\n   They become plain groups here: the panel supplies the frame, .co-field-label\n   supplies the heading. Scoped to .co-panel so the same classes keep their\n   previous look anywhere else they are used. */\n.co-panel .order-notes-section,\n.co-panel .coupon-section,\n.co-panel .rewards-redeem-section {\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  padding: 0;\n  margin-top: 22px;\n}\n\n/* The label is sentence case and sits directly above its control. The\n   uppercase treatment came from the old section-card headings. */\n.co-panel .co-field-label,\n.co-panel .order-notes-section h3,\n.co-panel .coupon-section h3,\n.co-panel .rewards-redeem-section h3 {\n  text-transform: none;\n  letter-spacing: normal;\n  font-size: 0.86rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n/* Same reason: the coupon field inherited an uppercase, letter-spaced\n   placeholder from the boxed treatment. */\n.co-panel .coupon-input,\n.co-panel .coupon-input::placeholder {\n  text-transform: none;\n  letter-spacing: normal;\n}\n\n/* The panel already carries the outer border, so the first group under the\n   title should not add a second rule line above itself. */\n.co-panel .order-notes-section:first-of-type { margin-top: 0; }\n\n/* ── Flatten the Order Summary panel ──────────────────────────────────────\n   .address-section and .order-items-section were each their own bordered,\n   shadowed card, from when .summary-left was a bare column and those boxes\n   were what gave the step structure. Inside .co-panel that stacks four\n   frames deep: panel > section card > grey .order-items wrapper > item card.\n\n   The panel is the frame now. The address box and the item cards keep their\n   own borders, because those are the things a shopper actually picks out;\n   the containers between them do not need to be visible at all.\n\n   Scoped to .summary-left.co-panel, so .address-section keeps its previous\n   card treatment on the address step, which still uses it standalone. */\n.summary-left.co-panel .address-section,\n.summary-left.co-panel .order-items-section {\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  padding: 0;\n}\n\n/* The sections are siblings in a flex column with its own gap, so their old\n   card margins would now double the spacing. */\n.summary-left.co-panel .address-section { margin-bottom: 4px; }\n\n/* The list wrapper was tinted to separate it from the page. Against the\n   panel it just adds a fifth surface behind the item cards. */\n.summary-left.co-panel .order-items {\n  background: transparent;\n  border: none;\n  padding: 0;\n}\n\n/* Section headings inside the panel follow the same rule as step 3: sentence\n   case, sitting directly above their content, with the panel title as the\n   only display-weight heading on the card. */\n.summary-left.co-panel .address-section h3,\n.summary-left.co-panel .order-items-section h3 {\n  text-transform: none;\n  letter-spacing: normal;\n  font-size: 0.86rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n/* Price Details carries both .price-details and .co-panel, which each supply\n   a background, border and padding. Let .co-panel own the frame so the two\n   columns are built from the same thing. */\n.summary-right .price-details.co-panel {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n}\n\n/* ── Per-size stock breakdown (admin product form) ────────────────────────\n   Tracking stock per size exists so a seller can see which size is running\n   out while the others are fine; a single total hides precisely that. These\n   chips sit under the total and name each level's count.\n\n   Low and sold-out use the same tones as the status dot above them: orange\n   for \"needs attention\", muted navy for \"gone\". Each chip also states its\n   count in words, so the state never rests on colour alone. */\n.admin-pf-stock-breakdown {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.admin-pf-stock-chip {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 6px;\n  padding: 5px 11px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border);\n  background: var(--color-surface-subtle);\n  font-size: 0.76rem;\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n.admin-pf-stock-chip strong {\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.admin-pf-stock-chip.is-low {\n  border-color: var(--color-primary);\n  background: var(--color-primary-soft);\n  color: var(--color-primary);\n}\n\n.admin-pf-stock-chip.is-low strong { color: var(--color-primary); }\n\n.admin-pf-stock-chip.is-out {\n  color: var(--text-muted);\n  border-style: dashed;\n}\n\n.admin-pf-stock-chip.is-out strong { color: var(--text-muted); }\n\n/* The total is derived in this state, so it should not look typeable. */\n.admin-pf-qty-input[readonly] {\n  background: var(--color-surface-subtle);\n  cursor: default;\n}\n\n.admin-pf-qty-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* ── Mobile marketplace checkout finish ──────────────────────────────────\n   These rules complete the shared checkout language across the address,\n   review and payment steps while preserving the existing DOM and behavior. */\n.checkout-address-container .address-section,\n.checkout-address-container .address-form-section {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.checkout-address-container .address-display {\n  border: 1px solid var(--color-border);\n  background: var(--color-surface-subtle);\n  border-radius: var(--radius-md);\n  padding: 18px;\n  transition: border-color 180ms ease, box-shadow 180ms ease, background 180ms ease;\n}\n\n.checkout-address-container .address-display:hover {\n  border-color: var(--color-secondary);\n  box-shadow: 0 10px 28px -20px color-mix(in srgb, var(--color-brand-navy) 38%, transparent);\n}\n\n.co-address-detail,\n.co-address-note,\n.zone-check-status {\n  display: flex;\n  align-items: flex-start;\n  gap: 7px;\n}\n\n.co-address-detail svg,\n.co-address-note svg,\n.zone-check-status svg {\n  flex: 0 0 auto;\n  margin-top: 3px;\n}\n\n.co-address-detail { color: var(--text-secondary); }\n\n.co-address-note {\n  margin-top: 8px !important;\n  padding: 9px 10px;\n  border-left: 3px solid var(--color-secondary);\n  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;\n  background: var(--color-secondary-soft);\n  color: var(--text-secondary);\n}\n\n.zone-check-status {\n  margin-top: 10px !important;\n  padding-top: 10px;\n  border-top: 1px solid var(--color-border);\n  font-weight: 700;\n}\n\n.fi-qty-arrow {\n  display: inline-flex;\n  align-items: center;\n  pointer-events: none;\n}\n\n.dmp-locate-btn,\n.ab-cancel-btn,\n.ab-default-badge,\n.brands-card-logo {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n}\n\n.co-panel,\n.fi-item,\n.payment-method-card,\n.checkout-del-opt,\n.co-more-items,\n.address-display,\n.coupon-input,\n.order-notes-input,\n.co-change-btn,\n.co-more-btn,\n.coupon-apply-btn,\n.btn-place-order {\n  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease,\n    background-color 180ms ease, color 180ms ease, opacity 180ms ease;\n}\n\n.payment-method-card[style*=\"cursor: pointer\"]:hover,\n.checkout-del-opt:hover,\n.fi-item:hover,\n.co-more-items:hover {\n  border-color: var(--color-secondary);\n  box-shadow: 0 12px 30px -22px color-mix(in srgb, var(--color-brand-navy) 42%, transparent);\n}\n\n.payment-method-card[style*=\"cursor: pointer\"]:active,\n.checkout-del-opt:active,\n.co-change-btn:active,\n.co-more-btn:active,\n.coupon-apply-btn:active,\n.btn-place-order:active {\n  transform: scale(0.985);\n}\n\n.coupon-input:focus,\n.order-notes-input:focus {\n  border-color: var(--color-secondary);\n  box-shadow: 0 0 0 3px var(--color-secondary-soft);\n  outline: none;\n}\n\n@media (max-width: 640px) {\n  .checkout-address-container {\n    padding: 0;\n  }\n\n  .checkout-address-container > .address-section,\n  .checkout-address-container > .address-form-section {\n    padding: 22px 18px 28px;\n    border-radius: 0;\n  }\n\n  .checkout-address-container h2 {\n    margin-bottom: 16px;\n    font-size: 1.1rem;\n    letter-spacing: -0.015em;\n  }\n\n  .checkout-address-container .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  html.m-app .co-panel-title {\n    margin-bottom: 16px;\n    padding-bottom: 12px;\n  }\n\n  html.m-app .payment-method-card.co-selected {\n    border-width: 1px;\n    background: linear-gradient(135deg, var(--color-secondary-soft), var(--color-surface));\n  }\n\n  html.m-app .price-row.total {\n    box-shadow: inset 3px 0 0 var(--color-secondary);\n  }\n\n  html.m-app .btn-place-order {\n    min-height: 50px;\n    border-radius: 12px;\n    box-shadow: 0 12px 24px -16px color-mix(in srgb, var(--color-primary) 70%, transparent);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .co-panel,\n  .fi-item,\n  .payment-method-card,\n  .checkout-del-opt,\n  .co-more-items,\n  .address-display,\n  .coupon-input,\n  .order-notes-input,\n  .co-change-btn,\n  .co-more-btn,\n  .coupon-apply-btn,\n  .btn-place-order {\n    transition: none;\n  }\n}\n\n/* ── Highlight suggestion status (admin product form) ─────────────────────\n   Sits above the highlight rows after an image upload has triggered an\n   analysis. Blue for in-progress and success, since blue carries information\n   in this system; orange for the failed read, which is the one state that\n   wants attention. Both also carry an icon and say what to do next, so the\n   state never rests on colour. */\n.admin-hl-suggest {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n  padding: 9px 13px;\n  border-radius: 10px;\n  font-size: 0.79rem;\n  font-weight: 600;\n  line-height: 1.4;\n  background: var(--color-secondary-soft);\n  color: var(--color-secondary-text);\n}\n\n.admin-hl-suggest svg { flex-shrink: 0; }\n\n.admin-hl-suggest-error {\n  background: var(--color-primary-soft);\n  color: var(--color-primary);\n}\n\n.admin-hl-suggest-unavailable {\n  background: var(--color-surface-subtle);\n  color: var(--text-muted);\n}\n\n/* Reading an image takes a few seconds; a still label reads as a stuck form. */\n.admin-hl-suggest-loading svg {\n  animation: admin-hl-pulse 1.1s ease-in-out infinite;\n}\n\n@keyframes admin-hl-pulse {\n  0%, 100% { opacity: 1; }\n  50%      { opacity: 0.35; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .admin-hl-suggest-loading svg { animation: none; }\n}\n\n/* ── Mobile type floor ────────────────────────────────────────────────────\n   No text on a customer-facing phone screen goes below 12px (0.75rem).\n\n   These are 21 rules that measured between 9.9px and 11.8px at a 360px\n   viewport -- rating pills, strikethrough prices, review counts, the\n   \"VERIFIED\" seller badge, the countdown. They read fine on a 27\" monitor\n   at arm's length and poorly on a phone held at arm's length, which is the\n   whole problem: they were sized against the desktop layout they were\n   designed in.\n\n   Scoped to mobile, and last in the file, so desktop stays pixel-identical\n   and these override the base rules without needing !important. The two\n   mobile-only components (BottomNav, MobileTopBar) are fixed at source\n   instead, since they never render above this width anyway.\n\n   This is a floor, not a type scale. If the palette ever grows a real scale\n   the right move is to delete this block and fix the sizes at source. */\n@media (max-width: 768px) {\n  .pdp-sil-verified,\n  .sr-header-sub,\n  .about-float-title,\n  .about-float-card,\n  .cat-carousel-rating-pill,\n  .cat-carousel-no-rating,\n  .cat-carousel-price-was,\n  .cat-carousel-review-cnt,\n  .ftr-cta-feature-sub,\n  .pdp-img-counter,\n  .pdp-cat-label,\n  .pdp-360-trigger,\n  .pdp-del-date,\n  .ssb-label,\n  .ann-countdown,\n  /* Lives in the rotating hero slides, so it is only measurable while its\n     own slide is the visible one. */\n  .slide-badge {\n    font-size: 0.75rem;\n  }\n  /* Matches the base rule's two-class specificity. */\n  .pcard-rating-badge.product-rating-pill { font-size: 0.75rem; }\n}\n\n/* Account, cart and checkout equivalents of the two floors above. These\n   pages are behind a login, so the first pass over the public storefront\n   never measured them; the same two problems were waiting here. */\n@media (max-width: 768px) {\n  /* Type floor -- see the block above for the reasoning. */\n  .oh-cell-label,\n  .oh-stat-sub,\n  .oh-status-sub,\n  .oh-pay-icon,\n  .oh-paid-badge,\n  .ab-default-badge,\n  .pf-info-label,\n  .dash-order-status,\n  .dash-stat-sub,\n  .ntf-badge,\n  .ntf-absolute,\n  .ntf-tab-count,\n  .step-label,\n  .ctb-item,\n  .fi-qty-arrow,\n  .cs-qty-max-hint {\n    font-size: 0.75rem;\n  }\n\n  /* Tap floor, standalone controls. The quantity select on the checkout\n     summary measured 8x15px -- it has no border and no padding, so it\n     collapsed to the width of the caret beside it. Changing quantity at\n     checkout is not a control anyone should have to aim at. */\n  .fi-qty-select { min-width: 44px; min-height: 44px; }\n  .sph-back,\n  .co-change-btn,\n  .co-more-btn,\n  .cs-qty-btn,\n  .oh-view-btn,\n  .oh-buy-again-btn,\n  .oh-export-btn,\n  .oh-date-select,\n  .wl-share-btn,\n  .wl-add-all-btn,\n  .ntf-tab,\n  .ntf-mark-all,\n  .cartpg-help-btn,\n  .coupon-input,\n  .ntf-filter-btn,\n  .ntf-search-input,\n  .oh-search-input {\n    min-height: 44px;\n  }\n  /* Icon-only, so they need the width too. */\n  .ntf-menu-btn,\n  .ntf-page-arrow,\n  .pf-input-eye,\n  .pf-avatar-edit {\n    min-width: 44px;\n    min-height: 44px;\n  }\n\n  /* Inline text actions inside dense list rows (\"Remove\", \"Save for later\",\n     \"Edit\"). These sit in tight stacks, so 44px each would space the rows\n     out badly. Held to 32px instead -- above the 24px WCAG 2.2 AA floor,\n     and double what they were at padding:0. */\n  .ab-edit-btn,\n  .ab-remove-btn,\n  .cs-item-action,\n  .dash-section-link {\n    min-height: 32px;\n    padding-top: 4px;\n    padding-bottom: 4px;\n  }\n}\n\n/* Standalone controls that measured under the 24px WCAG 2.2 AA floor on a\n   phone: a back button, breadcrumb links, the footer's legal row, and the\n   contact details. Each is a real navigation target rather than a link\n   inside a sentence, so the exception for inline links doesn't cover them.\n   Padding rather than height, so nothing shifts around them. */\n@media (max-width: 768px) {\n  .pdp-back-link,\n  .pdp-bc-item,\n  .ftr-bottom-link,\n  .contact-info-value,\n  .pdp-change-btn,\n  .pdp-offer-copy {\n    min-height: 24px;\n    display: inline-flex;\n    align-items: center;\n  }\n}\n\n/* Hover-only affordances on touch devices.\n   \"Hover to zoom\" is an instruction a touch user cannot act on, and its\n   reveal rule is not gated -- mobile browsers latch :hover on tap, so it\n   can appear and say something meaningless. The quick-view label already\n   only reveals under (hover: hover), so it is never visible here; removing\n   it from the tree as well drops ~30 dead nodes from a product grid. */\n@media (hover: none) {\n  .pdp-zoom-hint,\n  .cat-carousel-quickview {\n    display: none;\n  }\n}\n\n/* ── Top Sales eligibility, in admin Settings ─────────────────────────────\n   A checkbox that governs the two fields under it, plus a percent suffix.\n   Reuses .si-field-grid / .si-input from Store Information so the two cards\n   in this tab share one field geometry rather than drifting apart. */\n.ts-rule-toggle {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 14px 16px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: var(--bg-secondary);\n  cursor: pointer;\n}\n\n.ts-rule-toggle input[type=\"checkbox\"] {\n  /* Nudged down onto the first line of the label rather than the top of the\n     block, which is where it sits once the hint wraps to three lines. */\n  margin-top: 2px;\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n  accent-color: var(--color-secondary);\n  cursor: pointer;\n}\n\n.ts-rule-toggle > span {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  font-size: 0.86rem;\n  color: var(--text-primary);\n  min-width: 0;\n}\n\n.ts-rule-hint,\n.ts-field-hint {\n  font-size: 0.78rem;\n  font-weight: 400;\n  line-height: 1.45;\n  color: var(--text-secondary);\n}\n\n.ts-field-hint { margin: 6px 0 0; }\n\n/* The % sits inside the field's box rather than beside it, so the number and\n   its unit read as one control and the field keeps the grid's width. */\n.ts-suffix-field {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.ts-suffix-field .si-input {\n  width: 100%;\n  /* Room for the suffix, so a three-digit value never runs under it. */\n  padding-right: 34px;\n}\n\n.ts-suffix {\n  position: absolute;\n  right: 12px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  pointer-events: none;\n}\n\n/* A disabled field still has to be readable -- it says what the rule WOULD be\n   if the checkbox above were on, which is the thing being decided. */\n.ts-suffix-field .si-input:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
